var G0 = Object.defineProperty;
var _0 = (td, Ae, xr) => Ae in td ? G0(td, Ae, { enumerable: !0, configurable: !0, writable: !0, value: xr }) : td[Ae] = xr;
var _d = (td, Ae, xr) => (_0(td, typeof Ae != "symbol" ? Ae + "" : Ae, xr), xr);
const $global = function() {
  if (typeof globalThis != "undefined")
    return globalThis;
  if (typeof global != "undefined")
    return global;
  if (typeof self != "undefined")
    return self;
  if (typeof window != "undefined")
    return window;
  try {
    return new Function("return this")();
  } catch (td) {
    return {};
  }
}();
$global.trustedTypes === void 0 && ($global.trustedTypes = { createPolicy: (td, Ae) => Ae });
const propConfig = {
  configurable: !1,
  enumerable: !1,
  writable: !1
};
$global.FAST === void 0 && Reflect.defineProperty($global, "FAST", Object.assign({ value: /* @__PURE__ */ Object.create(null) }, propConfig));
const FAST = $global.FAST;
if (FAST.getById === void 0) {
  const td = /* @__PURE__ */ Object.create(null);
  Reflect.defineProperty(FAST, "getById", Object.assign({ value(Ae, xr) {
    let ed = td[Ae];
    return ed === void 0 && (ed = xr ? td[Ae] = xr() : null), ed;
  } }, propConfig));
}
const emptyArray = Object.freeze([]);
function createMetadataLocator() {
  const td = /* @__PURE__ */ new WeakMap();
  return function(Ae) {
    let xr = td.get(Ae);
    if (xr === void 0) {
      let ed = Reflect.getPrototypeOf(Ae);
      for (; xr === void 0 && ed !== null; )
        xr = td.get(ed), ed = Reflect.getPrototypeOf(ed);
      xr = xr === void 0 ? [] : xr.slice(0), td.set(Ae, xr);
    }
    return xr;
  };
}
const updateQueue = $global.FAST.getById(1, () => {
  const td = [], Ae = [];
  function xr() {
    if (Ae.length)
      throw Ae.shift();
  }
  function ed(ad) {
    try {
      ad.call();
    } catch (rd) {
      Ae.push(rd), setTimeout(xr, 0);
    }
  }
  function id() {
    let rd = 0;
    for (; rd < td.length; )
      if (ed(td[rd]), rd++, rd > 1024) {
        for (let sd = 0, nd = td.length - rd; sd < nd; sd++)
          td[sd] = td[sd + rd];
        td.length -= rd, rd = 0;
      }
    td.length = 0;
  }
  function od(ad) {
    td.length < 1 && $global.requestAnimationFrame(id), td.push(ad);
  }
  return Object.freeze({
    enqueue: od,
    process: id
  });
}), fastHTMLPolicy = $global.trustedTypes.createPolicy("fast-html", {
  createHTML: (td) => td
});
let htmlPolicy = fastHTMLPolicy;
const marker = `fast-${Math.random().toString(36).substring(2, 8)}`, _interpolationStart = `${marker}{`, _interpolationEnd = `}${marker}`, DOM = Object.freeze({
  /**
   * Indicates whether the DOM supports the adoptedStyleSheets feature.
   */
  supportsAdoptedStyleSheets: Array.isArray(document.adoptedStyleSheets) && "replace" in CSSStyleSheet.prototype,
  /**
   * Sets the HTML trusted types policy used by the templating engine.
   * @param policy - The policy to set for HTML.
   * @remarks
   * This API can only be called once, for security reasons. It should be
   * called by the application developer at the start of their program.
   */
  setHTMLPolicy(td) {
    if (htmlPolicy !== fastHTMLPolicy)
      throw new Error("The HTML policy can only be set once.");
    htmlPolicy = td;
  },
  /**
   * Turns a string into trusted HTML using the configured trusted types policy.
   * @param html - The string to turn into trusted HTML.
   * @remarks
   * Used internally by the template engine when creating templates
   * and setting innerHTML.
   */
  createHTML(td) {
    return htmlPolicy.createHTML(td);
  },
  /**
   * Determines if the provided node is a template marker used by the runtime.
   * @param node - The node to test.
   */
  isMarker(td) {
    return td && td.nodeType === 8 && td.data.startsWith(marker);
  },
  /**
   * Given a marker node, extract the {@link HTMLDirective} index from the placeholder.
   * @param node - The marker node to extract the index from.
   */
  extractDirectiveIndexFromMarker(td) {
    return parseInt(td.data.replace(`${marker}:`, ""));
  },
  /**
   * Creates a placeholder string suitable for marking out a location *within*
   * an attribute value or HTML content.
   * @param index - The directive index to create the placeholder for.
   * @remarks
   * Used internally by binding directives.
   */
  createInterpolationPlaceholder(td) {
    return `${_interpolationStart}${td}${_interpolationEnd}`;
  },
  /**
   * Creates a placeholder that manifests itself as an attribute on an
   * element.
   * @param attributeName - The name of the custom attribute.
   * @param index - The directive index to create the placeholder for.
   * @remarks
   * Used internally by attribute directives such as `ref`, `slotted`, and `children`.
   */
  createCustomAttributePlaceholder(td, Ae) {
    return `${td}="${this.createInterpolationPlaceholder(Ae)}"`;
  },
  /**
   * Creates a placeholder that manifests itself as a marker within the DOM structure.
   * @param index - The directive index to create the placeholder for.
   * @remarks
   * Used internally by structural directives such as `repeat`.
   */
  createBlockPlaceholder(td) {
    return `<!--${marker}:${td}-->`;
  },
  /**
   * Schedules DOM update work in the next async batch.
   * @param callable - The callable function or object to queue.
   */
  queueUpdate: updateQueue.enqueue,
  /**
   * Immediately processes all work previously scheduled
   * through queueUpdate.
   * @remarks
   * This also forces nextUpdate promises
   * to resolve.
   */
  processUpdates: updateQueue.process,
  /**
   * Resolves with the next DOM update.
   */
  nextUpdate() {
    return new Promise(updateQueue.enqueue);
  },
  /**
   * Sets an attribute value on an element.
   * @param element - The element to set the attribute value on.
   * @param attributeName - The attribute name to set.
   * @param value - The value of the attribute to set.
   * @remarks
   * If the value is `null` or `undefined`, the attribute is removed, otherwise
   * it is set to the provided value using the standard `setAttribute` API.
   */
  setAttribute(td, Ae, xr) {
    xr == null ? td.removeAttribute(Ae) : td.setAttribute(Ae, xr);
  },
  /**
   * Sets a boolean attribute value.
   * @param element - The element to set the boolean attribute value on.
   * @param attributeName - The attribute name to set.
   * @param value - The value of the attribute to set.
   * @remarks
   * If the value is true, the attribute is added; otherwise it is removed.
   */
  setBooleanAttribute(td, Ae, xr) {
    xr ? td.setAttribute(Ae, "") : td.removeAttribute(Ae);
  },
  /**
   * Removes all the child nodes of the provided parent node.
   * @param parent - The node to remove the children from.
   */
  removeChildNodes(td) {
    for (let Ae = td.firstChild; Ae !== null; Ae = td.firstChild)
      td.removeChild(Ae);
  },
  /**
   * Creates a TreeWalker configured to walk a template fragment.
   * @param fragment - The fragment to walk.
   */
  createTemplateWalker(td) {
    return document.createTreeWalker(
      td,
      133,
      // element, text, comment
      null,
      !1
    );
  }
});
class SubscriberSet {
  /**
   * Creates an instance of SubscriberSet for the specified source.
   * @param source - The object source that subscribers will receive notifications from.
   * @param initialSubscriber - An initial subscriber to changes.
   */
  constructor(Ae, xr) {
    this.sub1 = void 0, this.sub2 = void 0, this.spillover = void 0, this.source = Ae, this.sub1 = xr;
  }
  /**
   * Checks whether the provided subscriber has been added to this set.
   * @param subscriber - The subscriber to test for inclusion in this set.
   */
  has(Ae) {
    return this.spillover === void 0 ? this.sub1 === Ae || this.sub2 === Ae : this.spillover.indexOf(Ae) !== -1;
  }
  /**
   * Subscribes to notification of changes in an object's state.
   * @param subscriber - The object that is subscribing for change notification.
   */
  subscribe(Ae) {
    const xr = this.spillover;
    if (xr === void 0) {
      if (this.has(Ae))
        return;
      if (this.sub1 === void 0) {
        this.sub1 = Ae;
        return;
      }
      if (this.sub2 === void 0) {
        this.sub2 = Ae;
        return;
      }
      this.spillover = [this.sub1, this.sub2, Ae], this.sub1 = void 0, this.sub2 = void 0;
    } else
      xr.indexOf(Ae) === -1 && xr.push(Ae);
  }
  /**
   * Unsubscribes from notification of changes in an object's state.
   * @param subscriber - The object that is unsubscribing from change notification.
   */
  unsubscribe(Ae) {
    const xr = this.spillover;
    if (xr === void 0)
      this.sub1 === Ae ? this.sub1 = void 0 : this.sub2 === Ae && (this.sub2 = void 0);
    else {
      const ed = xr.indexOf(Ae);
      ed !== -1 && xr.splice(ed, 1);
    }
  }
  /**
   * Notifies all subscribers.
   * @param args - Data passed along to subscribers during notification.
   */
  notify(Ae) {
    const xr = this.spillover, ed = this.source;
    if (xr === void 0) {
      const id = this.sub1, od = this.sub2;
      id !== void 0 && id.handleChange(ed, Ae), od !== void 0 && od.handleChange(ed, Ae);
    } else
      for (let id = 0, od = xr.length; id < od; ++id)
        xr[id].handleChange(ed, Ae);
  }
}
class PropertyChangeNotifier {
  /**
   * Creates an instance of PropertyChangeNotifier for the specified source.
   * @param source - The object source that subscribers will receive notifications from.
   */
  constructor(Ae) {
    this.subscribers = {}, this.sourceSubscribers = null, this.source = Ae;
  }
  /**
   * Notifies all subscribers, based on the specified property.
   * @param propertyName - The property name, passed along to subscribers during notification.
   */
  notify(Ae) {
    var xr;
    const ed = this.subscribers[Ae];
    ed !== void 0 && ed.notify(Ae), (xr = this.sourceSubscribers) === null || xr === void 0 || xr.notify(Ae);
  }
  /**
   * Subscribes to notification of changes in an object's state.
   * @param subscriber - The object that is subscribing for change notification.
   * @param propertyToWatch - The name of the property that the subscriber is interested in watching for changes.
   */
  subscribe(Ae, xr) {
    var ed;
    if (xr) {
      let id = this.subscribers[xr];
      id === void 0 && (this.subscribers[xr] = id = new SubscriberSet(this.source)), id.subscribe(Ae);
    } else
      this.sourceSubscribers = (ed = this.sourceSubscribers) !== null && ed !== void 0 ? ed : new SubscriberSet(this.source), this.sourceSubscribers.subscribe(Ae);
  }
  /**
   * Unsubscribes from notification of changes in an object's state.
   * @param subscriber - The object that is unsubscribing from change notification.
   * @param propertyToUnwatch - The name of the property that the subscriber is no longer interested in watching.
   */
  unsubscribe(Ae, xr) {
    var ed;
    if (xr) {
      const id = this.subscribers[xr];
      id !== void 0 && id.unsubscribe(Ae);
    } else
      (ed = this.sourceSubscribers) === null || ed === void 0 || ed.unsubscribe(Ae);
  }
}
const Observable = FAST.getById(2, () => {
  const td = /(:|&&|\|\||if)/, Ae = /* @__PURE__ */ new WeakMap(), xr = DOM.queueUpdate;
  let ed, id = (nd) => {
    throw new Error("Must call enableArrayObservation before observing arrays.");
  };
  function od(nd) {
    let cd = nd.$fastController || Ae.get(nd);
    return cd === void 0 && (Array.isArray(nd) ? cd = id(nd) : Ae.set(nd, cd = new PropertyChangeNotifier(nd))), cd;
  }
  const ad = createMetadataLocator();
  class rd {
    constructor(cd) {
      this.name = cd, this.field = `_${cd}`, this.callback = `${cd}Changed`;
    }
    getValue(cd) {
      return ed !== void 0 && ed.watch(cd, this.name), cd[this.field];
    }
    setValue(cd, ud) {
      const ld = this.field, dd = cd[ld];
      if (dd !== ud) {
        cd[ld] = ud;
        const pd = cd[this.callback];
        typeof pd == "function" && pd.call(cd, dd, ud), od(cd).notify(this.name);
      }
    }
  }
  class sd extends SubscriberSet {
    constructor(cd, ud, ld = !1) {
      super(cd, ud), this.binding = cd, this.isVolatileBinding = ld, this.needsRefresh = !0, this.needsQueue = !0, this.first = this, this.last = null, this.propertySource = void 0, this.propertyName = void 0, this.notifier = void 0, this.next = void 0;
    }
    observe(cd, ud) {
      this.needsRefresh && this.last !== null && this.disconnect();
      const ld = ed;
      ed = this.needsRefresh ? this : void 0, this.needsRefresh = this.isVolatileBinding;
      const dd = this.binding(cd, ud);
      return ed = ld, dd;
    }
    disconnect() {
      if (this.last !== null) {
        let cd = this.first;
        for (; cd !== void 0; )
          cd.notifier.unsubscribe(this, cd.propertyName), cd = cd.next;
        this.last = null, this.needsRefresh = this.needsQueue = !0;
      }
    }
    watch(cd, ud) {
      const ld = this.last, dd = od(cd), pd = ld === null ? this.first : {};
      if (pd.propertySource = cd, pd.propertyName = ud, pd.notifier = dd, dd.subscribe(this, ud), ld !== null) {
        if (!this.needsRefresh) {
          let md;
          ed = void 0, md = ld.propertySource[ld.propertyName], ed = this, cd === md && (this.needsRefresh = !0);
        }
        ld.next = pd;
      }
      this.last = pd;
    }
    handleChange() {
      this.needsQueue && (this.needsQueue = !1, xr(this));
    }
    call() {
      this.last !== null && (this.needsQueue = !0, this.notify(this));
    }
    records() {
      let cd = this.first;
      return {
        next: () => {
          const ud = cd;
          return ud === void 0 ? { value: void 0, done: !0 } : (cd = cd.next, {
            value: ud,
            done: !1
          });
        },
        [Symbol.iterator]: function() {
          return this;
        }
      };
    }
  }
  return Object.freeze({
    /**
     * @internal
     * @param factory - The factory used to create array observers.
     */
    setArrayObserverFactory(nd) {
      id = nd;
    },
    /**
     * Gets a notifier for an object or Array.
     * @param source - The object or Array to get the notifier for.
     */
    getNotifier: od,
    /**
     * Records a property change for a source object.
     * @param source - The object to record the change against.
     * @param propertyName - The property to track as changed.
     */
    track(nd, cd) {
      ed !== void 0 && ed.watch(nd, cd);
    },
    /**
     * Notifies watchers that the currently executing property getter or function is volatile
     * with respect to its observable dependencies.
     */
    trackVolatile() {
      ed !== void 0 && (ed.needsRefresh = !0);
    },
    /**
     * Notifies subscribers of a source object of changes.
     * @param source - the object to notify of changes.
     * @param args - The change args to pass to subscribers.
     */
    notify(nd, cd) {
      od(nd).notify(cd);
    },
    /**
     * Defines an observable property on an object or prototype.
     * @param target - The target object to define the observable on.
     * @param nameOrAccessor - The name of the property to define as observable;
     * or a custom accessor that specifies the property name and accessor implementation.
     */
    defineProperty(nd, cd) {
      typeof cd == "string" && (cd = new rd(cd)), ad(nd).push(cd), Reflect.defineProperty(nd, cd.name, {
        enumerable: !0,
        get: function() {
          return cd.getValue(this);
        },
        set: function(ud) {
          cd.setValue(this, ud);
        }
      });
    },
    /**
     * Finds all the observable accessors defined on the target,
     * including its prototype chain.
     * @param target - The target object to search for accessor on.
     */
    getAccessors: ad,
    /**
     * Creates a {@link BindingObserver} that can watch the
     * provided {@link Binding} for changes.
     * @param binding - The binding to observe.
     * @param initialSubscriber - An initial subscriber to changes in the binding value.
     * @param isVolatileBinding - Indicates whether the binding's dependency list must be re-evaluated on every value evaluation.
     */
    binding(nd, cd, ud = this.isVolatileBinding(nd)) {
      return new sd(nd, cd, ud);
    },
    /**
     * Determines whether a binding expression is volatile and needs to have its dependency list re-evaluated
     * on every evaluation of the value.
     * @param binding - The binding to inspect.
     */
    isVolatileBinding(nd) {
      return td.test(nd.toString());
    }
  });
});
function observable(td, Ae) {
  Observable.defineProperty(td, Ae);
}
function volatile(td, Ae, xr) {
  return Object.assign({}, xr, {
    get: function() {
      return Observable.trackVolatile(), xr.get.apply(this);
    }
  });
}
const contextEvent = FAST.getById(3, () => {
  let td = null;
  return {
    get() {
      return td;
    },
    set(Ae) {
      td = Ae;
    }
  };
});
class ExecutionContext {
  constructor() {
    this.index = 0, this.length = 0, this.parent = null, this.parentContext = null;
  }
  /**
   * The current event within an event handler.
   */
  get event() {
    return contextEvent.get();
  }
  /**
   * Indicates whether the current item within a repeat context
   * has an even index.
   */
  get isEven() {
    return this.index % 2 === 0;
  }
  /**
   * Indicates whether the current item within a repeat context
   * has an odd index.
   */
  get isOdd() {
    return this.index % 2 !== 0;
  }
  /**
   * Indicates whether the current item within a repeat context
   * is the first item in the collection.
   */
  get isFirst() {
    return this.index === 0;
  }
  /**
   * Indicates whether the current item within a repeat context
   * is somewhere in the middle of the collection.
   */
  get isInMiddle() {
    return !this.isFirst && !this.isLast;
  }
  /**
   * Indicates whether the current item within a repeat context
   * is the last item in the collection.
   */
  get isLast() {
    return this.index === this.length - 1;
  }
  /**
   * Sets the event for the current execution context.
   * @param event - The event to set.
   * @internal
   */
  static setEvent(Ae) {
    contextEvent.set(Ae);
  }
}
Observable.defineProperty(ExecutionContext.prototype, "index");
Observable.defineProperty(ExecutionContext.prototype, "length");
const defaultExecutionContext = Object.seal(new ExecutionContext());
class HTMLDirective {
  constructor() {
    this.targetIndex = 0;
  }
}
class TargetedHTMLDirective extends HTMLDirective {
  constructor() {
    super(...arguments), this.createPlaceholder = DOM.createInterpolationPlaceholder;
  }
}
class AttachedBehaviorHTMLDirective extends HTMLDirective {
  /**
   *
   * @param name - The name of the behavior; used as a custom attribute on the element.
   * @param behavior - The behavior to instantiate and attach to the element.
   * @param options - Options to pass to the behavior during creation.
   */
  constructor(Ae, xr, ed) {
    super(), this.name = Ae, this.behavior = xr, this.options = ed;
  }
  /**
   * Creates a placeholder string based on the directive's index within the template.
   * @param index - The index of the directive within the template.
   * @remarks
   * Creates a custom attribute placeholder.
   */
  createPlaceholder(Ae) {
    return DOM.createCustomAttributePlaceholder(this.name, Ae);
  }
  /**
   * Creates a behavior for the provided target node.
   * @param target - The node instance to create the behavior for.
   * @remarks
   * Creates an instance of the `behavior` type this directive was constructed with
   * and passes the target and options to that `behavior`'s constructor.
   */
  createBehavior(Ae) {
    return new this.behavior(Ae, this.options);
  }
}
function normalBind(td, Ae) {
  this.source = td, this.context = Ae, this.bindingObserver === null && (this.bindingObserver = Observable.binding(this.binding, this, this.isBindingVolatile)), this.updateTarget(this.bindingObserver.observe(td, Ae));
}
function triggerBind(td, Ae) {
  this.source = td, this.context = Ae, this.target.addEventListener(this.targetName, this);
}
function normalUnbind() {
  this.bindingObserver.disconnect(), this.source = null, this.context = null;
}
function contentUnbind() {
  this.bindingObserver.disconnect(), this.source = null, this.context = null;
  const td = this.target.$fastView;
  td !== void 0 && td.isComposed && (td.unbind(), td.needsBindOnly = !0);
}
function triggerUnbind() {
  this.target.removeEventListener(this.targetName, this), this.source = null, this.context = null;
}
function updateAttributeTarget(td) {
  DOM.setAttribute(this.target, this.targetName, td);
}
function updateBooleanAttributeTarget(td) {
  DOM.setBooleanAttribute(this.target, this.targetName, td);
}
function updateContentTarget(td) {
  if (td == null && (td = ""), td.create) {
    this.target.textContent = "";
    let Ae = this.target.$fastView;
    Ae === void 0 ? Ae = td.create() : this.target.$fastTemplate !== td && (Ae.isComposed && (Ae.remove(), Ae.unbind()), Ae = td.create()), Ae.isComposed ? Ae.needsBindOnly && (Ae.needsBindOnly = !1, Ae.bind(this.source, this.context)) : (Ae.isComposed = !0, Ae.bind(this.source, this.context), Ae.insertBefore(this.target), this.target.$fastView = Ae, this.target.$fastTemplate = td);
  } else {
    const Ae = this.target.$fastView;
    Ae !== void 0 && Ae.isComposed && (Ae.isComposed = !1, Ae.remove(), Ae.needsBindOnly ? Ae.needsBindOnly = !1 : Ae.unbind()), this.target.textContent = td;
  }
}
function updatePropertyTarget(td) {
  this.target[this.targetName] = td;
}
function updateClassTarget(td) {
  const Ae = this.classVersions || /* @__PURE__ */ Object.create(null), xr = this.target;
  let ed = this.version || 0;
  if (td != null && td.length) {
    const id = td.split(/\s+/);
    for (let od = 0, ad = id.length; od < ad; ++od) {
      const rd = id[od];
      rd !== "" && (Ae[rd] = ed, xr.classList.add(rd));
    }
  }
  if (this.classVersions = Ae, this.version = ed + 1, ed !== 0) {
    ed -= 1;
    for (const id in Ae)
      Ae[id] === ed && xr.classList.remove(id);
  }
}
class HTMLBindingDirective extends TargetedHTMLDirective {
  /**
   * Creates an instance of BindingDirective.
   * @param binding - A binding that returns the data used to update the DOM.
   */
  constructor(Ae) {
    super(), this.binding = Ae, this.bind = normalBind, this.unbind = normalUnbind, this.updateTarget = updateAttributeTarget, this.isBindingVolatile = Observable.isVolatileBinding(this.binding);
  }
  /**
   * Gets/sets the name of the attribute or property that this
   * binding is targeting.
   */
  get targetName() {
    return this.originalTargetName;
  }
  set targetName(Ae) {
    if (this.originalTargetName = Ae, Ae !== void 0)
      switch (Ae[0]) {
        case ":":
          if (this.cleanedTargetName = Ae.substr(1), this.updateTarget = updatePropertyTarget, this.cleanedTargetName === "innerHTML") {
            const xr = this.binding;
            this.binding = (ed, id) => DOM.createHTML(xr(ed, id));
          }
          break;
        case "?":
          this.cleanedTargetName = Ae.substr(1), this.updateTarget = updateBooleanAttributeTarget;
          break;
        case "@":
          this.cleanedTargetName = Ae.substr(1), this.bind = triggerBind, this.unbind = triggerUnbind;
          break;
        default:
          this.cleanedTargetName = Ae, Ae === "class" && (this.updateTarget = updateClassTarget);
          break;
      }
  }
  /**
   * Makes this binding target the content of an element rather than
   * a particular attribute or property.
   */
  targetAtContent() {
    this.updateTarget = updateContentTarget, this.unbind = contentUnbind;
  }
  /**
   * Creates the runtime BindingBehavior instance based on the configuration
   * information stored in the BindingDirective.
   * @param target - The target node that the binding behavior should attach to.
   */
  createBehavior(Ae) {
    return new BindingBehavior(Ae, this.binding, this.isBindingVolatile, this.bind, this.unbind, this.updateTarget, this.cleanedTargetName);
  }
}
class BindingBehavior {
  /**
   * Creates an instance of BindingBehavior.
   * @param target - The target of the data updates.
   * @param binding - The binding that returns the latest value for an update.
   * @param isBindingVolatile - Indicates whether the binding has volatile dependencies.
   * @param bind - The operation to perform during binding.
   * @param unbind - The operation to perform during unbinding.
   * @param updateTarget - The operation to perform when updating.
   * @param targetName - The name of the target attribute or property to update.
   */
  constructor(Ae, xr, ed, id, od, ad, rd) {
    this.source = null, this.context = null, this.bindingObserver = null, this.target = Ae, this.binding = xr, this.isBindingVolatile = ed, this.bind = id, this.unbind = od, this.updateTarget = ad, this.targetName = rd;
  }
  /** @internal */
  handleChange() {
    this.updateTarget(this.bindingObserver.observe(this.source, this.context));
  }
  /** @internal */
  handleEvent(Ae) {
    ExecutionContext.setEvent(Ae);
    const xr = this.binding(this.source, this.context);
    ExecutionContext.setEvent(null), xr !== !0 && Ae.preventDefault();
  }
}
let sharedContext = null;
class CompilationContext {
  addFactory(Ae) {
    Ae.targetIndex = this.targetIndex, this.behaviorFactories.push(Ae);
  }
  captureContentBinding(Ae) {
    Ae.targetAtContent(), this.addFactory(Ae);
  }
  reset() {
    this.behaviorFactories = [], this.targetIndex = -1;
  }
  release() {
    sharedContext = this;
  }
  static borrow(Ae) {
    const xr = sharedContext || new CompilationContext();
    return xr.directives = Ae, xr.reset(), sharedContext = null, xr;
  }
}
function createAggregateBinding(td) {
  if (td.length === 1)
    return td[0];
  let Ae;
  const xr = td.length, ed = td.map((ad) => typeof ad == "string" ? () => ad : (Ae = ad.targetName || Ae, ad.binding)), id = (ad, rd) => {
    let sd = "";
    for (let nd = 0; nd < xr; ++nd)
      sd += ed[nd](ad, rd);
    return sd;
  }, od = new HTMLBindingDirective(id);
  return od.targetName = Ae, od;
}
const interpolationEndLength = _interpolationEnd.length;
function parseContent(td, Ae) {
  const xr = Ae.split(_interpolationStart);
  if (xr.length === 1)
    return null;
  const ed = [];
  for (let id = 0, od = xr.length; id < od; ++id) {
    const ad = xr[id], rd = ad.indexOf(_interpolationEnd);
    let sd;
    if (rd === -1)
      sd = ad;
    else {
      const nd = parseInt(ad.substring(0, rd));
      ed.push(td.directives[nd]), sd = ad.substring(rd + interpolationEndLength);
    }
    sd !== "" && ed.push(sd);
  }
  return ed;
}
function compileAttributes(td, Ae, xr = !1) {
  const ed = Ae.attributes;
  for (let id = 0, od = ed.length; id < od; ++id) {
    const ad = ed[id], rd = ad.value, sd = parseContent(td, rd);
    let nd = null;
    sd === null ? xr && (nd = new HTMLBindingDirective(() => rd), nd.targetName = ad.name) : nd = createAggregateBinding(sd), nd !== null && (Ae.removeAttributeNode(ad), id--, od--, td.addFactory(nd));
  }
}
function compileContent(td, Ae, xr) {
  const ed = parseContent(td, Ae.textContent);
  if (ed !== null) {
    let id = Ae;
    for (let od = 0, ad = ed.length; od < ad; ++od) {
      const rd = ed[od], sd = od === 0 ? Ae : id.parentNode.insertBefore(document.createTextNode(""), id.nextSibling);
      typeof rd == "string" ? sd.textContent = rd : (sd.textContent = " ", td.captureContentBinding(rd)), id = sd, td.targetIndex++, sd !== Ae && xr.nextNode();
    }
    td.targetIndex--;
  }
}
function compileTemplate(td, Ae) {
  const xr = td.content;
  document.adoptNode(xr);
  const ed = CompilationContext.borrow(Ae);
  compileAttributes(ed, td, !0);
  const id = ed.behaviorFactories;
  ed.reset();
  const od = DOM.createTemplateWalker(xr);
  let ad;
  for (; ad = od.nextNode(); )
    switch (ed.targetIndex++, ad.nodeType) {
      case 1:
        compileAttributes(ed, ad);
        break;
      case 3:
        compileContent(ed, ad, od);
        break;
      case 8:
        DOM.isMarker(ad) && ed.addFactory(Ae[DOM.extractDirectiveIndexFromMarker(ad)]);
    }
  let rd = 0;
  // If the first node in a fragment is a marker, that means it's an unstable first node,
  // because something like a when, repeat, etc. could add nodes before the marker.
  // To mitigate this, we insert a stable first node. However, if we insert a node,
  // that will alter the result of the TreeWalker. So, we also need to offset the target index.
  (DOM.isMarker(xr.firstChild) || // Or if there is only one node and a directive, it means the template's content
  // is *only* the directive. In that case, HTMLView.dispose() misses any nodes inserted by
  // the directive. Inserting a new node ensures proper disposal of nodes added by the directive.
  xr.childNodes.length === 1 && Ae.length) && (xr.insertBefore(document.createComment(""), xr.firstChild), rd = -1);
  const sd = ed.behaviorFactories;
  return ed.release(), {
    fragment: xr,
    viewBehaviorFactories: sd,
    hostBehaviorFactories: id,
    targetOffset: rd
  };
}
const range = document.createRange();
class HTMLView {
  /**
   * Constructs an instance of HTMLView.
   * @param fragment - The html fragment that contains the nodes for this view.
   * @param behaviors - The behaviors to be applied to this view.
   */
  constructor(Ae, xr) {
    this.fragment = Ae, this.behaviors = xr, this.source = null, this.context = null, this.firstChild = Ae.firstChild, this.lastChild = Ae.lastChild;
  }
  /**
   * Appends the view's DOM nodes to the referenced node.
   * @param node - The parent node to append the view's DOM nodes to.
   */
  appendTo(Ae) {
    Ae.appendChild(this.fragment);
  }
  /**
   * Inserts the view's DOM nodes before the referenced node.
   * @param node - The node to insert the view's DOM before.
   */
  insertBefore(Ae) {
    if (this.fragment.hasChildNodes())
      Ae.parentNode.insertBefore(this.fragment, Ae);
    else {
      const xr = this.lastChild;
      if (Ae.previousSibling === xr)
        return;
      const ed = Ae.parentNode;
      let id = this.firstChild, od;
      for (; id !== xr; )
        od = id.nextSibling, ed.insertBefore(id, Ae), id = od;
      ed.insertBefore(xr, Ae);
    }
  }
  /**
   * Removes the view's DOM nodes.
   * The nodes are not disposed and the view can later be re-inserted.
   */
  remove() {
    const Ae = this.fragment, xr = this.lastChild;
    let ed = this.firstChild, id;
    for (; ed !== xr; )
      id = ed.nextSibling, Ae.appendChild(ed), ed = id;
    Ae.appendChild(xr);
  }
  /**
   * Removes the view and unbinds its behaviors, disposing of DOM nodes afterward.
   * Once a view has been disposed, it cannot be inserted or bound again.
   */
  dispose() {
    const Ae = this.firstChild.parentNode, xr = this.lastChild;
    let ed = this.firstChild, id;
    for (; ed !== xr; )
      id = ed.nextSibling, Ae.removeChild(ed), ed = id;
    Ae.removeChild(xr);
    const od = this.behaviors, ad = this.source;
    for (let rd = 0, sd = od.length; rd < sd; ++rd)
      od[rd].unbind(ad);
  }
  /**
   * Binds a view's behaviors to its binding source.
   * @param source - The binding source for the view's binding behaviors.
   * @param context - The execution context to run the behaviors within.
   */
  bind(Ae, xr) {
    const ed = this.behaviors;
    if (this.source !== Ae)
      if (this.source !== null) {
        const id = this.source;
        this.source = Ae, this.context = xr;
        for (let od = 0, ad = ed.length; od < ad; ++od) {
          const rd = ed[od];
          rd.unbind(id), rd.bind(Ae, xr);
        }
      } else {
        this.source = Ae, this.context = xr;
        for (let id = 0, od = ed.length; id < od; ++id)
          ed[id].bind(Ae, xr);
      }
  }
  /**
   * Unbinds a view's behaviors from its binding source.
   */
  unbind() {
    if (this.source === null)
      return;
    const Ae = this.behaviors, xr = this.source;
    for (let ed = 0, id = Ae.length; ed < id; ++ed)
      Ae[ed].unbind(xr);
    this.source = null;
  }
  /**
   * Efficiently disposes of a contiguous range of synthetic view instances.
   * @param views - A contiguous range of views to be disposed.
   */
  static disposeContiguousBatch(Ae) {
    if (Ae.length !== 0) {
      range.setStartBefore(Ae[0].firstChild), range.setEndAfter(Ae[Ae.length - 1].lastChild), range.deleteContents();
      for (let xr = 0, ed = Ae.length; xr < ed; ++xr) {
        const id = Ae[xr], od = id.behaviors, ad = id.source;
        for (let rd = 0, sd = od.length; rd < sd; ++rd)
          od[rd].unbind(ad);
      }
    }
  }
}
class ViewTemplate {
  /**
   * Creates an instance of ViewTemplate.
   * @param html - The html representing what this template will instantiate, including placeholders for directives.
   * @param directives - The directives that will be connected to placeholders in the html.
   */
  constructor(Ae, xr) {
    this.behaviorCount = 0, this.hasHostBehaviors = !1, this.fragment = null, this.targetOffset = 0, this.viewBehaviorFactories = null, this.hostBehaviorFactories = null, this.html = Ae, this.directives = xr;
  }
  /**
   * Creates an HTMLView instance based on this template definition.
   * @param hostBindingTarget - The element that host behaviors will be bound to.
   */
  create(Ae) {
    if (this.fragment === null) {
      let nd;
      const cd = this.html;
      if (typeof cd == "string") {
        nd = document.createElement("template"), nd.innerHTML = DOM.createHTML(cd);
        const ld = nd.content.firstElementChild;
        ld !== null && ld.tagName === "TEMPLATE" && (nd = ld);
      } else
        nd = cd;
      const ud = compileTemplate(nd, this.directives);
      this.fragment = ud.fragment, this.viewBehaviorFactories = ud.viewBehaviorFactories, this.hostBehaviorFactories = ud.hostBehaviorFactories, this.targetOffset = ud.targetOffset, this.behaviorCount = this.viewBehaviorFactories.length + this.hostBehaviorFactories.length, this.hasHostBehaviors = this.hostBehaviorFactories.length > 0;
    }
    const xr = this.fragment.cloneNode(!0), ed = this.viewBehaviorFactories, id = new Array(this.behaviorCount), od = DOM.createTemplateWalker(xr);
    let ad = 0, rd = this.targetOffset, sd = od.nextNode();
    for (let nd = ed.length; ad < nd; ++ad) {
      const cd = ed[ad], ud = cd.targetIndex;
      for (; sd !== null; )
        if (rd === ud) {
          id[ad] = cd.createBehavior(sd);
          break;
        } else
          sd = od.nextNode(), rd++;
    }
    if (this.hasHostBehaviors) {
      const nd = this.hostBehaviorFactories;
      for (let cd = 0, ud = nd.length; cd < ud; ++cd, ++ad)
        id[ad] = nd[cd].createBehavior(Ae);
    }
    return new HTMLView(xr, id);
  }
  /**
   * Creates an HTMLView from this template, binds it to the source, and then appends it to the host.
   * @param source - The data source to bind the template to.
   * @param host - The Element where the template will be rendered.
   * @param hostBindingTarget - An HTML element to target the host bindings at if different from the
   * host that the template is being attached to.
   */
  render(Ae, xr, ed) {
    typeof xr == "string" && (xr = document.getElementById(xr)), ed === void 0 && (ed = xr);
    const id = this.create(ed);
    return id.bind(Ae, defaultExecutionContext), id.appendTo(xr), id;
  }
}
const lastAttributeNameRegex = (
  /* eslint-disable-next-line no-control-regex */
  /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/
);
function html(td, ...Ae) {
  const xr = [];
  let ed = "";
  for (let id = 0, od = td.length - 1; id < od; ++id) {
    const ad = td[id];
    let rd = Ae[id];
    if (ed += ad, rd instanceof ViewTemplate) {
      const sd = rd;
      rd = () => sd;
    }
    if (typeof rd == "function" && (rd = new HTMLBindingDirective(rd)), rd instanceof TargetedHTMLDirective) {
      const sd = lastAttributeNameRegex.exec(ad);
      sd !== null && (rd.targetName = sd[2]);
    }
    rd instanceof HTMLDirective ? (ed += rd.createPlaceholder(xr.length), xr.push(rd)) : ed += rd;
  }
  return ed += td[td.length - 1], new ViewTemplate(ed, xr);
}
class ElementStyles {
  constructor() {
    this.targets = /* @__PURE__ */ new WeakSet();
  }
  /** @internal */
  addStylesTo(Ae) {
    this.targets.add(Ae);
  }
  /** @internal */
  removeStylesFrom(Ae) {
    this.targets.delete(Ae);
  }
  /** @internal */
  isAttachedTo(Ae) {
    return this.targets.has(Ae);
  }
  /**
   * Associates behaviors with this set of styles.
   * @param behaviors - The behaviors to associate.
   */
  withBehaviors(...Ae) {
    return this.behaviors = this.behaviors === null ? Ae : this.behaviors.concat(Ae), this;
  }
}
ElementStyles.create = (() => {
  if (DOM.supportsAdoptedStyleSheets) {
    const td = /* @__PURE__ */ new Map();
    return (Ae) => (
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      new AdoptedStyleSheetsStyles(Ae, td)
    );
  }
  return (td) => new StyleElementStyles(td);
})();
function reduceStyles(td) {
  return td.map((Ae) => Ae instanceof ElementStyles ? reduceStyles(Ae.styles) : [Ae]).reduce((Ae, xr) => Ae.concat(xr), []);
}
function reduceBehaviors(td) {
  return td.map((Ae) => Ae instanceof ElementStyles ? Ae.behaviors : null).reduce((Ae, xr) => xr === null ? Ae : (Ae === null && (Ae = []), Ae.concat(xr)), null);
}
let addAdoptedStyleSheets = (td, Ae) => {
  td.adoptedStyleSheets = [...td.adoptedStyleSheets, ...Ae];
}, removeAdoptedStyleSheets = (td, Ae) => {
  td.adoptedStyleSheets = td.adoptedStyleSheets.filter((xr) => Ae.indexOf(xr) === -1);
};
if (DOM.supportsAdoptedStyleSheets)
  try {
    document.adoptedStyleSheets.push(), document.adoptedStyleSheets.splice(), addAdoptedStyleSheets = (td, Ae) => {
      td.adoptedStyleSheets.push(...Ae);
    }, removeAdoptedStyleSheets = (td, Ae) => {
      for (const xr of Ae) {
        const ed = td.adoptedStyleSheets.indexOf(xr);
        ed !== -1 && td.adoptedStyleSheets.splice(ed, 1);
      }
    };
  } catch (td) {
  }
class AdoptedStyleSheetsStyles extends ElementStyles {
  constructor(Ae, xr) {
    super(), this.styles = Ae, this.styleSheetCache = xr, this._styleSheets = void 0, this.behaviors = reduceBehaviors(Ae);
  }
  get styleSheets() {
    if (this._styleSheets === void 0) {
      const Ae = this.styles, xr = this.styleSheetCache;
      this._styleSheets = reduceStyles(Ae).map((ed) => {
        if (ed instanceof CSSStyleSheet)
          return ed;
        let id = xr.get(ed);
        return id === void 0 && (id = new CSSStyleSheet(), id.replaceSync(ed), xr.set(ed, id)), id;
      });
    }
    return this._styleSheets;
  }
  addStylesTo(Ae) {
    addAdoptedStyleSheets(Ae, this.styleSheets), super.addStylesTo(Ae);
  }
  removeStylesFrom(Ae) {
    removeAdoptedStyleSheets(Ae, this.styleSheets), super.removeStylesFrom(Ae);
  }
}
let styleClassId = 0;
function getNextStyleClass() {
  return `fast-style-class-${++styleClassId}`;
}
class StyleElementStyles extends ElementStyles {
  constructor(Ae) {
    super(), this.styles = Ae, this.behaviors = null, this.behaviors = reduceBehaviors(Ae), this.styleSheets = reduceStyles(Ae), this.styleClass = getNextStyleClass();
  }
  addStylesTo(Ae) {
    const xr = this.styleSheets, ed = this.styleClass;
    Ae = this.normalizeTarget(Ae);
    for (let id = 0; id < xr.length; id++) {
      const od = document.createElement("style");
      od.innerHTML = xr[id], od.className = ed, Ae.append(od);
    }
    super.addStylesTo(Ae);
  }
  removeStylesFrom(Ae) {
    Ae = this.normalizeTarget(Ae);
    const xr = Ae.querySelectorAll(`.${this.styleClass}`);
    for (let ed = 0, id = xr.length; ed < id; ++ed)
      Ae.removeChild(xr[ed]);
    super.removeStylesFrom(Ae);
  }
  isAttachedTo(Ae) {
    return super.isAttachedTo(this.normalizeTarget(Ae));
  }
  normalizeTarget(Ae) {
    return Ae === document ? document.body : Ae;
  }
}
const AttributeConfiguration = Object.freeze({
  /**
   * Locates all attribute configurations associated with a type.
   */
  locate: createMetadataLocator()
}), booleanConverter = {
  toView(td) {
    return td ? "true" : "false";
  },
  fromView(td) {
    return !(td == null || td === "false" || td === !1 || td === 0);
  }
}, nullableNumberConverter = {
  toView(td) {
    if (td == null)
      return null;
    const Ae = td * 1;
    return isNaN(Ae) ? null : Ae.toString();
  },
  fromView(td) {
    if (td == null)
      return null;
    const Ae = td * 1;
    return isNaN(Ae) ? null : Ae;
  }
};
class AttributeDefinition {
  /**
   * Creates an instance of AttributeDefinition.
   * @param Owner - The class constructor that owns this attribute.
   * @param name - The name of the property associated with the attribute.
   * @param attribute - The name of the attribute in HTML.
   * @param mode - The {@link AttributeMode} that describes the behavior of this attribute.
   * @param converter - A {@link ValueConverter} that integrates with the property getter/setter
   * to convert values to and from a DOM string.
   */
  constructor(Ae, xr, ed = xr.toLowerCase(), id = "reflect", od) {
    this.guards = /* @__PURE__ */ new Set(), this.Owner = Ae, this.name = xr, this.attribute = ed, this.mode = id, this.converter = od, this.fieldName = `_${xr}`, this.callbackName = `${xr}Changed`, this.hasCallback = this.callbackName in Ae.prototype, id === "boolean" && od === void 0 && (this.converter = booleanConverter);
  }
  /**
   * Sets the value of the attribute/property on the source element.
   * @param source - The source element to access.
   * @param value - The value to set the attribute/property to.
   */
  setValue(Ae, xr) {
    const ed = Ae[this.fieldName], id = this.converter;
    id !== void 0 && (xr = id.fromView(xr)), ed !== xr && (Ae[this.fieldName] = xr, this.tryReflectToAttribute(Ae), this.hasCallback && Ae[this.callbackName](ed, xr), Ae.$fastController.notify(this.name));
  }
  /**
   * Gets the value of the attribute/property on the source element.
   * @param source - The source element to access.
   */
  getValue(Ae) {
    return Observable.track(Ae, this.name), Ae[this.fieldName];
  }
  /** @internal */
  onAttributeChangedCallback(Ae, xr) {
    this.guards.has(Ae) || (this.guards.add(Ae), this.setValue(Ae, xr), this.guards.delete(Ae));
  }
  tryReflectToAttribute(Ae) {
    const xr = this.mode, ed = this.guards;
    ed.has(Ae) || xr === "fromView" || DOM.queueUpdate(() => {
      ed.add(Ae);
      const id = Ae[this.fieldName];
      switch (xr) {
        case "reflect":
          const od = this.converter;
          DOM.setAttribute(Ae, this.attribute, od !== void 0 ? od.toView(id) : id);
          break;
        case "boolean":
          DOM.setBooleanAttribute(Ae, this.attribute, id);
          break;
      }
      ed.delete(Ae);
    });
  }
  /**
   * Collects all attribute definitions associated with the owner.
   * @param Owner - The class constructor to collect attribute for.
   * @param attributeLists - Any existing attributes to collect and merge with those associated with the owner.
   * @internal
   */
  static collect(Ae, ...xr) {
    const ed = [];
    xr.push(AttributeConfiguration.locate(Ae));
    for (let id = 0, od = xr.length; id < od; ++id) {
      const ad = xr[id];
      if (ad !== void 0)
        for (let rd = 0, sd = ad.length; rd < sd; ++rd) {
          const nd = ad[rd];
          typeof nd == "string" ? ed.push(new AttributeDefinition(Ae, nd)) : ed.push(new AttributeDefinition(Ae, nd.property, nd.attribute, nd.mode, nd.converter));
        }
    }
    return ed;
  }
}
function attr(td, Ae) {
  let xr;
  function ed(id, od) {
    arguments.length > 1 && (xr.property = od), AttributeConfiguration.locate(id.constructor).push(xr);
  }
  if (arguments.length > 1) {
    xr = {}, ed(td, Ae);
    return;
  }
  return xr = td === void 0 ? {} : td, ed;
}
const defaultShadowOptions = { mode: "open" }, defaultElementOptions = {}, fastRegistry = FAST.getById(4, () => {
  const td = /* @__PURE__ */ new Map();
  return Object.freeze({
    register(Ae) {
      return td.has(Ae.type) ? !1 : (td.set(Ae.type, Ae), !0);
    },
    getByType(Ae) {
      return td.get(Ae);
    }
  });
});
class FASTElementDefinition {
  /**
   * Creates an instance of FASTElementDefinition.
   * @param type - The type this definition is being created for.
   * @param nameOrConfig - The name of the element to define or a config object
   * that describes the element to define.
   */
  constructor(Ae, xr = Ae.definition) {
    typeof xr == "string" && (xr = { name: xr }), this.type = Ae, this.name = xr.name, this.template = xr.template;
    const ed = AttributeDefinition.collect(Ae, xr.attributes), id = new Array(ed.length), od = {}, ad = {};
    for (let rd = 0, sd = ed.length; rd < sd; ++rd) {
      const nd = ed[rd];
      id[rd] = nd.attribute, od[nd.name] = nd, ad[nd.attribute] = nd;
    }
    this.attributes = ed, this.observedAttributes = id, this.propertyLookup = od, this.attributeLookup = ad, this.shadowOptions = xr.shadowOptions === void 0 ? defaultShadowOptions : xr.shadowOptions === null ? void 0 : Object.assign(Object.assign({}, defaultShadowOptions), xr.shadowOptions), this.elementOptions = xr.elementOptions === void 0 ? defaultElementOptions : Object.assign(Object.assign({}, defaultElementOptions), xr.elementOptions), this.styles = xr.styles === void 0 ? void 0 : Array.isArray(xr.styles) ? ElementStyles.create(xr.styles) : xr.styles instanceof ElementStyles ? xr.styles : ElementStyles.create([xr.styles]);
  }
  /**
   * Indicates if this element has been defined in at least one registry.
   */
  get isDefined() {
    return !!fastRegistry.getByType(this.type);
  }
  /**
   * Defines a custom element based on this definition.
   * @param registry - The element registry to define the element in.
   */
  define(Ae = customElements) {
    const xr = this.type;
    if (fastRegistry.register(this)) {
      const ed = this.attributes, id = xr.prototype;
      for (let od = 0, ad = ed.length; od < ad; ++od)
        Observable.defineProperty(id, ed[od]);
      Reflect.defineProperty(xr, "observedAttributes", {
        value: this.observedAttributes,
        enumerable: !0
      });
    }
    return Ae.get(this.name) || Ae.define(this.name, xr, this.elementOptions), this;
  }
}
FASTElementDefinition.forType = fastRegistry.getByType;
const shadowRoots = /* @__PURE__ */ new WeakMap(), defaultEventOptions = {
  bubbles: !0,
  composed: !0,
  cancelable: !0
};
function getShadowRoot(td) {
  return td.shadowRoot || shadowRoots.get(td) || null;
}
class Controller extends PropertyChangeNotifier {
  /**
   * Creates a Controller to control the specified element.
   * @param element - The element to be controlled by this controller.
   * @param definition - The element definition metadata that instructs this
   * controller in how to handle rendering and other platform integrations.
   * @internal
   */
  constructor(Ae, xr) {
    super(Ae), this.boundObservables = null, this.behaviors = null, this.needsInitialization = !0, this._template = null, this._styles = null, this._isConnected = !1, this.$fastController = this, this.view = null, this.element = Ae, this.definition = xr;
    const ed = xr.shadowOptions;
    if (ed !== void 0) {
      const od = Ae.attachShadow(ed);
      ed.mode === "closed" && shadowRoots.set(Ae, od);
    }
    const id = Observable.getAccessors(Ae);
    if (id.length > 0) {
      const od = this.boundObservables = /* @__PURE__ */ Object.create(null);
      for (let ad = 0, rd = id.length; ad < rd; ++ad) {
        const sd = id[ad].name, nd = Ae[sd];
        nd !== void 0 && (delete Ae[sd], od[sd] = nd);
      }
    }
  }
  /**
   * Indicates whether or not the custom element has been
   * connected to the document.
   */
  get isConnected() {
    return Observable.track(this, "isConnected"), this._isConnected;
  }
  setIsConnected(Ae) {
    this._isConnected = Ae, Observable.notify(this, "isConnected");
  }
  /**
   * Gets/sets the template used to render the component.
   * @remarks
   * This value can only be accurately read after connect but can be set at any time.
   */
  get template() {
    return this._template;
  }
  set template(Ae) {
    this._template !== Ae && (this._template = Ae, this.needsInitialization || this.renderTemplate(Ae));
  }
  /**
   * Gets/sets the primary styles used for the component.
   * @remarks
   * This value can only be accurately read after connect but can be set at any time.
   */
  get styles() {
    return this._styles;
  }
  set styles(Ae) {
    this._styles !== Ae && (this._styles !== null && this.removeStyles(this._styles), this._styles = Ae, !this.needsInitialization && Ae !== null && this.addStyles(Ae));
  }
  /**
   * Adds styles to this element. Providing an HTMLStyleElement will attach the element instance to the shadowRoot.
   * @param styles - The styles to add.
   */
  addStyles(Ae) {
    const xr = getShadowRoot(this.element) || this.element.getRootNode();
    if (Ae instanceof HTMLStyleElement)
      xr.append(Ae);
    else if (!Ae.isAttachedTo(xr)) {
      const ed = Ae.behaviors;
      Ae.addStylesTo(xr), ed !== null && this.addBehaviors(ed);
    }
  }
  /**
   * Removes styles from this element. Providing an HTMLStyleElement will detach the element instance from the shadowRoot.
   * @param styles - the styles to remove.
   */
  removeStyles(Ae) {
    const xr = getShadowRoot(this.element) || this.element.getRootNode();
    if (Ae instanceof HTMLStyleElement)
      xr.removeChild(Ae);
    else if (Ae.isAttachedTo(xr)) {
      const ed = Ae.behaviors;
      Ae.removeStylesFrom(xr), ed !== null && this.removeBehaviors(ed);
    }
  }
  /**
   * Adds behaviors to this element.
   * @param behaviors - The behaviors to add.
   */
  addBehaviors(Ae) {
    const xr = this.behaviors || (this.behaviors = /* @__PURE__ */ new Map()), ed = Ae.length, id = [];
    for (let od = 0; od < ed; ++od) {
      const ad = Ae[od];
      xr.has(ad) ? xr.set(ad, xr.get(ad) + 1) : (xr.set(ad, 1), id.push(ad));
    }
    if (this._isConnected) {
      const od = this.element;
      for (let ad = 0; ad < id.length; ++ad)
        id[ad].bind(od, defaultExecutionContext);
    }
  }
  /**
   * Removes behaviors from this element.
   * @param behaviors - The behaviors to remove.
   * @param force - Forces unbinding of behaviors.
   */
  removeBehaviors(Ae, xr = !1) {
    const ed = this.behaviors;
    if (ed === null)
      return;
    const id = Ae.length, od = [];
    for (let ad = 0; ad < id; ++ad) {
      const rd = Ae[ad];
      if (ed.has(rd)) {
        const sd = ed.get(rd) - 1;
        sd === 0 || xr ? ed.delete(rd) && od.push(rd) : ed.set(rd, sd);
      }
    }
    if (this._isConnected) {
      const ad = this.element;
      for (let rd = 0; rd < od.length; ++rd)
        od[rd].unbind(ad);
    }
  }
  /**
   * Runs connected lifecycle behavior on the associated element.
   */
  onConnectedCallback() {
    if (this._isConnected)
      return;
    const Ae = this.element;
    this.needsInitialization ? this.finishInitialization() : this.view !== null && this.view.bind(Ae, defaultExecutionContext);
    const xr = this.behaviors;
    if (xr !== null)
      for (const [ed] of xr)
        ed.bind(Ae, defaultExecutionContext);
    this.setIsConnected(!0);
  }
  /**
   * Runs disconnected lifecycle behavior on the associated element.
   */
  onDisconnectedCallback() {
    if (!this._isConnected)
      return;
    this.setIsConnected(!1);
    const Ae = this.view;
    Ae !== null && Ae.unbind();
    const xr = this.behaviors;
    if (xr !== null) {
      const ed = this.element;
      for (const [id] of xr)
        id.unbind(ed);
    }
  }
  /**
   * Runs the attribute changed callback for the associated element.
   * @param name - The name of the attribute that changed.
   * @param oldValue - The previous value of the attribute.
   * @param newValue - The new value of the attribute.
   */
  onAttributeChangedCallback(Ae, xr, ed) {
    const id = this.definition.attributeLookup[Ae];
    id !== void 0 && id.onAttributeChangedCallback(this.element, ed);
  }
  /**
   * Emits a custom HTML event.
   * @param type - The type name of the event.
   * @param detail - The event detail object to send with the event.
   * @param options - The event options. By default bubbles and composed.
   * @remarks
   * Only emits events if connected.
   */
  emit(Ae, xr, ed) {
    return this._isConnected ? this.element.dispatchEvent(new CustomEvent(Ae, Object.assign(Object.assign({ detail: xr }, defaultEventOptions), ed))) : !1;
  }
  finishInitialization() {
    const Ae = this.element, xr = this.boundObservables;
    if (xr !== null) {
      const id = Object.keys(xr);
      for (let od = 0, ad = id.length; od < ad; ++od) {
        const rd = id[od];
        Ae[rd] = xr[rd];
      }
      this.boundObservables = null;
    }
    const ed = this.definition;
    this._template === null && (this.element.resolveTemplate ? this._template = this.element.resolveTemplate() : ed.template && (this._template = ed.template || null)), this._template !== null && this.renderTemplate(this._template), this._styles === null && (this.element.resolveStyles ? this._styles = this.element.resolveStyles() : ed.styles && (this._styles = ed.styles || null)), this._styles !== null && this.addStyles(this._styles), this.needsInitialization = !1;
  }
  renderTemplate(Ae) {
    const xr = this.element, ed = getShadowRoot(xr) || xr;
    this.view !== null ? (this.view.dispose(), this.view = null) : this.needsInitialization || DOM.removeChildNodes(ed), Ae && (this.view = Ae.render(xr, ed, xr));
  }
  /**
   * Locates or creates a controller for the specified element.
   * @param element - The element to return the controller for.
   * @remarks
   * The specified element must have a {@link FASTElementDefinition}
   * registered either through the use of the {@link customElement}
   * decorator or a call to `FASTElement.define`.
   */
  static forCustomElement(Ae) {
    const xr = Ae.$fastController;
    if (xr !== void 0)
      return xr;
    const ed = FASTElementDefinition.forType(Ae.constructor);
    if (ed === void 0)
      throw new Error("Missing FASTElement definition.");
    return Ae.$fastController = new Controller(Ae, ed);
  }
}
function createFASTElement(td) {
  return class extends td {
    constructor() {
      super(), Controller.forCustomElement(this);
    }
    $emit(Ae, xr, ed) {
      return this.$fastController.emit(Ae, xr, ed);
    }
    connectedCallback() {
      this.$fastController.onConnectedCallback();
    }
    disconnectedCallback() {
      this.$fastController.onDisconnectedCallback();
    }
    attributeChangedCallback(Ae, xr, ed) {
      this.$fastController.onAttributeChangedCallback(Ae, xr, ed);
    }
  };
}
const FASTElement = Object.assign(createFASTElement(HTMLElement), {
  /**
   * Creates a new FASTElement base class inherited from the
   * provided base type.
   * @param BaseType - The base element type to inherit from.
   */
  from(td) {
    return createFASTElement(td);
  },
  /**
   * Defines a platform custom element based on the provided type and definition.
   * @param type - The custom element type to define.
   * @param nameOrDef - The name of the element to define or a definition object
   * that describes the element to define.
   */
  define(td, Ae) {
    return new FASTElementDefinition(td, Ae).define().type;
  }
});
function customElement(td) {
  return function(Ae) {
    new FASTElementDefinition(Ae, td).define();
  };
}
class CSSDirective {
  /**
   * Creates a CSS fragment to interpolate into the CSS document.
   * @returns - the string to interpolate into CSS
   */
  createCSS() {
    return "";
  }
  /**
   * Creates a behavior to bind to the host element.
   * @returns - the behavior to bind to the host element, or undefined.
   */
  createBehavior() {
  }
}
function collectStyles(td, Ae) {
  const xr = [];
  let ed = "";
  const id = [];
  for (let od = 0, ad = td.length - 1; od < ad; ++od) {
    ed += td[od];
    let rd = Ae[od];
    if (rd instanceof CSSDirective) {
      const sd = rd.createBehavior();
      rd = rd.createCSS(), sd && id.push(sd);
    }
    rd instanceof ElementStyles || rd instanceof CSSStyleSheet ? (ed.trim() !== "" && (xr.push(ed), ed = ""), xr.push(rd)) : ed += rd;
  }
  return ed += td[td.length - 1], ed.trim() !== "" && xr.push(ed), {
    styles: xr,
    behaviors: id
  };
}
function css(td, ...Ae) {
  const { styles: xr, behaviors: ed } = collectStyles(td, Ae), id = ElementStyles.create(xr);
  return ed.length && id.withBehaviors(...ed), id;
}
class CSSPartial extends CSSDirective {
  constructor(Ae, xr) {
    super(), this.behaviors = xr, this.css = "";
    const ed = Ae.reduce((id, od) => (typeof od == "string" ? this.css += od : id.push(od), id), []);
    ed.length && (this.styles = ElementStyles.create(ed));
  }
  createBehavior() {
    return this;
  }
  createCSS() {
    return this.css;
  }
  bind(Ae) {
    this.styles && Ae.$fastController.addStyles(this.styles), this.behaviors.length && Ae.$fastController.addBehaviors(this.behaviors);
  }
  unbind(Ae) {
    this.styles && Ae.$fastController.removeStyles(this.styles), this.behaviors.length && Ae.$fastController.removeBehaviors(this.behaviors);
  }
}
function cssPartial(td, ...Ae) {
  const { styles: xr, behaviors: ed } = collectStyles(td, Ae);
  return new CSSPartial(xr, ed);
}
function newSplice(td, Ae, xr) {
  return {
    index: td,
    removed: Ae,
    addedCount: xr
  };
}
const EDIT_LEAVE = 0, EDIT_UPDATE = 1, EDIT_ADD = 2, EDIT_DELETE = 3;
function calcEditDistances(td, Ae, xr, ed, id, od) {
  const ad = od - id + 1, rd = xr - Ae + 1, sd = new Array(ad);
  let nd, cd;
  for (let ud = 0; ud < ad; ++ud)
    sd[ud] = new Array(rd), sd[ud][0] = ud;
  for (let ud = 0; ud < rd; ++ud)
    sd[0][ud] = ud;
  for (let ud = 1; ud < ad; ++ud)
    for (let ld = 1; ld < rd; ++ld)
      td[Ae + ld - 1] === ed[id + ud - 1] ? sd[ud][ld] = sd[ud - 1][ld - 1] : (nd = sd[ud - 1][ld] + 1, cd = sd[ud][ld - 1] + 1, sd[ud][ld] = nd < cd ? nd : cd);
  return sd;
}
function spliceOperationsFromEditDistances(td) {
  let Ae = td.length - 1, xr = td[0].length - 1, ed = td[Ae][xr];
  const id = [];
  for (; Ae > 0 || xr > 0; ) {
    if (Ae === 0) {
      id.push(EDIT_ADD), xr--;
      continue;
    }
    if (xr === 0) {
      id.push(EDIT_DELETE), Ae--;
      continue;
    }
    const od = td[Ae - 1][xr - 1], ad = td[Ae - 1][xr], rd = td[Ae][xr - 1];
    let sd;
    ad < rd ? sd = ad < od ? ad : od : sd = rd < od ? rd : od, sd === od ? (od === ed ? id.push(EDIT_LEAVE) : (id.push(EDIT_UPDATE), ed = od), Ae--, xr--) : sd === ad ? (id.push(EDIT_DELETE), Ae--, ed = ad) : (id.push(EDIT_ADD), xr--, ed = rd);
  }
  return id.reverse(), id;
}
function sharedPrefix(td, Ae, xr) {
  for (let ed = 0; ed < xr; ++ed)
    if (td[ed] !== Ae[ed])
      return ed;
  return xr;
}
function sharedSuffix(td, Ae, xr) {
  let ed = td.length, id = Ae.length, od = 0;
  for (; od < xr && td[--ed] === Ae[--id]; )
    od++;
  return od;
}
function intersect(td, Ae, xr, ed) {
  return Ae < xr || ed < td ? -1 : Ae === xr || ed === td ? 0 : td < xr ? Ae < ed ? Ae - xr : ed - xr : ed < Ae ? ed - td : Ae - td;
}
function calcSplices(td, Ae, xr, ed, id, od) {
  let ad = 0, rd = 0;
  const sd = Math.min(xr - Ae, od - id);
  if (Ae === 0 && id === 0 && (ad = sharedPrefix(td, ed, sd)), xr === td.length && od === ed.length && (rd = sharedSuffix(td, ed, sd - ad)), Ae += ad, id += ad, xr -= rd, od -= rd, xr - Ae === 0 && od - id === 0)
    return emptyArray;
  if (Ae === xr) {
    const pd = newSplice(Ae, [], 0);
    for (; id < od; )
      pd.removed.push(ed[id++]);
    return [pd];
  } else if (id === od)
    return [newSplice(Ae, [], xr - Ae)];
  const nd = spliceOperationsFromEditDistances(calcEditDistances(td, Ae, xr, ed, id, od)), cd = [];
  let ud, ld = Ae, dd = id;
  for (let pd = 0; pd < nd.length; ++pd)
    switch (nd[pd]) {
      case EDIT_LEAVE:
        ud !== void 0 && (cd.push(ud), ud = void 0), ld++, dd++;
        break;
      case EDIT_UPDATE:
        ud === void 0 && (ud = newSplice(ld, [], 0)), ud.addedCount++, ld++, ud.removed.push(ed[dd]), dd++;
        break;
      case EDIT_ADD:
        ud === void 0 && (ud = newSplice(ld, [], 0)), ud.addedCount++, ld++;
        break;
      case EDIT_DELETE:
        ud === void 0 && (ud = newSplice(ld, [], 0)), ud.removed.push(ed[dd]), dd++;
        break;
    }
  return ud !== void 0 && cd.push(ud), cd;
}
const $push = Array.prototype.push;
function mergeSplice(td, Ae, xr, ed) {
  const id = newSplice(Ae, xr, ed);
  let od = !1, ad = 0;
  for (let rd = 0; rd < td.length; rd++) {
    const sd = td[rd];
    if (sd.index += ad, od)
      continue;
    const nd = intersect(id.index, id.index + id.removed.length, sd.index, sd.index + sd.addedCount);
    if (nd >= 0) {
      td.splice(rd, 1), rd--, ad -= sd.addedCount - sd.removed.length, id.addedCount += sd.addedCount - nd;
      const cd = id.removed.length + sd.removed.length - nd;
      if (!id.addedCount && !cd)
        od = !0;
      else {
        let ud = sd.removed;
        if (id.index < sd.index) {
          const ld = id.removed.slice(0, sd.index - id.index);
          $push.apply(ld, ud), ud = ld;
        }
        if (id.index + id.removed.length > sd.index + sd.addedCount) {
          const ld = id.removed.slice(sd.index + sd.addedCount - id.index);
          $push.apply(ud, ld);
        }
        id.removed = ud, sd.index < id.index && (id.index = sd.index);
      }
    } else if (id.index < sd.index) {
      od = !0, td.splice(rd, 0, id), rd++;
      const cd = id.addedCount - id.removed.length;
      sd.index += cd, ad += cd;
    }
  }
  od || td.push(id);
}
function createInitialSplices(td) {
  const Ae = [];
  for (let xr = 0, ed = td.length; xr < ed; xr++) {
    const id = td[xr];
    mergeSplice(Ae, id.index, id.removed, id.addedCount);
  }
  return Ae;
}
function projectArraySplices(td, Ae) {
  let xr = [];
  const ed = createInitialSplices(Ae);
  for (let id = 0, od = ed.length; id < od; ++id) {
    const ad = ed[id];
    if (ad.addedCount === 1 && ad.removed.length === 1) {
      ad.removed[0] !== td[ad.index] && xr.push(ad);
      continue;
    }
    xr = xr.concat(calcSplices(td, ad.index, ad.index + ad.addedCount, ad.removed, 0, ad.removed.length));
  }
  return xr;
}
let arrayObservationEnabled = !1;
function adjustIndex(td, Ae) {
  let xr = td.index;
  const ed = Ae.length;
  return xr > ed ? xr = ed - td.addedCount : xr < 0 && (xr = ed + td.removed.length + xr - td.addedCount), xr < 0 && (xr = 0), td.index = xr, td;
}
class ArrayObserver extends SubscriberSet {
  constructor(Ae) {
    super(Ae), this.oldCollection = void 0, this.splices = void 0, this.needsQueue = !0, this.call = this.flush, Reflect.defineProperty(Ae, "$fastController", {
      value: this,
      enumerable: !1
    });
  }
  subscribe(Ae) {
    this.flush(), super.subscribe(Ae);
  }
  addSplice(Ae) {
    this.splices === void 0 ? this.splices = [Ae] : this.splices.push(Ae), this.needsQueue && (this.needsQueue = !1, DOM.queueUpdate(this));
  }
  reset(Ae) {
    this.oldCollection = Ae, this.needsQueue && (this.needsQueue = !1, DOM.queueUpdate(this));
  }
  flush() {
    const Ae = this.splices, xr = this.oldCollection;
    if (Ae === void 0 && xr === void 0)
      return;
    this.needsQueue = !0, this.splices = void 0, this.oldCollection = void 0;
    const ed = xr === void 0 ? projectArraySplices(this.source, Ae) : calcSplices(this.source, 0, this.source.length, xr, 0, xr.length);
    this.notify(ed);
  }
}
function enableArrayObservation() {
  if (arrayObservationEnabled)
    return;
  arrayObservationEnabled = !0, Observable.setArrayObserverFactory((sd) => new ArrayObserver(sd));
  const td = Array.prototype;
  if (td.$fastPatch)
    return;
  Reflect.defineProperty(td, "$fastPatch", {
    value: 1,
    enumerable: !1
  });
  const Ae = td.pop, xr = td.push, ed = td.reverse, id = td.shift, od = td.sort, ad = td.splice, rd = td.unshift;
  td.pop = function() {
    const sd = this.length > 0, nd = Ae.apply(this, arguments), cd = this.$fastController;
    return cd !== void 0 && sd && cd.addSplice(newSplice(this.length, [nd], 0)), nd;
  }, td.push = function() {
    const sd = xr.apply(this, arguments), nd = this.$fastController;
    return nd !== void 0 && nd.addSplice(adjustIndex(newSplice(this.length - arguments.length, [], arguments.length), this)), sd;
  }, td.reverse = function() {
    let sd;
    const nd = this.$fastController;
    nd !== void 0 && (nd.flush(), sd = this.slice());
    const cd = ed.apply(this, arguments);
    return nd !== void 0 && nd.reset(sd), cd;
  }, td.shift = function() {
    const sd = this.length > 0, nd = id.apply(this, arguments), cd = this.$fastController;
    return cd !== void 0 && sd && cd.addSplice(newSplice(0, [nd], 0)), nd;
  }, td.sort = function() {
    let sd;
    const nd = this.$fastController;
    nd !== void 0 && (nd.flush(), sd = this.slice());
    const cd = od.apply(this, arguments);
    return nd !== void 0 && nd.reset(sd), cd;
  }, td.splice = function() {
    const sd = ad.apply(this, arguments), nd = this.$fastController;
    return nd !== void 0 && nd.addSplice(adjustIndex(newSplice(+arguments[0], sd, arguments.length > 2 ? arguments.length - 2 : 0), this)), sd;
  }, td.unshift = function() {
    const sd = rd.apply(this, arguments), nd = this.$fastController;
    return nd !== void 0 && nd.addSplice(adjustIndex(newSplice(0, [], arguments.length), this)), sd;
  };
}
class RefBehavior {
  /**
   * Creates an instance of RefBehavior.
   * @param target - The element to reference.
   * @param propertyName - The name of the property to assign the reference to.
   */
  constructor(Ae, xr) {
    this.target = Ae, this.propertyName = xr;
  }
  /**
   * Bind this behavior to the source.
   * @param source - The source to bind to.
   * @param context - The execution context that the binding is operating within.
   */
  bind(Ae) {
    Ae[this.propertyName] = this.target;
  }
  /**
   * Unbinds this behavior from the source.
   * @param source - The source to unbind from.
   */
  /* eslint-disable-next-line @typescript-eslint/no-empty-function */
  unbind() {
  }
}
function ref(td) {
  return new AttachedBehaviorHTMLDirective("fast-ref", RefBehavior, td);
}
const isFunction$1 = (td) => typeof td == "function", noTemplate = () => null;
function normalizeBinding(td) {
  return td === void 0 ? noTemplate : isFunction$1(td) ? td : () => td;
}
function when(td, Ae, xr) {
  const ed = isFunction$1(td) ? td : () => td, id = normalizeBinding(Ae), od = normalizeBinding(xr);
  return (ad, rd) => ed(ad, rd) ? id(ad, rd) : od(ad, rd);
}
const defaultRepeatOptions = Object.freeze({
  positioning: !1,
  recycle: !0
});
function bindWithoutPositioning(td, Ae, xr, ed) {
  td.bind(Ae[xr], ed);
}
function bindWithPositioning(td, Ae, xr, ed) {
  const id = Object.create(ed);
  id.index = xr, id.length = Ae.length, td.bind(Ae[xr], id);
}
class RepeatBehavior {
  /**
   * Creates an instance of RepeatBehavior.
   * @param location - The location in the DOM to render the repeat.
   * @param itemsBinding - The array to render.
   * @param isItemsBindingVolatile - Indicates whether the items binding has volatile dependencies.
   * @param templateBinding - The template to render for each item.
   * @param isTemplateBindingVolatile - Indicates whether the template binding has volatile dependencies.
   * @param options - Options used to turn on special repeat features.
   */
  constructor(Ae, xr, ed, id, od, ad) {
    this.location = Ae, this.itemsBinding = xr, this.templateBinding = id, this.options = ad, this.source = null, this.views = [], this.items = null, this.itemsObserver = null, this.originalContext = void 0, this.childContext = void 0, this.bindView = bindWithoutPositioning, this.itemsBindingObserver = Observable.binding(xr, this, ed), this.templateBindingObserver = Observable.binding(id, this, od), ad.positioning && (this.bindView = bindWithPositioning);
  }
  /**
   * Bind this behavior to the source.
   * @param source - The source to bind to.
   * @param context - The execution context that the binding is operating within.
   */
  bind(Ae, xr) {
    this.source = Ae, this.originalContext = xr, this.childContext = Object.create(xr), this.childContext.parent = Ae, this.childContext.parentContext = this.originalContext, this.items = this.itemsBindingObserver.observe(Ae, this.originalContext), this.template = this.templateBindingObserver.observe(Ae, this.originalContext), this.observeItems(!0), this.refreshAllViews();
  }
  /**
   * Unbinds this behavior from the source.
   * @param source - The source to unbind from.
   */
  unbind() {
    this.source = null, this.items = null, this.itemsObserver !== null && this.itemsObserver.unsubscribe(this), this.unbindAllViews(), this.itemsBindingObserver.disconnect(), this.templateBindingObserver.disconnect();
  }
  /** @internal */
  handleChange(Ae, xr) {
    Ae === this.itemsBinding ? (this.items = this.itemsBindingObserver.observe(this.source, this.originalContext), this.observeItems(), this.refreshAllViews()) : Ae === this.templateBinding ? (this.template = this.templateBindingObserver.observe(this.source, this.originalContext), this.refreshAllViews(!0)) : this.updateViews(xr);
  }
  observeItems(Ae = !1) {
    if (!this.items) {
      this.items = emptyArray;
      return;
    }
    const xr = this.itemsObserver, ed = this.itemsObserver = Observable.getNotifier(this.items), id = xr !== ed;
    id && xr !== null && xr.unsubscribe(this), (id || Ae) && ed.subscribe(this);
  }
  updateViews(Ae) {
    const xr = this.childContext, ed = this.views, id = this.bindView, od = this.items, ad = this.template, rd = this.options.recycle, sd = [];
    let nd = 0, cd = 0;
    for (let ud = 0, ld = Ae.length; ud < ld; ++ud) {
      const dd = Ae[ud], pd = dd.removed;
      let md = 0, fd = dd.index;
      const bd = fd + dd.addedCount, Sd = ed.splice(dd.index, pd.length), vd = cd = sd.length + Sd.length;
      for (; fd < bd; ++fd) {
        const Ed = ed[fd], Td = Ed ? Ed.firstChild : this.location;
        let Gd;
        rd && cd > 0 ? (md <= vd && Sd.length > 0 ? (Gd = Sd[md], md++) : (Gd = sd[nd], nd++), cd--) : Gd = ad.create(), ed.splice(fd, 0, Gd), id(Gd, od, fd, xr), Gd.insertBefore(Td);
      }
      Sd[md] && sd.push(...Sd.slice(md));
    }
    for (let ud = nd, ld = sd.length; ud < ld; ++ud)
      sd[ud].dispose();
    if (this.options.positioning)
      for (let ud = 0, ld = ed.length; ud < ld; ++ud) {
        const dd = ed[ud].context;
        dd.length = ld, dd.index = ud;
      }
  }
  refreshAllViews(Ae = !1) {
    const xr = this.items, ed = this.childContext, id = this.template, od = this.location, ad = this.bindView;
    let rd = xr.length, sd = this.views, nd = sd.length;
    if ((rd === 0 || Ae || !this.options.recycle) && (HTMLView.disposeContiguousBatch(sd), nd = 0), nd === 0) {
      this.views = sd = new Array(rd);
      for (let cd = 0; cd < rd; ++cd) {
        const ud = id.create();
        ad(ud, xr, cd, ed), sd[cd] = ud, ud.insertBefore(od);
      }
    } else {
      let cd = 0;
      for (; cd < rd; ++cd)
        if (cd < nd) {
          const ld = sd[cd];
          ad(ld, xr, cd, ed);
        } else {
          const ld = id.create();
          ad(ld, xr, cd, ed), sd.push(ld), ld.insertBefore(od);
        }
      const ud = sd.splice(cd, nd - cd);
      for (cd = 0, rd = ud.length; cd < rd; ++cd)
        ud[cd].dispose();
    }
  }
  unbindAllViews() {
    const Ae = this.views;
    for (let xr = 0, ed = Ae.length; xr < ed; ++xr)
      Ae[xr].unbind();
  }
}
class RepeatDirective extends HTMLDirective {
  /**
   * Creates an instance of RepeatDirective.
   * @param itemsBinding - The binding that provides the array to render.
   * @param templateBinding - The template binding used to obtain a template to render for each item in the array.
   * @param options - Options used to turn on special repeat features.
   */
  constructor(Ae, xr, ed) {
    super(), this.itemsBinding = Ae, this.templateBinding = xr, this.options = ed, this.createPlaceholder = DOM.createBlockPlaceholder, enableArrayObservation(), this.isItemsBindingVolatile = Observable.isVolatileBinding(Ae), this.isTemplateBindingVolatile = Observable.isVolatileBinding(xr);
  }
  /**
   * Creates a behavior for the provided target node.
   * @param target - The node instance to create the behavior for.
   */
  createBehavior(Ae) {
    return new RepeatBehavior(Ae, this.itemsBinding, this.isItemsBindingVolatile, this.templateBinding, this.isTemplateBindingVolatile, this.options);
  }
}
function repeat(td, Ae, xr = defaultRepeatOptions) {
  const ed = typeof Ae == "function" ? Ae : () => Ae;
  return new RepeatDirective(td, ed, Object.assign(Object.assign({}, defaultRepeatOptions), xr));
}
function elements(td) {
  return td ? function(Ae, xr, ed) {
    return Ae.nodeType === 1 && Ae.matches(td);
  } : function(Ae, xr, ed) {
    return Ae.nodeType === 1;
  };
}
class NodeObservationBehavior {
  /**
   * Creates an instance of NodeObservationBehavior.
   * @param target - The target to assign the nodes property on.
   * @param options - The options to use in configuring node observation.
   */
  constructor(Ae, xr) {
    this.target = Ae, this.options = xr, this.source = null;
  }
  /**
   * Bind this behavior to the source.
   * @param source - The source to bind to.
   * @param context - The execution context that the binding is operating within.
   */
  bind(Ae) {
    const xr = this.options.property;
    this.shouldUpdate = Observable.getAccessors(Ae).some((ed) => ed.name === xr), this.source = Ae, this.updateTarget(this.computeNodes()), this.shouldUpdate && this.observe();
  }
  /**
   * Unbinds this behavior from the source.
   * @param source - The source to unbind from.
   */
  unbind() {
    this.updateTarget(emptyArray), this.source = null, this.shouldUpdate && this.disconnect();
  }
  /** @internal */
  handleEvent() {
    this.updateTarget(this.computeNodes());
  }
  computeNodes() {
    let Ae = this.getNodes();
    return this.options.filter !== void 0 && (Ae = Ae.filter(this.options.filter)), Ae;
  }
  updateTarget(Ae) {
    this.source[this.options.property] = Ae;
  }
}
class SlottedBehavior extends NodeObservationBehavior {
  /**
   * Creates an instance of SlottedBehavior.
   * @param target - The slot element target to observe.
   * @param options - The options to use when observing the slot.
   */
  constructor(Ae, xr) {
    super(Ae, xr);
  }
  /**
   * Begins observation of the nodes.
   */
  observe() {
    this.target.addEventListener("slotchange", this);
  }
  /**
   * Disconnects observation of the nodes.
   */
  disconnect() {
    this.target.removeEventListener("slotchange", this);
  }
  /**
   * Retrieves the nodes that should be assigned to the target.
   */
  getNodes() {
    return this.target.assignedNodes(this.options);
  }
}
function slotted(td) {
  return typeof td == "string" && (td = { property: td }), new AttachedBehaviorHTMLDirective("fast-slotted", SlottedBehavior, td);
}
class ChildrenBehavior extends NodeObservationBehavior {
  /**
   * Creates an instance of ChildrenBehavior.
   * @param target - The element target to observe children on.
   * @param options - The options to use when observing the element children.
   */
  constructor(Ae, xr) {
    super(Ae, xr), this.observer = null, xr.childList = !0;
  }
  /**
   * Begins observation of the nodes.
   */
  observe() {
    this.observer === null && (this.observer = new MutationObserver(this.handleEvent.bind(this))), this.observer.observe(this.target, this.options);
  }
  /**
   * Disconnects observation of the nodes.
   */
  disconnect() {
    this.observer.disconnect();
  }
  /**
   * Retrieves the nodes that should be assigned to the target.
   */
  getNodes() {
    return "subtree" in this.options ? Array.from(this.target.querySelectorAll(this.options.selector)) : Array.from(this.target.childNodes);
  }
}
function children(td) {
  return typeof td == "string" && (td = {
    property: td
  }), new AttachedBehaviorHTMLDirective("fast-children", ChildrenBehavior, td);
}
const fastElement = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  $global,
  AttachedBehaviorHTMLDirective,
  AttributeConfiguration,
  AttributeDefinition,
  BindingBehavior,
  CSSDirective,
  ChildrenBehavior,
  Controller,
  DOM,
  ElementStyles,
  ExecutionContext,
  FAST,
  FASTElement,
  FASTElementDefinition,
  HTMLBindingDirective,
  HTMLDirective,
  HTMLView,
  Observable,
  PropertyChangeNotifier,
  RefBehavior,
  RepeatBehavior,
  RepeatDirective,
  SlottedBehavior,
  SubscriberSet,
  TargetedHTMLDirective,
  ViewTemplate,
  attr,
  booleanConverter,
  children,
  compileTemplate,
  createMetadataLocator,
  css,
  cssPartial,
  customElement,
  defaultExecutionContext,
  elements,
  emptyArray,
  enableArrayObservation,
  html,
  nullableNumberConverter,
  observable,
  ref,
  repeat,
  slotted,
  volatile,
  when
}, Symbol.toStringTag, { value: "Module" }));
class StartEnd {
  handleStartContentChange() {
    this.startContainer.classList.toggle("start", this.start.assignedNodes().length > 0);
  }
  handleEndContentChange() {
    this.endContainer.classList.toggle("end", this.end.assignedNodes().length > 0);
  }
}
const endSlotTemplate = (td, Ae) => html`
    <span
        part="end"
        ${ref("endContainer")}
        class=${(xr) => Ae.end ? "end" : void 0}
    >
        <slot name="end" ${ref("end")} @slotchange="${(xr) => xr.handleEndContentChange()}">
            ${Ae.end || ""}
        </slot>
    </span>
`, startSlotTemplate = (td, Ae) => html`
    <span
        part="start"
        ${ref("startContainer")}
        class="${(xr) => Ae.start ? "start" : void 0}"
    >
        <slot
            name="start"
            ${ref("start")}
            @slotchange="${(xr) => xr.handleStartContentChange()}"
        >
            ${Ae.start || ""}
        </slot>
    </span>
`, endTemplate = html`
    <span part="end" ${ref("endContainer")}>
        <slot
            name="end"
            ${ref("end")}
            @slotchange="${(td) => td.handleEndContentChange()}"
        ></slot>
    </span>
`, startTemplate = html`
    <span part="start" ${ref("startContainer")}>
        <slot
            name="start"
            ${ref("start")}
            @slotchange="${(td) => td.handleStartContentChange()}"
        ></slot>
    </span>
`, accordionItemTemplate = (td, Ae) => html`
    <template class="${(xr) => xr.expanded ? "expanded" : ""}">
        <div
            class="heading"
            part="heading"
            role="heading"
            aria-level="${(xr) => xr.headinglevel}"
        >
            <button
                class="button"
                part="button"
                ${ref("expandbutton")}
                aria-expanded="${(xr) => xr.expanded}"
                aria-controls="${(xr) => xr.id}-panel"
                id="${(xr) => xr.id}"
                @click="${(xr, ed) => xr.clickHandler(ed.event)}"
            >
                <span class="heading-content" part="heading-content">
                    <slot name="heading"></slot>
                </span>
            </button>
            ${startSlotTemplate(td, Ae)}
            ${endSlotTemplate(td, Ae)}
            <span class="icon" part="icon" aria-hidden="true">
                <slot name="expanded-icon" part="expanded-icon">
                    ${Ae.expandedIcon || ""}
                </slot>
                <slot name="collapsed-icon" part="collapsed-icon">
                    ${Ae.collapsedIcon || ""}
                </slot>
            <span>
        </div>
        <div
            class="region"
            part="region"
            id="${(xr) => xr.id}-panel"
            role="region"
            aria-labelledby="${(xr) => xr.id}"
        >
            <slot></slot>
        </div>
    </template>
`;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __decorate(td, Ae, xr, ed) {
  var id = arguments.length, od = id < 3 ? Ae : ed === null ? ed = Object.getOwnPropertyDescriptor(Ae, xr) : ed, ad;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    od = Reflect.decorate(td, Ae, xr, ed);
  else
    for (var rd = td.length - 1; rd >= 0; rd--)
      (ad = td[rd]) && (od = (id < 3 ? ad(od) : id > 3 ? ad(Ae, xr, od) : ad(Ae, xr)) || od);
  return id > 3 && od && Object.defineProperty(Ae, xr, od), od;
}
const metadataByTarget = /* @__PURE__ */ new Map();
"metadata" in Reflect || (Reflect.metadata = function(td, Ae) {
  return function(xr) {
    Reflect.defineMetadata(td, Ae, xr);
  };
}, Reflect.defineMetadata = function(td, Ae, xr) {
  let ed = metadataByTarget.get(xr);
  ed === void 0 && metadataByTarget.set(xr, ed = /* @__PURE__ */ new Map()), ed.set(td, Ae);
}, Reflect.getOwnMetadata = function(td, Ae) {
  const xr = metadataByTarget.get(Ae);
  if (xr !== void 0)
    return xr.get(td);
});
class ResolverBuilder {
  /**
   *
   * @param container - The container to create resolvers for.
   * @param key - The key to register resolvers under.
   */
  constructor(Ae, xr) {
    this.container = Ae, this.key = xr;
  }
  /**
   * Creates a resolver for an existing object instance.
   * @param value - The instance to resolve.
   * @returns The resolver.
   */
  instance(Ae) {
    return this.registerResolver(0, Ae);
  }
  /**
   * Creates a resolver that enforces a singleton lifetime.
   * @param value - The type to create and cache the singleton for.
   * @returns The resolver.
   */
  singleton(Ae) {
    return this.registerResolver(1, Ae);
  }
  /**
   * Creates a resolver that creates a new instance for every dependency request.
   * @param value - The type to create instances of.
   * @returns - The resolver.
   */
  transient(Ae) {
    return this.registerResolver(2, Ae);
  }
  /**
   * Creates a resolver that invokes a callback function for every dependency resolution
   * request, allowing custom logic to return the dependency.
   * @param value - The callback to call during resolution.
   * @returns The resolver.
   */
  callback(Ae) {
    return this.registerResolver(3, Ae);
  }
  /**
   * Creates a resolver that invokes a callback function the first time that a dependency
   * resolution is requested. The returned value is then cached and provided for all
   * subsequent requests.
   * @param value - The callback to call during the first resolution.
   * @returns The resolver.
   */
  cachedCallback(Ae) {
    return this.registerResolver(3, cacheCallbackResult(Ae));
  }
  /**
   * Aliases the current key to a different key.
   * @param destinationKey - The key to point the alias to.
   * @returns The resolver.
   */
  aliasTo(Ae) {
    return this.registerResolver(5, Ae);
  }
  registerResolver(Ae, xr) {
    const { container: ed, key: id } = this;
    return this.container = this.key = void 0, ed.registerResolver(id, new ResolverImpl(id, Ae, xr));
  }
}
function cloneArrayWithPossibleProps(td) {
  const Ae = td.slice(), xr = Object.keys(td), ed = xr.length;
  let id;
  for (let od = 0; od < ed; ++od)
    id = xr[od], isArrayIndex(id) || (Ae[id] = td[id]);
  return Ae;
}
const DefaultResolver = Object.freeze({
  /**
   * Disables auto-registration and throws for all un-registered dependencies.
   * @param key - The key to create the resolver for.
   */
  none(td) {
    throw Error(`${td.toString()} not registered, did you forget to add @singleton()?`);
  },
  /**
   * Provides default singleton resolution behavior during auto-registration.
   * @param key - The key to create the resolver for.
   * @returns The resolver.
   */
  singleton(td) {
    return new ResolverImpl(td, 1, td);
  },
  /**
   * Provides default transient resolution behavior during auto-registration.
   * @param key - The key to create the resolver for.
   * @returns The resolver.
   */
  transient(td) {
    return new ResolverImpl(td, 2, td);
  }
}), ContainerConfiguration = Object.freeze({
  /**
   * The default configuration used when creating a DOM-disconnected container.
   * @remarks
   * The default creates a root container, with no parent container. It does not handle
   * owner requests and it uses singleton resolution behavior for auto-registration.
   */
  default: Object.freeze({
    parentLocator: () => null,
    responsibleForOwnerRequests: !1,
    defaultResolver: DefaultResolver.singleton
  })
}), dependencyLookup = /* @__PURE__ */ new Map();
function getParamTypes(td) {
  return (Ae) => Reflect.getOwnMetadata(td, Ae);
}
let rootDOMContainer = null;
const DI = Object.freeze({
  /**
   * Creates a new dependency injection container.
   * @param config - The configuration for the container.
   * @returns A newly created dependency injection container.
   */
  createContainer(td) {
    return new ContainerImpl(null, Object.assign({}, ContainerConfiguration.default, td));
  },
  /**
   * Finds the dependency injection container responsible for providing dependencies
   * to the specified node.
   * @param node - The node to find the responsible container for.
   * @returns The container responsible for providing dependencies to the node.
   * @remarks
   * This will be the same as the parent container if the specified node
   * does not itself host a container configured with responsibleForOwnerRequests.
   */
  findResponsibleContainer(td) {
    const Ae = td.$$container$$;
    return Ae && Ae.responsibleForOwnerRequests ? Ae : DI.findParentContainer(td);
  },
  /**
   * Find the dependency injection container up the DOM tree from this node.
   * @param node - The node to find the parent container for.
   * @returns The parent container of this node.
   * @remarks
   * This will be the same as the responsible container if the specified node
   * does not itself host a container configured with responsibleForOwnerRequests.
   */
  findParentContainer(td) {
    const Ae = new CustomEvent(DILocateParentEventType, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: { container: void 0 }
    });
    return td.dispatchEvent(Ae), Ae.detail.container || DI.getOrCreateDOMContainer();
  },
  /**
   * Returns a dependency injection container if one is explicitly owned by the specified
   * node. If one is not owned, then a new container is created and assigned to the node.
   * @param node - The node to find or create the container for.
   * @param config - The configuration for the container if one needs to be created.
   * @returns The located or created container.
   * @remarks
   * This API does not search for a responsible or parent container. It looks only for a container
   * directly defined on the specified node and creates one at that location if one does not
   * already exist.
   */
  getOrCreateDOMContainer(td, Ae) {
    return td ? td.$$container$$ || new ContainerImpl(td, Object.assign({}, ContainerConfiguration.default, Ae, {
      parentLocator: DI.findParentContainer
    })) : rootDOMContainer || (rootDOMContainer = new ContainerImpl(null, Object.assign({}, ContainerConfiguration.default, Ae, {
      parentLocator: () => null
    })));
  },
  /**
   * Gets the "design:paramtypes" metadata for the specified type.
   * @param Type - The type to get the metadata for.
   * @returns The metadata array or undefined if no metadata is found.
   */
  getDesignParamtypes: getParamTypes("design:paramtypes"),
  /**
   * Gets the "di:paramtypes" metadata for the specified type.
   * @param Type - The type to get the metadata for.
   * @returns The metadata array or undefined if no metadata is found.
   */
  getAnnotationParamtypes: getParamTypes("di:paramtypes"),
  /**
   *
   * @param Type - Gets the "di:paramtypes" metadata for the specified type. If none is found,
   * an empty metadata array is created and added.
   * @returns The metadata array.
   */
  getOrCreateAnnotationParamTypes(td) {
    let Ae = this.getAnnotationParamtypes(td);
    return Ae === void 0 && Reflect.defineMetadata("di:paramtypes", Ae = [], td), Ae;
  },
  /**
   * Gets the dependency keys representing what is needed to instantiate the specified type.
   * @param Type - The type to get the dependencies for.
   * @returns An array of dependency keys.
   */
  getDependencies(td) {
    let Ae = dependencyLookup.get(td);
    if (Ae === void 0) {
      const xr = td.inject;
      if (xr === void 0) {
        const ed = DI.getDesignParamtypes(td), id = DI.getAnnotationParamtypes(td);
        if (ed === void 0)
          if (id === void 0) {
            const od = Object.getPrototypeOf(td);
            typeof od == "function" && od !== Function.prototype ? Ae = cloneArrayWithPossibleProps(DI.getDependencies(od)) : Ae = [];
          } else
            Ae = cloneArrayWithPossibleProps(id);
        else if (id === void 0)
          Ae = cloneArrayWithPossibleProps(ed);
        else {
          Ae = cloneArrayWithPossibleProps(ed);
          let od = id.length, ad;
          for (let nd = 0; nd < od; ++nd)
            ad = id[nd], ad !== void 0 && (Ae[nd] = ad);
          const rd = Object.keys(id);
          od = rd.length;
          let sd;
          for (let nd = 0; nd < od; ++nd)
            sd = rd[nd], isArrayIndex(sd) || (Ae[sd] = id[sd]);
        }
      } else
        Ae = cloneArrayWithPossibleProps(xr);
      dependencyLookup.set(td, Ae);
    }
    return Ae;
  },
  /**
   * Defines a property on a web component class. The value of this property will
   * be resolved from the dependency injection container responsible for the element
   * instance, based on where it is connected in the DOM.
   * @param target - The target to define the property on.
   * @param propertyName - The name of the property to define.
   * @param key - The dependency injection key.
   * @param respectConnection - Indicates whether or not to update the property value if the
   * hosting component is disconnected and then re-connected at a different location in the DOM.
   * @remarks
   * The respectConnection option is only applicable to elements that descend from FASTElement.
   */
  defineProperty(td, Ae, xr, ed = !1) {
    const id = `$di_${Ae}`;
    Reflect.defineProperty(td, Ae, {
      get: function() {
        let od = this[id];
        if (od === void 0 && (od = (this instanceof HTMLElement ? DI.findResponsibleContainer(this) : DI.getOrCreateDOMContainer()).get(xr), this[id] = od, ed && this instanceof FASTElement)) {
          const rd = this.$fastController, sd = () => {
            const cd = DI.findResponsibleContainer(this).get(xr), ud = this[id];
            cd !== ud && (this[id] = od, rd.notify(Ae));
          };
          rd.subscribe({ handleChange: sd }, "isConnected");
        }
        return od;
      }
    });
  },
  /**
   * Creates a dependency injection key.
   * @param nameConfigOrCallback - A friendly name for the key or a lambda that configures a
   * default resolution for the dependency.
   * @param configuror - If a friendly name was provided for the first parameter, then an optional
   * lambda that configures a default resolution for the dependency can be provided second.
   * @returns The created key.
   * @remarks
   * The created key can be used as a property decorator or constructor parameter decorator,
   * in addition to its standard use in an inject array or through direct container APIs.
   */
  createInterface(td, Ae) {
    const xr = typeof td == "function" ? td : Ae, ed = typeof td == "string" ? td : td && "friendlyName" in td && td.friendlyName || defaultFriendlyName, id = typeof td == "string" ? !1 : td && "respectConnection" in td && td.respectConnection || !1, od = function(ad, rd, sd) {
      if (ad == null || new.target !== void 0)
        throw new Error(`No registration for interface: '${od.friendlyName}'`);
      if (rd)
        DI.defineProperty(ad, rd, od, id);
      else {
        const nd = DI.getOrCreateAnnotationParamTypes(ad);
        nd[sd] = od;
      }
    };
    return od.$isInterface = !0, od.friendlyName = ed == null ? "(anonymous)" : ed, xr != null && (od.register = function(ad, rd) {
      return xr(new ResolverBuilder(ad, rd != null ? rd : od));
    }), od.toString = function() {
      return `InterfaceSymbol<${od.friendlyName}>`;
    }, od;
  },
  /**
   * A decorator that specifies what to inject into its target.
   * @param dependencies - The dependencies to inject.
   * @returns The decorator to be applied to the target class.
   * @remarks
   * The decorator can be used to decorate a class, listing all of the classes dependencies.
   * Or it can be used to decorate a constructor paramter, indicating what to inject for that
   * parameter.
   * Or it can be used for a web component property, indicating what that property should resolve to.
   */
  inject(...td) {
    return function(Ae, xr, ed) {
      if (typeof ed == "number") {
        const id = DI.getOrCreateAnnotationParamTypes(Ae), od = td[0];
        od !== void 0 && (id[ed] = od);
      } else if (xr)
        DI.defineProperty(Ae, xr, td[0]);
      else {
        const id = ed ? DI.getOrCreateAnnotationParamTypes(ed.value) : DI.getOrCreateAnnotationParamTypes(Ae);
        let od;
        for (let ad = 0; ad < td.length; ++ad)
          od = td[ad], od !== void 0 && (id[ad] = od);
      }
    };
  },
  /**
   * Registers the `target` class as a transient dependency; each time the dependency is resolved
   * a new instance will be created.
   *
   * @param target - The class / constructor function to register as transient.
   * @returns The same class, with a static `register` method that takes a container and returns the appropriate resolver.
   *
   * @example
   * On an existing class
   * ```ts
   * class Foo { }
   * DI.transient(Foo);
   * ```
   *
   * @example
   * Inline declaration
   *
   * ```ts
   * const Foo = DI.transient(class { });
   * // Foo is now strongly typed with register
   * Foo.register(container);
   * ```
   *
   * @public
   */
  transient(td) {
    return td.register = function(xr) {
      return Registration.transient(td, td).register(xr);
    }, td.registerInRequestor = !1, td;
  },
  /**
   * Registers the `target` class as a singleton dependency; the class will only be created once. Each
   * consecutive time the dependency is resolved, the same instance will be returned.
   *
   * @param target - The class / constructor function to register as a singleton.
   * @returns The same class, with a static `register` method that takes a container and returns the appropriate resolver.
   * @example
   * On an existing class
   * ```ts
   * class Foo { }
   * DI.singleton(Foo);
   * ```
   *
   * @example
   * Inline declaration
   * ```ts
   * const Foo = DI.singleton(class { });
   * // Foo is now strongly typed with register
   * Foo.register(container);
   * ```
   *
   * @public
   */
  singleton(td, Ae = defaultSingletonOptions) {
    return td.register = function(ed) {
      return Registration.singleton(td, td).register(ed);
    }, td.registerInRequestor = Ae.scoped, td;
  }
}), Container$9 = DI.createInterface("Container"), ServiceLocator = Container$9;
function createResolver(td) {
  return function(Ae) {
    const xr = function(ed, id, od) {
      DI.inject(xr)(ed, id, od);
    };
    return xr.$isResolver = !0, xr.resolve = function(ed, id) {
      return td(Ae, ed, id);
    }, xr;
  };
}
const inject = DI.inject;
function transientDecorator(td) {
  return DI.transient(td);
}
function transient(td) {
  return td == null ? transientDecorator : transientDecorator(td);
}
const defaultSingletonOptions = { scoped: !1 };
function singleton(td) {
  return typeof td == "function" ? DI.singleton(td) : function(Ae) {
    return DI.singleton(Ae, td);
  };
}
function createAllResolver(td) {
  return function(Ae, xr) {
    xr = !!xr;
    const ed = function(id, od, ad) {
      DI.inject(ed)(id, od, ad);
    };
    return ed.$isResolver = !0, ed.resolve = function(id, od) {
      return td(Ae, id, od, xr);
    }, ed;
  };
}
const all = createAllResolver((td, Ae, xr, ed) => xr.getAll(td, ed)), lazy = createResolver((td, Ae, xr) => () => xr.get(td)), optional = createResolver((td, Ae, xr) => {
  if (xr.has(td, !0))
    return xr.get(td);
});
function ignore(td, Ae, xr) {
  DI.inject(ignore)(td, Ae, xr);
}
ignore.$isResolver = !0;
ignore.resolve = () => {
};
const newInstanceForScope = createResolver((td, Ae, xr) => {
  const ed = createNewInstance(td, Ae), id = new ResolverImpl(td, 0, ed);
  return xr.registerResolver(td, id), ed;
}), newInstanceOf = createResolver((td, Ae, xr) => createNewInstance(td, Ae));
function createNewInstance(td, Ae) {
  return Ae.getFactory(td).construct(Ae);
}
class ResolverImpl {
  constructor(Ae, xr, ed) {
    this.key = Ae, this.strategy = xr, this.state = ed, this.resolving = !1;
  }
  get $isResolver() {
    return !0;
  }
  register(Ae) {
    return Ae.registerResolver(this.key, this);
  }
  resolve(Ae, xr) {
    switch (this.strategy) {
      case 0:
        return this.state;
      case 1: {
        if (this.resolving)
          throw new Error(`Cyclic dependency found: ${this.state.name}`);
        return this.resolving = !0, this.state = Ae.getFactory(this.state).construct(xr), this.strategy = 0, this.resolving = !1, this.state;
      }
      case 2: {
        const ed = Ae.getFactory(this.state);
        if (ed === null)
          throw new Error(`Resolver for ${String(this.key)} returned a null factory`);
        return ed.construct(xr);
      }
      case 3:
        return this.state(Ae, xr, this);
      case 4:
        return this.state[0].resolve(Ae, xr);
      case 5:
        return xr.get(this.state);
      default:
        throw new Error(`Invalid resolver strategy specified: ${this.strategy}.`);
    }
  }
  getFactory(Ae) {
    var xr, ed, id;
    switch (this.strategy) {
      case 1:
      case 2:
        return Ae.getFactory(this.state);
      case 5:
        return (id = (ed = (xr = Ae.getResolver(this.state)) === null || xr === void 0 ? void 0 : xr.getFactory) === null || ed === void 0 ? void 0 : ed.call(xr, Ae)) !== null && id !== void 0 ? id : null;
      default:
        return null;
    }
  }
}
function containerGetKey(td) {
  return this.get(td);
}
function transformInstance(td, Ae) {
  return Ae(td);
}
class FactoryImpl {
  constructor(Ae, xr) {
    this.Type = Ae, this.dependencies = xr, this.transformers = null;
  }
  construct(Ae, xr) {
    let ed;
    return xr === void 0 ? ed = new this.Type(...this.dependencies.map(containerGetKey, Ae)) : ed = new this.Type(...this.dependencies.map(containerGetKey, Ae), ...xr), this.transformers == null ? ed : this.transformers.reduce(transformInstance, ed);
  }
  registerTransformer(Ae) {
    (this.transformers || (this.transformers = [])).push(Ae);
  }
}
const containerResolver = {
  $isResolver: !0,
  resolve(td, Ae) {
    return Ae;
  }
};
function isRegistry(td) {
  return typeof td.register == "function";
}
function isSelfRegistry(td) {
  return isRegistry(td) && typeof td.registerInRequestor == "boolean";
}
function isRegisterInRequester(td) {
  return isSelfRegistry(td) && td.registerInRequestor;
}
function isClass(td) {
  return td.prototype !== void 0;
}
const InstrinsicTypeNames = /* @__PURE__ */ new Set([
  "Array",
  "ArrayBuffer",
  "Boolean",
  "DataView",
  "Date",
  "Error",
  "EvalError",
  "Float32Array",
  "Float64Array",
  "Function",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Map",
  "Number",
  "Object",
  "Promise",
  "RangeError",
  "ReferenceError",
  "RegExp",
  "Set",
  "SharedArrayBuffer",
  "String",
  "SyntaxError",
  "TypeError",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "URIError",
  "WeakMap",
  "WeakSet"
]), DILocateParentEventType = "__DI_LOCATE_PARENT__", factories = /* @__PURE__ */ new Map();
class ContainerImpl {
  constructor(Ae, xr) {
    this.owner = Ae, this.config = xr, this._parent = void 0, this.registerDepth = 0, this.context = null, Ae !== null && (Ae.$$container$$ = this), this.resolvers = /* @__PURE__ */ new Map(), this.resolvers.set(Container$9, containerResolver), Ae instanceof Node && Ae.addEventListener(DILocateParentEventType, (ed) => {
      ed.composedPath()[0] !== this.owner && (ed.detail.container = this, ed.stopImmediatePropagation());
    });
  }
  get parent() {
    return this._parent === void 0 && (this._parent = this.config.parentLocator(this.owner)), this._parent;
  }
  get depth() {
    return this.parent === null ? 0 : this.parent.depth + 1;
  }
  get responsibleForOwnerRequests() {
    return this.config.responsibleForOwnerRequests;
  }
  registerWithContext(Ae, ...xr) {
    return this.context = Ae, this.register(...xr), this.context = null, this;
  }
  register(...Ae) {
    if (++this.registerDepth === 100)
      throw new Error("Unable to autoregister dependency");
    let xr, ed, id, od, ad;
    const rd = this.context;
    for (let sd = 0, nd = Ae.length; sd < nd; ++sd)
      if (xr = Ae[sd], !!isObject$3(xr))
        if (isRegistry(xr))
          xr.register(this, rd);
        else if (isClass(xr))
          Registration.singleton(xr, xr).register(this);
        else
          for (ed = Object.keys(xr), od = 0, ad = ed.length; od < ad; ++od)
            id = xr[ed[od]], isObject$3(id) && (isRegistry(id) ? id.register(this, rd) : this.register(id));
    return --this.registerDepth, this;
  }
  registerResolver(Ae, xr) {
    validateKey(Ae);
    const ed = this.resolvers, id = ed.get(Ae);
    return id == null ? ed.set(Ae, xr) : id instanceof ResolverImpl && id.strategy === 4 ? id.state.push(xr) : ed.set(Ae, new ResolverImpl(Ae, 4, [id, xr])), xr;
  }
  registerTransformer(Ae, xr) {
    const ed = this.getResolver(Ae);
    if (ed == null)
      return !1;
    if (ed.getFactory) {
      const id = ed.getFactory(this);
      return id == null ? !1 : (id.registerTransformer(xr), !0);
    }
    return !1;
  }
  getResolver(Ae, xr = !0) {
    if (validateKey(Ae), Ae.resolve !== void 0)
      return Ae;
    let ed = this, id;
    for (; ed != null; )
      if (id = ed.resolvers.get(Ae), id == null) {
        if (ed.parent == null) {
          const od = isRegisterInRequester(Ae) ? this : ed;
          return xr ? this.jitRegister(Ae, od) : null;
        }
        ed = ed.parent;
      } else
        return id;
    return null;
  }
  has(Ae, xr = !1) {
    return this.resolvers.has(Ae) ? !0 : xr && this.parent != null ? this.parent.has(Ae, !0) : !1;
  }
  get(Ae) {
    if (validateKey(Ae), Ae.$isResolver)
      return Ae.resolve(this, this);
    let xr = this, ed;
    for (; xr != null; )
      if (ed = xr.resolvers.get(Ae), ed == null) {
        if (xr.parent == null) {
          const id = isRegisterInRequester(Ae) ? this : xr;
          return ed = this.jitRegister(Ae, id), ed.resolve(xr, this);
        }
        xr = xr.parent;
      } else
        return ed.resolve(xr, this);
    throw new Error(`Unable to resolve key: ${String(Ae)}`);
  }
  getAll(Ae, xr = !1) {
    validateKey(Ae);
    const ed = this;
    let id = ed, od;
    if (xr) {
      let ad = emptyArray;
      for (; id != null; )
        od = id.resolvers.get(Ae), od != null && (ad = ad.concat(
          /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
          buildAllResponse(od, id, ed)
        )), id = id.parent;
      return ad;
    } else
      for (; id != null; )
        if (od = id.resolvers.get(Ae), od == null) {
          if (id = id.parent, id == null)
            return emptyArray;
        } else
          return buildAllResponse(od, id, ed);
    return emptyArray;
  }
  getFactory(Ae) {
    let xr = factories.get(Ae);
    if (xr === void 0) {
      if (isNativeFunction(Ae))
        throw new Error(`${Ae.name} is a native function and therefore cannot be safely constructed by DI. If this is intentional, please use a callback or cachedCallback resolver.`);
      factories.set(Ae, xr = new FactoryImpl(Ae, DI.getDependencies(Ae)));
    }
    return xr;
  }
  registerFactory(Ae, xr) {
    factories.set(Ae, xr);
  }
  createChild(Ae) {
    return new ContainerImpl(null, Object.assign({}, this.config, Ae, { parentLocator: () => this }));
  }
  jitRegister(Ae, xr) {
    if (typeof Ae != "function")
      throw new Error(`Attempted to jitRegister something that is not a constructor: '${Ae}'. Did you forget to register this dependency?`);
    if (InstrinsicTypeNames.has(Ae.name))
      throw new Error(`Attempted to jitRegister an intrinsic type: ${Ae.name}. Did you forget to add @inject(Key)`);
    if (isRegistry(Ae)) {
      const ed = Ae.register(xr);
      if (!(ed instanceof Object) || ed.resolve == null) {
        const id = xr.resolvers.get(Ae);
        if (id != null)
          return id;
        throw new Error("A valid resolver was not returned from the static register method");
      }
      return ed;
    } else {
      if (Ae.$isInterface)
        throw new Error(`Attempted to jitRegister an interface: ${Ae.friendlyName}`);
      {
        const ed = this.config.defaultResolver(Ae, xr);
        return xr.resolvers.set(Ae, ed), ed;
      }
    }
  }
}
const cache = /* @__PURE__ */ new WeakMap();
function cacheCallbackResult(td) {
  return function(Ae, xr, ed) {
    if (cache.has(ed))
      return cache.get(ed);
    const id = td(Ae, xr, ed);
    return cache.set(ed, id), id;
  };
}
const Registration = Object.freeze({
  /**
   * Allows you to pass an instance.
   * Every time you request this {@link Key} you will get this instance back.
   *
   * @example
   * ```
   * Registration.instance(Foo, new Foo()));
   * ```
   *
   * @param key - The key to register the instance under.
   * @param value - The instance to return when the key is requested.
   */
  instance(td, Ae) {
    return new ResolverImpl(td, 0, Ae);
  },
  /**
   * Creates an instance from the class.
   * Every time you request this {@link Key} you will get the same one back.
   *
   * @example
   * ```
   * Registration.singleton(Foo, Foo);
   * ```
   *
   * @param key - The key to register the singleton under.
   * @param value - The class to instantiate as a singleton when first requested.
   */
  singleton(td, Ae) {
    return new ResolverImpl(td, 1, Ae);
  },
  /**
   * Creates an instance from a class.
   * Every time you request this {@link Key} you will get a new instance.
   *
   * @example
   * ```
   * Registration.instance(Foo, Foo);
   * ```
   *
   * @param key - The key to register the instance type under.
   * @param value - The class to instantiate each time the key is requested.
   */
  transient(td, Ae) {
    return new ResolverImpl(td, 2, Ae);
  },
  /**
   * Delegates to a callback function to provide the dependency.
   * Every time you request this {@link Key} the callback will be invoked to provide
   * the dependency.
   *
   * @example
   * ```
   * Registration.callback(Foo, () => new Foo());
   * Registration.callback(Bar, (c: Container) => new Bar(c.get(Foo)));
   * ```
   *
   * @param key - The key to register the callback for.
   * @param callback - The function that is expected to return the dependency.
   */
  callback(td, Ae) {
    return new ResolverImpl(td, 3, Ae);
  },
  /**
   * Delegates to a callback function to provide the dependency and then caches the
   * dependency for future requests.
   *
   * @example
   * ```
   * Registration.cachedCallback(Foo, () => new Foo());
   * Registration.cachedCallback(Bar, (c: Container) => new Bar(c.get(Foo)));
   * ```
   *
   * @param key - The key to register the callback for.
   * @param callback - The function that is expected to return the dependency.
   * @remarks
   * If you pass the same Registration to another container, the same cached value will be used.
   * Should all references to the resolver returned be removed, the cache will expire.
   */
  cachedCallback(td, Ae) {
    return new ResolverImpl(td, 3, cacheCallbackResult(Ae));
  },
  /**
   * Creates an alternate {@link Key} to retrieve an instance by.
   *
   * @example
   * ```
   * Register.singleton(Foo, Foo)
   * Register.aliasTo(Foo, MyFoos);
   *
   * container.getAll(MyFoos) // contains an instance of Foo
   * ```
   *
   * @param originalKey - The original key that has been registered.
   * @param aliasKey - The alias to the original key.
   */
  aliasTo(td, Ae) {
    return new ResolverImpl(Ae, 5, td);
  }
});
function validateKey(td) {
  if (td == null)
    throw new Error("key/value cannot be null or undefined. Are you trying to inject/register something that doesn't exist with DI?");
}
function buildAllResponse(td, Ae, xr) {
  if (td instanceof ResolverImpl && td.strategy === 4) {
    const ed = td.state;
    let id = ed.length;
    const od = new Array(id);
    for (; id--; )
      od[id] = ed[id].resolve(Ae, xr);
    return od;
  }
  return [td.resolve(Ae, xr)];
}
const defaultFriendlyName = "(anonymous)";
function isObject$3(td) {
  return typeof td == "object" && td !== null || typeof td == "function";
}
const isNativeFunction = /* @__PURE__ */ function() {
  const td = /* @__PURE__ */ new WeakMap();
  let Ae = !1, xr = "", ed = 0;
  return function(id) {
    return Ae = td.get(id), Ae === void 0 && (xr = id.toString(), ed = xr.length, Ae = // 29 is the length of 'function () { [native code] }' which is the smallest length of a native function string
    ed >= 29 && // 100 seems to be a safe upper bound of the max length of a native function. In Chrome and FF it's 56, in Edge it's 61.
    ed <= 100 && // This whole heuristic *could* be tricked by a comment. Do we need to care about that?
    xr.charCodeAt(ed - 1) === 125 && // }
    // TODO: the spec is a little vague about the precise constraints, so we do need to test this across various browsers to make sure just one whitespace is a safe assumption.
    xr.charCodeAt(ed - 2) <= 32 && // whitespace
    xr.charCodeAt(ed - 3) === 93 && // ]
    xr.charCodeAt(ed - 4) === 101 && // e
    xr.charCodeAt(ed - 5) === 100 && // d
    xr.charCodeAt(ed - 6) === 111 && // o
    xr.charCodeAt(ed - 7) === 99 && // c
    xr.charCodeAt(ed - 8) === 32 && //
    xr.charCodeAt(ed - 9) === 101 && // e
    xr.charCodeAt(ed - 10) === 118 && // v
    xr.charCodeAt(ed - 11) === 105 && // i
    xr.charCodeAt(ed - 12) === 116 && // t
    xr.charCodeAt(ed - 13) === 97 && // a
    xr.charCodeAt(ed - 14) === 110 && // n
    xr.charCodeAt(ed - 15) === 88, td.set(id, Ae)), Ae;
  };
}(), isNumericLookup = {};
function isArrayIndex(td) {
  switch (typeof td) {
    case "number":
      return td >= 0 && (td | 0) === td;
    case "string": {
      const Ae = isNumericLookup[td];
      if (Ae !== void 0)
        return Ae;
      const xr = td.length;
      if (xr === 0)
        return isNumericLookup[td] = !1;
      let ed = 0;
      for (let id = 0; id < xr; ++id)
        if (ed = td.charCodeAt(id), id === 0 && ed === 48 && xr > 1 || ed < 48 || ed > 57)
          return isNumericLookup[td] = !1;
      return isNumericLookup[td] = !0;
    }
    default:
      return !1;
  }
}
function presentationKeyFromTag(td) {
  return `${td.toLowerCase()}:presentation`;
}
const presentationRegistry = /* @__PURE__ */ new Map(), ComponentPresentation = Object.freeze({
  /**
   * Defines a component presentation for an element.
   * @param tagName - The element name to define the presentation for.
   * @param presentation - The presentation that will be applied to matching elements.
   * @param container - The dependency injection container to register the configuration in.
   * @public
   */
  define(td, Ae, xr) {
    const ed = presentationKeyFromTag(td);
    presentationRegistry.get(ed) === void 0 ? presentationRegistry.set(ed, Ae) : presentationRegistry.set(ed, !1), xr.register(Registration.instance(ed, Ae));
  },
  /**
   * Finds a component presentation for the specified element name,
   * searching the DOM hierarchy starting from the provided element.
   * @param tagName - The name of the element to locate the presentation for.
   * @param element - The element to begin the search from.
   * @returns The component presentation or null if none is found.
   * @public
   */
  forTag(td, Ae) {
    const xr = presentationKeyFromTag(td), ed = presentationRegistry.get(xr);
    return ed === !1 ? DI.findResponsibleContainer(Ae).get(xr) : ed || null;
  }
});
class DefaultComponentPresentation {
  /**
   * Creates an instance of DefaultComponentPresentation.
   * @param template - The template to apply to the element.
   * @param styles - The styles to apply to the element.
   * @public
   */
  constructor(Ae, xr) {
    this.template = Ae || null, this.styles = xr === void 0 ? null : Array.isArray(xr) ? ElementStyles.create(xr) : xr instanceof ElementStyles ? xr : ElementStyles.create([xr]);
  }
  /**
   * Applies the presentation details to the specified element.
   * @param element - The element to apply the presentation details to.
   * @public
   */
  applyTo(Ae) {
    const xr = Ae.$fastController;
    xr.template === null && (xr.template = this.template), xr.styles === null && (xr.styles = this.styles);
  }
}
class FoundationElement extends FASTElement {
  constructor() {
    super(...arguments), this._presentation = void 0;
  }
  /**
   * A property which resolves the ComponentPresentation instance
   * for the current component.
   * @public
   */
  get $presentation() {
    return this._presentation === void 0 && (this._presentation = ComponentPresentation.forTag(this.tagName, this)), this._presentation;
  }
  templateChanged() {
    this.template !== void 0 && (this.$fastController.template = this.template);
  }
  stylesChanged() {
    this.styles !== void 0 && (this.$fastController.styles = this.styles);
  }
  /**
   * The connected callback for this FASTElement.
   * @remarks
   * This method is invoked by the platform whenever this FoundationElement
   * becomes connected to the document.
   * @public
   */
  connectedCallback() {
    this.$presentation !== null && this.$presentation.applyTo(this), super.connectedCallback();
  }
  /**
   * Defines an element registry function with a set of element definition defaults.
   * @param elementDefinition - The definition of the element to create the registry
   * function for.
   * @public
   */
  static compose(Ae) {
    return (xr = {}) => new FoundationElementRegistry(this === FoundationElement ? class extends FoundationElement {
    } : this, Ae, xr);
  }
}
__decorate([
  observable
], FoundationElement.prototype, "template", void 0);
__decorate([
  observable
], FoundationElement.prototype, "styles", void 0);
function resolveOption(td, Ae, xr) {
  return typeof td == "function" ? td(Ae, xr) : td;
}
class FoundationElementRegistry {
  constructor(Ae, xr, ed) {
    this.type = Ae, this.elementDefinition = xr, this.overrideDefinition = ed, this.definition = Object.assign(Object.assign({}, this.elementDefinition), this.overrideDefinition);
  }
  register(Ae, xr) {
    const ed = this.definition, id = this.overrideDefinition, ad = `${ed.prefix || xr.elementPrefix}-${ed.baseName}`;
    xr.tryDefineElement({
      name: ad,
      type: this.type,
      baseClass: this.elementDefinition.baseClass,
      callback: (rd) => {
        const sd = new DefaultComponentPresentation(resolveOption(ed.template, rd, ed), resolveOption(ed.styles, rd, ed));
        rd.definePresentation(sd);
        let nd = resolveOption(ed.shadowOptions, rd, ed);
        rd.shadowRootMode && (nd ? id.shadowOptions || (nd.mode = rd.shadowRootMode) : nd !== null && (nd = { mode: rd.shadowRootMode })), rd.defineElement({
          elementOptions: resolveOption(ed.elementOptions, rd, ed),
          shadowOptions: nd,
          attributes: resolveOption(ed.attributes, rd, ed)
        });
      }
    });
  }
}
function applyMixins(td, ...Ae) {
  const xr = AttributeConfiguration.locate(td);
  Ae.forEach((ed) => {
    Object.getOwnPropertyNames(ed.prototype).forEach((od) => {
      od !== "constructor" && Object.defineProperty(
        td.prototype,
        od,
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
        Object.getOwnPropertyDescriptor(ed.prototype, od)
      );
    }), AttributeConfiguration.locate(ed).forEach((od) => xr.push(od));
  });
}
let AccordionItem$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.headinglevel = 2, this.expanded = !1, this.clickHandler = (Ae) => {
      this.expanded = !this.expanded, this.change();
    }, this.change = () => {
      this.$emit("change");
    };
  }
};
__decorate([
  attr({
    attribute: "heading-level",
    mode: "fromView",
    converter: nullableNumberConverter
  })
], AccordionItem$1.prototype, "headinglevel", void 0);
__decorate([
  attr({ mode: "boolean" })
], AccordionItem$1.prototype, "expanded", void 0);
__decorate([
  attr
], AccordionItem$1.prototype, "id", void 0);
applyMixins(AccordionItem$1, StartEnd);
const accordionTemplate = (td, Ae) => (
  /* TODO: deprecate slot name `item` to only support default slot https://github.com/microsoft/fast/issues/5515 */
  html`
    <template>
        <slot ${slotted({ property: "accordionItems", filter: elements() })}></slot>
        <slot name="item" part="item" ${slotted("accordionItems")}></slot>
    </template>
`
), Orientation$1 = {
  horizontal: "horizontal",
  vertical: "vertical"
};
function findLastIndex(td, Ae) {
  let xr = td.length;
  for (; xr--; )
    if (Ae(td[xr], xr, td))
      return xr;
  return -1;
}
function canUseDOM() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function isHTMLElement$1(...td) {
  return td.every((Ae) => Ae instanceof HTMLElement);
}
function getDisplayedNodes(td, Ae) {
  return !td || !Ae || !isHTMLElement$1(td) ? void 0 : Array.from(td.querySelectorAll(Ae)).filter((ed) => ed.offsetParent !== null);
}
function getNonce() {
  const td = document.querySelector('meta[property="csp-nonce"]');
  return td ? td.getAttribute("content") : null;
}
let _canUseFocusVisible;
function canUseFocusVisible() {
  if (typeof _canUseFocusVisible == "boolean")
    return _canUseFocusVisible;
  if (!canUseDOM())
    return _canUseFocusVisible = !1, _canUseFocusVisible;
  const td = document.createElement("style"), Ae = getNonce();
  Ae !== null && td.setAttribute("nonce", Ae), document.head.appendChild(td);
  try {
    td.sheet.insertRule("foo:focus-visible {color:inherit}", 0), _canUseFocusVisible = !0;
  } catch (xr) {
    _canUseFocusVisible = !1;
  } finally {
    document.head.removeChild(td);
  }
  return _canUseFocusVisible;
}
const eventFocus = "focus", eventFocusIn = "focusin", eventFocusOut = "focusout", eventKeyDown = "keydown", eventResize = "resize", eventScroll = "scroll";
var KeyCodes;
(function(td) {
  td[td.alt = 18] = "alt", td[td.arrowDown = 40] = "arrowDown", td[td.arrowLeft = 37] = "arrowLeft", td[td.arrowRight = 39] = "arrowRight", td[td.arrowUp = 38] = "arrowUp", td[td.back = 8] = "back", td[td.backSlash = 220] = "backSlash", td[td.break = 19] = "break", td[td.capsLock = 20] = "capsLock", td[td.closeBracket = 221] = "closeBracket", td[td.colon = 186] = "colon", td[td.colon2 = 59] = "colon2", td[td.comma = 188] = "comma", td[td.ctrl = 17] = "ctrl", td[td.delete = 46] = "delete", td[td.end = 35] = "end", td[td.enter = 13] = "enter", td[td.equals = 187] = "equals", td[td.equals2 = 61] = "equals2", td[td.equals3 = 107] = "equals3", td[td.escape = 27] = "escape", td[td.forwardSlash = 191] = "forwardSlash", td[td.function1 = 112] = "function1", td[td.function10 = 121] = "function10", td[td.function11 = 122] = "function11", td[td.function12 = 123] = "function12", td[td.function2 = 113] = "function2", td[td.function3 = 114] = "function3", td[td.function4 = 115] = "function4", td[td.function5 = 116] = "function5", td[td.function6 = 117] = "function6", td[td.function7 = 118] = "function7", td[td.function8 = 119] = "function8", td[td.function9 = 120] = "function9", td[td.home = 36] = "home", td[td.insert = 45] = "insert", td[td.menu = 93] = "menu", td[td.minus = 189] = "minus", td[td.minus2 = 109] = "minus2", td[td.numLock = 144] = "numLock", td[td.numPad0 = 96] = "numPad0", td[td.numPad1 = 97] = "numPad1", td[td.numPad2 = 98] = "numPad2", td[td.numPad3 = 99] = "numPad3", td[td.numPad4 = 100] = "numPad4", td[td.numPad5 = 101] = "numPad5", td[td.numPad6 = 102] = "numPad6", td[td.numPad7 = 103] = "numPad7", td[td.numPad8 = 104] = "numPad8", td[td.numPad9 = 105] = "numPad9", td[td.numPadDivide = 111] = "numPadDivide", td[td.numPadDot = 110] = "numPadDot", td[td.numPadMinus = 109] = "numPadMinus", td[td.numPadMultiply = 106] = "numPadMultiply", td[td.numPadPlus = 107] = "numPadPlus", td[td.openBracket = 219] = "openBracket", td[td.pageDown = 34] = "pageDown", td[td.pageUp = 33] = "pageUp", td[td.period = 190] = "period", td[td.print = 44] = "print", td[td.quote = 222] = "quote", td[td.scrollLock = 145] = "scrollLock", td[td.shift = 16] = "shift", td[td.space = 32] = "space", td[td.tab = 9] = "tab", td[td.tilde = 192] = "tilde", td[td.windowsLeft = 91] = "windowsLeft", td[td.windowsOpera = 219] = "windowsOpera", td[td.windowsRight = 92] = "windowsRight";
})(KeyCodes || (KeyCodes = {}));
const keyArrowDown$1 = "ArrowDown", keyArrowLeft$1 = "ArrowLeft", keyArrowRight$1 = "ArrowRight", keyArrowUp$1 = "ArrowUp", keyEnter$1 = "Enter", keyEscape$1 = "Escape", keyHome$1 = "Home", keyEnd$1 = "End", keyFunction2 = "F2", keyPageDown = "PageDown", keyPageUp = "PageUp", keySpace$1 = " ", keyTab$1 = "Tab", keyBackspace = "Backspace", keyDelete = "Delete", ArrowKeys$1 = {
  ArrowDown: keyArrowDown$1,
  ArrowLeft: keyArrowLeft$1,
  ArrowRight: keyArrowRight$1,
  ArrowUp: keyArrowUp$1
};
var Direction$1;
(function(td) {
  td.ltr = "ltr", td.rtl = "rtl";
})(Direction$1 || (Direction$1 = {}));
function wrapInBounds$1(td, Ae, xr) {
  return xr < td ? Ae : xr > Ae ? td : xr;
}
function limit$1(td, Ae, xr) {
  return Math.min(Math.max(xr, td), Ae);
}
function inRange$1(td, Ae, xr = 0) {
  return [Ae, xr] = [Ae, xr].sort((ed, id) => ed - id), Ae <= td && td < xr;
}
let uniqueIdCounter$1 = 0;
function uniqueId$1(td = "") {
  return `${td}${uniqueIdCounter$1++}`;
}
const AccordionExpandMode = {
  /**
   * Designates only a single {@link @microsoft/fast-foundation#(AccordionItem:class) } can be open a time.
   */
  single: "single",
  /**
   * Designates multiple {@link @microsoft/fast-foundation#(AccordionItem:class) | AccordionItems} can be open simultaneously.
   */
  multi: "multi"
};
let Accordion$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.expandmode = AccordionExpandMode.multi, this.activeItemIndex = 0, this.change = () => {
      this.$emit("change", this.activeid);
    }, this.setItems = () => {
      var Ae;
      this.accordionItems.length !== 0 && (this.accordionIds = this.getItemIds(), this.accordionItems.forEach((xr, ed) => {
        xr instanceof AccordionItem$1 && (xr.addEventListener("change", this.activeItemChange), this.isSingleExpandMode() && (this.activeItemIndex !== ed ? xr.expanded = !1 : xr.expanded = !0));
        const id = this.accordionIds[ed];
        xr.setAttribute("id", typeof id != "string" ? `accordion-${ed + 1}` : id), this.activeid = this.accordionIds[this.activeItemIndex], xr.addEventListener("keydown", this.handleItemKeyDown), xr.addEventListener("focus", this.handleItemFocus);
      }), this.isSingleExpandMode() && ((Ae = this.findExpandedItem()) !== null && Ae !== void 0 ? Ae : this.accordionItems[0]).setAttribute("aria-disabled", "true"));
    }, this.removeItemListeners = (Ae) => {
      Ae.forEach((xr, ed) => {
        xr.removeEventListener("change", this.activeItemChange), xr.removeEventListener("keydown", this.handleItemKeyDown), xr.removeEventListener("focus", this.handleItemFocus);
      });
    }, this.activeItemChange = (Ae) => {
      if (Ae.defaultPrevented || Ae.target !== Ae.currentTarget)
        return;
      Ae.preventDefault();
      const xr = Ae.target;
      this.activeid = xr.getAttribute("id"), this.isSingleExpandMode() && (this.resetItems(), xr.expanded = !0, xr.setAttribute("aria-disabled", "true"), this.accordionItems.forEach((ed) => {
        !ed.hasAttribute("disabled") && ed.id !== this.activeid && ed.removeAttribute("aria-disabled");
      })), this.activeItemIndex = Array.from(this.accordionItems).indexOf(xr), this.change();
    }, this.handleItemKeyDown = (Ae) => {
      if (Ae.target === Ae.currentTarget)
        switch (this.accordionIds = this.getItemIds(), Ae.key) {
          case keyArrowUp$1:
            Ae.preventDefault(), this.adjust(-1);
            break;
          case keyArrowDown$1:
            Ae.preventDefault(), this.adjust(1);
            break;
          case keyHome$1:
            this.activeItemIndex = 0, this.focusItem();
            break;
          case keyEnd$1:
            this.activeItemIndex = this.accordionItems.length - 1, this.focusItem();
            break;
        }
    }, this.handleItemFocus = (Ae) => {
      if (Ae.target === Ae.currentTarget) {
        const xr = Ae.target, ed = this.activeItemIndex = Array.from(this.accordionItems).indexOf(xr);
        this.activeItemIndex !== ed && ed !== -1 && (this.activeItemIndex = ed, this.activeid = this.accordionIds[this.activeItemIndex]);
      }
    };
  }
  /**
   * @internal
   */
  accordionItemsChanged(Ae, xr) {
    this.$fastController.isConnected && (this.removeItemListeners(Ae), this.setItems());
  }
  findExpandedItem() {
    for (let Ae = 0; Ae < this.accordionItems.length; Ae++)
      if (this.accordionItems[Ae].getAttribute("expanded") === "true")
        return this.accordionItems[Ae];
    return null;
  }
  resetItems() {
    this.accordionItems.forEach((Ae, xr) => {
      Ae.expanded = !1;
    });
  }
  getItemIds() {
    return this.accordionItems.map((Ae) => Ae.getAttribute("id"));
  }
  isSingleExpandMode() {
    return this.expandmode === AccordionExpandMode.single;
  }
  adjust(Ae) {
    this.activeItemIndex = wrapInBounds$1(0, this.accordionItems.length - 1, this.activeItemIndex + Ae), this.focusItem();
  }
  focusItem() {
    const Ae = this.accordionItems[this.activeItemIndex];
    Ae instanceof AccordionItem$1 && Ae.expandbutton.focus();
  }
};
__decorate([
  attr({ attribute: "expand-mode" })
], Accordion$1.prototype, "expandmode", void 0);
__decorate([
  observable
], Accordion$1.prototype, "accordionItems", void 0);
const anchorTemplate = (td, Ae) => html`
    <a
        class="control"
        part="control"
        download="${(xr) => xr.download}"
        href="${(xr) => xr.href}"
        hreflang="${(xr) => xr.hreflang}"
        ping="${(xr) => xr.ping}"
        referrerpolicy="${(xr) => xr.referrerpolicy}"
        rel="${(xr) => xr.rel}"
        target="${(xr) => xr.target}"
        type="${(xr) => xr.type}"
        aria-atomic="${(xr) => xr.ariaAtomic}"
        aria-busy="${(xr) => xr.ariaBusy}"
        aria-controls="${(xr) => xr.ariaControls}"
        aria-current="${(xr) => xr.ariaCurrent}"
        aria-describedby="${(xr) => xr.ariaDescribedby}"
        aria-details="${(xr) => xr.ariaDetails}"
        aria-disabled="${(xr) => xr.ariaDisabled}"
        aria-errormessage="${(xr) => xr.ariaErrormessage}"
        aria-expanded="${(xr) => xr.ariaExpanded}"
        aria-flowto="${(xr) => xr.ariaFlowto}"
        aria-haspopup="${(xr) => xr.ariaHaspopup}"
        aria-hidden="${(xr) => xr.ariaHidden}"
        aria-invalid="${(xr) => xr.ariaInvalid}"
        aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
        aria-label="${(xr) => xr.ariaLabel}"
        aria-labelledby="${(xr) => xr.ariaLabelledby}"
        aria-live="${(xr) => xr.ariaLive}"
        aria-owns="${(xr) => xr.ariaOwns}"
        aria-relevant="${(xr) => xr.ariaRelevant}"
        aria-roledescription="${(xr) => xr.ariaRoledescription}"
        ${ref("control")}
    >
        ${startSlotTemplate(td, Ae)}
        <span class="content" part="content">
            <slot ${slotted("defaultSlottedContent")}></slot>
        </span>
        ${endSlotTemplate(td, Ae)}
    </a>
`;
class ARIAGlobalStatesAndProperties {
}
__decorate([
  attr({ attribute: "aria-atomic" })
], ARIAGlobalStatesAndProperties.prototype, "ariaAtomic", void 0);
__decorate([
  attr({ attribute: "aria-busy" })
], ARIAGlobalStatesAndProperties.prototype, "ariaBusy", void 0);
__decorate([
  attr({ attribute: "aria-controls" })
], ARIAGlobalStatesAndProperties.prototype, "ariaControls", void 0);
__decorate([
  attr({ attribute: "aria-current" })
], ARIAGlobalStatesAndProperties.prototype, "ariaCurrent", void 0);
__decorate([
  attr({ attribute: "aria-describedby" })
], ARIAGlobalStatesAndProperties.prototype, "ariaDescribedby", void 0);
__decorate([
  attr({ attribute: "aria-details" })
], ARIAGlobalStatesAndProperties.prototype, "ariaDetails", void 0);
__decorate([
  attr({ attribute: "aria-disabled" })
], ARIAGlobalStatesAndProperties.prototype, "ariaDisabled", void 0);
__decorate([
  attr({ attribute: "aria-errormessage" })
], ARIAGlobalStatesAndProperties.prototype, "ariaErrormessage", void 0);
__decorate([
  attr({ attribute: "aria-flowto" })
], ARIAGlobalStatesAndProperties.prototype, "ariaFlowto", void 0);
__decorate([
  attr({ attribute: "aria-haspopup" })
], ARIAGlobalStatesAndProperties.prototype, "ariaHaspopup", void 0);
__decorate([
  attr({ attribute: "aria-hidden" })
], ARIAGlobalStatesAndProperties.prototype, "ariaHidden", void 0);
__decorate([
  attr({ attribute: "aria-invalid" })
], ARIAGlobalStatesAndProperties.prototype, "ariaInvalid", void 0);
__decorate([
  attr({ attribute: "aria-keyshortcuts" })
], ARIAGlobalStatesAndProperties.prototype, "ariaKeyshortcuts", void 0);
__decorate([
  attr({ attribute: "aria-label" })
], ARIAGlobalStatesAndProperties.prototype, "ariaLabel", void 0);
__decorate([
  attr({ attribute: "aria-labelledby" })
], ARIAGlobalStatesAndProperties.prototype, "ariaLabelledby", void 0);
__decorate([
  attr({ attribute: "aria-live" })
], ARIAGlobalStatesAndProperties.prototype, "ariaLive", void 0);
__decorate([
  attr({ attribute: "aria-owns" })
], ARIAGlobalStatesAndProperties.prototype, "ariaOwns", void 0);
__decorate([
  attr({ attribute: "aria-relevant" })
], ARIAGlobalStatesAndProperties.prototype, "ariaRelevant", void 0);
__decorate([
  attr({ attribute: "aria-roledescription" })
], ARIAGlobalStatesAndProperties.prototype, "ariaRoledescription", void 0);
let Anchor$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.handleUnsupportedDelegatesFocus = () => {
      var Ae;
      window.ShadowRoot && !window.ShadowRoot.prototype.hasOwnProperty("delegatesFocus") && (!((Ae = this.$fastController.definition.shadowOptions) === null || Ae === void 0) && Ae.delegatesFocus) && (this.focus = () => {
        var xr;
        (xr = this.control) === null || xr === void 0 || xr.focus();
      });
    };
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.handleUnsupportedDelegatesFocus();
  }
};
__decorate([
  attr
], Anchor$1.prototype, "download", void 0);
__decorate([
  attr
], Anchor$1.prototype, "href", void 0);
__decorate([
  attr
], Anchor$1.prototype, "hreflang", void 0);
__decorate([
  attr
], Anchor$1.prototype, "ping", void 0);
__decorate([
  attr
], Anchor$1.prototype, "referrerpolicy", void 0);
__decorate([
  attr
], Anchor$1.prototype, "rel", void 0);
__decorate([
  attr
], Anchor$1.prototype, "target", void 0);
__decorate([
  attr
], Anchor$1.prototype, "type", void 0);
__decorate([
  observable
], Anchor$1.prototype, "defaultSlottedContent", void 0);
class DelegatesARIALink {
}
__decorate([
  attr({ attribute: "aria-expanded" })
], DelegatesARIALink.prototype, "ariaExpanded", void 0);
applyMixins(DelegatesARIALink, ARIAGlobalStatesAndProperties);
applyMixins(Anchor$1, StartEnd, DelegatesARIALink);
const anchoredRegionTemplate = (td, Ae) => html`
    <template class="${(xr) => xr.initialLayoutComplete ? "loaded" : ""}">
        ${when((xr) => xr.initialLayoutComplete, html`
                <slot></slot>
            `)}
    </template>
`, getDirection$1 = (td) => {
  const Ae = td.closest("[dir]");
  return Ae !== null && Ae.dir === "rtl" ? Direction$1.rtl : Direction$1.ltr;
};
class IntersectionService {
  constructor() {
    this.intersectionDetector = null, this.observedElements = /* @__PURE__ */ new Map(), this.requestPosition = (Ae, xr) => {
      var ed;
      if (this.intersectionDetector !== null) {
        if (this.observedElements.has(Ae)) {
          (ed = this.observedElements.get(Ae)) === null || ed === void 0 || ed.push(xr);
          return;
        }
        this.observedElements.set(Ae, [xr]), this.intersectionDetector.observe(Ae);
      }
    }, this.cancelRequestPosition = (Ae, xr) => {
      const ed = this.observedElements.get(Ae);
      if (ed !== void 0) {
        const id = ed.indexOf(xr);
        id !== -1 && ed.splice(id, 1);
      }
    }, this.initializeIntersectionDetector = () => {
      $global.IntersectionObserver && (this.intersectionDetector = new IntersectionObserver(this.handleIntersection, {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1]
      }));
    }, this.handleIntersection = (Ae) => {
      if (this.intersectionDetector === null)
        return;
      const xr = [], ed = [];
      Ae.forEach((id) => {
        var od;
        (od = this.intersectionDetector) === null || od === void 0 || od.unobserve(id.target);
        const ad = this.observedElements.get(id.target);
        ad !== void 0 && (ad.forEach((rd) => {
          let sd = xr.indexOf(rd);
          sd === -1 && (sd = xr.length, xr.push(rd), ed.push([])), ed[sd].push(id);
        }), this.observedElements.delete(id.target));
      }), xr.forEach((id, od) => {
        id(ed[od]);
      });
    }, this.initializeIntersectionDetector();
  }
}
class AnchoredRegion extends FoundationElement {
  constructor() {
    super(...arguments), this.anchor = "", this.viewport = "", this.horizontalPositioningMode = "uncontrolled", this.horizontalDefaultPosition = "unset", this.horizontalViewportLock = !1, this.horizontalInset = !1, this.horizontalScaling = "content", this.verticalPositioningMode = "uncontrolled", this.verticalDefaultPosition = "unset", this.verticalViewportLock = !1, this.verticalInset = !1, this.verticalScaling = "content", this.fixedPlacement = !1, this.autoUpdateMode = "anchor", this.anchorElement = null, this.viewportElement = null, this.initialLayoutComplete = !1, this.resizeDetector = null, this.baseHorizontalOffset = 0, this.baseVerticalOffset = 0, this.pendingPositioningUpdate = !1, this.pendingReset = !1, this.currentDirection = Direction$1.ltr, this.regionVisible = !1, this.forceUpdate = !1, this.updateThreshold = 0.5, this.update = () => {
      this.pendingPositioningUpdate || this.requestPositionUpdates();
    }, this.startObservers = () => {
      this.stopObservers(), this.anchorElement !== null && (this.requestPositionUpdates(), this.resizeDetector !== null && (this.resizeDetector.observe(this.anchorElement), this.resizeDetector.observe(this)));
    }, this.requestPositionUpdates = () => {
      this.anchorElement === null || this.pendingPositioningUpdate || (AnchoredRegion.intersectionService.requestPosition(this, this.handleIntersection), AnchoredRegion.intersectionService.requestPosition(this.anchorElement, this.handleIntersection), this.viewportElement !== null && AnchoredRegion.intersectionService.requestPosition(this.viewportElement, this.handleIntersection), this.pendingPositioningUpdate = !0);
    }, this.stopObservers = () => {
      this.pendingPositioningUpdate && (this.pendingPositioningUpdate = !1, AnchoredRegion.intersectionService.cancelRequestPosition(this, this.handleIntersection), this.anchorElement !== null && AnchoredRegion.intersectionService.cancelRequestPosition(this.anchorElement, this.handleIntersection), this.viewportElement !== null && AnchoredRegion.intersectionService.cancelRequestPosition(this.viewportElement, this.handleIntersection)), this.resizeDetector !== null && this.resizeDetector.disconnect();
    }, this.getViewport = () => typeof this.viewport != "string" || this.viewport === "" ? document.documentElement : document.getElementById(this.viewport), this.getAnchor = () => document.getElementById(this.anchor), this.handleIntersection = (Ae) => {
      this.pendingPositioningUpdate && (this.pendingPositioningUpdate = !1, this.applyIntersectionEntries(Ae) && this.updateLayout());
    }, this.applyIntersectionEntries = (Ae) => {
      const xr = Ae.find((od) => od.target === this), ed = Ae.find((od) => od.target === this.anchorElement), id = Ae.find((od) => od.target === this.viewportElement);
      return xr === void 0 || id === void 0 || ed === void 0 ? !1 : !this.regionVisible || this.forceUpdate || this.regionRect === void 0 || this.anchorRect === void 0 || this.viewportRect === void 0 || this.isRectDifferent(this.anchorRect, ed.boundingClientRect) || this.isRectDifferent(this.viewportRect, id.boundingClientRect) || this.isRectDifferent(this.regionRect, xr.boundingClientRect) ? (this.regionRect = xr.boundingClientRect, this.anchorRect = ed.boundingClientRect, this.viewportElement === document.documentElement ? this.viewportRect = new DOMRectReadOnly(id.boundingClientRect.x + document.documentElement.scrollLeft, id.boundingClientRect.y + document.documentElement.scrollTop, id.boundingClientRect.width, id.boundingClientRect.height) : this.viewportRect = id.boundingClientRect, this.updateRegionOffset(), this.forceUpdate = !1, !0) : !1;
    }, this.updateRegionOffset = () => {
      this.anchorRect && this.regionRect && (this.baseHorizontalOffset = this.baseHorizontalOffset + (this.anchorRect.left - this.regionRect.left) + (this.translateX - this.baseHorizontalOffset), this.baseVerticalOffset = this.baseVerticalOffset + (this.anchorRect.top - this.regionRect.top) + (this.translateY - this.baseVerticalOffset));
    }, this.isRectDifferent = (Ae, xr) => Math.abs(Ae.top - xr.top) > this.updateThreshold || Math.abs(Ae.right - xr.right) > this.updateThreshold || Math.abs(Ae.bottom - xr.bottom) > this.updateThreshold || Math.abs(Ae.left - xr.left) > this.updateThreshold, this.handleResize = (Ae) => {
      this.update();
    }, this.reset = () => {
      this.pendingReset && (this.pendingReset = !1, this.anchorElement === null && (this.anchorElement = this.getAnchor()), this.viewportElement === null && (this.viewportElement = this.getViewport()), this.currentDirection = getDirection$1(this), this.startObservers());
    }, this.updateLayout = () => {
      let Ae, xr;
      if (this.horizontalPositioningMode !== "uncontrolled") {
        const od = this.getPositioningOptions(this.horizontalInset);
        if (this.horizontalDefaultPosition === "center")
          xr = "center";
        else if (this.horizontalDefaultPosition !== "unset") {
          let ld = this.horizontalDefaultPosition;
          if (ld === "start" || ld === "end") {
            const dd = getDirection$1(this);
            if (dd !== this.currentDirection) {
              this.currentDirection = dd, this.initialize();
              return;
            }
            this.currentDirection === Direction$1.ltr ? ld = ld === "start" ? "left" : "right" : ld = ld === "start" ? "right" : "left";
          }
          switch (ld) {
            case "left":
              xr = this.horizontalInset ? "insetStart" : "start";
              break;
            case "right":
              xr = this.horizontalInset ? "insetEnd" : "end";
              break;
          }
        }
        const ad = this.horizontalThreshold !== void 0 ? this.horizontalThreshold : this.regionRect !== void 0 ? this.regionRect.width : 0, rd = this.anchorRect !== void 0 ? this.anchorRect.left : 0, sd = this.anchorRect !== void 0 ? this.anchorRect.right : 0, nd = this.anchorRect !== void 0 ? this.anchorRect.width : 0, cd = this.viewportRect !== void 0 ? this.viewportRect.left : 0, ud = this.viewportRect !== void 0 ? this.viewportRect.right : 0;
        (xr === void 0 || this.horizontalPositioningMode !== "locktodefault" && this.getAvailableSpace(xr, rd, sd, nd, cd, ud) < ad) && (xr = this.getAvailableSpace(od[0], rd, sd, nd, cd, ud) > this.getAvailableSpace(od[1], rd, sd, nd, cd, ud) ? od[0] : od[1]);
      }
      if (this.verticalPositioningMode !== "uncontrolled") {
        const od = this.getPositioningOptions(this.verticalInset);
        if (this.verticalDefaultPosition === "center")
          Ae = "center";
        else if (this.verticalDefaultPosition !== "unset")
          switch (this.verticalDefaultPosition) {
            case "top":
              Ae = this.verticalInset ? "insetStart" : "start";
              break;
            case "bottom":
              Ae = this.verticalInset ? "insetEnd" : "end";
              break;
          }
        const ad = this.verticalThreshold !== void 0 ? this.verticalThreshold : this.regionRect !== void 0 ? this.regionRect.height : 0, rd = this.anchorRect !== void 0 ? this.anchorRect.top : 0, sd = this.anchorRect !== void 0 ? this.anchorRect.bottom : 0, nd = this.anchorRect !== void 0 ? this.anchorRect.height : 0, cd = this.viewportRect !== void 0 ? this.viewportRect.top : 0, ud = this.viewportRect !== void 0 ? this.viewportRect.bottom : 0;
        (Ae === void 0 || this.verticalPositioningMode !== "locktodefault" && this.getAvailableSpace(Ae, rd, sd, nd, cd, ud) < ad) && (Ae = this.getAvailableSpace(od[0], rd, sd, nd, cd, ud) > this.getAvailableSpace(od[1], rd, sd, nd, cd, ud) ? od[0] : od[1]);
      }
      const ed = this.getNextRegionDimension(xr, Ae), id = this.horizontalPosition !== xr || this.verticalPosition !== Ae;
      if (this.setHorizontalPosition(xr, ed), this.setVerticalPosition(Ae, ed), this.updateRegionStyle(), !this.initialLayoutComplete) {
        this.initialLayoutComplete = !0, this.requestPositionUpdates();
        return;
      }
      this.regionVisible || (this.regionVisible = !0, this.style.removeProperty("pointer-events"), this.style.removeProperty("opacity"), this.classList.toggle("loaded", !0), this.$emit("loaded", this, { bubbles: !1 })), this.updatePositionClasses(), id && this.$emit("positionchange", this, { bubbles: !1 });
    }, this.updateRegionStyle = () => {
      this.style.width = this.regionWidth, this.style.height = this.regionHeight, this.style.transform = `translate(${this.translateX}px, ${this.translateY}px)`;
    }, this.updatePositionClasses = () => {
      this.classList.toggle("top", this.verticalPosition === "start"), this.classList.toggle("bottom", this.verticalPosition === "end"), this.classList.toggle("inset-top", this.verticalPosition === "insetStart"), this.classList.toggle("inset-bottom", this.verticalPosition === "insetEnd"), this.classList.toggle("vertical-center", this.verticalPosition === "center"), this.classList.toggle("left", this.horizontalPosition === "start"), this.classList.toggle("right", this.horizontalPosition === "end"), this.classList.toggle("inset-left", this.horizontalPosition === "insetStart"), this.classList.toggle("inset-right", this.horizontalPosition === "insetEnd"), this.classList.toggle("horizontal-center", this.horizontalPosition === "center");
    }, this.setHorizontalPosition = (Ae, xr) => {
      if (Ae === void 0 || this.regionRect === void 0 || this.anchorRect === void 0 || this.viewportRect === void 0)
        return;
      let ed = 0;
      switch (this.horizontalScaling) {
        case "anchor":
        case "fill":
          ed = this.horizontalViewportLock ? this.viewportRect.width : xr.width, this.regionWidth = `${ed}px`;
          break;
        case "content":
          ed = this.regionRect.width, this.regionWidth = "unset";
          break;
      }
      let id = 0;
      switch (Ae) {
        case "start":
          this.translateX = this.baseHorizontalOffset - ed, this.horizontalViewportLock && this.anchorRect.left > this.viewportRect.right && (this.translateX = this.translateX - (this.anchorRect.left - this.viewportRect.right));
          break;
        case "insetStart":
          this.translateX = this.baseHorizontalOffset - ed + this.anchorRect.width, this.horizontalViewportLock && this.anchorRect.right > this.viewportRect.right && (this.translateX = this.translateX - (this.anchorRect.right - this.viewportRect.right));
          break;
        case "insetEnd":
          this.translateX = this.baseHorizontalOffset, this.horizontalViewportLock && this.anchorRect.left < this.viewportRect.left && (this.translateX = this.translateX - (this.anchorRect.left - this.viewportRect.left));
          break;
        case "end":
          this.translateX = this.baseHorizontalOffset + this.anchorRect.width, this.horizontalViewportLock && this.anchorRect.right < this.viewportRect.left && (this.translateX = this.translateX - (this.anchorRect.right - this.viewportRect.left));
          break;
        case "center":
          if (id = (this.anchorRect.width - ed) / 2, this.translateX = this.baseHorizontalOffset + id, this.horizontalViewportLock) {
            const od = this.anchorRect.left + id, ad = this.anchorRect.right - id;
            od < this.viewportRect.left && !(ad > this.viewportRect.right) ? this.translateX = this.translateX - (od - this.viewportRect.left) : ad > this.viewportRect.right && !(od < this.viewportRect.left) && (this.translateX = this.translateX - (ad - this.viewportRect.right));
          }
          break;
      }
      this.horizontalPosition = Ae;
    }, this.setVerticalPosition = (Ae, xr) => {
      if (Ae === void 0 || this.regionRect === void 0 || this.anchorRect === void 0 || this.viewportRect === void 0)
        return;
      let ed = 0;
      switch (this.verticalScaling) {
        case "anchor":
        case "fill":
          ed = this.verticalViewportLock ? this.viewportRect.height : xr.height, this.regionHeight = `${ed}px`;
          break;
        case "content":
          ed = this.regionRect.height, this.regionHeight = "unset";
          break;
      }
      let id = 0;
      switch (Ae) {
        case "start":
          this.translateY = this.baseVerticalOffset - ed, this.verticalViewportLock && this.anchorRect.top > this.viewportRect.bottom && (this.translateY = this.translateY - (this.anchorRect.top - this.viewportRect.bottom));
          break;
        case "insetStart":
          this.translateY = this.baseVerticalOffset - ed + this.anchorRect.height, this.verticalViewportLock && this.anchorRect.bottom > this.viewportRect.bottom && (this.translateY = this.translateY - (this.anchorRect.bottom - this.viewportRect.bottom));
          break;
        case "insetEnd":
          this.translateY = this.baseVerticalOffset, this.verticalViewportLock && this.anchorRect.top < this.viewportRect.top && (this.translateY = this.translateY - (this.anchorRect.top - this.viewportRect.top));
          break;
        case "end":
          this.translateY = this.baseVerticalOffset + this.anchorRect.height, this.verticalViewportLock && this.anchorRect.bottom < this.viewportRect.top && (this.translateY = this.translateY - (this.anchorRect.bottom - this.viewportRect.top));
          break;
        case "center":
          if (id = (this.anchorRect.height - ed) / 2, this.translateY = this.baseVerticalOffset + id, this.verticalViewportLock) {
            const od = this.anchorRect.top + id, ad = this.anchorRect.bottom - id;
            od < this.viewportRect.top && !(ad > this.viewportRect.bottom) ? this.translateY = this.translateY - (od - this.viewportRect.top) : ad > this.viewportRect.bottom && !(od < this.viewportRect.top) && (this.translateY = this.translateY - (ad - this.viewportRect.bottom));
          }
      }
      this.verticalPosition = Ae;
    }, this.getPositioningOptions = (Ae) => Ae ? ["insetStart", "insetEnd"] : ["start", "end"], this.getAvailableSpace = (Ae, xr, ed, id, od, ad) => {
      const rd = xr - od, sd = ad - (xr + id);
      switch (Ae) {
        case "start":
          return rd;
        case "insetStart":
          return rd + id;
        case "insetEnd":
          return sd + id;
        case "end":
          return sd;
        case "center":
          return Math.min(rd, sd) * 2 + id;
      }
    }, this.getNextRegionDimension = (Ae, xr) => {
      const ed = {
        height: this.regionRect !== void 0 ? this.regionRect.height : 0,
        width: this.regionRect !== void 0 ? this.regionRect.width : 0
      };
      return Ae !== void 0 && this.horizontalScaling === "fill" ? ed.width = this.getAvailableSpace(Ae, this.anchorRect !== void 0 ? this.anchorRect.left : 0, this.anchorRect !== void 0 ? this.anchorRect.right : 0, this.anchorRect !== void 0 ? this.anchorRect.width : 0, this.viewportRect !== void 0 ? this.viewportRect.left : 0, this.viewportRect !== void 0 ? this.viewportRect.right : 0) : this.horizontalScaling === "anchor" && (ed.width = this.anchorRect !== void 0 ? this.anchorRect.width : 0), xr !== void 0 && this.verticalScaling === "fill" ? ed.height = this.getAvailableSpace(xr, this.anchorRect !== void 0 ? this.anchorRect.top : 0, this.anchorRect !== void 0 ? this.anchorRect.bottom : 0, this.anchorRect !== void 0 ? this.anchorRect.height : 0, this.viewportRect !== void 0 ? this.viewportRect.top : 0, this.viewportRect !== void 0 ? this.viewportRect.bottom : 0) : this.verticalScaling === "anchor" && (ed.height = this.anchorRect !== void 0 ? this.anchorRect.height : 0), ed;
    }, this.startAutoUpdateEventListeners = () => {
      window.addEventListener(eventResize, this.update, { passive: !0 }), window.addEventListener(eventScroll, this.update, {
        passive: !0,
        capture: !0
      }), this.resizeDetector !== null && this.viewportElement !== null && this.resizeDetector.observe(this.viewportElement);
    }, this.stopAutoUpdateEventListeners = () => {
      window.removeEventListener(eventResize, this.update), window.removeEventListener(eventScroll, this.update), this.resizeDetector !== null && this.viewportElement !== null && this.resizeDetector.unobserve(this.viewportElement);
    };
  }
  anchorChanged() {
    this.initialLayoutComplete && (this.anchorElement = this.getAnchor());
  }
  viewportChanged() {
    this.initialLayoutComplete && (this.viewportElement = this.getViewport());
  }
  horizontalPositioningModeChanged() {
    this.requestReset();
  }
  horizontalDefaultPositionChanged() {
    this.updateForAttributeChange();
  }
  horizontalViewportLockChanged() {
    this.updateForAttributeChange();
  }
  horizontalInsetChanged() {
    this.updateForAttributeChange();
  }
  horizontalThresholdChanged() {
    this.updateForAttributeChange();
  }
  horizontalScalingChanged() {
    this.updateForAttributeChange();
  }
  verticalPositioningModeChanged() {
    this.requestReset();
  }
  verticalDefaultPositionChanged() {
    this.updateForAttributeChange();
  }
  verticalViewportLockChanged() {
    this.updateForAttributeChange();
  }
  verticalInsetChanged() {
    this.updateForAttributeChange();
  }
  verticalThresholdChanged() {
    this.updateForAttributeChange();
  }
  verticalScalingChanged() {
    this.updateForAttributeChange();
  }
  fixedPlacementChanged() {
    this.$fastController.isConnected && this.initialLayoutComplete && this.initialize();
  }
  autoUpdateModeChanged(Ae, xr) {
    this.$fastController.isConnected && this.initialLayoutComplete && (Ae === "auto" && this.stopAutoUpdateEventListeners(), xr === "auto" && this.startAutoUpdateEventListeners());
  }
  anchorElementChanged() {
    this.requestReset();
  }
  viewportElementChanged() {
    this.$fastController.isConnected && this.initialLayoutComplete && this.initialize();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.autoUpdateMode === "auto" && this.startAutoUpdateEventListeners(), this.initialize();
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.autoUpdateMode === "auto" && this.stopAutoUpdateEventListeners(), this.stopObservers(), this.disconnectResizeDetector();
  }
  /**
   * @internal
   */
  adoptedCallback() {
    this.initialize();
  }
  /**
   * destroys the instance's resize observer
   */
  disconnectResizeDetector() {
    this.resizeDetector !== null && (this.resizeDetector.disconnect(), this.resizeDetector = null);
  }
  /**
   * initializes the instance's resize observer
   */
  initializeResizeDetector() {
    this.disconnectResizeDetector(), this.resizeDetector = new window.ResizeObserver(this.handleResize);
  }
  /**
   * react to attribute changes that don't require a reset
   */
  updateForAttributeChange() {
    this.$fastController.isConnected && this.initialLayoutComplete && (this.forceUpdate = !0, this.update());
  }
  /**
   * fully initializes the component
   */
  initialize() {
    this.initializeResizeDetector(), this.anchorElement === null && (this.anchorElement = this.getAnchor()), this.requestReset();
  }
  /**
   * Request a reset if there are currently no open requests
   */
  requestReset() {
    this.$fastController.isConnected && this.pendingReset === !1 && (this.setInitialState(), DOM.queueUpdate(() => this.reset()), this.pendingReset = !0);
  }
  /**
   * sets the starting configuration for component internal values
   */
  setInitialState() {
    this.initialLayoutComplete = !1, this.regionVisible = !1, this.translateX = 0, this.translateY = 0, this.baseHorizontalOffset = 0, this.baseVerticalOffset = 0, this.viewportRect = void 0, this.regionRect = void 0, this.anchorRect = void 0, this.verticalPosition = void 0, this.horizontalPosition = void 0, this.style.opacity = "0", this.style.pointerEvents = "none", this.forceUpdate = !1, this.style.position = this.fixedPlacement ? "fixed" : "absolute", this.updatePositionClasses(), this.updateRegionStyle();
  }
}
AnchoredRegion.intersectionService = new IntersectionService();
__decorate([
  attr
], AnchoredRegion.prototype, "anchor", void 0);
__decorate([
  attr
], AnchoredRegion.prototype, "viewport", void 0);
__decorate([
  attr({ attribute: "horizontal-positioning-mode" })
], AnchoredRegion.prototype, "horizontalPositioningMode", void 0);
__decorate([
  attr({ attribute: "horizontal-default-position" })
], AnchoredRegion.prototype, "horizontalDefaultPosition", void 0);
__decorate([
  attr({ attribute: "horizontal-viewport-lock", mode: "boolean" })
], AnchoredRegion.prototype, "horizontalViewportLock", void 0);
__decorate([
  attr({ attribute: "horizontal-inset", mode: "boolean" })
], AnchoredRegion.prototype, "horizontalInset", void 0);
__decorate([
  attr({ attribute: "horizontal-threshold" })
], AnchoredRegion.prototype, "horizontalThreshold", void 0);
__decorate([
  attr({ attribute: "horizontal-scaling" })
], AnchoredRegion.prototype, "horizontalScaling", void 0);
__decorate([
  attr({ attribute: "vertical-positioning-mode" })
], AnchoredRegion.prototype, "verticalPositioningMode", void 0);
__decorate([
  attr({ attribute: "vertical-default-position" })
], AnchoredRegion.prototype, "verticalDefaultPosition", void 0);
__decorate([
  attr({ attribute: "vertical-viewport-lock", mode: "boolean" })
], AnchoredRegion.prototype, "verticalViewportLock", void 0);
__decorate([
  attr({ attribute: "vertical-inset", mode: "boolean" })
], AnchoredRegion.prototype, "verticalInset", void 0);
__decorate([
  attr({ attribute: "vertical-threshold" })
], AnchoredRegion.prototype, "verticalThreshold", void 0);
__decorate([
  attr({ attribute: "vertical-scaling" })
], AnchoredRegion.prototype, "verticalScaling", void 0);
__decorate([
  attr({ attribute: "fixed-placement", mode: "boolean" })
], AnchoredRegion.prototype, "fixedPlacement", void 0);
__decorate([
  attr({ attribute: "auto-update-mode" })
], AnchoredRegion.prototype, "autoUpdateMode", void 0);
__decorate([
  observable
], AnchoredRegion.prototype, "anchorElement", void 0);
__decorate([
  observable
], AnchoredRegion.prototype, "viewportElement", void 0);
__decorate([
  observable
], AnchoredRegion.prototype, "initialLayoutComplete", void 0);
const horizontalAnchorOverlay = {
  horizontalDefaultPosition: "center",
  horizontalPositioningMode: "locktodefault",
  horizontalInset: !1,
  horizontalScaling: "anchor"
}, FlyoutPosTop = Object.assign(Object.assign({}, horizontalAnchorOverlay), { verticalDefaultPosition: "top", verticalPositioningMode: "locktodefault", verticalInset: !1, verticalScaling: "content" }), FlyoutPosBottom = Object.assign(Object.assign({}, horizontalAnchorOverlay), { verticalDefaultPosition: "bottom", verticalPositioningMode: "locktodefault", verticalInset: !1, verticalScaling: "content" }), FlyoutPosTallest = Object.assign(Object.assign({}, horizontalAnchorOverlay), { verticalPositioningMode: "dynamic", verticalInset: !1, verticalScaling: "content" }), FlyoutPosTopFill = Object.assign(Object.assign({}, FlyoutPosTop), { verticalScaling: "fill" }), FlyoutPosBottomFill = Object.assign(Object.assign({}, FlyoutPosBottom), { verticalScaling: "fill" }), FlyoutPosTallestFill = Object.assign(Object.assign({}, FlyoutPosTallest), { verticalScaling: "fill" }), avatarTemplate = (td, Ae) => html`
    <div
        class="backplate ${(xr) => xr.shape}"
        part="backplate"
        style="${(xr) => xr.fill ? `background-color: var(--avatar-fill-${xr.fill});` : void 0}"
    >
        <a
            class="link"
            part="link"
            href="${(xr) => xr.link ? xr.link : void 0}"
            style="${(xr) => xr.color ? `color: var(--avatar-color-${xr.color});` : void 0}"
        >
            <slot name="media" part="media">${Ae.media || ""}</slot>
            <slot class="content" part="content"><slot>
        </a>
    </div>
    <slot name="badge" part="badge"></slot>
`;
let Avatar$1 = class extends FoundationElement {
  /**
   * Internal
   */
  connectedCallback() {
    super.connectedCallback(), this.shape || (this.shape = "circle");
  }
};
__decorate([
  attr
], Avatar$1.prototype, "fill", void 0);
__decorate([
  attr
], Avatar$1.prototype, "color", void 0);
__decorate([
  attr
], Avatar$1.prototype, "link", void 0);
__decorate([
  attr
], Avatar$1.prototype, "shape", void 0);
const badgeTemplate = (td, Ae) => html`
    <template class="${(xr) => xr.circular ? "circular" : ""}">
        <div class="control" part="control" style="${(xr) => xr.generateBadgeStyle()}">
            <slot></slot>
        </div>
    </template>
`;
let Badge$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.generateBadgeStyle = () => {
      if (!this.fill && !this.color)
        return;
      const Ae = `background-color: var(--badge-fill-${this.fill});`, xr = `color: var(--badge-color-${this.color});`;
      return this.fill && !this.color ? Ae : this.color && !this.fill ? xr : `${xr} ${Ae}`;
    };
  }
};
__decorate([
  attr({ attribute: "fill" })
], Badge$1.prototype, "fill", void 0);
__decorate([
  attr({ attribute: "color" })
], Badge$1.prototype, "color", void 0);
__decorate([
  attr({ mode: "boolean" })
], Badge$1.prototype, "circular", void 0);
const breadcrumbItemTemplate = (td, Ae) => html`
    <div role="listitem" class="listitem" part="listitem">
        ${when((xr) => xr.href && xr.href.length > 0, html`
                ${anchorTemplate(td, Ae)}
            `)}
        ${when((xr) => !xr.href, html`
                ${startSlotTemplate(td, Ae)}
                <slot></slot>
                ${endSlotTemplate(td, Ae)}
            `)}
        ${when((xr) => xr.separator, html`
                <span class="separator" part="separator" aria-hidden="true">
                    <slot name="separator">${Ae.separator || ""}</slot>
                </span>
            `)}
    </div>
`;
class BreadcrumbItem extends Anchor$1 {
  constructor() {
    super(...arguments), this.separator = !0;
  }
}
__decorate([
  observable
], BreadcrumbItem.prototype, "separator", void 0);
applyMixins(BreadcrumbItem, StartEnd, DelegatesARIALink);
const breadcrumbTemplate = (td, Ae) => html`
    <template role="navigation">
        <div role="list" class="list" part="list">
            <slot
                ${slotted({ property: "slottedBreadcrumbItems", filter: elements() })}
            ></slot>
        </div>
    </template>
`;
class Breadcrumb extends FoundationElement {
  slottedBreadcrumbItemsChanged() {
    if (this.$fastController.isConnected) {
      if (this.slottedBreadcrumbItems === void 0 || this.slottedBreadcrumbItems.length === 0)
        return;
      const Ae = this.slottedBreadcrumbItems[this.slottedBreadcrumbItems.length - 1];
      this.slottedBreadcrumbItems.forEach((xr) => {
        const ed = xr === Ae;
        this.setItemSeparator(xr, ed), this.setAriaCurrent(xr, ed);
      });
    }
  }
  setItemSeparator(Ae, xr) {
    Ae instanceof BreadcrumbItem && (Ae.separator = !xr);
  }
  /**
   * Finds href on childnodes in the light DOM or shadow DOM.
   * We look in the shadow DOM because we insert an anchor when breadcrumb-item has an href.
   */
  findChildWithHref(Ae) {
    var xr, ed;
    return Ae.childElementCount > 0 ? Ae.querySelector("a[href]") : !((xr = Ae.shadowRoot) === null || xr === void 0) && xr.childElementCount ? (ed = Ae.shadowRoot) === null || ed === void 0 ? void 0 : ed.querySelector("a[href]") : null;
  }
  /**
   *  Sets ARIA Current for the current node
   * If child node with an anchor tag and with href is found then set aria-current to correct value for the child node,
   * otherwise apply aria-current to the host element, with an href
   */
  setAriaCurrent(Ae, xr) {
    const ed = this.findChildWithHref(Ae);
    ed === null && Ae.hasAttribute("href") && Ae instanceof BreadcrumbItem ? xr ? Ae.setAttribute("aria-current", "page") : Ae.removeAttribute("aria-current") : ed !== null && (xr ? ed.setAttribute("aria-current", "page") : ed.removeAttribute("aria-current"));
  }
}
__decorate([
  observable
], Breadcrumb.prototype, "slottedBreadcrumbItems", void 0);
const buttonTemplate = (td, Ae) => html`
    <button
        class="control"
        part="control"
        ?autofocus="${(xr) => xr.autofocus}"
        ?disabled="${(xr) => xr.disabled}"
        form="${(xr) => xr.formId}"
        formaction="${(xr) => xr.formaction}"
        formenctype="${(xr) => xr.formenctype}"
        formmethod="${(xr) => xr.formmethod}"
        formnovalidate="${(xr) => xr.formnovalidate}"
        formtarget="${(xr) => xr.formtarget}"
        name="${(xr) => xr.name}"
        type="${(xr) => xr.type}"
        value="${(xr) => xr.value}"
        aria-atomic="${(xr) => xr.ariaAtomic}"
        aria-busy="${(xr) => xr.ariaBusy}"
        aria-controls="${(xr) => xr.ariaControls}"
        aria-current="${(xr) => xr.ariaCurrent}"
        aria-describedby="${(xr) => xr.ariaDescribedby}"
        aria-details="${(xr) => xr.ariaDetails}"
        aria-disabled="${(xr) => xr.ariaDisabled}"
        aria-errormessage="${(xr) => xr.ariaErrormessage}"
        aria-expanded="${(xr) => xr.ariaExpanded}"
        aria-flowto="${(xr) => xr.ariaFlowto}"
        aria-haspopup="${(xr) => xr.ariaHaspopup}"
        aria-hidden="${(xr) => xr.ariaHidden}"
        aria-invalid="${(xr) => xr.ariaInvalid}"
        aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
        aria-label="${(xr) => xr.ariaLabel}"
        aria-labelledby="${(xr) => xr.ariaLabelledby}"
        aria-live="${(xr) => xr.ariaLive}"
        aria-owns="${(xr) => xr.ariaOwns}"
        aria-pressed="${(xr) => xr.ariaPressed}"
        aria-relevant="${(xr) => xr.ariaRelevant}"
        aria-roledescription="${(xr) => xr.ariaRoledescription}"
        ${ref("control")}
    >
        ${startSlotTemplate(td, Ae)}
        <span class="content" part="content">
            <slot ${slotted("defaultSlottedContent")}></slot>
        </span>
        ${endSlotTemplate(td, Ae)}
    </button>
`, proxySlotName = "form-associated-proxy", ElementInternalsKey = "ElementInternals", supportsElementInternals = ElementInternalsKey in window && "setFormValue" in window[ElementInternalsKey].prototype, InternalsMap = /* @__PURE__ */ new WeakMap();
function FormAssociated(td) {
  const Ae = class extends td {
    constructor(...xr) {
      super(...xr), this.dirtyValue = !1, this.disabled = !1, this.proxyEventsToBlock = ["change", "click"], this.proxyInitialized = !1, this.required = !1, this.initialValue = this.initialValue || "", this.elementInternals || (this.formResetCallback = this.formResetCallback.bind(this));
    }
    /**
     * Must evaluate to true to enable elementInternals.
     * Feature detects API support and resolve respectively
     *
     * @internal
     */
    static get formAssociated() {
      return supportsElementInternals;
    }
    /**
     * Returns the validity state of the element
     *
     * @alpha
     */
    get validity() {
      return this.elementInternals ? this.elementInternals.validity : this.proxy.validity;
    }
    /**
     * Retrieve a reference to the associated form.
     * Returns null if not associated to any form.
     *
     * @alpha
     */
    get form() {
      return this.elementInternals ? this.elementInternals.form : this.proxy.form;
    }
    /**
     * Retrieve the localized validation message,
     * or custom validation message if set.
     *
     * @alpha
     */
    get validationMessage() {
      return this.elementInternals ? this.elementInternals.validationMessage : this.proxy.validationMessage;
    }
    /**
     * Whether the element will be validated when the
     * form is submitted
     */
    get willValidate() {
      return this.elementInternals ? this.elementInternals.willValidate : this.proxy.willValidate;
    }
    /**
     * A reference to all associated label elements
     */
    get labels() {
      if (this.elementInternals)
        return Object.freeze(Array.from(this.elementInternals.labels));
      if (this.proxy instanceof HTMLElement && this.proxy.ownerDocument && this.id) {
        const xr = this.proxy.labels, ed = Array.from(this.proxy.getRootNode().querySelectorAll(`[for='${this.id}']`)), id = xr ? ed.concat(Array.from(xr)) : ed;
        return Object.freeze(id);
      } else
        return emptyArray;
    }
    /**
     * Invoked when the `value` property changes
     * @param previous - the previous value
     * @param next - the new value
     *
     * @remarks
     * If elements extending `FormAssociated` implement a `valueChanged` method
     * They must be sure to invoke `super.valueChanged(previous, next)` to ensure
     * proper functioning of `FormAssociated`
     */
    valueChanged(xr, ed) {
      this.dirtyValue = !0, this.proxy instanceof HTMLElement && (this.proxy.value = this.value), this.currentValue = this.value, this.setFormValue(this.value), this.validate();
    }
    currentValueChanged() {
      this.value = this.currentValue;
    }
    /**
     * Invoked when the `initialValue` property changes
     *
     * @param previous - the previous value
     * @param next - the new value
     *
     * @remarks
     * If elements extending `FormAssociated` implement a `initialValueChanged` method
     * They must be sure to invoke `super.initialValueChanged(previous, next)` to ensure
     * proper functioning of `FormAssociated`
     */
    initialValueChanged(xr, ed) {
      this.dirtyValue || (this.value = this.initialValue, this.dirtyValue = !1);
    }
    /**
     * Invoked when the `disabled` property changes
     *
     * @param previous - the previous value
     * @param next - the new value
     *
     * @remarks
     * If elements extending `FormAssociated` implement a `disabledChanged` method
     * They must be sure to invoke `super.disabledChanged(previous, next)` to ensure
     * proper functioning of `FormAssociated`
     */
    disabledChanged(xr, ed) {
      this.proxy instanceof HTMLElement && (this.proxy.disabled = this.disabled), DOM.queueUpdate(() => this.classList.toggle("disabled", this.disabled));
    }
    /**
     * Invoked when the `name` property changes
     *
     * @param previous - the previous value
     * @param next - the new value
     *
     * @remarks
     * If elements extending `FormAssociated` implement a `nameChanged` method
     * They must be sure to invoke `super.nameChanged(previous, next)` to ensure
     * proper functioning of `FormAssociated`
     */
    nameChanged(xr, ed) {
      this.proxy instanceof HTMLElement && (this.proxy.name = this.name);
    }
    /**
     * Invoked when the `required` property changes
     *
     * @param previous - the previous value
     * @param next - the new value
     *
     * @remarks
     * If elements extending `FormAssociated` implement a `requiredChanged` method
     * They must be sure to invoke `super.requiredChanged(previous, next)` to ensure
     * proper functioning of `FormAssociated`
     */
    requiredChanged(xr, ed) {
      this.proxy instanceof HTMLElement && (this.proxy.required = this.required), DOM.queueUpdate(() => this.classList.toggle("required", this.required)), this.validate();
    }
    /**
     * The element internals object. Will only exist
     * in browsers supporting the attachInternals API
     */
    get elementInternals() {
      if (!supportsElementInternals)
        return null;
      let xr = InternalsMap.get(this);
      return xr || (xr = this.attachInternals(), InternalsMap.set(this, xr)), xr;
    }
    /**
     * @internal
     */
    connectedCallback() {
      super.connectedCallback(), this.addEventListener("keypress", this._keypressHandler), this.value || (this.value = this.initialValue, this.dirtyValue = !1), this.elementInternals || (this.attachProxy(), this.form && this.form.addEventListener("reset", this.formResetCallback));
    }
    /**
     * @internal
     */
    disconnectedCallback() {
      super.disconnectedCallback(), this.proxyEventsToBlock.forEach((xr) => this.proxy.removeEventListener(xr, this.stopPropagation)), !this.elementInternals && this.form && this.form.removeEventListener("reset", this.formResetCallback);
    }
    /**
     * Return the current validity of the element.
     */
    checkValidity() {
      return this.elementInternals ? this.elementInternals.checkValidity() : this.proxy.checkValidity();
    }
    /**
     * Return the current validity of the element.
     * If false, fires an invalid event at the element.
     */
    reportValidity() {
      return this.elementInternals ? this.elementInternals.reportValidity() : this.proxy.reportValidity();
    }
    /**
     * Set the validity of the control. In cases when the elementInternals object is not
     * available (and the proxy element is used to report validity), this function will
     * do nothing unless a message is provided, at which point the setCustomValidity method
     * of the proxy element will be invoked with the provided message.
     * @param flags - Validity flags
     * @param message - Optional message to supply
     * @param anchor - Optional element used by UA to display an interactive validation UI
     */
    setValidity(xr, ed, id) {
      this.elementInternals ? this.elementInternals.setValidity(xr, ed, id) : typeof ed == "string" && this.proxy.setCustomValidity(ed);
    }
    /**
     * Invoked when a connected component's form or fieldset has its disabled
     * state changed.
     * @param disabled - the disabled value of the form / fieldset
     */
    formDisabledCallback(xr) {
      this.disabled = xr;
    }
    formResetCallback() {
      this.value = this.initialValue, this.dirtyValue = !1;
    }
    /**
     * Attach the proxy element to the DOM
     */
    attachProxy() {
      var xr;
      this.proxyInitialized || (this.proxyInitialized = !0, this.proxy.style.display = "none", this.proxyEventsToBlock.forEach((ed) => this.proxy.addEventListener(ed, this.stopPropagation)), this.proxy.disabled = this.disabled, this.proxy.required = this.required, typeof this.name == "string" && (this.proxy.name = this.name), typeof this.value == "string" && (this.proxy.value = this.value), this.proxy.setAttribute("slot", proxySlotName), this.proxySlot = document.createElement("slot"), this.proxySlot.setAttribute("name", proxySlotName)), (xr = this.shadowRoot) === null || xr === void 0 || xr.appendChild(this.proxySlot), this.appendChild(this.proxy);
    }
    /**
     * Detach the proxy element from the DOM
     */
    detachProxy() {
      var xr;
      this.removeChild(this.proxy), (xr = this.shadowRoot) === null || xr === void 0 || xr.removeChild(this.proxySlot);
    }
    /** {@inheritDoc (FormAssociated:interface).validate} */
    validate(xr) {
      this.proxy instanceof HTMLElement && this.setValidity(this.proxy.validity, this.proxy.validationMessage, xr);
    }
    /**
     * Associates the provided value (and optional state) with the parent form.
     * @param value - The value to set
     * @param state - The state object provided to during session restores and when autofilling.
     */
    setFormValue(xr, ed) {
      this.elementInternals && this.elementInternals.setFormValue(xr, ed || xr);
    }
    _keypressHandler(xr) {
      switch (xr.key) {
        case keyEnter$1:
          if (this.form instanceof HTMLFormElement) {
            const ed = this.form.querySelector("[type=submit]");
            ed == null || ed.click();
          }
          break;
      }
    }
    /**
     * Used to stop propagation of proxy element events
     * @param e - Event object
     */
    stopPropagation(xr) {
      xr.stopPropagation();
    }
  };
  return attr({ mode: "boolean" })(Ae.prototype, "disabled"), attr({ mode: "fromView", attribute: "value" })(Ae.prototype, "initialValue"), attr({ attribute: "current-value" })(Ae.prototype, "currentValue"), attr(Ae.prototype, "name"), attr({ mode: "boolean" })(Ae.prototype, "required"), observable(Ae.prototype, "value"), Ae;
}
function CheckableFormAssociated(td) {
  class Ae extends FormAssociated(td) {
  }
  class xr extends Ae {
    constructor(...id) {
      super(id), this.dirtyChecked = !1, this.checkedAttribute = !1, this.checked = !1, this.dirtyChecked = !1;
    }
    checkedAttributeChanged() {
      this.defaultChecked = this.checkedAttribute;
    }
    /**
     * @internal
     */
    defaultCheckedChanged() {
      this.dirtyChecked || (this.checked = this.defaultChecked, this.dirtyChecked = !1);
    }
    checkedChanged(id, od) {
      this.dirtyChecked || (this.dirtyChecked = !0), this.currentChecked = this.checked, this.updateForm(), this.proxy instanceof HTMLInputElement && (this.proxy.checked = this.checked), id !== void 0 && this.$emit("change"), this.validate();
    }
    currentCheckedChanged(id, od) {
      this.checked = this.currentChecked;
    }
    updateForm() {
      const id = this.checked ? this.value : null;
      this.setFormValue(id, id);
    }
    connectedCallback() {
      super.connectedCallback(), this.updateForm();
    }
    formResetCallback() {
      super.formResetCallback(), this.checked = !!this.checkedAttribute, this.dirtyChecked = !1;
    }
  }
  return attr({ attribute: "checked", mode: "boolean" })(xr.prototype, "checkedAttribute"), attr({ attribute: "current-checked", converter: booleanConverter })(xr.prototype, "currentChecked"), observable(xr.prototype, "defaultChecked"), observable(xr.prototype, "checked"), xr;
}
class _Button extends FoundationElement {
}
class FormAssociatedButton extends FormAssociated(_Button) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
let Button$1 = class extends FormAssociatedButton {
  constructor() {
    super(...arguments), this.handleClick = (Ae) => {
      var xr;
      this.disabled && ((xr = this.defaultSlottedContent) === null || xr === void 0 ? void 0 : xr.length) <= 1 && Ae.stopPropagation();
    }, this.handleSubmission = () => {
      if (!this.form)
        return;
      const Ae = this.proxy.isConnected;
      Ae || this.attachProxy(), typeof this.form.requestSubmit == "function" ? this.form.requestSubmit(this.proxy) : this.proxy.click(), Ae || this.detachProxy();
    }, this.handleFormReset = () => {
      var Ae;
      (Ae = this.form) === null || Ae === void 0 || Ae.reset();
    }, this.handleUnsupportedDelegatesFocus = () => {
      var Ae;
      window.ShadowRoot && !window.ShadowRoot.prototype.hasOwnProperty("delegatesFocus") && (!((Ae = this.$fastController.definition.shadowOptions) === null || Ae === void 0) && Ae.delegatesFocus) && (this.focus = () => {
        this.control.focus();
      });
    };
  }
  formactionChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.formAction = this.formaction);
  }
  formenctypeChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.formEnctype = this.formenctype);
  }
  formmethodChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.formMethod = this.formmethod);
  }
  formnovalidateChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.formNoValidate = this.formnovalidate);
  }
  formtargetChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.formTarget = this.formtarget);
  }
  typeChanged(Ae, xr) {
    this.proxy instanceof HTMLInputElement && (this.proxy.type = this.type), xr === "submit" && this.addEventListener("click", this.handleSubmission), Ae === "submit" && this.removeEventListener("click", this.handleSubmission), xr === "reset" && this.addEventListener("click", this.handleFormReset), Ae === "reset" && this.removeEventListener("click", this.handleFormReset);
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  /**
   * @internal
   */
  connectedCallback() {
    var Ae;
    super.connectedCallback(), this.proxy.setAttribute("type", this.type), this.handleUnsupportedDelegatesFocus();
    const xr = Array.from((Ae = this.control) === null || Ae === void 0 ? void 0 : Ae.children);
    xr && xr.forEach((ed) => {
      ed.addEventListener("click", this.handleClick);
    });
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    var Ae;
    super.disconnectedCallback();
    const xr = Array.from((Ae = this.control) === null || Ae === void 0 ? void 0 : Ae.children);
    xr && xr.forEach((ed) => {
      ed.removeEventListener("click", this.handleClick);
    });
  }
};
__decorate([
  attr({ mode: "boolean" })
], Button$1.prototype, "autofocus", void 0);
__decorate([
  attr({ attribute: "form" })
], Button$1.prototype, "formId", void 0);
__decorate([
  attr
], Button$1.prototype, "formaction", void 0);
__decorate([
  attr
], Button$1.prototype, "formenctype", void 0);
__decorate([
  attr
], Button$1.prototype, "formmethod", void 0);
__decorate([
  attr({ mode: "boolean" })
], Button$1.prototype, "formnovalidate", void 0);
__decorate([
  attr
], Button$1.prototype, "formtarget", void 0);
__decorate([
  attr
], Button$1.prototype, "type", void 0);
__decorate([
  observable
], Button$1.prototype, "defaultSlottedContent", void 0);
class DelegatesARIAButton {
}
__decorate([
  attr({ attribute: "aria-expanded" })
], DelegatesARIAButton.prototype, "ariaExpanded", void 0);
__decorate([
  attr({ attribute: "aria-pressed" })
], DelegatesARIAButton.prototype, "ariaPressed", void 0);
applyMixins(DelegatesARIAButton, ARIAGlobalStatesAndProperties);
applyMixins(Button$1, StartEnd, DelegatesARIAButton);
class DateFormatter {
  constructor(Ae) {
    if (this.dayFormat = "numeric", this.weekdayFormat = "long", this.monthFormat = "long", this.yearFormat = "numeric", this.date = /* @__PURE__ */ new Date(), Ae)
      for (const xr in Ae) {
        const ed = Ae[xr];
        xr === "date" ? this.date = this.getDateObject(ed) : this[xr] = ed;
      }
  }
  /**
   * Helper function to make sure that the DateFormatter is working with an instance of Date
   * @param date - The date as an object, string or Date insance
   * @returns - A Date instance
   * @public
   */
  getDateObject(Ae) {
    if (typeof Ae == "string") {
      const xr = Ae.split(/[/-]/);
      return xr.length < 3 ? /* @__PURE__ */ new Date() : new Date(parseInt(xr[2], 10), parseInt(xr[0], 10) - 1, parseInt(xr[1], 10));
    } else if ("day" in Ae && "month" in Ae && "year" in Ae) {
      const { day: xr, month: ed, year: id } = Ae;
      return new Date(id, ed - 1, xr);
    }
    return Ae;
  }
  /**
   *
   * @param date - a valide date as either a Date, string, objec or a DateFormatter
   * @param format - The formatting for the string
   * @param locale - locale data used for formatting
   * @returns A localized string of the date provided
   * @public
   */
  getDate(Ae = this.date, xr = {
    weekday: this.weekdayFormat,
    month: this.monthFormat,
    day: this.dayFormat,
    year: this.yearFormat
  }, ed = this.locale) {
    const id = this.getDateObject(Ae);
    if (!id.getTime())
      return "";
    const od = Object.assign({ timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }, xr);
    return new Intl.DateTimeFormat(ed, od).format(id);
  }
  /**
   *
   * @param day - Day to localize
   * @param format - The formatting for the day
   * @param locale - The locale data used for formatting
   * @returns - A localized number for the day
   * @public
   */
  getDay(Ae = this.date.getDate(), xr = this.dayFormat, ed = this.locale) {
    return this.getDate({ month: 1, day: Ae, year: 2020 }, { day: xr }, ed);
  }
  /**
   *
   * @param month - The month to localize
   * @param format - The formatting for the month
   * @param locale - The locale data used for formatting
   * @returns - A localized name of the month
   * @public
   */
  getMonth(Ae = this.date.getMonth() + 1, xr = this.monthFormat, ed = this.locale) {
    return this.getDate({ month: Ae, day: 2, year: 2020 }, { month: xr }, ed);
  }
  /**
   *
   * @param year - The year to localize
   * @param format - The formatting for the year
   * @param locale - The locale data used for formatting
   * @returns - A localized string for the year
   * @public
   */
  getYear(Ae = this.date.getFullYear(), xr = this.yearFormat, ed = this.locale) {
    return this.getDate({ month: 2, day: 2, year: Ae }, { year: xr }, ed);
  }
  /**
   *
   * @param weekday - The number of the weekday, defaults to Sunday
   * @param format - The formatting for the weekday label
   * @param locale - The locale data used for formatting
   * @returns - A formatted weekday label
   * @public
   */
  getWeekday(Ae = 0, xr = this.weekdayFormat, ed = this.locale) {
    const id = `1-${Ae + 1}-2017`;
    return this.getDate(id, { weekday: xr }, ed);
  }
  /**
   *
   * @param format - The formatting for the weekdays
   * @param locale - The locale data used for formatting
   * @returns - An array of the weekday labels
   * @public
   */
  getWeekdays(Ae = this.weekdayFormat, xr = this.locale) {
    return Array(7).fill(null).map((ed, id) => this.getWeekday(id, Ae, xr));
  }
}
let Calendar$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.dateFormatter = new DateFormatter(), this.readonly = !1, this.locale = "en-US", this.month = (/* @__PURE__ */ new Date()).getMonth() + 1, this.year = (/* @__PURE__ */ new Date()).getFullYear(), this.dayFormat = "numeric", this.weekdayFormat = "short", this.monthFormat = "long", this.yearFormat = "numeric", this.minWeeks = 0, this.disabledDates = "", this.selectedDates = "", this.oneDayInMs = 864e5;
  }
  localeChanged() {
    this.dateFormatter.locale = this.locale;
  }
  dayFormatChanged() {
    this.dateFormatter.dayFormat = this.dayFormat;
  }
  weekdayFormatChanged() {
    this.dateFormatter.weekdayFormat = this.weekdayFormat;
  }
  monthFormatChanged() {
    this.dateFormatter.monthFormat = this.monthFormat;
  }
  yearFormatChanged() {
    this.dateFormatter.yearFormat = this.yearFormat;
  }
  /**
   * Gets data needed to render about a calendar month as well as the previous and next months
   * @param year - year of the calendar
   * @param month - month of the calendar
   * @returns - an object with data about the current and 2 surrounding months
   * @public
   */
  getMonthInfo(Ae = this.month, xr = this.year) {
    const ed = (sd) => new Date(sd.getFullYear(), sd.getMonth(), 1).getDay(), id = (sd) => {
      const nd = new Date(sd.getFullYear(), sd.getMonth() + 1, 1);
      return new Date(nd.getTime() - this.oneDayInMs).getDate();
    }, od = new Date(xr, Ae - 1), ad = new Date(xr, Ae), rd = new Date(xr, Ae - 2);
    return {
      length: id(od),
      month: Ae,
      start: ed(od),
      year: xr,
      previous: {
        length: id(rd),
        month: rd.getMonth() + 1,
        start: ed(rd),
        year: rd.getFullYear()
      },
      next: {
        length: id(ad),
        month: ad.getMonth() + 1,
        start: ed(ad),
        year: ad.getFullYear()
      }
    };
  }
  /**
   * A list of calendar days
   * @param info - an object containing the information needed to render a calendar month
   * @param minWeeks - minimum number of weeks to show
   * @returns a list of days in a calendar month
   * @public
   */
  getDays(Ae = this.getMonthInfo(), xr = this.minWeeks) {
    xr = xr > 10 ? 10 : xr;
    const { start: ed, length: id, previous: od, next: ad } = Ae, rd = [];
    let sd = 1 - ed;
    for (; sd < id + 1 || rd.length < xr || rd[rd.length - 1].length % 7 !== 0; ) {
      const { month: nd, year: cd } = sd < 1 ? od : sd > id ? ad : Ae, ud = sd < 1 ? od.length + sd : sd > id ? sd - id : sd, ld = `${nd}-${ud}-${cd}`, dd = this.dateInString(ld, this.disabledDates), pd = this.dateInString(ld, this.selectedDates), md = {
        day: ud,
        month: nd,
        year: cd,
        disabled: dd,
        selected: pd
      }, fd = rd[rd.length - 1];
      rd.length === 0 || fd.length % 7 === 0 ? rd.push([md]) : fd.push(md), sd++;
    }
    return rd;
  }
  /**
   * A helper function that checks if a date exists in a list of dates
   * @param date - A date objec that includes the day, month and year
   * @param datesString - a comma separated list of dates
   * @returns - Returns true if it found the date in the list of dates
   * @public
   */
  dateInString(Ae, xr) {
    const ed = xr.split(",").map((id) => id.trim());
    return Ae = typeof Ae == "string" ? Ae : `${Ae.getMonth() + 1}-${Ae.getDate()}-${Ae.getFullYear()}`, ed.some((id) => id === Ae);
  }
  /**
   * Creates a class string for the day container
   * @param date - date of the calendar cell
   * @returns - string of class names
   * @public
   */
  getDayClassNames(Ae, xr) {
    const { day: ed, month: id, year: od, disabled: ad, selected: rd } = Ae, sd = xr === `${id}-${ed}-${od}`, nd = this.month !== id;
    return [
      "day",
      sd && "today",
      nd && "inactive",
      ad && "disabled",
      rd && "selected"
    ].filter(Boolean).join(" ");
  }
  /**
   * Returns a list of weekday labels
   * @returns An array of weekday text and full text if abbreviated
   * @public
   */
  getWeekdayText() {
    const Ae = this.dateFormatter.getWeekdays().map((xr) => ({ text: xr }));
    if (this.weekdayFormat !== "long") {
      const xr = this.dateFormatter.getWeekdays("long");
      Ae.forEach((ed, id) => {
        ed.abbr = xr[id];
      });
    }
    return Ae;
  }
  /**
   * Emits the "date-select" event with the day, month and year.
   * @param date - Date cell
   * @public
   */
  handleDateSelect(Ae, xr) {
    Ae.preventDefault, this.$emit("dateselected", xr);
  }
  /**
   * Handles keyboard events on a cell
   * @param event - Keyboard event
   * @param date - Date of the cell selected
   */
  handleKeydown(Ae, xr) {
    return Ae.key === keyEnter$1 && this.handleDateSelect(Ae, xr), !0;
  }
};
__decorate([
  attr({ mode: "boolean" })
], Calendar$1.prototype, "readonly", void 0);
__decorate([
  attr
], Calendar$1.prototype, "locale", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Calendar$1.prototype, "month", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Calendar$1.prototype, "year", void 0);
__decorate([
  attr({ attribute: "day-format", mode: "fromView" })
], Calendar$1.prototype, "dayFormat", void 0);
__decorate([
  attr({ attribute: "weekday-format", mode: "fromView" })
], Calendar$1.prototype, "weekdayFormat", void 0);
__decorate([
  attr({ attribute: "month-format", mode: "fromView" })
], Calendar$1.prototype, "monthFormat", void 0);
__decorate([
  attr({ attribute: "year-format", mode: "fromView" })
], Calendar$1.prototype, "yearFormat", void 0);
__decorate([
  attr({ attribute: "min-weeks", converter: nullableNumberConverter })
], Calendar$1.prototype, "minWeeks", void 0);
__decorate([
  attr({ attribute: "disabled-dates" })
], Calendar$1.prototype, "disabledDates", void 0);
__decorate([
  attr({ attribute: "selected-dates" })
], Calendar$1.prototype, "selectedDates", void 0);
const GenerateHeaderOptions = {
  none: "none",
  default: "default",
  sticky: "sticky"
}, DataGridCellTypes = {
  default: "default",
  columnHeader: "columnheader",
  rowHeader: "rowheader"
}, DataGridRowTypes = {
  default: "default",
  header: "header",
  stickyHeader: "sticky-header"
};
let DataGridRow$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.rowType = DataGridRowTypes.default, this.rowData = null, this.columnDefinitions = null, this.isActiveRow = !1, this.cellsRepeatBehavior = null, this.cellsPlaceholder = null, this.focusColumnIndex = 0, this.refocusOnLoad = !1, this.updateRowStyle = () => {
      this.style.gridTemplateColumns = this.gridTemplateColumns;
    };
  }
  gridTemplateColumnsChanged() {
    this.$fastController.isConnected && this.updateRowStyle();
  }
  rowTypeChanged() {
    this.$fastController.isConnected && this.updateItemTemplate();
  }
  rowDataChanged() {
    if (this.rowData !== null && this.isActiveRow) {
      this.refocusOnLoad = !0;
      return;
    }
  }
  cellItemTemplateChanged() {
    this.updateItemTemplate();
  }
  headerCellItemTemplateChanged() {
    this.updateItemTemplate();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.cellsRepeatBehavior === null && (this.cellsPlaceholder = document.createComment(""), this.appendChild(this.cellsPlaceholder), this.updateItemTemplate(), this.cellsRepeatBehavior = new RepeatDirective((Ae) => Ae.columnDefinitions, (Ae) => Ae.activeCellItemTemplate, { positioning: !0 }).createBehavior(this.cellsPlaceholder), this.$fastController.addBehaviors([this.cellsRepeatBehavior])), this.addEventListener("cell-focused", this.handleCellFocus), this.addEventListener(eventFocusOut, this.handleFocusout), this.addEventListener(eventKeyDown, this.handleKeydown), this.updateRowStyle(), this.refocusOnLoad && (this.refocusOnLoad = !1, this.cellElements.length > this.focusColumnIndex && this.cellElements[this.focusColumnIndex].focus());
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("cell-focused", this.handleCellFocus), this.removeEventListener(eventFocusOut, this.handleFocusout), this.removeEventListener(eventKeyDown, this.handleKeydown);
  }
  handleFocusout(Ae) {
    this.contains(Ae.target) || (this.isActiveRow = !1, this.focusColumnIndex = 0);
  }
  handleCellFocus(Ae) {
    this.isActiveRow = !0, this.focusColumnIndex = this.cellElements.indexOf(Ae.target), this.$emit("row-focused", this);
  }
  handleKeydown(Ae) {
    if (Ae.defaultPrevented)
      return;
    let xr = 0;
    switch (Ae.key) {
      case keyArrowLeft$1:
        xr = Math.max(0, this.focusColumnIndex - 1), this.cellElements[xr].focus(), Ae.preventDefault();
        break;
      case keyArrowRight$1:
        xr = Math.min(this.cellElements.length - 1, this.focusColumnIndex + 1), this.cellElements[xr].focus(), Ae.preventDefault();
        break;
      case keyHome$1:
        Ae.ctrlKey || (this.cellElements[0].focus(), Ae.preventDefault());
        break;
      case keyEnd$1:
        Ae.ctrlKey || (this.cellElements[this.cellElements.length - 1].focus(), Ae.preventDefault());
        break;
    }
  }
  updateItemTemplate() {
    this.activeCellItemTemplate = this.rowType === DataGridRowTypes.default && this.cellItemTemplate !== void 0 ? this.cellItemTemplate : this.rowType === DataGridRowTypes.default && this.cellItemTemplate === void 0 ? this.defaultCellItemTemplate : this.headerCellItemTemplate !== void 0 ? this.headerCellItemTemplate : this.defaultHeaderCellItemTemplate;
  }
};
__decorate([
  attr({ attribute: "grid-template-columns" })
], DataGridRow$1.prototype, "gridTemplateColumns", void 0);
__decorate([
  attr({ attribute: "row-type" })
], DataGridRow$1.prototype, "rowType", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "rowData", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "columnDefinitions", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "cellItemTemplate", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "headerCellItemTemplate", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "rowIndex", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "isActiveRow", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "activeCellItemTemplate", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "defaultCellItemTemplate", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "defaultHeaderCellItemTemplate", void 0);
__decorate([
  observable
], DataGridRow$1.prototype, "cellElements", void 0);
function createRowItemTemplate(td) {
  const Ae = td.tagFor(DataGridRow$1);
  return html`
    <${Ae}
        :rowData="${(xr) => xr}"
        :cellItemTemplate="${(xr, ed) => ed.parent.cellItemTemplate}"
        :headerCellItemTemplate="${(xr, ed) => ed.parent.headerCellItemTemplate}"
    ></${Ae}>
`;
}
const dataGridTemplate = (td, Ae) => {
  const xr = createRowItemTemplate(td), ed = td.tagFor(DataGridRow$1);
  return html`
        <template
            role="grid"
            tabindex="0"
            :rowElementTag="${() => ed}"
            :defaultRowItemTemplate="${xr}"
            ${children({
    property: "rowElements",
    filter: elements("[role=row]")
  })}
        >
            <slot></slot>
        </template>
    `;
};
let DataGrid$1 = class o0 extends FoundationElement {
  constructor() {
    super(), this.noTabbing = !1, this.generateHeader = GenerateHeaderOptions.default, this.rowsData = [], this.columnDefinitions = null, this.focusRowIndex = 0, this.focusColumnIndex = 0, this.rowsPlaceholder = null, this.generatedHeader = null, this.isUpdatingFocus = !1, this.pendingFocusUpdate = !1, this.rowindexUpdateQueued = !1, this.columnDefinitionsStale = !0, this.generatedGridTemplateColumns = "", this.focusOnCell = (Ae, xr, ed) => {
      if (this.rowElements.length === 0) {
        this.focusRowIndex = 0, this.focusColumnIndex = 0;
        return;
      }
      const id = Math.max(0, Math.min(this.rowElements.length - 1, Ae)), ad = this.rowElements[id].querySelectorAll('[role="cell"], [role="gridcell"], [role="columnheader"], [role="rowheader"]'), rd = Math.max(0, Math.min(ad.length - 1, xr)), sd = ad[rd];
      ed && this.scrollHeight !== this.clientHeight && (id < this.focusRowIndex && this.scrollTop > 0 || id > this.focusRowIndex && this.scrollTop < this.scrollHeight - this.clientHeight) && sd.scrollIntoView({ block: "center", inline: "center" }), sd.focus();
    }, this.onChildListChange = (Ae, xr) => {
      Ae && Ae.length && (Ae.forEach((ed) => {
        ed.addedNodes.forEach((id) => {
          id.nodeType === 1 && id.getAttribute("role") === "row" && (id.columnDefinitions = this.columnDefinitions);
        });
      }), this.queueRowIndexUpdate());
    }, this.queueRowIndexUpdate = () => {
      this.rowindexUpdateQueued || (this.rowindexUpdateQueued = !0, DOM.queueUpdate(this.updateRowIndexes));
    }, this.updateRowIndexes = () => {
      let Ae = this.gridTemplateColumns;
      if (Ae === void 0) {
        if (this.generatedGridTemplateColumns === "" && this.rowElements.length > 0) {
          const xr = this.rowElements[0];
          this.generatedGridTemplateColumns = new Array(xr.cellElements.length).fill("1fr").join(" ");
        }
        Ae = this.generatedGridTemplateColumns;
      }
      this.rowElements.forEach((xr, ed) => {
        const id = xr;
        id.rowIndex = ed, id.gridTemplateColumns = Ae, this.columnDefinitionsStale && (id.columnDefinitions = this.columnDefinitions);
      }), this.rowindexUpdateQueued = !1, this.columnDefinitionsStale = !1;
    };
  }
  /**
   *  generates a gridTemplateColumns based on columndata array
   */
  static generateTemplateColumns(Ae) {
    let xr = "";
    return Ae.forEach((ed) => {
      xr = `${xr}${xr === "" ? "" : " "}1fr`;
    }), xr;
  }
  noTabbingChanged() {
    this.$fastController.isConnected && (this.noTabbing ? this.setAttribute("tabIndex", "-1") : this.setAttribute("tabIndex", this.contains(document.activeElement) || this === document.activeElement ? "-1" : "0"));
  }
  generateHeaderChanged() {
    this.$fastController.isConnected && this.toggleGeneratedHeader();
  }
  gridTemplateColumnsChanged() {
    this.$fastController.isConnected && this.updateRowIndexes();
  }
  rowsDataChanged() {
    this.columnDefinitions === null && this.rowsData.length > 0 && (this.columnDefinitions = o0.generateColumns(this.rowsData[0])), this.$fastController.isConnected && this.toggleGeneratedHeader();
  }
  columnDefinitionsChanged() {
    if (this.columnDefinitions === null) {
      this.generatedGridTemplateColumns = "";
      return;
    }
    this.generatedGridTemplateColumns = o0.generateTemplateColumns(this.columnDefinitions), this.$fastController.isConnected && (this.columnDefinitionsStale = !0, this.queueRowIndexUpdate());
  }
  headerCellItemTemplateChanged() {
    this.$fastController.isConnected && this.generatedHeader !== null && (this.generatedHeader.headerCellItemTemplate = this.headerCellItemTemplate);
  }
  focusRowIndexChanged() {
    this.$fastController.isConnected && this.queueFocusUpdate();
  }
  focusColumnIndexChanged() {
    this.$fastController.isConnected && this.queueFocusUpdate();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.rowItemTemplate === void 0 && (this.rowItemTemplate = this.defaultRowItemTemplate), this.rowsPlaceholder = document.createComment(""), this.appendChild(this.rowsPlaceholder), this.toggleGeneratedHeader(), this.rowsRepeatBehavior = new RepeatDirective((Ae) => Ae.rowsData, (Ae) => Ae.rowItemTemplate, { positioning: !0 }).createBehavior(this.rowsPlaceholder), this.$fastController.addBehaviors([this.rowsRepeatBehavior]), this.addEventListener("row-focused", this.handleRowFocus), this.addEventListener(eventFocus, this.handleFocus), this.addEventListener(eventKeyDown, this.handleKeydown), this.addEventListener(eventFocusOut, this.handleFocusOut), this.observer = new MutationObserver(this.onChildListChange), this.observer.observe(this, { childList: !0 }), this.noTabbing && this.setAttribute("tabindex", "-1"), DOM.queueUpdate(this.queueRowIndexUpdate);
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("row-focused", this.handleRowFocus), this.removeEventListener(eventFocus, this.handleFocus), this.removeEventListener(eventKeyDown, this.handleKeydown), this.removeEventListener(eventFocusOut, this.handleFocusOut), this.observer.disconnect(), this.rowsPlaceholder = null, this.generatedHeader = null;
  }
  /**
   * @internal
   */
  handleRowFocus(Ae) {
    this.isUpdatingFocus = !0;
    const xr = Ae.target;
    this.focusRowIndex = this.rowElements.indexOf(xr), this.focusColumnIndex = xr.focusColumnIndex, this.setAttribute("tabIndex", "-1"), this.isUpdatingFocus = !1;
  }
  /**
   * @internal
   */
  handleFocus(Ae) {
    this.focusOnCell(this.focusRowIndex, this.focusColumnIndex, !0);
  }
  /**
   * @internal
   */
  handleFocusOut(Ae) {
    (Ae.relatedTarget === null || !this.contains(Ae.relatedTarget)) && this.setAttribute("tabIndex", this.noTabbing ? "-1" : "0");
  }
  /**
   * @internal
   */
  handleKeydown(Ae) {
    if (Ae.defaultPrevented)
      return;
    let xr;
    const ed = this.rowElements.length - 1, id = this.offsetHeight + this.scrollTop, od = this.rowElements[ed];
    switch (Ae.key) {
      case keyArrowUp$1:
        Ae.preventDefault(), this.focusOnCell(this.focusRowIndex - 1, this.focusColumnIndex, !0);
        break;
      case keyArrowDown$1:
        Ae.preventDefault(), this.focusOnCell(this.focusRowIndex + 1, this.focusColumnIndex, !0);
        break;
      case keyPageUp:
        if (Ae.preventDefault(), this.rowElements.length === 0) {
          this.focusOnCell(0, 0, !1);
          break;
        }
        if (this.focusRowIndex === 0) {
          this.focusOnCell(0, this.focusColumnIndex, !1);
          return;
        }
        for (xr = this.focusRowIndex - 1, xr; xr >= 0; xr--) {
          const ad = this.rowElements[xr];
          if (ad.offsetTop < this.scrollTop) {
            this.scrollTop = ad.offsetTop + ad.clientHeight - this.clientHeight;
            break;
          }
        }
        this.focusOnCell(xr, this.focusColumnIndex, !1);
        break;
      case keyPageDown:
        if (Ae.preventDefault(), this.rowElements.length === 0) {
          this.focusOnCell(0, 0, !1);
          break;
        }
        if (this.focusRowIndex >= ed || od.offsetTop + od.offsetHeight <= id) {
          this.focusOnCell(ed, this.focusColumnIndex, !1);
          return;
        }
        for (xr = this.focusRowIndex + 1, xr; xr <= ed; xr++) {
          const ad = this.rowElements[xr];
          if (ad.offsetTop + ad.offsetHeight > id) {
            let rd = 0;
            this.generateHeader === GenerateHeaderOptions.sticky && this.generatedHeader !== null && (rd = this.generatedHeader.clientHeight), this.scrollTop = ad.offsetTop - rd;
            break;
          }
        }
        this.focusOnCell(xr, this.focusColumnIndex, !1);
        break;
      case keyHome$1:
        Ae.ctrlKey && (Ae.preventDefault(), this.focusOnCell(0, 0, !0));
        break;
      case keyEnd$1:
        Ae.ctrlKey && this.columnDefinitions !== null && (Ae.preventDefault(), this.focusOnCell(this.rowElements.length - 1, this.columnDefinitions.length - 1, !0));
        break;
    }
  }
  queueFocusUpdate() {
    this.isUpdatingFocus && (this.contains(document.activeElement) || this === document.activeElement) || this.pendingFocusUpdate === !1 && (this.pendingFocusUpdate = !0, DOM.queueUpdate(() => this.updateFocus()));
  }
  updateFocus() {
    this.pendingFocusUpdate = !1, this.focusOnCell(this.focusRowIndex, this.focusColumnIndex, !0);
  }
  toggleGeneratedHeader() {
    if (this.generatedHeader !== null && (this.removeChild(this.generatedHeader), this.generatedHeader = null), this.generateHeader !== GenerateHeaderOptions.none && this.rowsData.length > 0) {
      const Ae = document.createElement(this.rowElementTag);
      this.generatedHeader = Ae, this.generatedHeader.columnDefinitions = this.columnDefinitions, this.generatedHeader.gridTemplateColumns = this.gridTemplateColumns, this.generatedHeader.rowType = this.generateHeader === GenerateHeaderOptions.sticky ? DataGridRowTypes.stickyHeader : DataGridRowTypes.header, (this.firstChild !== null || this.rowsPlaceholder !== null) && this.insertBefore(Ae, this.firstChild !== null ? this.firstChild : this.rowsPlaceholder);
      return;
    }
  }
};
DataGrid$1.generateColumns = (td) => Object.getOwnPropertyNames(td).map((Ae, xr) => ({
  columnDataKey: Ae,
  gridColumn: `${xr}`
}));
__decorate([
  attr({ attribute: "no-tabbing", mode: "boolean" })
], DataGrid$1.prototype, "noTabbing", void 0);
__decorate([
  attr({ attribute: "generate-header" })
], DataGrid$1.prototype, "generateHeader", void 0);
__decorate([
  attr({ attribute: "grid-template-columns" })
], DataGrid$1.prototype, "gridTemplateColumns", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "rowsData", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "columnDefinitions", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "rowItemTemplate", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "cellItemTemplate", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "headerCellItemTemplate", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "focusRowIndex", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "focusColumnIndex", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "defaultRowItemTemplate", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "rowElementTag", void 0);
__decorate([
  observable
], DataGrid$1.prototype, "rowElements", void 0);
const defaultCellContentsTemplate = html`
    <template>
        ${(td) => td.rowData === null || td.columnDefinition === null || td.columnDefinition.columnDataKey === null ? null : td.rowData[td.columnDefinition.columnDataKey]}
    </template>
`, defaultHeaderCellContentsTemplate = html`
    <template>
        ${(td) => td.columnDefinition === null ? null : td.columnDefinition.title === void 0 ? td.columnDefinition.columnDataKey : td.columnDefinition.title}
    </template>
`;
let DataGridCell$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.cellType = DataGridCellTypes.default, this.rowData = null, this.columnDefinition = null, this.isActiveCell = !1, this.customCellView = null, this.updateCellStyle = () => {
      this.style.gridColumn = this.gridColumn;
    };
  }
  cellTypeChanged() {
    this.$fastController.isConnected && this.updateCellView();
  }
  gridColumnChanged() {
    this.$fastController.isConnected && this.updateCellStyle();
  }
  columnDefinitionChanged(Ae, xr) {
    this.$fastController.isConnected && this.updateCellView();
  }
  /**
   * @internal
   */
  connectedCallback() {
    var Ae;
    super.connectedCallback(), this.addEventListener(eventFocusIn, this.handleFocusin), this.addEventListener(eventFocusOut, this.handleFocusout), this.addEventListener(eventKeyDown, this.handleKeydown), this.style.gridColumn = `${((Ae = this.columnDefinition) === null || Ae === void 0 ? void 0 : Ae.gridColumn) === void 0 ? 0 : this.columnDefinition.gridColumn}`, this.updateCellView(), this.updateCellStyle();
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener(eventFocusIn, this.handleFocusin), this.removeEventListener(eventFocusOut, this.handleFocusout), this.removeEventListener(eventKeyDown, this.handleKeydown), this.disconnectCellView();
  }
  handleFocusin(Ae) {
    if (!this.isActiveCell) {
      switch (this.isActiveCell = !0, this.cellType) {
        case DataGridCellTypes.columnHeader:
          if (this.columnDefinition !== null && this.columnDefinition.headerCellInternalFocusQueue !== !0 && typeof this.columnDefinition.headerCellFocusTargetCallback == "function") {
            const xr = this.columnDefinition.headerCellFocusTargetCallback(this);
            xr !== null && xr.focus();
          }
          break;
        default:
          if (this.columnDefinition !== null && this.columnDefinition.cellInternalFocusQueue !== !0 && typeof this.columnDefinition.cellFocusTargetCallback == "function") {
            const xr = this.columnDefinition.cellFocusTargetCallback(this);
            xr !== null && xr.focus();
          }
          break;
      }
      this.$emit("cell-focused", this);
    }
  }
  handleFocusout(Ae) {
    this !== document.activeElement && !this.contains(document.activeElement) && (this.isActiveCell = !1);
  }
  handleKeydown(Ae) {
    if (!(Ae.defaultPrevented || this.columnDefinition === null || this.cellType === DataGridCellTypes.default && this.columnDefinition.cellInternalFocusQueue !== !0 || this.cellType === DataGridCellTypes.columnHeader && this.columnDefinition.headerCellInternalFocusQueue !== !0))
      switch (Ae.key) {
        case keyEnter$1:
        case keyFunction2:
          if (this.contains(document.activeElement) && document.activeElement !== this)
            return;
          switch (this.cellType) {
            case DataGridCellTypes.columnHeader:
              if (this.columnDefinition.headerCellFocusTargetCallback !== void 0) {
                const xr = this.columnDefinition.headerCellFocusTargetCallback(this);
                xr !== null && xr.focus(), Ae.preventDefault();
              }
              break;
            default:
              if (this.columnDefinition.cellFocusTargetCallback !== void 0) {
                const xr = this.columnDefinition.cellFocusTargetCallback(this);
                xr !== null && xr.focus(), Ae.preventDefault();
              }
              break;
          }
          break;
        case keyEscape$1:
          this.contains(document.activeElement) && document.activeElement !== this && (this.focus(), Ae.preventDefault());
          break;
      }
  }
  updateCellView() {
    if (this.disconnectCellView(), this.columnDefinition !== null)
      switch (this.cellType) {
        case DataGridCellTypes.columnHeader:
          this.columnDefinition.headerCellTemplate !== void 0 ? this.customCellView = this.columnDefinition.headerCellTemplate.render(this, this) : this.customCellView = defaultHeaderCellContentsTemplate.render(this, this);
          break;
        case void 0:
        case DataGridCellTypes.rowHeader:
        case DataGridCellTypes.default:
          this.columnDefinition.cellTemplate !== void 0 ? this.customCellView = this.columnDefinition.cellTemplate.render(this, this) : this.customCellView = defaultCellContentsTemplate.render(this, this);
          break;
      }
  }
  disconnectCellView() {
    this.customCellView !== null && (this.customCellView.dispose(), this.customCellView = null);
  }
};
__decorate([
  attr({ attribute: "cell-type" })
], DataGridCell$1.prototype, "cellType", void 0);
__decorate([
  attr({ attribute: "grid-column" })
], DataGridCell$1.prototype, "gridColumn", void 0);
__decorate([
  observable
], DataGridCell$1.prototype, "rowData", void 0);
__decorate([
  observable
], DataGridCell$1.prototype, "columnDefinition", void 0);
function createCellItemTemplate(td) {
  const Ae = td.tagFor(DataGridCell$1);
  return html`
    <${Ae}
        cell-type="${(xr) => xr.isRowHeader ? "rowheader" : void 0}"
        grid-column="${(xr, ed) => ed.index + 1}"
        :rowData="${(xr, ed) => ed.parent.rowData}"
        :columnDefinition="${(xr) => xr}"
    ></${Ae}>
`;
}
function createHeaderCellItemTemplate(td) {
  const Ae = td.tagFor(DataGridCell$1);
  return html`
    <${Ae}
        cell-type="columnheader"
        grid-column="${(xr, ed) => ed.index + 1}"
        :columnDefinition="${(xr) => xr}"
    ></${Ae}>
`;
}
const dataGridRowTemplate = (td, Ae) => {
  const xr = createCellItemTemplate(td), ed = createHeaderCellItemTemplate(td);
  return html`
        <template
            role="row"
            class="${(id) => id.rowType !== "default" ? id.rowType : ""}"
            :defaultCellItemTemplate="${xr}"
            :defaultHeaderCellItemTemplate="${ed}"
            ${children({
    property: "cellElements",
    filter: elements('[role="cell"],[role="gridcell"],[role="columnheader"],[role="rowheader"]')
  })}
        >
            <slot ${slotted("slottedCellElements")}></slot>
        </template>
    `;
}, dataGridCellTemplate = (td, Ae) => html`
        <template
            tabindex="-1"
            role="${(xr) => !xr.cellType || xr.cellType === "default" ? "gridcell" : xr.cellType}"
            class="
            ${(xr) => xr.cellType === "columnheader" ? "column-header" : xr.cellType === "rowheader" ? "row-header" : ""}
            "
        >
            <slot></slot>
        </template>
    `, CalendarTitleTemplate = html`
    <div
        class="title"
        part="title"
        aria-label="${(td) => td.dateFormatter.getDate(`${td.month}-2-${td.year}`, {
  month: "long",
  year: "numeric"
})}"
    >
        <span part="month">
            ${(td) => td.dateFormatter.getMonth(td.month)}
        </span>
        <span part="year">${(td) => td.dateFormatter.getYear(td.year)}</span>
    </div>
`, calendarWeekdayTemplate = (td) => {
  const Ae = td.tagFor(DataGridCell$1);
  return html`
        <${Ae}
            class="week-day"
            part="week-day"
            tabindex="-1"
            grid-column="${(xr, ed) => ed.index + 1}"
            abbr="${(xr) => xr.abbr}"
        >
            ${(xr) => xr.text}
        </${Ae}>
    `;
}, calendarCellTemplate = (td, Ae) => {
  const xr = td.tagFor(DataGridCell$1);
  return html`
        <${xr}
            class="${(ed, id) => id.parentContext.parent.getDayClassNames(ed, Ae)}"
            part="day"
            tabindex="-1"
            role="gridcell"
            grid-column="${(ed, id) => id.index + 1}"
            @click="${(ed, id) => id.parentContext.parent.handleDateSelect(id.event, ed)}"
            @keydown="${(ed, id) => id.parentContext.parent.handleKeydown(id.event, ed)}"
            aria-label="${(ed, id) => id.parentContext.parent.dateFormatter.getDate(`${ed.month}-${ed.day}-${ed.year}`, { month: "long", day: "numeric" })}"
        >
            <div
                class="date"
                part="${(ed) => Ae === `${ed.month}-${ed.day}-${ed.year}` ? "today" : "date"}"
            >
                ${(ed, id) => id.parentContext.parent.dateFormatter.getDay(ed.day)}
            </div>
            <slot name="${(ed) => ed.month}-${(ed) => ed.day}-${(ed) => ed.year}"></slot>
        </${xr}>
    `;
}, calendarRowTemplate = (td, Ae) => {
  const xr = td.tagFor(DataGridRow$1);
  return html`
        <${xr}
            class="week"
            part="week"
            role="row"
            role-type="default"
            grid-template-columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        >
        ${repeat((ed) => ed, calendarCellTemplate(td, Ae), {
    positioning: !0
  })}
        </${xr}>
    `;
}, interactiveCalendarGridTemplate = (td, Ae) => {
  const xr = td.tagFor(DataGrid$1), ed = td.tagFor(DataGridRow$1);
  return html`
    <${xr} class="days interact" part="days" generate-header="none">
        <${ed}
            class="week-days"
            part="week-days"
            role="row"
            row-type="header"
            grid-template-columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        >
            ${repeat((id) => id.getWeekdayText(), calendarWeekdayTemplate(td), {
    positioning: !0
  })}
        </${ed}>
        ${repeat((id) => id.getDays(), calendarRowTemplate(td, Ae))}
    </${xr}>
`;
}, noninteractiveCalendarTemplate = (td) => html`
        <div class="days" part="days">
            <div class="week-days" part="week-days">
                ${repeat((Ae) => Ae.getWeekdayText(), html`
                        <div class="week-day" part="week-day" abbr="${(Ae) => Ae.abbr}">
                            ${(Ae) => Ae.text}
                        </div>
                    `)}
            </div>
            ${repeat((Ae) => Ae.getDays(), html`
                    <div class="week">
                        ${repeat((Ae) => Ae, html`
                                <div
                                    class="${(Ae, xr) => xr.parentContext.parent.getDayClassNames(Ae, td)}"
                                    part="day"
                                    aria-label="${(Ae, xr) => xr.parentContext.parent.dateFormatter.getDate(`${Ae.month}-${Ae.day}-${Ae.year}`, { month: "long", day: "numeric" })}"
                                >
                                    <div
                                        class="date"
                                        part="${(Ae) => td === `${Ae.month}-${Ae.day}-${Ae.year}` ? "today" : "date"}"
                                    >
                                        ${(Ae, xr) => xr.parentContext.parent.dateFormatter.getDay(Ae.day)}
                                    </div>
                                    <slot
                                        name="${(Ae) => Ae.month}-${(Ae) => Ae.day}-${(Ae) => Ae.year}"
                                    ></slot>
                                </div>
                            `)}
                    </div>
                `)}
        </div>
    `, calendarTemplate = (td, Ae) => {
  var xr;
  const ed = /* @__PURE__ */ new Date(), id = `${ed.getMonth() + 1}-${ed.getDate()}-${ed.getFullYear()}`;
  return html`
        <template>
            ${startTemplate}
            ${Ae.title instanceof Function ? Ae.title(td, Ae) : (xr = Ae.title) !== null && xr !== void 0 ? xr : ""}
            <slot></slot>
            ${when((od) => od.readonly, noninteractiveCalendarTemplate(id), interactiveCalendarGridTemplate(td, id))}
            ${endTemplate}
        </template>
    `;
}, cardTemplate = (td, Ae) => html`
    <slot></slot>
`;
let Card$1 = class extends FoundationElement {
};
const checkboxTemplate = (td, Ae) => html`
    <template
        role="checkbox"
        aria-checked="${(xr) => xr.checked}"
        aria-required="${(xr) => xr.required}"
        aria-disabled="${(xr) => xr.disabled}"
        aria-readonly="${(xr) => xr.readOnly}"
        tabindex="${(xr) => xr.disabled ? null : 0}"
        @keypress="${(xr, ed) => xr.keypressHandler(ed.event)}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
        class="${(xr) => xr.readOnly ? "readonly" : ""} ${(xr) => xr.checked ? "checked" : ""} ${(xr) => xr.indeterminate ? "indeterminate" : ""}"
    >
        <div part="control" class="control">
            <slot name="checked-indicator">
                ${Ae.checkedIndicator || ""}
            </slot>
            <slot name="indeterminate-indicator">
                ${Ae.indeterminateIndicator || ""}
            </slot>
        </div>
        <label
            part="label"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot ${slotted("defaultSlottedNodes")}></slot>
        </label>
    </template>
`;
class _Checkbox extends FoundationElement {
}
class FormAssociatedCheckbox extends CheckableFormAssociated(_Checkbox) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
let Checkbox$1 = class extends FormAssociatedCheckbox {
  constructor() {
    super(), this.initialValue = "on", this.indeterminate = !1, this.keypressHandler = (Ae) => {
      if (!this.readOnly)
        switch (Ae.key) {
          case keySpace$1:
            this.indeterminate && (this.indeterminate = !1), this.checked = !this.checked;
            break;
        }
    }, this.clickHandler = (Ae) => {
      !this.disabled && !this.readOnly && (this.indeterminate && (this.indeterminate = !1), this.checked = !this.checked);
    }, this.proxy.setAttribute("type", "checkbox");
  }
  readOnlyChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.readOnly = this.readOnly);
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], Checkbox$1.prototype, "readOnly", void 0);
__decorate([
  observable
], Checkbox$1.prototype, "defaultSlottedNodes", void 0);
__decorate([
  observable
], Checkbox$1.prototype, "indeterminate", void 0);
function isListboxOption(td) {
  return isHTMLElement$1(td) && (td.getAttribute("role") === "option" || td instanceof HTMLOptionElement);
}
class ListboxOption extends FoundationElement {
  constructor(Ae, xr, ed, id) {
    super(), this.defaultSelected = !1, this.dirtySelected = !1, this.selected = this.defaultSelected, this.dirtyValue = !1, Ae && (this.textContent = Ae), xr && (this.initialValue = xr), ed && (this.defaultSelected = ed), id && (this.selected = id), this.proxy = new Option(`${this.textContent}`, this.initialValue, this.defaultSelected, this.selected), this.proxy.disabled = this.disabled;
  }
  /**
   * Updates the ariaChecked property when the checked property changes.
   *
   * @param prev - the previous checked value
   * @param next - the current checked value
   *
   * @public
   */
  checkedChanged(Ae, xr) {
    if (typeof xr == "boolean") {
      this.ariaChecked = xr ? "true" : "false";
      return;
    }
    this.ariaChecked = null;
  }
  /**
   * Updates the proxy's text content when the default slot changes.
   * @param prev - the previous content value
   * @param next - the current content value
   *
   * @internal
   */
  contentChanged(Ae, xr) {
    this.proxy instanceof HTMLOptionElement && (this.proxy.textContent = this.textContent), this.$emit("contentchange", null, { bubbles: !0 });
  }
  defaultSelectedChanged() {
    this.dirtySelected || (this.selected = this.defaultSelected, this.proxy instanceof HTMLOptionElement && (this.proxy.selected = this.defaultSelected));
  }
  disabledChanged(Ae, xr) {
    this.ariaDisabled = this.disabled ? "true" : "false", this.proxy instanceof HTMLOptionElement && (this.proxy.disabled = this.disabled);
  }
  selectedAttributeChanged() {
    this.defaultSelected = this.selectedAttribute, this.proxy instanceof HTMLOptionElement && (this.proxy.defaultSelected = this.defaultSelected);
  }
  selectedChanged() {
    this.ariaSelected = this.selected ? "true" : "false", this.dirtySelected || (this.dirtySelected = !0), this.proxy instanceof HTMLOptionElement && (this.proxy.selected = this.selected);
  }
  initialValueChanged(Ae, xr) {
    this.dirtyValue || (this.value = this.initialValue, this.dirtyValue = !1);
  }
  get label() {
    var Ae;
    return (Ae = this.value) !== null && Ae !== void 0 ? Ae : this.text;
  }
  get text() {
    var Ae, xr;
    return (xr = (Ae = this.textContent) === null || Ae === void 0 ? void 0 : Ae.replace(/\s+/g, " ").trim()) !== null && xr !== void 0 ? xr : "";
  }
  set value(Ae) {
    const xr = `${Ae != null ? Ae : ""}`;
    this._value = xr, this.dirtyValue = !0, this.proxy instanceof HTMLOptionElement && (this.proxy.value = xr), Observable.notify(this, "value");
  }
  get value() {
    var Ae;
    return Observable.track(this, "value"), (Ae = this._value) !== null && Ae !== void 0 ? Ae : this.text;
  }
  get form() {
    return this.proxy ? this.proxy.form : null;
  }
}
__decorate([
  observable
], ListboxOption.prototype, "checked", void 0);
__decorate([
  observable
], ListboxOption.prototype, "content", void 0);
__decorate([
  observable
], ListboxOption.prototype, "defaultSelected", void 0);
__decorate([
  attr({ mode: "boolean" })
], ListboxOption.prototype, "disabled", void 0);
__decorate([
  attr({ attribute: "selected", mode: "boolean" })
], ListboxOption.prototype, "selectedAttribute", void 0);
__decorate([
  observable
], ListboxOption.prototype, "selected", void 0);
__decorate([
  attr({ attribute: "value", mode: "fromView" })
], ListboxOption.prototype, "initialValue", void 0);
class DelegatesARIAListboxOption {
}
__decorate([
  observable
], DelegatesARIAListboxOption.prototype, "ariaChecked", void 0);
__decorate([
  observable
], DelegatesARIAListboxOption.prototype, "ariaPosInSet", void 0);
__decorate([
  observable
], DelegatesARIAListboxOption.prototype, "ariaSelected", void 0);
__decorate([
  observable
], DelegatesARIAListboxOption.prototype, "ariaSetSize", void 0);
applyMixins(DelegatesARIAListboxOption, ARIAGlobalStatesAndProperties);
applyMixins(ListboxOption, StartEnd, DelegatesARIAListboxOption);
let Listbox$1 = class f1 extends FoundationElement {
  constructor() {
    super(...arguments), this._options = [], this.selectedIndex = -1, this.selectedOptions = [], this.shouldSkipFocus = !1, this.typeaheadBuffer = "", this.typeaheadExpired = !0, this.typeaheadTimeout = -1;
  }
  /**
   * The first selected option.
   *
   * @internal
   */
  get firstSelectedOption() {
    var Ae;
    return (Ae = this.selectedOptions[0]) !== null && Ae !== void 0 ? Ae : null;
  }
  /**
   * Returns true if there is one or more selectable option.
   *
   * @internal
   */
  get hasSelectableOptions() {
    return this.options.length > 0 && !this.options.every((Ae) => Ae.disabled);
  }
  /**
   * The number of options.
   *
   * @public
   */
  get length() {
    var Ae, xr;
    return (xr = (Ae = this.options) === null || Ae === void 0 ? void 0 : Ae.length) !== null && xr !== void 0 ? xr : 0;
  }
  /**
   * The list of options.
   *
   * @public
   */
  get options() {
    return Observable.track(this, "options"), this._options;
  }
  set options(Ae) {
    this._options = Ae, Observable.notify(this, "options");
  }
  /**
   * Flag for the typeahead timeout expiration.
   *
   * @deprecated use `Listbox.typeaheadExpired`
   * @internal
   */
  get typeAheadExpired() {
    return this.typeaheadExpired;
  }
  set typeAheadExpired(Ae) {
    this.typeaheadExpired = Ae;
  }
  /**
   * Handle click events for listbox options.
   *
   * @internal
   */
  clickHandler(Ae) {
    const xr = Ae.target.closest("option,[role=option]");
    if (xr && !xr.disabled)
      return this.selectedIndex = this.options.indexOf(xr), !0;
  }
  /**
   * Ensures that the provided option is focused and scrolled into view.
   *
   * @param optionToFocus - The option to focus
   * @internal
   */
  focusAndScrollOptionIntoView(Ae = this.firstSelectedOption) {
    this.contains(document.activeElement) && Ae !== null && (Ae.focus(), requestAnimationFrame(() => {
      Ae.scrollIntoView({ block: "nearest" });
    }));
  }
  /**
   * Handles `focusin` actions for the component. When the component receives focus,
   * the list of selected options is refreshed and the first selected option is scrolled
   * into view.
   *
   * @internal
   */
  focusinHandler(Ae) {
    !this.shouldSkipFocus && Ae.target === Ae.currentTarget && (this.setSelectedOptions(), this.focusAndScrollOptionIntoView()), this.shouldSkipFocus = !1;
  }
  /**
   * Returns the options which match the current typeahead buffer.
   *
   * @internal
   */
  getTypeaheadMatches() {
    const Ae = this.typeaheadBuffer.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"), xr = new RegExp(`^${Ae}`, "gi");
    return this.options.filter((ed) => ed.text.trim().match(xr));
  }
  /**
   * Determines the index of the next option which is selectable, if any.
   *
   * @param prev - the previous selected index
   * @param next - the next index to select
   *
   * @internal
   */
  getSelectableIndex(Ae = this.selectedIndex, xr) {
    const ed = Ae > xr ? -1 : Ae < xr ? 1 : 0, id = Ae + ed;
    let od = null;
    switch (ed) {
      case -1: {
        od = this.options.reduceRight((ad, rd, sd) => !ad && !rd.disabled && sd < id ? rd : ad, od);
        break;
      }
      case 1: {
        od = this.options.reduce((ad, rd, sd) => !ad && !rd.disabled && sd > id ? rd : ad, od);
        break;
      }
    }
    return this.options.indexOf(od);
  }
  /**
   * Handles external changes to child options.
   *
   * @param source - the source object
   * @param propertyName - the property
   *
   * @internal
   */
  handleChange(Ae, xr) {
    switch (xr) {
      case "selected": {
        f1.slottedOptionFilter(Ae) && (this.selectedIndex = this.options.indexOf(Ae)), this.setSelectedOptions();
        break;
      }
    }
  }
  /**
   * Moves focus to an option whose label matches characters typed by the user.
   * Consecutive keystrokes are batched into a buffer of search text used
   * to match against the set of options.  If `TYPE_AHEAD_TIMEOUT_MS` passes
   * between consecutive keystrokes, the search restarts.
   *
   * @param key - the key to be evaluated
   *
   * @internal
   */
  handleTypeAhead(Ae) {
    this.typeaheadTimeout && window.clearTimeout(this.typeaheadTimeout), this.typeaheadTimeout = window.setTimeout(() => this.typeaheadExpired = !0, f1.TYPE_AHEAD_TIMEOUT_MS), !(Ae.length > 1) && (this.typeaheadBuffer = `${this.typeaheadExpired ? "" : this.typeaheadBuffer}${Ae}`);
  }
  /**
   * Handles `keydown` actions for listbox navigation and typeahead.
   *
   * @internal
   */
  keydownHandler(Ae) {
    if (this.disabled)
      return !0;
    this.shouldSkipFocus = !1;
    const xr = Ae.key;
    switch (xr) {
      case keyHome$1: {
        Ae.shiftKey || (Ae.preventDefault(), this.selectFirstOption());
        break;
      }
      case keyArrowDown$1: {
        Ae.shiftKey || (Ae.preventDefault(), this.selectNextOption());
        break;
      }
      case keyArrowUp$1: {
        Ae.shiftKey || (Ae.preventDefault(), this.selectPreviousOption());
        break;
      }
      case keyEnd$1: {
        Ae.preventDefault(), this.selectLastOption();
        break;
      }
      case keyTab$1:
        return this.focusAndScrollOptionIntoView(), !0;
      case keyEnter$1:
      case keyEscape$1:
        return !0;
      case keySpace$1:
        if (this.typeaheadExpired)
          return !0;
      default:
        return xr.length === 1 && this.handleTypeAhead(`${xr}`), !0;
    }
  }
  /**
   * Prevents `focusin` events from firing before `click` events when the
   * element is unfocused.
   *
   * @internal
   */
  mousedownHandler(Ae) {
    return this.shouldSkipFocus = !this.contains(document.activeElement), !0;
  }
  /**
   * Switches between single-selection and multi-selection mode.
   *
   * @param prev - the previous value of the `multiple` attribute
   * @param next - the next value of the `multiple` attribute
   *
   * @internal
   */
  multipleChanged(Ae, xr) {
    this.ariaMultiSelectable = xr ? "true" : null;
  }
  /**
   * Updates the list of selected options when the `selectedIndex` changes.
   *
   * @param prev - the previous selected index value
   * @param next - the current selected index value
   *
   * @internal
   */
  selectedIndexChanged(Ae, xr) {
    var ed;
    if (!this.hasSelectableOptions) {
      this.selectedIndex = -1;
      return;
    }
    if (!((ed = this.options[this.selectedIndex]) === null || ed === void 0) && ed.disabled && typeof Ae == "number") {
      const id = this.getSelectableIndex(Ae, xr), od = id > -1 ? id : Ae;
      this.selectedIndex = od, xr === od && this.selectedIndexChanged(xr, od);
      return;
    }
    this.setSelectedOptions();
  }
  /**
   * Updates the selectedness of each option when the list of selected options changes.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @internal
   */
  selectedOptionsChanged(Ae, xr) {
    var ed;
    const id = xr.filter(f1.slottedOptionFilter);
    (ed = this.options) === null || ed === void 0 || ed.forEach((od) => {
      const ad = Observable.getNotifier(od);
      ad.unsubscribe(this, "selected"), od.selected = id.includes(od), ad.subscribe(this, "selected");
    });
  }
  /**
   * Moves focus to the first selectable option.
   *
   * @public
   */
  selectFirstOption() {
    var Ae, xr;
    this.disabled || (this.selectedIndex = (xr = (Ae = this.options) === null || Ae === void 0 ? void 0 : Ae.findIndex((ed) => !ed.disabled)) !== null && xr !== void 0 ? xr : -1);
  }
  /**
   * Moves focus to the last selectable option.
   *
   * @internal
   */
  selectLastOption() {
    this.disabled || (this.selectedIndex = findLastIndex(this.options, (Ae) => !Ae.disabled));
  }
  /**
   * Moves focus to the next selectable option.
   *
   * @internal
   */
  selectNextOption() {
    !this.disabled && this.selectedIndex < this.options.length - 1 && (this.selectedIndex += 1);
  }
  /**
   * Moves focus to the previous selectable option.
   *
   * @internal
   */
  selectPreviousOption() {
    !this.disabled && this.selectedIndex > 0 && (this.selectedIndex = this.selectedIndex - 1);
  }
  /**
   * Updates the selected index to match the first selected option.
   *
   * @internal
   */
  setDefaultSelectedOption() {
    var Ae, xr;
    this.selectedIndex = (xr = (Ae = this.options) === null || Ae === void 0 ? void 0 : Ae.findIndex((ed) => ed.defaultSelected)) !== null && xr !== void 0 ? xr : -1;
  }
  /**
   * Sets an option as selected and gives it focus.
   *
   * @public
   */
  setSelectedOptions() {
    var Ae, xr, ed;
    !((Ae = this.options) === null || Ae === void 0) && Ae.length && (this.selectedOptions = [this.options[this.selectedIndex]], this.ariaActiveDescendant = (ed = (xr = this.firstSelectedOption) === null || xr === void 0 ? void 0 : xr.id) !== null && ed !== void 0 ? ed : "", this.focusAndScrollOptionIntoView());
  }
  /**
   * Updates the list of options and resets the selected option when the slotted option content changes.
   *
   * @param prev - the previous list of slotted options
   * @param next - the current list of slotted options
   *
   * @internal
   */
  slottedOptionsChanged(Ae, xr) {
    this.options = xr.reduce((id, od) => (isListboxOption(od) && id.push(od), id), []);
    const ed = `${this.options.length}`;
    this.options.forEach((id, od) => {
      id.id || (id.id = uniqueId$1("option-")), id.ariaPosInSet = `${od + 1}`, id.ariaSetSize = ed;
    }), this.$fastController.isConnected && (this.setSelectedOptions(), this.setDefaultSelectedOption());
  }
  /**
   * Updates the filtered list of options when the typeahead buffer changes.
   *
   * @param prev - the previous typeahead buffer value
   * @param next - the current typeahead buffer value
   *
   * @internal
   */
  typeaheadBufferChanged(Ae, xr) {
    if (this.$fastController.isConnected) {
      const ed = this.getTypeaheadMatches();
      if (ed.length) {
        const id = this.options.indexOf(ed[0]);
        id > -1 && (this.selectedIndex = id);
      }
      this.typeaheadExpired = !1;
    }
  }
};
Listbox$1.slottedOptionFilter = (td) => isListboxOption(td) && !td.hidden;
Listbox$1.TYPE_AHEAD_TIMEOUT_MS = 1e3;
__decorate([
  attr({ mode: "boolean" })
], Listbox$1.prototype, "disabled", void 0);
__decorate([
  observable
], Listbox$1.prototype, "selectedIndex", void 0);
__decorate([
  observable
], Listbox$1.prototype, "selectedOptions", void 0);
__decorate([
  observable
], Listbox$1.prototype, "slottedOptions", void 0);
__decorate([
  observable
], Listbox$1.prototype, "typeaheadBuffer", void 0);
class DelegatesARIAListbox {
}
__decorate([
  observable
], DelegatesARIAListbox.prototype, "ariaActiveDescendant", void 0);
__decorate([
  observable
], DelegatesARIAListbox.prototype, "ariaDisabled", void 0);
__decorate([
  observable
], DelegatesARIAListbox.prototype, "ariaExpanded", void 0);
__decorate([
  observable
], DelegatesARIAListbox.prototype, "ariaMultiSelectable", void 0);
applyMixins(DelegatesARIAListbox, ARIAGlobalStatesAndProperties);
applyMixins(Listbox$1, DelegatesARIAListbox);
const SelectPosition$1 = {
  above: "above",
  below: "below"
};
let _Combobox$1 = class extends Listbox$1 {
}, FormAssociatedCombobox$1 = class extends FormAssociated(_Combobox$1) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
};
const ComboboxAutocomplete = {
  inline: "inline",
  list: "list",
  both: "both",
  none: "none"
};
let Combobox$1 = class extends FormAssociatedCombobox$1 {
  constructor() {
    super(...arguments), this._value = "", this.filteredOptions = [], this.filter = "", this.forcedPosition = !1, this.listboxId = uniqueId$1("listbox-"), this.maxHeight = 0, this.open = !1;
  }
  /**
   * Reset the element to its first selectable option when its parent form is reset.
   *
   * @internal
   */
  formResetCallback() {
    super.formResetCallback(), this.setDefaultSelectedOption(), this.updateValue();
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  get isAutocompleteInline() {
    return this.autocomplete === ComboboxAutocomplete.inline || this.isAutocompleteBoth;
  }
  get isAutocompleteList() {
    return this.autocomplete === ComboboxAutocomplete.list || this.isAutocompleteBoth;
  }
  get isAutocompleteBoth() {
    return this.autocomplete === ComboboxAutocomplete.both;
  }
  /**
   * Sets focus and synchronize ARIA attributes when the open property changes.
   *
   * @param prev - the previous open value
   * @param next - the current open value
   *
   * @internal
   */
  openChanged() {
    if (this.open) {
      this.ariaControls = this.listboxId, this.ariaExpanded = "true", this.setPositioning(), this.focusAndScrollOptionIntoView(), DOM.queueUpdate(() => this.focus());
      return;
    }
    this.ariaControls = "", this.ariaExpanded = "false";
  }
  /**
   * The list of options.
   *
   * @public
   * @remarks
   * Overrides `Listbox.options`.
   */
  get options() {
    return Observable.track(this, "options"), this.filteredOptions.length ? this.filteredOptions : this._options;
  }
  set options(Ae) {
    this._options = Ae, Observable.notify(this, "options");
  }
  /**
   * Updates the placeholder on the proxy element.
   * @internal
   */
  placeholderChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.placeholder = this.placeholder);
  }
  positionChanged(Ae, xr) {
    this.positionAttribute = xr, this.setPositioning();
  }
  /**
   * The value property.
   *
   * @public
   */
  get value() {
    return Observable.track(this, "value"), this._value;
  }
  set value(Ae) {
    var xr, ed, id;
    const od = `${this._value}`;
    if (this.$fastController.isConnected && this.options) {
      const ad = this.options.findIndex((nd) => nd.text.toLowerCase() === Ae.toLowerCase()), rd = (xr = this.options[this.selectedIndex]) === null || xr === void 0 ? void 0 : xr.text, sd = (ed = this.options[ad]) === null || ed === void 0 ? void 0 : ed.text;
      this.selectedIndex = rd !== sd ? ad : this.selectedIndex, Ae = ((id = this.firstSelectedOption) === null || id === void 0 ? void 0 : id.text) || Ae;
    }
    od !== Ae && (this._value = Ae, super.valueChanged(od, Ae), Observable.notify(this, "value"));
  }
  /**
   * Handle opening and closing the listbox when the combobox is clicked.
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(Ae) {
    if (!this.disabled) {
      if (this.open) {
        const xr = Ae.target.closest("option,[role=option]");
        if (!xr || xr.disabled)
          return;
        this.selectedOptions = [xr], this.control.value = xr.text, this.clearSelectionRange(), this.updateValue(!0);
      }
      return this.open = !this.open, this.open && this.control.focus(), !0;
    }
  }
  connectedCallback() {
    super.connectedCallback(), this.forcedPosition = !!this.positionAttribute, this.value && (this.initialValue = this.value);
  }
  /**
   * Synchronize the `aria-disabled` property when the `disabled` property changes.
   *
   * @param prev - The previous disabled value
   * @param next - The next disabled value
   *
   * @internal
   */
  disabledChanged(Ae, xr) {
    super.disabledChanged && super.disabledChanged(Ae, xr), this.ariaDisabled = this.disabled ? "true" : "false";
  }
  /**
   * Filter available options by text value.
   *
   * @public
   */
  filterOptions() {
    (!this.autocomplete || this.autocomplete === ComboboxAutocomplete.none) && (this.filter = "");
    const Ae = this.filter.toLowerCase();
    this.filteredOptions = this._options.filter((xr) => xr.text.toLowerCase().startsWith(this.filter.toLowerCase())), this.isAutocompleteList && (!this.filteredOptions.length && !Ae && (this.filteredOptions = this._options), this._options.forEach((xr) => {
      xr.hidden = !this.filteredOptions.includes(xr);
    }));
  }
  /**
   * Focus the control and scroll the first selected option into view.
   *
   * @internal
   * @remarks
   * Overrides: `Listbox.focusAndScrollOptionIntoView`
   */
  focusAndScrollOptionIntoView() {
    this.contains(document.activeElement) && (this.control.focus(), this.firstSelectedOption && requestAnimationFrame(() => {
      var Ae;
      (Ae = this.firstSelectedOption) === null || Ae === void 0 || Ae.scrollIntoView({ block: "nearest" });
    }));
  }
  /**
   * Handle focus state when the element or its children lose focus.
   *
   * @param e - The focus event
   * @internal
   */
  focusoutHandler(Ae) {
    if (this.syncValue(), !this.open)
      return !0;
    const xr = Ae.relatedTarget;
    if (this.isSameNode(xr)) {
      this.focus();
      return;
    }
    (!this.options || !this.options.includes(xr)) && (this.open = !1);
  }
  /**
   * Handle content changes on the control input.
   *
   * @param e - the input event
   * @internal
   */
  inputHandler(Ae) {
    if (this.filter = this.control.value, this.filterOptions(), this.isAutocompleteInline || (this.selectedIndex = this.options.map((xr) => xr.text).indexOf(this.control.value)), Ae.inputType.includes("deleteContent") || !this.filter.length)
      return !0;
    this.isAutocompleteList && !this.open && (this.open = !0), this.isAutocompleteInline && (this.filteredOptions.length ? (this.selectedOptions = [this.filteredOptions[0]], this.selectedIndex = this.options.indexOf(this.firstSelectedOption), this.setInlineSelection()) : this.selectedIndex = -1);
  }
  /**
   * Handle keydown actions for listbox navigation.
   *
   * @param e - the keyboard event
   * @internal
   */
  keydownHandler(Ae) {
    const xr = Ae.key;
    if (Ae.ctrlKey || Ae.shiftKey)
      return !0;
    switch (xr) {
      case "Enter": {
        this.syncValue(), this.isAutocompleteInline && (this.filter = this.value), this.open = !1, this.clearSelectionRange();
        break;
      }
      case "Escape": {
        if (this.isAutocompleteInline || (this.selectedIndex = -1), this.open) {
          this.open = !1;
          break;
        }
        this.value = "", this.control.value = "", this.filter = "", this.filterOptions();
        break;
      }
      case "Tab": {
        if (this.setInputToSelection(), !this.open)
          return !0;
        Ae.preventDefault(), this.open = !1;
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        if (this.filterOptions(), !this.open) {
          this.open = !0;
          break;
        }
        this.filteredOptions.length > 0 && super.keydownHandler(Ae), this.isAutocompleteInline && this.setInlineSelection();
        break;
      }
      default:
        return !0;
    }
  }
  /**
   * Handle keyup actions for value input and text field manipulations.
   *
   * @param e - the keyboard event
   * @internal
   */
  keyupHandler(Ae) {
    switch (Ae.key) {
      case "ArrowLeft":
      case "ArrowRight":
      case "Backspace":
      case "Delete":
      case "Home":
      case "End": {
        this.filter = this.control.value, this.selectedIndex = -1, this.filterOptions();
        break;
      }
    }
  }
  /**
   * Ensure that the selectedIndex is within the current allowable filtered range.
   *
   * @param prev - the previous selected index value
   * @param next - the current selected index value
   *
   * @internal
   */
  selectedIndexChanged(Ae, xr) {
    if (this.$fastController.isConnected) {
      if (xr = limit$1(-1, this.options.length - 1, xr), xr !== this.selectedIndex) {
        this.selectedIndex = xr;
        return;
      }
      super.selectedIndexChanged(Ae, xr);
    }
  }
  /**
   * Move focus to the previous selectable option.
   *
   * @internal
   * @remarks
   * Overrides `Listbox.selectPreviousOption`
   */
  selectPreviousOption() {
    !this.disabled && this.selectedIndex >= 0 && (this.selectedIndex = this.selectedIndex - 1);
  }
  /**
   * Set the default selected options at initialization or reset.
   *
   * @internal
   * @remarks
   * Overrides `Listbox.setDefaultSelectedOption`
   */
  setDefaultSelectedOption() {
    if (this.$fastController.isConnected && this.options) {
      const Ae = this.options.findIndex((xr) => xr.getAttribute("selected") !== null || xr.selected);
      this.selectedIndex = Ae, !this.dirtyValue && this.firstSelectedOption && (this.value = this.firstSelectedOption.text), this.setSelectedOptions();
    }
  }
  /**
   * Focus and set the content of the control based on the first selected option.
   *
   * @internal
   */
  setInputToSelection() {
    this.firstSelectedOption && (this.control.value = this.firstSelectedOption.text, this.control.focus());
  }
  /**
   * Focus, set and select the content of the control based on the first selected option.
   *
   * @internal
   */
  setInlineSelection() {
    this.firstSelectedOption && (this.setInputToSelection(), this.control.setSelectionRange(this.filter.length, this.control.value.length, "backward"));
  }
  /**
   * Determines if a value update should involve emitting a change event, then updates the value.
   *
   * @internal
   */
  syncValue() {
    var Ae;
    const xr = this.selectedIndex > -1 ? (Ae = this.firstSelectedOption) === null || Ae === void 0 ? void 0 : Ae.text : this.control.value;
    this.updateValue(this.value !== xr);
  }
  /**
   * Calculate and apply listbox positioning based on available viewport space.
   *
   * @param force - direction to force the listbox to display
   * @public
   */
  setPositioning() {
    const Ae = this.getBoundingClientRect(), ed = window.innerHeight - Ae.bottom;
    this.position = this.forcedPosition ? this.positionAttribute : Ae.top > ed ? SelectPosition$1.above : SelectPosition$1.below, this.positionAttribute = this.forcedPosition ? this.positionAttribute : this.position, this.maxHeight = this.position === SelectPosition$1.above ? ~~Ae.top : ~~ed;
  }
  /**
   * Ensure that the entire list of options is used when setting the selected property.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @internal
   * @remarks
   * Overrides: `Listbox.selectedOptionsChanged`
   */
  selectedOptionsChanged(Ae, xr) {
    this.$fastController.isConnected && this._options.forEach((ed) => {
      ed.selected = xr.includes(ed);
    });
  }
  /**
   * Synchronize the form-associated proxy and update the value property of the element.
   *
   * @param prev - the previous collection of slotted option elements
   * @param next - the next collection of slotted option elements
   *
   * @internal
   */
  slottedOptionsChanged(Ae, xr) {
    super.slottedOptionsChanged(Ae, xr), this.updateValue();
  }
  /**
   * Sets the value and to match the first selected option.
   *
   * @param shouldEmit - if true, the change event will be emitted
   *
   * @internal
   */
  updateValue(Ae) {
    var xr;
    this.$fastController.isConnected && (this.value = ((xr = this.firstSelectedOption) === null || xr === void 0 ? void 0 : xr.text) || this.control.value, this.control.value = this.value), Ae && this.$emit("change");
  }
  /**
   * @internal
   */
  clearSelectionRange() {
    const Ae = this.control.value.length;
    this.control.setSelectionRange(Ae, Ae);
  }
};
__decorate([
  attr({ attribute: "autocomplete", mode: "fromView" })
], Combobox$1.prototype, "autocomplete", void 0);
__decorate([
  observable
], Combobox$1.prototype, "maxHeight", void 0);
__decorate([
  attr({ attribute: "open", mode: "boolean" })
], Combobox$1.prototype, "open", void 0);
__decorate([
  attr
], Combobox$1.prototype, "placeholder", void 0);
__decorate([
  attr({ attribute: "position" })
], Combobox$1.prototype, "positionAttribute", void 0);
__decorate([
  observable
], Combobox$1.prototype, "position", void 0);
let DelegatesARIACombobox$1 = class {
};
__decorate([
  observable
], DelegatesARIACombobox$1.prototype, "ariaAutoComplete", void 0);
__decorate([
  observable
], DelegatesARIACombobox$1.prototype, "ariaControls", void 0);
applyMixins(DelegatesARIACombobox$1, DelegatesARIAListbox);
applyMixins(Combobox$1, StartEnd, DelegatesARIACombobox$1);
const comboboxTemplate = (td, Ae) => html`
    <template
        aria-disabled="${(xr) => xr.ariaDisabled}"
        autocomplete="${(xr) => xr.autocomplete}"
        class="${(xr) => xr.open ? "open" : ""} ${(xr) => xr.disabled ? "disabled" : ""} ${(xr) => xr.position}"
        ?open="${(xr) => xr.open}"
        tabindex="${(xr) => xr.disabled ? null : "0"}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
        @focusout="${(xr, ed) => xr.focusoutHandler(ed.event)}"
        @keydown="${(xr, ed) => xr.keydownHandler(ed.event)}"
    >
        <div class="control" part="control">
            ${startSlotTemplate(td, Ae)}
            <slot name="control">
                <input
                    aria-activedescendant="${(xr) => xr.open ? xr.ariaActiveDescendant : null}"
                    aria-autocomplete="${(xr) => xr.ariaAutoComplete}"
                    aria-controls="${(xr) => xr.ariaControls}"
                    aria-disabled="${(xr) => xr.ariaDisabled}"
                    aria-expanded="${(xr) => xr.ariaExpanded}"
                    aria-haspopup="listbox"
                    class="selected-value"
                    part="selected-value"
                    placeholder="${(xr) => xr.placeholder}"
                    role="combobox"
                    type="text"
                    ?disabled="${(xr) => xr.disabled}"
                    :value="${(xr) => xr.value}"
                    @input="${(xr, ed) => xr.inputHandler(ed.event)}"
                    @keyup="${(xr, ed) => xr.keyupHandler(ed.event)}"
                    ${ref("control")}
                />
                <div class="indicator" part="indicator" aria-hidden="true">
                    <slot name="indicator">
                        ${Ae.indicator || ""}
                    </slot>
                </div>
            </slot>
            ${endSlotTemplate(td, Ae)}
        </div>
        <div
            class="listbox"
            id="${(xr) => xr.listboxId}"
            part="listbox"
            role="listbox"
            ?disabled="${(xr) => xr.disabled}"
            ?hidden="${(xr) => !xr.open}"
            ${ref("listbox")}
        >
            <slot
                ${slotted({
  filter: Listbox$1.slottedOptionFilter,
  flatten: !0,
  property: "slottedOptions"
})}
            ></slot>
        </div>
    </template>
`;
function composedParent(td) {
  const Ae = td.parentElement;
  if (Ae)
    return Ae;
  {
    const xr = td.getRootNode();
    if (xr.host instanceof HTMLElement)
      return xr.host;
  }
  return null;
}
function composedContains(td, Ae) {
  let xr = Ae;
  for (; xr !== null; ) {
    if (xr === td)
      return !0;
    xr = composedParent(xr);
  }
  return !1;
}
const defaultElement = document.createElement("div");
function isFastElement(td) {
  return td instanceof FASTElement;
}
class QueuedStyleSheetTarget {
  setProperty(Ae, xr) {
    DOM.queueUpdate(() => this.target.setProperty(Ae, xr));
  }
  removeProperty(Ae) {
    DOM.queueUpdate(() => this.target.removeProperty(Ae));
  }
}
class ConstructableStyleSheetTarget extends QueuedStyleSheetTarget {
  constructor(Ae) {
    super();
    const xr = new CSSStyleSheet();
    this.target = xr.cssRules[xr.insertRule(":host{}")].style, Ae.$fastController.addStyles(ElementStyles.create([xr]));
  }
}
class DocumentStyleSheetTarget extends QueuedStyleSheetTarget {
  constructor() {
    super();
    const Ae = new CSSStyleSheet();
    this.target = Ae.cssRules[Ae.insertRule(":root{}")].style, document.adoptedStyleSheets = [
      ...document.adoptedStyleSheets,
      Ae
    ];
  }
}
class HeadStyleElementStyleSheetTarget extends QueuedStyleSheetTarget {
  constructor() {
    super(), this.style = document.createElement("style"), document.head.appendChild(this.style);
    const { sheet: Ae } = this.style;
    if (Ae) {
      const xr = Ae.insertRule(":root{}", Ae.cssRules.length);
      this.target = Ae.cssRules[xr].style;
    }
  }
}
class StyleElementStyleSheetTarget {
  constructor(Ae) {
    this.store = /* @__PURE__ */ new Map(), this.target = null;
    const xr = Ae.$fastController;
    this.style = document.createElement("style"), xr.addStyles(this.style), Observable.getNotifier(xr).subscribe(this, "isConnected"), this.handleChange(xr, "isConnected");
  }
  targetChanged() {
    if (this.target !== null)
      for (const [Ae, xr] of this.store.entries())
        this.target.setProperty(Ae, xr);
  }
  setProperty(Ae, xr) {
    this.store.set(Ae, xr), DOM.queueUpdate(() => {
      this.target !== null && this.target.setProperty(Ae, xr);
    });
  }
  removeProperty(Ae) {
    this.store.delete(Ae), DOM.queueUpdate(() => {
      this.target !== null && this.target.removeProperty(Ae);
    });
  }
  handleChange(Ae, xr) {
    const { sheet: ed } = this.style;
    if (ed) {
      const id = ed.insertRule(":host{}", ed.cssRules.length);
      this.target = ed.cssRules[id].style;
    } else
      this.target = null;
  }
}
__decorate([
  observable
], StyleElementStyleSheetTarget.prototype, "target", void 0);
class ElementStyleSheetTarget {
  constructor(Ae) {
    this.target = Ae.style;
  }
  setProperty(Ae, xr) {
    DOM.queueUpdate(() => this.target.setProperty(Ae, xr));
  }
  removeProperty(Ae) {
    DOM.queueUpdate(() => this.target.removeProperty(Ae));
  }
}
class RootStyleSheetTarget {
  setProperty(Ae, xr) {
    RootStyleSheetTarget.properties[Ae] = xr;
    for (const ed of RootStyleSheetTarget.roots.values())
      PropertyTargetManager.getOrCreate(RootStyleSheetTarget.normalizeRoot(ed)).setProperty(Ae, xr);
  }
  removeProperty(Ae) {
    delete RootStyleSheetTarget.properties[Ae];
    for (const xr of RootStyleSheetTarget.roots.values())
      PropertyTargetManager.getOrCreate(RootStyleSheetTarget.normalizeRoot(xr)).removeProperty(Ae);
  }
  static registerRoot(Ae) {
    const { roots: xr } = RootStyleSheetTarget;
    if (!xr.has(Ae)) {
      xr.add(Ae);
      const ed = PropertyTargetManager.getOrCreate(this.normalizeRoot(Ae));
      for (const id in RootStyleSheetTarget.properties)
        ed.setProperty(id, RootStyleSheetTarget.properties[id]);
    }
  }
  static unregisterRoot(Ae) {
    const { roots: xr } = RootStyleSheetTarget;
    if (xr.has(Ae)) {
      xr.delete(Ae);
      const ed = PropertyTargetManager.getOrCreate(RootStyleSheetTarget.normalizeRoot(Ae));
      for (const id in RootStyleSheetTarget.properties)
        ed.removeProperty(id);
    }
  }
  /**
   * Returns the document when provided the default element,
   * otherwise is a no-op
   * @param root - the root to normalize
   */
  static normalizeRoot(Ae) {
    return Ae === defaultElement ? document : Ae;
  }
}
RootStyleSheetTarget.roots = /* @__PURE__ */ new Set();
RootStyleSheetTarget.properties = {};
const propertyTargetCache = /* @__PURE__ */ new WeakMap(), propertyTargetCtor = DOM.supportsAdoptedStyleSheets ? ConstructableStyleSheetTarget : StyleElementStyleSheetTarget, PropertyTargetManager = Object.freeze({
  getOrCreate(td) {
    if (propertyTargetCache.has(td))
      return propertyTargetCache.get(td);
    let Ae;
    return td === defaultElement ? Ae = new RootStyleSheetTarget() : td instanceof Document ? Ae = DOM.supportsAdoptedStyleSheets ? new DocumentStyleSheetTarget() : new HeadStyleElementStyleSheetTarget() : isFastElement(td) ? Ae = new propertyTargetCtor(td) : Ae = new ElementStyleSheetTarget(td), propertyTargetCache.set(td, Ae), Ae;
  }
});
class DesignTokenImpl extends CSSDirective {
  constructor(Ae) {
    super(), this.subscribers = /* @__PURE__ */ new WeakMap(), this._appliedTo = /* @__PURE__ */ new Set(), this.name = Ae.name, Ae.cssCustomPropertyName !== null && (this.cssCustomProperty = `--${Ae.cssCustomPropertyName}`, this.cssVar = `var(${this.cssCustomProperty})`), this.id = DesignTokenImpl.uniqueId(), DesignTokenImpl.tokensById.set(this.id, this);
  }
  get appliedTo() {
    return [...this._appliedTo];
  }
  static from(Ae) {
    return new DesignTokenImpl({
      name: typeof Ae == "string" ? Ae : Ae.name,
      cssCustomPropertyName: typeof Ae == "string" ? Ae : Ae.cssCustomPropertyName === void 0 ? Ae.name : Ae.cssCustomPropertyName
    });
  }
  static isCSSDesignToken(Ae) {
    return typeof Ae.cssCustomProperty == "string";
  }
  static isDerivedDesignTokenValue(Ae) {
    return typeof Ae == "function";
  }
  /**
   * Gets a token by ID. Returns undefined if the token was not found.
   * @param id - The ID of the token
   * @returns
   */
  static getTokenById(Ae) {
    return DesignTokenImpl.tokensById.get(Ae);
  }
  getOrCreateSubscriberSet(Ae = this) {
    return this.subscribers.get(Ae) || this.subscribers.set(Ae, /* @__PURE__ */ new Set()) && this.subscribers.get(Ae);
  }
  createCSS() {
    return this.cssVar || "";
  }
  getValueFor(Ae) {
    const xr = DesignTokenNode.getOrCreate(Ae).get(this);
    if (xr !== void 0)
      return xr;
    throw new Error(`Value could not be retrieved for token named "${this.name}". Ensure the value is set for ${Ae} or an ancestor of ${Ae}.`);
  }
  setValueFor(Ae, xr) {
    return this._appliedTo.add(Ae), xr instanceof DesignTokenImpl && (xr = this.alias(xr)), DesignTokenNode.getOrCreate(Ae).set(this, xr), this;
  }
  deleteValueFor(Ae) {
    return this._appliedTo.delete(Ae), DesignTokenNode.existsFor(Ae) && DesignTokenNode.getOrCreate(Ae).delete(this), this;
  }
  withDefault(Ae) {
    return this.setValueFor(defaultElement, Ae), this;
  }
  subscribe(Ae, xr) {
    const ed = this.getOrCreateSubscriberSet(xr);
    xr && !DesignTokenNode.existsFor(xr) && DesignTokenNode.getOrCreate(xr), ed.has(Ae) || ed.add(Ae);
  }
  unsubscribe(Ae, xr) {
    const ed = this.subscribers.get(xr || this);
    ed && ed.has(Ae) && ed.delete(Ae);
  }
  /**
   * Notifies subscribers that the value for an element has changed.
   * @param element - The element to emit a notification for
   */
  notify(Ae) {
    const xr = Object.freeze({ token: this, target: Ae });
    this.subscribers.has(this) && this.subscribers.get(this).forEach((ed) => ed.handleChange(xr)), this.subscribers.has(Ae) && this.subscribers.get(Ae).forEach((ed) => ed.handleChange(xr));
  }
  /**
   * Alias the token to the provided token.
   * @param token - the token to alias to
   */
  alias(Ae) {
    return (xr) => Ae.getValueFor(xr);
  }
}
DesignTokenImpl.uniqueId = /* @__PURE__ */ (() => {
  let td = 0;
  return () => (td++, td.toString(16));
})();
DesignTokenImpl.tokensById = /* @__PURE__ */ new Map();
class CustomPropertyReflector {
  startReflection(Ae, xr) {
    Ae.subscribe(this, xr), this.handleChange({ token: Ae, target: xr });
  }
  stopReflection(Ae, xr) {
    Ae.unsubscribe(this, xr), this.remove(Ae, xr);
  }
  handleChange(Ae) {
    const { token: xr, target: ed } = Ae;
    this.add(xr, ed);
  }
  add(Ae, xr) {
    PropertyTargetManager.getOrCreate(xr).setProperty(Ae.cssCustomProperty, this.resolveCSSValue(DesignTokenNode.getOrCreate(xr).get(Ae)));
  }
  remove(Ae, xr) {
    PropertyTargetManager.getOrCreate(xr).removeProperty(Ae.cssCustomProperty);
  }
  resolveCSSValue(Ae) {
    return Ae && typeof Ae.createCSS == "function" ? Ae.createCSS() : Ae;
  }
}
class DesignTokenBindingObserver {
  constructor(Ae, xr, ed) {
    this.source = Ae, this.token = xr, this.node = ed, this.dependencies = /* @__PURE__ */ new Set(), this.observer = Observable.binding(Ae, this, !1), this.observer.handleChange = this.observer.call, this.handleChange();
  }
  disconnect() {
    this.observer.disconnect();
  }
  /**
   * @internal
   */
  handleChange() {
    this.node.store.set(this.token, this.observer.observe(this.node.target, defaultExecutionContext));
  }
}
class Store {
  constructor() {
    this.values = /* @__PURE__ */ new Map();
  }
  set(Ae, xr) {
    this.values.get(Ae) !== xr && (this.values.set(Ae, xr), Observable.getNotifier(this).notify(Ae.id));
  }
  get(Ae) {
    return Observable.track(this, Ae.id), this.values.get(Ae);
  }
  delete(Ae) {
    this.values.delete(Ae);
  }
  all() {
    return this.values.entries();
  }
}
const nodeCache = /* @__PURE__ */ new WeakMap(), childToParent = /* @__PURE__ */ new WeakMap();
class DesignTokenNode {
  constructor(Ae) {
    this.target = Ae, this.store = new Store(), this.children = [], this.assignedValues = /* @__PURE__ */ new Map(), this.reflecting = /* @__PURE__ */ new Set(), this.bindingObservers = /* @__PURE__ */ new Map(), this.tokenValueChangeHandler = {
      handleChange: (xr, ed) => {
        const id = DesignTokenImpl.getTokenById(ed);
        id && (id.notify(this.target), this.updateCSSTokenReflection(xr, id));
      }
    }, nodeCache.set(Ae, this), Observable.getNotifier(this.store).subscribe(this.tokenValueChangeHandler), Ae instanceof FASTElement ? Ae.$fastController.addBehaviors([this]) : Ae.isConnected && this.bind();
  }
  /**
   * Returns a DesignTokenNode for an element.
   * Creates a new instance if one does not already exist for a node,
   * otherwise returns the cached instance
   *
   * @param target - The HTML element to retrieve a DesignTokenNode for
   */
  static getOrCreate(Ae) {
    return nodeCache.get(Ae) || new DesignTokenNode(Ae);
  }
  /**
   * Determines if a DesignTokenNode has been created for a target
   * @param target - The element to test
   */
  static existsFor(Ae) {
    return nodeCache.has(Ae);
  }
  /**
   * Searches for and return the nearest parent DesignTokenNode.
   * Null is returned if no node is found or the node provided is for a default element.
   */
  static findParent(Ae) {
    if (defaultElement !== Ae.target) {
      let xr = composedParent(Ae.target);
      for (; xr !== null; ) {
        if (nodeCache.has(xr))
          return nodeCache.get(xr);
        xr = composedParent(xr);
      }
      return DesignTokenNode.getOrCreate(defaultElement);
    }
    return null;
  }
  /**
   * Finds the closest node with a value explicitly assigned for a token, otherwise null.
   * @param token - The token to look for
   * @param start - The node to start looking for value assignment
   * @returns
   */
  static findClosestAssignedNode(Ae, xr) {
    let ed = xr;
    do {
      if (ed.has(Ae))
        return ed;
      ed = ed.parent ? ed.parent : ed.target !== defaultElement ? DesignTokenNode.getOrCreate(defaultElement) : null;
    } while (ed !== null);
    return null;
  }
  /**
   * The parent DesignTokenNode, or null.
   */
  get parent() {
    return childToParent.get(this) || null;
  }
  updateCSSTokenReflection(Ae, xr) {
    if (DesignTokenImpl.isCSSDesignToken(xr)) {
      const ed = this.parent, id = this.isReflecting(xr);
      if (ed) {
        const od = ed.get(xr), ad = Ae.get(xr);
        od !== ad && !id ? this.reflectToCSS(xr) : od === ad && id && this.stopReflectToCSS(xr);
      } else
        id || this.reflectToCSS(xr);
    }
  }
  /**
   * Checks if a token has been assigned an explicit value the node.
   * @param token - the token to check.
   */
  has(Ae) {
    return this.assignedValues.has(Ae);
  }
  /**
   * Gets the value of a token for a node
   * @param token - The token to retrieve the value for
   * @returns
   */
  get(Ae) {
    const xr = this.store.get(Ae);
    if (xr !== void 0)
      return xr;
    const ed = this.getRaw(Ae);
    if (ed !== void 0)
      return this.hydrate(Ae, ed), this.get(Ae);
  }
  /**
   * Retrieves the raw assigned value of a token from the nearest assigned node.
   * @param token - The token to retrieve a raw value for
   * @returns
   */
  getRaw(Ae) {
    var xr;
    return this.assignedValues.has(Ae) ? this.assignedValues.get(Ae) : (xr = DesignTokenNode.findClosestAssignedNode(Ae, this)) === null || xr === void 0 ? void 0 : xr.getRaw(Ae);
  }
  /**
   * Sets a token to a value for a node
   * @param token - The token to set
   * @param value - The value to set the token to
   */
  set(Ae, xr) {
    DesignTokenImpl.isDerivedDesignTokenValue(this.assignedValues.get(Ae)) && this.tearDownBindingObserver(Ae), this.assignedValues.set(Ae, xr), DesignTokenImpl.isDerivedDesignTokenValue(xr) ? this.setupBindingObserver(Ae, xr) : this.store.set(Ae, xr);
  }
  /**
   * Deletes a token value for the node.
   * @param token - The token to delete the value for
   */
  delete(Ae) {
    this.assignedValues.delete(Ae), this.tearDownBindingObserver(Ae);
    const xr = this.getRaw(Ae);
    xr ? this.hydrate(Ae, xr) : this.store.delete(Ae);
  }
  /**
   * Invoked when the DesignTokenNode.target is attached to the document
   */
  bind() {
    const Ae = DesignTokenNode.findParent(this);
    Ae && Ae.appendChild(this);
    for (const xr of this.assignedValues.keys())
      xr.notify(this.target);
  }
  /**
   * Invoked when the DesignTokenNode.target is detached from the document
   */
  unbind() {
    this.parent && childToParent.get(this).removeChild(this);
  }
  /**
   * Appends a child to a parent DesignTokenNode.
   * @param child - The child to append to the node
   */
  appendChild(Ae) {
    Ae.parent && childToParent.get(Ae).removeChild(Ae);
    const xr = this.children.filter((ed) => Ae.contains(ed));
    childToParent.set(Ae, this), this.children.push(Ae), xr.forEach((ed) => Ae.appendChild(ed)), Observable.getNotifier(this.store).subscribe(Ae);
    for (const [ed, id] of this.store.all())
      Ae.hydrate(ed, this.bindingObservers.has(ed) ? this.getRaw(ed) : id);
  }
  /**
   * Removes a child from a node.
   * @param child - The child to remove.
   */
  removeChild(Ae) {
    const xr = this.children.indexOf(Ae);
    return xr !== -1 && this.children.splice(xr, 1), Observable.getNotifier(this.store).unsubscribe(Ae), Ae.parent === this ? childToParent.delete(Ae) : !1;
  }
  /**
   * Tests whether a provided node is contained by
   * the calling node.
   * @param test - The node to test
   */
  contains(Ae) {
    return composedContains(this.target, Ae.target);
  }
  /**
   * Instructs the node to reflect a design token for the provided token.
   * @param token - The design token to reflect
   */
  reflectToCSS(Ae) {
    this.isReflecting(Ae) || (this.reflecting.add(Ae), DesignTokenNode.cssCustomPropertyReflector.startReflection(Ae, this.target));
  }
  /**
   * Stops reflecting a DesignToken to CSS
   * @param token - The design token to stop reflecting
   */
  stopReflectToCSS(Ae) {
    this.isReflecting(Ae) && (this.reflecting.delete(Ae), DesignTokenNode.cssCustomPropertyReflector.stopReflection(Ae, this.target));
  }
  /**
   * Determines if a token is being reflected to CSS for a node.
   * @param token - The token to check for reflection
   * @returns
   */
  isReflecting(Ae) {
    return this.reflecting.has(Ae);
  }
  /**
   * Handle changes to upstream tokens
   * @param source - The parent DesignTokenNode
   * @param property - The token ID that changed
   */
  handleChange(Ae, xr) {
    const ed = DesignTokenImpl.getTokenById(xr);
    ed && (this.hydrate(ed, this.getRaw(ed)), this.updateCSSTokenReflection(this.store, ed));
  }
  /**
   * Hydrates a token with a DesignTokenValue, making retrieval available.
   * @param token - The token to hydrate
   * @param value - The value to hydrate
   */
  hydrate(Ae, xr) {
    if (!this.has(Ae)) {
      const ed = this.bindingObservers.get(Ae);
      DesignTokenImpl.isDerivedDesignTokenValue(xr) ? ed ? ed.source !== xr && (this.tearDownBindingObserver(Ae), this.setupBindingObserver(Ae, xr)) : this.setupBindingObserver(Ae, xr) : (ed && this.tearDownBindingObserver(Ae), this.store.set(Ae, xr));
    }
  }
  /**
   * Sets up a binding observer for a derived token value that notifies token
   * subscribers on change.
   *
   * @param token - The token to notify when the binding updates
   * @param source - The binding source
   */
  setupBindingObserver(Ae, xr) {
    const ed = new DesignTokenBindingObserver(xr, Ae, this);
    return this.bindingObservers.set(Ae, ed), ed;
  }
  /**
   * Tear down a binding observer for a token.
   */
  tearDownBindingObserver(Ae) {
    return this.bindingObservers.has(Ae) ? (this.bindingObservers.get(Ae).disconnect(), this.bindingObservers.delete(Ae), !0) : !1;
  }
}
DesignTokenNode.cssCustomPropertyReflector = new CustomPropertyReflector();
__decorate([
  observable
], DesignTokenNode.prototype, "children", void 0);
function create$b(td) {
  return DesignTokenImpl.from(td);
}
const DesignToken = Object.freeze({
  create: create$b,
  /**
   * Informs DesignToken that an HTMLElement for which tokens have
   * been set has been connected to the document.
   *
   * The browser does not provide a reliable mechanism to observe an HTMLElement's connectedness
   * in all scenarios, so invoking this method manually is necessary when:
   *
   * 1. Token values are set for an HTMLElement.
   * 2. The HTMLElement does not inherit from FASTElement.
   * 3. The HTMLElement is not connected to the document when token values are set.
   *
   * @param element - The element to notify
   * @returns - true if notification was successful, otherwise false.
   */
  notifyConnection(td) {
    return !td.isConnected || !DesignTokenNode.existsFor(td) ? !1 : (DesignTokenNode.getOrCreate(td).bind(), !0);
  },
  /**
   * Informs DesignToken that an HTMLElement for which tokens have
   * been set has been disconnected to the document.
   *
   * The browser does not provide a reliable mechanism to observe an HTMLElement's connectedness
   * in all scenarios, so invoking this method manually is necessary when:
   *
   * 1. Token values are set for an HTMLElement.
   * 2. The HTMLElement does not inherit from FASTElement.
   *
   * @param element - The element to notify
   * @returns - true if notification was successful, otherwise false.
   */
  notifyDisconnection(td) {
    return td.isConnected || !DesignTokenNode.existsFor(td) ? !1 : (DesignTokenNode.getOrCreate(td).unbind(), !0);
  },
  /**
   * Registers and element or document as a DesignToken root.
   * {@link CSSDesignToken | CSSDesignTokens} with default values assigned via
   * {@link (DesignToken:interface).withDefault} will emit CSS custom properties to all
   * registered roots.
   * @param target - The root to register
   */
  registerRoot(td = defaultElement) {
    RootStyleSheetTarget.registerRoot(td);
  },
  /**
   * Unregister an element or document as a DesignToken root.
   * @param target - The root to deregister
   */
  unregisterRoot(td = defaultElement) {
    RootStyleSheetTarget.unregisterRoot(td);
  }
}), ElementDisambiguation = Object.freeze({
  /**
   * Skip defining the element but still call the provided callback passed
   * to DesignSystemRegistrationContext.tryDefineElement
   */
  definitionCallbackOnly: null,
  /**
   * Ignore the duplicate element entirely.
   */
  ignoreDuplicate: Symbol()
}), elementTypesByTag = /* @__PURE__ */ new Map(), elementTagsByType = /* @__PURE__ */ new Map();
let rootDesignSystem = null;
const designSystemKey = DI.createInterface((td) => td.cachedCallback((Ae) => (rootDesignSystem === null && (rootDesignSystem = new DefaultDesignSystem(null, Ae)), rootDesignSystem))), DesignSystem = Object.freeze({
  /**
   * Returns the HTML element name that the type is defined as.
   * @param type - The type to lookup.
   * @public
   */
  tagFor(td) {
    return elementTagsByType.get(td);
  },
  /**
   * Searches the DOM hierarchy for the design system that is responsible
   * for the provided element.
   * @param element - The element to locate the design system for.
   * @returns The located design system.
   * @public
   */
  responsibleFor(td) {
    const Ae = td.$$designSystem$$;
    return Ae || DI.findResponsibleContainer(td).get(designSystemKey);
  },
  /**
   * Gets the DesignSystem if one is explicitly defined on the provided element;
   * otherwise creates a design system defined directly on the element.
   * @param element - The element to get or create a design system for.
   * @returns The design system.
   * @public
   */
  getOrCreate(td) {
    if (!td)
      return rootDesignSystem === null && (rootDesignSystem = DI.getOrCreateDOMContainer().get(designSystemKey)), rootDesignSystem;
    const Ae = td.$$designSystem$$;
    if (Ae)
      return Ae;
    const xr = DI.getOrCreateDOMContainer(td);
    if (xr.has(designSystemKey, !1))
      return xr.get(designSystemKey);
    {
      const ed = new DefaultDesignSystem(td, xr);
      return xr.register(Registration.instance(designSystemKey, ed)), ed;
    }
  }
});
function extractTryDefineElementParams(td, Ae, xr) {
  return typeof td == "string" ? {
    name: td,
    type: Ae,
    callback: xr
  } : td;
}
class DefaultDesignSystem {
  constructor(Ae, xr) {
    this.owner = Ae, this.container = xr, this.designTokensInitialized = !1, this.prefix = "fast", this.shadowRootMode = void 0, this.disambiguate = () => ElementDisambiguation.definitionCallbackOnly, Ae !== null && (Ae.$$designSystem$$ = this);
  }
  withPrefix(Ae) {
    return this.prefix = Ae, this;
  }
  withShadowRootMode(Ae) {
    return this.shadowRootMode = Ae, this;
  }
  withElementDisambiguation(Ae) {
    return this.disambiguate = Ae, this;
  }
  withDesignTokenRoot(Ae) {
    return this.designTokenRoot = Ae, this;
  }
  register(...Ae) {
    const xr = this.container, ed = [], id = this.disambiguate, od = this.shadowRootMode, ad = {
      elementPrefix: this.prefix,
      tryDefineElement(rd, sd, nd) {
        const cd = extractTryDefineElementParams(rd, sd, nd), { name: ud, callback: ld, baseClass: dd } = cd;
        let { type: pd } = cd, md = ud, fd = elementTypesByTag.get(md), bd = !0;
        for (; fd; ) {
          const Sd = id(md, pd, fd);
          switch (Sd) {
            case ElementDisambiguation.ignoreDuplicate:
              return;
            case ElementDisambiguation.definitionCallbackOnly:
              bd = !1, fd = void 0;
              break;
            default:
              md = Sd, fd = elementTypesByTag.get(md);
              break;
          }
        }
        bd && ((elementTagsByType.has(pd) || pd === FoundationElement) && (pd = class extends pd {
        }), elementTypesByTag.set(md, pd), elementTagsByType.set(pd, md), dd && elementTagsByType.set(dd, md)), ed.push(new ElementDefinitionEntry(xr, md, pd, od, ld, bd));
      }
    };
    this.designTokensInitialized || (this.designTokensInitialized = !0, this.designTokenRoot !== null && DesignToken.registerRoot(this.designTokenRoot)), xr.registerWithContext(ad, ...Ae);
    for (const rd of ed)
      rd.callback(rd), rd.willDefine && rd.definition !== null && rd.definition.define();
    return this;
  }
}
class ElementDefinitionEntry {
  constructor(Ae, xr, ed, id, od, ad) {
    this.container = Ae, this.name = xr, this.type = ed, this.shadowRootMode = id, this.callback = od, this.willDefine = ad, this.definition = null;
  }
  definePresentation(Ae) {
    ComponentPresentation.define(this.name, Ae, this.container);
  }
  defineElement(Ae) {
    this.definition = new FASTElementDefinition(this.type, Object.assign(Object.assign({}, Ae), { name: this.name }));
  }
  tagFor(Ae) {
    return DesignSystem.tagFor(Ae);
  }
}
const dialogTemplate = (td, Ae) => html`
    <div class="positioning-region" part="positioning-region">
        ${when((xr) => xr.modal, html`
                <div
                    class="overlay"
                    part="overlay"
                    role="presentation"
                    @click="${(xr) => xr.dismiss()}"
                ></div>
            `)}
        <div
            role="dialog"
            tabindex="-1"
            class="control"
            part="control"
            aria-modal="${(xr) => xr.modal}"
            aria-describedby="${(xr) => xr.ariaDescribedby}"
            aria-labelledby="${(xr) => xr.ariaLabelledby}"
            aria-label="${(xr) => xr.ariaLabel}"
            ${ref("dialog")}
        >
            <slot></slot>
        </div>
    </div>
`;
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], candidateSelector = /* @__PURE__ */ candidateSelectors.join(","), NoElement = typeof Element == "undefined", matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, getRootNode = !NoElement && Element.prototype.getRootNode ? function(td) {
  return td.getRootNode();
} : function(td) {
  return td.ownerDocument;
}, getTabindex = function(Ae, xr) {
  return Ae.tabIndex < 0 && (xr || /^(AUDIO|VIDEO|DETAILS)$/.test(Ae.tagName) || Ae.isContentEditable) && isNaN(parseInt(Ae.getAttribute("tabindex"), 10)) ? 0 : Ae.tabIndex;
}, isInput = function(Ae) {
  return Ae.tagName === "INPUT";
}, isHiddenInput = function(Ae) {
  return isInput(Ae) && Ae.type === "hidden";
}, isDetailsWithSummary = function(Ae) {
  var xr = Ae.tagName === "DETAILS" && Array.prototype.slice.apply(Ae.children).some(function(ed) {
    return ed.tagName === "SUMMARY";
  });
  return xr;
}, getCheckedRadio = function(Ae, xr) {
  for (var ed = 0; ed < Ae.length; ed++)
    if (Ae[ed].checked && Ae[ed].form === xr)
      return Ae[ed];
}, isTabbableRadio = function(Ae) {
  if (!Ae.name)
    return !0;
  var xr = Ae.form || getRootNode(Ae), ed = function(rd) {
    return xr.querySelectorAll('input[type="radio"][name="' + rd + '"]');
  }, id;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    id = ed(window.CSS.escape(Ae.name));
  else
    try {
      id = ed(Ae.name);
    } catch (ad) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", ad.message), !1;
    }
  var od = getCheckedRadio(id, Ae.form);
  return !od || od === Ae;
}, isRadio = function(Ae) {
  return isInput(Ae) && Ae.type === "radio";
}, isNonTabbableRadio = function(Ae) {
  return isRadio(Ae) && !isTabbableRadio(Ae);
}, isZeroArea = function(Ae) {
  var xr = Ae.getBoundingClientRect(), ed = xr.width, id = xr.height;
  return ed === 0 && id === 0;
}, isHidden = function(Ae, xr) {
  var ed = xr.displayCheck, id = xr.getShadowRoot;
  if (getComputedStyle(Ae).visibility === "hidden")
    return !0;
  var od = matches.call(Ae, "details>summary:first-of-type"), ad = od ? Ae.parentElement : Ae;
  if (matches.call(ad, "details:not([open]) *"))
    return !0;
  var rd = getRootNode(Ae).host, sd = (rd == null ? void 0 : rd.ownerDocument.contains(rd)) || Ae.ownerDocument.contains(Ae);
  if (!ed || ed === "full") {
    if (typeof id == "function") {
      for (var nd = Ae; Ae; ) {
        var cd = Ae.parentElement, ud = getRootNode(Ae);
        if (cd && !cd.shadowRoot && id(cd) === !0)
          return isZeroArea(Ae);
        Ae.assignedSlot ? Ae = Ae.assignedSlot : !cd && ud !== Ae.ownerDocument ? Ae = ud.host : Ae = cd;
      }
      Ae = nd;
    }
    if (sd)
      return !Ae.getClientRects().length;
  } else if (ed === "non-zero-area")
    return isZeroArea(Ae);
  return !1;
}, isDisabledFromFieldset = function(Ae) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(Ae.tagName))
    for (var xr = Ae.parentElement; xr; ) {
      if (xr.tagName === "FIELDSET" && xr.disabled) {
        for (var ed = 0; ed < xr.children.length; ed++) {
          var id = xr.children.item(ed);
          if (id.tagName === "LEGEND")
            return matches.call(xr, "fieldset[disabled] *") ? !0 : !id.contains(Ae);
        }
        return !0;
      }
      xr = xr.parentElement;
    }
  return !1;
}, isNodeMatchingSelectorFocusable = function(Ae, xr) {
  return !(xr.disabled || isHiddenInput(xr) || isHidden(xr, Ae) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(xr) || isDisabledFromFieldset(xr));
}, isNodeMatchingSelectorTabbable = function(Ae, xr) {
  return !(isNonTabbableRadio(xr) || getTabindex(xr) < 0 || !isNodeMatchingSelectorFocusable(Ae, xr));
}, isTabbable = function(Ae, xr) {
  if (xr = xr || {}, !Ae)
    throw new Error("No node provided");
  return matches.call(Ae, candidateSelector) === !1 ? !1 : isNodeMatchingSelectorTabbable(xr, Ae);
}, focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(","), isFocusable = function(Ae, xr) {
  if (xr = xr || {}, !Ae)
    throw new Error("No node provided");
  return matches.call(Ae, focusableCandidateSelector) === !1 ? !1 : isNodeMatchingSelectorFocusable(xr, Ae);
};
let Dialog$1 = class Np extends FoundationElement {
  constructor() {
    super(...arguments), this.modal = !0, this.hidden = !1, this.trapFocus = !0, this.trapFocusChanged = () => {
      this.$fastController.isConnected && this.updateTrapFocus();
    }, this.isTrappingFocus = !1, this.handleDocumentKeydown = (Ae) => {
      if (!Ae.defaultPrevented && !this.hidden)
        switch (Ae.key) {
          case keyEscape$1:
            this.dismiss(), Ae.preventDefault();
            break;
          case keyTab$1:
            this.handleTabKeyDown(Ae);
            break;
        }
    }, this.handleDocumentFocus = (Ae) => {
      !Ae.defaultPrevented && this.shouldForceFocus(Ae.target) && (this.focusFirstElement(), Ae.preventDefault());
    }, this.handleTabKeyDown = (Ae) => {
      if (!this.trapFocus || this.hidden)
        return;
      const xr = this.getTabQueueBounds();
      if (xr.length !== 0) {
        if (xr.length === 1) {
          xr[0].focus(), Ae.preventDefault();
          return;
        }
        Ae.shiftKey && Ae.target === xr[0] ? (xr[xr.length - 1].focus(), Ae.preventDefault()) : !Ae.shiftKey && Ae.target === xr[xr.length - 1] && (xr[0].focus(), Ae.preventDefault());
      }
    }, this.getTabQueueBounds = () => {
      const Ae = [];
      return Np.reduceTabbableItems(Ae, this);
    }, this.focusFirstElement = () => {
      const Ae = this.getTabQueueBounds();
      Ae.length > 0 ? Ae[0].focus() : this.dialog instanceof HTMLElement && this.dialog.focus();
    }, this.shouldForceFocus = (Ae) => this.isTrappingFocus && !this.contains(Ae), this.shouldTrapFocus = () => this.trapFocus && !this.hidden, this.updateTrapFocus = (Ae) => {
      const xr = Ae === void 0 ? this.shouldTrapFocus() : Ae;
      xr && !this.isTrappingFocus ? (this.isTrappingFocus = !0, document.addEventListener("focusin", this.handleDocumentFocus), DOM.queueUpdate(() => {
        this.shouldForceFocus(document.activeElement) && this.focusFirstElement();
      })) : !xr && this.isTrappingFocus && (this.isTrappingFocus = !1, document.removeEventListener("focusin", this.handleDocumentFocus));
    };
  }
  /**
   * @internal
   */
  dismiss() {
    this.$emit("dismiss"), this.$emit("cancel");
  }
  /**
   * The method to show the dialog.
   *
   * @public
   */
  show() {
    this.hidden = !1;
  }
  /**
   * The method to hide the dialog.
   *
   * @public
   */
  hide() {
    this.hidden = !0, this.$emit("close");
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("keydown", this.handleDocumentKeydown), this.notifier = Observable.getNotifier(this), this.notifier.subscribe(this, "hidden"), this.updateTrapFocus();
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("keydown", this.handleDocumentKeydown), this.updateTrapFocus(!1), this.notifier.unsubscribe(this, "hidden");
  }
  /**
   * @internal
   */
  handleChange(Ae, xr) {
    switch (xr) {
      case "hidden":
        this.updateTrapFocus();
        break;
    }
  }
  /**
   * Reduce a collection to only its focusable elements.
   *
   * @param elements - Collection of elements to reduce
   * @param element - The current element
   *
   * @internal
   */
  static reduceTabbableItems(Ae, xr) {
    return xr.getAttribute("tabindex") === "-1" ? Ae : isTabbable(xr) || Np.isFocusableFastElement(xr) && Np.hasTabbableShadow(xr) ? (Ae.push(xr), Ae) : xr.childElementCount ? Ae.concat(Array.from(xr.children).reduce(Np.reduceTabbableItems, [])) : Ae;
  }
  /**
   * Test if element is focusable fast element
   *
   * @param element - The element to check
   *
   * @internal
   */
  static isFocusableFastElement(Ae) {
    var xr, ed;
    return !!(!((ed = (xr = Ae.$fastController) === null || xr === void 0 ? void 0 : xr.definition.shadowOptions) === null || ed === void 0) && ed.delegatesFocus);
  }
  /**
   * Test if the element has a focusable shadow
   *
   * @param element - The element to check
   *
   * @internal
   */
  static hasTabbableShadow(Ae) {
    var xr, ed;
    return Array.from((ed = (xr = Ae.shadowRoot) === null || xr === void 0 ? void 0 : xr.querySelectorAll("*")) !== null && ed !== void 0 ? ed : []).some((id) => isTabbable(id));
  }
};
__decorate([
  attr({ mode: "boolean" })
], Dialog$1.prototype, "modal", void 0);
__decorate([
  attr({ mode: "boolean" })
], Dialog$1.prototype, "hidden", void 0);
__decorate([
  attr({ attribute: "trap-focus", mode: "boolean" })
], Dialog$1.prototype, "trapFocus", void 0);
__decorate([
  attr({ attribute: "aria-describedby" })
], Dialog$1.prototype, "ariaDescribedby", void 0);
__decorate([
  attr({ attribute: "aria-labelledby" })
], Dialog$1.prototype, "ariaLabelledby", void 0);
__decorate([
  attr({ attribute: "aria-label" })
], Dialog$1.prototype, "ariaLabel", void 0);
const observer = new MutationObserver((td) => {
  for (const Ae of td)
    AttributeReflectionSubscriptionSet.getOrCreateFor(Ae.target).notify(Ae.attributeName);
});
class AttributeReflectionSubscriptionSet extends SubscriberSet {
  constructor(Ae) {
    super(Ae), this.watchedAttributes = /* @__PURE__ */ new Set(), AttributeReflectionSubscriptionSet.subscriberCache.set(Ae, this);
  }
  subscribe(Ae) {
    super.subscribe(Ae), this.watchedAttributes.has(Ae.attributes) || (this.watchedAttributes.add(Ae.attributes), this.observe());
  }
  unsubscribe(Ae) {
    super.unsubscribe(Ae), this.watchedAttributes.has(Ae.attributes) && (this.watchedAttributes.delete(Ae.attributes), this.observe());
  }
  static getOrCreateFor(Ae) {
    return this.subscriberCache.get(Ae) || new AttributeReflectionSubscriptionSet(Ae);
  }
  observe() {
    const Ae = [];
    for (const xr of this.watchedAttributes.values())
      for (let ed = 0; ed < xr.length; ed++)
        Ae.push(xr[ed]);
    observer.observe(this.source, { attributeFilter: Ae });
  }
}
AttributeReflectionSubscriptionSet.subscriberCache = /* @__PURE__ */ new WeakMap();
class ReflectAttrBehavior {
  constructor(Ae, xr) {
    this.target = Ae, this.attributes = Object.freeze(xr);
  }
  bind(Ae) {
    if (AttributeReflectionSubscriptionSet.getOrCreateFor(Ae).subscribe(this), Ae.hasAttributes())
      for (let xr = 0; xr < Ae.attributes.length; xr++)
        this.handleChange(Ae, Ae.attributes[xr].name);
  }
  unbind(Ae) {
    AttributeReflectionSubscriptionSet.getOrCreateFor(Ae).unsubscribe(this);
  }
  handleChange(Ae, xr) {
    this.attributes.includes(xr) && DOM.setAttribute(this.target, xr, Ae.getAttribute(xr));
  }
}
function reflectAttributes(...td) {
  return new AttachedBehaviorHTMLDirective("fast-reflect-attr", ReflectAttrBehavior, td);
}
const disclosureTemplate = (td, Ae) => html`
    <details class="disclosure" ${ref("details")}>
        <summary
            class="invoker"
            role="button"
            aria-controls="disclosure-content"
            aria-expanded="${(xr) => xr.expanded}"
        >
            <slot name="start"></slot>
            <slot name="title">${(xr) => xr.title}</slot>
            <slot name="end"></slot>
        </summary>
        <div id="disclosure-content"><slot></slot></div>
    </details>
`;
let Disclosure$1 = class extends FoundationElement {
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.setup();
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.details.removeEventListener("toggle", this.onToggle);
  }
  /**
   * Show extra content.
   */
  show() {
    this.details.open = !0;
  }
  /**
   * Hide extra content.
   */
  hide() {
    this.details.open = !1;
  }
  /**
   * Toggle the current(expanded/collapsed) state.
   */
  toggle() {
    this.details.open = !this.details.open;
  }
  /**
   * Register listener and set default disclosure mode
   */
  setup() {
    this.onToggle = this.onToggle.bind(this), this.details.addEventListener("toggle", this.onToggle), this.expanded && this.show();
  }
  /**
   * Update the aria attr and fire `toggle` event
   */
  onToggle() {
    this.expanded = this.details.open, this.$emit("toggle");
  }
};
__decorate([
  attr({ mode: "boolean" })
], Disclosure$1.prototype, "expanded", void 0);
__decorate([
  attr
], Disclosure$1.prototype, "title", void 0);
const dividerTemplate = (td, Ae) => html`
    <template role="${(xr) => xr.role}" aria-orientation="${(xr) => xr.orientation}"></template>
`, DividerRole = {
  /**
   * The divider semantically separates content
   */
  separator: "separator",
  /**
   * The divider has no semantic value and is for visual presentation only.
   */
  presentation: "presentation"
};
let Divider$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.role = DividerRole.separator, this.orientation = Orientation$1.horizontal;
  }
};
__decorate([
  attr
], Divider$1.prototype, "role", void 0);
__decorate([
  attr
], Divider$1.prototype, "orientation", void 0);
const FlipperDirection = {
  next: "next",
  previous: "previous"
}, flipperTemplate = (td, Ae) => html`
    <template
        role="button"
        aria-disabled="${(xr) => xr.disabled ? !0 : void 0}"
        tabindex="${(xr) => xr.hiddenFromAT ? -1 : 0}"
        class="${(xr) => xr.direction} ${(xr) => xr.disabled ? "disabled" : ""}"
        @keyup="${(xr, ed) => xr.keyupHandler(ed.event)}"
    >
        ${when((xr) => xr.direction === FlipperDirection.next, html`
                <span part="next" class="next">
                    <slot name="next">
                        ${Ae.next || ""}
                    </slot>
                </span>
            `)}
        ${when((xr) => xr.direction === FlipperDirection.previous, html`
                <span part="previous" class="previous">
                    <slot name="previous">
                        ${Ae.previous || ""}
                    </slot>
                </span>
            `)}
    </template>
`;
class Flipper extends FoundationElement {
  constructor() {
    super(...arguments), this.hiddenFromAT = !0, this.direction = FlipperDirection.next;
  }
  /**
   * Simulate a click event when the flipper has focus and the user hits enter or space keys
   * Blur focus if the user hits escape key
   * @param e - Keyboard event
   * @public
   */
  keyupHandler(Ae) {
    if (!this.hiddenFromAT) {
      const xr = Ae.key;
      (xr === "Enter" || xr === "Space") && this.$emit("click", Ae), xr === "Escape" && this.blur();
    }
  }
}
__decorate([
  attr({ mode: "boolean" })
], Flipper.prototype, "disabled", void 0);
__decorate([
  attr({ attribute: "aria-hidden", converter: booleanConverter })
], Flipper.prototype, "hiddenFromAT", void 0);
__decorate([
  attr
], Flipper.prototype, "direction", void 0);
const listboxOptionTemplate = (td, Ae) => html`
    <template
        aria-checked="${(xr) => xr.ariaChecked}"
        aria-disabled="${(xr) => xr.ariaDisabled}"
        aria-posinset="${(xr) => xr.ariaPosInSet}"
        aria-selected="${(xr) => xr.ariaSelected}"
        aria-setsize="${(xr) => xr.ariaSetSize}"
        class="${(xr) => [xr.checked && "checked", xr.selected && "selected", xr.disabled && "disabled"].filter(Boolean).join(" ")}"
        role="option"
    >
        ${startSlotTemplate(td, Ae)}
        <span class="content" part="content">
            <slot ${slotted("content")}></slot>
        </span>
        ${endSlotTemplate(td, Ae)}
    </template>
`;
class ListboxElement extends Listbox$1 {
  constructor() {
    super(...arguments), this.activeIndex = -1, this.rangeStartIndex = -1;
  }
  /**
   * Returns the last checked option.
   *
   * @internal
   */
  get activeOption() {
    return this.options[this.activeIndex];
  }
  /**
   * Returns the list of checked options.
   *
   * @internal
   */
  get checkedOptions() {
    var Ae;
    return (Ae = this.options) === null || Ae === void 0 ? void 0 : Ae.filter((xr) => xr.checked);
  }
  /**
   * Returns the index of the first selected option.
   *
   * @internal
   */
  get firstSelectedOptionIndex() {
    return this.options.indexOf(this.firstSelectedOption);
  }
  /**
   * Updates the `ariaActiveDescendant` property when the active index changes.
   *
   * @param prev - the previous active index
   * @param next - the next active index
   *
   * @internal
   */
  activeIndexChanged(Ae, xr) {
    var ed, id;
    this.ariaActiveDescendant = (id = (ed = this.options[xr]) === null || ed === void 0 ? void 0 : ed.id) !== null && id !== void 0 ? id : "", this.focusAndScrollOptionIntoView();
  }
  /**
   * Toggles the checked state for the currently active option.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @internal
   */
  checkActiveIndex() {
    if (!this.multiple)
      return;
    const Ae = this.activeOption;
    Ae && (Ae.checked = !0);
  }
  /**
   * Sets the active index to the first option and marks it as checked.
   *
   * @remarks
   * Multi-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkFirstOption(Ae = !1) {
    Ae ? (this.rangeStartIndex === -1 && (this.rangeStartIndex = this.activeIndex + 1), this.options.forEach((xr, ed) => {
      xr.checked = inRange$1(ed, this.rangeStartIndex);
    })) : this.uncheckAllOptions(), this.activeIndex = 0, this.checkActiveIndex();
  }
  /**
   * Decrements the active index and sets the matching option as checked.
   *
   * @remarks
   * Multi-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkLastOption(Ae = !1) {
    Ae ? (this.rangeStartIndex === -1 && (this.rangeStartIndex = this.activeIndex), this.options.forEach((xr, ed) => {
      xr.checked = inRange$1(ed, this.rangeStartIndex, this.options.length);
    })) : this.uncheckAllOptions(), this.activeIndex = this.options.length - 1, this.checkActiveIndex();
  }
  /**
   * @override
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("focusout", this.focusoutHandler);
  }
  /**
   * @override
   * @internal
   */
  disconnectedCallback() {
    this.removeEventListener("focusout", this.focusoutHandler), super.disconnectedCallback();
  }
  /**
   * Increments the active index and marks the matching option as checked.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkNextOption(Ae = !1) {
    Ae ? (this.rangeStartIndex === -1 && (this.rangeStartIndex = this.activeIndex), this.options.forEach((xr, ed) => {
      xr.checked = inRange$1(ed, this.rangeStartIndex, this.activeIndex + 1);
    })) : this.uncheckAllOptions(), this.activeIndex += this.activeIndex < this.options.length - 1 ? 1 : 0, this.checkActiveIndex();
  }
  /**
   * Decrements the active index and marks the matching option as checked.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkPreviousOption(Ae = !1) {
    Ae ? (this.rangeStartIndex === -1 && (this.rangeStartIndex = this.activeIndex), this.checkedOptions.length === 1 && (this.rangeStartIndex += 1), this.options.forEach((xr, ed) => {
      xr.checked = inRange$1(ed, this.activeIndex, this.rangeStartIndex);
    })) : this.uncheckAllOptions(), this.activeIndex -= this.activeIndex > 0 ? 1 : 0, this.checkActiveIndex();
  }
  /**
   * Handles click events for listbox options.
   *
   * @param e - the event object
   *
   * @override
   * @internal
   */
  clickHandler(Ae) {
    var xr;
    if (!this.multiple)
      return super.clickHandler(Ae);
    const ed = (xr = Ae.target) === null || xr === void 0 ? void 0 : xr.closest("[role=option]");
    if (!(!ed || ed.disabled))
      return this.uncheckAllOptions(), this.activeIndex = this.options.indexOf(ed), this.checkActiveIndex(), this.toggleSelectedForAllCheckedOptions(), !0;
  }
  /**
   * @override
   * @internal
   */
  focusAndScrollOptionIntoView() {
    super.focusAndScrollOptionIntoView(this.activeOption);
  }
  /**
   * In multiple-selection mode:
   * If any options are selected, the first selected option is checked when
   * the listbox receives focus. If no options are selected, the first
   * selectable option is checked.
   *
   * @override
   * @internal
   */
  focusinHandler(Ae) {
    if (!this.multiple)
      return super.focusinHandler(Ae);
    !this.shouldSkipFocus && Ae.target === Ae.currentTarget && (this.uncheckAllOptions(), this.activeIndex === -1 && (this.activeIndex = this.firstSelectedOptionIndex !== -1 ? this.firstSelectedOptionIndex : 0), this.checkActiveIndex(), this.setSelectedOptions(), this.focusAndScrollOptionIntoView()), this.shouldSkipFocus = !1;
  }
  /**
   * Unchecks all options when the listbox loses focus.
   *
   * @internal
   */
  focusoutHandler(Ae) {
    this.multiple && this.uncheckAllOptions();
  }
  /**
   * Handles keydown actions for listbox navigation and typeahead
   *
   * @override
   * @internal
   */
  keydownHandler(Ae) {
    if (!this.multiple)
      return super.keydownHandler(Ae);
    if (this.disabled)
      return !0;
    const { key: xr, shiftKey: ed } = Ae;
    switch (this.shouldSkipFocus = !1, xr) {
      case keyHome$1: {
        this.checkFirstOption(ed);
        return;
      }
      case keyArrowDown$1: {
        this.checkNextOption(ed);
        return;
      }
      case keyArrowUp$1: {
        this.checkPreviousOption(ed);
        return;
      }
      case keyEnd$1: {
        this.checkLastOption(ed);
        return;
      }
      case keyTab$1:
        return this.focusAndScrollOptionIntoView(), !0;
      case keyEscape$1:
        return this.uncheckAllOptions(), this.checkActiveIndex(), !0;
      case keySpace$1:
        if (Ae.preventDefault(), this.typeAheadExpired) {
          this.toggleSelectedForAllCheckedOptions();
          return;
        }
      default:
        return xr.length === 1 && this.handleTypeAhead(`${xr}`), !0;
    }
  }
  /**
   * Prevents `focusin` events from firing before `click` events when the
   * element is unfocused.
   *
   * @override
   * @internal
   */
  mousedownHandler(Ae) {
    if (Ae.offsetX >= 0 && Ae.offsetX <= this.scrollWidth)
      return super.mousedownHandler(Ae);
  }
  /**
   * Switches between single-selection and multi-selection mode.
   *
   * @internal
   */
  multipleChanged(Ae, xr) {
    var ed;
    this.ariaMultiSelectable = xr ? "true" : null, (ed = this.options) === null || ed === void 0 || ed.forEach((id) => {
      id.checked = xr ? !1 : void 0;
    }), this.setSelectedOptions();
  }
  /**
   * Sets an option as selected and gives it focus.
   *
   * @override
   * @public
   */
  setSelectedOptions() {
    if (!this.multiple) {
      super.setSelectedOptions();
      return;
    }
    this.$fastController.isConnected && this.options && (this.selectedOptions = this.options.filter((Ae) => Ae.selected), this.focusAndScrollOptionIntoView());
  }
  /**
   * Ensures the size is a positive integer when the property is updated.
   *
   * @param prev - the previous size value
   * @param next - the current size value
   *
   * @internal
   */
  sizeChanged(Ae, xr) {
    var ed;
    const id = Math.max(0, parseInt((ed = xr == null ? void 0 : xr.toFixed()) !== null && ed !== void 0 ? ed : "", 10));
    id !== xr && DOM.queueUpdate(() => {
      this.size = id;
    });
  }
  /**
   * Toggles the selected state of the provided options. If any provided items
   * are in an unselected state, all items are set to selected. If every
   * provided item is selected, they are all unselected.
   *
   * @internal
   */
  toggleSelectedForAllCheckedOptions() {
    const Ae = this.checkedOptions.filter((ed) => !ed.disabled), xr = !Ae.every((ed) => ed.selected);
    Ae.forEach((ed) => ed.selected = xr), this.selectedIndex = this.options.indexOf(Ae[Ae.length - 1]), this.setSelectedOptions();
  }
  /**
   * @override
   * @internal
   */
  typeaheadBufferChanged(Ae, xr) {
    if (!this.multiple) {
      super.typeaheadBufferChanged(Ae, xr);
      return;
    }
    if (this.$fastController.isConnected) {
      const ed = this.getTypeaheadMatches(), id = this.options.indexOf(ed[0]);
      id > -1 && (this.activeIndex = id, this.uncheckAllOptions(), this.checkActiveIndex()), this.typeAheadExpired = !1;
    }
  }
  /**
   * Unchecks all options.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @param preserveChecked - reset the rangeStartIndex
   *
   * @internal
   */
  uncheckAllOptions(Ae = !1) {
    this.options.forEach((xr) => xr.checked = this.multiple ? !1 : void 0), Ae || (this.rangeStartIndex = -1);
  }
}
__decorate([
  observable
], ListboxElement.prototype, "activeIndex", void 0);
__decorate([
  attr({ mode: "boolean" })
], ListboxElement.prototype, "multiple", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], ListboxElement.prototype, "size", void 0);
const listboxTemplate = (td, Ae) => html`
    <template
        aria-activedescendant="${(xr) => xr.ariaActiveDescendant}"
        aria-multiselectable="${(xr) => xr.ariaMultiSelectable}"
        class="listbox"
        role="listbox"
        tabindex="${(xr) => xr.disabled ? null : "0"}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
        @focusin="${(xr, ed) => xr.focusinHandler(ed.event)}"
        @keydown="${(xr, ed) => xr.keydownHandler(ed.event)}"
        @mousedown="${(xr, ed) => xr.mousedownHandler(ed.event)}"
    >
        <slot
            ${slotted({
  filter: ListboxElement.slottedOptionFilter,
  flatten: !0,
  property: "slottedOptions"
})}
        ></slot>
    </template>
`;
class PickerMenu extends FoundationElement {
  constructor() {
    super(...arguments), this.optionElements = [];
  }
  menuElementsChanged() {
    this.updateOptions();
  }
  headerElementsChanged() {
    this.updateOptions();
  }
  footerElementsChanged() {
    this.updateOptions();
  }
  updateOptions() {
    this.optionElements.splice(0, this.optionElements.length), this.addSlottedListItems(this.headerElements), this.addSlottedListItems(this.menuElements), this.addSlottedListItems(this.footerElements), this.$emit("optionsupdated", { bubbles: !1 });
  }
  addSlottedListItems(Ae) {
    Ae !== void 0 && Ae.forEach((xr) => {
      xr.nodeType === 1 && xr.getAttribute("role") === "listitem" && (xr.id = xr.id || uniqueId$1("option-"), this.optionElements.push(xr));
    });
  }
}
__decorate([
  observable
], PickerMenu.prototype, "menuElements", void 0);
__decorate([
  observable
], PickerMenu.prototype, "headerElements", void 0);
__decorate([
  observable
], PickerMenu.prototype, "footerElements", void 0);
__decorate([
  observable
], PickerMenu.prototype, "suggestionsAvailableText", void 0);
const defaultContentsTemplate$1 = html`
    <template>
        ${(td) => td.value}
    </template>
`;
class PickerMenuOption extends FoundationElement {
  contentsTemplateChanged() {
    this.$fastController.isConnected && this.updateView();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.updateView();
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.disconnectView();
  }
  handleClick(Ae) {
    return Ae.defaultPrevented || this.handleInvoked(), !1;
  }
  handleInvoked() {
    this.$emit("pickeroptioninvoked");
  }
  updateView() {
    var Ae, xr;
    this.disconnectView(), this.customView = (xr = (Ae = this.contentsTemplate) === null || Ae === void 0 ? void 0 : Ae.render(this, this)) !== null && xr !== void 0 ? xr : defaultContentsTemplate$1.render(this, this);
  }
  disconnectView() {
    var Ae;
    (Ae = this.customView) === null || Ae === void 0 || Ae.dispose(), this.customView = void 0;
  }
}
__decorate([
  attr({ attribute: "value" })
], PickerMenuOption.prototype, "value", void 0);
__decorate([
  observable
], PickerMenuOption.prototype, "contentsTemplate", void 0);
class PickerList extends FoundationElement {
}
const defaultContentsTemplate = html`
    <template>
        ${(td) => td.value}
    </template>
`;
class PickerListItem extends FoundationElement {
  contentsTemplateChanged() {
    this.$fastController.isConnected && this.updateView();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.updateView();
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    this.disconnectView(), super.disconnectedCallback();
  }
  handleKeyDown(Ae) {
    return Ae.defaultPrevented ? !1 : Ae.key === keyEnter$1 ? (this.handleInvoke(), !1) : !0;
  }
  handleClick(Ae) {
    return Ae.defaultPrevented || this.handleInvoke(), !1;
  }
  handleInvoke() {
    this.$emit("pickeriteminvoked");
  }
  updateView() {
    var Ae, xr;
    this.disconnectView(), this.customView = (xr = (Ae = this.contentsTemplate) === null || Ae === void 0 ? void 0 : Ae.render(this, this)) !== null && xr !== void 0 ? xr : defaultContentsTemplate.render(this, this);
  }
  disconnectView() {
    var Ae;
    (Ae = this.customView) === null || Ae === void 0 || Ae.dispose(), this.customView = void 0;
  }
}
__decorate([
  attr({ attribute: "value" })
], PickerListItem.prototype, "value", void 0);
__decorate([
  observable
], PickerListItem.prototype, "contentsTemplate", void 0);
function createDefaultListItemTemplate(td) {
  const Ae = td.tagFor(PickerListItem);
  return html`
    <${Ae}
        value="${(xr) => xr}"
        :contentsTemplate="${(xr, ed) => ed.parent.listItemContentsTemplate}"
    >
    </${Ae}>
    `;
}
function createDefaultMenuOptionTemplate(td) {
  const Ae = td.tagFor(PickerMenuOption);
  return html`
    <${Ae}
        value="${(xr) => xr}"
        :contentsTemplate="${(xr, ed) => ed.parent.menuOptionContentsTemplate}"
    >
    </${Ae}>
    `;
}
const pickerTemplate = (td, Ae) => {
  const xr = td.tagFor(AnchoredRegion), ed = td.tagFor(PickerMenu), id = td.tagFor(PickerList), od = td.tagFor(PickerList), ad = createDefaultListItemTemplate(td), rd = createDefaultMenuOptionTemplate(td);
  return html`
        <template
            :selectedListTag="${() => id}"
            :menuTag="${() => ed}"
            :defaultListItemTemplate="${ad}"
            :defaultMenuOptionTemplate="${rd}"
            @focusin="${(sd, nd) => sd.handleFocusIn(nd.event)}"
            @focusout="${(sd, nd) => sd.handleFocusOut(nd.event)}"
            @keydown="${(sd, nd) => sd.handleKeyDown(nd.event)}"
            @pickeriteminvoked="${(sd, nd) => sd.handleItemInvoke(nd.event)}"
            @pickeroptioninvoked="${(sd, nd) => sd.handleOptionInvoke(nd.event)}"
        >
            <slot name="list-region"></slot>

            ${when((sd) => sd.flyoutOpen, html`
                <${xr}
                    class="region"
                    part="region"
                    auto-update-mode="${(sd) => sd.menuConfig.autoUpdateMode}"
                    fixed-placement="${(sd) => sd.menuConfig.fixedPlacement}"
                    vertical-positioning-mode="${(sd) => sd.menuConfig.verticalPositioningMode}"
                    vertical-default-position="${(sd) => sd.menuConfig.verticalDefaultPosition}"
                    vertical-scaling="${(sd) => sd.menuConfig.verticalScaling}"
                    vertical-inset="${(sd) => sd.menuConfig.verticalInset}"
                    vertical-viewport-lock="${(sd) => sd.menuConfig.verticalViewportLock}"
                    horizontal-positioning-mode="${(sd) => sd.menuConfig.horizontalPositioningMode}"
                    horizontal-default-position="${(sd) => sd.menuConfig.horizontalDefaultPosition}"
                    horizontal-scaling="${(sd) => sd.menuConfig.horizontalScaling}"
                    horizontal-inset="${(sd) => sd.menuConfig.horizontalInset}"
                    horizontal-viewport-lock="${(sd) => sd.menuConfig.horizontalViewportLock}"
                    @loaded="${(sd, nd) => sd.handleRegionLoaded(nd.event)}"
                    ${ref("region")}
                >
                    ${when((sd) => !sd.showNoOptions && !sd.showLoading, html`
                            <slot name="menu-region"></slot>
                        `)}
                    ${when((sd) => sd.showNoOptions && !sd.showLoading, html`
                            <div class="no-options-display" part="no-options-display">
                                <slot name="no-options-region">
                                    ${(sd) => sd.noSuggestionsText}
                                </slot>
                            </div>
                        `)}
                    ${when((sd) => sd.showLoading, html`
                            <div class="loading-display" part="loading-display">
                                <slot name="loading-region">
                                    <${od}
                                        part="loading-progress"
                                        class="loading-progress
                                        slot="loading-region"
                                    ></${od}>
                                        ${(sd) => sd.loadingText}
                                </slot>
                            </div>
                        `)}
                </${xr}>
            `)}
        </template>
    `;
};
class _Picker extends FoundationElement {
}
class FormAssociatedPicker extends FormAssociated(_Picker) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
const pickerInputTemplate = html`
    <input
        slot="input-region"
        role="combobox"
        type="text"
        autocapitalize="off"
        autocomplete="off"
        haspopup="list"
        aria-label="${(td) => td.label}"
        aria-labelledby="${(td) => td.labelledBy}"
        placeholder="${(td) => td.placeholder}"
        ${ref("inputElement")}
    ></input>
`;
let Picker$1 = class extends FormAssociatedPicker {
  constructor() {
    super(...arguments), this.selection = "", this.filterSelected = !0, this.filterQuery = !0, this.noSuggestionsText = "No suggestions available", this.suggestionsAvailableText = "Suggestions available", this.loadingText = "Loading suggestions", this.menuPlacement = "bottom-fill", this.showLoading = !1, this.optionsList = [], this.filteredOptionsList = [], this.flyoutOpen = !1, this.menuFocusIndex = -1, this.showNoOptions = !1, this.selectedItems = [], this.inputElementView = null, this.handleTextInput = (Ae) => {
      this.query = this.inputElement.value;
    }, this.handleInputClick = (Ae) => {
      Ae.preventDefault(), this.toggleFlyout(!0);
    }, this.setRegionProps = () => {
      if (this.flyoutOpen) {
        if (this.region === null || this.region === void 0) {
          DOM.queueUpdate(this.setRegionProps);
          return;
        }
        this.region.anchorElement = this.inputElement;
      }
    }, this.configLookup = {
      top: FlyoutPosTop,
      bottom: FlyoutPosBottom,
      tallest: FlyoutPosTallest,
      "top-fill": FlyoutPosTopFill,
      "bottom-fill": FlyoutPosBottomFill,
      "tallest-fill": FlyoutPosTallestFill
    };
  }
  selectionChanged() {
    this.$fastController.isConnected && (this.handleSelectionChange(), this.proxy instanceof HTMLInputElement && (this.proxy.value = this.selection, this.validate()));
  }
  optionsChanged() {
    this.optionsList = this.options.split(",").map((Ae) => Ae.trim()).filter((Ae) => Ae !== "");
  }
  menuPlacementChanged() {
    this.$fastController.isConnected && this.updateMenuConfig();
  }
  showLoadingChanged() {
    this.$fastController.isConnected && DOM.queueUpdate(() => {
      this.setFocusedOption(0);
    });
  }
  listItemTemplateChanged() {
    this.updateListItemTemplate();
  }
  defaultListItemTemplateChanged() {
    this.updateListItemTemplate();
  }
  menuOptionTemplateChanged() {
    this.updateOptionTemplate();
  }
  defaultMenuOptionTemplateChanged() {
    this.updateOptionTemplate();
  }
  optionsListChanged() {
    this.updateFilteredOptions();
  }
  queryChanged() {
    this.$fastController.isConnected && (this.inputElement.value !== this.query && (this.inputElement.value = this.query), this.updateFilteredOptions(), this.$emit("querychange", { bubbles: !1 }));
  }
  filteredOptionsListChanged() {
    this.$fastController.isConnected && (this.showNoOptions = this.filteredOptionsList.length === 0 && this.menuElement.querySelectorAll('[role="listitem"]').length === 0, this.setFocusedOption(this.showNoOptions ? -1 : 0));
  }
  flyoutOpenChanged() {
    this.flyoutOpen ? (DOM.queueUpdate(this.setRegionProps), this.$emit("menuopening", { bubbles: !1 })) : this.$emit("menuclosing", { bubbles: !1 });
  }
  showNoOptionsChanged() {
    this.$fastController.isConnected && DOM.queueUpdate(() => {
      this.setFocusedOption(0);
    });
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.listElement = document.createElement(this.selectedListTag), this.appendChild(this.listElement), this.itemsPlaceholderElement = document.createComment(""), this.listElement.append(this.itemsPlaceholderElement), this.inputElementView = pickerInputTemplate.render(this, this.listElement);
    const Ae = this.menuTag.toUpperCase();
    this.menuElement = Array.from(this.children).find((xr) => xr.tagName === Ae), this.menuElement === void 0 && (this.menuElement = document.createElement(this.menuTag), this.appendChild(this.menuElement)), this.menuElement.id === "" && (this.menuElement.id = uniqueId$1("listbox-")), this.menuId = this.menuElement.id, this.optionsPlaceholder = document.createComment(""), this.menuElement.append(this.optionsPlaceholder), this.updateMenuConfig(), DOM.queueUpdate(() => this.initialize());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.toggleFlyout(!1), this.inputElement.removeEventListener("input", this.handleTextInput), this.inputElement.removeEventListener("click", this.handleInputClick), this.inputElementView !== null && (this.inputElementView.dispose(), this.inputElementView = null);
  }
  /**
   * Move focus to the input element
   * @public
   */
  focus() {
    this.inputElement.focus();
  }
  /**
   * Initialize the component.  This is delayed a frame to ensure children are connected as well.
   */
  initialize() {
    this.updateListItemTemplate(), this.updateOptionTemplate(), this.itemsRepeatBehavior = new RepeatDirective((Ae) => Ae.selectedItems, (Ae) => Ae.activeListItemTemplate, { positioning: !0 }).createBehavior(this.itemsPlaceholderElement), this.inputElement.addEventListener("input", this.handleTextInput), this.inputElement.addEventListener("click", this.handleInputClick), this.$fastController.addBehaviors([this.itemsRepeatBehavior]), this.menuElement.suggestionsAvailableText = this.suggestionsAvailableText, this.menuElement.addEventListener("optionsupdated", this.handleMenuOptionsUpdated), this.optionsRepeatBehavior = new RepeatDirective((Ae) => Ae.filteredOptionsList, (Ae) => Ae.activeMenuOptionTemplate, { positioning: !0 }).createBehavior(this.optionsPlaceholder), this.$fastController.addBehaviors([this.optionsRepeatBehavior]), this.handleSelectionChange();
  }
  /**
   * Toggles the menu flyout
   */
  toggleFlyout(Ae) {
    if (this.flyoutOpen !== Ae) {
      if (Ae && document.activeElement === this.inputElement) {
        this.flyoutOpen = Ae, DOM.queueUpdate(() => {
          this.menuElement !== void 0 ? this.setFocusedOption(0) : this.disableMenu();
        });
        return;
      }
      this.flyoutOpen = !1, this.disableMenu();
    }
  }
  /**
   * Handle the menu options updated event from the child menu
   */
  handleMenuOptionsUpdated(Ae) {
    Ae.preventDefault(), this.flyoutOpen && this.setFocusedOption(0);
  }
  /**
   * Handle key down events.
   */
  handleKeyDown(Ae) {
    if (Ae.defaultPrevented)
      return !1;
    switch (Ae.key) {
      case keyArrowDown$1: {
        if (!this.flyoutOpen)
          this.toggleFlyout(!0);
        else {
          const xr = this.flyoutOpen ? Math.min(this.menuFocusIndex + 1, this.menuElement.optionElements.length - 1) : 0;
          this.setFocusedOption(xr);
        }
        return !1;
      }
      case keyArrowUp$1: {
        if (!this.flyoutOpen)
          this.toggleFlyout(!0);
        else {
          const xr = this.flyoutOpen ? Math.max(this.menuFocusIndex - 1, 0) : 0;
          this.setFocusedOption(xr);
        }
        return !1;
      }
      case keyEscape$1:
        return this.toggleFlyout(!1), !1;
      case keyEnter$1:
        return this.menuFocusIndex !== -1 && this.menuElement.optionElements.length > this.menuFocusIndex && this.menuElement.optionElements[this.menuFocusIndex].click(), !1;
      case keyArrowRight$1:
        return document.activeElement !== this.inputElement ? (this.incrementFocusedItem(1), !1) : !0;
      case keyArrowLeft$1:
        return this.inputElement.selectionStart === 0 ? (this.incrementFocusedItem(-1), !1) : !0;
      case keyDelete:
      case keyBackspace: {
        if (document.activeElement === null)
          return !0;
        if (document.activeElement === this.inputElement)
          return this.inputElement.selectionStart === 0 ? (this.selection = this.selectedItems.slice(0, this.selectedItems.length - 1).toString(), this.toggleFlyout(!1), !1) : !0;
        const xr = Array.from(this.listElement.children), ed = xr.indexOf(document.activeElement);
        return ed > -1 ? (this.selection = this.selectedItems.splice(ed, 1).toString(), DOM.queueUpdate(() => {
          xr[Math.min(xr.length, ed)].focus();
        }), !1) : !0;
      }
    }
    return this.toggleFlyout(!0), !0;
  }
  /**
   * Handle focus in events.
   */
  handleFocusIn(Ae) {
    return !1;
  }
  /**
   * Handle focus out events.
   */
  handleFocusOut(Ae) {
    return (this.menuElement === void 0 || !this.menuElement.contains(Ae.relatedTarget)) && this.toggleFlyout(!1), !1;
  }
  /**
   * The list of selected items has changed
   */
  handleSelectionChange() {
    this.selectedItems.toString() !== this.selection && (this.selectedItems = this.selection === "" ? [] : this.selection.split(","), this.updateFilteredOptions(), DOM.queueUpdate(() => {
      this.checkMaxItems();
    }), this.$emit("selectionchange", { bubbles: !1 }));
  }
  /**
   * Anchored region is loaded, menu and options exist in the DOM.
   */
  handleRegionLoaded(Ae) {
    DOM.queueUpdate(() => {
      this.setFocusedOption(0), this.$emit("menuloaded", { bubbles: !1 });
    });
  }
  /**
   * Checks if the maximum number of items has been chosen and updates the ui.
   */
  checkMaxItems() {
    if (this.inputElement !== void 0)
      if (this.maxSelected !== void 0 && this.selectedItems.length >= this.maxSelected) {
        if (document.activeElement === this.inputElement) {
          const Ae = Array.from(this.listElement.querySelectorAll("[role='listitem']"));
          Ae[Ae.length - 1].focus();
        }
        this.inputElement.hidden = !0;
      } else
        this.inputElement.hidden = !1;
  }
  /**
   * A list item has been invoked.
   */
  handleItemInvoke(Ae) {
    if (Ae.defaultPrevented)
      return !1;
    if (Ae.target instanceof PickerListItem) {
      const ed = Array.from(this.listElement.querySelectorAll("[role='listitem']")).indexOf(Ae.target);
      if (ed !== -1) {
        const id = this.selectedItems.slice();
        id.splice(ed, 1), this.selection = id.toString(), DOM.queueUpdate(() => this.incrementFocusedItem(0));
      }
      return !1;
    }
    return !0;
  }
  /**
   * A menu option has been invoked.
   */
  handleOptionInvoke(Ae) {
    return Ae.defaultPrevented ? !1 : Ae.target instanceof PickerMenuOption ? (Ae.target.value !== void 0 && (this.selection = `${this.selection}${this.selection === "" ? "" : ","}${Ae.target.value}`), this.inputElement.value = "", this.query = "", this.inputElement.focus(), this.toggleFlyout(!1), !1) : !0;
  }
  /**
   * Increments the focused list item by the specified amount
   */
  incrementFocusedItem(Ae) {
    if (this.selectedItems.length === 0) {
      this.inputElement.focus();
      return;
    }
    const xr = Array.from(this.listElement.querySelectorAll("[role='listitem']"));
    if (document.activeElement !== null) {
      let ed = xr.indexOf(document.activeElement);
      ed === -1 && (ed = xr.length);
      const id = Math.min(xr.length, Math.max(0, ed + Ae));
      id === xr.length ? this.maxSelected !== void 0 && this.selectedItems.length >= this.maxSelected ? xr[id - 1].focus() : this.inputElement.focus() : xr[id].focus();
    }
  }
  /**
   * Disables the menu. Note that the menu can be open, just doens't have any valid options on display.
   */
  disableMenu() {
    var Ae, xr, ed;
    this.menuFocusIndex = -1, this.menuFocusOptionId = void 0, (Ae = this.inputElement) === null || Ae === void 0 || Ae.removeAttribute("aria-activedescendant"), (xr = this.inputElement) === null || xr === void 0 || xr.removeAttribute("aria-owns"), (ed = this.inputElement) === null || ed === void 0 || ed.removeAttribute("aria-expanded");
  }
  /**
   * Sets the currently focused menu option by index
   */
  setFocusedOption(Ae) {
    if (!this.flyoutOpen || Ae === -1 || this.showNoOptions || this.showLoading) {
      this.disableMenu();
      return;
    }
    if (this.menuElement.optionElements.length === 0)
      return;
    this.menuElement.optionElements.forEach((ed) => {
      ed.setAttribute("aria-selected", "false");
    }), this.menuFocusIndex = Ae, this.menuFocusIndex > this.menuElement.optionElements.length - 1 && (this.menuFocusIndex = this.menuElement.optionElements.length - 1), this.menuFocusOptionId = this.menuElement.optionElements[this.menuFocusIndex].id, this.inputElement.setAttribute("aria-owns", this.menuId), this.inputElement.setAttribute("aria-expanded", "true"), this.inputElement.setAttribute("aria-activedescendant", this.menuFocusOptionId);
    const xr = this.menuElement.optionElements[this.menuFocusIndex];
    xr.setAttribute("aria-selected", "true"), this.menuElement.scrollTo(0, xr.offsetTop);
  }
  /**
   * Updates the template used for the list item repeat behavior
   */
  updateListItemTemplate() {
    var Ae;
    this.activeListItemTemplate = (Ae = this.listItemTemplate) !== null && Ae !== void 0 ? Ae : this.defaultListItemTemplate;
  }
  /**
   * Updates the template used for the menu option repeat behavior
   */
  updateOptionTemplate() {
    var Ae;
    this.activeMenuOptionTemplate = (Ae = this.menuOptionTemplate) !== null && Ae !== void 0 ? Ae : this.defaultMenuOptionTemplate;
  }
  /**
   * Updates the filtered options array
   */
  updateFilteredOptions() {
    this.filteredOptionsList = this.optionsList.slice(0), this.filterSelected && (this.filteredOptionsList = this.filteredOptionsList.filter((Ae) => this.selectedItems.indexOf(Ae) === -1)), this.filterQuery && this.query !== "" && this.query !== void 0 && (this.filteredOptionsList = this.filteredOptionsList.filter((Ae) => Ae.indexOf(this.query) !== -1));
  }
  /**
   * Updates the menu configuration
   */
  updateMenuConfig() {
    let Ae = this.configLookup[this.menuPlacement];
    Ae === null && (Ae = FlyoutPosBottomFill), this.menuConfig = Object.assign(Object.assign({}, Ae), { autoUpdateMode: "auto", fixedPlacement: !0, horizontalViewportLock: !1, verticalViewportLock: !1 });
  }
};
__decorate([
  attr({ attribute: "selection" })
], Picker$1.prototype, "selection", void 0);
__decorate([
  attr({ attribute: "options" })
], Picker$1.prototype, "options", void 0);
__decorate([
  attr({ attribute: "filter-selected", mode: "boolean" })
], Picker$1.prototype, "filterSelected", void 0);
__decorate([
  attr({ attribute: "filter-query", mode: "boolean" })
], Picker$1.prototype, "filterQuery", void 0);
__decorate([
  attr({ attribute: "max-selected" })
], Picker$1.prototype, "maxSelected", void 0);
__decorate([
  attr({ attribute: "no-suggestions-text" })
], Picker$1.prototype, "noSuggestionsText", void 0);
__decorate([
  attr({ attribute: "suggestions-available-text" })
], Picker$1.prototype, "suggestionsAvailableText", void 0);
__decorate([
  attr({ attribute: "loading-text" })
], Picker$1.prototype, "loadingText", void 0);
__decorate([
  attr({ attribute: "label" })
], Picker$1.prototype, "label", void 0);
__decorate([
  attr({ attribute: "labelledby" })
], Picker$1.prototype, "labelledBy", void 0);
__decorate([
  attr({ attribute: "placeholder" })
], Picker$1.prototype, "placeholder", void 0);
__decorate([
  attr({ attribute: "menu-placement" })
], Picker$1.prototype, "menuPlacement", void 0);
__decorate([
  observable
], Picker$1.prototype, "showLoading", void 0);
__decorate([
  observable
], Picker$1.prototype, "listItemTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "defaultListItemTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "activeListItemTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuOptionTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "defaultMenuOptionTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "activeMenuOptionTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "listItemContentsTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuOptionContentsTemplate", void 0);
__decorate([
  observable
], Picker$1.prototype, "optionsList", void 0);
__decorate([
  observable
], Picker$1.prototype, "query", void 0);
__decorate([
  observable
], Picker$1.prototype, "filteredOptionsList", void 0);
__decorate([
  observable
], Picker$1.prototype, "flyoutOpen", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuId", void 0);
__decorate([
  observable
], Picker$1.prototype, "selectedListTag", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuTag", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuFocusIndex", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuFocusOptionId", void 0);
__decorate([
  observable
], Picker$1.prototype, "showNoOptions", void 0);
__decorate([
  observable
], Picker$1.prototype, "menuConfig", void 0);
__decorate([
  observable
], Picker$1.prototype, "selectedItems", void 0);
const pickerMenuTemplate = (td, Ae) => html`
        <template role="list" slot="menu-region">
            <div class="options-display" part="options-display">
                <div class="header-region" part="header-region">
                    <slot name="header-region" ${slotted("headerElements")}></slot>
                </div>

                <slot ${slotted("menuElements")}></slot>
                <div class="footer-region" part="footer-region">
                    <slot name="footer-region" ${slotted("footerElements")}></slot>
                </div>
                <div
                    role="alert"
                    aria-live="polite"
                    part="suggestions-available-alert"
                    class="suggestions-available-alert"
                >
                    ${(xr) => xr.suggestionsAvailableText}
                </div>
            </div>
        </template>
    `, pickerMenuOptionTemplate = (td, Ae) => html`
        <template
            role="listitem"
            tabindex="-1"
            @click="${(xr, ed) => xr.handleClick(ed.event)}"
        >
            <slot></slot>
        </template>
    `, pickerListTemplate = (td, Ae) => html`
        <template slot="list-region" role="list" class="picker-list">
            <slot></slot>
            <slot name="input-region"></slot>
        </template>
    `, pickerListItemTemplate = (td, Ae) => html`
        <template
            role="listitem"
            tabindex="0"
            @click="${(xr, ed) => xr.handleClick(ed.event)}"
            @keydown="${(xr, ed) => xr.handleKeyDown(ed.event)}"
        >
            <slot></slot>
        </template>
    `, MenuItemRole = {
  /**
   * The menu item has a "menuitem" role
   */
  menuitem: "menuitem",
  /**
   * The menu item has a "menuitemcheckbox" role
   */
  menuitemcheckbox: "menuitemcheckbox",
  /**
   * The menu item has a "menuitemradio" role
   */
  menuitemradio: "menuitemradio"
}, roleForMenuItem = {
  [MenuItemRole.menuitem]: "menuitem",
  [MenuItemRole.menuitemcheckbox]: "menuitemcheckbox",
  [MenuItemRole.menuitemradio]: "menuitemradio"
};
class MenuItem extends FoundationElement {
  constructor() {
    super(...arguments), this.role = MenuItemRole.menuitem, this.hasSubmenu = !1, this.currentDirection = Direction$1.ltr, this.focusSubmenuOnLoad = !1, this.handleMenuItemKeyDown = (Ae) => {
      if (Ae.defaultPrevented)
        return !1;
      switch (Ae.key) {
        case keyEnter$1:
        case keySpace$1:
          return this.invoke(), !1;
        case keyArrowRight$1:
          return this.expandAndFocus(), !1;
        case keyArrowLeft$1:
          if (this.expanded)
            return this.expanded = !1, this.focus(), !1;
      }
      return !0;
    }, this.handleMenuItemClick = (Ae) => (Ae.defaultPrevented || this.disabled || this.invoke(), !1), this.submenuLoaded = () => {
      this.focusSubmenuOnLoad && (this.focusSubmenuOnLoad = !1, this.hasSubmenu && (this.submenu.focus(), this.setAttribute("tabindex", "-1")));
    }, this.handleMouseOver = (Ae) => (this.disabled || !this.hasSubmenu || this.expanded || (this.expanded = !0), !1), this.handleMouseOut = (Ae) => (!this.expanded || this.contains(document.activeElement) || (this.expanded = !1), !1), this.expandAndFocus = () => {
      this.hasSubmenu && (this.focusSubmenuOnLoad = !0, this.expanded = !0);
    }, this.invoke = () => {
      if (!this.disabled)
        switch (this.role) {
          case MenuItemRole.menuitemcheckbox:
            this.checked = !this.checked;
            break;
          case MenuItemRole.menuitem:
            this.updateSubmenu(), this.hasSubmenu ? this.expandAndFocus() : this.$emit("change");
            break;
          case MenuItemRole.menuitemradio:
            this.checked || (this.checked = !0);
            break;
        }
    }, this.updateSubmenu = () => {
      this.submenu = this.domChildren().find((Ae) => Ae.getAttribute("role") === "menu"), this.hasSubmenu = this.submenu !== void 0;
    };
  }
  expandedChanged(Ae) {
    if (this.$fastController.isConnected) {
      if (this.submenu === void 0)
        return;
      this.expanded === !1 ? this.submenu.collapseExpandedItem() : this.currentDirection = getDirection$1(this), this.$emit("expanded-change", this, { bubbles: !1 });
    }
  }
  checkedChanged(Ae, xr) {
    this.$fastController.isConnected && this.$emit("change");
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      this.updateSubmenu();
    }), this.startColumnCount || (this.startColumnCount = 1), this.observer = new MutationObserver(this.updateSubmenu);
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.submenu = void 0, this.observer !== void 0 && (this.observer.disconnect(), this.observer = void 0);
  }
  /**
   * get an array of valid DOM children
   */
  domChildren() {
    return Array.from(this.children).filter((Ae) => !Ae.hasAttribute("hidden"));
  }
}
__decorate([
  attr({ mode: "boolean" })
], MenuItem.prototype, "disabled", void 0);
__decorate([
  attr({ mode: "boolean" })
], MenuItem.prototype, "expanded", void 0);
__decorate([
  observable
], MenuItem.prototype, "startColumnCount", void 0);
__decorate([
  attr
], MenuItem.prototype, "role", void 0);
__decorate([
  attr({ mode: "boolean" })
], MenuItem.prototype, "checked", void 0);
__decorate([
  observable
], MenuItem.prototype, "submenuRegion", void 0);
__decorate([
  observable
], MenuItem.prototype, "hasSubmenu", void 0);
__decorate([
  observable
], MenuItem.prototype, "currentDirection", void 0);
__decorate([
  observable
], MenuItem.prototype, "submenu", void 0);
applyMixins(MenuItem, StartEnd);
const menuItemTemplate = (td, Ae) => html`
    <template
        role="${(xr) => xr.role}"
        aria-haspopup="${(xr) => xr.hasSubmenu ? "menu" : void 0}"
        aria-checked="${(xr) => xr.role !== MenuItemRole.menuitem ? xr.checked : void 0}"
        aria-disabled="${(xr) => xr.disabled}"
        aria-expanded="${(xr) => xr.expanded}"
        @keydown="${(xr, ed) => xr.handleMenuItemKeyDown(ed.event)}"
        @click="${(xr, ed) => xr.handleMenuItemClick(ed.event)}"
        @mouseover="${(xr, ed) => xr.handleMouseOver(ed.event)}"
        @mouseout="${(xr, ed) => xr.handleMouseOut(ed.event)}"
        class="${(xr) => xr.disabled ? "disabled" : ""} ${(xr) => xr.expanded ? "expanded" : ""} ${(xr) => `indent-${xr.startColumnCount}`}"
    >
            ${when((xr) => xr.role === MenuItemRole.menuitemcheckbox, html`
                    <div part="input-container" class="input-container">
                        <span part="checkbox" class="checkbox">
                            <slot name="checkbox-indicator">
                                ${Ae.checkboxIndicator || ""}
                            </slot>
                        </span>
                    </div>
                `)}
            ${when((xr) => xr.role === MenuItemRole.menuitemradio, html`
                    <div part="input-container" class="input-container">
                        <span part="radio" class="radio">
                            <slot name="radio-indicator">
                                ${Ae.radioIndicator || ""}
                            </slot>
                        </span>
                    </div>
                `)}
        </div>
        ${startSlotTemplate(td, Ae)}
        <span class="content" part="content">
            <slot></slot>
        </span>
        ${endSlotTemplate(td, Ae)}
        ${when((xr) => xr.hasSubmenu, html`
                <div
                    part="expand-collapse-glyph-container"
                    class="expand-collapse-glyph-container"
                >
                    <span part="expand-collapse" class="expand-collapse">
                        <slot name="expand-collapse-indicator">
                            ${Ae.expandCollapseGlyph || ""}
                        </slot>
                    </span>
                </div>
            `)}
        ${when((xr) => xr.expanded, html`
                <${td.tagFor(AnchoredRegion)}
                    :anchorElement="${(xr) => xr}"
                    vertical-positioning-mode="dynamic"
                    vertical-default-position="bottom"
                    vertical-inset="true"
                    horizontal-positioning-mode="dynamic"
                    horizontal-default-position="end"
                    class="submenu-region"
                    dir="${(xr) => xr.currentDirection}"
                    @loaded="${(xr) => xr.submenuLoaded()}"
                    ${ref("submenuRegion")}
                    part="submenu-region"
                >
                    <slot name="submenu"></slot>
                </${td.tagFor(AnchoredRegion)}>
            `)}
    </template>
`, menuTemplate = (td, Ae) => html`
    <template
        slot="${(xr) => xr.slot ? xr.slot : xr.isNestedMenu() ? "submenu" : void 0}"
        role="menu"
        @keydown="${(xr, ed) => xr.handleMenuKeyDown(ed.event)}"
        @focusout="${(xr, ed) => xr.handleFocusOut(ed.event)}"
    >
        <slot ${slotted("items")}></slot>
    </template>
`;
class Menu extends FoundationElement {
  constructor() {
    super(...arguments), this.expandedItem = null, this.focusIndex = -1, this.isNestedMenu = () => this.parentElement !== null && isHTMLElement$1(this.parentElement) && this.parentElement.getAttribute("role") === "menuitem", this.handleFocusOut = (Ae) => {
      if (!this.contains(Ae.relatedTarget) && this.menuItems !== void 0) {
        this.collapseExpandedItem();
        const xr = this.menuItems.findIndex(this.isFocusableElement);
        this.menuItems[this.focusIndex].setAttribute("tabindex", "-1"), this.menuItems[xr].setAttribute("tabindex", "0"), this.focusIndex = xr;
      }
    }, this.handleItemFocus = (Ae) => {
      const xr = Ae.target;
      this.menuItems !== void 0 && xr !== this.menuItems[this.focusIndex] && (this.menuItems[this.focusIndex].setAttribute("tabindex", "-1"), this.focusIndex = this.menuItems.indexOf(xr), xr.setAttribute("tabindex", "0"));
    }, this.handleExpandedChanged = (Ae) => {
      if (Ae.defaultPrevented || Ae.target === null || this.menuItems === void 0 || this.menuItems.indexOf(Ae.target) < 0)
        return;
      Ae.preventDefault();
      const xr = Ae.target;
      if (this.expandedItem !== null && xr === this.expandedItem && xr.expanded === !1) {
        this.expandedItem = null;
        return;
      }
      xr.expanded && (this.expandedItem !== null && this.expandedItem !== xr && (this.expandedItem.expanded = !1), this.menuItems[this.focusIndex].setAttribute("tabindex", "-1"), this.expandedItem = xr, this.focusIndex = this.menuItems.indexOf(xr), xr.setAttribute("tabindex", "0"));
    }, this.removeItemListeners = () => {
      this.menuItems !== void 0 && this.menuItems.forEach((Ae) => {
        Ae.removeEventListener("expanded-change", this.handleExpandedChanged), Ae.removeEventListener("focus", this.handleItemFocus);
      });
    }, this.setItems = () => {
      const Ae = this.domChildren();
      this.removeItemListeners(), this.menuItems = Ae;
      const xr = this.menuItems.filter(this.isMenuItemElement);
      xr.length && (this.focusIndex = 0);
      function ed(od) {
        const ad = od.getAttribute("role"), rd = od.querySelector("[slot=start]");
        return ad !== MenuItemRole.menuitem && rd === null || ad === MenuItemRole.menuitem && rd !== null ? 1 : ad !== MenuItemRole.menuitem && rd !== null ? 2 : 0;
      }
      const id = xr.reduce((od, ad) => {
        const rd = ed(ad);
        return od > rd ? od : rd;
      }, 0);
      xr.forEach((od, ad) => {
        od.setAttribute("tabindex", ad === 0 ? "0" : "-1"), od.addEventListener("expanded-change", this.handleExpandedChanged), od.addEventListener("focus", this.handleItemFocus), (od instanceof MenuItem || "startColumnCount" in od) && (od.startColumnCount = id);
      });
    }, this.changeHandler = (Ae) => {
      if (this.menuItems === void 0)
        return;
      const xr = Ae.target, ed = this.menuItems.indexOf(xr);
      if (ed !== -1 && xr.role === "menuitemradio" && xr.checked === !0) {
        for (let od = ed - 1; od >= 0; --od) {
          const ad = this.menuItems[od], rd = ad.getAttribute("role");
          if (rd === MenuItemRole.menuitemradio && (ad.checked = !1), rd === "separator")
            break;
        }
        const id = this.menuItems.length - 1;
        for (let od = ed + 1; od <= id; ++od) {
          const ad = this.menuItems[od], rd = ad.getAttribute("role");
          if (rd === MenuItemRole.menuitemradio && (ad.checked = !1), rd === "separator")
            break;
        }
      }
    }, this.isMenuItemElement = (Ae) => isHTMLElement$1(Ae) && Menu.focusableElementRoles.hasOwnProperty(Ae.getAttribute("role")), this.isFocusableElement = (Ae) => this.isMenuItemElement(Ae);
  }
  itemsChanged(Ae, xr) {
    this.$fastController.isConnected && this.menuItems !== void 0 && this.setItems();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      this.setItems();
    }), this.addEventListener("change", this.changeHandler);
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeItemListeners(), this.menuItems = void 0, this.removeEventListener("change", this.changeHandler);
  }
  /**
   * Focuses the first item in the menu.
   *
   * @public
   */
  focus() {
    this.setFocus(0, 1);
  }
  /**
   * Collapses any expanded menu items.
   *
   * @public
   */
  collapseExpandedItem() {
    this.expandedItem !== null && (this.expandedItem.expanded = !1, this.expandedItem = null);
  }
  /**
   * @internal
   */
  handleMenuKeyDown(Ae) {
    if (!(Ae.defaultPrevented || this.menuItems === void 0))
      switch (Ae.key) {
        case keyArrowDown$1:
          this.setFocus(this.focusIndex + 1, 1);
          return;
        case keyArrowUp$1:
          this.setFocus(this.focusIndex - 1, -1);
          return;
        case keyEnd$1:
          this.setFocus(this.menuItems.length - 1, -1);
          return;
        case keyHome$1:
          this.setFocus(0, 1);
          return;
        default:
          return !0;
      }
  }
  /**
   * get an array of valid DOM children
   */
  domChildren() {
    return Array.from(this.children).filter((Ae) => !Ae.hasAttribute("hidden"));
  }
  setFocus(Ae, xr) {
    if (this.menuItems !== void 0)
      for (; Ae >= 0 && Ae < this.menuItems.length; ) {
        const ed = this.menuItems[Ae];
        if (this.isFocusableElement(ed)) {
          this.focusIndex > -1 && this.menuItems.length >= this.focusIndex - 1 && this.menuItems[this.focusIndex].setAttribute("tabindex", "-1"), this.focusIndex = Ae, ed.setAttribute("tabindex", "0"), ed.focus();
          break;
        }
        Ae += xr;
      }
  }
}
Menu.focusableElementRoles = roleForMenuItem;
__decorate([
  observable
], Menu.prototype, "items", void 0);
const numberFieldTemplate = (td, Ae) => html`
    <template class="${(xr) => xr.readOnly ? "readonly" : ""}">
        <label
            part="label"
            for="control"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot ${slotted("defaultSlottedNodes")}></slot>
        </label>
        <div class="root" part="root">
            ${startSlotTemplate(td, Ae)}
            <input
                class="control"
                part="control"
                id="control"
                @input="${(xr) => xr.handleTextInput()}"
                @change="${(xr) => xr.handleChange()}"
                @keydown="${(xr, ed) => xr.handleKeyDown(ed.event)}"
                @blur="${(xr, ed) => xr.handleBlur()}"
                ?autofocus="${(xr) => xr.autofocus}"
                ?disabled="${(xr) => xr.disabled}"
                list="${(xr) => xr.list}"
                maxlength="${(xr) => xr.maxlength}"
                minlength="${(xr) => xr.minlength}"
                placeholder="${(xr) => xr.placeholder}"
                ?readonly="${(xr) => xr.readOnly}"
                ?required="${(xr) => xr.required}"
                size="${(xr) => xr.size}"
                type="text"
                inputmode="numeric"
                min="${(xr) => xr.min}"
                max="${(xr) => xr.max}"
                step="${(xr) => xr.step}"
                aria-atomic="${(xr) => xr.ariaAtomic}"
                aria-busy="${(xr) => xr.ariaBusy}"
                aria-controls="${(xr) => xr.ariaControls}"
                aria-current="${(xr) => xr.ariaCurrent}"
                aria-describedby="${(xr) => xr.ariaDescribedby}"
                aria-details="${(xr) => xr.ariaDetails}"
                aria-disabled="${(xr) => xr.ariaDisabled}"
                aria-errormessage="${(xr) => xr.ariaErrormessage}"
                aria-flowto="${(xr) => xr.ariaFlowto}"
                aria-haspopup="${(xr) => xr.ariaHaspopup}"
                aria-hidden="${(xr) => xr.ariaHidden}"
                aria-invalid="${(xr) => xr.ariaInvalid}"
                aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
                aria-label="${(xr) => xr.ariaLabel}"
                aria-labelledby="${(xr) => xr.ariaLabelledby}"
                aria-live="${(xr) => xr.ariaLive}"
                aria-owns="${(xr) => xr.ariaOwns}"
                aria-relevant="${(xr) => xr.ariaRelevant}"
                aria-roledescription="${(xr) => xr.ariaRoledescription}"
                ${ref("control")}
            />
            ${when((xr) => !xr.hideStep && !xr.readOnly && !xr.disabled, html`
                    <div class="controls" part="controls">
                        <div class="step-up" part="step-up" @click="${(xr) => xr.stepUp()}">
                            <slot name="step-up-glyph">
                                ${Ae.stepUpGlyph || ""}
                            </slot>
                        </div>
                        <div
                            class="step-down"
                            part="step-down"
                            @click="${(xr) => xr.stepDown()}"
                        >
                            <slot name="step-down-glyph">
                                ${Ae.stepDownGlyph || ""}
                            </slot>
                        </div>
                    </div>
                `)}
            ${endSlotTemplate(td, Ae)}
        </div>
    </template>
`;
class _TextField extends FoundationElement {
}
class FormAssociatedTextField extends FormAssociated(_TextField) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
const TextFieldType = {
  /**
   * An email TextField
   */
  email: "email",
  /**
   * A password TextField
   */
  password: "password",
  /**
   * A telephone TextField
   */
  tel: "tel",
  /**
   * A text TextField
   */
  text: "text",
  /**
   * A URL TextField
   */
  url: "url"
};
let TextField$1 = class extends FormAssociatedTextField {
  constructor() {
    super(...arguments), this.type = TextFieldType.text;
  }
  readOnlyChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.readOnly = this.readOnly, this.validate());
  }
  autofocusChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.autofocus = this.autofocus, this.validate());
  }
  placeholderChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.placeholder = this.placeholder);
  }
  typeChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.type = this.type, this.validate());
  }
  listChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.setAttribute("list", this.list), this.validate());
  }
  maxlengthChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.maxLength = this.maxlength, this.validate());
  }
  minlengthChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.minLength = this.minlength, this.validate());
  }
  patternChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.pattern = this.pattern, this.validate());
  }
  sizeChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.size = this.size);
  }
  spellcheckChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.spellcheck = this.spellcheck);
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.proxy.setAttribute("type", this.type), this.validate(), this.autofocus && DOM.queueUpdate(() => {
      this.focus();
    });
  }
  /**
   * Selects all the text in the text field
   *
   * @public
   */
  select() {
    this.control.select(), this.$emit("select");
  }
  /**
   * Handles the internal control's `input` event
   * @internal
   */
  handleTextInput() {
    this.value = this.control.value;
  }
  /**
   * Change event handler for inner control.
   * @remarks
   * "Change" events are not `composable` so they will not
   * permeate the shadow DOM boundary. This fn effectively proxies
   * the change event, emitting a `change` event whenever the internal
   * control emits a `change` event
   * @internal
   */
  handleChange() {
    this.$emit("change");
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], TextField$1.prototype, "readOnly", void 0);
__decorate([
  attr({ mode: "boolean" })
], TextField$1.prototype, "autofocus", void 0);
__decorate([
  attr
], TextField$1.prototype, "placeholder", void 0);
__decorate([
  attr
], TextField$1.prototype, "type", void 0);
__decorate([
  attr
], TextField$1.prototype, "list", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], TextField$1.prototype, "maxlength", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], TextField$1.prototype, "minlength", void 0);
__decorate([
  attr
], TextField$1.prototype, "pattern", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], TextField$1.prototype, "size", void 0);
__decorate([
  attr({ mode: "boolean" })
], TextField$1.prototype, "spellcheck", void 0);
__decorate([
  observable
], TextField$1.prototype, "defaultSlottedNodes", void 0);
class DelegatesARIATextbox {
}
applyMixins(DelegatesARIATextbox, ARIAGlobalStatesAndProperties);
applyMixins(TextField$1, StartEnd, DelegatesARIATextbox);
let _NumberField$1 = class extends FoundationElement {
}, FormAssociatedNumberField$1 = class extends FormAssociated(_NumberField$1) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}, NumberField$1 = class extends FormAssociatedNumberField$1 {
  constructor() {
    super(...arguments), this.hideStep = !1, this.step = 1, this.isUserInput = !1;
  }
  /**
   * Ensures that the max is greater than the min and that the value
   *  is less than the max
   * @param previous - the previous max value
   * @param next - updated max value
   *
   * @internal
   */
  maxChanged(Ae, xr) {
    var ed;
    this.max = Math.max(xr, (ed = this.min) !== null && ed !== void 0 ? ed : xr);
    const id = Math.min(this.min, this.max);
    this.min !== void 0 && this.min !== id && (this.min = id), this.value = this.getValidValue(this.value);
  }
  /**
   * Ensures that the min is less than the max and that the value
   *  is greater than the min
   * @param previous - previous min value
   * @param next - updated min value
   *
   * @internal
   */
  minChanged(Ae, xr) {
    var ed;
    this.min = Math.min(xr, (ed = this.max) !== null && ed !== void 0 ? ed : xr);
    const id = Math.max(this.min, this.max);
    this.max !== void 0 && this.max !== id && (this.max = id), this.value = this.getValidValue(this.value);
  }
  /**
   * The value property, typed as a number.
   *
   * @public
   */
  get valueAsNumber() {
    return parseFloat(super.value);
  }
  set valueAsNumber(Ae) {
    this.value = Ae.toString();
  }
  /**
   * Validates that the value is a number between the min and max
   * @param previous - previous stored value
   * @param next - value being updated
   * @param updateControl - should the text field be updated with value, defaults to true
   * @internal
   */
  valueChanged(Ae, xr) {
    this.value = this.getValidValue(xr), xr === this.value && (this.control && !this.isUserInput && (this.control.value = this.value), super.valueChanged(Ae, this.value), Ae !== void 0 && !this.isUserInput && (this.$emit("input"), this.$emit("change")), this.isUserInput = !1);
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  /**
   * Sets the internal value to a valid number between the min and max properties
   * @param value - user input
   *
   * @internal
   */
  getValidValue(Ae) {
    var xr, ed;
    let id = parseFloat(parseFloat(Ae).toPrecision(12));
    return isNaN(id) ? id = "" : (id = Math.min(id, (xr = this.max) !== null && xr !== void 0 ? xr : id), id = Math.max(id, (ed = this.min) !== null && ed !== void 0 ? ed : id).toString()), id;
  }
  /**
   * Increments the value using the step value
   *
   * @public
   */
  stepUp() {
    const Ae = parseFloat(this.value), xr = isNaN(Ae) ? this.min > 0 ? this.min : this.max < 0 ? this.max : this.min ? 0 : this.step : Ae + this.step;
    this.value = xr.toString();
  }
  /**
   * Decrements the value using the step value
   *
   * @public
   */
  stepDown() {
    const Ae = parseFloat(this.value), xr = isNaN(Ae) ? this.min > 0 ? this.min : this.max < 0 ? this.max : this.min ? 0 : 0 - this.step : Ae - this.step;
    this.value = xr.toString();
  }
  /**
   * Sets up the initial state of the number field
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.proxy.setAttribute("type", "number"), this.validate(), this.control.value = this.value, this.autofocus && DOM.queueUpdate(() => {
      this.focus();
    });
  }
  /**
   * Selects all the text in the number field
   *
   * @public
   */
  select() {
    this.control.select(), this.$emit("select");
  }
  /**
   * Handles the internal control's `input` event
   * @internal
   */
  handleTextInput() {
    this.control.value = this.control.value.replace(/[^0-9\-+e.]/g, ""), this.isUserInput = !0, this.value = this.control.value;
  }
  /**
   * Change event handler for inner control.
   * @remarks
   * "Change" events are not `composable` so they will not
   * permeate the shadow DOM boundary. This fn effectively proxies
   * the change event, emitting a `change` event whenever the internal
   * control emits a `change` event
   * @internal
   */
  handleChange() {
    this.$emit("change");
  }
  /**
   * Handles the internal control's `keydown` event
   * @internal
   */
  handleKeyDown(Ae) {
    switch (Ae.key) {
      case keyArrowUp$1:
        return this.stepUp(), !1;
      case keyArrowDown$1:
        return this.stepDown(), !1;
    }
    return !0;
  }
  /**
   * Handles populating the input field with a validated value when
   *  leaving the input field.
   * @internal
   */
  handleBlur() {
    this.control.value = this.value;
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], NumberField$1.prototype, "readOnly", void 0);
__decorate([
  attr({ mode: "boolean" })
], NumberField$1.prototype, "autofocus", void 0);
__decorate([
  attr({ attribute: "hide-step", mode: "boolean" })
], NumberField$1.prototype, "hideStep", void 0);
__decorate([
  attr
], NumberField$1.prototype, "placeholder", void 0);
__decorate([
  attr
], NumberField$1.prototype, "list", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], NumberField$1.prototype, "maxlength", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], NumberField$1.prototype, "minlength", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], NumberField$1.prototype, "size", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], NumberField$1.prototype, "step", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], NumberField$1.prototype, "max", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], NumberField$1.prototype, "min", void 0);
__decorate([
  observable
], NumberField$1.prototype, "defaultSlottedNodes", void 0);
applyMixins(NumberField$1, StartEnd, DelegatesARIATextbox);
const progressSegments = 44, progressRingTemplate = (td, Ae) => html`
    <template
        role="progressbar"
        aria-valuenow="${(xr) => xr.value}"
        aria-valuemin="${(xr) => xr.min}"
        aria-valuemax="${(xr) => xr.max}"
        class="${(xr) => xr.paused ? "paused" : ""}"
    >
        ${when((xr) => typeof xr.value == "number", html`
                <svg
                    class="progress"
                    part="progress"
                    viewBox="0 0 16 16"
                    slot="determinate"
                >
                    <circle
                        class="background"
                        part="background"
                        cx="8px"
                        cy="8px"
                        r="7px"
                    ></circle>
                    <circle
                        class="determinate"
                        part="determinate"
                        style="stroke-dasharray: ${(xr) => progressSegments * xr.percentComplete / 100}px ${progressSegments}px"
                        cx="8px"
                        cy="8px"
                        r="7px"
                    ></circle>
                </svg>
            `, html`
                <slot name="indeterminate" slot="indeterminate">
                    ${Ae.indeterminateIndicator || ""}
                </slot>
            `)}
    </template>
`;
class BaseProgress extends FoundationElement {
  constructor() {
    super(...arguments), this.percentComplete = 0;
  }
  valueChanged() {
    this.$fastController.isConnected && this.updatePercentComplete();
  }
  minChanged() {
    this.$fastController.isConnected && this.updatePercentComplete();
  }
  maxChanged() {
    this.$fastController.isConnected && this.updatePercentComplete();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.updatePercentComplete();
  }
  updatePercentComplete() {
    const Ae = typeof this.min == "number" ? this.min : 0, xr = typeof this.max == "number" ? this.max : 100, ed = typeof this.value == "number" ? this.value : 0, id = xr - Ae;
    this.percentComplete = id === 0 ? 0 : Math.fround((ed - Ae) / id * 100);
  }
}
__decorate([
  attr({ converter: nullableNumberConverter })
], BaseProgress.prototype, "value", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], BaseProgress.prototype, "min", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], BaseProgress.prototype, "max", void 0);
__decorate([
  attr({ mode: "boolean" })
], BaseProgress.prototype, "paused", void 0);
__decorate([
  observable
], BaseProgress.prototype, "percentComplete", void 0);
const progressTemplate = (td, Ae) => html`
    <template
        role="progressbar"
        aria-valuenow="${(xr) => xr.value}"
        aria-valuemin="${(xr) => xr.min}"
        aria-valuemax="${(xr) => xr.max}"
        class="${(xr) => xr.paused ? "paused" : ""}"
    >
        ${when((xr) => typeof xr.value == "number", html`
                <div class="progress" part="progress" slot="determinate">
                    <div
                        class="determinate"
                        part="determinate"
                        style="width: ${(xr) => xr.percentComplete}%"
                    ></div>
                </div>
            `, html`
                <div class="progress" part="progress" slot="indeterminate">
                    <slot class="indeterminate" name="indeterminate">
                        ${Ae.indeterminateIndicator1 || ""}
                        ${Ae.indeterminateIndicator2 || ""}
                    </slot>
                </div>
            `)}
    </template>
`, radioGroupTemplate = (td, Ae) => html`
    <template
        role="radiogroup"
        aria-disabled="${(xr) => xr.disabled}"
        aria-readonly="${(xr) => xr.readOnly}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
        @keydown="${(xr, ed) => xr.keydownHandler(ed.event)}"
        @focusout="${(xr, ed) => xr.focusOutHandler(ed.event)}"
    >
        <slot name="label"></slot>
        <div
            class="positioning-region ${(xr) => xr.orientation === Orientation$1.horizontal ? "horizontal" : "vertical"}"
            part="positioning-region"
        >
            <slot
                ${slotted({
  property: "slottedRadioButtons",
  filter: elements("[role=radio]")
})}
            ></slot>
        </div>
    </template>
`;
let RadioGroup$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.orientation = Orientation$1.horizontal, this.radioChangeHandler = (Ae) => {
      const xr = Ae.target;
      xr.checked && (this.slottedRadioButtons.forEach((ed) => {
        ed !== xr && (ed.checked = !1, this.isInsideFoundationToolbar || ed.setAttribute("tabindex", "-1"));
      }), this.selectedRadio = xr, this.value = xr.value, xr.setAttribute("tabindex", "0"), this.focusedRadio = xr), Ae.stopPropagation();
    }, this.moveToRadioByIndex = (Ae, xr) => {
      const ed = Ae[xr];
      this.isInsideToolbar || (ed.setAttribute("tabindex", "0"), ed.readOnly ? this.slottedRadioButtons.forEach((id) => {
        id !== ed && id.setAttribute("tabindex", "-1");
      }) : (ed.checked = !0, this.selectedRadio = ed)), this.focusedRadio = ed, ed.focus();
    }, this.moveRightOffGroup = () => {
      var Ae;
      (Ae = this.nextElementSibling) === null || Ae === void 0 || Ae.focus();
    }, this.moveLeftOffGroup = () => {
      var Ae;
      (Ae = this.previousElementSibling) === null || Ae === void 0 || Ae.focus();
    }, this.focusOutHandler = (Ae) => {
      const xr = this.slottedRadioButtons, ed = Ae.target, id = ed !== null ? xr.indexOf(ed) : 0, od = this.focusedRadio ? xr.indexOf(this.focusedRadio) : -1;
      return (od === 0 && id === od || od === xr.length - 1 && od === id) && (this.selectedRadio ? (this.focusedRadio = this.selectedRadio, this.isInsideFoundationToolbar || (this.selectedRadio.setAttribute("tabindex", "0"), xr.forEach((ad) => {
        ad !== this.selectedRadio && ad.setAttribute("tabindex", "-1");
      }))) : (this.focusedRadio = xr[0], this.focusedRadio.setAttribute("tabindex", "0"), xr.forEach((ad) => {
        ad !== this.focusedRadio && ad.setAttribute("tabindex", "-1");
      }))), !0;
    }, this.clickHandler = (Ae) => {
      const xr = Ae.target;
      if (xr) {
        const ed = this.slottedRadioButtons;
        xr.checked || ed.indexOf(xr) === 0 ? (xr.setAttribute("tabindex", "0"), this.selectedRadio = xr) : (xr.setAttribute("tabindex", "-1"), this.selectedRadio = null), this.focusedRadio = xr;
      }
      Ae.preventDefault();
    }, this.shouldMoveOffGroupToTheRight = (Ae, xr, ed) => Ae === xr.length && this.isInsideToolbar && ed === keyArrowRight$1, this.shouldMoveOffGroupToTheLeft = (Ae, xr) => (this.focusedRadio ? Ae.indexOf(this.focusedRadio) - 1 : 0) < 0 && this.isInsideToolbar && xr === keyArrowLeft$1, this.checkFocusedRadio = () => {
      this.focusedRadio !== null && !this.focusedRadio.readOnly && !this.focusedRadio.checked && (this.focusedRadio.checked = !0, this.focusedRadio.setAttribute("tabindex", "0"), this.focusedRadio.focus(), this.selectedRadio = this.focusedRadio);
    }, this.moveRight = (Ae) => {
      const xr = this.slottedRadioButtons;
      let ed = 0;
      if (ed = this.focusedRadio ? xr.indexOf(this.focusedRadio) + 1 : 1, this.shouldMoveOffGroupToTheRight(ed, xr, Ae.key)) {
        this.moveRightOffGroup();
        return;
      } else
        ed === xr.length && (ed = 0);
      for (; ed < xr.length && xr.length > 1; )
        if (xr[ed].disabled) {
          if (this.focusedRadio && ed === xr.indexOf(this.focusedRadio))
            break;
          if (ed + 1 >= xr.length) {
            if (this.isInsideToolbar)
              break;
            ed = 0;
          } else
            ed += 1;
        } else {
          this.moveToRadioByIndex(xr, ed);
          break;
        }
    }, this.moveLeft = (Ae) => {
      const xr = this.slottedRadioButtons;
      let ed = 0;
      if (ed = this.focusedRadio ? xr.indexOf(this.focusedRadio) - 1 : 0, ed = ed < 0 ? xr.length - 1 : ed, this.shouldMoveOffGroupToTheLeft(xr, Ae.key)) {
        this.moveLeftOffGroup();
        return;
      }
      for (; ed >= 0 && xr.length > 1; )
        if (xr[ed].disabled) {
          if (this.focusedRadio && ed === xr.indexOf(this.focusedRadio))
            break;
          ed - 1 < 0 ? ed = xr.length - 1 : ed -= 1;
        } else {
          this.moveToRadioByIndex(xr, ed);
          break;
        }
    }, this.keydownHandler = (Ae) => {
      const xr = Ae.key;
      if (xr in ArrowKeys$1 && this.isInsideFoundationToolbar)
        return !0;
      switch (xr) {
        case keyEnter$1: {
          this.checkFocusedRadio();
          break;
        }
        case keyArrowRight$1:
        case keyArrowDown$1: {
          this.direction === Direction$1.ltr ? this.moveRight(Ae) : this.moveLeft(Ae);
          break;
        }
        case keyArrowLeft$1:
        case keyArrowUp$1: {
          this.direction === Direction$1.ltr ? this.moveLeft(Ae) : this.moveRight(Ae);
          break;
        }
        default:
          return !0;
      }
    };
  }
  readOnlyChanged() {
    this.slottedRadioButtons !== void 0 && this.slottedRadioButtons.forEach((Ae) => {
      this.readOnly ? Ae.readOnly = !0 : Ae.readOnly = !1;
    });
  }
  disabledChanged() {
    this.slottedRadioButtons !== void 0 && this.slottedRadioButtons.forEach((Ae) => {
      this.disabled ? Ae.disabled = !0 : Ae.disabled = !1;
    });
  }
  nameChanged() {
    this.slottedRadioButtons && this.slottedRadioButtons.forEach((Ae) => {
      Ae.setAttribute("name", this.name);
    });
  }
  valueChanged() {
    this.slottedRadioButtons && this.slottedRadioButtons.forEach((Ae) => {
      Ae.value === this.value && (Ae.checked = !0, this.selectedRadio = Ae);
    }), this.$emit("change");
  }
  slottedRadioButtonsChanged(Ae, xr) {
    this.slottedRadioButtons && this.slottedRadioButtons.length > 0 && this.setupRadioButtons();
  }
  get parentToolbar() {
    return this.closest('[role="toolbar"]');
  }
  get isInsideToolbar() {
    var Ae;
    return (Ae = this.parentToolbar) !== null && Ae !== void 0 ? Ae : !1;
  }
  get isInsideFoundationToolbar() {
    var Ae;
    return !!(!((Ae = this.parentToolbar) === null || Ae === void 0) && Ae.$fastController);
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.direction = getDirection$1(this), this.setupRadioButtons();
  }
  disconnectedCallback() {
    this.slottedRadioButtons.forEach((Ae) => {
      Ae.removeEventListener("change", this.radioChangeHandler);
    });
  }
  setupRadioButtons() {
    const Ae = this.slottedRadioButtons.filter((id) => id.hasAttribute("checked")), xr = Ae ? Ae.length : 0;
    if (xr > 1) {
      const id = Ae[xr - 1];
      id.checked = !0;
    }
    let ed = !1;
    if (this.slottedRadioButtons.forEach((id) => {
      this.name !== void 0 && id.setAttribute("name", this.name), this.disabled && (id.disabled = !0), this.readOnly && (id.readOnly = !0), this.value && this.value === id.value ? (this.selectedRadio = id, this.focusedRadio = id, id.checked = !0, id.setAttribute("tabindex", "0"), ed = !0) : (this.isInsideFoundationToolbar || id.setAttribute("tabindex", "-1"), id.checked = !1), id.addEventListener("change", this.radioChangeHandler);
    }), this.value === void 0 && this.slottedRadioButtons.length > 0) {
      const id = this.slottedRadioButtons.filter((ad) => ad.hasAttribute("checked")), od = id !== null ? id.length : 0;
      if (od > 0 && !ed) {
        const ad = id[od - 1];
        ad.checked = !0, this.focusedRadio = ad, ad.setAttribute("tabindex", "0");
      } else
        this.slottedRadioButtons[0].setAttribute("tabindex", "0"), this.focusedRadio = this.slottedRadioButtons[0];
    }
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], RadioGroup$1.prototype, "readOnly", void 0);
__decorate([
  attr({ attribute: "disabled", mode: "boolean" })
], RadioGroup$1.prototype, "disabled", void 0);
__decorate([
  attr
], RadioGroup$1.prototype, "name", void 0);
__decorate([
  attr
], RadioGroup$1.prototype, "value", void 0);
__decorate([
  attr
], RadioGroup$1.prototype, "orientation", void 0);
__decorate([
  observable
], RadioGroup$1.prototype, "childItems", void 0);
__decorate([
  observable
], RadioGroup$1.prototype, "slottedRadioButtons", void 0);
const radioTemplate = (td, Ae) => html`
    <template
        role="radio"
        class="${(xr) => xr.checked ? "checked" : ""} ${(xr) => xr.readOnly ? "readonly" : ""}"
        aria-checked="${(xr) => xr.checked}"
        aria-required="${(xr) => xr.required}"
        aria-disabled="${(xr) => xr.disabled}"
        aria-readonly="${(xr) => xr.readOnly}"
        @keypress="${(xr, ed) => xr.keypressHandler(ed.event)}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
    >
        <div part="control" class="control">
            <slot name="checked-indicator">
                ${Ae.checkedIndicator || ""}
            </slot>
        </div>
        <label
            part="label"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot ${slotted("defaultSlottedNodes")}></slot>
        </label>
    </template>
`;
class _Radio extends FoundationElement {
}
class FormAssociatedRadio extends CheckableFormAssociated(_Radio) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
let Radio$1 = class extends FormAssociatedRadio {
  constructor() {
    super(), this.initialValue = "on", this.keypressHandler = (Ae) => {
      switch (Ae.key) {
        case keySpace$1:
          !this.checked && !this.readOnly && (this.checked = !0);
          return;
      }
      return !0;
    }, this.proxy.setAttribute("type", "radio");
  }
  readOnlyChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.readOnly = this.readOnly);
  }
  /**
   * @internal
   */
  defaultCheckedChanged() {
    var Ae;
    this.$fastController.isConnected && !this.dirtyChecked && (this.isInsideRadioGroup() || (this.checked = (Ae = this.defaultChecked) !== null && Ae !== void 0 ? Ae : !1, this.dirtyChecked = !1));
  }
  /**
   * @internal
   */
  connectedCallback() {
    var Ae, xr;
    super.connectedCallback(), this.validate(), ((Ae = this.parentElement) === null || Ae === void 0 ? void 0 : Ae.getAttribute("role")) !== "radiogroup" && this.getAttribute("tabindex") === null && (this.disabled || this.setAttribute("tabindex", "0")), this.checkedAttribute && (this.dirtyChecked || this.isInsideRadioGroup() || (this.checked = (xr = this.defaultChecked) !== null && xr !== void 0 ? xr : !1, this.dirtyChecked = !1));
  }
  isInsideRadioGroup() {
    return this.closest("[role=radiogroup]") !== null;
  }
  /**
   * @internal
   */
  clickHandler(Ae) {
    !this.disabled && !this.readOnly && !this.checked && (this.checked = !0);
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], Radio$1.prototype, "readOnly", void 0);
__decorate([
  observable
], Radio$1.prototype, "name", void 0);
__decorate([
  observable
], Radio$1.prototype, "defaultSlottedNodes", void 0);
class HorizontalScroll extends FoundationElement {
  constructor() {
    super(...arguments), this.framesPerSecond = 60, this.updatingItems = !1, this.speed = 600, this.easing = "ease-in-out", this.flippersHiddenFromAT = !1, this.scrolling = !1, this.resizeDetector = null;
  }
  /**
   * The calculated duration for a frame.
   *
   * @internal
   */
  get frameTime() {
    return 1e3 / this.framesPerSecond;
  }
  /**
   * Firing scrollstart and scrollend events
   * @internal
   */
  scrollingChanged(Ae, xr) {
    if (this.scrollContainer) {
      const ed = this.scrolling == !0 ? "scrollstart" : "scrollend";
      this.$emit(ed, this.scrollContainer.scrollLeft);
    }
  }
  /**
   * In RTL mode
   * @internal
   */
  get isRtl() {
    return this.scrollItems.length > 1 && this.scrollItems[0].offsetLeft > this.scrollItems[1].offsetLeft;
  }
  connectedCallback() {
    super.connectedCallback(), this.initializeResizeDetector();
  }
  disconnectedCallback() {
    this.disconnectResizeDetector(), super.disconnectedCallback();
  }
  /**
   * Updates scroll stops and flippers when scroll items change
   * @param previous - current scroll items
   * @param next - new updated scroll items
   * @public
   */
  scrollItemsChanged(Ae, xr) {
    xr && !this.updatingItems && DOM.queueUpdate(() => this.setStops());
  }
  /**
   * destroys the instance's resize observer
   * @internal
   */
  disconnectResizeDetector() {
    this.resizeDetector && (this.resizeDetector.disconnect(), this.resizeDetector = null);
  }
  /**
   * initializes the instance's resize observer
   * @internal
   */
  initializeResizeDetector() {
    this.disconnectResizeDetector(), this.resizeDetector = new window.ResizeObserver(this.resized.bind(this)), this.resizeDetector.observe(this);
  }
  /**
   * Looks for slots and uses child nodes instead
   * @internal
   */
  updateScrollStops() {
    this.updatingItems = !0;
    const Ae = this.scrollItems.reduce((xr, ed) => ed instanceof HTMLSlotElement ? xr.concat(ed.assignedElements()) : (xr.push(ed), xr), []);
    this.scrollItems = Ae, this.updatingItems = !1;
  }
  /**
   * Finds all of the scroll stops between elements
   * @internal
   */
  setStops() {
    this.updateScrollStops();
    const { scrollContainer: Ae } = this, { scrollLeft: xr } = Ae, { width: ed, left: id } = Ae.getBoundingClientRect();
    this.width = ed;
    let od = 0, ad = this.scrollItems.map((rd, sd) => {
      const { left: nd, width: cd } = rd.getBoundingClientRect(), ud = Math.round(nd + xr - id), ld = Math.round(ud + cd);
      return this.isRtl ? -ld : (od = ld, sd === 0 ? 0 : ud);
    }).concat(od);
    ad = this.fixScrollMisalign(ad), ad.sort((rd, sd) => Math.abs(rd) - Math.abs(sd)), this.scrollStops = ad, this.setFlippers();
  }
  /**
   * Checks to see if the stops are returning values
   *  otherwise it will try to reinitialize them
   *
   * @returns boolean indicating that current scrollStops are valid non-zero values
   * @internal
   */
  validateStops(Ae = !0) {
    const xr = () => !!this.scrollStops.find((ed) => ed > 0);
    return !xr() && Ae && this.setStops(), xr();
  }
  /**
   *
   */
  fixScrollMisalign(Ae) {
    if (this.isRtl && Ae.some((xr) => xr > 0)) {
      Ae.sort((ed, id) => id - ed);
      const xr = Ae[0];
      Ae = Ae.map((ed) => ed - xr);
    }
    return Ae;
  }
  /**
   * Sets the controls view if enabled
   * @internal
   */
  setFlippers() {
    var Ae, xr;
    const ed = this.scrollContainer.scrollLeft;
    if ((Ae = this.previousFlipperContainer) === null || Ae === void 0 || Ae.classList.toggle("disabled", ed === 0), this.scrollStops) {
      const id = Math.abs(this.scrollStops[this.scrollStops.length - 1]);
      (xr = this.nextFlipperContainer) === null || xr === void 0 || xr.classList.toggle("disabled", this.validateStops(!1) && Math.abs(ed) + this.width >= id);
    }
  }
  /**
   * Function that can scroll an item into view.
   * @param item - An item index, a scroll item or a child of one of the scroll items
   * @param padding - Padding of the viewport where the active item shouldn't be
   * @param rightPadding - Optional right padding. Uses the padding if not defined
   *
   * @public
   */
  scrollInView(Ae, xr = 0, ed) {
    var id;
    if (typeof Ae != "number" && Ae && (Ae = this.scrollItems.findIndex((od) => od === Ae || od.contains(Ae))), Ae !== void 0) {
      ed = ed != null ? ed : xr;
      const { scrollContainer: od, scrollStops: ad, scrollItems: rd } = this, { scrollLeft: sd } = this.scrollContainer, { width: nd } = od.getBoundingClientRect(), cd = ad[Ae], { width: ud } = rd[Ae].getBoundingClientRect(), ld = cd + ud, dd = sd + xr > cd;
      if (dd || sd + nd - ed < ld) {
        const md = (id = [...ad].sort((fd, bd) => dd ? bd - fd : fd - bd).find((fd) => dd ? fd + xr < cd : fd + nd - (ed != null ? ed : 0) > ld)) !== null && id !== void 0 ? id : 0;
        this.scrollToPosition(md);
      }
    }
  }
  /**
   * Lets the user arrow left and right through the horizontal scroll
   * @param e - Keyboard event
   * @public
   */
  keyupHandler(Ae) {
    switch (Ae.key) {
      case "ArrowLeft":
        this.scrollToPrevious();
        break;
      case "ArrowRight":
        this.scrollToNext();
        break;
    }
  }
  /**
   * Scrolls items to the left
   * @public
   */
  scrollToPrevious() {
    this.validateStops();
    const Ae = this.scrollContainer.scrollLeft, xr = this.scrollStops.findIndex((od, ad) => od >= Ae && (this.isRtl || ad === this.scrollStops.length - 1 || this.scrollStops[ad + 1] > Ae)), ed = Math.abs(this.scrollStops[xr + 1]);
    let id = this.scrollStops.findIndex((od) => Math.abs(od) + this.width > ed);
    (id >= xr || id === -1) && (id = xr > 0 ? xr - 1 : 0), this.scrollToPosition(this.scrollStops[id], Ae);
  }
  /**
   * Scrolls items to the right
   * @public
   */
  scrollToNext() {
    this.validateStops();
    const Ae = this.scrollContainer.scrollLeft, xr = this.scrollStops.findIndex((od) => Math.abs(od) >= Math.abs(Ae)), ed = this.scrollStops.findIndex((od) => Math.abs(Ae) + this.width <= Math.abs(od));
    let id = xr;
    ed > xr + 2 ? id = ed - 2 : xr < this.scrollStops.length - 2 && (id = xr + 1), this.scrollToPosition(this.scrollStops[id], Ae);
  }
  /**
   * Handles scrolling with easing
   * @param position - starting position
   * @param newPosition - position to scroll to
   * @public
   */
  scrollToPosition(Ae, xr = this.scrollContainer.scrollLeft) {
    var ed;
    if (this.scrolling)
      return;
    this.scrolling = !0;
    const id = (ed = this.duration) !== null && ed !== void 0 ? ed : `${Math.abs(Ae - xr) / this.speed}s`;
    this.content.style.setProperty("transition-duration", id);
    const od = parseFloat(getComputedStyle(this.content).getPropertyValue("transition-duration")), ad = (nd) => {
      nd && nd.target !== nd.currentTarget || (this.content.style.setProperty("transition-duration", "0s"), this.content.style.removeProperty("transform"), this.scrollContainer.style.setProperty("scroll-behavior", "auto"), this.scrollContainer.scrollLeft = Ae, this.setFlippers(), this.content.removeEventListener("transitionend", ad), this.scrolling = !1);
    };
    if (od === 0) {
      ad();
      return;
    }
    this.content.addEventListener("transitionend", ad);
    const rd = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
    let sd = this.scrollContainer.scrollLeft - Math.min(Ae, rd);
    this.isRtl && (sd = this.scrollContainer.scrollLeft + Math.min(Math.abs(Ae), rd)), this.content.style.setProperty("transition-property", "transform"), this.content.style.setProperty("transition-timing-function", this.easing), this.content.style.setProperty("transform", `translateX(${sd}px)`);
  }
  /**
   * Monitors resize event on the horizontal-scroll element
   * @public
   */
  resized() {
    this.resizeTimeout && (this.resizeTimeout = clearTimeout(this.resizeTimeout)), this.resizeTimeout = setTimeout(() => {
      this.width = this.scrollContainer.offsetWidth, this.setFlippers();
    }, this.frameTime);
  }
  /**
   * Monitors scrolled event on the content container
   * @public
   */
  scrolled() {
    this.scrollTimeout && (this.scrollTimeout = clearTimeout(this.scrollTimeout)), this.scrollTimeout = setTimeout(() => {
      this.setFlippers();
    }, this.frameTime);
  }
}
__decorate([
  attr({ converter: nullableNumberConverter })
], HorizontalScroll.prototype, "speed", void 0);
__decorate([
  attr
], HorizontalScroll.prototype, "duration", void 0);
__decorate([
  attr
], HorizontalScroll.prototype, "easing", void 0);
__decorate([
  attr({ attribute: "flippers-hidden-from-at", converter: booleanConverter })
], HorizontalScroll.prototype, "flippersHiddenFromAT", void 0);
__decorate([
  observable
], HorizontalScroll.prototype, "scrolling", void 0);
__decorate([
  observable
], HorizontalScroll.prototype, "scrollItems", void 0);
__decorate([
  attr({ attribute: "view" })
], HorizontalScroll.prototype, "view", void 0);
const horizontalScrollTemplate = (td, Ae) => {
  var xr, ed;
  return html`
    <template
        class="horizontal-scroll"
        @keyup="${(id, od) => id.keyupHandler(od.event)}"
    >
        ${startSlotTemplate(td, Ae)}
        <div class="scroll-area" part="scroll-area">
            <div
                class="scroll-view"
                part="scroll-view"
                @scroll="${(id) => id.scrolled()}"
                ${ref("scrollContainer")}
            >
                <div class="content-container" part="content-container" ${ref("content")}>
                    <slot
                        ${slotted({
    property: "scrollItems",
    filter: elements()
  })}
                    ></slot>
                </div>
            </div>
            ${when((id) => id.view !== "mobile", html`
                    <div
                        class="scroll scroll-prev"
                        part="scroll-prev"
                        ${ref("previousFlipperContainer")}
                    >
                        <div class="scroll-action" part="scroll-action-previous">
                            <slot name="previous-flipper">
                                ${Ae.previousFlipper instanceof Function ? Ae.previousFlipper(td, Ae) : (xr = Ae.previousFlipper) !== null && xr !== void 0 ? xr : ""}
                            </slot>
                        </div>
                    </div>
                    <div
                        class="scroll scroll-next"
                        part="scroll-next"
                        ${ref("nextFlipperContainer")}
                    >
                        <div class="scroll-action" part="scroll-action-next">
                            <slot name="next-flipper">
                                ${Ae.nextFlipper instanceof Function ? Ae.nextFlipper(td, Ae) : (ed = Ae.nextFlipper) !== null && ed !== void 0 ? ed : ""}
                            </slot>
                        </div>
                    </div>
                `)}
        </div>
        ${endSlotTemplate(td, Ae)}
    </template>
`;
};
function whitespaceFilter(td, Ae, xr) {
  return td.nodeType !== Node.TEXT_NODE ? !0 : typeof td.nodeValue == "string" && !!td.nodeValue.trim().length;
}
const searchTemplate = (td, Ae) => html`
    <template
        class="
            ${(xr) => xr.readOnly ? "readonly" : ""}
        "
    >
        <label
            part="label"
            for="control"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot
                ${slotted({ property: "defaultSlottedNodes", filter: whitespaceFilter })}
            ></slot>
        </label>
        <div class="root" part="root" ${ref("root")}>
            ${startSlotTemplate(td, Ae)}
            <div class="input-wrapper" part="input-wrapper">
                <input
                    class="control"
                    part="control"
                    id="control"
                    @input="${(xr) => xr.handleTextInput()}"
                    @change="${(xr) => xr.handleChange()}"
                    ?autofocus="${(xr) => xr.autofocus}"
                    ?disabled="${(xr) => xr.disabled}"
                    list="${(xr) => xr.list}"
                    maxlength="${(xr) => xr.maxlength}"
                    minlength="${(xr) => xr.minlength}"
                    pattern="${(xr) => xr.pattern}"
                    placeholder="${(xr) => xr.placeholder}"
                    ?readonly="${(xr) => xr.readOnly}"
                    ?required="${(xr) => xr.required}"
                    size="${(xr) => xr.size}"
                    ?spellcheck="${(xr) => xr.spellcheck}"
                    :value="${(xr) => xr.value}"
                    type="search"
                    aria-atomic="${(xr) => xr.ariaAtomic}"
                    aria-busy="${(xr) => xr.ariaBusy}"
                    aria-controls="${(xr) => xr.ariaControls}"
                    aria-current="${(xr) => xr.ariaCurrent}"
                    aria-describedby="${(xr) => xr.ariaDescribedby}"
                    aria-details="${(xr) => xr.ariaDetails}"
                    aria-disabled="${(xr) => xr.ariaDisabled}"
                    aria-errormessage="${(xr) => xr.ariaErrormessage}"
                    aria-flowto="${(xr) => xr.ariaFlowto}"
                    aria-haspopup="${(xr) => xr.ariaHaspopup}"
                    aria-hidden="${(xr) => xr.ariaHidden}"
                    aria-invalid="${(xr) => xr.ariaInvalid}"
                    aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
                    aria-label="${(xr) => xr.ariaLabel}"
                    aria-labelledby="${(xr) => xr.ariaLabelledby}"
                    aria-live="${(xr) => xr.ariaLive}"
                    aria-owns="${(xr) => xr.ariaOwns}"
                    aria-relevant="${(xr) => xr.ariaRelevant}"
                    aria-roledescription="${(xr) => xr.ariaRoledescription}"
                    ${ref("control")}
                />
                <slot name="close-button">
                    <button
                        class="clear-button ${(xr) => xr.value ? "" : "clear-button__hidden"}"
                        part="clear-button"
                        tabindex="-1"
                        @click=${(xr) => xr.handleClearInput()}
                    >
                        <slot name="close-glyph">
                            <svg
                                width="9"
                                height="9"
                                viewBox="0 0 9 9"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.146447 0.146447C0.338683 -0.0478972 0.645911 -0.0270359 0.853553 0.146447L4.5 3.793L8.14645 0.146447C8.34171 -0.0488155 8.65829 -0.0488155 8.85355 0.146447C9.04882 0.341709 9.04882 0.658291 8.85355 0.853553L5.207 4.5L8.85355 8.14645C9.05934 8.35223 9.03129 8.67582 8.85355 8.85355C8.67582 9.03129 8.35409 9.02703 8.14645 8.85355L4.5 5.207L0.853553 8.85355C0.658291 9.04882 0.341709 9.04882 0.146447 8.85355C-0.0488155 8.65829 -0.0488155 8.34171 0.146447 8.14645L3.793 4.5L0.146447 0.853553C-0.0268697 0.680237 -0.0457894 0.34079 0.146447 0.146447Z"
                                />
                            </svg>
                        </slot>
                    </button>
                </slot>
            </div>
            ${endSlotTemplate(td, Ae)}
        </div>
    </template>
`;
class _Search extends FoundationElement {
}
class FormAssociatedSearch extends FormAssociated(_Search) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
let Search$1 = class extends FormAssociatedSearch {
  readOnlyChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.readOnly = this.readOnly, this.validate());
  }
  autofocusChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.autofocus = this.autofocus, this.validate());
  }
  placeholderChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.placeholder = this.placeholder);
  }
  listChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.setAttribute("list", this.list), this.validate());
  }
  maxlengthChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.maxLength = this.maxlength, this.validate());
  }
  minlengthChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.minLength = this.minlength, this.validate());
  }
  patternChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.pattern = this.pattern, this.validate());
  }
  sizeChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.size = this.size);
  }
  spellcheckChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.spellcheck = this.spellcheck);
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.validate(), this.autofocus && DOM.queueUpdate(() => {
      this.focus();
    });
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  /**
   * Handles the internal control's `input` event
   * @internal
   */
  handleTextInput() {
    this.value = this.control.value;
  }
  /**
   * Handles the control's clear value event
   * @public
   */
  handleClearInput() {
    this.value = "", this.control.focus(), this.handleChange();
  }
  /**
   * Change event handler for inner control.
   * @remarks
   * "Change" events are not `composable` so they will not
   * permeate the shadow DOM boundary. This fn effectively proxies
   * the change event, emitting a `change` event whenever the internal
   * control emits a `change` event
   * @internal
   */
  handleChange() {
    this.$emit("change");
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], Search$1.prototype, "readOnly", void 0);
__decorate([
  attr({ mode: "boolean" })
], Search$1.prototype, "autofocus", void 0);
__decorate([
  attr
], Search$1.prototype, "placeholder", void 0);
__decorate([
  attr
], Search$1.prototype, "list", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Search$1.prototype, "maxlength", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Search$1.prototype, "minlength", void 0);
__decorate([
  attr
], Search$1.prototype, "pattern", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Search$1.prototype, "size", void 0);
__decorate([
  attr({ mode: "boolean" })
], Search$1.prototype, "spellcheck", void 0);
__decorate([
  observable
], Search$1.prototype, "defaultSlottedNodes", void 0);
class DelegatesARIASearch {
}
applyMixins(DelegatesARIASearch, ARIAGlobalStatesAndProperties);
applyMixins(Search$1, StartEnd, DelegatesARIASearch);
let _Select$1 = class extends ListboxElement {
}, FormAssociatedSelect$1 = class extends FormAssociated(_Select$1) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("select");
  }
}, Select$1 = class extends FormAssociatedSelect$1 {
  constructor() {
    super(...arguments), this.open = !1, this.forcedPosition = !1, this.listboxId = uniqueId$1("listbox-"), this.maxHeight = 0;
  }
  /**
   * Sets focus and synchronizes ARIA attributes when the open property changes.
   *
   * @param prev - the previous open value
   * @param next - the current open value
   *
   * @internal
   */
  openChanged(Ae, xr) {
    if (this.collapsible) {
      if (this.open) {
        this.ariaControls = this.listboxId, this.ariaExpanded = "true", this.setPositioning(), this.focusAndScrollOptionIntoView(), this.indexWhenOpened = this.selectedIndex, DOM.queueUpdate(() => this.focus());
        return;
      }
      this.ariaControls = "", this.ariaExpanded = "false";
    }
  }
  /**
   * The component is collapsible when in single-selection mode with no size attribute.
   *
   * @internal
   */
  get collapsible() {
    return !(this.multiple || typeof this.size == "number");
  }
  /**
   * The value property.
   *
   * @public
   */
  get value() {
    return Observable.track(this, "value"), this._value;
  }
  set value(Ae) {
    var xr, ed, id, od, ad, rd, sd;
    const nd = `${this._value}`;
    if (!((xr = this._options) === null || xr === void 0) && xr.length) {
      const cd = this._options.findIndex((dd) => dd.value === Ae), ud = (id = (ed = this._options[this.selectedIndex]) === null || ed === void 0 ? void 0 : ed.value) !== null && id !== void 0 ? id : null, ld = (ad = (od = this._options[cd]) === null || od === void 0 ? void 0 : od.value) !== null && ad !== void 0 ? ad : null;
      (cd === -1 || ud !== ld) && (Ae = "", this.selectedIndex = cd), Ae = (sd = (rd = this.firstSelectedOption) === null || rd === void 0 ? void 0 : rd.value) !== null && sd !== void 0 ? sd : Ae;
    }
    nd !== Ae && (this._value = Ae, super.valueChanged(nd, Ae), Observable.notify(this, "value"), this.updateDisplayValue());
  }
  /**
   * Sets the value and display value to match the first selected option.
   *
   * @param shouldEmit - if true, the input and change events will be emitted
   *
   * @internal
   */
  updateValue(Ae) {
    var xr, ed;
    this.$fastController.isConnected && (this.value = (ed = (xr = this.firstSelectedOption) === null || xr === void 0 ? void 0 : xr.value) !== null && ed !== void 0 ? ed : ""), Ae && (this.$emit("input"), this.$emit("change", this, {
      bubbles: !0,
      composed: void 0
    }));
  }
  /**
   * Updates the proxy value when the selected index changes.
   *
   * @param prev - the previous selected index
   * @param next - the next selected index
   *
   * @internal
   */
  selectedIndexChanged(Ae, xr) {
    super.selectedIndexChanged(Ae, xr), this.updateValue();
  }
  positionChanged(Ae, xr) {
    this.positionAttribute = xr, this.setPositioning();
  }
  /**
   * Calculate and apply listbox positioning based on available viewport space.
   *
   * @public
   */
  setPositioning() {
    const Ae = this.getBoundingClientRect(), ed = window.innerHeight - Ae.bottom;
    this.position = this.forcedPosition ? this.positionAttribute : Ae.top > ed ? SelectPosition$1.above : SelectPosition$1.below, this.positionAttribute = this.forcedPosition ? this.positionAttribute : this.position, this.maxHeight = this.position === SelectPosition$1.above ? ~~Ae.top : ~~ed;
  }
  /**
   * The value displayed on the button.
   *
   * @public
   */
  get displayValue() {
    var Ae, xr;
    return Observable.track(this, "displayValue"), (xr = (Ae = this.firstSelectedOption) === null || Ae === void 0 ? void 0 : Ae.text) !== null && xr !== void 0 ? xr : "";
  }
  /**
   * Synchronize the `aria-disabled` property when the `disabled` property changes.
   *
   * @param prev - The previous disabled value
   * @param next - The next disabled value
   *
   * @internal
   */
  disabledChanged(Ae, xr) {
    super.disabledChanged && super.disabledChanged(Ae, xr), this.ariaDisabled = this.disabled ? "true" : "false";
  }
  /**
   * Reset the element to its first selectable option when its parent form is reset.
   *
   * @internal
   */
  formResetCallback() {
    this.setProxyOptions(), super.setDefaultSelectedOption(), this.selectedIndex === -1 && (this.selectedIndex = 0);
  }
  /**
   * Handle opening and closing the listbox when the select is clicked.
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(Ae) {
    if (!this.disabled) {
      if (this.open) {
        const xr = Ae.target.closest("option,[role=option]");
        if (xr && xr.disabled)
          return;
      }
      return super.clickHandler(Ae), this.open = this.collapsible && !this.open, !this.open && this.indexWhenOpened !== this.selectedIndex && this.updateValue(!0), !0;
    }
  }
  /**
   * Handles focus state when the element or its children lose focus.
   *
   * @param e - The focus event
   * @internal
   */
  focusoutHandler(Ae) {
    var xr;
    if (super.focusoutHandler(Ae), !this.open)
      return !0;
    const ed = Ae.relatedTarget;
    if (this.isSameNode(ed)) {
      this.focus();
      return;
    }
    !((xr = this.options) === null || xr === void 0) && xr.includes(ed) || (this.open = !1, this.indexWhenOpened !== this.selectedIndex && this.updateValue(!0));
  }
  /**
   * Updates the value when an option's value changes.
   *
   * @param source - the source object
   * @param propertyName - the property to evaluate
   *
   * @internal
   * @override
   */
  handleChange(Ae, xr) {
    super.handleChange(Ae, xr), xr === "value" && this.updateValue();
  }
  /**
   * Synchronize the form-associated proxy and updates the value property of the element.
   *
   * @param prev - the previous collection of slotted option elements
   * @param next - the next collection of slotted option elements
   *
   * @internal
   */
  slottedOptionsChanged(Ae, xr) {
    this.options.forEach((ed) => {
      Observable.getNotifier(ed).unsubscribe(this, "value");
    }), super.slottedOptionsChanged(Ae, xr), this.options.forEach((ed) => {
      Observable.getNotifier(ed).subscribe(this, "value");
    }), this.setProxyOptions(), this.updateValue();
  }
  /**
   * Prevents focus when size is set and a scrollbar is clicked.
   *
   * @param e - the mouse event object
   *
   * @override
   * @internal
   */
  mousedownHandler(Ae) {
    var xr;
    return Ae.offsetX >= 0 && Ae.offsetX <= ((xr = this.listbox) === null || xr === void 0 ? void 0 : xr.scrollWidth) ? super.mousedownHandler(Ae) : this.collapsible;
  }
  /**
   * Sets the multiple property on the proxy element.
   *
   * @param prev - the previous multiple value
   * @param next - the current multiple value
   */
  multipleChanged(Ae, xr) {
    super.multipleChanged(Ae, xr), this.proxy && (this.proxy.multiple = xr);
  }
  /**
   * Updates the selectedness of each option when the list of selected options changes.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @override
   * @internal
   */
  selectedOptionsChanged(Ae, xr) {
    var ed;
    super.selectedOptionsChanged(Ae, xr), (ed = this.options) === null || ed === void 0 || ed.forEach((id, od) => {
      var ad;
      const rd = (ad = this.proxy) === null || ad === void 0 ? void 0 : ad.options.item(od);
      rd && (rd.selected = id.selected);
    });
  }
  /**
   * Sets the selected index to match the first option with the selected attribute, or
   * the first selectable option.
   *
   * @override
   * @internal
   */
  setDefaultSelectedOption() {
    var Ae;
    const xr = (Ae = this.options) !== null && Ae !== void 0 ? Ae : Array.from(this.children).filter(Listbox$1.slottedOptionFilter), ed = xr == null ? void 0 : xr.findIndex((id) => id.hasAttribute("selected") || id.selected || id.value === this.value);
    if (ed !== -1) {
      this.selectedIndex = ed;
      return;
    }
    this.selectedIndex = 0;
  }
  /**
   * Resets and fills the proxy to match the component's options.
   *
   * @internal
   */
  setProxyOptions() {
    this.proxy instanceof HTMLSelectElement && this.options && (this.proxy.options.length = 0, this.options.forEach((Ae) => {
      const xr = Ae.proxy || (Ae instanceof HTMLOptionElement ? Ae.cloneNode() : null);
      xr && this.proxy.options.add(xr);
    }));
  }
  /**
   * Handle keyboard interaction for the select.
   *
   * @param e - the keyboard event
   * @internal
   */
  keydownHandler(Ae) {
    super.keydownHandler(Ae);
    const xr = Ae.key || Ae.key.charCodeAt(0);
    switch (xr) {
      case keySpace$1: {
        Ae.preventDefault(), this.collapsible && this.typeAheadExpired && (this.open = !this.open);
        break;
      }
      case keyHome$1:
      case keyEnd$1: {
        Ae.preventDefault();
        break;
      }
      case keyEnter$1: {
        Ae.preventDefault(), this.open = !this.open;
        break;
      }
      case keyEscape$1: {
        this.collapsible && this.open && (Ae.preventDefault(), this.open = !1);
        break;
      }
      case keyTab$1:
        return this.collapsible && this.open && (Ae.preventDefault(), this.open = !1), !0;
    }
    return !this.open && this.indexWhenOpened !== this.selectedIndex && (this.updateValue(!0), this.indexWhenOpened = this.selectedIndex), !(xr === keyArrowDown$1 || xr === keyArrowUp$1);
  }
  connectedCallback() {
    super.connectedCallback(), this.forcedPosition = !!this.positionAttribute, this.addEventListener("contentchange", this.updateDisplayValue);
  }
  disconnectedCallback() {
    this.removeEventListener("contentchange", this.updateDisplayValue), super.disconnectedCallback();
  }
  /**
   * Updates the proxy's size property when the size attribute changes.
   *
   * @param prev - the previous size
   * @param next - the current size
   *
   * @override
   * @internal
   */
  sizeChanged(Ae, xr) {
    super.sizeChanged(Ae, xr), this.proxy && (this.proxy.size = xr);
  }
  /**
   *
   * @internal
   */
  updateDisplayValue() {
    this.collapsible && Observable.notify(this, "displayValue");
  }
};
__decorate([
  attr({ attribute: "open", mode: "boolean" })
], Select$1.prototype, "open", void 0);
__decorate([
  volatile
], Select$1.prototype, "collapsible", null);
__decorate([
  observable
], Select$1.prototype, "control", void 0);
__decorate([
  attr({ attribute: "position" })
], Select$1.prototype, "positionAttribute", void 0);
__decorate([
  observable
], Select$1.prototype, "position", void 0);
__decorate([
  observable
], Select$1.prototype, "maxHeight", void 0);
class DelegatesARIASelect {
}
__decorate([
  observable
], DelegatesARIASelect.prototype, "ariaControls", void 0);
applyMixins(DelegatesARIASelect, DelegatesARIAListbox);
applyMixins(Select$1, StartEnd, DelegatesARIASelect);
const selectTemplate = (td, Ae) => html`
    <template
        class="${(xr) => [
  xr.collapsible && "collapsible",
  xr.collapsible && xr.open && "open",
  xr.disabled && "disabled",
  xr.collapsible && xr.position
].filter(Boolean).join(" ")}"
        aria-activedescendant="${(xr) => xr.ariaActiveDescendant}"
        aria-controls="${(xr) => xr.ariaControls}"
        aria-disabled="${(xr) => xr.ariaDisabled}"
        aria-expanded="${(xr) => xr.ariaExpanded}"
        aria-haspopup="${(xr) => xr.collapsible ? "listbox" : null}"
        aria-multiselectable="${(xr) => xr.ariaMultiSelectable}"
        ?open="${(xr) => xr.open}"
        role="combobox"
        tabindex="${(xr) => xr.disabled ? null : "0"}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
        @focusin="${(xr, ed) => xr.focusinHandler(ed.event)}"
        @focusout="${(xr, ed) => xr.focusoutHandler(ed.event)}"
        @keydown="${(xr, ed) => xr.keydownHandler(ed.event)}"
        @mousedown="${(xr, ed) => xr.mousedownHandler(ed.event)}"
    >
        ${when((xr) => xr.collapsible, html`
                <div
                    class="control"
                    part="control"
                    ?disabled="${(xr) => xr.disabled}"
                    ${ref("control")}
                >
                    ${startSlotTemplate(td, Ae)}
                    <slot name="button-container">
                        <div class="selected-value" part="selected-value">
                            <slot name="selected-value">${(xr) => xr.displayValue}</slot>
                        </div>
                        <div aria-hidden="true" class="indicator" part="indicator">
                            <slot name="indicator">
                                ${Ae.indicator || ""}
                            </slot>
                        </div>
                    </slot>
                    ${endSlotTemplate(td, Ae)}
                </div>
            `)}
        <div
            class="listbox"
            id="${(xr) => xr.listboxId}"
            part="listbox"
            role="listbox"
            ?disabled="${(xr) => xr.disabled}"
            ?hidden="${(xr) => xr.collapsible ? !xr.open : !1}"
            ${ref("listbox")}
        >
            <slot
                ${slotted({
  filter: Listbox$1.slottedOptionFilter,
  flatten: !0,
  property: "slottedOptions"
})}
            ></slot>
        </div>
    </template>
`, skeletonTemplate = (td, Ae) => html`
    <template
        class="${(xr) => xr.shape === "circle" ? "circle" : "rect"}"
        pattern="${(xr) => xr.pattern}"
        ?shimmer="${(xr) => xr.shimmer}"
    >
        ${when((xr) => xr.shimmer === !0, html`
                <span class="shimmer"></span>
            `)}
        <object type="image/svg+xml" data="${(xr) => xr.pattern}" role="presentation">
            <img class="pattern" src="${(xr) => xr.pattern}" />
        </object>
        <slot></slot>
    </template>
`;
let Skeleton$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.shape = "rect";
  }
};
__decorate([
  attr
], Skeleton$1.prototype, "fill", void 0);
__decorate([
  attr
], Skeleton$1.prototype, "shape", void 0);
__decorate([
  attr
], Skeleton$1.prototype, "pattern", void 0);
__decorate([
  attr({ mode: "boolean" })
], Skeleton$1.prototype, "shimmer", void 0);
const sliderLabelTemplate = (td, Ae) => html`
    <template
        aria-disabled="${(xr) => xr.disabled}"
        class="${(xr) => xr.sliderOrientation || Orientation$1.horizontal}
            ${(xr) => xr.disabled ? "disabled" : ""}"
    >
        <div ${ref("root")} part="root" class="root" style="${(xr) => xr.positionStyle}">
            <div class="container">
                ${when((xr) => !xr.hideMark, html`
                        <div class="mark"></div>
                    `)}
                <div class="label">
                    <slot></slot>
                </div>
            </div>
        </div>
    </template>
`;
function convertPixelToPercent(td, Ae, xr, ed) {
  let id = limit$1(0, 1, (td - Ae) / (xr - Ae));
  return ed === Direction$1.rtl && (id = 1 - id), id;
}
const defaultConfig = {
  min: 0,
  max: 0,
  direction: Direction$1.ltr,
  orientation: Orientation$1.horizontal,
  disabled: !1
};
let SliderLabel$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.hideMark = !1, this.sliderDirection = Direction$1.ltr, this.getSliderConfiguration = () => {
      if (!this.isSliderConfig(this.parentNode))
        this.sliderDirection = defaultConfig.direction || Direction$1.ltr, this.sliderOrientation = defaultConfig.orientation, this.sliderMaxPosition = defaultConfig.max, this.sliderMinPosition = defaultConfig.min;
      else {
        const Ae = this.parentNode, { min: xr, max: ed, direction: id, orientation: od, disabled: ad } = Ae;
        ad !== void 0 && (this.disabled = ad), this.sliderDirection = id || Direction$1.ltr, this.sliderOrientation = od || Orientation$1.horizontal, this.sliderMaxPosition = ed, this.sliderMinPosition = xr;
      }
    }, this.positionAsStyle = () => {
      const Ae = this.sliderDirection ? this.sliderDirection : Direction$1.ltr, xr = convertPixelToPercent(Number(this.position), Number(this.sliderMinPosition), Number(this.sliderMaxPosition));
      let ed = Math.round((1 - xr) * 100), id = Math.round(xr * 100);
      return Number.isNaN(id) && Number.isNaN(ed) && (ed = 50, id = 50), this.sliderOrientation === Orientation$1.horizontal ? Ae === Direction$1.rtl ? `right: ${id}%; left: ${ed}%;` : `left: ${id}%; right: ${ed}%;` : `top: ${id}%; bottom: ${ed}%;`;
    };
  }
  positionChanged() {
    this.positionStyle = this.positionAsStyle();
  }
  /**
   * @internal
   */
  sliderOrientationChanged() {
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.getSliderConfiguration(), this.positionStyle = this.positionAsStyle(), this.notifier = Observable.getNotifier(this.parentNode), this.notifier.subscribe(this, "orientation"), this.notifier.subscribe(this, "direction"), this.notifier.subscribe(this, "max"), this.notifier.subscribe(this, "min");
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.notifier.unsubscribe(this, "orientation"), this.notifier.unsubscribe(this, "direction"), this.notifier.unsubscribe(this, "max"), this.notifier.unsubscribe(this, "min");
  }
  /**
   * @internal
   */
  handleChange(Ae, xr) {
    switch (xr) {
      case "direction":
        this.sliderDirection = Ae.direction;
        break;
      case "orientation":
        this.sliderOrientation = Ae.orientation;
        break;
      case "max":
        this.sliderMaxPosition = Ae.max;
        break;
      case "min":
        this.sliderMinPosition = Ae.min;
        break;
    }
    this.positionStyle = this.positionAsStyle();
  }
  isSliderConfig(Ae) {
    return Ae.max !== void 0 && Ae.min !== void 0;
  }
};
__decorate([
  observable
], SliderLabel$1.prototype, "positionStyle", void 0);
__decorate([
  attr
], SliderLabel$1.prototype, "position", void 0);
__decorate([
  attr({ attribute: "hide-mark", mode: "boolean" })
], SliderLabel$1.prototype, "hideMark", void 0);
__decorate([
  attr({ attribute: "disabled", mode: "boolean" })
], SliderLabel$1.prototype, "disabled", void 0);
__decorate([
  observable
], SliderLabel$1.prototype, "sliderOrientation", void 0);
__decorate([
  observable
], SliderLabel$1.prototype, "sliderMinPosition", void 0);
__decorate([
  observable
], SliderLabel$1.prototype, "sliderMaxPosition", void 0);
__decorate([
  observable
], SliderLabel$1.prototype, "sliderDirection", void 0);
const sliderTemplate = (td, Ae) => html`
    <template
        role="slider"
        class="${(xr) => xr.readOnly ? "readonly" : ""}
        ${(xr) => xr.orientation || Orientation$1.horizontal}"
        tabindex="${(xr) => xr.disabled ? null : 0}"
        aria-valuetext="${(xr) => xr.valueTextFormatter(xr.value)}"
        aria-valuenow="${(xr) => xr.value}"
        aria-valuemin="${(xr) => xr.min}"
        aria-valuemax="${(xr) => xr.max}"
        aria-disabled="${(xr) => xr.disabled ? !0 : void 0}"
        aria-readonly="${(xr) => xr.readOnly ? !0 : void 0}"
        aria-orientation="${(xr) => xr.orientation}"
        class="${(xr) => xr.orientation}"
    >
        <div part="positioning-region" class="positioning-region">
            <div ${ref("track")} part="track-container" class="track">
                <slot name="track"></slot>
                <div part="track-start" class="track-start" style="${(xr) => xr.position}">
                    <slot name="track-start"></slot>
                </div>
            </div>
            <slot></slot>
            <div
                ${ref("thumb")}
                part="thumb-container"
                class="thumb-container"
                style="${(xr) => xr.position}"
            >
                <slot name="thumb">${Ae.thumb || ""}</slot>
            </div>
        </div>
    </template>
`;
class _Slider extends FoundationElement {
}
class FormAssociatedSlider extends FormAssociated(_Slider) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
const SliderMode = {
  singleValue: "single-value"
};
let Slider$1 = class extends FormAssociatedSlider {
  constructor() {
    super(...arguments), this.direction = Direction$1.ltr, this.isDragging = !1, this.trackWidth = 0, this.trackMinWidth = 0, this.trackHeight = 0, this.trackLeft = 0, this.trackMinHeight = 0, this.valueTextFormatter = () => null, this.min = 0, this.max = 10, this.step = 1, this.orientation = Orientation$1.horizontal, this.mode = SliderMode.singleValue, this.keypressHandler = (Ae) => {
      if (!this.readOnly) {
        if (Ae.key === keyHome$1)
          Ae.preventDefault(), this.value = `${this.min}`;
        else if (Ae.key === keyEnd$1)
          Ae.preventDefault(), this.value = `${this.max}`;
        else if (!Ae.shiftKey)
          switch (Ae.key) {
            case keyArrowRight$1:
            case keyArrowUp$1:
              Ae.preventDefault(), this.increment();
              break;
            case keyArrowLeft$1:
            case keyArrowDown$1:
              Ae.preventDefault(), this.decrement();
              break;
          }
      }
    }, this.setupTrackConstraints = () => {
      const Ae = this.track.getBoundingClientRect();
      this.trackWidth = this.track.clientWidth, this.trackMinWidth = this.track.clientLeft, this.trackHeight = Ae.bottom, this.trackMinHeight = Ae.top, this.trackLeft = this.getBoundingClientRect().left, this.trackWidth === 0 && (this.trackWidth = 1);
    }, this.setupListeners = (Ae = !1) => {
      const xr = `${Ae ? "remove" : "add"}EventListener`;
      this[xr]("keydown", this.keypressHandler), this[xr]("mousedown", this.handleMouseDown), this.thumb[xr]("mousedown", this.handleThumbMouseDown, {
        passive: !0
      }), this.thumb[xr]("touchstart", this.handleThumbMouseDown, {
        passive: !0
      }), Ae && (this.handleMouseDown(null), this.handleThumbMouseDown(null));
    }, this.initialValue = "", this.handleThumbMouseDown = (Ae) => {
      if (Ae) {
        if (this.readOnly || this.disabled || Ae.defaultPrevented)
          return;
        Ae.target.focus();
      }
      const xr = `${Ae !== null ? "add" : "remove"}EventListener`;
      window[xr]("mouseup", this.handleWindowMouseUp), window[xr]("mousemove", this.handleMouseMove, { passive: !0 }), window[xr]("touchmove", this.handleMouseMove, { passive: !0 }), window[xr]("touchend", this.handleWindowMouseUp), this.isDragging = Ae !== null;
    }, this.handleMouseMove = (Ae) => {
      if (this.readOnly || this.disabled || Ae.defaultPrevented)
        return;
      const xr = window.TouchEvent && Ae instanceof TouchEvent ? Ae.touches[0] : Ae, ed = this.orientation === Orientation$1.horizontal ? xr.pageX - document.documentElement.scrollLeft - this.trackLeft : xr.pageY - document.documentElement.scrollTop;
      this.value = `${this.calculateNewValue(ed)}`;
    }, this.calculateNewValue = (Ae) => {
      const xr = convertPixelToPercent(Ae, this.orientation === Orientation$1.horizontal ? this.trackMinWidth : this.trackMinHeight, this.orientation === Orientation$1.horizontal ? this.trackWidth : this.trackHeight, this.direction), ed = (this.max - this.min) * xr + this.min;
      return this.convertToConstrainedValue(ed);
    }, this.handleWindowMouseUp = (Ae) => {
      this.stopDragging();
    }, this.stopDragging = () => {
      this.isDragging = !1, this.handleMouseDown(null), this.handleThumbMouseDown(null);
    }, this.handleMouseDown = (Ae) => {
      const xr = `${Ae !== null ? "add" : "remove"}EventListener`;
      if ((Ae === null || !this.disabled && !this.readOnly) && (window[xr]("mouseup", this.handleWindowMouseUp), window.document[xr]("mouseleave", this.handleWindowMouseUp), window[xr]("mousemove", this.handleMouseMove), Ae)) {
        Ae.preventDefault(), this.setupTrackConstraints(), Ae.target.focus();
        const ed = this.orientation === Orientation$1.horizontal ? Ae.pageX - document.documentElement.scrollLeft - this.trackLeft : Ae.pageY - document.documentElement.scrollTop;
        this.value = `${this.calculateNewValue(ed)}`;
      }
    }, this.convertToConstrainedValue = (Ae) => {
      isNaN(Ae) && (Ae = this.min);
      let xr = Ae - this.min;
      const ed = Math.round(xr / this.step), id = xr - ed * (this.stepMultiplier * this.step) / this.stepMultiplier;
      return xr = id >= Number(this.step) / 2 ? xr - id + Number(this.step) : xr - id, xr + this.min;
    };
  }
  readOnlyChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.readOnly = this.readOnly);
  }
  /**
   * The value property, typed as a number.
   *
   * @public
   */
  get valueAsNumber() {
    return parseFloat(super.value);
  }
  set valueAsNumber(Ae) {
    this.value = Ae.toString();
  }
  /**
   * @internal
   */
  valueChanged(Ae, xr) {
    super.valueChanged(Ae, xr), this.$fastController.isConnected && this.setThumbPositionForOrientation(this.direction), this.$emit("change");
  }
  minChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.min = `${this.min}`), this.validate();
  }
  maxChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.max = `${this.max}`), this.validate();
  }
  stepChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.step = `${this.step}`), this.updateStepMultiplier(), this.validate();
  }
  orientationChanged() {
    this.$fastController.isConnected && this.setThumbPositionForOrientation(this.direction);
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.proxy.setAttribute("type", "range"), this.direction = getDirection$1(this), this.updateStepMultiplier(), this.setupTrackConstraints(), this.setupListeners(), this.setupDefaultValue(), this.setThumbPositionForOrientation(this.direction);
  }
  /**
   * @internal
   */
  disconnectedCallback() {
    this.setupListeners(!0);
  }
  /**
   * Increment the value by the step
   *
   * @public
   */
  increment() {
    const Ae = this.direction !== Direction$1.rtl && this.orientation !== Orientation$1.vertical ? Number(this.value) + Number(this.step) : Number(this.value) - Number(this.step), xr = this.convertToConstrainedValue(Ae), ed = xr < Number(this.max) ? `${xr}` : `${this.max}`;
    this.value = ed;
  }
  /**
   * Decrement the value by the step
   *
   * @public
   */
  decrement() {
    const Ae = this.direction !== Direction$1.rtl && this.orientation !== Orientation$1.vertical ? Number(this.value) - Number(this.step) : Number(this.value) + Number(this.step), xr = this.convertToConstrainedValue(Ae), ed = xr > Number(this.min) ? `${xr}` : `${this.min}`;
    this.value = ed;
  }
  /**
   * Places the thumb based on the current value
   *
   * @public
   * @param direction - writing mode
   */
  setThumbPositionForOrientation(Ae) {
    const ed = (1 - convertPixelToPercent(Number(this.value), Number(this.min), Number(this.max), Ae)) * 100;
    this.orientation === Orientation$1.horizontal ? this.position = this.isDragging ? `right: ${ed}%; transition: none;` : `right: ${ed}%; transition: all 0.2s ease;` : this.position = this.isDragging ? `bottom: ${ed}%; transition: none;` : `bottom: ${ed}%; transition: all 0.2s ease;`;
  }
  /**
   * Update the step multiplier used to ensure rounding errors from steps that
   * are not whole numbers
   */
  updateStepMultiplier() {
    const Ae = this.step + "", xr = this.step % 1 ? Ae.length - Ae.indexOf(".") - 1 : 0;
    this.stepMultiplier = Math.pow(10, xr);
  }
  get midpoint() {
    return `${this.convertToConstrainedValue((this.max + this.min) / 2)}`;
  }
  setupDefaultValue() {
    if (typeof this.value == "string")
      if (this.value.length === 0)
        this.initialValue = this.midpoint;
      else {
        const Ae = parseFloat(this.value);
        !Number.isNaN(Ae) && (Ae < this.min || Ae > this.max) && (this.value = this.midpoint);
      }
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], Slider$1.prototype, "readOnly", void 0);
__decorate([
  observable
], Slider$1.prototype, "direction", void 0);
__decorate([
  observable
], Slider$1.prototype, "isDragging", void 0);
__decorate([
  observable
], Slider$1.prototype, "position", void 0);
__decorate([
  observable
], Slider$1.prototype, "trackWidth", void 0);
__decorate([
  observable
], Slider$1.prototype, "trackMinWidth", void 0);
__decorate([
  observable
], Slider$1.prototype, "trackHeight", void 0);
__decorate([
  observable
], Slider$1.prototype, "trackLeft", void 0);
__decorate([
  observable
], Slider$1.prototype, "trackMinHeight", void 0);
__decorate([
  observable
], Slider$1.prototype, "valueTextFormatter", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Slider$1.prototype, "min", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Slider$1.prototype, "max", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], Slider$1.prototype, "step", void 0);
__decorate([
  attr
], Slider$1.prototype, "orientation", void 0);
__decorate([
  attr
], Slider$1.prototype, "mode", void 0);
const switchTemplate = (td, Ae) => html`
    <template
        role="switch"
        aria-checked="${(xr) => xr.checked}"
        aria-disabled="${(xr) => xr.disabled}"
        aria-readonly="${(xr) => xr.readOnly}"
        tabindex="${(xr) => xr.disabled ? null : 0}"
        @keypress="${(xr, ed) => xr.keypressHandler(ed.event)}"
        @click="${(xr, ed) => xr.clickHandler(ed.event)}"
        class="${(xr) => xr.checked ? "checked" : ""}"
    >
        <label
            part="label"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot ${slotted("defaultSlottedNodes")}></slot>
        </label>
        <div part="switch" class="switch">
            <slot name="switch">${Ae.switch || ""}</slot>
        </div>
        <span class="status-message" part="status-message">
            <span class="checked-message" part="checked-message">
                <slot name="checked-message"></slot>
            </span>
            <span class="unchecked-message" part="unchecked-message">
                <slot name="unchecked-message"></slot>
            </span>
        </span>
    </template>
`;
class _Switch extends FoundationElement {
}
class FormAssociatedSwitch extends CheckableFormAssociated(_Switch) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
let Switch$1 = class extends FormAssociatedSwitch {
  constructor() {
    super(), this.initialValue = "on", this.keypressHandler = (Ae) => {
      if (!this.readOnly)
        switch (Ae.key) {
          case keyEnter$1:
          case keySpace$1:
            this.checked = !this.checked;
            break;
        }
    }, this.clickHandler = (Ae) => {
      !this.disabled && !this.readOnly && (this.checked = !this.checked);
    }, this.proxy.setAttribute("type", "checkbox");
  }
  readOnlyChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.readOnly = this.readOnly), this.readOnly ? this.classList.add("readonly") : this.classList.remove("readonly");
  }
  /**
   * @internal
   */
  checkedChanged(Ae, xr) {
    super.checkedChanged(Ae, xr), this.checked ? this.classList.add("checked") : this.classList.remove("checked");
  }
};
__decorate([
  attr({ attribute: "readonly", mode: "boolean" })
], Switch$1.prototype, "readOnly", void 0);
__decorate([
  observable
], Switch$1.prototype, "defaultSlottedNodes", void 0);
const tabPanelTemplate = (td, Ae) => html`
    <template slot="tabpanel" role="tabpanel">
        <slot></slot>
    </template>
`;
let TabPanel$1 = class extends FoundationElement {
};
const tabTemplate = (td, Ae) => html`
    <template slot="tab" role="tab" aria-disabled="${(xr) => xr.disabled}">
        <slot></slot>
    </template>
`;
let Tab$1 = class extends FoundationElement {
};
__decorate([
  attr({ mode: "boolean" })
], Tab$1.prototype, "disabled", void 0);
const tabsTemplate = (td, Ae) => html`
    <template class="${(xr) => xr.orientation}">
        ${startSlotTemplate(td, Ae)}
        <div class="tablist" part="tablist" role="tablist">
            <slot class="tab" name="tab" part="tab" ${slotted("tabs")}></slot>

            ${when((xr) => xr.showActiveIndicator, html`
                    <div
                        ${ref("activeIndicatorRef")}
                        class="activeIndicator"
                        part="activeIndicator"
                    ></div>
                `)}
        </div>
        ${endSlotTemplate(td, Ae)}
        <div class="tabpanel" part="tabpanel">
            <slot name="tabpanel" ${slotted("tabpanels")}></slot>
        </div>
    </template>
`, TabsOrientation$1 = {
  vertical: "vertical",
  horizontal: "horizontal"
};
let Tabs$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.orientation = TabsOrientation$1.horizontal, this.activeindicator = !0, this.showActiveIndicator = !0, this.prevActiveTabIndex = 0, this.activeTabIndex = 0, this.ticking = !1, this.change = () => {
      this.$emit("change", this.activetab);
    }, this.isDisabledElement = (Ae) => Ae.getAttribute("aria-disabled") === "true", this.isHiddenElement = (Ae) => Ae.hasAttribute("hidden"), this.isFocusableElement = (Ae) => !this.isDisabledElement(Ae) && !this.isHiddenElement(Ae), this.setTabs = () => {
      const Ae = "gridColumn", xr = "gridRow", ed = this.isHorizontal() ? Ae : xr;
      this.activeTabIndex = this.getActiveIndex(), this.showActiveIndicator = !1, this.tabs.forEach((id, od) => {
        if (id.slot === "tab") {
          const ad = this.activeTabIndex === od && this.isFocusableElement(id);
          this.activeindicator && this.isFocusableElement(id) && (this.showActiveIndicator = !0);
          const rd = this.tabIds[od], sd = this.tabpanelIds[od];
          id.setAttribute("id", rd), id.setAttribute("aria-selected", ad ? "true" : "false"), id.setAttribute("aria-controls", sd), id.addEventListener("click", this.handleTabClick), id.addEventListener("keydown", this.handleTabKeyDown), id.setAttribute("tabindex", ad ? "0" : "-1"), ad && (this.activetab = id, this.activeid = rd);
        }
        id.style[Ae] = "", id.style[xr] = "", id.style[ed] = `${od + 1}`, this.isHorizontal() ? id.classList.remove("vertical") : id.classList.add("vertical");
      });
    }, this.setTabPanels = () => {
      this.tabpanels.forEach((Ae, xr) => {
        const ed = this.tabIds[xr], id = this.tabpanelIds[xr];
        Ae.setAttribute("id", id), Ae.setAttribute("aria-labelledby", ed), this.activeTabIndex !== xr ? Ae.setAttribute("hidden", "") : Ae.removeAttribute("hidden");
      });
    }, this.handleTabClick = (Ae) => {
      const xr = Ae.currentTarget;
      xr.nodeType === 1 && this.isFocusableElement(xr) && (this.prevActiveTabIndex = this.activeTabIndex, this.activeTabIndex = this.tabs.indexOf(xr), this.setComponent());
    }, this.handleTabKeyDown = (Ae) => {
      if (this.isHorizontal())
        switch (Ae.key) {
          case keyArrowLeft$1:
            Ae.preventDefault(), this.adjustBackward(Ae);
            break;
          case keyArrowRight$1:
            Ae.preventDefault(), this.adjustForward(Ae);
            break;
        }
      else
        switch (Ae.key) {
          case keyArrowUp$1:
            Ae.preventDefault(), this.adjustBackward(Ae);
            break;
          case keyArrowDown$1:
            Ae.preventDefault(), this.adjustForward(Ae);
            break;
        }
      switch (Ae.key) {
        case keyHome$1:
          Ae.preventDefault(), this.adjust(-this.activeTabIndex);
          break;
        case keyEnd$1:
          Ae.preventDefault(), this.adjust(this.tabs.length - this.activeTabIndex - 1);
          break;
      }
    }, this.adjustForward = (Ae) => {
      const xr = this.tabs;
      let ed = 0;
      for (ed = this.activetab ? xr.indexOf(this.activetab) + 1 : 1, ed === xr.length && (ed = 0); ed < xr.length && xr.length > 1; )
        if (this.isFocusableElement(xr[ed])) {
          this.moveToTabByIndex(xr, ed);
          break;
        } else {
          if (this.activetab && ed === xr.indexOf(this.activetab))
            break;
          ed + 1 >= xr.length ? ed = 0 : ed += 1;
        }
    }, this.adjustBackward = (Ae) => {
      const xr = this.tabs;
      let ed = 0;
      for (ed = this.activetab ? xr.indexOf(this.activetab) - 1 : 0, ed = ed < 0 ? xr.length - 1 : ed; ed >= 0 && xr.length > 1; )
        if (this.isFocusableElement(xr[ed])) {
          this.moveToTabByIndex(xr, ed);
          break;
        } else
          ed - 1 < 0 ? ed = xr.length - 1 : ed -= 1;
    }, this.moveToTabByIndex = (Ae, xr) => {
      const ed = Ae[xr];
      this.activetab = ed, this.prevActiveTabIndex = this.activeTabIndex, this.activeTabIndex = xr, ed.focus(), this.setComponent();
    };
  }
  /**
   * @internal
   */
  orientationChanged() {
    this.$fastController.isConnected && (this.setTabs(), this.setTabPanels(), this.handleActiveIndicatorPosition());
  }
  /**
   * @internal
   */
  activeidChanged(Ae, xr) {
    this.$fastController.isConnected && this.tabs.length <= this.tabpanels.length && (this.prevActiveTabIndex = this.tabs.findIndex((ed) => ed.id === Ae), this.setTabs(), this.setTabPanels(), this.handleActiveIndicatorPosition());
  }
  /**
   * @internal
   */
  tabsChanged() {
    this.$fastController.isConnected && this.tabs.length <= this.tabpanels.length && (this.tabIds = this.getTabIds(), this.tabpanelIds = this.getTabPanelIds(), this.setTabs(), this.setTabPanels(), this.handleActiveIndicatorPosition());
  }
  /**
   * @internal
   */
  tabpanelsChanged() {
    this.$fastController.isConnected && this.tabpanels.length <= this.tabs.length && (this.tabIds = this.getTabIds(), this.tabpanelIds = this.getTabPanelIds(), this.setTabs(), this.setTabPanels(), this.handleActiveIndicatorPosition());
  }
  getActiveIndex() {
    return this.activeid !== void 0 ? this.tabIds.indexOf(this.activeid) === -1 ? 0 : this.tabIds.indexOf(this.activeid) : 0;
  }
  getTabIds() {
    return this.tabs.map((Ae) => {
      var xr;
      return (xr = Ae.getAttribute("id")) !== null && xr !== void 0 ? xr : `tab-${uniqueId$1()}`;
    });
  }
  getTabPanelIds() {
    return this.tabpanels.map((Ae) => {
      var xr;
      return (xr = Ae.getAttribute("id")) !== null && xr !== void 0 ? xr : `panel-${uniqueId$1()}`;
    });
  }
  setComponent() {
    this.activeTabIndex !== this.prevActiveTabIndex && (this.activeid = this.tabIds[this.activeTabIndex], this.focusTab(), this.change());
  }
  isHorizontal() {
    return this.orientation === TabsOrientation$1.horizontal;
  }
  handleActiveIndicatorPosition() {
    this.showActiveIndicator && this.activeindicator && this.activeTabIndex !== this.prevActiveTabIndex && (this.ticking ? this.ticking = !1 : (this.ticking = !0, this.animateActiveIndicator()));
  }
  animateActiveIndicator() {
    this.ticking = !0;
    const Ae = this.isHorizontal() ? "gridColumn" : "gridRow", xr = this.isHorizontal() ? "translateX" : "translateY", ed = this.isHorizontal() ? "offsetLeft" : "offsetTop", id = this.activeIndicatorRef[ed];
    this.activeIndicatorRef.style[Ae] = `${this.activeTabIndex + 1}`;
    const od = this.activeIndicatorRef[ed];
    this.activeIndicatorRef.style[Ae] = `${this.prevActiveTabIndex + 1}`;
    const ad = od - id;
    this.activeIndicatorRef.style.transform = `${xr}(${ad}px)`, this.activeIndicatorRef.classList.add("activeIndicatorTransition"), this.activeIndicatorRef.addEventListener("transitionend", () => {
      this.ticking = !1, this.activeIndicatorRef.style[Ae] = `${this.activeTabIndex + 1}`, this.activeIndicatorRef.style.transform = `${xr}(0px)`, this.activeIndicatorRef.classList.remove("activeIndicatorTransition");
    });
  }
  /**
   * The adjust method for FASTTabs
   * @public
   * @remarks
   * This method allows the active index to be adjusted by numerical increments
   */
  adjust(Ae) {
    const xr = this.tabs.filter((ad) => this.isFocusableElement(ad)), ed = xr.indexOf(this.activetab), id = limit$1(0, xr.length - 1, ed + Ae), od = this.tabs.indexOf(xr[id]);
    od > -1 && this.moveToTabByIndex(this.tabs, od);
  }
  focusTab() {
    this.tabs[this.activeTabIndex].focus();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.tabIds = this.getTabIds(), this.tabpanelIds = this.getTabPanelIds(), this.activeTabIndex = this.getActiveIndex();
  }
};
__decorate([
  attr
], Tabs$1.prototype, "orientation", void 0);
__decorate([
  attr
], Tabs$1.prototype, "activeid", void 0);
__decorate([
  observable
], Tabs$1.prototype, "tabs", void 0);
__decorate([
  observable
], Tabs$1.prototype, "tabpanels", void 0);
__decorate([
  attr({ mode: "boolean" })
], Tabs$1.prototype, "activeindicator", void 0);
__decorate([
  observable
], Tabs$1.prototype, "activeIndicatorRef", void 0);
__decorate([
  observable
], Tabs$1.prototype, "showActiveIndicator", void 0);
applyMixins(Tabs$1, StartEnd);
class _TextArea extends FoundationElement {
}
class FormAssociatedTextArea extends FormAssociated(_TextArea) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("textarea");
  }
}
const TextAreaResize = {
  /**
   * No resize.
   */
  none: "none",
  /**
   * Resize vertically and horizontally.
   */
  both: "both",
  /**
   * Resize horizontally.
   */
  horizontal: "horizontal",
  /**
   * Resize vertically.
   */
  vertical: "vertical"
};
let TextArea$1 = class extends FormAssociatedTextArea {
  constructor() {
    super(...arguments), this.resize = TextAreaResize.none, this.cols = 20, this.handleTextInput = () => {
      this.value = this.control.value;
    };
  }
  readOnlyChanged() {
    this.proxy instanceof HTMLTextAreaElement && (this.proxy.readOnly = this.readOnly);
  }
  autofocusChanged() {
    this.proxy instanceof HTMLTextAreaElement && (this.proxy.autofocus = this.autofocus);
  }
  listChanged() {
    this.proxy instanceof HTMLTextAreaElement && this.proxy.setAttribute("list", this.list);
  }
  maxlengthChanged() {
    this.proxy instanceof HTMLTextAreaElement && (this.proxy.maxLength = this.maxlength);
  }
  minlengthChanged() {
    this.proxy instanceof HTMLTextAreaElement && (this.proxy.minLength = this.minlength);
  }
  spellcheckChanged() {
    this.proxy instanceof HTMLTextAreaElement && (this.proxy.spellcheck = this.spellcheck);
  }
  /**
   * Selects all the text in the text area
   *
   * @public
   */
  select() {
    this.control.select(), this.$emit("select");
  }
  /**
   * Change event handler for inner control.
   * @remarks
   * "Change" events are not `composable` so they will not
   * permeate the shadow DOM boundary. This fn effectively proxies
   * the change event, emitting a `change` event whenever the internal
   * control emits a `change` event
   * @internal
   */
  handleChange() {
    this.$emit("change");
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
};
__decorate([
  attr({ mode: "boolean" })
], TextArea$1.prototype, "readOnly", void 0);
__decorate([
  attr
], TextArea$1.prototype, "resize", void 0);
__decorate([
  attr({ mode: "boolean" })
], TextArea$1.prototype, "autofocus", void 0);
__decorate([
  attr({ attribute: "form" })
], TextArea$1.prototype, "formId", void 0);
__decorate([
  attr
], TextArea$1.prototype, "list", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], TextArea$1.prototype, "maxlength", void 0);
__decorate([
  attr({ converter: nullableNumberConverter })
], TextArea$1.prototype, "minlength", void 0);
__decorate([
  attr
], TextArea$1.prototype, "name", void 0);
__decorate([
  attr
], TextArea$1.prototype, "placeholder", void 0);
__decorate([
  attr({ converter: nullableNumberConverter, mode: "fromView" })
], TextArea$1.prototype, "cols", void 0);
__decorate([
  attr({ converter: nullableNumberConverter, mode: "fromView" })
], TextArea$1.prototype, "rows", void 0);
__decorate([
  attr({ mode: "boolean" })
], TextArea$1.prototype, "spellcheck", void 0);
__decorate([
  observable
], TextArea$1.prototype, "defaultSlottedNodes", void 0);
applyMixins(TextArea$1, DelegatesARIATextbox);
const textAreaTemplate = (td, Ae) => html`
    <template
        class="
            ${(xr) => xr.readOnly ? "readonly" : ""}
            ${(xr) => xr.resize !== TextAreaResize.none ? `resize-${xr.resize}` : ""}"
    >
        <label
            part="label"
            for="control"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot ${slotted("defaultSlottedNodes")}></slot>
        </label>
        <textarea
            part="control"
            class="control"
            id="control"
            ?autofocus="${(xr) => xr.autofocus}"
            cols="${(xr) => xr.cols}"
            ?disabled="${(xr) => xr.disabled}"
            form="${(xr) => xr.form}"
            list="${(xr) => xr.list}"
            maxlength="${(xr) => xr.maxlength}"
            minlength="${(xr) => xr.minlength}"
            name="${(xr) => xr.name}"
            placeholder="${(xr) => xr.placeholder}"
            ?readonly="${(xr) => xr.readOnly}"
            ?required="${(xr) => xr.required}"
            rows="${(xr) => xr.rows}"
            ?spellcheck="${(xr) => xr.spellcheck}"
            :value="${(xr) => xr.value}"
            aria-atomic="${(xr) => xr.ariaAtomic}"
            aria-busy="${(xr) => xr.ariaBusy}"
            aria-controls="${(xr) => xr.ariaControls}"
            aria-current="${(xr) => xr.ariaCurrent}"
            aria-describedby="${(xr) => xr.ariaDescribedby}"
            aria-details="${(xr) => xr.ariaDetails}"
            aria-disabled="${(xr) => xr.ariaDisabled}"
            aria-errormessage="${(xr) => xr.ariaErrormessage}"
            aria-flowto="${(xr) => xr.ariaFlowto}"
            aria-haspopup="${(xr) => xr.ariaHaspopup}"
            aria-hidden="${(xr) => xr.ariaHidden}"
            aria-invalid="${(xr) => xr.ariaInvalid}"
            aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
            aria-label="${(xr) => xr.ariaLabel}"
            aria-labelledby="${(xr) => xr.ariaLabelledby}"
            aria-live="${(xr) => xr.ariaLive}"
            aria-owns="${(xr) => xr.ariaOwns}"
            aria-relevant="${(xr) => xr.ariaRelevant}"
            aria-roledescription="${(xr) => xr.ariaRoledescription}"
            @input="${(xr, ed) => xr.handleTextInput()}"
            @change="${(xr) => xr.handleChange()}"
            ${ref("control")}
        ></textarea>
    </template>
`, textFieldTemplate = (td, Ae) => html`
    <template
        class="
            ${(xr) => xr.readOnly ? "readonly" : ""}
        "
    >
        <label
            part="label"
            for="control"
            class="${(xr) => xr.defaultSlottedNodes && xr.defaultSlottedNodes.length ? "label" : "label label__hidden"}"
        >
            <slot
                ${slotted({ property: "defaultSlottedNodes", filter: whitespaceFilter })}
            ></slot>
        </label>
        <div class="root" part="root">
            ${startSlotTemplate(td, Ae)}
            <input
                class="control"
                part="control"
                id="control"
                @input="${(xr) => xr.handleTextInput()}"
                @change="${(xr) => xr.handleChange()}"
                ?autofocus="${(xr) => xr.autofocus}"
                ?disabled="${(xr) => xr.disabled}"
                list="${(xr) => xr.list}"
                maxlength="${(xr) => xr.maxlength}"
                minlength="${(xr) => xr.minlength}"
                pattern="${(xr) => xr.pattern}"
                placeholder="${(xr) => xr.placeholder}"
                ?readonly="${(xr) => xr.readOnly}"
                ?required="${(xr) => xr.required}"
                size="${(xr) => xr.size}"
                ?spellcheck="${(xr) => xr.spellcheck}"
                :value="${(xr) => xr.value}"
                type="${(xr) => xr.type}"
                aria-atomic="${(xr) => xr.ariaAtomic}"
                aria-busy="${(xr) => xr.ariaBusy}"
                aria-controls="${(xr) => xr.ariaControls}"
                aria-current="${(xr) => xr.ariaCurrent}"
                aria-describedby="${(xr) => xr.ariaDescribedby}"
                aria-details="${(xr) => xr.ariaDetails}"
                aria-disabled="${(xr) => xr.ariaDisabled}"
                aria-errormessage="${(xr) => xr.ariaErrormessage}"
                aria-flowto="${(xr) => xr.ariaFlowto}"
                aria-haspopup="${(xr) => xr.ariaHaspopup}"
                aria-hidden="${(xr) => xr.ariaHidden}"
                aria-invalid="${(xr) => xr.ariaInvalid}"
                aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
                aria-label="${(xr) => xr.ariaLabel}"
                aria-labelledby="${(xr) => xr.ariaLabelledby}"
                aria-live="${(xr) => xr.ariaLive}"
                aria-owns="${(xr) => xr.ariaOwns}"
                aria-relevant="${(xr) => xr.ariaRelevant}"
                aria-roledescription="${(xr) => xr.ariaRoledescription}"
                ${ref("control")}
            />
            ${endSlotTemplate(td, Ae)}
        </div>
    </template>
`, toolbarTemplate = (td, Ae) => html`
    <template
        aria-label="${(xr) => xr.ariaLabel}"
        aria-labelledby="${(xr) => xr.ariaLabelledby}"
        aria-orientation="${(xr) => xr.orientation}"
        orientation="${(xr) => xr.orientation}"
        role="toolbar"
        @mousedown="${(xr, ed) => xr.mouseDownHandler(ed.event)}"
        @focusin="${(xr, ed) => xr.focusinHandler(ed.event)}"
        @keydown="${(xr, ed) => xr.keydownHandler(ed.event)}"
        ${children({
  property: "childItems",
  attributeFilter: ["disabled", "hidden"],
  filter: elements(),
  subtree: !0
})}
    >
        <slot name="label"></slot>
        <div class="positioning-region" part="positioning-region">
            ${startSlotTemplate(td, Ae)}
            <slot
                ${slotted({
  filter: elements(),
  property: "slottedItems"
})}
            ></slot>
            ${endSlotTemplate(td, Ae)}
        </div>
    </template>
`, ToolbarArrowKeyMap = Object.freeze({
  [ArrowKeys$1.ArrowUp]: {
    [Orientation$1.vertical]: -1
  },
  [ArrowKeys$1.ArrowDown]: {
    [Orientation$1.vertical]: 1
  },
  [ArrowKeys$1.ArrowLeft]: {
    [Orientation$1.horizontal]: {
      [Direction$1.ltr]: -1,
      [Direction$1.rtl]: 1
    }
  },
  [ArrowKeys$1.ArrowRight]: {
    [Orientation$1.horizontal]: {
      [Direction$1.ltr]: 1,
      [Direction$1.rtl]: -1
    }
  }
});
let Toolbar$1 = class a0 extends FoundationElement {
  constructor() {
    super(...arguments), this._activeIndex = 0, this.direction = Direction$1.ltr, this.orientation = Orientation$1.horizontal;
  }
  /**
   * The index of the currently focused element, clamped between 0 and the last element.
   *
   * @internal
   */
  get activeIndex() {
    return Observable.track(this, "activeIndex"), this._activeIndex;
  }
  set activeIndex(Ae) {
    this.$fastController.isConnected && (this._activeIndex = limit$1(0, this.focusableElements.length - 1, Ae), Observable.notify(this, "activeIndex"));
  }
  slottedItemsChanged() {
    this.$fastController.isConnected && this.reduceFocusableElements();
  }
  /**
   * Set the activeIndex when a focusable element in the toolbar is clicked.
   *
   * @internal
   */
  mouseDownHandler(Ae) {
    var xr;
    const ed = (xr = this.focusableElements) === null || xr === void 0 ? void 0 : xr.findIndex((id) => id.contains(Ae.target));
    return ed > -1 && this.activeIndex !== ed && this.setFocusedElement(ed), !0;
  }
  childItemsChanged(Ae, xr) {
    this.$fastController.isConnected && this.reduceFocusableElements();
  }
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.direction = getDirection$1(this);
  }
  /**
   * When the toolbar receives focus, set the currently active element as focused.
   *
   * @internal
   */
  focusinHandler(Ae) {
    const xr = Ae.relatedTarget;
    !xr || this.contains(xr) || this.setFocusedElement();
  }
  /**
   * Determines a value that can be used to iterate a list with the arrow keys.
   *
   * @param this - An element with an orientation and direction
   * @param key - The event key value
   * @internal
   */
  getDirectionalIncrementer(Ae) {
    var xr, ed, id, od, ad;
    return (ad = (id = (ed = (xr = ToolbarArrowKeyMap[Ae]) === null || xr === void 0 ? void 0 : xr[this.orientation]) === null || ed === void 0 ? void 0 : ed[this.direction]) !== null && id !== void 0 ? id : (od = ToolbarArrowKeyMap[Ae]) === null || od === void 0 ? void 0 : od[this.orientation]) !== null && ad !== void 0 ? ad : 0;
  }
  /**
   * Handle keyboard events for the toolbar.
   *
   * @internal
   */
  keydownHandler(Ae) {
    const xr = Ae.key;
    if (!(xr in ArrowKeys$1) || Ae.defaultPrevented || Ae.shiftKey)
      return !0;
    const ed = this.getDirectionalIncrementer(xr);
    if (!ed)
      return !Ae.target.closest("[role=radiogroup]");
    const id = this.activeIndex + ed;
    return this.focusableElements[id] && Ae.preventDefault(), this.setFocusedElement(id), !0;
  }
  /**
   * get all the slotted elements
   * @internal
   */
  get allSlottedItems() {
    return [
      ...this.start.assignedElements(),
      ...this.slottedItems,
      ...this.end.assignedElements()
    ];
  }
  /**
   * Prepare the slotted elements which can be focusable.
   *
   * @internal
   */
  reduceFocusableElements() {
    var Ae;
    const xr = (Ae = this.focusableElements) === null || Ae === void 0 ? void 0 : Ae[this.activeIndex];
    this.focusableElements = this.allSlottedItems.reduce(a0.reduceFocusableItems, []);
    const ed = this.focusableElements.indexOf(xr);
    this.activeIndex = Math.max(0, ed), this.setFocusableElements();
  }
  /**
   * Set the activeIndex and focus the corresponding control.
   *
   * @param activeIndex - The new index to set
   * @internal
   */
  setFocusedElement(Ae = this.activeIndex) {
    var xr;
    this.activeIndex = Ae, this.setFocusableElements(), (xr = this.focusableElements[this.activeIndex]) === null || xr === void 0 || xr.focus();
  }
  /**
   * Reduce a collection to only its focusable elements.
   *
   * @param elements - Collection of elements to reduce
   * @param element - The current element
   *
   * @internal
   */
  static reduceFocusableItems(Ae, xr) {
    var ed, id, od, ad;
    const rd = xr.getAttribute("role") === "radio", sd = (id = (ed = xr.$fastController) === null || ed === void 0 ? void 0 : ed.definition.shadowOptions) === null || id === void 0 ? void 0 : id.delegatesFocus, nd = Array.from((ad = (od = xr.shadowRoot) === null || od === void 0 ? void 0 : od.querySelectorAll("*")) !== null && ad !== void 0 ? ad : []).some((cd) => isFocusable(cd));
    return !xr.hasAttribute("disabled") && !xr.hasAttribute("hidden") && (isFocusable(xr) || rd || sd || nd) ? (Ae.push(xr), Ae) : xr.childElementCount ? Ae.concat(Array.from(xr.children).reduce(a0.reduceFocusableItems, [])) : Ae;
  }
  /**
   * @internal
   */
  setFocusableElements() {
    this.$fastController.isConnected && this.focusableElements.length > 0 && this.focusableElements.forEach((Ae, xr) => {
      Ae.tabIndex = this.activeIndex === xr ? 0 : -1;
    });
  }
};
__decorate([
  observable
], Toolbar$1.prototype, "direction", void 0);
__decorate([
  attr
], Toolbar$1.prototype, "orientation", void 0);
__decorate([
  observable
], Toolbar$1.prototype, "slottedItems", void 0);
__decorate([
  observable
], Toolbar$1.prototype, "slottedLabel", void 0);
__decorate([
  observable
], Toolbar$1.prototype, "childItems", void 0);
class DelegatesARIAToolbar {
}
__decorate([
  attr({ attribute: "aria-labelledby" })
], DelegatesARIAToolbar.prototype, "ariaLabelledby", void 0);
__decorate([
  attr({ attribute: "aria-label" })
], DelegatesARIAToolbar.prototype, "ariaLabel", void 0);
applyMixins(DelegatesARIAToolbar, ARIAGlobalStatesAndProperties);
applyMixins(Toolbar$1, StartEnd, DelegatesARIAToolbar);
const tooltipTemplate$2 = (td, Ae) => html`
        ${when((xr) => xr.tooltipVisible, html`
            <${td.tagFor(AnchoredRegion)}
                fixed-placement="true"
                auto-update-mode="${(xr) => xr.autoUpdateMode}"
                vertical-positioning-mode="${(xr) => xr.verticalPositioningMode}"
                vertical-default-position="${(xr) => xr.verticalDefaultPosition}"
                vertical-inset="${(xr) => xr.verticalInset}"
                vertical-scaling="${(xr) => xr.verticalScaling}"
                horizontal-positioning-mode="${(xr) => xr.horizontalPositioningMode}"
                horizontal-default-position="${(xr) => xr.horizontalDefaultPosition}"
                horizontal-scaling="${(xr) => xr.horizontalScaling}"
                horizontal-inset="${(xr) => xr.horizontalInset}"
                vertical-viewport-lock="${(xr) => xr.horizontalViewportLock}"
                horizontal-viewport-lock="${(xr) => xr.verticalViewportLock}"
                dir="${(xr) => xr.currentDirection}"
                ${ref("region")}
            >
                <div class="tooltip" part="tooltip" role="tooltip">
                    <slot></slot>
                </div>
            </${td.tagFor(AnchoredRegion)}>
        `)}
    `, TooltipPosition$1 = {
  /**
   * The tooltip is positioned above the element
   */
  top: "top",
  /**
   * The tooltip is positioned to the right of the element
   */
  right: "right",
  /**
   * The tooltip is positioned below the element
   */
  bottom: "bottom",
  /**
   * The tooltip is positioned to the left of the element
   */
  left: "left",
  /**
   * The tooltip is positioned before the element
   */
  start: "start",
  /**
   * The tooltip is positioned after the element
   */
  end: "end",
  /**
   * The tooltip is positioned above the element and to the left
   */
  topLeft: "top-left",
  /**
   * The tooltip is positioned above the element and to the right
   */
  topRight: "top-right",
  /**
   * The tooltip is positioned below the element and to the left
   */
  bottomLeft: "bottom-left",
  /**
   * The tooltip is positioned below the element and to the right
   */
  bottomRight: "bottom-right",
  /**
   * The tooltip is positioned above the element and to the left
   */
  topStart: "top-start",
  /**
   * The tooltip is positioned above the element and to the right
   */
  topEnd: "top-end",
  /**
   * The tooltip is positioned below the element and to the left
   */
  bottomStart: "bottom-start",
  /**
   * The tooltip is positioned below the element and to the right
   */
  bottomEnd: "bottom-end"
};
let Tooltip$2 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.anchor = "", this.delay = 300, this.autoUpdateMode = "anchor", this.anchorElement = null, this.viewportElement = null, this.verticalPositioningMode = "dynamic", this.horizontalPositioningMode = "dynamic", this.horizontalInset = "false", this.verticalInset = "false", this.horizontalScaling = "content", this.verticalScaling = "content", this.verticalDefaultPosition = void 0, this.horizontalDefaultPosition = void 0, this.tooltipVisible = !1, this.currentDirection = Direction$1.ltr, this.showDelayTimer = null, this.hideDelayTimer = null, this.isAnchorHoveredFocused = !1, this.isRegionHovered = !1, this.handlePositionChange = (Ae) => {
      this.classList.toggle("top", this.region.verticalPosition === "start"), this.classList.toggle("bottom", this.region.verticalPosition === "end"), this.classList.toggle("inset-top", this.region.verticalPosition === "insetStart"), this.classList.toggle("inset-bottom", this.region.verticalPosition === "insetEnd"), this.classList.toggle("center-vertical", this.region.verticalPosition === "center"), this.classList.toggle("left", this.region.horizontalPosition === "start"), this.classList.toggle("right", this.region.horizontalPosition === "end"), this.classList.toggle("inset-left", this.region.horizontalPosition === "insetStart"), this.classList.toggle("inset-right", this.region.horizontalPosition === "insetEnd"), this.classList.toggle("center-horizontal", this.region.horizontalPosition === "center");
    }, this.handleRegionMouseOver = (Ae) => {
      this.isRegionHovered = !0;
    }, this.handleRegionMouseOut = (Ae) => {
      this.isRegionHovered = !1, this.startHideDelayTimer();
    }, this.handleAnchorMouseOver = (Ae) => {
      if (this.tooltipVisible) {
        this.isAnchorHoveredFocused = !0;
        return;
      }
      this.startShowDelayTimer();
    }, this.handleAnchorMouseOut = (Ae) => {
      this.isAnchorHoveredFocused = !1, this.clearShowDelayTimer(), this.startHideDelayTimer();
    }, this.handleAnchorFocusIn = (Ae) => {
      this.startShowDelayTimer();
    }, this.handleAnchorFocusOut = (Ae) => {
      this.isAnchorHoveredFocused = !1, this.clearShowDelayTimer(), this.startHideDelayTimer();
    }, this.startHideDelayTimer = () => {
      this.clearHideDelayTimer(), this.tooltipVisible && (this.hideDelayTimer = window.setTimeout(() => {
        this.updateTooltipVisibility();
      }, 60));
    }, this.clearHideDelayTimer = () => {
      this.hideDelayTimer !== null && (clearTimeout(this.hideDelayTimer), this.hideDelayTimer = null);
    }, this.startShowDelayTimer = () => {
      if (!this.isAnchorHoveredFocused) {
        if (this.delay > 1) {
          this.showDelayTimer === null && (this.showDelayTimer = window.setTimeout(() => {
            this.startHover();
          }, this.delay));
          return;
        }
        this.startHover();
      }
    }, this.startHover = () => {
      this.isAnchorHoveredFocused = !0, this.updateTooltipVisibility();
    }, this.clearShowDelayTimer = () => {
      this.showDelayTimer !== null && (clearTimeout(this.showDelayTimer), this.showDelayTimer = null);
    }, this.getAnchor = () => {
      const Ae = this.getRootNode();
      return Ae instanceof ShadowRoot ? Ae.getElementById(this.anchor) : document.getElementById(this.anchor);
    }, this.handleDocumentKeydown = (Ae) => {
      if (!Ae.defaultPrevented && this.tooltipVisible)
        switch (Ae.key) {
          case keyEscape$1:
            this.isAnchorHoveredFocused = !1, this.updateTooltipVisibility(), this.$emit("dismiss");
            break;
        }
    }, this.updateTooltipVisibility = () => {
      if (this.visible === !1)
        this.hideTooltip();
      else if (this.visible === !0) {
        this.showTooltip();
        return;
      } else {
        if (this.isAnchorHoveredFocused || this.isRegionHovered) {
          this.showTooltip();
          return;
        }
        this.hideTooltip();
      }
    }, this.showTooltip = () => {
      this.tooltipVisible || (this.currentDirection = getDirection$1(this), this.tooltipVisible = !0, document.addEventListener("keydown", this.handleDocumentKeydown), DOM.queueUpdate(this.setRegionProps));
    }, this.hideTooltip = () => {
      this.tooltipVisible && (this.clearHideDelayTimer(), this.region !== null && this.region !== void 0 && (this.region.removeEventListener("positionchange", this.handlePositionChange), this.region.viewportElement = null, this.region.anchorElement = null, this.region.removeEventListener("mouseover", this.handleRegionMouseOver), this.region.removeEventListener("mouseout", this.handleRegionMouseOut)), document.removeEventListener("keydown", this.handleDocumentKeydown), this.tooltipVisible = !1);
    }, this.setRegionProps = () => {
      this.tooltipVisible && (this.region.viewportElement = this.viewportElement, this.region.anchorElement = this.anchorElement, this.region.addEventListener("positionchange", this.handlePositionChange), this.region.addEventListener("mouseover", this.handleRegionMouseOver, {
        passive: !0
      }), this.region.addEventListener("mouseout", this.handleRegionMouseOut, {
        passive: !0
      }));
    };
  }
  visibleChanged() {
    this.$fastController.isConnected && (this.updateTooltipVisibility(), this.updateLayout());
  }
  anchorChanged() {
    this.$fastController.isConnected && (this.anchorElement = this.getAnchor());
  }
  positionChanged() {
    this.$fastController.isConnected && this.updateLayout();
  }
  anchorElementChanged(Ae) {
    if (this.$fastController.isConnected) {
      if (Ae != null && (Ae.removeEventListener("mouseover", this.handleAnchorMouseOver), Ae.removeEventListener("mouseout", this.handleAnchorMouseOut), Ae.removeEventListener("focusin", this.handleAnchorFocusIn), Ae.removeEventListener("focusout", this.handleAnchorFocusOut)), this.anchorElement !== null && this.anchorElement !== void 0) {
        this.anchorElement.addEventListener("mouseover", this.handleAnchorMouseOver, { passive: !0 }), this.anchorElement.addEventListener("mouseout", this.handleAnchorMouseOut, { passive: !0 }), this.anchorElement.addEventListener("focusin", this.handleAnchorFocusIn, {
          passive: !0
        }), this.anchorElement.addEventListener("focusout", this.handleAnchorFocusOut, { passive: !0 });
        const xr = this.anchorElement.id;
        this.anchorElement.parentElement !== null && this.anchorElement.parentElement.querySelectorAll(":hover").forEach((ed) => {
          ed.id === xr && this.startShowDelayTimer();
        });
      }
      this.region !== null && this.region !== void 0 && this.tooltipVisible && (this.region.anchorElement = this.anchorElement), this.updateLayout();
    }
  }
  viewportElementChanged() {
    this.region !== null && this.region !== void 0 && (this.region.viewportElement = this.viewportElement), this.updateLayout();
  }
  connectedCallback() {
    super.connectedCallback(), this.anchorElement = this.getAnchor(), this.updateTooltipVisibility();
  }
  disconnectedCallback() {
    this.hideTooltip(), this.clearShowDelayTimer(), this.clearHideDelayTimer(), super.disconnectedCallback();
  }
  /**
   * updated the properties being passed to the anchored region
   */
  updateLayout() {
    switch (this.verticalPositioningMode = "locktodefault", this.horizontalPositioningMode = "locktodefault", this.position) {
      case TooltipPosition$1.top:
      case TooltipPosition$1.bottom:
        this.verticalDefaultPosition = this.position, this.horizontalDefaultPosition = "center";
        break;
      case TooltipPosition$1.right:
      case TooltipPosition$1.left:
      case TooltipPosition$1.start:
      case TooltipPosition$1.end:
        this.verticalDefaultPosition = "center", this.horizontalDefaultPosition = this.position;
        break;
      case TooltipPosition$1.topLeft:
        this.verticalDefaultPosition = "top", this.horizontalDefaultPosition = "left";
        break;
      case TooltipPosition$1.topRight:
        this.verticalDefaultPosition = "top", this.horizontalDefaultPosition = "right";
        break;
      case TooltipPosition$1.bottomLeft:
        this.verticalDefaultPosition = "bottom", this.horizontalDefaultPosition = "left";
        break;
      case TooltipPosition$1.bottomRight:
        this.verticalDefaultPosition = "bottom", this.horizontalDefaultPosition = "right";
        break;
      case TooltipPosition$1.topStart:
        this.verticalDefaultPosition = "top", this.horizontalDefaultPosition = "start";
        break;
      case TooltipPosition$1.topEnd:
        this.verticalDefaultPosition = "top", this.horizontalDefaultPosition = "end";
        break;
      case TooltipPosition$1.bottomStart:
        this.verticalDefaultPosition = "bottom", this.horizontalDefaultPosition = "start";
        break;
      case TooltipPosition$1.bottomEnd:
        this.verticalDefaultPosition = "bottom", this.horizontalDefaultPosition = "end";
        break;
      default:
        this.verticalPositioningMode = "dynamic", this.horizontalPositioningMode = "dynamic", this.verticalDefaultPosition = void 0, this.horizontalDefaultPosition = "center";
        break;
    }
  }
};
__decorate([
  attr({ mode: "boolean" })
], Tooltip$2.prototype, "visible", void 0);
__decorate([
  attr
], Tooltip$2.prototype, "anchor", void 0);
__decorate([
  attr
], Tooltip$2.prototype, "delay", void 0);
__decorate([
  attr
], Tooltip$2.prototype, "position", void 0);
__decorate([
  attr({ attribute: "auto-update-mode" })
], Tooltip$2.prototype, "autoUpdateMode", void 0);
__decorate([
  attr({ attribute: "horizontal-viewport-lock" })
], Tooltip$2.prototype, "horizontalViewportLock", void 0);
__decorate([
  attr({ attribute: "vertical-viewport-lock" })
], Tooltip$2.prototype, "verticalViewportLock", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "anchorElement", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "viewportElement", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "verticalPositioningMode", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "horizontalPositioningMode", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "horizontalInset", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "verticalInset", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "horizontalScaling", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "verticalScaling", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "verticalDefaultPosition", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "horizontalDefaultPosition", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "tooltipVisible", void 0);
__decorate([
  observable
], Tooltip$2.prototype, "currentDirection", void 0);
const treeItemTemplate = (td, Ae) => html`
    <template
        role="treeitem"
        slot="${(xr) => xr.isNestedItem() ? "item" : void 0}"
        tabindex="-1"
        class="${(xr) => xr.expanded ? "expanded" : ""} ${(xr) => xr.selected ? "selected" : ""} ${(xr) => xr.nested ? "nested" : ""}
            ${(xr) => xr.disabled ? "disabled" : ""}"
        aria-expanded="${(xr) => xr.childItems && xr.childItemLength() > 0 ? xr.expanded : void 0}"
        aria-selected="${(xr) => xr.selected}"
        aria-disabled="${(xr) => xr.disabled}"
        @focusin="${(xr, ed) => xr.handleFocus(ed.event)}"
        @focusout="${(xr, ed) => xr.handleBlur(ed.event)}"
        ${children({
  property: "childItems",
  filter: elements()
})}
    >
        <div class="positioning-region" part="positioning-region">
            <div class="content-region" part="content-region">
                ${when((xr) => xr.childItems && xr.childItemLength() > 0, html`
                        <div
                            aria-hidden="true"
                            class="expand-collapse-button"
                            part="expand-collapse-button"
                            @click="${(xr, ed) => xr.handleExpandCollapseButtonClick(ed.event)}"
                            ${ref("expandCollapseButton")}
                        >
                            <slot name="expand-collapse-glyph">
                                ${Ae.expandCollapseGlyph || ""}
                            </slot>
                        </div>
                    `)}
                ${startSlotTemplate(td, Ae)}
                <slot></slot>
                ${endSlotTemplate(td, Ae)}
            </div>
        </div>
        ${when((xr) => xr.childItems && xr.childItemLength() > 0 && (xr.expanded || xr.renderCollapsedChildren), html`
                <div role="group" class="items" part="items">
                    <slot name="item" ${slotted("items")}></slot>
                </div>
            `)}
    </template>
`;
function isTreeItemElement(td) {
  return isHTMLElement$1(td) && td.getAttribute("role") === "treeitem";
}
let TreeItem$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.expanded = !1, this.focusable = !1, this.isNestedItem = () => isTreeItemElement(this.parentElement), this.handleExpandCollapseButtonClick = (Ae) => {
      !this.disabled && !Ae.defaultPrevented && (this.expanded = !this.expanded);
    }, this.handleFocus = (Ae) => {
      this.setAttribute("tabindex", "0");
    }, this.handleBlur = (Ae) => {
      this.setAttribute("tabindex", "-1");
    };
  }
  expandedChanged() {
    this.$fastController.isConnected && this.$emit("expanded-change", this);
  }
  selectedChanged() {
    this.$fastController.isConnected && this.$emit("selected-change", this);
  }
  itemsChanged(Ae, xr) {
    this.$fastController.isConnected && this.items.forEach((ed) => {
      isTreeItemElement(ed) && (ed.nested = !0);
    });
  }
  /**
   * Places document focus on a tree item
   *
   * @public
   * @param el - the element to focus
   */
  static focusItem(Ae) {
    Ae.focusable = !0, Ae.focus();
  }
  /**
   * Gets number of children
   *
   * @internal
   */
  childItemLength() {
    const Ae = this.childItems.filter((xr) => isTreeItemElement(xr));
    return Ae ? Ae.length : 0;
  }
};
__decorate([
  attr({ mode: "boolean" })
], TreeItem$1.prototype, "expanded", void 0);
__decorate([
  attr({ mode: "boolean" })
], TreeItem$1.prototype, "selected", void 0);
__decorate([
  attr({ mode: "boolean" })
], TreeItem$1.prototype, "disabled", void 0);
__decorate([
  observable
], TreeItem$1.prototype, "focusable", void 0);
__decorate([
  observable
], TreeItem$1.prototype, "childItems", void 0);
__decorate([
  observable
], TreeItem$1.prototype, "items", void 0);
__decorate([
  observable
], TreeItem$1.prototype, "nested", void 0);
__decorate([
  observable
], TreeItem$1.prototype, "renderCollapsedChildren", void 0);
applyMixins(TreeItem$1, StartEnd);
const treeViewTemplate = (td, Ae) => html`
    <template
        role="tree"
        ${ref("treeView")}
        @keydown="${(xr, ed) => xr.handleKeyDown(ed.event)}"
        @focusin="${(xr, ed) => xr.handleFocus(ed.event)}"
        @focusout="${(xr, ed) => xr.handleBlur(ed.event)}"
        @click="${(xr, ed) => xr.handleClick(ed.event)}"
        @selected-change="${(xr, ed) => xr.handleSelectedChange(ed.event)}"
    >
        <slot ${slotted("slottedTreeItems")}></slot>
    </template>
`;
let TreeView$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.currentFocused = null, this.handleFocus = (Ae) => {
      if (!(this.slottedTreeItems.length < 1)) {
        if (Ae.target === this) {
          this.currentFocused === null && (this.currentFocused = this.getValidFocusableItem()), this.currentFocused !== null && TreeItem$1.focusItem(this.currentFocused);
          return;
        }
        this.contains(Ae.target) && (this.setAttribute("tabindex", "-1"), this.currentFocused = Ae.target);
      }
    }, this.handleBlur = (Ae) => {
      Ae.target instanceof HTMLElement && (Ae.relatedTarget === null || !this.contains(Ae.relatedTarget)) && this.setAttribute("tabindex", "0");
    }, this.handleKeyDown = (Ae) => {
      if (Ae.defaultPrevented)
        return;
      if (this.slottedTreeItems.length < 1)
        return !0;
      const xr = this.getVisibleNodes();
      switch (Ae.key) {
        case keyHome$1:
          xr.length && TreeItem$1.focusItem(xr[0]);
          return;
        case keyEnd$1:
          xr.length && TreeItem$1.focusItem(xr[xr.length - 1]);
          return;
        case keyArrowLeft$1:
          if (Ae.target && this.isFocusableElement(Ae.target)) {
            const ed = Ae.target;
            ed instanceof TreeItem$1 && ed.childItemLength() > 0 && ed.expanded ? ed.expanded = !1 : ed instanceof TreeItem$1 && ed.parentElement instanceof TreeItem$1 && TreeItem$1.focusItem(ed.parentElement);
          }
          return !1;
        case keyArrowRight$1:
          if (Ae.target && this.isFocusableElement(Ae.target)) {
            const ed = Ae.target;
            ed instanceof TreeItem$1 && ed.childItemLength() > 0 && !ed.expanded ? ed.expanded = !0 : ed instanceof TreeItem$1 && ed.childItemLength() > 0 && this.focusNextNode(1, Ae.target);
          }
          return;
        case keyArrowDown$1:
          Ae.target && this.isFocusableElement(Ae.target) && this.focusNextNode(1, Ae.target);
          return;
        case keyArrowUp$1:
          Ae.target && this.isFocusableElement(Ae.target) && this.focusNextNode(-1, Ae.target);
          return;
        case keyEnter$1:
          this.handleClick(Ae);
          return;
      }
      return !0;
    }, this.handleSelectedChange = (Ae) => {
      if (Ae.defaultPrevented)
        return;
      if (!(Ae.target instanceof Element) || !isTreeItemElement(Ae.target))
        return !0;
      const xr = Ae.target;
      xr.selected ? (this.currentSelected && this.currentSelected !== xr && (this.currentSelected.selected = !1), this.currentSelected = xr) : !xr.selected && this.currentSelected === xr && (this.currentSelected = null);
    }, this.setItems = () => {
      const Ae = this.treeView.querySelector("[aria-selected='true']");
      this.currentSelected = Ae, (this.currentFocused === null || !this.contains(this.currentFocused)) && (this.currentFocused = this.getValidFocusableItem()), this.nested = this.checkForNestedItems(), this.getVisibleNodes().forEach((ed) => {
        isTreeItemElement(ed) && (ed.nested = this.nested);
      });
    }, this.isFocusableElement = (Ae) => isTreeItemElement(Ae), this.isSelectedElement = (Ae) => Ae.selected;
  }
  slottedTreeItemsChanged() {
    this.$fastController.isConnected && this.setItems();
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("tabindex", "0"), DOM.queueUpdate(() => {
      this.setItems();
    });
  }
  /**
   * Handles click events bubbling up
   *
   *  @internal
   */
  handleClick(Ae) {
    if (Ae.defaultPrevented)
      return;
    if (!(Ae.target instanceof Element) || !isTreeItemElement(Ae.target))
      return !0;
    const xr = Ae.target;
    xr.disabled || (xr.selected = !xr.selected);
  }
  /**
   * Move focus to a tree item based on its offset from the provided item
   */
  focusNextNode(Ae, xr) {
    const ed = this.getVisibleNodes();
    if (!ed)
      return;
    const id = ed[ed.indexOf(xr) + Ae];
    isHTMLElement$1(id) && TreeItem$1.focusItem(id);
  }
  /**
   * checks if there are any nested tree items
   */
  getValidFocusableItem() {
    const Ae = this.getVisibleNodes();
    let xr = Ae.findIndex(this.isSelectedElement);
    return xr === -1 && (xr = Ae.findIndex(this.isFocusableElement)), xr !== -1 ? Ae[xr] : null;
  }
  /**
   * checks if there are any nested tree items
   */
  checkForNestedItems() {
    return this.slottedTreeItems.some((Ae) => isTreeItemElement(Ae) && Ae.querySelector("[role='treeitem']"));
  }
  getVisibleNodes() {
    return getDisplayedNodes(this, "[role='treeitem']") || [];
  }
};
__decorate([
  attr({ attribute: "render-collapsed-nodes" })
], TreeView$1.prototype, "renderCollapsedNodes", void 0);
__decorate([
  observable
], TreeView$1.prototype, "currentSelected", void 0);
__decorate([
  observable
], TreeView$1.prototype, "slottedTreeItems", void 0);
class MatchMediaBehavior {
  /**
   *
   * @param query - The media query to operate from.
   */
  constructor(Ae) {
    this.listenerCache = /* @__PURE__ */ new WeakMap(), this.query = Ae;
  }
  /**
   * Binds the behavior to the element.
   * @param source - The element for which the behavior is bound.
   */
  bind(Ae) {
    const { query: xr } = this, ed = this.constructListener(Ae);
    ed.bind(xr)(), xr.addListener(ed), this.listenerCache.set(Ae, ed);
  }
  /**
   * Unbinds the behavior from the element.
   * @param source - The element for which the behavior is unbinding.
   */
  unbind(Ae) {
    const xr = this.listenerCache.get(Ae);
    xr && (this.query.removeListener(xr), this.listenerCache.delete(Ae));
  }
}
class MatchMediaStyleSheetBehavior extends MatchMediaBehavior {
  /**
   * Constructs a {@link MatchMediaStyleSheetBehavior} instance.
   * @param query - The media query to operate from.
   * @param styles - The styles to coordinate with the query.
   */
  constructor(Ae, xr) {
    super(Ae), this.styles = xr;
  }
  /**
   * Defines a function to construct {@link MatchMediaStyleSheetBehavior | MatchMediaStyleSheetBehaviors} for
   * a provided query.
   * @param query - The media query to operate from.
   *
   * @public
   * @example
   *
   * ```ts
   * import { css } from "@microsoft/fast-element";
   * import { MatchMediaStyleSheetBehavior } from "@microsoft/fast-foundation";
   *
   * const landscapeBehavior = MatchMediaStyleSheetBehavior.with(
   *   window.matchMedia("(orientation: landscape)")
   * );
   * const styles = css`
   *   :host {
   *     width: 200px;
   *     height: 400px;
   *   }
   * `
   * .withBehaviors(landscapeBehavior(css`
   *   :host {
   *     width: 400px;
   *     height: 200px;
   *   }
   * `))
   * ```
   */
  static with(Ae) {
    return (xr) => new MatchMediaStyleSheetBehavior(Ae, xr);
  }
  /**
   * Constructs a match-media listener for a provided element.
   * @param source - the element for which to attach or detach styles.
   * @internal
   */
  constructListener(Ae) {
    let xr = !1;
    const ed = this.styles;
    return function() {
      const { matches: od } = this;
      od && !xr ? (Ae.$fastController.addStyles(ed), xr = od) : !od && xr && (Ae.$fastController.removeStyles(ed), xr = od);
    };
  }
  /**
   * Unbinds the behavior from the element.
   * @param source - The element for which the behavior is unbinding.
   * @internal
   */
  unbind(Ae) {
    super.unbind(Ae), Ae.$fastController.removeStyles(this.styles);
  }
}
const forcedColorsStylesheetBehavior = MatchMediaStyleSheetBehavior.with(window.matchMedia("(forced-colors)")), darkModeStylesheetBehavior = MatchMediaStyleSheetBehavior.with(window.matchMedia("(prefers-color-scheme: dark)")), lightModeStylesheetBehavior = MatchMediaStyleSheetBehavior.with(window.matchMedia("(prefers-color-scheme: light)"));
class PropertyStyleSheetBehavior {
  /**
   * Constructs a {@link PropertyStyleSheetBehavior} instance.
   * @param propertyName - The property name to operate from.
   * @param value - The property value to operate from.
   * @param styles - The styles to coordinate with the property.
   */
  constructor(Ae, xr, ed) {
    this.propertyName = Ae, this.value = xr, this.styles = ed;
  }
  /**
   * Binds the behavior to the element.
   * @param elementInstance - The element for which the property is applied.
   */
  bind(Ae) {
    Observable.getNotifier(Ae).subscribe(this, this.propertyName), this.handleChange(Ae, this.propertyName);
  }
  /**
   * Unbinds the behavior from the element.
   * @param source - The element for which the behavior is unbinding.
   * @internal
   */
  unbind(Ae) {
    Observable.getNotifier(Ae).unsubscribe(this, this.propertyName), Ae.$fastController.removeStyles(this.styles);
  }
  /**
   * Change event for the provided element.
   * @param source - the element for which to attach or detach styles.
   * @param key - the key to lookup to know if the element already has the styles
   * @internal
   */
  handleChange(Ae, xr) {
    Ae[xr] === this.value ? Ae.$fastController.addStyles(this.styles) : Ae.$fastController.removeStyles(this.styles);
  }
}
const disabledCursor = "not-allowed", hidden = ":host([hidden]){display:none}";
function display(td) {
  return `${hidden}:host{display:${td}}`;
}
const focusVisible = canUseFocusVisible() ? "focus-visible" : "focus", fastFoundation = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARIAGlobalStatesAndProperties,
  Accordion: Accordion$1,
  AccordionExpandMode,
  AccordionItem: AccordionItem$1,
  Anchor: Anchor$1,
  AnchoredRegion,
  Avatar: Avatar$1,
  Badge: Badge$1,
  BaseProgress,
  Breadcrumb,
  BreadcrumbItem,
  Button: Button$1,
  Calendar: Calendar$1,
  CalendarTitleTemplate,
  Card: Card$1,
  CheckableFormAssociated,
  Checkbox: Checkbox$1,
  Combobox: Combobox$1,
  ComboboxAutocomplete,
  ComponentPresentation,
  Container: Container$9,
  ContainerConfiguration,
  ContainerImpl,
  DI,
  DataGrid: DataGrid$1,
  DataGridCell: DataGridCell$1,
  DataGridCellTypes,
  DataGridRow: DataGridRow$1,
  DataGridRowTypes,
  DateFormatter,
  DefaultComponentPresentation,
  DefaultResolver,
  DelegatesARIAButton,
  DelegatesARIACombobox: DelegatesARIACombobox$1,
  DelegatesARIALink,
  DelegatesARIAListbox,
  DelegatesARIAListboxOption,
  DelegatesARIASearch,
  DelegatesARIASelect,
  DelegatesARIATextbox,
  DelegatesARIAToolbar,
  DesignSystem,
  DesignToken,
  Dialog: Dialog$1,
  Disclosure: Disclosure$1,
  Divider: Divider$1,
  DividerRole,
  ElementDisambiguation,
  FactoryImpl,
  Flipper,
  FlipperDirection,
  FlyoutPosBottom,
  FlyoutPosBottomFill,
  FlyoutPosTallest,
  FlyoutPosTallestFill,
  FlyoutPosTop,
  FlyoutPosTopFill,
  FormAssociated,
  FoundationElement,
  FoundationElementRegistry,
  GenerateHeaderOptions,
  HorizontalScroll,
  Listbox: Listbox$1,
  ListboxElement,
  ListboxOption,
  MatchMediaBehavior,
  MatchMediaStyleSheetBehavior,
  Menu,
  MenuItem,
  MenuItemRole,
  NumberField: NumberField$1,
  Picker: Picker$1,
  PickerList,
  PickerListItem,
  PickerMenu,
  PickerMenuOption,
  PropertyStyleSheetBehavior,
  Radio: Radio$1,
  RadioGroup: RadioGroup$1,
  Registration,
  ResolverBuilder,
  ResolverImpl,
  Search: Search$1,
  Select: Select$1,
  SelectPosition: SelectPosition$1,
  ServiceLocator,
  Skeleton: Skeleton$1,
  Slider: Slider$1,
  SliderLabel: SliderLabel$1,
  SliderMode,
  StartEnd,
  Switch: Switch$1,
  Tab: Tab$1,
  TabPanel: TabPanel$1,
  Tabs: Tabs$1,
  TabsOrientation: TabsOrientation$1,
  TextArea: TextArea$1,
  TextAreaResize,
  TextField: TextField$1,
  TextFieldType,
  Toolbar: Toolbar$1,
  Tooltip: Tooltip$2,
  TooltipPosition: TooltipPosition$1,
  TreeItem: TreeItem$1,
  TreeView: TreeView$1,
  accordionItemTemplate,
  accordionTemplate,
  all,
  anchorTemplate,
  anchoredRegionTemplate,
  applyMixins,
  avatarTemplate,
  badgeTemplate,
  breadcrumbItemTemplate,
  breadcrumbTemplate,
  buttonTemplate,
  calendarCellTemplate,
  calendarRowTemplate,
  calendarTemplate,
  calendarWeekdayTemplate,
  cardTemplate,
  checkboxTemplate,
  comboboxTemplate,
  composedContains,
  composedParent,
  darkModeStylesheetBehavior,
  dataGridCellTemplate,
  dataGridRowTemplate,
  dataGridTemplate,
  dialogTemplate,
  disabledCursor,
  disclosureTemplate,
  display,
  dividerTemplate,
  endSlotTemplate,
  endTemplate,
  flipperTemplate,
  focusVisible,
  forcedColorsStylesheetBehavior,
  getDirection: getDirection$1,
  hidden,
  horizontalScrollTemplate,
  ignore,
  inject,
  interactiveCalendarGridTemplate,
  isListboxOption,
  isTreeItemElement,
  lazy,
  lightModeStylesheetBehavior,
  listboxOptionTemplate,
  listboxTemplate,
  menuItemTemplate,
  menuTemplate,
  newInstanceForScope,
  newInstanceOf,
  noninteractiveCalendarTemplate,
  numberFieldTemplate,
  optional,
  pickerListItemTemplate,
  pickerListTemplate,
  pickerMenuOptionTemplate,
  pickerMenuTemplate,
  pickerTemplate,
  progressRingTemplate,
  progressTemplate,
  radioGroupTemplate,
  radioTemplate,
  reflectAttributes,
  roleForMenuItem,
  searchTemplate,
  selectTemplate,
  singleton,
  skeletonTemplate,
  sliderLabelTemplate,
  sliderTemplate,
  startSlotTemplate,
  startTemplate,
  supportsElementInternals,
  switchTemplate,
  tabPanelTemplate,
  tabTemplate,
  tabsTemplate,
  textAreaTemplate,
  textFieldTemplate,
  toolbarTemplate,
  tooltipTemplate: tooltipTemplate$2,
  transient,
  treeItemTemplate,
  treeViewTemplate,
  validateKey,
  whitespaceFilter
}, Symbol.toStringTag, { value: "Module" })), reservedReactProperties = /* @__PURE__ */ new Set([
  "children",
  "localName",
  "ref",
  "style",
  "className"
]), emptyProps = Object.freeze(/* @__PURE__ */ Object.create(null)), DEFAULT_CACHE_NAME = "_default", wrappersCache = /* @__PURE__ */ new Map();
function setRef(td, Ae) {
  typeof td == "function" ? td(Ae) : td.current = Ae;
}
function getTagName(td, Ae) {
  if (!Ae.name) {
    const xr = FASTElementDefinition.forType(td);
    if (xr)
      Ae.name = xr.name;
    else
      throw new Error("React wrappers must wrap a FASTElement or be configured with a name.");
  }
  return Ae.name;
}
function getElementEvents(td) {
  return td.events || (td.events = {});
}
function keyIsValid(td, Ae, xr) {
  return reservedReactProperties.has(xr) ? (console.warn(`${getTagName(td, Ae)} contains property ${xr} which is a React reserved property. It will be used by React and not set on the element.`), !1) : !0;
}
function getElementKeys(td, Ae) {
  if (!Ae.keys)
    if (Ae.properties)
      Ae.keys = new Set(Ae.properties.concat(Object.keys(getElementEvents(Ae))));
    else {
      const xr = new Set(Object.keys(getElementEvents(Ae))), ed = Observable.getAccessors(td.prototype);
      if (ed.length > 0)
        for (const id of ed)
          keyIsValid(td, Ae, id.name) && xr.add(id.name);
      else
        for (const id in td.prototype)
          !(id in HTMLElement.prototype) && keyIsValid(td, Ae, id) && xr.add(id);
      Ae.keys = xr;
    }
  return Ae.keys;
}
function provideReactWrapper(td, Ae) {
  let xr = [];
  const ed = {
    register(od, ...ad) {
      xr.forEach((rd) => rd.register(od, ...ad)), xr = [];
    }
  };
  function id(od, ad = {}) {
    var rd, sd;
    od instanceof FoundationElementRegistry && (Ae ? Ae.register(od) : xr.push(od), od = od.type);
    const nd = wrappersCache.get(od);
    if (nd) {
      const ld = nd.get((rd = ad.name) !== null && rd !== void 0 ? rd : DEFAULT_CACHE_NAME);
      if (ld)
        return ld;
    }
    class cd extends td.Component {
      constructor() {
        super(...arguments), this._element = null;
      }
      _updateElement(dd) {
        const pd = this._element;
        if (pd === null)
          return;
        const md = this.props, fd = dd || emptyProps, bd = getElementEvents(ad);
        for (const Sd in this._elementProps) {
          const vd = md[Sd], Ed = bd[Sd];
          if (Ed === void 0)
            pd[Sd] = vd;
          else {
            const Td = fd[Sd];
            if (vd === Td)
              continue;
            Td !== void 0 && pd.removeEventListener(Ed, Td), vd !== void 0 && pd.addEventListener(Ed, vd);
          }
        }
      }
      componentDidMount() {
        this._updateElement();
      }
      componentDidUpdate(dd) {
        this._updateElement(dd);
      }
      render() {
        const dd = this.props.__forwardedRef;
        (this._ref === void 0 || this._userRef !== dd) && (this._ref = (Sd) => {
          this._element === null && (this._element = Sd), dd !== null && setRef(dd, Sd), this._userRef = dd;
        });
        const pd = { ref: this._ref }, md = this._elementProps = {}, fd = getElementKeys(od, ad), bd = this.props;
        for (const Sd in bd) {
          const vd = bd[Sd];
          fd.has(Sd) ? md[Sd] = vd : pd[Sd === "className" ? "class" : Sd] = vd;
        }
        return td.createElement(getTagName(od, ad), pd);
      }
    }
    const ud = td.forwardRef((ld, dd) => td.createElement(cd, Object.assign(Object.assign({}, ld), { __forwardedRef: dd }), ld == null ? void 0 : ld.children));
    return wrappersCache.has(od) || wrappersCache.set(od, /* @__PURE__ */ new Map()), wrappersCache.get(od).set((sd = ad.name) !== null && sd !== void 0 ? sd : DEFAULT_CACHE_NAME, ud), ud;
  }
  return { wrap: id, registry: ed };
}
const fastReactWrapper = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  provideReactWrapper
}, Symbol.toStringTag, { value: "Module" }));
var _a$1, _b, _c$1;
const targets = Symbol("targets"), handleClick = Symbol("handleClick"), targetElement = Symbol("targetElement"), handleOutsideClick = Symbol("handleOutsideClick");
class ClickBehavior {
  constructor() {
    this[_a$1] = [], this[_b] = (Ae) => {
      this[targets].filter((xr) => xr !== Ae[targetElement]).forEach((xr) => xr.onClickOutside(Ae.target, Ae));
    }, this[_c$1] = (Ae) => {
      const xr = Ae.currentTarget;
      xr != null && xr.disabled || xr.onClick(Ae.target, Ae), Object.defineProperty(Ae, targetElement, { value: xr, writable: !0 });
    };
  }
  bind(Ae) {
    Ae.addEventListener("click", this[handleClick]), this[targets].length === 0 && document.addEventListener("click", this[handleOutsideClick]), this[targets].push(Ae);
  }
  unbind() {
    this[targets].forEach((Ae) => Ae.removeEventListener("click", this[handleClick])), document.removeEventListener("click", this[handleOutsideClick]);
  }
}
_a$1 = targets, _b = handleOutsideClick, _c$1 = handleClick;
class HostSizeBehavior {
  constructor(Ae, xr) {
    this.host = Ae, this.host.$fastController.addBehaviors([this]), this.observer = new ResizeObserver((ed) => {
      ed.forEach((id) => xr(id));
    });
  }
  bind() {
    this.observer.observe(this.host);
  }
  unbind() {
    this.observer.unobserve(this.host);
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let s$2 = class extends Event {
  constructor(Ae, xr, ed) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = Ae, this.callback = xr, this.subscribe = ed != null ? ed : !1;
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function n$4(td) {
  return td;
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let s$1 = class {
  constructor(Ae, xr, ed, id) {
    var od;
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (ad, rd) => {
      this.unsubscribe && (this.unsubscribe !== rd && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = ad, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(ad, rd)), this.unsubscribe = rd;
    }, this.host = Ae, xr.context !== void 0) {
      const ad = xr;
      this.context = ad.context, this.callback = ad.callback, this.subscribe = (od = ad.subscribe) != null ? od : !1;
    } else
      this.context = xr, this.callback = ed, this.subscribe = id != null ? id : !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new s$2(this.context, this.t, this.subscribe));
  }
};
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function c$3({ context: td, subscribe: Ae }) {
  return (xr, ed) => {
    typeof ed == "object" ? ed.addInitializer(function() {
      new s$1(this, { context: td, callback: (id) => {
        xr.set.call(this, id);
      }, subscribe: Ae });
    }) : xr.constructor.addInitializer((id) => {
      new s$1(id, { context: td, callback: (od) => {
        id[ed] = od;
      }, subscribe: Ae });
    });
  };
}
class ConsumerBehaviour {
  constructor(Ae, xr) {
    this.host = Ae, this.options = xr, this.value = void 0, this.provided = !1, this._callback = (ed, id) => {
      this.unsubscribe && (this.unsubscribe !== id && (this.provided = !1, this.unsubscribe()), this.options.subscribe || this.unsubscribe()), this.value = ed, this.unsubscribe = id, (!this.provided || this.options.subscribe) && (this.provided = !0, this.options.callback && this.options.callback(ed, id));
    }, this.host.$fastController.addBehaviors([this]);
  }
  bind() {
    this.host.dispatchEvent(new s$2(this.options.context, this._callback, this.options.subscribe));
  }
  unbind() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
}
class ValueNotifier {
  constructor(Ae) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [xr, { disposer: ed }] of this.subscriptions)
        xr(this._value, ed);
    }, Ae !== void 0 && (this.value = Ae);
  }
  get value() {
    return this._value;
  }
  set value(Ae) {
    this.setValue(Ae);
  }
  setValue(Ae, xr = !1) {
    const ed = xr || !Object.is(Ae, this._value);
    this._value = Ae, ed && this.updateObservers();
  }
  addCallback(Ae, xr, ed) {
    if (!ed) {
      Ae(this.value);
      return;
    }
    this.subscriptions.has(Ae) || this.subscriptions.set(Ae, {
      disposer: () => {
        this.subscriptions.delete(Ae);
      },
      consumerHost: xr
    });
    const { disposer: id } = this.subscriptions.get(Ae);
    Ae(this.value, id);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
class ProviderBehaviour extends ValueNotifier {
  constructor(Ae, xr, ed) {
    super(ed), this.host = Ae, this.context = xr, this.onContextRequest = (id) => {
      const od = id.composedPath()[0];
      id.context !== this.context || od === this.host || (id.stopPropagation(), this.addCallback(id.callback, od, id.subscribe));
    }, this.host.$fastController.addBehaviors([this]);
  }
  bind() {
    this.host.addEventListener("context-request", this.onContextRequest);
  }
  unbind() {
    this.host.removeEventListener("context-request", this.onContextRequest), this.clearCallbacks();
  }
}
const getAttributes = ([...td]) => td.map((Ae) => ({
  name: Ae[0],
  default: Ae[1],
  attribute: Ae[2],
  new: Ae[3],
  result: Ae[4]
})), hexToRgb = (td) => {
  const Ae = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(td);
  return Ae ? `rgb(${parseInt(Ae[1], 16)}, ${parseInt(Ae[2], 16)}, ${parseInt(Ae[3], 16)})` : td;
}, getFormatPartsIdx = (td = "DD/MM/YYYY") => {
  const Ae = [
    { name: "dayIdx", index: td.indexOf("DD") },
    { name: "monthIdx", index: td.indexOf("MM") },
    { name: "yearIdx", index: td.indexOf("YYYY") }
  ].sort((xr, ed) => xr.index - ed.index).map((xr, ed) => [xr.name, ed]);
  return Object.fromEntries(Ae);
}, formatDateToString = (td, Ae = "DD/MM/YYYY", xr = !1) => {
  if (!isNaN(td.valueOf())) {
    let ed = [];
    const { dayIdx: id, monthIdx: od, yearIdx: ad } = getFormatPartsIdx(Ae);
    return xr ? ed = [td.getDate().toString().padStart(2, "0"), (td.getMonth() + 1).toString().padStart(2, "0"), td.getFullYear().toString().substring(2, 4)] : ed = [td.getUTCDate().toString().padStart(2, "0"), (td.getUTCMonth() + 1).toString().padStart(2, "0"), td.getUTCFullYear().toString().substring(2, 4)], `${ed[id]}/${ed[od]}/${ed[ad]}`;
  }
  return "";
}, formatDate = (td, Ae = "DD/MM/YYYY", xr = !1) => {
  const ed = !isNaN(new Date(td).valueOf());
  if ((td == null ? void 0 : td.length) === 10) {
    const id = td.split(/-|\/+/), { dayIdx: od, monthIdx: ad, yearIdx: rd } = getFormatPartsIdx(Ae);
    return xr ? new Date(+id[rd], +id[ad] - 1, +id[od]) : new Date(Date.UTC(+id[rd], +id[ad] - 1, +id[od]));
  } else if (ed) {
    let id = new Date(td);
    return xr || (id = new Date(Date.UTC(id.getUTCFullYear(), id.getUTCMonth(), id.getUTCDate(), id.getUTCHours(), id.getUTCMinutes(), id.getUTCMilliseconds()))), id;
  }
  return /* @__PURE__ */ new Date();
}, isValidDate = (td, Ae = "DD/MM/YYYY", xr = !1) => {
  const ed = formatDate(td, Ae, xr), id = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/, od = /^((\d{4})[-/](0[1-9]|1[0-2])[-/](0[1-9]|[12][0-9]|3[01])|(0[1-9]|[12][0-9]|3[01])[-/](0[1-9]|1[0-2])[-/](\d{4}))$/;
  return { isValid: !!ed && !isNaN(new Date(td).valueOf()) && (id.test(td) || od.test(td)) && ed !== /* @__PURE__ */ new Date(), date: ed };
}, getFocusableInputs = () => Array.from(document.querySelectorAll('[tabindex]:not([tabindex="-1"]):not(disabled)')), getActiveEl = () => document.activeElement, getActiveElIndex = () => getFocusableInputs().findIndex((td) => td === getActiveEl());
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const n$3 = globalThis, c$2 = n$3.trustedTypes, h$3 = c$2 ? c$2.createPolicy("lit-html", { createHTML: (td) => td }) : void 0, f$3 = "$lit$", v = `lit$${Math.random().toFixed(9).slice(2)}$`, m$1 = "?" + v, _$1 = `<${m$1}>`, w$1 = document, lt$1 = () => w$1.createComment(""), st$1 = (td) => td === null || typeof td != "object" && typeof td != "function", g = Array.isArray, $$1 = (td) => g(td) || typeof (td == null ? void 0 : td[Symbol.iterator]) == "function", x$2 = `[ 	
\f\r]`, T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, E$1 = /-->/g, k$1 = />/g, O$1 = RegExp(`>|${x$2}(?:([^\\s"'>=/]+)(${x$2}*=${x$2}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), S$1 = /'/g, j$1 = /"/g, M$1 = /^(?:script|style|textarea|title)$/i, P$1 = (td) => (Ae, ...xr) => ({ _$litType$: td, strings: Ae, values: xr }), ke$1 = P$1(1), R$1 = Symbol.for("lit-noChange"), D$1 = Symbol.for("lit-nothing"), V$1 = /* @__PURE__ */ new WeakMap(), I$1 = w$1.createTreeWalker(w$1, 129);
function N$1(td, Ae) {
  if (!g(td) || !td.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return h$3 !== void 0 ? h$3.createHTML(Ae) : Ae;
}
const U$1 = (td, Ae) => {
  const xr = td.length - 1, ed = [];
  let id, od = Ae === 2 ? "<svg>" : Ae === 3 ? "<math>" : "", ad = T;
  for (let rd = 0; rd < xr; rd++) {
    const sd = td[rd];
    let nd, cd, ud = -1, ld = 0;
    for (; ld < sd.length && (ad.lastIndex = ld, cd = ad.exec(sd), cd !== null); )
      ld = ad.lastIndex, ad === T ? cd[1] === "!--" ? ad = E$1 : cd[1] !== void 0 ? ad = k$1 : cd[2] !== void 0 ? (M$1.test(cd[2]) && (id = RegExp("</" + cd[2], "g")), ad = O$1) : cd[3] !== void 0 && (ad = O$1) : ad === O$1 ? cd[0] === ">" ? (ad = id != null ? id : T, ud = -1) : cd[1] === void 0 ? ud = -2 : (ud = ad.lastIndex - cd[2].length, nd = cd[1], ad = cd[3] === void 0 ? O$1 : cd[3] === '"' ? j$1 : S$1) : ad === j$1 || ad === S$1 ? ad = O$1 : ad === E$1 || ad === k$1 ? ad = T : (ad = O$1, id = void 0);
    const dd = ad === O$1 && td[rd + 1].startsWith("/>") ? " " : "";
    od += ad === T ? sd + _$1 : ud >= 0 ? (ed.push(nd), sd.slice(0, ud) + f$3 + sd.slice(ud) + v + dd) : sd + v + (ud === -2 ? rd : dd);
  }
  return [N$1(td, od + (td[xr] || "<?>") + (Ae === 2 ? "</svg>" : Ae === 3 ? "</math>" : "")), ed];
};
let B$1 = class E0 {
  constructor({ strings: Ae, _$litType$: xr }, ed) {
    let id;
    this.parts = [];
    let od = 0, ad = 0;
    const rd = Ae.length - 1, sd = this.parts, [nd, cd] = U$1(Ae, xr);
    if (this.el = E0.createElement(nd, ed), I$1.currentNode = this.el.content, xr === 2 || xr === 3) {
      const ud = this.el.content.firstChild;
      ud.replaceWith(...ud.childNodes);
    }
    for (; (id = I$1.nextNode()) !== null && sd.length < rd; ) {
      if (id.nodeType === 1) {
        if (id.hasAttributes())
          for (const ud of id.getAttributeNames())
            if (ud.endsWith(f$3)) {
              const ld = cd[ad++], dd = id.getAttribute(ud).split(v), pd = /([.?@])?(.*)/.exec(ld);
              sd.push({ type: 1, index: od, name: pd[2], strings: dd, ctor: pd[1] === "." ? Y$1 : pd[1] === "?" ? Z$1 : pd[1] === "@" ? q$1 : G$1 }), id.removeAttribute(ud);
            } else
              ud.startsWith(v) && (sd.push({ type: 6, index: od }), id.removeAttribute(ud));
        if (M$1.test(id.tagName)) {
          const ud = id.textContent.split(v), ld = ud.length - 1;
          if (ld > 0) {
            id.textContent = c$2 ? c$2.emptyScript : "";
            for (let dd = 0; dd < ld; dd++)
              id.append(ud[dd], lt$1()), I$1.nextNode(), sd.push({ type: 2, index: ++od });
            id.append(ud[ld], lt$1());
          }
        }
      } else if (id.nodeType === 8)
        if (id.data === m$1)
          sd.push({ type: 2, index: od });
        else {
          let ud = -1;
          for (; (ud = id.data.indexOf(v, ud + 1)) !== -1; )
            sd.push({ type: 7, index: od }), ud += v.length - 1;
        }
      od++;
    }
  }
  static createElement(Ae, xr) {
    const ed = w$1.createElement("template");
    return ed.innerHTML = Ae, ed;
  }
};
function z$1(td, Ae, xr = td, ed) {
  var ad, rd, sd;
  if (Ae === R$1)
    return Ae;
  let id = ed !== void 0 ? (ad = xr.o) == null ? void 0 : ad[ed] : xr.l;
  const od = st$1(Ae) ? void 0 : Ae._$litDirective$;
  return (id == null ? void 0 : id.constructor) !== od && ((rd = id == null ? void 0 : id._$AO) == null || rd.call(id, !1), od === void 0 ? id = void 0 : (id = new od(td), id._$AT(td, xr, ed)), ed !== void 0 ? ((sd = xr.o) != null ? sd : xr.o = [])[ed] = id : xr.l = id), id !== void 0 && (Ae = z$1(td, id._$AS(td, Ae.values), id, ed)), Ae;
}
class F {
  constructor(Ae, xr) {
    this._$AV = [], this._$AN = void 0, this._$AD = Ae, this._$AM = xr;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(Ae) {
    var nd;
    const { el: { content: xr }, parts: ed } = this._$AD, id = ((nd = Ae == null ? void 0 : Ae.creationScope) != null ? nd : w$1).importNode(xr, !0);
    I$1.currentNode = id;
    let od = I$1.nextNode(), ad = 0, rd = 0, sd = ed[0];
    for (; sd !== void 0; ) {
      if (ad === sd.index) {
        let cd;
        sd.type === 2 ? cd = new et$1(od, od.nextSibling, this, Ae) : sd.type === 1 ? cd = new sd.ctor(od, sd.name, sd.strings, this, Ae) : sd.type === 6 && (cd = new K$1(od, this, Ae)), this._$AV.push(cd), sd = ed[++rd];
      }
      ad !== (sd == null ? void 0 : sd.index) && (od = I$1.nextNode(), ad++);
    }
    return I$1.currentNode = w$1, id;
  }
  p(Ae) {
    let xr = 0;
    for (const ed of this._$AV)
      ed !== void 0 && (ed.strings !== void 0 ? (ed._$AI(Ae, ed, xr), xr += ed.strings.length - 2) : ed._$AI(Ae[xr])), xr++;
  }
}
let et$1 = class $0 {
  get _$AU() {
    var Ae, xr;
    return (xr = (Ae = this._$AM) == null ? void 0 : Ae._$AU) != null ? xr : this.v;
  }
  constructor(Ae, xr, ed, id) {
    var od;
    this.type = 2, this._$AH = D$1, this._$AN = void 0, this._$AA = Ae, this._$AB = xr, this._$AM = ed, this.options = id, this.v = (od = id == null ? void 0 : id.isConnected) != null ? od : !0;
  }
  get parentNode() {
    let Ae = this._$AA.parentNode;
    const xr = this._$AM;
    return xr !== void 0 && (Ae == null ? void 0 : Ae.nodeType) === 11 && (Ae = xr.parentNode), Ae;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(Ae, xr = this) {
    Ae = z$1(this, Ae, xr), st$1(Ae) ? Ae === D$1 || Ae == null || Ae === "" ? (this._$AH !== D$1 && this._$AR(), this._$AH = D$1) : Ae !== this._$AH && Ae !== R$1 && this._(Ae) : Ae._$litType$ !== void 0 ? this.$(Ae) : Ae.nodeType !== void 0 ? this.T(Ae) : $$1(Ae) ? this.k(Ae) : this._(Ae);
  }
  O(Ae) {
    return this._$AA.parentNode.insertBefore(Ae, this._$AB);
  }
  T(Ae) {
    this._$AH !== Ae && (this._$AR(), this._$AH = this.O(Ae));
  }
  _(Ae) {
    this._$AH !== D$1 && st$1(this._$AH) ? this._$AA.nextSibling.data = Ae : this.T(w$1.createTextNode(Ae)), this._$AH = Ae;
  }
  $(Ae) {
    var od;
    const { values: xr, _$litType$: ed } = Ae, id = typeof ed == "number" ? this._$AC(Ae) : (ed.el === void 0 && (ed.el = B$1.createElement(N$1(ed.h, ed.h[0]), this.options)), ed);
    if (((od = this._$AH) == null ? void 0 : od._$AD) === id)
      this._$AH.p(xr);
    else {
      const ad = new F(id, this), rd = ad.u(this.options);
      ad.p(xr), this.T(rd), this._$AH = ad;
    }
  }
  _$AC(Ae) {
    let xr = V$1.get(Ae.strings);
    return xr === void 0 && V$1.set(Ae.strings, xr = new B$1(Ae)), xr;
  }
  k(Ae) {
    g(this._$AH) || (this._$AH = [], this._$AR());
    const xr = this._$AH;
    let ed, id = 0;
    for (const od of Ae)
      id === xr.length ? xr.push(ed = new $0(this.O(lt$1()), this.O(lt$1()), this, this.options)) : ed = xr[id], ed._$AI(od), id++;
    id < xr.length && (this._$AR(ed && ed._$AB.nextSibling, id), xr.length = id);
  }
  _$AR(Ae = this._$AA.nextSibling, xr) {
    var ed;
    for ((ed = this._$AP) == null ? void 0 : ed.call(this, !1, !0, xr); Ae && Ae !== this._$AB; ) {
      const id = Ae.nextSibling;
      Ae.remove(), Ae = id;
    }
  }
  setConnected(Ae) {
    var xr;
    this._$AM === void 0 && (this.v = Ae, (xr = this._$AP) == null || xr.call(this, Ae));
  }
}, G$1 = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(Ae, xr, ed, id, od) {
    this.type = 1, this._$AH = D$1, this._$AN = void 0, this.element = Ae, this.name = xr, this._$AM = id, this.options = od, ed.length > 2 || ed[0] !== "" || ed[1] !== "" ? (this._$AH = Array(ed.length - 1).fill(new String()), this.strings = ed) : this._$AH = D$1;
  }
  _$AI(Ae, xr = this, ed, id) {
    const od = this.strings;
    let ad = !1;
    if (od === void 0)
      Ae = z$1(this, Ae, xr, 0), ad = !st$1(Ae) || Ae !== this._$AH && Ae !== R$1, ad && (this._$AH = Ae);
    else {
      const rd = Ae;
      let sd, nd;
      for (Ae = od[0], sd = 0; sd < od.length - 1; sd++)
        nd = z$1(this, rd[ed + sd], xr, sd), nd === R$1 && (nd = this._$AH[sd]), ad || (ad = !st$1(nd) || nd !== this._$AH[sd]), nd === D$1 ? Ae = D$1 : Ae !== D$1 && (Ae += (nd != null ? nd : "") + od[sd + 1]), this._$AH[sd] = nd;
    }
    ad && !id && this.j(Ae);
  }
  j(Ae) {
    Ae === D$1 ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, Ae != null ? Ae : "");
  }
}, Y$1 = class extends G$1 {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(Ae) {
    this.element[this.name] = Ae === D$1 ? void 0 : Ae;
  }
}, Z$1 = class extends G$1 {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(Ae) {
    this.element.toggleAttribute(this.name, !!Ae && Ae !== D$1);
  }
}, q$1 = class extends G$1 {
  constructor(Ae, xr, ed, id, od) {
    super(Ae, xr, ed, id, od), this.type = 5;
  }
  _$AI(Ae, xr = this) {
    var ad;
    if ((Ae = (ad = z$1(this, Ae, xr, 0)) != null ? ad : D$1) === R$1)
      return;
    const ed = this._$AH, id = Ae === D$1 && ed !== D$1 || Ae.capture !== ed.capture || Ae.once !== ed.once || Ae.passive !== ed.passive, od = Ae !== D$1 && (ed === D$1 || id);
    id && this.element.removeEventListener(this.name, this, ed), od && this.element.addEventListener(this.name, this, Ae), this._$AH = Ae;
  }
  handleEvent(Ae) {
    var xr, ed;
    typeof this._$AH == "function" ? this._$AH.call((ed = (xr = this.options) == null ? void 0 : xr.host) != null ? ed : this.element, Ae) : this._$AH.handleEvent(Ae);
  }
}, K$1 = class {
  constructor(Ae, xr, ed) {
    this.element = Ae, this.type = 6, this._$AN = void 0, this._$AM = xr, this.options = ed;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(Ae) {
    z$1(this, Ae);
  }
};
const Re$1 = n$3.litHtmlPolyfillSupport;
var b0;
Re$1 == null || Re$1(B$1, et$1), ((b0 = n$3.litHtmlVersions) != null ? b0 : n$3.litHtmlVersions = []).push("3.2.0");
const Q$1 = (td, Ae, xr) => {
  var od, ad;
  const ed = (od = xr == null ? void 0 : xr.renderBefore) != null ? od : Ae;
  let id = ed._$litPart$;
  if (id === void 0) {
    const rd = (ad = xr == null ? void 0 : xr.renderBefore) != null ? ad : null;
    ed._$litPart$ = id = new et$1(Ae.insertBefore(lt$1(), rd), rd, void 0, xr != null ? xr : {});
  }
  return id._$AI(td), id;
}, renderLitTemplate = (td) => {
  const Ae = document.createElement("div");
  return Q$1(td, Ae), Ae.children[0];
}, firstLetterUppercase = (td) => td.charAt(0).toUpperCase() + td.slice(1, td.length).toLowerCase(), buildStory = (td, Ae, xr, ed) => {
  const id = xr ? ke$1`<h1>${xr}</h1>` : "", od = ed ? ke$1`<p>${ed}</p>` : "", ad = ke$1`<div maxWidth="1200px">
    ${id} ${od}

    <div class="playground">
      <h3>Playground</h3>
      ${td}
    </div>
    <hr />
    ${Ae}
  </div>`;
  return renderLitTemplate(ad);
}, buildExamples = (td, Ae) => {
  const xr = ke$1`<div>
    <h3>${td}</h3>
    ${Ae.map((ed) => ke$1`<span class="example__item">${ed}</span>`)}
  </div>`;
  return renderLitTemplate(xr);
}, buildTokenTable = (td, Ae = !0, xr = !1) => {
  const ed = Ae ? ke$1`<td>Example</td>` : "", id = xr ? ke$1`<td>Description</td>` : "", od = ke$1`
    <tm1-card>
      <h1>${td}</h1>
      <table>
        <tbody>
          <tr style="height: 50px; font-weight: bold;">
            <td>Token name</td>
            <td>Css var name</td>
            <td>Value</td>
            ${id} ${ed}
          </tr>
        </tbody>
      </table>
    </tm1-card>
  `;
  return renderLitTemplate(od);
}, formatTokenName = (td) => td.split("-").map((Ae, xr) => xr > 0 ? Ae[0].toUpperCase() + Ae.substring(1) : Ae).join(""), cssObjectToString = (td) => Object.entries(td).map(([Ae, xr]) => (Ae = Ae.replace(/[A-Z]/g, (ed) => `-${ed.toLowerCase()}`), `${Ae}:${xr}`)).join(";"), defaultStyle = "border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px;", style = {
  slot: "border: 1.5px solid gray; background-color: #BCE3FF; border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px;",
  deprecated: "border: 1.5px solid red; color: red; border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px;",
  info: "border: 1.5px solid #026CDF; color: #026CDF; border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px;",
  accessibility: "border: 1.5px solid gray; background-color: #FFF577; border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px;",
  action: "border: 1.5px solid green; color: green; border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px",
  optional: "background-color: #ececef; border-radius: 4px; padding: 0 5px; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px",
  mandatory: "border: 1.5px solid #006CFF; border-radius: 4px; padding: 0 5px; background-color: #BFDAFF; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px",
  unsupported: 'border: 1.5px solid gray; border-radius: 4px; padding: 0 5px; background-color: #ececef; font-size: 11px; font-weight: 600; width: fit-content; margin-bottom: 5px"'
}, badge$2 = (td, Ae) => `<div style="${defaultStyle} ${style[td]}">
    ${firstLetterUppercase(td)}${Ae ? ` - ${Ae}` : ""}
  </div>`, ariaLink = (td) => `For more details, see <a href="https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/${td}" target="_blank">documentation</a>`, removeElement$1 = (td) => {
  const Ae = document.getElementsByTagName(td)[0];
  Ae == null || Ae.remove();
}, isSecureContext = () => window.isSecureContext, setAttributes = (td, Ae = {}) => {
  Object.entries(Ae).filter(([xr, ed]) => (!!ed || Number.isInteger(ed)) && xr !== "content").forEach(([xr, ed]) => {
    ed === !0 ? td.setAttribute(xr, "true") : td.setAttribute(xr, ed);
  });
}, variantBehavior = (td, Ae, xr) => new PropertyStyleSheetBehavior(td, Ae, xr), emit = (td, Ae, xr) => {
  const ed = new CustomEvent(Ae, { detail: xr });
  td.dispatchEvent(ed);
}, waitForElm = (td, Ae) => new Promise((xr) => {
  if (td.querySelector(Ae))
    return xr(td.querySelector(Ae));
  const ed = new MutationObserver(() => {
    td.querySelector(Ae) && (ed.disconnect(), xr(td.querySelector(Ae)));
  });
  ed.observe(document.body, {
    childList: !0,
    subtree: !0
  });
});
var L = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ne(td) {
  return td && td.__esModule && Object.prototype.hasOwnProperty.call(td, "default") ? td.default : td;
}
function Rr() {
  this.__data__ = [], this.size = 0;
}
var Hr = Rr;
function Vr(td, Ae) {
  return td === Ae || td !== td && Ae !== Ae;
}
var U = Vr, zr = U;
function kr(td, Ae) {
  for (var xr = td.length; xr--; )
    if (zr(td[xr][0], Ae))
      return xr;
  return -1;
}
var R = kr, qr = R, Wr = Array.prototype, Yr = Wr.splice;
function Xr(td) {
  var Ae = this.__data__, xr = qr(Ae, td);
  if (xr < 0)
    return !1;
  var ed = Ae.length - 1;
  return xr == ed ? Ae.pop() : Yr.call(Ae, xr, 1), --this.size, !0;
}
var Jr = Xr, Qr = R;
function Zr(td) {
  var Ae = this.__data__, xr = Qr(Ae, td);
  return xr < 0 ? void 0 : Ae[xr][1];
}
var et = Zr, rt$1 = R;
function tt(td) {
  return rt$1(this.__data__, td) > -1;
}
var at = tt, nt = R;
function it(td, Ae) {
  var xr = this.__data__, ed = nt(xr, td);
  return ed < 0 ? (++this.size, xr.push([td, Ae])) : xr[ed][1] = Ae, this;
}
var ot = it, st = Hr, ct = Jr, ut = et, lt = at, ft = ot;
function O(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.clear(); ++Ae < xr; ) {
    var ed = td[Ae];
    this.set(ed[0], ed[1]);
  }
}
O.prototype.clear = st;
O.prototype.delete = ct;
O.prototype.get = ut;
O.prototype.has = lt;
O.prototype.set = ft;
var H = O, vt = H;
function pt() {
  this.__data__ = new vt(), this.size = 0;
}
var $t$1 = pt;
function gt$1(td) {
  var Ae = this.__data__, xr = Ae.delete(td);
  return this.size = Ae.size, xr;
}
var bt$1 = gt$1;
function yt$1(td) {
  return this.__data__.get(td);
}
var ht = yt$1;
function dt(td) {
  return this.__data__.has(td);
}
var _t$1 = dt, Tt = typeof L == "object" && L && L.Object === Object && L, cr = Tt, mt$1 = cr, At = typeof self == "object" && self && self.Object === Object && self, St = mt$1 || At || Function("return this")(), $ = St, Ot = $, jt = Ot.Symbol, M = jt, Se = M, ur = Object.prototype, Ct = ur.hasOwnProperty, Pt = ur.toString, x$1 = Se ? Se.toStringTag : void 0;
function It(td) {
  var Ae = Ct.call(td, x$1), xr = td[x$1];
  try {
    td[x$1] = void 0;
    var ed = !0;
  } catch (od) {
  }
  var id = Pt.call(td);
  return ed && (Ae ? td[x$1] = xr : delete td[x$1]), id;
}
var wt$1 = It, xt = Object.prototype, Mt = xt.toString;
function Et(td) {
  return Mt.call(td);
}
var Dt = Et, Oe = M, Ft = wt$1, Lt = Dt, Gt = "[object Null]", Nt = "[object Undefined]", je = Oe ? Oe.toStringTag : void 0;
function Bt(td) {
  return td == null ? td === void 0 ? Nt : Gt : je && je in Object(td) ? Ft(td) : Lt(td);
}
var j = Bt;
function Kt$1(td) {
  var Ae = typeof td;
  return td != null && (Ae == "object" || Ae == "function");
}
var y$1 = Kt$1, Ut = j, Rt = y$1, Ht = "[object AsyncFunction]", Vt = "[object Function]", zt = "[object GeneratorFunction]", kt = "[object Proxy]";
function qt$1(td) {
  if (!Rt(td))
    return !1;
  var Ae = Ut(td);
  return Ae == Vt || Ae == zt || Ae == Ht || Ae == kt;
}
var ie = qt$1, Wt = $, Yt = Wt["__core-js_shared__"], Xt = Yt, X = Xt, Ce = function() {
  var td = /[^.]+$/.exec(X && X.keys && X.keys.IE_PROTO || "");
  return td ? "Symbol(src)_1." + td : "";
}();
function Jt(td) {
  return !!Ce && Ce in td;
}
var Qt = Jt, Zt$1 = Function.prototype, ea = Zt$1.toString;
function ra(td) {
  if (td != null) {
    try {
      return ea.call(td);
    } catch (Ae) {
    }
    try {
      return td + "";
    } catch (Ae) {
    }
  }
  return "";
}
var lr = ra, ta = ie, aa = Qt, na = y$1, ia = lr, oa = /[\\^$.*+?()[\]{}|]/g, sa = /^\[object .+?Constructor\]$/, ca = Function.prototype, ua = Object.prototype, la = ca.toString, fa = ua.hasOwnProperty, va = RegExp(
  "^" + la.call(fa).replace(oa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function pa(td) {
  if (!na(td) || aa(td))
    return !1;
  var Ae = ta(td) ? va : sa;
  return Ae.test(ia(td));
}
var $a = pa;
function ga(td, Ae) {
  return td == null ? void 0 : td[Ae];
}
var ba = ga, ya = $a, ha = ba;
function da(td, Ae) {
  var xr = ha(td, Ae);
  return ya(xr) ? xr : void 0;
}
var A = da, _a = A, Ta = $, ma = _a(Ta, "Map"), oe = ma, Aa = A, Sa = Aa(Object, "create"), V = Sa, Pe = V;
function Oa() {
  this.__data__ = Pe ? Pe(null) : {}, this.size = 0;
}
var ja = Oa;
function Ca(td) {
  var Ae = this.has(td) && delete this.__data__[td];
  return this.size -= Ae ? 1 : 0, Ae;
}
var Pa = Ca, Ia = V, wa = "__lodash_hash_undefined__", xa = Object.prototype, Ma = xa.hasOwnProperty;
function Ea(td) {
  var Ae = this.__data__;
  if (Ia) {
    var xr = Ae[td];
    return xr === wa ? void 0 : xr;
  }
  return Ma.call(Ae, td) ? Ae[td] : void 0;
}
var Da = Ea, Fa = V, La = Object.prototype, Ga = La.hasOwnProperty;
function Na(td) {
  var Ae = this.__data__;
  return Fa ? Ae[td] !== void 0 : Ga.call(Ae, td);
}
var Ba = Na, Ka = V, Ua = "__lodash_hash_undefined__";
function Ra(td, Ae) {
  var xr = this.__data__;
  return this.size += this.has(td) ? 0 : 1, xr[td] = Ka && Ae === void 0 ? Ua : Ae, this;
}
var Ha = Ra, Va = ja, za = Pa, ka = Da, qa = Ba, Wa = Ha;
function C(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.clear(); ++Ae < xr; ) {
    var ed = td[Ae];
    this.set(ed[0], ed[1]);
  }
}
C.prototype.clear = Va;
C.prototype.delete = za;
C.prototype.get = ka;
C.prototype.has = qa;
C.prototype.set = Wa;
var Ya = C, Ie = Ya, Xa = H, Ja = oe;
function Qa() {
  this.size = 0, this.__data__ = {
    hash: new Ie(),
    map: new (Ja || Xa)(),
    string: new Ie()
  };
}
var Za = Qa;
function en(td) {
  var Ae = typeof td;
  return Ae == "string" || Ae == "number" || Ae == "symbol" || Ae == "boolean" ? td !== "__proto__" : td === null;
}
var rn = en, tn = rn;
function an(td, Ae) {
  var xr = td.__data__;
  return tn(Ae) ? xr[typeof Ae == "string" ? "string" : "hash"] : xr.map;
}
var z = an, nn$1 = z;
function on(td) {
  var Ae = nn$1(this, td).delete(td);
  return this.size -= Ae ? 1 : 0, Ae;
}
var sn = on, cn = z;
function un(td) {
  return cn(this, td).get(td);
}
var ln = un, fn = z;
function vn(td) {
  return fn(this, td).has(td);
}
var pn = vn, $n = z;
function gn(td, Ae) {
  var xr = $n(this, td), ed = xr.size;
  return xr.set(td, Ae), this.size += xr.size == ed ? 0 : 1, this;
}
var bn = gn, yn = Za, hn = sn, dn = ln, _n = pn, Tn = bn;
function P(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.clear(); ++Ae < xr; ) {
    var ed = td[Ae];
    this.set(ed[0], ed[1]);
  }
}
P.prototype.clear = yn;
P.prototype.delete = hn;
P.prototype.get = dn;
P.prototype.has = _n;
P.prototype.set = Tn;
var fr = P, mn = H, An = oe, Sn = fr, On = 200;
function jn(td, Ae) {
  var xr = this.__data__;
  if (xr instanceof mn) {
    var ed = xr.__data__;
    if (!An || ed.length < On - 1)
      return ed.push([td, Ae]), this.size = ++xr.size, this;
    xr = this.__data__ = new Sn(ed);
  }
  return xr.set(td, Ae), this.size = xr.size, this;
}
var Cn = jn, Pn = H, In = $t$1, wn = bt$1, xn = ht, Mn = _t$1, En = Cn;
function I(td) {
  var Ae = this.__data__ = new Pn(td);
  this.size = Ae.size;
}
I.prototype.clear = In;
I.prototype.delete = wn;
I.prototype.get = xn;
I.prototype.has = Mn;
I.prototype.set = En;
var vr = I, Dn = A, Fn = function() {
  try {
    var td = Dn(Object, "defineProperty");
    return td({}, "", {}), td;
  } catch (Ae) {
  }
}(), pr = Fn, we = pr;
function Ln(td, Ae, xr) {
  Ae == "__proto__" && we ? we(td, Ae, {
    configurable: !0,
    enumerable: !0,
    value: xr,
    writable: !0
  }) : td[Ae] = xr;
}
var se = Ln, Gn = se, Nn = U;
function Bn(td, Ae, xr) {
  (xr !== void 0 && !Nn(td[Ae], xr) || xr === void 0 && !(Ae in td)) && Gn(td, Ae, xr);
}
var $r = Bn;
function Kn(td) {
  return function(Ae, xr, ed) {
    for (var id = -1, od = Object(Ae), ad = ed(Ae), rd = ad.length; rd--; ) {
      var sd = ad[td ? rd : ++id];
      if (xr(od[sd], sd, od) === !1)
        break;
    }
    return Ae;
  };
}
var Un = Kn, Rn = Un, Hn = Rn(), Vn = Hn, N = { exports: {} };
N.exports;
(function(td, Ae) {
  var xr = $, ed = Ae && !Ae.nodeType && Ae, id = ed && !0 && td && !td.nodeType && td, od = id && id.exports === ed, ad = od ? xr.Buffer : void 0, rd = ad ? ad.allocUnsafe : void 0;
  function sd(nd, cd) {
    if (cd)
      return nd.slice();
    var ud = nd.length, ld = rd ? rd(ud) : new nd.constructor(ud);
    return nd.copy(ld), ld;
  }
  td.exports = sd;
})(N, N.exports);
var gr = N.exports, zn = $, kn = zn.Uint8Array, qn = kn, xe = qn;
function Wn(td) {
  var Ae = new td.constructor(td.byteLength);
  return new xe(Ae).set(new xe(td)), Ae;
}
var ce = Wn, Yn = ce;
function Xn(td, Ae) {
  var xr = Ae ? Yn(td.buffer) : td.buffer;
  return new td.constructor(xr, td.byteOffset, td.length);
}
var br = Xn;
function Jn(td, Ae) {
  var xr = -1, ed = td.length;
  for (Ae || (Ae = Array(ed)); ++xr < ed; )
    Ae[xr] = td[xr];
  return Ae;
}
var yr = Jn, Qn = y$1, Me = Object.create, Zn = /* @__PURE__ */ function() {
  function td() {
  }
  return function(Ae) {
    if (!Qn(Ae))
      return {};
    if (Me)
      return Me(Ae);
    td.prototype = Ae;
    var xr = new td();
    return td.prototype = void 0, xr;
  };
}(), ei = Zn;
function ri(td, Ae) {
  return function(xr) {
    return td(Ae(xr));
  };
}
var hr = ri, ti = hr, ai = ti(Object.getPrototypeOf, Object), ue = ai, ni = Object.prototype;
function ii$1(td) {
  var Ae = td && td.constructor, xr = typeof Ae == "function" && Ae.prototype || ni;
  return td === xr;
}
var le = ii$1, oi = ei, si = ue, ci = le;
function ui(td) {
  return typeof td.constructor == "function" && !ci(td) ? oi(si(td)) : {};
}
var dr = ui;
function li(td) {
  return td != null && typeof td == "object";
}
var _ = li, fi = j, vi = _, pi = "[object Arguments]";
function $i(td) {
  return vi(td) && fi(td) == pi;
}
var gi = $i, Ee = gi, bi = _, _r = Object.prototype, yi = _r.hasOwnProperty, hi = _r.propertyIsEnumerable, di = Ee(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ee : function(td) {
  return bi(td) && yi.call(td, "callee") && !hi.call(td, "callee");
}, k = di, _i = Array.isArray, h$2 = _i, Ti = 9007199254740991;
function mi(td) {
  return typeof td == "number" && td > -1 && td % 1 == 0 && td <= Ti;
}
var fe = mi, Ai = ie, Si = fe;
function Oi(td) {
  return td != null && Si(td.length) && !Ai(td);
}
var q = Oi, ji = q, Ci = _;
function Pi(td) {
  return Ci(td) && ji(td);
}
var Ii = Pi, B = { exports: {} };
function wi() {
  return !1;
}
var xi = wi;
B.exports;
(function(td, Ae) {
  var xr = $, ed = xi, id = Ae && !Ae.nodeType && Ae, od = id && !0 && td && !td.nodeType && td, ad = od && od.exports === id, rd = ad ? xr.Buffer : void 0, sd = rd ? rd.isBuffer : void 0, nd = sd || ed;
  td.exports = nd;
})(B, B.exports);
var ve = B.exports, Mi = j, Ei = ue, Di = _, Fi = "[object Object]", Li = Function.prototype, Gi = Object.prototype, Tr = Li.toString, Ni = Gi.hasOwnProperty, Bi = Tr.call(Object);
function Ki(td) {
  if (!Di(td) || Mi(td) != Fi)
    return !1;
  var Ae = Ei(td);
  if (Ae === null)
    return !0;
  var xr = Ni.call(Ae, "constructor") && Ae.constructor;
  return typeof xr == "function" && xr instanceof xr && Tr.call(xr) == Bi;
}
var Ui = Ki, Ri = j, Hi = fe, Vi = _, zi = "[object Arguments]", ki = "[object Array]", qi = "[object Boolean]", Wi = "[object Date]", Yi = "[object Error]", Xi = "[object Function]", Ji = "[object Map]", Qi = "[object Number]", Zi = "[object Object]", eo = "[object RegExp]", ro = "[object Set]", to = "[object String]", ao = "[object WeakMap]", no = "[object ArrayBuffer]", io = "[object DataView]", oo = "[object Float32Array]", so = "[object Float64Array]", co = "[object Int8Array]", uo = "[object Int16Array]", lo = "[object Int32Array]", fo = "[object Uint8Array]", vo = "[object Uint8ClampedArray]", po = "[object Uint16Array]", $o = "[object Uint32Array]", f$2 = {};
f$2[oo] = f$2[so] = f$2[co] = f$2[uo] = f$2[lo] = f$2[fo] = f$2[vo] = f$2[po] = f$2[$o] = !0;
f$2[zi] = f$2[ki] = f$2[no] = f$2[qi] = f$2[io] = f$2[Wi] = f$2[Yi] = f$2[Xi] = f$2[Ji] = f$2[Qi] = f$2[Zi] = f$2[eo] = f$2[ro] = f$2[to] = f$2[ao] = !1;
function go(td) {
  return Vi(td) && Hi(td.length) && !!f$2[Ri(td)];
}
var bo = go;
function yo(td) {
  return function(Ae) {
    return td(Ae);
  };
}
var pe = yo, K = { exports: {} };
K.exports;
(function(td, Ae) {
  var xr = cr, ed = Ae && !Ae.nodeType && Ae, id = ed && !0 && td && !td.nodeType && td, od = id && id.exports === ed, ad = od && xr.process, rd = function() {
    try {
      var sd = id && id.require && id.require("util").types;
      return sd || ad && ad.binding && ad.binding("util");
    } catch (nd) {
    }
  }();
  td.exports = rd;
})(K, K.exports);
var $e = K.exports, ho = bo, _o = pe, De = $e, Fe = De && De.isTypedArray, To = Fe ? _o(Fe) : ho, mr = To;
function mo(td, Ae) {
  if (!(Ae === "constructor" && typeof td[Ae] == "function") && Ae != "__proto__")
    return td[Ae];
}
var Ar = mo, Ao = se, So = U, Oo = Object.prototype, jo = Oo.hasOwnProperty;
function Co(td, Ae, xr) {
  var ed = td[Ae];
  (!(jo.call(td, Ae) && So(ed, xr)) || xr === void 0 && !(Ae in td)) && Ao(td, Ae, xr);
}
var ge = Co, Po = ge, Io = se;
function wo(td, Ae, xr, ed) {
  var id = !xr;
  xr || (xr = {});
  for (var od = -1, ad = Ae.length; ++od < ad; ) {
    var rd = Ae[od], sd = ed ? ed(xr[rd], td[rd], rd, xr, td) : void 0;
    sd === void 0 && (sd = td[rd]), id ? Io(xr, rd, sd) : Po(xr, rd, sd);
  }
  return xr;
}
var E = wo;
function xo(td, Ae) {
  for (var xr = -1, ed = Array(td); ++xr < td; )
    ed[xr] = Ae(xr);
  return ed;
}
var Mo = xo, Eo = 9007199254740991, Do = /^(?:0|[1-9]\d*)$/;
function Fo(td, Ae) {
  var xr = typeof td;
  return Ae = Ae != null ? Ae : Eo, !!Ae && (xr == "number" || xr != "symbol" && Do.test(td)) && td > -1 && td % 1 == 0 && td < Ae;
}
var W = Fo, Lo = Mo, Go = k, No = h$2, Bo = ve, Ko = W, Uo = mr, Ro = Object.prototype, Ho = Ro.hasOwnProperty;
function Vo(td, Ae) {
  var xr = No(td), ed = !xr && Go(td), id = !xr && !ed && Bo(td), od = !xr && !ed && !id && Uo(td), ad = xr || ed || id || od, rd = ad ? Lo(td.length, String) : [], sd = rd.length;
  for (var nd in td)
    (Ae || Ho.call(td, nd)) && !(ad && // Safari 9 has enumerable `arguments.length` in strict mode.
    (nd == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    id && (nd == "offset" || nd == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    od && (nd == "buffer" || nd == "byteLength" || nd == "byteOffset") || // Skip index properties.
    Ko(nd, sd))) && rd.push(nd);
  return rd;
}
var Sr = Vo;
function zo(td) {
  var Ae = [];
  if (td != null)
    for (var xr in Object(td))
      Ae.push(xr);
  return Ae;
}
var ko = zo, qo = y$1, Wo = le, Yo = ko, Xo = Object.prototype, Jo = Xo.hasOwnProperty;
function Qo(td) {
  if (!qo(td))
    return Yo(td);
  var Ae = Wo(td), xr = [];
  for (var ed in td)
    ed == "constructor" && (Ae || !Jo.call(td, ed)) || xr.push(ed);
  return xr;
}
var Zo = Qo, es = Sr, rs = Zo, ts = q;
function as(td) {
  return ts(td) ? es(td, !0) : rs(td);
}
var D = as, ns = E, is = D;
function os(td) {
  return ns(td, is(td));
}
var ss = os, Le = $r, cs = gr, us = br, ls = yr, fs = dr, Ge = k, Ne = h$2, vs = Ii, ps = ve, $s = ie, gs = y$1, bs = Ui, ys = mr, Be = Ar, hs = ss;
function ds(td, Ae, xr, ed, id, od, ad) {
  var rd = Be(td, xr), sd = Be(Ae, xr), nd = ad.get(sd);
  if (nd) {
    Le(td, xr, nd);
    return;
  }
  var cd = od ? od(rd, sd, xr + "", td, Ae, ad) : void 0, ud = cd === void 0;
  if (ud) {
    var ld = Ne(sd), dd = !ld && ps(sd), pd = !ld && !dd && ys(sd);
    cd = sd, ld || dd || pd ? Ne(rd) ? cd = rd : vs(rd) ? cd = ls(rd) : dd ? (ud = !1, cd = cs(sd, !0)) : pd ? (ud = !1, cd = us(sd, !0)) : cd = [] : bs(sd) || Ge(sd) ? (cd = rd, Ge(rd) ? cd = hs(rd) : (!gs(rd) || $s(rd)) && (cd = fs(sd))) : ud = !1;
  }
  ud && (ad.set(sd, cd), id(cd, sd, ed, od, ad), ad.delete(sd)), Le(td, xr, cd);
}
var _s = ds, Ts = vr, ms = $r, As = Vn, Ss = _s, Os = y$1, js = D, Cs = Ar;
function Or(td, Ae, xr, ed, id) {
  td !== Ae && As(Ae, function(od, ad) {
    if (id || (id = new Ts()), Os(od))
      Ss(td, Ae, ad, xr, Or, ed, id);
    else {
      var rd = ed ? ed(Cs(td, ad), od, ad + "", td, Ae, id) : void 0;
      rd === void 0 && (rd = od), ms(td, ad, rd);
    }
  }, js);
}
var Ps = Or;
function Is(td) {
  return td;
}
var jr = Is;
function ws(td, Ae, xr) {
  switch (xr.length) {
    case 0:
      return td.call(Ae);
    case 1:
      return td.call(Ae, xr[0]);
    case 2:
      return td.call(Ae, xr[0], xr[1]);
    case 3:
      return td.call(Ae, xr[0], xr[1], xr[2]);
  }
  return td.apply(Ae, xr);
}
var xs = ws, Ms = xs, Ke = Math.max;
function Es(td, Ae, xr) {
  return Ae = Ke(Ae === void 0 ? td.length - 1 : Ae, 0), function() {
    for (var ed = arguments, id = -1, od = Ke(ed.length - Ae, 0), ad = Array(od); ++id < od; )
      ad[id] = ed[Ae + id];
    id = -1;
    for (var rd = Array(Ae + 1); ++id < Ae; )
      rd[id] = ed[id];
    return rd[Ae] = xr(ad), Ms(td, this, rd);
  };
}
var Cr = Es;
function Ds(td) {
  return function() {
    return td;
  };
}
var Fs = Ds, Ls = Fs, Ue = pr, Gs = jr, Ns = Ue ? function(td, Ae) {
  return Ue(td, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ls(Ae),
    writable: !0
  });
} : Gs, Bs = Ns, Ks = 800, Us = 16, Rs = Date.now;
function Hs(td) {
  var Ae = 0, xr = 0;
  return function() {
    var ed = Rs(), id = Us - (ed - xr);
    if (xr = ed, id > 0) {
      if (++Ae >= Ks)
        return arguments[0];
    } else
      Ae = 0;
    return td.apply(void 0, arguments);
  };
}
var Vs = Hs, zs = Bs, ks = Vs, qs = ks(zs), Pr = qs, Ws = jr, Ys = Cr, Xs = Pr;
function Js(td, Ae) {
  return Xs(Ys(td, Ae, Ws), td + "");
}
var Qs = Js, Zs = U, ec = q, rc = W, tc = y$1;
function ac(td, Ae, xr) {
  if (!tc(xr))
    return !1;
  var ed = typeof Ae;
  return (ed == "number" ? ec(xr) && rc(Ae, xr.length) : ed == "string" && Ae in xr) ? Zs(xr[Ae], td) : !1;
}
var nc = ac, ic = Qs, oc = nc;
function sc(td) {
  return ic(function(Ae, xr) {
    var ed = -1, id = xr.length, od = id > 1 ? xr[id - 1] : void 0, ad = id > 2 ? xr[2] : void 0;
    for (od = td.length > 3 && typeof od == "function" ? (id--, od) : void 0, ad && oc(xr[0], xr[1], ad) && (od = id < 3 ? void 0 : od, id = 1), Ae = Object(Ae); ++ed < id; ) {
      var rd = xr[ed];
      rd && td(Ae, rd, ed, od);
    }
    return Ae;
  });
}
var cc = sc, uc = Ps, lc = cc, fc = lc(function(td, Ae, xr) {
  uc(td, Ae, xr);
}), vc = fc;
const J = /* @__PURE__ */ ne(vc), Ir = {
  bubbles: !0,
  composed: !0
}, wr = "register";
function Q(td) {
  return {
    bubbles: td.bubbles,
    cancelable: td.cancelable,
    composed: td.composed
  };
}
let pc = class T0 extends CustomEvent {
  constructor(Ae, xr = {}) {
    super(wr, {
      ...Ir,
      ...xr,
      detail: { injectable: Ae }
    }), this.version = "v1", this.dependencies = /* @__PURE__ */ new Map();
  }
  putIfAbsent(Ae, xr) {
    return this.dependencies.has(Ae) ? !1 : (this.dependencies.set(Ae, xr), !0);
  }
  static from(Ae) {
    const xr = new T0(
      Ae.detail.injectable,
      Q(Ae)
    );
    return J(xr, {
      dependencies: new Map([...Ae.dependencies])
    }), xr;
  }
};
const $c = /* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RegisterEvent: pc
}, Symbol.toStringTag, { value: "Module" });
function gc(td, Ae) {
  for (var xr = -1, ed = td == null ? 0 : td.length; ++xr < ed && Ae(td[xr], xr, td) !== !1; )
    ;
  return td;
}
var bc = gc, yc = hr, hc = yc(Object.keys, Object), dc = hc, _c = le, Tc = dc, mc = Object.prototype, Ac = mc.hasOwnProperty;
function Sc(td) {
  if (!_c(td))
    return Tc(td);
  var Ae = [];
  for (var xr in Object(td))
    Ac.call(td, xr) && xr != "constructor" && Ae.push(xr);
  return Ae;
}
var Oc = Sc, jc = Sr, Cc = Oc, Pc = q;
function Ic(td) {
  return Pc(td) ? jc(td) : Cc(td);
}
var be = Ic, wc = E, xc = be;
function Mc(td, Ae) {
  return td && wc(Ae, xc(Ae), td);
}
var Ec = Mc, Dc = E, Fc = D;
function Lc(td, Ae) {
  return td && Dc(Ae, Fc(Ae), td);
}
var Gc = Lc;
function Nc(td, Ae) {
  for (var xr = -1, ed = td == null ? 0 : td.length, id = 0, od = []; ++xr < ed; ) {
    var ad = td[xr];
    Ae(ad, xr, td) && (od[id++] = ad);
  }
  return od;
}
var Bc = Nc;
function Kc() {
  return [];
}
var Mr = Kc, Uc = Bc, Rc = Mr, Hc = Object.prototype, Vc = Hc.propertyIsEnumerable, Re = Object.getOwnPropertySymbols, zc = Re ? function(td) {
  return td == null ? [] : (td = Object(td), Uc(Re(td), function(Ae) {
    return Vc.call(td, Ae);
  }));
} : Rc, ye = zc, kc = E, qc = ye;
function Wc(td, Ae) {
  return kc(td, qc(td), Ae);
}
var Yc = Wc;
function Xc(td, Ae) {
  for (var xr = -1, ed = Ae.length, id = td.length; ++xr < ed; )
    td[id + xr] = Ae[xr];
  return td;
}
var he = Xc, Jc = he, Qc = ue, Zc = ye, eu = Mr, ru = Object.getOwnPropertySymbols, tu = ru ? function(td) {
  for (var Ae = []; td; )
    Jc(Ae, Zc(td)), td = Qc(td);
  return Ae;
} : eu, Er = tu, au = E, nu = Er;
function iu(td, Ae) {
  return au(td, nu(td), Ae);
}
var ou = iu, su = he, cu = h$2;
function uu(td, Ae, xr) {
  var ed = Ae(td);
  return cu(td) ? ed : su(ed, xr(td));
}
var Dr = uu, lu = Dr, fu = ye, vu = be;
function pu(td) {
  return lu(td, vu, fu);
}
var $u = pu, gu = Dr, bu = Er, yu = D;
function hu(td) {
  return gu(td, yu, bu);
}
var du = hu, _u = A, Tu = $, mu = _u(Tu, "DataView"), Au = mu, Su = A, Ou = $, ju = Su(Ou, "Promise"), Cu = ju, Pu = A, Iu = $, wu = Pu(Iu, "Set"), xu = wu, Mu = A, Eu = $, Du = Mu(Eu, "WeakMap"), Fu = Du, Z = Au, ee = oe, re = Cu, te = xu, ae = Fu, Fr = j, w = lr, He = "[object Map]", Lu = "[object Object]", Ve = "[object Promise]", ze = "[object Set]", ke = "[object WeakMap]", qe = "[object DataView]", Gu = w(Z), Nu = w(ee), Bu = w(re), Ku = w(te), Uu = w(ae), m = Fr;
(Z && m(new Z(new ArrayBuffer(1))) != qe || ee && m(new ee()) != He || re && m(re.resolve()) != Ve || te && m(new te()) != ze || ae && m(new ae()) != ke) && (m = function(td) {
  var Ae = Fr(td), xr = Ae == Lu ? td.constructor : void 0, ed = xr ? w(xr) : "";
  if (ed)
    switch (ed) {
      case Gu:
        return qe;
      case Nu:
        return He;
      case Bu:
        return Ve;
      case Ku:
        return ze;
      case Uu:
        return ke;
    }
  return Ae;
});
var de = m, Ru = Object.prototype, Hu = Ru.hasOwnProperty;
function Vu(td) {
  var Ae = td.length, xr = new td.constructor(Ae);
  return Ae && typeof td[0] == "string" && Hu.call(td, "index") && (xr.index = td.index, xr.input = td.input), xr;
}
var zu = Vu, ku = ce;
function qu(td, Ae) {
  var xr = Ae ? ku(td.buffer) : td.buffer;
  return new td.constructor(xr, td.byteOffset, td.byteLength);
}
var Wu = qu, Yu = /\w*$/;
function Xu(td) {
  var Ae = new td.constructor(td.source, Yu.exec(td));
  return Ae.lastIndex = td.lastIndex, Ae;
}
var Ju = Xu, We = M, Ye = We ? We.prototype : void 0, Xe = Ye ? Ye.valueOf : void 0;
function Qu(td) {
  return Xe ? Object(Xe.call(td)) : {};
}
var Zu = Qu, el = ce, rl = Wu, tl = Ju, al = Zu, nl = br, il = "[object Boolean]", ol = "[object Date]", sl = "[object Map]", cl = "[object Number]", ul = "[object RegExp]", ll = "[object Set]", fl = "[object String]", vl = "[object Symbol]", pl = "[object ArrayBuffer]", $l = "[object DataView]", gl = "[object Float32Array]", bl = "[object Float64Array]", yl = "[object Int8Array]", hl = "[object Int16Array]", dl = "[object Int32Array]", _l = "[object Uint8Array]", Tl = "[object Uint8ClampedArray]", ml = "[object Uint16Array]", Al = "[object Uint32Array]";
function Sl(td, Ae, xr) {
  var ed = td.constructor;
  switch (Ae) {
    case pl:
      return el(td);
    case il:
    case ol:
      return new ed(+td);
    case $l:
      return rl(td, xr);
    case gl:
    case bl:
    case yl:
    case hl:
    case dl:
    case _l:
    case Tl:
    case ml:
    case Al:
      return nl(td, xr);
    case sl:
      return new ed();
    case cl:
    case fl:
      return new ed(td);
    case ul:
      return tl(td);
    case ll:
      return new ed();
    case vl:
      return al(td);
  }
}
var Ol = Sl, jl = de, Cl = _, Pl = "[object Map]";
function Il(td) {
  return Cl(td) && jl(td) == Pl;
}
var wl = Il, xl = wl, Ml = pe, Je = $e, Qe = Je && Je.isMap, El = Qe ? Ml(Qe) : xl, Dl = El, Fl = de, Ll = _, Gl = "[object Set]";
function Nl(td) {
  return Ll(td) && Fl(td) == Gl;
}
var Bl = Nl, Kl = Bl, Ul = pe, Ze = $e, er = Ze && Ze.isSet, Rl = er ? Ul(er) : Kl, Hl = Rl, Vl = vr, zl = bc, kl = ge, ql = Ec, Wl = Gc, Yl = gr, Xl = yr, Jl = Yc, Ql = ou, Zl = $u, ef = du, rf = de, tf = zu, af = Ol, nf = dr, of = h$2, sf = ve, cf = Dl, uf = y$1, lf = Hl, ff = be, vf = D, pf = 1, $f = 2, gf = 4, Lr = "[object Arguments]", bf = "[object Array]", yf = "[object Boolean]", hf = "[object Date]", df = "[object Error]", Gr = "[object Function]", _f = "[object GeneratorFunction]", Tf = "[object Map]", mf = "[object Number]", Nr = "[object Object]", Af = "[object RegExp]", Sf = "[object Set]", Of = "[object String]", jf = "[object Symbol]", Cf = "[object WeakMap]", Pf = "[object ArrayBuffer]", If = "[object DataView]", wf = "[object Float32Array]", xf = "[object Float64Array]", Mf = "[object Int8Array]", Ef = "[object Int16Array]", Df = "[object Int32Array]", Ff = "[object Uint8Array]", Lf = "[object Uint8ClampedArray]", Gf = "[object Uint16Array]", Nf = "[object Uint32Array]", l$1 = {};
l$1[Lr] = l$1[bf] = l$1[Pf] = l$1[If] = l$1[yf] = l$1[hf] = l$1[wf] = l$1[xf] = l$1[Mf] = l$1[Ef] = l$1[Df] = l$1[Tf] = l$1[mf] = l$1[Nr] = l$1[Af] = l$1[Sf] = l$1[Of] = l$1[jf] = l$1[Ff] = l$1[Lf] = l$1[Gf] = l$1[Nf] = !0;
l$1[df] = l$1[Gr] = l$1[Cf] = !1;
function G(td, Ae, xr, ed, id, od) {
  var ad, rd = Ae & pf, sd = Ae & $f, nd = Ae & gf;
  if (xr && (ad = id ? xr(td, ed, id, od) : xr(td)), ad !== void 0)
    return ad;
  if (!uf(td))
    return td;
  var cd = of(td);
  if (cd) {
    if (ad = tf(td), !rd)
      return Xl(td, ad);
  } else {
    var ud = rf(td), ld = ud == Gr || ud == _f;
    if (sf(td))
      return Yl(td, rd);
    if (ud == Nr || ud == Lr || ld && !id) {
      if (ad = sd || ld ? {} : nf(td), !rd)
        return sd ? Ql(td, Wl(ad, td)) : Jl(td, ql(ad, td));
    } else {
      if (!l$1[ud])
        return id ? td : {};
      ad = af(td, ud, rd);
    }
  }
  od || (od = new Vl());
  var dd = od.get(td);
  if (dd)
    return dd;
  od.set(td, ad), lf(td) ? td.forEach(function(fd) {
    ad.add(G(fd, Ae, xr, fd, td, od));
  }) : cf(td) && td.forEach(function(fd, bd) {
    ad.set(bd, G(fd, Ae, xr, bd, td, od));
  });
  var pd = nd ? sd ? ef : Zl : sd ? vf : ff, md = cd ? void 0 : pd(td);
  return zl(md || td, function(fd, bd) {
    md && (bd = fd, fd = td[bd]), kl(ad, bd, G(fd, Ae, xr, bd, td, od));
  }), ad;
}
var Bf = G, Kf = Bf, Uf = 1, Rf = 4;
function Hf(td) {
  return Kf(td, Uf | Rf);
}
var Vf = Hf;
const rr = /* @__PURE__ */ ne(Vf);
var zf = j, kf = _, qf = "[object Symbol]";
function Wf(td) {
  return typeof td == "symbol" || kf(td) && zf(td) == qf;
}
var _e = Wf, Yf = h$2, Xf = _e, Jf = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Qf = /^\w*$/;
function Zf(td, Ae) {
  if (Yf(td))
    return !1;
  var xr = typeof td;
  return xr == "number" || xr == "symbol" || xr == "boolean" || td == null || Xf(td) ? !0 : Qf.test(td) || !Jf.test(td) || Ae != null && td in Object(Ae);
}
var ev = Zf, Br = fr, rv = "Expected a function";
function Te(td, Ae) {
  if (typeof td != "function" || Ae != null && typeof Ae != "function")
    throw new TypeError(rv);
  var xr = function() {
    var ed = arguments, id = Ae ? Ae.apply(this, ed) : ed[0], od = xr.cache;
    if (od.has(id))
      return od.get(id);
    var ad = td.apply(this, ed);
    return xr.cache = od.set(id, ad) || od, ad;
  };
  return xr.cache = new (Te.Cache || Br)(), xr;
}
Te.Cache = Br;
var tv = Te, av = tv, nv = 500;
function iv(td) {
  var Ae = av(td, function(ed) {
    return xr.size === nv && xr.clear(), ed;
  }), xr = Ae.cache;
  return Ae;
}
var ov = iv, sv = ov, cv = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, uv = /\\(\\)?/g, lv = sv(function(td) {
  var Ae = [];
  return td.charCodeAt(0) === 46 && Ae.push(""), td.replace(cv, function(xr, ed, id, od) {
    Ae.push(id ? od.replace(uv, "$1") : ed || xr);
  }), Ae;
}), fv = lv;
function vv(td, Ae) {
  for (var xr = -1, ed = td == null ? 0 : td.length, id = Array(ed); ++xr < ed; )
    id[xr] = Ae(td[xr], xr, td);
  return id;
}
var pv = vv, tr = M, $v = pv, gv = h$2, bv = _e, yv = 1 / 0, ar = tr ? tr.prototype : void 0, nr = ar ? ar.toString : void 0;
function Kr(td) {
  if (typeof td == "string")
    return td;
  if (gv(td))
    return $v(td, Kr) + "";
  if (bv(td))
    return nr ? nr.call(td) : "";
  var Ae = td + "";
  return Ae == "0" && 1 / td == -yv ? "-0" : Ae;
}
var hv = Kr, dv = hv;
function _v(td) {
  return td == null ? "" : dv(td);
}
var Tv = _v, mv = h$2, Av = ev, Sv = fv, Ov = Tv;
function jv(td, Ae) {
  return mv(td) ? td : Av(td, Ae) ? [td] : Sv(Ov(td));
}
var Y = jv, Cv = _e, Pv = 1 / 0;
function Iv(td) {
  if (typeof td == "string" || Cv(td))
    return td;
  var Ae = td + "";
  return Ae == "0" && 1 / td == -Pv ? "-0" : Ae;
}
var me = Iv, wv = Y, xv = me;
function Mv(td, Ae) {
  Ae = wv(Ae, td);
  for (var xr = 0, ed = Ae.length; td != null && xr < ed; )
    td = td[xv(Ae[xr++])];
  return xr && xr == ed ? td : void 0;
}
var Ev = Mv, Dv = ge, Fv = Y, Lv = W, ir = y$1, Gv = me;
function Nv(td, Ae, xr, ed) {
  if (!ir(td))
    return td;
  Ae = Fv(Ae, td);
  for (var id = -1, od = Ae.length, ad = od - 1, rd = td; rd != null && ++id < od; ) {
    var sd = Gv(Ae[id]), nd = xr;
    if (sd === "__proto__" || sd === "constructor" || sd === "prototype")
      return td;
    if (id != ad) {
      var cd = rd[sd];
      nd = ed ? ed(cd, sd, rd) : void 0, nd === void 0 && (nd = ir(cd) ? cd : Lv(Ae[id + 1]) ? [] : {});
    }
    Dv(rd, sd, nd), rd = rd[sd];
  }
  return td;
}
var Bv = Nv, Kv = Ev, Uv = Bv, Rv = Y;
function Hv(td, Ae, xr) {
  for (var ed = -1, id = Ae.length, od = {}; ++ed < id; ) {
    var ad = Ae[ed], rd = Kv(td, ad);
    xr(rd, ad) && Uv(od, Rv(ad, td), rd);
  }
  return od;
}
var Vv = Hv;
function zv(td, Ae) {
  return td != null && Ae in Object(td);
}
var kv = zv, qv = Y, Wv = k, Yv = h$2, Xv = W, Jv = fe, Qv = me;
function Zv(td, Ae, xr) {
  Ae = qv(Ae, td);
  for (var ed = -1, id = Ae.length, od = !1; ++ed < id; ) {
    var ad = Qv(Ae[ed]);
    if (!(od = td != null && xr(td, ad)))
      break;
    td = td[ad];
  }
  return od || ++ed != id ? od : (id = td == null ? 0 : td.length, !!id && Jv(id) && Xv(ad, id) && (Yv(td) || Wv(td)));
}
var ep = Zv, rp = kv, tp = ep;
function ap(td, Ae) {
  return td != null && tp(td, Ae, rp);
}
var np = ap, ip = Vv, op = np;
function sp(td, Ae) {
  return ip(td, Ae, function(xr, ed) {
    return op(td, ed);
  });
}
var cp = sp, or = M, up = k, lp = h$2, sr = or ? or.isConcatSpreadable : void 0;
function fp(td) {
  return lp(td) || up(td) || !!(sr && td && td[sr]);
}
var vp = fp, pp = he, $p = vp;
function Ur(td, Ae, xr, ed, id) {
  var od = -1, ad = td.length;
  for (xr || (xr = $p), id || (id = []); ++od < ad; ) {
    var rd = td[od];
    Ae > 0 && xr(rd) ? Ae > 1 ? Ur(rd, Ae - 1, xr, ed, id) : pp(id, rd) : ed || (id[id.length] = rd);
  }
  return id;
}
var gp = Ur, bp = gp;
function yp(td) {
  var Ae = td == null ? 0 : td.length;
  return Ae ? bp(td, 1) : [];
}
var hp = yp, dp = hp, _p = Cr, Tp = Pr;
function mp(td) {
  return Tp(_p(td, void 0, dp), td + "");
}
var Ap = mp, Sp = cp, Op$2 = Ap, jp = Op$2(function(td, Ae) {
  return td == null ? {} : Sp(td, Ae);
}), Cp = jp;
const Pp = /* @__PURE__ */ ne(Cp);
var hh;
let b$1 = (hh = class extends CustomEvent {
  constructor(Ae, xr, ed) {
    super(wr, {
      ...Ir,
      ...ed,
      detail: {
        ...ed == null ? void 0 : ed.detail,
        injectable: Ae
      }
    }), this.requestedDependencies = xr, this.version = hh.version, this.inject = this.detail.injectable.inject.bind(this.detail.injectable), this.context = {
      collectedDependencies: {},
      componentTree: []
    };
  }
  get collectedDependencies() {
    return { ...this.context.collectedDependencies };
  }
  get componentTree() {
    return rr(this.context.componentTree);
  }
  get targetComponent() {
    return this.context.componentTree[0];
  }
  bindComponent(Ae) {
    this.context.componentTree.push(Ae);
  }
  provideDependency(Ae, xr) {
    return Ae in this.context.collectedDependencies ? !1 : (this.context.collectedDependencies[Ae] = xr, !0);
  }
  /**
   * @deprecated - use {@link provideDependency} instead.
   */
  putIfAbsent(Ae, xr) {
    return this.provideDependency(Ae, xr);
  }
  clone() {
    return hh.clone(this);
  }
  static from(Ae) {
    return hh.hasSameVersion(Ae) ? hh.clone(Ae) : this.uplevel(Ae);
  }
  static hasSameVersion(Ae) {
    return "version" in Ae && Ae.version === hh.version;
  }
  static clone(Ae) {
    const xr = new hh(
      Ae,
      Ae.requestedDependencies,
      Q(Ae)
    );
    return J(
      xr.context,
      rr(Pp(
        Ae,
        Object.keys(xr.context)
      )),
      {
        collectedDependencies: { ...Ae.collectedDependencies }
      }
    ), xr;
  }
  static uplevel(Ae) {
    const xr = new hh({
      inject({ dependencies: ed }) {
        Ae.detail.injectable.inject({
          activatedRoute: ed.activatedRoute.v1,
          analytics: ed.analytics.v1beta1,
          breadcrumb: ed.breadcrumb.v1beta1,
          commandQueue: ed.commandQueue.v1,
          dispatcher: ed.dispatcher.v1,
          featureFlags: ed.featureFlags.v1.features,
          translator: ed.translator.v1,
          ...ed.additionalDependencies.v1
        });
      }
    }, {
      activatedRoute: ["v1"],
      analytics: ["v1beta1"],
      breadcrumb: ["v1beta1"],
      commandQueue: ["v1"],
      dispatcher: ["v1"],
      featureFlags: ["v1"],
      translator: ["v1"],
      additionalDependencies: ["v1"]
    }, Q(Ae));
    return J(
      xr.context,
      {
        collectedDependencies: Object.fromEntries(Ae.dependencies.entries())
      }
    ), xr;
  }
}, hh.version = "v2", hh);
const Ip = /* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RegisterEvent: b$1
}, Symbol.toStringTag, { value: "Module" }), wp = /* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  v1: $c,
  v2: Ip
}, Symbol.toStringTag, { value: "Module" }), requestedDep$1 = {
  featureFlags: ["v1"]
};
class FeatureFlags {
  isEnabled(Ae, xr) {
    var ed;
    return this.featureFlagService || Ae.dispatchEvent(new wp.v2.RegisterEvent(this, requestedDep$1)), ((ed = this.featureFlagService) == null ? void 0 : ed.isEnabled(xr)) || !1;
  }
  inject(Ae) {
    var xr, ed;
    this.featureFlagService = (ed = (xr = Ae.dependencies) == null ? void 0 : xr.featureFlags) == null ? void 0 : ed.v1;
  }
}
const features = new FeatureFlags(), requestedDep = {
  translator: ["v1"]
};
class Language {
  getLanguage(Ae) {
    var xr;
    return this.translatorService || Ae.dispatchEvent(new wp.v2.RegisterEvent(this, requestedDep)), ((xr = this.translatorService) == null ? void 0 : xr.language) || "en-US";
  }
  inject(Ae) {
    var xr, ed;
    this.translatorService = (ed = (xr = Ae.dependencies) == null ? void 0 : xr.translator) == null ? void 0 : ed.v1;
  }
}
const language = new Language(), parseElementLang = (td) => {
  if (!td.lang)
    return [];
  const Ae = td.lang.split(/[-_]/);
  let xr = (Ae.shift() || "en").toLowerCase();
  const ed = [xr];
  for (; Ae.length; ) {
    const id = Ae.shift();
    id && (xr = `${xr}_${id.toLowerCase()}`, ed.unshift(xr));
  }
  return ed;
}, designSystem = DesignSystem.getOrCreate().withElementDisambiguation(() => ElementDisambiguation.ignoreDuplicate).withPrefix("tm1"), getComputedStyle$2 = (td, Ae = null) => window.getComputedStyle(td, Ae), hostSelector = (td) => cssPartial`
    :host(${Object.entries(td).map(([Ae, xr]) => `[${Ae}="${xr}"]`).join("")})
  `, InputSize = {
  small: "small",
  regular: "regular",
  large: "large"
}, ThemeVersion = {
  v1: "v1",
  v2: "v2"
}, themeContext = "tm1-theme";
class RootThemeNotifier extends ValueNotifier {
  constructor(Ae) {
    super(), this.onContextRequest = (xr) => {
      const ed = xr.composedPath()[0];
      xr.context === themeContext && (xr.stopPropagation(), this.addCallback(xr.callback, ed, xr.subscribe));
    }, (Ae || document.body).addEventListener("context-request", this.onContextRequest);
  }
}
const themeVersionContext = "tm1-theme-version", { create: create$a } = DesignToken, GDSEBorderWidth0 = create$a("gdse-g-border-width-0").withDefault("0"), GDSEBorderWidth10 = create$a("gdse-g-border-width-10").withDefault("1px"), GDSEBorderWidth25 = create$a("gdse-g-border-width-25").withDefault("2px"), GDSEBorderRadius0 = create$a("gdse-g-border-radius-0").withDefault("0"), GDSEBorderRadius10 = create$a("gdse-g-border-radius-10").withDefault("1px"), GDSEBorderRadius25 = create$a("gdse-g-border-radius-25").withDefault("2px"), GDSEBorderRadius50 = create$a("gdse-g-border-radius-50").withDefault("4px"), GDSEBorderRadius75 = create$a("gdse-g-border-radius-75").withDefault("6px"), GDSEBorderRadius100 = create$a("gdse-g-border-radius-100").withDefault("8px"), GDSEBorderRadiusFull = create$a("gdse-g-border-radius-full").withDefault("9999px"), globalBorders = {
  GDSEBorderWidth0,
  GDSEBorderWidth10,
  GDSEBorderWidth25,
  GDSEBorderRadius0,
  GDSEBorderRadius10,
  GDSEBorderRadius25,
  GDSEBorderRadius50,
  GDSEBorderRadius75,
  GDSEBorderRadius100,
  GDSEBorderRadiusFull
}, { create: create$9 } = DesignToken, GDSEColorTransparent = create$9("gdse-g-color-transparent").withDefault("#000000"), GDSEColorBlue100 = create$9("gdse-g-color-blue-100").withDefault("#F1F7FE"), GDSEColorBlue200 = create$9("gdse-g-color-blue-200").withDefault("#D6E7FA"), GDSEColorBlue300 = create$9("gdse-g-color-blue-300").withDefault("#BFDAF6"), GDSEColorBlue400 = create$9("gdse-g-color-blue-400").withDefault("#80B5EF"), GDSEColorBlue500 = create$9("gdse-g-color-blue-500").withDefault("#408EE7"), GDSEColorBlue600 = create$9("gdse-g-color-blue-600").withDefault("#026CDF"), GDSEColorBlue700 = create$9("gdse-g-color-blue-700").withDefault("#0150A7"), GDSEColorBlue800 = create$9("gdse-g-color-blue-800").withDefault("#013670"), GDSEColorGrey100 = create$9("gdse-g-color-grey-100").withDefault("#F6F6F6"), GDSEColorGrey200 = create$9("gdse-g-color-grey-200").withDefault("#EBEBEB"), GDSEColorGrey300 = create$9("gdse-g-color-grey-300").withDefault("#E5E5E5"), GDSEColorGrey400 = create$9("gdse-g-color-grey-400").withDefault("#BFBFBF"), GDSEColorGrey500 = create$9("gdse-g-color-grey-500").withDefault("#999999"), GDSEColorGrey600 = create$9("gdse-g-color-grey-600").withDefault("#646464"), GDSEColorGrey700 = create$9("gdse-g-color-grey-700").withDefault("#484848"), GDSEColorGrey800 = create$9("gdse-g-color-grey-800").withDefault("#262626"), GDSEColorGrey900 = create$9("gdse-g-color-grey-900").withDefault("#191919"), GDSEColorGreen100 = create$9("gdse-g-color-green-100").withDefault("#E8F6E8"), GDSEColorGreen200 = create$9("gdse-g-color-green-200").withDefault("#CCF0CC"), GDSEColorGreen300 = create$9("gdse-g-color-green-300").withDefault("#BAE5BB"), GDSEColorGreen400 = create$9("gdse-g-color-green-400").withDefault("#6ECF6F"), GDSEColorGreen500 = create$9("gdse-g-color-green-500").withDefault("#1BAB1E"), GDSEColorGreen600 = create$9("gdse-g-color-green-600").withDefault("#148016"), GDSEColorGreen700 = create$9("gdse-g-color-green-700").withDefault("#0C4F0E"), GDSEColorYellow100 = create$9("gdse-g-color-yellow-100").withDefault("#FDF5DF"), GDSEColorYellow200 = create$9("gdse-g-color-yellow-200").withDefault("#FAE5AA"), GDSEColorYellow300 = create$9("gdse-g-color-yellow-300").withDefault("#F6D57A"), GDSEColorYellow400 = create$9("gdse-g-color-yellow-400").withDefault("#F2BD2A"), GDSEColorYellow500 = create$9("gdse-g-color-yellow-500").withDefault("#DFA402"), GDSEColorYellow600 = create$9("gdse-g-color-yellow-600").withDefault("#B98800"), GDSEColorYellow700 = create$9("gdse-g-color-yellow-700").withDefault("#704900"), GDSEColorRed100 = create$9("gdse-g-color-red-100").withDefault("#FBEBEB"), GDSEColorRed200 = create$9("gdse-g-color-red-200").withDefault("#F3C3C3"), GDSEColorRed300 = create$9("gdse-g-color-red-300").withDefault("#F5A8A8"), GDSEColorRed400 = create$9("gdse-g-color-red-400").withDefault("#EF6B6B"), GDSEColorRed500 = create$9("gdse-g-color-red-500").withDefault("#D93A3A"), GDSEColorRed600 = create$9("gdse-g-color-red-600").withDefault("#A22B2B"), GDSEColorRed700 = create$9("gdse-g-color-red-700").withDefault("#590101"), GDSEColorMonoBlack = create$9("gdse-g-color-mono-black").withDefault("#121212"), GDSEColorMonoWhite = create$9("gdse-g-color-mono-white").withDefault("#FFFFFF"), GDSEColorNeptune = create$9("gdse-g-color-neptune").withDefault("#024DFF"), GDSEColorCosmos = create$9("gdse-g-color-cosmos").withDefault("#050505"), GDSEColorSpotlight = create$9("gdse-g-color-spotlight").withDefault("#FFFFFF"), GDSEColorGanymede = create$9("gdse-g-color-ganymede").withDefault("#00F0FF"), GDSEColorTitan = create$9("gdse-g-color-titan").withDefault("#FFE816"), GDSEColorOberon = create$9("gdse-g-color-oberon").withDefault("#26FF44"), GDSEColorOberonA = create$9("gdse-g-color-oberon-med").withDefault("#72FF85"), GDSEColorOberonB = create$9("gdse-g-color-oberon-lite").withDefault("#BEFFC7"), GDSEColorJupiter = create$9("gdse-g-color-jupiter").withDefault("#FF7126"), GDSEColorJupiterA = create$9("gdse-g-color-jupiter-med").withDefault("#FFB892"), GDSEColorJupiterB = create$9("gdse-g-color-jupiter-lite").withDefault("#FFD4BE"), GDSEColorCallisto = create$9("gdse-g-color-callisto").withDefault("#E711FA"), GDSEColorCallistoA = create$9("gdse-g-color-callisto-med").withDefault("#F388FD"), GDSEColorCallistoB = create$9("gdse-g-color-callisto-lite").withDefault("#FACFFE"), GDSEColorCosmoA = create$9("gdse-g-color-cosmos-a").withDefault("#12151B"), GDSEColorCosmoAB = create$9("gdse-g-color-cosmos-ab").withDefault("#1F232B"), GDSEColorCosmoB = create$9("gdse-g-color-cosmos-b").withDefault("#2E3037"), GDSEColorCosmoC = create$9("gdse-g-color-cosmos-c").withDefault("#44474D"), GDSEColorCosmoD = create$9("gdse-g-color-cosmos-d").withDefault("#A9ABB3"), GDSEColorCosmoE = create$9("gdse-g-color-cosmos-e").withDefault("#E1E2EA"), GDSEColorMars = create$9("gdse-g-color-mars").withDefault("#FF004E"), GDSEColorMarsA = create$9("gdse-g-color-mars-a").withDefault("#FF4D88"), GDSEColorMarsB = create$9("gdse-g-color-mars-b").withDefault("#FF99B8"), GDSEColorNeptuneA = create$9("gdse-g-color-neptune-a").withDefault("#012770"), globalColors = {
  GDSEColorTransparent,
  GDSEColorBlue100,
  GDSEColorBlue200,
  GDSEColorBlue300,
  GDSEColorBlue400,
  GDSEColorBlue500,
  GDSEColorBlue600,
  GDSEColorBlue700,
  GDSEColorBlue800,
  GDSEColorGrey100,
  GDSEColorGrey200,
  GDSEColorGrey300,
  GDSEColorGrey400,
  GDSEColorGrey500,
  GDSEColorGrey600,
  GDSEColorGrey700,
  GDSEColorGrey800,
  GDSEColorGrey900,
  GDSEColorGreen100,
  GDSEColorGreen200,
  GDSEColorGreen300,
  GDSEColorGreen400,
  GDSEColorGreen500,
  GDSEColorGreen600,
  GDSEColorGreen700,
  GDSEColorYellow100,
  GDSEColorYellow200,
  GDSEColorYellow300,
  GDSEColorYellow400,
  GDSEColorYellow500,
  GDSEColorYellow600,
  GDSEColorYellow700,
  GDSEColorRed100,
  GDSEColorRed200,
  GDSEColorRed300,
  GDSEColorRed400,
  GDSEColorRed500,
  GDSEColorRed600,
  GDSEColorRed700,
  GDSEColorMonoBlack,
  GDSEColorMonoWhite,
  GDSEColorNeptune,
  GDSEColorCosmos,
  GDSEColorSpotlight,
  GDSEColorGanymede,
  GDSEColorTitan,
  GDSEColorOberon,
  GDSEColorOberonA,
  GDSEColorOberonB,
  GDSEColorJupiter,
  GDSEColorJupiterA,
  GDSEColorJupiterB,
  GDSEColorCallisto,
  GDSEColorCallistoA,
  GDSEColorCallistoB,
  GDSEColorCosmoA,
  GDSEColorCosmoAB,
  GDSEColorCosmoB,
  GDSEColorCosmoC,
  GDSEColorCosmoD,
  GDSEColorCosmoE,
  GDSEColorMars,
  GDSEColorMarsA,
  GDSEColorMarsB,
  GDSEColorNeptuneA
}, { create: create$8 } = DesignToken, GDSESpacing0 = create$8("gdse-g-spacing-0").withDefault("0px"), GDSESpacing25 = create$8("gdse-g-spacing-25").withDefault("2px"), GDSESpacing50 = create$8("gdse-g-spacing-50").withDefault("4px"), GDSESpacing75 = create$8("gdse-g-spacing-75").withDefault("6px"), GDSESpacing100 = create$8("gdse-g-spacing-100").withDefault("8px"), GDSESpacing125 = create$8("gdse-g-spacing-125").withDefault("10px"), GDSESpacing150 = create$8("gdse-g-spacing-150").withDefault("12px"), GDSESpacing175 = create$8("gdse-g-spacing-175").withDefault("14px"), GDSESpacing200 = create$8("gdse-g-spacing-200").withDefault("16px"), GDSESpacing225 = create$8("gdse-g-spacing-225").withDefault("18px"), GDSESpacing250 = create$8("gdse-g-spacing-250").withDefault("20px"), GDSESpacing300 = create$8("gdse-g-spacing-300").withDefault("24px"), GDSESpacing400 = create$8("gdse-g-spacing-400").withDefault("32px"), GDSESpacing500 = create$8("gdse-g-spacing-500").withDefault("40px"), GDSESpacing600 = create$8("gdse-g-spacing-600").withDefault("48px"), GDSESpacing800 = create$8("gdse-g-spacing-800").withDefault("64px"), GDSESpacing1000 = create$8("gdse-g-spacing-1000").withDefault("80px"), GDSESpacing1200 = create$8("gdse-g-spacing-1200").withDefault("96px"), GDSESpacing1500 = create$8("gdse-g-spacing-1500").withDefault("120px"), GDSESpacing2000 = create$8("gdse-g-spacing-2000").withDefault("160px"), GDSESpacing2500 = create$8("gdse-g-spacing-2500").withDefault("200px"), globalSpacings = {
  GDSESpacing0,
  GDSESpacing25,
  GDSESpacing50,
  GDSESpacing75,
  GDSESpacing100,
  GDSESpacing125,
  GDSESpacing150,
  GDSESpacing175,
  GDSESpacing200,
  GDSESpacing225,
  GDSESpacing250,
  GDSESpacing300,
  GDSESpacing400,
  GDSESpacing500,
  GDSESpacing600,
  GDSESpacing800,
  GDSESpacing1000,
  GDSESpacing1200,
  GDSESpacing1500,
  GDSESpacing2000,
  GDSESpacing2500
}, { create: create$7 } = DesignToken, GDSEFontFamily = create$7("gdse-g-font-family").withDefault("Averta, sans-serif"), GDSEFontSize1 = create$7("gdse-g-font-size-1").withDefault("12px"), GDSEFontSize2 = create$7("gdse-g-font-size-2").withDefault("14px"), GDSEFontSize3 = create$7("gdse-g-font-size-3").withDefault("16px"), GDSEFontSize4 = create$7("gdse-g-font-size-4").withDefault("18px"), GDSEFontSize5 = create$7("gdse-g-font-size-5").withDefault("20px"), GDSEFontSize6 = create$7("gdse-g-font-size-6").withDefault("23px"), GDSEFontSize7 = create$7("gdse-g-font-size-7").withDefault("26px"), GDSEFontSize8 = create$7("gdse-g-font-size-8").withDefault("29px"), GDSEFontSize9 = create$7("gdse-g-font-size-9").withDefault("32px"), GDSEFontSize10 = create$7("gdse-g-font-size-10").withDefault("36px"), GDSEFontSize11 = create$7("gdse-g-font-size-11").withDefault("41px"), GDSEFontWeightThin = create$7("gdse-g-font-weight-thin").withDefault("200"), GDSEFontWeightLight = create$7("gdse-g-font-weight-light").withDefault("300"), GDSEFontWeightRegular = create$7("gdse-g-font-weight-regular").withDefault("400"), GDSEFontWeightSemiBold = create$7("gdse-g-font-weight-semibold").withDefault("600"), GDSEFontWeightBold = create$7("gdse-g-font-weight-bold").withDefault("700"), GDSELineHeightReset = create$7("gdse-g-line-height-reset").withDefault("100%"), GDSELineHeightTitle = create$7("gdse-g-line-height-title").withDefault("125%"), GDSELineHeightBody = create$7("gdse-g-line-height-body").withDefault("150%"), GDSELetterSpacingNeg2 = create$7("gdse-g-letter-spacing-neg-2").withDefault("-0.02em"), GDSELetterSpacingNeg1 = create$7("gdse-g-letter-spacing-neg-1").withDefault("-0.01em"), GDSELetterSpacing0 = create$7("gdse-g-letter-spacing-0").withDefault("0"), GDSELetterSpacing1 = create$7("gdse-g-letter-spacing-1").withDefault("0.01em"), GDSELetterSpacing2 = create$7("gdse-g-letter-spacing-2").withDefault("0.02em"), GDSEFontFeatureText = create$7("gdse-g-font-feature-text").withDefault("auto"), GDSEFontFeatureTable = create$7("gdse-g-font-feature-table").withDefault("tnum"), GDSETextCaseNone = create$7("gdse-g-text-case-none").withDefault("none"), GDSETextCaseUpper = create$7("gdse-g-text-case-upper").withDefault("uppercase"), Tm1FontSize0 = create$7("tm1-g-font-size-0").withDefault("9px"), Tm1FontSize1 = create$7("tm1-g-font-size-1").withDefault("10px"), Tm1FontSize2 = create$7("tm1-g-font-size-2").withDefault("11px"), Tm1FontSize3 = create$7("tm1-g-font-size-3").withDefault("12px"), Tm1FontSize4 = create$7("tm1-g-font-size-4").withDefault("13px"), Tm1FontSize5 = create$7("tm1-g-font-size-5").withDefault("14px"), Tm1FontSize6 = create$7("tm1-g-font-size-6").withDefault("16px"), Tm1FontSize7 = create$7("tm1-g-font-size-7").withDefault("18px"), Tm1FontSize8 = create$7("tm1-g-font-size-8").withDefault("20px"), Tm1FontSize9 = create$7("tm1-g-font-size-9").withDefault("24px"), Tm1FontSize10 = create$7("tm1-g-font-size-10").withDefault("26px"), Tm1FontSize11 = create$7("tm1-g-font-size-11").withDefault("28px"), Tm1FontSize12 = create$7("tm1-g-font-size-12").withDefault("32px"), Tm1FontSize13 = create$7("tm1-g-font-size-13").withDefault("40px"), Tm1FontSize14 = create$7("tm1-g-font-size-14").withDefault("52px"), Tm1FontSize15 = create$7("tm1-g-font-size-15").withDefault("64px"), Tm1FontLineHeight1 = create$7("tm1-g-font-line-height-1").withDefault("100%"), Tm1FontLineHeight2 = create$7("tm1-g-font-line-height-2").withDefault("110%"), Tm1FontLineHeight3 = create$7("tm1-g-font-line-height-3").withDefault("120%"), Tm1FontLineHeight4 = create$7("tm1-g-font-line-height-4").withDefault("140%"), Tm1FontLetterSpacing1 = create$7("tm1-g-font-letter-spacing-1").withDefault("0px"), Tm1FontLetterSpacing2 = create$7("tm1-g-font-letter-spacing-2").withDefault("1.95px"), Tm1FontTextDecorationNone = create$7("tm1-g-font-text-decoration-none").withDefault("none"), globalTypographies = {
  GDSEFontFamily,
  GDSEFontSize1,
  GDSEFontSize2,
  GDSEFontSize3,
  GDSEFontSize4,
  GDSEFontSize5,
  GDSEFontSize6,
  GDSEFontSize7,
  GDSEFontSize8,
  GDSEFontSize9,
  GDSEFontSize10,
  GDSEFontSize11,
  GDSEFontWeightRegular,
  GDSEFontWeightSemiBold,
  GDSEFontWeightBold,
  GDSEFontWeightLight,
  GDSEFontWeightThin,
  GDSELineHeightReset,
  GDSELineHeightTitle,
  GDSELineHeightBody,
  GDSELetterSpacingNeg2,
  GDSELetterSpacingNeg1,
  GDSELetterSpacing0,
  GDSELetterSpacing1,
  GDSELetterSpacing2,
  GDSEFontFeatureText,
  GDSEFontFeatureTable,
  GDSETextCaseNone,
  GDSETextCaseUpper,
  Tm1FontSize0,
  Tm1FontSize1,
  Tm1FontSize2,
  Tm1FontSize3,
  Tm1FontSize4,
  Tm1FontSize5,
  Tm1FontSize6,
  Tm1FontSize7,
  Tm1FontSize8,
  Tm1FontSize9,
  Tm1FontSize10,
  Tm1FontSize11,
  Tm1FontSize12,
  Tm1FontSize13,
  Tm1FontSize14,
  Tm1FontSize15,
  Tm1FontLineHeight1,
  Tm1FontLineHeight2,
  Tm1FontLineHeight3,
  Tm1FontLineHeight4,
  Tm1FontLetterSpacing1,
  Tm1FontLetterSpacing2,
  Tm1FontTextDecorationNone
}, { create: create$6 } = DesignToken, GDSEWidthNone = create$6("gdse-s-width-none").withDefault(globalBorders.GDSEBorderWidth0), GDSEWidthDefault = create$6("gdse-s-width-default").withDefault(globalBorders.GDSEBorderWidth10), GDSEWidthLarge = create$6("gdse-s-width-large").withDefault(globalBorders.GDSEBorderWidth25), GDSERadiusSharp = create$6("gdse-s-radius-sharp").withDefault(globalBorders.GDSEBorderRadius0), GDSERadiusSurface = create$6("gdse-s-radius-surface").withDefault(globalBorders.GDSEBorderRadius50), GDSERadiusInput = create$6("gdse-s-radius-input").withDefault(globalBorders.GDSEBorderRadius25), GDSERadiusPill = create$6("gdse-s-radius-pill").withDefault(globalBorders.GDSEBorderRadiusFull), GDSERadiusPopover = create$6("gdse-s-radius-popover").withDefault(globalBorders.GDSEBorderRadius25), semanticBorders = {
  GDSEWidthNone,
  GDSEWidthDefault,
  GDSEWidthLarge,
  GDSERadiusSharp,
  GDSERadiusSurface,
  GDSERadiusInput,
  GDSERadiusPill,
  GDSERadiusPopover
}, { create: create$5 } = DesignToken, hexToRgbObj = (td) => {
  const Ae = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(td);
  return Ae ? {
    r: parseInt(Ae[1], 16),
    g: parseInt(Ae[2], 16),
    b: parseInt(Ae[3], 16)
  } : null;
}, GDSEColorBackground = create$5("gdse-s-color-background"), GDSEColorBackgroundAlt = create$5("gdse-s-color-background-alt"), GDSEColorBackgroundOverlay = create$5("gdse-s-color-background-overlay"), GDSEColorSurface = create$5("gdse-s-color-surface"), GDSEColorSurfacePopover = create$5("gdse-s-color-surface-popover"), GDSEColorSurfaceHovered = create$5("gdse-s-color-surface-hovered"), GDSEColorSurfacePressed = create$5("gdse-s-color-surface-pressed"), GDSEColorSurfaceSelected = create$5("gdse-s-color-surface-selected"), GDSEColorSurfaceAlt = create$5("gdse-s-color-surface-alt"), GDSEColorSurfaceInverse = create$5("gdse-s-color-surface-inverse"), GDSEColorSurfaceCard = create$5("gdse-s-color-surface-card"), GDSEColorSurfaceModal = create$5("gdse-s-color-surface-modal"), GDSEColorSurfaceTooltip = create$5("gdse-s-color-surface-tooltip"), GDSEColorFillInfo = create$5("gdse-s-color-fill-info"), GDSEColorFillInfoLight = create$5("gdse-s-color-fill-info-light"), GDSEColorFillPositive = create$5("gdse-s-color-fill-positive"), GDSEColorFillPositiveHovered = create$5("gdse-s-color-fill-positive-hovered"), GDSEColorFillPositivePressed = create$5("gdse-s-color-fill-positive-pressed"), GDSEColorFillPositiveLight = create$5("gdse-s-color-fill-positive-light"), GDSEColorFillPositivePressedLight = create$5("gdse-s-color-fill-positive-pressed-light"), GDSEColorFillPositiveSecondaryHovered = create$5("gdse-s-color-fill-positive-secondary-hovered"), GDSEColorFillPositiveSecondaryPressed = create$5("gdse-s-color-fill-positive-secondary-pressed"), GDSEColorFillCritical = create$5("gdse-s-color-fill-critical"), GDSEColorFillCriticalHovered = create$5("gdse-s-color-fill-critical-hovered"), GDSEColorFillCriticalPressed = create$5("gdse-s-color-fill-critical-pressed"), GDSEColorFillCriticalLight = create$5("gdse-s-color-fill-critical-light"), GDSEColorFillCriticalPressedLight = create$5("gdse-s-color-fill-critical-pressed-light"), GDSEColorFillCriticalSecondaryHovered = create$5("gdse-s-color-fill-critical-secondary-hovered"), GDSEColorFillCriticalSecondaryPressed = create$5("gdse-s-color-fill-critical-secondary-pressed"), GDSEColorFillNegative = create$5("gdse-s-color-fill-negative"), GDSEColorFillWarning = create$5("gdse-s-color-fill-warning"), GDSEColorFillWarningHovered = create$5("gdse-s-color-fill-warning-hovered"), GDSEColorFillWarningPressed = create$5("gdse-s-color-fill-warning-pressed"), GDSEColorFillWarningLight = create$5("gdse-s-color-fill-warning-light"), GDSEColorFillWarningPressedLight = create$5("gdse-s-color-fill-warning-pressed-light"), GDSEColorFillPrimary = create$5("gdse-s-color-fill-primary"), GDSEColorFillPrimaryHovered = create$5("gdse-s-color-fill-primary-hovered"), GDSEColorFillPrimaryPressed = create$5("gdse-s-color-fill-primary-pressed"), GDSEColorFillPrimarySelected = create$5("gdse-s-color-fill-primary-selected"), GDSEColorFillPrimaryDisabled = create$5("gdse-s-color-fill-primary-disabled"), GDSEColorFillPrimaryHoveredLight = create$5("gdse-s-color-fill-primary-hovered-light"), GDSEColorFillPrimaryPressedLight = create$5("gdse-s-color-fill-primary-pressed-light"), GDSEColorFillPrimarySelectedLight = create$5("gdse-s-color-fill-primary-selected-light"), GDSEColorFillPrimaryFocused = create$5("gdse-s-color-fill-primary-focused"), GDSEColorFillLight = create$5("gdse-s-color-fill-light"), GDSEColorFillHoveredLight = create$5("gdse-s-color-fill-hovered-light"), GDSEColorFillPressedLight = create$5("gdse-s-color-fill-pressed-light"), GDSEColorFillHoveredInverse = create$5("gdse-s-color-fill-hovered-inverse"), GDSEColorFillPressedInverse = create$5("gdse-s-color-fill-pressed-inverse"), GDSEColorFillDisabled = create$5("gdse-s-color-fill-disabled"), GDSEColorFillDisabledLight = create$5("gdse-s-color-fill-disabled-light"), GDSEColorFillHovered = create$5("gdse-s-color-fill-hovered"), GDSEColorFillPressed = create$5("gdse-s-color-fill-pressed"), GDSEColorFillFocused = create$5("gdse-s-color-fill-focused"), GDSEColorFillLoading = create$5("gdse-s-color-fill-loading"), GDSEColorFillInput = create$5("gdse-s-color-fill-input"), GDSEColorFillInputHovered = create$5("gdse-s-color-fill-input-hovered"), GDSEColorFillInputFocused = create$5("gdse-s-color-fill-input-focused"), GDSEColorFillInputPressed = create$5("gdse-s-color-fill-input-pressed"), GDSEColorFillInputSelected = create$5("gdse-s-color-fill-input-selected"), GDSEColorFillInputSelectedAlt = create$5("gdse-s-color-fill-input-selected-alt"), GDSEColorFillInputDisabled = create$5("gdse-s-color-fill-input-disabled"), GDSEColorFillDataSold = create$5("gdse-s-color-fill-data-sold"), GDSEColorFillDataSoldMed = create$5("gdse-s-color-fill-data-sold-med"), GDSEColorFillDataSoldLite = create$5("gdse-s-color-fill-data-sold-lite"), GDSEColorFillDataPerformance = create$5("gdse-s-color-fill-data-performance"), GDSEColorFillDataPerformanceMed = create$5("gdse-s-color-fill-data-performance-med"), GDSEColorFillDataPerformanceLite = create$5("gdse-s-color-fill-data-performance-lite"), GDSEColorFillDataComparative = create$5("gdse-s-color-fill-data-comparative"), GDSEColorFillDataComparativeMed = create$5("gdse-s-color-fill-data-comparative-med"), GDSEColorFillDataComparativeLite = create$5("gdse-s-color-fill-data-comparative-lite"), GDSEColorFillDataHold = create$5("gdse-s-color-fill-data-hold"), GDSEColorFillDataBenchmark = create$5("gdse-s-color-fill-data-benchmark"), GDSEColorFillDataAttention = create$5("gdse-s-color-fill-data-attention"), GDSEColorFillDataBg = create$5("gdse-s-color-fill-data-bg"), GDSEColorFillDataBgAlt = create$5("gdse-s-color-fill-data-bg-alt"), GDSEColorFillNavigationDefault = create$5("gdse-s-color-fill-navigation-default"), GDSEColorFillNavigationSelected = create$5("gdse-s-color-fill-navigation-selected"), GDSEColorFillNavigationHovered = create$5("gdse-s-color-fill-navigation-hovered"), GDSEColorFillSecondary = create$5("gdse-s-color-fill-secondary"), GDSEColorFillSecondaryInverse = create$5("gdse-s-color-fill-secondary-inverse"), GDSEColorFillSecondaryHovered = create$5("gdse-s-color-fill-secondary-hovered"), GDSEColorFillSecondaryPressed = create$5("gdse-s-color-fill-secondary-pressed"), GDSEColorFillSecondaryFocused = create$5("gdse-s-color-fill-secondary-focused"), GDSEColorFillSecondaryDisabled = create$5("gdse-s-color-fill-secondary-disabled"), GDSEColorFillSelected = create$5("gdse-s-color-fill-selected"), GDSEColorFillPositiveLightStrong = create$5("gdse-s-color-fill-positive-light-strong"), GDSEColorFillInfoLightStrong = create$5("gdse-s-color-fill-info-light-strong"), GDSEColorFillCriticalLightStrong = create$5("gdse-s-color-fill-critical-light-strong"), GDSEColorFillWarningLightStrong = create$5("gdse-s-color-fill-warning-light-strong"), GDSEColorFillDraft = create$5("gdse-s-color-fill-draft"), GDSEColorText = create$5("gdse-s-color-text"), GDSEColorTextHovered = create$5("gdse-s-color-text-hovered"), GDSEColorTextPressed = create$5("gdse-s-color-text-pressed"), GDSEColorTextFocused = create$5("gdse-s-color-text-focused"), GDSEColorTextLoading = create$5("gdse-s-color-text-loading"), GDSEColorTextStatic = create$5("gdse-s-color-text-static"), GDSEColorTextLight = create$5("gdse-s-color-text-light"), GDSEColorTextMuted = create$5("gdse-s-color-text-muted"), GDSEColorTextInverseStatic = create$5("gdse-s-color-text-inverse-static"), GDSEColorTextInverse = create$5("gdse-s-color-text-inverse"), GDSEColorTextLightInverse = create$5("gdse-s-color-text-light-inverse"), GDSEColorTextMutedInverse = create$5("gdse-s-color-text-muted-inverse"), GDSEColorTextInfo = create$5("gdse-s-color-text-info"), GDSEColorTextInfoStrong = create$5("gdse-s-color-text-info-strong"), GDSEColorTextInfoHovered = create$5("gdse-s-color-text-info-hovered"), GDSEColorTextInformation = create$5("gdse-s-color-text-information"), GDSEColorTextPositive = create$5("gdse-s-color-text-positive"), GDSEColorTextPositiveHovered = create$5("gdse-s-color-text-positive-hovered"), GDSEColorTextCritical = create$5("gdse-s-color-text-critical"), GDSEColorTextCriticalHovered = create$5("gdse-s-color-text-critical-hovered"), GDSEColorTextCriticalStrong = create$5("gdse-s-color-text-critical-strong"), GDSEColorTextWarning = create$5("gdse-s-color-text-warning"), GDSEColorTextPrimary = create$5("gdse-s-color-text-primary"), GDSEColorTextPrimaryHovered = create$5("gdse-s-color-text-primary-hovered"), GDSEColorTextPrimaryPressed = create$5("gdse-s-color-text-primary-pressed"), GDSEColorTextPrimaryInverse = create$5("gdse-s-color-text-primary-inverse"), GDSEColorTextPrimaryLoading = create$5("gdse-s-color-text-primary-loading"), GDSEColorTextPrimaryDisabled = create$5("gdse-s-color-text-primary-disabled"), GDSEColorTextDisabled = create$5("gdse-s-color-text-disabled"), GDSEColorTextData = create$5("gdse-s-color-text-data"), GDSEColorTextNavigationDefault = create$5("gdse-s-color-text-navigation-default"), GDSEColorTextNavigationSelected = create$5("gdse-s-color-text-navigation-selected"), GDSEColorTextNavigationHovered = create$5("gdse-s-color-text-navigation-hovered"), GDSEColorTextSecondary = create$5("gdse-s-color-text-secondary"), GDSEColorTextSecondaryHovered = create$5("gdse-s-color-text-secondary-hovered"), GDSEColorTextSecondaryPressed = create$5("gdse-s-color-text-secondary-pressed"), GDSEColorTextSecondaryFocused = create$5("gdse-s-color-text-secondary-focused"), GDSEColorTextSecondaryDisabled = create$5("gdse-s-color-text-secondary-disabled"), GDSEColorTextSecondaryLoading = create$5("gdse-s-color-text-secondary-loading"), GDSEColorTextInputDefault = create$5("gdse-s-color-text-input-default"), GDSEColorTextInputHovered = create$5("gdse-s-color-text-input-hovered"), GDSEColorTextInputPressed = create$5("gdse-s-color-text-input-pressed"), GDSEColorTextInputFocused = create$5("gdse-s-color-text-input-focused"), GDSEColorTextInputSelected = create$5("gdse-s-color-text-input-selected"), GDSEColorTextInputSelectedAlt = create$5("gdse-s-color-text-input-selected-alt"), GDSEColorTextInputDisabled = create$5("gdse-s-color-text-input-disabled"), GDSEColorTextPositiveSecondary = create$5("gdse-s-color-text-positive-secondary"), GDSEColorTextPositiveSecondaryHovered = create$5("gdse-s-color-text-positive-secondary-hovered"), GDSEColorTextCriticalSecondary = create$5("gdse-s-color-text-critical-secondary"), GDSEColorTextCriticalSecondaryHovered = create$5("gdse-s-color-text-critical-secondary-hovered"), GDSEColorTextOnfill = create$5("gdse-s-color-text-onfill"), GDSEColorTextOnfillHovered = create$5("gdse-s-color-text-onfill-hovered"), GDSEColorTextOnfillStrong = create$5("gdse-s-color-text-onfill-strong"), GDSEColorTextOnfillStrongHovered = create$5("gdse-s-color-text-onfill-strong-hovered"), GDSEColorTextPositiveStrong = create$5("gdse-s-color-text-positive-strong"), GDSEColorTextWarningStrong = create$5("gdse-s-color-text-warning-strong"), GDSEColorBorder = create$5("gdse-s-color-border"), GDSEColorBorderHovered = create$5("gdse-s-color-border-hovered"), GDSEColorBorderPressed = create$5("gdse-s-color-border-pressed"), GDSEColorBorderFocus = create$5("gdse-s-color-border-focus"), GDSEColorBorderFocusInverse = create$5("gdse-s-color-border-focus"), GDSEColorBorderDisabled = create$5("gdse-s-color-border-disabled"), GDSEColorBorderInfo = create$5("gdse-s-color-border-info"), GDSEColorBorderInformation = create$5("gdse-s-color-border-information"), GDSEColorBorderPrimary = create$5("gdse-s-color-border-primary"), GDSEColorBorderPrimaryHovered = create$5("gdse-s-color-border-primary-hovered"), GDSEColorBorderPrimaryPressed = create$5("gdse-s-color-border-primary-pressed"), GDSEColorBorderPrimaryFocused = create$5("gdse-s-color-border-primary-focused"), GDSEColorBorderPrimaryDisabled = create$5("gdse-s-color-border-primary-disabled"), GDSEColorBorderPrimaryLoading = create$5("gdse-s-color-border-primary-loading"), GDSEColorBorderPositive = create$5("gdse-s-color-border-positive"), GDSEColorBorderCritical = create$5("gdse-s-color-border-critical"), GDSEColorBorderWarning = create$5("gdse-s-color-border-warning"), GDSEColorBorderInputDefault = create$5("gdse-s-color-border-input-default"), GDSEColorBorderInputHovered = create$5("gdse-s-color-border-input-hovered"), GDSEColorBorderInputPressed = create$5("gdse-s-color-border-input-pressed"), GDSEColorBorderInputFocused = create$5("gdse-s-color-border-input-focused"), GDSEColorBorderInputActive = create$5("gdse-s-color-border-input-active"), GDSEColorBorderInputDisabled = create$5("gdse-s-color-border-input-disabled"), GDSEColorBorderInputDefaultInverse = create$5("gdse-s-color-border-input-default-inverse"), GDSEColorBorderInputHoveredInverse = create$5("gdse-s-color-border-input-hovered-inverse"), GDSEColorBorderInputActiveInverse = create$5("gdse-s-color-border-input-active-inverse"), GDSEColorBorderInputDisabledInverse = create$5("gdse-s-color-border-input-disabled-inverse"), GDSEColorBorderDataPerformance = create$5("gdse-s-color-border-data-performance"), GDSEColorBorderSecondary = create$5("gdse-s-color-border-secondary"), GDSEColorBorderSecondaryFocus = create$5("gdse-s-color-border-secondary-focus"), GDSEColorBorderSecondaryDisabled = create$5("gdse-s-color-border-secondary-disabled"), GDSEColorBorderSecondaryLoading = create$5("gdse-s-color-border-secondary-loading"), GDSEColorBorderTertiaryLoading = create$5("gdse-s-color-border-tertiary-loading"), GDSEColorBorderPopover = create$5("gdse-s-color-border-popover"), GDSEColorBorderNeutral = create$5("gdse-s-color-border-neutral"), GDSEColorSkeletonShimmer = create$5("gdse-s-color-skeleton-shimmer"), GDSEColorObjectListHover = create$5("gdse-s-color-object-list-hover"), semanticColors = {
  GDSEColorFillPositiveLightStrong,
  GDSEColorFillInfoLightStrong,
  GDSEColorFillCriticalLightStrong,
  GDSEColorFillWarningLightStrong,
  GDSEColorFillDraft,
  GDSEColorTextPositiveStrong,
  GDSEColorTextWarningStrong,
  GDSEColorBorderNeutral,
  GDSEColorBackground,
  GDSEColorBackgroundAlt,
  GDSEColorBackgroundOverlay,
  GDSEColorBorder,
  GDSEColorBorderHovered,
  GDSEColorBorderPressed,
  GDSEColorBorderCritical,
  GDSEColorBorderDisabled,
  GDSEColorBorderFocus,
  GDSEColorBorderFocusInverse,
  GDSEColorBorderInfo,
  GDSEColorBorderInformation,
  GDSEColorBorderInputActive,
  GDSEColorBorderInputActiveInverse,
  GDSEColorBorderInputDefault,
  GDSEColorBorderInputDefaultInverse,
  GDSEColorBorderInputDisabled,
  GDSEColorBorderInputDisabledInverse,
  GDSEColorBorderInputPressed,
  GDSEColorBorderInputFocused,
  GDSEColorBorderDataPerformance,
  GDSEColorBorderSecondary,
  GDSEColorBorderSecondaryFocus,
  GDSEColorBorderSecondaryDisabled,
  GDSEColorBorderSecondaryLoading,
  GDSEColorBorderTertiaryLoading,
  GDSEColorBorderPopover,
  GDSEColorBorderInputHovered,
  GDSEColorBorderInputHoveredInverse,
  GDSEColorBorderPositive,
  GDSEColorBorderPrimary,
  GDSEColorBorderPrimaryHovered,
  GDSEColorBorderPrimaryPressed,
  GDSEColorBorderPrimaryFocused,
  GDSEColorBorderPrimaryDisabled,
  GDSEColorBorderPrimaryLoading,
  GDSEColorBorderWarning,
  GDSEColorFillCritical,
  GDSEColorFillCriticalHovered,
  GDSEColorFillCriticalLight,
  GDSEColorFillCriticalPressed,
  GDSEColorFillCriticalPressedLight,
  GDSEColorFillCriticalSecondaryHovered,
  GDSEColorFillCriticalSecondaryPressed,
  GDSEColorFillNegative,
  GDSEColorFillDisabled,
  GDSEColorFillDisabledLight,
  GDSEColorFillHovered,
  GDSEColorFillPressed,
  GDSEColorFillFocused,
  GDSEColorFillLoading,
  GDSEColorFillHoveredInverse,
  GDSEColorFillHoveredLight,
  GDSEColorFillInfo,
  GDSEColorFillInfoLight,
  GDSEColorFillInput,
  GDSEColorFillInputDisabled,
  GDSEColorFillInputHovered,
  GDSEColorFillInputFocused,
  GDSEColorFillInputPressed,
  GDSEColorFillInputSelected,
  GDSEColorFillInputSelectedAlt,
  GDSEColorFillDataSold,
  GDSEColorFillDataSoldMed,
  GDSEColorFillDataSoldLite,
  GDSEColorFillDataPerformance,
  GDSEColorFillDataPerformanceMed,
  GDSEColorFillDataPerformanceLite,
  GDSEColorFillDataComparative,
  GDSEColorFillDataComparativeMed,
  GDSEColorFillDataComparativeLite,
  GDSEColorFillDataHold,
  GDSEColorFillDataBenchmark,
  GDSEColorFillDataAttention,
  GDSEColorFillDataBg,
  GDSEColorFillDataBgAlt,
  GDSEColorFillNavigationDefault,
  GDSEColorFillNavigationSelected,
  GDSEColorFillNavigationHovered,
  GDSEColorFillSecondary,
  GDSEColorFillSecondaryInverse,
  GDSEColorFillSecondaryHovered,
  GDSEColorFillSecondaryPressed,
  GDSEColorFillSecondaryFocused,
  GDSEColorFillSecondaryDisabled,
  GDSEColorFillLight,
  GDSEColorFillPositive,
  GDSEColorFillPositiveHovered,
  GDSEColorFillPositiveLight,
  GDSEColorFillPositivePressed,
  GDSEColorFillPositivePressedLight,
  GDSEColorFillPositiveSecondaryHovered,
  GDSEColorFillPositiveSecondaryPressed,
  GDSEColorFillPressedInverse,
  GDSEColorFillPressedLight,
  GDSEColorFillPrimary,
  GDSEColorFillPrimaryHovered,
  GDSEColorFillPrimaryHoveredLight,
  GDSEColorFillPrimaryPressed,
  GDSEColorFillPrimaryPressedLight,
  GDSEColorFillPrimarySelected,
  GDSEColorFillPrimarySelectedLight,
  GDSEColorFillPrimaryDisabled,
  GDSEColorFillPrimaryFocused,
  GDSEColorFillWarning,
  GDSEColorFillWarningHovered,
  GDSEColorFillWarningLight,
  GDSEColorFillWarningPressed,
  GDSEColorFillWarningPressedLight,
  GDSEColorSurface,
  GDSEColorSurfacePopover,
  GDSEColorSurfaceAlt,
  GDSEColorSurfaceCard,
  GDSEColorSurfaceModal,
  GDSEColorSurfaceTooltip,
  GDSEColorSurfaceHovered,
  GDSEColorSurfaceInverse,
  GDSEColorSurfacePressed,
  GDSEColorSurfaceSelected,
  GDSEColorText,
  GDSEColorTextHovered,
  GDSEColorTextPressed,
  GDSEColorTextFocused,
  GDSEColorTextLoading,
  GDSEColorTextCritical,
  GDSEColorTextCriticalStrong,
  GDSEColorTextDisabled,
  GDSEColorTextInfo,
  GDSEColorTextInfoStrong,
  GDSEColorTextInfoHovered,
  GDSEColorTextInformation,
  GDSEColorTextInverse,
  GDSEColorTextInverseStatic,
  GDSEColorTextLight,
  GDSEColorTextLightInverse,
  GDSEColorTextMuted,
  GDSEColorTextMutedInverse,
  GDSEColorTextPositive,
  GDSEColorTextPrimary,
  GDSEColorTextPrimaryHovered,
  GDSEColorTextPrimaryPressed,
  GDSEColorTextPrimaryInverse,
  GDSEColorTextPrimaryLoading,
  GDSEColorTextPrimaryDisabled,
  GDSEColorTextData,
  GDSEColorTextNavigationDefault,
  GDSEColorTextNavigationSelected,
  GDSEColorTextNavigationHovered,
  GDSEColorTextSecondary,
  GDSEColorTextSecondaryHovered,
  GDSEColorTextSecondaryPressed,
  GDSEColorTextSecondaryFocused,
  GDSEColorTextSecondaryDisabled,
  GDSEColorTextSecondaryLoading,
  GDSEColorTextInputDefault,
  GDSEColorTextInputHovered,
  GDSEColorTextInputPressed,
  GDSEColorTextInputFocused,
  GDSEColorTextInputSelected,
  GDSEColorTextInputSelectedAlt,
  GDSEColorTextInputDisabled,
  GDSEColorTextPositiveSecondary,
  GDSEColorTextPositiveSecondaryHovered,
  GDSEColorTextCriticalSecondary,
  GDSEColorTextCriticalSecondaryHovered,
  GDSEColorTextOnfill,
  GDSEColorTextOnfillHovered,
  GDSEColorTextOnfillStrong,
  GDSEColorTextOnfillStrongHovered,
  GDSEColorTextStatic,
  GDSEColorTextWarning,
  GDSEColorSkeletonShimmer,
  GDSEColorObjectListHover,
  hexToRgbObj,
  GDSEColorFillSelected
}, deprecatedTokens = [], { create: create$4 } = DesignToken, GDSETypographyTitlePageFontSize = create$4("gdse-s-typography-title-page-font-size").withDefault(
  globalTypographies.GDSEFontSize7
), GDSETypographyTitlePageFontSizeMobile = create$4(
  "gdse-s-typography-title-page-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize7), GDSETypographyTitlePageFontWeight = create$4("gdse-s-typography-title-page-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyTitlePageLineHeight = create$4("gdse-s-typography-title-page-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyTitlePageFontFamily = create$4("gdse-s-typography-title-page-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyTitlePageLetterSpacing = create$4(
  "gdse-s-typography-title-page-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacingNeg1), GDSETypographySubtitlePageFontSize = create$4("gdse-s-typography-subtitle-page-font-size").withDefault(
  globalTypographies.GDSEFontSize5
), GDSETypographySubtitlePageFontSizeMobile = create$4(
  "gdse-s-typography-subtitle-page-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize5), GDSETypographySubtitlePageFontWeight = create$4(
  "gdse-s-typography-subtitle-page-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographySubtitlePageLineHeight = create$4(
  "gdse-s-typography-subtitle-page-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographySubtitlePageFontFamily = create$4(
  "gdse-s-typography-subtitle-page-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographySubtitlePageLetterSpacing = create$4(
  "gdse-s-typography-subtitle-page-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyTitleSectionFontSize = create$4("gdse-s-typography-title-section-font-size").withDefault(
  globalTypographies.GDSEFontSize6
), GDSETypographyTitleSectionFontWeight = create$4(
  "gdse-s-typography-title-section-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyTitleSectionLineHeight = create$4(
  "gdse-s-typography-title-section-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyTitleSectionFontFamily = create$4(
  "gdse-s-typography-title-section-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyTitleSectionLetterSpacing = create$4(
  "gdse-s-typography-title-section-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacingNeg1), GDSETypographySubtitleSectionFontSize = create$4("gdse-s-typography-subtitle-page-font-size").withDefault(
  globalTypographies.GDSEFontSize4
), GDSETypographySubtitleSectionFontWeight = create$4(
  "gdse-s-typography-subtitle-section-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographySubtitleSectionLineHeight = create$4(
  "gdse-s-typography-subtitle-section-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographySubtitleSectionFontFamily = create$4(
  "gdse-s-typography-subtitle-section-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographySubtitleSectionLetterSpacing = create$4(
  "gdse-s-typography-subtitle-section-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyHeadingLFontSize = create$4("gdse-s-typography-heading-l-font-size").withDefault(
  globalTypographies.GDSEFontSize7
), GDSETypographyHeadingLFontSizeMobile = create$4(
  "gdse-s-typography-heading-l-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize7), GDSETypographyHeadingLFontWeight = create$4("gdse-s-typography-heading-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyHeadingLLineHeight = create$4("gdse-s-typography-heading-l-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyHeadingLFontFamily = create$4("gdse-s-typography-heading-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyHeadingLLetterSpacing = create$4("gdse-s-typography-heading-l-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyHeadingMFontSize = create$4("gdse-s-typography-heading-m-font-size").withDefault(
  globalTypographies.GDSEFontSize5
), GDSETypographyHeadingMFontSizeMobile = create$4(
  "gdse-s-typography-heading-m-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize5), GDSETypographyHeadingMFontWeight = create$4("gdse-s-typography-heading-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightSemiBold
), GDSETypographyHeadingMLineHeight = create$4("gdse-s-typography-heading-m-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyHeadingMFontFamily = create$4("gdse-s-typography-heading-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyHeadingMLetterSpacing = create$4("gdse-s-typography-heading-m-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyHeadingSFontSize = create$4("gdse-s-typography-heading-s-font-size").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyHeadingSFontSizeMobile = create$4(
  "gdse-s-typography-heading-s-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize3), GDSETypographyHeadingSFontWeight = create$4("gdse-s-typography-heading-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightSemiBold
), GDSETypographyHeadingSLineHeight = create$4("gdse-s-typography-heading-s-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyHeadingSFontFamily = create$4("gdse-s-typography-heading-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyHeadingSLetterSpacing = create$4("gdse-s-typography-heading-s-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographySubheadingLFontSize = create$4("gdse-s-typography-subheading-l-font-size").withDefault(
  globalTypographies.GDSEFontSize4
), GDSETypographySubheadingLFontWeight = create$4("gdse-s-typography-subheading-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographySubheadingLLineHeight = create$4("gdse-s-typography-subheading-l-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographySubheadingLFontFamily = create$4("gdse-s-typography-subheading-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographySubheadingLLetterSpacing = create$4(
  "gdse-s-typography-subheading-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographySubheadingMFontSize = create$4("gdse-s-typography-subheading-m-font-size").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographySubheadingMFontWeight = create$4("gdse-s-typography-subheading-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographySubheadingMLineHeight = create$4("gdse-s-typography-subheading-m-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographySubheadingMFontFamily = create$4("gdse-s-typography-subheading-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographySubheadingMLetterSpacing = create$4(
  "gdse-s-typography-subheading-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographySubheadingSFontSize = create$4("gdse-s-typography-subheading-s-font-size").withDefault(
  globalTypographies.GDSEFontSize2
), GDSETypographySubheadingSFontWeight = create$4("gdse-s-typography-subheading-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographySubheadingSLineHeight = create$4("gdse-s-typography-subheading-s-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographySubheadingSFontFamily = create$4("gdse-s-typography-subheading-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographySubheadingSLetterSpacing = create$4(
  "gdse-s-typography-subheading-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyDataXXLFontSize = create$4("gdse-s-typography-data-xxl-font-size").withDefault(
  globalTypographies.Tm1FontSize15
), GDSETypographyDataXXLFontSizeMobile = create$4("gdse-s-typography-data-xxl-font-size-mobile").withDefault(
  globalTypographies.Tm1FontSize15
), GDSETypographyDataXXLFontWeight = create$4("gdse-s-typography-data-xxl-font-weight").withDefault(
  globalTypographies.GDSEFontWeightThin
), GDSETypographyDataXXLLineHeight = create$4("gdse-s-typography-data-xxl-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight1
), GDSETypographyDataXXLFontFamily = create$4("gdse-s-typography-data-xxl-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataXXLLetterSpacing = create$4("gdse-s-typography-data-xxl-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing1
), GDSETypographyDataXLFontSize = create$4("gdse-s-typography-data-xl-font-size").withDefault(
  globalTypographies.Tm1FontSize13
), GDSETypographyDataXLFontSizeMobile = create$4("gdse-s-typography-data-xl-font-size-mobile").withDefault(
  globalTypographies.Tm1FontSize13
), GDSETypographyDataXLFontWeight = create$4("gdse-s-typography-data-xl-font-weight").withDefault(
  globalTypographies.GDSEFontWeightThin
), GDSETypographyDataXLFontWeightMobile = create$4(
  "gdse-s-typography-data-xl-font-weight-mobile"
).withDefault(globalTypographies.GDSEFontWeightLight), GDSETypographyDataXLLineHeight = create$4("gdse-s-typography-data-xl-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight1
), GDSETypographyDataXLFontFamily = create$4("gdse-s-typography-data-xl-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataXLLetterSpacing = create$4("gdse-s-typography-data-xl-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing1
), GDSETypographyDataLFontSize = create$4("gdse-s-typography-data-l-font-size").withDefault(
  globalTypographies.GDSEFontSize10
), GDSETypographyDataLFontSizeMobile = create$4("gdse-s-typography-data-l-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize10
), GDSETypographyDataLFontWeight = create$4("gdse-s-typography-data-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyDataLFontWeightMobile = create$4("gdse-s-typography-data-l-font-weight-mobile").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyDataLLineHeight = create$4("gdse-s-typography-data-l-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyDataLFontFamily = create$4("gdse-s-typography-data-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataLLetterSpacing = create$4("gdse-s-typography-data-l-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyDataLFontFeature = create$4("gdse-s-typography-data-l-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureText
), GDSETypographyDataMFontSize = create$4("gdse-s-typography-data-m-font-size").withDefault(
  globalTypographies.GDSEFontSize7
), GDSETypographyDataMFontSizeMobile = create$4("gdse-s-typography-data-m-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize7
), GDSETypographyDataMFontWeight = create$4("gdse-s-typography-data-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyDataMLineHeight = create$4("gdse-s-typography-data-m-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyDataMLineHeightMobile = create$4("gdse-s-typography-data-m-line-height-mobile").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyDataMFontFamily = create$4("gdse-s-typography-data-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataMLetterSpacing = create$4("gdse-s-typography-data-m-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyDataMFontFeature = create$4("gdse-s-typography-data-m-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureText
), GDSETypographyDataSFontSize = create$4("gdse-s-typography-data-s-font-size").withDefault(
  globalTypographies.GDSEFontSize5
), GDSETypographyDataSFontSizeMobile = create$4("gdse-s-typography-data-s-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize5
), GDSETypographyDataSFontWeight = create$4("gdse-s-typography-data-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyDataSLineHeight = create$4("gdse-s-typography-data-s-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyDataSFontFamily = create$4("gdse-s-typography-data-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataSLetterSpacing = create$4("gdse-s-typography-data-s-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyDataSFontFeature = create$4("gdse-s-typography-data-s-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureText
), GDSETypographyDataXSFontSize = create$4("gdse-s-typography-data-xs-font-size").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyDataXSFontSizeMobile = create$4("gdse-s-typography-data-xs-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyDataXSFontWeight = create$4("gdse-s-typography-data-xs-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyDataXSLineHeight = create$4("gdse-s-typography-data-xs-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyDataXSFontFamily = create$4("gdse-s-typography-data-xs-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataXSLetterSpacing = create$4("gdse-s-typography-data-xs-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyDataXSFontFeature = create$4("gdse-s-typography-data-xs-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureText
), GDSETypographyDataContextFontSize = create$4("gdse-s-typography-data-context-font-size").withDefault(
  globalTypographies.Tm1FontSize3
), GDSETypographyDataContextFontSizeMobile = create$4(
  "gdse-s-typography-data-context-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize3), GDSETypographyDataContextFontWeight = create$4("gdse-s-typography-data-context-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyDataContextLineHeight = create$4("gdse-s-typography-data-context-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyDataContextFontFamily = create$4("gdse-s-typography-data-context-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyDataContextLetterSpacing = create$4(
  "gdse-s-typography-data-context-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyTitleListMFontSize = create$4("gdse-s-typography-title-list-m-font-size").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyTitleListMFontWeight = create$4("gdse-s-typography-title-list-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightSemiBold
), GDSETypographyTitleListMLineHeight = create$4("gdse-s-typography-title-list-m-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyTitleListMFontFamily = create$4("gdse-s-typography-title-list-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyTitleListMLetterSpacing = create$4(
  "gdse-s-typography-title-list-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacingNeg1), GDSETypographyTitleListMFontFeature = create$4("gdse-s-typography-title-list-m-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureTable
), GDSETypographySubtitleListMFontSize = create$4("gdse-s-typography-subtitle-list-m-font-size").withDefault(
  globalTypographies.GDSEFontSize2
), GDSETypographySubtitleListMFontWeight = create$4(
  "gdse-s-typography-subtitle-list-m-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographySubtitleListMLineHeight = create$4(
  "gdse-s-typography-subtitle-list-m-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographySubtitleListMFontFamily = create$4(
  "gdse-s-typography-subtitle-list-m-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographySubtitleListMLetterSpacing = create$4(
  "gdse-s-typography-subtitle-list-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographySubtitleListMFontFeature = create$4(
  "gdse-s-typography-subtitle-list-m-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureTable), GDSETypographyTitleListSFontSize = create$4("gdse-s-typography-title-list-s-font-size").withDefault(
  globalTypographies.GDSEFontSize2
), GDSETypographyTitleListSFontWeight = create$4("gdse-s-typography-title-list-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightSemiBold
), GDSETypographyTitleListSLineHeight = create$4("gdse-s-typography-title-list-s-line-height").withDefault(
  globalTypographies.GDSELineHeightTitle
), GDSETypographyTitleListSFontFamily = create$4("gdse-s-typography-title-list-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyTitleListSLetterSpacing = create$4(
  "gdse-s-typography-title-list-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyTitleListSFontFeature = create$4("gdse-s-typography-title-list-s-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureTable
), GDSETypographySubtitleListSFontSize = create$4("gdse-s-typography-subtitle-list-s-font-size").withDefault(
  globalTypographies.GDSEFontSize1
), GDSETypographySubtitleListSFontWeight = create$4(
  "gdse-s-typography-subtitle-list-s-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographySubtitleListSLineHeight = create$4(
  "gdse-s-typography-subtitle-list-s-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographySubtitleListSFontFamily = create$4(
  "gdse-s-typography-subtitle-list-s-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographySubtitleListSLetterSpacing = create$4(
  "gdse-s-typography-subtitle-list-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacingNeg1), GDSETypographySubtitleListSFontFeature = create$4(
  "gdse-s-typography-subtitle-list-s-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureTable), GDSETypographyBodyXLFontSize = create$4("gdse-s-typography-body-xl-font-size").withDefault(
  globalTypographies.GDSEFontSize4
), GDSETypographyBodyXLFontSizeMobile = create$4("gdse-s-typography-body-xl-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize4
), GDSETypographyBodyXLFontWeight = create$4("gdse-s-typography-body-xl-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyBodyXLLineHeight = create$4("gdse-s-typography-body-xl-line-height").withDefault(
  globalTypographies.GDSELineHeightBody
), GDSETypographyBodyXLFontFamily = create$4("gdse-s-typography-body-xl-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyBodyXLLetterSpacing = create$4("gdse-s-typography-body-xl-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyBodyXLFontFeature = create$4("gdse-s-typography-body-xl-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureTable
), GDSETypographyBodyLFontSize = create$4("gdse-s-typography-body-l-font-size").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyBodyLFontSizeMobile = create$4("gdse-s-typography-body-l-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyBodyLFontWeight = create$4("gdse-s-typography-body-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyBodyLLineHeight = create$4("gdse-s-typography-body-l-line-height").withDefault(
  globalTypographies.GDSELineHeightBody
), GDSETypographyBodyLFontFamily = create$4("gdse-s-typography-body-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyBodyLLetterSpacing = create$4("gdse-s-typography-body-l-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyBodyLFontFeature = create$4("gdse-s-typography-body-l-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureTable
), GDSETypographyBodyMFontSize = create$4("gdse-s-typography-body-m-font-size").withDefault(
  globalTypographies.GDSEFontSize2
), GDSETypographyBodyMFontSizeMobile = create$4("gdse-s-typography-body-m-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize2
), GDSETypographyBodyMFontWeight = create$4("gdse-s-typography-body-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyBodyMLineHeight = create$4("gdse-s-typography-body-m-line-height").withDefault(
  globalTypographies.GDSELineHeightBody
), GDSETypographyBodyMFontFamily = create$4("gdse-s-typography-body-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyBodyMLetterSpacing = create$4("gdse-s-typography-body-m-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyBodyMFontFeature = create$4("gdse-s-typography-body-m-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureTable
), GDSETypographyBodySFontSize = create$4("gdse-s-typography-body-s-font-size").withDefault(
  globalTypographies.GDSEFontSize1
), GDSETypographyBodySFontSizeMobile = create$4("gdse-s-typography-body-s-font-size-mobile").withDefault(
  globalTypographies.GDSEFontSize1
), GDSETypographyBodySFontWeight = create$4("gdse-s-typography-body-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyBodySLineHeight = create$4("gdse-s-typography-body-s-line-height").withDefault(
  globalTypographies.GDSELineHeightBody
), GDSETypographyBodySFontFamily = create$4("gdse-s-typography-body-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyBodySLetterSpacing = create$4("gdse-s-typography-body-s-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing0
), GDSETypographyBodySFontFeature = create$4("gdse-s-typography-body-s-font-feature").withDefault(
  globalTypographies.GDSEFontFeatureTable
), GDSETypographyLabelHelpertextHighemphasisFontSize = create$4(
  "gdse-s-typography-label-helpertext-highemphasis-font-size"
).withDefault(globalTypographies.GDSEFontSize1), GDSETypographyLabelHelpertextHighemphasisFontSizeMobile = create$4(
  "gdse-s-typography-label-helpertext-highemphasis-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize1), GDSETypographyLabelHelpertextHighemphasisFontWeight = create$4(
  "gdse-s-typography-label-helpertext-highemphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelHelpertextHighemphasisLineHeight = create$4(
  "gdse-s-typography-label-helpertext-highemphasis-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelHelpertextHighemphasisFontFamily = create$4(
  "gdse-s-typography-label-helpertext-highemphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelHelpertextHighemphasisLetterSpacing = create$4(
  "gdse-s-typography-label-helpertext-highemphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyLabelHelpertextRegularFontSize = create$4(
  "gdse-s-typography-label-helpertext-regular-font-size"
).withDefault(globalTypographies.GDSEFontSize1), GDSETypographyLabelHelpertextRegularFontSizeMobile = create$4(
  "gdse-s-typography-label-helpertext-regular-font-size-mobile"
).withDefault(globalTypographies.GDSEFontSize1), GDSETypographyLabelHelpertextRegularFontWeight = create$4(
  "gdse-s-typography-label-helpertext-regular-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyLabelHelpertextRegularLineHeight = create$4(
  "gdse-s-typography-label-helpertext-regular-line-height"
).withDefault(globalTypographies.GDSELineHeightBody), GDSETypographyLabelHelpertextRegularFontFamily = create$4(
  "gdse-s-typography-label-helpertext-regular-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelHelpertextRegularLetterSpacing = create$4(
  "gdse-s-typography-label-helpertext-regular-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyLabelButtonLFontSize = create$4("gdse-s-typography-label-button-l-font-size").withDefault(
  globalTypographies.GDSEFontSize3
), GDSETypographyLabelButtonLFontWeight = create$4(
  "gdse-s-typography-label-button-l-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelButtonLLineHeight = create$4(
  "gdse-s-typography-label-button-l-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelButtonLFontFamily = create$4(
  "gdse-s-typography-label-button-l-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelButtonLLetterSpacing = create$4(
  "gdse-s-typography-label-button-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelButtonMFontSize = create$4("gdse-s-typography-label-button-m-font-size").withDefault(
  globalTypographies.GDSEFontSize2
), GDSETypographyLabelButtonMFontWeight = create$4(
  "gdse-s-typography-label-button-m-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelButtonMLineHeight = create$4(
  "gdse-s-typography-label-button-m-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelButtonMFontFamily = create$4(
  "gdse-s-typography-label-button-m-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelButtonMLetterSpacing = create$4(
  "gdse-s-typography-label-button-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelButtonSFontSize = create$4("gdse-s-typography-label-button-s-font-size").withDefault(
  globalTypographies.GDSEFontSize1
), GDSETypographyLabelButtonSFontWeight = create$4(
  "gdse-s-typography-label-button-s-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelButtonSLineHeight = create$4(
  "gdse-s-typography-label-button-s-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelButtonSFontFamily = create$4(
  "gdse-s-typography-label-button-s-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelButtonSLetterSpacing = create$4(
  "gdse-s-typography-label-button-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelContainerLFontSize = create$4(
  "gdse-s-typography-label-container-l-font-size"
).withDefault(globalTypographies.GDSEFontSize3), GDSETypographyLabelContainerLFontWeight = create$4(
  "gdse-s-typography-label-container-l-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelContainerLLineHeight = create$4(
  "gdse-s-typography-label-container-l-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelContainerLFontFamily = create$4(
  "gdse-s-typography-label-container-l-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelContainerLLetterSpacing = create$4(
  "gdse-s-typography-label-container-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyLabelContainerLTextTransform = create$4(
  "gdse-s-typography-label-container-l-text-transform"
).withDefault(globalTypographies.GDSETextCaseUpper), GDSETypographyLabelContainerMFontSize = create$4(
  "gdse-s-typography-label-container-m-font-size"
).withDefault(globalTypographies.GDSEFontSize2), GDSETypographyLabelContainerMFontWeight = create$4(
  "gdse-s-typography-label-container-m-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelContainerMLineHeight = create$4(
  "gdse-s-typography-label-container-m-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelContainerMFontFamily = create$4(
  "gdse-s-typography-label-container-m-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelContainerMLetterSpacing = create$4(
  "gdse-s-typography-label-container-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyLabelContainerMTextTransform = create$4(
  "gdse-s-typography-label-container-m-text-transform"
).withDefault(globalTypographies.GDSETextCaseUpper), GDSETypographyLabelContainerSFontSize = create$4(
  "gdse-s-typography-label-container-s-font-size"
).withDefault(globalTypographies.Tm1FontSize2), GDSETypographyLabelContainerSFontWeight = create$4(
  "gdse-s-typography-label-container-s-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelContainerSLineHeight = create$4(
  "gdse-s-typography-label-container-s-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelContainerSFontFamily = create$4(
  "gdse-s-typography-label-container-s-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelContainerSLetterSpacing = create$4(
  "gdse-s-typography-label-container-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing2), GDSETypographyLabelContainerSTextTransform = create$4(
  "gdse-s-typography-label-container-s-text-transform"
).withDefault(globalTypographies.GDSETextCaseUpper), GDSETypographyLabelDataLFontSize = create$4("gdse-s-typography-label-data-l-font-size").withDefault(
  globalTypographies.Tm1FontSize6
), GDSETypographyLabelDataLFontSizeMobile = create$4(
  "gdse-s-typography-label-data-l-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize6), GDSETypographyLabelDataLFontWeight = create$4("gdse-s-typography-label-data-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelDataLLineHeight = create$4("gdse-s-typography-label-data-l-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelDataLFontFamily = create$4("gdse-s-typography-label-data-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelDataLLetterSpacing = create$4(
  "gdse-s-typography-label-data-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelDataMFontSize = create$4("gdse-s-typography-label-data-m-font-size").withDefault(
  globalTypographies.Tm1FontSize5
), GDSETypographyLabelDataMFontWeight = create$4("gdse-s-typography-label-data-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelDataMLineHeight = create$4("gdse-s-typography-label-data-m-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelDataMFontFamily = create$4("gdse-s-typography-label-data-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelDataMLetterSpacing = create$4(
  "gdse-s-typography-label-data-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelDataSFontSize = create$4("gdse-s-typography-label-data-s-font-size").withDefault(
  globalTypographies.Tm1FontSize3
), GDSETypographyLabelDataSFontSizeMobile = create$4(
  "gdse-s-typography-label-data-s-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize3), GDSETypographyLabelDataSFontWeight = create$4("gdse-s-typography-label-data-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelDataSLineHeight = create$4("gdse-s-typography-label-data-s-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelDataSFontFamily = create$4("gdse-s-typography-label-data-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelDataSLetterSpacing = create$4(
  "gdse-s-typography-label-data-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelDataHighemphasisFontSize = create$4(
  "gdse-s-typography-label-data-highemphasis-font-size"
).withDefault(globalTypographies.GDSEFontSize1), GDSETypographyLabelDataHighemphasisFontWeight = create$4(
  "gdse-s-typography-label-data-highemphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelDataHighemphasisLineHeight = create$4(
  "gdse-s-typography-label-data-highemphasis-line-height"
).withDefault(globalTypographies.GDSELineHeightReset), GDSETypographyLabelDataHighemphasisFontFamily = create$4(
  "gdse-s-typography-label-data-highemphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelDataHighemphasisLetterSpacing = create$4(
  "gdse-s-typography-label-data-highemphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelDataHighemphasisFontFeature = create$4(
  "gdse-s-typography-label-data-highemphasis-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureTable), GDSETypographyLabelDataHighemphasisTextTransform = create$4(
  "gdse-s-typography-label-data-highemphasis-text-transform"
).withDefault(globalTypographies.GDSETextCaseUpper), GDSETypographyLabelDataRegularFontSize = create$4(
  "gdse-s-typography-label-data-regular-font-size"
).withDefault(globalTypographies.GDSEFontSize1), GDSETypographyLabelDataRegularFontWeight = create$4(
  "gdse-s-typography-label-data-regular-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyLabelDataRegularLineHeight = create$4(
  "gdse-s-typography-label-data-regular-line-height"
).withDefault(globalTypographies.GDSELineHeightReset), GDSETypographyLabelDataRegularFontFamily = create$4(
  "gdse-s-typography-label-data-regular-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelDataRegularLetterSpacing = create$4(
  "gdse-s-typography-label-data-regular-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelDataRegularFontFeature = create$4(
  "gdse-s-typography-label-data-regular-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureTable), GDSETypographyLabelStatusSFontSize = create$4("gdse-s-typography-label-status-s-font-size").withDefault(
  globalTypographies.Tm1FontSize0
), GDSETypographyLabelStatusSFontWeight = create$4(
  "gdse-s-typography-label-status-s-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelStatusSLineHeight = create$4(
  "gdse-s-typography-label-status-s-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelStatusSFontFamily = create$4(
  "gdse-s-typography-label-status-s-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelStatusSLetterSpacing = create$4(
  "gdse-s-typography-label-status-s-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing2), GDSETypographyLabelStatusMFontSize = create$4("gdse-s-typography-label-status-m-font-size").withDefault(
  globalTypographies.GDSEFontSize1
), GDSETypographyLabelStatusMFontWeight = create$4(
  "gdse-s-typography-label-status-m-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelStatusMLineHeight = create$4(
  "gdse-s-typography-label-status-m-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelStatusMFontFamily = create$4(
  "gdse-s-typography-label-status-m-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelStatusMLetterSpacing = create$4(
  "gdse-s-typography-label-status-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing2), GDSETypographyLabelStatusMFontFeature = create$4(
  "gdse-s-typography-label-status-m-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureText), GDSETypographyLabelStatusMTextTransform = create$4(
  "gdse-s-typography-label-status-m-text-transform"
).withDefault(globalTypographies.GDSETextCaseUpper), GDSETypographyLabelNavigationLFontSize = create$4(
  "gdse-s-typography-label-navigation-l-font-size"
).withDefault(globalTypographies.GDSEFontSize3), GDSETypographyLabelNavigationLFontWeight = create$4(
  "gdse-s-typography-label-navigation-l-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyLabelNavigationLLineHeight = create$4(
  "gdse-s-typography-label-navigation-l-line-height"
).withDefault(globalTypographies.GDSELineHeightReset), GDSETypographyLabelNavigationLFontFamily = create$4(
  "gdse-s-typography-label-navigation-l-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelNavigationLLetterSpacing = create$4(
  "gdse-s-typography-label-navigation-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyLabelNavigationLFontFeature = create$4(
  "gdse-s-typography-label-navigation-l-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureText), GDSETypographyLabelNavigationMFontSize = create$4(
  "gdse-s-typography-label-navigation-m-font-size"
).withDefault(globalTypographies.GDSEFontSize2), GDSETypographyLabelNavigationMFontWeight = create$4(
  "gdse-s-typography-label-navigation-m-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyLabelNavigationMLineHeight = create$4(
  "gdse-s-typography-label-navigation-m-line-height"
).withDefault(globalTypographies.GDSELineHeightTitle), GDSETypographyLabelNavigationMFontFamily = create$4(
  "gdse-s-typography-label-navigation-m-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelNavigationMLetterSpacing = create$4(
  "gdse-s-typography-label-navigation-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing0), GDSETypographyLabelNavigationMFontFeature = create$4(
  "gdse-s-typography-label-navigation-m-font-feature"
).withDefault(globalTypographies.GDSEFontFeatureText), GDSETypographyLabelNavBreadcrumbsFontSize = create$4(
  "gdse-s-typography-label-navigation-m-font-size"
).withDefault(globalTypographies.Tm1FontSize5), GDSETypographyLabelNavBreadcrumbsFontSizeMobile = create$4(
  "gdse-s-typography-label-navigation-m-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize5), GDSETypographyLabelNavBreadcrumbsFontWeight = create$4(
  "gdse-s-typography-label-navigation-m-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyLabelNavBreadcrumbsLineHeight = create$4(
  "gdse-s-typography-label-navigation-m-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelNavBreadcrumbsFontFamily = create$4(
  "gdse-s-typography-label-navigation-m-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelNavBreadcrumbsLetterSpacing = create$4(
  "gdse-s-typography-label-navigation-m-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelUIXLFontSize = create$4("gdse-s-typography-label-ui-xl-font-size").withDefault(
  globalTypographies.Tm1FontSize6
), GDSETypographyLabelUIXLFontWeight = create$4("gdse-s-typography-label-ui-xl-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelUIXLLineHeight = create$4("gdse-s-typography-label-ui-xl-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelUIXLFontFamily = create$4("gdse-s-typography-label-ui-xl-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelUIXLLetterSpacing = create$4(
  "gdse-s-typography-label-ui-xl-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelUIXLEmphasisFontSize = create$4(
  "gdse-s-typography-label-ui-xl-emphasis-font-size"
).withDefault(globalTypographies.Tm1FontSize6), GDSETypographyLabelUIXLEmphasisFontSizeMobile = create$4(
  "gdse-s-typography-label-ui-xl-emphasis-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize6), GDSETypographyLabelUIXLEmphasisFontWeight = create$4(
  "gdse-s-typography-label-ui-xl-emphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelUIXLEmphasisLineHeight = create$4(
  "gdse-s-typography-label-ui-xl-emphasis-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelUIXLEmphasisFontFamily = create$4(
  "gdse-s-typography-label-ui-xl-emphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelUIXLEmphasisLetterSpacing = create$4(
  "gdse-s-typography-label-ui-xl-emphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelUILFontSize = create$4("gdse-s-typography-label-ui-l-font-size").withDefault(
  globalTypographies.Tm1FontSize5
), GDSETypographyLabelUILFontWeight = create$4("gdse-s-typography-label-ui-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelUILLineHeight = create$4("gdse-s-typography-label-ui-l-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelUILFontFamily = create$4("gdse-s-typography-label-ui-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelUILLetterSpacing = create$4("gdse-s-typography-label-ui-l-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing1
), GDSETypographyLabelUILEmphasisFontSize = create$4(
  "gdse-s-typography-label-ui-l-emphasis-font-size"
).withDefault(globalTypographies.Tm1FontSize5), GDSETypographyLabelUILEmphasisFontWeight = create$4(
  "gdse-s-typography-label-ui-l-emphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelUILEmphasisLineHeight = create$4(
  "gdse-s-typography-label-ui-l-emphasis-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelUILEmphasisFontFamily = create$4(
  "gdse-s-typography-label-ui-l-emphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelUILEmphasisLetterSpacing = create$4(
  "gdse-s-typography-label-ui-l-emphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelUIMFontSize = create$4("gdse-s-typography-label-ui-m-font-size").withDefault(
  globalTypographies.Tm1FontSize3
), GDSETypographyLabelUIMFontWeight = create$4("gdse-s-typography-label-ui-m-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelUIMLineHeight = create$4("gdse-s-typography-label-ui-m-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelUIMFontFamily = create$4("gdse-s-typography-label-ui-m-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelUIMLetterSpacing = create$4("gdse-s-typography-label-ui-m-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing1
), GDSETypographyLabelUIMEmphasisFontSize = create$4(
  "gdse-s-typography-label-ui-m-emphasis-font-size"
).withDefault(globalTypographies.Tm1FontSize3), GDSETypographyLabelUIMEmphasisFontWeight = create$4(
  "gdse-s-typography-label-ui-m-emphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelUIMEmphasisLineHeight = create$4(
  "gdse-s-typography-label-ui-m-emphasis-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelUIMEmphasisFontFamily = create$4(
  "gdse-s-typography-label-ui-m-emphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelUIMEmphasisLetterSpacing = create$4(
  "gdse-s-typography-label-ui-m-emphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelUISFontSize = create$4("gdse-s-typography-label-ui-s-font-size").withDefault(
  globalTypographies.Tm1FontSize1
), GDSETypographyLabelUISFontWeight = create$4("gdse-s-typography-label-ui-s-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelUISLineHeight = create$4("gdse-s-typography-label-ui-s-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelUISFontFamily = create$4("gdse-s-typography-label-ui-s-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelUISLetterSpacing = create$4("gdse-s-typography-label-ui-s-letter-spacing").withDefault(
  globalTypographies.GDSELetterSpacing1
), GDSETypographyLabelUISEmphasisFontSize = create$4(
  "gdse-s-typography-label-ui-s-emphasis-font-size"
).withDefault(globalTypographies.Tm1FontSize1), GDSETypographyLabelUISEmphasisFontWeight = create$4(
  "gdse-s-typography-label-ui-s-emphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelUISEmphasisLineHeight = create$4(
  "gdse-s-typography-label-ui-s-emphasis-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelUISEmphasisFontFamily = create$4(
  "gdse-s-typography-label-ui-s-emphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelUISEmphasisLetterSpacing = create$4(
  "gdse-s-typography-label-ui-s-emphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelTableFontSize = create$4("gdse-s-typography-label-table-font-size").withDefault(
  globalTypographies.Tm1FontSize5
), GDSETypographyLabelTableFontWeight = create$4("gdse-s-typography-label-table-font-weight").withDefault(
  globalTypographies.GDSEFontWeightRegular
), GDSETypographyLabelTableLineHeight = create$4("gdse-s-typography-label-table-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyLabelTableFontFamily = create$4("gdse-s-typography-label-table-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyLabelTableLetterSpacing = create$4(
  "gdse-s-typography-label-table-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyLabelTableEmphasisFontSize = create$4(
  "gdse-s-typography-label-table-emphasis-font-size"
).withDefault(globalTypographies.Tm1FontSize5), GDSETypographyLabelTableEmphasisFontWeight = create$4(
  "gdse-s-typography-label-table-emphasis-font-weight"
).withDefault(globalTypographies.GDSEFontWeightSemiBold), GDSETypographyLabelTableEmphasisLineHeight = create$4(
  "gdse-s-typography-label-table-emphasis-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight3), GDSETypographyLabelTableEmphasisFontFamily = create$4(
  "gdse-s-typography-label-table-emphasis-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyLabelTableEmphasisLetterSpacing = create$4(
  "gdse-s-typography-label-table-emphasis-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyStatementLFontSize = create$4("gdse-s-typography-statement-l-font-size").withDefault(
  globalTypographies.Tm1FontSize12
), GDSETypographyStatementLFontSizeMobile = create$4(
  "gdse-s-typography-statement-l-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize12), GDSETypographyStatementLFontWeight = create$4("gdse-s-typography-statement-l-font-weight").withDefault(
  globalTypographies.GDSEFontWeightLight
), GDSETypographyStatementLLineHeight = create$4("gdse-s-typography-statement-l-line-height").withDefault(
  globalTypographies.Tm1FontLineHeight3
), GDSETypographyStatementLFontFamily = create$4("gdse-s-typography-statement-l-font-family").withDefault(
  globalTypographies.GDSEFontFamily
), GDSETypographyStatementLLetterSpacing = create$4(
  "gdse-s-typography-statement-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), GDSETypographyStatementSubtextLFontSize = create$4(
  "gdse-s-typography-statement-subtext-l-font-size"
).withDefault(globalTypographies.Tm1FontSize7), GDSETypographyStatementSubtextLFontSizeMobile = create$4(
  "gdse-s-typography-statement-subtext-l-font-size-mobile"
).withDefault(globalTypographies.Tm1FontSize7), GDSETypographyStatementSubtextLFontWeight = create$4(
  "gdse-s-typography-statement-subtext-l-font-weight"
).withDefault(globalTypographies.GDSEFontWeightRegular), GDSETypographyStatementSubtextLLineHeight = create$4(
  "gdse-s-typography-statement-subtext-l-line-height"
).withDefault(globalTypographies.Tm1FontLineHeight4), GDSETypographyStatementSubtextLFontFamily = create$4(
  "gdse-s-typography-statement-subtext-l-font-family"
).withDefault(globalTypographies.GDSEFontFamily), GDSETypographyStatementSubtextLLetterSpacing = create$4(
  "gdse-s-typography-statement-subtext-l-letter-spacing"
).withDefault(globalTypographies.GDSELetterSpacing1), semanticFonts = {
  GDSETypographyTitlePageFontSize,
  GDSETypographyTitlePageFontSizeMobile,
  GDSETypographyTitlePageFontFamily,
  GDSETypographyTitlePageFontWeight,
  GDSETypographyTitlePageLineHeight,
  GDSETypographyTitlePageLetterSpacing,
  GDSETypographySubtitlePageFontSize,
  GDSETypographySubtitlePageFontSizeMobile,
  GDSETypographySubtitlePageFontWeight,
  GDSETypographySubtitlePageLineHeight,
  GDSETypographySubtitlePageFontFamily,
  GDSETypographySubtitlePageLetterSpacing,
  GDSETypographyTitleSectionFontSize,
  GDSETypographyTitleSectionFontWeight,
  GDSETypographyTitleSectionLineHeight,
  GDSETypographyTitleSectionFontFamily,
  GDSETypographyTitleSectionLetterSpacing,
  GDSETypographySubtitleSectionFontSize,
  GDSETypographySubtitleSectionFontWeight,
  GDSETypographySubtitleSectionLineHeight,
  GDSETypographySubtitleSectionFontFamily,
  GDSETypographySubtitleSectionLetterSpacing,
  GDSETypographyHeadingLFontSize,
  GDSETypographyHeadingLFontSizeMobile,
  GDSETypographyHeadingLFontWeight,
  GDSETypographyHeadingLLineHeight,
  GDSETypographyHeadingLFontFamily,
  GDSETypographyHeadingLLetterSpacing,
  GDSETypographyHeadingMFontSize,
  GDSETypographyHeadingMFontSizeMobile,
  GDSETypographyHeadingMFontWeight,
  GDSETypographyHeadingMLineHeight,
  GDSETypographyHeadingMFontFamily,
  GDSETypographyHeadingMLetterSpacing,
  GDSETypographyHeadingSFontSize,
  GDSETypographyHeadingSFontSizeMobile,
  GDSETypographyHeadingSFontWeight,
  GDSETypographyHeadingSLineHeight,
  GDSETypographyHeadingSFontFamily,
  GDSETypographyHeadingSLetterSpacing,
  GDSETypographySubheadingLFontSize,
  GDSETypographySubheadingLFontWeight,
  GDSETypographySubheadingLLineHeight,
  GDSETypographySubheadingLFontFamily,
  GDSETypographySubheadingLLetterSpacing,
  GDSETypographySubheadingMFontSize,
  GDSETypographySubheadingMFontWeight,
  GDSETypographySubheadingMLineHeight,
  GDSETypographySubheadingMFontFamily,
  GDSETypographySubheadingMLetterSpacing,
  GDSETypographySubheadingSFontSize,
  GDSETypographySubheadingSFontWeight,
  GDSETypographySubheadingSLineHeight,
  GDSETypographySubheadingSFontFamily,
  GDSETypographySubheadingSLetterSpacing,
  GDSETypographyDataXXLFontSize,
  GDSETypographyDataXXLFontSizeMobile,
  GDSETypographyDataXXLFontWeight,
  GDSETypographyDataXXLLineHeight,
  GDSETypographyDataXXLFontFamily,
  GDSETypographyDataXXLLetterSpacing,
  GDSETypographyDataXLFontSize,
  GDSETypographyDataXLFontSizeMobile,
  GDSETypographyDataXLFontWeight,
  GDSETypographyDataXLFontWeightMobile,
  GDSETypographyDataXLLineHeight,
  GDSETypographyDataXLFontFamily,
  GDSETypographyDataXLLetterSpacing,
  GDSETypographyDataLFontSize,
  GDSETypographyDataLFontSizeMobile,
  GDSETypographyDataLFontWeight,
  GDSETypographyDataLFontWeightMobile,
  GDSETypographyDataLLineHeight,
  GDSETypographyDataLFontFamily,
  GDSETypographyDataLFontFeature,
  GDSETypographyDataLLetterSpacing,
  GDSETypographyDataMFontSize,
  GDSETypographyDataMFontSizeMobile,
  GDSETypographyDataMFontWeight,
  GDSETypographyDataMLineHeight,
  GDSETypographyDataMLineHeightMobile,
  GDSETypographyDataMFontFamily,
  GDSETypographyDataMFontFeature,
  GDSETypographyDataMLetterSpacing,
  GDSETypographyDataSFontSize,
  GDSETypographyDataSFontSizeMobile,
  GDSETypographyDataSFontWeight,
  GDSETypographyDataSLineHeight,
  GDSETypographyDataSFontFamily,
  GDSETypographyDataSFontFeature,
  GDSETypographyDataSLetterSpacing,
  GDSETypographyDataXSFontSize,
  GDSETypographyDataXSFontSizeMobile,
  GDSETypographyDataXSFontWeight,
  GDSETypographyDataXSLineHeight,
  GDSETypographyDataXSFontFamily,
  GDSETypographyDataXSFontFeature,
  GDSETypographyDataXSLetterSpacing,
  GDSETypographyDataContextFontSize,
  GDSETypographyDataContextFontSizeMobile,
  GDSETypographyDataContextFontWeight,
  GDSETypographyDataContextLineHeight,
  GDSETypographyDataContextFontFamily,
  GDSETypographyDataContextLetterSpacing,
  GDSETypographyTitleListMFontSize,
  GDSETypographyTitleListMFontWeight,
  GDSETypographyTitleListMLineHeight,
  GDSETypographyTitleListMFontFamily,
  GDSETypographyTitleListMLetterSpacing,
  GDSETypographyTitleListMFontFeature,
  GDSETypographySubtitleListMFontSize,
  GDSETypographySubtitleListMFontWeight,
  GDSETypographySubtitleListMLineHeight,
  GDSETypographySubtitleListMFontFamily,
  GDSETypographySubtitleListMLetterSpacing,
  GDSETypographySubtitleListMFontFeature,
  GDSETypographyTitleListSFontSize,
  GDSETypographyTitleListSFontWeight,
  GDSETypographyTitleListSLineHeight,
  GDSETypographyTitleListSFontFamily,
  GDSETypographyTitleListSLetterSpacing,
  GDSETypographyTitleListSFontFeature,
  GDSETypographySubtitleListSFontSize,
  GDSETypographySubtitleListSFontWeight,
  GDSETypographySubtitleListSLineHeight,
  GDSETypographySubtitleListSFontFamily,
  GDSETypographySubtitleListSLetterSpacing,
  GDSETypographySubtitleListSFontFeature,
  GDSETypographyBodyXLFontSize,
  GDSETypographyBodyXLFontSizeMobile,
  GDSETypographyBodyXLFontWeight,
  GDSETypographyBodyXLLineHeight,
  GDSETypographyBodyXLFontFamily,
  GDSETypographyBodyXLLetterSpacing,
  GDSETypographyBodyXLFontFeature,
  GDSETypographyBodyLFontSize,
  GDSETypographyBodyLFontSizeMobile,
  GDSETypographyBodyLFontWeight,
  GDSETypographyBodyLLineHeight,
  GDSETypographyBodyLFontFamily,
  GDSETypographyBodyLLetterSpacing,
  GDSETypographyBodyLFontFeature,
  GDSETypographyBodyMFontSize,
  GDSETypographyBodyMFontSizeMobile,
  GDSETypographyBodyMFontWeight,
  GDSETypographyBodyMLineHeight,
  GDSETypographyBodyMFontFamily,
  GDSETypographyBodyMLetterSpacing,
  GDSETypographyBodyMFontFeature,
  GDSETypographyBodySFontSize,
  GDSETypographyBodySFontSizeMobile,
  GDSETypographyBodySFontWeight,
  GDSETypographyBodySLineHeight,
  GDSETypographyBodySFontFamily,
  GDSETypographyBodySLetterSpacing,
  GDSETypographyBodySFontFeature,
  GDSETypographyLabelHelpertextHighemphasisFontSize,
  GDSETypographyLabelHelpertextHighemphasisFontSizeMobile,
  GDSETypographyLabelHelpertextHighemphasisFontWeight,
  GDSETypographyLabelHelpertextHighemphasisLineHeight,
  GDSETypographyLabelHelpertextHighemphasisFontFamily,
  GDSETypographyLabelHelpertextHighemphasisLetterSpacing,
  GDSETypographyLabelHelpertextRegularFontSize,
  GDSETypographyLabelHelpertextRegularFontSizeMobile,
  GDSETypographyLabelHelpertextRegularFontWeight,
  GDSETypographyLabelHelpertextRegularLineHeight,
  GDSETypographyLabelHelpertextRegularFontFamily,
  GDSETypographyLabelHelpertextRegularLetterSpacing,
  GDSETypographyLabelButtonLFontSize,
  GDSETypographyLabelButtonLFontWeight,
  GDSETypographyLabelButtonLLineHeight,
  GDSETypographyLabelButtonLFontFamily,
  GDSETypographyLabelButtonLLetterSpacing,
  GDSETypographyLabelButtonMFontSize,
  GDSETypographyLabelButtonMFontWeight,
  GDSETypographyLabelButtonMLineHeight,
  GDSETypographyLabelButtonMFontFamily,
  GDSETypographyLabelButtonMLetterSpacing,
  GDSETypographyLabelButtonSFontSize,
  GDSETypographyLabelButtonSFontWeight,
  GDSETypographyLabelButtonSLineHeight,
  GDSETypographyLabelButtonSFontFamily,
  GDSETypographyLabelButtonSLetterSpacing,
  GDSETypographyLabelContainerLFontSize,
  GDSETypographyLabelContainerLFontWeight,
  GDSETypographyLabelContainerLLineHeight,
  GDSETypographyLabelContainerLFontFamily,
  GDSETypographyLabelContainerLLetterSpacing,
  GDSETypographyLabelContainerLTextTransform,
  GDSETypographyLabelContainerMFontSize,
  GDSETypographyLabelContainerMFontWeight,
  GDSETypographyLabelContainerMLineHeight,
  GDSETypographyLabelContainerMFontFamily,
  GDSETypographyLabelContainerMLetterSpacing,
  GDSETypographyLabelContainerMTextTransform,
  GDSETypographyLabelContainerSFontSize,
  GDSETypographyLabelContainerSFontWeight,
  GDSETypographyLabelContainerSLineHeight,
  GDSETypographyLabelContainerSFontFamily,
  GDSETypographyLabelContainerSLetterSpacing,
  GDSETypographyLabelContainerSTextTransform,
  GDSETypographyLabelDataHighemphasisFontSize,
  GDSETypographyLabelDataHighemphasisFontWeight,
  GDSETypographyLabelDataHighemphasisLineHeight,
  GDSETypographyLabelDataHighemphasisFontFamily,
  GDSETypographyLabelDataHighemphasisLetterSpacing,
  GDSETypographyLabelDataHighemphasisFontFeature,
  GDSETypographyLabelDataHighemphasisTextTransform,
  GDSETypographyLabelDataRegularFontSize,
  GDSETypographyLabelDataRegularFontWeight,
  GDSETypographyLabelDataRegularLineHeight,
  GDSETypographyLabelDataRegularFontFamily,
  GDSETypographyLabelDataRegularLetterSpacing,
  GDSETypographyLabelDataRegularFontFeature,
  GDSETypographyLabelDataLFontSize,
  GDSETypographyLabelDataLFontSizeMobile,
  GDSETypographyLabelDataLFontWeight,
  GDSETypographyLabelDataLLineHeight,
  GDSETypographyLabelDataLFontFamily,
  GDSETypographyLabelDataLLetterSpacing,
  GDSETypographyLabelDataMFontSize,
  GDSETypographyLabelDataMFontWeight,
  GDSETypographyLabelDataMLineHeight,
  GDSETypographyLabelDataMFontFamily,
  GDSETypographyLabelDataMLetterSpacing,
  GDSETypographyLabelDataSFontSize,
  GDSETypographyLabelDataSFontSizeMobile,
  GDSETypographyLabelDataSFontWeight,
  GDSETypographyLabelDataSLineHeight,
  GDSETypographyLabelDataSFontFamily,
  GDSETypographyLabelDataSLetterSpacing,
  GDSETypographyLabelStatusMFontSize,
  GDSETypographyLabelStatusMFontWeight,
  GDSETypographyLabelStatusMLineHeight,
  GDSETypographyLabelStatusMFontFamily,
  GDSETypographyLabelStatusMLetterSpacing,
  GDSETypographyLabelStatusSFontSize,
  GDSETypographyLabelStatusSFontWeight,
  GDSETypographyLabelStatusSLineHeight,
  GDSETypographyLabelStatusSFontFamily,
  GDSETypographyLabelStatusSLetterSpacing,
  GDSETypographyLabelNavigationLFontSize,
  GDSETypographyLabelNavigationLFontWeight,
  GDSETypographyLabelNavigationLLineHeight,
  GDSETypographyLabelNavigationLFontFamily,
  GDSETypographyLabelNavigationLLetterSpacing,
  GDSETypographyLabelNavigationLFontFeature,
  GDSETypographyLabelNavigationMFontSize,
  GDSETypographyLabelNavigationMFontWeight,
  GDSETypographyLabelNavigationMLineHeight,
  GDSETypographyLabelNavigationMFontFamily,
  GDSETypographyLabelNavigationMLetterSpacing,
  GDSETypographyLabelNavigationMFontFeature,
  GDSETypographyLabelNavBreadcrumbsFontSize,
  GDSETypographyLabelNavBreadcrumbsFontSizeMobile,
  GDSETypographyLabelNavBreadcrumbsFontWeight,
  GDSETypographyLabelNavBreadcrumbsLineHeight,
  GDSETypographyLabelNavBreadcrumbsFontFamily,
  GDSETypographyLabelNavBreadcrumbsLetterSpacing,
  GDSETypographyLabelUIXLFontSize,
  GDSETypographyLabelUIXLFontWeight,
  GDSETypographyLabelUIXLLineHeight,
  GDSETypographyLabelUIXLFontFamily,
  GDSETypographyLabelUIXLLetterSpacing,
  GDSETypographyLabelUIXLEmphasisFontSize,
  GDSETypographyLabelUIXLEmphasisFontSizeMobile,
  GDSETypographyLabelUIXLEmphasisFontWeight,
  GDSETypographyLabelUIXLEmphasisLineHeight,
  GDSETypographyLabelUIXLEmphasisFontFamily,
  GDSETypographyLabelUIXLEmphasisLetterSpacing,
  GDSETypographyLabelUILFontSize,
  GDSETypographyLabelUILFontWeight,
  GDSETypographyLabelUILLineHeight,
  GDSETypographyLabelUILFontFamily,
  GDSETypographyLabelUILLetterSpacing,
  GDSETypographyLabelUILEmphasisFontSize,
  GDSETypographyLabelUILEmphasisFontWeight,
  GDSETypographyLabelUILEmphasisLineHeight,
  GDSETypographyLabelUILEmphasisFontFamily,
  GDSETypographyLabelUILEmphasisLetterSpacing,
  GDSETypographyLabelUIMFontSize,
  GDSETypographyLabelUIMFontWeight,
  GDSETypographyLabelUIMLineHeight,
  GDSETypographyLabelUIMFontFamily,
  GDSETypographyLabelUIMLetterSpacing,
  GDSETypographyLabelUIMEmphasisFontSize,
  GDSETypographyLabelUIMEmphasisFontWeight,
  GDSETypographyLabelUIMEmphasisLineHeight,
  GDSETypographyLabelUIMEmphasisFontFamily,
  GDSETypographyLabelUIMEmphasisLetterSpacing,
  GDSETypographyLabelUISFontSize,
  GDSETypographyLabelUISFontWeight,
  GDSETypographyLabelUISLineHeight,
  GDSETypographyLabelUISFontFamily,
  GDSETypographyLabelUISLetterSpacing,
  GDSETypographyLabelUISEmphasisFontSize,
  GDSETypographyLabelUISEmphasisFontWeight,
  GDSETypographyLabelUISEmphasisLineHeight,
  GDSETypographyLabelUISEmphasisFontFamily,
  GDSETypographyLabelUISEmphasisLetterSpacing,
  GDSETypographyLabelTableFontSize,
  GDSETypographyLabelTableFontWeight,
  GDSETypographyLabelTableLineHeight,
  GDSETypographyLabelTableFontFamily,
  GDSETypographyLabelTableLetterSpacing,
  GDSETypographyLabelTableEmphasisFontSize,
  GDSETypographyLabelTableEmphasisFontWeight,
  GDSETypographyLabelTableEmphasisLineHeight,
  GDSETypographyLabelTableEmphasisFontFamily,
  GDSETypographyLabelTableEmphasisLetterSpacing,
  GDSETypographyStatementLFontSize,
  GDSETypographyStatementLFontSizeMobile,
  GDSETypographyStatementLFontWeight,
  GDSETypographyStatementLLineHeight,
  GDSETypographyStatementLFontFamily,
  GDSETypographyStatementLLetterSpacing,
  GDSETypographyStatementSubtextLFontSize,
  GDSETypographyStatementSubtextLFontSizeMobile,
  GDSETypographyStatementSubtextLFontWeight,
  GDSETypographyStatementSubtextLLineHeight,
  GDSETypographyStatementSubtextLFontFamily,
  GDSETypographyStatementSubtextLLetterSpacing
}, { create: create$3 } = DesignToken, GDSESpacingActionHorM = create$3("gdse-s-spacing-action-hor-m").withDefault(globalSpacings.GDSESpacing250), GDSESpacingActionVerM = create$3("gdse-s-spacing-action-ver-m").withDefault(globalSpacings.GDSESpacing150), GDSESpacingActionHorS = create$3("gdse-s-spacing-action-hor-s").withDefault(globalSpacings.GDSESpacing100), GDSESpacingActionVerS = create$3("gdse-s-spacing-action-ver-s").withDefault(globalSpacings.GDSESpacing50), GDSESpacingActionIconM = create$3("gdse-s-spacing-action-icon-m").withDefault(globalSpacings.GDSESpacing250), GDSESpacingActionIconS = create$3("gdse-s-spacing-action-icon-s").withDefault(globalSpacings.GDSESpacing200), GDSESpacingActionIconL = create$3("gdse-s-spacing-action-icon-l").withDefault(globalSpacings.GDSESpacing250), GDSESpacingActionHorL = create$3("gdse-s-spacing-action-hor-l").withDefault(globalSpacings.GDSESpacing200), GDSESpacingActionVerL = create$3("gdse-s-spacing-action-ver-l").withDefault(globalSpacings.GDSESpacing150), GDSESpacingInputHorM = create$3("gdse-s-spacing-input-hor-m").withDefault(globalSpacings.GDSESpacing100), GDSESpacingInputVerM = create$3("gdse-s-spacing-input-ver-m").withDefault(globalSpacings.GDSESpacing100), GDSESpacingInputHorS = create$3("gdse-s-spacing-input-hor-s").withDefault(globalSpacings.GDSESpacing100), GDSESpacingInputVerS = create$3("gdse-s-spacing-input-ver-s").withDefault(globalSpacings.GDSESpacing50), GDSESpacingInputHorL = create$3("gdse-s-spacing-input-hor-l").withDefault(globalSpacings.GDSESpacing125), GDSESpacingInputVerL = create$3("gdse-s-spacing-input-ver-l").withDefault(globalSpacings.GDSESpacing125), GDSESpacingSurfaceHorXS = create$3("gdse-s-spacing-surface-hor-xs").withDefault(globalSpacings.GDSESpacing50), GDSESpacingSurfaceVerXS = create$3("gdse-s-spacing-surface-ver-xs").withDefault(globalSpacings.GDSESpacing50), GDSESpacingListHorS = create$3("gdse-s-spacing-list-hor-s").withDefault(globalSpacings.GDSESpacing150), GDSESpacingListVerS = create$3("gdse-s-spacing-list-ver-s").withDefault(globalSpacings.GDSESpacing100), GDSESpacingPillHorS = create$3("gdse-s-spacing-pill-hor-s").withDefault(globalSpacings.GDSESpacing100), GDSESpacingPillVerS = create$3("gdse-s-spacing-pill-ver-s").withDefault(globalSpacings.GDSESpacing25), GDSESpacingTabHorM = create$3("gdse-s-spacing-tab-hor-m").withDefault(globalSpacings.GDSESpacing0), GDSESpacingTabVerM = create$3("gdse-s-spacing-tab-ver-m").withDefault(globalSpacings.GDSESpacing200), GDSESpacingTabHorL = create$3("gdse-s-spacing-tab-hor-l").withDefault(globalSpacings.GDSESpacing100), GDSESpacingTabVerL = create$3("gdse-s-spacing-tab-ver-l").withDefault(globalSpacings.GDSESpacing150), GDSESpacingTabWidth = create$3("gdse-s-spacing-tab-width").withDefault(globalSpacings.GDSESpacing2000), GDSESpacingTooltipHorM = create$3("gdse-s-spacing-tooltip-hor-m").withDefault(globalSpacings.GDSESpacing125), GDSESpacingTooltipVerM = create$3("gdse-s-spacing-tooltip-ver-m").withDefault(globalSpacings.GDSESpacing75), GDSESpacingTooltipHorL = create$3("gdse-s-spacing-tooltip-hor-l").withDefault(globalSpacings.GDSESpacing200), GDSESpacingTooltipVerL = create$3("gdse-s-spacing-tooltip-ver-l").withDefault(globalSpacings.GDSESpacing200), semanticSpacings = {
  GDSESpacingActionHorM,
  GDSESpacingActionVerM,
  GDSESpacingActionHorS,
  GDSESpacingActionVerS,
  GDSESpacingActionIconM,
  GDSESpacingActionIconS,
  GDSESpacingActionIconL,
  GDSESpacingActionHorL,
  GDSESpacingActionVerL,
  GDSESpacingInputHorM,
  GDSESpacingInputVerM,
  GDSESpacingInputHorS,
  GDSESpacingInputVerS,
  GDSESpacingInputHorL,
  GDSESpacingInputVerL,
  GDSESpacingSurfaceHorXS,
  GDSESpacingSurfaceVerXS,
  GDSESpacingListHorS,
  GDSESpacingListVerS,
  GDSESpacingPillHorS,
  GDSESpacingPillVerS,
  GDSESpacingTabHorM,
  GDSESpacingTabVerM,
  GDSESpacingTabHorL,
  GDSESpacingTabVerL,
  GDSESpacingTabWidth,
  GDSESpacingTooltipHorM,
  GDSESpacingTooltipVerM,
  GDSESpacingTooltipHorL,
  GDSESpacingTooltipVerL
}, { create: create$2 } = DesignToken, GDSEMediaHoverTransform = create$2("gdse-s-media-hover-transform").withDefault(
  "translateX(0) translateY(0) translateZ(0) scale(1.1)"
), { create: create$1 } = DesignToken, GDSEZIndexDefault = create$1("gdse-s-z-index-default").withDefault(0), GDSEZIndexDrawerContent = create$1("gdse-s-z-index-drawer-content").withDefault(4), GDSEZIndexDrawerOverlay = create$1("gdse-s-z-index-drawer-overlay").withDefault(3), GDSEZIndexFilterPanel = create$1("gdse-s-z-index-filter-panel").withDefault(5), GDSEZIndexLayoutAds = create$1("gdse-s-z-index-layout-ads").withDefault(2), GDSEZIndexLayoutFeedback = create$1("gdse-s-z-index-layout-feedback").withDefault(1), GDSEZIndexLayoutHeader = create$1("gdse-s-z-index-layout-header").withDefault(3), GDSEZIndexLayoutMenu = create$1("gdse-s-z-index-layout-menu").withDefault(4), GDSEZIndexLayoutOverlay = create$1("gdse-s-z-index-layout-overlay").withDefault(9), GDSEZIndexReset = create$1("gdse-s-z-index-reset").withDefault(1), GDSEZIndexSearchSuggestBase = create$1("gdse-s-z-index-searchsuggest-base").withDefault(4), GDSEZIndexSearchSuggestFields = create$1("gdse-s-z-index-searchsuggest-fields").withDefault(5), GDSEZIndexSharedAutocomplete = create$1("gdse-s-z-index-shared-autocomplete").withDefault(1), GDSEZIndexTooltip = create$1("gdse-s-z-index-tooltip").withDefault(8), GDSEZIndexUnset = create$1("gdse-s-z-index-unset").withDefault(-1), monoBlackRGB$2 = semanticColors.hexToRgbObj(globalColors.GDSEColorMonoBlack.getValueFor(document.body)), darkTheme = [
  { element: globalColors.GDSEColorTransparent, value: "rgba(0, 0, 0, 0)" },
  // Color
  { element: semanticColors.GDSEColorBackground, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorBackgroundAlt, value: globalColors.GDSEColorCosmos },
  {
    element: semanticColors.GDSEColorBackgroundOverlay,
    value: `rgba(${monoBlackRGB$2 == null ? void 0 : monoBlackRGB$2.r}, ${monoBlackRGB$2 == null ? void 0 : monoBlackRGB$2.g}, ${monoBlackRGB$2 == null ? void 0 : monoBlackRGB$2.b}, 0.65)`
  },
  { element: semanticColors.GDSEColorSurface, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorSurfacePopover, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorSurfaceHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorSurfacePressed, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorSurfaceSelected, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorSurfaceAlt, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorSurfaceInverse, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorSurfaceCard, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorSurfaceModal, value: globalColors.GDSEColorCosmoAB },
  { element: semanticColors.GDSEColorSurfaceTooltip, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillSelected, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorFillHovered, value: globalColors.GDSEColorCosmoAB },
  { element: semanticColors.GDSEColorFillPressed, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillFocused, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorFillDisabled, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillLoading, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorFillLight, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillHoveredLight, value: globalColors.GDSEColorCosmoAB },
  { element: semanticColors.GDSEColorFillPressedLight, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorFillDisabledLight, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorFillHoveredInverse, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillPressedInverse, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorFillPrimary, value: globalColors.GDSEColorNeptune },
  { element: semanticColors.GDSEColorFillPrimaryHovered, value: globalColors.GDSEColorNeptuneA },
  { element: semanticColors.GDSEColorFillPrimaryPressed, value: globalColors.GDSEColorNeptuneA },
  { element: semanticColors.GDSEColorFillPrimarySelected, value: globalColors.GDSEColorNeptune },
  { element: semanticColors.GDSEColorFillPrimaryDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillPrimaryHoveredLight, value: globalColors.GDSEColorBlue800 },
  { element: semanticColors.GDSEColorFillPrimaryPressedLight, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorFillPrimarySelectedLight, value: globalColors.GDSEColorBlue800 },
  { element: semanticColors.GDSEColorFillPrimaryFocused, value: globalColors.GDSEColorNeptune },
  { element: semanticColors.GDSEColorFillSecondary, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorFillSecondaryInverse, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorFillSecondaryHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorFillSecondaryPressed, value: globalColors.GDSEColorCosmoE },
  { element: semanticColors.GDSEColorFillSecondaryFocused, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillSecondaryDisabled, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorFillInfo, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorFillInfoLight, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillPositive, value: globalColors.GDSEColorOberon },
  { element: semanticColors.GDSEColorFillPositiveHovered, value: globalColors.GDSEColorOberonA },
  { element: semanticColors.GDSEColorFillPositivePressed, value: globalColors.GDSEColorOberonB },
  { element: semanticColors.GDSEColorFillPositiveSecondaryHovered, value: globalColors.GDSEColorOberon },
  { element: semanticColors.GDSEColorFillPositiveSecondaryPressed, value: globalColors.GDSEColorOberonA },
  { element: semanticColors.GDSEColorFillPositiveLight, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillPositivePressedLight, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorFillNegative, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorFillCritical, value: globalColors.GDSEColorMars },
  { element: semanticColors.GDSEColorFillCriticalHovered, value: globalColors.GDSEColorMarsA },
  { element: semanticColors.GDSEColorFillCriticalPressed, value: globalColors.GDSEColorMarsB },
  { element: semanticColors.GDSEColorFillCriticalSecondaryHovered, value: globalColors.GDSEColorMars },
  { element: semanticColors.GDSEColorFillCriticalSecondaryPressed, value: globalColors.GDSEColorMarsA },
  { element: semanticColors.GDSEColorFillCriticalLight, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillCriticalPressedLight, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorFillWarning, value: globalColors.GDSEColorTitan },
  { element: semanticColors.GDSEColorFillWarningHovered, value: globalColors.GDSEColorYellow500 },
  { element: semanticColors.GDSEColorFillWarningPressed, value: globalColors.GDSEColorYellow600 },
  { element: semanticColors.GDSEColorFillWarningLight, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillWarningPressedLight, value: globalColors.GDSEColorYellow600 },
  { element: semanticColors.GDSEColorFillNavigationDefault, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillNavigationHovered, value: globalColors.GDSEColorCosmoC },
  {
    element: semanticColors.GDSEColorFillNavigationSelected,
    value: globalColors.GDSEColorSpotlight
  },
  { element: semanticColors.GDSEColorFillDataSold, value: globalColors.GDSEColorOberon },
  { element: semanticColors.GDSEColorFillDataSoldMed, value: globalColors.GDSEColorOberonA },
  { element: semanticColors.GDSEColorFillDataSoldLite, value: globalColors.GDSEColorOberonB },
  { element: semanticColors.GDSEColorFillDataPerformance, value: globalColors.GDSEColorJupiter },
  { element: semanticColors.GDSEColorFillDataPerformanceMed, value: globalColors.GDSEColorJupiterA },
  {
    element: semanticColors.GDSEColorFillDataPerformanceLite,
    value: globalColors.GDSEColorJupiterB
  },
  { element: semanticColors.GDSEColorFillDataComparative, value: globalColors.GDSEColorCallisto },
  { element: semanticColors.GDSEColorFillDataComparativeMed, value: globalColors.GDSEColorCallistoA },
  {
    element: semanticColors.GDSEColorFillDataComparativeLite,
    value: globalColors.GDSEColorCallistoB
  },
  { element: semanticColors.GDSEColorFillDataHold, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorFillDataBenchmark, value: globalColors.GDSEColorGanymede },
  { element: semanticColors.GDSEColorFillDataAttention, value: globalColors.GDSEColorTitan },
  { element: semanticColors.GDSEColorFillDataBg, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillDataBgAlt, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorFillInput, value: globalColors.GDSEColorCosmoAB },
  { element: semanticColors.GDSEColorFillInputHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorFillInputFocused, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorFillInputPressed, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorFillPressedLight, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorFillInputSelected, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorFillInputSelectedAlt, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillInputDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorText, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextOnfill, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextOnfillHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextOnfillStrong, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextOnfillStrongHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextPressed, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextLoading, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextDisabled, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorTextData, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextLight, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorTextMuted, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorTextInverse, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextLightInverse, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextMutedInverse, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextStatic, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextInverseStatic, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextInfo, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextInfoStrong, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorTextInfoHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextPositive, value: globalColors.GDSEColorOberon },
  { element: semanticColors.GDSEColorTextPositiveSecondary, value: globalColors.GDSEColorOberon },
  { element: semanticColors.GDSEColorTextPositiveSecondaryHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextCritical, value: globalColors.GDSEColorMars },
  { element: semanticColors.GDSEColorTextCriticalSecondary, value: globalColors.GDSEColorMars },
  { element: semanticColors.GDSEColorTextCriticalSecondaryHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextCriticalStrong, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextWarning, value: globalColors.GDSEColorTitan },
  { element: semanticColors.GDSEColorTextInformation, value: globalColors.GDSEColorGanymede },
  { element: semanticColors.GDSEColorTextPrimary, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextPrimaryHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextPrimaryPressed, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextPrimaryInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorTextPrimaryDisabled, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorTextPrimaryLoading, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextSecondary, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextSecondaryHovered, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorTextSecondaryPressed, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorTextSecondaryFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextSecondaryDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorTextSecondaryLoading, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextNavigationDefault, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorTextNavigationSelected, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextNavigationHovered, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorTextInputDefault, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextInputHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextInputPressed, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextInputFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorTextInputSelected, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorTextInputSelectedAlt, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorTextInputDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorder, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPressed, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorBorderFocus, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderFocusInverse, value: globalColors.GDSEColorCosmoA },
  { element: semanticColors.GDSEColorBorderDisabled, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorBorderInfo, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorBorderPrimary, value: globalColors.GDSEColorNeptune },
  { element: semanticColors.GDSEColorBorderPrimaryHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPrimaryPressed, value: globalColors.GDSEColorCosmoE },
  { element: semanticColors.GDSEColorBorderPrimaryFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPrimaryDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderPrimaryLoading, value: globalColors.GDSEColorNeptune },
  { element: semanticColors.GDSEColorBorderSecondary, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderSecondaryFocus, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderSecondaryDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderSecondaryLoading, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderTertiaryLoading, value: globalColors.GDSEColorCosmos },
  { element: semanticColors.GDSEColorBorderPopover, value: globalColors.GDSEColorCosmoB },
  { element: semanticColors.GDSEColorBorderPositive, value: globalColors.GDSEColorOberon },
  { element: semanticColors.GDSEColorBorderCritical, value: globalColors.GDSEColorMars },
  { element: semanticColors.GDSEColorBorderWarning, value: globalColors.GDSEColorTitan },
  { element: semanticColors.GDSEColorBorderInputDefault, value: globalColors.GDSEColorCosmoD },
  { element: semanticColors.GDSEColorBorderInputHovered, value: globalColors.GDSEColorCosmoE },
  { element: semanticColors.GDSEColorBorderInputPressed, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderInputFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderInputActive, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderInputDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderInputDefaultInverse, value: globalColors.GDSEColorGrey300 },
  {
    element: semanticColors.GDSEColorBorderInputHoveredInverse,
    value: globalColors.GDSEColorMonoWhite
  },
  { element: semanticColors.GDSEColorBorderInputActiveInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorBorderInputDisabledInverse, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorBorderInformation, value: globalColors.GDSEColorGanymede },
  { element: semanticColors.GDSEColorBorderDataPerformance, value: globalColors.GDSEColorJupiter },
  // Specific cases
  {
    element: semanticColors.GDSEColorSkeletonShimmer,
    value: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0px, rgba(255, 255, 255, 0.1) 20%, rgba(255, 255, 255, 0.1) 40%, rgba(255, 255, 255, 0))"
  },
  { element: semanticColors.GDSEColorObjectListHover, value: globalColors.GDSEColorCosmoA },
  // Spacing
  { element: semanticSpacings.GDSESpacingActionHorM, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingActionHorS, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingActionVerS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingActionIconM, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionIconS, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingActionIconL, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionHorL, value: globalSpacings.GDSESpacing300 },
  { element: semanticSpacings.GDSESpacingActionVerL, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingInputHorM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingInputVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingSurfaceHorXS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingSurfaceVerXS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingListHorS, value: globalSpacings.GDSESpacing125 },
  { element: semanticSpacings.GDSESpacingListVerS, value: globalSpacings.GDSESpacing125 },
  { element: semanticSpacings.GDSESpacingPillHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingPillVerS, value: globalSpacings.GDSESpacing25 },
  { element: semanticSpacings.GDSESpacingTabHorM, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingTabVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabHorL, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingTabVerL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingTabWidth, value: globalSpacings.GDSESpacing2000 },
  { element: semanticSpacings.GDSESpacingTooltipHorM, value: globalSpacings.GDSESpacing125 },
  { element: semanticSpacings.GDSESpacingTooltipVerM, value: globalSpacings.GDSESpacing75 },
  { element: semanticSpacings.GDSESpacingTooltipHorL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingTooltipVerL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingInputHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingInputVerS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingInputHorL, value: globalSpacings.GDSESpacing125 },
  { element: semanticSpacings.GDSESpacingInputVerL, value: globalSpacings.GDSESpacing125 },
  // Border
  { element: semanticBorders.GDSERadiusPopover, value: globalBorders.GDSEBorderRadius50 },
  { element: semanticBorders.GDSERadiusInput, value: globalBorders.GDSEBorderRadius50 },
  // Typography
  {
    element: semanticFonts.GDSETypographyTitlePageFontSize,
    value: globalTypographies.Tm1FontSize13
  },
  {
    element: semanticFonts.GDSETypographyTitlePageFontSizeMobile,
    value: globalTypographies.Tm1FontSize8
  },
  {
    element: semanticFonts.GDSETypographyTitlePageLineHeight,
    value: globalTypographies.Tm1FontLineHeight2
  },
  {
    element: semanticFonts.GDSETypographyTitlePageLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageFontSize,
    value: globalTypographies.Tm1FontSize6
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageFontSizeMobile,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyHeadingLFontSize,
    value: globalTypographies.Tm1FontSize12
  },
  {
    element: semanticFonts.GDSETypographyHeadingLLineHeight,
    value: globalTypographies.Tm1FontLineHeight2
  },
  {
    element: semanticFonts.GDSETypographyHeadingLLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontSize,
    value: globalTypographies.Tm1FontSize9
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyHeadingMLineHeight,
    value: globalTypographies.Tm1FontLineHeight2
  },
  {
    element: semanticFonts.GDSETypographyHeadingMLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyHeadingSFontSize,
    value: globalTypographies.Tm1FontSize7
  },
  {
    element: semanticFonts.GDSETypographyHeadingSFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyHeadingSLineHeight,
    value: globalTypographies.Tm1FontLineHeight2
  },
  {
    element: semanticFonts.GDSETypographyHeadingSLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographySubheadingSFontSize,
    value: globalTypographies.Tm1FontSize2
  },
  {
    element: semanticFonts.GDSETypographySubheadingSLineHeight,
    value: globalTypographies.Tm1FontLineHeight1
  },
  {
    element: semanticFonts.GDSETypographySubheadingSLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyDataLFontSize,
    value: globalTypographies.Tm1FontSize13
  },
  {
    element: semanticFonts.GDSETypographyDataLFontWeight,
    value: globalTypographies.GDSEFontWeightThin
  },
  {
    element: semanticFonts.GDSETypographyDataLLineHeight,
    value: globalTypographies.Tm1FontLineHeight1
  },
  {
    element: semanticFonts.GDSETypographyDataLLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyDataMFontSize,
    value: globalTypographies.Tm1FontSize12
  },
  {
    element: semanticFonts.GDSETypographyDataMFontWeight,
    value: globalTypographies.GDSEFontWeightLight
  },
  {
    element: semanticFonts.GDSETypographyDataMLineHeight,
    value: globalTypographies.Tm1FontLineHeight1
  },
  {
    element: semanticFonts.GDSETypographyDataMLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyDataSFontSize,
    value: globalTypographies.Tm1FontSize6
  },
  {
    element: semanticFonts.GDSETypographyDataSLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyDataSLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyDataXSFontSize,
    value: globalTypographies.Tm1FontSize3
  },
  {
    element: semanticFonts.GDSETypographyDataXSLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyDataXSLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyBodyXLFontSize,
    value: globalTypographies.Tm1FontSize7
  },
  {
    element: semanticFonts.GDSETypographyBodyXLLineHeight,
    value: globalTypographies.Tm1FontLineHeight4
  },
  {
    element: semanticFonts.GDSETypographyBodyXLLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyBodyLFontSize,
    value: globalTypographies.Tm1FontSize6
  },
  {
    element: semanticFonts.GDSETypographyBodyLLineHeight,
    value: globalTypographies.Tm1FontLineHeight4
  },
  {
    element: semanticFonts.GDSETypographyBodyLLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyBodyMFontSize,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyBodyMLineHeight,
    value: globalTypographies.Tm1FontLineHeight4
  },
  {
    element: semanticFonts.GDSETypographyBodyMLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyBodySFontSize,
    value: globalTypographies.Tm1FontSize3
  },
  {
    element: semanticFonts.GDSETypographyBodySLineHeight,
    value: globalTypographies.Tm1FontLineHeight4
  },
  {
    element: semanticFonts.GDSETypographyBodySLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontSize,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularFontSize,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMFontSize,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSFontSize,
    value: globalTypographies.Tm1FontSize3
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMFontSize,
    value: globalTypographies.Tm1FontSize4
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMLineHeight,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing2
  },
  {
    element: semanticFonts.GDSETypographyStatementLFontSize,
    value: globalTypographies.Tm1FontSize12
  },
  {
    element: semanticFonts.GDSETypographyStatementLFontSizeMobile,
    value: globalTypographies.Tm1FontSize11
  },
  {
    element: semanticFonts.GDSETypographyStatementSubtextLFontSizeMobile,
    value: globalTypographies.Tm1FontSize6
  },
  {
    element: semanticFonts.GDSETypographyHeadingLFontSizeMobile,
    value: globalTypographies.Tm1FontSize10
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontSizeMobile,
    value: globalTypographies.Tm1FontSize8
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontSizeMobile,
    value: globalTypographies.Tm1FontSize6
  },
  {
    element: semanticFonts.GDSETypographyDataXXLFontSizeMobile,
    value: globalTypographies.Tm1FontSize14
  },
  {
    element: semanticFonts.GDSETypographyDataXLFontSizeMobile,
    value: globalTypographies.Tm1FontSize12
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerSFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerSLetterSpacing,
    value: globalTypographies.Tm1FontLetterSpacing2
  },
  {
    element: semanticFonts.GDSETypographyLabelUIXLEmphasisFontSizeMobile,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyLabelNavBreadcrumbsFontSizeMobile,
    value: globalTypographies.Tm1FontSize12
  },
  {
    element: semanticFonts.GDSETypographyLabelDataSFontSizeMobile,
    value: globalTypographies.Tm1FontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelDataLFontSizeMobile,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularFontSizeMobile,
    value: globalTypographies.Tm1FontSize0
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontSizeMobile,
    value: globalTypographies.Tm1FontSize0
  },
  {
    element: semanticFonts.GDSETypographyBodySFontSizeMobile,
    value: globalTypographies.Tm1FontSize1
  },
  {
    element: semanticFonts.GDSETypographyBodyMFontSizeMobile,
    value: globalTypographies.Tm1FontSize3
  },
  {
    element: semanticFonts.GDSETypographyBodyLFontSizeMobile,
    value: globalTypographies.Tm1FontSize3
  },
  {
    element: semanticFonts.GDSETypographyBodyXLFontSize,
    value: globalTypographies.Tm1FontSize3
  },
  {
    element: semanticFonts.GDSETypographyDataContextFontSizeMobile,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyDataXSFontSizeMobile,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyDataSFontSizeMobile,
    value: globalTypographies.Tm1FontSize5
  },
  {
    element: semanticFonts.GDSETypographyDataMLineHeightMobile,
    value: globalTypographies.Tm1FontLineHeight3
  },
  {
    element: semanticFonts.GDSETypographyDataMFontSizeMobile,
    value: globalTypographies.Tm1FontSize11
  },
  {
    element: semanticFonts.GDSETypographyDataLFontWeightMobile,
    value: globalTypographies.GDSEFontWeightLight
  },
  {
    element: semanticFonts.GDSETypographyDataLFontSizeMobile,
    value: globalTypographies.Tm1FontSize9
  }
], monoBlackRGB$1 = semanticColors.hexToRgbObj(globalColors.GDSEColorMonoBlack.getValueFor(document.body)), monoWhiteRGB$1 = semanticColors.hexToRgbObj(globalColors.GDSEColorMonoWhite.getValueFor(document.body)), legacyTheme = [
  { element: globalColors.GDSEColorTransparent, value: "rgba(0, 0, 0, 0)" },
  // Color
  { element: semanticColors.GDSEColorBackground, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorBackgroundAlt, value: globalColors.GDSEColorGrey100 },
  {
    element: semanticColors.GDSEColorBackgroundOverlay,
    value: `rgba(${monoBlackRGB$1 == null ? void 0 : monoBlackRGB$1.r}, ${monoBlackRGB$1 == null ? void 0 : monoBlackRGB$1.g}, ${monoBlackRGB$1 == null ? void 0 : monoBlackRGB$1.b}, 0.65)`
  },
  { element: semanticColors.GDSEColorSurface, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfacePopover, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfaceHovered, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorSurfacePressed, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorSurfaceSelected, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorSurfaceAlt, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorSurfaceInverse, value: globalColors.GDSEColorGrey800 },
  { element: semanticColors.GDSEColorSurfaceCard, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfaceModal, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfaceTooltip, value: globalColors.GDSEColorGrey900 },
  { element: semanticColors.GDSEColorFillSelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillHovered, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorFillPressed, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorFillDisabled, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillLoading, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorFillLight, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillHoveredLight, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillPressedLight, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorFillDisabledLight, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillHoveredInverse, value: `rgba(${monoWhiteRGB$1 == null ? void 0 : monoWhiteRGB$1.r}, ${monoWhiteRGB$1 == null ? void 0 : monoWhiteRGB$1.g}, ${monoWhiteRGB$1 == null ? void 0 : monoWhiteRGB$1.b}, 0.2)` },
  { element: semanticColors.GDSEColorFillPressedInverse, value: `rgba(${monoWhiteRGB$1 == null ? void 0 : monoWhiteRGB$1.r}, ${monoWhiteRGB$1 == null ? void 0 : monoWhiteRGB$1.g}, ${monoWhiteRGB$1 == null ? void 0 : monoWhiteRGB$1.b}, 0.4)` },
  { element: semanticColors.GDSEColorFillPrimary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillPrimaryHovered, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorFillPrimaryPressed, value: globalColors.GDSEColorBlue800 },
  { element: semanticColors.GDSEColorFillPrimarySelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillPrimaryDisabled, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorFillPrimaryHoveredLight, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillPrimaryPressedLight, value: globalColors.GDSEColorBlue200 },
  { element: semanticColors.GDSEColorFillPrimarySelectedLight, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillPrimaryFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorFillSecondary, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillSecondaryInverse, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorFillSecondaryHovered, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillSecondaryPressed, value: globalColors.GDSEColorBlue200 },
  { element: semanticColors.GDSEColorFillSecondaryFocused, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorFillSecondaryDisabled, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillInfo, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillInfoLight, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillPositive, value: globalColors.GDSEColorGreen500 },
  { element: semanticColors.GDSEColorFillPositiveHovered, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorFillPositivePressed, value: globalColors.GDSEColorGreen700 },
  { element: semanticColors.GDSEColorFillPositiveLight, value: globalColors.GDSEColorGreen100 },
  { element: semanticColors.GDSEColorFillPositivePressedLight, value: globalColors.GDSEColorGreen200 },
  { element: semanticColors.GDSEColorFillPositiveSecondaryHovered, value: globalColors.GDSEColorGreen100 },
  { element: semanticColors.GDSEColorFillPositiveSecondaryPressed, value: globalColors.GDSEColorGreen200 },
  { element: semanticColors.GDSEColorFillNegative, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorFillCritical, value: globalColors.GDSEColorRed500 },
  { element: semanticColors.GDSEColorFillCriticalSecondaryHovered, value: globalColors.GDSEColorRed100 },
  { element: semanticColors.GDSEColorFillCriticalSecondaryPressed, value: globalColors.GDSEColorRed200 },
  { element: semanticColors.GDSEColorFillCriticalHovered, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorFillCriticalPressed, value: globalColors.GDSEColorRed700 },
  { element: semanticColors.GDSEColorFillCriticalLight, value: globalColors.GDSEColorRed100 },
  { element: semanticColors.GDSEColorFillCriticalPressedLight, value: globalColors.GDSEColorRed200 },
  { element: semanticColors.GDSEColorFillWarning, value: globalColors.GDSEColorYellow400 },
  { element: semanticColors.GDSEColorFillWarningHovered, value: globalColors.GDSEColorYellow500 },
  { element: semanticColors.GDSEColorFillWarningPressed, value: globalColors.GDSEColorYellow600 },
  { element: semanticColors.GDSEColorFillWarningLight, value: globalColors.GDSEColorYellow100 },
  { element: semanticColors.GDSEColorFillWarningPressedLight, value: globalColors.GDSEColorYellow200 },
  { element: semanticColors.GDSEColorFillNavigationDefault, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillNavigationHovered, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillNavigationSelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillDataSold, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillDataSoldMed, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorFillDataSoldLite, value: globalColors.GDSEColorBlue400 },
  { element: semanticColors.GDSEColorFillDataPerformance, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillDataPerformanceMed, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorFillDataPerformanceLite, value: globalColors.GDSEColorBlue400 },
  { element: semanticColors.GDSEColorFillDataComparative, value: globalColors.GDSEColorCallistoA },
  { element: semanticColors.GDSEColorFillDataComparativeMed, value: globalColors.GDSEColorCallistoA },
  {
    element: semanticColors.GDSEColorFillDataComparativeLite,
    value: globalColors.GDSEColorCallistoB
  },
  { element: semanticColors.GDSEColorFillDataHold, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillDataBenchmark, value: "#18c9A0" },
  // TODO Fix when we have the token name
  { element: semanticColors.GDSEColorFillDataAttention, value: globalColors.GDSEColorYellow300 },
  { element: semanticColors.GDSEColorFillDataBg, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillDataBgAlt, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillInput, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillInputHovered, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorFillInputFocused, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillInputPressed, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillPressedLight, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorFillInputSelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillInputSelectedAlt, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillInputDisabled, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorText, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextOnfill, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextOnfillHovered, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextOnfillStrong, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextOnfillStrongHovered, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextDisabled, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextData, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextLight, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextMuted, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextInverse, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextLightInverse, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextMutedInverse, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextStatic, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextInverseStatic, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextInfo, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextInfoStrong, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorTextInfoHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextPositive, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorTextPositiveSecondary, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorTextPositiveSecondaryHovered, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorTextCritical, value: globalColors.GDSEColorRed500 },
  { element: semanticColors.GDSEColorTextCriticalSecondary, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextCriticalSecondaryHovered, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextCriticalStrong, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextWarning, value: globalColors.GDSEColorYellow600 },
  { element: semanticColors.GDSEColorTextInformation, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextPrimary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextPrimaryHovered, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorTextPrimaryPressed, value: globalColors.GDSEColorBlue800 },
  { element: semanticColors.GDSEColorTextPrimaryInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorTextPrimaryDisabled, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextPrimaryLoading, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextSecondary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextSecondaryHovered, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextSecondaryPressed, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextSecondaryFocused, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextSecondaryDisabled, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextSecondaryLoading, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextNavigationDefault, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextNavigationSelected, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextNavigationHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputDefault, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextInputHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputSelected, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputSelectedAlt, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputDisabled, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorder, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorBorderHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderFocus, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderFocusInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorBorderDisabled, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorBorderInfo, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderPrimary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderPrimaryHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPrimaryPressed, value: globalColors.GDSEColorCosmoE },
  { element: semanticColors.GDSEColorBorderPrimaryFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPrimaryDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderPrimaryLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderSecondary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderSecondaryFocus, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderSecondaryDisabled, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderSecondaryLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderTertiaryLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderPopover, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorBorderPositive, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorBorderCritical, value: globalColors.GDSEColorRed500 },
  { element: semanticColors.GDSEColorBorderWarning, value: globalColors.GDSEColorYellow500 },
  { element: semanticColors.GDSEColorBorderInputDefault, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorBorderInputHovered, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorBorderInputPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderInputFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderInputActive, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderInputDisabled, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorBorderInputDefaultInverse, value: globalColors.GDSEColorGrey300 },
  {
    element: semanticColors.GDSEColorBorderInputHoveredInverse,
    value: globalColors.GDSEColorMonoWhite
  },
  { element: semanticColors.GDSEColorBorderInputActiveInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorBorderInputDisabledInverse, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorBorderInformation, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderDataPerformance, value: globalColors.GDSEColorJupiter },
  { element: semanticColors.GDSEColorFillPositiveLightStrong, value: globalColors.GDSEColorGreen200 },
  { element: semanticColors.GDSEColorFillInfoLightStrong, value: globalColors.GDSEColorBlue200 },
  { element: semanticColors.GDSEColorBorderNeutral, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillCriticalLightStrong, value: globalColors.GDSEColorRed200 },
  { element: semanticColors.GDSEColorFillWarningLightStrong, value: globalColors.GDSEColorYellow200 },
  { element: semanticColors.GDSEColorTextPositiveStrong, value: globalColors.GDSEColorGreen700 },
  { element: semanticColors.GDSEColorTextWarningStrong, value: globalColors.GDSEColorYellow700 },
  { element: semanticColors.GDSEColorFillDraft, value: globalColors.GDSEColorGrey300 },
  // Specific cases
  {
    element: semanticColors.GDSEColorSkeletonShimmer,
    value: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0px, rgba(255, 255, 255, 0.3) 20%, rgba(255, 255, 255, 0.8) 60%, rgba(255, 255, 255, 0))"
  },
  {
    element: semanticColors.GDSEColorObjectListHover,
    value: "rgba(24, 181, 183, 0.08)"
  },
  // Spacing
  { element: semanticSpacings.GDSESpacingActionHorM, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingActionVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingActionHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingActionVerS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingActionIconM, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionIconS, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingActionIconL, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionHorL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingActionVerL, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingPillHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingPillVerS, value: globalSpacings.GDSESpacing25 },
  { element: semanticSpacings.GDSESpacingTabHorM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabHorL, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabVerL, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingTabWidth, value: globalSpacings.GDSESpacing800 },
  { element: semanticSpacings.GDSESpacingTooltipHorM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTooltipVerM, value: globalSpacings.GDSESpacing75 },
  { element: semanticSpacings.GDSESpacingTooltipHorL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingTooltipVerL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingInputHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingInputVerS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingInputHorL, value: globalSpacings.GDSESpacing125 },
  { element: semanticSpacings.GDSESpacingInputVerL, value: globalSpacings.GDSESpacing125 },
  // Border
  { element: semanticBorders.GDSERadiusPopover, value: globalBorders.GDSEBorderRadius25 },
  { element: semanticBorders.GDSERadiusInput, value: globalBorders.GDSEBorderRadius25 },
  // Typography
  {
    element: semanticFonts.GDSETypographyTitlePageFontSize,
    value: globalTypographies.GDSEFontSize7
  },
  {
    element: semanticFonts.GDSETypographyTitlePageLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyTitlePageLetterSpacing,
    value: globalTypographies.GDSELetterSpacingNeg1
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageFontSize,
    value: globalTypographies.GDSEFontSize5
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyHeadingLFontSize,
    value: globalTypographies.GDSEFontSize7
  },
  {
    element: semanticFonts.GDSETypographyHeadingLLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyHeadingLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontSize,
    value: globalTypographies.GDSEFontSize5
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontWeight,
    value: globalTypographies.GDSEFontWeightSemiBold
  },
  {
    element: semanticFonts.GDSETypographyHeadingMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyHeadingMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyHeadingSFontSize,
    value: globalTypographies.GDSEFontSize3
  },
  {
    element: semanticFonts.GDSETypographyHeadingSFontWeight,
    value: globalTypographies.GDSEFontWeightSemiBold
  },
  {
    element: semanticFonts.GDSETypographyHeadingSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyHeadingSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographySubheadingSFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographySubheadingSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographySubheadingSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataLFontSize,
    value: globalTypographies.GDSEFontSize10
  },
  {
    element: semanticFonts.GDSETypographyDataLFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyDataLLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataMFontSize,
    value: globalTypographies.GDSEFontSize7
  },
  {
    element: semanticFonts.GDSETypographyDataMFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyDataMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataSFontSize,
    value: globalTypographies.GDSEFontSize5
  },
  {
    element: semanticFonts.GDSETypographyDataSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataXSFontSize,
    value: globalTypographies.GDSEFontSize3
  },
  {
    element: semanticFonts.GDSETypographyDataXSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataXSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodyXLFontSize,
    value: globalTypographies.GDSEFontSize4
  },
  {
    element: semanticFonts.GDSETypographyBodyXLLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodyXLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodyLFontSize,
    value: globalTypographies.GDSEFontSize3
  },
  {
    element: semanticFonts.GDSETypographyBodyLLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodyLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodyMFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographyBodyMLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodyMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodySFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyBodySLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodySLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerSFontWeight,
    value: globalTypographies.GDSEFontWeightSemiBold
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  }
], monoBlackRGB = semanticColors.hexToRgbObj(globalColors.GDSEColorMonoBlack.getValueFor(document.body)), monoWhiteRGB = semanticColors.hexToRgbObj(globalColors.GDSEColorMonoWhite.getValueFor(document.body)), lightTheme = [
  { element: globalColors.GDSEColorTransparent, value: "rgba(0, 0, 0, 0)" },
  // Color
  { element: semanticColors.GDSEColorBackground, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorBackgroundAlt, value: globalColors.GDSEColorGrey100 },
  {
    element: semanticColors.GDSEColorBackgroundOverlay,
    value: `rgba(${monoBlackRGB == null ? void 0 : monoBlackRGB.r}, ${monoBlackRGB == null ? void 0 : monoBlackRGB.g}, ${monoBlackRGB == null ? void 0 : monoBlackRGB.b}, 0.65)`
  },
  { element: semanticColors.GDSEColorSurface, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfacePopover, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfaceHovered, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorSurfacePressed, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorSurfaceSelected, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorSurfaceAlt, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorSurfaceInverse, value: globalColors.GDSEColorGrey800 },
  { element: semanticColors.GDSEColorSurfaceCard, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfaceModal, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorSurfaceTooltip, value: globalColors.GDSEColorGrey900 },
  { element: semanticColors.GDSEColorFillSelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillHovered, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorFillPressed, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorFillDisabled, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillLoading, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorFillLight, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillHoveredLight, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillPressedLight, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorFillDisabledLight, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillHoveredInverse, value: `rgba(${monoWhiteRGB == null ? void 0 : monoWhiteRGB.r}, ${monoWhiteRGB == null ? void 0 : monoWhiteRGB.g}, ${monoWhiteRGB == null ? void 0 : monoWhiteRGB.b}, 0.2)` },
  { element: semanticColors.GDSEColorFillPressedInverse, value: `rgba(${monoWhiteRGB == null ? void 0 : monoWhiteRGB.r}, ${monoWhiteRGB == null ? void 0 : monoWhiteRGB.g}, ${monoWhiteRGB == null ? void 0 : monoWhiteRGB.b}, 0.4)` },
  { element: semanticColors.GDSEColorFillPrimary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillPrimaryHovered, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorFillPrimaryPressed, value: globalColors.GDSEColorBlue800 },
  { element: semanticColors.GDSEColorFillPrimarySelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillPrimaryDisabled, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorFillPrimaryHoveredLight, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillPrimaryPressedLight, value: globalColors.GDSEColorBlue200 },
  { element: semanticColors.GDSEColorFillPrimarySelectedLight, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillPrimaryFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorFillSecondary, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillSecondaryInverse, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorFillSecondaryHovered, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillSecondaryPressed, value: globalColors.GDSEColorBlue200 },
  { element: semanticColors.GDSEColorFillSecondaryFocused, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorFillSecondaryDisabled, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillInfo, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillInfoLight, value: globalColors.GDSEColorBlue100 },
  { element: semanticColors.GDSEColorFillPositive, value: globalColors.GDSEColorGreen500 },
  { element: semanticColors.GDSEColorFillPositiveHovered, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorFillPositivePressed, value: globalColors.GDSEColorGreen700 },
  { element: semanticColors.GDSEColorFillPositiveLight, value: globalColors.GDSEColorGreen100 },
  { element: semanticColors.GDSEColorFillPositivePressedLight, value: globalColors.GDSEColorGreen200 },
  { element: semanticColors.GDSEColorFillPositiveSecondaryHovered, value: globalColors.GDSEColorGreen100 },
  { element: semanticColors.GDSEColorFillPositiveSecondaryPressed, value: globalColors.GDSEColorGreen200 },
  { element: semanticColors.GDSEColorFillNegative, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorFillCritical, value: globalColors.GDSEColorRed500 },
  { element: semanticColors.GDSEColorFillCriticalSecondaryHovered, value: globalColors.GDSEColorRed100 },
  { element: semanticColors.GDSEColorFillCriticalSecondaryPressed, value: globalColors.GDSEColorRed200 },
  { element: semanticColors.GDSEColorFillCriticalHovered, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorFillCriticalPressed, value: globalColors.GDSEColorRed700 },
  { element: semanticColors.GDSEColorFillCriticalLight, value: globalColors.GDSEColorRed100 },
  { element: semanticColors.GDSEColorFillCriticalPressedLight, value: globalColors.GDSEColorRed200 },
  { element: semanticColors.GDSEColorFillWarning, value: globalColors.GDSEColorYellow400 },
  { element: semanticColors.GDSEColorFillWarningHovered, value: globalColors.GDSEColorYellow500 },
  { element: semanticColors.GDSEColorFillWarningPressed, value: globalColors.GDSEColorYellow600 },
  { element: semanticColors.GDSEColorFillWarningLight, value: globalColors.GDSEColorYellow100 },
  { element: semanticColors.GDSEColorFillWarningPressedLight, value: globalColors.GDSEColorYellow200 },
  { element: semanticColors.GDSEColorFillNavigationDefault, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillNavigationHovered, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorFillNavigationSelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillDataSold, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillDataSoldMed, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorFillDataSoldLite, value: globalColors.GDSEColorBlue400 },
  { element: semanticColors.GDSEColorFillDataPerformance, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillDataPerformanceMed, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorFillDataPerformanceLite, value: globalColors.GDSEColorBlue400 },
  { element: semanticColors.GDSEColorFillDataComparative, value: globalColors.GDSEColorCallistoA },
  { element: semanticColors.GDSEColorFillDataComparativeMed, value: globalColors.GDSEColorCallistoA },
  {
    element: semanticColors.GDSEColorFillDataComparativeLite,
    value: globalColors.GDSEColorCallistoB
  },
  { element: semanticColors.GDSEColorFillDataHold, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillDataBenchmark, value: "#18c9A0" },
  // TODO Fix when we have the token name
  { element: semanticColors.GDSEColorFillDataAttention, value: globalColors.GDSEColorYellow300 },
  { element: semanticColors.GDSEColorFillDataBg, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillDataBgAlt, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillInput, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillInputHovered, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorFillInputFocused, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorFillInputPressed, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillPressedLight, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorFillInputSelected, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorFillInputSelectedAlt, value: globalColors.GDSEColorGrey200 },
  { element: semanticColors.GDSEColorFillInputDisabled, value: globalColors.GDSEColorGrey100 },
  { element: semanticColors.GDSEColorText, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextOnfill, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextOnfillHovered, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextOnfillStrong, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextOnfillStrongHovered, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextDisabled, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextData, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextLight, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextMuted, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextInverse, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextLightInverse, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextMutedInverse, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextStatic, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextInverseStatic, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextInfo, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextInfoStrong, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorTextInfoHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextPositive, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorTextPositiveSecondary, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorTextPositiveSecondaryHovered, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorTextCritical, value: globalColors.GDSEColorRed500 },
  { element: semanticColors.GDSEColorTextCriticalSecondary, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextCriticalSecondaryHovered, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextCriticalStrong, value: globalColors.GDSEColorRed600 },
  { element: semanticColors.GDSEColorTextWarning, value: globalColors.GDSEColorYellow600 },
  { element: semanticColors.GDSEColorTextInformation, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextPrimary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextPrimaryHovered, value: globalColors.GDSEColorBlue700 },
  { element: semanticColors.GDSEColorTextPrimaryPressed, value: globalColors.GDSEColorBlue800 },
  { element: semanticColors.GDSEColorTextPrimaryInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorTextPrimaryDisabled, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextPrimaryLoading, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextSecondary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextSecondaryHovered, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorTextSecondaryPressed, value: globalColors.GDSEColorMonoWhite },
  { element: semanticColors.GDSEColorTextSecondaryFocused, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextSecondaryDisabled, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorTextSecondaryLoading, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextNavigationDefault, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextNavigationSelected, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorTextNavigationHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputDefault, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorTextInputHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputSelected, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputSelectedAlt, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorTextInputDisabled, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorder, value: globalColors.GDSEColorGrey300 },
  { element: semanticColors.GDSEColorBorderHovered, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderFocus, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderFocusInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorBorderDisabled, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorBorderInfo, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderPrimary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderPrimaryHovered, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPrimaryPressed, value: globalColors.GDSEColorCosmoE },
  { element: semanticColors.GDSEColorBorderPrimaryFocused, value: globalColors.GDSEColorSpotlight },
  { element: semanticColors.GDSEColorBorderPrimaryDisabled, value: globalColors.GDSEColorCosmoC },
  { element: semanticColors.GDSEColorBorderPrimaryLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderSecondary, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderSecondaryFocus, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderSecondaryDisabled, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderSecondaryLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderTertiaryLoading, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderPopover, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorBorderPositive, value: globalColors.GDSEColorGreen600 },
  { element: semanticColors.GDSEColorBorderCritical, value: globalColors.GDSEColorRed500 },
  { element: semanticColors.GDSEColorBorderWarning, value: globalColors.GDSEColorYellow500 },
  { element: semanticColors.GDSEColorBorderInputDefault, value: globalColors.GDSEColorGrey500 },
  { element: semanticColors.GDSEColorBorderInputHovered, value: globalColors.GDSEColorMonoBlack },
  { element: semanticColors.GDSEColorBorderInputPressed, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderInputFocused, value: "#FFFFFF" },
  { element: semanticColors.GDSEColorBorderInputActive, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderInputDisabled, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorBorderInputDefaultInverse, value: globalColors.GDSEColorGrey300 },
  {
    element: semanticColors.GDSEColorBorderInputHoveredInverse,
    value: globalColors.GDSEColorMonoWhite
  },
  { element: semanticColors.GDSEColorBorderInputActiveInverse, value: globalColors.GDSEColorBlue500 },
  { element: semanticColors.GDSEColorBorderInputDisabledInverse, value: globalColors.GDSEColorGrey600 },
  { element: semanticColors.GDSEColorBorderInformation, value: globalColors.GDSEColorBlue600 },
  { element: semanticColors.GDSEColorBorderDataPerformance, value: globalColors.GDSEColorJupiter },
  { element: semanticColors.GDSEColorFillPositiveLightStrong, value: globalColors.GDSEColorGreen200 },
  { element: semanticColors.GDSEColorFillInfoLightStrong, value: globalColors.GDSEColorBlue200 },
  { element: semanticColors.GDSEColorBorderNeutral, value: globalColors.GDSEColorGrey400 },
  { element: semanticColors.GDSEColorFillCriticalLightStrong, value: globalColors.GDSEColorRed200 },
  { element: semanticColors.GDSEColorFillWarningLightStrong, value: globalColors.GDSEColorYellow200 },
  { element: semanticColors.GDSEColorTextPositiveStrong, value: globalColors.GDSEColorGreen700 },
  { element: semanticColors.GDSEColorTextWarningStrong, value: globalColors.GDSEColorYellow700 },
  { element: semanticColors.GDSEColorFillDraft, value: globalColors.GDSEColorGrey300 },
  // Specific cases
  {
    element: semanticColors.GDSEColorSkeletonShimmer,
    value: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0px, rgba(255, 255, 255, 0.3) 20%, rgba(255, 255, 255, 0.8) 60%, rgba(255, 255, 255, 0))"
  },
  {
    element: semanticColors.GDSEColorObjectListHover,
    value: "rgba(24, 181, 183, 0.08)"
  },
  // Spacing
  { element: semanticSpacings.GDSESpacingActionHorM, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingActionVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingActionHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingActionVerS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingActionIconM, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionIconS, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingActionIconL, value: globalSpacings.GDSESpacing250 },
  { element: semanticSpacings.GDSESpacingActionHorL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingActionVerL, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingPillHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingPillVerS, value: globalSpacings.GDSESpacing25 },
  { element: semanticSpacings.GDSESpacingTabHorM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabVerM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabHorL, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTabVerL, value: globalSpacings.GDSESpacing150 },
  { element: semanticSpacings.GDSESpacingTabWidth, value: globalSpacings.GDSESpacing800 },
  { element: semanticSpacings.GDSESpacingTooltipHorM, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingTooltipVerM, value: globalSpacings.GDSESpacing75 },
  { element: semanticSpacings.GDSESpacingTooltipHorL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingTooltipVerL, value: globalSpacings.GDSESpacing200 },
  { element: semanticSpacings.GDSESpacingInputHorS, value: globalSpacings.GDSESpacing100 },
  { element: semanticSpacings.GDSESpacingInputVerS, value: globalSpacings.GDSESpacing50 },
  { element: semanticSpacings.GDSESpacingInputHorL, value: globalSpacings.GDSESpacing125 },
  { element: semanticSpacings.GDSESpacingInputVerL, value: globalSpacings.GDSESpacing125 },
  // Border
  { element: semanticBorders.GDSERadiusPopover, value: globalBorders.GDSEBorderRadius25 },
  { element: semanticBorders.GDSERadiusInput, value: globalBorders.GDSEBorderRadius25 },
  // Typography
  {
    element: semanticFonts.GDSETypographyTitlePageFontSize,
    value: globalTypographies.GDSEFontSize7
  },
  {
    element: semanticFonts.GDSETypographyTitlePageLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyTitlePageLetterSpacing,
    value: globalTypographies.GDSELetterSpacingNeg1
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageFontSize,
    value: globalTypographies.GDSEFontSize5
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographySubtitlePageLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyHeadingLFontSize,
    value: globalTypographies.GDSEFontSize7
  },
  {
    element: semanticFonts.GDSETypographyHeadingLLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyHeadingLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontSize,
    value: globalTypographies.GDSEFontSize5
  },
  {
    element: semanticFonts.GDSETypographyHeadingMFontWeight,
    value: globalTypographies.GDSEFontWeightSemiBold
  },
  {
    element: semanticFonts.GDSETypographyHeadingMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyHeadingMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyHeadingSFontSize,
    value: globalTypographies.GDSEFontSize3
  },
  {
    element: semanticFonts.GDSETypographyHeadingSFontWeight,
    value: globalTypographies.GDSEFontWeightSemiBold
  },
  {
    element: semanticFonts.GDSETypographyHeadingSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyHeadingSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographySubheadingSFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographySubheadingSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographySubheadingSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataLFontSize,
    value: globalTypographies.GDSEFontSize10
  },
  {
    element: semanticFonts.GDSETypographyDataLFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyDataLLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataMFontSize,
    value: globalTypographies.GDSEFontSize7
  },
  {
    element: semanticFonts.GDSETypographyDataMFontWeight,
    value: globalTypographies.GDSEFontWeightRegular
  },
  {
    element: semanticFonts.GDSETypographyDataMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataSFontSize,
    value: globalTypographies.GDSEFontSize5
  },
  {
    element: semanticFonts.GDSETypographyDataSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyDataXSFontSize,
    value: globalTypographies.GDSEFontSize3
  },
  {
    element: semanticFonts.GDSETypographyDataXSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyDataXSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodyXLFontSize,
    value: globalTypographies.GDSEFontSize4
  },
  {
    element: semanticFonts.GDSETypographyBodyXLLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodyXLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodyLFontSize,
    value: globalTypographies.GDSEFontSize3
  },
  {
    element: semanticFonts.GDSETypographyBodyLLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodyLLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodyMFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographyBodyMLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodyMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyBodySFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyBodySLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyBodySLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextHighemphasisLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularLineHeight,
    value: globalTypographies.GDSELineHeightBody
  },
  {
    element: semanticFonts.GDSETypographyLabelHelpertextRegularLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSFontSize,
    value: globalTypographies.GDSEFontSize1
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelButtonSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing1
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMFontSize,
    value: globalTypographies.GDSEFontSize2
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMLineHeight,
    value: globalTypographies.GDSELineHeightTitle
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerMLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerSFontWeight,
    value: globalTypographies.GDSEFontWeightSemiBold
  },
  {
    element: semanticFonts.GDSETypographyLabelContainerSLetterSpacing,
    value: globalTypographies.GDSELetterSpacing0
  }
], core$1 = {
  dimension: {
    50: "2",
    100: "4",
    150: "6",
    200: "8",
    250: "10",
    300: "12",
    350: "14",
    400: "16",
    450: "18",
    500: "20",
    550: "22",
    600: "24",
    650: "26",
    700: "28",
    750: "30",
    800: "32",
    850: "34",
    900: "36",
    1e3: "40",
    1100: "44",
    1200: "48",
    1300: "52",
    1400: "56",
    1500: "60",
    1600: "64",
    1700: "68",
    1800: "72",
    1900: "76",
    2e3: "80",
    zero: "0"
  },
  typography: {
    "font-family": {
      "01": "Averta"
    },
    "font-weight": {
      light: "300",
      regular: "400",
      semibold: "600",
      bold: "700",
      black: "900"
    },
    "font-size": {
      25: "10",
      50: "12",
      75: "14",
      100: "16",
      150: "18",
      175: "20",
      200: "24",
      250: "28",
      300: "32",
      350: "34",
      400: "36",
      450: "40",
      500: "44",
      550: "48",
      600: "50"
    },
    "line-height": {
      25: "10",
      50: "12",
      75: "14",
      100: "16",
      150: "18",
      175: "20",
      200: "24",
      250: "28",
      300: "32",
      350: "34",
      400: "36",
      450: "40",
      500: "44",
      550: "48",
      600: "50",
      650: "52",
      700: "54",
      800: "64",
      full: "100%"
    },
    "letter-spacing": {
      100: "1%",
      300: "3%",
      800: "15%",
      "neg-300": "-3%",
      "neg-200": "-1.20%",
      "neg-100": "-0.50%"
    }
  },
  color: {
    brand: {
      "01": "#024dff",
      "02": "#050505",
      "03": "#ffffff"
    },
    modify: {
      50: "0.05",
      100: "0.1",
      150: "0.15000000000000002",
      200: "0.2",
      250: "0.25",
      300: "0.30000000000000004",
      350: "0.35000000000000003",
      400: "0.4",
      450: "0.45",
      500: "0.5",
      550: "0.55",
      600: "0.6000000000000001",
      650: "0.65",
      700: "0.7000000000000001",
      750: "0.75",
      800: "0.8",
      850: "0.8500000000000001",
      900: "0.9",
      950: "0.9500000000000001",
      1e3: "1",
      zero: "0"
    }
  },
  border: {
    radius: {
      xs: "2",
      s: "4",
      m: "6",
      l: "8",
      xl: "12",
      xxl: "20",
      full: "999"
    },
    width: {
      xs: "1",
      s: "2",
      m: "3",
      l: "4",
      xl: "8"
    }
  }
}, brand$1 = {
  color: {
    feedback: {
      "01": "#fc3a56",
      "02": "#db6511",
      "03": "#1d9c41"
    },
    "data-vis": {
      "01": "#1d8a89",
      "02": "#8863ee",
      "03": "#e91e92",
      "04": "#bc7d12"
    }
  }
}, typography$1 = {
  label: {
    m: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "14",
      lineHeight: "16",
      letterSpacing: "1%"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "1%"
    },
    s: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "1%"
    }
  },
  heading: {
    xl: {
      fontFamily: "Averta",
      fontWeight: "900",
      fontSize: "40",
      lineHeight: "100%",
      letterSpacing: "-3%",
      textCase: "uppercase"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "900",
      fontSize: "24",
      lineHeight: "100%",
      letterSpacing: "-3%",
      textCase: "uppercase"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "900",
      fontSize: "16",
      lineHeight: "100%",
      letterSpacing: "-3%",
      textCase: "uppercase"
    }
  },
  title: {
    xs: {
      fontFamily: "Averta",
      fontWeight: "300",
      fontSize: "12",
      lineHeight: "14",
      letterSpacing: "15%",
      textCase: "uppercase"
    },
    s: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "14",
      lineHeight: "18",
      letterSpacing: "0"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "16",
      lineHeight: "20"
    }
  },
  body: {
    s: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "14",
      lineHeight: "18",
      letterSpacing: "0"
    },
    xs: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "0"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "0"
    }
  },
  data: {
    s: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "14",
      lineHeight: "18",
      letterSpacing: "0"
    },
    xs: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "0"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "700",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "0"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "32",
      lineHeight: "36",
      letterSpacing: "-0.50%"
    },
    xl: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "40",
      lineHeight: "48",
      letterSpacing: "-0.50%"
    }
  },
  "label-underline": {
    m: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "14",
      lineHeight: "16",
      letterSpacing: "1%",
      textDecoration: "underline"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "1%",
      textDecoration: "underline"
    },
    s: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "1%",
      textDecoration: "underline"
    }
  }
}, badge$1 = {
  spacing: {
    m: {
      verticalPadding: "2px",
      horizontalPadding: "6px"
    },
    l: {
      verticalPadding: "4px",
      horizontalPadding: "8px"
    }
  }
}, banner$1 = {
  spacing: {
    m: {
      verticalPadding: "16px",
      horizontalPadding: "16px",
      itemSpacing: "12px"
    }
  }
}, button$1 = {
  spacing: {
    "s​​": {
      verticalPadding: "8px",
      horizontalPadding: "12px",
      itemSpacing: "4px"
    },
    m: {
      verticalPadding: "12px",
      horizontalPadding: "16px",
      itemSpacing: "8px"
    },
    l: {
      verticalPadding: "16px",
      horizontalPadding: "20px",
      itemSpacing: "8px",
      maxHeight: "48"
    }
  }
}, icon$2 = {
  size: {
    s: "12px",
    m: "16px",
    l: "20px"
  }
}, selection$1 = {
  size: {
    m: {
      height: "18px",
      width: "18px"
    },
    l: {
      height: "20px",
      width: "20px"
    }
  }
}, tabs$1 = {
  spacing: {
    m: {
      verticalPadding: "12px",
      horizontalPadding: "20px",
      itemSpacing: "8px",
      minWidth: "64"
    },
    l: {
      verticalPadding: "20px",
      horizontalPadding: "28px",
      itemSpacing: "8px",
      minWidth: "64"
    }
  }
}, color$1 = {
  interactive: {
    primary: {
      fill: {
        default: "#024dff",
        hover: "#024dff",
        pressed: "#024dff"
      },
      text: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      icon: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      }
    },
    secondary: {
      fill: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      text: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      icon: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      border: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      }
    },
    tertiary: {
      text: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      icon: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      fill: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      }
    },
    fill: {
      default: "#ffffff",
      hover: "#ffffff",
      pressed: "#ffffff"
    },
    text: {
      default: "#ffffff",
      hover: "#ffffff",
      pressed: "#ffffff"
    },
    icon: {
      default: "#ffffff",
      hover: "#ffffff",
      pressed: "#ffffff"
    }
  },
  disabled: {
    a: "#ffffff",
    b: "#ffffff",
    c: "#ffffff"
  },
  focus: {
    border: "#ffffff"
  },
  text: {
    "primary​​": "#ffffff",
    "secondary​​": "#ffffff",
    placeholder: "#ffffff",
    inverse: "#050505",
    "on-accent": "#ffffff"
  },
  icon: {
    "primary​​": "#ffffff",
    "secondary​​": "#ffffff"
  },
  border: {
    primary: "#050505",
    secondary: "#050505",
    elevation: "#050505",
    "on-accent": "#ffffff",
    inverse: "#050505"
  },
  input: {
    fill: {
      default: "#050505",
      hover: "#050505",
      active: "#050505"
    },
    border: {
      default: "#050505",
      hover: "#050505",
      active: "#050505",
      success: "#1d9c41",
      error: "#fc3a56"
    },
    text: {
      default: "#ffffff",
      active: "#ffffff",
      hover: "#ffffff"
    },
    icon: {
      default: "#ffffff",
      hover: "#ffffff",
      active: "#ffffff"
    }
  },
  feedback: {
    fill: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    },
    text: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    },
    icon: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    },
    border: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    }
  },
  active: {
    fill: {
      default: "#ffffff"
    },
    border: {
      default: "#ffffff"
    },
    text: {
      default: "#ffffff"
    }
  },
  elevation: {
    base: "#024dff",
    canvas: "#050505",
    undercanvas: "#024dff",
    "level-1": "#024dff",
    "level-2": "#024dff",
    "level-3": "#024dff",
    "level-5": "#024dff",
    "level-4": "#024dff",
    inverse: "#ffffff",
    overlay: "#050505",
    "accent-a": "#024dff",
    "accent-b": "#050505"
  },
  "selected​": {
    fill: {
      default: "#ffffff",
      hover: "#ffffff",
      active: "#024dff"
    },
    border: {
      default: "#ffffff",
      hover: "#ffffff",
      active: "#ffffff"
    },
    icon: {
      default: "#ffffff",
      hover: "#ffffff",
      active: "#ffffff"
    }
  },
  status: {
    draft: {
      fill: "#ffffff",
      text: "#ffffff"
    },
    active: {
      fill: "#024dff",
      text: "#024dff"
    },
    positive: {
      fill: "#1d9c41",
      text: "#1d9c41"
    },
    critical: {
      fill: "#fc3a56",
      text: "#fc3a56"
    },
    attention: {
      fill: "#db6511",
      text: "#db6511"
    },
    neutral: {
      fill: "#050505",
      text: "#ffffff",
      border: "#050505"
    },
    update: {
      fill: "#024dff",
      text: "#ffffff"
    },
    general: {
      fill: "#050505",
      text: "#ffffff",
      border: "#050505"
    }
  }
}, darkTokens = {
  core: core$1,
  brand: brand$1,
  typography: typography$1,
  "border-radius": {
    interactive: {
      s: "2",
      m: "4",
      l: "6",
      full: "999"
    },
    input: {
      s: "2",
      m: "4",
      l: "6",
      full: "999"
    }
  },
  badge: badge$1,
  banner: banner$1,
  button: button$1,
  "icon-button": {
    spacing: {
      "s​​": {
        verticalPadding: "8px",
        horizontalPadding: "8px"
      },
      m: {
        verticalPadding: "12px",
        horizontalPadding: "12px"
      },
      l: {
        verticalPadding: "14px",
        horizontalPadding: "14px"
      }
    }
  },
  icon: icon$2,
  selection: selection$1,
  "input-box": {
    spacing: {
      "s​​": {
        verticalPadding: "6px",
        horizontalPadding: "10px",
        itemSpacing: "8px",
        minHeight: "32"
      },
      m: {
        verticalPadding: "10px",
        horizontalPadding: "12px",
        itemSpacing: "8px",
        minHeight: "40"
      },
      l: {
        verticalPadding: "14px",
        horizontalPadding: "16px",
        itemSpacing: "8px",
        minHeight: "48"
      }
    }
  },
  tabs: tabs$1,
  color: color$1
}, core = {
  dimension: {
    50: "2",
    100: "4",
    150: "6",
    200: "8",
    250: "10",
    300: "12",
    350: "14",
    400: "16",
    450: "18",
    500: "20",
    550: "22",
    600: "24",
    650: "26",
    700: "28",
    750: "30",
    800: "32",
    850: "34",
    900: "36",
    1e3: "40",
    1100: "44",
    1200: "48",
    1300: "52",
    1400: "56",
    1500: "60",
    1600: "64",
    1700: "68",
    1800: "72",
    1900: "76",
    2e3: "80",
    zero: "0"
  },
  typography: {
    "font-family": {
      "01": "Averta"
    },
    "font-weight": {
      light: "300",
      regular: "400",
      semibold: "600",
      bold: "700",
      black: "900"
    },
    "font-size": {
      25: "10",
      50: "12",
      75: "14",
      100: "16",
      150: "18",
      175: "20",
      200: "24",
      250: "28",
      300: "32",
      350: "34",
      400: "36",
      450: "40",
      500: "44",
      550: "48",
      600: "50"
    },
    "line-height": {
      25: "10",
      50: "12",
      75: "14",
      100: "16",
      150: "18",
      175: "20",
      200: "24",
      250: "28",
      300: "32",
      350: "34",
      400: "36",
      450: "40",
      500: "44",
      550: "48",
      600: "50",
      650: "52",
      700: "54",
      800: "64",
      full: "100%"
    },
    "letter-spacing": {
      100: "1%",
      300: "3%",
      800: "15%",
      "neg-300": "-3%",
      "neg-200": "-1.20%",
      "neg-100": "-0.50%"
    }
  },
  color: {
    brand: {
      "01": "#024dff",
      "02": "#050505",
      "03": "#ffffff"
    },
    modify: {
      50: "0.05",
      100: "0.1",
      150: "0.15000000000000002",
      200: "0.2",
      250: "0.25",
      300: "0.30000000000000004",
      350: "0.35000000000000003",
      400: "0.4",
      450: "0.45",
      500: "0.5",
      550: "0.55",
      600: "0.6000000000000001",
      650: "0.65",
      700: "0.7000000000000001",
      750: "0.75",
      800: "0.8",
      850: "0.8500000000000001",
      900: "0.9",
      950: "0.9500000000000001",
      1e3: "1",
      zero: "0"
    }
  },
  border: {
    radius: {
      xs: "2",
      s: "4",
      m: "6",
      l: "8",
      xl: "12",
      xxl: "20",
      full: "999"
    },
    width: {
      xs: "1",
      s: "2",
      m: "3",
      l: "4",
      xl: "8"
    }
  }
}, brand = {
  color: {
    feedback: {
      "01": "#fc3a56",
      "02": "#db6511",
      "03": "#1d9c41"
    },
    "data-vis": {
      "01": "#1d8a89",
      "02": "#8863ee",
      "03": "#e91e92",
      "04": "#bc7d12"
    }
  }
}, typography = {
  label: {
    m: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "14",
      lineHeight: "16",
      letterSpacing: "1%"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "1%"
    },
    s: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "1%"
    }
  },
  heading: {
    xl: {
      fontFamily: "Averta",
      fontWeight: "900",
      fontSize: "40",
      lineHeight: "100%",
      letterSpacing: "-3%",
      textCase: "uppercase"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "900",
      fontSize: "24",
      lineHeight: "100%",
      letterSpacing: "-3%",
      textCase: "uppercase"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "900",
      fontSize: "16",
      lineHeight: "100%",
      letterSpacing: "-3%",
      textCase: "uppercase"
    }
  },
  title: {
    xs: {
      fontFamily: "Averta",
      fontWeight: "300",
      fontSize: "12",
      lineHeight: "14",
      letterSpacing: "15%",
      textCase: "uppercase"
    },
    s: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "14",
      lineHeight: "18",
      letterSpacing: "0"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "16",
      lineHeight: "20"
    }
  },
  body: {
    s: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "14",
      lineHeight: "18",
      letterSpacing: "0"
    },
    xs: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "0"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "0"
    }
  },
  data: {
    s: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "14",
      lineHeight: "18",
      letterSpacing: "0"
    },
    xs: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "0"
    },
    m: {
      fontFamily: "Averta",
      fontWeight: "700",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "0"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "32",
      lineHeight: "36",
      letterSpacing: "-0.50%"
    },
    xl: {
      fontFamily: "Averta",
      fontWeight: "400",
      fontSize: "40",
      lineHeight: "48",
      letterSpacing: "-0.50%"
    }
  },
  "label-underline": {
    m: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "14",
      lineHeight: "16",
      letterSpacing: "1%",
      textDecoration: "underline"
    },
    l: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "16",
      lineHeight: "20",
      letterSpacing: "1%",
      textDecoration: "underline"
    },
    s: {
      fontFamily: "Averta",
      fontWeight: "600",
      fontSize: "12",
      lineHeight: "16",
      letterSpacing: "1%",
      textDecoration: "underline"
    }
  }
}, badge = {
  spacing: {
    m: {
      verticalPadding: "2px",
      horizontalPadding: "6px"
    },
    l: {
      verticalPadding: "4px",
      horizontalPadding: "8px"
    }
  }
}, banner = {
  spacing: {
    m: {
      verticalPadding: "16px",
      horizontalPadding: "16px",
      itemSpacing: "12px"
    }
  }
}, button = {
  spacing: {
    "s​​": {
      verticalPadding: "8px",
      horizontalPadding: "12px",
      itemSpacing: "4px"
    },
    m: {
      verticalPadding: "12px",
      horizontalPadding: "16px",
      itemSpacing: "8px"
    },
    l: {
      verticalPadding: "16px",
      horizontalPadding: "20px",
      itemSpacing: "8px",
      maxHeight: "48"
    }
  }
}, icon$1 = {
  size: {
    s: "12px",
    m: "16px",
    l: "20px"
  }
}, selection = {
  size: {
    m: {
      height: "18px",
      width: "18px"
    },
    l: {
      height: "20px",
      width: "20px"
    }
  }
}, tabs = {
  spacing: {
    m: {
      verticalPadding: "12px",
      horizontalPadding: "20px",
      itemSpacing: "8px",
      minWidth: "64"
    },
    l: {
      verticalPadding: "20px",
      horizontalPadding: "28px",
      itemSpacing: "8px",
      minWidth: "64"
    }
  }
}, color = {
  interactive: {
    primary: {
      fill: {
        default: "#024dff",
        hover: "#024dff",
        pressed: "#024dff"
      },
      text: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      },
      icon: {
        default: "#ffffff",
        hover: "#ffffff",
        pressed: "#ffffff"
      }
    },
    secondary: {
      fill: {
        default: "#050505",
        hover: "#050505",
        pressed: "#050505"
      },
      text: {
        default: "#050505",
        hover: "#050505",
        pressed: "#050505"
      },
      icon: {
        default: "#050505",
        hover: "#050505",
        pressed: "#050505"
      },
      border: {
        default: "#050505",
        hover: "#050505",
        pressed: "#050505"
      }
    },
    tertiary: {
      text: {
        default: "#024dff",
        hover: "#024dff",
        pressed: "#024dff"
      },
      icon: {
        default: "#024dff",
        hover: "#024dff",
        pressed: "#024dff"
      },
      fill: {
        default: "#050505",
        hover: "#050505",
        pressed: "#050505"
      }
    },
    fill: {
      default: "#050505",
      hover: "#050505",
      pressed: "#050505"
    },
    text: {
      default: "#050505",
      hover: "#050505",
      pressed: "#050505"
    },
    icon: {
      default: "#050505",
      hover: "#050505",
      pressed: "#050505"
    }
  },
  disabled: {
    a: "#050505",
    b: "#050505",
    c: "#050505"
  },
  focus: {
    border: "#050505"
  },
  text: {
    "primary​​": "#050505",
    "secondary​​": "#050505",
    placeholder: "#050505",
    inverse: "#ffffff",
    "on-accent": "#ffffff"
  },
  icon: {
    "primary​​": "#050505",
    "secondary​​": "#050505"
  },
  border: {
    primary: "#050505",
    secondary: "#050505",
    elevation: "#ffffff",
    inverse: "#ffffff",
    "on-accent": "#ffffff"
  },
  input: {
    fill: {
      default: "#ffffff",
      hover: "#ffffff",
      active: "#ffffff"
    },
    border: {
      default: "#050505",
      hover: "#050505",
      active: "#050505",
      success: "#1d9c41",
      error: "#fc3a56"
    },
    text: {
      default: "#050505",
      active: "#050505",
      hover: "#050505"
    },
    icon: {
      default: "#050505",
      hover: "#050505",
      active: "#050505"
    }
  },
  feedback: {
    fill: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    },
    text: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    },
    icon: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    },
    border: {
      error: "#fc3a56",
      success: "#1d9c41",
      warning: "#db6511",
      info: "#024dff"
    }
  },
  active: {
    fill: {
      default: "#050505"
    },
    border: {
      default: "#024dff"
    },
    text: {
      default: "#024dff"
    }
  },
  elevation: {
    base: "#ffffff",
    canvas: "#ffffff",
    undercanvas: "#ffffff",
    "level-1": "#ffffff",
    "level-2": "#ffffff",
    "level-3": "#ffffff",
    "level-4": "#ffffff",
    "level-5": "#ffffff",
    inverse: "#050505",
    overlay: "#050505",
    "accent-a": "#024dff",
    "accent-b": "#050505"
  },
  "selected​": {
    fill: {
      default: "#050505",
      hover: "#050505",
      active: "#024dff"
    },
    border: {
      default: "#050505",
      hover: "#050505",
      active: "#050505"
    },
    icon: {
      default: "#ffffff",
      hover: "#ffffff",
      active: "#ffffff"
    }
  },
  status: {
    draft: {
      fill: "#050505",
      text: "#050505"
    },
    active: {
      fill: "#024dff",
      text: "#024dff"
    },
    positive: {
      fill: "#1d9c41",
      text: "#1d9c41"
    },
    critical: {
      fill: "#fc3a56",
      text: "#fc3a56"
    },
    attention: {
      fill: "#db6511",
      text: "#db6511"
    },
    neutral: {
      fill: "#ffffff",
      text: "#050505",
      border: "#050505"
    },
    update: {
      fill: "#024dff",
      text: "#ffffff"
    },
    general: {
      fill: "#ffffff",
      text: "#050505",
      border: "#050505"
    }
  }
}, lightTokens = {
  core,
  brand,
  typography,
  "border-radius": {
    interactive: {
      s: "2",
      m: "4",
      l: "6",
      full: "999"
    },
    input: {
      s: "2",
      m: "4",
      l: "6",
      full: "999"
    }
  },
  badge,
  banner,
  button,
  "icon-button": {
    spacing: {
      "s​​": {
        verticalPadding: "8px",
        horizontalPadding: "8px"
      },
      m: {
        verticalPadding: "12px",
        horizontalPadding: "12px"
      },
      l: {
        verticalPadding: "14px",
        horizontalPadding: "14px"
      }
    }
  },
  icon: icon$1,
  selection,
  "input-box": {
    spacing: {
      "s​​": {
        verticalPadding: "6px",
        horizontalPadding: "10px",
        itemSpacing: "8px",
        minHeight: "32"
      },
      m: {
        verticalPadding: "10px",
        horizontalPadding: "12px",
        itemSpacing: "8px",
        minHeight: "40"
      },
      l: {
        verticalPadding: "14px",
        horizontalPadding: "16px",
        itemSpacing: "8px",
        minHeight: "48"
      }
    }
  },
  tabs,
  color
};
var __defProp$1b = Object.defineProperty, __getOwnPropDesc$1b = Object.getOwnPropertyDescriptor, __decorateClass$1b = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$1b(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$1b(Ae, xr, id), id;
};
const ThemeType = {
  legacy: "legacy",
  light: "light",
  dark: "dark"
};
class ThemeManager {
  constructor(td, Ae = {}) {
    this.theme = ThemeType.light, this.darkTokensV2 = [], this.lightTokensV2 = [], this.themeColors = lightTheme, this.node = td || document.documentElement, this.setupTokensStudio(), this.onThemeChanged = Ae == null ? void 0 : Ae.onThemeChanged, this.themeChanged();
  }
  themeChanged() {
    var td;
    this.node && (this.theme === ThemeType.legacy && (this.theme = ThemeType.light), (td = this.onThemeChanged) == null || td.call(this, this.theme), DOM.queueUpdate(() => {
      this.themeColors = this.theme === ThemeType.light ? [...lightTheme, ...this.lightTokensV2] : this.theme === ThemeType.dark ? [...darkTheme, ...this.darkTokensV2] : [...lightTheme, ...this.lightTokensV2], this.setValues(this.themeColors);
    }));
  }
  setValues(td) {
    const Ae = [];
    td.forEach((xr) => {
      if (typeof xr.element == "string" && typeof xr.value == "string")
        Ae.push({ element: xr.element, value: xr.value });
      else if (typeof xr.element != "string")
        return xr.element.setValueFor(this.node, () => typeof xr.value == "string" ? xr.value : xr.value.getValueFor(this.node));
    }), this.setupCSSTokens(Ae);
  }
  setupTokensStudio() {
    this.parseJsonTokensToObject(darkTokens, ThemeType.dark), this.parseJsonTokensToObject(lightTokens, ThemeType.light);
  }
  parseJsonTokensToObject(obj, theme, prefix = "") {
    const basePrefix = "gdse-v2";
    for (const key in obj) {
      const value = obj[key], variableName = `--${basePrefix}-${prefix}${key}`.replace(/\s+/g, "-").toLowerCase();
      if (typeof value == "string") {
        const computedValue = value.includes("/") || value.includes("*") ? eval(value).toString() : value, token = { element: variableName, value: computedValue };
        theme === ThemeType.light ? this.lightTokensV2.push(token) : this.darkTokensV2.push(token);
      } else
        typeof value == "object" && this.parseJsonTokensToObject(value, theme, `${prefix}${key}-`);
    }
  }
  setupCSSTokens(td) {
    const Ae = document.createElement("style"), xr = td.map((ed) => `${ed.element}: ${ed.value};`).join(" ");
    Ae.textContent = `:root { ${xr} }`, document.head.appendChild(Ae);
  }
}
__decorateClass$1b([
  observable
], ThemeManager.prototype, "theme", 2);
__decorateClass$1b([
  observable
], ThemeManager.prototype, "darkTokensV2", 2);
__decorateClass$1b([
  observable
], ThemeManager.prototype, "lightTokensV2", 2);
const baseButtonsStyles = css`
  :host {
    display: inline-block;
    outline: none;
    border-radius: ${GDSERadiusInput};
    fill: currentcolor;
    cursor: pointer;
    -webkit-font-smoothing: subpixel-antialiased;
  }

  .control {
    position: relative;
    background: transparent;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    outline: none;
    text-decoration: none;
    border: ${GDSEWidthDefault} solid transparent;
    color: inherit;
    border-radius: inherit;
    fill: inherit;
    cursor: inherit;
    margin: 0;
  }

  .content-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  :host([isLoading]) {
    cursor: not-allowed;
  }

  :host(:not([isLoading]):hover) {
    color: var(--text-color-hovered);
    background: var(--background-color-hovered);
  }

  :host(:not([isLoading]):active) {
    background: var(--background-color-pressed);
  }

  :host(:not([isLoading]):not([disabled])){
    background: var(--background-color);
    color: var(--text-color);
    fill: var(--text-color);
    border-color: var(--border-color);
  }

  :host(:not([isLoading]):not([disabled]):hover){
    background: var(--background-color-hovered);
    color: var(--text-color-hovered);
    fill: var(--text-color-hovered);
  }

  :host(:not([isLoading]):not([disabled]):active){
    background: var(--background-color-pressed);
    color: var(--text-color-pressed);
    fill: var(--text-color-pressed);
  }

  :host(:not([isLoading]):not([disabled])) .control:focus-visible {
    background-color: var(--background-color-focus);
    color: var(--text-color-focus);
    fill: var(--text-color-focus);
    border-radius: ${GDSERadiusInput};
    outline: 2px solid ${GDSEColorBorderFocus};
    outline-offset: 2px;
  }

  :host(:not([isLoading])[disabled]),
  :host(:not([isLoading])[disabled]):hover {
    border-color: transparent;
    background: var(--background-color-disabled);
    color: var(--text-color-disabled);
    fill: var(--text-color-disabled);
    cursor: not-allowed;
  }

  .control::-moz-focus-inner {
    border: ${GDSEBorderRadius0};
  }

  .start,
  .content,
  .end {
    align-self: center;
  }

  .start,
  .end {
    display: flex;
  }

  .control.icon-only {
    padding: ${GDSESpacing0};
    line-height: 0;
  }

  ::slotted(svg) {
   /* Glyph size and margin-left is temporary - replace when adaptive typography is figured out */
    width: 16px;
    height: 16px;
    pointer-events: none;
  }

  .start {
    margin-inline-end: 11px;
  }

  .end {
    margin-inline-start: 11px;
  }
`, AccentButtonStyles = css`
  :host(:not([isLoading]):not([disabled])[variant='solid']:focus),
  :host(:not([isLoading]):not([disabled])[variant='solid']:focus-visible) {
    box-shadow:
      0 0 0 1px var(--focus-color) inset,
      0 0 0 3px #ffffff inset;
  }

  :host([variant='solid'][disabled]) {
    background: ${GDSEColorFillDisabled};
    color: ${GDSEColorTextDisabled};
    fill: ${GDSEColorFillDisabled};
  }
`, LightweightButtonStyles = css`
  :host([variant='lightweight']) .dot {
    background: var(--text-color);
  }

  :host([variant='lightweight']) .control {
    height: initial;
    border: none;
    box-shadow: none;
    border-radius: ${GDSEBorderRadius0};
  }

  :host(:not([isLoading]):not([disabled])[variant='lightweight']:focus),
  :host(:not([isLoading]):not([disabled])[variant='lightweight']:focus-visible) {
    box-shadow: 0 0 0 1px var(--focus-color) inset;
  }

  :host([variant='lightweight'][disabled]) {
    background: transparent;
    color: ${GDSEColorTextDisabled};
    fill: ${GDSEColorFillDisabled};
  }
`, OutlineButtonStyles = css`
  :host([variant='outline']) .dot {
    background: var(--text-color);
  }

  :host([variant='outline']) .control {
    border-color: inherit;
    padding: var(--padding);
  }

  :host([variant='outline'][disabled]) {
    background: transparent;
    color: ${GDSEColorTextDisabled};
    fill: ${GDSEColorFillDisabled};
    border-color: ${GDSEColorBorderInputDisabledInverse};
  }
`, baseCardStyles = css`
  ${display("block")} :host {
    display: block;
    height: var(--card-height, 100%);
    width: var(--card-width, 100%);
    box-sizing: border-box;
  }
`, shadowVariantCardStyles = css`
  :host([variant='shadow']) {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 4px, rgba(0, 0, 0, 0.06) 0px 4px 4px;
    border: none;
  }
`, outlineVariantCardStyles = css`
  :host([variant='outline']) {
    box-shadow: none;
    border: 1px solid ${GDSEColorBorder};
  }
`, defaultVariantCardStyles = css`
  :host([variant='default']) {
    box-shadow: none;
    border: none;
  }
`, inputSizeSmall$1 = cssPartial`
  --input-size: 28px;
  --padding: ${GDSESpacingInputVerS} ${GDSESpacingInputHorS};
`, inputSizeRegular$1 = cssPartial`
  --input-size: 37px;
  --padding: ${GDSESpacingInputVerM} ${GDSESpacingInputHorM};
`, inputSizeLarge$1 = cssPartial`
  --input-size: 44px;
  --padding: ${GDSESpacingInputVerL} ${GDSESpacingInputHorL};
`, selectStyles = css`
  :host {
    position: relative;
    width: 100%;
    user-select: none;
    display: flex;
    flex-direction: column;
    ${inputSizeRegular$1}
  }

  :host([input-size='small']),
  :host([inputsize='small']) {
    ${inputSizeSmall$1}
  }

  :host([input-size='large']),
  :host([inputsize='large']) {
    ${inputSizeLarge$1}
  }

  :host([label-position='left']),
  :host([labelposition='left']) {
    flex-direction: row;
    align-items: center;
  }

  :host([label-position='left']) .control,
  :host([labelposition='left']) .control {
    width: 'auto';
  }

  :host([label-position='left']) .label,
  :host([labelposition='left']) .label {
    margin: ${GDSESpacing0} ${GDSESpacing100} ${GDSESpacing0} ${GDSESpacing0};
  }

  :host .control {
    cursor: pointer;
    padding: var(--padding);
    border: 1px solid ${GDSEColorBorderInputDefault};
    border-radius: ${GDSERadiusInput};
    outline: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: border-color 0.2s ease-in;

    width: 100%;
    height: var(--input-size);

    box-sizing: border-box;
    color: ${GDSEColorText};
  }

  :host(:not([disabled])) .control:hover {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host(:not([disabled])) .control:active {
    border-color: ${GDSEColorBorderInputActive};
  }

  :host(:not([disabled]):focus) .control {
    border-color: ${GDSEColorBorderInputActive};
  }

  :host([disabled]) .control {
    cursor: not-allowed;
    background-color: ${GDSEColorFillInputDisabled};
    border: 1px solid ${GDSEColorBorderInputDisabled};
    color: ${GDSEColorTextDisabled};
  }

  .label {
    display: inline-block;
    color: ${GDSEColorText};
    margin-bottom: ${GDSESpacing25};
  }

  .error {
    color: ${GDSEColorTextCritical};
    margin-top: ${GDSESpacing25};
    display: flex;
    align-items: center;
    gap: ${GDSESpacing50};
  }

  :host([has-error]:not([disabled])) .control {
    border-color: ${GDSEColorBorderCritical};
  }

  :host([has-error]:not([disabled])) .control:hover {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host([has-error][open]) .control {
    border-color: ${GDSEColorBorderInputDefault};
  }

  :host(:${focusVisible}) {
    outline: none;
  }

  :host(:${focusVisible}) .control {
    border-color: ${GDSEColorBorderFocus};
  }

  ::slotted([role='option']),
  ::slotted(option) {
    flex: 0 0 auto;
    padding: var(--padding);
    max-height: var(--input-size);
  }

  .start,
  .control,
  .end,
  ::slotted(tm1-icon) {
    align-self: center;
  }

  .start,
  .end {
    display: flex;
    margin: auto;
    fill: currentcolor;
  }

  .start {
    padding-right: 9px;
  }

  .end {
    padding-left: 9px;
  }

  .start,
  .end {
    margin-inline-start: auto;
  }

  :host .listbox {
    position: absolute;
    overflow-y: auto;
    width: 100%;
    max-width: var(--input-width);
    z-index: 200;
    box-shadow: none;
    transition: position 0.1s ease-in;
  }

  .control + .listbox {
    --stroke-size: 8;
  }

  :host([open]) .svg-indicator {
    transform: rotate(180deg);
  }

  .svg-indicator {
    transition: transform 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  }

  .body-m {
    font-family: ${semanticFonts.GDSETypographyBodyMFontFamily};
    font-size: ${semanticFonts.GDSETypographyBodyMFontSizeMobile};
    font-weight: ${semanticFonts.GDSETypographyBodyMFontWeight};
    line-height: ${semanticFonts.GDSETypographyBodyMLineHeight};
    letter-spacing: ${semanticFonts.GDSETypographyBodyMLetterSpacing};
    font-feature: auto;
    text-transform: initial;
    text-decoration: initial;
  }

  .body-l {
    font-family: ${semanticFonts.GDSETypographyBodyLFontFamily};
    font-size: ${semanticFonts.GDSETypographyBodyLFontSizeMobile};
    font-weight: ${semanticFonts.GDSETypographyBodyLFontWeight};
    line-height: ${semanticFonts.GDSETypographyBodyLLineHeight};
    letter-spacing: ${semanticFonts.GDSETypographyBodyLLetterSpacing};
    font-feature: auto;
    text-transform: initial;
    text-decoration: initial;
  }

  ::slotted([slot='end']) {
    margin-inline-start: ${GDSESpacing100};
  }

  ::slotted([slot='start']) {
    margin-inline-end: ${GDSESpacing100};
  }

  ::slotted(tm1-icon) {
    height: 20px;
    width: 20px
  }
`, progressRingDarkStyles = css`
  :host([theme='dark']) .middle-ring > div {
    border: var(--border-width) solid ${GDSEColorFillLoading};
    border-color: ${GDSEColorFillLoading} transparent transparent transparent;
  }

  :host([theme='dark']) .outer-ring > div,
  :host([theme='dark']) .inner-ring > div {
    border: var(--border-width) solid ${GDSEColorFillLoading};
    border-color: ${GDSEColorFillLoading} transparent transparent transparent;
  }
`, progressRingLightStyles = css`
  :host .outer-ring > div,
  :host([theme='legacy']) .outer-ring > div,
  :host([theme='light']) .outer-ring > div {
    border: var(--border-width) solid ${GDSEColorFillLoading};
    border-color: ${GDSEColorFillLoading} transparent transparent transparent;
  }

  :host .middle-ring > div,
  :host([theme='legacy']) .middle-ring > div,
  :host([theme='light']) .middle-ring > div {
    border: var(--border-width) solid ${GDSEColorFillLoading};
    border-color: ${GDSEColorFillLoading} transparent transparent transparent;
  }

  :host .inner-ring > div,
  :host([theme='legacy']) .inner-ring > div,
  :host([theme='light']) .inner-ring > div {
    border: var(--border-width) solid ${GDSEColorFillLoading};
    border-color: ${GDSEColorFillLoading} transparent transparent transparent;
  }
`, typeRampBase = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: ${GDSEFontSize2};
  line-height: 20px;
  font-weight: initial;
`, typeRampMinus1 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: ${GDSEFontSize1};
  line-height: 16px;
  font-weight: initial;
`, typeRampMinus2 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: 10px;
  line-height: 14px;
  font-weight: initial;
`, typeRampPlus1 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: ${GDSEFontSize3};
  line-height: 22px;
  font-weight: initial;
`, typeRampPlus2 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: ${GDSEFontSize5};
  line-height: 26px;
  font-weight: initial;
`, typeRampPlus3 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: 24px;
  line-height: 32px;
  font-weight: initial;
`, typeRampPlus5 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: ${GDSEFontSize9};
  line-height: 40px;
  font-weight: initial;
`, typeRampPlus6 = cssPartial`
  font-family: ${GDSEFontFamily};
  font-size: 46px;
  line-height: 52px;
  font-weight: initial;
`, heightNumber = cssPartial`40`, notifier = new RootThemeNotifier(document.documentElement);
let themeManagerInstance = new ThemeManager(document.documentElement, { onThemeChanged: (td) => notifier.value = td });
const getThemeManager = () => themeManagerInstance, setThemeManager = (td) => themeManagerInstance = td, tm1ThemeProviderStyles = css`
  :host {
    display: contents;
  }
`, tm1ThemeProviderTemplate = html`<slot></slot>`;
var __defProp$1a = Object.defineProperty, __getOwnPropDesc$1a = Object.getOwnPropertyDescriptor, __decorateClass$1a = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$1a(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$1a(Ae, xr, id), id;
};
class ThemeProvider extends FoundationElement {
  constructor() {
    super(...arguments), this.themeProvider = new ProviderBehaviour(this, themeContext, ThemeType.light), this.theme = ThemeType.light;
  }
  themeChanged(Ae, xr) {
    xr === "legacy" && (xr = ThemeType.light, this.theme = ThemeType.light), this.themeManager && (this.themeManager.theme = xr, this.themeProvider.value = xr);
  }
  connectedCallback() {
    super.connectedCallback(), this.themeManager = new ThemeManager(this), this.themeManager.theme = this.theme, this.themeProvider.value = this.theme;
  }
}
__decorateClass$1a([
  observable
], ThemeProvider.prototype, "themeManager", 2);
__decorateClass$1a([
  attr()
], ThemeProvider.prototype, "theme", 2);
const tm1ThemeProvider = ThemeProvider.compose({
  baseName: "theme-provider",
  template: tm1ThemeProviderTemplate,
  styles: tm1ThemeProviderStyles
});
designSystem.register(
  tm1ThemeProvider()
);
const Orientation = {
  horizontal: "horizontal",
  vertical: "vertical"
}, keyArrowDown = "ArrowDown", keyArrowLeft = "ArrowLeft", keyArrowRight = "ArrowRight", keyArrowUp = "ArrowUp", keyEnd = "End", keyEnter = "Enter", keyEscape = "Escape", keyHome = "Home", keySpace = " ", keyTab = "Tab", ArrowKeys = {
  ArrowDown: keyArrowDown,
  ArrowLeft: keyArrowLeft,
  ArrowRight: keyArrowRight,
  ArrowUp: keyArrowUp
};
var Direction;
(function(td) {
  td.ltr = "ltr", td.rtl = "rtl";
})(Direction || (Direction = {}));
function wrapInBounds(td, Ae, xr) {
  return xr < td ? Ae : xr > Ae ? td : xr;
}
function limit(td, Ae, xr) {
  return Math.min(Math.max(xr, td), Ae);
}
function inRange(td, Ae, xr = 0) {
  return [Ae, xr] = [Ae, xr].sort((ed, id) => ed - id), Ae <= td && td < xr;
}
let uniqueIdCounter = 0;
function uniqueId(td = "") {
  return `${td}${uniqueIdCounter++}`;
}
var SystemColors;
(function(td) {
  td.Canvas = "Canvas", td.CanvasText = "CanvasText", td.LinkText = "LinkText", td.VisitedText = "VisitedText", td.ActiveText = "ActiveText", td.ButtonFace = "ButtonFace", td.ButtonText = "ButtonText", td.Field = "Field", td.FieldText = "FieldText", td.Highlight = "Highlight", td.HighlightText = "HighlightText", td.GrayText = "GrayText";
})(SystemColors || (SystemColors = {}));
const sprites = {
  actionMenu: {
    24: () => html` <svg viewBox="0 0 27 17">
        <path
          d="M19.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-6 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
        />
      </svg>`
  },
  add: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 1C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm-.5-18a.5.5 0 1 1 1 0v14a.5.5 0 1 1-1 0V5zM5 12.5a.5.5 0 1 1 0-1h14a.5.5 0 1 1 0 1H5z"
        />
      </svg>`
  },
  addEvent: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm1-7c.828 0 1.5.597 1.5 1.333V2h1a1 1 0 0 1 1 1v3.5a.5.5 0 1 1-1 0V6H1v8h4.5a.5.5 0 1 1 0 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1v-.667C2 .597 2.672 0 3.5 0S5 .597 5 1.333V2h6v-.667C11 .597 11.672 0 12.5 0zm-1 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 1a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H12v1.5s0 .5-.5.5c-.458 0-.497-.42-.5-.49V12H9.5a.5.5 0 1 1 0-1H11V9.5a.5.5 0 0 1 .5-.5zm-6-2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2zM5 8H4v1h1V8zM2.047 3H1v2h14V3h-1.047c-.167.575-.714 1-1.453 1-.739 0-1.2-.42-1.5-1H4.953c-.167.575-.754 1-1.453 1-.699 0-1.286-.425-1.453-1zM12.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.5-.5zm-9 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.5 11a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zm0 1a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zM18 0a1.5 1.5 0 0 1 1.5 1.5v.499L23 2v1l-3.5-.001V4a1.5 1.5 0 0 1-3 0V3h-9v1a1.5 1.5 0 0 1-3 0V3H1v4h22V2a1 1 0 0 1 1 1v7.227a.5.5 0 1 1-1 0V8H1v13h7.136a.5.5 0 1 1 0 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 .883-.993L1 2h3.5v-.5a1.5 1.5 0 0 1 3 0V2h9v-.5A1.5 1.5 0 0 1 18 0zm-.5 14a.5.5 0 0 1 .5.5v2.499l2.5.001a.5.5 0 1 1 0 1l-2.5-.001V20.5a.5.5 0 1 1-1 0v-2.501L14.5 18a.5.5 0 1 1 0-1l2.5-.001V14.5a.5.5 0 0 1 .5-.5zM7.167 10c.46 0 .833.373.833.833v3.334c0 .46-.373.833-.833.833H3.833A.833.833 0 0 1 3 14.167v-3.334c0-.46.373-.833.833-.833h3.334zM7 11H4v3h3v-3zM18 1a.5.5 0 0 0-.5.5V4a.5.5 0 1 0 1 0V1.5A.5.5 0 0 0 18 1zM6 1a.5.5 0 0 0-.5.5V4a.5.5 0 0 0 1 0V1.5A.5.5 0 0 0 6 1z"
        />
      </svg>`
  },
  addTicket: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m10.175.272 2.082 2.082a.458.458 0 0 1 0 .648l-.217.218a.543.543 0 1 0 .768.768l.218-.218a.458.458 0 0 1 .648 0l2.054 2.055a.785.785 0 0 1 0 1.11l-.235.236a.458.458 0 1 1-.648-.648l.143-.143-1.644-1.643a1.46 1.46 0 0 1-2.053-2.053L9.62 1.012 7.13 3.501l1.999 1.998a.5.5 0 0 1-.708.707L6.423 4.208 1.013 9.62l5.367 5.368.044-.044a.458.458 0 1 1 .648.647l-.136.137a.785.785 0 0 1-1.111 0L.272 10.175a.785.785 0 0 1 0-1.11L9.064.271a.785.785 0 0 1 1.111 0zM11.5 6.9a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 1.1a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H12v1.5s0 .5-.5.5c-.458 0-.497-.42-.5-.49V12H9.5a.5.5 0 1 1 0-1H11V9.5a.5.5 0 0 1 .5-.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.5 11a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zM15.206.337l3.182 3.182a.5.5 0 0 1 0 .707l-.332.332a1.03 1.03 0 1 0 1.457 1.457l.332-.332a.5.5 0 0 1 .707 0l3.14 3.14a1 1 0 0 1 0 1.414l-1.356 1.355a.5.5 0 0 1-.707-.707l1.356-1.356-2.786-2.785a2.03 2.03 0 0 1-2.871-2.871l-2.829-2.829-2.828 2.829 1.768 1.767a.5.5 0 0 1-.708.708L10.964 4.58l-9.9 9.9 8.485 8.485 1.323-1.323a.5.5 0 1 1 .707.707l-1.322 1.323a1 1 0 0 1-1.415 0L.357 15.186a1 1 0 0 1 0-1.414L13.792.337a1 1 0 0 1 1.414 0zM17.5 12a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zm0 2a.5.5 0 0 1 .5.5V17h2.5a.5.5 0 1 1 0 1H18v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 1 1 0-1H17v-2.5a.5.5 0 0 1 .5-.5zm-4.769-4.824a.5.5 0 0 1 0 .707l-4.95 4.95a.5.5 0 0 1-.706-.707l4.95-4.95a.5.5 0 0 1 .706 0zm2.122-2.121 1.194 1.194a.5.5 0 1 1-.707.707l-1.194-1.194a.5.5 0 0 1 .707-.707z"
        />
      </svg>`
  },
  addToWallet: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M18.5 13a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 2a.5.5 0 0 1 .492.41l.008.09V18h1.5a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L20.5 19H19v1.5a.5.5 0 0 1-.41.492L18.5 21a.5.5 0 0 1-.492-.41L18 20.5V19h-1.5a.5.5 0 0 1-.492-.41L16 18.5a.5.5 0 0 1 .41-.492L16.5 18H18v-1.5a.5.5 0 0 1 .41-.492L18.5 16zm0-16A2.5 2.5 0 0 1 21 2.5v9a.5.5 0 1 1-1 0V9h-4.197c-.96 0-1.855.48-2.387 1.277l-.168.252a3.303 3.303 0 0 1-5.496 0l-.168-.252A2.869 2.869 0 0 0 5.197 9H1v4.5A3.5 3.5 0 0 0 4.5 17h6a.5.5 0 1 1 0 1h-6A4.5 4.5 0 0 1 0 13.5v-11A2.5 2.5 0 0 1 2.5 0h16zm-2 6h-12A1.5 1.5 0 0 0 3 7.5V8h2.197c1.294 0 2.502.646 3.219 1.723l.168.252a2.303 2.303 0 0 0 3.832 0l.168-.252A3.869 3.869 0 0 1 15.803 8H18v-.5A1.5 1.5 0 0 0 16.5 6zm2-5h-16A1.5 1.5 0 0 0 1 2.5V8h1V4.5A2.5 2.5 0 0 1 4.5 2h12A2.5 2.5 0 0 1 19 4.5V8h1V2.5A1.5 1.5 0 0 0 18.5 1zm-2 2h-12A1.5 1.5 0 0 0 3 4.5v1c.418-.314.937-.5 1.5-.5h12c.563 0 1.083.186 1.501.5L18 4.5A1.5 1.5 0 0 0 16.5 3z"
        />
      </svg>`,
    32: () => html` <svg viewBox="0 0 32 32">
        <path
          d="M24.5 17a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm0 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 2a.5.5 0 0 1 .492.41l.008.09V24h3.5a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L28.5 25H25v3.5a.5.5 0 0 1-.41.492L24.5 29a.5.5 0 0 1-.492-.41L24 28.5V25h-3.5a.5.5 0 0 1-.492-.41L20 24.5a.5.5 0 0 1 .41-.492L20.5 24H24v-3.5a.5.5 0 0 1 .41-.492L24.5 20zm0-20A3.5 3.5 0 0 1 28 3.5v12a.5.5 0 1 1-1 0V13h-6.063c-1.233 0-2.385.59-3.105 1.58l-.13.19A4.841 4.841 0 0 1 13.625 17h-.25a4.841 4.841 0 0 1-3.945-2.036l-.132-.194A3.841 3.841 0 0 0 6.063 13H1v5.5A4.5 4.5 0 0 0 5.5 23h9a.5.5 0 1 1 0 1h-9A5.5 5.5 0 0 1 0 18.5v-15A3.5 3.5 0 0 1 3.5 0h21zm1 8h-23A1.5 1.5 0 0 0 1 9.5V12h5.063c1.572 0 3.04.762 3.946 2.036l.131.194A3.841 3.841 0 0 0 13.375 16h.25c1.232 0 2.385-.59 3.105-1.58l.13-.19A4.841 4.841 0 0 1 20.937 12H27V9.5A1.5 1.5 0 0 0 25.5 8zm-1-7h-21A2.5 2.5 0 0 0 1 3.5v4c.29-.219.63-.375 1-.45V5.5A2.5 2.5 0 0 1 4.5 3h19A2.5 2.5 0 0 1 26 5.5v1.55c.37.075.71.232 1.001.45L27 3.5A2.5 2.5 0 0 0 24.5 1zm-1 3h-19A1.5 1.5 0 0 0 3 5.5V7h22V5.5A1.5 1.5 0 0 0 23.5 4z"
        />
      </svg>`
  },
  callUs: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M5.724 4.708 7.846 6.83c.975.977.975 2.56 0 3.536l-.385.385a47.105 47.105 0 0 0 5.789 5.79l.385-.386a2.5 2.5 0 0 1 3.535 0l2.122 2.121a2.5 2.5 0 0 1 0 3.535l-1.165 1.164a3.496 3.496 0 0 1-4.403.443A46.983 46.983 0 0 1 .584 10.276a3.495 3.495 0 0 1 .44-4.404L2.19 4.708a2.501 2.501 0 0 1 3.535 0zm-2.828.707L1.732 6.58a2.495 2.495 0 0 0-.315 3.145 45.983 45.983 0 0 0 12.86 12.859c.99.655 2.305.523 3.143-.316l1.165-1.164a1.5 1.5 0 0 0 0-2.12l-2.122-2.122a1.5 1.5 0 0 0-2.121 0l-.707.707a.5.5 0 0 1-.67.033 47.918 47.918 0 0 1-6.567-6.565.5.5 0 0 1 .034-.67l.707-.708a1.503 1.503 0 0 0 0-2.122l-2.122-2.12a1.501 1.501 0 0 0-2.121 0zM12 0c6.628 0 12 5.372 12 12a.5.5 0 1 1-1 0c0-6.076-4.924-11-11-11a.5.5 0 1 1 0-1zm0 4a8 8 0 0 1 8 8 .5.5 0 1 1-1 0 7 7 0 0 0-7-7 .5.5 0 1 1 0-1zm0 4a4 4 0 0 1 4 4 .5.5 0 1 1-1 0 3 3 0 0 0-3-3 .5.5 0 1 1 0-1z"
        />
      </svg>`
  },
  cards: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 1H10V10H1V1ZM2.5 2.5H8.5V8.5H2.5V2.5Z"
        />
        <path 
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 14H10V23H1V14ZM2.5 15.5H8.5V21.5H2.5V15.5Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 1V10H23V1H14ZM21.5 2.5H15.5V8.5H21.5V2.5Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 14H23V23H14V14ZM15.5 15.5H21.5V21.5H15.5V15.5Z"
        />
      </svg>
    `
  },
  circle: {
    16: () => html`
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
        />
      </svg>
    `
  },
  clear: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm3 3c.195.195.204.503.02.687L8.707 8l2.313 2.313c.184.184.175.492-.02.687-.195.195-.503.204-.687.02L8 8.707 5.687 11.02c-.184.184-.492.175-.687-.02-.195-.195-.204-.503-.02-.687L7.293 8 4.98 5.687C4.796 5.503 4.805 5.195 5 5c.195-.195.503-.204.687-.02L8 7.293l2.313-2.313c.184-.184.492-.175.687.02z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 1C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm3.89-15.596a.5.5 0 0 1 .706.707l-8.485 8.485a.5.5 0 0 1-.707-.707l8.485-8.485zm-8.486.707a.5.5 0 0 1 .707-.707l8.485 8.485a.5.5 0 0 1-.707.707L7.404 8.111z"
        />
      </svg>`
  },
  close: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path
          d="M8.52 6.944 1.872.314.812 1.37 7.462 8 .813 14.63l1.059 1.056 6.648-6.63 6.608 6.59 1.06-1.056L9.578 8l6.608-6.59L15.128.354 8.52 6.944Z"
        />
      </svg>`
  },
  compress: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M10.5 13h.012c.02 0 .041.002.062.005L10.5 13a.502.502 0 0 1 .354.146l.011.013a.503.503 0 0 1 .033.039l-.044-.052A.502.502 0 0 1 11 13.5v6a.5.5 0 1 1-1 0v-4.794l-6.146 6.148a.5.5 0 0 1-.708-.708L9.292 14H4.5a.5.5 0 1 1 0-1h6zm10.354-9.854a.5.5 0 0 1 0 .708L14.706 10H19.5a.5.5 0 1 1 0 1h-6.02a.503.503 0 0 1-.052-.005L13.5 11a.502.502 0 0 1-.354-.146l-.011-.013a.503.503 0 0 1-.033-.039l.044.052A.502.502 0 0 1 13 10.5v-6a.5.5 0 1 1 1 0v4.792l6.146-6.146a.5.5 0 0 1 .708 0z"
        />
      </svg>`
  },
  delete: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M10 0a1 1 0 0 1 1 1v1h2.5a1.5 1.5 0 0 1 0 3h-.544l-.917 10.09a1 1 0 0 1-.996.91H4.957a1 1 0 0 1-.996-.91L3.043 5H2.5a1.5 1.5 0 0 1 0-3H5V1a1 1 0 0 1 1-1h4zm1.952 5H4.048l.909 10h6.086l.91-10zM9.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .5-.5zm-3 0a.5.5 0 0 1 .492.41L7 7.5v5a.5.5 0 0 1-.992.09L6 12.5v-5a.5.5 0 0 1 .5-.5zm7-4h-11a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1zM10 1H6v1h4V1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16 1a1 1 0 0 1 1 1v2h3.5a1.5 1.5 0 0 1 0 3h-1.53l-.942 15.062a1 1 0 0 1-.998.938H6.97a1 1 0 0 1-.998-.938L5.029 7H3.5a1.5 1.5 0 0 1 0-3H7V2a1 1 0 0 1 1-1h8zm-2 9.5a.5.5 0 1 1 1 0v8a.5.5 0 1 1-1 0v-8zm-4 0a.5.5 0 1 0-1 0v8a.5.5 0 1 0 1 0v-8zM16 2H8v2h8V2zM3.5 5a.5.5 0 0 0 0 1h17a.5.5 0 1 0 0-1h-17zm2.532 2 .938 15h10.06l.938-15H6.032z"
        />
      </svg>`
  },
  drawer: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21 19a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h18zm0-8a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h18zm0-8a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2h18z"
        />
      </svg>`
  },
  duplicate: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M10.5 4a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5zM10 5H2v10h8V5zm4.5 5.014a.5.5 0 0 1 .5.5V12.5a.5.5 0 0 1-.5.5h-1.991a.5.5 0 1 1 0-1H14v-1.486a.5.5 0 0 1 .5-.5zm0-2.989a.5.5 0 0 1 .5.5v.958a.5.5 0 1 1-1 0v-.958a.5.5 0 0 1 .5-.5zm0-3a.5.5 0 0 1 .5.5v.958a.5.5 0 1 1-1 0v-.958a.5.5 0 0 1 .5-.5zM7.53 0a.5.5 0 1 1 0 1H6.024v1.517a.5.5 0 1 1-1 0V.5a.5.5 0 0 1 .5-.5zm6.97 0a.5.5 0 0 1 .5.5v2.017a.5.5 0 1 1-1 0V1h-1.491a.5.5 0 1 1 0-1zm-4 0a.5.5 0 1 1 0 1h-.965a.5.5 0 0 1 0-1z"
        />
      </svg>`
  },
  edit: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m10.451.389 2.598 1.5a1 1 0 0 1 .366 1.366l-5.75 9.96a.5.5 0 0 1-.047.067l.047-.068a.501.501 0 0 1-.157.167L5.055 15H12.5a.5.5 0 1 1 0 1h-9a.5.5 0 0 1-.5-.5l.002-.02a.521.521 0 0 1-.001-.082l.268-4.464.002-.027a.497.497 0 0 1 .006-.038l-.008.065a.5.5 0 0 1 .066-.22l5.75-9.96A1 1 0 0 1 10.45.39zM4.219 11.802l-.16 2.658 2.223-1.467-2.063-1.191zm4.232-7.95-4 6.929 2.598 1.5 4-6.928-2.598-1.5zm1.5-2.597-1 1.732 2.598 1.5 1-1.732-2.598-1.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m14.918.134 4.535 2.618c.477.278.64.887.365 1.366l-9.103 15.767a.53.53 0 0 1-.223.212l-4.4 2.902L19.5 23a.5.5 0 1 1 0 1h-15a.5.5 0 0 1-.5-.5v-.075l.377-6.86a.53.53 0 0 1 .072-.299L13.553.5a1 1 0 0 1 1.365-.365zM5.336 17.355l-.282 5.132 4.277-2.825-3.995-2.307zM12.08 5.05 5.564 16.333l4.535 2.618 6.514-11.284L12.08 5.05zM14.418 1 12.58 4.183l4.533 2.618 1.839-3.182L14.418 1z"
        />
      </svg>`
  },
  edit2: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0566 0.291982C20.2476 0.101654 20.5074 -0.00368117 20.7771 9.83105e-05C21.7445 0.0136515 22.5301 0.295703 23.0967 0.862138C23.6587 1.42391 23.9533 2.21344 23.9992 3.19944C24.0121 3.48038 23.9062 3.75381 23.7072 3.9527L11.895 15.7615C11.7037 15.9527 11.4588 16.0813 11.1928 16.1301L8.51651 16.6214C7.97315 16.7212 7.4518 16.3617 7.35202 15.8185C7.3285 15.6905 7.33022 15.5591 7.35706 15.4317L7.92797 12.7231C7.98129 12.4701 8.10706 12.2381 8.28994 12.0552L20.0566 0.291982ZM9.23324 12.9981L17.9566 4.27609L19.727 6.04596L10.9521 14.8188L8.76428 15.2201L9.23324 12.9981ZM22.6561 3.11755L20.67 5.10314L18.8996 3.33324L20.8943 1.3389L20.7587 1.33332C21.401 1.34232 21.8537 1.50483 22.1539 1.80497L22.2621 1.92718C22.4664 2.18784 22.5978 2.54658 22.6485 3.01672L22.6561 3.11755Z"  />
        <path d="M2.00055 2.66694H15.795L14.4613 4.00024H2.00083C1.67346 4.00024 1.40119 4.23607 1.34473 4.54707L1.33398 4.6669V22C1.33398 22.3273 1.56988 22.5995 1.88097 22.6559L2.00083 22.6667H19.3389C19.6663 22.6667 19.9386 22.4308 19.9951 22.1198L20.0058 22V9.53881L21.3392 8.20577V22C21.3392 23.1046 20.4435 24 19.3387 24H2.00055C0.895677 24 0 23.1046 0 22V4.66692C0 3.56236 0.895677 2.66694 2.00055 2.66694Z"  />
      </svg>
      `
  },
  email: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M14.5 2A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5V3.487a.5.5 0 0 1 .002-.028L0 3.5A1.5 1.5 0 0 1 1.5 2h13zm.5 2.434L8.277 8.916a.5.5 0 0 1-.554 0L1 4.435V12.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4.434zM14.5 3h-13a.5.5 0 0 0-.444.27L8 7.9l6.944-4.63A.5.5 0 0 0 14.5 3z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M22.5 3A1.5 1.5 0 0 1 24 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 19.5v-15A1.5 1.5 0 0 1 1.5 3h21zm.5 3.456L12.286 13.91a.5.5 0 0 1-.572 0L1 6.457V19.5a.5.5 0 0 0 .5.5h21a.5.5 0 0 0 .5-.5V6.456zM22.5 4h-21a.5.5 0 0 0-.5.5v.739l11 7.652 11-7.653V4.5a.5.5 0 0 0-.5-.5z"
        />
      </svg>`
  },
  expand: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M10.854 13.146a.5.5 0 0 1 0 .708l-6.147 6.145L9.5 20a.5.5 0 1 1 0 1H3.49a.503.503 0 0 1-.064-.005L3.5 21a.502.502 0 0 1-.354-.146l-.011-.013a.503.503 0 0 1-.033-.039l.044.052A.502.502 0 0 1 3 20.5v-6a.5.5 0 1 1 1 0v4.792l6.146-6.146a.5.5 0 0 1 .708 0zM20.5 3h.012c.02 0 .041.002.062.005L20.5 3a.502.502 0 0 1 .354.146l.011.013a.503.503 0 0 1 .033.039l-.044-.052A.502.502 0 0 1 21 3.5v6a.5.5 0 1 1-1 0V4.706l-6.146 6.148a.5.5 0 0 1-.708-.708L19.292 4H14.5a.5.5 0 1 1 0-1h6z"
        />
      </svg>`
  },
  feedback: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m5 22.293 4.146-4.147A.5.5 0 0 1 9.5 18h10a3.5 3.5 0 0 0 3.5-3.5v-10A3.5 3.5 0 0 0 19.5 1h-15A3.5 3.5 0 0 0 1 4.5v10A3.5 3.5 0 0 0 4.5 18a.5.5 0 0 1 .5.5v3.793zM9.707 19l-4.853 4.854A.5.5 0 0 1 4 23.5v-4.527A4.5 4.5 0 0 1 0 14.5v-10A4.5 4.5 0 0 1 4.5 0h15A4.5 4.5 0 0 1 24 4.5v10a4.5 4.5 0 0 1-4.5 4.5H9.707zM5.5 6a.5.5 0 0 1 0-1h13a.5.5 0 1 1 0 1h-13zm0 4a.5.5 0 0 1 0-1h13a.5.5 0 1 1 0 1h-13zm0 4a.5.5 0 1 1 0-1h7a.5.5 0 1 1 0 1h-7z"
        />
      </svg>`
  },
  filter: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M2.5 0a.5.5 0 0 1 .5.5V3h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3v8.5a.5.5 0 1 1-1 0V7H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h1V.5a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5V9h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8v2.5a.5.5 0 1 1-1 0V13H6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1V.5a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5V5h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1v6.5a.5.5 0 1 1-1 0V9h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1V.5a.5.5 0 0 1 .5-.5zM9 10H6v2h3v-2zm5-4h-3v2h3V6zM4 4H1v2h3V4z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M10.5 16v2h3v-2h-3zm9-3a.5.5 0 0 1 .5.5v9a.5.5 0 1 1-1 0v-9a.5.5 0 0 1 .5-.5zM12 1a.5.5 0 0 1 .5.5V15h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1v3.5a.5.5 0 1 1-1 0V19h-1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1V1.5A.5.5 0 0 1 12 1zm7.5 0a.5.5 0 0 1 .5.5v9a.5.5 0 1 1-1 0v-9a.5.5 0 0 1 .5-.5zM18 11v2h3v-2h-3zm0-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM3 6v2h3V6H3zm1.5-5a.5.5 0 0 1 .5.5V5h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5v13.5a.5.5 0 1 1-1 0V9H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1V1.5a.5.5 0 0 1 .5-.5z"
        />
      </svg>`
  },
  getHelp: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 0a8 8 0 1 1 0 16c-4.419 0-8-3.58-8-8a8 8 0 0 1 8-8zm0 1.17a6.83 6.83 0 1 0 0 13.66A6.83 6.83 0 0 0 8 1.17zm0 9.562a.52.52 0 1 1-.001 1.041A.52.52 0 0 1 8 10.732zm0-5.854c1.254 0 2.146.87 2.146 2.038 0 .988-.442 1.595-1.546 2.088l-.08.033v.914a.52.52 0 0 1-.356.494l-.08.02-.084.007a.52.52 0 0 1-.514-.436L7.48 9.95V8.687a.52.52 0 0 1 .338-.488c1.03-.385 1.288-.658 1.288-1.283 0-.591-.426-.997-1.106-.997-.68 0-1.106.406-1.106.997a.52.52 0 0 1-1.04 0c0-1.168.892-2.038 2.146-2.038z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 0c6.628 0 12 5.373 12 12.001C24 18.629 18.628 24 12 24S0 18.629 0 12.001 5.372 0 12 0zm0 1C5.924 1 1 5.925 1 12.001S5.924 23 12 23s11-4.923 11-10.999C23 5.925 18.076 1 12 1zm0 15.5a.5.5 0 1 1-.002 1.002A.5.5 0 0 1 12 16.5zm0-9c1.81 0 3 1.25 3 2.833 0 1.452-.652 2.313-2.5 3.064V15a.5.5 0 1 1-1 0v-1.944a.5.5 0 0 1 .325-.469C13.56 11.94 14 11.411 14 10.333c0-1.041-.754-1.833-2-1.833s-2 .792-2 1.833a.5.5 0 1 1-1 0C9 8.75 10.19 7.5 12 7.5z"
        />
      </svg>`
  },
  home: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m8.343.137 7.178 6.788c.617.588.64 1.558.056 2.17a1.553 1.553 0 0 1-1.578.414L14 15a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9.51a1.546 1.546 0 0 1-1.573-.416 1.533 1.533 0 0 1 .06-2.167l7.17-6.79a.5.5 0 0 1 .686 0zM8 4.18 3 8.8V15l3-.001V11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3.999L13 15V8.799L8 4.18zM9 11H7v3.999h2V11zM8 1.188 1.174 7.653a.533.533 0 0 0-.02.753.546.546 0 0 0 .766.026l5.74-5.3A.499.499 0 0 1 8 3l.09.008a.503.503 0 0 1 .25.125l5.738 5.297a.553.553 0 0 0 .775-.025.532.532 0 0 0-.018-.752L8 1.188z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m12.354 1.146 10.25 10.25a1.56 1.56 0 0 1-2.208 2.208L20 13.206V22a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.793l-.396.397a1.56 1.56 0 0 1-2.208-2.208l10.25-10.25a.5.5 0 0 1 .708 0zM12 5.207l-7 7V22h4v-6l.007-.117a1 1 0 0 1 .876-.876L10 15h4l.117.007a1 1 0 0 1 .876.876L15 16v6h4v-9.793l-7-7zM14 16h-4v6h4v-6zM12 2.207l-9.896 9.897a.56.56 0 1 0 .792.792l8.75-8.75a.5.5 0 0 1 .708 0l8.75 8.75a.56.56 0 0 0 .792-.792L12 2.207z"
        />
      </svg>`
  },
  kebab: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path d="M8 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
      </svg>`
  },
  link: {
    16: () => html`<svg viewBox="0 0 17 16">
        <g clip-path="url(#a)">
          <path
            d="M4.41 5.222C2.912 5.222 1.694 6.467 1.694 8s1.218 2.778 2.716 2.778h3.092V12H4.41a3.866 3.866 0 0 1-2.765-1.172A4.047 4.047 0 0 1 .5 8c0-1.06.412-2.078 1.145-2.828A3.866 3.866 0 0 1 4.41 4h3.092v1.222H4.41Z"
          />
          <path d="M5.408 7.347h6.184v1.306H5.408V7.347Z" />
          <path
            d="M12.59 5.222H9.498V4h3.092c1.037 0 2.031.421 2.765 1.172A4.047 4.047 0 0 1 16.5 8c0 1.06-.412 2.078-1.145 2.828A3.866 3.866 0 0 1 12.59 12H9.498v-1.222h3.092c1.498 0 2.716-1.245 2.716-2.778s-1.218-2.778-2.716-2.778Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M.5 0h16v16H.5z" />
          </clipPath>
        </defs>
      </svg>`
  },
  linkOut: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0V2.707l-8.146 8.147a.5.5 0 0 1-.708-.708L13.293 2H9.5zM14 14v-3.5a.5.5 0 1 1 1 0v4a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H2v12h12z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M20.293 3H14.5a.5.5 0 1 1 0-1h7a.5.5 0 0 1 .5.5v7a.5.5 0 1 1-1 0V3.707L8.854 15.854a.5.5 0 0 1-.708-.708L20.293 3zM21 21v-5.5a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-19a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H3v18h18z"
        />
      </svg>`
  },
  list: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.90002 1.06006H1.15002V1.81006V22.0001V22.7501H1.90002H16.3794H18.19H18.2V22.0101L18.7204 22.5304L22.6204 18.6304L22.84 18.4107V18.1001V1.81006V1.06006H22.09H1.90002ZM2.65002 21.2501H17.8794L21.34 17.7894V2.56006H2.65002V21.2501ZM7.43004 7.93006H4.60004V6.43006H7.43004V7.93006ZM19.6 7.93006H8.89001V6.43006H19.6V7.93006ZM4.60004 12.2501H7.43004V10.7501H4.60004V12.2501ZM19.6 12.2501H8.89001V10.7501H19.6V12.2501ZM4.60004 16.5601H7.43004V15.0601H4.60004V16.5601ZM19.6 16.5601H8.89001V15.0601H19.6V16.5601Z"
        />
      </svg>
    `
  },
  meatballSub: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
      </svg>`
  },
  minus: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path d="M3.5 12a.5.5 0 1 1 0-1h16a.5.5 0 1 1 0 1h-16z" />
      </svg>`
  },
  pause: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M9.5 4A1.5 1.5 0 0 1 11 5.5v13A1.5 1.5 0 0 1 9.5 20h-1A1.5 1.5 0 0 1 7 18.5v-13A1.5 1.5 0 0 1 8.5 4h1zm6 0A1.5 1.5 0 0 1 17 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 14.5 4h1zm-6 1h-1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zm6 0h-1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
        />
      </svg>`
  },
  play: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M7.76 4.85a.5.5 0 0 0-.76.427v13.446a.5.5 0 0 0 .76.427l11.073-6.723a.5.5 0 0 0 0-.854L7.759 4.85zm.518-.855 11.074 6.723a1.5 1.5 0 0 1 0 2.564L8.278 20.005A1.5 1.5 0 0 1 6 18.723V5.277a1.5 1.5 0 0 1 2.278-1.282z"
        />
      </svg>`
  },
  plus: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path d="M11 11V3.5a.5.5 0 1 1 1 0V11h7.5a.5.5 0 1 1 0 1H12v7.5a.5.5 0 1 1-1 0V12H3.5a.5.5 0 1 1 0-1H11z" />
      </svg>`
  },
  print: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M13.508 4A2.49 2.49 0 0 1 16 6.498v4.004A2.494 2.494 0 0 1 13.5 13l-1.501-.001L12 15.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5l-.001-2.501L2.5 13A2.494 2.494 0 0 1 0 10.502V6.498A2.496 2.496 0 0 1 2.492 4h11.016zM11 11H5v4h6v-4zm2.508-6H2.492C1.669 5 1 5.671 1 6.498v4.004C1 11.334 1.668 12 2.5 12l1.499-.001L4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5l-.001 1.499L13.5 12c.833 0 1.5-.668 1.5-1.498V6.498A1.49 1.49 0 0 0 13.508 5zM4.5 7a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1h2zm6-7a.5.5 0 0 1 .354.146l2 2 .011.013a.503.503 0 0 1 .033.039l-.044-.052A.502.502 0 0 1 13 2.5v.012c0 .02-.002.041-.005.062L13 2.5a.502.502 0 0 1-.146.354l-.013.011a.503.503 0 0 1-.039.033l.052-.044A.502.502 0 0 1 12.5 3h-3a.5.5 0 0 1-.5-.5L8.999.999 4 1v1.5a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5h7zm-.207 1L9.999.999 10 2h1.293l-1-1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 6C22.876 6 24 7.123 24 8.5v6c0 1.376-1.124 2.5-2.5 2.5H19v6.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V17H2.5A2.506 2.506 0 0 1 0 14.5v-6C0 7.123 1.124 6 2.5 6h19zM18 14H6v2.49a.51.51 0 0 1 0 .01l-.001.01L6 23h12v-9zm3.5-7h-19C1.676 7 1 7.676 1 8.5v6c0 .824.676 1.5 1.5 1.5H5v-2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5V16h2.5c.824 0 1.5-.676 1.5-1.5v-6c0-.824-.676-1.5-1.5-1.5zm-17 2a1.5 1.5 0 1 1 .002 2.998A1.5 1.5 0 0 1 4.5 9zm0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm11-10a.5.5 0 0 1 .354.146l3 3A.5.5 0 0 1 19 3.5v1a.5.5 0 1 1-1 0v-.793L15.293 1H6v3.5a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5h10zm.5 3h2.5a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 1 1 1 0V3z"
        />
      </svg>`
  },
  promoted: {
    24: () => html`
      <svg viewBox="0 0 24 24">
        <path
          d="M22.603 17.168c-.502.265-1.223-.083-1.625-.762L13.505 3.788c-.402-.662-.335-1.44.15-1.706.47-.248 1.207.083 1.61.762l7.472 12.618c.403.679.336 1.44-.15 1.706h.016ZM2.027 15.975c-.234-.132-.503-.165-.72-.05-.336.183-.42.762-.134 1.21l1.893 3.179c.268.463.838.695 1.173.497.335-.166.402-.597.234-1.01l16.338-2.319-8.194-13.611-10.59 12.104Zm11.042 5.001c.185-.331.235-.762.117-1.192l-.217-.762s-.118-.331-.386-.248c-.268.066-.217.331-.217.331l.217.762a.948.948 0 0 1-.067.712.748.748 0 0 1-.57.38L9.3 21.34c-.503.067-1.022-.314-1.173-.844l-.2-.762s-.068-.281-.403-.232c-.235.05-.201.332-.201.332l.201.745c.251.894 1.123 1.523 1.96 1.407l2.648-.38a1.218 1.218 0 0 0 .938-.63Zm-9.4-4.487L13.22 5.692l.838 1.391-10.137 9.87-.269-.464h.017Z"
        />
      </svg>
    `
  },
  refresh: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path
          d="M13.177 4.872 12.289.761l-.978.211.492 2.276A6.503 6.503 0 0 0 2.316 11.4a6.502 6.502 0 0 0 12.376-3.334l-.996.092a5.502 5.502 0 1 1-7.788-4.48 5.509 5.509 0 0 1 5.539.54l-2.7.572.208.978 4.222-.896Z"
        />
      </svg>`
  },
  search: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path
          fill-rule="evenodd"
          d="M7.967 1.272c-3.431 0-6.195 2.735-6.195 6.089 0 3.354 2.764 6.09 6.195 6.09 3.43 0 6.195-2.736 6.195-6.09 0-3.354-2.764-6.09-6.195-6.09ZM.5 7.36C.5 3.286 3.852 0 7.967 0c4.114 0 7.467 3.286 7.467 7.361 0 1.78-.64 3.41-1.704 4.681l2.77 2.728-.892.906-2.775-2.732a7.504 7.504 0 0 1-4.866 1.778C3.852 14.722.5 11.436.5 7.361Z"
          clip-rule="evenodd"
        />
      </svg>`
  },
  settings: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m22.543 9.293.007.001a1.713 1.713 0 0 1 1.45 1.68v2.055a1.715 1.715 0 0 1-1.448 1.682l-1.094.153a9.828 9.828 0 0 1-.75 1.798c.278.363.467.613.661.877.497.68.426 1.62-.17 2.219l-1.443 1.444a1.711 1.711 0 0 1-2.223.157c-.308-.227-.605-.45-.875-.658-.575.31-1.18.56-1.796.748-.05.366-.101.733-.156 1.101A1.714 1.714 0 0 1 13.03 24h-2.06a1.713 1.713 0 0 1-1.681-1.443 67.537 67.537 0 0 1-.156-1.1 9.828 9.828 0 0 1-1.796-.748c-.274.208-.562.425-.877.66-.68.497-1.62.426-2.219-.17l-1.444-1.443a1.711 1.711 0 0 1-.157-2.223c.227-.308.45-.605.658-.875a9.835 9.835 0 0 1-.749-1.798l-1.1-.154A1.714 1.714 0 0 1 0 13.03v-2.06a1.715 1.715 0 0 1 1.448-1.68l1.094-.153a9.828 9.828 0 0 1 .749-1.797 58.225 58.225 0 0 1-.66-.878 1.713 1.713 0 0 1 .17-2.22l1.446-1.433a1.712 1.712 0 0 1 2.22-.167c.308.227.605.45.875.658a9.835 9.835 0 0 1 1.796-.748c.05-.366.101-.733.156-1.101A1.713 1.713 0 0 1 10.974 0h2.055a1.713 1.713 0 0 1 1.681 1.443c.055.364.107.728.156 1.1a9.828 9.828 0 0 1 1.796.748c.274-.208.562-.425.877-.66a1.712 1.712 0 0 1 2.219.17l1.444 1.443c.594.602.66 1.546.157 2.223-.227.308-.45.605-.658.875a9.83 9.83 0 0 1 .749 1.798l1.093.153zm-1.446.807a.629.629 0 0 1-.542-.457 8.824 8.824 0 0 0-.82-1.986c-.14-.21-.14-.485.022-.727.26-.337.527-.69.798-1.058a.711.711 0 0 0-.062-.923L19.05 3.51a.71.71 0 0 0-.918-.074c-.384.287-.73.549-1.09.822a.62.62 0 0 1-.668.017 8.841 8.841 0 0 0-2.016-.838.623.623 0 0 1-.453-.527c-.057-.44-.119-.878-.184-1.311A.711.711 0 0 0 13.026 1H10.98a.711.711 0 0 0-.696.6c-.066.44-.127.878-.183 1.303a.629.629 0 0 1-.457.542 8.828 8.828 0 0 0-1.986.82c-.21.14-.485.14-.727-.022-.337-.26-.69-.527-1.055-.796a.712.712 0 0 0-.923.07L3.508 4.95a.711.711 0 0 0-.071.92c.27.367.537.72.82 1.088a.62.62 0 0 1 .017.668 8.872 8.872 0 0 0-.841 2.027.63.63 0 0 1-.52.441l-1.315.185a.711.711 0 0 0-.598.696v2.05a.71.71 0 0 0 .595.692l1.308.184a.629.629 0 0 1 .542.457c.195.703.477 1.38.82 1.986.14.21.14.485-.022.727-.26.337-.527.69-.798 1.058a.711.711 0 0 0 .062.923l1.442 1.44a.71.71 0 0 0 .918.074c.384-.287.73-.549 1.09-.822a.62.62 0 0 1 .668-.017 8.86 8.86 0 0 0 2.016.838c.248.07.429.285.453.527.057.44.119.878.184 1.311a.711.711 0 0 0 .696.598h2.05a.711.711 0 0 0 .693-.6c.066-.44.127-.878.184-1.315a.637.637 0 0 1 .456-.53 8.833 8.833 0 0 0 1.986-.82c.21-.14.485-.14.727.022.337.26.69.527 1.058.798.282.21.675.182.923-.062l1.44-1.442a.711.711 0 0 0 .072-.92 83.489 83.489 0 0 0-.82-1.088.62.62 0 0 1-.017-.668c.361-.634.642-1.31.841-2.027a.63.63 0 0 1 .52-.441l1.315-.185a.711.711 0 0 0 .598-.696V10.98a.712.712 0 0 0-.6-.696l-1.303-.183zM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-1 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0z"
        />
      </svg>`
  },
  share: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M.327 14.97a.484.484 0 0 1-.325-.514c.007-.09.021-.233.048-.433.045-.338.11-.714.197-1.117.25-1.153.634-2.306 1.184-3.387C2.951 6.533 5.423 4.67 9 4.511V1.5a.5.5 0 0 1 .838-.369l6 5.5a.5.5 0 0 1 0 .738l-6 5.5A.5.5 0 0 1 9 12.5V9.512c-2.408.116-4.405 1.07-6.03 2.6a10.847 10.847 0 0 0-1.538 1.806 7.226 7.226 0 0 0-.492.82.484.484 0 0 1-.613.231zm1.958-3.587C4.195 9.583 6.595 8.5 9.5 8.5a.5.5 0 0 1 .5.5v2.363L14.76 7 10 2.637V5a.5.5 0 0 1-.5.5c-3.44 0-5.747 1.663-7.178 4.473a12.563 12.563 0 0 0-.889 2.3c.262-.303.546-.6.852-.89z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M3.09 17.141C5.755 14.555 9.205 13 13.5 13a.5.5 0 0 1 .5.5v3.919l8.7-7.395L14 3.5v4a.5.5 0 0 1-.5.5c-5.262 0-8.706 2.505-10.737 6.717-.687 1.425-1.161 2.952-1.46 4.485.511-.705 1.105-1.4 1.786-2.061zm.696.718a14.683 14.683 0 0 0-2.169 2.66c-.2.315-.368.608-.505.869-.08.153-.131.26-.154.312-.221.506-.977.333-.958-.218.005-.12.019-.335.048-.633.05-.492.125-1.039.234-1.627.31-1.682.82-3.364 1.58-4.94C3.985 9.88 7.602 7.165 13 7.008V2.5a.5.5 0 0 1 .8-.4l10 7.5a.5.5 0 0 1 .024.781l-10 8.5A.5.5 0 0 1 13 18.5v-4.492c-3.786.115-6.83 1.538-9.214 3.851z"
        />
      </svg>`
  },
  sort: {
    16: () => html`
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 9H1L5 13L9 9Z" fill="#646464"/>
        <path d="M9 7H1L5 3L9 7Z" fill="#646464"/>
      </svg>
    `
  },
  sortAsc: {
    16: () => html`
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 10H1L5 6L9 10Z" fill="#121212"/>
      </svg>
    `
  },
  sortDesc: {
    16: () => html`
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 6H1L5 10L9 6Z" fill="#121212"/>
      </svg>
    `
  },
  user: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 14a5 5 0 0 0-4.995 4.783L7 19v2.8c1.5.768 3.2 1.2 5 1.2 1.8 0 3.5-.433 5-1.2V19a5 5 0 0 0-5-5zm0-13C5.925 1 1 5.925 1 12a10.99 10.99 0 0 0 5 9.222V19a6.002 6.002 0 0 1 3.874-5.612 4 4 0 1 1 4.252.001 6 6 0 0 1 3.87 5.386L18 19v2.22A10.99 10.99 0 0 0 23 12c0-6.075-4.925-11-11-11zm0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        />
      </svg>`
  },
  visibilityOff: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.854 2.146a.5.5 0 0 1 .057.638l-.057.07-19 19a.5.5 0 0 1-.765-.638l.057-.07 19-19a.5.5 0 0 1 .708 0zM19.81 7.883a23.502 23.502 0 0 1 3.514 3.15l.445.509.122.148a.5.5 0 0 1 .019.595l-.109.15-.113.15c-.177.23-.386.485-.625.76a19.34 19.34 0 0 1-2.374 2.293C18.108 17.736 15.191 19 12 19c-1.05 0-2.1-.167-3.148-.486a.5.5 0 1 1 .291-.956c.957.29 1.91.442 2.857.442 2.934 0 5.642-1.173 8.06-3.138a18.347 18.347 0 0 0 2.25-2.175l.316-.373.235-.296-.12-.138-.327-.36-.18-.191a22.51 22.51 0 0 0-3.01-2.636.5.5 0 1 1 .587-.81zM16 11.5a.5.5 0 0 1 .5.5 4.5 4.5 0 0 1-4.5 4.5.5.5 0 1 1 0-1 3.5 3.5 0 0 0 3.5-3.5.5.5 0 0 1 .5-.5zM12 5c.874 0 1.751.117 2.628.34a.5.5 0 1 1-.248.97A9.592 9.592 0 0 0 12 6C9.066 6 6.358 7.174 3.94 9.138a18.35 18.35 0 0 0-2.707 2.722l-.096.121.279.315.35.375a22.508 22.508 0 0 0 2.995 2.625.5.5 0 1 1-.587.81 23.5 23.5 0 0 1-3.666-3.324l-.4-.471a.5.5 0 0 1-.02-.595l.162-.22.06-.08c.178-.23.386-.485.625-.76A19.343 19.343 0 0 1 3.31 8.362C5.892 6.264 8.809 5 12 5zm0 2.5a.5.5 0 1 1 0 1A3.5 3.5 0 0 0 8.5 12a.5.5 0 1 1-1 0A4.5 4.5 0 0 1 12 7.5z"
        />
      </svg>`
  },
  visibilityOn: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 5c3.191 0 6.108 1.264 8.69 3.362.899.73 1.692 1.512 2.374 2.294.24.274.448.53.625.76l.222.3a.5.5 0 0 1 0 .569l-.222.3c-.177.23-.385.485-.625.76a19.342 19.342 0 0 1-2.374 2.293C18.108 17.736 15.191 19 12 19s-6.108-1.264-8.69-3.362a19.342 19.342 0 0 1-2.374-2.294c-.24-.274-.448-.53-.625-.76l-.222-.3a.5.5 0 0 1 .002-.572l.203-.275c.207-.272.482-.607.823-.986a19.306 19.306 0 0 1 2.412-2.265C6.063 6.191 8.905 5 12 5zm0 1C9.155 6 6.519 7.105 4.148 8.972a18.313 18.313 0 0 0-2.954 2.936L1.123 12l.11.14c.09.114.188.233.293.358l.163.19a18.35 18.35 0 0 0 2.251 2.175C6.358 16.827 9.066 18 12 18s5.642-1.173 8.06-3.138a18.35 18.35 0 0 0 2.566-2.548l.25-.314-.109-.14a17.84 17.84 0 0 0-.293-.357l-.163-.19a18.35 18.35 0 0 0-2.251-2.175C17.642 7.173 14.934 6 12 6zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        />
      </svg>`
  },
  back: {
    12: () => html` <svg viewBox="0 0 12 12">
        <rect width="12" height="12" rx="1" />
        <path
          d="M8.301 9.453a.75.75 0 1 1-1.056 1.065L3.222 6.533a.75.75 0 0 1 0-1.066l4.01-3.972A.75.75 0 0 1 8.288 2.56L4.816 6 8.3 9.453z"
        />
      </svg>`,
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M10.521 12.724A.75.75 0 0 1 9.46 13.78L4.22 8.517a.75.75 0 0 1 0-1.059l5.24-5.237a.75.75 0 0 1 1.06 1.06l-4.712 4.71 4.713 4.733z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16.788 20.741a.75.75 0 0 1-1.106 1.013L7.212 12.503a.75.75 0 0 1 0-1.013l8.47-9.243a.75.75 0 1 1 1.106 1.014l-8.006 8.736 8.006 8.745z"
        />
      </svg>`
  },
  backLast: {
    12: () => html` <svg viewBox="0 0 12 12">
        <path
          d="M9.843 1.472a.75.75 0 0 1-.005 1.06l-3.472 3.44L9.85 9.426a.75.75 0 0 1-1.056 1.066L4.772 6.505a.75.75 0 0 1 0-1.065l4.01-3.973a.75.75 0 0 1 1.061.005zM2.5 1.25a.75.75 0 0 1 .75.75v7.95a.75.75 0 1 1-1.5 0V2a.75.75 0 0 1 .75-.75z"
        />
      </svg>`
  },
  down: {
    12: () => html` <svg viewBox="0 0 12 12">
        <rect width="12" height="12" rx="1" />
        <path
          d="M2.554 3.703a.75.75 0 1 0-1.066 1.056l3.986 4.023a.75.75 0 0 0 1.065 0l3.973-4.01a.75.75 0 0 0-1.066-1.056l-3.44 3.472-3.452-3.485z"
        />
      </svg>`,
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M3.278 5.459A.75.75 0 0 0 2.221 6.52l5.263 5.24a.75.75 0 0 0 1.059 0l5.237-5.24a.75.75 0 0 0-1.06-1.06l-4.71 4.711L3.278 5.46z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M3.244 7.197a.75.75 0 1 0-1.013 1.106l9.252 8.47a.75.75 0 0 0 1.013 0l9.243-8.47a.75.75 0 1 0-1.013-1.106l-8.737 8.006-8.745-8.006z"
        />
      </svg>`
  },
  forward: {
    12: () => html` <svg viewBox="0 0 12 12">
        <rect width="12" height="12" rx="1" />
        <path
          d="M3.726 9.446a.75.75 0 1 0 1.055 1.066l4.024-3.986a.75.75 0 0 0 0-1.065l-4.01-3.973a.75.75 0 0 0-1.056 1.066l3.472 3.44-3.485 3.452z"
        />
      </svg>`,
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M4.849 12.723a.75.75 0 0 0 1.062 1.057l5.24-5.263a.75.75 0 0 0 0-1.059L5.91 2.22a.75.75 0 1 0-1.06 1.06l4.712 4.71-4.713 4.733z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m7.212 20.741a.75.75 0 0 0 1.106 1.013l8.47-9.252a.75.75 0 0 0 0-1.013l-8.47-9.243a.75.75 0 1 0-1.106 1.014l8.006 8.736-8.006 8.745z"
        />
      </svg>`
  },
  fowardLast: {
    12: () => html` <svg viewBox="0 0 12 12">
        <path
          d="M1.98 1.472a.75.75 0 0 0 .005 1.06l3.472 3.44-3.485 3.453a.75.75 0 0 0 1.056 1.066L7.05 6.505a.75.75 0 0 0 0-1.065L3.04 1.467a.75.75 0 0 0-1.06.005zm7.343-.222a.75.75 0 0 0-.75.75v7.95a.75.75 0 1 0 1.5 0V2a.75.75 0 0 0-.75-.75z"
        />
      </svg>`
  },
  up: {
    12: () => html` <svg viewBox="0 0 12 12">
        <rect width="12" height="12" rx="1" />
        <path
          d="M2.554 8.305a.75.75 0 1 1-1.066-1.056l3.986-4.023a.75.75 0 0 1 1.065 0l3.973 4.01a.75.75 0 0 1-1.066 1.056l-3.44-3.473-3.452 3.486z"
        />
      </svg>`,
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M3.278 11.559a.75.75 0 0 1-1.057-1.063l5.263-5.24a.75.75 0 0 1 1.059.001l5.238 5.24a.75.75 0 0 1-1.06 1.06L8.01 6.846l-4.733 4.713z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M20.726 16.786a.75.75 0 1 0 1.013-1.107l-9.252-8.47a.75.75 0 0 0-1.013 0L2.23 15.68a.75.75 0 1 0 1.013 1.106L11.98 8.78l8.745 8.007z"
        />
      </svg>`
  },
  audioTour: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 0a7 7 0 0 1 6.77 8.783 2.492 2.492 0 0 1 1.084 2.764l-.69 2.575a2.502 2.502 0 0 1-3.062 1.768l-1.931-.518a.5.5 0 0 1-.354-.612l1.725-6.44a.5.5 0 0 1 .613-.353l1.677.449a6 6 0 1 0-11.665-.002l1.667-.447a.5.5 0 0 1 .613.354l1.725 6.44a.5.5 0 0 1-.353.611l-1.932.518a2.502 2.502 0 0 1-3.062-1.768l-.69-2.575a2.496 2.496 0 0 1 1.094-2.772A7 7 0 0 1 8 0zM3.61 9.062l-1.449.389a1.494 1.494 0 0 0-1.091 1.695l.03.142.69 2.575a1.502 1.502 0 0 0 1.838 1.061l1.448-.389L3.61 9.062zm8.77 0-1.467 5.473 1.448.39a1.502 1.502 0 0 0 1.837-1.062l.69-2.575.031-.142a1.495 1.495 0 0 0-1.091-1.695l-1.448-.389z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 1c5.523 0 10 4.477 10 10 0 .476-.033.948-.1 1.413a3.502 3.502 0 0 1 1.99 4.117l-1.035 3.863a3.504 3.504 0 0 1-4.287 2.476l-2.897-.777a.5.5 0 0 1-.354-.612l2.588-9.66a.5.5 0 0 1 .613-.353l2.414.647a9 9 0 1 0-17.862.009l2.446-.656a.5.5 0 0 1 .613.354l2.588 9.659a.5.5 0 0 1-.354.612l-2.898.777a3.504 3.504 0 0 1-4.286-2.476L.144 16.53a3.504 3.504 0 0 1 1.959-4.105A9.772 9.772 0 0 1 2 11C2 5.477 6.477 1 12 1zM5.291 12.563l-2.414.646a2.503 2.503 0 0 0-1.805 2.903l.038.16 1.035 3.863a2.504 2.504 0 0 0 3.062 1.768l2.414-.647-2.33-8.693zm13.452 0-2.33 8.693 2.414.647a2.504 2.504 0 0 0 3.062-1.768l1.035-3.863.038-.16a2.503 2.503 0 0 0-1.805-2.903l-2.414-.646z"
        />
      </svg>`
  },
  camping: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M9.757.071a.5.5 0 0 1 .211.605l-.04.081L8.584 3l7.346 12.244a.5.5 0 0 1-.342.75L15.5 16H.5a.5.5 0 0 1-.467-.679l.038-.078L7.417 2.999 6.071.757A.5.5 0 0 1 6.17.124l.073-.053a.5.5 0 0 1 .633.099l.053.073L8 2.028 9.071.243A.5.5 0 0 1 9.757.07zM9.817 7H6.181l-4.799 7.999h3.731l.736-2.793a.5.5 0 0 1 .064-.146l.05-.063 1.666-1.833a.5.5 0 0 1 .669-.065l.071.065 1.667 1.833a.5.5 0 0 1 .087.134l.026.075.735 2.793h3.731l-4.8-8zm-1.818 4.243-1.214 1.336-.637 2.42h3.703l-.637-2.42-1.215-1.336zM8 3.971 6.782 6h2.434L8 3.97z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13.746.065a.5.5 0 0 1 .226.599l-.037.082-1.362 2.407 11.362 20.101a.5.5 0 0 1-.35.739L23.5 24H.5a.5.5 0 0 1-.471-.668l.036-.078 11.36-20.101-1.36-2.407a.5.5 0 0 1 .114-.63l.074-.051a.5.5 0 0 1 .63.115l.052.074 1.064 1.883L13.064.254a.5.5 0 0 1 .682-.19zM16.989 13H7.01L1.356 23h6.731l.922-4.598a.5.5 0 0 1 .114-.232l.064-.06 2.5-2a.5.5 0 0 1 .542-.054l.082.054 2.5 2a.5.5 0 0 1 .154.208l.024.084.92 4.598h6.732l-5.653-10zM12 17.14l-2.046 1.636L9.109 23h5.78l-.844-4.224L12 17.14zM15.293 10h-6.59l-1.13 2h8.85l-1.13-2zM12 4.17 9.269 9h5.46l-2.73-4.83z"
        />
      </svg>`
  },
  concession: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M15.5 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-.541l-.961 11.542-.015.083A.5.5 0 0 1 13.5 15h-1.767c-.345.598-.99 1-1.73 1H2.998A1.995 1.995 0 0 1 1 14v-1.086a1.515 1.515 0 0 1-.992-1.268L0 11.5c0-.646.414-1.198.988-1.409a3.984 3.984 0 0 1 .514-1.836c.681-1.212 1.967-2 3.937-2.203L5.058 3H4.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h11zm-4.501 13h-9L2 14c0 .516.383.936.88.993l.117.007h7.006A1 1 0 0 0 11 14l-.001-1zm2.957-10h-7.89l.375 3.001L6.5 6c2.475 0 4.07.772 4.899 2.088l.1.167c.35.624.496 1.263.513 1.836.576.207.988.758.988 1.409 0 .65-.42 1.205-1 1.413v1.086l1.04.001.916-11zm-2.458 8H1.502c-.273 0-.502.227-.503.471l.004.089a.5.5 0 0 0 .5.44h9.995a.499.499 0 1 0 0-1zM6.5 7c-2.235 0-3.518.662-4.127 1.745-.213.38-.326.774-.367 1.137L1.995 10h9.009l-.01-.118a3.03 3.03 0 0 0-.269-.946l-.098-.19C10.017 7.661 8.735 7 6.5 7zM15 1H5.001v1H15V1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m21.923.234.041.08.026.087a.5.5 0 0 1-.224.522l-.08.041-2.238.895-.358 2.14L23.5 4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-.534l-.968 14.533-.013.085a.5.5 0 0 1-.4.375l-.086.007H17c0 1.055-.81 1.918-1.844 1.995l-.15.005H2.994a1.992 1.992 0 0 1-1.988-1.85L1 22v-1.27a2.01 2.01 0 0 1-.971-1.402l-.022-.168L0 19c0-.746.405-1.394 1.01-1.738.022-.294.077-.659.179-1.068a6.73 6.73 0 0 1 .974-2.188C3.461 12.116 5.691 11 9 11c1.262 0 2.366.162 3.32.466L12.03 7h-.53a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h6.576l.43-2.582.022-.084a.5.5 0 0 1 .21-.26l.076-.038 2.5-1 .087-.026a.5.5 0 0 1 .522.224zM16 21H2v1c0 .477.325.87.765.974l.112.02.116.006h12.014c.511 0 .93-.384.986-.883L16 22l-.001-1zm5.965-14h-8.933l.317 4.868a6.378 6.378 0 0 1 2.638 2.367 6.8 6.8 0 0 1 .886 2.226c.068.327.104.605.12.817v-.014c.602.344 1.008.99 1.008 1.736 0 .742-.4 1.387-1 1.732L17 21h4.033l.932-14zm-5.973 11H2.01a1 1 0 0 0-1.003.865L1 18.978l.005.114a1 1 0 0 0 .885.901l.12.007h13.98a1 1 0 1 0 0-2zM9 12c-2.987 0-4.905.96-6.012 2.572a5.722 5.722 0 0 0-.885 2.06l-.044.24-.018.128h13.912l-.06-.336a5.813 5.813 0 0 0-.754-1.899C14.059 13.039 12.112 12 9 12zm-3.5 3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm4 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm-2-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm10.958-9.002L12.001 5v1H23V4.999h-4.534l-.008-.001z"
        />
      </svg>`
  },
  lawnChair: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m3.182 1.245 1.084 5.45 8.312-.684h.09a.502.502 0 0 1 .455.456.501.501 0 0 1-.461.54l-1.448.118 1.03 2.165 2.057-.188a1.551 1.551 0 0 1 1.687 1.34 1.48 1.48 0 0 1-1.155 1.627l-.184.029-1.025.096 1.472 3.094.03.084a.498.498 0 0 1-.272.58.507.507 0 0 1-.672-.239l-1.625-3.417-8.142.775a2.55 2.55 0 0 1-.693-.028l-1.784 2.729-.056.07a.509.509 0 0 1-.642.078.496.496 0 0 1-.15-.691l1.68-2.568a2.49 2.49 0 0 1-1.087-1.668l-.508-3.04-.628.052H.456a.502.502 0 0 1-.454-.456.501.501 0 0 1 .46-.54l.547-.045-.87-5.203-.017-.145A1.517 1.517 0 0 1 1.397.021a1.557 1.557 0 0 1 1.785 1.224zm8.45 9.105-6.169.569c-.117.01-.233.008-.346-.008l-.761 1.161 7.744-.736-.468-.986zM3.449 7.766l-1.265.104.495 2.96c.07.418.31.768.639.992l.897-1.373a1.488 1.488 0 0 1-.378-.733l-.388-1.95zm10.946 2.33-1.694.156.467.982 1.398-.132a.48.48 0 0 0 .42-.535.544.544 0 0 0-.591-.47zM10.14 7.214l-2.757.227-1.598 2.444 5.388-.496-1.03-2.168-.003-.007zm-4.028.332-1.651.136.364 1.833 1.287-1.969zM1.659.999l-.125.012a.511.511 0 0 0-.399.587l.884 5.283 1.234-.102-1.062-5.341A.548.548 0 0 0 1.66.999z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m5.254 1.898 1.623 8.39 11.568-1.285.09-.002a.5.5 0 0 1 .02.996l-2.392.265 1.872 4.213 3.377-.326a2.129 2.129 0 0 1 2.305 1.769 1.936 1.936 0 0 1-1.591 2.227l-.11.016-2.235.241 2.176 4.895.029.085a.5.5 0 0 1-.943.321l-2.306-5.189L6.864 19.8a2.49 2.49 0 0 1-1.356-.235l-2.582 4.198-.054.072a.5.5 0 0 1-.798-.596l2.636-4.283a2.49 2.49 0 0 1-.57-1.177l-1.146-6.053-2.439.272-.09.002a.5.5 0 0 1-.02-.996l2.363-.264-1.543-8.152a1.988 1.988 0 0 1 1.44-2.29l.187-.04a2.06 2.06 0 0 1 2.362 1.641zm12.161 13.641-8.988.871a1.495 1.495 0 0 1-.868-.179l-1.522 2.474c.221.09.467.127.72.1l11.553-1.252-.895-2.014zM6.071 11.383l-2.081.231 1.132 5.978c.03.157.083.305.156.439l1.597-2.595a1.507 1.507 0 0 1-.065-.234l-.739-3.819zm15.437 3.761-3.045.294.89 2.002 2.608-.281a.936.936 0 0 0 .77-1.077 1.129 1.129 0 0 0-1.223-.938zm-6.387-4.766-4.251.472-2.785 4.526c.075.033.16.047.246.039l8.656-.839-1.866-4.198zm-5.51.612-2.544.282.567 2.93 1.977-3.212zM3.169 1.23l-.134.017a.988.988 0 0 0-.787 1.154l1.556 8.228 2.076-.23-1.608-8.311a1.061 1.061 0 0 0-1.103-.858z"
        />
      </svg>`
  },
  meal: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m9.5 0 .149.005C11.78.135 14 3.045 14 7v3.5a.5.5 0 0 1-.5.5h-1.501L12 14.5a1.5 1.5 0 0 1-2.994.13L9 14.493V.5a.5.5 0 0 1 .5-.5zm-3 0a.5.5 0 0 1 .492.41L7 .5v2.995A2.499 2.499 0 0 1 5 5.95L4.999 10H5.5a.5.5 0 0 1 .492.41L6 10.5v4c0 .831-.67 1.5-1.5 1.5-.831 0-1.5-.67-1.5-1.5v-4a.5.5 0 0 1 .5-.5h.499V5.95a2.501 2.501 0 0 1-1.994-2.29L2 3.495V.5a.5.5 0 0 1 .992-.09L3 .5v2.995a1.5 1.5 0 0 0 2.994.138L6 3.495V.5a.5.5 0 0 1 .5-.5zm4.499 11h-1L10 14.493a.501.501 0 0 0 .992.098L11 14.5l-.001-3.5zM5 11h-.49a.51.51 0 0 1-.01 0l-.011-.001H4V14.5c0 .247.175.45.41.492L4.5 15c.278 0 .5-.222.5-.5V11zm5-9.921V10h2.999L13 7c0-3.157-1.54-5.455-2.982-5.915L10 1.079zM4.5 0a.5.5 0 0 1 .492.41L5 .5v3a.5.5 0 0 1-.992.09L4 3.5v-3a.5.5 0 0 1 .5-.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M10.5 0a.5.5 0 0 1 .492.41L11 .5v4.491A4.01 4.01 0 0 1 7.5 8.97L7.499 15H8.5a.5.5 0 0 1 .492.41L9 15.5v6.495a1.999 1.999 0 1 1-4 0V15.5a.5.5 0 0 1 .5-.5h.999V8.969a3.999 3.999 0 0 1-3.494-3.777L3 4.992V.5a.5.5 0 0 1 .992-.09L4 .5v4.491A2.998 2.998 0 0 0 7 8a3.007 3.007 0 0 0 2.995-2.832L10 4.99V.5a.5.5 0 0 1 .5-.5zm5 0C18.344 0 21 4.384 21 10.5v5a.5.5 0 0 1-.5.5h-1.501L19 21.995a2 2 0 0 1-1.87 2l-.152.005-.16-.008A1.999 1.999 0 0 1 15 21.995V.5a.5.5 0 0 1 .5-.5zM18 16h-2.001L16 21.995a1 1 0 0 0 .773.982l.112.017L17 23c.554 0 1-.446 1-1.005V16zM7.999 16h-2L6 21.995c0 .518.383.94.883.998L7 23c.554 0 1-.446 1-1.005L7.999 16zM16 1.068v13.931L20 15v-4.5c0-5.185-1.982-8.87-3.98-9.427L16 1.068zM7 0a.5.5 0 0 1 .492.41L7.5.5v5a.5.5 0 0 1-.992.09L6.5 5.5v-5A.5.5 0 0 1 7 0z"
        />
      </svg>`
  },
  merchandise: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m10.5 0 .121.015 4 1 .08.027a.5.5 0 0 1 .292.376l1 6 .007.09a.5.5 0 0 1-.342.466L13 8.86v6.64l-.008.09a.5.5 0 0 1-.492.41h-9l-.09-.008A.5.5 0 0 1 3 15.5l-.001-6.64-2.657-.886-.083-.036a.5.5 0 0 1-.252-.52l1-6 .02-.082a.5.5 0 0 1 .352-.321l4-1L5.5 0h5zm.954 1.253a4.08 4.08 0 0 1-.607 1.284C10.212 3.445 9.267 4 8 4s-2.212-.555-2.847-1.463a4.08 4.08 0 0 1-.607-1.284l-2.606.652-.876 5.255L3 7.805V5.5l.008-.09A.5.5 0 0 1 3.5 5l.09.008A.5.5 0 0 1 4 5.5V15h8V5.5l.008-.09A.5.5 0 0 1 12.5 5l.09.008A.5.5 0 0 1 13 5.5v2.306l1.937-.646-.876-5.255zM10.44 1H5.562l-.044.01.014.048.055.16c.093.255.22.51.385.745C6.43 2.618 7.08 3 8 3c.92 0 1.57-.382 2.028-1.037a3.258 3.258 0 0 0 .459-.97l-.006.017-.042-.01z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m15.5 0 .158.026 6 2 .078.033a.5.5 0 0 1 .25.32l2 8 .013.092a.5.5 0 0 1-.4.52l-4.6.919L19 23.5l-.008.09a.5.5 0 0 1-.492.41h-13l-.09-.008A.5.5 0 0 1 5 23.5V11.91l-4.598-.92-.09-.026a.5.5 0 0 1-.297-.585l2-8 .027-.08a.5.5 0 0 1 .3-.273l6-2L8.5 0h7zm.946 1.34a5.251 5.251 0 0 1-.713 1.68C14.943 4.25 13.711 5 12 5c-1.711 0-2.942-.75-3.733-1.98a5.252 5.252 0 0 1-.713-1.679L2.92 2.887l-1.806 7.225L5 10.889V7.5l.008-.09A.5.5 0 0 1 5.5 7l.09.008A.5.5 0 0 1 6 7.5V23h12V7.5l.008-.09A.5.5 0 0 1 19 7.5v3.389l3.888-.777-1.806-7.225zM15.42 1H8.581l-.07.021a4.417 4.417 0 0 0 .597 1.458C9.724 3.438 10.648 4 12 4c1.352 0 2.276-.563 2.892-1.52a4.417 4.417 0 0 0 .587-1.412l.008-.046L15.42 1z"
        />
      </svg>`
  },
  parking: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm.5 3C9.883 4 11 5.114 11 6.5 11 7.883 9.886 9 8.5 9H7v3.5a.5.5 0 0 1-.41.492L6.5 13a.5.5 0 0 1-.5-.5V8.51a.51.51 0 0 1 0-.01v-4a.5.5 0 0 1 .5-.5h2zm0 1L7 4.999v3L8.5 8c.833 0 1.5-.669 1.5-1.5C10 5.667 9.331 5 8.5 5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1.49 5A3.51 3.51 0 0 1 17 9.51v.98A3.51 3.51 0 0 1 13.49 14L10 13.999V18.5a.5.5 0 0 1-.41.492L9.5 19a.5.5 0 0 1-.5-.5v-4.994a.51.51 0 0 1 0-.006v-7a.5.5 0 0 1 .5-.5h3.99zm0 1L10 6.999v6l3.49.001A2.51 2.51 0 0 0 16 10.49v-.98A2.51 2.51 0 0 0 13.49 7z"
        />
      </svg>`
  },
  reservedLawn: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M13.5 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H10v4.573l1.11-1.385a.5.5 0 0 1 .83.55l-.05.074-1.244 1.555 2.63-1.314a.5.5 0 0 1 .524.847l-.076.047L11.617 15H15.5a.5.5 0 0 1 .09.992L15.5 16H.5a.5.5 0 0 1-.09-.992L.5 15h3.882l-2.106-1.053a.5.5 0 0 1 .364-.927l.084.033 2.314 1.156-.954-1.432a.5.5 0 0 1 .775-.625l.057.07L6 13.849V9H2.5a.5.5 0 0 1-.492-.41L2 8.5v-8a.5.5 0 0 1 .5-.5zM9 9H7v6h2V9zm4-8H3v7h10V1zM9.5 5l.09.008A.5.5 0 0 1 9.5 6h-3l-.09-.008A.5.5 0 0 1 6.5 5h3zm1-2 .09.008A.5.5 0 0 1 10.5 4h-5l-.09-.008A.5.5 0 0 1 5.5 3h5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M20.5 0a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-6.501v7.848l1.085-1.625a.5.5 0 0 1 .875.475l-.043.08-1.714 2.57L17.2 20.1a.5.5 0 0 1 .667.74l-.067.06-2.801 2.1H23.5a.5.5 0 0 1 .09.992L23.5 24H.5a.5.5 0 0 1-.09-.992L.5 23H9l-2.8-2.1a.5.5 0 0 1 .523-.847l.077.047 2.997 2.248-1.713-2.57a.5.5 0 0 1 .775-.626l.057.07 1.083 1.625V13H3.5a.5.5 0 0 1-.492-.41L3 12.5V.5a.5.5 0 0 1 .5-.5zm-7.501 13h-2l.002 9.999H13L12.999 13zM20 1H4v11h16V1zm-4.5 7 .09.008A.5.5 0 0 1 15.5 9h-7l-.09-.008A.5.5 0 0 1 8.5 8h7zm2-4 .09.008A.5.5 0 0 1 17.5 5h-11l-.09-.008A.5.5 0 0 1 6.5 4h11z"
        />
      </svg>`
  },
  room: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M1.5 2A1.5 1.5 0 0 1 3 3.5V6h2.5a2.5 2.5 0 0 1 2.45 2H13v-.5a1.5 1.5 0 0 1 1.356-1.493L14.5 6A1.5 1.5 0 0 1 16 7.5v6a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V12H3v1.5a.5.5 0 0 1-.41.492L2.5 14h-2a.5.5 0 0 1-.5-.5v-10A1.5 1.5 0 0 1 1.5 2zm0 1a.5.5 0 0 0-.5.5V13h1V3.5a.5.5 0 0 0-.41-.492zm13 4a.5.5 0 0 0-.5.5V13h1V7.5a.5.5 0 0 0-.41-.492zM13 9H3v2h10V9zM5.5 7H3v1h3.913l-.018-.052a1.501 1.501 0 0 0-1.25-.941L5.5 7z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M2 3a2 2 0 0 1 2 2v4h5.5a2.5 2.5 0 0 1 2.495 2.336L12 11.5l-.001.5h8L20 11a2 2 0 0 1 1.85-1.995L22 9a2 2 0 0 1 2 2v9.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5l-.001-2.5H4v2.5a.5.5 0 0 1-.41.492L3.5 21h-3a.5.5 0 0 1-.5-.5V5a2 2 0 0 1 2-2zm20 7a1 1 0 0 0-1 1l-.001 1.49.001.01v5a.51.51 0 0 1 0 .01L20.999 20h2L23 11a1 1 0 0 0-.883-.993zM2 4a1 1 0 0 0-1 1L.999 19.999h2L3 9.5a.51.51 0 0 1 0-.007V5a1 1 0 0 0-.883-.993zm17.999 9-8.49-.001L11.5 13H4v3.999L19.999 17v-4zM4 9.999v2h6.999L11 11.5a1.5 1.5 0 0 0-1.356-1.493L9.5 10 4 9.999z"
        />
      </svg>`
  },
  specialEntry: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M1 4.5a2.5 2.5 0 1 1 3.087-.068C4.983 5.478 6.273 6 8 6c1.747 0 3.048-.516 3.945-1.544A2.5 2.5 0 1 1 15 4.5V13h.5a.5.5 0 0 1 .492.41l.008.09v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h.5V5.779C10.969 6.593 9.628 7 8 7c-1.627 0-2.967-.42-4-1.26V13h.5a.5.5 0 0 1 .492.41L5 13.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5H1zM15 14h-3v1h3v-1zM4 14H1v1h3v-1zm9.472-9H13v8h1V5l-.473-.001L13.5 5h-.028zM3 5l-.473-.001L2.5 5H2v8h1V5zm10.5-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M20 0a4 4 0 0 1 1.997 7.467L22 7.5V20h1.5a.5.5 0 0 1 .492.41l.008.09v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H18v-9.254C15.87 11.58 13.87 12 12 12s-3.87-.42-6-1.254V20h1.5a.5.5 0 0 1 .492.41L8 20.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H2V7.5l.001-.035a4 4 0 1 1 4.189-.117C7.992 8.45 9.926 9 12 9c2.074 0 4.008-.55 5.81-1.652A4 4 0 0 1 20 0zm3 21h-6v2h6v-2zM2.49 21H.999v2h6v-2l-1.489-.001L5.5 21h-3a.51.51 0 0 1-.01 0zM21 8h-2v12h2V8zM3.96 8l-.961-.001v12h2v-12H4.04L4 8h-.04zM12 10c-2.133 0-4.136-.535-6-1.603v1.269l.15.063C8.25 10.578 10.2 11 12 11c1.842 0 3.842-.443 6-1.332V8.397A11.887 11.887 0 0 1 12 10zM4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm16 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        />
      </svg>`
  },
  vip: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m5.016 4.872-4.584.633-.084.018A.5.5 0 0 0 .1 6.3l2.869 3.824-.96 5.287-.01.08a.5.5 0 0 0 .73.453L8 13.23l5.271 2.715.074.032a.5.5 0 0 0 .647-.565l-.962-5.286L15.9 6.3l.046-.072a.5.5 0 0 0-.378-.723l-4.585-.633L8.438.258a.5.5 0 0 0-.876 0L5.016 4.872zM8 1.534l2.229 4.04.053.078a.5.5 0 0 0 .316.177l3.992.55L12.1 9.7l-.044.07a.5.5 0 0 0-.048.32l.818 4.501-4.597-2.369-.089-.035a.5.5 0 0 0-.369.035l-4.598 2.369.819-4.502.008-.082a.5.5 0 0 0-.1-.307L1.409 6.379l3.993-.55a.5.5 0 0 0 .37-.254L8 1.534z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m7.679 7.538-7.245.966-.086.02a.5.5 0 0 0-.232.796l4.84 5.809-1.943 8.256-.012.083a.5.5 0 0 0 .733.474L12 19.565l8.266 4.377.077.033a.5.5 0 0 0 .644-.59l-1.944-8.256 4.841-5.809.05-.072a.5.5 0 0 0-.368-.744l-7.246-.966L12.441.265a.5.5 0 0 0-.882 0l-3.88 7.273zM12 1.563l3.559 6.672.053.08a.5.5 0 0 0 .322.18l6.601.88-4.42 5.305-.052.077a.5.5 0 0 0-.05.358l1.748 7.428-7.527-3.985-.09-.037a.5.5 0 0 0-.378.037l-7.528 3.985 1.749-7.428.013-.093a.5.5 0 0 0-.116-.342l-4.42-5.305 6.602-.88a.5.5 0 0 0 .375-.26L12 1.563z"
        />
      </svg>`
  },
  calendar: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path fill-rule="evenodd" d="M3.333 7.5H7v3.667H3.333V7.5Zm1 1v1.667H6V8.5H4.333Z" clip-rule="evenodd" />
        <path
          fill-rule="evenodd"
          d="M6.333 2V.667h-1V2H1.167v13.333h11.352l3.314-3.261V2h-4.166V.667h-1V2H6.333Zm4.334 2.333V3H6.333v1.333h-1V3H2.167v2.167h12.666V3h-3.166v1.333h-1Zm4.166 1.834H2.167v8.166h9.943-.387v-3.11h3.11V6.167Zm-.464 5.943H12.61v1.731l1.759-1.731Z"
          clip-rule="evenodd"
        />
      </svg>`
  },
  camera: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M10 1c1.145 0 1.794.55 2.325 1.926l.027.073L14.506 3c.768 0 1.414.596 1.487 1.352l.007.144v9.008c0 .828-.676 1.496-1.507 1.496H1.507A1.5 1.5 0 0 1 0 13.504V4.496C0 3.669.668 3 1.494 3l2.153-.001.028-.073c.505-1.31 1.118-1.872 2.165-1.922L6 1zm0 1H6c-.746 0-1.086.34-1.526 1.658A.5.5 0 0 1 4 4H1.494A.494.494 0 0 0 1 4.496v9.008a.5.5 0 0 0 .507.496h12.986a.501.501 0 0 0 .507-.496V4.496A.503.503 0 0 0 14.506 4H12a.5.5 0 0 1-.474-.342C11.086 2.341 10.746 2 10 2zM8 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.5-2a.5.5 0 0 1 .09.992L13.5 6h-2a.5.5 0 0 1-.09-.992L11.5 5h2z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M15 2c1.629 0 2.53.784 3.299 2.844l.056.156h3.144a2.498 2.498 0 0 1 2.496 2.33l.005.164v12.012A2.499 2.499 0 0 1 21.5 22h-19A2.501 2.501 0 0 1 0 19.506V7.494A2.499 2.499 0 0 1 2.501 5h3.143l.057-.156c.74-1.98 1.601-2.782 3.114-2.84L9 2zm0 1H9c-1.246 0-1.836.59-2.526 2.658A.5.5 0 0 1 6 6H2.501C1.672 6 1 6.67 1 7.494v12.012C1 20.328 1.675 21 2.5 21h19c.828 0 1.5-.67 1.5-1.494V7.494C23 6.67 22.328 6 21.499 6H18a.5.5 0 0 1-.474-.342C16.836 3.591 16.246 3 15 3zm-3 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm8.5-1a.5.5 0 0 1 .09.992L20.5 9h-3a.5.5 0 0 1-.09-.992L17.5 8h3z"
        />
      </svg>`
  },
  continuous: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m8.352 4.978-.076-.03-3-1.5a.5.5 0 0 1 .363-.928l.084.033 1.911.955-.5-.77a3.693 3.693 0 0 0-6.212.03.5.5 0 1 1-.844-.536 4.693 4.693 0 0 1 7.766-.226l.128.187.323.497.212-1.272A.5.5 0 0 1 8.992 1l.09.007a.5.5 0 0 1 .418.485l-.007.09-.5 3a.5.5 0 0 1-.64.396zM9.65 11.3l-.154-.13-.33-.298a.5.5 0 0 1 .596-.798l.072.054.331.298a2.484 2.484 0 0 0 3.47-.144 2.6 2.6 0 0 0 0-3.564l-.095-.097a2.247 2.247 0 0 0-3.05-.027l-.126.124-4 4.25-.139.139a3.246 3.246 0 0 1-4.59-.14 3.6 3.6 0 0 1 0-4.935A3.484 3.484 0 0 1 6.35 5.7l.154.13.33.298a.5.5 0 0 1-.596.798l-.072-.054-.331-.298a2.484 2.484 0 0 0-3.47.144 2.6 2.6 0 0 0 0 3.564c.85.904 2.271.947 3.175.097l.096-.097 4-4.25a3.246 3.246 0 0 1 4.589-.139l.14.14a3.6 3.6 0 0 1 0 4.935 3.484 3.484 0 0 1-4.715.332zm-1.852 3.197-.183-.175-.469-.468a.5.5 0 0 1 .638-.765l.07.057.468.47a4.533 4.533 0 0 0 6.783-.423.5.5 0 1 1 .79.614 5.533 5.533 0 0 1-8.097.69z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m12.807 6.962-.073-.038-4-2.5a.5.5 0 0 1 .45-.889l.08.04 2.494 1.56-.476-.953a5.644 5.644 0 0 0-10.315.497.5.5 0 0 1-.934-.358 6.644 6.644 0 0 1 12.03-.803l.113.216.533 1.065.294-2.361A.5.5 0 0 1 13.471 2l.09.003a.5.5 0 0 1 .438.468l-.003.09-.5 4a.5.5 0 0 1-.689.4zm1.13 8.675-.18-.174-.61-.61a.5.5 0 0 1 .637-.764l.07.057.61.61a4.493 4.493 0 0 0 6.447-.098 3.92 3.92 0 0 0-.225-5.54l-.13-.116a4.095 4.095 0 0 0-5.627.319l-.144.162-4.806 5.68a5.095 5.095 0 0 1-7.625.172 4.92 4.92 0 0 1 .282-6.953 5.493 5.493 0 0 1 7.426-.019l.182.174.61.61a.5.5 0 0 1-.638.764l-.07-.057-.61-.61a4.493 4.493 0 0 0-6.222-.126 3.92 3.92 0 0 0 0 5.764 4.095 4.095 0 0 0 5.786-.234l.115-.131 4.806-5.68a5.095 5.095 0 0 1 7.18-.598l.163.143a4.92 4.92 0 0 1 0 7.236 5.493 5.493 0 0 1-7.426.019zM11.74 21.51l-.187-.202-.425-.474a.5.5 0 0 1 .678-.73l.066.062.426.475a7.01 7.01 0 0 0 10.804-.443.5.5 0 1 1 .796.604 8.01 8.01 0 0 1-12.158.708z"
        />
      </svg>`
  },
  default: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M14.5 11a.5.5 0 0 1 .492.41l.008.09v2a1.5 1.5 0 0 1-1.356 1.493L13.5 15h-4a.5.5 0 0 1-.09-.992L9.5 14h4a.5.5 0 0 0 .492-.41L14 13.5v-2a.5.5 0 0 1 .5-.5zm-13 0a.5.5 0 0 1 .492.41L2 11.5v2a.5.5 0 0 0 .41.492L2.5 14h4a.5.5 0 0 1 .09.992L6.5 15h-4a1.5 1.5 0 0 1-1.493-1.356L1 13.5v-2a.5.5 0 0 1 .5-.5zm14-4a.5.5 0 0 1 .09.992L15.5 8H.5a.5.5 0 0 1-.09-.992L.5 7h15zm-2-6a1.5 1.5 0 0 1 1.493 1.356L15 2.5v2a.5.5 0 0 1-.992.09L14 4.5v-2a.5.5 0 0 0-.41-.492L13.5 2h-4a.5.5 0 0 1-.09-.992L9.5 1h4zm-7 0a.5.5 0 0 1 .09.992L6.5 2h-4a.5.5 0 0 0-.492.41L2 2.5v2a.5.5 0 0 1-.992.09L1 4.5v-2a1.5 1.5 0 0 1 1.356-1.493L2.5 1h4z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 16a.5.5 0 0 1 .492.41l.008.09V20a2 2 0 0 1-1.85 1.995L20 22h-5.5a.5.5 0 0 1-.09-.992L14.5 21H20a1 1 0 0 0 .993-.883L21 20v-3.5a.5.5 0 0 1 .5-.5zm-19 0a.5.5 0 0 1 .492.41L3 16.5V20a1 1 0 0 0 .883.993L4 21h5.5a.5.5 0 0 1 .09.992L9.5 22H4a2 2 0 0 1-1.995-1.85L2 20v-3.5a.5.5 0 0 1 .5-.5zm21-5a.5.5 0 0 1 .09.992L23.5 12H.5a.5.5 0 0 1-.09-.992L.5 11h23zM20 2a2 2 0 0 1 1.995 1.85L22 4v3.5a.5.5 0 0 1-.992.09L21 7.5V4a1 1 0 0 0-.883-.993L20 3h-5.5a.5.5 0 0 1-.09-.992L14.5 2H20zM9.5 2a.5.5 0 0 1 .09.992L9.5 3H4a1 1 0 0 0-.993.883L3 4v3.5a.5.5 0 0 1-.992.09L2 7.5V4a2 2 0 0 1 1.85-1.995L4 2h5.5z"
        />
      </svg>`
  },
  manual: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M16 12.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5zm-15 0a.5.5 0 0 0 .5.5H3v-2H1zm11 .5v-2H4v2h8zm2.5 0a.5.5 0 0 0 .5-.5V11h-2v2zm.5-3V8h-2v2h2zM1 10h2V8H1v2zm11-2h-2v2h2V8zM9 8H7v2h2V8zM6 8H4v2h2V8zm9-1V5h-2v2h2zM1 7h2V5H1v2zm11-2h-2v2h2V5zM9 5H7v2h2V5zM6 5H4v2h2V5zm8.5-2h-13a.5.5 0 0 0-.5.5V4h14v-.5a.5.5 0 0 0-.41-.492L14.5 3z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M24 18.5a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 18.5v-13A1.5 1.5 0 0 1 1.5 4h21A1.5 1.5 0 0 1 24 5.5zm-23 0a.5.5 0 0 0 .5.5H4v-2H1zM16 17H5v2h11v-2zm4 0h-3v2h3v-2zm3 0h-2v2h1.5a.5.5 0 0 0 .492-.41L23 18.5V17zm0-1v-3h-2v3h2zM1 16h3v-3H1v3zm19-3h-3v3h3v-3zm-4 0h-3v3h3v-3zm-4 0H9v3h3v-3zm-4 0H5v3h3v-3zm15-1V9h-2v3h2zM1 12h3V9H1v3zm19-3h-3v3h3V9zm-4 0h-3v3h3V9zm-4 0H9v3h3V9zM8 9H5v3h3V9zm14.5-4h-21a.5.5 0 0 0-.5.5V8h22V5.5a.5.5 0 0 0-.41-.492L22.5 5z"
        />
      </svg>`
  },
  faq: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16.5 9a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm-2-9A2.5 2.5 0 0 1 17 2.5v4a.5.5 0 1 1-1 0v-4A1.5 1.5 0 0 0 14.5 1h-12A1.5 1.5 0 0 0 1 2.5v18A1.5 1.5 0 0 0 2.5 22h7a.5.5 0 1 1 0 1h-7A2.5 2.5 0 0 1 0 20.5v-18A2.5 2.5 0 0 1 2.5 0h12zm2 10a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 10a.5.5 0 1 1-.002 1.002A.5.5 0 0 1 16.5 20zm0-8c1.632 0 2.5 1.042 2.5 2.5 0 1.115-.458 1.714-2 2.766V18.5a.5.5 0 1 1-1 0V17a.5.5 0 0 1 .223-.416C17.689 15.606 18 15.234 18 14.5c0-.942-.465-1.5-1.5-1.5s-1.5.558-1.5 1.5a.5.5 0 1 1-1 0c0-1.458.868-2.5 2.5-2.5zm-9 3a.5.5 0 1 1 0 1h-4a.5.5 0 1 1 0-1h4zm1-5a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1h5zm5-5a.5.5 0 1 1 0 1h-10a.5.5 0 0 1 0-1h10z"
        />
      </svg>`
  },
  file: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M9.787.09a.498.498 0 0 1 .067.056l3 3 .05.06a.501.501 0 0 1 .004.005l-.055-.065a.49.49 0 0 1 .146.317L13 3.5v3l-.008.09A.5.5 0 0 1 12.5 7l-.09-.008A.5.5 0 0 1 12 6.5V4H9.499a.5.5 0 0 1-.5-.5L8.998 1H2v13.999h10V13.5l.008-.09a.5.5 0 0 1 .992.09v2l-.008.09a.5.5 0 0 1-.492.41h-11l-.09-.008A.5.5 0 0 1 1 15.5V.5l.008-.09A.5.5 0 0 1 1.5 0h7.98a.485.485 0 0 1 .307.09zM14.5 8a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zm-.5.999H7V11h6.999L14 8.999z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13.787.09a.498.498 0 0 1 .067.056l5 5 .05.06a.501.501 0 0 1 .004.005l-.055-.065a.49.49 0 0 1 .146.317L19 5.5v4l-.008.09a.5.5 0 0 1-.492.41l-.09-.008A.5.5 0 0 1 18 9.5V6h-4.501a.5.5 0 0 1-.5-.5L12.998.999H2L2.001 23H18v-2.5l.008-.09a.5.5 0 0 1 .992.09v3l-.008.09a.5.5 0 0 1-.492.41h-17l-.09-.008A.5.5 0 0 1 1 23.5V.5l.008-.09A.5.5 0 0 1 1.5 0h11.98a.485.485 0 0 1 .307.09zM22.5 12a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zm-.5.999H11V17h10.999L22 12.999z"
        />
      </svg>`
  },
  fraudulentActivity: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M18.5 9a3.5 3.5 0 0 1 3.5 3.5V14h.5a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-7a1.5 1.5 0 0 1 1.5-1.5h.5v-1.5A3.5 3.5 0 0 1 18.5 9zm4 6h-8a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zm-4 2a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 0 1 .5-.5zm2.009-17A2.49 2.49 0 0 1 23 2.498V8.5a.5.5 0 1 1-1 0V5H1v12.503C1 18.332 1.67 19 2.5 19h8a.5.5 0 1 1 0 1h-8A2.496 2.496 0 0 1 0 17.503V2.497A2.493 2.493 0 0 1 2.491 0H20.51zM18.5 10a2.5 2.5 0 0 0-2.5 2.5V14h5v-1.5a2.5 2.5 0 0 0-2.5-2.5zm2.009-9H2.49C1.667 1 1 1.67 1 2.497V4h21V2.498A1.49 1.49 0 0 0 20.509 1zM3.5 2a.5.5 0 1 1-.002 1.002A.5.5 0 0 1 3.5 2zm2 0a.5.5 0 1 1-.002 1.002A.5.5 0 0 1 5.5 2zm2 0a.5.5 0 1 1-.002 1.002A.5.5 0 0 1 7.5 2z"
        />
      </svg>`
  },
  location: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 0c3.453 0 6 2.388 6 6 0 2.494-1.887 5.753-5.631 9.838a.5.5 0 0 1-.738 0C3.887 11.753 2 8.494 2 6c0-3.612 2.547-6 6-6zm0 1C5.086 1 3 2.955 3 6c0 2.045 1.577 4.889 4.754 8.48l.245.275.247-.275c3.078-3.479 4.654-6.257 4.75-8.286L13 6c0-3.045-2.086-5-5-5zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12.373 23.833a.5.5 0 0 1-.746 0C5.883 17.413 3 12.495 3 9c0-5.276 3.724-9 9-9s9 3.724 9 9c0 3.495-2.883 8.414-8.627 14.833zM20 9c0-4.724-3.276-8-8-8S4 4.276 4 9c0 3.1 2.66 7.707 8 13.748C17.34 16.708 20 12.1 20 9zm-8-4a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
        />
      </svg>`
  },
  mobileDevice: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M11 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6zm0 1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM8 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM9.5 2a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16.5 0A2.5 2.5 0 0 1 19 2.5v19a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 21.5v-19A2.5 2.5 0 0 1 7.5 0h9zm0 1h-9A1.5 1.5 0 0 0 6 2.5v19A1.5 1.5 0 0 0 7.5 23h9a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 16.5 1zM12 19a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm2.5-16a.5.5 0 1 1 0 1h-5a.5.5 0 0 1 0-1z"
        />
      </svg>`
  },
  mobileTicket: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16.5 0A2.5 2.5 0 0 1 19 2.5v19a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 21.5v-19A2.5 2.5 0 0 1 7.5 0h9zM18 21H6v.5A1.5 1.5 0 0 0 7.5 23h9a1.5 1.5 0 0 0 1.5-1.5V21zM16.5 1h-9A1.5 1.5 0 0 0 6 2.5V20h1V8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .447.276l.053.106a1.118 1.118 0 0 0 2 0l.053-.106A.5.5 0 0 1 13.5 8h3a.5.5 0 0 1 .5.5V20h1V2.5A1.5 1.5 0 0 0 16.5 1zM16 13H8v7h8v-7zm-5.799-4H8v3h8V9h-2.201A2.118 2.118 0 0 1 10.2 9zM9.5 3a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm5 0a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1z"
        />
      </svg>`
  },
  notes: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M13 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-2H.5a.5.5 0 1 1 0-1h.499V8H.5a.5.5 0 0 1 0-1h.499V4H.5a.5.5 0 0 1 0-1h.499L1 2a2 2 0 0 1 2-2h10zm0 1H3a1 1 0 0 0-1 1l-.001 1H2.5a.5.5 0 0 1 0 1h-.501v3H2.5a.5.5 0 0 1 0 1h-.501v3H2.5a.5.5 0 1 1 0 1h-.501L2 14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM9.5 8a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1h4zm2-3a.5.5 0 1 1 0 1h-6a.5.5 0 0 1 0-1h6z"
        />
      </svg>`
  },
  "payment-amex": {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 3C22.877 3 24 4.124 24 5.5v13c0 1.376-1.123 2.5-2.5 2.5h-19A2.506 2.506 0 0 1 0 18.5v-13C0 4.124 1.124 3 2.5 3h19zm0 1h-19C1.676 4 1 4.676 1 5.5v13c0 .824.676 1.5 1.5 1.5h19c.824 0 1.5-.676 1.5-1.5v-13c0-.824-.676-1.5-1.5-1.5zM4.752 10.03 6.614 15H5.73l-.377-1.071h-2.03L2.953 15H2.07l1.854-4.97h.827zm3.486 0 1.638 2.975h.014l1.637-2.975h.848V15h-.848v-3.325h-.013l-1.358 2.366h-.554l-1.357-2.366h-.007V15H7.39v-4.97h.847zm8.483 0v.756H14.44v1.372h1.84v.756h-1.84v1.33h2.429V15h-3.277v-4.97h3.13zm1.758 0 1.19 1.834h.006l1.19-1.834h.966l-1.61 2.478L21.873 15h-.994l-1.218-1.834h-.014L18.438 15h-.98l1.645-2.492-1.61-2.478h.986zM4.346 11.045h-.014l-.75 2.156h1.52l-.756-2.156z"
        />
      </svg>`
  },
  "payment-amexsolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#006DB0" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.8964 11.5444L18.8835 9.95752V11.5444H17.629L17.4037 11.0466H16.2364L16.0139 11.5444H15.0135C15.0135 11.5444 14.1533 11.4275 14.1533 10.4234C14.1533 9.19272 15.0043 9.15708 15.144 9.15123C15.1539 9.15081 15.1602 9.15055 15.1624 9.15002L15.95 9.17021V9.70465L15.3031 9.71262C15.3031 9.71262 14.881 9.71262 14.8297 10.2301C14.8242 10.2901 14.821 10.3443 14.8215 10.3947C14.8241 11.1742 15.517 10.9627 15.5811 10.9432L15.5851 10.9419L16.376 9.16968H17.2706L18.2295 11.3228V9.17127H19.1328L20.1337 10.7342V9.17127H20.7773V11.546H19.8948L19.8964 11.5444ZM7.34168 11.5444V9.90546L6.53987 11.5444H6.01623L5.21114 9.91343V11.5444H3.94896L3.72805 11.0466H2.56078L2.33496 11.5444H1.63623L2.69714 9.16968H3.59605L4.56696 11.3515V9.17021H5.57714L6.28078 10.6444L6.97896 9.17021H7.98805V11.5449H7.34168V11.5444ZM8.34259 9.16968V11.5444V11.5449H10.3368V11.0312H8.98623V10.629H10.303V10.0909H8.98623V9.72431H10.3368V9.16968H8.34259ZM13.2931 11.5523H13.9368V9.17127H13.2931V11.5523ZM10.562 14.7988H10.0035L9.32714 14.0949L8.64532 14.7988H6.26714V12.4204H8.59405L9.32714 13.1748L10.0635 12.4241H10.5544V12.4204H12.1046C12.1046 12.4204 12.914 12.3354 12.914 13.1185C12.914 13.8181 12.6451 14.0349 11.8188 14.0349H11.1926V14.7988H10.562ZM21.4346 14.7946H20.2973V14.2474H21.29C21.29 14.2474 21.6522 14.2877 21.6522 14.0598C21.6522 13.8457 21.1106 13.8622 21.1106 13.8622C21.1106 13.8622 20.2291 13.935 20.2291 13.1556C20.2291 12.38 21.0255 12.4241 21.0255 12.4241H22.249V12.9782H21.2644C21.2644 12.9782 20.9235 12.9145 20.9235 13.1482C20.9235 13.3437 21.3871 13.3156 21.3871 13.3156C21.3871 13.3156 22.3635 13.2481 22.3635 13.9631C22.3635 14.7292 21.7351 14.7972 21.5126 14.7972C21.4635 14.7972 21.4346 14.7946 21.4346 14.7946ZM15.7602 14.7983V12.4289H17.7533V12.9782H16.4028V13.3437H17.72V13.8824H16.4028V14.2846H17.7533V14.7983H15.7602ZM18.0435 14.7946H19.1813V14.7951C19.1813 14.7951 19.2097 14.7977 19.2588 14.7977C19.4813 14.7977 20.1097 14.7297 20.1097 13.9637C20.1097 13.2481 19.1333 13.3156 19.1333 13.3156C19.1333 13.3156 18.6697 13.3437 18.6697 13.1482C18.6697 12.9145 19.0117 12.9782 19.0117 12.9782H19.999V12.4241H18.7717C18.7717 12.4241 17.9753 12.38 17.9753 13.1556C17.9753 13.935 18.8573 13.8622 18.8573 13.8622C18.8573 13.8622 19.3984 13.8457 19.3984 14.0598C19.3984 14.2877 19.0406 14.2474 19.0406 14.2474H18.0435V14.7946ZM10.5539 14.4572L9.76132 13.6301H9.76078L10.5539 12.805V14.4572ZM6.91078 14.2846H8.25696L8.88805 13.6301L8.25696 12.9787H6.91078V13.3437H8.22314V13.8824H6.91078V14.2846ZM11.8526 13.416H11.1926V12.966H11.8526C12.0446 12.966 12.2017 13.0669 12.2017 13.1912C12.2017 13.315 12.0446 13.416 11.8526 13.416ZM14.8226 14.8025V14.3403C14.8226 14.3403 14.7964 13.9791 14.396 13.9791H13.7742V14.8025H13.135V12.4278H14.6868C14.6868 12.4278 15.4962 12.3359 15.4962 13.1238C15.4962 13.5328 15.1379 13.6773 15.1379 13.6773C15.1379 13.6773 15.4444 13.8139 15.4444 14.2155V14.8025H14.8226ZM14.4353 13.4202H13.7753V12.9708H14.4353C14.6262 12.9708 14.7844 13.0706 14.7844 13.1955C14.7844 13.3193 14.6262 13.4202 14.4353 13.4202ZM2.8335 10.4394L3.14441 9.73281L3.45532 10.4394H2.8335ZM17.132 10.4394H16.5091H16.5086L16.825 9.73281L17.132 10.4394ZM12.3555 11.5444V11.0822C12.3555 11.0822 12.3299 10.7209 11.93 10.7209H11.3082V11.5444H10.6684V9.16968H12.218C12.218 9.16968 13.0275 9.07777 13.0275 9.86562C13.0275 10.2747 12.6697 10.4197 12.6697 10.4197C12.6697 10.4197 12.9806 10.5562 12.9806 10.9579V11.5444H12.3555ZM11.9682 10.1631H11.3082V10.1621V9.71262H11.9682C12.1591 9.71262 12.3173 9.81302 12.3173 9.93734C12.3173 10.0622 12.1591 10.1631 11.9682 10.1631Z"
          fill="white"
        />
      </svg>
    `
  },
  "payment-unionpay": {
    24: () => html`
      <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_11316_30135)">
          <rect x="0.500244" y="1" width="22.9938" height="17" rx="1.5" fill="white" stroke="black"/>
          <g clip-path="url(#clip1_11316_30135)">
            <path d="M6.2207 3.5H10.9573C11.6191 3.5 12.0311 4.04518 11.8754 4.71366L9.66933 14.2834C9.51361 14.9519 8.84854 15.4971 8.18996 15.4971H3.45336C2.79153 15.4971 2.37627 14.9487 2.53199 14.2834L4.73808 4.71366C4.8938 4.04193 5.55563 3.5 6.21746 3.5H6.2207Z" fill="#D10429"/>
            <path d="M10.5419 3.5H15.9923C16.6541 3.5 16.3524 4.04518 16.1999 4.71366L13.9938 14.2834C13.8381 14.9519 13.8868 15.4971 13.2249 15.4971H7.77461C7.10954 15.4971 6.70076 14.9519 6.85973 14.2834L9.06582 4.71366C9.22154 4.04193 9.88337 3.5 10.5484 3.5H10.5419Z" fill="#022E64"/>
            <path d="M15.8042 3.5H20.544C21.2058 3.5 21.6178 4.04518 21.4621 4.71366L19.256 14.2834C19.1003 14.9519 18.4352 15.4971 17.7767 15.4971H13.0401C12.375 15.4971 11.9662 14.9519 12.1219 14.2834L14.328 4.71366C14.4773 4.04193 15.1391 3.5 15.8042 3.5Z" fill="#076F74"/>
            <path d="M11.1649 10.1914L11.0092 10.4769C10.9768 10.5386 10.9476 10.5775 10.9184 10.5938C10.8957 10.6067 10.847 10.6132 10.7756 10.6132H10.6945L10.5842 10.9799H10.8567C10.9865 10.9799 11.0871 10.9313 11.1358 10.9085C11.1877 10.8793 11.1974 10.8956 11.2396 10.8566L11.3336 10.7755H12.1804L12.2939 10.3958H11.6743L11.7781 10.1914H11.1649Z" fill="#FEFEFE"/>
            <path d="M11.074 12.609L11.2265 12.106H11.8429L11.9565 11.7295H11.3368L11.4309 11.4213H12.0343L12.1446 11.0546H10.6328L10.6393 11.0578L10.529 11.4245H10.8696L10.7756 11.7328H10.4317L10.3181 12.1157H10.662L10.4609 12.7842C10.4349 12.8751 10.4738 12.9075 10.4998 12.9465C10.5225 12.9854 10.5517 13.0114 10.6101 13.0276C10.6717 13.0406 10.7139 13.0471 10.7691 13.0471H11.4633L11.5866 12.6284L11.2752 12.6706C11.22 12.6739 11.0546 12.6641 11.074 12.609Z" fill="#FEFEFE"/>
            <path d="M16.5083 11.3272H17.1506L17.0566 11.6289H16.4012L16.3039 11.9599H16.8749L16.4402 12.5765C16.4142 12.6219 16.385 12.6349 16.3526 12.6479C16.3201 12.6641 16.2812 12.6836 16.2358 12.6836H16.0963L16.1482 12.5149H15.9924L16.5699 10.584L16.5667 10.5808H16.7581L16.8068 10.4185L16.81 10.6035C16.8035 10.7398 16.9106 10.8599 17.1896 10.8404H17.514L17.6243 10.4672H17.5043C17.4329 10.4672 17.4004 10.451 17.4037 10.412L17.3972 10.1849H16.8068L16.81 10.1881C16.6024 10.1914 16.0476 10.2076 15.934 10.24C15.7881 10.279 15.6421 10.3861 15.6421 10.3861L15.7005 10.1881H15.1392L15.0224 10.584L14.4385 12.5441H14.3249L14.2146 12.914H15.3306L15.2917 13.0373H15.8432L15.8821 12.914H16.0184L15.9795 13.0438H16.3915C16.6089 13.0438 16.7354 12.9432 16.8295 12.8134L17.1247 12.4045L17.1863 12.8231C17.1993 12.9043 17.2545 12.9497 17.2934 12.9659C17.3356 12.9854 17.3745 13.0211 17.4394 13.0276C17.5043 13.0276 17.5529 13.0308 17.5854 13.0308H17.7898L17.913 12.6252H17.8352C17.7898 12.6252 17.7119 12.6187 17.6989 12.6057C17.6859 12.5895 17.6859 12.5603 17.6795 12.5181L17.6146 12.0995H17.3485L17.4653 11.9599H18.1174L18.218 11.6289H17.6146L17.7087 11.3272H18.2991L18.4094 10.954H16.6186L16.5083 11.3272ZM15.4539 12.5213H15.0062L15.136 12.0865H15.5804L15.4539 12.5213ZM15.7037 11.6841C15.7037 11.6841 15.5674 11.7003 15.4734 11.7231C15.3793 11.7523 15.2106 11.8366 15.2106 11.8366L15.3631 11.3239H15.8075L15.7037 11.6841ZM15.7005 10.9799C15.6064 11.0026 15.4409 11.0805 15.4409 11.0805L15.5902 10.5873L15.5934 10.5905H16.0379L15.9308 10.9475C15.9308 10.9475 15.7913 10.954 15.7005 10.9799Z" fill="#FEFEFE"/>
            <path d="M13.65 10.1946C13.65 10.1946 13.3873 10.2368 13.2705 10.279C13.1537 10.3277 12.9882 10.464 12.9882 10.464L13.0628 10.1946H12.5373L11.7976 12.6706C11.7684 12.768 11.7522 12.8361 11.7489 12.8783C11.7457 12.9237 11.8041 12.9692 11.843 13.0049C11.8884 13.0406 11.9533 13.0341 12.0149 13.0406C12.0798 13.0438 12.1739 13.0471 12.3037 13.0471H12.7092L12.8325 12.6219L12.4724 12.6576C12.4334 12.6576 12.4042 12.6382 12.3945 12.6187C12.3815 12.5992 12.3913 12.5603 12.4107 12.4824L12.6411 11.7068H13.4651C13.5819 11.7068 13.6727 11.7036 13.7279 11.7003C13.7895 11.6971 13.8544 11.6711 13.929 11.6354C14.0037 11.5933 14.0426 11.5478 14.075 11.4991C14.1107 11.4472 14.1691 11.3401 14.2178 11.1714L14.5098 10.1914L13.65 10.1946ZM13.6079 11.3564C13.6014 11.3629 13.5852 11.3499 13.4943 11.3596H12.7449L12.7968 11.1811H13.6598H13.663L13.6079 11.3564ZM13.7766 10.8079C13.7766 10.8079 13.3645 10.8015 13.2964 10.8144C13.0207 10.8599 12.8552 11.0059 12.839 11.0189L12.9655 10.6003H13.8382L13.7766 10.8079Z" fill="#FEFEFE"/>
            <path d="M7.45342 6.57635C6.96354 6.57959 6.82404 6.57635 6.77538 6.56661V6.56337C6.75915 6.64774 6.42824 8.17942 6.42824 8.17942C6.35687 8.4877 6.30496 8.71162 6.13302 8.8544C6.03244 8.93877 5.91565 8.97771 5.78264 8.97771C5.56527 8.97771 5.44199 8.87062 5.42253 8.66618L5.41928 8.59804C5.41928 8.59804 5.48417 8.18267 5.48417 8.17942C5.48417 8.17942 5.82806 6.78079 5.8897 6.59582C5.89294 6.58608 5.89294 6.57959 5.89294 6.57635C5.22138 6.58284 5.10135 6.57635 5.09486 6.56661C5.09161 6.57959 5.07539 6.66721 5.07539 6.66721L4.71852 8.23783L4.68608 8.37088L4.62769 8.80897C4.62769 8.93877 4.6504 9.04586 4.7023 9.13348C4.86452 9.41905 5.32195 9.46123 5.58149 9.46123C5.91565 9.46123 6.23034 9.38659 6.43797 9.26004C6.80782 9.03937 6.9019 8.69539 6.98625 8.3936L7.02843 8.23783C7.02843 8.23783 7.38205 6.78728 7.44369 6.59906C7.45018 6.58608 7.45018 6.57959 7.45342 6.57635Z" fill="#FEFEFE"/>
            <path d="M10.8373 9.48395C11.1098 9.48395 11.3888 9.40606 11.5997 9.1854C11.7619 9.00367 11.8333 8.73433 11.8625 8.61751H11.8593C11.9404 8.24757 11.8755 8.07558 11.7976 7.97173C11.6743 7.81272 11.4537 7.7608 11.2266 7.7608C11.0904 7.7608 10.7659 7.77378 10.5096 8.01067C10.328 8.18266 10.2404 8.41307 10.1917 8.63698C10.1398 8.86413 10.0814 9.26977 10.4545 9.42229C10.5648 9.47097 10.7303 9.48395 10.8373 9.48395ZM10.8146 8.64996C10.8762 8.36763 10.9509 8.13399 11.1423 8.13399C11.2915 8.13399 11.3012 8.30922 11.2364 8.5883C11.2266 8.64996 11.1715 8.8836 11.1001 8.98096C11.0482 9.05559 10.9898 9.09778 10.9217 9.09778C10.9022 9.09778 10.7854 9.09778 10.7789 8.9193C10.7757 8.83817 10.7919 8.74731 10.8146 8.64996Z" fill="#FEFEFE"/>
            <path d="M14.0749 11.7555L14.0718 11.7617H14.0779L14.0749 11.7555Z" fill="#FEFEFE"/>
            <path d="M8.6539 7.74458C8.56631 7.74458 8.41383 7.76405 8.27108 7.83544C8.21917 7.8614 8.17051 7.89061 8.1186 7.92306L8.16402 7.75756L8.14131 7.72835C7.84284 7.78676 7.77471 7.7965 7.5022 7.83544L7.47949 7.84842C7.44704 8.11776 7.41785 8.31896 7.30105 8.84466C7.25563 9.03937 7.21021 9.23407 7.16479 9.42878L7.17777 9.45474C7.46002 9.44176 7.54762 9.44176 7.79093 9.445L7.8104 9.42553C7.84284 9.26652 7.84609 9.22758 7.91422 8.89983C7.9499 8.74731 8.01479 8.40658 8.04723 8.28326C8.10887 8.25406 8.16727 8.2281 8.22566 8.2281C8.36192 8.2281 8.34894 8.35141 8.34246 8.40009C8.33597 8.48121 8.2873 8.74731 8.2354 8.97447L8.19971 9.12049C8.18024 9.22758 8.15105 9.33143 8.12834 9.44176L8.13807 9.46123C8.41707 9.44825 8.50467 9.44825 8.7415 9.45149L8.73825 9.44825L8.76421 9.42878C8.80638 9.17891 8.81936 9.11076 8.89398 8.74406L8.93291 8.57856C9.00753 8.24757 9.04321 8.08207 8.98806 7.94577C8.92642 7.78352 8.78367 7.74458 8.6539 7.74458Z" fill="#FEFEFE"/>
            <path d="M13.624 11.9275C13.6175 11.9502 13.6078 11.9697 13.5883 11.9794C13.5721 11.9892 13.5397 11.9924 13.4975 11.9924H13.3742L13.3807 11.7815H12.8681L12.8486 12.8167C12.8486 12.8945 12.8551 12.9335 12.9103 12.9692C12.9622 13.0114 13.1309 13.0178 13.3547 13.0178H13.6759L13.7927 12.6284L13.5137 12.6414L13.4196 12.6479C13.4066 12.6414 13.3969 12.6382 13.3807 12.6219C13.371 12.609 13.3482 12.6155 13.3547 12.5408L13.358 12.278L13.65 12.265C13.8089 12.265 13.8738 12.2131 13.9322 12.1644C13.9874 12.1157 14.0036 12.0605 14.0263 11.9859L14.0717 11.7555H13.6727L13.624 11.9275Z" fill="#FEFEFE"/>
            <path d="M10.0164 8.0918C9.86721 8.12101 9.77313 8.13723 9.67905 8.15021C9.58496 8.16319 9.49737 8.17942 9.35138 8.19889L9.34165 8.20862L9.33191 8.21511C9.31894 8.3222 9.3092 8.41631 9.28649 8.5234C9.27027 8.63698 9.24107 8.76678 9.1989 8.95175C9.16321 9.09453 9.14699 9.14321 9.13077 9.19189C9.1113 9.24056 9.09184 9.28924 9.05615 9.42878L9.06264 9.44176L9.06913 9.45149C9.20214 9.44825 9.28974 9.44176 9.38058 9.44176C9.47142 9.43851 9.56225 9.44176 9.70825 9.44176L9.71473 9.445L9.72771 9.43527L9.74069 9.42553C9.76015 9.29897 9.7634 9.26977 9.77962 9.20487C9.78935 9.13996 9.81531 9.0491 9.86721 8.80572C9.88992 8.69214 9.91912 8.57532 9.94508 8.46174L10.0262 8.11776L10.0229 8.10478L10.0164 8.0918Z" fill="#FEFEFE"/>
            <path d="M20.0444 7.75431L20.0217 7.72511C19.7297 7.78352 19.6745 7.79325 19.4052 7.8322L19.3858 7.85167C19.3858 7.85491 19.3825 7.85816 19.3825 7.86465V7.8614C19.1814 8.33194 19.1846 8.23134 19.0257 8.59804C19.0257 8.58181 19.0257 8.56883 19.0224 8.55261L18.9803 7.75107L18.9575 7.72186C18.6461 7.78027 18.6396 7.79001 18.3574 7.82895L18.3379 7.84842C18.3346 7.85816 18.3346 7.86789 18.3346 7.88087L18.3379 7.88412C18.3736 8.06909 18.3638 8.0269 18.3995 8.31571C18.4158 8.4585 18.4385 8.60128 18.4547 8.74082C18.4806 8.97771 18.5001 9.09129 18.5325 9.4515C18.3411 9.77276 18.2957 9.89283 18.1076 10.1752L18.1108 10.1816H18.0946L17.9583 10.4023C17.9421 10.4218 17.9324 10.438 17.9097 10.4445C17.8902 10.4542 17.861 10.4575 17.8221 10.4575H17.7474L17.6404 10.8177L18.007 10.8339C18.2211 10.8339 18.3574 10.7301 18.432 10.5938L18.6591 10.2011H18.6623L18.7077 10.1492C18.8635 9.8117 20.0476 7.7608 20.0476 7.7608L20.0444 7.75431Z" fill="#FEFEFE"/>
            <path d="M16.1482 8.68241C16.0963 8.90632 16.0379 9.3152 16.4077 9.45799C16.5245 9.50991 16.6316 9.52289 16.7386 9.5164C16.8424 9.50991 16.943 9.46123 17.0338 9.38659C17.0274 9.4158 17.0176 9.44501 17.0111 9.47421L17.0274 9.49368C17.2934 9.4807 17.3745 9.4807 17.6632 9.48395V9.48719L17.6892 9.46772C17.7314 9.21785 17.767 8.97447 17.8773 8.49744C17.9325 8.27028 17.9844 8.04637 18.0396 7.81597L18.0331 7.79325C17.7346 7.84842 17.6535 7.85816 17.368 7.90034L17.3485 7.91657C17.3453 7.93279 17.3453 7.94577 17.342 7.962C17.2966 7.8971 17.235 7.84193 17.1441 7.80623C17.0176 7.75431 16.7159 7.81921 16.4629 8.05611C16.2844 8.2281 16.1968 8.46174 16.1482 8.68241ZM16.7711 8.69539C16.8327 8.41956 16.9073 8.18916 17.0987 8.18916C17.1993 8.18916 17.2609 8.26704 17.2707 8.40658C17.2577 8.47472 17.2382 8.55585 17.2188 8.64671C17.1928 8.75705 17.1669 8.86738 17.1377 8.97771C17.1279 8.99718 17.1182 9.01665 17.1052 9.02963C17.0566 9.09778 16.9398 9.14321 16.8749 9.14321C16.8554 9.14321 16.7419 9.14321 16.7321 8.96798C16.7321 8.8836 16.7483 8.79274 16.7711 8.69539Z" fill="#FEFEFE"/>
            <path d="M10.0166 7.64073C9.88357 7.55961 9.64343 7.58557 9.48767 7.6959C9.32866 7.80299 9.31243 7.95551 9.44548 8.03988C9.57528 8.11776 9.81542 8.09505 9.97118 7.98471C10.1302 7.87438 10.1497 7.72186 10.0166 7.64073Z" fill="#FEFEFE"/>
            <path d="M12.5436 9.44176L12.5631 9.42229C12.5955 9.26328 12.602 9.22434 12.6669 8.89658C12.7026 8.74406 12.7707 8.40333 12.7999 8.28002C12.8583 8.25081 12.92 8.22485 12.9783 8.22485C13.1114 8.22485 13.0984 8.34816 13.0919 8.39684C13.0887 8.47797 13.0367 8.74406 12.9848 8.97122L12.9524 9.11725C12.9297 9.22434 12.9005 9.32818 12.8778 9.43851L12.8875 9.45798C13.1665 9.445 13.2476 9.445 13.4877 9.44825L13.4845 9.445L13.5104 9.42553C13.5526 9.17566 13.5623 9.10751 13.6402 8.74082L13.6791 8.57532C13.7537 8.24432 13.7927 8.07882 13.7375 7.94253C13.6759 7.79001 13.5331 7.75107 13.4033 7.75107C13.3158 7.75107 13.1633 7.77054 13.0205 7.84193C12.9719 7.86789 12.92 7.89709 12.8713 7.92955L12.9135 7.76405L12.8908 7.73484C12.5955 7.79325 12.5274 7.80299 12.2516 7.84193L12.2322 7.84842C12.1965 8.11776 12.1705 8.31896 12.0537 8.84466C12.0083 9.03937 11.9629 9.23407 11.9175 9.42878L11.9305 9.45474C12.2127 9.43851 12.2971 9.43851 12.5436 9.44176Z" fill="#FEFEFE"/>
            <path d="M14.5909 9.45798C14.6071 9.37037 14.7109 8.86089 14.7141 8.86089C14.7141 8.86089 14.805 8.48446 14.8082 8.47148C14.8082 8.47148 14.8342 8.43253 14.8634 8.41631H14.9056C15.2949 8.41631 15.7328 8.41631 16.0767 8.16319C16.3103 7.98796 16.4693 7.72835 16.5407 7.41682C16.5569 7.33894 16.5731 7.25132 16.5731 7.15721C16.5731 7.0339 16.5504 6.91708 16.479 6.82297C16.3038 6.57634 15.9567 6.5731 15.5512 6.56985L15.35 6.5731C14.8342 6.57959 14.6265 6.57634 14.5454 6.56661C14.539 6.60555 14.526 6.67045 14.526 6.67045C14.526 6.67045 14.3411 7.53365 14.3411 7.53689C14.3411 7.53689 13.8998 9.37361 13.8804 9.46123C14.3313 9.44825 14.513 9.44825 14.5909 9.45798ZM14.9315 7.92955C14.9315 7.92955 15.1294 7.06635 15.1294 7.0696L15.1359 7.02417L15.1391 6.98847L15.217 6.99496C15.217 6.99496 15.6225 7.03066 15.629 7.03066C15.788 7.09231 15.8561 7.25457 15.8075 7.4655C15.7653 7.65696 15.642 7.81921 15.483 7.8971C15.3533 7.962 15.1943 7.97173 15.0288 7.97173H14.925L14.9315 7.92955Z" fill="#FEFEFE"/>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_11316_30135">
            <rect width="23.9938" height="18" fill="white" transform="translate(0.000244141 0.5)"/>
          </clipPath>
          <clipPath id="clip1_11316_30135">
            <rect width="18.9951" height="11.9971" fill="white" transform="translate(2.49951 3.5)"/>
          </clipPath>
        </defs>
      </svg>
    `
  },
  "payment-dinersclub": {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 3C22.877 3 24 4.124 24 5.5v13c0 1.376-1.123 2.5-2.5 2.5h-19A2.506 2.506 0 0 1 0 18.5v-13C0 4.124 1.124 3 2.5 3h19zm0 1h-19C1.676 4 1 4.676 1 5.5v13c0 .824.676 1.5 1.5 1.5h19c.824 0 1.5-.676 1.5-1.5v-13c0-.824-.676-1.5-1.5-1.5zm-8 2c2.862 0 5.5 2.814 5.5 6s-2.638 6-5.5 6a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5zm-3 0a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5C7.627 18 5 15.211 5 12s2.627-6 5.5-6zM14 7.037v9.926c2.105-.308 4-2.509 4-4.963s-1.895-4.655-4-4.963zm-4 0C7.886 7.34 6 9.521 6 12s1.886 4.66 4 4.964V7.036z"
        />
      </svg>`
  },
  "payment-dinersclubsolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#004A98" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8865 17.4983H12.874C15.9763 17.4983 18.4485 15.0597 18.5454 12.0473V11.9995C18.497 8.93928 15.9763 6.45286 12.874 6.50068H10.6442C7.68726 6.59631 5.3605 9.08272 5.45745 12.0473C5.45745 15.0119 7.88115 17.4505 10.8865 17.4983ZM6.42693 11.9995C6.42693 9.51307 8.51131 7.45699 11.032 7.45699C13.5526 7.45699 15.637 9.51307 15.637 11.9995C15.637 14.4859 13.5526 16.542 11.032 16.542C8.51131 16.542 6.42693 14.4859 6.42693 11.9995ZM11.7591 15.0597V8.98709C13.4557 9.41743 14.5221 11.091 14.0858 12.7645C13.795 13.9121 12.9225 14.7728 11.7591 15.0597ZM8.02657 11.2344C7.59031 12.908 8.60826 14.6293 10.3049 15.0597V8.98709C9.18995 9.27399 8.31742 10.1347 8.02657 11.2344Z"
          fill="white"
        />
      </svg>
    `
  },
  "payment-discover": {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 3C22.877 3 24 4.124 24 5.5v13c0 1.376-1.123 2.5-2.5 2.5h-19A2.506 2.506 0 0 1 0 18.5v-13C0 4.124 1.124 3 2.5 3h19zm0 1h-19C1.676 4 1 4.676 1 5.5v13c0 .824.676 1.5 1.5 1.5h19c.824 0 1.5-.676 1.5-1.5v-13c0-.824-.676-1.5-1.5-1.5zM7.051 10.266c.352 0 .67.122.939.356l-.324.437c-.163-.182-.313-.259-.501-.259-.27 0-.47.154-.47.356 0 .174.11.265.486.405.712.26.922.493.922 1.003 0 .62-.45 1.052-1.1 1.052-.475 0-.827-.192-1.117-.615l.405-.389c.144.28.382.421.68.421.279 0 .485-.192.485-.453 0-.31-.275-.374-.615-.502-.584-.22-.793-.449-.793-.89 0-.525.435-.922 1.003-.922zm5.6 0c.924 0 1.666.742 1.666 1.667 0 .924-.742 1.683-1.667 1.683a1.69 1.69 0 0 1-1.683-1.683c0-.925.759-1.667 1.683-1.667zm2.232.065.858 2.152.874-2.152h.68l-1.392 3.285h-.34l-1.36-3.285h.68zm-4.87-.081c.269 0 .501.07.776.21v.729c-.26-.255-.495-.356-.793-.356-.586 0-1.051.485-1.051 1.1 0 .65.453 1.1 1.084 1.1.283 0 .51-.105.76-.356v.745a1.758 1.758 0 0 1-.793.178c-.952 0-1.699-.725-1.699-1.667 0-.933.767-1.683 1.716-1.683zm-6.99.08c1.015 0 1.715.656 1.715 1.603 0 .5-.32 1.602-1.716 1.602H2.1V10.33zm2.637 0v3.205h-.631V10.33h.63zm13.69 0v.535H18.2v.712h1.1v.55h-1.1v.858h1.15v.55h-1.78V10.33h1.78zm1.342 0c.722 0 1.133.339 1.133.94 0 .49-.257.825-.728.922l1.003 1.343h-.777l-.857-1.295h-.081v1.295h-.631V10.33zm-17.75.535h-.21v2.12h.16c1.127 0 1.198-.811 1.198-1.052 0-.504-.297-1.068-1.149-1.068zm17.637-.032h-.194v.97h.178c.398 0 .615-.18.615-.501 0-.312-.209-.47-.599-.47z"
        />
      </svg>`
  },
  "payment-discoversolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#ED7523" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7976 11.9343C10.7976 10.9823 11.5992 10.25 12.5535 10.25C13.5459 10.25 14.3094 11.0189 14.3476 11.971C14.3094 12.923 13.5459 13.6919 12.5535 13.6553C11.561 13.6187 10.7976 12.8498 10.7976 11.9343ZM6.36965 11.1677C6.36965 11.3508 6.48417 11.424 6.86589 11.5705C7.62932 11.8634 7.82018 12.0831 7.85835 12.5225V12.6324C7.82018 13.2182 7.32395 13.6576 6.7132 13.621C6.25514 13.621 5.79708 13.4013 5.56805 12.9985L5.98793 12.5958C6.10245 12.8521 6.36965 13.0352 6.67503 13.0352H6.7132C6.94223 13.0352 7.17126 12.8155 7.17126 12.5591C7.17126 12.4127 7.09492 12.3028 6.9804 12.2296C6.82771 12.1564 6.67503 12.0831 6.52234 12.0465C5.91159 11.8634 5.72073 11.6071 5.72073 11.1677V11.1311C5.7589 10.6185 6.21697 10.2157 6.75137 10.2523C7.09492 10.2523 7.43846 10.3988 7.70566 10.6185L7.36212 11.0579C7.20943 10.9114 7.01857 10.8016 6.82771 10.8016C6.59868 10.7649 6.40782 10.948 6.36965 11.1677ZM8.04921 11.9733C8.04921 12.8887 8.81265 13.6576 9.76694 13.6576C10.0723 13.6576 10.3395 13.5844 10.6067 13.4745V12.7422C10.4159 12.9619 10.1487 13.1084 9.84328 13.1084C9.23254 13.1084 8.7363 12.669 8.7363 12.0831V12.0099C8.69813 11.424 9.19436 10.9114 9.80511 10.8748C10.1105 10.8748 10.4159 11.0213 10.6067 11.241V10.5086C10.3777 10.3622 10.0723 10.3255 9.80511 10.3255C8.81265 10.2523 8.04921 11.0213 8.04921 11.9733ZM14.9201 10.3255L15.7981 12.5225L16.7142 10.3255H17.4013L15.9889 13.6576H15.6454L14.233 10.3255H14.9201ZM17.7067 13.5844H19.5389V13.0352H18.3556V12.1564H19.5007V11.6071H18.3556V10.8748H19.5389V10.3255H17.7067V13.5844ZM20.9131 10.3255C21.6765 10.3255 22.0964 10.6551 22.0964 11.2776C22.1346 11.7536 21.791 12.1564 21.333 12.2296L22.3636 13.5844H21.562L20.6841 12.2662H20.6077V13.5844H19.9588V10.3255H20.9131ZM20.6077 11.8268H20.7986C21.2185 11.8268 21.4093 11.6437 21.4093 11.3142C21.4093 11.0213 21.2185 10.8382 20.7986 10.8382H20.6077V11.8268ZM4.65192 13.5844H5.30084V10.3255H4.65192V13.5844ZM2.47613 13.0352C2.78151 13.0718 3.12505 12.9619 3.35408 12.7788C3.58311 12.5591 3.69763 12.2662 3.69763 11.9367C3.69763 11.6437 3.58311 11.3508 3.35408 11.1311C3.12505 10.948 2.78151 10.8382 2.47613 10.8748H2.28527V13.0352H2.47613ZM2.59065 10.3255H1.63635V13.5844H2.59065C3.01054 13.621 3.43043 13.4745 3.77397 13.2182C4.15569 12.8887 4.38472 12.4493 4.38472 11.9733C4.42289 11.0945 3.69763 10.3622 2.78151 10.3255H2.59065Z"
          fill="white"
        />
      </svg>
    `
  },
  "payment-mastercard": {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 3C22.877 3 24 4.124 24 5.5v13c0 1.376-1.123 2.5-2.5 2.5h-19A2.506 2.506 0 0 1 0 18.5v-13C0 4.124 1.124 3 2.5 3h19zm0 1h-19C1.676 4 1 4.676 1 5.5v13c0 .824.676 1.5 1.5 1.5h19c.824 0 1.5-.676 1.5-1.5v-13c0-.824-.676-1.5-1.5-1.5zM16 7a5.5 5.5 0 1 1 0 11 5.44 5.44 0 0 1-3.737-1.49 5.5 5.5 0 1 1 .001-8.019A5.435 5.435 0 0 1 16 7zM8.5 8a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zM16 8a4.44 4.44 0 0 0-3.072 1.24A5.465 5.465 0 0 1 14 12.5a5.48 5.48 0 0 1-1.07 3.261 4.433 4.433 0 0 0 3.07 1.24 4.5 4.5 0 1 0 0-9z"
        />
      </svg>`
  },
  "payment-mastercardsolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V19C24 20.1046 23.1046 21 22 21H2C0.89543 21 0 20.1046 0 19V5Z"
          fill="black"
        />
        <path d="M9.81738 8H14.1842V15.847H9.81793L9.81738 8Z" fill="#FF5F00" />
        <path
          d="M9.9865 11.9902C9.9865 10.3968 10.7347 8.98221 11.8858 8.06718C11.0406 7.4019 9.97178 7 8.80808 7C6.0488 7 3.81738 9.23142 3.81738 11.9896C3.81738 14.7489 6.04935 16.9814 8.80863 16.9814C9.97342 16.9814 11.0411 16.5795 11.8869 15.9137C10.7363 15.0128 9.98759 13.5852 9.98759 11.9902H9.9865Z"
          fill="#EB001B"
        />
        <path
          d="M19.8864 11.9896C19.8864 14.7489 17.6539 16.9814 14.8951 16.9814C13.7303 16.9814 12.6632 16.5795 11.8174 15.9137C12.9822 14.9986 13.7167 13.5852 13.7167 11.9902C13.7167 10.3968 12.968 8.98221 11.8174 8.06718C12.6626 7.4019 13.7303 7 14.8951 7C17.6544 7 19.8864 9.24505 19.8864 11.9896V11.9896Z"
          fill="#F79E1B"
        />
      </svg>
    `
  },
  "payment-multiplesolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#1F262D" />
        <path
          d="M9.98298 15H13.952V14.046H11.567L11.558 14.019L12.863 12.66C13.646 11.85 13.889 11.265 13.889 10.581C13.889 9.447 12.971 8.763 11.954 8.763C10.946 8.763 10.307 9.267 9.95598 9.933L10.703 10.464C10.982 9.978 11.387 9.735 11.882 9.735C12.44 9.735 12.827 10.149 12.827 10.698C12.827 11.229 12.458 11.679 11.954 12.21L9.96498 14.307L9.98298 15Z"
          fill="white"
        />
        <rect x="1.5" y="4.5" width="21" height="15" rx="0.5" stroke="white" />
      </svg>
    `
  },
  "payment-visa": {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 3C22.877 3 24 4.124 24 5.5v13c0 1.376-1.123 2.5-2.5 2.5h-19A2.506 2.506 0 0 1 0 18.5v-13C0 4.124 1.124 3 2.5 3h19zm0 1h-19C1.676 4 1 4.676 1 5.5v13c0 .824.676 1.5 1.5 1.5h19c.824 0 1.5-.676 1.5-1.5v-13c0-.824-.676-1.5-1.5-1.5zm-6.657 4.945c.137.029.244.058.311.08a.5.5 0 0 1-.308.95 2.162 2.162 0 0 0-.206-.05 2.258 2.258 0 0 0-.665-.048c-.282.029-.454.124-.541.303-.244.498-.049.834.601 1.325.788.594 1.237 1.276 1.063 2.082-.272 1.273-1.367 1.995-2.984 1.298a.5.5 0 0 1 .396-.918c.986.425 1.46.112 1.61-.59.068-.315-.18-.69-.687-1.074-.99-.748-1.42-1.49-.898-2.561.258-.53.743-.8 1.34-.86.32-.032.648-.003.968.063zm3.105.04.735.015a.5.5 0 0 1 .46.333l.022.086.828 5a.5.5 0 0 1-.964.25l-.022-.087-.263-1.583h-1.629l-.649 1.681a.5.5 0 0 1-.56.311l-.086-.025a.5.5 0 0 1-.311-.56l.025-.086 1.937-5.016a.5.5 0 0 1 .477-.32zM6 9a.5.5 0 0 1 .482.367l.016.083.454 4.55h.21l1.874-4.686a.5.5 0 0 1 .954.285l-.026.087-2 5a.5.5 0 0 1-.378.307L7.5 15h-1a.5.5 0 0 1-.482-.367l-.016-.083L5.548 10H4.5a.5.5 0 0 1-.09-.992L4.5 9H6zm5.644.021a.5.5 0 0 1 .353.534l-.018.089-1.5 5a.5.5 0 0 1-.976-.2l.018-.088 1.5-5a.5.5 0 0 1 .623-.335zm6.612 1.026-.755 1.952h1.077l-.322-1.952z"
        />
      </svg>`
  },
  "payment-visasolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#1A1F71" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.3498 10.3592C14.0559 10.3592 13.8041 10.5249 13.7621 10.8147C13.7621 11.0623 14.0761 11.2243 14.4536 11.4189C15.0221 11.712 15.7345 12.0793 15.7345 12.9251C15.7345 14.0427 14.7696 14.7873 13.2171 14.7464C12.7133 14.7464 12.1683 14.6632 11.6645 14.4566L11.9164 13.2974C12.3774 13.5047 12.8812 13.6288 13.385 13.6288C13.8041 13.6288 14.2239 13.4631 14.2239 13.0908C14.2659 12.8426 14.0559 12.6769 13.5109 12.4287C13.0072 12.1798 12.2935 11.7666 12.2935 10.9797C12.2935 9.94532 13.301 9.20001 14.6857 9.20001C15.1047 9.20001 15.5665 9.28322 15.9863 9.44893L15.7345 10.6074C15.3146 10.4008 14.8116 10.3176 14.3498 10.3592ZM7.63653 14.7048H6.12594L4.99319 10.4008C4.93943 10.2028 4.82527 10.0278 4.65734 9.94532C4.23827 9.73801 3.77648 9.57302 3.27271 9.48981V9.32411H5.70613C6.04198 9.32411 6.29387 9.57302 6.33585 9.86211L6.92358 12.9667L8.43343 9.32411H9.90203L7.63653 14.7048ZM10.7417 14.7048H9.31503L10.4898 9.32411H11.9164L10.7417 14.7048ZM20.7273 14.7048L19.5945 9.32411H18.3778C18.1259 9.32411 17.874 9.48981 17.79 9.73801L15.6925 14.7048H17.1611L17.4542 13.9186H19.2586L19.4266 14.7048H20.7273ZM19.0068 12.801L18.5877 10.7731L17.832 12.801H19.0068Z"
          fill="white"
        />
      </svg>
    `
  },
  "payment-nycesolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#EE3A42" />
        <mask id="mask0_2964_135395" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="7" width="22" height="10">
          <path d="M1 12.097V16.6939H23V7.5H1V12.097Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2964_135395)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.4078 8.34793C22.206 8.34793 22.0416 8.18009 22.0416 7.96882C22.0416 7.76048 22.206 7.59205 22.4078 7.59205C22.6086 7.59205 22.7717 7.76048 22.7717 7.96882C22.7717 8.18009 22.6086 8.34793 22.4078 8.34793M21.9266 7.49991L21.6754 8.57564H19.4359L19.2681 9.29573H21.1637L20.889 10.4695H18.9946L18.8103 11.2588H21.139L20.8656 12.4326H17.0309L18.1812 7.49991H16.6096C17.3226 7.79686 17.6102 8.46003 17.477 9.40137H16.0016C16.0808 8.87201 15.8431 8.56801 15.356 8.56801C14.8102 8.56801 14.3607 9.06978 14.1277 10.0528C13.9575 10.7658 13.9428 11.4378 14.7333 11.4378C15.2339 11.4378 15.5608 11.0622 15.7351 10.5751H17.2299C16.7792 11.8897 15.7158 12.6808 14.4634 12.6808C12.8964 12.6808 12.1922 11.6491 12.5854 9.99528C12.8818 8.74759 13.6899 7.8579 14.6394 7.49932H13.7703L11.3641 10.5892L10.9298 12.432H9.42452L9.85118 10.6174L8.90338 7.49991H8.70795L7.5483 12.4326H6.13805L5.13626 9.7171L4.92616 10.8527L4.55643 12.4326H3.11273L4.27297 7.49991H3.01707L1 16.6938H21.0123L23.0006 7.49991H21.9266"
            fill="white"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.5892 8.18135H22.5287L22.4131 7.98651H22.3227V8.18135H22.2699V7.75704H22.4507C22.4847 7.75704 22.5187 7.75704 22.5504 7.78052C22.5798 7.79812 22.5974 7.83627 22.5962 7.87089C22.5962 7.95423 22.5387 7.98475 22.4671 7.98592L22.5903 8.18076L22.5892 8.18135ZM22.4072 7.64906C22.2353 7.64906 22.0962 7.79343 22.0962 7.97066C22.0962 8.15024 22.2353 8.29344 22.4072 8.29344C22.5798 8.29344 22.7165 8.15024 22.7165 7.97066C22.7165 7.79343 22.5798 7.64964 22.4072 7.64964V7.64906Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.3985 7.94604H22.3234V7.79697H22.4384C22.4889 7.79697 22.544 7.8046 22.544 7.86916C22.544 7.95484 22.456 7.94545 22.3985 7.94545"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.4383 7.79754H22.3233V7.94661H22.3984C22.4554 7.94661 22.544 7.95482 22.544 7.86914C22.544 7.80459 22.4888 7.79754 22.4383 7.79754ZM5.71606 7.5L6.69614 10.1679L6.90565 9.03173L7.2654 7.5M10.5225 7.5L10.904 9.13561L12.1129 7.5"
          fill="white"
        />
      </svg>
    `
  },
  "payment-othersolid": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <rect width="24" height="18" rx="2" fill="#8F9296" />
          <circle cx="6" cy="9" r="2" fill="white" />
          <circle cx="12" cy="9" r="2" fill="white" />
          <circle cx="18" cy="9" r="2" fill="white" />
          <rect x="1.5" y="1.5" width="21" height="15" rx="0.5" stroke="white" />
        </g>
      </svg>
    `
  },
  "payment-pixsolid": {
    24: () => html`
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 18" xml:space="preserve">
        <style type="text/css">
            .st0{fill:#121212;}
            .st1{fill:#32BCAD;}
        </style>
        <g>
            <path class="st0" d="M22,18H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h20c1.1,0,2,0.9,2,2v14C24,17.1,23.1,18,22,18z M2,1C1.4,1,1,1.4,1,2v14c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V2c0-0.6-0.4-1-1-1H2z"/>
        </g>
        <g>
            <path class="st1" d="M15.4,12.2c-0.5,0-0.9-0.2-1.2-0.5l-1.8-1.8c-0.1-0.1-0.3-0.1-0.5,0L10,11.7c-0.3,0.3-0.8,0.5-1.2,0.5H8.4l2.3,2.3c0.7,0.7,1.9,0.7,2.6,0l2.3-2.3H15.4z"/>
            <path class="st1" d="M8.8,5.8C9.3,5.8,9.7,6,10,6.3l1.8,1.8c0.1,0.1,0.3,0.1,0.5,0l1.8-1.8c0.3-0.3,0.8-0.5,1.2-0.5h0.2l-2.3-2.3c-0.7-0.7-1.9-0.7-2.6,0L8.4,5.8H8.8z"/>
            <path class="st1" d="M17.5,7.7l-1.4-1.4c0,0-0.1,0-0.1,0h-0.6c-0.3,0-0.6,0.1-0.9,0.4l-1.8,1.8c-0.2,0.2-0.4,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.6-0.3L9.7,6.7C9.4,6.5,9.1,6.3,8.8,6.3H8c0,0-0.1,0-0.1,0L6.5,7.7c-0.7,0.7-0.7,1.9,0,2.6l1.4,1.4c0,0,0.1,0,0.1,0h0.8c0.3,0,0.6-0.1,0.9-0.4l1.8-1.8c0.3-0.3,0.9-0.3,1.2,0l1.8,1.8c0.2,0.2,0.5,0.4,0.9,0.4H16c0,0,0.1,0,0.1,0l1.4-1.4C18.2,9.6,18.2,8.4,17.5,7.7z"/>
        </g>
      </svg>`
  },
  "payment-pulsesolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="black" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.88962 16.1479L3.04046 14.8889H21.7875L21.6987 15.6234C21.6523 15.9802 21.4979 16.1479 21.2578 16.1479H2.88904"
          fill="#ED7523"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5446 10.247C14.0109 10.247 13.5757 10.7262 13.4904 11.3029L13.4127 11.8326C13.3402 12.3907 13.6361 12.8595 14.1437 12.8885L14.1925 12.8902H16.0223L15.9759 13.1826H13.9146C13.5444 13.1838 13.1835 13.2209 13.1371 13.6004L13.0019 14.4956H16.3199C16.867 14.4956 17.3758 14.126 17.4513 13.5499L17.558 12.8235C17.6323 12.2474 17.2424 11.7665 16.6959 11.7665H14.7929L14.8277 11.4926H17.0016C17.5493 11.4926 17.7199 11.4247 17.7947 11.0099L17.9067 10.247H14.5452H14.5446ZM19.5532 11.7601L19.5753 11.593C19.5944 11.4537 19.7203 11.34 19.8578 11.34H21.0094C21.1464 11.34 21.2415 11.4532 21.2229 11.593L21.1997 11.7612H19.5521L19.5532 11.7601ZM18.7874 14.4967H22.15L22.2371 13.9032C22.2852 13.5302 22.1599 13.178 21.7828 13.1821H19.3461L19.4076 12.7609H22.4036L22.6142 11.3255C22.6913 10.7471 22.2893 10.2482 21.7132 10.2482H19.3542C18.7856 10.2482 18.2461 10.7471 18.1695 11.3255L17.8585 13.4489C17.7814 14.028 18.2182 14.4973 18.7868 14.4973L18.7874 14.4967ZM3.10775 11.5796H4.26693C4.55527 11.5796 4.7856 11.7978 4.71946 12.1563L4.66725 12.5137C4.62953 12.8079 4.35976 13.0504 4.07083 13.0504H2.89135L3.10833 11.5796H3.10775ZM4.06967 14.4961C5.01767 14.4961 5.90301 13.6973 6.0289 12.7324L6.13623 11.9921C6.26213 11.0267 5.59552 10.2476 4.64752 10.2476H1.86271L1 16.1473C1 16.1473 2.42141 16.1427 2.43766 16.1473L2.67959 14.4961H4.07025H4.06967ZM22.6931 14.1405C22.7279 14.1405 22.7453 14.1272 22.7453 14.0912C22.7453 14.0709 22.7378 14.043 22.6971 14.043H22.6124V14.1399H22.6919L22.6931 14.1405ZM22.5463 13.9804H22.7099C22.7969 13.9804 22.812 14.0523 22.812 14.0836C22.812 14.1231 22.7946 14.1591 22.7621 14.1707C22.7882 14.1834 22.8027 14.1939 22.8027 14.2623C22.8027 14.3157 22.8027 14.3291 22.8178 14.3354V14.3453H22.7424C22.7383 14.3279 22.7354 14.3088 22.7354 14.271C22.7354 14.2211 22.7325 14.2014 22.6821 14.2014H22.6124V14.3447H22.5457V13.9792L22.5463 13.9804ZM22.9524 14.162C22.9524 13.9995 22.8306 13.869 22.6809 13.8696C22.5301 13.8696 22.4105 14.003 22.4111 14.1643C22.4111 14.3267 22.533 14.4579 22.6826 14.4567C22.8323 14.4567 22.953 14.3244 22.953 14.1626L22.9524 14.162ZM22.6826 14.5112C22.5063 14.5112 22.3635 14.3563 22.3635 14.1643C22.3624 13.9728 22.5045 13.8162 22.6809 13.8162C22.8567 13.8144 23 13.9699 23 14.162C23.0012 14.3534 22.859 14.5101 22.6826 14.5112ZM10.4875 14.4967L11.1083 10.2476H9.62305L9.21345 13.0556H8.21904C8.01772 13.0544 7.84773 12.9222 7.88718 12.6698L8.11345 11.1277C8.16102 10.8144 8.18771 10.2505 7.67832 10.2476H6.73787L6.32479 13.0585C6.19947 13.9984 6.68333 14.4973 7.29367 14.4973H10.4881L10.4875 14.4967ZM12.4949 14.4967H10.998L11.9536 8H12.789C13.3477 8.03481 13.3773 8.53201 13.321 8.87025L12.4972 14.4961L12.4949 14.4967Z"
          fill="#FEFEFE"
        />
      </svg>
    `
  },
  checkingAccount: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M22.5 6a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-20a.5.5 0 1 1 0-1H22V6.5a.5.5 0 0 1 .5-.5zm-2-2a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-12A.5.5 0 0 1 .5 4h20zM20 5H1v11h19V5zm-1.5 8a.5.5 0 1 1 0 1h-16a.5.5 0 1 1 0-1h16zm-9-4a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7zm9-2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h6zM18 8h-5v1h5V8z"
        />
      </svg>`
  },
  creditCard: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 4h-19C1.676 4 1 4.674 1 5.5v13c0 .832.67 1.5 1.5 1.5h19c.825 0 1.5-.674 1.5-1.5v-13c0-.832-.67-1.5-1.5-1.5zm0-1C22.881 3 24 4.116 24 5.5v13c0 1.379-1.124 2.5-2.5 2.5h-19A2.497 2.497 0 0 1 0 18.5v-13C0 4.121 1.124 3 2.5 3h19zm-16 11a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1h2zm5 0a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1h2zm5 0a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1h2zm5 0a.5.5 0 1 1 0 1h-2a.5.5 0 1 1 0-1h2zM9 10.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v4zM8 7H4v3h4V7zm.5 10a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1h5z"
        />
      </svg>`,
    44: () => html` <svg viewBox="0 0 44 44">
        <path
          d="M39.493 7H4.507A3.505 3.505 0 0 0 1 10.505v22.99A3.51 3.51 0 0 0 4.507 37h34.986A3.505 3.505 0 0 0 43 33.495v-22.99A3.51 3.51 0 0 0 39.493 7zm0-1A4.51 4.51 0 0 1 44 10.505v22.99A4.505 4.505 0 0 1 39.493 38H4.507A4.51 4.51 0 0 1 0 33.495v-22.99A4.505 4.505 0 0 1 4.507 6h34.986zM11.5 26a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1h6zm4.004-6a.5.5 0 0 0 .496-.497v-6.006a.496.496 0 0 0-.496-.497H6.496a.5.5 0 0 0-.496.497v6.006c0 .275.222.497.496.497h9.008zm0 1H6.496C5.669 21 5 20.33 5 19.503v-6.006A1.5 1.5 0 0 1 6.496 12h9.008c.827 0 1.496.67 1.496 1.497v6.006A1.5 1.5 0 0 1 15.504 21zm4.996 5a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1h6zm9 0a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1h6zm9 0a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1h6zm-22 5a.5.5 0 1 1 0 1h-11a.5.5 0 1 1 0-1h11z"
        />
      </svg>`
  },
  debitCard: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.5 3C22.881 3 24 4.116 24 5.5v13c0 1.379-1.124 2.5-2.5 2.5h-19A2.497 2.497 0 0 1 0 18.5v-13C0 4.121 1.124 3 2.5 3h19zm0 1h-19C1.676 4 1 4.674 1 5.5v13c0 .832.67 1.5 1.5 1.5h19c.825 0 1.5-.674 1.5-1.5v-13c0-.832-.67-1.5-1.5-1.5zM4.096 9.03c1.575 0 2.583 1.022 2.583 2.492C6.68 12.985 5.714 14 4.118 14H2.515V9.03h1.582zm6.699 0v.756H8.514v1.372h1.841v.756H8.514v1.33h2.429V14H7.667V9.03h3.129zm2.849 0c1.022 0 1.617.399 1.617 1.211 0 .462-.224.924-.735 1.127v.007c.581.14.987.574.987 1.26 0 .791-.532 1.365-1.631 1.365h-1.967V9.03h1.729zm3.682 0V14h-.847V9.03h.847zm4.55 0v.756h-1.428V14h-.847V9.786h-1.407V9.03h3.682zM4.11 9.786h-.749v3.458h.707c1.05 0 1.736-.735 1.736-1.722 0-1.008-.693-1.736-1.694-1.736zm9.534 2.03h-.882v1.428h1.015c.525 0 .854-.231.854-.7 0-.441-.329-.728-.987-.728zm-.091-2.037-.791.007v1.302h.819c.476 0 .819-.189.819-.658 0-.392-.266-.651-.847-.651z"
        />
      </svg>`,
    44: () => html` <svg viewBox="0 0 44 44">
        <path
          d="M39.493 6A4.51 4.51 0 0 1 44 10.505v22.99A4.505 4.505 0 0 1 39.493 38H4.507A4.51 4.51 0 0 1 0 33.495v-22.99A4.505 4.505 0 0 1 4.507 6h34.986zm0 1H4.507A3.505 3.505 0 0 0 1 10.505v22.99A3.51 3.51 0 0 0 4.507 37h34.986A3.505 3.505 0 0 0 43 33.495v-22.99A3.51 3.51 0 0 0 39.493 7zM16.5 31a.5.5 0 1 1 0 1h-11a.5.5 0 1 1 0-1zm-5-5a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1zm9 0a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1zm9 0a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1zm9 0a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1zM7.13 11.9c2.25 0 3.69 1.46 3.69 3.56 0 2.09-1.38 3.54-3.66 3.54H4.87v-7.1h2.26zm9.57 0v1.08h-3.26v1.96h2.63v1.08h-2.63v1.9h3.47V19h-4.68v-7.1h4.47zm4.07 0c1.46 0 2.31.57 2.31 1.73 0 .66-.32 1.32-1.05 1.61v.01c.83.2 1.41.82 1.41 1.8 0 1.13-.76 1.95-2.33 1.95H18.3v-7.1h2.47zm5.26 0V19h-1.21v-7.1h1.21zm6.5 0v1.08h-2.04V19h-1.21v-6.02h-2.01V11.9h5.26zM7.15 12.98H6.08v4.94h1.01c1.5 0 2.48-1.05 2.48-2.46 0-1.44-.99-2.48-2.42-2.48zm13.62 2.9h-1.26v2.04h1.45c.75 0 1.22-.33 1.22-1 0-.63-.47-1.04-1.41-1.04zm-.13-2.91-1.13.01v1.86h1.17c.68 0 1.17-.27 1.17-.94 0-.56-.38-.93-1.21-.93z"
        />
      </svg>`
  },
  giftCard: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M11 1c1.66 0 3 1.337 3 3 0 .351-.06.688-.17 1.001L21.5 5C22.883 5 24 6.116 24 7.5v13c0 1.379-1.124 2.5-2.5 2.5h-19A2.497 2.497 0 0 1 0 20.5v-13C0 6.122 1.122 5 2.495 5l.675.001A3.01 3.01 0 0 1 3 4c0-1.663 1.34-3 3-3 1.047 0 1.965.531 2.501 1.339A2.985 2.985 0 0 1 11 1zM8 12H1v8.5c0 .832.67 1.5 1.5 1.5H8V12zm15 0H9v10h12.5c.825 0 1.5-.674 1.5-1.5V12zm-6.5 7a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1h3zm4-2a.5.5 0 1 1 0 1h-7a.5.5 0 1 1 0-1h7zM3.76 6H2.496C1.675 6 1 6.674 1 7.5V11h7V7H6a2.99 2.99 0 0 1-2.24-1zM21.5 6h-8.26A2.99 2.99 0 0 1 11 7H9v4h14V7.5c0-.832-.67-1.5-1.5-1.5zM11 2c-1.11 0-2 .892-2 2v2h2a1.993 1.993 0 0 0 2-2c0-1.11-.892-2-2-2zM6 2c-1.108 0-2 .89-2 2a1.996 1.996 0 0 0 2 2h2V4l-.005-.15A1.993 1.993 0 0 0 6 2z"
        />
      </svg>`
  },
  "payment-interacsolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 3H22C23.1 3 24 3.87568 24 4.94595V19.0541C24 20.1243 23.1 21 22 21H2C0.9 21 0 20.1243 0 19.0541V4.94595C0 3.87568 0.9 3 2 3Z"
          fill="#FDB913"
        />
        <path
          d="M13.375 11.3828V7.48284L14.375 7.28284V7.78284C14.375 7.78284 14.675 7.08284 15.275 6.98284C15.375 6.98284 15.475 6.98284 15.575 6.98284V7.98284C15.375 7.98284 15.175 7.98284 15.075 8.08284C14.675 8.28284 14.475 8.58284 14.475 9.08284V11.2828L13.375 11.3828Z"
          fill="black"
        />
        <path
          d="M7.9749 12.6828C7.9749 12.6828 7.7749 12.3828 7.7749 11.5828V9.58284L7.2749 9.68284V8.88284L7.7749 8.78284V7.88284L8.8749 7.58284V8.48284L9.6749 8.28284V9.18284L8.8749 9.38284C8.8749 9.38284 8.8749 10.9828 8.8749 11.3828C8.8749 12.2828 9.0749 12.4828 9.0749 12.4828L7.9749 12.6828Z"
          fill="black"
        />
        <path
          d="M9.7749 10.3828C9.7749 9.68284 9.8749 9.18284 10.0749 8.78284C10.3749 8.28284 10.7749 7.98284 11.3749 7.88284C12.5749 7.58284 12.9749 8.28284 12.9749 9.28284C12.9749 9.58284 12.9749 9.78284 12.9749 9.78284L10.8749 10.2828C10.8749 10.9828 10.9749 11.2828 11.4749 11.1828C11.8749 11.0828 11.9749 10.8828 11.9749 10.5828V10.3828L12.9749 10.1828C12.9749 10.1828 12.9749 10.2828 12.9749 10.3828C12.9749 10.7828 12.8749 11.6828 11.4749 11.9828C10.0749 12.2828 9.7749 11.4828 9.7749 10.3828ZM11.3749 8.58284C10.9749 8.68284 10.8749 8.98284 10.8749 9.58284L11.9749 9.28284C11.9749 9.28284 11.9749 9.18284 11.9749 9.08284C11.8749 8.68284 11.7749 8.48284 11.3749 8.58284Z"
          fill="black"
        />
        <path
          d="M19.2749 8.08284C19.2749 6.88284 19.5749 5.88284 20.8749 5.58284C21.7749 5.38284 22.0749 5.58284 22.1749 5.78284C22.3749 5.98284 22.3749 6.28284 22.3749 6.68284V6.78284L21.3749 6.98284V6.88284C21.3749 6.38284 21.2749 6.28284 20.8749 6.38284C20.4749 6.48284 20.2749 6.88284 20.2749 7.58284C20.2749 7.88284 20.2749 7.88284 20.2749 7.88284C20.2749 8.68284 20.3749 8.98284 20.8749 8.88284C21.2749 8.78284 21.3749 8.48284 21.3749 8.18284V7.98284L22.3749 7.78284C22.3749 7.78284 22.3749 7.88284 22.3749 7.98284C22.3749 8.98284 21.8749 9.58284 20.8749 9.88284C19.5749 10.0828 19.2749 9.28284 19.2749 8.08284Z"
          fill="black"
        />
        <path
          d="M15.6749 9.78284C15.6749 8.88284 16.1749 8.58284 16.9749 8.28284C17.6749 7.98284 17.6749 7.88284 17.6749 7.58284C17.6749 7.38284 17.5749 7.18284 17.1749 7.28284C16.9749 7.28284 16.7749 7.58284 16.7749 7.78284C16.7749 7.88284 16.7749 7.88284 16.7749 7.98284L15.7749 8.18284C15.7749 7.98284 15.7749 7.78284 15.8749 7.58284C16.0749 7.08284 16.4749 6.68284 17.3749 6.48284C18.4749 6.28284 18.7749 6.68284 18.7749 7.48284V9.18284C18.7749 9.98284 18.9749 10.1828 18.9749 10.1828L17.9749 10.3828C17.8749 10.2828 17.8749 10.1828 17.8749 9.98284C17.8749 9.98284 17.6749 10.4828 16.8749 10.6828C16.0749 10.8828 15.6749 10.3828 15.6749 9.78284ZM17.6749 8.48284C17.4749 8.58284 17.3749 8.68284 17.1749 8.78284C16.8749 8.98284 16.6749 9.18284 16.6749 9.48284C16.6749 9.78284 16.8749 9.88284 17.1749 9.88284C17.4749 9.78284 17.6749 9.48284 17.6749 9.08284V8.48284Z"
          fill="black"
        />
        <path
          d="M2.175 15.4828C1.975 15.4828 1.775 15.3828 1.575 15.1828C1.475 14.9828 1.475 14.6828 1.575 14.5828L3.075 14.1828V15.2828C2.775 15.3828 2.375 15.4828 2.275 15.4828C2.275 15.4828 2.275 15.4828 2.175 15.4828Z"
          fill="black"
        />
        <path
          d="M2.17495 16.8828C1.87495 16.8828 1.57495 16.5828 1.57495 16.2828C1.57495 16.1828 1.57495 16.0828 1.67495 15.9828L3.17495 15.5828V16.6828C2.87495 16.7828 2.47495 16.8828 2.37495 16.8828C2.27495 16.8828 2.27495 16.8828 2.17495 16.8828Z"
          fill="black"
        />
        <path
          d="M2.17495 18.3828C1.87495 18.3828 1.57495 18.0828 1.57495 17.7828C1.57495 17.6828 1.57495 17.5828 1.67495 17.4828L3.17495 17.0828V18.1828C2.77495 18.2828 2.37495 18.3828 2.37495 18.3828C2.27495 18.3828 2.27495 18.3828 2.17495 18.3828Z"
          fill="black"
        />
        <path d="M2.07495 14.0828V7.78284L3.17495 7.48284V13.7828L2.07495 14.0828Z" fill="black" />
        <path
          d="M5.875 9.18284C5.475 9.28284 5.075 9.48284 4.875 9.88284V9.48284L3.875 9.68284V12.4828C4.275 12.3828 4.675 12.3828 4.975 12.6828V10.8828C4.975 10.4828 5.175 10.0828 5.475 9.98284C5.675 9.88284 5.875 9.98284 5.875 10.4828V13.1828L6.975 12.8828V10.0828C6.975 9.38284 6.675 8.98284 5.875 9.18284Z"
          fill="black"
        />
        <path
          d="M4.87498 13.5828C4.87498 13.1828 4.57498 12.8828 4.17498 12.8828C3.77498 12.8828 3.47498 13.1828 3.47498 13.5828V19.1828H7.37498V18.9828C7.37498 17.6828 7.37498 16.2828 7.37498 16.2828C7.37498 15.9828 7.17498 15.6828 6.97498 15.4828L5.27498 14.1828C5.27498 14.1828 5.27498 16.7828 5.27498 16.9828C5.27498 17.0828 5.17498 17.1828 5.07498 17.1828C4.97498 17.1828 4.87498 17.0828 4.87498 16.9828C4.87498 16.8828 4.87498 13.8828 4.87498 13.5828Z"
          fill="black"
        />
      </svg>
    `
  },
  phone: {
    24: () => html`<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5795 14.5973C19.4095 13.4272 17.5126 13.4272 16.3424 14.5974L15.8808 15.0591C13.4077 12.9884 11.0084 10.5892 8.94209 8.11985L9.40376 7.65814L9.40403 7.65786C10.5726 6.48766 10.5726 4.58979 9.40403 3.41959L6.8602 0.876717C5.69134 -0.292255 3.79204 -0.292255 2.62308 0.876816L1.22789 2.27213C-0.182293 3.68245 -0.402228 5.88571 0.698708 7.55056C4.79449 13.7445 10.2554 19.2059 16.45 23.3033C18.1123 24.4032 20.3205 24.182 21.7271 22.7724L23.1229 21.3777C24.2933 20.2088 24.2933 18.3117 23.1234 17.1402L20.5795 14.5973ZM6.01286 1.72443L8.55642 4.26703C9.25724 4.96882 9.25728 6.10843 8.55617 6.81064L7.7089 7.658C7.4911 7.87581 7.47386 8.22326 7.66902 8.46158C9.97549 11.278 12.718 14.0205 15.539 16.3323C15.7773 16.5276 16.1248 16.5104 16.3426 16.2925L17.1901 15.445C17.8921 14.7429 19.0301 14.7429 19.7322 15.445L22.2758 17.9876C22.9777 18.6906 22.9777 19.8287 22.2759 20.5296L20.8794 21.925C19.8754 22.9312 18.2987 23.0891 17.1114 22.3035C11.0512 18.295 5.70542 12.9487 1.69857 6.88931C0.911597 5.69924 1.06856 4.12682 2.07554 3.11975L3.47072 1.72443C4.1716 1.02349 5.31198 1.02349 6.01286 1.72443Z"
        />
      </svg> `
  },
  phoneSupport: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 0a8.001 8.001 0 0 1 7.938 7H21c1.663 0 3 1.34 3 3v5c0 1.663-1.34 3-3 3h-1v1.5a2.5 2.5 0 0 1-2.505 2.5H15v1.5a.5.5 0 0 1-.41.492L14.5 24h-5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5l-.001.5h2.496A1.5 1.5 0 0 0 19 19.5V18h-.5a.5.5 0 0 1-.492-.41L18 17.5v-10a.5.5 0 0 1 .5-.5h.43A7.002 7.002 0 0 0 5.07 7h.43a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3c-1.66 0-3-1.337-3-3v-5c0-1.66 1.337-3 3-3h1.062A8.001 8.001 0 0 1 12 0zm2 21h-4v2h4v-2zM5 8H3c-1.11 0-2 .892-2 2v5c0 1.11.892 2 2 2h2V8zm16 0h-2v9h2c1.108 0 2-.89 2-2v-5c0-1.108-.89-2-2-2zm-5.276 5.053a.5.5 0 0 1 .223.67c-.151.303-.452.729-.927 1.15C14.23 15.577 13.223 16 12 16s-2.23-.424-3.02-1.126c-.475-.422-.776-.848-.927-1.15a.5.5 0 1 1 .894-.448c.099.198.329.522.698.85.615.548 1.39.874 2.355.874.964 0 1.74-.326 2.355-.874.37-.328.6-.652.698-.85a.5.5 0 0 1 .67-.223zM9.5 8a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5z"
        />
      </svg>`
  },
  pieChart: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M7 2.052C3.324 2.446 1 5.021 1 8.5A6.5 6.5 0 0 0 7.5 15c3.48 0 6.054-2.324 6.448-6H7V2.052zM8 1v7h7c0 5-3.358 8-7.5 8A7.5 7.5 0 0 1 0 8.5C0 4.358 3 1 8 1zm2 .083V6h4.917A6.005 6.005 0 0 0 10 1.083zM16 7H9V0a7 7 0 0 1 7 7z"
        />
      </svg>`
  },
  pricingLog: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M14 0c.587 0 1 .448 1 1v14c0 .552-.413 1-1 1H2.125c-.587 0-1.063-.448-1.063-1v-3H.5a.5.5 0 1 1 0-1h.562V8H.5a.5.5 0 0 1 0-1h.562V4H.5a.5.5 0 0 1 0-1l.562-.001V1c0-.552.476-1 1.063-1H14zM2 1v2h.5a.5.5 0 0 1 0 1H2v3h.5a.5.5 0 0 1 0 1H2v3h.5a.5.5 0 1 1 0 1H2v3h12V1H2zm6.006 2 .09.008a.511.511 0 0 1 .416.497v1.074c.738.081 1.459.39 1.985.886.202.19.21.507.016.707a.51.51 0 0 1-.716.016c-.712-.673-1.994-.846-2.77-.33-.37.246-.51.573-.39.815.125.251.447.459 1.07.706.097.039.441.17.505.196l.164.065v.001c.126.05.345.134.425.165.843.335 1.329.649 1.599 1.192.375.751.019 1.587-.733 2.087-.344.228-.74.37-1.154.433v.977a.508.508 0 0 1-.507.505l-.089-.008a.511.511 0 0 1-.417-.497v-.976c-.697-.1-1.37-.4-1.868-.87a.496.496 0 0 1-.017-.708.51.51 0 0 1 .716-.016c.712.672 1.995.845 2.77.33.372-.247.511-.574.39-.815-.124-.251-.446-.459-1.068-.706-.097-.039-.442-.17-.506-.196l-.164-.066-.085-.033-.191-.075a23.734 23.734 0 0 1-.147-.057c-.845-.335-1.331-.649-1.602-1.194-.373-.75-.017-1.585.734-2.085a2.815 2.815 0 0 1 1.039-.414L7.5 3.504c0-.275.227-.504.506-.504z"
        />
      </svg>`
  },
  relatedOrders: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M6 13v2h9V3.998C15 4 13.667 4 11 4H6.01c-.008 0-.011 2.667-.01 8v1zm-1 0H.996A.997.997 0 0 1 0 12.001V1c0-.554.445-1 .996-1h9.008c.55 0 .996.447.996.999V3h3.929a1.01 1.01 0 0 1 1.015.998L16 15.002a.99.99 0 0 1-.99.999H5.995a.998.998 0 0 1-.995-1V13zm5-10V1H1v11h4v-2H3.5a.5.5 0 0 1 0-1H5V7H3.5a.5.5 0 0 1 0-1H5V4H3.5a.5.5 0 0 1 0-1H10zm-1.5 9h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0-3h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0-3h1.733a.5.5 0 1 1 0 1H8.5a.5.5 0 0 1 0-1z"
        />
      </svg>`
  },
  cleanVenue: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M9.5 1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5l-1.454.001a2.74 2.74 0 0 0 1.297 1.854l.17.092.21.106a.5.5 0 0 1-.363.927l-.084-.033-.21-.105a3.736 3.736 0 0 1-1.985-2.57l-.002-.002L6 4.81v1.039l.916 1.375a.5.5 0 0 1 .074.18L7 7.5V14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7.5a.5.5 0 0 1 .084-.277L2 5.847V5H.5a.5.5 0 0 1-.492-.41L0 4.5A3.5 3.5 0 0 1 3.5 1zM5 5H3v1a.5.5 0 0 1-.038.19l-.046.087L2 7.651V14h4V7.653l-.916-1.376a.5.5 0 0 1-.074-.18L5 6V5zm10.5-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm-2-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM7 2H3.5c-1.16 0-2.135.79-2.418 1.86L1.05 4h4.33L7 3.19V2zm2 0H8v1h1V2zm6.5 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm-4 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm2-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm2-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13.5 2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2.466a3.663 3.663 0 0 0 2.286 2.907l.184.067.154.052a.5.5 0 0 1-.228.97l-.088-.022-.154-.051a4.663 4.663 0 0 1-3.123-3.646l-1.341.67a.5.5 0 0 1-.147.047L8.5 7H8v1.867l1.934 3.385a.5.5 0 0 1 .059.162L10 12.5v8A1.5 1.5 0 0 1 8.5 22h-6A1.5 1.5 0 0 1 1 20.5v-8a.5.5 0 0 1 .066-.248L3 8.865V7H.5a.5.5 0 0 1-.492-.41L0 6.5A4.5 4.5 0 0 1 4.5 2zM7 7H4v2a.5.5 0 0 1-.007.086l-.023.084-.036.078L2 12.633V20.5a.5.5 0 0 0 .41.492L2.5 21h6a.5.5 0 0 0 .5-.5v-7.866L7.066 9.248a.5.5 0 0 1-.059-.162L7 9V7zm16-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM10 2.999 4.5 3a3.5 3.5 0 0 0-3.454 2.932L1.036 6h7.346L10 5.19V2.999zM23 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-4.001-.001H11V5l1.999-.001v-2zM20 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
        />
      </svg>`
  },
  handSanitizer: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M7.543 1.297a.5.5 0 0 1 .914 0c.304.684.633 1.304.996 1.889.521.841 2.18 2.969 2.309 3.124l.167.236C12.666 7.636 13 8.634 13 10c0 2.636-2.027 5-5 5s-5-2.364-5-5c0-1.464.383-2.504 1.235-3.69l.306-.386c.48-.618 1.397-1.818 1.867-2.523l.14-.215c.362-.585.691-1.205.995-1.89zM8 2.649l-.156.296-.22.389-.227.378c-.456.736-1.68 2.335-2.16 2.948l-.19.234-.151.217C4.267 8.041 4 8.851 4 10c0 2.114 1.616 4 4 4s4-1.886 4-4c0-1.238-.31-2.08-1.047-3.106l-.44-.556c-.477-.619-1.229-1.611-1.687-2.285l-.223-.34c-.155-.25-.304-.505-.447-.768L8 2.65zM10.5 9a.5.5 0 0 1 .5.5c0 1.803-.703 2.928-2.342 3.474a.5.5 0 1 1-.316-.948C9.545 11.625 10 10.896 10 9.5a.5.5 0 0 1 .5-.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M11.533 2.32a.5.5 0 0 1 .934 0A19.387 19.387 0 0 0 14.68 6.5c.14.202.363.504.62.845l1.89 2.465C18.437 11.54 19 13 19 15c0 3.776-3.224 7-7 7s-7-3.224-7-7c0-2 .563-3.46 1.811-5.19.117-.161.679-.883 1.257-1.636l.267-.348a67.2 67.2 0 0 0 .719-.956l.266-.37a19.387 19.387 0 0 0 2.213-4.18zM12 3.798l-.207.447a20.602 20.602 0 0 1-1.65 2.824c-.22.317-.623.853-1.044 1.405l-.282.368c-.562.732-1.091 1.411-1.195 1.554l-.193.274C6.432 12.117 6 13.337 6 15c0 3.224 2.776 6 6 6s6-2.776 6-6c0-1.767-.488-3.034-1.622-4.605l-.035-.047c-.286-.381-1.664-2.14-2.314-3.039l-.172-.241a20.602 20.602 0 0 1-1.65-2.824L12 3.797zM15.5 14a.5.5 0 0 1 .5.5c0 2.446-1.124 3.921-3.379 4.485a.5.5 0 0 1-.242-.97C14.183 17.564 15 16.492 15 14.5a.5.5 0 0 1 .5-.5z"
        />
      </svg>`
  },
  mask: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m8.09 2.008 4.678.85a1.5 1.5 0 0 1 1.223 1.309 3.002 3.002 0 0 1-.305 5.754A6.008 6.008 0 0 1 7.99 14l-.231-.005A6.002 6.002 0 0 1 2.314 9.92a3 3 0 0 1-.305-5.752 1.5 1.5 0 0 1 1.223-1.31l4.679-.85h.178zM8 3.007l-4.59.836a.5.5 0 0 0-.41.492v-.012V5h-.001L3 8a5 5 0 0 0 4.568 4.982l.22.014L8 13a5 5 0 0 0 5-5V4.335a.5.5 0 0 0-.41-.492L8 3.007zM10.5 10l.09.008a.5.5 0 0 1-.09.992h-5l-.09-.008A.5.5 0 0 1 5.5 10h5zm3.501-4.732L14 8c0 .257-.016.51-.048.759a1.999 1.999 0 0 0 .05-3.49zM1 7a2 2 0 0 0 1.048 1.76A5.98 5.98 0 0 1 2 8V5.268A2 2 0 0 0 1 7zm10.5 0 .09.008A.5.5 0 0 1 11.5 8h-7l-.09-.008A.5.5 0 0 1 4.5 7h7z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m12.038 3.001.077.012 6.958 1.637A2.5 2.5 0 0 1 21 7.084l-.001-.049A3.5 3.5 0 0 1 24 10.5v1l-.005.192A3.5 3.5 0 0 1 20.487 15a9.005 9.005 0 0 1-8.494 6l-.263-.004a9.003 9.003 0 0 1-8.218-5.997L3.5 15a3.5 3.5 0 0 1-3.495-3.308L0 11.5v-1a3.5 3.5 0 0 1 3.001-3.465A2.499 2.499 0 0 1 4.927 4.65l6.958-1.637a.5.5 0 0 1 .23 0zM12 4.013l-6.844 1.61A1.5 1.5 0 0 0 4 7.085v.406a.51.51 0 0 1 0 .01l-.001.01L4 12c0 4.245 3.312 7.733 7.505 7.985l.247.011L12 20a8 8 0 0 0 8-8V7.084a1.5 1.5 0 0 0-1.156-1.46L12 4.013zM15.5 16l.09.008a.5.5 0 0 1-.09.992h-7l-.09-.008A.5.5 0 0 1 8.5 16h7zM21 8.05V12a9.03 9.03 0 0 1-.22 1.984A2.5 2.5 0 0 0 23 11.5v-1l-.005-.164A2.501 2.501 0 0 0 21 8.05zM1.005 10.336 1 10.5v1a2.5 2.5 0 0 0 2.219 2.484A9.072 9.072 0 0 1 3 12V8.05a2.501 2.501 0 0 0-1.995 2.286zM17.5 12l.09.008a.5.5 0 0 1-.09.992h-11l-.09-.008A.5.5 0 0 1 6.5 12h11z"
        />
      </svg>`
  },
  socialDistance: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 1a3 3 0 0 1 1.778 5.417A3.998 3.998 0 0 1 12 10.009V14.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4.491a4.01 4.01 0 0 1 2.225-3.59A3 3 0 0 1 8 1zm.021 5.999L8 7h-.01l-.155.004A3.008 3.008 0 0 0 5 10.01V14h6v-3.991a2.999 2.999 0 0 0-2.823-3.004L8.02 7zm5.767-2.907.066.055 2.012 2.013a.503.503 0 0 1 .134.32v.02l-.004.053.001-.007a.392.392 0 0 1-.02.105l-.015.04a.494.494 0 0 1-.04.076l-.027.039-.031.035.027-.03-.009.011a.503.503 0 0 1-.017.02l-2.011 2.012a.5.5 0 0 1-.847-.268L13 8.501v-1.5h-1.5a.5.5 0 0 1-.09-.992l.09-.008H13v-1.5a.5.5 0 0 1 .788-.41zM.135 6.16l2.011-2.013a.5.5 0 0 1 .847.268L3 4.501v1.5h1.5a.5.5 0 0 1 .09.992L4.5 7H3v1.5a.5.5 0 0 1-.788.41l-.066-.056L.134 6.842a.503.503 0 0 1-.123-.236l-.006-.03A.51.51 0 0 1 0 6.512V6.5l.005-.074.006-.031a.513.513 0 0 1 .012-.046l.015-.04a.494.494 0 0 1 .04-.076l.024-.035.002-.005.005-.005-.007.01a.503.503 0 0 1 .033-.04zM8 2a2 2 0 1 0 0 4l-.015-.001.031.001A2 2 0 0 0 8 2z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 2a4 4 0 0 1 2.128 7.388A6.003 6.003 0 0 1 18 15.008V21.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-6.492A6.014 6.014 0 0 1 9.877 9.39 4 4 0 0 1 12 2zm.024 7.999L12 10h-.018l-.183.004A5.009 5.009 0 0 0 7 15.008V21l10-.001v-5.99c0-2.7-2.12-4.89-4.783-5.004l-.193-.006zm8.764-3.907.066.055 3.012 3.013a.503.503 0 0 1 .134.32v.04l-.002.019V9.52l-.003.052.002-.026a.392.392 0 0 1-.02.105l-.015.04a.494.494 0 0 1-.04.076l-.027.039-.031.035.027-.03-.009.011a.503.503 0 0 1-.017.02l-3.011 3.012a.5.5 0 0 1-.847-.268L20 12.501v-2.5h-2.5a.5.5 0 0 1-.09-.992l.09-.008H20v-2.5a.5.5 0 0 1 .788-.41zM.135 9.16l3.011-3.013a.5.5 0 0 1 .847.268L4 6.501v2.5h2.5a.5.5 0 0 1 .09.992L6.5 10H4v2.5a.5.5 0 0 1-.788.41l-.066-.056L.134 9.842a.503.503 0 0 1-.123-.236l-.006-.03A.51.51 0 0 1 0 9.512V9.5l.005-.074.006-.031a.513.513 0 0 1 .012-.046l.015-.04a.494.494 0 0 1 .04-.076l.024-.035.002-.005.005-.005-.007.01a.503.503 0 0 1 .033-.04zM12 3a3 3 0 0 0 0 6l-.019-.001.037.001A3 3 0 0 0 12 3z"
        />
      </svg>`
  },
  temperature: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M14.642 1.414a2 2 0 0 1 0 2.829L7.03 11.855l.006.14a2.993 2.993 0 0 1-.74 1.998l-.14.15A3 3 0 1 1 4.063 9.02l.14.005 1.662-1.662 5.95-5.95a2 2 0 0 1 2.598-.198l.12.097zm-.707.707a1 1 0 0 0-1.414 0l-5.95 5.95 1.414 1.414L10.4 7.071l-.353-.353-.058-.07a.5.5 0 0 1 .765-.638l.354.354.707-.708-.354-.353-.058-.069a.5.5 0 0 1 .765-.638l.355.353 1.413-1.413a1 1 0 0 0 .078-1.327z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M21.256 2.828a3.003 3.003 0 0 1 .124 4.111l-.124.132-6.657 6.657-2.535 2.535.024.198a5.022 5.022 0 0 1-.405 2.544 4.99 4.99 0 0 1-.868 1.327l-.166.174a5 5 0 1 1-3.026-8.51l.197.024 9.193-9.192a3 3 0 0 1 4.115-.12zm-.707.708-.11-.102a2 2 0 0 0-2.718.102l-6.658 6.656 2.829 2.828 3.121-3.12-1.06-1.061-.058-.07a.5.5 0 0 1 .765-.637l1.06 1.06 1.415-1.414-1.06-1.06-.059-.07a.5.5 0 0 1 .765-.638l1.06 1.061.697-.695.101-.108a2 2 0 0 0-.09-2.732z"
        />
      </svg>`
  },
  time: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 2a.5.5 0 0 1 .492.41l.008.09v3.217l2.257 1.354a.5.5 0 0 1 .211.605l-.04.081a.5.5 0 0 1-.604.211l-.081-.04-2.5-1.5a.5.5 0 0 1-.235-.342L7.5 8V4.5A.5.5 0 0 1 8 4z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 2a.5.5 0 0 1 .492.41l.008.09v6.256l4.307 3.35a.5.5 0 0 1 .136.625l-.048.076a.5.5 0 0 1-.626.136l-.076-.048-4.5-3.5a.5.5 0 0 1-.185-.304L11.5 12V5.5A.5.5 0 0 1 12 5z"
        />
      </svg>`
  },
  seat: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M11.08 0a1.5 1.5 0 0 1 1.495 1.375L12.96 6H15a1 1 0 0 1 1 1v1.5a.5.5 0 0 1-.5.5H15v5.5a1.5 1.5 0 0 1-3 0 .5.5 0 1 1 1 0 .5.5 0 1 0 1 0v-6a.5.5 0 0 1 .5-.5h.5V7h-3v1h.5a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0V9h-.5a.5.5 0 0 1-.5-.5V7a1 1 0 0 1 .956-1l-.378-4.542A.5.5 0 0 0 11.08 1H4.92a.5.5 0 0 0-.498.458l-.378 4.543A1 1 0 0 1 5 7v1.5a.5.5 0 0 1-.5.5H4v.5a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5H4V7H1v1h.5a.5.5 0 0 1 .5.5v6a.5.5 0 1 0 1 0 .5.5 0 1 1 1 0 1.5 1.5 0 0 1-3 0V9H.5a.5.5 0 0 1-.5-.5V7a1 1 0 0 1 1-1l2.039-.001.386-4.624A1.5 1.5 0 0 1 4.784.006L4.92 0zM11 10a2 2 0 0 1 2 2v.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 12.5V12a2 2 0 0 1 2-2h6zm0 1H5a1 1 0 0 0-1 1v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V12a1 1 0 0 0-1-1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16.108 0a2.5 2.5 0 0 1 2.496 2.361L18.973 9H22.5a1.5 1.5 0 0 1 1.5 1.5v2a.5.5 0 0 1-.5.5H22v9a2 2 0 1 1-4 0v-.5a.5.5 0 1 1 1 0v.5a1 1 0 0 0 2 0v-9.5a.5.5 0 0 1 .5-.5H23v-1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V12h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0V13h-1.5a.5.5 0 0 1-.5-.5v-2A1.5 1.5 0 0 1 17.5 9h.471l-.365-6.583a1.5 1.5 0 0 0-1.359-1.41L16.108 1H7.892a1.5 1.5 0 0 0-1.498 1.417L6.028 9H6.5a1.5 1.5 0 0 1 1.493 1.356L8 10.5v2.042a.5.5 0 0 1-.5.5H6v.458a.5.5 0 1 1-1 0v-.958a.5.5 0 0 1 .5-.5H7V10.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V12h1.5a.5.5 0 0 1 .5.5V22a1 1 0 0 0 2 0v-.5a.5.5 0 1 1 1 0v.5a2 2 0 1 1-4 0v-9H.5a.5.5 0 0 1-.5-.5v-2A1.5 1.5 0 0 1 1.5 9h3.526l.37-6.639A2.5 2.5 0 0 1 7.727.005L7.892 0zM17.5 15a2.5 2.5 0 0 1 2.5 2.5v1a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-1A2.5 2.5 0 0 1 6.5 15h11zm0 1h-11A1.5 1.5 0 0 0 5 17.5v1a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1a1.5 1.5 0 0 0-1.5-1.5z"
        />
      </svg>`
  },
  stadium: {
    24: () => html` <svg viewBox="0 0 21 24">
        <path 
          fill-rule="evenodd" 
          clip-rule="evenodd" 
          d="M2.78859 1.72401L3.62742 1L8.07199 2.67167L8.06659 4.12168L4.07562 5.57725V7.45224L4.88398 7.04317H13.9429V1.72401L14.7817 1L19.2263 2.67167L19.2209 4.12168L15.2299 5.57725V7.04317H15.7086L19.7346 9.08049V10.792V11.5912V20.6385L16.4846 23H4.10799L0.858032 20.6385V11.5912V10.792V9.08049L2.78859 8.10354V1.72401ZM2.14507 12.2425V14.0024L4.85374 15.4016H7.93674V15.4015H13.0849V15.4016H15.7388L18.4475 14.0023V12.2425L15.9514 13.5057L15.4445 13.6285H4.88398L2.14507 12.2425ZM2.14507 17.0417V15.6611L4.58452 16.9213H7.93674V18.441H4.85374L2.14507 17.0417ZM2.14507 18.7005V19.7893L4.47227 21.4803H7.93674V19.9607H4.58452L2.14507 18.7005ZM9.22377 21.4803V16.9213H11.7978V21.4803H9.22377ZM13.0849 18.441V16.9213H15.8735L16.1314 16.8576L18.4475 15.6611V17.0417L15.7388 18.441H13.0849ZM13.0849 19.9607V21.4803H16.1203L18.4475 19.7893V18.7005L16.1314 19.897L15.8735 19.9607H13.0849ZM4.07562 3.98671L5.72674 3.38452L4.07562 2.76351V3.98671ZM15.2299 3.98671L16.8811 3.38452L15.2299 2.76351V3.98671ZM15.4445 12.1088H5.14816L2.14507 10.5891V10.0826L5.14816 8.56287H15.4445L18.4475 10.0826V10.5891L15.4445 12.1088Z"
        />
      </svg>
    `
  },
  standardMail: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.5 17H12v6h2.5a.5.5 0 1 1 0 1h-8a.5.5 0 1 1 0-1H9v-6H3.5c-.825 0-1.5-.676-1.5-1.495V10.51A4.505 4.505 0 0 1 6.51 6h5.99a.5.5 0 1 1 0 1H6.51A3.505 3.505 0 0 0 3 10.51v4.995c0 .267.228.495.5.495h14c.278 0 .5-.22.5-.495v-8.01A.504.504 0 0 0 17.5 7h-1a.5.5 0 1 1 0-1h1c.825 0 1.5.676 1.5 1.495V8h2.5a.5.5 0 0 1 .495.57l-1 7a.5.5 0 0 1-.495.43h-1.584c-.204.583-.76 1-1.417 1zm1.5-2h1.066l.857-6H19v6zM14 4H9.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v8a.5.5 0 1 1-1 0V4zm0-1V1h-4v2h4zm-3 14h-1v6h1v-6z"
        />
      </svg>`
  },
  starRatingDuotone: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          fill-opacity=".65"
          d="M7.994 11.496 4.04 14l.74-4.785L1 6.028l5.008-.504L8 1l1.979 4.524L15 6.028l-3.794 3.187.825 4.785z"
        />
        <path d="M7.994 11.496 4.04 14l.74-4.785L1 6.028l5.008-.504L8 1z" />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          fill-opacity=".65"
          d="M11.99 18.147 5.78 22l1.163-7.362L1 9.736l7.87-.776L12 2l3.11 6.96 7.89.776-5.962 4.902L18.335 22z"
        />
        <path d="M11.99 18.147 5.78 22l1.163-7.362L1 9.736l7.87-.776L12 2z" />
      </svg>`
  },
  starRatingSolid: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path d="M7.994 11.496 4.04 14l.74-4.785L1 6.028l5.008-.504L8 1l1.979 4.524L15 6.028l-3.794 3.187.825 4.785z" />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path d="M11.99 18.147 5.78 22l1.163-7.362L1 9.736l7.87-.776L12 2l3.11 6.96 7.89.776-5.962 4.902L18.335 22z" />
      </svg>`
  },
  "payment-starsolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#C7003E" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.42621 10.2196C4.24907 9.49044 6.07479 8.81598 8.27979 8.42564C10.0348 8.11513 11.4169 7.9605 13.3314 7.85993C15.0748 7.77005 15.2342 7.77193 15.2342 7.89262C15.2342 7.94793 15.2117 7.99319 15.1828 7.99319C14.8215 7.99759 12.6904 8.1409 12.1903 8.19433C9.58543 8.4753 7.85293 9.14221 7.06993 10.1668L6.75879 10.5753L3.0225 10.5779L3.4275 10.2196H3.42621ZM16.6324 10.7727L17.2014 8.91844L15.5595 7.7933L17.7092 7.74428L18.2769 6L18.849 7.74428L21 7.79456L19.344 8.95113L19.9226 10.8192C19.9129 10.8274 19.5626 10.5867 19.1447 10.2818C18.7256 9.97821 18.3321 9.72741 18.2704 9.72489L16.6324 10.7727V10.7727ZM18.3244 13.7565C18.6137 13.6308 18.7635 13.3102 18.7635 12.8218C18.7635 12.5811 18.7281 12.3089 18.6844 12.2172C18.5861 12.0097 18.1251 11.83 17.7684 11.8589L17.5093 11.8809L17.5157 13.8816C17.5189 13.9382 18.1232 13.8452 18.3244 13.7572V13.7565ZM13.3661 14.58L12.747 13.1424L11.9653 14.5988C12.0296 14.6617 13.3667 14.6428 13.3667 14.58H13.3661ZM12.5111 11.3567L13.5255 11.3642L15.8205 16.4807L15.9954 11.3045L17.6391 11.3259C19.1627 11.3466 19.3022 11.3585 19.5594 11.4905C20.712 12.0845 20.5956 13.4668 19.3453 14.0174L18.9737 14.1796L20.9068 16.8931L19.1216 16.8962L17.5376 14.5284L17.5221 16.8962H15.9105L14.2989 16.895L13.6496 15.2355H11.6278L10.9721 16.8635L10.4706 16.8824L9.96921 16.9013L12.5104 11.3573L12.5111 11.3567ZM3.80036 16.9295C3.5805 16.8761 3.3105 16.7875 3.20057 16.7328L3 16.6335L3.15429 16.0866C3.35357 15.3889 3.44357 15.3512 3.71036 15.8553C4.04464 16.4851 5.34514 16.5995 5.65436 16.025C5.87293 15.6165 5.69936 15.1299 5.259 14.9213C5.169 14.8791 4.77043 14.695 4.36993 14.5114C3.58693 14.1532 3.34136 13.9332 3.15621 13.4322C2.8605 12.6295 3.2025 11.8545 4.04786 11.4051C4.377 11.2303 4.77236 11.082 5.37729 11.092C5.54764 11.1077 5.74371 11.1486 6.10886 11.3516L11.2787 11.3265L11.325 12.2901L9.71271 12.0625L9.6645 16.8962H8.17629L8.05221 12.0525L6.16479 12.1926C5.89993 12.0745 5.59907 11.7809 5.25707 11.7803C4.52679 11.7791 4.36607 11.8771 4.26707 12.3856C4.19829 12.7364 4.42007 12.9388 5.38371 13.4077C5.83371 13.6264 6.19564 13.8426 6.18729 13.8866C6.17764 13.9306 6.20979 13.9526 6.258 13.935C6.37564 13.891 6.74657 14.2474 6.89314 14.5416C7.07314 14.9062 7.05257 15.558 6.85136 15.9075C6.6315 16.2878 6.04779 16.7322 5.59907 16.8617C5.06807 17.0157 4.27221 17.0452 3.79907 16.9295H3.80036Z"
          fill="white"
        />
      </svg>
    `
  },
  statistics: {
    16: () => html` <svg viewBox="0 0 16 16" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path
            d="M7 15h2V5.002C9 5.006 8.994 5 8.99 5H7.01C6.997 5 7 4.998 7 5.002V15zM6 5.002A1 1 0 0 1 7.01 4h1.98C9.549 4 10 4.456 10 5.002V16H6V5.002zM2 15h2V8.997C4 9.005 3.995 9 3.99 9H2.01C2.002 9 2 9 2 8.998V15zM1 8.997C1 8.447 1.443 8 2.01 8h1.98C4.549 8 5 8.453 5 8.997V16H1V8.997zM10 16v-1h1V1a1 1 0 0 1 1.01-1h1.98C14.549 0 15 .445 15 1v14h.5a.5.5 0 1 1 0 1H10zm-9-1v1H.5a.5.5 0 1 1 0-1H1zm5 0v1H5v-1h1zm6-14v14h2V1h-2z"
            id="a"
          />
        </defs>
        <use xlink:href="#a" />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M.5 24a.5.5 0 1 1 0-1H1v-9.998C1 12.45 1.451 12 1.99 12h4.02c.546 0 .99.456.99 1.002V23h2V6.993C9 6.445 9.451 6 9.99 6h4.02c.546 0 .99.445.99.993V23h2V1a1 1 0 0 1 .99-1h4.02c.546 0 .99.447.99 1v22h.5a.5.5 0 1 1 0 1H.5zM14 7h-4v16h4V7zm-7.99 6H1.99l.01.001V23h4v-9.998S5.998 13 6.01 13zM22 1h-4v22h4V1z"
        />
      </svg>`
  },
  ticket: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M2 13.015a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12.017a1 1 0 0 1 1 1.042l-.001 2.037a.5.5 0 0 1-.341.453l-.552.184a.887.887 0 0 0 0 1.684l.552.184a.5.5 0 0 1 .341.456l.003 2.94v.035a1 1 0 0 1-1 1H2zM14.017 4h-3.532v1.502a.5.5 0 0 1-1 0V4H2v8.015h7.485V10.5a.5.5 0 1 1 1 0v1.515h3.535l.01-2.592-.223-.074a1.887 1.887 0 0 1 0-3.582l.224-.074L14.017 4zM6.503 8.008a.5.5 0 0 1 0 1H4.514a.5.5 0 1 1 0-1h1.99zm3.482-.999a.5.5 0 0 1 .5.5v.988a.5.5 0 0 1-1 0V7.51a.5.5 0 0 1 .5-.5zm-2.485-1a.5.5 0 1 1 0 1H4.514a.5.5 0 0 1 0-1H7.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M18.006 4.528a1.03 1.03 0 0 0 1.457 1.457l.332-.332a.5.5 0 0 1 .707 0l3.14 3.14a1 1 0 0 1 0 1.414L10.207 23.642a1 1 0 0 1-1.415 0L.307 15.156a1 1 0 0 1 0-1.414L13.742.307a1 1 0 0 1 1.414 0l3.182 3.182a.5.5 0 0 1 0 .707l-.332.332zM14.45 1.014 1.014 14.45 9.5 22.935 22.935 9.499l-2.786-2.785a2.03 2.03 0 0 1-2.871-2.871l-2.829-2.829zm-3.89 3.182a.5.5 0 1 1 .707-.707L13.39 5.61a.5.5 0 1 1-.708.708l-2.12-2.122zM7.732 14.803a.5.5 0 1 1-.707-.707l4.95-4.95a.5.5 0 1 1 .706.707l-4.95 4.95zm4.242 0a.5.5 0 1 1-.707-.707l2.829-2.829a.5.5 0 1 1 .707.707l-2.829 2.829zm2.122-7.071a.5.5 0 1 1 .707-.707l2.121 2.12a.5.5 0 1 1-.707.708l-2.121-2.121zm3.535 3.535a.5.5 0 1 1 .707-.707l2.122 2.121a.5.5 0 1 1-.707.708l-2.122-2.122z"
        />
      </svg>`
  },
  exchangeTickets: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="m15.759 7.149 1.693 1.693a.5.5 0 0 1 .048.65c-.628.851-.628 1.478-.048 2.058.58.58 1.207.58 2.057-.048a.5.5 0 0 1 .651.048l1.693 1.693a.5.5 0 0 1 0 .707l-9.903 9.904a.5.5 0 0 1-.707 0l-6.095-6.095a.5.5 0 0 1 0-.707l9.904-9.903a.5.5 0 0 1 .707 0zm-.354 1.06L6.21 17.407l5.387 5.387 9.196-9.196-1.049-1.05c-1.095.656-2.138.571-2.998-.29-.861-.86-.946-1.903-.29-2.998l-1.05-1.05zm-2.072 5.081a.5.5 0 0 1 .054.639l-.059.069-1.049 1.037 3.873-.002a.483.483 0 0 1 .47.401l.008.087a.493.493 0 0 1-.405.48l-.088.007h-3.796l.905.943a.5.5 0 0 1 .045.64l-.06.067a.5.5 0 0 1-.638.045l-.069-.059-1.758-1.83a.5.5 0 0 1-.049-.634l.058-.068 1.85-1.827a.5.5 0 0 1 .708.005zM11.757.146 13.45 1.84a.5.5 0 0 1 .049.651c-.629.85-.629 1.478-.049 2.058.58.58 1.207.58 2.058-.049a.5.5 0 0 1 .65.049l1.377 1.376a.405.405 0 0 1-.03.6.524.524 0 0 1-.68-.014l-1.083-.965c-1.096.655-2.138.57-2.999-.29-.86-.86-.945-1.903-.29-2.998l-1.05-1.05-9.195 9.196 3.61 3.61a.461.461 0 0 1-.029.68.546.546 0 0 1-.738-.032l-3.904-3.904a.5.5 0 0 1 0-.707L11.05.146a.5.5 0 0 1 .707 0zm-2.81 6.198a.5.5 0 0 1 .708 0L11.5 8.19l.058.07a.5.5 0 0 1-.058.638l-1.794 1.794-.07.058A.5.5 0 0 1 9 10.692l-.058-.069A.5.5 0 0 1 9 9.985l.981-.982H6.118a.5.5 0 1 1 0-1l3.78-.001-.95-.95-.059-.07a.5.5 0 0 1 .058-.638z"
        />
      </svg>`
  },
  sellTickets: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M4.5 15c.276 0 .5.228.5.51l-.001.04h2.304c1.966 0 3.385.611 4.27 1.432h3.19c.68 0 1.226.262 1.524.686l3.403-1.229c1.151-.39 2.256.172 3.564 1.503a.514.514 0 0 1-.13.815 138.32 138.32 0 0 0-3.746 1.976c-.553.302-2.282 1.259-2.619 1.442-1.687.918-2.535 1.283-3.419 1.412-.936.137-1.815-.022-3.254-.54-.298-.108-1.482-.573-2.742-1.067l-.76-.297c-.57-.222-1.124-.438-1.585-.614L5 21.49a.505.505 0 0 1-.5.509h-4a.505.505 0 0 1-.5-.51v-5.98c0-.282.224-.51.5-.51h4zm.499 1.568-.001 3.413c.518.197 1.216.467 1.94.75l.758.297c1.26.492 2.436.955 2.724 1.059 1.3.468 2.035.601 2.778.492.504-.073 2.627-1.12 4.737-2.211l.574-.298c1.428-.744 2.78-1.47 3.541-1.881-.822-.725-1.471-.978-2.034-.787l-3.493 1.264c-.1.78-.796 1.351-1.76 1.351H9.338a.505.505 0 0 1-.5-.509c0-.281.223-.51.5-.51h5.425c.511 0 .77-.237.77-.525 0-.288-.259-.473-.77-.473h-3.39a.496.496 0 0 1-.358-.153c-.683-.708-1.895-1.279-3.712-1.279H5zm-1-.55H1.001v4.964h2.998v-4.964zM23.516 2.9c.276 0 .484.228.484.51l.016 8.144c0 .281-.224.446-.5.446H6.5c-.276 0-.5-.165-.5-.446s.224-.51.5-.51h16.515L23 3.41c0-.281.24-.509.516-.509zM21.5 1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-18a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h18zM21 2H4v7h17V2zm-8.51 1.036c1.382 0 2.502 1.14 2.502 2.545 0 1.406-1.12 2.546-2.502 2.546-1.382 0-2.502-1.14-2.502-2.546 0-1.405 1.12-2.545 2.502-2.545zm0 1.018c-.83 0-1.502.684-1.502 1.527 0 .844.673 1.528 1.502 1.528s1.501-.684 1.501-1.528c0-.843-.672-1.527-1.501-1.527z"
        />
      </svg>`
  },
  transferTickets: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.5 0a3.5 3.5 0 0 0-1.997 6.375A5.497 5.497 0 0 0 12 11.5v3.895a.67.67 0 0 0 .484.624l1.516.373L15 24h5l1-7.608 1.516-.373a.672.672 0 0 0 .484-.624V11.5a5.506 5.506 0 0 0-3.505-5.126A3.5 3.5 0 0 0 17.5 0zm0 7c2.481 0 4.5 2.017 4.5 4.5v3.616l-1.239.305a1 1 0 0 0-.752.839L19.1 23h-3.2l-.909-6.74a1 1 0 0 0-.752-.84L13 15.117V11.5C13 9.013 15.014 7 17.5 7zM6.834 2.628A.5.5 0 0 0 6 3v2.999L.5 6l-.09.008A.5.5 0 0 0 0 6.5l.008.09A.5.5 0 0 0 .5 7L6 6.999V10a.5.5 0 0 0 .834.372l3.9-3.5a.5.5 0 0 0 0-.744zM7 4.12 9.651 6.5 7 8.88V4.12zM17.5 1a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z"
        />
      </svg>`
  },
  upgradeTickets: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.5 9.5a.5.5 0 0 1 .5.5v12c0 .488-.477 1-1 1H4.963C4.424 23 4 22.534 4 22v-1.949a.5.5 0 0 1 1 0V22h12V10a.5.5 0 0 1 .5-.5zM2.5 15a.5.5 0 0 1 .5.5v1.51h1.51a.49.49 0 0 1 0 .98H3v1.51a.5.5 0 1 1-1 0v-1.51H.49a.49.49 0 0 1 0-.98H2V15.5a.5.5 0 0 1 .5-.5zm6-15a.5.5 0 0 1 .5.5V1c0 1.013.69 1.986 2.005 2C12.31 3.014 13 2.028 13 1V.5a.5.5 0 0 1 .5-.5H17c.533 0 1 .462 1 1v2.657a.5.5 0 1 1-1 0V1h-3c0 1.523-1.05 3.02-3.005 3C9.045 3.98 8 2.503 8 1H5v14.238a.5.5 0 0 1-1 0V1c0-.534.424-1 .963-1H8.5zm13.005 10.505a.5.5 0 0 1 .5.5l-.001 1.002 1.022.006a.48.48 0 0 1 0 .96h-1.022v1.032a.5.5 0 1 1-1 0v-1.032h-1.01a.49.49 0 0 1-.49-.49c0-.268.219-.486.488-.486h.002l1.01.005v-.997a.5.5 0 0 1 .5-.5zM19.5 3a.5.5 0 0 1 .5.5v2.52h2.5a.5.5 0 0 1 .001 1H22.5L20 7.011V9.5a.5.5 0 1 1-1 0V7.009l-2.51-.008a.491.491 0 0 1 0-.98L19 6.02V3.5a.5.5 0 0 1 .5-.5zm-5 5a.5.5 0 1 1 0 1H5V8h9.5z"
        />
      </svg>`
  },
  tickets: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.978 4.5a1.03 1.03 0 0 0 1.457 1.457l.332-.332a.5.5 0 0 1 .707 0l3.14 3.14a1 1 0 0 1 0 1.413L10.177 23.613a1 1 0 0 1-1.414 0L.28 15.128a1 1 0 0 1 0-1.414L13.714.279a1 1 0 0 1 1.414 0L18.31 3.46a.5.5 0 0 1 0 .707l-.332.332zM14.42.986.986 14.421l8.485 8.485L22.906 9.471 20.12 6.685a2.03 2.03 0 0 1-2.87-2.87L14.42.986zm-3.889 3.182a.5.5 0 0 1 .707-.707l2.121 2.121a.5.5 0 0 1-.707.707l-2.121-2.121zM7.704 14.775a.5.5 0 1 1-.708-.707l4.95-4.95a.5.5 0 0 1 .707.707l-4.95 4.95zm4.242 0a.5.5 0 1 1-.707-.707l2.829-2.829a.5.5 0 0 1 .707.707l-2.829 2.829zm2.122-7.071a.5.5 0 0 1 .707-.708l2.121 2.122a.5.5 0 0 1-.707.707l-2.121-2.121zm3.535 2.828a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 0 1-.707.707l-2.12-2.12a.5.5 0 0 1 0-.708zM4.827 4.037 6.077.606a1 1 0 0 1 1.17-.632l.111.034 3.232 1.176a.5.5 0 0 1 .322.554l-.023.087-.232.639c-.142.39.03.817.388 1.005l.102.045a.5.5 0 1 1-.343.939 1.819 1.819 0 0 1-1.132-2.189l.045-.142.062-.169L7.016.948 5.91 3.985l1.404.51a.5.5 0 0 1 .322.554l-.024.087a.5.5 0 0 1-.553.322l-.087-.023-1.404-.51-2.791 7.67a.5.5 0 0 1-.554.323l-.087-.023a.5.5 0 0 1-.322-.554l.023-.087 2.936-8.07.02-.074c.01-.026.02-.05.034-.073L6.077.606l-1.25 3.43z"
        />
      </svg>`
  },
  transportation: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M10.5 3c.605 0 1.406.252 1.941.6l.152.106 2.044 1.563.343.245c.531.38.95 1.149 1.012 1.828l.008.167V10.5a.5.5 0 0 1-.024.152l-.029.072-.053.107c-.307.613-1.043 1.1-1.738 1.162l-.148.007h-.158a2 2 0 0 1-3.547.001H5.85a2 2 0 0 1-3.547 0L.5 12a.5.5 0 0 1-.09-.992l.08-.007-.283-1.415a2.208 2.208 0 0 1-.019-.695.499.499 0 0 1 .222-.883l.047-.005c.078-.155.17-.299.276-.424l.075-.084.024-.033c.13-.17.349-.367.673-.56l.171-.096c.2-.104.42-.199.666-.28l1.364-.456C5.07 4.435 6.822 3.114 7.868 3.007L8 3h2.5zm-6.424 7.076a1 1 0 1 0 .93 1.368L5 11.5c0-.081.02-.158.054-.226a.818.818 0 0 0 .022-.198 1 1 0 0 0-1-1zm8 0a1 1 0 1 0 .93 1.368L13 11.5c0-.081.02-.158.054-.226a.818.818 0 0 0 .022-.198 1 1 0 0 0-1-1zm2.516-3.564-.415.209a3.02 3.02 0 0 1-.986.27L13.003 7l-8.92-.001-1.425.475a3.433 3.433 0 0 0-.515.217c-.228.12-.374.23-.455.31L2.5 8a.5.5 0 0 1 .09.992L2.5 9H1.182a1.374 1.374 0 0 0-.01.255l.016.135.302 1.512c.007.033.01.066.01.099L2.078 11a2 2 0 0 1 3.998.076L6.073 11h4.005a2 2 0 0 1 1.85-1.918l.148-.006a2 2 0 0 1 2 2l-.003-.081.045-.004c.3-.045.65-.263.824-.513l.058-.097V9h-1.5a.5.5 0 0 1-.09-.992L13.5 8l1.5-.001v-.49c0-.31-.18-.726-.408-.997zM9.941 4H8c-.529 0-1.767.85-2.883 2l3.824-.001 1-1.999zm1.08.074L10.06 6h2.943c.16 0 .41-.051.598-.12l.122-.051-1.737-1.328c-.23-.176-.607-.337-.964-.427z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M16.5 5c.599 0 1.408.251 1.947.594l.153.106 3.162 2.372 1.067.533c.617.309 1.102 1.051 1.164 1.754l.007.15V15l-.026.158-.027.08c-.309.928-1.288 1.675-2.271 1.755l-.174.007h-.552a2.501 2.501 0 0 1-4.9 0h-7.1a2.501 2.501 0 0 1-4.9 0H.5a.5.5 0 0 1-.09-.992L.5 16h.359l-.602-2.41a2.268 2.268 0 0 1-.054-.69l-.025-.018a.499.499 0 0 1 .229-.873c.085-.21.195-.398.323-.548a5.281 5.281 0 0 1 1.058-1.084 5.144 5.144 0 0 1 1.554-.851 10.104 10.104 0 0 1 2.72-.52L6.254 9l.021-.027c1.603-2.034 4.057-3.84 5.563-3.966L12 5h4.5zm-10 10a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 6.5 15zm12 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 15zM3.658 10.474c-.45.15-.87.388-1.252.689a4.933 4.933 0 0 0-.833.838L2.5 12a.5.5 0 0 1 .09.992L2.5 13l-1.301.001c-.004.073-.002.144.005.211l.023.135L1.89 16h2.16a2.502 2.502 0 0 1 2.286-1.995L6.5 14c1.21 0 2.219.86 2.45 2h7.1a2.502 2.502 0 0 1 4.9 0h.552c.565 0 1.206-.434 1.448-.956l.05-.128V13h-1.5a.5.5 0 0 1-.09-.992L21.5 12H23v-1.491c0-.33-.24-.753-.523-.952l-.095-.057-.133-.066a.497.497 0 0 1-.042.021l-.086.03-1.516.379a5.41 5.41 0 0 1-.895.13l-.206.006H6.5l-.014-.001h-.212c-.683.012-1.61.14-2.616.475zM15.19 6H12c-.987 0-2.965 1.36-4.44 3h6.13l1.5-3zm1.31 0h-.191l-1.5 3h4.695c.187 0 .478-.031.704-.073l.155-.033.62-.157L18 6.5c-.315-.236-.905-.448-1.344-.492L16.5 6z"
        />
      </svg>`
  },
  venue: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="m2 16-.051-.003a.498.498 0 0 1-.438-.392l.023.076a.497.497 0 0 1-.003-.007l-.02-.07-1.5-7a.5.5 0 0 1 .212-.52c.401-.268.81-.51 1.225-.726L1.015 5.62a.5.5 0 0 1 .228-.55c.249-.149.501-.288.757-.416V1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5L3 2.999v1.217A11.161 11.161 0 0 1 7 3.5v-3l.008-.09A.5.5 0 0 1 7.5 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H8l.001 1.524c1.495.074 2.829.316 4 .729L12 1.5l.008-.09A.5.5 0 0 1 12.5 1h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13l.002 1.666a9.1 9.1 0 0 1 .755.405.5.5 0 0 1 .242.459l-.014.091-.4 1.604a9.8 9.8 0 0 1 2.235 1.39.5.5 0 0 1 .158.532l-2 6.5a.504.504 0 0 1-.388.345.508.508 0 0 1-.09.008l.038-.004L13.5 16H2zm5-9C4.766 7 2.696 7.637.777 8.916l.119-.077.164-.106 1.343 6.266H4V13a2 2 0 1 1 4 0v1.999h5.131l1.791-5.821-.214-.159C12.92 7.736 10.495 7.06 7.423 7.004zm0-2.5c-1.655 0-3.186.357-4.6 1.073l-.323.171.294 1.18A11.837 11.837 0 0 1 7 6c2.153 0 4.036.282 5.647.849l.275-1.102-.258-.134c-1.4-.69-3.136-1.062-5.214-1.108L7 4.5z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M3 24a.5.5 0 0 1-.486-.384l.022.07a.496.496 0 0 1-.014-.038l-.008-.032-2.5-10.5a.5.5 0 0 1 .179-.51c.467-.364.938-.7 1.413-1.008l-.091.023-.5-2a.5.5 0 0 1 .131-.475A9.233 9.233 0 0 1 3 7.717V1.5l.008-.09A.5.5 0 0 1 3.5 1h4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H4v3.2c1.664-.748 3.666-1.146 6-1.195V.5l.008-.09A.5.5 0 0 1 10.5 0h4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H11v3.004c2.168.04 4.166.329 6 .868V1.5l.008-.09A.5.5 0 0 1 17.5 1h4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H18v3.197a17.169 17.169 0 0 1 3.777 1.887.5.5 0 0 1 .212.518l-.025.084-.76 1.903a13.58 13.58 0 0 1 2.65 2.057.5.5 0 0 1 .123.505l-3 9.5a.504.504 0 0 1-.263.3.5.5 0 0 1-.214.049zm7-14c-2.96 0-5.787.954-8.49 2.872l-.449.328L3.395 23H6v-4a3 3 0 0 1 6 0v4h8.133l2.797-8.857-.043-.041c-2.807-2.646-6.924-4.018-12.372-4.098zm.5-3c-3.6 0-6.335.826-8.225 2.462l-.22.197.362 1.442C4.838 9.702 7.368 9 10 9c4.12 0 7.564.699 10.321 2.102l.561-1.406-.012-.008c-2.729-1.716-6.014-2.612-9.865-2.683L10.5 7z"
        />
      </svg>`
  },
  willCall: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M18.5 0a3.5 3.5 0 0 1 1.917 6.43A4.502 4.502 0 0 1 23 10.5V14h.5a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.5.5H12v1.5a.5.5 0 0 1-.5.5H8.966l-.467 6.536A.5.5 0 0 1 8 24H4a.5.5 0 0 1-.499-.464L3.034 17H.5a.5.5 0 0 1-.5-.5v-3.505a6.001 6.001 0 0 1 3.875-5.607 4 4 0 1 1 4.252 0A5.994 5.994 0 0 1 12 12.995V14h2v-3.5a4.503 4.503 0 0 1 2.583-4.072A3.5 3.5 0 0 1 18.5 0zM6 8a5 5 0 0 0-5 4.995V16h2.5a.5.5 0 0 1 .499.464L4.466 23h3.068l.467-6.536A.5.5 0 0 1 8.5 16H11v-3.005A4.997 4.997 0 0 0 6 8zm12.5-1C16.57 7 15 8.569 15 10.5V14h7v-3.5a3.503 3.503 0 0 0-3.308-3.495zM6 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm12.5 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
        />
      </svg>`
  },
  alert: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M1.968 12.524a.384.384 0 0 0-.055.198.4.4 0 0 0 .405.393h11.364a.415.415 0 0 0 .204-.053.387.387 0 0 0 .146-.538L8.35 3.08a.413.413 0 0 0-.7 0l-5.682 9.444zm-.788-.446 5.68-9.444a1.341 1.341 0 0 1 1.803-.46c.196.111.36.27.474.46l5.682 9.444c.367.61.155 1.392-.474 1.748a1.35 1.35 0 0 1-.664.174H2.318C1.59 14 1 13.428 1 12.722c0-.226.062-.449.18-.644zM8 11.831a.685.685 0 1 0 0-1.37.685.685 0 0 0 0 1.37zm0-2.255a.684.684 0 0 0 .684-.684v-2.17a.684.684 0 0 0-1.369 0v2.17c0 .378.307.684.685.684z"
          fill-rule="evenodd"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M2.041 19.13a.612.612 0 0 0-.085.313.63.63 0 0 0 .637.623h18.814a.648.648 0 0 0 .32-.084.615.615 0 0 0 .231-.851L12.551 3.245a.645.645 0 0 0-1.103 0L2.042 19.131zm-.827-.467 9.407-15.886a1.613 1.613 0 0 1 2.757 0l9.407 15.886a1.537 1.537 0 0 1-.58 2.127 1.62 1.62 0 0 1-.798.21H2.593C1.713 21 1 20.303 1 19.443c0-.274.074-.543.214-.78zM12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-4a1 1 0 0 0 1-1V8.5a1 1 0 0 0-2 0V13a1 1 0 0 0 1 1z"
          fill-rule="evenodd"
        />
      </svg>`,
    36: () => html` <svg viewBox="0 0 36 36">
        <path
          d="M2.111 30.88a.957.957 0 0 0-.127.478c0 .535.44.969.983.969h30.066c.17 0 .337-.044.484-.126a.96.96 0 0 0 .371-1.32L18.856 4.754a.992.992 0 0 0-1.711 0L2.11 30.88zm-.855-.477L16.288 4.278a1.983 1.983 0 0 1 3.423 0l15.033 26.125a1.92 1.92 0 0 1-.742 2.64 1.99 1.99 0 0 1-.97.252H2.968C1.881 33.295 1 32.428 1 31.358c0-.335.088-.664.256-.955zM18 29.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-4.908a1.5 1.5 0 0 0 1.5-1.5V13.5a1.5 1.5 0 0 0-3 0v9.592a1.5 1.5 0 0 0 1.5 1.5z"
          fill-rule="evenodd"
        />
      </svg>`
  },
  alertOutlineNeutral: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M1.968 12.524a.384.384 0 0 0-.055.198.4.4 0 0 0 .405.393h11.364a.415.415 0 0 0 .204-.053.387.387 0 0 0 .146-.538L8.35 3.08a.413.413 0 0 0-.7 0l-5.682 9.444zm-.788-.446 5.68-9.444a1.341 1.341 0 0 1 1.803-.46c.196.111.36.27.474.46l5.682 9.444c.367.61.155 1.392-.474 1.748a1.35 1.35 0 0 1-.664.174H2.318C1.59 14 1 13.428 1 12.722c0-.226.062-.449.18-.644zM8 11.831a.685.685 0 1 0 0-1.37.685.685 0 0 0 0 1.37zm0-2.255a.684.684 0 0 0 .684-.684v-2.17a.684.684 0 0 0-1.369 0v2.17c0 .378.307.684.685.684z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M2.041 19.13a.612.612 0 0 0-.085.313.63.63 0 0 0 .637.623h18.814a.648.648 0 0 0 .32-.084.615.615 0 0 0 .231-.851L12.551 3.245a.645.645 0 0 0-1.103 0L2.042 19.131zm-.827-.467 9.407-15.886a1.613 1.613 0 0 1 2.757 0l9.407 15.886a1.537 1.537 0 0 1-.58 2.127 1.62 1.62 0 0 1-.798.21H2.593C1.713 21 1 20.303 1 19.443c0-.274.074-.543.214-.78zM12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-4a1 1 0 0 0 1-1V8.5a1 1 0 0 0-2 0V13a1 1 0 0 0 1 1z"
        />
      </svg>`,
    36: () => html` <svg viewBox="0 0 36 36">
        <path
          d="M2.111 30.88a.957.957 0 0 0-.127.478c0 .535.44.969.983.969h30.066c.17 0 .337-.044.484-.126a.96.96 0 0 0 .371-1.32L18.856 4.754a.992.992 0 0 0-1.711 0L2.11 30.88zm-.855-.477L16.288 4.278a1.983 1.983 0 0 1 3.423 0l15.033 26.125a1.92 1.92 0 0 1-.742 2.64 1.99 1.99 0 0 1-.97.252H2.968C1.881 33.295 1 32.428 1 31.358c0-.335.088-.664.256-.955zM18 29.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-4.908a1.5 1.5 0 0 0 1.5-1.5V13.5a1.5 1.5 0 0 0-3 0v9.592a1.5 1.5 0 0 0 1.5 1.5z"
        />
      </svg>`
  },
  alertSolid: {
    16: () => html` <svg viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
          <path
            d="M1.05 13.33 7.617 2.195a.444.444 0 0 1 .766 0L14.95 13.33a.444.444 0 0 1-.383.67H1.433a.444.444 0 0 1-.383-.67z"
            fill="#F2BD2A"
          />
          <path
            d="M8 10.886c.435 0 .787.349.787.779 0 .43-.352.778-.787.778a.783.783 0 0 1-.787-.778c0-.43.352-.779.787-.779zm0-5.189c.435 0 .787.353.787.787v2.578a.787.787 0 1 1-1.574 0V6.484c0-.434.352-.787.787-.787z"
            fill="#FFF"
          />
        </g>
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <g fill="none" fill-rule="evenodd">
          <path
            d="m1.074 19.997 10.35-17.7a.667.667 0 0 1 1.151 0l10.35 17.7A.667.667 0 0 1 22.35 21H1.65a.667.667 0 0 1-.576-1.003z"
            fill="#F2BD2A"
          />
          <path
            d="M12 16.578c.578 0 1.047.464 1.047 1.037 0 .572-.469 1.036-1.047 1.036a1.041 1.041 0 0 1-1.047-1.036c0-.573.469-1.037 1.047-1.037zm0-9.308c.578 0 1.047.469 1.047 1.047v5.16a1.047 1.047 0 0 1-2.094 0v-5.16c0-.578.469-1.047 1.047-1.047z"
            fill="#FFF"
          />
        </g>
      </svg>`,
    36: () => html` <svg viewBox="0 0 36 36">
        <g fill="none" fill-rule="evenodd">
          <path
            d="M1.107 31.504 17.132 3.455a1 1 0 0 1 1.736 0l16.025 28.049A1 1 0 0 1 34.024 33H1.975a1 1 0 0 1-.868-1.496z"
            fill="#F2BD2A"
          />
          <path
            d="M18 26.787a1.56 1.56 0 0 1 1.566 1.553A1.56 1.56 0 0 1 18 29.894a1.56 1.56 0 0 1-1.566-1.554A1.56 1.56 0 0 1 18 26.787zm0-15.532c.865 0 1.566.7 1.566 1.566v10.33a1.566 1.566 0 0 1-3.132 0V12.82c0-.865.701-1.566 1.566-1.566z"
            fill="#FFF"
          />
        </g>
      </svg>`
  },
  error: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M14.936 8.157a.222.222 0 0 0 0-.314l-6.78-6.78a.222.222 0 0 0-.313 0l-6.78 6.78a.222.222 0 0 0 0 .314l6.805 6.78a.222.222 0 0 0 .314-.001l6.754-6.779zM8.89 15.641a1.22 1.22 0 0 1-1.726.003L.359 8.864a1.221 1.221 0 0 1-.002-1.728L7.137.358a1.22 1.22 0 0 1 1.726 0l6.78 6.779a1.22 1.22 0 0 1 0 1.725L8.89 15.641zM8 12.495a.75.75 0 1 0 0-1.498.75.75 0 0 0 0 1.498zm0-2.497a.75.75 0 0 0 .75-.75V4.755a.75.75 0 0 0-1.498 0V9.25a.75.75 0 0 0 .749.749z"
          fill-rule="evenodd"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M22.267 11.918a.333.333 0 0 0 0-.471l-10.35-10.35a.333.333 0 0 0-.471 0L1.097 11.448a.333.333 0 0 0 0 .47l10.387 10.35c.13.13.342.13.472 0l10.311-10.349zm-9.603 11.054a1.333 1.333 0 0 1-1.886.004L.392 12.626A1.334 1.334 0 0 1 .39 10.74L10.74.391a1.332 1.332 0 0 1 1.885 0l10.35 10.349c.52.52.52 1.363.001 1.884L12.664 22.972zm-.982-4.29a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-4a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v7a1 1 0 0 0 1 1z"
          fill-rule="evenodd"
        />
      </svg>`,
    36: () => html` <svg viewBox="0 0 36 36">
        <path
          d="M33.9 18.377a.5.5 0 0 0 0-.707L18.376 2.146a.5.5 0 0 0-.707 0L2.146 17.67a.5.5 0 0 0 0 .707l15.58 15.525a.5.5 0 0 0 .707-.001l15.468-15.523zM19.143 34.606a1.5 1.5 0 0 1-2.122.003L1.441 19.085a1.5 1.5 0 0 1-.002-2.123L16.962 1.44a1.5 1.5 0 0 1 2.121 0l15.524 15.524a1.5 1.5 0 0 1 .002 2.12L19.142 34.606zm-1.119-6.583a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-6a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-3 0v10a1.5 1.5 0 0 0 1.5 1.5z"
          fill-rule="evenodd"
        />
      </svg>`
  },
  errorSolid: {
    16: () => html` <svg viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
          <path
            d="m8.34 15.37 7.03-7.056a.444.444 0 0 0 0-.628L8.314.63a.444.444 0 0 0-.629 0L.63 7.685a.444.444 0 0 0 0 .63l7.082 7.056a.444.444 0 0 0 .629-.001z"
            fill="var(--gdse-s-color-fill-critical)"
          />
          <path
            d="M8 11.12a.668.668 0 1 1 0 1.336.668.668 0 0 1 0-1.337zm0-7.13c.369 0 .668.299.668.668v4.456a.668.668 0 0 1-1.337 0V4.658c0-.37.3-.669.669-.669z"
            fill="#FFF"
          />
        </g>
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <g fill="none" fill-rule="evenodd">
          <path
            d="m12.51 22.804 10.296-10.333a.667.667 0 0 0-.001-.942L12.47 1.195a.667.667 0 0 0-.943 0L1.195 11.528a.667.667 0 0 0 .001.943l10.371 10.335c.261.26.683.259.943-.002z"
            fill="var(--gdse-s-color-fill-critical)"
          />
          <path
            d="M12 16.575a.98.98 0 1 1 0 1.96.98.98 0 0 1 0-1.96zm0-10.457a.98.98 0 0 1 .98.98v6.536a.98.98 0 0 1-1.96 0V7.098a.98.98 0 0 1 .98-.98z"
            fill="#FFF"
          />
        </g>
      </svg>`,
    36: () => html` <svg viewBox="0 0 36 37">
        <g fill="none" fill-rule="evenodd">
          <path
            d="M18.767 35.27 34.54 19.44a1 1 0 0 0-.002-1.413L18.706 2.195a1 1 0 0 0-1.414 0l-15.83 15.83a1 1 0 0 0 .002 1.415l15.888 15.832a1 1 0 0 0 1.415-.003z"
            fill="var(--gdse-s-color-fill-critical)"
          />
          <path
            d="M18 25.733a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0-16a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 1 1-3 0v-10a1.5 1.5 0 0 1 1.5-1.5z"
            fill="#FFF"
          />
        </g>
      </svg>`
  },
  errorOutlineNeutral: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M14.936 8.157a.222.222 0 0 0 0-.314l-6.78-6.78a.222.222 0 0 0-.313 0l-6.78 6.78a.222.222 0 0 0 0 .314l6.805 6.78a.222.222 0 0 0 .314-.001l6.754-6.779zM8.89 15.641a1.22 1.22 0 0 1-1.726.003L.359 8.864a1.221 1.221 0 0 1-.002-1.728L7.137.358a1.22 1.22 0 0 1 1.726 0l6.78 6.779a1.22 1.22 0 0 1 0 1.725L8.89 15.641zM8 12.495a.75.75 0 1 0 0-1.498.75.75 0 0 0 0 1.498zm0-2.497a.75.75 0 0 0 .75-.75V4.755a.75.75 0 0 0-1.498 0V9.25a.75.75 0 0 0 .749.749z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M22.267 11.918a.333.333 0 0 0 0-.471l-10.35-10.35a.333.333 0 0 0-.471 0L1.097 11.448a.333.333 0 0 0 0 .47l10.387 10.35c.13.13.342.13.472 0l10.311-10.349zm-9.603 11.054a1.333 1.333 0 0 1-1.886.004L.392 12.626A1.334 1.334 0 0 1 .39 10.74L10.74.391a1.332 1.332 0 0 1 1.885 0l10.35 10.349c.52.52.52 1.363.001 1.884L12.664 22.972zm-.982-4.29a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-4a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v7a1 1 0 0 0 1 1z"
        />
      </svg>`,
    36: () => html` <svg viewBox="0 0 36 36">
        <path
          d="M33.9 18.377a.5.5 0 0 0 0-.707L18.376 2.146a.5.5 0 0 0-.707 0L2.146 17.67a.5.5 0 0 0 0 .707l15.58 15.525a.5.5 0 0 0 .707-.001l15.468-15.523zM19.143 34.606a1.5 1.5 0 0 1-2.122.003L1.441 19.085a1.5 1.5 0 0 1-.002-2.123L16.962 1.44a1.5 1.5 0 0 1 2.121 0l15.524 15.524a1.5 1.5 0 0 1 .002 2.12L19.142 34.606zm-1.119-6.583a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0-6a1.5 1.5 0 0 0 1.5-1.5v-10a1.5 1.5 0 0 0-3 0v10a1.5 1.5 0 0 0 1.5 1.5z"
        />
      </svg>`
  },
  info: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path
          fill-rule="evenodd"
          d="M8.5 15.333A7.333 7.333 0 1 0 8.5.667a7.333 7.333 0 0 0 0 14.666Zm0-1a6.333 6.333 0 1 0 0-12.666 6.333 6.333 0 0 0 0 12.666Z"
          clip-rule="evenodd"
        />
        <path d="M7.833 4v1.333h1.334V4H7.833Zm.334 3.333V12h1V6.333H7.333v1h.834Z" />
      </svg>`,
    24: () => html`<svg viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm0-1.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z"
          clip-rule="evenodd"
        />
        <path d="M11 6v2h2V6h-2Zm.5 5v7H13V9.5h-2.75V11h1.25Z" />
      </svg>`
  },
  infoSolid: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#024DDF" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z" />
        <path fill="#FFF" d="M11 6v2h2V6h-2Zm.5 5v7H13V9.5h-2.75V11h1.25Z" />
      </svg>`
  },
  infoFilled: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#024DDF" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z" />
        <path d="M11 6v2h2V6h-2Zm.5 5v7H13V9.5h-2.75V11h1.25Z" />
      </svg>`
  },
  infoOutlineNeutral: {
    16: () => html`<svg viewBox="0 0 16 16">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"/>
    <path d="M8.75 5.75C8.75 6.16421 8.41421 6.5 8 6.5C7.58579 6.5 7.25 6.16421 7.25 5.75C7.25 5.33579 7.58579 5 8 5C8.41421 5 8.75 5.33579 8.75 5.75Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25 10.75C7.25 11.1642 7.58579 11.5 8 11.5C8.41421 11.5 8.75 11.1642 8.75 10.75V8.25C8.75 7.83579 8.41421 7.5 8 7.5C7.58579 7.5 7.25 7.83579 7.25 8.25V10.75Z"/>
    </svg>
    `,
    24: () => html`<svg viewBox="0 0 24 24">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"/>
    <path d="M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V17Z"/>
    </svg>
    `
  },
  success: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#1BAB1E" d="m10.037 17.097 7.527-8.603-1.128-.988-6.472 7.397L7.53 12.47l-1.06 1.06 3.567 3.567Z" />
        <path
          fill="#1BAB1E"
          fill-rule="evenodd"
          d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Z"
          clip-rule="evenodd"
        />
      </svg>`
  },
  successSolid: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#1BAB1E" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z" />
        <path
          fill="#FFF"
          fill-rule="evenodd"
          d="m17.564 8.494-7.527 8.603-3.567-3.566 1.06-1.061 2.434 2.433 6.472-7.397 1.128.988Z"
          clip-rule="evenodd"
        />
      </svg>`
  },
  successOutlineNeutral: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path d="m10.037 17.097 7.527-8.603-1.128-.988-6.472 7.397L7.53 12.47l-1.06 1.06 3.567 3.567Z" />
        <path fill-rule="evenodd" d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Z" clip-rule="evenodd" />
      </svg>`
  },
  ada: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M8.64 9h4.86a.5.5 0 1 1 0 1H8.89l1 4h7.94l3 7h1.67a.5.5 0 1 1 0 1h-2.33l-3-7H9.11L7.029 6.677a3.5 3.5 0 1 1 1.107.304L8.64 9zm-3.367-.876a.5.5 0 0 1 .498.867 7.5 7.5 0 1 0 10.258 10.203.5.5 0 0 1 .87.494A8.5 8.5 0 1 1 5.272 8.124zM8.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
        />
      </svg>`
  },
  bookmark: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M3 0h10a1 1 0 0 1 1 1v15l-5.58-3.072a1 1 0 0 0-.973.005L2 16V1a1 1 0 0 1 1-1zm10 14.308V1H3v13.29l3.957-2.229a2 2 0 0 1 1.946-.01L13 14.309z"
        />
      </svg>`
  },
  bookmarkSolid: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path d="M3 0h10a1 1 0 0 1 1 1v15l-5.58-3.072a1 1 0 0 0-.973.005L2 16V1a1 1 0 0 1 1-1z" />
      </svg>`
  },
  broadcastActivated: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M9.375 15c.345 0 .625.224.625.5s-.28.5-.625.5h-3.75C5.28 16 5 15.776 5 15.5s.28-.5.625-.5h3.75zM7.5 5A2 2 0 0 1 8 8.937V15H7l-.001-6.063A2 2 0 0 1 7.5 5zm0-5a7 7 0 0 1 2.688 13.465.5.5 0 0 1-.327-.948A6.002 6.002 0 0 0 7.5 1a6 6 0 0 0-2.36 11.518.5.5 0 1 1-.332.942H4.8A7.002 7.002 0 0 1 7.5 0zm0 2.5A4.5 4.5 0 0 1 12 7c0 1.285-.539 2.46-1.402 3.282-.061.058-.32.338-.578.338a.5.5 0 0 1-.5-.5c0-.27.169-.389.173-.392a3.5 3.5 0 1 0-4.417-.025.571.571 0 0 1 .204.417.5.5 0 0 1-.5.5c-.267 0-.511-.3-.541-.328A4.467 4.467 0 0 1 3 7a4.5 4.5 0 0 1 4.5-4.5zm0 3.5a1 1 0 0 0-.017 2l.034-.001.1-.006A1 1 0 0 0 7.5 6z"
        />
      </svg>`
  },
  broadcastDeactivated: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M5.5 7a2 2 0 1 1 2.501 1.937L8 15h1.375c.345 0 .625.224.625.5s-.28.5-.625.5h-3.75C5.28 16 5 15.776 5 15.5s.28-.5.625-.5H7V8.937A2 2 0 0 1 5.5 7zm2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        />
      </svg>`
  },
  cart: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M19.239 13.058 21.656 5H10a1 1 0 1 1 0-2h13a1 1 0 0 1 .958 1.287l-3 10a1 1 0 0 1-.878.71l-11.433.914L8.839 17H20c.06 0 .117.005.174.015A3.5 3.5 0 1 1 20.5 24a3.5 3.5 0 0 1-3.163-5H9.663A3.5 3.5 0 1 1 3 20.5a3.5 3.5 0 0 1 3.81-3.486L4.161 2H1a1 1 0 1 1 0-2h4a1 1 0 0 1 .985.826l2.313 13.107 10.94-.875zM19 20.5a1.5 1.5 0 0 0 3 0 1.5 1.5 0 0 0-3 0zm-14 0a1.5 1.5 0 0 0 3 0 1.5 1.5 0 0 0-3 0z"
        />
      </svg>`
  },
  cartThin: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M20 18a3 3 0 0 1 0 6 3 3 0 0 1-2.236-5H9.236a3 3 0 1 1-2.817-.944L3.576 1H.5a.5.5 0 1 1 0-1H4a.5.5 0 0 1 .493.418l2.595 15.574 13.032-.965L22.828 6H7.5a.5.5 0 0 1 0-1h16a.5.5 0 0 1 .48.644l-3 10a.5.5 0 0 1-.443.355l-13.284.983.17 1.018H20zm0 1a2 2 0 0 0 0 4 2 2 0 0 0 0-4zM7 19a2 2 0 0 0 0 4 2 2 0 0 0 0-4z"
        />
      </svg>`
  },
  "payment-cashsolid": {
    24: () => html`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="3" width="24" height="18" rx="2" fill="#1BAB1E" />
        <rect x="1.5" y="4.5" width="21" height="15" rx="0.5" stroke="white" />
        <path
          d="M14.9325 13.72C14.9325 12.16 13.8525 11.752 12.2925 11.26C11.3805 10.972 10.8525 10.732 10.8525 10.168C10.8525 9.64 11.2965 9.328 11.9925 9.328C12.5445 9.328 13.2525 9.544 13.9005 10.012L14.7165 9.004C14.1645 8.56 13.3725 8.2 12.6045 8.056V6.508H11.5485V8.02C10.1445 8.164 9.34052 9.064 9.34052 10.264C9.34052 11.752 10.5525 12.196 11.8845 12.604C12.9165 12.928 13.4085 13.18 13.4085 13.828C13.4085 14.392 12.9165 14.74 12.2085 14.74C11.5125 14.74 10.6845 14.44 10.0125 13.792L9.16052 14.812C9.85652 15.496 10.6845 15.88 11.5485 16V17.464H12.6045V16.024C14.0445 15.88 14.9325 15.004 14.9325 13.72Z"
          fill="white"
        />
      </svg>
    `
  },
  favorite: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M12.051.036C14.396.314 16 2.08 16 4.94c0 3.098-1.534 5.23-4.684 7.678-.229.178-.46.355-.772.589l-.375.281-.364.275c-.377.285-.806.631-1.288 1.037-.296.263-.738.263-1.012.019l-.021-.019a20.88 20.88 0 0 0-1.29-1.037l-.363-.275-.375-.281a59.892 59.892 0 0 1-.772-.589C1.534 10.171 0 8.038 0 4.94 0 2.079 1.604.314 3.949.036 5.473-.144 7.047.36 8 1.306c.954-.946 2.527-1.45 4.051-1.27zM8.868 12.482a97.93 97.93 0 0 1 .744-.56c.305-.229.531-.4.752-.573 2.798-2.174 4.067-3.938 4.067-6.409 0-2.038-.995-3.133-2.56-3.318-1.394-.165-2.817.495-3.137 1.363a.78.78 0 0 1-1.468 0c-.32-.868-1.743-1.528-3.136-1.363-1.566.185-2.561 1.28-2.561 3.318 0 2.47 1.27 4.235 4.067 6.41a57.65 57.65 0 0 0 1.126.854l.37.278c.34.259.623.479.868.678.248-.202.529-.42.868-.678z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M18.17 1.053c3.47.402 5.83 2.946 5.83 7.11 0 4.55-2.307 7.69-7.072 11.317-.349.266-.703.53-1.178.88a786.245 786.245 0 0 1-1.131.834c-.58.43-1.242.952-1.987 1.566-.362.316-.902.316-1.237.023l-.027-.023c-.52-.453-1.117-.92-1.987-1.566a154.815 154.815 0 0 0-1.131-.834c-.475-.35-.83-.614-1.178-.88C2.307 15.853 0 12.712 0 8.164c0-4.165 2.36-6.71 5.83-7.111C8.185.78 10.62 1.587 12 3.06c1.38-1.473 3.814-2.28 6.17-2.007zm-4.698 18.606a156.578 156.578 0 0 1 1.137-.838c.468-.345.814-.603 1.154-.862 4.334-3.299 6.317-5.999 6.317-9.795 0-3.177-1.615-4.919-4.13-5.21-2.232-.259-4.518.78-5.051 2.196-.312.828-1.486.828-1.798 0-.533-1.416-2.82-2.455-5.05-2.196-2.516.291-4.131 2.033-4.131 5.21 0 3.796 1.983 6.496 6.317 9.795.34.259.686.517 1.154.862a785.986 785.986 0 0 0 1.137.838c.59.438 1.065.8 1.472 1.13a44.92 44.92 0 0 1 1.472-1.13z"
        />
      </svg>`
  },
  groups: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M13.5 0a.5.5 0 0 1 .492.41L14 .5V2h.5a.5.5 0 0 1 .492.41L15 2.5V5h.5a.5.5 0 0 1 .492.41L16 5.5v10a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-10A.5.5 0 0 1 .5 5H1V2.5a.5.5 0 0 1 .41-.492L1.5 2H2V.5a.5.5 0 0 1 .41-.492L2.5 0h11zM15 6H1v9h14V6zm-1-3H2v2h12V3zm-1-2H3v1h10V1z"
        />
      </svg>`,
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M17.5 2a.5.5 0 0 1 .492.41L18 2.5V4h1.5a.5.5 0 0 1 .492.41L20 4.5V7h1.5a.5.5 0 0 1 .492.41L22 7.5v14a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 .5-.5H4V4.5a.5.5 0 0 1 .41-.492L4.5 4H6V2.5a.5.5 0 0 1 .41-.492L6.5 2h11zM21 8H3v13h18V8zm-2-3H5v2h14V5zm-2-2H7v1h10V3z"
        />
      </svg>`
  },
  infoDot: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path
          fill-rule="evenodd"
          d="M8.5 15.333A7.333 7.333 0 1 0 8.5.667a7.333 7.333 0 0 0 0 14.666Zm0-1a6.333 6.333 0 1 0 0-12.666 6.333 6.333 0 0 0 0 12.666Z"
          clip-rule="evenodd"
        />
        <path d="M7.833 4v1.333h1.334V4H7.833Zm.334 3.333V12h1V6.333H7.333v1h.834Z" />
      </svg>`,
    24: () => html`<svg viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm0-1.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z"
          clip-rule="evenodd"
        />
        <path d="M11 6v2h2V6h-2Zm.5 5v7H13V9.5h-2.75V11h1.25Z" />
      </svg>`
  },
  mobilityImpaired: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M4.5 0a2.5 2.5 0 0 1 1.815 4.22A3.995 3.995 0 0 1 9 8v2.249C9 11.216 8.22 12 7.254 12H6.75v3.25A.75.75 0 0 1 6 16H3a.75.75 0 0 1-.75-.75V12h-.504A1.75 1.75 0 0 1 0 10.249V8a4.004 4.004 0 0 1 2.686-3.78A2.5 2.5 0 0 1 4.5 0zm7.452 6c1.257 0 2.286.977 2.37 2.212l.005.163V14.5h.5a.75.75 0 0 1 .102 1.493l-.102.007h-2.5a.75.75 0 0 1-.102-1.493l.102-.007h.5V8.375a.875.875 0 0 0-1.743-.11l-.007.11v.875a.75.75 0 0 1-1.493.102l-.007-.102v-.875A2.375 2.375 0 0 1 11.952 6zM5.25 12l-1.5.001V14.5h1.5V12zm-.246-6.5H3.996A2.5 2.5 0 0 0 1.5 8v2.249c0 .139.111.251.246.251h5.508c.136 0 .246-.11.246-.251V8c0-1.384-1.113-2.5-2.496-2.5zm-.504-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
          opacity=".65"
        />
      </svg>`
  },
  notifications: {
    24: () => html` <svg viewBox="0 0 24 24" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path
            d="M12 0a2 2 0 0 1 2 2v.252c3.45.888 6 4.02 6 7.748v8c0 .117.066.224.17.276l.554.277A2.309 2.309 0 0 1 22 20.618v.882a.5.5 0 0 1-.5.5h-6.627c-.455 1.309-1.44 2-2.873 2-1.433 0-2.418-.691-2.873-2H2.5a.5.5 0 0 1-.5-.5v-.882c0-.875.494-1.674 1.276-2.065l.553-.277A.309.309 0 0 0 4 18v-8c0-3.728 2.55-6.86 6-7.748V2a2 2 0 0 1 2-2zm1.792 22h-3.584c.342.683.922 1 1.792 1s1.45-.317 1.792-1zM12 3a7 7 0 0 0-7 7v8c0 .496-.28.95-.724 1.17l-.552.277A1.309 1.309 0 0 0 3 20.618V21h18v-.382c0-.496-.28-.949-.724-1.17l-.552-.277A1.309 1.309 0 0 1 19 18v-8a7 7 0 0 0-7-7zm0-2a1 1 0 0 0-1 1l-.001.062a8.079 8.079 0 0 1 2.001 0V2a1 1 0 0 0-1-1z"
            id="a"
          />
        </defs>
        <use xlink:href="#a" />
      </svg>`
  },
  tableSort: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M7.628 13.834a.5.5 0 0 0 .744 0l4.5-5a.5.5 0 1 0-.744-.668L8.5 12.196V2.5a.5.5 0 0 0-.41-.492L8 2a.5.5 0 0 0-.5.5v9.699L3.872 8.166a.5.5 0 0 0-.634-.092l-.072.054a.5.5 0 0 0-.038.706z"
        />
      </svg>`
  },
  ticketTypePlatinum: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path d="m12 3 3 4-7 7-7-7 3-4z" />
      </svg>`
  },
  ticketTypeResale: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path
          d="M7.836 3.009C5.233 3.141 2.75 5.203 2.75 8.25H1l2.625 2.662L6.25 8.25H4.5c0-3.165 3.823-4.707 5.933-2.496l1.258-1.22a4.903 4.903 0 0 0-2.734-1.47 5.155 5.155 0 0 0-1.121-.056v.001zm4.54 2.579L9.75 8.25h1.75c0 3.166-3.823 4.707-5.933 2.496l-1.258 1.22c3.14 3.292 8.941.929 8.941-3.716H15l-2.625-2.662z"
        />
      </svg>`
  },
  ticketTypeVip: {
    16: () => html` <svg viewBox="0 0 16 16">
        <path d="M8 11.492 4.038 14l.742-4.792L.99 6.017l5.02-.505L8.006.98 9.99 5.51l5.033.506-3.803 3.19.827 4.793z" />
      </svg>`
  },
  volumeDown: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13 2.5v19a.5.5 0 0 1-.854.354L7.293 17H2.5A2.5 2.5 0 0 1 0 14.5v-5A2.5 2.5 0 0 1 2.5 7h4.793l4.853-4.854A.5.5 0 0 1 13 2.5zm-1 1.207L7.854 7.854A.5.5 0 0 1 7.5 8h-5A1.5 1.5 0 0 0 1 9.5v5A1.5 1.5 0 0 0 2.5 16h5a.5.5 0 0 1 .354.146L12 20.293V3.707zm4.916 4.516C17.639 9.307 18 10.57 18 12c0 1.43-.361 2.693-1.084 3.777a.5.5 0 1 1-.832-.554c.61-.916.916-1.986.916-3.223 0-1.237-.306-2.307-.916-3.223a.5.5 0 1 1 .832-.554z"
        />
      </svg>`
  },
  volumeMiddle: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13 2.5v19a.5.5 0 0 1-.854.354L7.293 17H2.5A2.5 2.5 0 0 1 0 14.5v-5A2.5 2.5 0 0 1 2.5 7h4.793l4.853-4.854A.5.5 0 0 1 13 2.5zm-1 1.207L7.854 7.854A.5.5 0 0 1 7.5 8h-5A1.5 1.5 0 0 0 1 9.5v5A1.5 1.5 0 0 0 2.5 16h5a.5.5 0 0 1 .354.146L12 20.293V3.707zm6.854 2.44C20.287 7.58 21 9.54 21 12c0 2.459-.713 4.42-2.146 5.854a.5.5 0 0 1-.708-.708C19.38 15.913 20 14.208 20 12c0-2.208-.62-3.913-1.854-5.146a.5.5 0 0 1 .708-.708zm-1.938 2.076C17.639 9.307 18 10.57 18 12c0 1.43-.361 2.693-1.084 3.777a.5.5 0 1 1-.832-.554c.61-.916.916-1.986.916-3.223 0-1.237-.306-2.307-.916-3.223a.5.5 0 1 1 .832-.554z"
        />
      </svg>`
  },
  volumeMute: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13 2.5v19a.5.5 0 0 1-.854.354L7.293 17H2.5A2.5 2.5 0 0 1 0 14.5v-5A2.5 2.5 0 0 1 2.5 7h4.793l4.853-4.854A.5.5 0 0 1 13 2.5zm-1 1.207L7.854 7.854A.5.5 0 0 1 7.5 8h-5A1.5 1.5 0 0 0 1 9.5v5A1.5 1.5 0 0 0 2.5 16h5a.5.5 0 0 1 .354.146L12 20.293V3.707zm4.146 4.44a.5.5 0 0 1 .708 0L20 11.292l3.146-3.147a.5.5 0 0 1 .708.708L20.707 12l3.147 3.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.708 0L20 12.707l-3.146 3.147a.5.5 0 0 1-.708-.708L19.293 12l-3.147-3.146a.5.5 0 0 1-.057-.638z"
        />
      </svg>`
  },
  volumeUp: {
    24: () => html` <svg viewBox="0 0 24 24">
        <path
          d="M13 2.5v19a.5.5 0 0 1-.854.354L7.293 17H2.5A2.5 2.5 0 0 1 0 14.5v-5A2.5 2.5 0 0 1 2.5 7h4.793l4.853-4.854A.5.5 0 0 1 13 2.5zm-1 1.207L7.854 7.854A.5.5 0 0 1 7.5 8h-5A1.5 1.5 0 0 0 1 9.5v5A1.5 1.5 0 0 0 2.5 16h5a.5.5 0 0 1 .354.146L12 20.293V3.707zm8.906.442C22.966 6.245 24 8.871 24 12c0 3.13-1.051 5.758-3.146 7.854a.5.5 0 0 1-.708-.708C22.051 17.242 23 14.87 23 12c0-2.871-.934-5.245-2.807-7.15a.5.5 0 1 1 .713-.7zm-2.052 1.997C20.287 7.58 21 9.541 21 12s-.713 4.42-2.146 5.854a.5.5 0 0 1-.708-.708C19.38 15.913 20 14.208 20 12c0-2.208-.62-3.913-1.854-5.146a.5.5 0 0 1 .708-.708zm-1.938 2.077C17.639 9.307 18 10.57 18 12c0 1.43-.361 2.693-1.084 3.777a.5.5 0 1 1-.832-.554c.61-.916.916-1.986.916-3.223 0-1.237-.306-2.307-.916-3.223a.5.5 0 1 1 .832-.554z"
        />
      </svg>`
  },
  check: {
    24: () => html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.7071 5.29289C22.0976 5.68342 22.0976 6.31658 21.7071 6.70711L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071L2.29289 12.7071C1.90237 12.3166 1.90237 11.6834 2.29289 11.2929C2.68342 10.9024 3.31658 10.9024 3.70711 11.2929L9 16.5858L20.2929 5.29289C20.6834 4.90237 21.3166 4.90237 21.7071 5.29289Z"/>
      </svg>`,
    16: () => html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 3.29289C15.0976 3.68342 15.0976 4.31658 14.7071 4.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L1.29289 8.70711C0.902369 8.31658 0.902369 7.68342 1.29289 7.29289C1.68342 6.90237 2.31658 6.90237 2.70711 7.29289L6 10.5858L13.2929 3.29289C13.6834 2.90237 14.3166 2.90237 14.7071 3.29289Z"/>
      </svg>`
  },
  reorder: {
    24: () => html`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <circle cx="8.5" cy="4.5" r="1.5" />
        <circle cx="8.5" cy="12" r="1.5" />
        <circle cx="15.5" cy="4.5" r="1.5" />
        <circle cx="15.5" cy="12" r="1.5" />
        <circle cx="8.5" cy="19.5" r="1.5" />
        <circle cx="15.5" cy="19.5" r="1.5" />
      </svg>
    `
  },
  addImage: {
    24: () => html`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M3.664 22c-.462 0-.855-.162-1.179-.486A1.608 1.608 0 0 1 2 20.334V3.666c0-.463.162-.857.485-1.18A1.604 1.604 0 0 1 3.665 2H15.01v1.667H3.664v16.666h16.644V9h1.664v11.333c0 .463-.162.857-.485 1.18a1.604 1.604 0 0 1-1.18.487H3.665ZM18.09 8.167v-2.25h-2.247V4.25h2.247V2h1.664v2.25H22v1.667h-2.247v2.25H18.09ZM5.329 17.5h13.315l-3.995-5.333-3.523 4.639L8.52 13.36 5.329 17.5Z"
        />
      </svg>
    `
  },
  crop: {
    24: () => html`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M16.545 14.727h1.819V7.455c0-1-.819-1.819-1.819-1.819H9.273v1.819h7.272v7.272Zm-9.09 1.819V2H5.636v3.636H2v1.819h3.636v9.09c0 1 .819 1.819 1.819 1.819h9.09V22h1.819v-3.636H22v-1.819H7.455Z"
        />
      </svg>
    `
  },
  "payment-maestrosolid": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="18" rx="1.895" fill="black" />
        <path d="M9.81995 5H14.1879V12.847H9.82049L9.81995 5Z" fill="#6C69BF" />
        <path
          d="M9.98909 8.99015C9.98909 7.39675 10.7375 5.98221 11.8889 5.06718C11.0435 4.4019 9.97436 4 8.81036 4C6.05036 4 3.81836 6.23142 3.81836 8.98961C3.81836 11.7489 6.05091 13.9814 8.81091 13.9814C9.976 13.9814 11.044 13.5795 11.89 12.9137C10.7391 12.0128 9.99018 10.5852 9.99018 8.99015H9.98909Z"
          fill="#EE0005"
        />
        <path
          d="M19.8915 8.98961C19.8915 11.7489 17.6584 13.9814 14.899 13.9814C13.7339 13.9814 12.6664 13.5795 11.8204 12.9137C12.9855 11.9986 13.7203 10.5852 13.7203 8.99015C13.7203 7.39675 12.9713 5.98221 11.8204 5.06718C12.6659 4.4019 13.7339 4 14.899 4C17.659 4 19.8915 6.24505 19.8915 8.98961V8.98961Z"
          fill="#0098E2"
        />
      </svg>
    `
  },
  errorFilled: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path
          fill="#FF004E"
          fill-rule="evenodd"
          d="M6.895 1h10.21L23 6.916v10.261L17.1 23H6.9L1 17.177V6.917L6.895 1Z"
          clip-rule="evenodd"
        />
        <path fill="#050505" d="M11 6v9h2V6h-2Zm0 10.5v2h2v-2h-2Z" />
      </svg>`
  },
  errorOutline: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path d="M11 15V6h2v9h-2Zm0 3.5v-2h2v2h-2Z" />
        <path
          fill-rule="evenodd"
          d="M17.105 1H6.895L1 6.916v10.261L6.9 23h10.2l5.9-5.823V6.917L17.105 1ZM2.5 7.536 7.518 2.5h8.964L21.5 7.536v9.013L16.486 21.5H7.514L2.5 16.55V7.535Z"
          clip-rule="evenodd"
        />
      </svg>`
  },
  navigation: {
    16: () => html`<svg viewBox="0 0 17 16">
        <path
          d="M10.13 2.815a1.481 1.481 0 1 1-2.963 0 1.481 1.481 0 0 1 2.963 0Zm0 5.185a1.481 1.481 0 1 1-2.963 0 1.481 1.481 0 0 1 2.963 0Zm-1.482 6.667a1.481 1.481 0 1 0 0-2.963 1.481 1.481 0 0 0 0 2.963Z"
        />
      </svg>`
  },
  questionFilled: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#E711FA" d="M5.895 1h12.21L23 5.916v12.261L18.1 23H5.9L1 18.177V5.917L5.895 1Z" />
        <path
          fill="#050505"
          d="M12.25 8h.003l.046.003a2.273 2.273 0 0 1 .771.183c.2.088.365.206.478.358.107.142.202.357.202.706 0 .67-.338 1.083-.916 1.79l-.04.048c-.583.713-1.294 1.638-1.294 3.162H13c0-.976.414-1.551.956-2.212l.112-.137c.514-.62 1.182-1.428 1.182-2.65 0-.652-.187-1.187-.502-1.607a2.678 2.678 0 0 0-1.068-.83 3.77 3.77 0 0 0-1.383-.313h-.066a1.966 1.966 0 0 0-.142.006 3.821 3.821 0 0 0-1.425.385c-.4.2-.825.513-1.147.997C9.19 8.377 9 8.994 9 9.75h1.5c0-.494.121-.814.265-1.03a1.45 1.45 0 0 1 .57-.487A2.324 2.324 0 0 1 12.247 8h.004Zm-.75 7.5V17H13v-1.5h-1.5Z"
        />
      </svg>`
  },
  questionOutline: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path
          fill-rule="evenodd"
          d="M5.895 1h12.21L23 5.916v12.261L18.1 23H5.9L1 18.177V5.917L5.895 1Zm.623 1.5L2.5 6.536v11.013l4.014 3.95 10.972.001 4.014-3.95V6.535L17.482 2.5H6.518Z"
          clip-rule="evenodd"
        />
        <path
          d="M12.25 8h.003l.046.003a2.273 2.273 0 0 1 .771.183c.2.088.365.206.478.358.107.142.202.357.202.706 0 .67-.338 1.083-.916 1.79l-.04.048c-.583.713-1.294 1.638-1.294 3.162H13c0-.976.414-1.551.956-2.212l.112-.137c.514-.62 1.182-1.428 1.182-2.65 0-.652-.187-1.187-.502-1.607a2.678 2.678 0 0 0-1.068-.83 3.77 3.77 0 0 0-1.383-.313h-.066a1.98 1.98 0 0 0-.142.006 3.821 3.821 0 0 0-1.425.385c-.4.2-.825.513-1.147.997C9.19 8.377 9 8.994 9 9.75h1.5c0-.494.121-.814.265-1.03a1.45 1.45 0 0 1 .57-.487A2.324 2.324 0 0 1 12.247 8h.004Zm-.75 7.5V17H13v-1.5h-1.5Z"
        />
      </svg>`
  },
  statusArrowPositive: {
    16: () => html` <svg viewBox="0 0 17 16">
        <g stroke="none" stroke-width="1" fill-rule="evenodd">
          <g transform="translate(0.8742, 0)" fill-rule="nonzero">
            <polygon
              points="16 0 16 15.8693975 15.6073536 15.8693975 15.6073536 0.637845289 10.5828932 5.67318678 0.278226839 16 0 15.7235133 10.3046664 5.39670012 15.2988644 0.391836975 0.147358994 0.391836975 0.147358994 0"
            ></polygon>
          </g>
        </g>
      </svg>`,
    24: () => html`<svg viewBox="0 0 28 28">
        <path
          d="M25.2491 1.85156H0.997155V0.351562H27.7472V26.9974H26.2472V2.97348L1.60002 27.0822L0.546875 26.0142L25.2491 1.85156Z"
        />
      </svg>`
  },
  statusArrowNegative: {
    16: () => html`<svg viewBox="0 0 16 16">
        <g stroke="none" stroke-width="1" fill-rule="evenodd">
          <g transform="translate(-0.0003, 0)" fill-rule="nonzero">
            <polygon
              points="16 0 16 16 2.11584656e-05 16 2.11584656e-05 15.6049383 15.323391 15.6049383 0 0.3292392 0.280223417 0.0498883724 15.6037042 15.3256296 15.6037042 0"
            ></polygon>
          </g>
        </g>
      </svg> `,
    24: () => html`<svg viewBox="0 0 28 28">
        <path
          d="M25.2491 26.1448L0.546875 1.98211L1.60002 0.914062L26.2472 25.0228V0.99896H27.7472V27.6448H0.997155V26.1448H25.2491Z"
        />
      </svg>`
  },
  successFilled: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#26FF44" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z" />
        <path
        fill="#050505"
          fill-rule="evenodd"
          d="m17.564 8.494-7.527 8.603-3.567-3.566 1.06-1.061 2.434 2.433 6.472-7.397 1.128.988Z"
          clip-rule="evenodd"
        />
      </svg>`
  },
  warningFilled: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill="#FF7126" d="M12 2 1 22h22L12 2Z" />
        <path fill="#050505" d="M11.25 9.25v7h1.5v-7h-1.5Zm0 8.25V19h1.5v-1.5h-1.5Z" />
      </svg>`
  },
  warningOutline: {
    24: () => html`<svg viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M1 22h22L12 2 1 22Zm2.537-1.5h16.926L12 5.113 3.537 20.5Z" clip-rule="evenodd" />
        <path d="M11.25 9.25v7h1.5v-7h-1.5Zm0 8.25V19h1.5v-1.5h-1.5Z" />
      </svg>`
  },
  "payment-klarna": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5152_104200)">
          <rect width="24" height="18" rx="2" fill="#FFB3C7"/>
          <path d="M5.68156 6.79999H4.72141C4.72141 7.58791 4.35974 8.30694 3.73113 8.78056L3.35223 9.06473L4.82474 11.0711H6.03461L4.67835 9.22403C5.31989 8.58681 5.68156 7.72569 5.68156 6.79999Z" fill="black"/>
          <path d="M3.23167 6.79999H2.25V11.0711H3.23167V6.79999Z" fill="black"/>
          <path d="M7.24447 6.79999H6.31877V11.0711H7.24447V6.79999Z" fill="black"/>
          <path d="M15.3648 8.03571C15.0118 8.03571 14.6759 8.14335 14.452 8.44904V8.11751H13.5737V11.0711H14.4649V9.52113C14.4649 9.07335 14.7663 8.85377 15.128 8.85377C15.5155 8.85377 15.7394 9.08627 15.7394 9.51683V11.0754H16.622V9.19391C16.622 8.50501 16.0752 8.03571 15.3648 8.03571Z" fill="black"/>
          <path d="M10.0431 8.11751V8.30696C9.79339 8.13473 9.49199 8.03571 9.16477 8.03571C8.30365 8.03571 7.60615 8.73321 7.60615 9.59433C7.60615 10.4554 8.30365 11.1529 9.16477 11.1529C9.49199 11.1529 9.79339 11.0539 10.0431 10.8817V11.0711H10.9258V8.11751H10.0431ZM9.23796 10.3521C8.79449 10.3521 8.43713 10.012 8.43713 9.59433C8.43713 9.17669 8.79449 8.83654 9.23796 8.83654C9.68144 8.83654 10.0388 9.17669 10.0388 9.59433C10.0388 10.012 9.68144 10.3521 9.23796 10.3521Z" fill="black"/>
          <path d="M12.2949 8.50075V8.11755H11.3908V11.0712H12.2992V9.6934C12.2992 9.22839 12.803 8.97867 13.1517 8.97867C13.156 8.97867 13.1604 8.97867 13.1604 8.97867V8.11755C12.803 8.11755 12.4715 8.27255 12.2949 8.50075Z" fill="black"/>
          <path d="M19.369 8.11751V8.30696C19.1193 8.13473 18.8179 8.03571 18.4907 8.03571C17.6296 8.03571 16.9321 8.73321 16.9321 9.59433C16.9321 10.4554 17.6296 11.1529 18.4907 11.1529C18.8179 11.1529 19.1193 11.0539 19.369 10.8817V11.0711H20.2517V8.11751H19.369ZM18.5639 10.3521C18.1204 10.3521 17.763 10.012 17.763 9.59433C17.763 9.17669 18.1204 8.83654 18.5639 8.83654C19.0073 8.83654 19.3647 9.17669 19.3647 9.59433C19.369 10.012 19.0073 10.3521 18.5639 10.3521Z" fill="black"/>
          <path d="M20.9362 8.20353C20.9362 8.16048 20.9061 8.13464 20.8587 8.13464H20.7769V8.35853H20.8157V8.27673H20.8587L20.8932 8.35853H20.9362L20.8975 8.26812C20.9233 8.2552 20.9362 8.23367 20.9362 8.20353ZM20.8587 8.23798H20.8157V8.16909H20.8587C20.8846 8.16909 20.8975 8.182 20.8975 8.20353C20.8975 8.22506 20.8889 8.23798 20.8587 8.23798Z" fill="black"/>
          <path d="M20.8458 8.03998C20.7296 8.03998 20.6348 8.1347 20.6348 8.25095C20.6392 8.3672 20.7296 8.46193 20.8458 8.46193C20.9621 8.46193 21.0568 8.3672 21.0568 8.25095C21.0568 8.1347 20.9621 8.03998 20.8458 8.03998ZM20.8458 8.42318C20.7511 8.42318 20.6779 8.34567 20.6779 8.25095C20.6779 8.15623 20.7554 8.07873 20.8458 8.07873C20.9405 8.07873 21.0137 8.15623 21.0137 8.25095C21.0137 8.34567 20.9362 8.42318 20.8458 8.42318Z" fill="black"/>
          <path d="M21.1946 10.025C20.8889 10.025 20.6392 10.2747 20.6392 10.5804C20.6392 10.8861 20.8889 11.1358 21.1946 11.1358C21.5003 11.1358 21.75 10.8861 21.75 10.5804C21.75 10.2704 21.5003 10.025 21.1946 10.025Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_5152_104200">
            <rect width="24" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    `
  },
  "payment-applepay": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5152_104196)">
          <rect x="0.5" y="0.5" width="23" height="17" rx="1.5" fill="white" stroke="black"/>
          <path d="M6.41465 6.1573C6.62408 5.88803 6.77367 5.52901 6.7288 5.16998C6.41465 5.18494 6.04067 5.37941 5.81628 5.63372C5.62181 5.85811 5.4423 6.23209 5.48717 6.57616C5.8462 6.62104 6.19026 6.42657 6.41465 6.1573ZM6.7288 6.66591C6.22018 6.636 5.78636 6.95014 5.54701 6.95014C5.30766 6.95014 4.93368 6.68087 4.52978 6.68087C4.0062 6.69583 3.5275 6.98006 3.25824 7.45876C2.7197 8.40119 3.10864 9.79241 3.64718 10.5553C3.90149 10.9293 4.21563 11.3482 4.61953 11.3332C5.00848 11.3183 5.15807 11.0789 5.62181 11.0789C6.08555 11.0789 6.22018 11.3332 6.63904 11.3183C7.0579 11.3033 7.32717 10.9443 7.58148 10.5553C7.88066 10.1215 8.00034 9.70265 8.00034 9.6877C7.98538 9.67274 7.17758 9.37355 7.17758 8.44607C7.16262 7.66819 7.80587 7.29421 7.83579 7.27925C7.49172 6.74071 6.92327 6.68087 6.7288 6.66591Z" fill="black"/>
          <path d="M11.1268 5.60376C12.2338 5.60376 12.9968 6.36668 12.9968 7.45871C12.9968 8.5657 12.2189 9.32863 11.0969 9.32863H9.88522V11.2584H9.00262V5.60376H11.1268ZM9.88522 8.59562H10.8875C11.6504 8.59562 12.0842 8.17676 12.0842 7.47367C12.0842 6.75563 11.6504 6.35173 10.8875 6.35173H9.87027V8.59562H9.88522ZM13.2212 10.1065C13.2212 9.38847 13.7746 8.93969 14.762 8.87985L15.8989 8.82001V8.50587C15.8989 8.04213 15.5847 7.77286 15.0761 7.77286C14.5824 7.77286 14.2833 8.01221 14.2085 8.37123H13.4007C13.4455 7.62327 14.0888 7.06977 15.106 7.06977C16.1083 7.06977 16.7515 7.59335 16.7515 8.43107V11.2733H15.9437V10.6002H15.9288C15.6894 11.0639 15.1659 11.3481 14.6273 11.3481C13.7896 11.3481 13.2212 10.8395 13.2212 10.1065ZM15.8989 9.73253V9.40342L14.8816 9.46326C14.373 9.49318 14.0888 9.71757 14.0888 10.0766C14.0888 10.4356 14.388 10.675 14.8368 10.675C15.4351 10.675 15.8989 10.2711 15.8989 9.73253ZM17.4995 12.7992V12.1111C17.5594 12.126 17.7089 12.126 17.7688 12.126C18.1577 12.126 18.3672 11.9615 18.5018 11.5426C18.5018 11.5276 18.5766 11.2883 18.5766 11.2883L17.0807 7.15953H17.9932L19.0403 10.5254H19.0553L20.1024 7.15953H21L19.4592 11.5127C19.1002 12.515 18.6963 12.8291 17.8436 12.8291C17.7837 12.8141 17.5743 12.8141 17.4995 12.7992Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_5152_104196">
            <rect width="24" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    `
  },
  "payment-paypal": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5152_104198)">
          <rect x="0.5" y="0.5" width="23" height="17" rx="1.5" fill="white" stroke="black"/>
          <path d="M15.5741 7.06301L10.196 12.9315H8.2234C8.08642 12.9315 7.97683 12.7945 8.00423 12.6575L9.31929 4.32877C9.34669 4.13699 9.51108 4 9.70286 4H13.0453C15.3467 4.08219 15.9768 5.26027 15.5659 7.06849L15.5741 7.06301Z" fill="#002C8A"/>
          <path d="M15.6618 6.52057C16.4837 6.95892 16.6755 7.78084 16.4015 8.87673C16.0453 10.4932 14.9768 11.1781 13.4152 11.2055L12.9768 11.2329C12.8124 11.2329 12.7029 11.3425 12.6755 11.5069L12.3193 13.6713C12.2919 13.863 12.1275 14 11.9357 14H10.2919C10.1549 14 10.0453 13.863 10.0727 13.726L10.6755 9.80824C10.7029 9.67125 15.6618 6.52057 15.6618 6.52057Z" fill="#009BE1"/>
          <path d="M10.6426 10L11.1905 6.52055C11.2085 6.43814 11.2531 6.36396 11.3175 6.30948C11.3819 6.255 11.4624 6.22326 11.5467 6.21918H14.1768C14.807 6.21918 15.2727 6.32877 15.6563 6.52055C15.5193 7.72603 14.9439 9.67123 12.1494 9.72603H10.9439C10.807 9.72603 10.67 9.83561 10.6426 10Z" fill="#001F6B"/>
        </g>
        <defs>
          <clipPath id="clip0_5152_104198">
            <rect width="24" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>

    `
  },
  "payment-flexpay": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5152_104199)">
          <rect x="0.5" y="0.5" width="23" height="17" rx="1.5" fill="white" stroke="black"/>
          <path d="M17.965 5.17119C17.965 5.07288 17.9626 4.96977 17.941 4.87386C17.8235 4.33436 17.3967 4.00107 16.8236 4.00107C14.6656 4.00107 12.5076 3.99867 10.3496 4.00107C9.86284 4.00107 9.38808 4.0754 8.92771 4.23605C7.17253 4.84509 6.0048 6.48038 6.00241 8.33866C5.99761 9.84927 6.00241 11.3623 6.00001 12.8729C5.99761 13.5826 6.57308 14.0094 7.12697 13.9998C8.17001 13.9831 9.21304 13.995 10.2561 13.995C11.2344 13.995 12.2151 13.995 13.1934 13.995C13.3516 13.995 13.5123 13.9879 13.6705 13.9711C14.7184 13.8656 15.6343 13.4555 16.404 12.7434C17.4494 11.7747 17.9626 10.5662 17.9626 9.14192C17.965 7.81834 17.965 6.49477 17.965 5.17119ZM16.6869 9.25222C16.6726 10.9738 15.3826 12.4341 13.6633 12.6811C13.4811 12.7074 13.2989 12.7218 13.1142 12.7218C11.3567 12.7242 9.59669 12.7194 7.83911 12.7266C7.51301 12.729 7.27563 12.5372 7.28043 12.1679C7.29242 10.9019 7.28522 9.63347 7.28522 8.36744C7.28522 6.93116 8.23235 5.71548 9.63026 5.375C9.85805 5.31985 10.0954 5.29108 10.328 5.28868C11.2871 5.27909 12.2462 5.28388 13.2054 5.28388C14.1956 5.28388 15.1883 5.28388 16.1786 5.28388C16.4999 5.28388 16.6869 5.46851 16.6869 5.78742C16.6869 6.94075 16.6941 8.09649 16.6869 9.25222Z" fill="#3B424F"/>
          <path d="M12.8313 6.03918C13.7305 6.03918 14.6296 6.03918 15.5264 6.03918C15.8046 6.03918 15.9053 6.13989 15.9029 6.41804C15.9029 7.37955 15.9125 8.34346 15.8933 9.30497C15.8837 9.76295 15.7542 10.1969 15.5 10.5878C15.2123 11.0338 14.843 11.3958 14.3659 11.6356C14.0949 11.7723 13.8096 11.8538 13.5099 11.9042C13.2677 11.9449 13.0255 11.9234 12.7833 11.9282C12.1791 11.9401 11.5749 11.9473 10.9706 11.9569C10.75 11.9593 10.6493 11.861 10.6493 11.638C10.6493 11.4702 10.6469 11.3023 10.6493 11.1345C10.6517 10.8923 10.7836 10.758 11.0282 10.758C11.7619 10.7556 12.498 10.77 13.2317 10.7484C13.6418 10.7365 14.0062 10.571 14.294 10.2641C14.4019 10.149 14.5241 10.0483 14.6009 9.90682C14.7879 9.55914 14.8982 9.20187 14.8478 8.79904C14.8023 8.44177 14.6728 8.12046 14.4666 7.83753C14.2268 7.51143 13.8863 7.322 13.4907 7.24048C13.3828 7.2189 13.2701 7.2117 13.1598 7.2117C12.2846 7.20931 11.4094 7.20691 10.5366 7.2117C9.92758 7.2141 9.49118 7.61693 9.35691 8.20678C9.33772 8.2955 9.42165 8.38662 9.52475 8.38662C10.2129 8.38662 10.8987 8.38662 11.5868 8.38662C12.0137 8.38662 12.4429 8.39381 12.8697 8.38422C13.2773 8.37703 13.4116 8.60002 13.4691 8.83261C13.5698 9.24743 13.2605 9.62867 12.8529 9.63107C11.8314 9.63107 10.8076 9.63107 9.78611 9.63107C9.49838 9.63107 9.35691 9.77254 9.35691 10.0651C9.35691 10.5926 9.35691 11.1201 9.35691 11.6476C9.35691 11.8658 9.261 11.9593 9.0428 11.9617C8.80781 11.9617 8.57043 11.9641 8.33545 11.9593C8.1748 11.9569 8.0621 11.8394 8.0621 11.6788C8.0597 10.4727 8.05011 9.26661 8.0645 8.06052C8.0693 7.68167 8.21316 7.32919 8.41937 7.00789C8.62079 6.69138 8.90133 6.4588 9.22503 6.28136C9.52475 6.11831 9.85325 6.04158 10.1937 6.04158C11.0737 6.03918 11.9513 6.03918 12.8313 6.03918Z" fill="#8FC640"/>
        </g>
        <defs>
          <clipPath id="clip0_5152_104199">
            <rect width="24" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    `
  },
  "payment-googlepay": {
    24: () => html`
      <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_5152_104197)">
          <rect x="0.5" y="0.5" width="23" height="17" rx="1.5" fill="white" stroke="black"/>
          <path d="M11.5133 8.8927V10.9873H10.8483V5.81341H12.6111C13.0364 5.80436 13.4473 5.96572 13.7527 6.26128C14.0618 6.5395 14.236 6.93761 14.2292 7.35306C14.2382 7.77152 14.064 8.17264 13.7527 8.45162C13.4443 8.74568 13.0635 8.8927 12.6111 8.89195L11.5133 8.8927ZM11.5133 6.45053V8.25709H12.6277C12.875 8.26463 13.1133 8.16737 13.2852 7.98942C13.6343 7.65013 13.6426 7.09142 13.3025 6.74233C13.2965 6.73629 13.2912 6.73026 13.2852 6.72498C13.1155 6.54327 12.8758 6.44375 12.6277 6.45053H11.5133ZM15.7613 7.33195C16.2529 7.33195 16.6404 7.46314 16.9247 7.72553C17.2089 7.98792 17.3507 8.34832 17.3507 8.80524V10.9873H16.7151V10.4957H16.6864C16.4112 10.9006 16.0448 11.1026 15.5879 11.1026C15.198 11.1026 14.8716 10.9873 14.6092 10.7558C14.3543 10.5409 14.2096 10.2227 14.2156 9.88873C14.2156 9.52229 14.3543 9.23125 14.631 9.01485C14.9078 8.79846 15.2772 8.68988 15.7402 8.68988C16.1345 8.68988 16.4602 8.76226 16.7151 8.90628V8.75397C16.7166 8.52627 16.6155 8.31062 16.4406 8.16586C16.2649 8.00752 16.0357 7.92081 15.799 7.92383C15.428 7.92383 15.134 8.08066 14.9176 8.39356L14.3325 8.02486C14.6537 7.56267 15.1302 7.33195 15.7613 7.33195ZM14.901 9.9038C14.9002 10.0757 14.9824 10.2371 15.1211 10.3373C15.2682 10.4527 15.4506 10.5145 15.6376 10.5108C15.9181 10.51 16.1873 10.3984 16.3856 10.2001C16.6057 9.99278 16.7158 9.74999 16.7158 9.47026C16.5085 9.30514 16.2197 9.2222 15.8487 9.2222C15.5788 9.2222 15.3534 9.28704 15.1732 9.41748C14.9915 9.55018 14.901 9.71078 14.901 9.9038ZM21 7.44731L18.781 12.548H18.0949L18.9182 10.7634L17.4585 7.44731H18.1808L19.2357 9.99051H19.25L20.2762 7.44731H21Z" fill="#5F6368"/>
          <path d="M8.82683 8.44027C8.82683 8.23745 8.81025 8.03538 8.77556 7.83557H5.97223V8.98013H7.57747C7.51112 9.34958 7.29699 9.67606 6.98408 9.88341V10.6268H7.9424C8.50337 10.1104 8.82683 9.34506 8.82683 8.44027Z" fill="#4285F4"/>
          <path d="M5.97223 11.3454C6.77448 11.3454 7.45005 11.0823 7.94241 10.6276L6.98409 9.8842C6.71718 10.0652 6.37411 10.1685 5.97223 10.1685C5.19713 10.1685 4.5389 9.64594 4.30365 8.94171H3.31668V9.70776C3.8211 10.7121 4.84879 11.3454 5.97223 11.3454Z" fill="#34A853"/>
          <path d="M4.30365 8.94167C4.17924 8.57297 4.17924 8.1726 4.30365 7.8039V7.03784H3.31668C2.89444 7.87779 2.89444 8.86777 3.31668 9.70772L4.30365 8.94167Z" fill="#FBBC04"/>
          <path d="M5.97223 6.57718C6.39598 6.5704 6.80539 6.73024 7.11227 7.02279L7.96126 6.17455C7.42291 5.66938 6.71039 5.39191 5.97223 5.40021C4.84879 5.40021 3.8211 6.03431 3.31668 7.03787L4.30365 7.80392C4.5389 7.0997 5.19713 6.57718 5.97223 6.57718Z" fill="#EA4335"/>
        </g>
        <defs>
          <clipPath id="clip0_5152_104197">
            <rect width="24" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    `
  }
}, tm1IconStyles = () => css`
  :host {
    display: inline-block;
    fill: currentColor;
  }

  :host([size='small']) {
    width: 16px;
    height: 16px;
  }

  :host([size='regular']) {
    width: 24px;
    height: 24px;
  }

  :host([size='large']) {
    width: 36px;
    height: 36px;
  }

  :host svg {
    display: block;
    width: inherit;
    height: inherit;
  }

  :host([icon='alert']:not([color])),
  :host([icon='alert'][color='']) {
    fill: #F2BD2A;
  }
  
  :host([icon='error']:not([color])),
  :host([icon='error'][color='']) {
    fill: ${GDSEColorRed500};
  }
`, template = html`<template role="${(td) => td.role}" alt="${(td) => td.alt}" part="icon">${(td) => td.renderer}</template>`;
var __defProp$19 = Object.defineProperty, __getOwnPropDesc$19 = Object.getOwnPropertyDescriptor, __decorateClass$19 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$19(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$19(Ae, xr, id), id;
};
const IconSize = {
  small: "small",
  regular: "regular",
  large: "large"
};
var IconSizeEnum = /* @__PURE__ */ ((td) => (td[td.small = 16] = "small", td[td.regular = 24] = "regular", td[td.large = 36] = "large", td))(IconSizeEnum || {});
class Icon extends FoundationElement {
  constructor() {
    super(...arguments), this.size = IconSize.regular, this.icon = "", this.role = "img", this.deprecated = !1;
  }
  colorChanged(Ae, xr) {
    Ae !== xr && (this.style.fill = xr);
  }
  sizeChanged(Ae, xr) {
    Ae !== xr && this.handleIconOrSizeChange();
  }
  iconChanged(Ae, xr) {
    Ae !== xr && this.handleIconOrSizeChange();
  }
  handleIconOrSizeChange() {
    const Ae = this.icon && sprites[this.icon], xr = Object.entries(Ae || {}).map(([id, od]) => ({ size: Number(id), renderer: od }));
    if (xr.length === 0) {
      this.renderer = html`<svg></svg>`;
      return;
    }
    const ed = this.size && IconSizeEnum[this.size];
    this.renderer = xr.reduce((id, od) => Math.abs(id.size - Number(ed)) < Math.abs(od.size - Number(ed)) ? id : od).renderer();
  }
}
__decorateClass$19([
  attr()
], Icon.prototype, "alt", 2);
__decorateClass$19([
  attr()
], Icon.prototype, "color", 2);
__decorateClass$19([
  attr()
], Icon.prototype, "size", 2);
__decorateClass$19([
  attr()
], Icon.prototype, "icon", 2);
__decorateClass$19([
  attr()
], Icon.prototype, "role", 2);
__decorateClass$19([
  observable
], Icon.prototype, "renderer", 2);
const tm1Icon = Icon.compose({
  baseName: "icon",
  template,
  styles: tm1IconStyles
});
designSystem.register(
  tm1Icon()
);
const mobileStylesheetBehavior$3 = new MatchMediaStyleSheetBehavior(
  matchMedia("(max-width: 767px)"),
  css`
    :host(.title-page) {
      font-family: ${semanticFonts.GDSETypographyTitlePageFontFamily};
      font-size: ${semanticFonts.GDSETypographyTitlePageFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyTitlePageFontWeight};
      line-height: ${semanticFonts.GDSETypographyTitlePageLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyTitlePageLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subtitle-page) {
      font-family: ${semanticFonts.GDSETypographySubtitlePageFontFamily};
      font-size: ${semanticFonts.GDSETypographySubtitlePageFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographySubtitlePageFontWeight};
      line-height: ${semanticFonts.GDSETypographySubtitlePageLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubtitlePageLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.statement-l) {
      font-family: ${semanticFonts.GDSETypographyStatementLFontFamily};
      font-size: ${semanticFonts.GDSETypographyStatementLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyStatementLFontWeight};
      line-height: ${semanticFonts.GDSETypographyStatementLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyStatementLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.statement-subtext-l) {
      font-family: ${semanticFonts.GDSETypographyStatementSubtextLFontFamily};
      font-size: ${semanticFonts.GDSETypographyStatementSubtextLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyStatementSubtextLFontWeight};
      line-height: ${semanticFonts.GDSETypographyStatementSubtextLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyStatementSubtextLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.heading-l) {
      font-family: ${semanticFonts.GDSETypographyHeadingLFontFamily};
      font-size: ${semanticFonts.GDSETypographyHeadingLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyHeadingLFontWeight};
      line-height: ${semanticFonts.GDSETypographyHeadingLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyHeadingLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.heading-m) {
      font-family: ${semanticFonts.GDSETypographyHeadingMFontFamily};
      font-size: ${semanticFonts.GDSETypographyHeadingMFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyHeadingMFontWeight};
      line-height: ${semanticFonts.GDSETypographyHeadingMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyHeadingMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.heading-s) {
      font-family: ${semanticFonts.GDSETypographyHeadingSFontFamily};
      font-size: ${semanticFonts.GDSETypographyHeadingSFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyHeadingSFontWeight};
      line-height: ${semanticFonts.GDSETypographyHeadingSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyHeadingSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-xxl) {
      font-family: ${semanticFonts.GDSETypographyDataXXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataXXLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataXXLFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataXXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataXXLLetterSpacing};
      font-feature: auto;
      text-transform: none;
      text-decoration: none;
    }

    :host(.data-xl) {
      font-family: ${semanticFonts.GDSETypographyDataXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataXLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataXLFontWeightMobile};
      line-height: ${semanticFonts.GDSETypographyDataXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataXLLetterSpacing};
      font-feature: auto;
      text-transform: none;
      text-decoration: none;
    }

    :host(.data-l) {
      font-family: ${semanticFonts.GDSETypographyDataLFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataLFontWeightMobile};
      line-height: ${semanticFonts.GDSETypographyDataLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataLLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataLFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-m) {
      font-family: ${semanticFonts.GDSETypographyDataMFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataMFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataMFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataMLineHeightMobile};
      letter-spacing: ${semanticFonts.GDSETypographyDataMLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataMFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-s) {
      font-family: ${semanticFonts.GDSETypographyDataSFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataSFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataSFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataSLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataSFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-xs) {
      font-family: ${semanticFonts.GDSETypographyDataXSFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataXSFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataXSFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataXSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataXSLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataXSFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-context) {
      font-family: ${semanticFonts.GDSETypographyDataContextFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataContextFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyDataContextFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataContextLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataContextLetterSpacing};
      font-feature: auto;
      text-transform: ${GDSETextCaseNone};
      text-decoration: none;
    }

    :host(.body-xl) {
      font-family: ${semanticFonts.GDSETypographyBodyXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodyXLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyBodyXLFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodyXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodyXLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-l) {
      font-family: ${semanticFonts.GDSETypographyBodyLFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodyLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyBodyLFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodyLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodyLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-m) {
      font-family: ${semanticFonts.GDSETypographyBodyMFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodyMFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyBodyMFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodyMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodyMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-s) {
      font-family: ${semanticFonts.GDSETypographyBodySFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodySFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyBodySFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodySLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodySLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-helpertext-highemphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-helpertext-regular) {
      font-family: ${semanticFonts.GDSETypographyLabelHelpertextRegularFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelHelpertextRegularFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelHelpertextRegularFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelHelpertextRegularLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelHelpertextRegularLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-data-l) {
      font-family: ${semanticFonts.GDSETypographyLabelDataLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataLFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelDataLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-data-s) {
      font-family: ${semanticFonts.GDSETypographyLabelDataSFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataSFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelDataSFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-nav-breadcrumbs) {
      font-family: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-xl-emphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelUIXLEmphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUIXLEmphasisFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelUIXLEmphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUIXLEmphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUIXLEmphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }
  `
), tm1TypographyStyles = () => css`
    :host {
      display: block;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    :host(.title-page) {
      font-family: ${semanticFonts.GDSETypographyTitlePageFontFamily};
      font-size: ${semanticFonts.GDSETypographyTitlePageFontSize};
      font-weight: ${semanticFonts.GDSETypographyTitlePageFontWeight};
      line-height: ${semanticFonts.GDSETypographyTitlePageLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyTitlePageLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subtitle-page) {
      font-family: ${semanticFonts.GDSETypographySubtitlePageFontFamily};
      font-size: ${semanticFonts.GDSETypographySubtitlePageFontSize};
      font-weight: ${semanticFonts.GDSETypographySubtitlePageFontWeight};
      line-height: ${semanticFonts.GDSETypographySubtitlePageLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubtitlePageLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.title-section) {
      font-family: ${semanticFonts.GDSETypographyTitleSectionFontFamily};
      font-size: ${semanticFonts.GDSETypographyTitleSectionFontSize};
      font-weight: ${semanticFonts.GDSETypographyTitleSectionFontWeight};
      line-height: ${semanticFonts.GDSETypographyTitleSectionLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyTitleSectionLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subtitle-section) {
      font-family: ${semanticFonts.GDSETypographySubtitleSectionFontFamily};
      font-size: ${semanticFonts.GDSETypographySubtitleSectionFontSize};
      font-weight: ${semanticFonts.GDSETypographySubtitleSectionFontWeight};
      line-height: ${semanticFonts.GDSETypographySubtitleSectionLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubtitleSectionLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.heading-l) {
      font-family: ${semanticFonts.GDSETypographyHeadingLFontFamily};
      font-size: ${semanticFonts.GDSETypographyHeadingLFontSize};
      font-weight: ${semanticFonts.GDSETypographyHeadingLFontWeight};
      line-height: ${semanticFonts.GDSETypographyHeadingLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyHeadingLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.heading-m) {
      font-family: ${semanticFonts.GDSETypographyHeadingMFontFamily};
      font-size: ${semanticFonts.GDSETypographyHeadingMFontSize};
      font-weight: ${semanticFonts.GDSETypographyHeadingMFontWeight};
      line-height: ${semanticFonts.GDSETypographyHeadingMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyHeadingMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.heading-s) {
      font-family: ${semanticFonts.GDSETypographyHeadingSFontFamily};
      font-size: ${semanticFonts.GDSETypographyHeadingSFontSize};
      font-weight: ${semanticFonts.GDSETypographyHeadingSFontWeight};
      line-height: ${semanticFonts.GDSETypographyHeadingSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyHeadingSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subheading-l) {
      font-family: ${semanticFonts.GDSETypographySubheadingLFontFamily};
      font-size: ${semanticFonts.GDSETypographySubheadingLFontSize};
      font-weight: ${semanticFonts.GDSETypographySubheadingLFontWeight};
      line-height: ${semanticFonts.GDSETypographySubheadingLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubheadingLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subheading-m) {
      font-family: ${semanticFonts.GDSETypographySubheadingMFontFamily};
      font-size: ${semanticFonts.GDSETypographySubheadingMFontSize};
      font-weight: ${semanticFonts.GDSETypographySubheadingMFontWeight};
      line-height: ${semanticFonts.GDSETypographySubheadingMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubheadingMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subheading-s) {
      font-family: ${semanticFonts.GDSETypographySubheadingSFontFamily};
      font-size: ${semanticFonts.GDSETypographySubheadingSFontSize};
      font-weight: ${semanticFonts.GDSETypographySubheadingSFontWeight};
      line-height: ${semanticFonts.GDSETypographySubheadingSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubheadingSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-xxl) {
      font-family: ${semanticFonts.GDSETypographyDataXXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataXXLFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataXXLFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataXXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataXXLLetterSpacing};
      font-feature: auto;
      text-transform: ${GDSETextCaseNone};
      text-decoration: none;
    }

    :host(.data-xl) {
      font-family: ${semanticFonts.GDSETypographyDataXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataXLFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataXLFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataXLLetterSpacing};
      font-feature: auto;
      text-transform: ${GDSETextCaseNone};
      text-decoration: none;
    }

    :host(.data-l) {
      font-family: ${semanticFonts.GDSETypographyDataLFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataLFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataLFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataLLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataLFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-m) {
      font-family: ${semanticFonts.GDSETypographyDataMFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataMFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataMFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataMLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataMFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-s) {
      font-family: ${semanticFonts.GDSETypographyDataSFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataSFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataSFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataSLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataSFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-xs) {
      font-family: ${semanticFonts.GDSETypographyDataXSFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataXSFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataXSFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataXSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataXSLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyDataXSFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.data-context) {
      font-family: ${semanticFonts.GDSETypographyDataContextFontFamily};
      font-size: ${semanticFonts.GDSETypographyDataContextFontSize};
      font-weight: ${semanticFonts.GDSETypographyDataContextFontWeight};
      line-height: ${semanticFonts.GDSETypographyDataContextLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyDataContextLetterSpacing};
      font-feature: auto;
      text-transform: ${GDSETextCaseNone};
      text-decoration: none;
    }

    :host(.title-list-m) {
      font-family: ${semanticFonts.GDSETypographyTitleListMFontFamily};
      font-size: ${semanticFonts.GDSETypographyTitleListMFontSize};
      font-weight: ${semanticFonts.GDSETypographyTitleListMFontWeight};
      line-height: ${semanticFonts.GDSETypographyTitleListMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyTitleListMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.title-list-s) {
      font-family: ${semanticFonts.GDSETypographyTitleListSFontFamily};
      font-size: ${semanticFonts.GDSETypographyTitleListSFontSize};
      font-weight: ${semanticFonts.GDSETypographyTitleListSFontWeight};
      line-height: ${semanticFonts.GDSETypographyTitleListSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyTitleListSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subtitle-list-m) {
      font-family: ${semanticFonts.GDSETypographySubtitleListMFontFamily};
      font-size: ${semanticFonts.GDSETypographySubtitleListMFontSize};
      font-weight: ${semanticFonts.GDSETypographySubtitleListMFontWeight};
      line-height: ${semanticFonts.GDSETypographySubtitleListMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubtitleListMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.subtitle-list-s) {
      font-family: ${semanticFonts.GDSETypographySubtitleListSFontFamily};
      font-size: ${semanticFonts.GDSETypographySubtitleListSFontSize};
      font-weight: ${semanticFonts.GDSETypographySubtitleListSFontWeight};
      line-height: ${semanticFonts.GDSETypographySubtitleListSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographySubtitleListSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-xl) {
      font-family: ${semanticFonts.GDSETypographyBodyXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodyXLFontSize};
      font-weight: ${semanticFonts.GDSETypographyBodyXLFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodyXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodyXLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-l) {
      font-family: ${semanticFonts.GDSETypographyBodyLFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodyLFontSize};
      font-weight: ${semanticFonts.GDSETypographyBodyLFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodyLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodyLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-m) {
      font-family: ${semanticFonts.GDSETypographyBodyMFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodyMFontSize};
      font-weight: ${semanticFonts.GDSETypographyBodyMFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodyMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodyMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.body-s) {
      font-family: ${semanticFonts.GDSETypographyBodySFontFamily};
      font-size: ${semanticFonts.GDSETypographyBodySFontSize};
      font-weight: ${semanticFonts.GDSETypographyBodySFontWeight};
      line-height: ${semanticFonts.GDSETypographyBodySLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyBodySLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-helpertext-highemphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelHelpertextHighemphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-helpertext-regular) {
      font-family: ${semanticFonts.GDSETypographyLabelHelpertextRegularFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelHelpertextRegularFontSizeMobile};
      font-weight: ${semanticFonts.GDSETypographyLabelHelpertextRegularFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelHelpertextRegularLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelHelpertextRegularLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-button-l) {
      font-family: ${semanticFonts.GDSETypographyLabelButtonLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelButtonLFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelButtonLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelButtonLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelButtonLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-button-m) {
      font-family: ${semanticFonts.GDSETypographyLabelButtonMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelButtonMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelButtonMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelButtonMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelButtonMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-button-s) {
      font-family: ${semanticFonts.GDSETypographyLabelButtonSFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelButtonSFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelButtonSFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelButtonSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelButtonSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-button-l-underline) {
      font-family: ${semanticFonts.GDSETypographyLabelButtonLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelButtonLFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelButtonLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelButtonLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelButtonLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: underline;
    }

    :host(.label-button-m-underline) {
      font-family: ${semanticFonts.GDSETypographyLabelButtonMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelButtonMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelButtonMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelButtonMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelButtonMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: underline;
    }

    :host(.label-button-s-underline) {
      font-family: ${semanticFonts.GDSETypographyLabelButtonSFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelButtonSFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelButtonSFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelButtonSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelButtonSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: underline;
    }

    :host(.label-container-l) {
      font-family: ${semanticFonts.GDSETypographyLabelContainerLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelContainerLFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelContainerLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelContainerLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelContainerLLetterSpacing};
      font-feature: auto;
      text-transform: ${semanticFonts.GDSETypographyLabelContainerLTextTransform};
      text-decoration: initial;
    }

    :host(.label-container-m) {
      font-family: ${semanticFonts.GDSETypographyLabelContainerMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelContainerMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelContainerMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelContainerMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelContainerMLetterSpacing};
      font-feature: auto;
      text-transform: ${semanticFonts.GDSETypographyLabelContainerMTextTransform};
      text-decoration: initial;
    }

    :host(.label-container-s) {
      font-family: ${semanticFonts.GDSETypographyLabelContainerSFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelContainerSFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelContainerSFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelContainerSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelContainerSLetterSpacing};
      font-feature: auto;
      text-transform: ${semanticFonts.GDSETypographyLabelContainerSTextTransform};
      text-decoration: initial;
    }

    :host(.label-data-l) {
      font-family: ${semanticFonts.GDSETypographyLabelDataLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataLFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelDataLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-data-m) {
      font-family: ${semanticFonts.GDSETypographyLabelDataMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelDataMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-data-s) {
      font-family: ${semanticFonts.GDSETypographyLabelDataSFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataSFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelDataSFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-data-highemphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelDataHighemphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataHighemphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelDataHighemphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataHighemphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataHighemphasisLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyLabelDataHighemphasisFontFeature};
      text-transform: ${semanticFonts.GDSETypographyLabelDataHighemphasisTextTransform};
      text-decoration: initial;
    }

    :host(.label-data-regular) {
      font-family: ${semanticFonts.GDSETypographyLabelDataRegularFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelDataRegularFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelDataRegularFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelDataRegularLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelDataRegularLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyLabelDataRegularFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-status-m) {
      font-family: ${semanticFonts.GDSETypographyLabelStatusMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelStatusMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelStatusMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelStatusMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelStatusMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-status-s) {
      font-family: ${semanticFonts.GDSETypographyLabelStatusSFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelStatusSFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelStatusSFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelStatusSLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelStatusSLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-navigation-l) {
      font-family: ${semanticFonts.GDSETypographyLabelNavigationLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelNavigationLFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelNavigationLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelNavigationLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelNavigationLLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyLabelNavigationLFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-navigation-m) {
      font-family: ${semanticFonts.GDSETypographyLabelNavigationMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelNavigationMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelNavigationMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelNavigationMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelNavigationMLetterSpacing};
      font-feature: ${semanticFonts.GDSETypographyLabelNavigationMFontFeature};
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-nav-breadcrumbs) {
      font-family: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelNavBreadcrumbsLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-xl) {
      font-family: ${semanticFonts.GDSETypographyLabelUIXLFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUIXLFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUIXLFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUIXLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUIXLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-xl-emphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelUIXLEmphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUIXLEmphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUIXLEmphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUIXLEmphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUIXLEmphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-l) {
      font-family: ${semanticFonts.GDSETypographyLabelUILFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUILFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUILFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUILLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUILLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-l-emphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelUILEmphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUILEmphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUILEmphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUILEmphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUILEmphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-m) {
      font-family: ${semanticFonts.GDSETypographyLabelUIMFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUIMFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUIMFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUIMLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUIMLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-m-emphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelUIMEmphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUIMEmphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUIMEmphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUIMEmphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUIMEmphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-s) {
      font-family: ${semanticFonts.GDSETypographyLabelUISFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUISFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUISFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUISLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUISLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-ui-s-emphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelUISEmphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelUISEmphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelUISEmphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelUISEmphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelUISEmphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-table) {
      font-family: ${semanticFonts.GDSETypographyLabelTableFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelTableFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelTableFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelTableLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelTableLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.label-table-emphasis) {
      font-family: ${semanticFonts.GDSETypographyLabelTableEmphasisFontFamily};
      font-size: ${semanticFonts.GDSETypographyLabelTableEmphasisFontSize};
      font-weight: ${semanticFonts.GDSETypographyLabelTableEmphasisFontWeight};
      line-height: ${semanticFonts.GDSETypographyLabelTableEmphasisLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyLabelTableEmphasisLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.statement-l) {
      font-family: ${semanticFonts.GDSETypographyStatementLFontFamily};
      font-size: ${semanticFonts.GDSETypographyStatementLFontSize};
      font-weight: ${semanticFonts.GDSETypographyStatementLFontWeight};
      line-height: ${semanticFonts.GDSETypographyStatementLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyStatementLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    :host(.statement-subtext-l) {
      font-family: ${semanticFonts.GDSETypographyStatementSubtextLFontFamily};
      font-size: ${semanticFonts.GDSETypographyStatementSubtextLFontSize};
      font-weight: ${semanticFonts.GDSETypographyStatementSubtextLFontWeight};
      line-height: ${semanticFonts.GDSETypographyStatementSubtextLLineHeight};
      letter-spacing: ${semanticFonts.GDSETypographyStatementSubtextLLetterSpacing};
      font-feature: auto;
      text-transform: initial;
      text-decoration: initial;
    }

    /** Must be last */
    :host([ignore-line-height]) {
      line-height: normal;
    }
  `.withBehaviors(mobileStylesheetBehavior$3), tm1TypographyTemplate = () => html`
    <template class="${(td) => {
  var Ae;
  return (Ae = td.type) != null ? Ae : "";
}}">
      <slot></slot>
    </template>
  `;
var __defProp$18 = Object.defineProperty, __getOwnPropDesc$18 = Object.getOwnPropertyDescriptor, __decorateClass$18 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$18(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$18(Ae, xr, id), id;
};
const typographyTypes = [
  "title-page",
  "subtitle-page",
  "title-section",
  "subtitle-section",
  "heading-l",
  "heading-m",
  "heading-s",
  "subheading-l",
  "subheading-m",
  "subheading-s",
  "data-xxl",
  "data-xl",
  "data-l",
  "data-m",
  "data-s",
  "data-xs",
  "data-context",
  "title-list-m",
  "title-list-s",
  "subtitle-list-m",
  "subtitle-list-s",
  "body-xl",
  "body-l",
  "body-m",
  "body-s",
  "label-helpertext-highemphasis",
  "label-helpertext-regular",
  "label-button-l",
  "label-button-m",
  "label-button-s",
  "label-button-l-underline",
  "label-button-m-underline",
  "label-button-s-underline",
  "label-container-l",
  "label-container-m",
  "label-container-s",
  "label-data-l",
  "label-data-m",
  "label-data-s",
  "label-data-highemphasis",
  "label-data-regular",
  "label-nav-breadcrumbs",
  "label-status-m",
  "label-status-s",
  "label-navigation-l",
  "label-navigation-m",
  "label-ui-xl",
  "label-ui-xl-emphasis",
  "label-ui-l",
  "label-ui-l-emphasis",
  "label-ui-m",
  "label-ui-m-emphasis",
  "label-ui-s",
  "label-ui-s-emphasis",
  "label-table",
  "label-table-emphasis",
  "statement-l",
  "statement-subtext-l"
];
class Typography extends FoundationElement {
  constructor() {
    super(...arguments), this.ignoreLineHeight = !1;
  }
}
__decorateClass$18([
  attr()
], Typography.prototype, "type", 2);
__decorateClass$18([
  attr({
    attribute: "ignore-line-height",
    mode: "boolean"
  })
], Typography.prototype, "ignoreLineHeight", 2);
const tm1Typography = Typography.compose({
  baseName: "typography",
  template: tm1TypographyTemplate,
  styles: tm1TypographyStyles
});
designSystem.register(
  tm1Typography()
);
const tm1AccordionItemStyles = () => css`
  ${display("flex")} :host {
    ${typeRampBase};
    box-sizing: border-box;
    font-family: ${GDSEFontFamily};
    flex-direction: column;
    border-bottom: ${GDSEWidthDefault} solid ${GDSEColorBorder};
    display: flex;
  }

  button {
    padding: ${GDSESpacing150} ${GDSESpacing200};
    border: 0;
    background-color: transparent;
    cursor: pointer;
  }

  button:active {
    background-color: ${GDSEColorSurfaceHovered};
  }

  button:focus,
  button:focus-visible {
    background-color: ${GDSEColorSurfaceHovered};
    outline: 2px solid ${GDSEColorBorderFocus};
    outline-offset: 2px;
    border-radius: ${GDSEBorderRadius25}
  }

  .region {
    padding: 0 ${GDSESpacing200} ${GDSESpacing200} ${GDSESpacing200};
  }

  .heading {
    display: flex;
    position: relative;
    align-items: center;
  }

  .heading-button {
    width: 100%;
    appearance: none;
    border: none;
    background: none;
    outline: none;
    text-align: left;
    font-family: inherit;
    padding-left: ${GDSESpacing100};
  }

  tm1-icon {
    width: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    rotate: -90deg;
    transition: 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  }

  :host([disabled]) {
    color: ${GDSEColorTextDisabled};
  }

  :host([disabled]) button,
  :host([disabled]) tm1-icon {
    cursor: not-allowed;
  }

  slot[name='expanded-icon'],
  slot[name='collapsed-icon'] {
    fill: #999999;
  }

  slot[name='collapsed-icon'] {
    display: flex;
  }

  :host([expanded]) slot[name='collapsed-icon'] {
    display: none;
  }

  slot[name='expanded-icon'] {
    display: none;
  }

  :host([expanded]) slot[name='expanded-icon'] {
    display: flex;
  }

  :host([expanded]) tm1-icon {
    rotate: 0deg;
  }

  :host([containsaction]) button {
    padding: 0;
  }

  :host([containsaction]) .heading {
    padding: ${GDSESpacing150} ${GDSESpacing200};
  }
`, icon = (td) => html`
    <${td.tagFor(Icon)}
      variant="lightweight"
      icon-position="icon-only"
      icon="down"
      size="small"
    >
    </${td.tagFor(Icon)}>
`, heading = (td) => html`
  <div
    class="heading-button"
    ${ref("expandbutton")}
    data-testid="heading-content"
  >
    <${td.tagFor(Typography)} type="title-list-m">
        <slot name="heading"></slot>
    </${td.tagFor(Typography)}>
  </div>
`, tm1AccordionItemTemplate = (td) => html`
  <template class="${(Ae) => Ae.expanded ? "expanded" : ""}">
    ${when((Ae) => !Ae.containsAction, html`
      <button
        class="heading"
        @click="${(Ae, xr) => Ae.toggleHandler(xr.event)}"
        aria-expanded="${(Ae) => Ae.expanded}"
        aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled) != null ? xr : !1;
}}"
        ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
      >
        <div
          class="icon-button"
          aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled) != null ? xr : !1;
}}"
          ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
          data-testid="icon"
        >
          ${icon(td)}
        </div>
        ${heading(td)}
      </button>
    `)}
    ${when((Ae) => Ae.containsAction, html`
        <div class="heading">
          <button
            class="icon-button"
            aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled) != null ? xr : !1;
}}"
            ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
            data-testid="icon"
            @click="${(Ae, xr) => Ae.toggleHandler(xr.event)}"
            aria-expanded="${(Ae) => Ae.expanded}"
            aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled) != null ? xr : !1;
}}"
            ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
          >
            ${icon(td)}
          </button>
          ${heading(td)}
        </div>
    `)}

    ${when((Ae) => Ae.expanded, html`
      <div class="region" role="region">
        <slot></slot>
      </div>
    `)}
  </template>
`;
var __defProp$17 = Object.defineProperty, __getOwnPropDesc$17 = Object.getOwnPropertyDescriptor, __decorateClass$17 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$17(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$17(Ae, xr, id), id;
};
class AccordionItem extends AccordionItem$1 {
  constructor() {
    super(...arguments), this.containsAction = !1, this.disabled = !1, this.toggleHandler = (Ae) => {
      this.disabled || this.clickHandler(Ae);
    };
  }
}
__decorateClass$17([
  attr({ mode: "boolean", attribute: "contains-action" }),
  attr({ mode: "boolean", attribute: "containsaction" })
], AccordionItem.prototype, "containsAction", 2);
__decorateClass$17([
  attr({ mode: "boolean" })
], AccordionItem.prototype, "disabled", 2);
const tm1AccordionItem = AccordionItem.compose({
  baseName: "accordion-item",
  baseClass: AccordionItem$1,
  template: tm1AccordionItemTemplate,
  styles: tm1AccordionItemStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
}), tm1AccordionStyles = () => css`
  ${display("flex")} :host {
    box-sizing: border-box;
    flex-direction: column;
    ${typeRampBase};
  }

  :host([offset]) {
    gap: ${GDSESpacingTabVerL};
  }

  :host([offset]) ::slotted(tm1-accordion-item) {
    border: ${GDSEWidthDefault} solid ${GDSEColorBorder};
  }
`;
var __defProp$16 = Object.defineProperty, __getOwnPropDesc$16 = Object.getOwnPropertyDescriptor, __decorateClass$16 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$16(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$16(Ae, xr, id), id;
};
let Accordion = class extends FoundationElement {
  constructor() {
    super(...arguments), this.containsAction = !1, this.offset = !1, this.activeItemIndex = 0, this.change = () => {
      this.$emit("change", this.activeid);
    }, this.setItems = () => {
      if (this.slottedAccordionItems.length === 0)
        return;
      const td = Array.from(this.children);
      this.removeItemListeners(td), td.forEach((xr) => Observable.getNotifier(xr).subscribe(this, "disabled")), this.accordionItems = td.filter((xr) => !xr.hasAttribute("disabled")), this.accordionIds = this.getItemIds(), this.accordionItems.forEach((xr, ed) => {
        xr instanceof AccordionItem && (xr.addEventListener("click", this.activeItemChange), Observable.getNotifier(xr).subscribe(this, "expanded"));
        const id = this.accordionIds[ed];
        xr.setAttribute(
          "id",
          typeof id != "string" ? `accordion-${ed + 1}` : id
        ), this.activeid = this.accordionIds[this.activeItemIndex], xr.addEventListener("keydown", this.handleItemKeyDown), xr.addEventListener("focus", this.handleItemFocus);
      });
      const Ae = this.findExpandedItem();
      this.setSingleExpandMode(Ae);
    }, this.removeItemListeners = (td) => {
      td.forEach((Ae, xr) => {
        Observable.getNotifier(Ae).unsubscribe(this, "disabled"), Observable.getNotifier(Ae).unsubscribe(this, "expanded"), Ae.removeEventListener("click", this.activeItemChange), Ae.removeEventListener("keydown", this.handleItemKeyDown), Ae.removeEventListener("focus", this.handleItemFocus);
      });
    }, this.activeItemChange = (td) => {
      td.defaultPrevented || td.target !== td.currentTarget || (td.preventDefault(), this.handleExpandedChange(td.target));
    }, this.handleExpandedChange = (td) => {
      td instanceof AccordionItem && (this.activeid = td.getAttribute("id"), this.setSingleExpandMode(td), this.change());
    }, this.handleItemKeyDown = (td) => {
      if (td.target === td.currentTarget)
        switch (this.accordionIds = this.getItemIds(), td.key) {
          case keyArrowUp:
            td.preventDefault(), this.adjust(-1);
            break;
          case keyArrowDown:
            td.preventDefault(), this.adjust(1);
            break;
          case keyHome:
            this.activeItemIndex = 0, this.focusItem();
            break;
          case keyEnd:
            this.activeItemIndex = this.accordionItems.length - 1, this.focusItem();
            break;
        }
    }, this.handleItemFocus = (td) => {
      if (td.target === td.currentTarget) {
        const Ae = td.target, xr = this.activeItemIndex = Array.from(
          this.accordionItems
        ).indexOf(Ae);
        this.activeItemIndex !== xr && xr !== -1 && (this.activeItemIndex = xr, this.activeid = this.accordionIds[this.activeItemIndex]);
      }
    };
  }
  accordionItemsChanged(td, Ae) {
    var xr;
    (xr = this.accordionItems) == null || xr.forEach((ed) => {
      this.containsAction && ed.setAttribute("containsAction", "");
    });
  }
  /**
   * @internal
   */
  slottedAccordionItemsChanged(td, Ae) {
    this.$fastController.isConnected && this.setItems();
  }
  /**
   * @internal
   */
  handleChange(td, Ae) {
    Ae === "disabled" ? this.setItems() : Ae === "expanded" && td.expanded && this.setSingleExpandMode(td);
  }
  findExpandedItem() {
    var td;
    return this.accordionItems.length === 0 ? null : (td = this.accordionItems.find(
      (Ae) => Ae instanceof AccordionItem && Ae.expanded
    )) != null ? td : this.accordionItems[0];
  }
  setSingleExpandMode(td) {
    if (this.accordionItems.length === 0)
      return;
    const Ae = Array.from(this.accordionItems);
    this.activeItemIndex = Ae.indexOf(td), Ae.forEach((xr, ed) => {
      this.activeItemIndex === ed ? (xr.expanded = !0, xr.expandbutton.setAttribute("aria-disabled", "true")) : (xr.expanded = !1, xr.hasAttribute("disabled") || xr.expandbutton.removeAttribute("aria-disabled"));
    });
  }
  getItemIds() {
    return this.slottedAccordionItems.map((td) => td.id);
  }
  adjust(td) {
    this.activeItemIndex = wrapInBounds(
      0,
      this.accordionItems.length - 1,
      this.activeItemIndex + td
    ), this.focusItem();
  }
  focusItem() {
    const td = this.accordionItems[this.activeItemIndex];
    td instanceof AccordionItem && td.expandbutton.focus();
  }
};
__decorateClass$16([
  attr({ mode: "boolean", attribute: "contains-action" }),
  attr({ mode: "boolean", attribute: "containsaction" })
], Accordion.prototype, "containsAction", 2);
__decorateClass$16([
  attr({ mode: "boolean" })
], Accordion.prototype, "offset", 2);
__decorateClass$16([
  observable
], Accordion.prototype, "slottedAccordionItems", 2);
Accordion = __decorateClass$16([
  customElement("tm1-accordion")
], Accordion);
const tm1Accordion = Accordion.compose({
  baseName: "accordion",
  baseClass: Accordion,
  template: accordionTemplate,
  styles: tm1AccordionStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Accordion(),
  tm1AccordionItem()
);
const tm1ButtonStyles = () => css`
    ${baseButtonsStyles}
    :host {
      --background-color: ${GDSEColorFillPrimary};
      --background-color-hovered: ${GDSEColorFillPrimaryHovered};
      --background-color-focus: ${GDSEColorFillPrimaryHovered};
      --background-color-pressed: ${GDSEColorFillPrimaryPressed};
      --background-color-loading: ${GDSEColorFillPrimary};
      --text-color: ${GDSEColorTextOnfillStrong};
      --text-color-hovered: ${GDSEColorTextOnfillStrongHovered};
      --text-color-focus: ${GDSEColorTextOnfillStrongHovered};
      --text-color-pressed: ${GDSEColorTextOnfillStrongHovered};
      --border-color: transparent;

      --padding: ${GDSESpacing100} ${GDSESpacing150};
      --padding-icon: ${GDSESpacing100};
      --horizontal-padding-small: ${GDSESpacing50};
      --button-border: ${GDSEWidthDefault};

      outline-offset: 2px;
      border-radius: ${GDSERadiusInput};
      position: relative;
      color: var(--text-color);
      fill: var(--text-color);
      background: var(--background-color);
    }

    :host .hidden {
      visibility: hidden;
    }

    :host .control {
      padding: var(--padding);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :host([iconPosition='only-icon']) .control {
      padding: var(--padding-icon);
    }

    :host([iconPosition='before']) tm1-icon {
      margin-right: var(--horizontal-padding-small);
    }

    :host([iconPosition='after']) tm1-icon {
      margin-left: var(--horizontal-padding-small);
    }

    :host .content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :host .loader {
      width: 100%;
      white-space: nowrap;
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${GDSESpacing50};
    }

    :host .dot {
      --dot-size: 4px;
      display: inline-block;
      width: var(--dot-size);
      height: var(--dot-size);
      border-radius: ${GDSERadiusPill};
      background: var(--text-color);
      animation: 0.8s linear 0s infinite normal none running MoveUpDown;
    }

    :host([size='small']) .dot {
      --dot-size: 3px;
    }

    :host([size='large']) .dot {
      --dot-size: 5px;
    }

    :host .dot:nth-child(2) {
      animation-delay: -0.1s;
    }

    :host .dot:nth-child(3) {
      animation-delay: -0.5s;
    }

    @keyframes MoveUpDown {
      0%,
      60%,
      100% {
        transform: initial;
      }
      30% {
        transform: translateY(-5px);
      }
    }

    :host([size='small']) {
      --padding: ${GDSESpacingActionVerS} ${GDSESpacingActionHorS};
      --padding-icon: ${GDSESpacingActionVerS} ${GDSESpacingActionHorS};
    }

    :host([size='regular']) {
      --padding: ${GDSESpacingActionVerM} ${GDSESpacingActionHorM};
      --padding-icon: ${GDSESpacingActionVerM} ${GDSESpacingActionHorM};
    }

    :host([size='large']) {
      --padding: ${GDSESpacingActionVerL} ${GDSESpacingActionHorL};
      --padding-icon: ${GDSESpacingActionVerL} ${GDSESpacingActionHorL};
    }

    :host([size='small']) tm1-icon {
      height: ${GDSESpacingActionIconS};
      width: ${GDSESpacingActionIconS};
    }

    :host([size='regular']) tm1-icon {
      height: ${GDSESpacingActionIconM};
      width: ${GDSESpacingActionIconM};
    }

    :host([size='large']) tm1-icon {
      height: ${GDSESpacingActionIconL};
      width: ${GDSESpacingActionIconL};
    }

    :host,
    :host([variant='solid']){
      --background-color-disabled: ${GDSEColorFillDisabled};
      --text-color-disabled: ${GDSEColorTextDisabled};
    }

    :host([variant='outline']){
      --background-color-disabled: transparent;
      --text-color-disabled: ${GDSEColorTextDisabled};
    }

    :host([variant='lightweight']) {
      --background-color-disabled: transparent;
      --text-color-disabled: ${GDSEColorTextDisabled};
    }

    :host,
    :host([color='primary']),
    :host([color='primary'][variant='solid']) {
      --background-color: ${GDSEColorFillPrimary};
      --background-color-hovered: ${GDSEColorFillPrimaryHovered};
      --background-color-focus: ${GDSEColorFillPrimaryHovered};
      --background-color-pressed: ${GDSEColorFillPrimaryPressed};
      --background-color-loading: ${GDSEColorFillPrimary};
      --text-color: ${GDSEColorTextOnfill};
      --text-color-hovered: ${GDSEColorTextOnfillHovered};
      --text-color-focus: ${GDSEColorTextOnfillHovered};
      --text-color-pressed: ${GDSEColorTextOnfillHovered};
      --border-color: transparent;
    }

    :host([variant='outline']),
    :host([color='primary'][variant='outline']) {
      --background-color: transparent;
      --background-color-hovered: ${GDSEColorFillSecondaryHovered};
      --background-color-focus: ${GDSEColorFillSecondaryHovered};
      --background-color-pressed: ${GDSEColorFillSecondaryPressed};
      --background-color-loading: transparent;
      --text-color: ${GDSEColorTextSecondary};
      --text-color-hovered: ${GDSEColorTextSecondaryHovered};
      --text-color-focus: ${GDSEColorTextSecondaryHovered};
      --text-color-pressed: ${GDSEColorTextSecondaryHovered};
      --border-color: ${GDSEColorBorderSecondary};
    }

    :host([variant='lightweight']),
    :host([color='primary'][variant='lightweight']) {
      --background-color: transparent;
      --background-color-hovered: ${GDSEColorFillSecondaryHovered};
      --background-color-focus: ${GDSEColorFillSecondaryHovered};
      --background-color-pressed: ${GDSEColorFillSecondaryPressed};
      --text-color: ${GDSEColorTextSecondary};
      --text-color-hovered: ${GDSEColorTextSecondaryHovered};
      --text-color-focus: ${GDSEColorTextSecondaryHovered};
      --text-color-pressed: ${GDSEColorTextSecondaryHovered};
      --border-color: transparent;
    }

    :host([color='positive']),
    :host([color='positive'][variant='solid']) {
      --background-color: ${GDSEColorFillPositive};
      --background-color-hovered: ${GDSEColorFillPositiveHovered};
      --background-color-focus: ${GDSEColorFillPositiveHovered};
      --background-color-pressed: ${GDSEColorFillPositivePressed};
      --background-color-loading: ${GDSEColorFillPositive};
      --text-color: ${GDSEColorTextOnfillStrong};
      --text-color-hovered: ${GDSEColorTextOnfillStrongHovered};
      --text-color-focus: ${GDSEColorTextOnfillStrongHovered};
      --text-color-pressed: ${GDSEColorTextOnfillStrongHovered};
      --border-color: transparent;
    }

    :host([color='positive'][variant='outline']) {
      --background-color: transparent;
      --background-color-hovered: ${GDSEColorFillPositiveSecondaryHovered};
      --background-color-focus: ${GDSEColorFillPositiveSecondaryHovered};
      --background-color-pressed: ${GDSEColorFillPositiveSecondaryPressed};
      --background-color-loading: transparent;
      --text-color: ${GDSEColorTextPositiveSecondary};
      --text-color-hovered: ${GDSEColorTextPositiveSecondaryHovered};
      --text-color-focus: ${GDSEColorTextPositiveSecondaryHovered};
      --text-color-pressed: ${GDSEColorTextPositiveSecondaryHovered};
      --border-color: ${GDSEColorBorderPositive};
    }

    :host([color='positive'][variant='lightweight']) {
      --background-color: transparent;
      --background-color-hovered: ${GDSEColorFillPositiveSecondaryHovered};
      --background-color-focus: ${GDSEColorFillPositiveSecondaryHovered};
      --background-color-pressed: ${GDSEColorFillPositiveSecondaryPressed};
      --text-color: ${GDSEColorTextPositiveSecondary};
      --text-color-hovered: ${GDSEColorTextPositiveSecondaryHovered};
      --text-color-focus: ${GDSEColorTextPositiveSecondaryHovered};
      --text-color-pressed: ${GDSEColorTextPositiveSecondaryHovered};
      --border-color: transparent;
    }

    :host([color='negative']),
    :host([color='negative'][variant='solid']) {
      --background-color: ${GDSEColorFillCritical};
      --background-color-hovered: ${GDSEColorFillCriticalHovered};
      --background-color-focus: ${GDSEColorFillCriticalHovered};
      --background-color-pressed: ${GDSEColorFillCriticalPressed};
      --background-color-loading: ${GDSEColorFillCritical};
      --text-color: ${GDSEColorTextOnfillStrong};
      --text-color-hovered: ${GDSEColorTextOnfillStrongHovered};
      --text-color-focus: ${GDSEColorTextOnfillStrongHovered};
      --text-color-pressed: ${GDSEColorTextOnfillStrongHovered};
      --border-color: transparent;
    }

    :host([color='negative'][variant='outline']) {
      --background-color: transparent;
      --background-color-hovered: ${GDSEColorFillCriticalSecondaryHovered};
      --background-color-focus: ${GDSEColorFillCriticalSecondaryHovered};
      --background-color-pressed: ${GDSEColorFillCriticalSecondaryPressed};
      --background-color-loading: transparent;
      --text-color: ${GDSEColorTextCriticalSecondary};
      --text-color-hovered: ${GDSEColorTextCriticalSecondaryHovered};
      --text-color-focus: ${GDSEColorTextCriticalSecondaryHovered};
      --text-color-pressed: ${GDSEColorTextCriticalSecondaryHovered};
      --border-color: ${GDSEColorBorderCritical};
    }

    :host([color='negative'][variant='lightweight']) {
      --background-color: transparent;
      --background-color-hovered: ${GDSEColorFillCriticalSecondaryHovered};
      --background-color-focus: ${GDSEColorFillCriticalSecondaryHovered};
      --background-color-pressed: ${GDSEColorFillCriticalSecondaryPressed};
      --text-color: ${GDSEColorTextCriticalSecondary};
      --text-color-hovered: ${GDSEColorTextCriticalSecondaryHovered};
      --text-color-focus: ${GDSEColorTextCriticalSecondaryHovered};
      --text-color-pressed: ${GDSEColorTextCriticalSecondaryHovered};
      --border-color: transparent;
    }
  `.withBehaviors(
  variantBehavior("variant", "solid", AccentButtonStyles),
  variantBehavior("variant", "lightweight", LightweightButtonStyles),
  variantBehavior("variant", "outline", OutlineButtonStyles)
), tm1ButtonStylesV2 = () => css`
  ${tm1ButtonStyles()}

  :host {
    --background-color: var(--gdse-v2-color-teal-400);
    --background-color-hovered: darkgray;
    --background-color-focus: darkgray;
    --background-color-pressed: darkgray;
    --background-color-loading: darkgray;
    --text-color: white;
    --text-color-hovered: white;
    --text-color-focus: white;
    --text-color-pressed: white;
    --border-color: transparent;

    --padding: 10px 12px !important;
    --horizontal-padding-small: 5px;
    --button-border: 1px;
  }
`, tm1ButtonTemplate = (td, Ae) => html`
  <template
    aria-atomic="${(xr) => {
  var ed;
  return (ed = xr.ariaAtomic) != null ? ed : !1;
}}"
    aria-busy="${(xr) => {
  var ed;
  return (ed = xr.ariaBusy) != null ? ed : !1;
}}"
    aria-controls="${(xr) => xr.ariaControls}"
    aria-current="${(xr) => {
  var ed;
  return (ed = xr.ariaCurrent) != null ? ed : null;
}}"
    aria-describedby="${(xr) => xr.ariaDescribedby}"
    aria-details="${(xr) => xr.ariaDetails}"
    aria-disabled="${(xr) => {
  var ed;
  return (ed = xr.ariaDisabled) != null ? ed : !1;
}}"
    aria-expanded="${(xr) => xr.ariaExpanded}"
    aria-flowto="${(xr) => xr.ariaFlowto}"
    aria-haspopup="${(xr) => {
  var ed;
  return (ed = xr.ariaHaspopup) != null ? ed : !1;
}}"
    aria-hidden="${(xr) => {
  var ed;
  return (ed = xr.ariaHidden) != null ? ed : !1;
}}"
    aria-invalid="${(xr) => {
  var ed;
  return (ed = xr.ariaInvalid) != null ? ed : !1;
}}"
    aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
    aria-label="${(xr) => {
  var ed;
  return (ed = xr.ariaLabel) != null ? ed : "";
}}"
    aria-labelledby="${(xr) => xr.ariaLabelledby}"
    aria-live="${(xr) => {
  var ed;
  return (ed = xr.ariaLive) != null ? ed : "off";
}}"
    aria-owns="${(xr) => xr.ariaOwns}"
    aria-pressed="${(xr) => xr.ariaPressed}"
    aria-relevant="${(xr) => {
  var ed;
  return (ed = xr.ariaRelevant) != null ? ed : "additions text";
}}"
    aria-roledescription="${(xr) => xr.ariaRoledescription}"
    form="${(xr) => {
  var ed;
  return (ed = xr.formId) != null ? ed : "";
}}"
    formaction="${(xr) => xr.formaction}"
    formenctype="${(xr) => {
  var ed;
  return (ed = xr.formenctype) != null ? ed : "application/x-www-form-urlencoded";
}}"
    formmethod="${(xr) => xr.formmethod}"
    formnovalidate="${(xr) => {
  var ed;
  return (ed = xr.formnovalidate) != null ? ed : !1;
}}"
    formtarget="${(xr) => {
  var ed;
  return (ed = xr.formtarget) != null ? ed : "_self";
}}"
    name="${(xr) => xr.name}"
    role="button"
    type="${(xr) => {
  var ed;
  return (ed = xr.type) != null ? ed : "button";
}}"
    value="${(xr) => {
  var ed;
  return (ed = xr.value) != null ? ed : "";
}}"
    ?autofocus="${(xr) => {
  var ed;
  return (ed = xr.autofocus) != null ? ed : !1;
}}"
    ?disabled="${(xr) => {
  var ed;
  return (ed = xr.disabled) != null ? ed : !1;
}}"
    @click="${(xr, ed) => xr.clickHandler(ed.event)}"
  >
    <button
      class="control ${(xr) => xr.className}"
      type="${(xr) => {
  var ed;
  return (ed = xr.type) != null ? ed : "button";
}}"
      part="control"
      role="generic"
      ?disabled="${(xr) => {
  var ed;
  return (ed = xr.disabled || xr.isLoading) != null ? ed : !1;
}}"
      ${ref("control")}
    >
    <div class=${(xr) => xr.isLoading ? "hidden content-container" : "content-container"}>
      <${td.tagFor(Typography)} type="${(xr) => {
  var ed;
  return xr.textType[(ed = xr.size) != null ? ed : "regular"];
}}" tag="span">
        ${startSlotTemplate(td, Ae)}
      </${td.tagFor(Typography)}>
          <span class="content" part="content">
            ${when(
  (xr) => xr.icon && xr.iconPosition === "before" || xr.icon && xr.iconPosition === "only-icon",
  html`<${td.tagFor(Icon)} icon=${(xr) => xr.icon} />`
)}

            <${td.tagFor(Typography)} type="${(xr) => {
  var ed;
  return xr.textType[(ed = xr.size) != null ? ed : "regular"];
}}">
              ${when((xr) => xr.iconPosition !== "only-icon", html`<slot ${slotted("defaultSlottedContent")}></slot>`)}
            </${td.tagFor(Typography)}>

            ${when((xr) => xr.icon && xr.iconPosition === "after", html`<${td.tagFor(Icon)} icon=${(xr) => xr.icon} />`)}
          </span>
          <${td.tagFor(Typography)} type="${(xr) => {
  var ed;
  return xr.textType[(ed = xr.size) != null ? ed : "regular"];
}}" tag="span">
        ${endSlotTemplate(td, Ae)}
      </${td.tagFor(Typography)}>
            </div>
      ${when(
  (xr) => xr.isLoading,
  html`
          <div class="loader" title="loader" role="alert">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        `
)}
    </button>
  </template>
`;
var __defProp$15 = Object.defineProperty, __getOwnPropDesc$15 = Object.getOwnPropertyDescriptor, __decorateClass$15 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$15(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$15(Ae, xr, id), id;
};
const ButtonVariant = {
  solid: "solid",
  lightweight: "lightweight",
  outline: "outline"
}, ButtonColor = {
  primary: "primary",
  positive: "positive",
  negative: "negative"
}, ButtonSize = {
  small: "small",
  regular: "regular",
  large: "large"
}, ButtonIconPosition = {
  none: "none",
  onlyIcon: "only-icon",
  before: "before",
  after: "after"
};
class Button extends Button$1 {
  constructor() {
    super(...arguments), this.size = "regular", this.isLoading = !1, this.iconPosition = "before", this.inverse = !1, this.debounceDelay = 200, this.tabIndex = 0, this.isDebounced = !1, this.textType = {
      small: "label-button-s",
      regular: "label-button-m",
      large: "label-button-l"
    }, this.themeVersion = ThemeVersion.v1, this.themeVersionConsumer = new ConsumerBehaviour(this, {
      context: themeVersionContext,
      subscribe: !0,
      callback: (Ae) => this.themeVersion = Ae
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.variant === void 0 && (this.variant = "solid");
  }
  themeVersionChanged(Ae, xr) {
    Ae !== xr && this.resolveStyles();
  }
  resolveStyles() {
    return this.themeVersion === ThemeVersion.v2 ? this.$fastController.styles = tm1ButtonStylesV2() : this.$fastController.styles = tm1ButtonStyles();
  }
  variantChanged(Ae, xr) {
    xr === "lightweight" && (this.textType = {
      small: "label-button-s-underline",
      regular: "label-button-m-underline",
      large: "label-button-l-underline"
    });
  }
  clickHandler(Ae) {
    if (this.isLoading || this.isDebounced) {
      Ae.stopPropagation();
      return;
    }
    this.isDebounced = !0, setTimeout(() => {
      this.isDebounced = !1;
    }, this.debounceDelay);
  }
}
__decorateClass$15([
  attr()
], Button.prototype, "variant", 2);
__decorateClass$15([
  attr()
], Button.prototype, "color", 2);
__decorateClass$15([
  attr()
], Button.prototype, "size", 2);
__decorateClass$15([
  attr({ mode: "boolean", attribute: "is-loading" }),
  attr({ mode: "boolean", attribute: "isloading" })
], Button.prototype, "isLoading", 2);
__decorateClass$15([
  attr()
], Button.prototype, "icon", 2);
__decorateClass$15([
  attr({ attribute: "icon-position" }),
  attr({ attribute: "iconposition" })
], Button.prototype, "iconPosition", 2);
__decorateClass$15([
  attr({ mode: "boolean" })
], Button.prototype, "inverse", 2);
__decorateClass$15([
  attr({ attribute: "debounce-delay" }),
  attr({ attribute: "debouncedelay" })
], Button.prototype, "debounceDelay", 2);
__decorateClass$15([
  attr()
], Button.prototype, "tabIndex", 2);
__decorateClass$15([
  observable
], Button.prototype, "textType", 2);
__decorateClass$15([
  observable
], Button.prototype, "themeVersion", 2);
const tm1Button = Button.compose({
  baseName: "button",
  baseClass: Button$1,
  template: tm1ButtonTemplate,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Button()
);
const tm1CheckboxStyles = () => css`
    ${display("flex")}
    :host {
      margin-left: calc(${GDSESpacing100} * -1);
      padding: ${GDSESpacing0} ${GDSESpacing100} 0;
      width: 100%;
      outline: none;
      position: relative;
      transition: all 0.2s ease-in-out;
      color: ${GDSEColorText};
      flex-direction: column;
    }

    :host([size='small']) {
      --checkbox-width: 16px;
    }

    :host([size='medium']) {
      --checkbox-width: 18px;
    }

    :host([size='large']) {
      --checkbox-width: 20px;
    }

    :host .checkbox-container {
      display: flex;
      flex-direction: row;
    }

    :host .control {
      position: relative;
      flex-shrink: 0;
      box-sizing: border-box;
      border-radius: ${GDSERadiusInput};
      border: 1px solid ${GDSEColorBorderInputDefault};
      background: ${GDSEColorBackground};
      outline: none;
      cursor: pointer;
      width: var(--checkbox-width);
      margin: ${GDSESpacing25};
    }

    :host([size='small']) .control {
      width: var(--checkbox-width);
      height: 16px;
    }

    :host([size='small']) tm1-icon[icon="check"] {
      width: 7.5px;
      height: 7.5px;
    }

    :host([size='medium']) .control {
      width: var(--checkbox-width);
      height: 18px;
    }

    :host([size='medium']) tm1-icon[icon="check"] {
      width: 11px;
      height: 11px;
    }

    :host([size='large']) .control {
      width: var(--checkbox-width);
      height: 20px;
    }

    :host([size='large']) tm1-icon[icon="check"] {
      width: 12px;
      height: 12px;
    }

    :host([iscentered]) .checkbox-container,
    :host([is-centered]) .checkbox-container {
      align-items: center;
    }

    :host(:not([checked]):not([indeterminate]):not([disabled]):not([readonly])[has-error]) .control,
    :host(:not([disabled]):not([readonly])[has-error]:focus) .control {
      border-color: ${GDSEColorBorderCritical} !important;
    }

    .label__hidden {
      display: none;
      visibility: hidden;
    }

    tm1-typography {
      cursor: pointer;
    }

    .description {
      --margin-left: ${GDSESpacing100};
      display: flex;
      flex-direction: column;
      margin-left: var(--margin-left);
    }

    .description.empty {
      display: none;
    }

    :host([size='small']) .description {
      --margin-left: ${GDSESpacing75};
    }

    .error {
      --margin-left-error: calc(${GDSESpacing75} + var(--checkbox-width));
      color: ${GDSEColorTextCritical};
      display: flex;
      align-items: center;
      margin-top: ${GDSESpacing25};
      margin-left: var(--margin-left-error);
    }

    :host([size='small']) .error {
      --margin-left-error: calc(${GDSESpacing75} + var(--checkbox-width));
    }

    :host([size='medium']) .error {
      --margin-left-error: calc(${GDSESpacing100} + var(--checkbox-width));
    }

    :host([size='large']) .error {
      --margin-left-error: calc(${GDSESpacing100} + var(--checkbox-width));
    }

    .error .error-text {
      margin-left: ${GDSESpacing50};
    }

    slot[name='checked-indicator'],
    slot[name='indeterminate-indicator'] {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      stroke: ${GDSEColorBackground};
      opacity: 0;
      pointer-events: none;
      transition: 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    }

    :host(:not([aria-checked="true"])) .control {
      background: transparent;
      border: 1px solid ${GDSEColorBorderInputDefault};
      transition: 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    }

    slot[name='indeterminate-indicator'] {
      position: absolute;
      top: ${GDSESpacing0};
    }

    slot[name='indeterminate-indicator'] svg {
      fill: ${GDSEColorTextOnfillStrong};
      stroke: ${GDSEColorTextOnfillStrong};
    }

    :host([disabled]) slot[name='indeterminate-indicator'] svg {
      fill: ${GDSEColorTextDisabled};
      stroke: ${GDSEColorTextDisabled};
    }

    :host([checked]) .control,
    :host([indeterminate]) .control,
    :host([checked]:${focusVisible}) .control,
    :host([indeterminate]:${focusVisible}) .control {
      border-color: transparent;
      background: ${GDSEColorFillInputSelected};
    }

    :host([checked][has-error]) .control,
    :host([indeterminate][has-error]) .control,
    :host([checked]:not([disabled]):not([readonly])[has-error]) .control,
    :host([checked][has-error]:${focusVisible}) .control,
    :host([indeterminate][has-error]:${focusVisible}) .control {
      border-color: ${GDSEColorBorderCritical};
      background: ${GDSEColorFillCritical};
    }

    :host([checked]:not([disabled]):not([readonly]):hover) .control,
    :host([indeterminate]:not([disabled]):not([readonly]):hover) .control {
      background: ${GDSEColorFillInputSelected};
      border-color: transparent;
    }

    :host([checked]:not([disabled]):not([readonly])[has-error]:hover) .control,
    :host([indeterminate]:not([disabled]):not([readonly])[has-error]:hover) .control {
      background: ${GDSEColorFillCriticalHovered};
      border-color: ${GDSEColorFillCriticalHovered};
    }

    :host([checked]) tm1-icon[icon="check"],
    :host([checked]) slot[name='checked-indicator'],
    :host([indeterminate]) slot[name='indeterminate-indicator'] {
      stroke: ${GDSEColorTextOnfillStrong};
      transform: scale(1, 1);
    }

    :host(:not([disabled]):not([readonly]):hover) .control {
      background: transparent;
      border-color: ${GDSEColorBorderInputHovered};
    }

    :host(:not([checked]):not([disabled]):not([readonly]):focus) .control {
      border-color: ${GDSEColorBorderInputHovered};
    }

    :host([checked]:not([disabled]):not([readonly]):focus) .control {
      border-color: ${GDSEColorBorderPrimary};
    }

    :host(:not([disabled]):not([readonly]):active) .control {
      background: ${GDSEColorFillInputHovered};
      border-color: ${GDSEColorBorderInputHovered};
    }

    :host(:not([disabled]):not([readonly]):focus) .control:after,
    :host(:not([disabled]):not([readonly]):active) .control:after {
      content: '';
      position: absolute;
      inset: -3px;
      border: 1px solid ${GDSEColorBorderPrimary};
      border-radius: ${GDSERadiusSurface};
    }

    :host(:not([disabled]):not([readonly])[has-error]:hover) .control,
    :host(:not([disabled]):not([readonly])[has-error]:active) .control {
      background: ${GDSEColorFillInput};
      border-color: ${GDSEColorFillCriticalPressed};
    }

    :host([disabled]) label,
    :host([readonly]) label,
    :host([readonly]) .control,
    :host([disabled]) .control {
      cursor: not-allowed;
    }

    :host([disabled]) .label {
      color: ${GDSEColorTextDisabled};
    }

    :host([checked]:not([indeterminate])) slot[name='checked-indicator'],
    :host([indeterminate]) slot[name='indeterminate-indicator'] {
      opacity: 1;
    }

    :host([disabled]) .control,
    :host([disabled]):hover .control {
      border-color: ${GDSEColorBorderInputDisabled};
    }

    :host([disabled][checked]) .control,
    :host([disabled][checked]):hover .control,
    :host([disabled][indeterminate]) .control,
    :host([disabled][indeterminate]):hover .control {
      background: ${GDSEColorFillDisabled};
      border-color: ${GDSEColorBorderInputDisabled};
    }

    :host([disabled]) slot[name='checked-indicator'],
    :host([disabled]) slot[name='indeterminate-indicator'] {
      stroke: ${GDSEColorTextDisabled};
      fill: ${GDSEColorTextDisabled};
    }
  `, renderError$2 = (td) => when(
  (Ae) => !!Ae.error && !Ae.readOnly && !Ae.disabled,
  html`
    <div class="error">
      <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
      <${td.tagFor(Typography)} class="error-text" tag="span" type="label-helpertext-regular" id="${(Ae) => Ae.errorDefaultId()}" role="alert">
        ${(Ae) => Ae.error}
      </${td.tagFor(Typography)}>
    </div>
  `
), tm1CheckboxTemplate = (td, Ae) => html`
  <template
    id="${(xr) => xr.defaultId()}"
    role="checkbox"
    aria-checked="${(xr) => xr.indeterminate ? "mixed" : xr.checked}"
    aria-disabled="${(xr) => xr.disabled}"
    aria-errormessage="${(xr) => xr.errorDefaultId()}"
    aria-invalid="${(xr) => !!xr.error || xr.required && !xr.checked}"
    aria-readonly="${(xr) => {
  var ed;
  return (ed = xr.readOnly) != null ? ed : !1;
}}"
    aria-required="${(xr) => {
  var ed;
  return (ed = xr.required) != null ? ed : !1;
}}"
    tabindex="${(xr) => xr.disabled ? null : "0"}"
    value="${(xr) => {
  var ed;
  return (ed = xr.value) != null ? ed : "";
}}"
    ?checked="${(xr) => xr.checked}"
    ?indeterminate="${(xr) => xr.indeterminate}"
    ?has-error="${(xr) => !!xr.error}"
    @keypress="${(xr, ed) => xr.keypressHandler(ed.event)}"
    @click="${(xr) => xr.clickHandler()}"
    class="${(xr) => xr.readOnly ? "readonly" : ""}"
  >
    <div class="checkbox-container">
      <div part="control" class="control" data-testid="control">
        <slot aria-hidden="true" name="checked-indicator">
          <${td.tagFor(Icon)} icon="check" size="small" color="white"></${td.tagFor(Icon)}>
        </slot>
        <slot aria-hidden="true" name="indeterminate-indicator"> ${Ae.indeterminateIndicator || ""} </slot>
      </div>
      <div class="description ${(xr) => xr.descriptionTemplateClasses()}" data-testid="description">
        <${td.tagFor(Typography)}
          type="${(xr) => xr.textType()[xr.size]}"
          class="${(xr) => xr.labelClasses}"
          ${ref("label")}
        >
          <label for="${(xr) => xr.defaultId()}" part="label">
            <slot ${slotted("defaultSlottedNodes")}></slot>
          </label>
        </${td.tagFor(Typography)}>
      </div>
    </div>
    ${renderError$2(td)}
  </template>
`;
var __defProp$14 = Object.defineProperty, __getOwnPropDesc$14 = Object.getOwnPropertyDescriptor, __decorateClass$14 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$14(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$14(Ae, xr, id), id;
};
const CheckboxSize = {
  small: "small",
  medium: "medium",
  large: "large"
};
class Checkbox extends Checkbox$1 {
  constructor() {
    var Ae;
    super(...arguments), this.size = "large", this.disabled = !1, this.error = "", this.isCentered = !1, this.needConfirmation = !1, this.indeterminate = !1, this.descriptionTemplateClasses = () => {
      var xr;
      return (xr = this.defaultSlottedNodes) != null && xr.length ? "" : "empty";
    }, this.textType = () => ({ small: "body-m", medium: "body-m", large: "body-l" }), this.labelClasses = ((Ae = this.label) == null ? void 0 : Ae.innerHTML) !== "" ? "label" : "label label__hidden", this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.keypressHandler = (xr) => {
      if (!this.disabled)
        switch (xr.key) {
          case keySpace:
            this.toggleChecked();
            break;
        }
    }, this.clickHandler = () => {
      !this.disabled && !this.readOnly && !this.needConfirmation && this.toggleChecked();
    };
  }
  indeterminateChanged(Ae, xr) {
    Ae !== xr && (this.indeterminate = xr, this.$emit("change"));
  }
  toggleChecked() {
    this.indeterminate && (this.indeterminate = !1), this.checked = !this.checked;
  }
  formResetCallback() {
    super.formResetCallback(), this.checked === !0 && (this.checked = !1);
  }
  checkedChanged(Ae, xr) {
    super.checkedChanged(Ae, xr), this.checked = xr;
  }
}
__decorateClass$14([
  attr()
], Checkbox.prototype, "size", 2);
__decorateClass$14([
  attr({ mode: "boolean" })
], Checkbox.prototype, "disabled", 2);
__decorateClass$14([
  attr()
], Checkbox.prototype, "error", 2);
__decorateClass$14([
  attr({ attribute: "is-centered", mode: "boolean" }),
  attr({ attribute: "iscentered", mode: "boolean" })
], Checkbox.prototype, "isCentered", 2);
__decorateClass$14([
  attr({ mode: "boolean", attribute: "need-confirmation" }),
  attr({ mode: "boolean", attribute: "needconfirmation" })
], Checkbox.prototype, "needConfirmation", 2);
__decorateClass$14([
  attr({ mode: "boolean" })
], Checkbox.prototype, "indeterminate", 2);
__decorateClass$14([
  observable
], Checkbox.prototype, "label", 2);
const tm1Checkbox = Checkbox.compose({
  baseName: "checkbox",
  baseClass: Checkbox$1,
  template: tm1CheckboxTemplate,
  styles: tm1CheckboxStyles,
  indeterminateIndicator: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
      <path d="M16.8 10.5c.663 0 1.2.672 1.2 1.5 0 .77-.463 1.403-1.06 1.49l-.14.01H7.2c-.663 0-1.2-.672-1.2-1.5 0-.77.463-1.403 1.06-1.49l.14-.01h9.6Z"/>
    </svg>
  `
});
designSystem.register(
  tm1Checkbox()
);
const tm1OptionStyles = css`
  :host {
    box-sizing: border-box;
    color: ${GDSEColorText};
    background-color: ${GDSEColorFillInput};
    cursor: pointer;
    fill: currentcolor;
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    margin: 0;
    outline: none;
    overflow: hidden;
    padding:  var(--padding, ${GDSESpacingListVerS} ${GDSESpacingListHorS});
    user-select: none;
    white-space: nowrap;
    max-height: var(--option-height, 37px);
    pointer-events: auto;
  }

  :host([hidden]) {
    display: none;
  }

  :host(:active),
  :host(:focus),
  :host(:focus-visible) {
    box-shadow: 0 0 0 2px inset var(--focus-stroke-inner);
    background: ${GDSEColorSurfacePressed};
  }

  :host(:not([disabled])[selected][aria-selected="true"]:hover) ::part(control) {
    background: ${GDSEColorFillPrimaryHovered};
    border-color: ${GDSEColorFillPrimaryHovered};
  }

  :host(:not([disabled]):active),
  :host(:not([selected]):active) {
    background: ${GDSEColorSurfacePressed};
  }

  :host([aria-checked="true"]:not([disabled])),
  :host([aria-selected="true"]:not([disabled])) {
    background: ${GDSEColorSurfaceSelected};
  }

  :host(:not([disabled]):hover),
  :host(:not([disabled]):not([selected]):hover),
  :host([selected]:not([checked]):hover),
  :host([aria-selected="true"]:not([disabled]):hover),
  :host([aria-checked="true"][aria-selected="false"]:not([disabled]):hover),
  :host([hovered]:not([disabled])) {
    background: ${GDSEColorSurfaceHovered};
  }

  :host([disabled]) {
    cursor: not-allowed;
    color: ${GDSEColorTextDisabled};
    pointer-events: none;
  }

  .container {
    display: flex;
    align-items: center;
    width: 100%;
  }

  :host([alignTop]) .container {
    align-items: flex-start;
  }

  :host(:not([alignTop])) tm1-checkbox {
    padding-top: 0;
  }

  :host tm1-checkbox {
    max-width: 16px;
  }

  :host tm1-typography {
    width: 100%;
  }

  .content {
    grid-column-start: 2;
    justify-self: start;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .start,
  .end,
  ::slotted(svg) {
    display: flex;
  }

  ::slotted(svg) {
    height: 16px;
    width: 16px;
  }

  ::slotted([slot='end']) {
    margin-inline-start: 1ch;
  }

  ::slotted([slot='start']) {
    margin-inline-end: 1ch;
  }
`, tm1OptionTemplate = (td, Ae) => html`
    <template
      aria-checked="${(xr) => xr.ariaChecked || xr.checked}"
      aria-disabled="${(xr) => xr.ariaDisabled || xr.disabled}"
      aria-posinset="${(xr) => xr.ariaPosInSet}"
      aria-selected="${(xr) => xr.ariaSelected || xr.selected}"
      aria-setsize="${(xr) => xr.ariaSetSize}"
      role="option"
      ?alignTop="${(xr) => xr.alignTop}"
      ?checked="${(xr) => xr.checked || xr.ariaChecked}"
      ?selected="${(xr) => xr.selected || xr.ariaSelected}"
    >
      <div class="container" data-testid="container">
        ${when(
  (xr) => xr.multiple,
  html`<${td.tagFor(Checkbox)}
            ?checked=${(xr) => xr.selected}
            ?current-checked=${(xr) => xr.selected}
            size="small"
            ?disabled=${(xr) => xr.disabled}>
          </${td.tagFor(Checkbox)}>`
)}
        ${startSlotTemplate(td, Ae)}
        <${td.tagFor(Typography)} type="body-m">
          <span class="content" part="content">
            <slot ${slotted("content")}></slot>
          </span>
        </${td.tagFor(Typography)}>
        ${endSlotTemplate(td, Ae)}
      </div>
    </template>
  `;
var __defProp$13 = Object.defineProperty, __getOwnPropDesc$13 = Object.getOwnPropertyDescriptor, __decorateClass$13 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$13(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$13(Ae, xr, id), id;
};
let Option$1 = class extends ListboxOption {
  constructor() {
    super(...arguments), this.alignTop = !1, this.ariaChecked = "false", this.ariaPosInSet = "0", this.ariaSelected = "false", this.ariaSetSize = "0", this.checked = !1, this.multiple = !1;
  }
  checkedChanged(Ae, xr) {
    super.checkedChanged(Ae, xr), this.$emit("change");
  }
  selectedChanged() {
    super.selectedChanged(), this.$emit("change");
  }
  getTextContent() {
    var Ae;
    return (Ae = this.content[0]) == null ? void 0 : Ae.textContent;
  }
};
__decorateClass$13([
  attr({ attribute: "align-top", mode: "boolean" }),
  attr({ attribute: "aligntop", mode: "boolean" })
], Option$1.prototype, "alignTop", 2);
__decorateClass$13([
  attr({ attribute: "aria-checked", mode: "boolean" }),
  attr({ attribute: "ariachecked", mode: "boolean" })
], Option$1.prototype, "ariaChecked", 2);
__decorateClass$13([
  attr({ attribute: "aria-posinset" }),
  attr({ attribute: "ariaposinset" })
], Option$1.prototype, "ariaPosInSet", 2);
__decorateClass$13([
  attr({ attribute: "aria-selected", mode: "boolean" }),
  attr({ attribute: "ariaselected", mode: "boolean" })
], Option$1.prototype, "ariaSelected", 2);
__decorateClass$13([
  attr({ attribute: "aria-setsize" }),
  attr({ attribute: "ariasetsize" })
], Option$1.prototype, "ariaSetSize", 2);
__decorateClass$13([
  attr({ mode: "boolean" })
], Option$1.prototype, "checked", 2);
__decorateClass$13([
  attr({ mode: "boolean" })
], Option$1.prototype, "multiple", 2);
const tm1Option = Option$1.compose({
  baseName: "option",
  baseClass: ListboxOption,
  template: tm1OptionTemplate,
  styles: tm1OptionStyles
});
designSystem.register(
  tm1Option()
);
const sides = ["top", "right", "bottom", "left"], min = Math.min, max = Math.max, round = Math.round, floor = Math.floor, createCoords = (td) => ({
  x: td,
  y: td
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(td, Ae, xr) {
  return max(td, min(Ae, xr));
}
function evaluate(td, Ae) {
  return typeof td == "function" ? td(Ae) : td;
}
function getSide(td) {
  return td.split("-")[0];
}
function getAlignment(td) {
  return td.split("-")[1];
}
function getOppositeAxis(td) {
  return td === "x" ? "y" : "x";
}
function getAxisLength(td) {
  return td === "y" ? "height" : "width";
}
function getSideAxis(td) {
  return ["top", "bottom"].includes(getSide(td)) ? "y" : "x";
}
function getAlignmentAxis(td) {
  return getOppositeAxis(getSideAxis(td));
}
function getAlignmentSides(td, Ae, xr) {
  xr === void 0 && (xr = !1);
  const ed = getAlignment(td), id = getAlignmentAxis(td), od = getAxisLength(id);
  let ad = id === "x" ? ed === (xr ? "end" : "start") ? "right" : "left" : ed === "start" ? "bottom" : "top";
  return Ae.reference[od] > Ae.floating[od] && (ad = getOppositePlacement(ad)), [ad, getOppositePlacement(ad)];
}
function getExpandedPlacements(td) {
  const Ae = getOppositePlacement(td);
  return [getOppositeAlignmentPlacement(td), Ae, getOppositeAlignmentPlacement(Ae)];
}
function getOppositeAlignmentPlacement(td) {
  return td.replace(/start|end/g, (Ae) => oppositeAlignmentMap[Ae]);
}
function getSideList(td, Ae, xr) {
  const ed = ["left", "right"], id = ["right", "left"], od = ["top", "bottom"], ad = ["bottom", "top"];
  switch (td) {
    case "top":
    case "bottom":
      return xr ? Ae ? id : ed : Ae ? ed : id;
    case "left":
    case "right":
      return Ae ? od : ad;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(td, Ae, xr, ed) {
  const id = getAlignment(td);
  let od = getSideList(getSide(td), xr === "start", ed);
  return id && (od = od.map((ad) => ad + "-" + id), Ae && (od = od.concat(od.map(getOppositeAlignmentPlacement)))), od;
}
function getOppositePlacement(td) {
  return td.replace(/left|right|bottom|top/g, (Ae) => oppositeSideMap[Ae]);
}
function expandPaddingObject(td) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...td
  };
}
function getPaddingObject(td) {
  return typeof td != "number" ? expandPaddingObject(td) : {
    top: td,
    right: td,
    bottom: td,
    left: td
  };
}
function rectToClientRect(td) {
  const {
    x: Ae,
    y: xr,
    width: ed,
    height: id
  } = td;
  return {
    width: ed,
    height: id,
    top: xr,
    left: Ae,
    right: Ae + ed,
    bottom: xr + id,
    x: Ae,
    y: xr
  };
}
function computeCoordsFromPlacement(td, Ae, xr) {
  let {
    reference: ed,
    floating: id
  } = td;
  const od = getSideAxis(Ae), ad = getAlignmentAxis(Ae), rd = getAxisLength(ad), sd = getSide(Ae), nd = od === "y", cd = ed.x + ed.width / 2 - id.width / 2, ud = ed.y + ed.height / 2 - id.height / 2, ld = ed[rd] / 2 - id[rd] / 2;
  let dd;
  switch (sd) {
    case "top":
      dd = {
        x: cd,
        y: ed.y - id.height
      };
      break;
    case "bottom":
      dd = {
        x: cd,
        y: ed.y + ed.height
      };
      break;
    case "right":
      dd = {
        x: ed.x + ed.width,
        y: ud
      };
      break;
    case "left":
      dd = {
        x: ed.x - id.width,
        y: ud
      };
      break;
    default:
      dd = {
        x: ed.x,
        y: ed.y
      };
  }
  switch (getAlignment(Ae)) {
    case "start":
      dd[ad] -= ld * (xr && nd ? -1 : 1);
      break;
    case "end":
      dd[ad] += ld * (xr && nd ? -1 : 1);
      break;
  }
  return dd;
}
const computePosition$1 = async (td, Ae, xr) => {
  const {
    placement: ed = "bottom",
    strategy: id = "absolute",
    middleware: od = [],
    platform: ad
  } = xr, rd = od.filter(Boolean), sd = await (ad.isRTL == null ? void 0 : ad.isRTL(Ae));
  let nd = await ad.getElementRects({
    reference: td,
    floating: Ae,
    strategy: id
  }), {
    x: cd,
    y: ud
  } = computeCoordsFromPlacement(nd, ed, sd), ld = ed, dd = {}, pd = 0;
  for (let md = 0; md < rd.length; md++) {
    const {
      name: fd,
      fn: bd
    } = rd[md], {
      x: Sd,
      y: vd,
      data: Ed,
      reset: Td
    } = await bd({
      x: cd,
      y: ud,
      initialPlacement: ed,
      placement: ld,
      strategy: id,
      middlewareData: dd,
      rects: nd,
      platform: ad,
      elements: {
        reference: td,
        floating: Ae
      }
    });
    cd = Sd != null ? Sd : cd, ud = vd != null ? vd : ud, dd = {
      ...dd,
      [fd]: {
        ...dd[fd],
        ...Ed
      }
    }, Td && pd <= 50 && (pd++, typeof Td == "object" && (Td.placement && (ld = Td.placement), Td.rects && (nd = Td.rects === !0 ? await ad.getElementRects({
      reference: td,
      floating: Ae,
      strategy: id
    }) : Td.rects), {
      x: cd,
      y: ud
    } = computeCoordsFromPlacement(nd, ld, sd)), md = -1);
  }
  return {
    x: cd,
    y: ud,
    placement: ld,
    strategy: id,
    middlewareData: dd
  };
};
async function detectOverflow(td, Ae) {
  var xr;
  Ae === void 0 && (Ae = {});
  const {
    x: ed,
    y: id,
    platform: od,
    rects: ad,
    elements: rd,
    strategy: sd
  } = td, {
    boundary: nd = "clippingAncestors",
    rootBoundary: cd = "viewport",
    elementContext: ud = "floating",
    altBoundary: ld = !1,
    padding: dd = 0
  } = evaluate(Ae, td), pd = getPaddingObject(dd), fd = rd[ld ? ud === "floating" ? "reference" : "floating" : ud], bd = rectToClientRect(await od.getClippingRect({
    element: (xr = await (od.isElement == null ? void 0 : od.isElement(fd))) == null || xr ? fd : fd.contextElement || await (od.getDocumentElement == null ? void 0 : od.getDocumentElement(rd.floating)),
    boundary: nd,
    rootBoundary: cd,
    strategy: sd
  })), Sd = ud === "floating" ? {
    x: ed,
    y: id,
    width: ad.floating.width,
    height: ad.floating.height
  } : ad.reference, vd = await (od.getOffsetParent == null ? void 0 : od.getOffsetParent(rd.floating)), Ed = await (od.isElement == null ? void 0 : od.isElement(vd)) ? await (od.getScale == null ? void 0 : od.getScale(vd)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Td = rectToClientRect(od.convertOffsetParentRelativeRectToViewportRelativeRect ? await od.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: rd,
    rect: Sd,
    offsetParent: vd,
    strategy: sd
  }) : Sd);
  return {
    top: (bd.top - Td.top + pd.top) / Ed.y,
    bottom: (Td.bottom - bd.bottom + pd.bottom) / Ed.y,
    left: (bd.left - Td.left + pd.left) / Ed.x,
    right: (Td.right - bd.right + pd.right) / Ed.x
  };
}
const arrow$1 = (td) => ({
  name: "arrow",
  options: td,
  async fn(Ae) {
    const {
      x: xr,
      y: ed,
      placement: id,
      rects: od,
      platform: ad,
      elements: rd,
      middlewareData: sd
    } = Ae, {
      element: nd,
      padding: cd = 0
    } = evaluate(td, Ae) || {};
    if (nd == null)
      return {};
    const ud = getPaddingObject(cd), ld = {
      x: xr,
      y: ed
    }, dd = getAlignmentAxis(id), pd = getAxisLength(dd), md = await ad.getDimensions(nd), fd = dd === "y", bd = fd ? "top" : "left", Sd = fd ? "bottom" : "right", vd = fd ? "clientHeight" : "clientWidth", Ed = od.reference[pd] + od.reference[dd] - ld[dd] - od.floating[pd], Td = ld[dd] - od.reference[dd], Gd = await (ad.getOffsetParent == null ? void 0 : ad.getOffsetParent(nd));
    let Id = Gd ? Gd[vd] : 0;
    (!Id || !await (ad.isElement == null ? void 0 : ad.isElement(Gd))) && (Id = rd.floating[vd] || od.floating[pd]);
    const Pd = Ed / 2 - Td / 2, Hd = Id / 2 - md[pd] / 2 - 1, Rd = min(ud[bd], Hd), Cd = min(ud[Sd], Hd), wd = Rd, Ld = Id - md[pd] - Cd, kd = Id / 2 - md[pd] / 2 + Pd, Dd = clamp(wd, kd, Ld), Fd = !sd.arrow && getAlignment(id) != null && kd !== Dd && od.reference[pd] / 2 - (kd < wd ? Rd : Cd) - md[pd] / 2 < 0, xd = Fd ? kd < wd ? kd - wd : kd - Ld : 0;
    return {
      [dd]: ld[dd] + xd,
      data: {
        [dd]: Dd,
        centerOffset: kd - Dd - xd,
        ...Fd && {
          alignmentOffset: xd
        }
      },
      reset: Fd
    };
  }
}), flip$1 = function(td) {
  return td === void 0 && (td = {}), {
    name: "flip",
    options: td,
    async fn(Ae) {
      var xr, ed;
      const {
        placement: id,
        middlewareData: od,
        rects: ad,
        initialPlacement: rd,
        platform: sd,
        elements: nd
      } = Ae, {
        mainAxis: cd = !0,
        crossAxis: ud = !0,
        fallbackPlacements: ld,
        fallbackStrategy: dd = "bestFit",
        fallbackAxisSideDirection: pd = "none",
        flipAlignment: md = !0,
        ...fd
      } = evaluate(td, Ae);
      if ((xr = od.arrow) != null && xr.alignmentOffset)
        return {};
      const bd = getSide(id), Sd = getSideAxis(rd), vd = getSide(rd) === rd, Ed = await (sd.isRTL == null ? void 0 : sd.isRTL(nd.floating)), Td = ld || (vd || !md ? [getOppositePlacement(rd)] : getExpandedPlacements(rd)), Gd = pd !== "none";
      !ld && Gd && Td.push(...getOppositeAxisPlacements(rd, md, pd, Ed));
      const Id = [rd, ...Td], Pd = await detectOverflow(Ae, fd), Hd = [];
      let Rd = ((ed = od.flip) == null ? void 0 : ed.overflows) || [];
      if (cd && Hd.push(Pd[bd]), ud) {
        const kd = getAlignmentSides(id, ad, Ed);
        Hd.push(Pd[kd[0]], Pd[kd[1]]);
      }
      if (Rd = [...Rd, {
        placement: id,
        overflows: Hd
      }], !Hd.every((kd) => kd <= 0)) {
        var Cd, wd;
        const kd = (((Cd = od.flip) == null ? void 0 : Cd.index) || 0) + 1, Dd = Id[kd];
        if (Dd)
          return {
            data: {
              index: kd,
              overflows: Rd
            },
            reset: {
              placement: Dd
            }
          };
        let Fd = (wd = Rd.filter((xd) => xd.overflows[0] <= 0).sort((xd, Ad) => xd.overflows[1] - Ad.overflows[1])[0]) == null ? void 0 : wd.placement;
        if (!Fd)
          switch (dd) {
            case "bestFit": {
              var Ld;
              const xd = (Ld = Rd.filter((Ad) => {
                if (Gd) {
                  const Nd = getSideAxis(Ad.placement);
                  return Nd === Sd || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Nd === "y";
                }
                return !0;
              }).map((Ad) => [Ad.placement, Ad.overflows.filter((Nd) => Nd > 0).reduce((Nd, zd) => Nd + zd, 0)]).sort((Ad, Nd) => Ad[1] - Nd[1])[0]) == null ? void 0 : Ld[0];
              xd && (Fd = xd);
              break;
            }
            case "initialPlacement":
              Fd = rd;
              break;
          }
        if (id !== Fd)
          return {
            reset: {
              placement: Fd
            }
          };
      }
      return {};
    }
  };
};
function getSideOffsets(td, Ae) {
  return {
    top: td.top - Ae.height,
    right: td.right - Ae.width,
    bottom: td.bottom - Ae.height,
    left: td.left - Ae.width
  };
}
function isAnySideFullyClipped(td) {
  return sides.some((Ae) => td[Ae] >= 0);
}
const hide$1 = function(td) {
  return td === void 0 && (td = {}), {
    name: "hide",
    options: td,
    async fn(Ae) {
      const {
        rects: xr
      } = Ae, {
        strategy: ed = "referenceHidden",
        ...id
      } = evaluate(td, Ae);
      switch (ed) {
        case "referenceHidden": {
          const od = await detectOverflow(Ae, {
            ...id,
            elementContext: "reference"
          }), ad = getSideOffsets(od, xr.reference);
          return {
            data: {
              referenceHiddenOffsets: ad,
              referenceHidden: isAnySideFullyClipped(ad)
            }
          };
        }
        case "escaped": {
          const od = await detectOverflow(Ae, {
            ...id,
            altBoundary: !0
          }), ad = getSideOffsets(od, xr.floating);
          return {
            data: {
              escapedOffsets: ad,
              escaped: isAnySideFullyClipped(ad)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function convertValueToCoords(td, Ae) {
  const {
    placement: xr,
    platform: ed,
    elements: id
  } = td, od = await (ed.isRTL == null ? void 0 : ed.isRTL(id.floating)), ad = getSide(xr), rd = getAlignment(xr), sd = getSideAxis(xr) === "y", nd = ["left", "top"].includes(ad) ? -1 : 1, cd = od && sd ? -1 : 1, ud = evaluate(Ae, td);
  let {
    mainAxis: ld,
    crossAxis: dd,
    alignmentAxis: pd
  } = typeof ud == "number" ? {
    mainAxis: ud,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: ud.mainAxis || 0,
    crossAxis: ud.crossAxis || 0,
    alignmentAxis: ud.alignmentAxis
  };
  return rd && typeof pd == "number" && (dd = rd === "end" ? pd * -1 : pd), sd ? {
    x: dd * cd,
    y: ld * nd
  } : {
    x: ld * nd,
    y: dd * cd
  };
}
const offset$1 = function(td) {
  return td === void 0 && (td = 0), {
    name: "offset",
    options: td,
    async fn(Ae) {
      var xr, ed;
      const {
        x: id,
        y: od,
        placement: ad,
        middlewareData: rd
      } = Ae, sd = await convertValueToCoords(Ae, td);
      return ad === ((xr = rd.offset) == null ? void 0 : xr.placement) && (ed = rd.arrow) != null && ed.alignmentOffset ? {} : {
        x: id + sd.x,
        y: od + sd.y,
        data: {
          ...sd,
          placement: ad
        }
      };
    }
  };
}, shift$1 = function(td) {
  return td === void 0 && (td = {}), {
    name: "shift",
    options: td,
    async fn(Ae) {
      const {
        x: xr,
        y: ed,
        placement: id
      } = Ae, {
        mainAxis: od = !0,
        crossAxis: ad = !1,
        limiter: rd = {
          fn: (fd) => {
            let {
              x: bd,
              y: Sd
            } = fd;
            return {
              x: bd,
              y: Sd
            };
          }
        },
        ...sd
      } = evaluate(td, Ae), nd = {
        x: xr,
        y: ed
      }, cd = await detectOverflow(Ae, sd), ud = getSideAxis(getSide(id)), ld = getOppositeAxis(ud);
      let dd = nd[ld], pd = nd[ud];
      if (od) {
        const fd = ld === "y" ? "top" : "left", bd = ld === "y" ? "bottom" : "right", Sd = dd + cd[fd], vd = dd - cd[bd];
        dd = clamp(Sd, dd, vd);
      }
      if (ad) {
        const fd = ud === "y" ? "top" : "left", bd = ud === "y" ? "bottom" : "right", Sd = pd + cd[fd], vd = pd - cd[bd];
        pd = clamp(Sd, pd, vd);
      }
      const md = rd.fn({
        ...Ae,
        [ld]: dd,
        [ud]: pd
      });
      return {
        ...md,
        data: {
          x: md.x - xr,
          y: md.y - ed,
          enabled: {
            [ld]: od,
            [ud]: ad
          }
        }
      };
    }
  };
}, size$1 = function(td) {
  return td === void 0 && (td = {}), {
    name: "size",
    options: td,
    async fn(Ae) {
      var xr, ed;
      const {
        placement: id,
        rects: od,
        platform: ad,
        elements: rd
      } = Ae, {
        apply: sd = () => {
        },
        ...nd
      } = evaluate(td, Ae), cd = await detectOverflow(Ae, nd), ud = getSide(id), ld = getAlignment(id), dd = getSideAxis(id) === "y", {
        width: pd,
        height: md
      } = od.floating;
      let fd, bd;
      ud === "top" || ud === "bottom" ? (fd = ud, bd = ld === (await (ad.isRTL == null ? void 0 : ad.isRTL(rd.floating)) ? "start" : "end") ? "left" : "right") : (bd = ud, fd = ld === "end" ? "top" : "bottom");
      const Sd = md - cd.top - cd.bottom, vd = pd - cd.left - cd.right, Ed = min(md - cd[fd], Sd), Td = min(pd - cd[bd], vd), Gd = !Ae.middlewareData.shift;
      let Id = Ed, Pd = Td;
      if ((xr = Ae.middlewareData.shift) != null && xr.enabled.x && (Pd = vd), (ed = Ae.middlewareData.shift) != null && ed.enabled.y && (Id = Sd), Gd && !ld) {
        const Rd = max(cd.left, 0), Cd = max(cd.right, 0), wd = max(cd.top, 0), Ld = max(cd.bottom, 0);
        dd ? Pd = pd - 2 * (Rd !== 0 || Cd !== 0 ? Rd + Cd : max(cd.left, cd.right)) : Id = md - 2 * (wd !== 0 || Ld !== 0 ? wd + Ld : max(cd.top, cd.bottom));
      }
      await sd({
        ...Ae,
        availableWidth: Pd,
        availableHeight: Id
      });
      const Hd = await ad.getDimensions(rd.floating);
      return pd !== Hd.width || md !== Hd.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function hasWindow() {
  return typeof window != "undefined";
}
function getNodeName(td) {
  return isNode(td) ? (td.nodeName || "").toLowerCase() : "#document";
}
function getWindow(td) {
  var Ae;
  return (td == null || (Ae = td.ownerDocument) == null ? void 0 : Ae.defaultView) || window;
}
function getDocumentElement(td) {
  var Ae;
  return (Ae = (isNode(td) ? td.ownerDocument : td.document) || window.document) == null ? void 0 : Ae.documentElement;
}
function isNode(td) {
  return hasWindow() ? td instanceof Node || td instanceof getWindow(td).Node : !1;
}
function isElement(td) {
  return hasWindow() ? td instanceof Element || td instanceof getWindow(td).Element : !1;
}
function isHTMLElement(td) {
  return hasWindow() ? td instanceof HTMLElement || td instanceof getWindow(td).HTMLElement : !1;
}
function isShadowRoot(td) {
  return !hasWindow() || typeof ShadowRoot == "undefined" ? !1 : td instanceof ShadowRoot || td instanceof getWindow(td).ShadowRoot;
}
function isOverflowElement(td) {
  const {
    overflow: Ae,
    overflowX: xr,
    overflowY: ed,
    display: id
  } = getComputedStyle$1(td);
  return /auto|scroll|overlay|hidden|clip/.test(Ae + ed + xr) && !["inline", "contents"].includes(id);
}
function isTableElement(td) {
  return ["table", "td", "th"].includes(getNodeName(td));
}
function isTopLayer(td) {
  return [":popover-open", ":modal"].some((Ae) => {
    try {
      return td.matches(Ae);
    } catch (xr) {
      return !1;
    }
  });
}
function isContainingBlock(td) {
  const Ae = isWebKit(), xr = isElement(td) ? getComputedStyle$1(td) : td;
  return xr.transform !== "none" || xr.perspective !== "none" || (xr.containerType ? xr.containerType !== "normal" : !1) || !Ae && (xr.backdropFilter ? xr.backdropFilter !== "none" : !1) || !Ae && (xr.filter ? xr.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((ed) => (xr.willChange || "").includes(ed)) || ["paint", "layout", "strict", "content"].some((ed) => (xr.contain || "").includes(ed));
}
function getContainingBlock(td) {
  let Ae = getParentNode(td);
  for (; isHTMLElement(Ae) && !isLastTraversableNode(Ae); ) {
    if (isContainingBlock(Ae))
      return Ae;
    if (isTopLayer(Ae))
      return null;
    Ae = getParentNode(Ae);
  }
  return null;
}
function isWebKit() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(td) {
  return ["html", "body", "#document"].includes(getNodeName(td));
}
function getComputedStyle$1(td) {
  return getWindow(td).getComputedStyle(td);
}
function getNodeScroll(td) {
  return isElement(td) ? {
    scrollLeft: td.scrollLeft,
    scrollTop: td.scrollTop
  } : {
    scrollLeft: td.scrollX,
    scrollTop: td.scrollY
  };
}
function getParentNode(td) {
  if (getNodeName(td) === "html")
    return td;
  const Ae = (
    // Step into the shadow DOM of the parent of a slotted node.
    td.assignedSlot || // DOM Element detected.
    td.parentNode || // ShadowRoot detected.
    isShadowRoot(td) && td.host || // Fallback.
    getDocumentElement(td)
  );
  return isShadowRoot(Ae) ? Ae.host : Ae;
}
function getNearestOverflowAncestor(td) {
  const Ae = getParentNode(td);
  return isLastTraversableNode(Ae) ? td.ownerDocument ? td.ownerDocument.body : td.body : isHTMLElement(Ae) && isOverflowElement(Ae) ? Ae : getNearestOverflowAncestor(Ae);
}
function getOverflowAncestors(td, Ae, xr) {
  var ed;
  Ae === void 0 && (Ae = []), xr === void 0 && (xr = !0);
  const id = getNearestOverflowAncestor(td), od = id === ((ed = td.ownerDocument) == null ? void 0 : ed.body), ad = getWindow(id);
  if (od) {
    const rd = getFrameElement(ad);
    return Ae.concat(ad, ad.visualViewport || [], isOverflowElement(id) ? id : [], rd && xr ? getOverflowAncestors(rd) : []);
  }
  return Ae.concat(id, getOverflowAncestors(id, [], xr));
}
function getFrameElement(td) {
  return td.parent && Object.getPrototypeOf(td.parent) ? td.frameElement : null;
}
function getCssDimensions(td) {
  const Ae = getComputedStyle$1(td);
  let xr = parseFloat(Ae.width) || 0, ed = parseFloat(Ae.height) || 0;
  const id = isHTMLElement(td), od = id ? td.offsetWidth : xr, ad = id ? td.offsetHeight : ed, rd = round(xr) !== od || round(ed) !== ad;
  return rd && (xr = od, ed = ad), {
    width: xr,
    height: ed,
    $: rd
  };
}
function unwrapElement(td) {
  return isElement(td) ? td : td.contextElement;
}
function getScale(td) {
  const Ae = unwrapElement(td);
  if (!isHTMLElement(Ae))
    return createCoords(1);
  const xr = Ae.getBoundingClientRect(), {
    width: ed,
    height: id,
    $: od
  } = getCssDimensions(Ae);
  let ad = (od ? round(xr.width) : xr.width) / ed, rd = (od ? round(xr.height) : xr.height) / id;
  return (!ad || !Number.isFinite(ad)) && (ad = 1), (!rd || !Number.isFinite(rd)) && (rd = 1), {
    x: ad,
    y: rd
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(td) {
  const Ae = getWindow(td);
  return !isWebKit() || !Ae.visualViewport ? noOffsets : {
    x: Ae.visualViewport.offsetLeft,
    y: Ae.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(td, Ae, xr) {
  return Ae === void 0 && (Ae = !1), !xr || Ae && xr !== getWindow(td) ? !1 : Ae;
}
function getBoundingClientRect(td, Ae, xr, ed) {
  Ae === void 0 && (Ae = !1), xr === void 0 && (xr = !1);
  const id = td.getBoundingClientRect(), od = unwrapElement(td);
  let ad = createCoords(1);
  Ae && (ed ? isElement(ed) && (ad = getScale(ed)) : ad = getScale(td));
  const rd = shouldAddVisualOffsets(od, xr, ed) ? getVisualOffsets(od) : createCoords(0);
  let sd = (id.left + rd.x) / ad.x, nd = (id.top + rd.y) / ad.y, cd = id.width / ad.x, ud = id.height / ad.y;
  if (od) {
    const ld = getWindow(od), dd = ed && isElement(ed) ? getWindow(ed) : ed;
    let pd = ld, md = getFrameElement(pd);
    for (; md && ed && dd !== pd; ) {
      const fd = getScale(md), bd = md.getBoundingClientRect(), Sd = getComputedStyle$1(md), vd = bd.left + (md.clientLeft + parseFloat(Sd.paddingLeft)) * fd.x, Ed = bd.top + (md.clientTop + parseFloat(Sd.paddingTop)) * fd.y;
      sd *= fd.x, nd *= fd.y, cd *= fd.x, ud *= fd.y, sd += vd, nd += Ed, pd = getWindow(md), md = getFrameElement(pd);
    }
  }
  return rectToClientRect({
    width: cd,
    height: ud,
    x: sd,
    y: nd
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(td) {
  let {
    elements: Ae,
    rect: xr,
    offsetParent: ed,
    strategy: id
  } = td;
  const od = id === "fixed", ad = getDocumentElement(ed), rd = Ae ? isTopLayer(Ae.floating) : !1;
  if (ed === ad || rd && od)
    return xr;
  let sd = {
    scrollLeft: 0,
    scrollTop: 0
  }, nd = createCoords(1);
  const cd = createCoords(0), ud = isHTMLElement(ed);
  if ((ud || !ud && !od) && ((getNodeName(ed) !== "body" || isOverflowElement(ad)) && (sd = getNodeScroll(ed)), isHTMLElement(ed))) {
    const ld = getBoundingClientRect(ed);
    nd = getScale(ed), cd.x = ld.x + ed.clientLeft, cd.y = ld.y + ed.clientTop;
  }
  return {
    width: xr.width * nd.x,
    height: xr.height * nd.y,
    x: xr.x * nd.x - sd.scrollLeft * nd.x + cd.x,
    y: xr.y * nd.y - sd.scrollTop * nd.y + cd.y
  };
}
function getClientRects(td) {
  return Array.from(td.getClientRects());
}
function getWindowScrollBarX(td, Ae) {
  const xr = getNodeScroll(td).scrollLeft;
  return Ae ? Ae.left + xr : getBoundingClientRect(getDocumentElement(td)).left + xr;
}
function getDocumentRect(td) {
  const Ae = getDocumentElement(td), xr = getNodeScroll(td), ed = td.ownerDocument.body, id = max(Ae.scrollWidth, Ae.clientWidth, ed.scrollWidth, ed.clientWidth), od = max(Ae.scrollHeight, Ae.clientHeight, ed.scrollHeight, ed.clientHeight);
  let ad = -xr.scrollLeft + getWindowScrollBarX(td);
  const rd = -xr.scrollTop;
  return getComputedStyle$1(ed).direction === "rtl" && (ad += max(Ae.clientWidth, ed.clientWidth) - id), {
    width: id,
    height: od,
    x: ad,
    y: rd
  };
}
function getViewportRect(td, Ae) {
  const xr = getWindow(td), ed = getDocumentElement(td), id = xr.visualViewport;
  let od = ed.clientWidth, ad = ed.clientHeight, rd = 0, sd = 0;
  if (id) {
    od = id.width, ad = id.height;
    const nd = isWebKit();
    (!nd || nd && Ae === "fixed") && (rd = id.offsetLeft, sd = id.offsetTop);
  }
  return {
    width: od,
    height: ad,
    x: rd,
    y: sd
  };
}
function getInnerBoundingClientRect(td, Ae) {
  const xr = getBoundingClientRect(td, !0, Ae === "fixed"), ed = xr.top + td.clientTop, id = xr.left + td.clientLeft, od = isHTMLElement(td) ? getScale(td) : createCoords(1), ad = td.clientWidth * od.x, rd = td.clientHeight * od.y, sd = id * od.x, nd = ed * od.y;
  return {
    width: ad,
    height: rd,
    x: sd,
    y: nd
  };
}
function getClientRectFromClippingAncestor(td, Ae, xr) {
  let ed;
  if (Ae === "viewport")
    ed = getViewportRect(td, xr);
  else if (Ae === "document")
    ed = getDocumentRect(getDocumentElement(td));
  else if (isElement(Ae))
    ed = getInnerBoundingClientRect(Ae, xr);
  else {
    const id = getVisualOffsets(td);
    ed = {
      ...Ae,
      x: Ae.x - id.x,
      y: Ae.y - id.y
    };
  }
  return rectToClientRect(ed);
}
function hasFixedPositionAncestor(td, Ae) {
  const xr = getParentNode(td);
  return xr === Ae || !isElement(xr) || isLastTraversableNode(xr) ? !1 : getComputedStyle$1(xr).position === "fixed" || hasFixedPositionAncestor(xr, Ae);
}
function getClippingElementAncestors(td, Ae) {
  const xr = Ae.get(td);
  if (xr)
    return xr;
  let ed = getOverflowAncestors(td, [], !1).filter((rd) => isElement(rd) && getNodeName(rd) !== "body"), id = null;
  const od = getComputedStyle$1(td).position === "fixed";
  let ad = od ? getParentNode(td) : td;
  for (; isElement(ad) && !isLastTraversableNode(ad); ) {
    const rd = getComputedStyle$1(ad), sd = isContainingBlock(ad);
    !sd && rd.position === "fixed" && (id = null), (od ? !sd && !id : !sd && rd.position === "static" && !!id && ["absolute", "fixed"].includes(id.position) || isOverflowElement(ad) && !sd && hasFixedPositionAncestor(td, ad)) ? ed = ed.filter((cd) => cd !== ad) : id = rd, ad = getParentNode(ad);
  }
  return Ae.set(td, ed), ed;
}
function getClippingRect(td) {
  let {
    element: Ae,
    boundary: xr,
    rootBoundary: ed,
    strategy: id
  } = td;
  const ad = [...xr === "clippingAncestors" ? isTopLayer(Ae) ? [] : getClippingElementAncestors(Ae, this._c) : [].concat(xr), ed], rd = ad[0], sd = ad.reduce((nd, cd) => {
    const ud = getClientRectFromClippingAncestor(Ae, cd, id);
    return nd.top = max(ud.top, nd.top), nd.right = min(ud.right, nd.right), nd.bottom = min(ud.bottom, nd.bottom), nd.left = max(ud.left, nd.left), nd;
  }, getClientRectFromClippingAncestor(Ae, rd, id));
  return {
    width: sd.right - sd.left,
    height: sd.bottom - sd.top,
    x: sd.left,
    y: sd.top
  };
}
function getDimensions(td) {
  const {
    width: Ae,
    height: xr
  } = getCssDimensions(td);
  return {
    width: Ae,
    height: xr
  };
}
function getRectRelativeToOffsetParent(td, Ae, xr) {
  const ed = isHTMLElement(Ae), id = getDocumentElement(Ae), od = xr === "fixed", ad = getBoundingClientRect(td, !0, od, Ae);
  let rd = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const sd = createCoords(0);
  if (ed || !ed && !od)
    if ((getNodeName(Ae) !== "body" || isOverflowElement(id)) && (rd = getNodeScroll(Ae)), ed) {
      const dd = getBoundingClientRect(Ae, !0, od, Ae);
      sd.x = dd.x + Ae.clientLeft, sd.y = dd.y + Ae.clientTop;
    } else
      id && (sd.x = getWindowScrollBarX(id));
  let nd = 0, cd = 0;
  if (id && !ed && !od) {
    const dd = id.getBoundingClientRect();
    cd = dd.top + rd.scrollTop, nd = dd.left + rd.scrollLeft - // RTL <body> scrollbar.
    getWindowScrollBarX(id, dd);
  }
  const ud = ad.left + rd.scrollLeft - sd.x - nd, ld = ad.top + rd.scrollTop - sd.y - cd;
  return {
    x: ud,
    y: ld,
    width: ad.width,
    height: ad.height
  };
}
function isStaticPositioned(td) {
  return getComputedStyle$1(td).position === "static";
}
function getTrueOffsetParent(td, Ae) {
  if (!isHTMLElement(td) || getComputedStyle$1(td).position === "fixed")
    return null;
  if (Ae)
    return Ae(td);
  let xr = td.offsetParent;
  return getDocumentElement(td) === xr && (xr = xr.ownerDocument.body), xr;
}
function getOffsetParent(td, Ae) {
  const xr = getWindow(td);
  if (isTopLayer(td))
    return xr;
  if (!isHTMLElement(td)) {
    let id = getParentNode(td);
    for (; id && !isLastTraversableNode(id); ) {
      if (isElement(id) && !isStaticPositioned(id))
        return id;
      id = getParentNode(id);
    }
    return xr;
  }
  let ed = getTrueOffsetParent(td, Ae);
  for (; ed && isTableElement(ed) && isStaticPositioned(ed); )
    ed = getTrueOffsetParent(ed, Ae);
  return ed && isLastTraversableNode(ed) && isStaticPositioned(ed) && !isContainingBlock(ed) ? xr : ed || getContainingBlock(td) || xr;
}
const getElementRects = async function(td) {
  const Ae = this.getOffsetParent || getOffsetParent, xr = this.getDimensions, ed = await xr(td.floating);
  return {
    reference: getRectRelativeToOffsetParent(td.reference, await Ae(td.floating), td.strategy),
    floating: {
      x: 0,
      y: 0,
      width: ed.width,
      height: ed.height
    }
  };
};
function isRTL(td) {
  return getComputedStyle$1(td).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(td, Ae) {
  let xr = null, ed;
  const id = getDocumentElement(td);
  function od() {
    var rd;
    clearTimeout(ed), (rd = xr) == null || rd.disconnect(), xr = null;
  }
  function ad(rd, sd) {
    rd === void 0 && (rd = !1), sd === void 0 && (sd = 1), od();
    const {
      left: nd,
      top: cd,
      width: ud,
      height: ld
    } = td.getBoundingClientRect();
    if (rd || Ae(), !ud || !ld)
      return;
    const dd = floor(cd), pd = floor(id.clientWidth - (nd + ud)), md = floor(id.clientHeight - (cd + ld)), fd = floor(nd), Sd = {
      rootMargin: -dd + "px " + -pd + "px " + -md + "px " + -fd + "px",
      threshold: max(0, min(1, sd)) || 1
    };
    let vd = !0;
    function Ed(Td) {
      const Gd = Td[0].intersectionRatio;
      if (Gd !== sd) {
        if (!vd)
          return ad();
        Gd ? ad(!1, Gd) : ed = setTimeout(() => {
          ad(!1, 1e-7);
        }, 1e3);
      }
      vd = !1;
    }
    try {
      xr = new IntersectionObserver(Ed, {
        ...Sd,
        // Handle <iframe>s
        root: id.ownerDocument
      });
    } catch (Td) {
      xr = new IntersectionObserver(Ed, Sd);
    }
    xr.observe(td);
  }
  return ad(!0), od;
}
function autoUpdate(td, Ae, xr, ed) {
  ed === void 0 && (ed = {});
  const {
    ancestorScroll: id = !0,
    ancestorResize: od = !0,
    elementResize: ad = typeof ResizeObserver == "function",
    layoutShift: rd = typeof IntersectionObserver == "function",
    animationFrame: sd = !1
  } = ed, nd = unwrapElement(td), cd = id || od ? [...nd ? getOverflowAncestors(nd) : [], ...getOverflowAncestors(Ae)] : [];
  cd.forEach((bd) => {
    id && bd.addEventListener("scroll", xr, {
      passive: !0
    }), od && bd.addEventListener("resize", xr);
  });
  const ud = nd && rd ? observeMove(nd, xr) : null;
  let ld = -1, dd = null;
  ad && (dd = new ResizeObserver((bd) => {
    let [Sd] = bd;
    Sd && Sd.target === nd && dd && (dd.unobserve(Ae), cancelAnimationFrame(ld), ld = requestAnimationFrame(() => {
      var vd;
      (vd = dd) == null || vd.observe(Ae);
    })), xr();
  }), nd && !sd && dd.observe(nd), dd.observe(Ae));
  let pd, md = sd ? getBoundingClientRect(td) : null;
  sd && fd();
  function fd() {
    const bd = getBoundingClientRect(td);
    md && (bd.x !== md.x || bd.y !== md.y || bd.width !== md.width || bd.height !== md.height) && xr(), md = bd, pd = requestAnimationFrame(fd);
  }
  return xr(), () => {
    var bd;
    cd.forEach((Sd) => {
      id && Sd.removeEventListener("scroll", xr), od && Sd.removeEventListener("resize", xr);
    }), ud == null || ud(), (bd = dd) == null || bd.disconnect(), dd = null, sd && cancelAnimationFrame(pd);
  };
}
const offset = offset$1, shift = shift$1, flip = flip$1, size = size$1, hide = hide$1, arrow = arrow$1, computePosition = (td, Ae, xr) => {
  const ed = /* @__PURE__ */ new Map(), id = {
    platform,
    ...xr
  }, od = {
    ...id.platform,
    _c: ed
  };
  return computePosition$1(td, Ae, {
    ...id,
    platform: od
  });
}, tm1PopoverStyles = () => css`
  :host {
    display: contents;
    position: relative;
    width: max-content;
  }

  .trigger {
    display: block;
  }

  .popover {
    position: absolute;
    visibility: hidden;
    z-index: ${GDSEZIndexDrawerContent};
  }

  :host([visible]) .popover {
    visibility: visible;
  }

  :host([visible]) .overlay {
    --visibility: visible;
    --opacity: 1;
    --scale: 1;
  }

  :host([theme='dark']) .overlay {
    border-radius: ${GDSERadiusSurface};
  }

  .overlay {
    display: block;
    transition: 0.1s cubic-bezier(0.55, 0.085, 0.68, 0.53) 0s;
    transition-property: visibility, opacity, transform;

    visibility: var(--visibility, hidden);
    opacity: var(--opacity, 0);
    transform: scale(var(--scale, 0.8));

    padding: ${GDSESpacing100};
    color: ${GDSEColorText};
    background-color: ${GDSEColorSurfacePopover};
  }

  :host([hidden]) .popover {
    display: none;
  }

  :host([mode="relative"]:not([floating-ui])) > .container {
    position: relative;
    width: max-content;
  }

  :host([mode="relative"]:not([floating-ui])) .popover {
    width: max-content;
  }

  :host([direction="down"]) .popover {
    margin-top: ${GDSESpacing50};
  }

  :host([mode="relative"][direction="down"]:not([floating-ui])) .popover {
    top: 100%;
    bottom: auto;
  }

  :host([mode="absolute"]:not([floating-ui])) .popover {
    position: absolute;
  }

  :host([mode="relative"][direction="up"]:not([floating-ui])) .popover {
    top: auto;
    bottom: 100%;
    margin-bottom: var(--spacing-slim);
  }

  :host([mode="relative"][alignment="start"]:not([floating-ui])) .popover {
    left: 0;
    right: auto;
  }

  :host([mode="relative"][alignment="center"]:not([floating-ui])) .popover {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }

  :host([mode="relative"][alignment="end"]:not([floating-ui])) .popover {
    left: auto;
    right: 0;
  }

  :host([mode="inline"]:not([floating-ui])) .popover {
    position: relative;
  }

  :host([theme='dark']) .popover {
    background-color: ${GDSEColorSurfaceAlt};
    border: none;
  }

  .popover {
    position: absolute;
    background-color: ${GDSEColorSurfacePopover};
    color: ${GDSEColorText};
    border: 1px solid ${GDSEColorBorder};
    border-radius: ${GDSERadiusSurface};
    z-index: ${GDSEZIndexDrawerContent};
  }

  .padding-none {
    padding: ${GDSESpacing0};
  }

  .padding-cozy {
    padding: ${GDSESpacing100};
  }

  .padding-relax {
    padding: ${GDSESpacing150};
  }

  .padding-moderate {
    padding: ${GDSESpacing200};
  }

  .padding-normal {
    padding: ${GDSESpacing300};
  }
`, tm1PopoverTemplate = (td) => html`
  <template theme="${(Ae) => Ae.theme}">
    <div class="container" ${ref("container")}>
      <slot
        name="trigger"
        data-testid="popover-trigger"
        aria-describedby="popover"
        aria-expanded="${(Ae) => Ae.visible}"
        aria-haspopup="true"
        ${slotted("buttonEl")}
      ></slot>
      <div id="popover" class="popover" role="tooltip" ${ref("floatingEl")} style="${(Ae) => Ae.triggerHeight ? `top: ${Ae.triggerHeight};` : ""}">
        <${td.tagFor(Typography)} type="body-m">
          <slot part="popover-overlay" class="overlay padding-${(Ae) => Ae.padding}" data-testid="popover-overlay"></slot>
        </${td.tagFor(Typography)}>
      </div>
    </div>
  </template>
`;
var __defProp$12 = Object.defineProperty, __getOwnPropDesc$12 = Object.getOwnPropertyDescriptor, __decorateClass$12 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$12(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$12(Ae, xr, id), id;
};
const PopoverAlignment = {
  start: "start",
  center: "center",
  end: "end"
}, PopoverDirection = {
  up: "up",
  down: "down"
}, PopoverMode = {
  absolute: "absolute",
  relative: "relative",
  inline: "inline"
}, PopoverPadding = {
  none: "none",
  cozy: "cozy",
  relax: "relax",
  moderate: "moderate",
  normal: "normal"
};
class PopoverBase extends FoundationElement {
  constructor() {
    super(), this.alignment = PopoverAlignment.center, this.direction = PopoverDirection.down, this.mode = PopoverMode.relative, this.padding = PopoverPadding.moderate, this.visible = !1, this.isInsideScrollable = !1, this.isInsideDropdown = !1, this.scrollElevation = 0, this.scrollDimension = 0, this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this.isOpen = !1, this.clickBehavior = new ClickBehavior();
  }
  connectedCallback() {
    super.connectedCallback(), this.$fastController.addBehaviors([this.clickBehavior]), DOM.queueUpdate(() => {
      this.isOpen = this.visible;
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.$fastController.removeBehaviors([this.clickBehavior]);
  }
  toggleVisibility(Ae = !this.visible) {
    this.visible = Ae, this.updatePopoverPosition(), this.$emit("change", this.visible);
  }
  updatePopoverPosition() {
    var xr;
    const Ae = (xr = this.buttonEl) == null ? void 0 : xr[0];
    if (Ae && this.floatingEl && this.visible && this.isInsideScrollable && this.mode === PopoverMode.absolute) {
      const ed = Ae.getBoundingClientRect(), id = this.floatingEl.getBoundingClientRect(), od = window.scrollX || window.pageXOffset, ad = window.scrollY || window.pageYOffset;
      let rd = ed.top + ad;
      this.direction === "up" ? rd -= id.height : this.direction === "down" && (rd += ed.height);
      let sd;
      this.alignment === "end" ? sd = ed.left + od : this.alignment === "center" ? sd = ed.left + od + ed.width / 2 - id.width / 2 : this.alignment === "start" && (sd = ed.right + od - id.width), this.floatingEl.style.top = `${rd}px`, this.floatingEl.style.left = `${sd}px`;
    }
  }
  close(Ae) {
    Ae ? (this.toggleVisibility(!1), this.isOpen = !1) : this.isOpen = !0;
  }
  onClick(Ae) {
    var ed;
    const xr = (ed = this.buttonEl) == null ? void 0 : ed[0];
    this.isOpen ? Ae === xr && this.toggleVisibility() : this.toggleVisibility(!0), this.close(this.isOpen && !!this.closeOnClick);
  }
  onClickOutside(Ae) {
    this.isOpen && this.close(this.isOpen && !this.isInsideDropdown);
  }
}
__decorateClass$12([
  attr()
], PopoverBase.prototype, "alignment", 2);
__decorateClass$12([
  attr()
], PopoverBase.prototype, "direction", 2);
__decorateClass$12([
  attr()
], PopoverBase.prototype, "mode", 2);
__decorateClass$12([
  attr()
], PopoverBase.prototype, "padding", 2);
__decorateClass$12([
  attr({ mode: "boolean" })
], PopoverBase.prototype, "visible", 2);
__decorateClass$12([
  attr({ mode: "boolean", attribute: "close-on-click" }),
  attr({ mode: "boolean", attribute: "closeonclick" })
], PopoverBase.prototype, "closeOnClick", 2);
__decorateClass$12([
  attr({ mode: "boolean", attribute: "is-inside-scrollable" }),
  attr({ mode: "boolean", attribute: "isinsidescrollable" })
], PopoverBase.prototype, "isInsideScrollable", 2);
__decorateClass$12([
  attr({ mode: "boolean", attribute: "is-inside-dropdown" }),
  attr({ mode: "boolean", attribute: "isinsidedropdown" })
], PopoverBase.prototype, "isInsideDropdown", 2);
__decorateClass$12([
  attr({ attribute: "trigger-height" }),
  attr({ attribute: "triggerheight" })
], PopoverBase.prototype, "triggerHeight", 2);
__decorateClass$12([
  observable
], PopoverBase.prototype, "floatingEl", 2);
__decorateClass$12([
  observable
], PopoverBase.prototype, "buttonEl", 2);
__decorateClass$12([
  observable
], PopoverBase.prototype, "scrollElevation", 2);
__decorateClass$12([
  observable
], PopoverBase.prototype, "scrollDimension", 2);
__decorateClass$12([
  observable
], PopoverBase.prototype, "theme", 2);
class Popover extends PopoverBase {
  constructor() {
    super(...arguments), this.floatingUi = !1, this.positionStyles = void 0, this.toggleVisibility = (Ae = !this.visible) => {
      if (!this.floatingUi) {
        super.toggleVisibility(Ae);
        return;
      }
      this.visible = Ae, this.visible ? this.show() : this.hide(), this.$emit("change", this.visible);
    }, this.placementMap = { up: "top", down: "bottom" };
  }
  floatingUiChanged(Ae, xr) {
    xr || (this.positionStyles = void 0);
  }
  positionStylesChanged(Ae, xr) {
    Ae && this.$fastController.removeStyles(Ae), xr && this.$fastController.addStyles(xr);
  }
  connectedCallback() {
    super.connectedCallback(), this.floatingUi && DOM.queueUpdate(() => this.setPositioning());
  }
  show() {
    DOM.queueUpdate(() => this.setPositioning());
  }
  hide() {
    var Ae;
    this.visible = !1, (Ae = this.cleanup) == null || Ae.call(this);
  }
  getPlacement() {
    return this.alignment === "center" ? this.placementMap[this.direction] : `${this.placementMap[this.direction]}-${this.alignment}`;
  }
  setPositioning() {
    var ed, id;
    (ed = this.cleanup) == null || ed.call(this);
    const Ae = (id = this.buttonEl) == null ? void 0 : id[0], xr = this.floatingEl;
    if (!Ae || !xr) {
      this.hide();
      return;
    }
    this.cleanup = autoUpdate(Ae, this, async () => {
      const od = [shift()], ad = this.getPlacement();
      ad || od.unshift(flip());
      const { x: rd, y: sd } = await computePosition(Ae, xr, {
        placement: ad,
        strategy: "fixed",
        middleware: od
      });
      this.positionStyles = css`
        .popover {
          position: fixed;
          left: ${rd.toString()}px;
          top: ${sd.toString()}px;
        }
      `;
    });
  }
}
__decorateClass$12([
  attr({ mode: "boolean", attribute: "floating-ui" })
], Popover.prototype, "floatingUi", 2);
__decorateClass$12([
  observable
], Popover.prototype, "positionStyles", 2);
const tm1Popover = Popover.compose({
  baseName: "popover",
  template: tm1PopoverTemplate,
  styles: tm1PopoverStyles
});
designSystem.register(
  tm1Popover()
);
const tm1ActionGroupStyles = css`
  :host {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    column-gap: ${GDSESpacing300};
  }

  :host .content-container {
    flex: 1;
  }

  :host .actions-container {
    box-sizing: border-box;
    width: fit-content;
    display: flex;
    justify-content: flex-end;
    gap: ${GDSESpacing100};
  }

  :host .actions {
    gap: ${GDSESpacing100};
  }

  ::part(popover-overlay) {
    border: none;
    box-shadow: none;
    padding: 0;
  }

  :host([mobile]) {
    display: block;
  }

  :host([mobile]) .actions-container {
    width: 100%;
  }

  :host .select-all-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`, inputSizeSmall = cssPartial`
  --option-height: 29px;
  --padding: ${GDSESpacingInputVerS} ${GDSESpacingInputHorS};
`, inputSizeRegular = cssPartial`
  --option-height: 37px;
  --padding: ${GDSESpacingInputVerM} ${GDSESpacingInputHorM};
`, inputSizeLarge = cssPartial`
  --option-height: 41px;
  --padding: ${GDSESpacingInputVerL} ${GDSESpacingInputHorL};
`, tm1ListboxStyles = css`
  :host {
    background: ${GDSEColorSurfacePopover};
    border: 1px solid ${GDSEColorBorderInputDefault};
    border-radius: ${GDSERadiusInput};
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    padding: ${GDSESpacing50};
    min-width: 150px;
    --select-all: 0px;
    ${inputSizeRegular}
  }

  :host([input-size='small']),
  :host([inputsize='small']) {
    ${inputSizeSmall}
  }

  :host([input-size='large']),
  :host([inputsize='large']) {
    ${inputSizeLarge}
  }

  :host([enableSelectAll]) {
    --select-all: 41px;
  }

  :host([hidden]) {
    display: none !important;
  }

  :host(:focus-within:not([disabled])) {
    border-color: ${GDSEColorBorderFocus};
  }

  :host([theme='dark']) {
    border-color: ${GDSEColorSurfacePopover};
  }

  :host([disabled]) ::slotted(*) {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }

  :host([size]) {
    overflow-y: auto;
  }

  .listbox::-webkit-scrollbar {
    width: ${GDSESpacing100};
  }

  .listbox::-webkit-scrollbar-thumb {
    background-color: ${GDSEColorFillInput};
    border-radius: 6px;
    border: 2px solid ${GDSEColorFillInput};
  }

  .select-all {
    padding: ${GDSESpacingListVerS} calc(${GDSESpacingListHorS} - 4px); /* 4px is the checkbox padding */
    border-bottom: 1px solid ${GDSEColorBorder};
  }
`, tm1ListboxTemplate = (td) => html`
  <template
    aria-activedescendant="${(Ae) => Ae.ariaActiveDescendant}"
    aria-multiselectable="${(Ae) => Ae.ariaMultiSelectable}"
    role="listbox"
    style="--size: ${(Ae) => {
  var xr;
  return (xr = Ae.size) != null ? xr : 4;
}}; max-height: ${(Ae) => Ae.listboxHeight > 10 ? `${Ae.listboxHeight}px` : "none"};"
    tabindex="${(Ae) => Ae.disabled ? null : "0"}"
    theme="${(Ae) => Ae.theme}"
    @click="${(Ae, xr) => Ae.clickHandler(xr.event)}"
    @focusin="${(Ae, xr) => Ae.focusinHandler(xr.event)}"
    @keydown="${(Ae, xr) => Ae.keydownHandler(xr.event)}"
    @mousedown="${(Ae, xr) => Ae.mousedownHandler(xr.event)}"
  >
    <slot name="listbox-top"></slot>
    ${when((Ae) => Ae.enableSelectAll, html`
      <div class="select-all" data-testid="select-all">
        <${td.tagFor(Checkbox)}
          ?checked=${(Ae) => Ae.checked}
          ?indeterminate=${(Ae) => Ae.indeterminate}
          size="small"
          is-centered
          need-confirmation
          @click="${(Ae, xr) => Ae.handleSelectAll(xr.event)}"
        >
          ${(Ae) => Ae.selectAllText}
        </${td.tagFor(Checkbox)}>
      </div>
   `)}
    <slot
      ${slotted({
  filter: (Ae) => isListboxOption(Ae) && !Ae.hidden,
  flatten: !0,
  property: "slottedOptions"
})}
    ></slot>
    <slot name="listbox-bottom"></slot>
  </template>
`;
var __defProp$11 = Object.defineProperty, __getOwnPropDesc$11 = Object.getOwnPropertyDescriptor, __decorateClass$11 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$11(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$11(Ae, xr, id), id;
};
class Listbox extends ListboxElement {
  constructor() {
    super(...arguments), this.ariaMultiSelectable = "false", this.ariaActiveDescendant = "", this.isInsideElement = !1, this.selectAllText = "Select All", this.enableSelectAll = !1, this.inputSize = "regular", this.checked = !1, this.indeterminate = !1, this.hasDisabledOption = !1, this.theme = ThemeType.light, this.listboxHeight = 0, this.optionSizes = { small: 29, regular: 37, large: 41 }, this.optionHeaderSizes = { small: 25.5, regular: 34, large: 37.5 }, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this.setOptionsSelected = (Ae) => {
      this.options.forEach((xr) => {
        if (!xr.disabled) {
          const ed = Observable.getNotifier(xr);
          ed.unsubscribe(this, "selected"), xr.selected = Ae, ed.subscribe(this, "selected");
        }
      }), this.setSelectedOptions(), this.updateSelectAllState(), Ae ? this.$emit("select-all") : this.$emit("clear-all");
    };
  }
  getOptions() {
    var ed, id, od, ad;
    const Ae = (id = (ed = this.querySelectorAll("slot")[1]) == null ? void 0 : ed.assignedElements()) != null ? id : Array.from(this.children);
    let xr = [];
    return ((od = Ae[0]) == null ? void 0 : od.nodeName) === "TM1-OPTION" || ((ad = Ae[0]) == null ? void 0 : ad.nodeName) === "TM1-LIST-ITEM" ? xr = Ae : Ae.map((rd) => {
      var sd, nd, cd;
      rd.nodeName === "TM1-OPTIONS-GROUP" || rd.nodeName === "TM1-LIST-ITEMS-GROUP" ? xr = [...xr, ...(cd = ((sd = rd.shadowRoot) == null ? void 0 : sd.querySelectorAll("tm1-options-header")) || ((nd = rd.shadowRoot) == null ? void 0 : nd.querySelectorAll("tm1-list-items-header"))) != null ? cd : [], ...Array.from(rd.children)] : rd.nodeName === "SLOT" ? xr = Array.from(this.querySelectorAll('[role="option"]')) : xr = [...xr, rd];
    }), xr;
  }
  /**
   * @override
   * Add condition to FAST function to not interact with the tm1Select and tm1Combobox
   * */
  slottedOptionsChanged(Ae, xr) {
    if (this.hasDisabledOption = this.options.some((ed) => ed.disabled), this.options = xr.reduce((ed, id) => ((isListboxOption(id) || isListItem(id)) && ed.push(id), ed), []), this.options.length === 0 && (this.options = this.getOptions().filter((ed) => isListboxOption(ed) || isListItem(ed))), !this.isInsideElement) {
      const ed = `${this.options.length}`;
      this.options.forEach((id, od) => {
        id.id || (id.id = uniqueId("option-")), id.ariaPosInSet = `${od + 1}`, id.ariaSetSize = ed;
      }), this.$fastController.isConnected && (this.setSelectedOptions(), this.setDefaultSelectedOption());
    }
  }
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      this.enableSelectAll && this.checked && this.options.length > 0 && (this.hasDisabledOption = this.options.some((Ae) => Ae.disabled), this.setOptionsSelected(!0), this.hasDisabledOption && (this.indeterminate = !0)), this.listboxHeight = this.setMaxHeight(this.getOptions()), this.updateSelectAllState();
    });
  }
  /**
   * Handle changing the state of the select all checkbox when clicked
   *
   * @param e - the mouse event
   * @internal
   */
  handleSelectAll(Ae) {
    const xr = this.options.filter((id) => !id.disabled), ed = this.options.filter((id) => id.selected);
    this.checked = ed.length !== xr.length ? !0 : !Ae.target.checked, this.setOptionsSelected(this.checked);
  }
  /**
   * Handle action when clicking on an option
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(Ae) {
    super.clickHandler(Ae);
    const xr = Ae.composedPath().some((od) => od.nodeName === "TM1-OPTION" || od.nodeName === "TM1-LIST-ITEM"), ed = ["TM1-SELECT", "TM1-COMBOBOX"], id = Ae.composedPath().some((od) => ed.includes(od.nodeName));
    xr && this.enableSelectAll && this.updateSelectAllState(), !this.multiple && !id && this.options.forEach((od) => {
      od === Ae.target ? od.checked = !0 : od.checked = !1;
    });
  }
  /**
   * Handle changing the state of the select all checkbox
   *
   * @internal
   */
  updateSelectAllState() {
    DOM.queueUpdate(() => {
      setTimeout(() => {
        const Ae = this.options.every((ed) => ed.selected), xr = this.options.every((ed) => !ed.selected);
        Ae && !this.hasDisabledOption ? (this.checked = !0, this.indeterminate = !1, this.$emit("select-all")) : xr ? (this.checked = !1, this.indeterminate = !1) : (this.checked = !0, this.indeterminate = !0);
      }, 100);
    });
  }
  /**
   * @override
   * Keep this function empty to not manage in Fast and manage it in setOptionsSelected instead
   * */
  selectedOptionsChanged(Ae, xr) {
  }
  setMaxHeight(Ae = []) {
    var ed, id;
    let xr = 10;
    if (this.size && Ae && Ae.length > 0) {
      for (let od = 0; od < this.size; od++)
        if (Ae[od]) {
          const ad = getComputedStyle(Ae[od]).height.replace("px", "");
          +ad == 0 || ad === "auto" ? Ae[od].nodeName === "TM1-OPTIONS-HEADER" || Ae[od].nodeName === "TM1-LIST-ITEMS-HEADER" ? xr += this.optionHeaderSizes[(ed = this.inputSize) != null ? ed : "regular"] : xr += this.optionSizes[(id = this.inputSize) != null ? id : "regular"] : xr += +ad;
        }
    }
    return xr;
  }
  sortOptions() {
    this.options = this.options.sort((Ae, xr) => Ae.id > xr.id ? 1 : Ae.id < xr.id ? -1 : 0);
  }
  get activeOption() {
    return this.sortOptions(), this.options[this.activeIndex];
  }
  checkPreviousOption(Ae) {
    var id, od;
    this.options.forEach((ad) => ad.removeAttribute("hovered")), this.sortOptions();
    const xr = this.options.length - this.activeIndex - 1, ed = this.options.reverse();
    if ((id = ed[xr + 1]) != null && id.disabled) {
      const ad = ed.findIndex((rd, sd) => !rd.disabled && sd > xr);
      this.activeIndex = this.options.length - ad, this.checkPreviousAvailableOption(Ae);
    } else
      this.checkPreviousAvailableOption(Ae);
    (od = this.activeOption) == null || od.setAttribute("hovered", "");
  }
  checkNextOption(Ae) {
    var xr, ed;
    this.options.forEach((id) => id.removeAttribute("hovered")), this.sortOptions(), (xr = this.options[this.activeIndex + 1]) != null && xr.disabled ? (this.activeIndex = this.options.findIndex((id, od) => !id.disabled && od > this.activeIndex) - 1, this.checkNextAvailableOption(Ae)) : this.checkNextAvailableOption(Ae), (ed = this.activeOption) == null || ed.setAttribute("hovered", "");
  }
  checkNextAvailableOption(Ae) {
    Ae ? (this.rangeStartIndex === -1 && (this.rangeStartIndex = this.activeIndex), this.options.forEach((xr, ed) => {
      xr.checked = inRange(ed, this.rangeStartIndex, this.activeIndex);
    })) : this.uncheckAllOptions(), this.activeIndex += this.activeIndex < this.options.length - 1 ? 1 : 0, this.checkActiveIndex();
  }
  checkPreviousAvailableOption(Ae) {
    Ae ? (this.rangeStartIndex === -1 && (this.rangeStartIndex = this.activeIndex), this.checkedOptions.length === 1 && (this.rangeStartIndex += 1), this.options.forEach((xr, ed) => {
      xr.checked = inRange(ed, this.activeIndex, this.rangeStartIndex);
    })) : this.uncheckAllOptions(), this.activeIndex -= this.activeIndex > 0 ? 1 : 0, this.checkActiveIndex();
  }
}
__decorateClass$11([
  attr({ attribute: "aria-multiselectable" })
], Listbox.prototype, "ariaMultiSelectable", 2);
__decorateClass$11([
  attr({ attribute: "aria-activedescendant" })
], Listbox.prototype, "ariaActiveDescendant", 2);
__decorateClass$11([
  attr({ mode: "boolean" })
], Listbox.prototype, "isInsideElement", 2);
__decorateClass$11([
  attr({ attribute: "select-all-text" }),
  attr({ attribute: "selectalltext" })
], Listbox.prototype, "selectAllText", 2);
__decorateClass$11([
  attr({ attribute: "enable-select-all", mode: "boolean" }),
  attr({ attribute: "enableselectall", mode: "boolean" })
], Listbox.prototype, "enableSelectAll", 2);
__decorateClass$11([
  attr({ attribute: "input-size" }),
  attr({ attribute: "inputsize" })
], Listbox.prototype, "inputSize", 2);
__decorateClass$11([
  attr({ mode: "boolean" })
], Listbox.prototype, "checked", 2);
__decorateClass$11([
  observable
], Listbox.prototype, "indeterminate", 2);
__decorateClass$11([
  observable
], Listbox.prototype, "hasDisabledOption", 2);
__decorateClass$11([
  observable
], Listbox.prototype, "theme", 2);
__decorateClass$11([
  observable
], Listbox.prototype, "listboxHeight", 2);
const isListItem = (td) => td.nodeName === "TM1-LIST-ITEM", tm1Listbox = Listbox.compose({
  baseName: "listbox",
  baseClass: ListboxElement,
  template: tm1ListboxTemplate,
  styles: tm1ListboxStyles
});
designSystem.register(
  tm1Listbox()
);
const tm1ActionGroupTemplate = (td) => html`
  <template
    ?mobile=${(Ae) => Ae.isMobile}
    ?enable-select-all=${(Ae) => Ae.enableSelectAll}
    ?show-clear=${(Ae) => Ae.showClear}
    ?select-all-indeterminate=${(Ae) => Ae.selectAllIndeterminate}
    ?select-all-checked=${(Ae) => Ae.selectAllChecked}
  >
    ${when((Ae) => Ae.enableSelectAll, html`
      <div class="select-all-container">
        <${td.tagFor(Checkbox)}
          ${ref("selectAllCheckboxRef")}
          ?indeterminate="${(Ae) => Ae.selectAllIndeterminate}"
          ?checked="${(Ae) => Ae.selectAllChecked}"
          @change="${(Ae, xr) => Ae.selectAllHandler(xr.event)}"
        >
          ${(Ae) => Ae.selectAllText}
        </${td.tagFor(Checkbox)}>
        
        ${when((Ae) => Ae.showClear === !0, html`
          <${td.tagFor(Button)}
            variant="lightweight"
            @click="${(Ae, xr) => Ae.clearHandler(xr.event)}"
          >
            ${(Ae) => Ae.clearText}
          </${td.tagFor(Button)}>
        `)}
      </div>
    `)}
    <div class="content-container">
      <slot></slot>
    </div>
    <div class="actions-container" ${ref("actionsContainerRef")}>
      <slot name="actions" class="actions" ${slotted("slottedActions")}></slot>
      ${when((Ae) => Ae.hasKebabActions || Ae.forceKebab, html`
      <${td.tagFor(Popover)} alignment=${PopoverAlignment.end}>
        <${td.tagFor(Button)}
            slot="trigger"
            class="kebab-actions-button"
            variant="outline"
            iconPosition="only-icon"
            icon="kebab"
            aria-label="button-popover"
            close-on-click=${!0}
        ></${td.tagFor(Button)}>
        <${td.tagFor(Listbox)}>
          <slot name="kebab-actions" ${slotted("slottedKebabActions")}></slot>
        </${td.tagFor(Listbox)}>
        </${td.tagFor(Popover)}>`)}
    </div>
  </template>
`;
var __defProp$10 = Object.defineProperty, __getOwnPropDesc$10 = Object.getOwnPropertyDescriptor, __decorateClass$10 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$10(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$10(Ae, xr, id), id;
};
class ActionGroup extends FoundationElement {
  constructor() {
    super(...arguments), this.enableSelectAll = !1, this.showClear = !1, this.selectAllText = "Select all", this.clearText = "Clear selection", this.selectAllIndeterminate = !1, this.selectAllChecked = !1, this.forceKebab = !1, this.slottedActions = [], this.slottedKebabActions = [], this.hasKebabActions = !1, this.isMobile = !1, this.firstRender = !0, this.btnActions = [], this.kebabActions = [], this.filteredSlottedActions = [], this.validChild = ["TM1-BUTTON", "BUTTON"], this.hostSizeBehavior = new HostSizeBehavior(this, (Ae) => {
      DOM.queueUpdate(() => {
        if (Ae.contentRect.width < 550)
          this.isMobile = !0, this.filteredSlottedActions.length > 2 && this.filteredSlottedActions.slice(0, 2).forEach((ed) => {
            this.actionsContainerRef.clientWidth > Ae.contentRect.width && this.addKebabAction(ed);
          });
        else if (this.isMobile = !1, this.filteredSlottedActions.length < this.btnActions.length || !this.firstRender) {
          for (; this.lastChild && this.validChild.includes(this.lastChild.nodeName); )
            this.lastChild.remove();
          this.slottedKebabActions.forEach((xr) => {
            this.removeChild(xr);
          }), this.setActions();
        }
        this.firstRender = !1;
      });
    });
  }
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      var Ae, xr;
      if (((Ae = this.slottedActions) == null ? void 0 : Ae.length) > 0) {
        this.slottedActions.forEach((od) => {
          this.validChild.includes(od.nodeName) || this.removeChild(od);
        }), this.filteredSlottedActions = this.slottedActions.filter((od) => this.validChild.includes(od.nodeName)), ((xr = this.filteredSlottedActions) == null ? void 0 : xr.length) > 4 && (this.hasKebabActions = !0);
        const ed = [...this.filteredSlottedActions], id = ed.filter((od) => od.variant !== "solid");
        this.primaryBtns = ed.filter((od) => od.variant === "solid"), this.btnActions = this.primaryBtns ? id.slice(0, 4 - this.primaryBtns.length) : id.slice(0, 4), this.btnActions = [...this.btnActions, ...this.primaryBtns], this.kebabActions = this.primaryBtns ? id.slice(4 - this.primaryBtns.length, ed.length) : id.slice(3, id.length), this.setActions();
      }
    });
  }
  selectAllHandler(Ae) {
    const xr = Ae.target, ed = xr.indeterminate, id = xr.checked;
    (this.selectAllChecked !== id || this.selectAllIndeterminate !== ed) && (this.toggle(), this.$emit("select-all", Ae));
  }
  clearHandler(Ae) {
    this.toggle(!0), this.$emit("clear");
  }
  selectAllCheckedChanged(Ae, xr) {
    Ae !== xr && this.selectAllCheckboxRef && this.selectAllCheckboxRef.checked !== xr && (this.selectAllCheckboxRef.checked = xr);
  }
  selectAllIndeterminateChanged(Ae, xr) {
    Ae !== xr && this.selectAllCheckboxRef && this.selectAllCheckboxRef.indeterminate !== xr && (this.selectAllCheckboxRef.indeterminate = xr);
  }
  toggle(Ae = !1) {
    Ae ? (this.selectAllChecked = !1, this.selectAllIndeterminate = !1) : this.selectAllIndeterminate ? this.selectAllIndeterminate = !this.selectAllIndeterminate : this.selectAllChecked = !this.selectAllChecked;
  }
  setActions() {
    this.kebabActions.forEach((Ae) => {
      this.addKebabAction(Ae);
    }), this.btnActions.forEach((Ae) => {
      Ae && this.append(Ae);
    });
  }
  addKebabAction(Ae) {
    const xr = document.createElement("tm1-option");
    xr.innerText = Ae.innerText, xr.slot = "kebab-actions", xr.addEventListener("click", () => Ae.dispatchEvent(new Event("click"))), this.contains(Ae) && this.removeChild(Ae), this.contains(xr) || this.appendChild(xr);
  }
}
__decorateClass$10([
  attr({ mode: "boolean", attribute: "enableSelectAll" }),
  attr({ mode: "boolean", attribute: "enable-select-all" })
], ActionGroup.prototype, "enableSelectAll", 2);
__decorateClass$10([
  attr({ mode: "boolean", attribute: "showClear" }),
  attr({ mode: "boolean", attribute: "show-clear" })
], ActionGroup.prototype, "showClear", 2);
__decorateClass$10([
  attr({ attribute: "selectAllText" }),
  attr({ attribute: "select-all-text" })
], ActionGroup.prototype, "selectAllText", 2);
__decorateClass$10([
  attr({ attribute: "clearText" }),
  attr({ attribute: "clear-text" })
], ActionGroup.prototype, "clearText", 2);
__decorateClass$10([
  attr({ mode: "boolean", attribute: "selectAllIndeterminate" }),
  attr({ mode: "boolean", attribute: "select-all-indeterminate" })
], ActionGroup.prototype, "selectAllIndeterminate", 2);
__decorateClass$10([
  attr({ mode: "boolean", attribute: "selectAllChecked" }),
  attr({ mode: "boolean", attribute: "select-all-checked" })
], ActionGroup.prototype, "selectAllChecked", 2);
__decorateClass$10([
  attr({ mode: "boolean", attribute: "forceKebab" }),
  attr({ mode: "boolean", attribute: "force-kebab" })
], ActionGroup.prototype, "forceKebab", 2);
__decorateClass$10([
  observable
], ActionGroup.prototype, "selectAllCheckboxRef", 2);
__decorateClass$10([
  observable
], ActionGroup.prototype, "slottedActions", 2);
__decorateClass$10([
  observable
], ActionGroup.prototype, "slottedKebabActions", 2);
__decorateClass$10([
  observable
], ActionGroup.prototype, "hasKebabActions", 2);
__decorateClass$10([
  observable
], ActionGroup.prototype, "isMobile", 2);
__decorateClass$10([
  observable
], ActionGroup.prototype, "actionsContainerRef", 2);
const tm1ActionGroup = ActionGroup.compose({
  baseName: "action-group",
  template: tm1ActionGroupTemplate,
  styles: tm1ActionGroupStyles
});
designSystem.register(
  tm1ActionGroup()
);
const tm1AnchorStyles = () => css`
  :host .control,
  :host .content {
    display: inline-block;
  }

  :host([variant='hypertext']:not([isloading]):hover),
  :host([variant='hypertext']:hover) {
    text-decoration-color: ${GDSEColorTextPrimaryHovered};
    color: ${GDSEColorTextPrimaryHovered};
    background-color: transparent;
  }

  :host([variant='hypertext']) {
    text-decoration: underline !important;
    text-decoration-color: ${GDSEColorTextPrimary};
    background-color: transparent;
    color: ${GDSEColorTextPrimary};
  }

  :host([variant='hypertext']:not([isloading]):active),
  :host([variant='hypertext']:active) {
    text-decoration-color: ${GDSEColorTextPrimaryPressed};
    color: ${GDSEColorTextPrimaryPressed};
    background-color: transparent;
  }

  ${tm1ButtonStyles()}
`, tm1AnchorTemplate = (td, Ae) => {
  const xr = (ed) => ed.variant === "hypertext";
  return html`
    <a
      id="${(ed) => ed.id}"
      class="control"
      part="control"
      download="${(ed) => ed.download}"
      href="${(ed) => ed.href}"
      hreflang="${(ed) => ed.hreflang}"
      ping="${(ed) => ed.ping}"
      referrerpolicy="${(ed) => ed.referrerpolicy}"
      rel="${(ed) => ed.rel}"
      target="${(ed) => ed.target}"
      type="${(ed) => {
    var id;
    return (id = ed.type) != null ? id : "link";
  }}"
      aria-atomic="${(ed) => {
    var id;
    return (id = ed.ariaAtomic) != null ? id : !1;
  }}"
      aria-busy="${(ed) => {
    var id;
    return (id = ed.ariaBusy) != null ? id : !1;
  }}"
      aria-controls="${(ed) => ed.ariaControls}"
      aria-current="${(ed) => {
    var id;
    return (id = ed.ariaCurrent) != null ? id : null;
  }}"
      aria-describedby="${(ed) => ed.ariaDescribedby}"
      aria-details="${(ed) => ed.ariaDetails}"
      aria-disabled="${(ed) => {
    var id;
    return (id = ed.ariaDisabled) != null ? id : !1;
  }}"
      aria-expanded="${(ed) => ed.ariaExpanded}"
      aria-flowto="${(ed) => ed.ariaFlowto}"
      aria-haspopup="${(ed) => {
    var id;
    return (id = ed.ariaHaspopup) != null ? id : !1;
  }}"
      aria-hidden="${(ed) => {
    var id;
    return (id = ed.ariaHidden) != null ? id : !1;
  }}"
      aria-invalid="${(ed) => {
    var id;
    return (id = ed.ariaInvalid) != null ? id : !1;
  }}"
      aria-keyshortcuts="${(ed) => ed.ariaKeyshortcuts}"
      aria-label="${(ed) => {
    var id;
    return (id = ed.ariaLabel) != null ? id : "";
  }}"
      aria-labelledby="${(ed) => ed.ariaLabelledby}"
      aria-live="${(ed) => {
    var id;
    return (id = ed.ariaLive) != null ? id : "off";
  }}"
      aria-owns="${(ed) => ed.ariaOwns}"
      aria-relevant="${(ed) => {
    var id;
    return (id = ed.ariaRelevant) != null ? id : "additions text";
  }}"
      aria-roledescription="${(ed) => ed.ariaRoledescription}"
      ${ref("control")}
    >
      ${startSlotTemplate(td, Ae)}
      <tm1-typography type="${(ed) => {
    var id;
    return ed.textType[(id = ed.size) != null ? id : "regular"];
  }}" class="content ${(ed) => xr(ed) ? "hypertext" : ""}" part="content">
        <slot ${slotted("defaultSlottedContent")}></slot>
      </tm1-typography>
      ${endSlotTemplate(td, Ae)}
    </a>
  `;
};
var __defProp$$ = Object.defineProperty, __getOwnPropDesc$$ = Object.getOwnPropertyDescriptor, __decorateClass$$ = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$$(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$$(Ae, xr, id), id;
};
const AnchorVariant = {
  solid: "solid",
  lightweight: "lightweight",
  outline: "outline",
  hypertext: "hypertext"
}, AnchorTarget = {
  _self: "_self",
  _blank: "_blank",
  _parent: "_parent",
  _top: "_top"
};
class Anchor extends Anchor$1 {
  constructor() {
    super(...arguments), this.color = "primary", this.size = ButtonSize.regular, this.textType = {
      small: "label-button-s",
      regular: "label-button-m",
      large: "label-button-l"
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.variant === void 0 && (this.variant = "solid");
  }
  variantChanged(Ae, xr) {
    xr === "lightweight" && (this.textType = {
      small: "label-button-s-underline",
      regular: "label-button-m-underline",
      large: "label-button-l-underline"
    });
  }
}
__decorateClass$$([
  attr()
], Anchor.prototype, "variant", 2);
__decorateClass$$([
  attr()
], Anchor.prototype, "color", 2);
__decorateClass$$([
  attr()
], Anchor.prototype, "size", 2);
__decorateClass$$([
  observable
], Anchor.prototype, "textType", 2);
const tm1Anchor = Anchor.compose({
  baseName: "anchor",
  baseClass: Anchor$1,
  template: tm1AnchorTemplate,
  styles: tm1AnchorStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Anchor()
);
const tm1BadgeStyles = css`
  :host {
    display: block;
    border-radius: ${GDSERadiusInput};
    padding: ${GDSESpacingPillVerS} ${GDSESpacingPillHorS};
    border: 1px solid transparent;
    white-space: nowrap;
    width: fit-content;

    font-family: ${GDSEFontFamily};
    font-weight: ${GDSEFontWeightSemiBold};
    font-size: ${GDSEFontSize1};
    line-height: ${GDSELineHeightTitle};
    text-transform: ${GDSETextCaseUpper};
    letter-spacing: ${GDSELetterSpacing0};
    font-feature-settings: ${GDSEFontFeatureText};
  }

  :host([circular]) {
    border-radius: ${GDSERadiusPill};
    min-width: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :host([appearance='accent']) {
    background: ${GDSEColorTransparent};
    color: ${GDSEColorTextLight};
  }

  :host([appearance='accent'][baseColor='neutral']) {
    color: ${GDSEColorTextLight};
    border: 1px solid ${GDSEColorBorder};
  }

  :host([appearance='accent'][baseColor='new']) {
    color: ${GDSEColorTextInverse};
    background: ${GDSEColorFillInfo};
  }

  :host([appearance='accent'][baseColor='success']) {
    color: ${GDSEColorTextInverse};
    background: ${GDSEColorFillPositive};
  }

  :host([appearance='accent'][baseColor='error']) {
    color: ${GDSEColorTextInverseStatic};
    background: ${GDSEColorFillCritical};
  }

  :host([appearance='accent'][baseColor='caution']) {
    color: ${GDSEColorTextStatic};
    background: ${GDSEColorFillWarning};
  }

  /* To remove once the badge issue is fixed in events tag-mapping.ts */
  :host([appearance='accent'][baseColor='dark']) {
    color: ${GDSEColorTextInverseStatic};
    background: ${GDSEColorSurfaceInverse};
  }

  :host([appearance='accent'][baseColor='gray-02']) {
    color: ${GDSEColorTextInverseStatic};
    background: #999999;
  }

  :host([appearance='accent'][baseColor='gray-03']) {
    color: ${GDSEColorText};
    background: #bfbfbf;
  }

  :host([appearance='accent'][baseColor='accent-01']) {
    color: ${GDSEColorTextInverseStatic};
    background: #904eba;
  }
  /* ___________________________________________________________________ */

  :host([appearance='accent'][theme='dark']) {
    background: ${GDSEColorTransparent};
  }

  :host([appearance='accent'][baseColor='new'][theme='dark']) {
    color: ${GDSEColorTextInformation};
    border-color: ${GDSEColorBorderInformation};
  }

  :host([appearance='accent'][baseColor='success'][theme='dark']) {
    color: ${GDSEColorTextPositive};
    border-color: ${GDSEColorBorderPositive};
  }

  :host([appearance='accent'][baseColor='caution'][theme='dark']) {
    color: ${GDSEColorTextWarning};
    border-color: ${GDSEColorBorderWarning};
  }

  :host([appearance='accent'][baseColor='neutral'][theme='dark']) {
    color: ${GDSEColorTextLight};
    border-color: ${GDSEColorBorder};
  }

  :host([appearance='accent'][baseColor='error'][theme='dark']) {
    color: ${GDSEColorTextCritical};
    border-color: ${GDSEColorBorderCritical};
  }
`, tm1BadgeTemplate = (td) => html`
    <template
      appearance=${(Ae) => Ae.appearance}
      baseColor=${(Ae) => Ae.baseColor}
      ?circular=${(Ae) => Ae.circular}
      class="control ${(Ae) => Ae.className}"
      part="control"
      theme="${(Ae) => Ae.theme}"
    >
      <${td.tagFor(Typography)} type="label-status-m">
        <slot></slot>
      </${td.tagFor(Typography)}>
    </template>
  `;
var __defProp$_ = Object.defineProperty, __getOwnPropDesc$_ = Object.getOwnPropertyDescriptor, __decorateClass$_ = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$_(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$_(Ae, xr, id), id;
};
class Badge extends Badge$1 {
  constructor() {
    super(...arguments), this.appearance = "accent", this.baseColor = "neutral", this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
}
__decorateClass$_([
  attr()
], Badge.prototype, "appearance", 2);
__decorateClass$_([
  attr()
], Badge.prototype, "baseColor", 2);
__decorateClass$_([
  observable
], Badge.prototype, "theme", 2);
const tm1Badge = Badge.compose({
  baseName: "badge",
  baseClass: Badge$1,
  template: tm1BadgeTemplate,
  styles: tm1BadgeStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Badge()
);
const tm1AvatarStyles = (td) => css`
  :host {
    position: relative;
    height: var(--avatar-size, var(--avatar-size-default));
    width: var(--avatar-size, var(--avatar-size-default));
    --avatar-size-default: 32px;
    --avatar-text-size: 14px;
    --avatar-text-ratio: 4;
  }

  .link {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 100%;
  }

  .square {
    border-radius: ${GDSERadiusSurface};
    overflow: hidden;
    height: var(--avatar-size, var(--avatar-size-default));
    width: var(--avatar-size, var(--avatar-size-default));
  }

  .circle {
    border-radius: ${GDSERadiusPill};
    overflow: hidden;
    height: var(--avatar-size, var(--avatar-size-default));
    width: var(--avatar-size, var(--avatar-size-default));
  }

  .backplate {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .media,
  ::slotted(img) {
    max-width: 100%;
    position: absolute;
    display: block;
  }

  ::slotted(${td.tagFor(Badge)}) {
    position: absolute;
    display: block;
  }
`, tm1AvatarTemplate = (td, Ae) => html`
    <div
        class="backplate ${(xr) => {
  var ed;
  return (ed = xr.shape) != null ? ed : "";
}}"
        part="backplate"
        style="${(xr) => xr.fill ? `background-color: ${xr.fill};` : ""}"
    >
        <${td.tagFor(Typography)} type="body-m">
            <a
                class="link"
                part="link"
                role="link"
                href="${(xr) => xr.link ? xr.link : void 0}"
                style="${(xr) => xr.color ? `color: ${xr.color};` : ""}"
            >
                <slot name="media" part="media">${Ae.media || ""}</slot>
                <slot class="content" part="content"><slot>
            </a>
        </${td.tagFor(Typography)}>
    </div>
`;
var __defProp$Z = Object.defineProperty, __getOwnPropDesc$Z = Object.getOwnPropertyDescriptor, __decorateClass$Z = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$Z(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$Z(Ae, xr, id), id;
};
const AvatarShape = {
  circle: "circle",
  square: "square"
}, AvatarFill = {
  blue: "blue",
  pink: "pink",
  green: "green",
  orange: "orange",
  purple: "purple",
  aqua: "aqua",
  yellow: "yellow",
  gold: "gold",
  blueviolet: "blueviolet",
  lightpink: "lightpink",
  gray: "gray"
};
class Avatar extends Avatar$1 {
}
__decorateClass$Z([
  attr()
], Avatar.prototype, "src", 2);
__decorateClass$Z([
  attr()
], Avatar.prototype, "alt", 2);
const imgTemplate = html`${when(
  (td) => td.src,
  html`<img slot="media" class="media" part="media" :src=${(td) => td.src} :alt=${(td) => td.alt} />`
)} `, tm1Avatar = Avatar.compose({
  baseName: "avatar",
  baseClass: Avatar$1,
  template: tm1AvatarTemplate,
  styles: tm1AvatarStyles,
  media: imgTemplate,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Avatar()
);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1 = globalThis, e$2 = t$1.ShadowRoot && (t$1.ShadyCSS === void 0 || t$1.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s = Symbol(), o$2 = /* @__PURE__ */ new WeakMap();
let n$2 = class {
  constructor(Ae, xr, ed) {
    if (this._$cssResult$ = !0, ed !== s)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = Ae, this.t = xr;
  }
  get styleSheet() {
    let Ae = this.o;
    const xr = this.t;
    if (e$2 && Ae === void 0) {
      const ed = xr !== void 0 && xr.length === 1;
      ed && (Ae = o$2.get(xr)), Ae === void 0 && ((this.o = Ae = new CSSStyleSheet()).replaceSync(this.cssText), ed && o$2.set(xr, Ae));
    }
    return Ae;
  }
  toString() {
    return this.cssText;
  }
};
const r$3 = (td) => new n$2(typeof td == "string" ? td : td + "", void 0, s), i$2 = (td, ...Ae) => {
  const xr = td.length === 1 ? td[0] : Ae.reduce((ed, id, od) => ed + ((ad) => {
    if (ad._$cssResult$ === !0)
      return ad.cssText;
    if (typeof ad == "number")
      return ad;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + ad + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(id) + td[od + 1], td[0]);
  return new n$2(xr, td, s);
}, S = (td, Ae) => {
  if (e$2)
    td.adoptedStyleSheets = Ae.map((xr) => xr instanceof CSSStyleSheet ? xr : xr.styleSheet);
  else
    for (const xr of Ae) {
      const ed = document.createElement("style"), id = t$1.litNonce;
      id !== void 0 && ed.setAttribute("nonce", id), ed.textContent = xr.cssText, td.appendChild(ed);
    }
}, c$1 = e$2 ? (td) => td : (td) => td instanceof CSSStyleSheet ? ((Ae) => {
  let xr = "";
  for (const ed of Ae.cssRules)
    xr += ed.cssText;
  return r$3(xr);
})(td) : td;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: i$1, defineProperty: e$1, getOwnPropertyDescriptor: r$2, getOwnPropertyNames: h$1, getOwnPropertySymbols: o$1, getPrototypeOf: n$1 } = Object, a = globalThis, c = a.trustedTypes, l = c ? c.emptyScript : "", p = a.reactiveElementPolyfillSupport, d = (td, Ae) => td, u = { toAttribute(td, Ae) {
  switch (Ae) {
    case Boolean:
      td = td ? l : null;
      break;
    case Object:
    case Array:
      td = td == null ? td : JSON.stringify(td);
  }
  return td;
}, fromAttribute(td, Ae) {
  let xr = td;
  switch (Ae) {
    case Boolean:
      xr = td !== null;
      break;
    case Number:
      xr = td === null ? null : Number(td);
      break;
    case Object:
    case Array:
      try {
        xr = JSON.parse(td);
      } catch (ed) {
        xr = null;
      }
  }
  return xr;
} }, f$1 = (td, Ae) => !i$1(td, Ae), y = { attribute: !0, type: String, converter: u, reflect: !1, hasChanged: f$1 };
var y0, S0;
(y0 = Symbol.metadata) != null || (Symbol.metadata = Symbol("metadata")), (S0 = a.litPropertyMetadata) != null || (a.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class b extends HTMLElement {
  static addInitializer(Ae) {
    var xr;
    this._$Ei(), ((xr = this.l) != null ? xr : this.l = []).push(Ae);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(Ae, xr = y) {
    if (xr.state && (xr.attribute = !1), this._$Ei(), this.elementProperties.set(Ae, xr), !xr.noAccessor) {
      const ed = Symbol(), id = this.getPropertyDescriptor(Ae, ed, xr);
      id !== void 0 && e$1(this.prototype, Ae, id);
    }
  }
  static getPropertyDescriptor(Ae, xr, ed) {
    var ad;
    const { get: id, set: od } = (ad = r$2(this.prototype, Ae)) != null ? ad : { get() {
      return this[xr];
    }, set(rd) {
      this[xr] = rd;
    } };
    return { get() {
      return id == null ? void 0 : id.call(this);
    }, set(rd) {
      const sd = id == null ? void 0 : id.call(this);
      od.call(this, rd), this.requestUpdate(Ae, sd, ed);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(Ae) {
    var xr;
    return (xr = this.elementProperties.get(Ae)) != null ? xr : y;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d("elementProperties")))
      return;
    const Ae = n$1(this);
    Ae.finalize(), Ae.l !== void 0 && (this.l = [...Ae.l]), this.elementProperties = new Map(Ae.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d("finalized")))
      return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d("properties"))) {
      const xr = this.properties, ed = [...h$1(xr), ...o$1(xr)];
      for (const id of ed)
        this.createProperty(id, xr[id]);
    }
    const Ae = this[Symbol.metadata];
    if (Ae !== null) {
      const xr = litPropertyMetadata.get(Ae);
      if (xr !== void 0)
        for (const [ed, id] of xr)
          this.elementProperties.set(ed, id);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [xr, ed] of this.elementProperties) {
      const id = this._$Eu(xr, ed);
      id !== void 0 && this._$Eh.set(id, xr);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(Ae) {
    const xr = [];
    if (Array.isArray(Ae)) {
      const ed = new Set(Ae.flat(1 / 0).reverse());
      for (const id of ed)
        xr.unshift(c$1(id));
    } else
      Ae !== void 0 && xr.push(c$1(Ae));
    return xr;
  }
  static _$Eu(Ae, xr) {
    const ed = xr.attribute;
    return ed === !1 ? void 0 : typeof ed == "string" ? ed : typeof Ae == "string" ? Ae.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var Ae;
    this._$ES = new Promise((xr) => this.enableUpdating = xr), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (Ae = this.constructor.l) == null || Ae.forEach((xr) => xr(this));
  }
  addController(Ae) {
    var xr, ed;
    ((xr = this._$EO) != null ? xr : this._$EO = /* @__PURE__ */ new Set()).add(Ae), this.renderRoot !== void 0 && this.isConnected && ((ed = Ae.hostConnected) == null || ed.call(Ae));
  }
  removeController(Ae) {
    var xr;
    (xr = this._$EO) == null || xr.delete(Ae);
  }
  _$E_() {
    const Ae = /* @__PURE__ */ new Map(), xr = this.constructor.elementProperties;
    for (const ed of xr.keys())
      this.hasOwnProperty(ed) && (Ae.set(ed, this[ed]), delete this[ed]);
    Ae.size > 0 && (this._$Ep = Ae);
  }
  createRenderRoot() {
    var xr;
    const Ae = (xr = this.shadowRoot) != null ? xr : this.attachShadow(this.constructor.shadowRootOptions);
    return S(Ae, this.constructor.elementStyles), Ae;
  }
  connectedCallback() {
    var Ae, xr;
    (Ae = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (xr = this._$EO) == null || xr.forEach((ed) => {
      var id;
      return (id = ed.hostConnected) == null ? void 0 : id.call(ed);
    });
  }
  enableUpdating(Ae) {
  }
  disconnectedCallback() {
    var Ae;
    (Ae = this._$EO) == null || Ae.forEach((xr) => {
      var ed;
      return (ed = xr.hostDisconnected) == null ? void 0 : ed.call(xr);
    });
  }
  attributeChangedCallback(Ae, xr, ed) {
    this._$AK(Ae, ed);
  }
  _$EC(Ae, xr) {
    var od;
    const ed = this.constructor.elementProperties.get(Ae), id = this.constructor._$Eu(Ae, ed);
    if (id !== void 0 && ed.reflect === !0) {
      const ad = (((od = ed.converter) == null ? void 0 : od.toAttribute) !== void 0 ? ed.converter : u).toAttribute(xr, ed.type);
      this._$Em = Ae, ad == null ? this.removeAttribute(id) : this.setAttribute(id, ad), this._$Em = null;
    }
  }
  _$AK(Ae, xr) {
    var od;
    const ed = this.constructor, id = ed._$Eh.get(Ae);
    if (id !== void 0 && this._$Em !== id) {
      const ad = ed.getPropertyOptions(id), rd = typeof ad.converter == "function" ? { fromAttribute: ad.converter } : ((od = ad.converter) == null ? void 0 : od.fromAttribute) !== void 0 ? ad.converter : u;
      this._$Em = id, this[id] = rd.fromAttribute(xr, ad.type), this._$Em = null;
    }
  }
  requestUpdate(Ae, xr, ed) {
    var id;
    if (Ae !== void 0) {
      if (ed != null || (ed = this.constructor.getPropertyOptions(Ae)), !((id = ed.hasChanged) != null ? id : f$1)(this[Ae], xr))
        return;
      this.P(Ae, xr, ed);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(Ae, xr, ed) {
    var id;
    this._$AL.has(Ae) || this._$AL.set(Ae, xr), ed.reflect === !0 && this._$Em !== Ae && ((id = this._$Ej) != null ? id : this._$Ej = /* @__PURE__ */ new Set()).add(Ae);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (xr) {
      Promise.reject(xr);
    }
    const Ae = this.scheduleUpdate();
    return Ae != null && await Ae, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var ed, id;
    if (!this.isUpdatePending)
      return;
    if (!this.hasUpdated) {
      if ((ed = this.renderRoot) != null || (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [ad, rd] of this._$Ep)
          this[ad] = rd;
        this._$Ep = void 0;
      }
      const od = this.constructor.elementProperties;
      if (od.size > 0)
        for (const [ad, rd] of od)
          rd.wrapped !== !0 || this._$AL.has(ad) || this[ad] === void 0 || this.P(ad, this[ad], rd);
    }
    let Ae = !1;
    const xr = this._$AL;
    try {
      Ae = this.shouldUpdate(xr), Ae ? (this.willUpdate(xr), (id = this._$EO) == null || id.forEach((od) => {
        var ad;
        return (ad = od.hostUpdate) == null ? void 0 : ad.call(od);
      }), this.update(xr)) : this._$EU();
    } catch (od) {
      throw Ae = !1, this._$EU(), od;
    }
    Ae && this._$AE(xr);
  }
  willUpdate(Ae) {
  }
  _$AE(Ae) {
    var xr;
    (xr = this._$EO) == null || xr.forEach((ed) => {
      var id;
      return (id = ed.hostUpdated) == null ? void 0 : id.call(ed);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(Ae)), this.updated(Ae);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(Ae) {
    return !0;
  }
  update(Ae) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((xr) => this._$EC(xr, this[xr]))), this._$EU();
  }
  updated(Ae) {
  }
  firstUpdated(Ae) {
  }
}
var v0;
b.elementStyles = [], b.shadowRootOptions = { mode: "open" }, b[d("elementProperties")] = /* @__PURE__ */ new Map(), b[d("finalized")] = /* @__PURE__ */ new Map(), p == null || p({ ReactiveElement: b }), ((v0 = a.reactiveElementVersions) != null ? v0 : a.reactiveElementVersions = []).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class h extends b {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var xr, ed;
    const Ae = super.createRenderRoot();
    return (ed = (xr = this.renderOptions).renderBefore) != null || (xr.renderBefore = Ae.firstChild), Ae;
  }
  update(Ae) {
    const xr = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(Ae), this.o = Q$1(xr, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var Ae;
    super.connectedCallback(), (Ae = this.o) == null || Ae.setConnected(!0);
  }
  disconnectedCallback() {
    var Ae;
    super.disconnectedCallback(), (Ae = this.o) == null || Ae.setConnected(!1);
  }
  render() {
    return R$1;
  }
}
var D0;
h._$litElement$ = !0, h.finalized = !0, (D0 = globalThis.litElementHydrateSupport) == null || D0.call(globalThis, { LitElement: h });
const f = globalThis.litElementPolyfillSupport;
f == null || f({ LitElement: h });
var C0;
((C0 = globalThis.litElementVersions) != null ? C0 : globalThis.litElementVersions = []).push("4.1.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const o = { attribute: !0, type: String, converter: u, reflect: !1, hasChanged: f$1 }, r$1 = (td = o, Ae, xr) => {
  const { kind: ed, metadata: id } = xr;
  let od = globalThis.litPropertyMetadata.get(id);
  if (od === void 0 && globalThis.litPropertyMetadata.set(id, od = /* @__PURE__ */ new Map()), od.set(xr.name, td), ed === "accessor") {
    const { name: ad } = xr;
    return { set(rd) {
      const sd = Ae.get.call(this);
      Ae.set.call(this, rd), this.requestUpdate(ad, sd, td);
    }, init(rd) {
      return rd !== void 0 && this.P(ad, void 0, td), rd;
    } };
  }
  if (ed === "setter") {
    const { name: ad } = xr;
    return function(rd) {
      const sd = this[ad];
      Ae.call(this, rd), this.requestUpdate(ad, sd, td);
    };
  }
  throw Error("Unsupported decorator location: " + ed);
};
function n(td) {
  return (Ae, xr) => typeof xr == "object" ? r$1(td, Ae, xr) : ((ed, id, od) => {
    const ad = id.hasOwnProperty(od);
    return id.constructor.createProperty(od, ad ? { ...ed, wrapped: !0 } : ed), ad ? Object.getOwnPropertyDescriptor(id, od) : void 0;
  })(td, Ae, xr);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r(td) {
  return n({ ...td, state: !0, attribute: !1 });
}
const tm1BadgeV2Styles = i$2`
  :host {
    display: block;
    border-radius: var(--gdse-s-radius-input);
    padding: var(--gdse-s-spacing-pill-ver-s) var(--gdse-s-spacing-pill-hor-s);
    border: 1px solid transparent;
    white-space: nowrap;
    width: fit-content;
  }

  :host([type='tag']) {
    border-radius: var(--gdse-s-radius-pill);
    min-width: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :host([variant='draft']) {
    color: var(--gdse-s-color-text);
    background-color: var(--gdse-s-color-fill-draft);
  }
  
  :host([variant='active']) {
    color: var(--gdse-s-color-text-info-strong);
    background-color: var(--gdse-s-color-fill-info-light-strong);
  }
  
  :host([variant='positive']) {
    color: var(--gdse-s-color-text-positive-strong);
    background-color: var(--gdse-s-color-fill-positive-light-strong);
  }
  
  :host([variant='critical']) {
    color: var(--gdse-s-color-text-critical-strong);
    background-color: var(--gdse-s-color-fill-critical-light-strong);
  }
  
  :host([variant='attention']) {
    color: var(--gdse-s-color-text-warning-strong);
    background-color: var(--gdse-s-color-fill-warning-light-strong);
  }
  
  :host([variant='neutral']),
  :host([variant='general']) {
    color: var(--gdse-s-color-text);
    border: 1px solid var(--gdse-s-color-border-neutral);
  }
  
  :host([variant='update']) {
    color: var(--gdse-s-color-text-onfill);
    background-color: var(--gdse-s-color-fill-info);
  }

  .text {
    text-transform: uppercase;
  }
`;
var __defProp$Y = Object.defineProperty, __getOwnPropDesc$Y = Object.getOwnPropertyDescriptor, __decorateClass$Y = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$Y(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$Y(Ae, xr, id), id;
};
const BadgeV2Variant = {
  draft: "draft",
  active: "active",
  positive: "positive",
  critical: "critical",
  attention: "attention",
  neutral: "neutral",
  update: "update",
  general: "general"
}, BadgeV2Type = {
  status: "status",
  tag: "tag"
}, n0 = class n0 extends h {
  constructor() {
    super(...arguments), this.variant = BadgeV2Variant.draft, this.type = BadgeV2Type.status;
  }
  render() {
    return ke$1`
      <div class="control" part="control">
        <tm1-typography class="text" type="label-status-m">
          <slot></slot>
        </tm1-typography>
      </div>
    `;
  }
};
n0.styles = tm1BadgeV2Styles;
let BadgeV2 = n0;
__decorateClass$Y([
  n({ reflect: !0 })
], BadgeV2.prototype, "variant", 2);
__decorateClass$Y([
  n({ reflect: !0 })
], BadgeV2.prototype, "type", 2);
customElements.get("tm1-badge-v2") || customElements.define("tm1-badge-v2", BadgeV2);
const tm1BannerStyles = () => css`
  :host .banner {
    color: ${GDSEColorText};
    font-family: ${GDSEFontFamily};
    padding: ${GDSESpacing200};
    position: relative;
    border: 1px solid ${GDSEColorBorderInfo};
    border-radius: ${GDSERadiusSurface};
    display: flex;
    overflow: hidden;
    background-color: ${GDSEColorFillInfoLight};
    line-height: ${GDSELineHeightTitle};
    font-size: ${GDSEFontSize3};
  }

  :host([open]) {
    opacity: 1;
    visibility: visible;
  }

  :host(:not([open])) .banner {
    animation: hideBanner 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) forwards;
  }

  @keyframes hideBanner {
    0% {
      opacity: 1;
    }
    99.9% {
      opacity: 0;
    }
    100% {
      display: none;
      opacity: 0;
      visibility: hidden;
    }
  }

  :host([theme='legacy']) .banner,
  :host([theme='light']) .banner {
    background-color: ${GDSEColorFillInfoLight};
    border: 1px solid ${GDSEColorBorderInfo};
  }

  :host([variant='success']) .banner,
  :host([theme='legacy'][variant='success']) .banner,
  :host([theme='light'][variant='success']) .banner {
    background-color: ${GDSEColorFillPositiveLight};
    border-color: ${GDSEColorBorderPositive};
  }

  :host([variant='error']) .banner,
  :host([theme='legacy'][variant='error']) .banner,
  :host([theme='light'][variant='error']) .banner {
    background-color: ${GDSEColorFillCriticalLight};
    border-color: ${GDSEColorBorderCritical};
  }

  :host([variant='caution']) .banner,
  :host([theme='legacy'][variant='caution']) .banner,
  :host([theme='light'][variant='caution']) .banner {
    background-color: ${GDSEColorFillWarningLight};
    border-color: ${GDSEColorBorderWarning};
  }

  :host([theme='dark']) .banner {
    background-color: ${GDSEColorSurfacePopover};
    border-color: ${GDSEColorSurfacePopover};
  }

  :host .control {
    padding: ${GDSESpacing150} !important ;
  }

  :host([closable]) .icon {
    position: absolute;
    right: calc(${GDSESpacing200} - 8px);
    cursor: pointer;
  }

  :host([closable]) tm1-disclosure.empty ~ .icon {
    top: calc(50% - 12px);
  }

  :host([closable]) :not(tm1-disclosure.empty) ~ .icon {
    top: calc(${GDSESpacing200} - 4px);
  }

  :host tm1-button {
    --text-color: ${GDSEColorTextLight};
    --text-color-hovered: ${GDSEColorTextLight};
    --text-color-focus: ${GDSEColorTextLight};
    --text-color-pressed: ${GDSEColorText};
    --background-color-hovered: ${GDSEColorFillHovered};
    --background-color-focus: ${GDSEColorFillHovered};
    --background-color-pressed: ${GDSEColorFillPressed};
  }
`, tm1DisclosureStyles = () => css`
  :host {
    display: flex;
  }

  .icon {
    padding: ${GDSESpacing0} ${GDSESpacing150} ${GDSESpacing0} ${GDSESpacing0};
    height: 24px;
  }

  :host(.empty) .disclosure-content {
    padding-top: ${GDSESpacing0} !important;
  }

  :host .link {
    cursor: pointer;
    text-decoration: none;
    color: ${GDSEColorTextPrimary};
  }

  :host .link:hover {
    color: ${GDSEColorTextPrimaryHovered};
  }

  .summary {
    list-style-type: none;
    display: flex;
    flex-direction: column;
  }

  :host([display='row']) .summary {
    flex-direction: row;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    padding-top: 3px;
  }

  .invoker {
    cursor: pointer;
    color: ${GDSEColorTextPrimary};
  }

  :host([display='row']) .content-title {
    padding-right: ${GDSESpacing100};
  }

  .disclosure .invoker::-webkit-details-marker {
    display: none;
  }

  :host([appearance='lightweight']) .invoker {
    background: transparent;
    color: ${GDSEColorTextPrimary};
    cursor: pointer;
    width: max-content;
  }

  :host([appearance='lightweight']) .invoker:active {
    color: ${GDSEColorTextPrimaryPressed};
  }

  :host([appearance='lightweight']) .invoker:hover {
    color: ${GDSEColorTextPrimaryHovered};
  }

  .disclosure {
    transition: max-height 0.7s linear;
    max-height: 65px;
  }


  :host([closable]) summary   {
    padding-right: calc(${GDSESpacingActionIconS} + ${GDSESpacing250});
  }

  .disclosure[open] {
    max-height: 1000px;
  }

  .disclosure[disabled] {
    pointer-events: none;
  }

  :host(:not([title=''])) .disclosure-content {
    padding-top: ${GDSESpacing100};
  }

  :host([title='']) .disclosure-content {
    padding-right: ${GDSESpacing400};
  }

  details summary::-webkit-details-marker {
    display: none;
  }

  :host([icon='info']) tm1-icon,
  :host([icon='infoSolid']) tm1-icon {
    color:  ${GDSEColorFillInfo};
  }

  :host([icon='success']) tm1-icon,
  :host([icon='successSolid']) tm1-icon {
    color: ${GDSEColorFillPositive};
  }

  :host([icon='alert']) tm1-icon,
  :host([icon='alertSolid']) tm1-icon {
    color: ${GDSEColorFillWarning};
  }

  :host([icon='error']) tm1-icon,
  :host([icon='errorSolid']) tm1-icon {
    color: ${GDSEColorFillCritical};
  }
`, tm1DisclosureTemplate = (td) => html`
    <div part="diclosure-icon" class="icon">${when((Ae) => !!Ae.icon, iconTemplate(td))}</div>
    <div class="content">
      <details class="disclosure" ${ref("details")} ?disabled="${(Ae) => !Ae.link}" data-testid="details">
        <summary class="summary">
          ${when(
  (Ae) => Ae.title,
  html`<${td.tagFor(Typography)} type="heading-s">
              <span data-testid="title" class="content-title">${(Ae) => Ae.title}</span>
            </${td.tagFor(Typography)}>`
)}

          <${td.tagFor(Typography)} type="label-button-l">
            ${when(
  (Ae) => Ae.link,
  html`
                <a @click="${(Ae, xr) => Ae.linkClickHandler(xr.event)}" data-testid="link" class="link">
                  ${(Ae) => Ae.linkText ? Ae.linkText : Ae.link}
                </a>
              `
)}
          </${td.tagFor(Typography)}>
        </summary>
        <div class="disclosure-content">
          <${td.tagFor(Typography)} type="body-m">
            <slot ${slotted({ property: "content", filter: whitespaceFilter })}></slot>
          </${td.tagFor(Typography)}>
        </div>
      </details>
    </div>
  `, iconTemplate = (td) => html` <${td.tagFor(Icon)} icon="${(Ae) => Ae.icon}" size="regular" />`;
var __defProp$X = Object.defineProperty, __getOwnPropDesc$X = Object.getOwnPropertyDescriptor, __decorateClass$X = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$X(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$X(Ae, xr, id), id;
};
const DisclosureDisplay = {
  column: "column",
  row: "row"
}, DisclosureAppearance = {
  accent: "accent",
  lightweight: "lightweight"
};
class Disclosure extends Disclosure$1 {
  constructor() {
    super(), this.display = "column", this.icon = "", this.title = "", this.linkText = "Click here", this.setContentClass = () => {
      var Ae, xr, ed;
      this.content && ((Ae = this.parentElement) != null && Ae.role) && this.parentElement.role !== "alert" && (((xr = this.content) == null ? void 0 : xr.length) === 0 || ((ed = this.content[0]) == null ? void 0 : ed.nodeName) === "SLOT" ? this.classList.add("empty") : this.classList.remove("empty"));
    }, this.height = 0, this.totalHeight = 0;
  }
  get disclosureHeight() {
    return this.expanded ? this.totalHeight : this.height;
  }
  linkClickHandler(Ae) {
    this.$emit("link-click", Ae), this.link && window.open(this.link, "_blank");
  }
  connectedCallback() {
    super.connectedCallback(), this.appearance || (this.appearance = "lightweight"), this.details.open = !0;
  }
  contentChanged() {
    this.setContentClass();
  }
}
__decorateClass$X([
  observable
], Disclosure.prototype, "content", 2);
__decorateClass$X([
  attr()
], Disclosure.prototype, "display", 2);
__decorateClass$X([
  attr()
], Disclosure.prototype, "icon", 2);
__decorateClass$X([
  attr()
], Disclosure.prototype, "title", 2);
__decorateClass$X([
  attr()
], Disclosure.prototype, "link", 2);
__decorateClass$X([
  attr({ attribute: "link-text" }),
  attr({ attribute: "linktext" })
], Disclosure.prototype, "linkText", 2);
const tm1Disclosure = Disclosure.compose({
  baseName: "disclosure",
  baseClass: Disclosure,
  template: tm1DisclosureTemplate,
  styles: tm1DisclosureStyles
}), tm1BannerTemplate = (td) => html`
  <template theme="${(Ae) => Ae.theme}">
    <div role="alert" class="banner">
      <${td.tagFor(Disclosure)}
        display="row"
        icon="${(Ae) => Ae.icon}"
        title="${(Ae) => Ae.title}"
        link="${(Ae) => Ae.link}"
        linkText="${(Ae) => Ae.linkText}"
        ?closable="${(Ae) => Ae.closable}"
        @link-click="${(Ae, xr) => Ae.linkClickHandler(xr.event)}"
        data-testid="disclosure"
        ${ref("disclosure")}
      >
        <slot ${slotted({ property: "content", filter: whitespaceFilter })}></slot>
      </${td.tagFor(Disclosure)}>
      ${when(
  (Ae) => Ae.closable,
  html`
          <${td.tagFor(Button)}
            data-testid="close-button"
            class="icon"
            size="small"
            variant="lightweight"
            icon="close"
            iconPosition="only-icon"
            @click="${(Ae, xr) => Ae.requestClose(xr.event)}"
          />
        `
)}
    </div>
  </template>
  `;
var __defProp$W = Object.defineProperty, __getOwnPropDesc$W = Object.getOwnPropertyDescriptor, __decorateClass$W = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$W(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$W(Ae, xr, id), id;
};
const BannerVariant = {
  caution: "caution",
  error: "error",
  success: "success",
  info: "info"
};
class Banner extends FoundationElement {
  constructor() {
    super(...arguments), this.closable = !1, this.linkText = "Click here", this.open = !0, this.hidden = !1, this.title = "", this.theme = ThemeType.light, this.icon = "infoSolid", this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.updateIcon();
  }
  variantChanged(Ae, xr) {
    Ae !== xr && this.updateIcon();
  }
  themeChanged() {
    this.updateIcon();
  }
  requestClose(Ae) {
    this.open = !1, this.$emit("close", Ae);
  }
  linkClickHandler(Ae) {
    Ae.stopPropagation(), this.$emit("link-click", Ae);
  }
  updateIcon() {
    switch (this.variant) {
      case "success":
        this.icon = this.theme === "dark" ? "successFilled" : "successSolid";
        break;
      case "caution":
        this.icon = this.theme === "dark" ? "warningFilled" : "alertSolid";
        break;
      case "error":
        this.icon = this.theme === "dark" ? "errorFilled" : "errorSolid";
        break;
      default:
        this.icon = this.theme === "dark" ? "infoFilled" : "infoSolid";
    }
  }
  contentChanged() {
    var Ae, xr, ed;
    this.content && ((Ae = this.content) == null ? void 0 : Ae.length) > 0 ? (xr = this.disclosure) == null || xr.classList.remove("empty") : (ed = this.disclosure) == null || ed.classList.add("empty");
  }
}
__decorateClass$W([
  attr({ mode: "boolean" })
], Banner.prototype, "closable", 2);
__decorateClass$W([
  attr()
], Banner.prototype, "link", 2);
__decorateClass$W([
  attr({ attribute: "link-text" }),
  attr({ attribute: "linktext" })
], Banner.prototype, "linkText", 2);
__decorateClass$W([
  attr({ mode: "boolean" })
], Banner.prototype, "open", 2);
__decorateClass$W([
  attr({ mode: "boolean" })
], Banner.prototype, "hidden", 2);
__decorateClass$W([
  attr()
], Banner.prototype, "title", 2);
__decorateClass$W([
  attr()
], Banner.prototype, "variant", 2);
__decorateClass$W([
  observable
], Banner.prototype, "theme", 2);
__decorateClass$W([
  observable
], Banner.prototype, "icon", 2);
__decorateClass$W([
  observable
], Banner.prototype, "content", 2);
__decorateClass$W([
  observable
], Banner.prototype, "disclosure", 2);
const tm1Banner = Banner.compose({
  baseName: "banner",
  template: tm1BannerTemplate,
  styles: tm1BannerStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Banner(),
  tm1Disclosure()
);
const TooltipPosition = {
  bottom: "bottom",
  left: "left",
  right: "right",
  top: "top"
}, TooltipVariant = {
  dark: "dark",
  light: "light"
}, tm1TooltipStyles = css`
  /** Fast story styles */
  :host {
    position: fixed;
    visibility: hidden;
  }

  :host([hidden]) {
    display: none;
  }

  :host([visible]) {
    transition:
      visibility 0s 0s linear,
      opacity 50ms 0.5s linear;
    opacity: 1;
    visibility: visible;
  }

  :host(:not([visible])),
  :host([visible='false']) {
    transition:
      visibility 0s 0.5s,
      opacity 50ms linear;
    opacity: 0;
    visibility: hidden;
  }

  :host([show='true'][visible]) {
    transition: none;
  }

  /** Custom styles */
  :host {
    overflow: visible;
    z-index: ${GDSEZIndexTooltip};
  }

  .tooltip {
    border-radius: ${GDSERadiusSurface};
    background: ${GDSEColorSurfaceTooltip};
    color: ${GDSEColorTextOnfill};
    padding: ${GDSESpacingTooltipVerM} ${GDSESpacingTooltipHorM};
    height: max-content;
    width: max-content;
    display: block;
    max-width: 288px;
    pointer-events: none;
    display: block;
  }

  :host([theme='dark']) .tooltip {
    background: ${GDSEColorSurfaceInverse};
    color: ${GDSEColorTextInverseStatic};
  }

  @keyframes animate-visibility {
    from {
      visibility: hidden;
    }
    to {
      visibility: visible;
    }
  }

  @keyframes animate-tooltip-top {
    from {
      transform: translateY(10px);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes animate-tooltip-bottom {
    from {
      transform: translateY(-10px);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes animate-tooltip-right {
    from {
      transform: translateX(-10px);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes animate-tooltip-left {
    from {
      transform: translateX(10px);
    }
    to {
      transform: translateX(0);
    }
  }

  .arrow {
    position: absolute;
  }

  :host([position='top']) .arrow,
  :host([position='bottom']) .arrow,
  :host([position='left']) .arrow,
  :host([position='right']) .arrow {
    content: '';
    width: 12px;
    height: 12px;
    background: ${GDSEColorSurfaceTooltip};
    position: absolute;
    z-index: calc(${GDSEZIndexTooltip} + 1);
  }

  :host([theme='dark']):host([position='top']) .arrow,
  :host([theme='dark']):host([position='bottom']) .arrow,
  :host([theme='dark']):host([position='left']) .arrow,
  :host([theme='dark']):host([position='right']) .arrow {
    background: ${GDSEColorSurfaceInverse};
  }

  :host([position='top']) .arrow {
    transform: rotate(225deg);
    bottom: 6px;
    animation: animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='top']) .tooltip {
    margin-bottom: ${GDSESpacing150};
    animation:
      animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
      animate-tooltip-top 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='bottom']) .arrow {
    transform: rotate(45deg);
    top: 6px;
    animation: animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='bottom']) .tooltip {
    margin-top: ${GDSESpacing150};
    animation:
      animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
      animate-tooltip-bottom 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='left']) .arrow {
    transform: rotate(135deg);
    right: 6px;
    animation: animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='left']) .tooltip {
    margin-right: ${GDSESpacing150};
    animation:
      animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
      animate-tooltip-left 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='right']) .arrow {
    transform: rotate(-45deg);
    left: 6px;
    animation: animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  :host([position='right']) .tooltip {
    margin-left: ${GDSESpacing150};
    animation:
      animate-visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
      animate-tooltip-right 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`, tooltipTemplate$1 = (td) => html`
    <template
      aria-describedby="tooltip"
      aria-haspopup="true"
      aria-expanded="${(Ae) => {
  var xr;
  return (xr = Ae.visible) != null ? xr : !1;
}}"
      ?visible="${(Ae) => {
  var xr;
  return (xr = Ae.visible) != null ? xr : !1;
}}"
      ?hidden="${(Ae) => !Ae.visible}"
      theme="${(Ae) => Ae.theme}"
    >
      <div id="tooltip" role="tooltip" class="tooltip" part="tooltip">
        <${td.tagFor(Typography)} type="body-m">
          <slot></slot>
        </${td.tagFor(Typography)}>
      </div>
      <div class="arrow" ${ref("arrow")}></div>
    </template>
  `;
var __defProp$V = Object.defineProperty, __getOwnPropDesc$V = Object.getOwnPropertyDescriptor, __decorateClass$V = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$V(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$V(Ae, xr, id), id;
};
let Tooltip$1 = class extends FoundationElement {
  constructor() {
    super(...arguments), this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this._visible = !1, this.anchorElement = null, this.controlledVisibility = !1, this.focusoutAnchorHandler = () => {
      !this.controlledVisibility && this._visible && this.hideTooltip();
    }, this.focusinAnchorHandler = () => {
      !this.controlledVisibility && !this._visible && this.showTooltip();
    }, this.keydownDocumentHandler = (Ae) => {
      if (!Ae.defaultPrevented && this._visible)
        switch (Ae.key) {
          case keyEscape: {
            this.dismiss();
            break;
          }
        }
    }, this.mouseoverAnchorHandler = () => {
      var Ae;
      (Ae = document.activeElement) != null && Ae.isSameNode(this.anchorElement) || this.showTooltip();
    }, this.mouseoutAnchorHandler = (Ae) => {
      var xr;
      !((xr = document.activeElement) != null && xr.isSameNode(this.anchorElement)) && !this.isSameNode(Ae.relatedTarget) && this.hideTooltip();
    }, this.position = TooltipPosition.bottom, this.positionStyles = void 0;
  }
  /**
   * Removes listeners from the previous anchor element and updates the anchor element reference.
   *
   * @param _prev - the previous anchor string
   * @param next - the current anchor string
   *
   * @internal
   */
  anchorChanged(Ae, xr) {
    this.$fastController.isConnected && (this.removeListeners(), this.removeAnchorAriaDescribedBy(this.id), this.anchorElement = this.getAnchorElement(xr), this.addAnchorAriaDescribedBy(), this.controlledVisibility || this.addListeners());
  }
  /**
   * Switches between controlled and uncontrolled visibility.
   *
   * @param _prev - the previous forced visibility state
   * @param next - the current forced visibility state
   * @internal
   */
  controlledVisibilityChanged(Ae, xr) {
    if (!xr) {
      this.addListeners(), this.hideTooltip();
      return;
    }
    this.removeListeners();
  }
  idChanged(Ae, xr) {
    this.removeAnchorAriaDescribedBy(Ae), DOM.queueUpdate(() => {
      this.addAnchorAriaDescribedBy();
    });
  }
  /**
   * Updates the styles for the tooltip position.
   *
   * @param prev - the previous placement styles
   * @param next - the current placement styles
   *
   * @internal
   */
  positionStylesChanged(Ae, xr) {
    Ae && this.$fastController.removeStyles(Ae), xr && this.$fastController.addStyles(xr);
  }
  visibleChanged(Ae, xr) {
    this.setVisible(xr);
  }
  /**
   * Returns the current visibility of the tooltip.
   * @public
   */
  get show() {
    return this._visible;
  }
  /**
   * Sets the forced visibility state and shows or hides the tooltip.
   *
   * @internal
   */
  setVisible(Ae) {
    if (this.controlledVisibility = typeof Ae == "boolean", this.controlledVisibility && (this.visible = Ae), Ae) {
      this.showTooltip();
      return;
    }
    this.hideTooltip();
  }
  /**
   * Adds the `id` of the tooltip to the `aria-describedby` attribute of the anchor element.
   *
   * @internal
   */
  addAnchorAriaDescribedBy() {
    var xr;
    if (!this.id) {
      this.id = uniqueId("tooltip-");
      return;
    }
    if (!this.anchorElement)
      return;
    const Ae = (xr = this.anchorElement.getAttribute("aria-describedby")) == null ? void 0 : xr.concat(" ", this.id).trim();
    Ae && this.anchorElement.setAttribute("aria-describedby", Ae);
  }
  /**
   * Adds event listeners to the anchor element, the tooltip element, and the document.
   *
   * @internal
   */
  addListeners() {
    this.anchorElement && (this.anchorElement.addEventListener("focusin", this.focusinAnchorHandler), this.anchorElement.addEventListener("focusout", this.focusoutAnchorHandler), this.anchorElement.addEventListener("mouseout", this.mouseoutAnchorHandler), this.anchorElement.addEventListener("mouseover", this.mouseoverAnchorHandler), this.addEventListener("mouseout", this.mouseoutAnchorHandler), this.addEventListener("mouseover", this.mouseoverAnchorHandler), document.addEventListener("keydown", this.keydownDocumentHandler));
  }
  connectedCallback() {
    super.connectedCallback(), this.anchorChanged(void 0, this.anchor);
  }
  /**
   * Hides the tooltip and emits a custom `dismiss` event.
   *
   * @internal
   */
  dismiss() {
    this.hideTooltip(), this.$emit("dismiss");
  }
  /**
   * Hides the tooltip.
   *
   * @internal
   */
  hideTooltip() {
    var Ae;
    this._visible = !1, (Ae = this.cleanup) == null || Ae.call(this);
  }
  /**
   * Gets the anchor element by id.
   *
   * @param id - the id of the anchor element
   *
   * @internal
   */
  getAnchorElement(Ae = "") {
    const xr = this.getRootNode();
    return xr instanceof ShadowRoot ? xr.getElementById(Ae) : document.getElementById(Ae);
  }
  /**
   * Removes the `id` of the tooltip from the `aria-describedby` attribute of the anchor element.
   *
   * @param id - the id of the tooltip
   *
   * @internal
   */
  removeAnchorAriaDescribedBy(Ae) {
    var xr;
    if (this.anchorElement) {
      const ed = (xr = this.anchorElement.getAttribute("aria-describedby")) == null ? void 0 : xr.split(" ");
      this.anchorElement.setAttribute(
        "aria-describedby",
        (ed != null ? ed : []).filter((id) => id !== Ae).join(" ")
      ), this.anchorElement.getAttribute("aria-describedby") === "" && this.anchorElement.removeAttribute("aria-describedby");
    }
  }
  /**
   * Removes event listeners from the anchor element, the tooltip element, and the document.
   *
   * @internal
   */
  removeListeners() {
    this.anchorElement && (this.anchorElement.removeEventListener("focusin", this.focusinAnchorHandler), this.anchorElement.removeEventListener("focusout", this.focusoutAnchorHandler), this.anchorElement.removeEventListener("mouseout", this.mouseoutAnchorHandler), this.anchorElement.removeEventListener("mouseover", this.mouseoverAnchorHandler), this.removeEventListener("mouseout", this.mouseoutAnchorHandler), this.removeEventListener("mouseover", this.mouseoverAnchorHandler), document.removeEventListener("keydown", this.keydownDocumentHandler));
  }
  /**
   * Sets the tooltip position.
   *
   * @public
   */
  setPositioning() {
    var xr;
    if ((xr = this.cleanup) == null || xr.call(this), !this.anchorElement) {
      this.hideTooltip();
      return;
    }
    const Ae = this.anchorElement;
    this.cleanup = autoUpdate(Ae, this, async () => {
      const ed = [shift(), arrow({ element: this.arrow })];
      this.position || ed.unshift(flip());
      const { x: id, y: od, middlewareData: ad } = await computePosition(Ae, this, {
        placement: this.position,
        strategy: "fixed",
        middleware: ed
      });
      if (this.positionStyles = css`
        :host {
          position: fixed;
          left: ${id.toString()}px;
          top: ${od.toString()}px;
        }
      `, ad.arrow) {
        const { x: rd, y: sd } = ad.arrow;
        Object.assign(this.arrow.style, {
          left: rd != null ? `${rd}px` : "",
          top: sd != null ? `${sd}px` : ""
        });
      }
    });
  }
  /**
   * Shows the tooltip.
   *
   * @internal
   */
  showTooltip() {
    this._visible = !0, DOM.queueUpdate(() => this.setPositioning());
  }
};
__decorateClass$V([
  observable
], Tooltip$1.prototype, "theme", 2);
__decorateClass$V([
  observable
], Tooltip$1.prototype, "_visible", 2);
__decorateClass$V([
  attr({ attribute: "anchor" })
], Tooltip$1.prototype, "anchor", 2);
__decorateClass$V([
  observable
], Tooltip$1.prototype, "controlledVisibility", 2);
__decorateClass$V([
  attr
], Tooltip$1.prototype, "id", 2);
__decorateClass$V([
  attr
], Tooltip$1.prototype, "position", 2);
__decorateClass$V([
  observable
], Tooltip$1.prototype, "positionStyles", 2);
__decorateClass$V([
  attr({
    mode: "boolean"
  })
], Tooltip$1.prototype, "visible", 2);
const tm1Tooltip = Tooltip$1.compose({
  baseName: "tooltip",
  template: tooltipTemplate$1,
  styles: tm1TooltipStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Tooltip()
);
const tm1CalendarStyles = css`
  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  select {
    border: none;
    background-color: ${GDSEColorSurfacePopover};
    color: ${GDSEColorText};
    font-family: ${semanticFonts.GDSETypographyTitleListMFontFamily};
    font-size: ${semanticFonts.GDSETypographyTitleListMFontSize};
    font-weight: ${semanticFonts.GDSETypographyTitleListMFontWeight};
    line-height: ${semanticFonts.GDSETypographyTitleListMLineHeight};
    letter-spacing: ${semanticFonts.GDSETypographyTitleListMLetterSpacing};
    font-feature: auto;
    text-transform: initial;
    text-decoration: initial;
  }

  :host([theme='dark']) select {
    background-color: ${GDSEColorSurfaceModal};
  }

  tm1-button[hidden] {
    visibility: hidden;
  }

  :host([borderless]) select {
    background-color: transparent;
  }

  .calendar {
    width: 280px;
    padding: ${GDSESpacing200};
    border-radius: ${GDSERadiusSurface};
    border: 1px solid ${GDSEColorBorderPopover};
    background-color: ${GDSEColorSurfacePopover};
  }

  :host([theme='dark']) .calendar {
    background-color: ${GDSEColorSurfaceModal};
  }

  :host([borderless]) .calendar {
    border: none;
    padding: ${GDSESpacing0};
    background-color: transparent;
  }

  .calendar__header {
    display: flex;
    justify-content: space-between;
    gap: ${GDSESpacing100};
    margin-bottom: ${GDSESpacing150};
  }

  .header__date {
    display: flex;
    gap: ${GDSESpacing150};
    color: ${GDSEColorText};
  }

  .calendar__weekdays,
  .calendar__days {
    display: flex;
  }

  .weekdays__weekday,
  .days__day {
    width: 40px;
    height: 36px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${GDSEColorText};
    border-radius: ${GDSERadiusSurface};
  }

  .calendar__days {
    display: flex;
    flex-wrap: wrap;
  }

  .days__day {
    cursor: pointer;
    position: relative;
  }

  .days__day:hover, .range {
    background-color: ${GDSEColorFillHovered};
  }

  .days__day:focus {
    outline: 2px solid ${GDSEColorBorderFocus};
    outline-offset: 1px;
  }

  :host([theme='dark']) .days__day:hover,
  :host([theme='dark']) .range {
    background-color: ${GDSEColorSurfacePopover};
  }

  .days__day:active {
    background-color: ${GDSEColorFillPressed};
  }

  .today::after {
    content: '';
    background-color: ${GDSEColorFillPrimarySelected};
    height: 4px;
    width: 12px;
    position: absolute;
    bottom: 2px;
    border-radius: ${GDSERadiusPill};
  }

  .selected, .start-range, .end-range {
    background-color: ${GDSEColorFillSelected};
    color: ${GDSEColorTextOnfillStrong};
  }

  :host([theme='dark']) .selected,
  :host([theme='dark']) .start-range,
  :host([theme='dark']) .end-range {
    background-color: ${GDSEColorFillPrimary};
    color: ${GDSEColorText};
  }

  .selected:hover, .start-range:hover, .end-range:hover {
    background-color: transparent;
    outline: 2px solid ${GDSEColorBorderFocus};
    outline-offset: 1px;
    color: ${GDSEColorText};
    z-index: 2;
  }

  .selected:hover {
    border-radius: 7px;
  }

  .disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: ${GDSEColorTextDisabled};
  }

  .anchor {
    background-color: ${GDSEColorFillPrimarySelected};
    height: 4px;
    width: 4px;
    border-radius: ${GDSERadiusPill};
    position: absolute;
    top: 2px;
  }

  .start-range {
    border-radius: ${GDSEBorderRadius50} 0 0 ${GDSEBorderRadius50};
  }

  .range {
    border-radius: 0;
  }

  .end-range {
    border-radius: 0 ${GDSEBorderRadius50} ${GDSEBorderRadius50} 0;
  }

  :host tm1-button {
    --text-color: ${GDSEColorTextLight};
    --text-color-hovered: ${GDSEColorTextLight};
    --text-color-focus: ${GDSEColorTextLight};
    --text-color-pressed: ${GDSEColorText};
    --background-color-hovered: ${GDSEColorFillHovered};
    --background-color-focus: ${GDSEColorFillHovered};
    --background-color-pressed: ${GDSEColorFillPressed};
  }
`, tm1CalendarTemplate = (td) => html`
  <template theme=${(Ae) => Ae.theme}>
    <div class="calendar">
      <div class="calendar__header">
        <${td.tagFor(Button)}
          variant="lightweight"
          size="small"
          iconPosition="only-icon"
          icon="back"
          ?disabled=${(Ae) => Ae.isPrevBtnDisabled}
          ?hidden=${(Ae) => Ae.fixed && Ae.order === "second"}
          aria-hidden=${(Ae) => Ae.fixed && Ae.order === "second"}
          @click=${(Ae) => Ae.goToPrevMonth()}
        >
        </${td.tagFor(Button)}>

        <div class="header__date">
        ${when((Ae) => !Ae.fixed, html`
          <select @change=${(Ae, xr) => Ae.setMonth(xr.event)} ${ref("monthSelectRef")} data-testid="month-select">
          ${repeat(
  (Ae) => Ae.months,
  html`
            <option value=${(Ae) => Ae.value} ?selected=${(Ae, xr) => xr.parent.isSelectedMonth(Ae.value)} role="option" data-testid="month">
              ${(Ae) => Ae.name}
            </option>
          `
)}
        </select>

        <select @change=${(Ae, xr) => Ae.setYear(xr.event)} ${ref("yearSelectRef")} data-testid="year-select">
        ${repeat(
  (Ae) => Ae.years,
  html`
            <option value=${(Ae) => Ae.value} ?selected=${(Ae, xr) => xr.parent.isSelectedYear(Ae)} role="option" data-testid="year">
              ${(Ae) => Ae}
            </option>
          `
)}
        </select>`)}
        ${when((Ae) => Ae.fixed, html`<${td.tagFor(Typography)} type="title-list-m" data-testid="month">${(Ae) => {
  var xr;
  return (xr = Ae.getSelectedMonth()) == null ? void 0 : xr.name;
}}</${td.tagFor(Typography)}><${td.tagFor(Typography)} type="title-list-m">${(Ae) => Ae.year}</${td.tagFor(Typography)}>`)}
        </div>

        <${td.tagFor(Button)}
          variant="lightweight"
          size="small"
          iconPosition="only-icon"
          icon="forward"
          ?disabled=${(Ae) => Ae.isNextBtnDisabled}
          ?hidden=${(Ae) => Ae.fixed && Ae.order === "first"}
          aria-hidden=${(Ae) => Ae.fixed && Ae.order === "first"}
          @click=${(Ae) => Ae.goToNextMonth()}
        >
        </${td.tagFor(Button)}>
      </div>

      <div class="calendar__weekdays">
        ${repeat(
  (Ae) => Ae.weekdays,
  html`
            <div class="weekdays__weekday" data-testid="weekday">
              <${td.tagFor(Typography)} type="body-m">
                ${(Ae) => Ae}
              </${td.tagFor(Typography)}>
            </div>
          `
)}
      </div>

      <div class="calendar__days">
        ${repeat(
  (Ae) => Ae.calendarDays,
  html`
            <button class="days__day" @click=${(Ae, xr) => xr.parent.handleClickDate(Ae, xr.event)} data-testid="day">
              <${td.tagFor(Typography)} type="body-m">
                ${(Ae) => Ae}
              </${td.tagFor(Typography)}>
            </button>
          `
)}
      </div>
    </div>
  </template>
`;
var __defProp$U = Object.defineProperty, __getOwnPropDesc$U = Object.getOwnPropertyDescriptor, __decorateClass$U = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$U(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$U(Ae, xr, id), id;
};
const WeekdayType = {
  long: "long",
  short: "short",
  narrow: "narrow"
}, MonthType = {
  numeric: "numeric",
  "2-digit": "2-digit",
  long: "long",
  short: "short",
  narrow: "narrow"
}, CalendarOrder = {
  first: "first",
  second: "second"
};
class Calendar extends FoundationElement {
  constructor() {
    super(...arguments), this.today = /* @__PURE__ */ new Date(), this.firstRender = !0, this.month = this.today.getUTCMonth(), this.year = this.today.getUTCFullYear(), this.format = "DD/MM/YYYY", this.multiple = !1, this.range = !1, this.fixed = !1, this.order = CalendarOrder.first, this.disabledDates = [], this.maxDate = "", this.minDate = "", this.selectedDates = [], this.highlightDates = [], this.startYear = this.year - 1, this.endYear = this.year + 10, this.keepTimezone = !1, this.borderless = !1, this.isInDatePicker = !1, this.isInDateTimePicker = !1, this.lang = "en_US", this.nbDays = 0, this.months = this.getMonths("en"), this.days = [], this.years = [], this.weekdays = [], this.isPrevBtnDisabled = !1, this.isNextBtnDisabled = !1, this.calendarDays = [], this.theme = ThemeType.light, this._disabledDates = [], this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
  connectedCallback() {
    var Ae, xr, ed, id;
    super.connectedCallback(), this.lang = language.getLanguage(this), this.month = (Ae = this.month) != null ? Ae : this.getTimezoneMonth(this.today), this.year = (xr = this.year) != null ? xr : this.getTimezoneYear(this.today), this.endYear = (ed = this.endYear) != null ? ed : this.year + 10, this.months = this.getMonths(this.lang), this.years = this.getYears(), this.weekdays = this.getWeekdays(this.lang), this.nbDays = this.getNbDays(), this.format = (id = this.format) != null ? id : "DD/MM/YYYY", this.setDays(this.nbDays), DOM.queueUpdate(() => {
      this.updateStyleDates(), this.setToday(), this.setBtnDisabled(), this.firstRender = !1;
    });
  }
  startYearChanged() {
    this.years = this.getYears();
  }
  endYearChanged() {
    this.years = this.getYears();
  }
  monthChanged(Ae, xr) {
    this.nbDays = this.getNbDays(), this.monthSelectRef && (this.monthSelectRef.value = xr.toString()), Ae !== xr && (this.month = +xr), this.setDays(this.nbDays), this.setToday(), this.setBtnDisabled(), DOM.queueUpdate(() => {
      this.updateStyleDates();
    });
  }
  yearChanged(Ae, xr) {
    this.nbDays = this.getNbDays(), this.yearSelectRef && (this.yearSelectRef.value = xr.toString()), this.setDays(this.nbDays), this.setToday(), this.setBtnDisabled(), DOM.queueUpdate(() => {
      this.updateStyleDates();
    });
  }
  selectedDateChanged(Ae, xr) {
    DOM.queueUpdate(() => {
      if (!this.firstRender)
        if (this.selectedDate && Ae !== xr) {
          const { isValid: ed } = isValidDate(xr, this.format, this.keepTimezone);
          ed ? this.setDateStyle([formatDate(this.selectedDate, this.format, this.keepTimezone)], "selected") : this.setDateStyle([], "selected"), this.$emit("change", this.selectedDate);
        } else
          Ae !== xr && (this.setDateStyle([], "selected"), this.$emit("change", this.selectedDate));
    });
  }
  selectedDatesChanged(Ae, xr) {
    this.multiple ? (this.selectedDates = this.setElement(this.selectedDates), this.$emit("change", this.selectedDates)) : this.range && JSON.stringify(Ae) !== JSON.stringify(xr) && this.$emit("change", { start: this.rangeStartDate, end: this.rangeEndDate });
  }
  highlightDatesChanged() {
    this.highlightDates = this.setElement(this.highlightDates);
  }
  disabledDatesChanged(Ae, xr) {
    this.disabledDates = this.setElement(this.disabledDates), Ae !== xr && this.updateDisabledDates();
  }
  setHours(Ae, xr = "start") {
    this.keepTimezone ? xr === "start" ? Ae == null || Ae.setHours(0, 0, 0, 0) : Ae == null || Ae.setHours(23, 59, 59, 0) : xr === "start" ? Ae == null || Ae.setUTCHours(0, 0, 0, 0) : Ae == null || Ae.setUTCHours(23, 59, 59, 0);
  }
  rangeStartDateChanged(Ae, xr) {
    this.range && this.rangeStartDate && this.rangeEndDate && Ae !== xr ? this.updateRangeDates() : this.range && this.rangeStartDate && !this.rangeEndDate ? (this.setRangeDateStyle([]), this.setDateStyle([formatDate(this.rangeStartDate, this.format, this.keepTimezone)], "selected")) : this.setRangeDateStyle([]);
  }
  rangeEndDateChanged(Ae, xr) {
    this.range && this.rangeStartDate && this.rangeEndDate && Ae !== xr ? this.updateRangeDates() : this.range && this.rangeStartDate && !this.rangeEndDate && (this.setRangeDateStyle([]), this.setDateStyle([formatDate(this.rangeStartDate, this.format, this.keepTimezone)], "selected"));
  }
  minDateChanged(Ae, xr) {
    Ae !== xr && this.updateDisabledDates();
  }
  maxDateChanged(Ae, xr) {
    Ae !== xr && this.updateDisabledDates();
  }
  getWeekdays(Ae = "en-US", xr = WeekdayType.narrow) {
    const { format: ed } = new Intl.DateTimeFormat(Ae.replace("_", "-"), { weekday: xr });
    return [...Array(7).keys()].map((id) => ed(new Date(2024, 0, id)));
  }
  getMonths(Ae = "en-US", xr = MonthType.long) {
    const { format: ed } = new Intl.DateTimeFormat(Ae.replace("_", "-"), { month: xr });
    return [...Array(12).keys()].map((id) => ({ name: ed(new Date(2024, id, 1)), value: id }));
  }
  setMonth(Ae) {
    this.month = +Ae.target.value;
  }
  setYear(Ae) {
    this.year = +Ae.target.value;
  }
  getNbDays() {
    return new Date(this.year, this.month + 1, 0).getDate();
  }
  setDays(Ae) {
    this.$fastController.isConnected && Ae ? this.calendarDays = [...Array(Ae).keys()].map((xr) => xr + 1) : this.calendarDays = [];
  }
  getYears() {
    const Ae = [];
    for (let xr = this.startYear; xr <= this.endYear; xr++)
      Ae.push(xr);
    return Ae;
  }
  setToday() {
    this.$fastController.isConnected && (this.setDateStyle([this.today], "today"), this.setFirstDayStyle(this.days[0]));
  }
  isSelectedMonth(Ae) {
    var xr;
    return ((xr = this.months.find((ed) => +ed.value == +this.month)) == null ? void 0 : xr.value) === Ae;
  }
  getSelectedMonth() {
    return this.months.find((Ae) => +Ae.value == +this.month);
  }
  isSelectedYear(Ae) {
    return this.years.find((xr) => +xr == +this.year) === Ae;
  }
  setBtnDisabled() {
    var Ae, xr;
    this.year && ((Ae = this.months) != null && Ae.length) && ((xr = this.years) != null && xr.length) && (this.isPrevBtnDisabled = this.month === this.months[0].value && this.year === this.years[0], this.isNextBtnDisabled = this.month === this.months[11].value && this.year === this.years[10]);
  }
  goToPrevMonth() {
    +this.month == 0 ? (this.year = +this.year - 1, this.month = 11, this.$emit("year-change", this.year)) : this.month = +this.month - 1, this.$emit("month-change", this.month);
  }
  goToNextMonth() {
    +this.month == 11 && this.order === CalendarOrder.first ? (this.year = +this.year + 1, this.month = 0, this.$emit("year-change", this.year)) : +this.month == 0 && this.order === CalendarOrder.second ? this.$emit("year-change", this.year) : this.month = +this.month + 1, this.$emit("month-change", this.month);
  }
  setElement(Ae) {
    return Ae && typeof Ae == "string" ? Ae.includes("[") && !Ae.includes("object") || this.isInDatePicker ? JSON.parse(Ae) : Ae.split(",") : Ae;
  }
  updateStyleDates() {
    var Ae;
    this.days = Array.from((Ae = this.shadowRoot) == null ? void 0 : Ae.querySelectorAll(".days__day")), this.updateMultipleDates(), this.updateDisabledDates(), this.updateHighlightDates(), this.range && this.rangeStartDate && this.rangeEndDate ? this.updateRangeDates() : this.range && this.rangeStartDate && !this.rangeEndDate && this.setDateStyle([formatDate(this.rangeStartDate, this.format, this.keepTimezone)], "selected");
  }
  updateMultipleDates() {
    var Ae;
    if (this.multiple) {
      this.selectedDates = this.setElement(this.selectedDates);
      const xr = (Ae = this.selectedDates) == null ? void 0 : Ae.map((ed) => formatDate(ed, this.format, this.keepTimezone));
      this.setDateStyle(xr, "selected");
    } else
      this.selectedDate && this.setDateStyle([formatDate(this.selectedDate, this.format, this.keepTimezone)], "selected");
  }
  isDateAvailable(Ae = [], xr) {
    return Ae.length > 0 && (Ae == null ? void 0 : Ae.find((ed) => ed.toISOString() === xr.toISOString())) === void 0 || Ae.length === 0;
  }
  updateDisabledDates() {
    var ed, id, od;
    let Ae, xr;
    if (this.disabledDates && typeof this.disabledDates == "object") {
      const ad = (ed = this.disabledDates) == null ? void 0 : ed.filter((cd) => typeof cd == "string").map((cd) => formatDate(cd, this.format, this.keepTimezone)), rd = (id = this.disabledDates) == null ? void 0 : id.filter((cd) => typeof cd == "object" && cd.from && cd.to), sd = (od = this.disabledDates) == null ? void 0 : od.filter((cd) => typeof cd == "object" && !cd.from && !cd.to).map((cd) => formatDate(cd, this.format, this.keepTimezone)), nd = [];
      rd.length > 0 && rd.forEach((cd) => {
        this.createDisabledDatesArray(cd).forEach((ld) => {
          this.isDateAvailable(nd, ld) && nd.push(ld);
        });
      }), this._disabledDates = [...ad, ...sd, ...nd], this.setDateStyle([...ad, ...sd, ...nd], "disabled");
    } else if (this.disabledDates) {
      const ad = [];
      let rd = [];
      this.isInDatePicker && (rd = JSON.parse(this.disabledDates)), this.isInDateTimePicker && (rd = JSON.parse(rd)), rd.length > 0 ? (rd == null || rd.forEach((sd) => {
        ad.push(formatDate(sd, this.format, this.keepTimezone));
      }), this._disabledDates = [...ad], this.setDateStyle([...ad], "disabled")) : this._disabledDates = [];
    }
    this.minDate && (Ae = formatDate(this.minDate, this.format, this.keepTimezone)), this.maxDate && (xr = formatDate(this.maxDate, this.format, this.keepTimezone)), this.setDisabledDateStyle({ maxDate: xr, minDate: Ae });
  }
  updateHighlightDates() {
    var Ae;
    if (this.highlightDates.length > 0 && typeof this.highlightDates == "object") {
      const xr = (Ae = this.highlightDates) == null ? void 0 : Ae.map((ed) => ({ date: formatDate(ed.date, this.format, this.keepTimezone), text: ed.text }));
      this.setHighlightDates(xr);
    }
  }
  updateRangeDates() {
    const Ae = formatDate(this.rangeStartDate, this.format, this.keepTimezone), xr = formatDate(this.rangeEndDate, this.format, this.keepTimezone);
    this.selectedDates = [];
    const ed = [];
    for (this.setHours(Ae), this.setHours(xr, "end"); Ae <= xr; )
      ed.push(new Date(Ae)), this.selectedDates.push(Ae.toISOString()), Ae.setDate(Ae.getDate() + 1);
    this.isInDatePicker && this.setHours(ed[ed.length - 1], "end"), this.setRangeDateStyle(ed);
  }
  createDisabledDatesArray(Ae) {
    var od;
    const xr = formatDate(Ae.from, this.format, this.keepTimezone), ed = formatDate(Ae.to, this.format, this.keepTimezone), id = [];
    for (this.setHours(xr), this.setHours(ed, "end"); xr <= ed; )
      id.push(new Date(xr)), xr.setDate(xr.getDate() + ((od = Ae.interval) != null ? od : 1));
    return id;
  }
  handleClickDate(Ae, xr) {
    var id, od;
    xr.stopPropagation();
    const ed = this.keepTimezone ? new Date(this.year, this.month, Ae).toISOString() : new Date(Date.UTC(this.year, this.month, Ae)).toISOString();
    if (this.multiple) {
      this.selectedDates = this.setElement(this.selectedDates);
      const ad = (id = this.selectedDates) == null ? void 0 : id.map((sd) => formatDate(sd, this.format, this.keepTimezone).toISOString());
      if (ad.includes(ed)) {
        const sd = ad.findIndex((nd) => nd === ed);
        this.selectedDates.splice(sd, 1);
      } else
        this.selectedDates.push(ed);
      const rd = (od = this.selectedDates) == null ? void 0 : od.map((sd) => formatDate(sd, this.format, this.keepTimezone));
      this.setDateStyle(rd, "selected");
    } else if (this.range)
      if (!this.rangeStartDate || this.rangeStartDate && this.rangeEndDate)
        (this.rangeStartDate && this.rangeEndDate || !this.rangeStartDate && this.rangeEndDate) && (this.rangeEndDate = ""), this.rangeStartDate = ed, this.removeStyle(), this.setDateStyle([new Date(ed)], "selected"), this.$emit("change", this.rangeStartDate);
      else {
        const ad = formatDate(this.rangeStartDate, this.format, this.keepTimezone), rd = formatDate(ed, this.format, this.keepTimezone);
        ad <= rd ? (this.rangeEndDate = ed, this.selectedDates = [], this.updateRangeDates()) : (this.rangeStartDate = ed, this.setDateStyle([new Date(ed)], "selected"), this.$emit("change", this.rangeStartDate));
      }
    else
      this.selectedDate = ed, this.setDateStyle([new Date(this.selectedDate)], "selected");
  }
  setFirstDayStyle(Ae) {
    const xr = new Date(this.year, +this.month, 1).getDay();
    Ae && (Ae.style.marginLeft = xr !== -1 ? `${xr * 40}px` : "0px");
  }
  setDateStyle(Ae, xr) {
    var ed;
    (ed = this.days) == null || ed.forEach((id) => {
      var rd, sd;
      const od = (sd = (rd = id.textContent) == null ? void 0 : rd.trim()) != null ? sd : "1", ad = Ae == null ? void 0 : Ae.find((nd) => this.getTimezoneDate(nd).toString() === od && this.getTimezoneMonth(nd) === +this.month);
      if (ad) {
        const nd = this.getTimezoneYear(ad) === +this.year;
        id.classList.toggle(xr, nd);
      } else
        id.classList.remove(xr);
    });
  }
  setDisabledDateStyle({ minDate: Ae, maxDate: xr }) {
    var ed;
    (ed = this.days) == null || ed.forEach((id) => {
      var rd, sd;
      const od = (sd = (rd = id.textContent) == null ? void 0 : rd.trim()) != null ? sd : "1", ad = (nd, cd) => {
        if (nd) {
          const ud = this.getTimezoneMonth(nd), ld = this.getTimezoneYear(nd), dd = this.getTimezoneDate(nd), pd = formatDate(this.minDate, this.format, this.keepTimezone).toISOString(), md = formatDate(this.maxDate, this.format, this.keepTimezone).toISOString(), fd = ud === +this.month, bd = ld === +this.year, Sd = formatDate(new Date(this.year, this.month, +od).toISOString(), this.format, this.keepTimezone);
          fd && bd ? cd(+od, +dd) ? id.classList.add("disabled") : this.isDateAvailable(this._disabledDates, Sd) && this.minDate && Sd.toISOString() > pd && this.maxDate && Sd.toISOString() < md && id.classList.remove("disabled") : cd(+this.month, ud) && ld === +this.year || cd(this.year, ld) ? id.classList.add("disabled") : this.isDateAvailable(this._disabledDates, Sd) || id.classList.remove("disabled");
        }
      };
      ad(Ae, (nd, cd) => nd < cd), ad(xr, (nd, cd) => nd > cd);
    });
  }
  setRangeDateStyle(Ae) {
    this.removeStyle(), this.days.forEach((xr) => {
      var nd, cd;
      const ed = (cd = (nd = xr.textContent) == null ? void 0 : nd.trim()) != null ? cd : "1", od = Ae.filter((ud) => this.getTimezoneDate(ud).toString() === ed).find((ud) => this.getTimezoneMonth(ud) === +this.month && this.getTimezoneYear(ud) === +this.year), ad = od === Ae[0], rd = formatDate(this.rangeEndDate, this.format, this.keepTimezone), sd = od && od.toDateString() === rd.toDateString();
      od && (ad && sd ? xr.classList.add("selected") : ad ? xr.classList.add("start-range") : sd ? xr.classList.add("end-range") : xr.classList.add("range"));
    });
  }
  removeStyle() {
    this.days.forEach((Ae) => {
      Ae.classList.remove("start-range", "range", "end-range", "selected");
    });
  }
  setHighlightDates(Ae) {
    this.days.forEach((xr) => {
      var od, ad, rd, sd;
      const ed = (ad = (od = xr.textContent) == null ? void 0 : od.trim()) != null ? ad : "1", id = Ae.find((nd) => this.getTimezoneDate(nd.date).toString() === ed);
      if (id) {
        const nd = this.getTimezoneMonth(id.date) === +this.month, cd = this.getTimezoneYear(id.date) === +this.year;
        if (nd && cd) {
          const ud = new Tooltip$1();
          setAttributes(ud, { anchor: `calendar-highlight-${this.getTimezoneDate(id.date).toString()}`, position: "top" }), setAttributes(xr, { id: `calendar-highlight-${this.getTimezoneDate(id.date).toString()}` });
          const ld = document.createElement("div");
          ld.classList.add("anchor"), DOM.queueUpdate(() => {
            ud.prepend(id.text), xr.prepend(ld), xr.prepend(ud);
          });
        }
      } else
        (rd = xr.querySelector("tm1-tooltip")) == null || rd.remove(), (sd = xr.querySelector(".anchor")) == null || sd.remove();
    });
  }
  getTimezoneDate(Ae) {
    return this.keepTimezone ? Ae == null ? void 0 : Ae.getDate() : Ae == null ? void 0 : Ae.getUTCDate();
  }
  getTimezoneMonth(Ae) {
    return this.keepTimezone ? Ae == null ? void 0 : Ae.getMonth() : Ae == null ? void 0 : Ae.getUTCMonth();
  }
  getTimezoneYear(Ae) {
    return this.keepTimezone ? Ae == null ? void 0 : Ae.getFullYear() : Ae == null ? void 0 : Ae.getUTCFullYear();
  }
}
__decorateClass$U([
  attr
], Calendar.prototype, "month", 2);
__decorateClass$U([
  attr
], Calendar.prototype, "year", 2);
__decorateClass$U([
  attr
], Calendar.prototype, "format", 2);
__decorateClass$U([
  attr({ mode: "boolean" })
], Calendar.prototype, "multiple", 2);
__decorateClass$U([
  attr({ mode: "boolean" })
], Calendar.prototype, "range", 2);
__decorateClass$U([
  attr({ mode: "boolean" })
], Calendar.prototype, "fixed", 2);
__decorateClass$U([
  attr()
], Calendar.prototype, "order", 2);
__decorateClass$U([
  attr({ attribute: "disabled-dates", mode: "fromView" }),
  attr({ attribute: "disableddates", mode: "fromView" })
], Calendar.prototype, "disabledDates", 2);
__decorateClass$U([
  attr({ attribute: "max-date" }),
  attr({ attribute: "maxdate" })
], Calendar.prototype, "maxDate", 2);
__decorateClass$U([
  attr({ attribute: "min-date" }),
  attr({ attribute: "mindate" })
], Calendar.prototype, "minDate", 2);
__decorateClass$U([
  attr({ attribute: "range-end-date" }),
  attr({ attribute: "rangeenddate" })
], Calendar.prototype, "rangeEndDate", 2);
__decorateClass$U([
  attr({ attribute: "range-start-date" }),
  attr({ attribute: "rangestartdate" })
], Calendar.prototype, "rangeStartDate", 2);
__decorateClass$U([
  attr({ attribute: "selected-date" }),
  attr({ attribute: "selecteddate" })
], Calendar.prototype, "selectedDate", 2);
__decorateClass$U([
  attr({ attribute: "selected-dates", mode: "fromView" }),
  attr({ attribute: "selecteddates", mode: "fromView" })
], Calendar.prototype, "selectedDates", 2);
__decorateClass$U([
  attr({ attribute: "highlight-dates", mode: "fromView" }),
  attr({ attribute: "highlightdates", mode: "fromView" })
], Calendar.prototype, "highlightDates", 2);
__decorateClass$U([
  attr({ attribute: "start-year" }),
  attr({ attribute: "startyear" })
], Calendar.prototype, "startYear", 2);
__decorateClass$U([
  attr({ attribute: "end-year" }),
  attr({ attribute: "endyear" })
], Calendar.prototype, "endYear", 2);
__decorateClass$U([
  attr({ mode: "boolean", attribute: "keep-timezone" }),
  attr({ mode: "boolean", attribute: "keeptimezone" })
], Calendar.prototype, "keepTimezone", 2);
__decorateClass$U([
  attr({ mode: "boolean" })
], Calendar.prototype, "borderless", 2);
__decorateClass$U([
  attr({ mode: "boolean" })
], Calendar.prototype, "isInDatePicker", 2);
__decorateClass$U([
  attr({ mode: "boolean" })
], Calendar.prototype, "isInDateTimePicker", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "lang", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "nbDays", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "months", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "days", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "years", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "weekdays", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "isPrevBtnDisabled", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "isNextBtnDisabled", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "calendarDays", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "theme", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "monthSelectRef", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "yearSelectRef", 2);
__decorateClass$U([
  observable
], Calendar.prototype, "_disabledDates", 2);
const tm1Calendar = Calendar.compose({
  baseName: "calendar",
  template: tm1CalendarTemplate,
  styles: tm1CalendarStyles
});
designSystem.register(
  tm1Calendar()
);
const iconTooltipTemplate = (td) => html`
  <template>
    <${td.tagFor(Icon)}
      color=${(Ae) => Ae.color}
      icon=${(Ae) => Ae.icon}
      id=${(Ae) => {
  var xr;
  return (xr = Ae.anchor) != null ? xr : "icon-tooltip";
}}
      size=${(Ae) => Ae.size}
      role=${(Ae) => Ae.role}
    ></${td.tagFor(Icon)}>
    <${td.tagFor(Tooltip$1)}
      anchor=${(Ae) => {
  var xr;
  return (xr = Ae.anchor) != null ? xr : "icon-tooltip";
}}
      delay=${(Ae) => Ae.delay}
      position=${(Ae) => Ae.position}
      ?visible=${(Ae) => Ae.visible}
      data-testid="tooltip"
    >
      <slot></slot>
    </${td.tagFor(Tooltip$1)}>
  </template>
`;
var __defProp$T = Object.defineProperty, __getOwnPropDesc$T = Object.getOwnPropertyDescriptor, __decorateClass$T = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$T(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$T(Ae, xr, id), id;
};
class IconTooltip extends FoundationElement {
  constructor() {
    super(...arguments), this.delay = 300, this.icon = "", this.position = "bottom", this.role = "img", this.size = IconSize.regular;
  }
}
__decorateClass$T([
  attr()
], IconTooltip.prototype, "anchor", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "color", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "delay", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "icon", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "position", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "role", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "size", 2);
__decorateClass$T([
  attr()
], IconTooltip.prototype, "visible", 2);
const tm1IconTooltip = IconTooltip.compose({
  baseName: "icon-tooltip",
  template: iconTooltipTemplate,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1IconTooltip()
);
const tm1CardStyles = () => css`
  ${baseCardStyles}

  :host {
    font-family: ${GDSEFontFamily};
    border-radius: ${GDSERadiusSurface};
    color: ${GDSEColorText};
    background-color: ${GDSEColorSurfaceCard};
    padding: ${GDSESpacing300};
    background-position: center center;
    background-size: cover;
  }

  ${shadowVariantCardStyles}

  ${outlineVariantCardStyles}

  ${defaultVariantCardStyles}
`, tm1CardContentStyles = () => css`
  :host {
    display: flex;
    padding: ${GDSESpacing300} 0;
  }
`, tm1CardContentTemplate = () => html`
  <slot></slot>
`;
class CardContent extends FoundationElement {
}
const tm1CardContent = CardContent.compose({
  baseName: "card-content",
  baseClass: FoundationElement,
  template: tm1CardContentTemplate,
  styles: tm1CardContentStyles
}), tm1CardFooterStyles = () => css`
  :host {
    display: flex;
    padding: ${GDSESpacing200} ${GDSESpacing300} 0 ${GDSESpacing300};
    gap: ${GDSESpacing200};
    margin-left: calc(${GDSESpacing300} * -1);
    margin-right: calc(${GDSESpacing300} * -1);
    margin-bottom: calc(${GDSESpacing100} * -1);
    justify-content: space-between;
    align-items: center;
  }

  slot[name='actions'] {
    display: flex;
    gap: ${GDSESpacing100};
  }
`, tm1CardFooterTemplate = () => html`
  <div><slot name="content"></slot></div>
  <slot name="actions"></slot>
`;
class CardFooter extends FoundationElement {
}
const tm1CardFooter = CardFooter.compose({
  baseName: "card-footer",
  baseClass: FoundationElement,
  template: tm1CardFooterTemplate,
  styles: tm1CardFooterStyles
}), tm1CardHeaderStyles = () => css`
  :host {
    display: flex;
    padding: 0 ${GDSESpacing300} ${GDSESpacing200};
    margin-left: calc(${GDSESpacing300} * -1);
    margin-right: calc(${GDSESpacing300} * -1);
    margin-top: calc(${GDSESpacing100} * -1);
    gap: ${GDSESpacing200};
    justify-content: space-between;
  }

  :host .title-tooltip,
  :host .actions {
    display: flex;
    gap: ${GDSESpacing100};
    align-items: center;
  }

  :host .title {
    text-align: left;
    color: ${GDSEColorTextLight};
  }

  :host .listbox {
    padding: ${GDSESpacingSurfaceVerXS} ${GDSESpacingSurfaceHorXS};
    display: flex;
    flex-direction: column;
    max-width: 144px;
    border: 1px solid ${GDSEColorBorderPopover};
    border-radius: ${GDSERadiusPopover};
    transition: opacity 0.1s ease-in 0s;
  }

  :host .icon-tooltip {
    vertical-align: -webkit-baseline-middle;
  }
`, tm1CardHeaderTemplate = (td) => html`
  <div class="title-tooltip">
    ${when((Ae) => !!Ae.title, html`<${td.tagFor(Typography)}  class="title" type="label-container-l" data-testid="title">${(Ae) => Ae.title}</${td.tagFor(Typography)} >`)}
    ${when((Ae) => !!Ae.info, html`<div class="info" data-testid="info"><${td.tagFor(IconTooltip)} class="icon-tooltip" icon="info" size="small">${(Ae) => Ae.info}</${td.tagFor(IconTooltip)}></div>`)}
    </div>
  <div class="actions">
    <slot name="actions"></slot>
  ${when(
  (Ae) => Ae.hasKebab,
  html`
      <${td.tagFor(Popover)}
        alignment="${PopoverAlignment.end}"
        direction="${PopoverDirection.down}"
        mode="${PopoverMode.relative}"
        padding="${PopoverPadding.none}"
        ?visible="true"
        ?closeOnClick="true"
      >
          <!-- here -->
          <${td.tagFor(Button)}
              slot="trigger"
              class="kebab-actions-button"
              color="neutral"
              size="small"
              variant="lightweight"
              iconPosition="only-icon"
              icon="kebab"
              aria-label="button-popover"
          ></${td.tagFor(Button)}>
          <div class="listbox">
            <slot name="kebab-actions"></slot>
          </div>
      </${td.tagFor(Popover)}>
    `
)}
  </div>
`;
var __defProp$S = Object.defineProperty, __getOwnPropDesc$S = Object.getOwnPropertyDescriptor, __decorateClass$S = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$S(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$S(Ae, xr, id), id;
};
class CardHeader extends FoundationElement {
  constructor() {
    super(...arguments), this.title = "", this.info = "", this.hasKebab = !1;
  }
}
__decorateClass$S([
  attr()
], CardHeader.prototype, "title", 2);
__decorateClass$S([
  attr()
], CardHeader.prototype, "info", 2);
__decorateClass$S([
  attr({ mode: "boolean", attribute: "haskebab" }),
  attr({ mode: "boolean", attribute: "has-kebab" })
], CardHeader.prototype, "hasKebab", 2);
const tm1CardHeader = CardHeader.compose({
  baseName: "card-header",
  baseClass: FoundationElement,
  template: tm1CardHeaderTemplate,
  styles: tm1CardHeaderStyles
}), header$1 = (td) => html`
    <${td.tagFor(CardHeader)} data-testid="card-content">
    </${td.tagFor(CardHeader)}>
  `, content$1 = (td) => html`
  <${td.tagFor(CardContent)} data-testid="card-content">
  </${td.tagFor(CardContent)}>
`, footer$1 = (td) => html`
    <${td.tagFor(CardFooter)} data-testid="card-footer">
    </${td.tagFor(CardFooter)}>
  `, tm1CardTemplate = (td) => html`<slot>
  ${header$1(td)}
  ${content$1(td)}
  ${footer$1(td)}
</slot> `;
var __defProp$R = Object.defineProperty, __getOwnPropDesc$R = Object.getOwnPropertyDescriptor, __decorateClass$R = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$R(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$R(Ae, xr, id), id;
};
const CardVariant = {
  default: "default",
  shadow: "shadow",
  outline: "outline"
};
class Card extends Card$1 {
}
__decorateClass$R([
  attr()
], Card.prototype, "variant", 2);
const tm1Card = Card.compose({
  baseName: "card",
  baseClass: Card$1,
  template: tm1CardTemplate,
  styles: tm1CardStyles,
  shadowOptions: {
    delegatesFocus: !1
  }
});
designSystem.register(
  tm1Card(),
  tm1CardContent(),
  tm1CardFooter(),
  tm1CardHeader()
);
const CheckboxGroupOrientation = Orientation, tm1CheckboxGroupStyles = () => css`
  :host {
    display: flex;
    flex-direction: column;
  }

  .container {
    display: flex;
    flex-direction: row;
    gap: ${GDSESpacing300};
  }

  .sub-container {
    display: flex;
    flex-direction: column;
  }

  .positioning-region {
    display: flex;
    flex-direction: row;
    gap: ${GDSESpacing300};
  }

  :host([orientation='vertical']) .positioning-region {
    width: 'auto';
    display: flex;
    flex-direction: column;
    gap: ${GDSESpacing25};
  }

  :host([orientation='vertical']) .container {
    flex-direction: column;
    gap: ${GDSESpacing100};
  }

  .error {
    color: ${GDSEColorTextCritical};
    display: flex;
    align-items: center;
    margin-top: ${GDSESpacing100};
    gap: ${GDSESpacing50};
  }

  .label {
    display: flex;
    align-items: baseline;
  }

  :host([orientation='horizontal']) .label {
    line-height: 21px; /* Checkbox's label line-height to be centered */
  }

  :host([orientation='horizontal'][size='large']) .label {
    line-height: 24px; /* Checkbox's label line-height to be centered */
  }
`, tm1CheckboxGroupTemplate = (td) => html`
  <template
    id="${(Ae) => Ae.defaultId()}"
    role="group"
    tabindex="${(Ae) => Ae.disabled ? -1 : "0"}"
    aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
    aria-readonly="${(Ae) => {
  var xr;
  return (xr = Ae.readOnly) != null ? xr : !1;
}}"
    aria-orientation="${(Ae) => Ae.orientation}"
    aria-errormessage="${(Ae) => Ae.errorDefaultId()}"
    @click="${(Ae, xr) => Ae.clickHandler(xr.event)}"
    @keydown="${(Ae, xr) => Ae.keydownHandler(xr.event)}"
    @focusout="${(Ae, xr) => Ae.focusOutHandler(xr.event)}"
  >
    <div class="container">
      <${td.tagFor(Typography)} tag="span" type="label-helpertext-highemphasis" class="label" role="label">
        <slot name="label"></slot>
      </${td.tagFor(Typography)}>
      <div class="sub-container">
        <div
          class="positioning-region ${(Ae) => Ae.orientation === CheckboxGroupOrientation.horizontal ? "horizontal" : "vertical"}"
          part="positioning-region"
        >
          <slot
            ${slotted({
  flatten: !0,
  property: "slottedCheckboxes",
  filter: elements()
})}
          ></slot>
        </div>
        ${when(
  (Ae) => !!Ae.error && !Ae.readOnly && !Ae.disabled,
  html`
            <div class="error">
              <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
              <${td.tagFor(Typography)} tag="span" type="label-helpertext-regular" id="${(Ae) => Ae.errorDefaultId()}" role="alert">
                ${(Ae) => Ae.error}
              </${td.tagFor(Typography)}>
            </div>
          `
)}
      </div>
    </div>
  </template>
`;
var __defProp$Q = Object.defineProperty, __getOwnPropDesc$Q = Object.getOwnPropertyDescriptor, __decorateClass$Q = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$Q(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$Q(Ae, xr, id), id;
};
const getDirection = (td) => {
  var Ae;
  return ((Ae = td.closest("[dir]")) == null ? void 0 : Ae.dir) === "rtl" ? Direction.rtl : Direction.ltr;
};
class CheckboxGroup extends FoundationElement {
  constructor() {
    super(...arguments), this.readOnly = !1, this.disabled = !1, this.error = "", this.name = "checkbox-group", this.size = "small", this.value = [], this.orientation = CheckboxGroupOrientation.horizontal, this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.checkboxChangeHandler = (Ae) => {
      var ed, id;
      const xr = Ae.target;
      xr.checked ? (id = this.value) == null || id.push(xr.value) : (this.value = (ed = this.value) == null ? void 0 : ed.filter((od) => od !== xr.value), this.setCheckbox(xr)), Ae.stopPropagation(), this.$emit("change");
    }, this.moveToCheckboxByIndex = (Ae, xr) => {
      const ed = Ae[xr];
      this.setCheckbox(ed), ed.focus();
    }, this.moveRightOffGroup = () => {
      var Ae;
      (Ae = this.nextElementSibling) == null || Ae.focus();
    }, this.moveLeftOffGroup = () => {
      var Ae;
      (Ae = this.previousElementSibling) == null || Ae.focus();
    }, this.focusOutHandler = (Ae) => {
      const xr = this.slottedCheckboxes || [], ed = Ae.target, id = ed !== null ? xr.indexOf(ed) : 0, od = this.focusedCheckbox ? xr.indexOf(this.focusedCheckbox) : -1;
      return (od === 0 && id === od || od === xr.length - 1 && od === id) && (this.selectedCheckbox ? (this.focusedCheckbox = this.selectedCheckbox, this.selectedCheckbox.setAttribute("tabindex", "0"), xr.forEach((ad) => {
        ad !== this.selectedCheckbox && ad.setAttribute("tabindex", "-1");
      })) : (this.focusedCheckbox = xr[0], this.focusedCheckbox.setAttribute("tabindex", "0"), xr.forEach((ad) => {
        ad !== this.focusedCheckbox && ad.setAttribute("tabindex", "-1");
      }))), !0;
    }, this.clickHandler = (Ae) => {
      this.disabled || Ae.preventDefault();
    }, this.shouldMoveOffGroupToTheRight = (Ae, xr, ed) => Ae === xr.length && ed === keyArrowRight, this.shouldMoveOffGroupToTheLeft = (Ae, xr) => (this.focusedCheckbox ? Ae.indexOf(this.focusedCheckbox) - 1 : 0) < 0 && xr === keyArrowLeft, this.checkFocusedCheckbox = () => {
      this.focusedCheckbox !== null && this.focusedCheckbox !== void 0 && (this.focusedCheckbox.checked ? this.focusedCheckbox.checked = !1 : (this.focusedCheckbox.checked = !0, this.focusedCheckbox.setAttribute("tabindex", "0"), this.focusedCheckbox.focus(), this.selectedCheckbox = this.focusedCheckbox));
    }, this.moveRight = (Ae) => {
      const xr = this.slottedCheckboxes || [];
      let ed = 0;
      if (ed = this.focusedCheckbox ? xr.indexOf(this.focusedCheckbox) + 1 : 1, this.shouldMoveOffGroupToTheRight(ed, xr, Ae.key)) {
        this.moveRightOffGroup();
        return;
      } else
        ed === xr.length && (ed = 0);
      for (; ed < xr.length && xr.length > 1; )
        if (xr[ed].disabled) {
          if (this.focusedCheckbox && ed === xr.indexOf(this.focusedCheckbox))
            break;
          ed + 1 >= xr.length ? ed = 0 : ed += 1;
        } else {
          this.moveToCheckboxByIndex(xr, ed);
          break;
        }
    }, this.moveLeft = (Ae) => {
      const xr = this.slottedCheckboxes || [];
      let ed = 0;
      if (ed = this.focusedCheckbox ? xr.indexOf(this.focusedCheckbox) - 1 : 0, ed = ed < 0 ? xr.length - 1 : ed, this.shouldMoveOffGroupToTheLeft(xr, Ae.key)) {
        this.moveLeftOffGroup();
        return;
      }
      for (; ed >= 0 && xr.length > 1; )
        if (xr[ed].disabled) {
          if (this.focusedCheckbox && ed === xr.indexOf(this.focusedCheckbox))
            break;
          ed - 1 < 0 ? ed = xr.length - 1 : ed -= 1;
        } else {
          this.moveToCheckboxByIndex(xr, ed);
          break;
        }
    }, this.keydownHandler = (Ae) => {
      const xr = Ae.key;
      if (xr in ArrowKeys && this.disabled)
        return !0;
      switch (xr) {
        case keyEnter: {
          this.checkFocusedCheckbox();
          break;
        }
        case keyArrowRight:
        case keyArrowDown: {
          this.direction === Direction.ltr ? this.moveRight(Ae) : this.moveLeft(Ae);
          break;
        }
        case keyArrowLeft:
        case keyArrowUp: {
          this.direction === Direction.ltr ? this.moveLeft(Ae) : this.moveRight(Ae);
          break;
        }
        default:
          return !0;
      }
    };
  }
  nameChanged() {
    this.slottedCheckboxes && this.slottedCheckboxes.forEach((Ae) => {
      Ae.setAttribute("name", this.name);
    });
  }
  sizeChanged() {
    this.slottedCheckboxes && this.slottedCheckboxes.forEach((Ae) => {
      Ae.setAttribute("size", this.size);
    });
  }
  disabledChanged() {
    this.setCheckboxAttribute("disabled", this.disabled);
  }
  readOnlyChanged() {
    this.setCheckboxAttribute("readOnly", this.readOnly);
  }
  slottedCheckboxesChanged() {
    this.slottedCheckboxes && this.slottedCheckboxes.length > 0 && this.setupCheckboxButtons();
  }
  connectedCallback() {
    super.connectedCallback(), this.direction = getDirection(this), this.setupCheckboxButtons();
  }
  disconnectedCallback() {
    var Ae;
    (Ae = this.slottedCheckboxes) == null || Ae.forEach((xr) => {
      xr.removeEventListener("change", (ed) => this.checkboxChangeHandler(ed));
    });
  }
  setupCheckboxButtons() {
    var id, od, ad;
    const Ae = ((id = this.slottedCheckboxes) == null ? void 0 : id.filter((rd) => rd.hasAttribute("checked"))) || [], xr = Ae ? Ae.length : 0;
    if (xr > 1) {
      const rd = Ae[xr - 1];
      rd.checked = !0;
    }
    let ed = !1;
    if ((od = this.slottedCheckboxes) == null || od.forEach((rd) => {
      this.name !== void 0 && rd.setAttribute("name", this.name), this.readOnlyChanged(), this.disabledChanged(), this.value && this.value.includes(rd.value) ? (this.setCheckbox(rd), rd.checked = !0, ed = !0) : rd.checked = !1, rd.setAttribute("size", this.size), rd.addEventListener("change", (sd) => this.checkboxChangeHandler(sd));
    }), this.value === void 0 && this.slottedCheckboxes !== void 0 && this.slottedCheckboxes.length > 0) {
      const rd = (ad = this.slottedCheckboxes) == null ? void 0 : ad.filter((nd) => nd.hasAttribute("checked")), sd = rd !== null ? rd.length : 0;
      if (sd > 0 && !ed) {
        const nd = rd[sd - 1];
        nd.checked = !0, this.focusedCheckbox = nd, nd.setAttribute("tabindex", "0");
      } else
        this.slottedCheckboxes[0].setAttribute("tabindex", "0"), this.focusedCheckbox = this.slottedCheckboxes[0];
    }
  }
  setCheckboxAttribute(Ae, xr) {
    this.slottedCheckboxes && this.slottedCheckboxes.forEach((ed) => {
      xr ? ed.setAttribute(Ae, "") : ed.removeAttribute(Ae);
    });
  }
  setCheckbox(Ae) {
    this.selectedCheckbox = Ae, this.focusedCheckbox = Ae, Ae.setAttribute("tabindex", "0");
  }
  valueChanged(Ae, xr) {
    Array.isArray(xr) || (this.value = [xr]);
  }
}
__decorateClass$Q([
  attr({ attribute: "readonly", mode: "boolean" })
], CheckboxGroup.prototype, "readOnly", 2);
__decorateClass$Q([
  attr({ attribute: "disabled", mode: "boolean" })
], CheckboxGroup.prototype, "disabled", 2);
__decorateClass$Q([
  attr()
], CheckboxGroup.prototype, "error", 2);
__decorateClass$Q([
  attr()
], CheckboxGroup.prototype, "name", 2);
__decorateClass$Q([
  attr()
], CheckboxGroup.prototype, "legend", 2);
__decorateClass$Q([
  attr()
], CheckboxGroup.prototype, "size", 2);
__decorateClass$Q([
  attr()
], CheckboxGroup.prototype, "value", 2);
__decorateClass$Q([
  attr()
], CheckboxGroup.prototype, "orientation", 2);
__decorateClass$Q([
  observable
], CheckboxGroup.prototype, "childItems", 2);
__decorateClass$Q([
  observable
], CheckboxGroup.prototype, "slottedCheckboxes", 2);
const tm1CheckboxGroup = CheckboxGroup.compose({
  baseName: "checkbox-group",
  template: tm1CheckboxGroupTemplate,
  styles: tm1CheckboxGroupStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1CheckboxGroup()
);
class _Combobox extends Listbox {
}
class FormAssociatedCombobox extends FormAssociated(_Combobox) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
const tm1ComboboxStyles = css`
  ${selectStyles}

  :host(:empty) .listbox {
    display: none;
  }

  :host([disabled]) * {
    cursor: ${disabledCursor};
    user-select: none;
  }

  .selected-value {
    -webkit-appearance: none;
    background: transparent;
    border: none;
    color: inherit;
    margin: auto 0;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .selected-value:hover,
  .selected-value:${focusVisible},
  .selected-value:disabled,
  .selected-value:active {
    outline: none;
  }

  :host(:not([disabled]):hover) {
    background: transparent;
    border: none;
  }

  :host .control {
    display: flex;
    align-items: center;
  }

  :host(:not([disabled])) .control:active {
    border-radius: ${GDSERadiusInput};
  }

  :host([disabled]) input::placeholder {
    color: ${GDSEColorTextDisabled};
  }

  :host input::placeholder {
    color: ${GDSEColorTextMuted};
  }

  :host(:${focusVisible}) {
    border: none;
    box-shadow: none !important;
  }

  :host .input {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .control-input {
    width: 100%;
  }

  .indicator {
    display: flex;
  }

  .indicator,
  .select-indicator {
    fill: ${GDSEColorTextLight};
  }

  :host([disabled]) .indicator,
  :host([disabled]) .select-indicator {
    fill: ${GDSEColorTextDisabled};
  }

  .start,
  .end {
    display: flex;
    margin: auto;
    fill: currentcolor;
    padding-right: 0px;
    padding-left: 0px;
  }

  .start,
  .end,
  .indicator,
  .select-indicator,
  ::slotted(svg) {
    height: 1em;
    min-height: 16px;
    min-width: 16px;
    width: 1em;
  }

  .no-result {
    display: flex;
    color: ${GDSEColorTextMuted};
    padding: ${GDSESpacingListVerS} ${GDSESpacingListHorS};
    align-items: center;
    align-self: stretch;
  }

  :host ::slotted(tm1-option) {
    max-height: fit-content;
  }

  .helper {
    color: ${GDSEColorTextLight};
    margin-top: ${GDSESpacing25};
    margin-bottom: ${GDSESpacing0};
  }
`, tm1ComboboxTemplate = (td, Ae) => {
  var xr;
  return html`
    <template
      aria-disabled="${(ed) => ed.ariaDisabled}"
      autocomplete="${(ed) => ed.autocomplete}"
      ?open="${(ed) => ed.open}"
      error="${(ed) => ed.error}"
      ?has-error="${(ed) => !!ed.error}"
      tabindex="${(ed) => ed.disabled ? null : "0"}"
      @click="${(ed, id) => ed.clickHandler(id.event)}"
      @focusout="${(ed, id) => ed.focusoutHandler(id.event)}"
      @keydown="${(ed, id) => ed.keydownHandler(id.event)}"
    >
      ${when(
    (ed) => !!ed.label,
    html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="label">
          <label part="label" for="${(ed) => ed.defaultId()}">${(ed) => ed.label}</label>
        </${td.tagFor(Typography)}>`
  )}

      <div class="control" part="control" ${ref("combobox")} data-testid="control">
        ${startSlotTemplate(td, Ae)}
        <slot name="control" class="input">
          <${td.tagFor(Typography)} class="control-input" type="${(ed) => ed.textType()[ed.inputSize || "regular"]}">
            <input
              id="${(ed) => ed.defaultId()}"
              aria-activedescendant="${(ed) => ed.open ? ed.ariaActiveDescendant : null}"
              aria-autocomplete="${(ed) => ed.ariaAutoComplete}"
              aria-controls="${(ed) => ed.ariaControls}"
              aria-disabled="${(ed) => ed.ariaDisabled}"
              aria-expanded="${(ed) => ed.ariaExpanded}"
              aria-errormessage="${(ed) => ed.errorDefaultId()}"
              aria-invalid="${(ed) => ed.ariaInvalid || ed.isInvalid()}"
              aria-haspopup="listbox"
              autocomplete="off"
              class="selected-value"
              part="selected-value"
              placeholder="${(ed) => ed.placeholder}"
              role="combobox"
              type="text"
              ?disabled="${(ed) => ed.disabled}"
              value="${(ed) => ed.value}"
              @input="${(ed, id) => ed.inputHandler(id.event)}"
              @keyup="${(ed, id) => ed.keyupHandler(id.event)}"
              ${ref("control")}
            />
          </${td.tagFor(Typography)}>
          <div class="indicator" part="indicator" aria-hidden="true">
            <slot name="indicator"> ${(xr = Ae.indicator) != null ? xr : ""} </slot>
          </div>
        </slot>
        ${endSlotTemplate(td, Ae)}
      </div>

      ${when(
    (ed) => !!ed.error && !ed.disabled,
    html`<div class="error">
          <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
          <${td.tagFor(Typography)}
            type="label-helpertext-regular"
            tag="span"
            id="${(ed) => ed.errorDefaultId()}"
            role="alert"
          >
            ${(ed) => ed.error}
          </${td.tagFor(Typography)}>
        </div>`
  )}

    ${when(
    (ed) => !!ed.helpLabel && !ed.error,
    html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="helper">${(ed) => ed.helpLabel}</${td.tagFor(Typography)}>`
  )}
    </div>

      <${td.tagFor(Listbox)}
        class="listbox"
        id="${(ed) => ed.listboxId}"
        size="${(ed) => ed.size}"
        part="listbox"
        role="listbox"
        ?disabled="${(ed) => ed.disabled}"
        ?hidden="${(ed) => !ed.open}"
        isInsideElement
        inputSize=${(ed) => ed.inputSize}
        ${ref("listbox")}
      >
        ${when((ed) => ed.hasNoResult, html`
          <${td.tagFor(Typography)} type="body-m" class="no-result">
            ${(ed) => ed.noResultLabel} '${(ed) => ed.userInput}'
          </${td.tagFor(Typography)}>
        `)}
        <slot name='listbox-top' slot='listbox-top'></slot>
        <slot
          ${slotted({
    filter: (ed) => (isListboxOption(ed) || isListItem(ed) || isOptionGroup(ed)) && !ed.hidden,
    flatten: !0,
    property: "slottedOptions"
  })}
        ></slot>
        <slot name='listbox-bottom' slot='listbox-bottom'></slot>
      </${td.tagFor(Listbox)}>
    </template>
  `;
};
var __defProp$P = Object.defineProperty, __getOwnPropDesc$P = Object.getOwnPropertyDescriptor, __decorateClass$P = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$P(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$P(Ae, xr, id), id;
};
class Combobox extends FormAssociatedCombobox {
  constructor() {
    super(...arguments), this._value = "", this.error = "", this.inputSize = "regular", this.label = "", this.noResultLabel = "No results found for", this.position = SelectPosition$1.below, this.size = 4, this.hasNoResult = !1, this.userInput = "", this.hasBeenTouched = !1, this.computedStylesheet = css``, this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" }), this.isInvalid = () => !!this.error || this.required && (this.value === void 0 || this.value === "" || this.value === null), this.filteredOptions = [], this.filter = "", this.listboxId = uniqueId("listbox-"), this.open = !1;
  }
  /**
   * Reset the element to its first selectable option when its parent form is reset.
   *
   * @internal
   */
  formResetCallback() {
    if (super.formResetCallback(), this.setDefaultSelectedOption(), !this.firstSelectedOption) {
      this.control.value = "", this.value = "", this.filter = "";
      return;
    }
    this.updateValue();
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  get isAutocompleteInline() {
    return this.autocomplete === ComboboxAutocomplete.inline || this.isAutocompleteBoth;
  }
  get isAutocompleteList() {
    return this.autocomplete === ComboboxAutocomplete.list || this.isAutocompleteBoth;
  }
  get isAutocompleteBoth() {
    return this.autocomplete === ComboboxAutocomplete.both;
  }
  /**
   * Sets focus and synchronize ARIA attributes when the open property changes.
   *
   * @param prev - the previous open value
   * @param next - the current open value
   *
   * @internal
   */
  openChanged() {
    var Ae;
    if (this.open) {
      this.ariaControls = this.listboxId, this.ariaExpanded = "true", this.updateComputedStylesheet(), DOM.queueUpdate(() => this.setPositioning()), this.focusAndScrollOptionIntoView(), DOM.queueUpdate(() => this.focus());
      return;
    }
    this.open && this.listbox && (this.listbox.hidden = !1, DOM.queueUpdate(() => this.setPositioning())), (Ae = this.cleanup) == null || Ae.call(this), this.ariaControls = "", this.ariaExpanded = "false";
  }
  /**
   * Updates the proxy's size property when the size attribute changes.
   *
   * @param prev - the previous size
   * @param next - the current size
   *
   * @override
   * @internal
   */
  sizeChanged(Ae, xr) {
    if (typeof xr != "number" || xr === 0) {
      this.size = typeof xr == "string" ? parseInt(xr) : 4;
      return;
    }
    super.sizeChanged(Ae, xr), this.proxy && (this.proxy.size = xr);
  }
  /**
   * The list of options.
   *
   * @public
   * @remarks
   * Overrides `Listbox.options`.
   */
  get options() {
    var Ae;
    return Observable.track(this, "options"), (Ae = this.filteredOptions) != null && Ae.length ? this.filteredOptions : this._options;
  }
  set options(Ae) {
    this._options = Ae, Observable.notify(this, "options");
  }
  /**
   * Updates the placeholder on the proxy element.
   * @internal
   */
  placeholderChanged() {
    this.proxy instanceof HTMLInputElement && (this.proxy.placeholder = this.placeholder);
  }
  /**
   * The value property.
   *
   * @public
   */
  get value() {
    return Observable.track(this, "value"), this._value;
  }
  set value(Ae) {
    var id, od, ad;
    const xr = `${this._value}`;
    if (document.activeElement === this && (this.hasBeenTouched = !0), this.$fastController.isConnected && this.options && Ae) {
      const rd = this.options.findIndex(
        (sd) => ((sd == null ? void 0 : sd.getTextContent()) || sd.text).toLowerCase() === Ae.toLowerCase()
      );
      this.selectedIndex = xr !== Ae ? rd : this.selectedIndex, this.control.value = this.selectedIndex !== -1 ? ((id = this.options[this.selectedIndex]) == null ? void 0 : id.getTextContent()) || ((od = this.options[this.selectedIndex]) == null ? void 0 : od.text) : Ae, Ae = ((ad = this.firstSelectedOption) == null ? void 0 : ad.getTextContent()) || Ae;
    }
    this.required && Ae && (this.setValidity({}), this.setFormValue(Ae)), xr !== Ae && (this._value = Ae, super.valueChanged(xr, Ae), Observable.notify(this, "value"));
  }
  /**
   * Handle opening and closing the listbox when the combobox is clicked.
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(Ae) {
    const xr = Ae.target.closest(
      "option,[role=option]"
    );
    if (!(this.disabled || xr != null && xr.disabled)) {
      if (this.open) {
        if (Ae.composedPath()[0] === this.control)
          return;
        xr && (this.selectedOptions = [xr], this.control.value = (xr == null ? void 0 : xr.getTextContent()) || xr.text, this.clearSelectionRange(), this.updateValue(!0));
      }
      return this.open = !this.open, this.open && this.control.focus(), !0;
    }
  }
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      this.value && (this.initialValue = this.value);
    }), this.updateComputedStylesheet(), this.listbox.addEventListener("change", (Ae) => Ae.stopPropagation());
  }
  /**
   * Synchronize the `aria-disabled` property when the `disabled` property changes.
   *
   * @param prev - The previous disabled value
   * @param next - The next disabled value
   *
   * @internal
   */
  disabledChanged(Ae, xr) {
    super.disabledChanged && super.disabledChanged(Ae, xr), this.ariaDisabled = this.disabled ? "true" : "false";
  }
  disconnectedCallback() {
    var Ae;
    this.listbox.removeEventListener("change", (xr) => xr.stopPropagation()), (Ae = this.cleanup) == null || Ae.call(this), super.disconnectedCallback();
  }
  /**
   * Filter available options by text value.
   *
   * @public
   */
  filterOptions() {
    (!this.autocomplete || this.autocomplete === ComboboxAutocomplete.none) && (this.filter = "");
    const Ae = this.filter.toLowerCase();
    this.filteredOptions = this._options.filter((xr) => ((xr == null ? void 0 : xr.getTextContent()) || xr.text).toLowerCase().includes(Ae)), this.isAutocompleteList && (!this.filteredOptions.length && !Ae && (this.filteredOptions = this._options), this._options.forEach((xr) => {
      xr.hidden = !this.filteredOptions.includes(xr);
    }), this.groupOptions.forEach((xr) => {
      xr.parentElement && isOptionGroup(xr) && (xr.hidden = this.areAllOptionsHidden(xr.children));
    }));
  }
  /**
   * Check if all options in a HTMLCollection are hidden or not
   *
   * @internal
   */
  areAllOptionsHidden(Ae) {
    for (let xr = 0; xr < Ae.length; xr++)
      if (!Ae[xr].hidden)
        return !1;
    return !0;
  }
  /**
   * Focus the control and scroll the first selected option into view.
   *
   * @internal
   * @remarks
   * Overrides: `Listbox.focusAndScrollOptionIntoView`
   */
  focusAndScrollOptionIntoView() {
    this.contains(getRootActiveElement(this)) && (this.control.focus(), this.firstSelectedOption && requestAnimationFrame(() => {
      var Ae;
      (Ae = this.firstSelectedOption) == null || Ae.scrollIntoView({ block: "nearest" });
    }));
  }
  /**
   * Handle focus state when the element or its children lose focus.
   *
   * @param e - The focus event
   * @internal
   */
  focusoutHandler(Ae) {
    if (this.updateValue(), !this.open)
      return !0;
    const xr = Ae.relatedTarget;
    if (this.isSameNode(xr)) {
      this.focus();
      return;
    }
    (!this.options || !this.options.includes(xr)) && (this.open = !1, this.filter !== this.value && (this.value = this.filter, this.control.value = this.filter));
  }
  /**
   * Handle content changes on the control input.
   *
   * @param e - the input event
   * @internal
   */
  inputHandler(Ae) {
    if (this.filter = this.control.value, this.filterOptions(), this.isAutocompleteInline || (this.selectedIndex = this.options.map((xr) => xr.text).indexOf(this.control.value)), Ae.inputType.includes("deleteContent") || !this.filter.length)
      return this.checkHasNoResult(), !0;
    this.isAutocompleteList && !this.open && (this.open = !0), this.isAutocompleteInline && (this.filteredOptions.length ? (this.selectedOptions = [this.filteredOptions[0]], this.selectedIndex = this.options.indexOf(this.firstSelectedOption), this.setInlineSelection()) : this.selectedIndex = -1), this.userInput = this.filter, this.checkHasNoResult();
  }
  /**
   * Check if filteredOptions has any result and update the observable.
   *
   * @internal
   */
  checkHasNoResult() {
    var Ae;
    this.hasNoResult = ((Ae = this.filteredOptions) == null ? void 0 : Ae.length) === 0 && this.filter.length > 0 && this.filteredOptions.length !== this.options.length;
  }
  /**
   * Handle keydown actions for listbox navigation.
   *
   * @param e - the keyboard event
   * @internal
   */
  keydownHandler(Ae) {
    const xr = Ae.key;
    if (Ae.ctrlKey || Ae.shiftKey)
      return !0;
    switch (xr) {
      case "Enter": {
        this.syncValue(), this.isAutocompleteInline && (this.filter = this.value), this.open = !1, this.clearSelectionRange();
        break;
      }
      case "Escape": {
        if (this.isAutocompleteInline || (this.selectedIndex = -1), this.open) {
          this.open = !1, this.filter && (this.value = this.filter, this.control.value = this.filter);
          break;
        }
        this.value = "", this.control.value = "", this.filter = "", this.filterOptions();
        break;
      }
      case "Tab": {
        if (this.setInputToSelection(), !this.open)
          return !0;
        Ae.preventDefault(), this.filter && (this.value = this.filter, this.control.value = this.filter), this.open = !1;
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        if (this.filterOptions(), !this.open) {
          this.open = !0;
          break;
        }
        this.filteredOptions.length > 0 && super.keydownHandler(Ae), this.isAutocompleteInline && this.setInlineSelection();
        break;
      }
      default:
        return !0;
    }
  }
  /**
   * Handle keyup actions for value input and text field manipulations.
   *
   * @param e - the keyboard event
   * @internal
   */
  keyupHandler(Ae) {
    switch (Ae.key) {
      case "ArrowLeft":
      case "ArrowRight":
      case "Backspace":
      case "Delete":
      case "Home":
      case "End": {
        this.filter = this.control.value, this.selectedIndex = -1, this.filterOptions();
        break;
      }
    }
  }
  /**
   * Ensure that the selectedIndex is within the current allowable filtered range.
   *
   * @param prev - the previous selected index value
   * @param next - the current selected index value
   *
   * @internal
   */
  selectedIndexChanged(Ae, xr) {
    if (this.$fastController.isConnected) {
      if (xr = limit(-1, this.options.length - 1, xr), xr !== this.selectedIndex) {
        this.selectedIndex = xr;
        return;
      }
      super.selectedIndexChanged(Ae, xr);
    }
  }
  /**
   * Move focus to the previous selectable option.
   *
   * @internal
   * @remarks
   * Overrides `Listbox.selectPreviousOption`
   */
  selectPreviousOption() {
    !this.disabled && this.selectedIndex >= 0 && (this.selectedIndex = this.selectedIndex - 1);
  }
  /**
   * Set the default selected options at initialization or reset.
   *
   * @internal
   * @remarks
   * Overrides `Listbox.setDefaultSelectedOption`
   */
  setDefaultSelectedOption() {
    var Ae;
    if (this.$fastController.isConnected && this.options) {
      const xr = this.options.findIndex(
        (ed) => ed.getAttribute("selected") !== null || ed.selected
      );
      this.selectedIndex = xr, !this.dirtyValue && this.firstSelectedOption ? this.value = ((Ae = this.firstSelectedOption) == null ? void 0 : Ae.getTextContent()) || this.firstSelectedOption.text : (this.options.forEach((ed) => ed.selected = !1), this.value = ""), this.setSelectedOptions();
    }
  }
  /**
   * Focus and set the content of the control based on the first selected option.
   *
   * @internal
   */
  setInputToSelection() {
    var Ae;
    this.firstSelectedOption && (this.control.value = (Ae = this.firstSelectedOption.getTextContent()) != null ? Ae : this.firstSelectedOption.text, this.control.focus());
  }
  /**
   * Focus, set and select the content of the control based on the first selected option.
   *
   * @internal
   */
  setInlineSelection() {
    this.firstSelectedOption && (this.setInputToSelection(), this.control.setSelectionRange(
      this.filter.length,
      this.control.value.length,
      "backward"
    ));
  }
  /**
     * Determines if a value update should involve emitting a change event, then updates the value.
     *
     * @internal
     */
  syncValue() {
    var xr;
    const Ae = this.selectedIndex > -1 ? (xr = this.firstSelectedOption) == null ? void 0 : xr.getTextContent() : this.control.value;
    this.updateValue(this.value !== Ae);
  }
  /**
   * Calculate and apply listbox positioning based on available viewport space.
   *
   * @public
   */
  setPositioning() {
    var Ae;
    if (this.$fastController.isConnected) {
      const xr = (Ae = this.shadowRoot) == null ? void 0 : Ae.querySelector('[data-testid="control"]');
      let ed = 0;
      DOM.queueUpdate(() => {
        const id = this.listbox.getOptions();
        ed = this.listbox.setMaxHeight(id);
      }), this.cleanup = autoUpdate(this, this.listbox, async () => {
        var nd;
        const { middlewareData: id, placement: od, x: ad, y: rd } = await computePosition(
          xr,
          this.listbox,
          {
            placement: "bottom",
            strategy: "fixed",
            middleware: [
              flip(),
              size({
                apply: ({ rects: cd }) => {
                  Object.assign(this.listbox.style, {
                    maxHeight: `${ed}px`,
                    width: `${cd.reference.width}px`
                  });
                }
              }),
              hide()
            ]
          }
        ), sd = od === "top" ? "above" : "below";
        if (sd !== this.position && (this.position = sd), (nd = id.hide) != null && nd.referenceHidden) {
          this.open = !1, this.cleanup();
          return;
        }
        Object.assign(this.listbox.style, {
          position: "fixed",
          top: "0",
          left: "0",
          transform: `translate(${ad}px, ${rd + (this.position === "below" ? 2 : -2)}px)`
        });
      });
    }
  }
  /**
   * Ensure that the entire list of options is used when setting the selected property.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @internal
   * @remarks
   * Overrides: `Listbox.selectedOptionsChanged`
   */
  selectedOptionsChanged(Ae, xr) {
    this.$fastController.isConnected && this._options.forEach((ed) => {
      ed.selected = xr.includes(ed);
    });
  }
  /**
   * Synchronize the form-associated proxy and update the value property of the element.
   *
   * @param prev - the previous collection of slotted option elements
   * @param next - the next collection of slotted option elements
   *
   * @internal
   */
  slottedOptionsChanged(Ae, xr) {
    super.slottedOptionsChanged(Ae, xr);
    const ed = xr.filter((id) => isOptionGroup(id));
    if (this.groupOptions = ed, ed.length > 0) {
      let id = [];
      ed.forEach((od) => {
        id = [...id, ...od.children];
      }), this.options = [...this.options, ...id];
    }
    this.updateValue();
  }
  /**
   * Sets the value and to match the first selected option.
   *
   * @param shouldEmit - if true, the change event will be emitted
   *
   * @internal
   */
  updateValue(Ae) {
    var xr, ed;
    this.$fastController.isConnected && (this.value = (ed = (xr = this.firstSelectedOption) == null ? void 0 : xr.getTextContent()) != null ? ed : this.control.value, this.control.value = this.value), Ae && this.$emit("change");
  }
  /**
   * @internal
   */
  clearSelectionRange() {
    const Ae = this.control.value.length;
    this.control.setSelectionRange(Ae, Ae);
  }
  updateComputedStylesheet() {
    DOM.queueUpdate(() => {
      this.$fastController.removeStyles(this.computedStylesheet);
      const Ae = this.combobox ? getComputedStyle(this.combobox).width : "100px";
      this.computedStylesheet = css`
        :host {
          --input-width: ${Ae};
        }
      `, this.$fastController.addStyles(this.computedStylesheet);
    });
  }
}
__decorateClass$P([
  attr({ attribute: "autocomplete", mode: "fromView" })
], Combobox.prototype, "autocomplete", 2);
__decorateClass$P([
  attr({ attribute: "error" })
], Combobox.prototype, "error", 2);
__decorateClass$P([
  attr({ attribute: "help-label" }),
  attr({ attribute: "helplabel" })
], Combobox.prototype, "helpLabel", 2);
__decorateClass$P([
  attr({ attribute: "input-size" }),
  attr({ attribute: "inputsize" })
], Combobox.prototype, "inputSize", 2);
__decorateClass$P([
  attr({ attribute: "label" })
], Combobox.prototype, "label", 2);
__decorateClass$P([
  attr({ attribute: "no-result-label" }),
  attr({ attribute: "noresultlabel" })
], Combobox.prototype, "noResultLabel", 2);
__decorateClass$P([
  attr({ attribute: "position" })
], Combobox.prototype, "position", 2);
__decorateClass$P([
  attr({ attribute: "size" })
], Combobox.prototype, "size", 2);
__decorateClass$P([
  observable
], Combobox.prototype, "hasNoResult", 2);
__decorateClass$P([
  observable
], Combobox.prototype, "userInput", 2);
__decorateClass$P([
  observable
], Combobox.prototype, "hasBeenTouched", 2);
__decorateClass$P([
  observable
], Combobox.prototype, "groupOptions", 2);
__decorateClass$P([
  attr({ attribute: "open", mode: "boolean" })
], Combobox.prototype, "open", 2);
__decorateClass$P([
  attr
], Combobox.prototype, "placeholder", 2);
class DelegatesARIACombobox {
}
__decorateClass$P([
  observable
], DelegatesARIACombobox.prototype, "ariaAutoComplete", 2);
__decorateClass$P([
  observable
], DelegatesARIACombobox.prototype, "ariaControls", 2);
const isOptionGroup = (td) => td.nodeName.toUpperCase() === "TM1-OPTIONS-GROUP" || td.nodeName.toUpperCase() === "TM1-LIST-ITEMS-GROUP";
applyMixins(DelegatesARIACombobox, DelegatesARIAListbox);
applyMixins(Combobox, StartEnd, DelegatesARIACombobox);
function getRootActiveElement(td) {
  const Ae = td.getRootNode();
  return Ae instanceof ShadowRoot ? Ae.activeElement : document.activeElement;
}
const tm1Combobox = Combobox.compose({
  baseName: "combobox",
  template: tm1ComboboxTemplate,
  styles: tm1ComboboxStyles,
  shadowOptions: {
    delegatesFocus: !0
  },
  indicator: `
    <svg class="svg-indicator" viewBox="0 0 16 16">
      <path d="M3.278 5.459A.75.75 0 0 0 2.221 6.52l5.263 5.24a.75.75 0 0 0 1.059 0l5.237-5.24a.75.75 0 0 0-1.06-1.06l-4.71 4.711L3.278 5.46z"/>
    </svg>
  `
});
designSystem.register(
  tm1Combobox()
);
const tm1CopyActionStyles = () => css`
  :host {
    position: relative;
  }

  .hidden {
    display: none;
  }

  .content {
    width: fit-content;
    display: flex;
    align-items: center;
  }

  .icon {
    margin-right: ${GDSESpacing50};
  }

  .message {
    display: flex;
    align-items: center;
  }

  .message svg {
    margin-right: var(--spacing-slim);
  }
`, tooltipTemplate = (td) => html`
  <${td.tagFor(Tooltip$1)}
    anchor="${(Ae) => Ae.anchor}"
    position="top"
  >
    <slot
      name="default"
      :className="${(Ae) => Ae.tooltipState !== "ready" ? "hidden" : ""}"
    >
      Click to Copy
    </slot>
    <slot
      name="success"
      :className="${(Ae) => Ae.tooltipState !== "success" ? "hidden" : ""}"
    >
      <span class="message">
        <${td.tagFor(Icon)} class='icon' icon='success' size='small'></${td.tagFor(Icon)}> Copied to Clipboard
      </span>
    </slot>
    <slot
      name="failure"
      :className="${(Ae) => Ae.tooltipState !== "failure" ? "hidden" : ""}"
    >
      <span class="message">
         <${td.tagFor(Icon)} class='icon' icon='error' size='small'></${td.tagFor(Icon)}> Please try again
      </span>
    </slot>
  </${td.tagFor(Tooltip$1)}>
`, tm1CopyActionTemplate = (td) => html`
  <div
    class="content"
    part="content"
    id="${(Ae) => Ae.anchor}"
    @click=${(Ae) => Ae.copyToClipboard()}
  >
    <slot></slot>
  </div>
  ${when(
  (Ae) => Ae.enableTooltip,
  () => tooltipTemplate(td)
)}
`;
var __defProp$O = Object.defineProperty, __getOwnPropDesc$O = Object.getOwnPropertyDescriptor, __decorateClass$O = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$O(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$O(Ae, xr, id), id;
};
class Tm1CopyAction extends FoundationElement {
  constructor() {
    super(...arguments), this.autocloseDelay = 2e3, this.enableTooltip = !0, this.anchor = "", this.tooltipState = "ready";
  }
  reset() {
    clearTimeout(this.autocloseId), this.$emit("status", "ready"), this.tooltipState = "ready", this.autocloseId = void 0;
  }
  async copyToClipboard() {
    this.reset();
    try {
      if (navigator.clipboard && isSecureContext())
        await navigator.clipboard.writeText(this.data), this.tooltipState = "success", this.$emit("status", "success");
      else
        throw Error("Website not safe");
    } catch (Ae) {
      console.error(Ae), this.tooltipState = "failure", this.$emit("status", "failure");
    }
    this.autocloseDelay && (this.autocloseId = setTimeout(() => this.reset(), this.autocloseDelay));
  }
}
__decorateClass$O([
  attr
], Tm1CopyAction.prototype, "data", 2);
__decorateClass$O([
  attr
], Tm1CopyAction.prototype, "autocloseDelay", 2);
__decorateClass$O([
  attr({ mode: "boolean" })
], Tm1CopyAction.prototype, "enableTooltip", 2);
__decorateClass$O([
  attr
], Tm1CopyAction.prototype, "anchor", 2);
__decorateClass$O([
  observable
], Tm1CopyAction.prototype, "tooltipState", 2);
const tm1CopyAction = Tm1CopyAction.compose({
  baseName: "copy-action",
  template: tm1CopyActionTemplate,
  styles: tm1CopyActionStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1CopyAction()
);
const mobileStylesheetBehavior$2 = new MatchMediaStyleSheetBehavior(
  matchMedia("(max-width: 767px)"),
  css`
    :host {
      margin: 0 ${GDSESpacing50};
    }
  `
), tm1DataGridStyles = () => css`
    :host {
      display: grid;
      position: relative;
      margin: 0 ${GDSESpacing300};
    }
  `.withBehaviors(mobileStylesheetBehavior$2);
class DataGrid extends DataGrid$1 {
}
const tm1DataGrid = DataGrid.compose({
  baseName: "data-grid",
  baseClass: DataGrid$1,
  template: dataGridTemplate,
  styles: tm1DataGridStyles
}), tm1DataGridCellStyles = () => css`
  :host {
    font-family: ${GDSEFontFamily};
    font-size: ${GDSEFontSize2};
    line-height: ${GDSELineHeightBody};

    background: ${GDSEColorSurface};
    border: 1px solid ${GDSEColorBorder};

    box-sizing: border-box;
    overflow: hidden;
    padding: ${GDSESpacing150};
  }
`;
class DataGridCell extends DataGridCell$1 {
  constructor() {
    super(...arguments), this.inputs = [];
  }
  connectedCallback() {
    super.connectedCallback(), setTimeout(() => this.inputs = getFocusableInputs(), 1e3);
  }
  handleKeydown(Ae) {
    var ad;
    super.handleKeydown(Ae);
    const xr = Ae.target.shadowRoot.querySelector("input"), ed = xr == null ? void 0 : xr.value.length, id = getActiveElIndex(), od = ((ad = this.inputs[id]) == null ? void 0 : ad.nodeName) === "TM1-DATA-GRID" ? this.inputs[id] : this.inputs[id + 1];
    if (Ae.key === keyArrowLeft && Ae.target.nodeName === (od == null ? void 0 : od.nodeName)) {
      Ae.preventDefault();
      const rd = xr.selectionStart - 1;
      rd !== -1 ? xr.setSelectionRange(rd, rd) : rd === -1 && xr.selectionStart !== xr.selectionEnd ? xr.setSelectionRange(0, 0) : od == null || od.focus();
    } else if (Ae.key === keyArrowRight && Ae.target.nodeName === (od == null ? void 0 : od.nodeName)) {
      Ae.preventDefault();
      const rd = (xr == null ? void 0 : xr.selectionStart) + 1;
      xr.selectionStart !== xr.selectionEnd ? xr.setSelectionRange(ed, ed) : rd <= ed ? xr.setSelectionRange(rd, rd) : od == null || od.focus();
    }
  }
}
const tm1DataGridCell = DataGridCell.compose({
  baseName: "data-grid-cell",
  baseClass: DataGridCell$1,
  template: dataGridCellTemplate,
  styles: tm1DataGridCellStyles
}), tm1DataGridRowStyles = () => css`
    :host {
      display: grid;
      box-sizing: border-box;
      width: 100%;
      word-wrap: break-word;
    }

    :host([row-type='sticky-header']) {
      position: sticky;
      top: 0;
      z-index: 1;
    }

    :host([row-type='header']) ::slotted([cell-type='columnheader']),
    :host([row-type='sticky-header']) ::slotted([cell-type='columnheader']) {
      font-size: ${GDSEFontSize3};
      font-weight: ${GDSEFontWeightSemiBold};
      line-height: 1.25;

      background: ${GDSEColorSurfaceAlt};
    }

    ::slotted(tm1-data-grid-cell:not(:first-child)) {
      border-left: ${GDSERadiusSharp};
    }

    ::slotted(tm1-data-grid-cell:not([cell-type='columnheader'])) {
      border-top: ${GDSERadiusSharp};
    }
  `;
class DataGridRow extends DataGridRow$1 {
}
const tm1DataGridRow = DataGridRow.compose({
  baseName: "data-grid-row",
  baseClass: DataGridRow$1,
  template: dataGridRowTemplate,
  styles: tm1DataGridRowStyles
});
designSystem.register(
  tm1DataGrid(),
  tm1DataGridCell(),
  tm1DataGridRow()
);
const tm1DividerStyles = css`
  :host {
    border-left: none;
    border-top: 1px solid ${GDSEColorBorder};
    box-sizing: content-box;
    display: block;
    height: 0;
    margin: ${GDSESpacing50} ${GDSESpacing0};
  }

  :host([orientation='vertical']) {
    border-top: none;
    border-left: 1px solid ${GDSEColorBorder};
    height: 100%;
    margin: ${GDSESpacing0} ${GDSESpacing50};
  }
`;
class Divider extends Divider$1 {
}
const tm1Divider = Divider.compose({
  baseName: "divider",
  baseClass: Divider$1,
  template: dividerTemplate,
  styles: tm1DividerStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Divider()
);
const tm1SkeletonStyles = () => css`
  :host {
    display: grid;
    gap: ${GDSESpacing200};
    position: relative;
    border-radius: ${GDSERadiusSurface};
    background-color: ${GDSEColorFillHoveredLight};
    overflow: hidden;
  }

  :host([shape='circle']) {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    overflow: hidden;
  }

  :host::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: ${GDSEColorSkeletonShimmer};
    content: '';
  }

  :host([shimmer])::after {
    animation: shimmer 1.2s infinite;
  }

  :host([shape='rect']:not([hasSvg])) {
    height: 100%;
    min-height: 10px;
  }

  :host([shape='rect']:not([hasSvg])) {
    height: 1em;
  }

  object {
    position: absolute;
    z-index: 2;
  }

  svg {
    z-index: 2;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`, tm1SkeletonTemplate = () => html`
  <template pattern="${(td) => td.pattern}" ?shimmer="${(td) => td.shimmer}">
    ${when((td) => td.shimmer === !0, html` <span class="shimmer"></span> `)}
    <object type="image/svg+xml" data="${(td) => td.pattern}" role="presentation">
      <img class="pattern" src="${(td) => td.pattern}" />
    </object>
    <slot></slot>
  </template>
`;
class Skeleton extends Skeleton$1 {
}
const tm1Skeleton = Skeleton.compose({
  baseName: "skeleton",
  baseClass: Skeleton$1,
  template: tm1SkeletonTemplate,
  styles: tm1SkeletonStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Skeleton()
);
const tm1DataRefreshChipStyles = css`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  :host .container {
    display: flex;
    align-items: center;
    color: ${GDSEColorText};
    height: 14px;
    gap: ${GDSESpacing100};
    width: max-content;
  }

  :host .content {
    width: max-content;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: rtl;
  }

  :host .content.ltr {
    direction: ltr;
  }

  :host([theme='dark']) .content {
    font-weight: ${GDSEFontWeightThin};
  }

  :host .hidden {
    display: none;
  }

  :host tm1-skeleton {
    width: 165px;
  }

  :host tm1-divider {
    margin: ${GDSESpacing0};
  }

  :host .icon-wrapper {
    display: flex;
    width: ${GDSESpacing200};
  }

  :host tm1-button {
    min-height: auto;
  }

  :host tm1-button tm1-icon.loading {
    animation: spin 4s infinite linear;
  }

  :host tm1-icon {
    cursor: pointer;
    color: ${GDSEColorTextLight};
  }

  :host([error]) tm1-icon {
    color: ${GDSEColorTextCritical};
  }

  .tooltip {
    position: fixed;
  }

  /* Remove lightweight button padding */
  ::part(control) {
    padding: ${GDSESpacing0};
  }

  tm1-button:hover {
    background: transparent;
  }
`, tm1DataRefreshChipTemplate = (td) => {
  const Ae = html`<${td.tagFor(
    Skeleton
  )} data-testid="data-refresh-chip-skeleton" shape="rect" shimmer></${td.tagFor(Skeleton)}>`, xr = html`
    <${td.tagFor(Typography)}
      className="content${(rd) => rd != null && rd.text && rd.text.match(/^\d+/) !== null ? " ltr" : ""}"
      type="label-ui-l"
      ignore-line-height
    >${(rd) => rd.text}</${td.tagFor(Typography)}>`, ed = html`
    <${td.tagFor(Icon)}
      id=${(rd) => rd.tooltipAnchor}
      data-testid="data-refresh-chip-info-icon"
      size="small"
      icon="info"
      :className=${(rd) => rd.tooltipAnchor || rd.error ? "" : "hidden"}
    >
    </${td.tagFor(Icon)}>
  `, id = html`
    <${td.tagFor(Button)}
      icon-position="only-icon"
      variant="lightweight"
      icon="refresh"
      ?disabled="${(rd) => rd.loading}"
      @click="${(rd) => rd.clickHandler()}"
    >
    </${td.tagFor(Button)}>`, od = html`<${td.tagFor(Divider)} orientation="vertical"></${td.tagFor(Divider)}>`, ad = html`
    <${td.tagFor(Tooltip$1)} anchor=${(rd) => rd.tooltipAnchor} class="tooltip" position="bottom">
      <slot name="tooltip"></slot>
    </${td.tagFor(Tooltip$1)}>`;
  return html`<template theme=${(rd) => rd.theme}>
    <div part="container" class="container">
      ${(rd) => rd.loading ? Ae : xr} ${ed} ${od} ${id} ${ad}
    </div>
  </template>`;
};
var __defProp$N = Object.defineProperty, __getOwnPropDesc$N = Object.getOwnPropertyDescriptor, __decorateClass$N = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$N(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$N(Ae, xr, id), id;
};
class DataRefreshChip extends FoundationElement {
  constructor() {
    super(...arguments), this.loading = !1, this.error = !1, this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
  clickHandler() {
    this.$emit("refresh");
  }
}
__decorateClass$N([
  attr()
], DataRefreshChip.prototype, "tooltipAnchor", 2);
__decorateClass$N([
  attr({ mode: "boolean" })
], DataRefreshChip.prototype, "loading", 2);
__decorateClass$N([
  attr({ mode: "boolean" })
], DataRefreshChip.prototype, "error", 2);
__decorateClass$N([
  attr()
], DataRefreshChip.prototype, "text", 2);
__decorateClass$N([
  observable
], DataRefreshChip.prototype, "theme", 2);
const tm1DataRefreshChip = DataRefreshChip.compose({
  baseName: "data-refresh-chip",
  template: tm1DataRefreshChipTemplate,
  styles: tm1DataRefreshChipStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1DataRefreshChip()
);
const tm1TextFieldStyles = () => css`
  :host {
    outline: none;
    user-select: none;
    width: 100%;
    ${textFieldSizeRegular}
  }

  :host([input-size='small']),
  :host([input-size='small']) input,
  :host([inputsize='small']),
  :host([inputsize='small']) input {
    ${textFieldSizeSmall}
  }

  :host([input-size='regular']),
  :host([input-size='regular']) input,
  :host([inputsize='regular']),
  :host([inputsize='regular']) input {
    ${textFieldSizeRegular}
  }

  :host([input-size='large']),
  :host([input-size='large']) input,
  :host([inputsize='large']),
  :host([inputsize='large']) input {
    ${textFieldSizeLarge}
  }

  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .root {
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: row;
    color: ${GDSEColorText};
    align-items: baseline;

    padding: var(--padding);
    border-radius: ${GDSERadiusInput};
    border: solid 1px ${GDSEColorBorderInputDefault};
    background-color: ${GDSEColorFillInput};
    height: var(--input-size);
  }

  .label {
    display: block;
    color: ${GDSEColorText};
    margin-bottom: ${GDSESpacing25};
    line-height: ${GDSELineHeightBody};
  }

  .error,
  .helper {
    margin-top: ${GDSESpacing25};
    margin-bottom: ${GDSESpacing0};
  }

  .error {
    color: ${GDSEColorTextCritical};
    display: flex;
    align-items: center;
    gap: ${GDSESpacing25};
  }

  .character-count,
  .helper {
    color: ${GDSEColorTextLight};
  }

  .control {
    display: flex;
    align-items: center;
    width: 100%;
  }

  input,
  input:disabled,
  input:focus {
    font-family: ${GDSEFontFamily};
    -webkit-appearance: none;
    background: transparent;
    color: inherit;
    height: 100%;
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;

    border: none;
    outline: none;
    box-sizing: border-box;
    line-height: var(--line-height);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  input:disabled {
    cursor: not-allowed;
  }

  .start,
  .control,
  .end {
    align-self: center;
  }

  .start,
  .end {
    display: flex;
    margin: auto;
    fill: currentcolor;
  }

  .start {
    padding-right: 9px;
  }

  .end {
    padding-left: 9px;
  }

  ::slotted(svg) {
    /* TODO: adaptive typography https://github.com/microsoft/fast/issues/2432 */
    width: 16px;
    height: 16px;
  }

  :host(:not([disabled]):not([readonly])) .root:has(input[aria-invalid='true']) {
    border-color: ${GDSEColorBorderCritical};
  }

  :host(:not([disabled]):not([readonly])) .root:hover {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host(:not([disabled]):not([readonly]):focus) .root,
  :host(:not([disabled]):not([readonly]):active) .root {
    border-color: ${GDSEColorBorderInputActive};
  }

  :host([disabled]),
  :host([readonly]),
  :host([disabled]) .label,
  :host([readonly]) .label,
  :host([readonly]) .root,
  :host([disabled]) .root,
  :host([readonly]) .control,
  :host([disabled]) .control {
    cursor: not-allowed;
  }

  :host([readonly]) .root {
    border: none;
    background: transparent;
    padding: ${GDSESpacing0};
  }

  :host([disabled]) .root {
    border: 1px solid ${GDSEColorBorderInputDisabled};
    background-color: ${GDSEColorFillInputDisabled};
  }

  :host([disabled]) .control,
  :host([disabled]) input::placeholder {
    font-family: ${GDSEFontFamily};
    color: ${GDSEColorTextDisabled};
  }

  :host input::placeholder {
    color: ${GDSEColorTextMuted};
  }

  :host([labelposition='top']) .label {
    display: block;
  }

  :host([labelposition='top']) .root {
    display: flex;
  }

  :host([labelposition='left']) {
    display: inline-flex;
  }

  :host([labelposition='left']) .label {
    display: inline-flex;
    padding-top: var(--label-padding);
    margin-right: ${GDSESpacing100};
    min-width: fit-content;
  }

  :host([labelposition='left']) .root {
    display: inline-flex;
    width: 100%;
  }

  :host input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  .input-typography {
    width: inherit;
  }
`, textFieldSizeSmall = cssPartial`
  --line-height: 21px;
  --input-size: 28px;
  --label-padding: 7px;
  --padding: ${GDSESpacingInputVerS} ${GDSESpacingInputHorS};
`, textFieldSizeRegular = cssPartial`
  --line-height: 21px;
  --input-size: 36px;
  --input-horizontal-padding: ${GDSESpacing150};
  --label-padding: 10px;
  --padding: ${GDSESpacingInputVerM}  ${GDSESpacingInputHorM};
`, textFieldSizeLarge = cssPartial`
--line-height: 24px;
  --input-size: 44px;
  --line-height: 24px;
  --label-padding: 12px;
  --padding: ${GDSESpacingInputVerL} ${GDSESpacingInputHorL};
`, tm1TextFieldTemplate = (td, Ae) => html`
  ${when(
  (xr) => xr.hasLabel(),
  html`<${td.tagFor(Typography)} class="label" type="label-helpertext-regular" data-testid="label">
      <label part="label" for="${(xr) => xr.defaultId()}">
        ${(xr) => xr.label ? xr.label : html`<slot ${slotted("defaultSlottedNodes")}></slot>`}
      </label>
    </${td.tagFor(Typography)}>`
)}

  <div class="container">
    <div part="root" class="root" data-testid="root">
      <div part="control" class="control">
        <${td.tagFor(Typography)}
          tag="span"
          type="label-helpertext-regular"
        >
          ${startSlotTemplate(td, Ae)}
        </${td.tagFor(Typography)}>

      <${td.tagFor(Typography)} data-testid="input-Typography" type="${(xr) => {
  var ed;
  return xr.textType()[(ed = xr.inputSize) != null ? ed : "regular"];
}}" class="input-typography">
        <input
          id="${(xr) => xr.defaultId()}"
          class="${(xr) => `${xr.className}`}"
          :start="${(xr) => xr.start}"
          :end="${(xr) => xr.end}"
          :placeholder="${(xr) => {
  var ed;
  return (ed = xr.placeholder) != null ? ed : "";
}}"
          aria-atomic="${(xr) => {
  var ed;
  return (ed = xr.ariaAtomic) != null ? ed : !1;
}}"
          aria-busy="${(xr) => {
  var ed;
  return (ed = xr.ariaBusy) != null ? ed : !1;
}}"
          aria-controls="${(xr) => {
  var ed;
  return (ed = xr.ariaControls) != null ? ed : xr.defaultId();
}}"
          aria-current="${(xr) => {
  var ed;
  return (ed = xr.ariaCurrent) != null ? ed : null;
}}"
          aria-describedby="${(xr) => xr.ariaDescribedby}"
          aria-details="${(xr) => xr.ariaDetails}"
          aria-disabled="${(xr) => {
  var ed;
  return (ed = xr.ariaDisabled || xr.disabled) != null ? ed : !1;
}}"
          aria-errormessage="${(xr) => xr.errorDefaultId()}"
          aria-flowto="${(xr) => xr.ariaFlowto}"
          aria-haspopup="${(xr) => {
  var ed;
  return (ed = xr.ariaHaspopup) != null ? ed : !1;
}}"
          aria-hidden="${(xr) => {
  var ed;
  return (ed = xr.ariaHidden) != null ? ed : !1;
}}"
          aria-invalid="${(xr) => !!xr.errorLabel}"
          aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
          aria-label="${(xr) => {
  var ed;
  return (ed = xr.ariaLabel || xr.label) != null ? ed : "";
}}"
          aria-labelledby="${(xr) => xr.ariaLabelledby}"
          aria-live="${(xr) => {
  var ed;
  return (ed = xr.ariaLive) != null ? ed : !1;
}}"
          aria-owns="${(xr) => xr.ariaOwns}"
          aria-relevant="${(xr) => {
  var ed;
  return (ed = xr.ariaRelevant) != null ? ed : "additions text";
}}"
          aria-roledescription="${(xr) => xr.ariaRoledescription}"
          ?autofocus="${(xr) => {
  var ed;
  return (ed = xr.autofocus) != null ? ed : !1;
}}"
          ?disabled="${(xr) => {
  var ed;
  return (ed = xr.disabled) != null ? ed : !1;
}}"
          ?readonly="${(xr) => {
  var ed;
  return (ed = xr.readOnly) != null ? ed : !1;
}}"
          ?required="${(xr) => {
  var ed;
  return (ed = xr.required) != null ? ed : !1;
}}"
          ?spellcheck="${(xr) => {
  var ed;
  return (ed = xr.spellcheck) != null ? ed : !1;
}}"
          list="${(xr) => {
  var ed;
  return (ed = xr.list) != null ? ed : null;
}}"
          maxlength="${(xr) => xr.maxlength}"
          minlength="${(xr) => xr.minlength}"
          name="${(xr) => xr.name}"
          pattern="${(xr) => xr.pattern}"
          role="${(xr) => xr.inSearch ? "searchbox" : xr.role}"
          size="${(xr) => xr.size}"
          tabindex="${(xr) => xr.disabled ? null : 0}"
          type="${(xr) => {
  var ed;
  return (ed = xr.type) != null ? ed : "text";
}}"
          value="${(xr) => xr.value}"
          part="input"
          data-testid="text-field"
          @input="${(xr) => xr.handleTextInput()}"
          @change="${(xr) => xr.handleChange()}"
          @blur="${(xr) => xr.handleBlur()}"
          ${ref("control")}
        />
      </${td.tagFor(Typography)}>

        <${td.tagFor(Typography)}
          tag="span"
          type="label-helpertext-regular"
        >
          ${endSlotTemplate(td, Ae)}
        </${td.tagFor(Typography)}>
      </div>
    </div>

    ${when(
  (xr) => !!xr.errorLabel && !xr.readOnly && !xr.disabled,
  html`<div class="error" role="alert">
        <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
        <${td.tagFor(Typography)} type="label-helpertext-regular" id="${(xr) => xr.errorDefaultId()}">
          ${(xr) => xr.errorLabel}
        </${td.tagFor(Typography)}>
      </div>`
)}

    ${when((xr) => xr.showCharacterCount && !xr.errorLabel && !xr.readOnly && !!xr.maxlength, html`
      <${td.tagFor(Typography)} data-testid="character-count" type="label-helpertext-regular" class="character-count">${(xr) => xr.getCharactersLeft()} ${(xr) => xr.characterCountLabel}</${td.tagFor(Typography)}>
    `)}

    ${when(
  (xr) => !!xr.helpLabel && !xr.errorLabel && !xr.readOnly && !xr.showCharacterCount,
  html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="helper" data-testid="helper">${(xr) => xr.helpLabel}</${td.tagFor(Typography)}>`
)}
  </div>
`;
var __defProp$M = Object.defineProperty, __getOwnPropDesc$M = Object.getOwnPropertyDescriptor, __decorateClass$M = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$M(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$M(Ae, xr, id), id;
};
class TextField extends TextField$1 {
  constructor() {
    super(...arguments), this.inputSize = "regular", this.labelPosition = "top", this.showCharacterCount = !1, this.characterCountLabel = "character(s) left", this.inSearch = !1, this.readOnly = !1, this.tabIndex = 0, this.firstRender = !0, this.hasBlurred = !1, this.hasLabel = () => {
      var Ae;
      return !!this.label || ((Ae = this.defaultSlottedNodes) == null ? void 0 : Ae.length) !== 0;
    }, this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" }), this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.getCharactersLeft = () => {
      var Ae;
      return (this.maxlength - ((Ae = this.value) == null ? void 0 : Ae.length)).toString();
    }, this.handleKeyDown = (Ae) => {
      const xr = Ae.key;
      (xr === keyArrowLeft || xr === keyArrowRight || xr === keyArrowUp || xr === keyArrowDown) && Ae.stopPropagation();
    };
  }
  errorChanged() {
    this.proxy instanceof HTMLInputElement && this.valueChanged("", this.value);
  }
  valueChanged(Ae, xr) {
    super.valueChanged(Ae, xr), DOM.queueUpdate(() => {
      this.control && (this.validate(), this.control.value = xr, this.hasError());
    });
  }
  select() {
    super.select();
  }
  hasError() {
    var xr, ed, id, od, ad, rd;
    if (this.validateOnBlur ? this.control && this.hasBlurred : this.control) {
      const sd = ((xr = this.control.checkValidity()) != null ? xr : !0) === !1 || !!this.error || ((ed = this.value) == null ? void 0 : ed.length) < this.minlength && !this.firstRender || ((id = this.value) == null ? void 0 : id.length) < this.minlength && !!this.value || this.required && !((od = this.value) != null && od.trim());
      if (this.classList.toggle("invalid", sd), this.control.ariaInvalid = sd.toString(), this.firstRender = !1, sd)
        return this.control.validationMessage && ((ad = this.elementInternals) == null || ad.setValidity(this.control.validity, this.control.validationMessage, this.control)), this.error ? this.errorLabel = this.error : ((rd = this.value) == null ? void 0 : rd.length) < this.minlength ? this.errorLabel = this.minLengthError || void 0 : this.errorLabel = this.patternError || void 0, !0;
      this.errorLabel = void 0;
    }
    return !1;
  }
  handleBlur() {
    this.hasBlurred = !0, this.hasError(), this.$emit("blur");
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("keydown", this.handleKeyDown), DOM.queueUpdate(() => {
      this.error && this.hasError();
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("keydown", this.handleKeyDown);
  }
  formResetCallback() {
    super.formResetCallback(), this.control && (this.value = "", this.control.value = "");
  }
}
__decorateClass$M([
  attr({ attribute: "input-size" }),
  attr({ attribute: "inputsize" })
], TextField.prototype, "inputSize", 2);
__decorateClass$M([
  attr()
], TextField.prototype, "label", 2);
__decorateClass$M([
  attr({ attribute: "label-position" }),
  attr({ attribute: "labelposition" })
], TextField.prototype, "labelPosition", 2);
__decorateClass$M([
  attr({ attribute: "help-label" }),
  attr({ attribute: "helplabel" })
], TextField.prototype, "helpLabel", 2);
__decorateClass$M([
  attr({ mode: "boolean", attribute: "show-character-count" }),
  attr({ mode: "boolean", attribute: "showcharactercount" })
], TextField.prototype, "showCharacterCount", 2);
__decorateClass$M([
  attr({ attribute: "character-count-label" }),
  attr({ attribute: "charactercountlabel" })
], TextField.prototype, "characterCountLabel", 2);
__decorateClass$M([
  attr({ mode: "boolean", attribute: "in-search" }),
  attr({ mode: "boolean", attribute: "insearch" })
], TextField.prototype, "inSearch", 2);
__decorateClass$M([
  attr()
], TextField.prototype, "error", 2);
__decorateClass$M([
  attr({ attribute: "min-length-error" }),
  attr({ attribute: "minlengtherror" })
], TextField.prototype, "minLengthError", 2);
__decorateClass$M([
  attr({ attribute: "pattern-error" }),
  attr({ attribute: "patternerror" })
], TextField.prototype, "patternError", 2);
__decorateClass$M([
  attr({ mode: "boolean", attribute: "validate-on-blur" }),
  attr({ mode: "boolean", attribute: "validateonblur" })
], TextField.prototype, "validateOnBlur", 2);
__decorateClass$M([
  attr({ mode: "boolean", attribute: "read-only" }),
  attr({ mode: "boolean", attribute: "readonly" })
], TextField.prototype, "readOnly", 2);
__decorateClass$M([
  attr()
], TextField.prototype, "tabIndex", 2);
__decorateClass$M([
  observable
], TextField.prototype, "errorLabel", 2);
const tm1TextField = TextField.compose({
  baseName: "text-field",
  baseClass: TextField$1,
  template: tm1TextFieldTemplate,
  styles: tm1TextFieldStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1TextField()
);
const tm1TimePickerStyles = () => css`
  tm1-icon {
    margin-right: ${GDSESpacing50};
  }

  :host input::-webkit-calendar-picker-indicator {
    background: none;
    display: none;
  }

  :host(:focus) .control input {
    width: auto;
  }

  :host .control {
    width: auto;
    position: relative;
  }


  :host .control.empty .placeholder,
  :host .control.empty .meridian {
    color: ${GDSEColorTextMuted};
  }

  :host .control.empty .placeholder {
    margin: 0 ${GDSESpacing50};
  }

  :host(:focus) .control.empty .placeholder {
    display: none;
  }

  :host .empty input {
    width: 0;
  }

  :host([meridianType='12']) .control:not(.empty) .meridian,
  :host([meridianType='12']:focus) .control .meridian {
    color: ${GDSEColorText};
  }

  :host([disabled][meridianType='12']) .control:not(.empty) .meridian,
  :host([disabled][meridianType='12']:focus) .control:not(.empty) .meridian {
    color: ${GDSEColorTextDisabled};
  }

  :host input {
    font-family: ${GDSETypographyBodyMFontFamily};
    font-size: ${GDSETypographyBodyMFontSizeMobile};
    font-weight: ${GDSETypographyBodyMFontWeight};
    line-height: ${GDSETypographyBodyMLineHeight};
    letter-spacing: ${GDSETypographyBodyMLetterSpacing};
    font-feature: auto;
    text-transform: initial;
    text-decoration: initial;
  }

  ${tm1TextFieldStyles()};

  .root {
    align-items: center;
  }
`, tm1TimePickerTemplate = (td) => html`
<template @focus=${(Ae) => Ae.handleFocus()}>
  ${when(
  (Ae) => Ae.hasLabel(),
  html`<${td.tagFor(Typography)} class="label" type="label-helpertext-regular" data-testid="label">
      <label part="label" for="${(Ae) => Ae.defaultId()}">
        ${(Ae) => Ae.label ? Ae.label : html`<slot ${slotted("defaultSlottedNodes")}></slot>`}
      </label>
    </${td.tagFor(Typography)}>`
)}

  <div class="container">
    <div part="root" class="root" data-testid="root">
      <div part="control" class="${(Ae) => `control ${Ae.isEmpty ? "empty" : ""}`}">
        <${td.tagFor(Icon)} size="small" icon="time"></${td.tagFor(Icon)}>

        ${when((Ae) => Ae.isEmpty, html`<${td.tagFor(Typography)} type="body-m" class="placeholder" data-testid="placeholder">HH:MM</${td.tagFor(Typography)}>`)}

        <input
          id="${(Ae) => Ae.defaultId()}"
          class="${(Ae) => `${Ae.textType()[Ae.inputSize || "regular"]} ${Ae.className}`}"
          aria-atomic="${(Ae) => {
  var xr;
  return (xr = Ae.ariaAtomic) != null ? xr : !1;
}}"
          aria-busy="${(Ae) => {
  var xr;
  return (xr = Ae.ariaBusy) != null ? xr : !1;
}}"
          aria-controls="${(Ae) => {
  var xr;
  return (xr = Ae.ariaControls) != null ? xr : Ae.defaultId();
}}"
          aria-current="${(Ae) => {
  var xr;
  return (xr = Ae.ariaCurrent) != null ? xr : null;
}}"
          aria-describedby="${(Ae) => Ae.ariaDescribedby}"
          aria-details="${(Ae) => Ae.ariaDetails}"
          aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled || Ae.disabled) != null ? xr : !1;
}}"
          aria-errormessage="${(Ae) => Ae.errorDefaultId()}"
          aria-flowto="${(Ae) => Ae.ariaFlowto}"
          aria-haspopup="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHaspopup) != null ? xr : !1;
}}"
          aria-hidden="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHidden) != null ? xr : !1;
}}"
          aria-invalid="${(Ae) => !!Ae.errorLabel}"
          aria-keyshortcuts="${(Ae) => Ae.ariaKeyshortcuts}"
          aria-label="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLabel || Ae.label) != null ? xr : "";
}}"
          aria-labelledby="${(Ae) => Ae.ariaLabelledby}"
          aria-live="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLive) != null ? xr : !1;
}}"
          aria-owns="${(Ae) => Ae.ariaOwns}"
          aria-relevant="${(Ae) => {
  var xr;
  return (xr = Ae.ariaRelevant) != null ? xr : "additions text";
}}"
          aria-roledescription="${(Ae) => Ae.ariaRoledescription}"
          ?autofocus="${(Ae) => {
  var xr;
  return (xr = Ae.autofocus) != null ? xr : !1;
}}"
          ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
          ?readonly="${(Ae) => {
  var xr;
  return (xr = Ae.readOnly) != null ? xr : !1;
}}"
          ?required="${(Ae) => {
  var xr;
  return (xr = Ae.required) != null ? xr : !1;
}}"
          list="${(Ae) => {
  var xr;
  return (xr = Ae.list) != null ? xr : null;
}}"
          max="${(Ae) => Ae.max}"
          min="${(Ae) => Ae.min}"
          name="${(Ae) => Ae.name}"
          tabindex="${(Ae) => Ae.disabled ? null : 0}"
          type="time"
          value="${(Ae) => Ae.value}"
          @input="${(Ae) => Ae.handleInput()}"
          @change="${(Ae) => Ae.handleChange()}"
          ${ref("control")}
        />

        ${when((Ae) => +Ae.meridianType == 12, html`<${td.tagFor(Typography)} type="body-m" class="meridian" data-testid="meridian">${(Ae) => Ae.meridian.toUpperCase()}</${td.tagFor(Typography)}>`)}
      </div>
    </div>

    ${when(
  (Ae) => !!Ae.errorLabel && !Ae.readOnly,
  html`<div class="error" role="alert">
        <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
        <${td.tagFor(Typography)} tag="p" type="label-helpertext-regular" id="${(Ae) => Ae.errorDefaultId()}">
          ${(Ae) => Ae.errorLabel}
        </${td.tagFor(Typography)}>
      </div>`
)}
    </div>
</template>
`;
var __defProp$L = Object.defineProperty, __getOwnPropDesc$L = Object.getOwnPropertyDescriptor, __decorateClass$L = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$L(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$L(Ae, xr, id), id;
};
class TimePicker extends TextField {
  constructor() {
    var Ae, xr;
    super(...arguments), this.min = "", this.max = "", this.meridianType = 24, this.minutes = 0, this.customValue = "", this.meridian = "am", this.isEmpty = ((Ae = this.control) == null ? void 0 : Ae.value) === void 0 || ((xr = this.control) == null ? void 0 : xr.value) === "", this.handleKeyDown = (ed) => {
      const id = this.hour;
      ed.key === "a" && this.hour ? (this.meridian = "am", this.hour - 12 > 0 && (this.hour = this.hour - 12, this.customValue = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }))) : ed.key === "p" && this.hour && (this.meridian = "pm", this.hour + 12 <= 24 && (this.hour + 12 === 24 ? this.hour = 0 : this.hour = this.hour + 12, this.customValue = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }))), id !== this.hour && this.$emit("input");
    }, this.formattedTimeToString = ({ hour: ed = 0, minutes: id = 0 }) => `${ed.toString().padStart(2, "0")}:${id.toString().padStart(2, "0")}`;
  }
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      var Ae;
      if (+this.meridianType == 12) {
        if (this.min) {
          const [xr, ed] = this.min.toString().split(":").map(Number);
          xr > 12 && (this.min = this.formattedTimeToString({ hour: xr - 12, minutes: ed }));
        }
        if (this.max) {
          const [xr, ed] = this.max.toString().split(":").map(Number);
          xr > 12 && (this.max = this.formattedTimeToString({ hour: xr - 12, minutes: ed }));
        }
        this.hour && (this.hour > 12 && (this.meridian = "pm"), this.customValue = (Ae = this.convertTime12HTo24H(this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }))) != null ? Ae : "", this.value = this.formatTime12H(this.hour, this.minutes));
      } else
        this.hour && (this.customValue = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }), this.control.value = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }), this.value = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }));
    });
  }
  handleChange() {
    this.$emit("change");
  }
  setMeridian(Ae) {
    Ae >= 12 ? this.meridian = "pm" : this.meridian = "am";
  }
  formatTime12H(Ae, xr) {
    let ed = Ae;
    return ed > 12 && (ed -= 12), this.formattedTimeToString({ hour: ed, minutes: xr });
  }
  convertTime12HTo24H(Ae) {
    const xr = /^(\d{1,2}):(\d{2})$/i.exec(Ae);
    if (xr) {
      let [, ed, id] = xr.map(Number);
      ed = parseInt(ed.toString(), 10), id = parseInt(id.toString(), 10);
      const [od] = this.customValue.split(":").map(Number);
      return this.meridian === "pm" && ed < 12 && od !== 12 ? ed += 12 : this.meridian === "pm" && ed === 12 && od === 23 && (ed = 0), this.setMeridian(ed), this.hour !== ed && (this.hour = ed), this.minutes != id && (this.minutes = id), this.formattedTimeToString({ hour: ed, minutes: id });
    }
    return null;
  }
  setValue() {
    var Ae, xr;
    if ((Ae = this.control) != null && Ae.value)
      if (+this.meridianType == 12) {
        const ed = this.control.value.trim();
        if (this.customValue = (xr = this.convertTime12HTo24H(ed)) != null ? xr : "", this.customValue) {
          const [id, od] = this.customValue.split(":").map(Number);
          this.value = this.formatTime12H(id, od);
        }
      } else {
        const [ed, id] = this.control.value.split(":").map(Number);
        this.hour = ed, this.minutes = id, this.customValue = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes });
      }
    else
      this.isEmpty = !0, this.customValue = "";
  }
  handleInput() {
    this.setValue();
  }
  hourChanged(Ae, xr) {
    xr ? (Ae !== xr && (this.hour = xr, this.value = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes })), this.isEmpty = !1) : this.isEmpty = !0;
  }
  minutesChanged(Ae, xr) {
    xr && (xr < 0 ? this.minutes = 0 : xr > 59 && (this.minutes = 59), this.value = this.formattedTimeToString({ hour: this.hour, minutes: this.minutes }));
  }
  formResetCallback() {
    this.value = "";
  }
  handleFocus() {
    this.control.focus();
  }
}
__decorateClass$L([
  attr()
], TimePicker.prototype, "min", 2);
__decorateClass$L([
  attr()
], TimePicker.prototype, "max", 2);
__decorateClass$L([
  attr({ attribute: "meridian-type" }),
  attr({ attribute: "meridiantype" })
], TimePicker.prototype, "meridianType", 2);
__decorateClass$L([
  attr()
], TimePicker.prototype, "hour", 2);
__decorateClass$L([
  attr()
], TimePicker.prototype, "minutes", 2);
__decorateClass$L([
  observable
], TimePicker.prototype, "meridian", 2);
__decorateClass$L([
  observable
], TimePicker.prototype, "isEmpty", 2);
const tm1TimePicker = TimePicker.compose({
  baseName: "time-picker",
  template: tm1TimePickerTemplate,
  styles: tm1TimePickerStyles
});
designSystem.register(
  tm1TimePicker()
);
function isString(td) {
  return typeof td == "string" || td instanceof String;
}
function isObject$2(td) {
  var Ae;
  return typeof td == "object" && td != null && (td == null || (Ae = td.constructor) == null ? void 0 : Ae.name) === "Object";
}
function pick(td, Ae) {
  return Array.isArray(Ae) ? pick(td, (xr, ed) => Ae.includes(ed)) : Object.entries(td).reduce((xr, ed) => {
    let [id, od] = ed;
    return Ae(od, id) && (xr[id] = od), xr;
  }, {});
}
const DIRECTION = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function forceDirection(td) {
  switch (td) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return td;
  }
}
function escapeRegExp(td) {
  return td.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function objectIncludes(td, Ae) {
  if (Ae === td)
    return !0;
  const xr = Array.isArray(Ae), ed = Array.isArray(td);
  let id;
  if (xr && ed) {
    if (Ae.length != td.length)
      return !1;
    for (id = 0; id < Ae.length; id++)
      if (!objectIncludes(Ae[id], td[id]))
        return !1;
    return !0;
  }
  if (xr != ed)
    return !1;
  if (Ae && td && typeof Ae == "object" && typeof td == "object") {
    const od = Ae instanceof Date, ad = td instanceof Date;
    if (od && ad)
      return Ae.getTime() == td.getTime();
    if (od != ad)
      return !1;
    const rd = Ae instanceof RegExp, sd = td instanceof RegExp;
    if (rd && sd)
      return Ae.toString() == td.toString();
    if (rd != sd)
      return !1;
    const nd = Object.keys(Ae);
    for (id = 0; id < nd.length; id++)
      if (!Object.prototype.hasOwnProperty.call(td, nd[id]))
        return !1;
    for (id = 0; id < nd.length; id++)
      if (!objectIncludes(td[nd[id]], Ae[nd[id]]))
        return !1;
    return !0;
  } else if (Ae && td && typeof Ae == "function" && typeof td == "function")
    return Ae.toString() === td.toString();
  return !1;
}
class ActionDetails {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(Ae) {
    for (Object.assign(this, Ae); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? DIRECTION.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
  }
}
function IMask(td, Ae) {
  return new IMask.InputMask(td, Ae);
}
function maskedClass(td) {
  if (td == null)
    throw new Error("mask property should be defined");
  return td instanceof RegExp ? IMask.MaskedRegExp : isString(td) ? IMask.MaskedPattern : td === Date ? IMask.MaskedDate : td === Number ? IMask.MaskedNumber : Array.isArray(td) || td === Array ? IMask.MaskedDynamic : IMask.Masked && td.prototype instanceof IMask.Masked ? td : IMask.Masked && td instanceof IMask.Masked ? td.constructor : td instanceof Function ? IMask.MaskedFunction : (console.warn("Mask not found for mask", td), IMask.Masked);
}
function normalizeOpts(td) {
  if (!td)
    throw new Error("Options in not defined");
  if (IMask.Masked) {
    if (td.prototype instanceof IMask.Masked)
      return {
        mask: td
      };
    const {
      mask: Ae = void 0,
      ...xr
    } = td instanceof IMask.Masked ? {
      mask: td
    } : isObject$2(td) && td.mask instanceof IMask.Masked ? td : {};
    if (Ae) {
      const ed = Ae.mask;
      return {
        ...pick(Ae, (id, od) => !od.startsWith("_")),
        mask: Ae.constructor,
        _mask: ed,
        ...xr
      };
    }
  }
  return isObject$2(td) ? {
    ...td
  } : {
    mask: td
  };
}
function createMask(td) {
  if (IMask.Masked && td instanceof IMask.Masked)
    return td;
  const Ae = normalizeOpts(td), xr = maskedClass(Ae.mask);
  if (!xr)
    throw new Error("Masked class is not found for provided mask " + Ae.mask + ", appropriate module needs to be imported manually before creating mask.");
  return Ae.mask === xr && delete Ae.mask, Ae._mask && (Ae.mask = Ae._mask, delete Ae._mask), new xr(Ae);
}
IMask.createMask = createMask;
class MaskElement {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let Ae;
    try {
      Ae = this._unsafeSelectionStart;
    } catch (xr) {
    }
    return Ae != null ? Ae : this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let Ae;
    try {
      Ae = this._unsafeSelectionEnd;
    } catch (xr) {
    }
    return Ae != null ? Ae : this.value.length;
  }
  /** Safely sets element selection */
  select(Ae, xr) {
    if (!(Ae == null || xr == null || Ae === this.selectionStart && xr === this.selectionEnd))
      try {
        this._unsafeSelect(Ae, xr);
      } catch (ed) {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
IMask.MaskElement = MaskElement;
const KEY_Z = 90, KEY_Y = 89;
class HTMLMaskElement extends MaskElement {
  /** HTMLElement to use mask on */
  constructor(Ae) {
    super(), this.input = Ae, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var Ae, xr, ed;
    return (Ae = (xr = (ed = this.input).getRootNode) == null ? void 0 : xr.call(ed)) != null ? Ae : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(Ae) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", Ae.drop), this.input.addEventListener("click", Ae.click), this.input.addEventListener("focus", Ae.focus), this.input.addEventListener("blur", Ae.commit), this._handlers = Ae;
  }
  _onKeydown(Ae) {
    if (this._handlers.redo && (Ae.keyCode === KEY_Z && Ae.shiftKey && (Ae.metaKey || Ae.ctrlKey) || Ae.keyCode === KEY_Y && Ae.ctrlKey))
      return Ae.preventDefault(), this._handlers.redo(Ae);
    if (this._handlers.undo && Ae.keyCode === KEY_Z && (Ae.metaKey || Ae.ctrlKey))
      return Ae.preventDefault(), this._handlers.undo(Ae);
    Ae.isComposing || this._handlers.selectionChange(Ae);
  }
  _onBeforeinput(Ae) {
    if (Ae.inputType === "historyUndo" && this._handlers.undo)
      return Ae.preventDefault(), this._handlers.undo(Ae);
    if (Ae.inputType === "historyRedo" && this._handlers.redo)
      return Ae.preventDefault(), this._handlers.redo(Ae);
  }
  _onCompositionEnd(Ae) {
    this._handlers.input(Ae);
  }
  _onInput(Ae) {
    Ae.isComposing || this._handlers.input(Ae);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;
class HTMLInputMaskElement extends HTMLMaskElement {
  /** InputElement to use mask on */
  constructor(Ae) {
    super(Ae), this.input = Ae;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(Ae, xr) {
    this.input.setSelectionRange(Ae, xr);
  }
  get value() {
    return this.input.value;
  }
  set value(Ae) {
    this.input.value = Ae;
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;
class HTMLContenteditableMaskElement extends HTMLMaskElement {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const Ae = this.rootElement, xr = Ae.getSelection && Ae.getSelection(), ed = xr && xr.anchorOffset, id = xr && xr.focusOffset;
    return id == null || ed == null || ed < id ? ed : id;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const Ae = this.rootElement, xr = Ae.getSelection && Ae.getSelection(), ed = xr && xr.anchorOffset, id = xr && xr.focusOffset;
    return id == null || ed == null || ed > id ? ed : id;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(Ae, xr) {
    if (!this.rootElement.createRange)
      return;
    const ed = this.rootElement.createRange();
    ed.setStart(this.input.firstChild || this.input, Ae), ed.setEnd(this.input.lastChild || this.input, xr);
    const id = this.rootElement, od = id.getSelection && id.getSelection();
    od && (od.removeAllRanges(), od.addRange(ed));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(Ae) {
    this.input.textContent = Ae;
  }
}
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
class InputHistory {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(Ae) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(Ae), this.states.length > InputHistory.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(Ae) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + Ae, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
InputHistory.MAX_LENGTH = 100;
class InputMask {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(Ae, xr) {
    this.el = Ae instanceof MaskElement ? Ae : Ae.isContentEditable && Ae.tagName !== "INPUT" && Ae.tagName !== "TEXTAREA" ? new HTMLContenteditableMaskElement(Ae) : new HTMLInputMaskElement(Ae), this.masked = createMask(xr), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new InputHistory(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(Ae) {
    var xr;
    return Ae == null || ((xr = this.masked) == null ? void 0 : xr.maskEquals(Ae));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(Ae) {
    if (this.maskEquals(Ae))
      return;
    if (!(Ae instanceof IMask.Masked) && this.masked.constructor === maskedClass(Ae)) {
      this.masked.updateOptions({
        mask: Ae
      });
      return;
    }
    const xr = Ae instanceof IMask.Masked ? Ae : createMask({
      mask: Ae
    });
    xr.unmaskedValue = this.masked.unmaskedValue, this.masked = xr;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(Ae) {
    this.value !== Ae && (this.masked.value = Ae, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(Ae) {
    this.unmaskedValue !== Ae && (this.masked.unmaskedValue = Ae, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(Ae) {
    this.rawInputValue !== Ae && (this.masked.rawInputValue = Ae, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(Ae) {
    this.masked.typedValueEquals(Ae) || (this.masked.typedValue = Ae, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(Ae, xr) {
    const ed = this._listeners[Ae];
    ed && ed.forEach((id) => id(xr));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(Ae) {
    !this.el || !this.el.isActive || (this.el.select(Ae, Ae), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(Ae) {
    const xr = this.masked.unmaskedValue, ed = this.masked.value, id = this.masked.rawInputValue, od = this.displayValue, ad = this.unmaskedValue !== xr || this.value !== ed || this._rawInputValue !== id;
    this._unmaskedValue = xr, this._value = ed, this._rawInputValue = id, this.el.value !== od && (this.el.value = od), Ae === "auto" ? this.alignCursor() : Ae != null && (this.cursorPos = Ae), ad && this._fireChangeEvents(), !this._historyChanging && (ad || this.history.isEmpty) && this.history.push({
      unmaskedValue: xr,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(Ae) {
    const {
      mask: xr,
      ...ed
    } = Ae, id = !this.maskEquals(xr), od = this.masked.optionsIsChanged(ed);
    id && (this.mask = xr), od && this.masked.updateOptions(ed), (id || od) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(Ae) {
    Ae != null && (this.cursorPos = Ae, this._delayUpdateCursor(Ae));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(Ae) {
    this._abortUpdateCursor(), this._changingCursorPos = Ae, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(Ae, xr) {
    return this._listeners[Ae] || (this._listeners[Ae] = []), this._listeners[Ae].push(xr), this;
  }
  /** Removes custom event listener */
  off(Ae, xr) {
    if (!this._listeners[Ae])
      return this;
    if (!xr)
      return delete this._listeners[Ae], this;
    const ed = this._listeners[Ae].indexOf(xr);
    return ed >= 0 && this._listeners[Ae].splice(ed, 1), this;
  }
  /** Handles view input event */
  _onInput(Ae) {
    this._inputEvent = Ae, this._abortUpdateCursor();
    const xr = new ActionDetails({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), ed = this.masked.rawInputValue, id = this.masked.splice(xr.startChangePos, xr.removed.length, xr.inserted, xr.removeDirection, {
      input: !0,
      raw: !0
    }).offset, od = ed === this.masked.rawInputValue ? xr.removeDirection : DIRECTION.NONE;
    let ad = this.masked.nearestInputPos(xr.startChangePos + id, od);
    od !== DIRECTION.NONE && (ad = this.masked.nearestInputPos(ad, DIRECTION.NONE)), this.updateControl(ad), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(Ae) {
    Ae.preventDefault(), Ae.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(Ae) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(Ae) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(Ae) {
    Ae && (this._historyChanging = !0, this.unmaskedValue = Ae.unmaskedValue, this.el.select(Ae.selection.start, Ae.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
IMask.InputMask = InputMask;
class ChangeDetails {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(Ae) {
    return Array.isArray(Ae) ? Ae : [Ae, new ChangeDetails()];
  }
  constructor(Ae) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, Ae);
  }
  /** Aggregate changes */
  aggregate(Ae) {
    return this.inserted += Ae.inserted, this.rawInserted += Ae.rawInserted, this.tailShift += Ae.tailShift, this.skip = this.skip || Ae.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(Ae) {
    return this.inserted === Ae.inserted && this.tailShift === Ae.tailShift && this.rawInserted === Ae.rawInserted && this.skip === Ae.skip;
  }
}
IMask.ChangeDetails = ChangeDetails;
class ContinuousTailDetails {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(Ae, xr, ed) {
    Ae === void 0 && (Ae = ""), xr === void 0 && (xr = 0), this.value = Ae, this.from = xr, this.stop = ed;
  }
  toString() {
    return this.value;
  }
  extend(Ae) {
    this.value += String(Ae);
  }
  appendTo(Ae) {
    return Ae.append(this.toString(), {
      tail: !0
    }).aggregate(Ae._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(Ae) {
    Object.assign(this, Ae);
  }
  unshift(Ae) {
    if (!this.value.length || Ae != null && this.from >= Ae)
      return "";
    const xr = this.value[0];
    return this.value = this.value.slice(1), xr;
  }
  shift() {
    if (!this.value.length)
      return "";
    const Ae = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), Ae;
  }
}
class Masked {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(Ae) {
    this._value = "", this._update({
      ...Masked.DEFAULTS,
      ...Ae
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(Ae) {
    this.optionsIsChanged(Ae) && this.withValueRefresh(this._update.bind(this, Ae));
  }
  /** Sets new options */
  _update(Ae) {
    Object.assign(this, Ae);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(Ae) {
    this._value = Ae._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(Ae) {
    this.resolve(Ae, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(Ae, xr) {
    xr === void 0 && (xr = {
      input: !0
    }), this.reset(), this.append(Ae, xr, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(Ae) {
    this.resolve(Ae, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(Ae) {
    this.format ? this.value = this.format(Ae, this) : this.unmaskedValue = String(Ae);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(Ae) {
    this.resolve(Ae, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(Ae, xr) {
    return Ae;
  }
  totalInputPositions(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), Math.min(this.displayValue.length, xr - Ae);
  }
  /** Extracts value in range considering flags */
  extractInput(Ae, xr, ed) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), this.displayValue.slice(Ae, xr);
  }
  /** Extracts tail in range */
  extractTail(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), new ContinuousTailDetails(this.extractInput(Ae, xr), Ae);
  }
  /** Appends tail */
  appendTail(Ae) {
    return isString(Ae) && (Ae = new ContinuousTailDetails(String(Ae))), Ae.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(Ae, xr) {
    return Ae ? (this._value += Ae, new ChangeDetails({
      inserted: Ae,
      rawInserted: Ae
    })) : new ChangeDetails();
  }
  /** Appends char */
  _appendChar(Ae, xr, ed) {
    xr === void 0 && (xr = {});
    const id = this.state;
    let od;
    if ([Ae, od] = this.doPrepareChar(Ae, xr), Ae && (od = od.aggregate(this._appendCharRaw(Ae, xr)), !od.rawInserted && this.autofix === "pad")) {
      const ad = this.state;
      this.state = id;
      let rd = this.pad(xr);
      const sd = this._appendCharRaw(Ae, xr);
      rd = rd.aggregate(sd), sd.rawInserted || rd.equals(od) ? od = rd : this.state = ad;
    }
    if (od.inserted) {
      let ad, rd = this.doValidate(xr) !== !1;
      if (rd && ed != null) {
        const sd = this.state;
        if (this.overwrite === !0) {
          ad = ed.state;
          for (let cd = 0; cd < od.rawInserted.length; ++cd)
            ed.unshift(this.displayValue.length - od.tailShift);
        }
        let nd = this.appendTail(ed);
        if (rd = nd.rawInserted.length === ed.toString().length, !(rd && nd.inserted) && this.overwrite === "shift") {
          this.state = sd, ad = ed.state;
          for (let cd = 0; cd < od.rawInserted.length; ++cd)
            ed.shift();
          nd = this.appendTail(ed), rd = nd.rawInserted.length === ed.toString().length;
        }
        rd && nd.inserted && (this.state = sd);
      }
      rd || (od = new ChangeDetails(), this.state = id, ed && ad && (ed.state = ad));
    }
    return od;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new ChangeDetails();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new ChangeDetails();
  }
  /** Appends symbols considering flags */
  append(Ae, xr, ed) {
    if (!isString(Ae))
      throw new Error("value should be string");
    const id = isString(ed) ? new ContinuousTailDetails(String(ed)) : ed;
    xr != null && xr.tail && (xr._beforeTailState = this.state);
    let od;
    [Ae, od] = this.doPrepare(Ae, xr);
    for (let ad = 0; ad < Ae.length; ++ad) {
      const rd = this._appendChar(Ae[ad], xr, id);
      if (!rd.rawInserted && !this.doSkipInvalid(Ae[ad], xr, id))
        break;
      od.aggregate(rd);
    }
    return (this.eager === !0 || this.eager === "append") && xr != null && xr.input && Ae && od.aggregate(this._appendEager()), id != null && (od.tailShift += this.appendTail(id).tailShift), od;
  }
  remove(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), this._value = this.displayValue.slice(0, Ae) + this.displayValue.slice(xr), new ChangeDetails();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(Ae) {
    if (this._refreshing || !this._initialized)
      return Ae();
    this._refreshing = !0;
    const xr = this.rawInputValue, ed = this.value, id = Ae();
    return this.rawInputValue = xr, this.value && this.value !== ed && ed.indexOf(this.value) === 0 && (this.append(ed.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, id;
  }
  runIsolated(Ae) {
    if (this._isolated || !this._initialized)
      return Ae(this);
    this._isolated = !0;
    const xr = this.state, ed = Ae(this);
    return this.state = xr, delete this._isolated, ed;
  }
  doSkipInvalid(Ae, xr, ed) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(Ae, xr) {
    return xr === void 0 && (xr = {}), ChangeDetails.normalize(this.prepare ? this.prepare(Ae, this, xr) : Ae);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(Ae, xr) {
    return xr === void 0 && (xr = {}), ChangeDetails.normalize(this.prepareChar ? this.prepareChar(Ae, this, xr) : Ae);
  }
  /** Validates if value is acceptable */
  doValidate(Ae) {
    return (!this.validate || this.validate(this.value, this, Ae)) && (!this.parent || this.parent.doValidate(Ae));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(Ae, xr, ed, id, od) {
    ed === void 0 && (ed = ""), id === void 0 && (id = DIRECTION.NONE), od === void 0 && (od = {
      input: !0
    });
    const ad = Ae + xr, rd = this.extractTail(ad), sd = this.eager === !0 || this.eager === "remove";
    let nd;
    sd && (id = forceDirection(id), nd = this.extractInput(0, ad, {
      raw: !0
    }));
    let cd = Ae;
    const ud = new ChangeDetails();
    if (id !== DIRECTION.NONE && (cd = this.nearestInputPos(Ae, xr > 1 && Ae !== 0 && !sd ? DIRECTION.NONE : id), ud.tailShift = cd - Ae), ud.aggregate(this.remove(cd)), sd && id !== DIRECTION.NONE && nd === this.rawInputValue)
      if (id === DIRECTION.FORCE_LEFT) {
        let ld;
        for (; nd === this.rawInputValue && (ld = this.displayValue.length); )
          ud.aggregate(new ChangeDetails({
            tailShift: -1
          })).aggregate(this.remove(ld - 1));
      } else
        id === DIRECTION.FORCE_RIGHT && rd.unshift();
    return ud.aggregate(this.append(ed, od, rd));
  }
  maskEquals(Ae) {
    return this.mask === Ae;
  }
  optionsIsChanged(Ae) {
    return !objectIncludes(this, Ae);
  }
  typedValueEquals(Ae) {
    const xr = this.typedValue;
    return Ae === xr || Masked.EMPTY_VALUES.includes(Ae) && Masked.EMPTY_VALUES.includes(xr) || (this.format ? this.format(Ae, this) === this.format(this.typedValue, this) : !1);
  }
  pad(Ae) {
    return new ChangeDetails();
  }
}
Masked.DEFAULTS = {
  skipInvalid: !0
};
Masked.EMPTY_VALUES = [void 0, null, ""];
IMask.Masked = Masked;
class ChunksTailDetails {
  /** */
  constructor(Ae, xr) {
    Ae === void 0 && (Ae = []), xr === void 0 && (xr = 0), this.chunks = Ae, this.from = xr;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(Ae) {
    if (!String(Ae))
      return;
    Ae = isString(Ae) ? new ContinuousTailDetails(String(Ae)) : Ae;
    const xr = this.chunks[this.chunks.length - 1], ed = xr && // if stops are same or tail has no stop
    (xr.stop === Ae.stop || Ae.stop == null) && // if tail chunk goes just after last chunk
    Ae.from === xr.from + xr.toString().length;
    if (Ae instanceof ContinuousTailDetails)
      ed ? xr.extend(Ae.toString()) : this.chunks.push(Ae);
    else if (Ae instanceof ChunksTailDetails) {
      if (Ae.stop == null) {
        let id;
        for (; Ae.chunks.length && Ae.chunks[0].stop == null; )
          id = Ae.chunks.shift(), id.from += Ae.from, this.extend(id);
      }
      Ae.toString() && (Ae.stop = Ae.blockIndex, this.chunks.push(Ae));
    }
  }
  appendTo(Ae) {
    if (!(Ae instanceof IMask.MaskedPattern))
      return new ContinuousTailDetails(this.toString()).appendTo(Ae);
    const xr = new ChangeDetails();
    for (let ed = 0; ed < this.chunks.length; ++ed) {
      const id = this.chunks[ed], od = Ae._mapPosToBlock(Ae.displayValue.length), ad = id.stop;
      let rd;
      if (ad != null && // if block not found or stop is behind lastBlock
      (!od || od.index <= ad) && ((id instanceof ChunksTailDetails || // for continuous block also check if stop is exist
      Ae._stops.indexOf(ad) >= 0) && xr.aggregate(Ae._appendPlaceholder(ad)), rd = id instanceof ChunksTailDetails && Ae._blocks[ad]), rd) {
        const sd = rd.appendTail(id);
        xr.aggregate(sd);
        const nd = id.toString().slice(sd.rawInserted.length);
        nd && xr.aggregate(Ae.append(nd, {
          tail: !0
        }));
      } else
        xr.aggregate(Ae.append(id.toString(), {
          tail: !0
        }));
    }
    return xr;
  }
  get state() {
    return {
      chunks: this.chunks.map((Ae) => Ae.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(Ae) {
    const {
      chunks: xr,
      ...ed
    } = Ae;
    Object.assign(this, ed), this.chunks = xr.map((id) => {
      const od = "chunks" in id ? new ChunksTailDetails() : new ContinuousTailDetails();
      return od.state = id, od;
    });
  }
  unshift(Ae) {
    if (!this.chunks.length || Ae != null && this.from >= Ae)
      return "";
    const xr = Ae != null ? Ae - this.from : Ae;
    let ed = 0;
    for (; ed < this.chunks.length; ) {
      const id = this.chunks[ed], od = id.unshift(xr);
      if (id.toString()) {
        if (!od)
          break;
        ++ed;
      } else
        this.chunks.splice(ed, 1);
      if (od)
        return od;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let Ae = this.chunks.length - 1;
    for (; 0 <= Ae; ) {
      const xr = this.chunks[Ae], ed = xr.shift();
      if (xr.toString()) {
        if (!ed)
          break;
        --Ae;
      } else
        this.chunks.splice(Ae, 1);
      if (ed)
        return ed;
    }
    return "";
  }
}
class PatternCursor {
  constructor(Ae, xr) {
    this.masked = Ae, this._log = [];
    const {
      offset: ed,
      index: id
    } = Ae._mapPosToBlock(xr) || (xr < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = ed, this.index = id, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(Ae) {
    Object.assign(this, Ae);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const Ae = this._log.pop();
    return Ae && (this.state = Ae), Ae;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(Ae) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((xr = this.block) == null ? void 0 : xr.displayValue.length) || 0) {
      var xr;
      if (Ae())
        return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(Ae) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (Ae())
        return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE), !0;
    });
  }
}
class PatternFixedDefinition {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(Ae) {
    Object.assign(this, Ae), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this._value.length), this._value = this._value.slice(0, Ae) + this._value.slice(xr), this._value || (this._isRawInput = !1), new ChangeDetails();
  }
  nearestInputPos(Ae, xr) {
    xr === void 0 && (xr = DIRECTION.NONE);
    const ed = 0, id = this._value.length;
    switch (xr) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return ed;
      case DIRECTION.NONE:
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
      default:
        return id;
    }
  }
  totalInputPositions(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this._value.length), this._isRawInput ? xr - Ae : 0;
  }
  extractInput(Ae, xr, ed) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this._value.length), ed === void 0 && (ed = {}), ed.raw && this._isRawInput && this._value.slice(Ae, xr) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(Ae, xr) {
    if (xr === void 0 && (xr = {}), this.isFilled)
      return new ChangeDetails();
    const ed = this.eager === !0 || this.eager === "append", od = this.char === Ae && (this.isUnmasking || xr.input || xr.raw) && (!xr.raw || !ed) && !xr.tail, ad = new ChangeDetails({
      inserted: this.char,
      rawInserted: od ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = od && (xr.raw || xr.input), ad;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const Ae = new ChangeDetails();
    return this.isFilled || (this._value = Ae.inserted = this.char), Ae;
  }
  extractTail() {
    return new ContinuousTailDetails("");
  }
  appendTail(Ae) {
    return isString(Ae) && (Ae = new ContinuousTailDetails(String(Ae))), Ae.appendTo(this);
  }
  append(Ae, xr, ed) {
    const id = this._appendChar(Ae[0], xr);
    return ed != null && (id.tailShift += this.appendTail(ed).tailShift), id;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(Ae) {
    this._value = Ae._value, this._isRawInput = !!Ae._rawInputValue;
  }
  pad(Ae) {
    return this._appendPlaceholder();
  }
}
class PatternInputDefinition {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(Ae) {
    const {
      parent: xr,
      isOptional: ed,
      placeholderChar: id,
      displayChar: od,
      lazy: ad,
      eager: rd,
      ...sd
    } = Ae;
    this.masked = createMask(sd), Object.assign(this, {
      parent: xr,
      isOptional: ed,
      placeholderChar: id,
      displayChar: od,
      lazy: ad,
      eager: rd
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.value.length), Ae === 0 && xr >= 1 ? (this.isFilled = !1, this.masked.remove(Ae, xr)) : new ChangeDetails();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(Ae, xr) {
    if (xr === void 0 && (xr = {}), this.isFilled)
      return new ChangeDetails();
    const ed = this.masked.state;
    let id = this.masked._appendChar(Ae, this.currentMaskFlags(xr));
    return id.inserted && this.doValidate(xr) === !1 && (id = new ChangeDetails(), this.masked.state = ed), !id.inserted && !this.isOptional && !this.lazy && !xr.input && (id.inserted = this.placeholderChar), id.skip = !id.inserted && !this.isOptional, this.isFilled = !!id.inserted, id;
  }
  append(Ae, xr, ed) {
    return this.masked.append(Ae, this.currentMaskFlags(xr), ed);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new ChangeDetails() : (this.isFilled = !0, new ChangeDetails({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new ChangeDetails();
  }
  extractTail(Ae, xr) {
    return this.masked.extractTail(Ae, xr);
  }
  appendTail(Ae) {
    return this.masked.appendTail(Ae);
  }
  extractInput(Ae, xr, ed) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.value.length), this.masked.extractInput(Ae, xr, ed);
  }
  nearestInputPos(Ae, xr) {
    xr === void 0 && (xr = DIRECTION.NONE);
    const ed = 0, id = this.value.length, od = Math.min(Math.max(Ae, ed), id);
    switch (xr) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return this.isComplete ? od : ed;
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        return this.isComplete ? od : id;
      case DIRECTION.NONE:
      default:
        return od;
    }
  }
  totalInputPositions(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.value.length), this.value.slice(Ae, xr).length;
  }
  doValidate(Ae) {
    return this.masked.doValidate(this.currentMaskFlags(Ae)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(Ae)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(Ae) {
    this.masked.state = Ae.masked, this.isFilled = Ae.isFilled;
  }
  currentMaskFlags(Ae) {
    var xr;
    return {
      ...Ae,
      _beforeTailState: (Ae == null || (xr = Ae._beforeTailState) == null ? void 0 : xr.masked) || (Ae == null ? void 0 : Ae._beforeTailState)
    };
  }
  pad(Ae) {
    return new ChangeDetails();
  }
}
PatternInputDefinition.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class MaskedRegExp extends Masked {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    const xr = Ae.mask;
    xr && (Ae.validate = (ed) => ed.search(xr) >= 0), super._update(Ae);
  }
}
IMask.MaskedRegExp = MaskedRegExp;
class MaskedPattern extends Masked {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(Ae) {
    super({
      ...MaskedPattern.DEFAULTS,
      ...Ae,
      definitions: Object.assign({}, PatternInputDefinition.DEFAULT_DEFINITIONS, Ae == null ? void 0 : Ae.definitions)
    });
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    Ae.definitions = Object.assign({}, this.definitions, Ae.definitions), super._update(Ae), this._rebuildMask();
  }
  _rebuildMask() {
    const Ae = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const xr = this.mask;
    if (!xr || !Ae)
      return;
    let ed = !1, id = !1;
    for (let od = 0; od < xr.length; ++od) {
      if (this.blocks) {
        const nd = xr.slice(od), cd = Object.keys(this.blocks).filter((ld) => nd.indexOf(ld) === 0);
        cd.sort((ld, dd) => dd.length - ld.length);
        const ud = cd[0];
        if (ud) {
          const {
            expose: ld,
            repeat: dd,
            ...pd
          } = normalizeOpts(this.blocks[ud]), md = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...pd,
            repeat: dd,
            parent: this
          }, fd = dd != null ? new IMask.RepeatBlock(
            md
            /* TODO */
          ) : createMask(md);
          fd && (this._blocks.push(fd), ld && (this.exposeBlock = fd), this._maskedBlocks[ud] || (this._maskedBlocks[ud] = []), this._maskedBlocks[ud].push(this._blocks.length - 1)), od += ud.length - 1;
          continue;
        }
      }
      let ad = xr[od], rd = ad in Ae;
      if (ad === MaskedPattern.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (ad === "{" || ad === "}") {
        ed = !ed;
        continue;
      }
      if (ad === "[" || ad === "]") {
        id = !id;
        continue;
      }
      if (ad === MaskedPattern.ESCAPE_CHAR) {
        if (++od, ad = xr[od], !ad)
          break;
        rd = !1;
      }
      const sd = rd ? new PatternInputDefinition({
        isOptional: id,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...normalizeOpts(Ae[ad]),
        parent: this
      }) : new PatternFixedDefinition({
        char: ad,
        eager: this.eager,
        isUnmasking: ed
      });
      this._blocks.push(sd);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((Ae) => Ae.state)
    };
  }
  set state(Ae) {
    if (!Ae) {
      this.reset();
      return;
    }
    const {
      _blocks: xr,
      ...ed
    } = Ae;
    this._blocks.forEach((id, od) => id.state = xr[od]), super.state = ed;
  }
  reset() {
    super.reset(), this._blocks.forEach((Ae) => Ae.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((Ae) => Ae.isComplete);
  }
  get isFilled() {
    return this._blocks.every((Ae) => Ae.isFilled);
  }
  get isFixed() {
    return this._blocks.every((Ae) => Ae.isFixed);
  }
  get isOptional() {
    return this._blocks.every((Ae) => Ae.isOptional);
  }
  doCommit() {
    this._blocks.forEach((Ae) => Ae.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((Ae, xr) => Ae += xr.unmaskedValue, "");
  }
  set unmaskedValue(Ae) {
    if (this.exposeBlock) {
      const xr = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = Ae, this.appendTail(xr), this.doCommit();
    } else
      super.unmaskedValue = Ae;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((Ae, xr) => Ae += xr.value, "")
    );
  }
  set value(Ae) {
    if (this.exposeBlock) {
      const xr = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = Ae, this.appendTail(xr), this.doCommit();
    } else
      super.value = Ae;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(Ae) {
    if (this.exposeBlock) {
      const xr = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = Ae, this.appendTail(xr), this.doCommit();
    } else
      super.typedValue = Ae;
  }
  get displayValue() {
    return this._blocks.reduce((Ae, xr) => Ae += xr.displayValue, "");
  }
  appendTail(Ae) {
    return super.appendTail(Ae).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var Ae;
    const xr = new ChangeDetails();
    let ed = (Ae = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : Ae.index;
    if (ed == null)
      return xr;
    this._blocks[ed].isFilled && ++ed;
    for (let id = ed; id < this._blocks.length; ++id) {
      const od = this._blocks[id]._appendEager();
      if (!od.inserted)
        break;
      xr.aggregate(od);
    }
    return xr;
  }
  _appendCharRaw(Ae, xr) {
    xr === void 0 && (xr = {});
    const ed = this._mapPosToBlock(this.displayValue.length), id = new ChangeDetails();
    if (!ed)
      return id;
    for (let ad = ed.index, rd; rd = this._blocks[ad]; ++ad) {
      var od;
      const sd = rd._appendChar(Ae, {
        ...xr,
        _beforeTailState: (od = xr._beforeTailState) == null || (od = od._blocks) == null ? void 0 : od[ad]
      });
      if (id.aggregate(sd), sd.consumed)
        break;
    }
    return id;
  }
  extractTail(Ae, xr) {
    Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length);
    const ed = new ChunksTailDetails();
    return Ae === xr || this._forEachBlocksInRange(Ae, xr, (id, od, ad, rd) => {
      const sd = id.extractTail(ad, rd);
      sd.stop = this._findStopBefore(od), sd.from = this._blockStartPos(od), sd instanceof ChunksTailDetails && (sd.blockIndex = od), ed.extend(sd);
    }), ed;
  }
  extractInput(Ae, xr, ed) {
    if (Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), ed === void 0 && (ed = {}), Ae === xr)
      return "";
    let id = "";
    return this._forEachBlocksInRange(Ae, xr, (od, ad, rd, sd) => {
      id += od.extractInput(rd, sd, ed);
    }), id;
  }
  _findStopBefore(Ae) {
    let xr;
    for (let ed = 0; ed < this._stops.length; ++ed) {
      const id = this._stops[ed];
      if (id <= Ae)
        xr = id;
      else
        break;
    }
    return xr;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(Ae) {
    const xr = new ChangeDetails();
    if (this.lazy && Ae == null)
      return xr;
    const ed = this._mapPosToBlock(this.displayValue.length);
    if (!ed)
      return xr;
    const id = ed.index, od = Ae != null ? Ae : this._blocks.length;
    return this._blocks.slice(id, od).forEach((ad) => {
      if (!ad.lazy || Ae != null) {
        var rd;
        xr.aggregate(ad._appendPlaceholder((rd = ad._blocks) == null ? void 0 : rd.length));
      }
    }), xr;
  }
  /** Finds block in pos */
  _mapPosToBlock(Ae) {
    let xr = "";
    for (let ed = 0; ed < this._blocks.length; ++ed) {
      const id = this._blocks[ed], od = xr.length;
      if (xr += id.displayValue, Ae <= xr.length)
        return {
          index: ed,
          offset: Ae - od
        };
    }
  }
  _blockStartPos(Ae) {
    return this._blocks.slice(0, Ae).reduce((xr, ed) => xr += ed.displayValue.length, 0);
  }
  _forEachBlocksInRange(Ae, xr, ed) {
    xr === void 0 && (xr = this.displayValue.length);
    const id = this._mapPosToBlock(Ae);
    if (id) {
      const od = this._mapPosToBlock(xr), ad = od && id.index === od.index, rd = id.offset, sd = od && ad ? od.offset : this._blocks[id.index].displayValue.length;
      if (ed(this._blocks[id.index], id.index, rd, sd), od && !ad) {
        for (let nd = id.index + 1; nd < od.index; ++nd)
          ed(this._blocks[nd], nd, 0, this._blocks[nd].displayValue.length);
        ed(this._blocks[od.index], od.index, 0, od.offset);
      }
    }
  }
  remove(Ae, xr) {
    Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length);
    const ed = super.remove(Ae, xr);
    return this._forEachBlocksInRange(Ae, xr, (id, od, ad, rd) => {
      ed.aggregate(id.remove(ad, rd));
    }), ed;
  }
  nearestInputPos(Ae, xr) {
    if (xr === void 0 && (xr = DIRECTION.NONE), !this._blocks.length)
      return 0;
    const ed = new PatternCursor(this, Ae);
    if (xr === DIRECTION.NONE)
      return ed.pushRightBeforeInput() || (ed.popState(), ed.pushLeftBeforeInput()) ? ed.pos : this.displayValue.length;
    if (xr === DIRECTION.LEFT || xr === DIRECTION.FORCE_LEFT) {
      if (xr === DIRECTION.LEFT) {
        if (ed.pushRightBeforeFilled(), ed.ok && ed.pos === Ae)
          return Ae;
        ed.popState();
      }
      if (ed.pushLeftBeforeInput(), ed.pushLeftBeforeRequired(), ed.pushLeftBeforeFilled(), xr === DIRECTION.LEFT) {
        if (ed.pushRightBeforeInput(), ed.pushRightBeforeRequired(), ed.ok && ed.pos <= Ae || (ed.popState(), ed.ok && ed.pos <= Ae))
          return ed.pos;
        ed.popState();
      }
      return ed.ok ? ed.pos : xr === DIRECTION.FORCE_LEFT ? 0 : (ed.popState(), ed.ok || (ed.popState(), ed.ok) ? ed.pos : 0);
    }
    return xr === DIRECTION.RIGHT || xr === DIRECTION.FORCE_RIGHT ? (ed.pushRightBeforeInput(), ed.pushRightBeforeRequired(), ed.pushRightBeforeFilled() ? ed.pos : xr === DIRECTION.FORCE_RIGHT ? this.displayValue.length : (ed.popState(), ed.ok || (ed.popState(), ed.ok) ? ed.pos : this.nearestInputPos(Ae, DIRECTION.LEFT))) : Ae;
  }
  totalInputPositions(Ae, xr) {
    Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length);
    let ed = 0;
    return this._forEachBlocksInRange(Ae, xr, (id, od, ad, rd) => {
      ed += id.totalInputPositions(ad, rd);
    }), ed;
  }
  /** Get block by name */
  maskedBlock(Ae) {
    return this.maskedBlocks(Ae)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(Ae) {
    const xr = this._maskedBlocks[Ae];
    return xr ? xr.map((ed) => this._blocks[ed]) : [];
  }
  pad(Ae) {
    const xr = new ChangeDetails();
    return this._forEachBlocksInRange(0, this.displayValue.length, (ed) => xr.aggregate(ed.pad(Ae))), xr;
  }
}
MaskedPattern.DEFAULTS = {
  ...Masked.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
MaskedPattern.STOP_CHAR = "`";
MaskedPattern.ESCAPE_CHAR = "\\";
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;
class MaskedRange extends MaskedPattern {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(Ae) {
    super(Ae);
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    const {
      to: xr = this.to || 0,
      from: ed = this.from || 0,
      maxLength: id = this.maxLength || 0,
      autofix: od = this.autofix,
      ...ad
    } = Ae;
    this.to = xr, this.from = ed, this.maxLength = Math.max(String(xr).length, id), this.autofix = od;
    const rd = String(this.from).padStart(this.maxLength, "0"), sd = String(this.to).padStart(this.maxLength, "0");
    let nd = 0;
    for (; nd < sd.length && sd[nd] === rd[nd]; )
      ++nd;
    ad.mask = sd.slice(0, nd).replace(/0/g, "\\0") + "0".repeat(this.maxLength - nd), super._update(ad);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(Ae) {
    let xr = "", ed = "";
    const [, id, od] = Ae.match(/^(\D*)(\d*)(\D*)/) || [];
    return od && (xr = "0".repeat(id.length) + od, ed = "9".repeat(id.length) + od), xr = xr.padEnd(this.maxLength, "0"), ed = ed.padEnd(this.maxLength, "9"), [xr, ed];
  }
  doPrepareChar(Ae, xr) {
    xr === void 0 && (xr = {});
    let ed;
    return [Ae, ed] = super.doPrepareChar(Ae.replace(/\D/g, ""), xr), Ae || (ed.skip = !this.isComplete), [Ae, ed];
  }
  _appendCharRaw(Ae, xr) {
    if (xr === void 0 && (xr = {}), !this.autofix || this.value.length + 1 > this.maxLength)
      return super._appendCharRaw(Ae, xr);
    const ed = String(this.from).padStart(this.maxLength, "0"), id = String(this.to).padStart(this.maxLength, "0"), [od, ad] = this.boundaries(this.value + Ae);
    return Number(ad) < this.from ? super._appendCharRaw(ed[this.value.length], xr) : Number(od) > this.to ? !xr.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(ed[this.value.length], xr).aggregate(this._appendCharRaw(Ae, xr)) : super._appendCharRaw(id[this.value.length], xr) : super._appendCharRaw(Ae, xr);
  }
  doValidate(Ae) {
    const xr = this.value;
    if (xr.search(/[^0]/) === -1 && xr.length <= this._matchFrom)
      return !0;
    const [id, od] = this.boundaries(xr);
    return this.from <= Number(od) && Number(id) <= this.to && super.doValidate(Ae);
  }
  pad(Ae) {
    const xr = new ChangeDetails();
    if (this.value.length === this.maxLength)
      return xr;
    const ed = this.value, id = this.maxLength - this.value.length;
    if (id) {
      this.reset();
      for (let od = 0; od < id; ++od)
        xr.aggregate(super._appendCharRaw("0", Ae));
      ed.split("").forEach((od) => this._appendCharRaw(od));
    }
    return xr;
  }
}
IMask.MaskedRange = MaskedRange;
const DefaultPattern = "d{.}`m{.}`Y";
class MaskedDate extends MaskedPattern {
  static extractPatternOptions(Ae) {
    const {
      mask: xr,
      pattern: ed,
      ...id
    } = Ae;
    return {
      ...id,
      mask: isString(xr) ? xr : ed
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(Ae) {
    super(MaskedDate.extractPatternOptions({
      ...MaskedDate.DEFAULTS,
      ...Ae
    }));
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    const {
      mask: xr,
      pattern: ed,
      blocks: id,
      ...od
    } = {
      ...MaskedDate.DEFAULTS,
      ...Ae
    }, ad = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
    Ae.min && (ad.Y.from = Ae.min.getFullYear()), Ae.max && (ad.Y.to = Ae.max.getFullYear()), Ae.min && Ae.max && ad.Y.from === ad.Y.to && (ad.m.from = Ae.min.getMonth() + 1, ad.m.to = Ae.max.getMonth() + 1, ad.m.from === ad.m.to && (ad.d.from = Ae.min.getDate(), ad.d.to = Ae.max.getDate())), Object.assign(ad, this.blocks, id), super._update({
      ...od,
      mask: isString(xr) ? xr : ed,
      blocks: ad
    });
  }
  doValidate(Ae) {
    const xr = this.date;
    return super.doValidate(Ae) && (!this.isComplete || this.isDateExist(this.value) && xr != null && (this.min == null || this.min <= xr) && (this.max == null || xr <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(Ae) {
    return this.format(this.parse(Ae, this), this).indexOf(Ae) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(Ae) {
    this.typedValue = Ae;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(Ae) {
    super.typedValue = Ae;
  }
  maskEquals(Ae) {
    return Ae === Date || super.maskEquals(Ae);
  }
  optionsIsChanged(Ae) {
    return super.optionsIsChanged(MaskedDate.extractPatternOptions(Ae));
  }
}
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: MaskedRange,
    from: 1900,
    to: 9999
  }
});
MaskedDate.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  mask: Date,
  pattern: DefaultPattern,
  format: (td, Ae) => {
    if (!td)
      return "";
    const xr = String(td.getDate()).padStart(2, "0"), ed = String(td.getMonth() + 1).padStart(2, "0"), id = td.getFullYear();
    return [xr, ed, id].join(".");
  },
  parse: (td, Ae) => {
    const [xr, ed, id] = td.split(".").map(Number);
    return new Date(id, ed - 1, xr);
  }
};
IMask.MaskedDate = MaskedDate;
class MaskedDynamic extends Masked {
  constructor(Ae) {
    super({
      ...MaskedDynamic.DEFAULTS,
      ...Ae
    }), this.currentMask = void 0;
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    super._update(Ae), "mask" in Ae && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(Ae.mask) ? Ae.mask.map((xr) => {
      const {
        expose: ed,
        ...id
      } = normalizeOpts(xr), od = createMask({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...id
      });
      return ed && (this.exposeMask = od), od;
    }) : []);
  }
  _appendCharRaw(Ae, xr) {
    xr === void 0 && (xr = {});
    const ed = this._applyDispatch(Ae, xr);
    return this.currentMask && ed.aggregate(this.currentMask._appendChar(Ae, this.currentMaskFlags(xr))), ed;
  }
  _applyDispatch(Ae, xr, ed) {
    Ae === void 0 && (Ae = ""), xr === void 0 && (xr = {}), ed === void 0 && (ed = "");
    const id = xr.tail && xr._beforeTailState != null ? xr._beforeTailState._value : this.value, od = this.rawInputValue, ad = xr.tail && xr._beforeTailState != null ? xr._beforeTailState._rawInputValue : od, rd = od.slice(ad.length), sd = this.currentMask, nd = new ChangeDetails(), cd = sd == null ? void 0 : sd.state;
    return this.currentMask = this.doDispatch(Ae, {
      ...xr
    }, ed), this.currentMask && (this.currentMask !== sd ? (this.currentMask.reset(), ad && (this.currentMask.append(ad, {
      raw: !0
    }), nd.tailShift = this.currentMask.value.length - id.length), rd && (nd.tailShift += this.currentMask.append(rd, {
      raw: !0,
      tail: !0
    }).tailShift)) : cd && (this.currentMask.state = cd)), nd;
  }
  _appendPlaceholder() {
    const Ae = this._applyDispatch();
    return this.currentMask && Ae.aggregate(this.currentMask._appendPlaceholder()), Ae;
  }
  _appendEager() {
    const Ae = this._applyDispatch();
    return this.currentMask && Ae.aggregate(this.currentMask._appendEager()), Ae;
  }
  appendTail(Ae) {
    const xr = new ChangeDetails();
    return Ae && xr.aggregate(this._applyDispatch("", {}, Ae)), xr.aggregate(this.currentMask ? this.currentMask.appendTail(Ae) : super.appendTail(Ae));
  }
  currentMaskFlags(Ae) {
    var xr, ed;
    return {
      ...Ae,
      _beforeTailState: ((xr = Ae._beforeTailState) == null ? void 0 : xr.currentMaskRef) === this.currentMask && ((ed = Ae._beforeTailState) == null ? void 0 : ed.currentMask) || Ae._beforeTailState
    };
  }
  doDispatch(Ae, xr, ed) {
    return xr === void 0 && (xr = {}), ed === void 0 && (ed = ""), this.dispatch(Ae, this, xr, ed);
  }
  doValidate(Ae) {
    return super.doValidate(Ae) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(Ae)));
  }
  doPrepare(Ae, xr) {
    xr === void 0 && (xr = {});
    let [ed, id] = super.doPrepare(Ae, xr);
    if (this.currentMask) {
      let od;
      [ed, od] = super.doPrepare(ed, this.currentMaskFlags(xr)), id = id.aggregate(od);
    }
    return [ed, id];
  }
  doPrepareChar(Ae, xr) {
    xr === void 0 && (xr = {});
    let [ed, id] = super.doPrepareChar(Ae, xr);
    if (this.currentMask) {
      let od;
      [ed, od] = super.doPrepareChar(ed, this.currentMaskFlags(xr)), id = id.aggregate(od);
    }
    return [ed, id];
  }
  reset() {
    var Ae;
    (Ae = this.currentMask) == null || Ae.reset(), this.compiledMasks.forEach((xr) => xr.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(Ae) {
    this.exposeMask ? (this.exposeMask.value = Ae, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = Ae;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(Ae) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = Ae, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = Ae;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(Ae) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = Ae, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let xr = String(Ae);
    this.currentMask && (this.currentMask.typedValue = Ae, xr = this.currentMask.unmaskedValue), this.unmaskedValue = xr;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var Ae;
    return !!((Ae = this.currentMask) != null && Ae.isComplete);
  }
  get isFilled() {
    var Ae;
    return !!((Ae = this.currentMask) != null && Ae.isFilled);
  }
  remove(Ae, xr) {
    const ed = new ChangeDetails();
    return this.currentMask && ed.aggregate(this.currentMask.remove(Ae, xr)).aggregate(this._applyDispatch()), ed;
  }
  get state() {
    var Ae;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((xr) => xr.state),
      currentMaskRef: this.currentMask,
      currentMask: (Ae = this.currentMask) == null ? void 0 : Ae.state
    };
  }
  set state(Ae) {
    const {
      compiledMasks: xr,
      currentMaskRef: ed,
      currentMask: id,
      ...od
    } = Ae;
    xr && this.compiledMasks.forEach((ad, rd) => ad.state = xr[rd]), ed != null && (this.currentMask = ed, this.currentMask.state = id), super.state = od;
  }
  extractInput(Ae, xr, ed) {
    return this.currentMask ? this.currentMask.extractInput(Ae, xr, ed) : "";
  }
  extractTail(Ae, xr) {
    return this.currentMask ? this.currentMask.extractTail(Ae, xr) : super.extractTail(Ae, xr);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(Ae, xr) {
    return this.currentMask ? this.currentMask.nearestInputPos(Ae, xr) : super.nearestInputPos(Ae, xr);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(Ae) {
    this._overwrite = Ae;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(Ae) {
    this._eager = Ae;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(Ae) {
    this._skipInvalid = Ae;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(Ae) {
    this._autofix = Ae;
  }
  maskEquals(Ae) {
    return Array.isArray(Ae) ? this.compiledMasks.every((xr, ed) => {
      if (!Ae[ed])
        return;
      const {
        mask: id,
        ...od
      } = Ae[ed];
      return objectIncludes(xr, od) && xr.maskEquals(id);
    }) : super.maskEquals(Ae);
  }
  typedValueEquals(Ae) {
    var xr;
    return !!((xr = this.currentMask) != null && xr.typedValueEquals(Ae));
  }
}
MaskedDynamic.DEFAULTS = {
  ...Masked.DEFAULTS,
  dispatch: (td, Ae, xr, ed) => {
    if (!Ae.compiledMasks.length)
      return;
    const id = Ae.rawInputValue, od = Ae.compiledMasks.map((ad, rd) => {
      const sd = Ae.currentMask === ad, nd = sd ? ad.displayValue.length : ad.nearestInputPos(ad.displayValue.length, DIRECTION.FORCE_LEFT);
      return ad.rawInputValue !== id ? (ad.reset(), ad.append(id, {
        raw: !0
      })) : sd || ad.remove(nd), ad.append(td, Ae.currentMaskFlags(xr)), ad.appendTail(ed), {
        index: rd,
        weight: ad.rawInputValue.length,
        totalInputPositions: ad.totalInputPositions(0, Math.max(nd, ad.nearestInputPos(ad.displayValue.length, DIRECTION.FORCE_LEFT)))
      };
    });
    return od.sort((ad, rd) => rd.weight - ad.weight || rd.totalInputPositions - ad.totalInputPositions), Ae.compiledMasks[od[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;
class MaskedEnum extends MaskedPattern {
  constructor(Ae) {
    super({
      ...MaskedEnum.DEFAULTS,
      ...Ae
    });
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    const {
      enum: xr,
      ...ed
    } = Ae;
    if (xr) {
      const id = xr.map((rd) => rd.length), od = Math.min(...id), ad = Math.max(...id) - od;
      ed.mask = "*".repeat(od), ad && (ed.mask += "[" + "*".repeat(ad) + "]"), this.enum = xr;
    }
    super._update(ed);
  }
  _appendCharRaw(Ae, xr) {
    xr === void 0 && (xr = {});
    const ed = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length), id = this.enum.filter((od) => this.matchValue(od, this.unmaskedValue + Ae, ed));
    if (id.length) {
      id.length === 1 && this._forEachBlocksInRange(0, this.value.length, (ad, rd) => {
        const sd = id[0][rd];
        rd >= this.value.length || sd === ad.value || (ad.reset(), ad._appendChar(sd, xr));
      });
      const od = super._appendCharRaw(id[0][this.value.length], xr);
      return id.length === 1 && id[0].slice(this.unmaskedValue.length).split("").forEach((ad) => od.aggregate(super._appendCharRaw(ad))), od;
    }
    return new ChangeDetails({
      skip: !this.isComplete
    });
  }
  extractTail(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), new ContinuousTailDetails("", Ae);
  }
  remove(Ae, xr) {
    if (Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), Ae === xr)
      return new ChangeDetails();
    const ed = Math.min(super.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    let id;
    for (id = Ae; id >= 0 && !(this.enum.filter((rd) => this.matchValue(rd, this.value.slice(ed, id), ed)).length > 1); --id)
      ;
    const od = super.remove(id, xr);
    return od.tailShift += id - Ae, od;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
MaskedEnum.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  matchValue: (td, Ae, xr) => td.indexOf(Ae, xr) === xr
};
IMask.MaskedEnum = MaskedEnum;
class MaskedFunction extends Masked {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    super._update({
      ...Ae,
      validate: Ae.mask
    });
  }
}
IMask.MaskedFunction = MaskedFunction;
var _MaskedNumber;
class MaskedNumber extends Masked {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(Ae) {
    super({
      ...MaskedNumber.DEFAULTS,
      ...Ae
    });
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    super._update(Ae), this._updateRegExps();
  }
  _updateRegExps() {
    const Ae = "^" + (this.allowNegative ? "[+|\\-]?" : ""), xr = "\\d*", ed = (this.scale ? "(" + escapeRegExp(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(Ae + xr + ed), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(escapeRegExp).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(Ae) {
    return Ae.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(Ae) {
    const xr = Ae.split(this.radix);
    return xr[0] = xr[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), xr.join(this.radix);
  }
  doPrepareChar(Ae, xr) {
    xr === void 0 && (xr = {});
    const [ed, id] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (xr.input && xr.raw || !xr.input && !xr.raw) ? Ae.replace(this._mapToRadixRegExp, this.radix) : Ae), xr);
    return Ae && !ed && (id.skip = !0), ed && !this.allowPositive && !this.value && ed !== "-" && id.aggregate(this._appendChar("-")), [ed, id];
  }
  _separatorsCount(Ae, xr) {
    xr === void 0 && (xr = !1);
    let ed = 0;
    for (let id = 0; id < Ae; ++id)
      this._value.indexOf(this.thousandsSeparator, id) === id && (++ed, xr && (Ae += this.thousandsSeparator.length));
    return ed;
  }
  _separatorsCountFromSlice(Ae) {
    return Ae === void 0 && (Ae = this._value), this._separatorsCount(this._removeThousandsSeparators(Ae).length, !0);
  }
  extractInput(Ae, xr, ed) {
    return Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), [Ae, xr] = this._adjustRangeWithSeparators(Ae, xr), this._removeThousandsSeparators(super.extractInput(Ae, xr, ed));
  }
  _appendCharRaw(Ae, xr) {
    xr === void 0 && (xr = {});
    const ed = xr.tail && xr._beforeTailState ? xr._beforeTailState._value : this._value, id = this._separatorsCountFromSlice(ed);
    this._value = this._removeThousandsSeparators(this.value);
    const od = this._value;
    this._value += Ae;
    const ad = this.number;
    let rd = !isNaN(ad), sd = !1;
    if (rd) {
      let ld;
      this.min != null && this.min < 0 && this.number < this.min && (ld = this.min), this.max != null && this.max > 0 && this.number > this.max && (ld = this.max), ld != null && (this.autofix ? (this._value = this.format(ld, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix), sd || (sd = od === this._value && !xr.tail)) : rd = !1), rd && (rd = !!this._value.match(this._numberRegExp));
    }
    let nd;
    rd ? nd = new ChangeDetails({
      inserted: this._value.slice(od.length),
      rawInserted: sd ? "" : Ae,
      skip: sd
    }) : (this._value = od, nd = new ChangeDetails()), this._value = this._insertThousandsSeparators(this._value);
    const cd = xr.tail && xr._beforeTailState ? xr._beforeTailState._value : this._value, ud = this._separatorsCountFromSlice(cd);
    return nd.tailShift += (ud - id) * this.thousandsSeparator.length, nd;
  }
  _findSeparatorAround(Ae) {
    if (this.thousandsSeparator) {
      const xr = Ae - this.thousandsSeparator.length + 1, ed = this.value.indexOf(this.thousandsSeparator, xr);
      if (ed <= Ae)
        return ed;
    }
    return -1;
  }
  _adjustRangeWithSeparators(Ae, xr) {
    const ed = this._findSeparatorAround(Ae);
    ed >= 0 && (Ae = ed);
    const id = this._findSeparatorAround(xr);
    return id >= 0 && (xr = id + this.thousandsSeparator.length), [Ae, xr];
  }
  remove(Ae, xr) {
    Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length), [Ae, xr] = this._adjustRangeWithSeparators(Ae, xr);
    const ed = this.value.slice(0, Ae), id = this.value.slice(xr), od = this._separatorsCount(ed.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(ed + id));
    const ad = this._separatorsCountFromSlice(ed);
    return new ChangeDetails({
      tailShift: (ad - od) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(Ae, xr) {
    if (!this.thousandsSeparator)
      return Ae;
    switch (xr) {
      case DIRECTION.NONE:
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT: {
        const ed = this._findSeparatorAround(Ae - 1);
        if (ed >= 0) {
          const id = ed + this.thousandsSeparator.length;
          if (Ae < id || this.value.length <= id || xr === DIRECTION.FORCE_LEFT)
            return ed;
        }
        break;
      }
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT: {
        const ed = this._findSeparatorAround(Ae);
        if (ed >= 0)
          return ed + this.thousandsSeparator.length;
      }
    }
    return Ae;
  }
  doCommit() {
    if (this.value) {
      const Ae = this.number;
      let xr = Ae;
      this.min != null && (xr = Math.max(xr, this.min)), this.max != null && (xr = Math.min(xr, this.max)), xr !== Ae && (this.unmaskedValue = this.format(xr, this));
      let ed = this.value;
      this.normalizeZeros && (ed = this._normalizeZeros(ed)), this.padFractionalZeros && this.scale > 0 && (ed = this._padFractionalZeros(ed)), this._value = ed;
    }
    super.doCommit();
  }
  _normalizeZeros(Ae) {
    const xr = this._removeThousandsSeparators(Ae).split(this.radix);
    return xr[0] = xr[0].replace(/^(\D*)(0*)(\d*)/, (ed, id, od, ad) => id + ad), Ae.length && !/\d$/.test(xr[0]) && (xr[0] = xr[0] + "0"), xr.length > 1 && (xr[1] = xr[1].replace(/0*$/, ""), xr[1].length || (xr.length = 1)), this._insertThousandsSeparators(xr.join(this.radix));
  }
  _padFractionalZeros(Ae) {
    if (!Ae)
      return Ae;
    const xr = Ae.split(this.radix);
    return xr.length < 2 && xr.push(""), xr[1] = xr[1].padEnd(this.scale, "0"), xr.join(this.radix);
  }
  doSkipInvalid(Ae, xr, ed) {
    xr === void 0 && (xr = {});
    const id = this.scale === 0 && Ae !== this.thousandsSeparator && (Ae === this.radix || Ae === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(Ae));
    return super.doSkipInvalid(Ae, xr, ed) && !id;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
  }
  set unmaskedValue(Ae) {
    super.unmaskedValue = Ae;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(Ae) {
    this.rawInputValue = this.format(Ae, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(Ae) {
    this.typedValue = Ae;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(Ae) {
    return (super.typedValueEquals(Ae) || MaskedNumber.EMPTY_VALUES.includes(Ae) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(Ae === 0 && this.value === "");
  }
}
_MaskedNumber = MaskedNumber;
MaskedNumber.UNMASKED_RADIX = ".";
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
MaskedNumber.DEFAULTS = {
  ...Masked.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [_MaskedNumber.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (td) => td.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
IMask.MaskedNumber = MaskedNumber;
const PIPE_TYPE = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function createPipe(td, Ae, xr) {
  Ae === void 0 && (Ae = PIPE_TYPE.MASKED), xr === void 0 && (xr = PIPE_TYPE.MASKED);
  const ed = createMask(td);
  return (id) => ed.runIsolated((od) => (od[Ae] = id, od[xr]));
}
function pipe(td, Ae, xr, ed) {
  return createPipe(Ae, xr, ed)(td);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;
class RepeatBlock extends MaskedPattern {
  get repeatFrom() {
    var Ae;
    return (Ae = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? Ae : 0;
  }
  get repeatTo() {
    var Ae;
    return (Ae = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? Ae : 1 / 0;
  }
  constructor(Ae) {
    super(Ae);
  }
  updateOptions(Ae) {
    super.updateOptions(Ae);
  }
  _update(Ae) {
    var xr, ed, id;
    const {
      repeat: od,
      ...ad
    } = normalizeOpts(Ae);
    this._blockOpts = Object.assign({}, this._blockOpts, ad);
    const rd = createMask(this._blockOpts);
    this.repeat = (xr = (ed = od != null ? od : rd.repeat) != null ? ed : this.repeat) != null ? xr : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((id = this._blocks) == null ? void 0 : id.length) || 0, this.repeatFrom)),
      blocks: {
        m: rd
      },
      eager: rd.eager,
      overwrite: rd.overwrite,
      skipInvalid: rd.skipInvalid,
      lazy: rd.lazy,
      placeholderChar: rd.placeholderChar,
      displayChar: rd.displayChar
    });
  }
  _allocateBlock(Ae) {
    if (Ae < this._blocks.length)
      return this._blocks[Ae];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(createMask(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(Ae, xr) {
    xr === void 0 && (xr = {});
    const ed = new ChangeDetails();
    for (
      let sd = (id = (od = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : od.index) != null ? id : Math.max(this._blocks.length - 1, 0), nd, cd;
      // try to get a block or
      // try to allocate a new block if not allocated already
      nd = (ad = this._blocks[sd]) != null ? ad : cd = !cd && this._allocateBlock(sd);
      ++sd
    ) {
      var id, od, ad, rd;
      const ud = nd._appendChar(Ae, {
        ...xr,
        _beforeTailState: (rd = xr._beforeTailState) == null || (rd = rd._blocks) == null ? void 0 : rd[sd]
      });
      if (ud.skip && cd) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (ed.aggregate(ud), ud.consumed)
        break;
    }
    return ed;
  }
  _trimEmptyTail(Ae, xr) {
    var ed, id;
    Ae === void 0 && (Ae = 0);
    const od = Math.max(((ed = this._mapPosToBlock(Ae)) == null ? void 0 : ed.index) || 0, this.repeatFrom, 0);
    let ad;
    xr != null && (ad = (id = this._mapPosToBlock(xr)) == null ? void 0 : id.index), ad == null && (ad = this._blocks.length - 1);
    let rd = 0;
    for (let sd = ad; od <= sd && !this._blocks[sd].unmaskedValue; --sd, ++rd)
      ;
    rd && (this._blocks.splice(ad - rd + 1, rd), this.mask = this.mask.slice(rd));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(Ae, xr) {
    Ae === void 0 && (Ae = 0), xr === void 0 && (xr = this.displayValue.length);
    const ed = super.remove(Ae, xr);
    return this._trimEmptyTail(Ae, xr), ed;
  }
  totalInputPositions(Ae, xr) {
    return Ae === void 0 && (Ae = 0), xr == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(Ae, xr);
  }
  get state() {
    return super.state;
  }
  set state(Ae) {
    this._blocks.length = Ae._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = Ae;
  }
}
IMask.RepeatBlock = RepeatBlock;
try {
  globalThis.IMask = IMask;
} catch (td) {
}
class _DatePicker extends FoundationElement {
}
class FormAssociatedDatePicker extends FormAssociated(_DatePicker) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
const datePlaceholderLocaleData = {
  fr: { year: "A", month: "M", day: "J" },
  en: { year: "Y", month: "M", day: "D" },
  es: { year: "A", month: "M", day: "D" },
  cs: { year: "R", month: "M", day: "D" },
  da: { year: "Å", month: "M", day: "D" },
  de: { year: "J", month: "M", day: "T" },
  it: { year: "A", month: "M", day: "G" },
  nl: { year: "J", month: "M", day: "D" },
  no: { year: "Å", month: "M", day: "D" },
  pl: { year: "R", month: "M", day: "D" },
  pt: { year: "A", month: "M", day: "D" },
  fi: { year: "V", month: "K", day: "P" },
  sv: { year: "Å", month: "M", day: "D" }
}, datePickerSizeSmall = cssPartial`
  --line-height: 21px;
  --input-size: 28px;
  --label-padding: 7px;
  --padding: ${GDSESpacingInputVerS} ${GDSESpacingInputHorS};
`, datePickerSizeRegular = cssPartial`
  --line-height: 21px;
  --input-size: 36px;
  --input-horizontal-padding: ${GDSESpacing150};
  --label-padding: 10px;
  --padding: ${GDSESpacingInputVerM}  ${GDSESpacingInputHorM};
`, datePickerSizeLarge = cssPartial`
--line-height: 24px;
  --input-size: 44px;
  --line-height: 24px;
  --label-padding: 12px;
  --padding: ${GDSESpacingInputVerL} ${GDSESpacingInputHorL};
`, tm1DatePickerStyles = css`
  :host {
    --input-height: 36px;
    --label-height: 20px;
    width: 100%;
    box-sizing: border-box;
    display: block;
  }

  .date-picker {
    position: relative;
  }

  .container {
    display: flex;
    column-gap: ${GDSESpacing200};
    row-gap: ${GDSESpacing500};
  }

  :host([calendar-visible]) .container,
  :host([calendarvisible]) .container {
    width: 280px;
    margin-bottom: ${GDSESpacing200};
  }

  :host([theme='dark'][calendar-visible]) .container,
  :host([theme='dark'][calendarvisible]) .container {
    margin-bottom: ${GDSESpacing500};
  }

  :host([calendar-visible]),
  :host([calendarvisible]) {
    width: auto;
  }

  :host([calendar-visible]) .date-picker,
  :host([calendarvisible]) .date-picker {
    width: max-content;
  }

  :host([calendar-visible][mobile]) .date-picker,
  :host([calendarvisible][mobile]) .date-picker {
    margin: 0 auto;
  }

  :host(:not([calendar-hidden])) .calendars {
    width: max-content;
    z-index: 2;
    padding: ${GDSESpacing200};
    border-radius: ${GDSERadiusSurface};
    border: 1px solid ${GDSEColorBorderPopover};
    background-color: ${GDSEColorSurfacePopover};
    gap: ${GDSESpacing200};
    position: absolute;
    top: calc(var(--input-height) + var(--label-height) + 2px);
  }

  :host .calendars-container {
    display: flex;
    gap: ${GDSESpacing200};
  }

  :host([calendar-visible]) .calendars,
  :host([calendarvisible]) .calendars {
    margin-top: ${GDSESpacing300};
    display: block;
  }

  :host([calendar-visible]) tm1-calendar,
  :host([calendarvisible]) tm1-calendar {
    display: block;
  }

  :host([inputsize='small']),
  :host([input-size='small']) {
    --input-height: 28px;
  }

  :host([inputsize='large']),
  :host([input-size='large']) {
    --input-height: 44px;
  }

  :host(:not([label])) {
    --label-height: 0px;
  }

  :host .placeholder {
    color: ${GDSEColorTextMuted};
  }

  :host .actions-container {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    gap: ${GDSESpacing200};
    margin-top: ${GDSESpacing200};
  }
  :host([input-size='small']),
  :host([input-size='small']) input,
  :host([inputsize='small']),
  :host([inputsize='small']) input {
    ${datePickerSizeSmall}
  }

  :host([input-size='regular']),
  :host([input-size='regular']) input,
  :host([inputsize='regular']),
  :host([inputsize='regular']) input {
    ${datePickerSizeRegular}
  }

  :host([input-size='large']),
  :host([input-size='large']) input,
  :host([inputsize='large']),
  :host([inputsize='large']) input {
    ${datePickerSizeLarge}
  }

  .input-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .root {
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: row;
    color: ${GDSEColorText};
    align-items: baseline;

    padding: var(--padding);
    border-radius: ${GDSERadiusInput};
    border: solid 1px ${GDSEColorBorderInputDefault};
    background-color: ${GDSEColorFillInput};
    height: var(--input-size);
  }

  .label {
    display: block;
    color: ${GDSEColorText};
    margin-bottom: ${GDSESpacing25};
    line-height: ${GDSELineHeightBody};
  }

  .error,
  .helper {
    margin-top: ${GDSESpacing25};
    margin-bottom: ${GDSESpacing0};
  }

  .error {
    color: ${GDSEColorTextCritical};
    display: flex;
    align-items: center;
    gap: ${GDSESpacing25};
  }

  .helper {
    color: ${GDSEColorTextLight};
  }

  .control {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  input,
  input:disabled,
  input:focus {
    font-family: ${GDSEFontFamily};
    -webkit-appearance: none;
    background: transparent;
    color: inherit;
    height: 100%;
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;

    border: none;
    outline: none;
    box-sizing: border-box;
    line-height: var(--line-height);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  input:disabled {
    cursor: not-allowed;
  }

  ::slotted(svg) {
    /* TODO: adaptive typography https://github.com/microsoft/fast/issues/2432 */
    width: 16px;
    height: 16px;
  }

  :host([aria-invalid="true"]:not([disabled]):not([readonly])) .root {
    border-color: ${GDSEColorTextCritical};
  }

  :host(:not([disabled]):not([readonly])) .root:hover {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host(:not([disabled]):not([readonly]):focus) .root,
  :host(:not([disabled]):not([readonly]):active) .root {
    border-color: ${GDSEColorBorderInputActive};
  }

  :host([appearance='filled']) .root {
    background: ${GDSEColorSurfaceAlt};
  }

  :host([disabled]),
  :host([readonly]),
  :host([disabled]) .label,
  :host([readonly]) .label,
  :host([readonly]) .root,
  :host([disabled]) .root,
  :host([readonly]) .control,
  :host([disabled]) .control {
    cursor: not-allowed;
  }

  :host([readonly]) .root {
    border: none;
    background: transparent;
    padding: ${GDSESpacing0};
  }

  :host([disabled]) .root {
    border: 1px solid ${GDSEColorBorderInputDisabled};
    background-color: ${GDSEColorFillInputDisabled};
  }

  :host([disabled]) .control,
  :host([disabled]) input::placeholder {
    font-family: ${GDSEFontFamily};
    color: ${GDSEColorTextDisabled};
  }

  :host input::placeholder {
    color: ${GDSEColorTextMuted};
  }

  :host([labelposition='top']) .label {
    display: block;
  }

  :host([labelposition='top']) .root {
    display: flex;
  }

  :host([labelposition='left']) {
    display: inline-flex;
  }

  :host([labelposition='left']) .label {
    display: inline-flex;
    padding-top: var(--label-padding);
    margin-right: ${GDSESpacing100};
    min-width: fit-content;
  }

  :host([labelposition='left']) .root {
    display: inline-flex;
    width: 100%;
  }

  :host input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }

  .input-typography {
    width: inherit;
  }

  .clear-button {
    background: transparent;
    color: ${GDSEColorTextLight};
    fill: ${GDSEColorTextLight};
    border: none;
    outline: none;
    padding: ${GDSESpacing0};
  }

  .clear-button:not([disabled]):not([readonly]):hover {
    cursor: pointer;
    fill: ${GDSEColorText};
    color: ${GDSEColorText};
  }

  .clear-button:not([hidden]) {
    height: 16px;
  }
`, tm1DatePickerTemplate = (td) => html`
<template ?calendar-hidden=${(Ae) => !Ae.open} ?mobile=${(Ae) => Ae.mobile} theme=${(Ae) => Ae.theme}>
  <div class="date-picker">
      <div class="container">
        <div class="input-container">
        ${when(
  (Ae) => Ae.hasLabel(),
  html`<${td.tagFor(Typography)} class="label" type="label-helpertext-regular" data-testid="label">
            <label part="label" for="${(Ae) => Ae.defaultId()}">
              ${(Ae) => Ae.label ? Ae.label : html`<slot ${slotted("defaultSlottedNodes")}></slot>`}
            </label>
          </${td.tagFor(Typography)}>`
)}

          <div part="root" class="root" data-testid="root">
            <div part="control" class="control">
              <input
                id=${(Ae) => Ae.defaultId()}
                class=${(Ae) => Ae.classes}
                data-testid="input"
                name=${(Ae) => Ae.name}
                inputSize=${(Ae) => Ae.inputSize}
                part="input"
                placeholder=${(Ae) => Ae.placeholder}
                type="text"
                tabindex="${(Ae) => Ae.disabled ? null : 0}"
                aria-atomic="${(Ae) => {
  var xr;
  return (xr = Ae.ariaAtomic) != null ? xr : !1;
}}"
                aria-busy="${(Ae) => {
  var xr;
  return (xr = Ae.ariaBusy) != null ? xr : !1;
}}"
                aria-controls="${(Ae) => Ae.ariaControls}"
                aria-current="${(Ae) => {
  var xr;
  return (xr = Ae.ariaCurrent) != null ? xr : null;
}}"
                aria-describedby="${(Ae) => Ae.ariaDescribedby}"
                aria-details="${(Ae) => Ae.ariaDetails}"
                aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled || Ae.disabled) != null ? xr : !1;
}}"
                aria-errormessage="${(Ae) => Ae.errorDefaultId()}"
                aria-flowto="${(Ae) => Ae.ariaFlowto}"
                aria-haspopup="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHaspopup) != null ? xr : !1;
}}"
                aria-hidden="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHidden) != null ? xr : !1;
}}"
                aria-invalid="${(Ae) => !!Ae.errorLabel}"
                aria-keyshortcuts="${(Ae) => Ae.ariaKeyshortcuts}"
                aria-label="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLabel || Ae.label) != null ? xr : "";
}}"
                aria-labelledby="${(Ae) => Ae.ariaLabelledby}"
                aria-live="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLive) != null ? xr : !1;
}}"
                aria-owns="${(Ae) => Ae.ariaOwns}"
                aria-relevant="${(Ae) => {
  var xr;
  return (xr = Ae.ariaRelevant) != null ? xr : "additions text";
}}"
                aria-roledescription="${(Ae) => Ae.ariaRoledescription}"
                ?autofocus="${(Ae) => {
  var xr;
  return (xr = Ae.autofocus) != null ? xr : !1;
}}"
                ?disabled=${(Ae) => Ae.disabled}
                ?readonly="${(Ae) => {
  var xr;
  return (xr = Ae.readOnly) != null ? xr : !1;
}}"
                ?required=${(Ae) => Ae.required}
                ?spellcheck="${(Ae) => {
  var xr;
  return (xr = Ae.spellcheck) != null ? xr : !1;
}}"
                pattern="${(Ae) => Ae.pattern}"
                @blur="${(Ae) => Ae.handleBlur()}"
                @click="${(Ae) => Ae.showCalendar()}"
                @focus="${(Ae) => Ae.handleFocus()}"
                @change="${(Ae, xr) => Ae.mode === "single" ? Ae.handleChange(xr.event) : Ae.handleDoubleDateChange(xr.event)}"
                ${ref("control")}
              />

              ${when((Ae) => Ae.clearable, html`
                <button
                  class="clear-button"
                  part="clear-button"
                  aria-label="button-clear"
                  aria-hidden="${(Ae) => Ae.closeHidden}"
                  ?hidden="${(Ae) => Ae.closeHidden}"
                  ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled || Ae.readOnly) != null ? xr : !1;
}}"
                  tabindex="-1"
                  role="button"
                  @click=${(Ae) => Ae.handleClearInput()}
                  data-testid="clear-button"
                >
                <slot name="close-glyph">
                  <${td.tagFor(Icon)}
                    class="clear-icon"
                    icon="clear"
                    size="small"
                    color="inherit"
                  ></${td.tagFor(Icon)}>
                  </slot>
                </button>
              `)}

              ${when((Ae) => !!Ae.closeHidden || !Ae.clearable, html`<${td.tagFor(Icon)} slot="start" icon="calendar" size="small"></${td.tagFor(Icon)}>`)}
            </div>
          </div>

            ${when(
  (Ae) => !!Ae.errorLabel && !Ae.readOnly && !Ae.disabled,
  html`<div class="error" role="alert">
                    <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
                    <${td.tagFor(Typography)} type="label-helpertext-regular" id="${(Ae) => Ae.errorDefaultId()}">
                      ${(Ae) => Ae.errorLabel}
                    </${td.tagFor(Typography)}>
                  </div>`
)}

            ${when(
  (Ae) => !!Ae.helpLabel && !Ae.errorLabel && !Ae.readOnly,
  html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="helper" data-testid="helper">${(Ae) => Ae.helpLabel}</${td.tagFor(Typography)}>`
)}
        </div>
        <slot name="time"></slot>
        </div>

    ${when((Ae) => !Ae.calendarVisible, html`
    <div class="calendars" ${ref("calendar")}>
      <div class="calendars-container">
        <${td.tagFor(Calendar)}
          aria-modal="true"
          aria-live="polite"
          borderless
          isInDatePicker
          isInDateTimePicker=${(Ae) => Ae.isInDateTimePicker}
          role="dialog"
          month=${(Ae) => Ae.month}
          year=${(Ae) => Ae.year}
          end-year=${(Ae) => Ae.endYear}
          format=${(Ae) => Ae.format}
          selected-date=${(Ae) => Ae.selectedDate}
          disabled-dates=${(Ae) => JSON.stringify(Ae.disabledDates)}
          highlight-dates=${(Ae) => {
  var xr;
  return JSON.stringify((xr = Ae.highlightDates) != null ? xr : []);
}}
          max-date=${(Ae) => Ae.maxDate}
          min-date=${(Ae) => Ae.minDate}
          start-year=${(Ae) => Ae.startYear}
          range-start-date=${(Ae) => Ae.rangeStartDate}
          range-end-date=${(Ae) => Ae.rangeEndDate}
          ?fixed=${(Ae) => Ae.mode === "multi" && !Ae.mobile}
          ?hidden=${(Ae) => !Ae.open && !Ae.calendarVisible}
          ?range=${(Ae) => Ae.range}
          @change="${(Ae, xr) => Ae.handleCalendarChange(xr.event, Ae.mode === "multi" && !Ae.mobile && Ae.range)}"
          @month-change=${(Ae, xr) => Ae.mode === "multi" && !Ae.mobile ? Ae.handleMonthChange(xr.event, "first") : ""}
          @year-change=${(Ae, xr) => Ae.mode === "multi" && !Ae.mobile ? Ae.handleYearChange(xr.event) : ""}
        ></${td.tagFor(Calendar)}>

        ${when((Ae) => Ae.mode === "multi" && !Ae.mobile, html`
          <${td.tagFor(Calendar)}
            aria-modal="true"
            aria-live="polite"
            role="dialog"
            borderless
            fixed
            isInDatePicker
            isInDateTimePicker=${(Ae) => Ae.isInDateTimePicker}
            order="second"
            month=${(Ae) => Ae.getSecondSelectedMonth()}
            year=${(Ae) => Ae.getSecondSelectedYear()}
            end-year=${(Ae) => Ae.endYear}
            format=${(Ae) => Ae.format}
            selected-date=${(Ae) => Ae.selectedDate}
            disabled-dates=${(Ae) => JSON.stringify(Ae.disabledDates)}
            highlight-dates=${(Ae) => {
  var xr;
  return JSON.stringify((xr = Ae.highlightDates) != null ? xr : []);
}}
            max-date=${(Ae) => Ae.maxDate}
            min-date=${(Ae) => Ae.minDate}
            start-year=${(Ae) => Ae.startYear}
            range-start-date=${(Ae) => Ae.rangeStartDate}
            range-end-date=${(Ae) => Ae.rangeEndDate}
            ?range=${(Ae) => Ae.range}
            ?hidden=${(Ae) => !Ae.open && !Ae.calendarVisible}
            @change="${(Ae, xr) => Ae.handleCalendarChange(xr.event, Ae.range)}"
            @month-change=${(Ae, xr) => Ae.handleMonthChange(xr.event, "second")}
            @year-change=${(Ae, xr) => Ae.handleYearChange(xr.event)}
          ></${td.tagFor(Calendar)}>
      </div>
      `)}
    </div>

    ${when((Ae) => Ae.mode === "multi" && !Ae.mobile && Ae.open, html`
      <div class="actions-container">
        <${td.tagFor(Button)} variant="lightweight" @click=${(Ae) => Ae.onHandleCancel()}>
          ${(Ae) => Ae.cancelText}
        </${td.tagFor(Button)}>

        <${td.tagFor(Button)} @click=${(Ae) => Ae.hideCalendar()}>
          ${(Ae) => Ae.confirmText}
        </${td.tagFor(Button)}>
      </div>
    `)}
  `)}

  ${when((Ae) => Ae.calendarVisible, html`
    <div class="calendars-container">
      <${td.tagFor(Calendar)}
        aria-modal="true"
        aria-live="polite"
        role="dialog"
        borderless
        isInDatePicker
        isInDateTimePicker=${(Ae) => Ae.isInDateTimePicker}
        month=${(Ae) => Ae.month}
        year=${(Ae) => Ae.year}
        end-year=${(Ae) => Ae.endYear}
        format=${(Ae) => Ae.format}
        selected-date=${(Ae) => Ae.selectedDate}
        disabled-dates=${(Ae) => JSON.stringify(Ae.disabledDates)}
        highlight-dates=${(Ae) => {
  var xr;
  return JSON.stringify((xr = Ae.highlightDates) != null ? xr : []);
}}
        max-date=${(Ae) => Ae.maxDate}
        min-date=${(Ae) => Ae.minDate}
        start-year=${(Ae) => Ae.startYear}
        range-start-date=${(Ae) => Ae.rangeStartDate}
        range-end-date=${(Ae) => Ae.rangeEndDate}
        ?fixed=${(Ae) => Ae.mode === "multi" && !Ae.mobile}
        ?keepTimezone=${(Ae) => Ae.keepTimezone}
        ?range=${(Ae) => Ae.range}
        @change="${(Ae, xr) => Ae.handleCalendarChange(xr.event, Ae.mode === "multi" && Ae.range && !Ae.mobile)}"
        @month-change=${(Ae, xr) => Ae.mode === "multi" && !Ae.mobile ? Ae.handleMonthChange(xr.event, "first") : ""}
        @year-change=${(Ae, xr) => Ae.mode === "multi" && !Ae.mobile ? Ae.handleYearChange(xr.event) : ""}
      ></${td.tagFor(Calendar)}>

      ${when((Ae) => Ae.mode === "multi" && !Ae.mobile, html`
        <${td.tagFor(Calendar)}
          aria-modal="true"
          aria-live="polite"
          role="dialog"
          borderless
          fixed
          isInDatePicker
          isInDateTimePicker=${(Ae) => Ae.isInDateTimePicker}
          order="second"
          month=${(Ae) => Ae.getSecondSelectedMonth()}
          year=${(Ae) => Ae.getSecondSelectedYear()}
          end-year=${(Ae) => Ae.endYear}
          format=${(Ae) => Ae.format}
          selected-date=${(Ae) => Ae.selectedDate}
          disabled-dates=${(Ae) => JSON.stringify(Ae.disabledDates)}
          highlight-dates=${(Ae) => {
  var xr;
  return JSON.stringify((xr = Ae.highlightDates) != null ? xr : []);
}}
          max-date=${(Ae) => Ae.maxDate}
          min-date=${(Ae) => Ae.minDate}
          start-year=${(Ae) => Ae.startYear}
          range-start-date=${(Ae) => Ae.rangeStartDate}
          range-end-date=${(Ae) => Ae.rangeEndDate}
          ?range=${(Ae) => Ae.range}
          ?keepTimezone=${(Ae) => Ae.keepTimezone}
          @change="${(Ae, xr) => Ae.handleCalendarChange(xr.event, Ae.range)}"
          @month-change=${(Ae, xr) => Ae.handleMonthChange(xr.event, "second")}
          @year-change=${(Ae, xr) => Ae.handleYearChange(xr.event)}
        ></${td.tagFor(Calendar)}>
      `)}
    </div>
    </div>
  `)}
      </div>
</template>
`;
var __defProp$K = Object.defineProperty, __getOwnPropDesc$K = Object.getOwnPropertyDescriptor, __decorateClass$K = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$K(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$K(Ae, xr, id), id;
};
const CalendarPosition = {
  bottom: "bottom",
  top: "top",
  "top-start": "top-start",
  "top-end": "top-end",
  "bottom-start": "bottom-start",
  "bottom-end": "bottom-end"
}, DatePickerMode = {
  single: "single",
  multi: "multi"
};
class DatePickerV2 extends FormAssociatedDatePicker {
  constructor() {
    super(), this.placeholder = "", this.format = "DD/MM/YYYY", this.localized = !1, this.month = (/* @__PURE__ */ new Date()).getUTCMonth(), this.disabled = !1, this.range = !1, this.required = !1, this.open = !1, this.clearable = !1, this.position = CalendarPosition.bottom, this.mode = DatePickerMode.single, this.labelPosition = "top", this.readOnly = !1, this.disabledDates = [], this.inputSize = "regular", this.maxDate = "", this.minDate = "", this.rangeEndDate = "", this.rangeStartDate = "", this.selectedDate = "", this.calendarVisible = !1, this.keepTimezone = !1, this.confirmText = "Apply", this.cancelText = "Cancel", this.isInDateTimePicker = !1, this.lang = "en", this.classes = "", this.mobile = !1, this.theme = ThemeType.light, this.closeHidden = !0, this.firstRender = !0, this.hasBlurred = !1, this.mobileThreshold = 650, this.pattern = /^\d{2}\/\d{2}\/\d{2}$/, this.hasLabel = () => {
      var xr;
      const Ae = (xr = this.defaultSlottedNodes) == null ? void 0 : xr.filter((ed) => ed.data !== `
`);
      return !!this.label || (Ae == null ? void 0 : Ae.length) !== 0;
    }, this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" }), this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this.handleTextInput = (Ae) => {
      Ae.stopPropagation(), this.range ? this.onInputHandleRange() : this.onInputHandleNonRange(), this.onInputHandleCloseHidden();
    }, this.clickBehavior = new ClickBehavior();
  }
  formatDatePlaceholderToLocale() {
    return this.format.replace("YYYY", `${datePlaceholderLocaleData[this.lang].year}${datePlaceholderLocaleData[this.lang].year}`).replace("MM", `${datePlaceholderLocaleData[this.lang].month}${datePlaceholderLocaleData[this.lang].month}`).replace("DD", `${datePlaceholderLocaleData[this.lang].day}${datePlaceholderLocaleData[this.lang].day}`);
  }
  errorChanged() {
    this.validate();
  }
  connectedCallback() {
    var ed;
    super.connectedCallback(), this.$fastController.addBehaviors([this.clickBehavior]), this.lang = (ed = language.getLanguage(this).substring(0, 2)) != null ? ed : "en", this.localized && (this.format = userLanguageToFormat(this.lang));
    const { monthIdx: Ae, yearIdx: xr } = getFormatPartsIdx(this.format);
    window.addEventListener("resize", () => this.handleMobileResize(), !0), DOM.queueUpdate(() => {
      var ad;
      this.handleMobileResize(), this.formatDatePlaceholderToLocale(), this.year = (ad = this.year) != null ? ad : (/* @__PURE__ */ new Date()).getUTCFullYear(), this.pattern = this.range ? /^\d{2}\/\d{2}\/\d{2} - \d{2}\/\d{2}\/\d{2}$/ : /^\d{2}\/\d{2}\/\d{2}$/, this.placeholder === "" && !this.range ? this.placeholder = this.formatDatePlaceholderToLocale() : this.placeholder === "" && this.range && (this.placeholder = `${this.formatDatePlaceholderToLocale()} - ${this.formatDatePlaceholderToLocale()}`);
      const id = this.getShortFormat(), od = {
        mask: Date,
        pattern: this.range ? `${id} - ${id}` : id,
        lazy: !1,
        autofix: "pad",
        overwrite: !0,
        blocks: {
          d: { mask: IMask.MaskedRange, placeholderChar: datePlaceholderLocaleData[this.lang].day, from: 1, to: 31, maxLength: 2 },
          m: { mask: IMask.MaskedRange, placeholderChar: datePlaceholderLocaleData[this.lang].month, from: 1, to: 12, maxLength: 2 },
          Y: { mask: IMask.MaskedRange, placeholderChar: datePlaceholderLocaleData[this.lang].year, from: 0, to: 99, maxLength: 2 }
        },
        format: (rd) => rd,
        parse: (rd) => rd
      };
      if (this.mask = IMask(this.control, od), this.control.addEventListener("input", this.handleTextInput), this.selectedDate) {
        const rd = formatDate(this.selectedDate, this.format, this.keepTimezone);
        if (rd && !isNaN(new Date(this.selectedDate).valueOf())) {
          const sd = formatDateToString(rd, this.format, this.keepTimezone), nd = sd.split(/\/+/), cd = +nd[Ae] - 1, ud = +nd[xr];
          this.mask.value = sd, this.value = sd, this.month !== cd && (this.month = cd), this.year !== ud && (this.year = ud + 2e3);
        } else
          this.selectedDate = "";
      }
      if (this.range && this.rangeStartDate) {
        const { isValid: rd, date: sd } = isValidDate(this.rangeStartDate, this.format, this.keepTimezone);
        this.rangeStartDate = rd ? sd.toISOString() : "";
        const cd = formatDateToString(sd, this.format, this.keepTimezone).split(/\/+/), ud = +cd[Ae] - 1, ld = +cd[xr];
        if (this.rangeStartDate && this.rangeEndDate) {
          const { isValid: dd, date: pd } = isValidDate(this.rangeEndDate, this.format, this.keepTimezone);
          if (this.rangeEndDate = dd ? pd.toISOString() : "", rd && dd) {
            const md = formatDateToString(sd, this.format, this.keepTimezone), fd = formatDateToString(pd, this.format, this.keepTimezone);
            this.mask.value = `${md} - ${fd}`, this.value = `${md} - ${fd}`, this.month !== ud && (this.month = ud), this.year !== ld && (this.year = ld + 2e3);
          } else if (sd && !isNaN(new Date(this.rangeStartDate).valueOf())) {
            const md = formatDateToString(sd, this.format, this.keepTimezone);
            this.mask.value = `${md} - ${this.format.replace("YYYY", "YY")}`, this.value = `${md} - ${this.format.replace("YYYY", "YY")}`, this.month !== ud && (this.month = ud), this.year !== ld && (this.year = ld + 2e3);
          } else
            this.rangeStartDate = "", this.rangeEndDate = "";
        } else if (sd && !isNaN(new Date(this.rangeStartDate).valueOf())) {
          const dd = formatDateToString(sd, this.format, this.keepTimezone);
          this.mask.value = `${dd} - ${this.format.replace("YYYY", "YY")}`, this.value = `${dd} - ${this.format.replace("YYYY", "YY")}`, this.month !== ud && (this.month = ud), this.year !== ld && (this.year = ld + 2e3);
        } else
          this.rangeStartDate = "";
      }
      this.control.value !== this.placeholder && (this.closeHidden = !1), this.setPlaceholder(), this.firstRender = !1;
    });
  }
  disconnectedCallback() {
    var Ae;
    this.$fastController.removeBehaviors([this.clickBehavior]), (Ae = this.mask) == null || Ae.destroy(), this.control.removeEventListener("input", this.handleTextInput), window.removeEventListener("resize", () => this.handleMobileResize(), !0), super.disconnectedCallback();
  }
  handleMobileResize() {
    this.mobile = document.documentElement.clientWidth < this.mobileThreshold;
  }
  getShortFormat() {
    return this.format.replace("YYYY", "`Y").replace("MM", "`m").replace("DD", "`d");
  }
  formatChanged(Ae, xr) {
    if (Ae !== xr && xr && this.mask) {
      const ed = this.getShortFormat();
      this.mask.updateOptions({
        pattern: this.range ? `${ed} - ${ed}` : ed
      });
    }
  }
  disabledDatesChanged() {
    this.isInDateTimePicker && typeof this.disabledDates == "string" && (this.disabledDates = JSON.parse(this.disabledDates));
  }
  highlightDatesChanged() {
    this.isInDateTimePicker && typeof this.highlightDates == "string" && this.highlightDates.trim() && (this.highlightDates = JSON.parse(this.highlightDates));
  }
  handleMonthChange(Ae, xr) {
    xr === CalendarOrder.second ? this.month = nextMonth(+this.month) : this.month = +Ae.detail;
  }
  handleYearChange(Ae) {
    this.year = +Ae.detail;
  }
  getSecondSelectedMonth() {
    return nextMonth(+this.month);
  }
  getSecondSelectedYear() {
    return +this.month == 11 && this.year ? +this.year + 1 : this.year;
  }
  setPlaceholder() {
    var ed, id, od, ad;
    const Ae = !!this.selectedDate || !!this.rangeStartDate && this.range, xr = this.range ? `${this.formatDatePlaceholderToLocale()} - ${this.formatDatePlaceholderToLocale()}` : this.formatDatePlaceholderToLocale();
    ((ed = this.mask) == null ? void 0 : ed.value) === this.placeholder || this.placeholder && !Ae && (((id = this.mask) == null ? void 0 : id.value) === "" || ((od = this.mask) == null ? void 0 : od.value) === void 0 || ((ad = this.mask) == null ? void 0 : ad.value) === xr) ? this.classes = "placeholder" : this.classes = "";
  }
  validate() {
    var Ae;
    this.control && (super.validate(this.control), !this.validateValue() || !this.validateValue() && !this.control.checkValidity() ? (this.ariaInvalid = "true", (Ae = this.elementInternals) == null || Ae.setValidity(this.control.validity, this.control.validationMessage, this.control)) : this.ariaInvalid = "false");
  }
  validateValue() {
    var od;
    const Ae = formatDate(this.rangeStartDate, this.format, this.keepTimezone), xr = formatDate(this.rangeEndDate, this.format, this.keepTimezone), ed = !isNaN(new Date(this.rangeStartDate).valueOf()), id = !isNaN(new Date(this.rangeEndDate).valueOf());
    return this.error ? (this.errorLabel = this.error, !1) : this.firstRender ? !0 : !isNaN(new Date((od = this.selectedDate) != null ? od : "").valueOf()) && !this.range || ed && id && Ae <= xr && this.pattern.test(this.control.value) || !this.required && this.mask.value === this.placeholder && this.hasBlurred || !this.required && this.mask.value !== this.placeholder && this.rangeStartDate && !this.rangeEndDate && this.hasBlurred || !this.hasBlurred ? (this.errorLabel = "", !0) : !1;
  }
  handleFocus() {
    this.classes = "";
  }
  handleBlur() {
    this.setPlaceholder(), this.hasBlurred || (this.hasBlurred = !0, this.validate());
  }
  onInputHandleNonRange() {
    const Ae = normalizeUserInput(this.control.value, this.format), xr = Ae.split(/\/+/), { dayIdx: ed, monthIdx: id, yearIdx: od } = getFormatPartsIdx(normalizedFormat), ad = xr[id], rd = xr[od];
    if (ad.includes("-") || (this.month = +ad - 1), rd.includes("-") || (this.year = +rd + 2e3), Ae.includes("-"))
      this.selectedDate = void 0, this.$emit("input", this.control.value);
    else {
      const sd = /* @__PURE__ */ new Date(`20${xr[od]}/${ad}/${xr[ed]}`);
      isNaN(sd.valueOf()) || (this.selectedDate = sd.toISOString(), this.validate(), this.$emit("input", sd.toISOString()));
    }
  }
  onInputHandleRange() {
    const Ae = this.control.value, { start: xr, end: ed, startValid: id, endValid: od, endEmpty: ad } = normalizeUserRangeInput(Ae, this.format);
    if (ad && (this.rangeEndDate = ""), id && !od) {
      const rd = normalizedFormat.indexOf("Y"), sd = xr.substring(0, rd) + "20" + xr.substring(rd, xr.length), nd = new Date(sd);
      isNaN(nd.valueOf()) || (this.rangeStartDate = formatDate(sd, normalizedFormat, this.keepTimezone).toISOString(), this.validate(), this.$emit("input", { start: this.rangeStartDate, end: null }));
    } else
      id && od ? (this.rangeStartDate = formatDate(normalizedToNormalizedWithYear(xr), normalizedFormat, this.keepTimezone).toISOString(), this.rangeEndDate = formatDate(normalizedToNormalizedWithYear(ed), normalizedFormat, this.keepTimezone).toISOString(), this.validate(), this.$emit("input", { start: this.rangeStartDate, end: this.rangeEndDate })) : this.$emit("input", [xr, ed].join(" - "));
  }
  onInputHandleCloseHidden() {
    this.control.value !== this.placeholder && this.control.value !== this.placeholder.substring(1, this.placeholder.length) && this.control.value !== "" ? this.closeHidden = !1 : this.closeHidden = !0;
  }
  handleCalendarChange(Ae, xr = !1) {
    xr ? this.handleDoubleDateChange(Ae) : this.handleChange(Ae);
  }
  handleChange(Ae) {
    var xr, ed;
    if (Ae.stopPropagation(), this.mask) {
      if (this.range && (xr = Ae.detail) != null && xr.start && (ed = Ae.detail) != null && ed.end) {
        this.setRangeDates({ eventStartDate: Ae.detail.start, eventEndDate: Ae.detail.end });
        return;
      }
      const id = new Date(Ae.detail);
      id && !isNaN(id.valueOf()) && Ae.detail && (this.selectedDate = new Date(Ae.detail).toISOString(), id && !isNaN(id.valueOf()) && this.selectedDate && (this.range ? (this.mask.value = `${formatDateToString(id, this.format, this.keepTimezone)} - ${this.format.replace("YYYY", "YY")}`, this.value = `${formatDateToString(id, this.format, this.keepTimezone)} - ${this.format.replace("YYYY", "YY")}`) : (this.mask.value = formatDateToString(id, this.format, this.keepTimezone), this.value = formatDateToString(id, this.format, this.keepTimezone)))), this.firstRender || this.validate();
    }
  }
  setRangeDates({ eventEndDate: Ae, eventStartDate: xr, shouldEmit: ed = !0 }) {
    const id = formatDate(xr, this.format, this.keepTimezone), od = formatDate(Ae, this.format, this.keepTimezone);
    this.keepTimezone ? (id.setHours(0, 0, 0, 0), od.setHours(23, 59, 59, 0)) : (id.setUTCHours(0, 0, 0, 0), od.setUTCHours(23, 59, 59, 0)), this.rangeStartDate = id.toISOString(), this.rangeEndDate = od.toISOString(), this.mask.value = `${formatDateToString(id, this.format, this.keepTimezone)} - ${formatDateToString(od, this.format, this.keepTimezone)}`, this.value = `${formatDateToString(id, this.format, this.keepTimezone)} - ${formatDateToString(od, this.format, this.keepTimezone)}`, this.validate(), ed && this.$emit("change", { start: this.rangeStartDate, end: this.rangeEndDate });
  }
  handleDoubleDateChange(Ae) {
    var ed, id;
    Ae.stopPropagation();
    let xr;
    this.mask && ((ed = Ae.detail) != null && ed.start ? this.setRangeDates({ eventStartDate: Ae.detail.start, eventEndDate: Ae.detail.end }) : ((id = Ae.detail) == null ? void 0 : id.start) === void 0 && Ae.detail && (xr = formatDate(Ae.detail, this.format, this.keepTimezone), xr && !isNaN(xr.valueOf()) && (this.selectedDate = xr.toISOString(), this.rangeEndDate = "", this.rangeStartDate = xr.toISOString()), this.$emit("change", { start: this.rangeStartDate, end: this.rangeEndDate })), this.validate());
  }
  showCalendar() {
    !this.calendarVisible && !this.readOnly && (this.open = !0, DOM.queueUpdate(() => this.setPositioning()));
  }
  hideCalendar() {
    this.calendarVisible || (this.open = !1);
  }
  onClick() {
  }
  onClickOutside(Ae) {
    var xr;
    Ae !== this && ((xr = Ae.nodeName) == null ? void 0 : xr.toUpperCase()) !== "TM1-CALENDAR" && !this.calendarVisible && (this.open = !1);
  }
  selectedDateChanged(Ae, xr) {
    if (Ae !== xr && this.$fastController.isConnected && this.mask) {
      if (xr) {
        const { monthIdx: ed, yearIdx: id } = getFormatPartsIdx(this.format), { isValid: od, date: ad } = isValidDate(xr, this.format, this.keepTimezone), sd = formatDateToString(ad, this.format, this.keepTimezone).split(/\/+/), nd = +sd[ed] - 1, cd = +sd[id];
        this.closeHidden = !1, od ? (this.selectedDate = xr, ad && !isNaN(ad.valueOf()) && this.selectedDate && (this.range ? (this.mask.value = `${formatDateToString(ad, this.format, this.keepTimezone)} - ${this.format.replace("YYYY", "YY")}`, this.value = `${formatDateToString(ad, this.format, this.keepTimezone)} - ${this.format.replace("YYYY", "YY")}`) : (this.mask.value = formatDateToString(ad, this.format, this.keepTimezone), this.value = formatDateToString(ad, this.format, this.keepTimezone), this.month !== nd && (this.month = nd), this.year !== cd && (this.year = cd + 2e3)), this.$emit("change", ad.toISOString()))) : (this.selectedDate = "", this.mask.value = "", this.value = "", this.closeHidden = !0);
      } else
        !this.range && (!this.control.value || xr === "") && (this.mask.value = xr != null ? xr : "", this.value = xr != null ? xr : ""), xr === "" && (this.closeHidden = !0);
      this.setPlaceholder(), this.validate();
    }
  }
  rangeStartDateChanged(Ae, xr) {
    if (this.mask && Ae !== xr) {
      if (this.range && xr) {
        const { monthIdx: ed, yearIdx: id } = getFormatPartsIdx(this.format), { isValid: od, date: ad } = isValidDate(xr, this.format, this.keepTimezone), sd = formatDateToString(ad, this.format, this.keepTimezone).split(/\/+/), nd = +sd[ed] - 1, cd = +sd[id];
        if (od) {
          const ud = this.mode === "multi" && !this.mobile && nextMonth(this.month) === nd;
          this.month !== nd && !ud && (this.month = nd), this.year !== cd && (this.year = cd + 2e3), this.rangeEndDate ? this.setRangeDates({ eventStartDate: ad.toISOString(), eventEndDate: this.rangeEndDate, shouldEmit: !1 }) : (this.mask.value = formatDateToString(ad, this.format, this.keepTimezone), this.value = formatDateToString(ad, this.format, this.keepTimezone));
        } else
          this.rangeStartDate = "", this.mask.value = "", this.value = "", this.closeHidden = !0;
      } else
        this.range && !this.rangeEndDate ? (this.mask.value = xr, this.value = xr, xr === "" && (this.closeHidden = !0)) : (this.mask.value = "", this.value = "");
      this.setPlaceholder();
    }
  }
  rangeEndDateChanged(Ae, xr) {
    if (this.mask && Ae !== xr) {
      if (this.range && this.rangeStartDate && xr) {
        const { isValid: ed, date: id } = isValidDate(xr, this.format, this.keepTimezone);
        ed ? this.setRangeDates({ eventStartDate: this.rangeStartDate, eventEndDate: id.toISOString(), shouldEmit: !1 }) : this.rangeStartDate ? (this.rangeEndDate = "", this.mask.value = formatDateToString(new Date(this.rangeStartDate), this.format, this.keepTimezone), this.value = formatDateToString(new Date(this.rangeStartDate), this.format, this.keepTimezone)) : (this.rangeEndDate = "", this.mask.value = "", this.value = "");
      } else
        this.rangeStartDate ? this.control.value.length >= 19 && (this.mask.value = formatDateToString(new Date(this.rangeStartDate), this.format, this.keepTimezone), this.value = formatDateToString(new Date(this.rangeStartDate), this.format, this.keepTimezone)) : (this.mask.value = "", this.value = "");
      this.setPlaceholder();
    }
  }
  /**
  * Calculate and apply calendar positioning based on available viewport space
  *
  * @public
  */
  setPositioning() {
    this.$fastController.isConnected && (this.cleanup = autoUpdate(this, this.calendar, async () => {
      var id;
      const Ae = (id = this.shadowRoot) == null ? void 0 : id.querySelector(".input-container"), { x: xr, y: ed } = await computePosition(
        Ae,
        this.calendar,
        {
          placement: this.position,
          strategy: "fixed",
          middleware: [flip(), shift(), offset(2)]
        }
      );
      Object.assign(this.calendar.style, {
        position: "fixed",
        left: `${xr}px`,
        top: `${ed}px`
      });
    }));
  }
  onHandleCancel() {
    this.formResetCallback(), this.hideCalendar(), this.setPlaceholder();
  }
  handleClearInput() {
    this.value = "", this.mask.value = "", this.selectedDate = "", this.rangeStartDate = "", this.rangeEndDate = "", this.$emit("input"), this.$emit("clear");
  }
  formResetCallback() {
    super.formResetCallback(), this.value = "", this.mask.value = "", this.selectedDate = "", this.rangeStartDate = "", this.rangeEndDate = "";
  }
}
__decorateClass$K([
  attr
], DatePickerV2.prototype, "placeholder", 2);
__decorateClass$K([
  attr
], DatePickerV2.prototype, "format", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "localized", 2);
__decorateClass$K([
  attr
], DatePickerV2.prototype, "label", 2);
__decorateClass$K([
  attr
], DatePickerV2.prototype, "month", 2);
__decorateClass$K([
  attr
], DatePickerV2.prototype, "year", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "disabled", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "range", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "required", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "open", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "clearable", 2);
__decorateClass$K([
  attr()
], DatePickerV2.prototype, "position", 2);
__decorateClass$K([
  attr()
], DatePickerV2.prototype, "mode", 2);
__decorateClass$K([
  attr({ attribute: "label-position" }),
  attr({ attribute: "labelposition" })
], DatePickerV2.prototype, "labelPosition", 2);
__decorateClass$K([
  attr({ attribute: "help-label" }),
  attr({ attribute: "helplabel" })
], DatePickerV2.prototype, "helpLabel", 2);
__decorateClass$K([
  attr()
], DatePickerV2.prototype, "error", 2);
__decorateClass$K([
  attr({ mode: "boolean", attribute: "read-only" }),
  attr({ mode: "boolean", attribute: "readonly" })
], DatePickerV2.prototype, "readOnly", 2);
__decorateClass$K([
  attr({ attribute: "aria-controls" })
], DatePickerV2.prototype, "ariaControls", 2);
__decorateClass$K([
  attr({ attribute: "aria-describedby" })
], DatePickerV2.prototype, "ariaDescribedby", 2);
__decorateClass$K([
  attr({ attribute: "aria-details" })
], DatePickerV2.prototype, "ariaDetails", 2);
__decorateClass$K([
  attr({ attribute: "aria-flowto" })
], DatePickerV2.prototype, "ariaFlowto", 2);
__decorateClass$K([
  attr({ attribute: "aria-haspopup" })
], DatePickerV2.prototype, "ariaHaspopup", 2);
__decorateClass$K([
  attr({ attribute: "aria-keyshortcuts" })
], DatePickerV2.prototype, "ariaKeyshortcuts", 2);
__decorateClass$K([
  attr({ attribute: "aria-labelledby" })
], DatePickerV2.prototype, "ariaLabelledby", 2);
__decorateClass$K([
  attr({ attribute: "aria-owns" })
], DatePickerV2.prototype, "ariaOwns", 2);
__decorateClass$K([
  attr({ attribute: "aria-relevant" })
], DatePickerV2.prototype, "ariaRelevant", 2);
__decorateClass$K([
  attr({ attribute: "aria-roledescription" })
], DatePickerV2.prototype, "ariaRoledescription", 2);
__decorateClass$K([
  attr({ attribute: "disabled-dates" }),
  attr({ attribute: "disableddates" })
], DatePickerV2.prototype, "disabledDates", 2);
__decorateClass$K([
  attr({ attribute: "highlight-dates" }),
  attr({ attribute: "highlightdates" })
], DatePickerV2.prototype, "highlightDates", 2);
__decorateClass$K([
  attr({ attribute: "input-size" }),
  attr({ attribute: "inputsize" })
], DatePickerV2.prototype, "inputSize", 2);
__decorateClass$K([
  attr({ attribute: "max-date" }),
  attr({ attribute: "maxdate" })
], DatePickerV2.prototype, "maxDate", 2);
__decorateClass$K([
  attr({ attribute: "min-date" }),
  attr({ attribute: "mindate" })
], DatePickerV2.prototype, "minDate", 2);
__decorateClass$K([
  attr({ attribute: "range-end-date" }),
  attr({ attribute: "rangeenddate" })
], DatePickerV2.prototype, "rangeEndDate", 2);
__decorateClass$K([
  attr({ attribute: "range-start-date" }),
  attr({ attribute: "rangestartdate" })
], DatePickerV2.prototype, "rangeStartDate", 2);
__decorateClass$K([
  attr({ attribute: "selected-date" }),
  attr({ attribute: "selecteddate" })
], DatePickerV2.prototype, "selectedDate", 2);
__decorateClass$K([
  attr({ attribute: "start-year" }),
  attr({ attribute: "startyear" })
], DatePickerV2.prototype, "startYear", 2);
__decorateClass$K([
  attr({ attribute: "end-year" }),
  attr({ attribute: "endyear" })
], DatePickerV2.prototype, "endYear", 2);
__decorateClass$K([
  attr({ mode: "boolean", attribute: "calendar-visible" }),
  attr({ mode: "boolean", attribute: "calendarvisible" })
], DatePickerV2.prototype, "calendarVisible", 2);
__decorateClass$K([
  attr({ mode: "boolean", attribute: "keep-timezone" }),
  attr({ mode: "boolean", attribute: "keeptimezone" })
], DatePickerV2.prototype, "keepTimezone", 2);
__decorateClass$K([
  attr({ attribute: "confirm-text" }),
  attr({ attribute: "confirmtext" })
], DatePickerV2.prototype, "confirmText", 2);
__decorateClass$K([
  attr({ attribute: "cancel-text" }),
  attr({ attribute: "canceltext" })
], DatePickerV2.prototype, "cancelText", 2);
__decorateClass$K([
  attr({ mode: "boolean" })
], DatePickerV2.prototype, "isInDateTimePicker", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "lang", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "control", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "calendar", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "classes", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "mobile", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "theme", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "errorLabel", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "defaultSlottedNodes", 2);
__decorateClass$K([
  observable
], DatePickerV2.prototype, "closeHidden", 2);
const normalizedFormat = "MM/DD/YYYY", userLanguageToFormat = (td) => new Intl.DateTimeFormat(td, {
  year: "2-digit",
  month: "2-digit",
  day: "2-digit"
}).format(new Date(2e3, 0, 2)).replace("00", "YYYY").replace("01", "MM").replace("02", "DD"), normalizeUserInput = (td, Ae) => {
  const xr = Ae.indexOf("DD"), ed = Ae.indexOf("MM"), id = Ae.indexOf("YYYY");
  return [
    td.slice(ed, ed + 2),
    td.slice(xr, xr + 2),
    td.slice(id, id + 2)
  ].map((od) => clean(od)).join("/");
}, clean = (td) => td.replace(/([A-Z]|Å)*/g, "").padEnd(2, "-"), normalizeUserRangeInput = (td, Ae) => {
  const xr = td.split(" - "), ed = normalizeUserInput(xr[0], Ae), id = normalizeUserInput(xr[1], Ae);
  return {
    start: ed,
    startValid: !ed.includes("-"),
    end: id,
    endValid: !id.includes("-"),
    endEmpty: id === "--/--/--"
  };
}, nextMonth = (td) => {
  const Ae = td + 1;
  return Ae >= 12 ? 0 : Ae;
}, normalizedToNormalizedWithYear = (td) => `${td.substring(0, 2)}/${td.substring(3, 5)}/20${td.substring(6, 8)}`, tm1DatePickerV2 = DatePickerV2.compose({
  baseName: "date-picker-v2",
  template: tm1DatePickerTemplate,
  styles: tm1DatePickerStyles
});
designSystem.register(
  tm1DatePickerV2()
);
const tm1DateTimePickerTemplate = (td) => html`
<${td.tagFor(DatePickerV2)}
  isInDateTimePicker
  aria-atomic=${(Ae) => Ae.dateAriaAtomic}
  aria-busy=${(Ae) => Ae.dateAriaBusy}
  aria-controls=${(Ae) => Ae.dateAriaControls}
  aria-current=${(Ae) => Ae.dateAriaCurrent}
  aria-describedby=${(Ae) => Ae.dateAriaDescribedby}
  aria-details=${(Ae) => Ae.dateAriaDetails}
  aria-flowto=${(Ae) => Ae.dateAriaFlowto}
  aria-haspopup=${(Ae) => Ae.dateAriaHaspopup}
  aria-hidden=${(Ae) => Ae.dateAriaHidden}
  aria-keyshortcuts=${(Ae) => Ae.dateAriaKeyshortcuts}
  aria-label=${(Ae) => Ae.dateAriaLabel}
  aria-labelledby=${(Ae) => Ae.dateAriaLabelledby}
  aria-live=${(Ae) => Ae.dateAriaLive}
  aria-owns=${(Ae) => Ae.dateAriaOwns}
  aria-relevant=${(Ae) => Ae.dateAriaRelevant}
  aria-roledescription=${(Ae) => Ae.dateAriaRoledescription}
  placeholder=${(Ae) => Ae.placeholder}
  localized
  label=${(Ae) => Ae.dateLabel}
  name=${(Ae) => Ae.dateName}
  error=${(Ae) => Ae.dateError}
  month=${(Ae) => Ae.month}
  year=${(Ae) => Ae.year}
  mode=${(Ae) => Ae.mode}
  calendarPosition=${(Ae) => Ae.calendarPosition}
  disabledDates=${(Ae) => JSON.stringify(Ae.disabledDates)}
  highlightDates=${(Ae) => {
  var xr;
  return JSON.stringify((xr = Ae.highlightDates) != null ? xr : []);
}}
  maxDate=${(Ae) => Ae.maxDate}
  minDate=${(Ae) => Ae.minDate}
  selectedDate=${(Ae) => {
  var xr;
  return (xr = Ae.selectedDate) != null ? xr : Ae.date;
}}
  startYear=${(Ae) => Ae.startYear}
  endYear=${(Ae) => Ae.endYear}
  confirmText=${(Ae) => Ae.confirmText}
  cancelText=${(Ae) => Ae.cancelText}
  inputSize=${(Ae) => Ae.inputSize}
  ?autofocus=${(Ae) => Ae.dateAutofocus}
  ?disabled=${(Ae) => Ae.disabled}
  ?readOnly=${(Ae) => Ae.readOnly}
  ?required=${(Ae) => Ae.dateRequired}
  ?open=${(Ae) => Ae.open}
  ?calendar-visible=${(Ae) => Ae.calendarVisible}
  ?keepTimezone=${(Ae) => Ae.keepTimezone}
  @change=${(Ae, xr) => Ae.handleChangeDate(xr.event)}
>
<${td.tagFor(TimePicker)}
  slot="time"
  aria-atomic=${(Ae) => Ae.timeAriaAtomic}
  aria-busy=${(Ae) => Ae.timeAriaBusy}
  aria-controls=${(Ae) => Ae.timeAriaControls}
  aria-current=${(Ae) => Ae.timeAriaCurrent}
  aria-describedby=${(Ae) => Ae.timeAriaDescribedby}
  aria-details=${(Ae) => Ae.timeAriaDetails}
  aria-flowto=${(Ae) => Ae.timeAriaFlowto}
  aria-haspopup=${(Ae) => Ae.timeAriaHaspopup}
  aria-hidden=${(Ae) => Ae.timeAriaHidden}
  aria-keyshortcuts=${(Ae) => Ae.timeAriaKeyshortcuts}
  aria-label=${(Ae) => Ae.timeAriaLabel}
  aria-labelledby=${(Ae) => Ae.timeAriaLabelledby}
  aria-live=${(Ae) => Ae.timeAriaLive}
  aria-owns=${(Ae) => Ae.timeAriaOwns}
  aria-relevant=${(Ae) => Ae.timeAriaRelevant}
  aria-roledescription=${(Ae) => Ae.timeAriaRoledescription}
  hour=${(Ae) => Ae.hour}
  minutes=${(Ae) => Ae.minutes}
  meridianType=${(Ae) => Ae.meridianType}
  label=${(Ae) => Ae.timeLabel}
  inputSize=${(Ae) => Ae.inputSize}
  error=${(Ae) => Ae.timeError}
  ?autofocus=${(Ae) => Ae.timeAutofocus}
  ?disabled=${(Ae) => Ae.disabled}
  ?readonly=${(Ae) => Ae.readOnly}
  ?required=${(Ae) => Ae.timeRequired}
  @change=${(Ae, xr) => Ae.handleChangeTime(xr.event)}
></${td.tagFor(TimePicker)}>
</${td.tagFor(DatePickerV2)}>
`;
var __defProp$J = Object.defineProperty, __getOwnPropDesc$J = Object.getOwnPropertyDescriptor, __decorateClass$J = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$J(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$J(Ae, xr, id), id;
};
class DateTimePicker extends FoundationElement {
  constructor() {
    super(...arguments), this.disabledDates = [], this.selectedTime = null, this.choosenDate = null, this.hour = null, this.minutes = null;
  }
  connectedCallback() {
    super.connectedCallback(), DOM.queueUpdate(() => {
      (this.date || this.selectedDate) && (this.choosenDate = this.selectedDate ? new Date(this.selectedDate) : new Date(this.date), this.hour = this.choosenDate.getUTCHours(), this.minutes = this.choosenDate.getUTCMinutes(), this.selectedTime = `${this.hour}:${this.minutes}`);
    });
  }
  handleChangeDate(Ae) {
    Ae.stopPropagation();
    const xr = this.choosenDate;
    this.choosenDate = new Date(Ae.detail), this.selectedTime ? this.setTime() : (this.hour = this.choosenDate.getUTCHours(), this.minutes = this.choosenDate.getUTCMinutes(), this.selectedTime = `${this.hour}:${this.minutes}`), xr !== this.choosenDate && (this.$emit("change", this.choosenDate.toISOString()), this.value = this.choosenDate.toISOString());
  }
  handleChangeTime(Ae) {
    Ae.stopPropagation(), this.selectedTime = Ae.target.customValue, this.choosenDate === null && (this.choosenDate = /* @__PURE__ */ new Date()), this.selectedTime && this.setTime(), this.$emit("change", this.choosenDate.toISOString()), this.value = this.choosenDate.toISOString();
  }
  setTime() {
    var xr, ed, id, od;
    const Ae = (ed = (xr = this.selectedTime) == null ? void 0 : xr.split(":")) != null ? ed : [0, 0];
    (id = this.choosenDate) == null || id.setUTCHours(+Ae[0]), (od = this.choosenDate) == null || od.setUTCMinutes(+Ae[1]);
  }
}
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "date", 2);
__decorateClass$J([
  attr({ attribute: "input-size" }),
  attr({ attribute: "inputsize" })
], DateTimePicker.prototype, "inputSize", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "min", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "max", 2);
__decorateClass$J([
  attr({ attribute: "time-label" }),
  attr({ attribute: "timelabel" })
], DateTimePicker.prototype, "timeLabel", 2);
__decorateClass$J([
  attr({ attribute: "time-name" }),
  attr({ attribute: "timename" })
], DateTimePicker.prototype, "timeName", 2);
__decorateClass$J([
  attr({ attribute: "time-error" }),
  attr({ attribute: "timeerror" })
], DateTimePicker.prototype, "timeError", 2);
__decorateClass$J([
  attr({ attribute: "time-required", mode: "boolean" }),
  attr({ attribute: "timerequired", mode: "boolean" })
], DateTimePicker.prototype, "timeRequired", 2);
__decorateClass$J([
  attr({ attribute: "time-autofocus", mode: "boolean" }),
  attr({ attribute: "timeautofocus", mode: "boolean" })
], DateTimePicker.prototype, "timeAutofocus", 2);
__decorateClass$J([
  attr({ attribute: "meridian-type" }),
  attr({ attribute: "meridiantype" })
], DateTimePicker.prototype, "meridianType", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-atomic" }),
  attr({ attribute: "timeariaatomic" })
], DateTimePicker.prototype, "timeAriaAtomic", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-busy" }),
  attr({ attribute: "timeariabusy" })
], DateTimePicker.prototype, "timeAriaBusy", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-controls" }),
  attr({ attribute: "timeariacontrols" })
], DateTimePicker.prototype, "timeAriaControls", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-current" }),
  attr({ attribute: "timeariacurrent" })
], DateTimePicker.prototype, "timeAriaCurrent", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-describedby" }),
  attr({ attribute: "timeariadescribedby" })
], DateTimePicker.prototype, "timeAriaDescribedby", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-details" }),
  attr({ attribute: "timeariadetails" })
], DateTimePicker.prototype, "timeAriaDetails", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-flowto" }),
  attr({ attribute: "timeariaflowto" })
], DateTimePicker.prototype, "timeAriaFlowto", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-haspopup" }),
  attr({ attribute: "timeariahaspopup" })
], DateTimePicker.prototype, "timeAriaHaspopup", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-hidden" }),
  attr({ attribute: "timeariahidden" })
], DateTimePicker.prototype, "timeAriaHidden", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-keyshortcuts" }),
  attr({ attribute: "timeariakeyshortcuts" })
], DateTimePicker.prototype, "timeAriaKeyshortcuts", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-label" }),
  attr({ attribute: "timearialabel" })
], DateTimePicker.prototype, "timeAriaLabel", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-labelledby" }),
  attr({ attribute: "timearialabelledby" })
], DateTimePicker.prototype, "timeAriaLabelledby", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-live" }),
  attr({ attribute: "timearialive" })
], DateTimePicker.prototype, "timeAriaLive", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-owns" }),
  attr({ attribute: "timeariaowns" })
], DateTimePicker.prototype, "timeAriaOwns", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-relevant" }),
  attr({ attribute: "timeariarelevant" })
], DateTimePicker.prototype, "timeAriaRelevant", 2);
__decorateClass$J([
  attr({ attribute: "time-aria-roledescription" }),
  attr({ attribute: "timeariaroledescription" })
], DateTimePicker.prototype, "timeAriaRoledescription", 2);
__decorateClass$J([
  attr({ attribute: "list" })
], DateTimePicker.prototype, "list", 2);
__decorateClass$J([
  attr({ attribute: "value" })
], DateTimePicker.prototype, "value", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "placeholder", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "month", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "year", 2);
__decorateClass$J([
  attr({ mode: "boolean" })
], DateTimePicker.prototype, "disabled", 2);
__decorateClass$J([
  attr({ mode: "boolean" })
], DateTimePicker.prototype, "readOnly", 2);
__decorateClass$J([
  attr({ mode: "boolean" })
], DateTimePicker.prototype, "open", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "calendarPosition", 2);
__decorateClass$J([
  attr()
], DateTimePicker.prototype, "mode", 2);
__decorateClass$J([
  attr({ attribute: "date-autofocus", mode: "boolean" }),
  attr({ attribute: "dateautofocus", mode: "boolean" })
], DateTimePicker.prototype, "dateAutofocus", 2);
__decorateClass$J([
  attr({ attribute: "date-required", mode: "boolean" }),
  attr({ attribute: "daterequired", mode: "boolean" })
], DateTimePicker.prototype, "dateRequired", 2);
__decorateClass$J([
  attr({ attribute: "date-format" }),
  attr({ attribute: "date-label" }),
  attr({ attribute: "datelabel" })
], DateTimePicker.prototype, "dateLabel", 2);
__decorateClass$J([
  attr({ attribute: "date-name" }),
  attr({ attribute: "datename" })
], DateTimePicker.prototype, "dateName", 2);
__decorateClass$J([
  attr({ attribute: "date-error" }),
  attr({ attribute: "dateerror" })
], DateTimePicker.prototype, "dateError", 2);
__decorateClass$J([
  attr({ attribute: "disabled-dates" }),
  attr({ attribute: "disableddates" })
], DateTimePicker.prototype, "disabledDates", 2);
__decorateClass$J([
  attr({ attribute: "highlight-dates" }),
  attr({ attribute: "highlightdates" })
], DateTimePicker.prototype, "highlightDates", 2);
__decorateClass$J([
  attr({ attribute: "max-date" }),
  attr({ attribute: "maxdate" })
], DateTimePicker.prototype, "maxDate", 2);
__decorateClass$J([
  attr({ attribute: "min-date" }),
  attr({ attribute: "mindate" })
], DateTimePicker.prototype, "minDate", 2);
__decorateClass$J([
  attr({ attribute: "selected-date" }),
  attr({ attribute: "selecteddate" })
], DateTimePicker.prototype, "selectedDate", 2);
__decorateClass$J([
  attr({ attribute: "start-year" }),
  attr({ attribute: "startyear" })
], DateTimePicker.prototype, "startYear", 2);
__decorateClass$J([
  attr({ attribute: "end-year" }),
  attr({ attribute: "endyear" })
], DateTimePicker.prototype, "endYear", 2);
__decorateClass$J([
  attr({ mode: "boolean", attribute: "calendar-visible" }),
  attr({ mode: "boolean", attribute: "calendarvisible" })
], DateTimePicker.prototype, "calendarVisible", 2);
__decorateClass$J([
  attr({ mode: "boolean", attribute: "keep-timezone" }),
  attr({ mode: "boolean", attribute: "keeptimezone" })
], DateTimePicker.prototype, "keepTimezone", 2);
__decorateClass$J([
  attr({ attribute: "confirm-text" }),
  attr({ attribute: "confirmtext" })
], DateTimePicker.prototype, "confirmText", 2);
__decorateClass$J([
  attr({ attribute: "cancel-text" }),
  attr({ attribute: "canceltext" })
], DateTimePicker.prototype, "cancelText", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-atomic" }),
  attr({ attribute: "dateariaatomic" })
], DateTimePicker.prototype, "dateAriaAtomic", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-busy" }),
  attr({ attribute: "dateariabusy" })
], DateTimePicker.prototype, "dateAriaBusy", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-controls" }),
  attr({ attribute: "dateariacontrols" })
], DateTimePicker.prototype, "dateAriaControls", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-current" }),
  attr({ attribute: "dateariacurrent" })
], DateTimePicker.prototype, "dateAriaCurrent", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-describedby" }),
  attr({ attribute: "dateariadescribedby" })
], DateTimePicker.prototype, "dateAriaDescribedby", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-details" }),
  attr({ attribute: "dateariadetails" })
], DateTimePicker.prototype, "dateAriaDetails", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-flowto" }),
  attr({ attribute: "dateariaflowto" })
], DateTimePicker.prototype, "dateAriaFlowto", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-haspopup" }),
  attr({ attribute: "dateariahaspopup" })
], DateTimePicker.prototype, "dateAriaHaspopup", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-hidden" }),
  attr({ attribute: "dateariahidden" })
], DateTimePicker.prototype, "dateAriaHidden", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-keyshortcuts" }),
  attr({ attribute: "dateariakeyshortcuts" })
], DateTimePicker.prototype, "dateAriaKeyshortcuts", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-label" }),
  attr({ attribute: "datearialabel" })
], DateTimePicker.prototype, "dateAriaLabel", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-labelledby" }),
  attr({ attribute: "datearialabelledby" })
], DateTimePicker.prototype, "dateAriaLabelledby", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-live" }),
  attr({ attribute: "datearialive" })
], DateTimePicker.prototype, "dateAriaLive", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-owns" }),
  attr({ attribute: "dateariaowns" })
], DateTimePicker.prototype, "dateAriaOwns", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-relevant" }),
  attr({ attribute: "dateariarelevant" })
], DateTimePicker.prototype, "dateAriaRelevant", 2);
__decorateClass$J([
  attr({ attribute: "date-aria-roledescription" }),
  attr({ attribute: "dateariaroledescription" })
], DateTimePicker.prototype, "dateAriaRoledescription", 2);
__decorateClass$J([
  observable
], DateTimePicker.prototype, "choosenDate", 2);
__decorateClass$J([
  observable
], DateTimePicker.prototype, "hour", 2);
__decorateClass$J([
  observable
], DateTimePicker.prototype, "minutes", 2);
const tm1DateTimePicker = DateTimePicker.compose({
  baseName: "date-time-picker",
  template: tm1DateTimePickerTemplate
});
designSystem.register(
  tm1DateTimePicker()
);
var __defProp$I = Object.defineProperty, __getOwnPropDesc$I = Object.getOwnPropertyDescriptor, __decorateClass$I = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$I(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$I(Ae, xr, id), id;
};
class DeprecateToken extends FoundationElement {
  constructor(Ae) {
    super(), this.usedCSSVarInStyleSheets = [], this.kebabToCamelCase = (xr) => xr.replace(/-./g, (ed) => ed[1].toUpperCase()), this.node = Ae || document.body;
  }
  connectedCallback() {
    super.connectedCallback();
    const Ae = new MutationObserver(() => {
      this.node && this.detectDeprecatedToken(this.node);
    });
    this.node && (Ae == null || Ae.observe(this.node, {
      attributes: !0,
      attributeFilter: ["style", "class"],
      childList: !0,
      subtree: !0
    }));
  }
  getAllElements(Ae, xr) {
    var ed;
    if (Ae.nodeType === Node.ELEMENT_NODE && xr(Ae), Ae.shadowRoot && (this.usedCSSVarInStyleSheets.push(...this.checkStyleSheetsForCSSVar((ed = Ae.shadowRoot) == null ? void 0 : ed.styleSheets)), this.getAllElements(Ae.shadowRoot, xr)), Ae.childNodes && Ae.childNodes.forEach((id) => {
      this.getAllElements(id, xr);
    }), Ae.tagName === "IFRAME")
      try {
        const id = Ae.contentDocument;
        id && this.getAllElements(id, xr);
      } catch (id) {
        console.error("Error accessing iframe content:", id);
      }
  }
  // This function will look for any deprecated tokens in the source code of the page
  detectDeprecatedTokenSourceCode() {
    const Ae = document.documentElement.outerHTML, xr = [];
    return deprecatedTokens.forEach((ed) => {
      Ae.includes(ed.cssVar) === !0 && xr.push(ed.cssCustomProperty);
    }), xr;
  }
  // This function will combine multiple ways to retreive deprecated CSS vars
  detectDeprecatedToken(Ae) {
    const xr = this.detectDeprecatedTokenSourceCode(), ed = [];
    this.usedCSSVarInStyleSheets = [], this.getAllElements(Ae, (ad) => {
      const rd = this.checkForClassAndInlineCSSVar(ad);
      rd.length >= 1 && ed.push(...rd);
    });
    const id = this.checkStyleSheetsForCSSVar(document.styleSheets);
    id.length >= 1 && ed.push(...id);
    const od = [];
    if (ed.forEach((ad) => {
      xr.includes(ad) || od.push(ad);
    }), ed.length > 0) {
      const ad = this.buildDeprecationMessage(ed);
      console.warn(ad);
    } else
      console.info(
        "No deprecated CSS design token has been detected. You are all set to upgrade to the next major when it's going to be released."
      );
    od && od.length > 0 && console.warn(
      `We have found some token(s) that needs a more in depth research to find their origin. Tokens: ${od == null ? void 0 : od.join(
        ", "
      )}`,
      window.location.href,
      document.documentElement.outerHTML
    );
  }
  cleanVarString(Ae) {
    return Ae.startsWith("var(") && Ae.endsWith(")") ? Ae.slice(4, -1) : Ae;
  }
  cleanCSSText(Ae) {
    return Ae.replace(/ /g, "").split(":").join(";").split(";").filter((xr) => xr);
  }
  // Function will go through every inline style and class element in the DOM to find deprecated CSS vars
  checkForClassAndInlineCSSVar(Ae) {
    const xr = /* @__PURE__ */ new Set(), ed = Ae.style;
    if (ed.cssText.includes("var(--")) {
      const id = this.cleanCSSText(ed.cssText);
      for (let od = 0; od < id.length - 1; od += 2) {
        const ad = id[od].startsWith("--") && id[od].match(/\b[a-z]+(?:-[a-z]+)*\b/g) ? ed[this.kebabToCamelCase(id[od])] : ed[id[od]];
        ad && deprecatedTokens.some((rd) => rd.cssVar && rd.cssVar.includes(ad)) && xr.add(this.cleanVarString(ad));
      }
    }
    return Array.from(xr);
  }
  // Function will go through every stylesheets provided as argument to find any deprecated tokens
  checkStyleSheetsForCSSVar(Ae) {
    const xr = /* @__PURE__ */ new Set();
    for (const ed of Ae || [])
      for (const id of ed.cssRules || [])
        if (id.style && id.style.cssText.includes("var(--")) {
          const od = this.cleanCSSText(id.style.cssText);
          for (let ad = 0; ad < od.length - 1; ad += 2) {
            const rd = od[ad].startsWith("--") && od[ad].match(/\b[a-z]+(?:-[a-z]+)*\b/g) ? id.style[this.kebabToCamelCase(od[ad])] : id.style[od[ad]];
            rd && deprecatedTokens.some((sd) => sd.cssVar && sd.cssVar.includes(rd)) && xr.add(this.cleanVarString(rd));
          }
        }
    return Array.from(xr);
  }
  buildDeprecationMessage(Ae) {
    return `Some of the design system tokens has been deprecated. Visit storybook docs for more information about the deprecation and how to replace the tokens. Here is a list of the deprecated design system tokens currently being use: ${Ae.filter((ed, id) => Ae.indexOf(ed) === id).join(", ")}`;
  }
}
__decorateClass$I([
  observable
], DeprecateToken.prototype, "node", 2);
const tm1DeprecateToken = DeprecateToken.compose({
  baseName: "deprecate-token",
  template: html`<slot></slot>`,
  styles: css``,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1DeprecateToken()
);
const tm1DialogStepContentStyles = () => css``, tm1DialogStepContentTemplate = () => html`
  <slot></slot>
`;
class DialogStepContent extends FoundationElement {
}
const tm1DialogStepContent = DialogStepContent.compose({
  baseName: "dialog-step-content",
  baseClass: FoundationElement,
  template: tm1DialogStepContentTemplate,
  styles: tm1DialogStepContentStyles
}), ambientShadow$1 = cssPartial`0 0 calc((var(--elevation) * 0.225px) + 2px) rgba(0, 0, 0, calc(.11 * (2 - var(--background-luminance, 1))))`, directionalShadow$1 = cssPartial`0 calc(var(--elevation) * 0.4px) calc((var(--elevation) * 0.9px)) rgba(0, 0, 0, calc(.13 * (2 - var(--background-luminance, 1))))`, elevation$1 = cssPartial`box-shadow: ${ambientShadow$1}, ${directionalShadow$1};`, tm1DialogStyles = () => css`
  :host {
    display: contents;
    --dialog-max-height: auto;
  }

  :host .control:focus-visible {
    outline: none;
  }

  :host([size='small']) {
    --dialog-max-width: 400px;
  }

  :host([size='medium']) {
    --dialog-max-width: 520px;
  }

  :host([size='large']) {
    --dialog-max-width: 640px;
  }

  :host([size='extra-large']) {
    --dialog-max-width: 860px;
  }

  :host([size='fullscreen']) {
    --dialog-max-width: 90vw;
    --dialog-max-height: 90vh;
  }

  :host([size='fullscreen']) .control {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  :host([size='fullscreen']) tm1-dialog-footer {
    margin-top: auto;
  }

  :host([wrapcontent]) .control,
  :host([wrapcontent]) .control {
    height: auto;
  }

  @media (min-height: 720px) {
    :host([scrollable][size='small']) .positioning-region,
    :host([scrollable][size='medium']) .positioning-region {
      align-items: start;
      padding: 128px 0;
    }
  }

  @media (min-height: 720px) and (max-height: 1079px) {
    :host([size='fullscreen']) {
      --dialog-max-height: 95vh;
    }
  }

  @media (min-height: 1080px) {
    :host([size='fullscreen']) {
      --dialog-max-height: 1030px;
    }
  }

  @media (max-width: 1439px) {
    :host([size='fullscreen']) {
      --dialog-max-width: 90vw;
    }
  }

  @media (min-width: 1440px) {
    :host([size='fullscreen']) {
      --dialog-max-width: 1296px;
    }
  }

  :host {
    --elevation: 6;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${GDSEColorBackgroundOverlay};
    touch-action: none;
  }

  :host(:not([open])[firstrender]) {
    visibility: hidden;
    display: none;
  }

  :host(:not([open])) {
    animation: hideDialog .3s ease forwards;
  }

  :host([open]) {
    opacity: 1;
    visibility: visible;
    transition: all .3s ease;
  }

  :host([open]) .control {
    animation: open .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
  }

  :host(:not([open])) .control {
    animation: close .3s ease forwards;
  }

  .positioning-region {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${GDSEZIndexLayoutOverlay};
  }

  .control {
    ${elevation$1}
    width: 100%;
    max-width: var(--dialog-max-width);
    max-height: var(--dialog-max-height);
    background-color: ${GDSEColorSurfaceModal};
    z-index: ${GDSEZIndexLayoutOverlay};
    border-radius: ${GDSERadiusSurface};
    border: 1px solid transparent;
  }

  .control > * {
    padding: 0 ${GDSESpacing300};
  }

  :host([theme='dark']) .control > * {
    padding: 0 ${GDSESpacing500};
  }

  :host([borderless]) .control,
  :host([borderless]) .control > * {
    padding: 0;
  }

  .dialog-header {
    position: relative;
    top: 0;
    background: ${GDSEColorSurfaceModal};
    display: flex;
    padding: ${GDSESpacing300} ${GDSESpacing300} ${GDSESpacing150};
    z-index: 1;
  }

  :host([theme='dark']) .dialog-header {
    padding: ${GDSESpacing500};
  }

  .header-container {
    display: flex;
    flex: 1;
    align-items: center;
  }

  .header {
    flex: 1;
  }

  .icon {
    margin-right: ${GDSESpacing100};
  }

  .close {
    margin-left: ${GDSESpacing100};
    height: fit-content;
  }

  .dialog-content {
    flex: 1;
    overflow: auto;
  }

  :host(:not([scrollable]):not([size='fullscreen'])) .dialog-content {
    max-height: 65vh;
    overflow: visible;
  }

  :host([scrollable]) {
    --dialog-max-height: calc(100vh - 256px); /* 256px is padding-top + padding-bottom */
  }

  :host([scrollable]) .control {
    display: flex;
    flex-direction: column;
  }

  :host([scrollable]) .empty {
    display: none;
  }

  :host([scrollable]) .dialog-content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .gutter-shadow-top .dialog-header {
    border-bottom: 1px solid ${GDSEColorBorder};
  }

  .gutter-shadow-bottom ::slotted(tm1-dialog-footer) {
    border-top: 1px solid ${GDSEColorBorder};
  }

  :host .subtitle {
    color: ${GDSEColorTextLight};
  }

  @keyframes open {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes close {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0);
      opacity: 0;
      visibility: hidden;
    }
  }

  @keyframes hideDialog {
    0% {
      opacity: 1;
    }
    99.9% {
      opacity: 0;
    }
    100% {
      opacity: 0;
      visibility: hidden;
    }
  }

  :host ::slotted(tm1-button[icon="close"]),
  :host tm1-button[icon="close"] {
    --text-color: ${GDSEColorTextLight};
    --text-color-hovered: ${GDSEColorTextLight};
    --text-color-focus: ${GDSEColorTextLight};
    --text-color-pressed: ${GDSEColorText};
    --background-color-hovered: ${GDSEColorFillHovered};
    --background-color-focus: ${GDSEColorFillHovered};
    --background-color-pressed: ${GDSEColorFillPressed};
  }
`, overlay$1 = () => html`
  ${when(
  (td) => td.backgroundOverlay,
  html` <div class="overlay" part="overlay" role="presentation" @click="${(td) => {
    var Ae;
    return td.dismissable ? (Ae = td.close) == null ? void 0 : Ae.call(td) : "";
  }}"></div> `
)}
`, header = (td) => html`
<div class="dialog-header ${(Ae) => Ae.headerTemplateClasses()}" data-testid="dialog-header">
  <div class="header-container">
    ${when((Ae) => Ae.type, html` <${td.tagFor(Icon)} class="icon" size="regular" icon="${(Ae) => Ae.headerIcon}" />`)}
    <div class="header">
      <${td.tagFor(Typography)} type="heading-m">
        <slot name="dialog-header"></slot>
      </${td.tagFor(Typography)}>

      <${td.tagFor(Typography)} type="subheading-s" class="subtitle">
        <slot name="dialog-header-subtitle"></slot>
      </${td.tagFor(Typography)}>
    </div>
  </div>
  ${when(
  (Ae) => Ae.dismissable,
  html`<slot name="close">
      <${td.tagFor(Button)}
        class="close"
        variant="lightweight"
        aria-label="close"
        icon="close"
        iconPosition="only-icon"
        size="small"
        @click="${(Ae) => {
    var xr;
    return (xr = Ae.close) == null ? void 0 : xr.call(Ae);
  }}"
        >
        </${td.tagFor(Button)}>
    </slot>`
)}
</div>
`, content = () => html`
  <div ${ref("contentElement")} class="dialog-content" data-testid="dialog-content">
    <slot name="dialog-content"></slot>
    <slot ${slotted({ filter: (td) => td.nodeName === "TM1-DIALOG-STEP-CONTENT", flatten: !0, property: "slottedSteps" })}></slot>
    <slot></slot>
  </div>
`, footer = () => html`
    <slot name="footer">
      <tm1-dialog-footer
        class="${(td) => td.templateClasses()}"
        type="${(td) => td.footer}"
        nbSteps="${(td) => td.nbSteps}"
        ?nextDisabled="${(td) => td.nextDisabled}"
        ?previousDisabled="${(td) => td.previousDisabled}"
        stepLabelSeparator="${(td) => td.stepLabelSeparator}"
        activeStep=${(td) => td.activeStep}
        @active-step-change=${(td, Ae) => td.handleActiveStep(Ae.event)}
        data-testid="footer"
      >
        <slot slot="subactions" name="subactions" ${slotted("subactionsContent")}></slot>
        <slot slot="actions" name="actions" ${slotted("actionsContent")}></slot>
        <slot></slot>
      </tm1-dialog-footer>
    </slot>
  `, tm1DialogTemplate = (td) => html`
<template ?firstRender=${(Ae) => Ae.firstRender} theme=${(Ae) => Ae.theme}>
  <div
    class="positioning-region"
    part="positioning-region"
    data-testid="positioning-region"
  >
    ${overlay$1()}
    <div
      role="dialog"
      tabindex="-1"
      class="control"
      part="control"
      aria-modal="${(Ae) => Ae.open}"
      aria-describedby="${(Ae) => Ae.ariaDescribedby}"
      aria-labelledby="${(Ae) => Ae.ariaLabelledby}"
      aria-label="${(Ae) => Ae.ariaLabel}"
      ${ref("dialog")}
    >
      ${header(td)}

      ${content()}

      ${footer()}
    </div>
  </div>
</template>
`;
var __defProp$H = Object.defineProperty, __getOwnPropDesc$H = Object.getOwnPropertyDescriptor, __decorateClass$H = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$H(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$H(Ae, xr, id), id;
};
class Dialog extends Dialog$1 {
  constructor() {
    super(), this.backgroundOverlay = !0, this.borderless = !1, this.wrapContent = !1, this.activeStep = 1, this.actionsContent = [], this.subactionsContent = [], this.firstRender = !0, this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this.headerTemplateClasses = () => !this.querySelector('[slot="dialog-header"]') && !this.dismissable ? "empty" : "", this.templateClasses = () => this.subactionsContent.length || this.actionsContent.length || this.footer === "steps" ? "" : "empty", this.dismissable = !1, this.footer = "default", this.nextDisabled = !1, this.previousDisabled = !1, this.stepLabelSeparator = "of", this.open = !1, this.size = "small", this.scrollable = !1, this.deprecated = !1, this.handleContentScroll = () => {
      var id, od, ad, rd, sd, nd;
      const Ae = (((id = this.contentElement) == null ? void 0 : id.scrollHeight) || 0) - Math.abs(((od = this.contentElement) == null ? void 0 : od.scrollTop) || 0) - (((ad = this.contentElement) == null ? void 0 : ad.clientHeight) || 0), xr = ((rd = this.contentElement) == null ? void 0 : rd.scrollTop) === 0, ed = Ae <= 1 && Ae >= -1;
      (sd = this.dialog) == null || sd.classList.toggle("gutter-shadow-top", !xr), (nd = this.dialog) == null || nd.classList.toggle("gutter-shadow-bottom", !ed);
    }, document.addEventListener("keydown", (Ae) => this.keydownHandler(Ae, this.dismissable));
  }
  openChanged(Ae, xr) {
    var ed;
    this.firstRender && xr && (this.firstRender = !1), xr && ((ed = document.activeElement) == null || ed.blur()), document.body.style.overflowY = xr ? "hidden" : "auto";
  }
  typeChanged(Ae, xr) {
    Ae !== xr && this.updateIcon();
  }
  slottedStepsChanged(Ae, xr) {
    var ed;
    this.setActiveContent(), this.nbSteps = (ed = this.slottedSteps.length) != null ? ed : 1;
  }
  connectedCallback() {
    var Ae;
    super.connectedCallback(), (Ae = this.contentElement) == null || Ae.addEventListener("scroll", this.handleContentScroll), document.addEventListener("focusin", this.handleDocumentFocusOverride);
  }
  disconnectedCallback() {
    var Ae;
    super.disconnectedCallback(), (Ae = this.contentElement) == null || Ae.removeEventListener("scroll", this.handleContentScroll), document.removeEventListener("focusin", this.handleDocumentFocusOverride), document.removeEventListener("keydown", (xr) => this.keydownHandler(xr, this.dismissable));
  }
  handleDocumentFocusOverride(Ae) {
    Ae.preventDefault();
  }
  handleActiveStep(Ae) {
    this.activeStep = Ae.detail;
  }
  activeStepChanged() {
    this.setActiveContent(), this.$emit("active-step-change", this.activeStep);
  }
  setActiveContent() {
    var Ae;
    (Ae = this.slottedSteps) == null || Ae.forEach((xr) => {
      xr.hidden = !1, xr !== this.slottedSteps[this.activeStep - 1] && (xr.hidden = !0);
    });
  }
  updateIcon() {
    this.headerIcon = this.type ? `${this.type}Solid` : void 0;
  }
  keydownHandler(Ae, xr) {
    var ed;
    if (!this.hidden)
      switch (Ae.key) {
        case keyEscape:
          xr && ((ed = this.close) == null || ed.call(this), this.dismiss(), Ae.preventDefault());
          break;
      }
  }
}
__decorateClass$H([
  attr({ attribute: "background-overlay", mode: "boolean" }),
  attr({ attribute: "backgroundoverlay", mode: "boolean" })
], Dialog.prototype, "backgroundOverlay", 2);
__decorateClass$H([
  attr({ mode: "boolean" })
], Dialog.prototype, "borderless", 2);
__decorateClass$H([
  attr({ mode: "boolean", attribute: "wrap-content" }),
  attr({ mode: "boolean", attribute: "wrapcontent" })
], Dialog.prototype, "wrapContent", 2);
__decorateClass$H([
  attr({ attribute: "active-step" }),
  attr({ attribute: "activestep" })
], Dialog.prototype, "activeStep", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "actionsContent", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "subactionsContent", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "firstRender", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "nbSteps", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "theme", 2);
__decorateClass$H([
  attr({ mode: "fromView" })
], Dialog.prototype, "close", 2);
__decorateClass$H([
  attr({ mode: "boolean" })
], Dialog.prototype, "dismissable", 2);
__decorateClass$H([
  attr()
], Dialog.prototype, "footer", 2);
__decorateClass$H([
  attr({ mode: "boolean", attribute: "next-disabled" }),
  attr({ mode: "boolean", attribute: "nextdisabled" })
], Dialog.prototype, "nextDisabled", 2);
__decorateClass$H([
  attr({ mode: "boolean", attribute: "previous-disabled" }),
  attr({ mode: "boolean", attribute: "previousdisabled" })
], Dialog.prototype, "previousDisabled", 2);
__decorateClass$H([
  attr({ attribute: "step-label-separator" }),
  attr({ attribute: "steplabelseparator" })
], Dialog.prototype, "stepLabelSeparator", 2);
__decorateClass$H([
  attr({ mode: "boolean" })
], Dialog.prototype, "open", 2);
__decorateClass$H([
  attr()
], Dialog.prototype, "size", 2);
__decorateClass$H([
  attr({ mode: "boolean" })
], Dialog.prototype, "scrollable", 2);
__decorateClass$H([
  attr()
], Dialog.prototype, "type", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "slottedSteps", 2);
__decorateClass$H([
  observable
], Dialog.prototype, "headerIcon", 2);
const tm1Dialog = Dialog.compose({
  baseName: "dialog",
  baseClass: Dialog$1,
  template: tm1DialogTemplate,
  styles: tm1DialogStyles
}), tm1DialogFooterStyles = () => css`
  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  :host {
    background: ${GDSEColorSurfaceModal};
    padding: ${GDSESpacing300};
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  :host([theme='dark']) {
    padding: ${GDSESpacing200} ${GDSESpacing500} ${GDSESpacing500};
  }

  :host([type="steps"]),
  :host([type="steps"]) {
    display: grid;
    grid-template-columns: max-content 1fr 1fr;
  }

  :host([type="steps"]) slot[name='actions'] {
    justify-content: end;
  }

  :host(.empty-slot) slot:not([name]),
  :host(.empty-slot-actions) slot[name='actions'] {
    display: none;
  }

  :host(:not(.empty-slot):not(.empty-slot-actions)) {
    justify-content: flex-end;
    column-gap: ${GDSESpacing200};
  }

  :host(.empty) {
    padding: 0 ${GDSESpacing300} ${GDSESpacing300};
  }

  slot[name='subactions'],
  slot[name='actions'],
  slot:not([name]) {
    display: flex;
    gap: ${GDSESpacing200};
  }


  /** Steps type */
  :host(:not([type='steps'])) slot[name='steps'] {
    display: none;
  }

  :host([type='steps']) {
    justify-content: space-between;
  }

  :host([type='steps']) slot:not([name]) {
    flex-grow: 0;
  }

  .steps-container {
    display: flex;
    align-items: center;
  }

  .steps-state {
    color: ${GDSEColorTextLight};
  }

  .steps {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${GDSESpacing150};
  }

  .step {
    border-radius: ${GDSERadiusPill};
    border: 1px solid ${GDSEColorBorderInputDefault};
    height: 8px;
    width: 8px;
  }

  .step.active {
    background-color: ${GDSEColorFillLoading};
  }

  .step[disabled] {
    border: none;
    background-color: ${GDSEColorFillDisabled};
    cursor: not-allowed;
  }
`, tm1DialogFooterTemplate = (td) => html`
  <template theme=${(Ae) => Ae.theme}>
    ${when((Ae) => Ae.type === "steps", html`
      <div class="steps-container">
        <slot name="steps"></slot>
        ${when((Ae) => Ae.nbSteps, html`
          <div class="steps">
            <${td.tagFor(Button)} ?disabled="${(Ae) => Ae.isPreviousDisabled(Ae.activeStep)}" @click="${(Ae) => Ae.handleClickStep(Number(Ae.activeStep) - 1)}" variant="outline"><</${td.tagFor(Button)}>
            <${td.tagFor(Typography)} data-testid="steps-state" class="steps-state" type="body-m">${(Ae) => {
  var xr;
  return (xr = Ae.activeStep) == null ? void 0 : xr.toString();
}} ${(Ae) => Ae.stepLabelSeparator} ${(Ae) => {
  var xr;
  return (xr = Ae.nbSteps) == null ? void 0 : xr.toString();
}}</${td.tagFor(Typography)}>
            <${td.tagFor(Button)} ?disabled="${(Ae) => Ae.isNextDisabled(Ae.activeStep)}" @click="${(Ae) => Ae.handleClickStep(Number(Ae.activeStep) + 1)}" variant="outline">></${td.tagFor(Button)}>
          </div>
        `)}
      </div>
    `)}

    <slot ${slotted({ property: "contentSubActions", filter: whitespaceFilter })} name="subactions"></slot>
    <slot ${slotted({ property: "contentActions", filter: whitespaceFilter })}name="actions"></slot>
    <slot ${slotted({ property: "content", filter: whitespaceFilter })}></slot>
  </template>
`;
var __defProp$G = Object.defineProperty, __getOwnPropDesc$G = Object.getOwnPropertyDescriptor, __decorateClass$G = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$G(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$G(Ae, xr, id), id;
};
class DialogFooterElement extends FoundationElement {
  constructor() {
    super(...arguments), this.type = "default", this.activeStep = 1, this.stepLabelSeparator = "of", this.previousDisabled = !1, this.nextDisabled = !1, this.steps = [], this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
  isDisabled(Ae) {
    const xr = Ae + 1;
    return this.nextDisabled && +this.activeStep !== xr && xr > +this.activeStep;
  }
  isPreviousDisabled(Ae) {
    return !!(+Ae == 1 || this.previousDisabled);
  }
  isNextDisabled(Ae) {
    return !!(this.nbSteps && +Ae == +this.nbSteps || this.nextDisabled);
  }
  nbStepsChanged(Ae, xr) {
    if (this.steps = [], this.nbSteps)
      for (let ed = 0; ed < this.nbSteps; ed++)
        this.steps.push(ed);
  }
  contentChanged() {
    var Ae;
    ((Ae = this.content) == null ? void 0 : Ae.length) === 0 ? this.classList.add("empty-slot") : this.classList.remove("empty-slot");
  }
  contentActionsChanged() {
    var Ae;
    ((Ae = this.contentActions) == null ? void 0 : Ae.length) === 0 ? this.classList.add("empty-slot-actions") : this.classList.remove("empty-slot-actions");
  }
  contentSubActionsChanged() {
    var Ae;
    ((Ae = this.contentSubActions) == null ? void 0 : Ae.length) === 0 ? this.classList.add("empty-slot-sub-actions") : this.classList.remove("empty-slot-sub-actions");
  }
  handleClickStep(Ae) {
    this.activeStep = Ae, this.$emit("active-step-change", Ae);
  }
}
__decorateClass$G([
  attr()
], DialogFooterElement.prototype, "type", 2);
__decorateClass$G([
  attr({ attribute: "active-step" }),
  attr({ attribute: "activestep" })
], DialogFooterElement.prototype, "activeStep", 2);
__decorateClass$G([
  attr({ attribute: "nb-steps" }),
  attr({ attribute: "nbsteps" })
], DialogFooterElement.prototype, "nbSteps", 2);
__decorateClass$G([
  attr({ attribute: "step-label-separator" }),
  attr({ attribute: "steplabelseparator" })
], DialogFooterElement.prototype, "stepLabelSeparator", 2);
__decorateClass$G([
  attr({ mode: "boolean", attribute: "previous-disabled" }),
  attr({ mode: "boolean", attribute: "previousdisabled" })
], DialogFooterElement.prototype, "previousDisabled", 2);
__decorateClass$G([
  attr({ mode: "boolean", attribute: "next-disabled" }),
  attr({ mode: "boolean", attribute: "nextdisabled" })
], DialogFooterElement.prototype, "nextDisabled", 2);
__decorateClass$G([
  observable
], DialogFooterElement.prototype, "steps", 2);
__decorateClass$G([
  observable
], DialogFooterElement.prototype, "content", 2);
__decorateClass$G([
  observable
], DialogFooterElement.prototype, "contentActions", 2);
__decorateClass$G([
  observable
], DialogFooterElement.prototype, "contentSubActions", 2);
__decorateClass$G([
  observable
], DialogFooterElement.prototype, "theme", 2);
const tm1DialogFooter = DialogFooterElement.compose({
  baseName: "dialog-footer",
  baseClass: FoundationElement,
  template: tm1DialogFooterTemplate,
  styles: tm1DialogFooterStyles
});
designSystem.register(
  tm1Dialog(),
  tm1DialogFooter(),
  tm1DialogStepContent()
);
const tm1DialogStepContentV2Styles = i$2``, l0 = class l0 extends h {
  render() {
    return ke$1`
      <slot></slot>
    `;
  }
};
l0.styles = tm1DialogStepContentV2Styles;
let DialogStepContentV2 = l0;
customElements.get("tm1-dialog-step-content-v2") || customElements.define("tm1-dialog-step-content-v2", DialogStepContentV2);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const rt = (td) => td.strings === void 0;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, e = (td) => (...Ae) => ({ _$litDirective$: td, values: Ae });
class i {
  constructor(Ae) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(Ae, xr, ed) {
    this.t = Ae, this._$AM = xr, this.i = ed;
  }
  _$AS(Ae, xr) {
    return this.update(Ae, xr);
  }
  update(Ae, xr) {
    return this.render(...xr);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const mt = (td, Ae) => {
  var ed;
  const xr = td._$AN;
  if (xr === void 0)
    return !1;
  for (const id of xr)
    (ed = id._$AO) == null || ed.call(id, Ae, !1), mt(id, Ae);
  return !0;
}, _t = (td) => {
  let Ae, xr;
  do {
    if ((Ae = td._$AM) === void 0)
      break;
    xr = Ae._$AN, xr.delete(td), td = Ae;
  } while ((xr == null ? void 0 : xr.size) === 0);
}, wt = (td) => {
  for (let Ae; Ae = td._$AM; td = Ae) {
    let xr = Ae._$AN;
    if (xr === void 0)
      Ae._$AN = xr = /* @__PURE__ */ new Set();
    else if (xr.has(td))
      break;
    xr.add(td), gt(Ae);
  }
};
function bt(td) {
  this._$AN !== void 0 ? (_t(this), this._$AM = td, wt(this)) : this._$AM = td;
}
function yt(td, Ae = !1, xr = 0) {
  const ed = this._$AH, id = this._$AN;
  if (id !== void 0 && id.size !== 0)
    if (Ae)
      if (Array.isArray(ed))
        for (let od = xr; od < ed.length; od++)
          mt(ed[od], !1), _t(ed[od]);
      else
        ed != null && (mt(ed, !1), _t(ed));
    else
      mt(this, td);
}
const gt = (td) => {
  var Ae, xr;
  td.type == t.CHILD && ((Ae = td._$AP) != null || (td._$AP = yt), (xr = td._$AQ) != null || (td._$AQ = bt));
};
class $t extends i {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(Ae, xr, ed) {
    super._$AT(Ae, xr, ed), wt(this), this.isConnected = Ae._$AU;
  }
  _$AO(Ae, xr = !0) {
    var ed, id;
    Ae !== this.isConnected && (this.isConnected = Ae, Ae ? (ed = this.reconnected) == null || ed.call(this) : (id = this.disconnected) == null || id.call(this)), xr && (mt(this, Ae), _t(this));
  }
  setValue(Ae) {
    if (rt(this.t))
      this.t._$AI(Ae, this);
    else {
      const xr = [...this.t._$AH];
      xr[this.i] = Ae, this.t._$AI(xr, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const ii = () => new Zt();
class Zt {
}
const qt = /* @__PURE__ */ new WeakMap(), Kt = e(class extends $t {
  render(td) {
    return D$1;
  }
  update(td, [Ae]) {
    var ed;
    const xr = Ae !== this.Y;
    return xr && this.Y !== void 0 && this.rt(void 0), (xr || this.lt !== this.ct) && (this.Y = Ae, this.ht = (ed = td.options) == null ? void 0 : ed.host, this.rt(this.ct = td.element)), D$1;
  }
  rt(td) {
    var Ae;
    if (this.isConnected || (td = void 0), typeof this.Y == "function") {
      const xr = (Ae = this.ht) != null ? Ae : globalThis;
      let ed = qt.get(xr);
      ed === void 0 && (ed = /* @__PURE__ */ new WeakMap(), qt.set(xr, ed)), ed.get(this.Y) !== void 0 && this.Y.call(this.ht, void 0), ed.set(this.Y, td), td !== void 0 && this.Y.call(this.ht, td);
    } else
      this.Y.value = td;
  }
  get lt() {
    var td, Ae, xr;
    return typeof this.Y == "function" ? (Ae = qt.get((td = this.ht) != null ? td : globalThis)) == null ? void 0 : Ae.get(this.Y) : (xr = this.Y) == null ? void 0 : xr.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function nn(td, Ae, xr) {
  return td ? Ae(td) : xr == null ? void 0 : xr(td);
}
const ambientShadow = i$2`0 0 calc((var(--elevation) * 0.225px) + 2px) rgba(0, 0, 0, calc(.11 * (2 - var(--background-luminance, 1))))`, directionalShadow = i$2`0 calc(var(--elevation) * 0.4px) calc((var(--elevation) * 0.9px)) rgba(0, 0, 0, calc(.13 * (2 - var(--background-luminance, 1))))`, elevation = i$2`box-shadow: ${ambientShadow}, ${directionalShadow};`, tm1DialogV2Styles = i$2`
    :host {
    display: contents;
    --dialog-max-height: auto;
  }

  :host .control:focus-visible {
    outline: none;
  }

  dialog {
    padding: 0;
  }

  :host([size='small']) {
    --dialog-max-width: 400px;
  }

  :host([size='medium']) {
    --dialog-max-width: 520px;
  }

  :host([size='large']) {
    --dialog-max-width: 640px;
  }

  :host([size='extra-large']) {
    --dialog-max-width: 860px;
  }

  :host([size='fullscreen']) {
    --dialog-max-width: 90vw;
    --dialog-max-height: 90vh;
  }

  :host([size='fullscreen']) .control {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  :host([size='fullscreen']) tm1-dialog-footer-v2 {
    margin-top: auto;
  }

  :host([wrap-content]) .control {
    height: auto;
  }

  @media (min-height: 720px) and (max-height: 1079px) {
    :host([size='fullscreen']) {
      --dialog-max-height: 95vh;
    }
  }

  @media (min-height: 1080px) {
    :host([size='fullscreen']) {
      --dialog-max-height: 1030px;
    }
  }

  @media (max-width: 1439px) {
    :host([size='fullscreen']) {
      --dialog-max-width: 90vw;
    }
  }

  @media (min-width: 1440px) {
    :host([size='fullscreen']) {
      --dialog-max-width: 1296px;
    }
  }

  :host {
    --elevation: 6;
  }

  :host([background-overlay]) ::backdrop,
  :host([backgroundoverlay]) ::backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--gdse-s-color-background-overlay);
    touch-action: none;
  }

  :host(:not([open])),
  :host([open="false"]) {
    visibility: hidden;
    display: none;
  }

  :host([open]),
  :host([open="true"]) {
    opacity: 1;
    visibility: visible;
    transition: all .3s ease;
  }

  .control {
    ${elevation}
    width: 100%;
    max-width: var(--dialog-max-width);
    max-height: var(--dialog-max-height);
    background-color: var(--gdse-s-color-surface-modal);
    z-index: var(--gdse-s-z-index-layout-overlay);
    border-radius: var(--gdse-s-radius-surface);
    border: 1px solid transparent;
  }

  .control > * {
    padding: 0 var(--gdse-g-spacing-300);
  }

  :host([theme='dark']) .control > * {
    padding: 0 var(--gdse-g-spacing-500);
  }

  :host([borderless]) .control,
  :host([borderless]) .control > * {
    padding: 0;
  }

  .dialog-header {
    position: relative;
    top: 0;
    background: var(--gdse-s-color-surface-modal);
    display: flex;
    padding: var(--gdse-g-spacing-300) var(--gdse-g-spacing-300) var(--gdse-g-spacing-150);
    z-index: 1;
  }

  :host([theme='dark']) .dialog-header {
    padding: var(--gdse-g-spacing-500);
  }

  .header-container {
    display: flex;
    flex: 1;
    align-items: center;
  }

  .header {
    flex: 1;
  }

  .icon {
    margin-right: var(--gdse-g-spacing-100);
  }

  .close {
    margin-left: var(--gdse-g-spacing-100);
    height: fit-content;
  }

  .dialog-content {
    flex: 1;
    overflow: auto;
  }

  :host(:not([scrollable]):not([size='fullscreen'])) .dialog-content {
    max-height: 65vh;
    overflow: visible;
  }

  :host([scrollable]) {
    --dialog-max-height: calc(100vh - 256px); /* 256px is padding-top + padding-bottom */
  }

  :host([scrollable]) .control {
    display: flex;
    flex-direction: column;
  }

  :host([scrollable]) .empty {
    display: none;
  }

  :host([scrollable]) .dialog-content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .gutter-shadow-top .dialog-header {
    border-bottom: 1px solid var(--gdse-s-color-border);
  }

  .gutter-shadow-bottom ::slotted(tm1-dialog-footer-v2) {
    border-top: 1px solid var(--gdse-s-color-border);
  }

  :host .subtitle {
    color: var(--gdse-s-color-text-light);
  }

  :host ::slotted(tm1-button[icon="close"]),
  :host tm1-button[icon="close"] {
    --text-color: var(--gdse-s-color-text-light);
    --text-color-hovered: var(--gdse-s-color-text-light);
    --text-color-focus: var(--gdse-s-color-text-light);
    --text-color-pressed: var(--gdse-s-color-text);
    --background-color-hovered: var(--gdse-s-color-fill-hovered);
    --background-color-focus: var(--gdse-s-color-fill-hovered);
    --background-color-pressed: var(--gdse-s-color-fill-pressed);
  }
`;
var __defProp$F = Object.defineProperty, __getOwnPropDesc$F = Object.getOwnPropertyDescriptor, __decorateClass$F = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$F(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$F(Ae, xr, id), id;
};
const c0 = class c0 extends h {
  constructor() {
    super(), this.activeStep = 1, this.backgroundOverlay = !0, this.borderless = !1, this.dismissable = !1, this.footer = "default", this.nbSteps = void 0, this.nextDisabled = !1, this.open = !1, this.previousDisabled = !1, this.scrollable = !1, this.size = "small", this.stepLabelSeparator = "of", this.type = void 0, this.dialog = void 0, this.content = void 0, this.slottedSteps = void 0, this.contentElement = ii(), this.headerTemplateClasses = () => !this.querySelector('[slot="dialog-header"]') && !this.dismissable ? "empty" : "", this.handleContentScroll = () => {
      var id, od, ad, rd, sd, nd;
      const Ae = (((id = this.contentElement.value) == null ? void 0 : id.scrollHeight) || 0) - Math.abs(((od = this.contentElement.value) == null ? void 0 : od.scrollTop) || 0) - (((ad = this.contentElement.value) == null ? void 0 : ad.clientHeight) || 0), xr = ((rd = this.contentElement.value) == null ? void 0 : rd.scrollTop) === 0, ed = Ae <= 1 && Ae >= -1;
      (sd = this.dialog) == null || sd.classList.toggle("gutter-shadow-top", !xr), (nd = this.dialog) == null || nd.classList.toggle("gutter-shadow-bottom", !ed);
    }, document.addEventListener("keydown", this.keydownHandler);
  }
  updated(Ae) {
    var xr;
    super.updated(Ae), Ae.has("open") && (this.open ? (xr = this.dialog) == null || xr.showModal() : this.handleClose()), Ae.has("type") && this.updateIcon(), Ae.has("active-step") && emit(this, "active-step-change", this.activeStep);
  }
  handleClose() {
    var Ae, xr;
    (Ae = this.dialog) == null || Ae.close(), (xr = this.close) == null || xr.call(this);
  }
  updateIcon() {
    this.headerIcon = this.type ? `${this.type}Solid` : void 0;
  }
  slottedStepsChanged() {
    waitForElm(this.shadowRoot, "dialog").then(() => {
      this.setActiveContent();
    });
  }
  setActiveContent() {
    var Ae;
    (Ae = this.slottedSteps) == null || Ae.forEach((xr) => {
      xr.hidden = !1, this.slottedSteps && xr !== this.slottedSteps[this.activeStep - 1] && (xr.hidden = !0);
    });
  }
  firstUpdated() {
    waitForElm(this.shadowRoot, "dialog").then(() => {
      var Ae, xr, ed, id, od, ad, rd;
      this.content = (Ae = this.shadowRoot) == null ? void 0 : Ae.querySelector(".dialog-content"), this.dialog = (xr = this.shadowRoot) == null ? void 0 : xr.querySelector("dialog"), this.slottedSteps = (od = (id = (ed = this.shadowRoot) == null ? void 0 : ed.querySelector("slot:not([name])")) == null ? void 0 : id.assignedElements()) == null ? void 0 : od.filter((sd) => sd.nodeName === "TM1-DIALOG-STEP-CONTENT-V2"), (ad = this.content) == null || ad.addEventListener("scroll", this.handleContentScroll), this.open && ((rd = this.dialog) == null || rd.showModal());
    }), document.addEventListener("focusin", this.handleDocumentFocusOverride);
  }
  disconnectedCallback() {
    var Ae;
    super.disconnectedCallback(), (Ae = this.contentElement.value) == null || Ae.removeEventListener("scroll", this.handleContentScroll), document.removeEventListener("focusin", this.handleDocumentFocusOverride), document.removeEventListener("keydown", this.keydownHandler);
  }
  handleDocumentFocusOverride(Ae) {
    Ae.preventDefault();
  }
  handleActiveStep(Ae) {
    this.activeStep = Ae.detail, emit(this, "active-step-change", this.activeStep);
  }
  keydownHandler(Ae) {
    if (!this.hidden)
      switch (Ae.key) {
        case "Escape":
          this.dismissable && (this.handleClose(), Ae.preventDefault());
          break;
      }
  }
  clickHandler(Ae) {
    if (this.dialog) {
      const xr = this.dialog.getBoundingClientRect();
      !(xr.top <= Ae.clientY && Ae.clientY <= xr.top + xr.height && xr.left <= Ae.clientX && Ae.clientX <= xr.left + xr.width) && this.dismissable && (this.open = !1);
    }
  }
  render() {
    return ke$1`
    <dialog
      class="control"
      role="dialog"
      aria-modal=${this.open}
      aria-describedby=${this.ariaDescribedby}
      aria-labelledby=${this.ariaLabelledby}
      aria-label=${this.ariaLabel}
      @click=${this.clickHandler}
    >
      <div class="dialog-header ${this.headerTemplateClasses()}" data-testid="dialog-header">
        <div class="header-container">
          ${nn(this.type, () => ke$1`<tm1-icon class="icon" size="regular" icon="${this.headerIcon}" />`)}
          <div class="header">
            <tm1-typography type="heading-m">
              <slot name="dialog-header"></slot>
            </tm1-typography>

            <tm1-typography type="subheading-s" class="subtitle">
              <slot name="dialog-header-subtitle"></slot>
            </tm1-typography>
          </div>
        </div>

        ${nn(this.dismissable, () => ke$1`<slot name="close">
          <tm1-button
            class="close"
            variant="lightweight"
            aria-label="close"
            icon="close"
            iconPosition="only-icon"
            size="small"
            @click=${this.handleClose}
            >
            </tm1-button>
          </slot>`)}
      </div>

      <div ${Kt(this.contentElement)} class="dialog-content" data-testid="dialog-content">
        <slot name="dialog-content"></slot>
        <slot ${Kt(this.slottedStepsChanged)}></slot>
      </div>

      <slot name="footer">
        <tm1-dialog-footer-v2
          type="${this.footer}"
          nb-steps="${this.nbSteps}"
          ?next-disabled="${this.nextDisabled}"
          ?previous-disabled="${this.previousDisabled}"
          step-label-separator="${this.stepLabelSeparator}"
          active-step=${this.activeStep}
          @active-step-change=${this.handleActiveStep}
        >
          <slot slot="subactions" name="subactions"></slot>
          <slot slot="actions" name="actions"></slot>
          <slot></slot>
        </tm1-dialog-footer-v2>
      </slot>
    </dialog>
  `;
  }
};
c0.styles = tm1DialogV2Styles;
let DialogV2 = c0;
__decorateClass$F([
  n({ attribute: "active-step" })
], DialogV2.prototype, "activeStep", 2);
__decorateClass$F([
  n({ attribute: "aria-describedby" })
], DialogV2.prototype, "ariaDescribedby", 2);
__decorateClass$F([
  n({ attribute: "aria-labelledby" })
], DialogV2.prototype, "ariaLabelledby", 2);
__decorateClass$F([
  n({ attribute: "background-overlay", reflect: !0, type: Boolean })
], DialogV2.prototype, "backgroundOverlay", 2);
__decorateClass$F([
  n({ attribute: !0, reflect: !0, type: Boolean })
], DialogV2.prototype, "borderless", 2);
__decorateClass$F([
  n({ attribute: !0, reflect: !0, type: Boolean })
], DialogV2.prototype, "dismissable", 2);
__decorateClass$F([
  n()
], DialogV2.prototype, "footer", 2);
__decorateClass$F([
  n({ attribute: "nb-steps" })
], DialogV2.prototype, "nbSteps", 2);
__decorateClass$F([
  n({ attribute: "next-disabled", type: Boolean })
], DialogV2.prototype, "nextDisabled", 2);
__decorateClass$F([
  n({ attribute: !0, reflect: !0, type: Boolean })
], DialogV2.prototype, "open", 2);
__decorateClass$F([
  n({ attribute: "previous-disabled", reflect: !0, type: Boolean })
], DialogV2.prototype, "previousDisabled", 2);
__decorateClass$F([
  n({ attribute: !0, reflect: !0, type: Boolean })
], DialogV2.prototype, "scrollable", 2);
__decorateClass$F([
  n({ reflect: !0 })
], DialogV2.prototype, "size", 2);
__decorateClass$F([
  n({ attribute: "step-label-separator" })
], DialogV2.prototype, "stepLabelSeparator", 2);
__decorateClass$F([
  n()
], DialogV2.prototype, "type", 2);
__decorateClass$F([
  n({ attribute: "wrap-content", type: Boolean, reflect: !0 })
], DialogV2.prototype, "wrapContent", 2);
__decorateClass$F([
  n()
], DialogV2.prototype, "close", 2);
__decorateClass$F([
  r()
], DialogV2.prototype, "headerIcon", 2);
customElements.get("tm1-dialog-v2") || customElements.define("tm1-dialog-v2", DialogV2);
const tm1DialogFooterV2Styles = i$2`
  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  :host {
    background: var(--gdse-s-color-surface-modal);
    padding: var(--gdse-g-spacing-300);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  :host([theme='dark']) {
    padding: var(--gdse-g-spacing-200) var(--gdse-g-spacing-500) var(--gdse-g-spacing-500);
  }

  :host([type="steps"]) {
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
  }

  :host([type="steps"]) slot[name='actions'] {
    justify-content: end;
  }

  :host(.empty-slot) slot:not([name]),
  :host(.empty-slot-actions) slot[name='actions'] {
    display: none;
  }

  :host(:not(.empty-slot):not(.empty-slot-actions)) {
    justify-content: flex-end;
    column-gap: var(--gdse-g-spacing-200);
  }

  :host(.empty) {
    padding: 0 var(--gdse-g-spacing-300) var(--gdse-g-spacing-300);
  }

  slot[name='subactions'],
  slot[name='actions'],
  slot:not([name]) {
    display: flex;
    gap: var(--gdse-g-spacing-200);
  }


  /** Steps type */
  :host(:not([type='steps'])) slot[name='steps'] {
    display: none;
  }

  :host([type='steps']) {
    justify-content: space-between;
  }

  :host([type='steps']) slot:not([name]) {
    flex-grow: 0;
  }

  .steps-container {
    display: flex;
    align-items: center;
  }

  .steps {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--gdse-g-spacing-100);
  }

  .step {
    border-radius: var(--gdse-s-radius-pill);
    border: 1px solid var(--gdse-s-color-border-input-default);
    height: 8px;
    width: 8px;
  }

  .step.active {
    background-color: var(--gdse-s-color-fill-loading);
  }

  .step[disabled] {
    border: none;
    background-color: var(--gdse-s-color-fill-disabled);
    cursor: not-allowed;
  }

  :host ::part(icon) {
    width: 16px;
    height: 16px;
  }
`;
var __defProp$E = Object.defineProperty, __getOwnPropDesc$E = Object.getOwnPropertyDescriptor, __decorateClass$E = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$E(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$E(Ae, xr, id), id;
};
const d0 = class d0 extends h {
  constructor() {
    super(...arguments), this.type = "default", this.activeStep = 1, this.previousDisabled = !1, this.nextDisabled = !1, this.stepLabelSeparator = "of", this._steps = [], this.theme = ThemeType.light;
  }
  firstUpdated() {
    const Ae = this.querySelectorAll("slot");
    this.setSteps(), Ae && (this.contentChanged(Ae[0]), this.contentActionsChanged(Ae[1]), this.contentSubActionsChanged(Ae[2]));
  }
  updated(Ae) {
    super.updated(Ae), Ae.has("nb-steps") && this.setSteps();
  }
  setSteps() {
    if (this._steps = [], this.nbSteps)
      for (let Ae = 0; Ae < +this.nbSteps; Ae++)
        this._steps.push(Ae);
  }
  contentChanged(Ae) {
    waitForElm(this.shadowRoot, "slot").then(() => {
      var xr;
      this._content = (xr = Ae == null ? void 0 : Ae.assignedElements()) != null ? xr : [], this._content.length === 0 ? this.classList.add("empty-slot") : this.classList.remove("empty-slot"), this.setEmptyClass();
    });
  }
  contentActionsChanged(Ae) {
    waitForElm(this.shadowRoot, 'slot[name="actions"]').then(() => {
      var xr, ed, id;
      this._contentActions = (id = (Ae == null ? void 0 : Ae.assignedElements()) || ((ed = (xr = this.shadowRoot) == null ? void 0 : xr.querySelector('slot[name="actions"]')) == null ? void 0 : ed.assignedElements())) != null ? id : [], this._contentActions.length === 0 ? this.classList.add("empty-slot-actions") : this.classList.remove("empty-slot-actions"), this.setEmptyClass();
    });
  }
  contentSubActionsChanged(Ae) {
    waitForElm(this.shadowRoot, 'slot[name="subactions"]').then(() => {
      var xr, ed, id;
      this._contentSubActions = (id = (Ae == null ? void 0 : Ae.assignedElements()) || ((ed = (xr = this.shadowRoot) == null ? void 0 : xr.querySelector('slot[name="subactions"]')) == null ? void 0 : ed.assignedElements())) != null ? id : [], this._contentSubActions.length === 0 ? this.classList.add("empty-slot-sub-actions") : this.classList.remove("empty-slot-sub-actions"), this.setEmptyClass();
    });
  }
  setEmptyClass() {
    var Ae, xr, ed;
    ((Ae = this._content) == null ? void 0 : Ae.length) === 0 && ((xr = this._contentActions) == null ? void 0 : xr.length) === 0 && ((ed = this._contentSubActions) == null ? void 0 : ed.length) === 0 ? this.classList.add("empty") : this.classList.remove("empty");
  }
  isDisabled(Ae) {
    const xr = Ae + 1;
    return this.nextDisabled && +this.activeStep !== xr && xr > +this.activeStep;
  }
  isPreviousDisabled(Ae) {
    return !!(+Ae == 1 || this.previousDisabled);
  }
  isNextDisabled(Ae) {
    return !!(this.nbSteps && +Ae == +this.nbSteps || this.nextDisabled);
  }
  handleClickStep(Ae) {
    this.activeStep = +Ae, emit(this, "active-step-change", Ae);
  }
  render() {
    return ke$1`
      ${nn(this.type === "steps", () => ke$1`
        <div class="steps-container">
          <slot name="steps"></slot>
          ${nn(this.nbSteps, () => ke$1`
            <div class="steps">
              <tm1-button ?disabled="${this.isPreviousDisabled(this.activeStep)}" @click="${() => this.handleClickStep(+this.activeStep - 1)}" variant="outline" icon="back" iconPosition="only-icon"></tm1-button>
              <tm1-typography data-testid="steps-state" class="steps-state" type="body-m">${this.activeStep} ${this.stepLabelSeparator} ${this.nbSteps}</tm1-typography>
              <tm1-button ?disabled="${this.isNextDisabled(this.activeStep)}" @click="${() => this.handleClickStep(+this.activeStep + 1)}" variant="outline" icon="forward" iconPosition="only-icon"></tm1-button>
            </div>
          `)}
        </div>
      `)}

      <slot ${Kt(this.contentSubActionsChanged)} name="subactions"></slot>
      <slot ${Kt(this.contentActionsChanged)} name="actions"></slot>
      <slot ${Kt(this.contentChanged)}></slot>
    `;
  }
};
d0.styles = r$3(tm1DialogFooterV2Styles);
let DialogFooterV2 = d0;
__decorateClass$E([
  n({ reflect: !0 })
], DialogFooterV2.prototype, "type", 2);
__decorateClass$E([
  n({ attribute: "active-step" })
], DialogFooterV2.prototype, "activeStep", 2);
__decorateClass$E([
  n({ attribute: "nb-steps" })
], DialogFooterV2.prototype, "nbSteps", 2);
__decorateClass$E([
  n({ attribute: "previous-disabled", type: Boolean, reflect: !0 })
], DialogFooterV2.prototype, "previousDisabled", 2);
__decorateClass$E([
  n({ attribute: "next-disabled", type: Boolean, reflect: !0 })
], DialogFooterV2.prototype, "nextDisabled", 2);
__decorateClass$E([
  n({ attribute: "step-label-separator" })
], DialogFooterV2.prototype, "stepLabelSeparator", 2);
__decorateClass$E([
  r()
], DialogFooterV2.prototype, "_steps", 2);
__decorateClass$E([
  r()
], DialogFooterV2.prototype, "_content", 2);
__decorateClass$E([
  r()
], DialogFooterV2.prototype, "_contentActions", 2);
__decorateClass$E([
  r()
], DialogFooterV2.prototype, "_contentSubActions", 2);
__decorateClass$E([
  c$3({ context: themeContext, subscribe: !0 })
], DialogFooterV2.prototype, "theme", 2);
customElements.get("tm1-dialog-footer-v2") || customElements.define("tm1-dialog-footer-v2", DialogFooterV2);
const tm1DrawerFooterStyles = () => css`
  :host {
    display: flex;
    padding: ${GDSESpacing300};
    justify-content: flex-end;
    align-items: center;
    background: ${GDSEColorSurfaceModal};
  }

  .container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${GDSESpacing150};
  }
`, tm1DrawerFooterTemplate = (td) => html`
    <template>
      <div class="container">
        <slot></slot>
      </div>
    </template>
  `;
class DrawerFooter extends FoundationElement {
}
const tm1DrawerFooter = DrawerFooter.compose({
  baseName: "drawer-footer",
  template: tm1DrawerFooterTemplate,
  styles: tm1DrawerFooterStyles
}), tm1DrawerHeaderStyles = () => css`
  :host {
    display: flex;
    padding: ${GDSESpacing300};
    align-items: flex-start;
    gap: ${GDSESpacing100};
    background: ${GDSEColorSurfaceModal};
  }

  .close,
  .back {
    align-self: flex-start;
  }

  .header {
    display: flex;
    min-height: 48px;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
  }

  .heading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    flex: 1 0 0;
  }

  .heading {
    color: ${GDSEColorText};
  }

  .subheading {
    color: ${GDSEColorTextLight};
  }

  :host(slot) {
    display: flex;
  }

  :host tm1-button {
    --text-color: ${GDSEColorTextLight};
    --text-color-hovered: ${GDSEColorTextLight};
    --text-color-focus: ${GDSEColorTextLight};
    --text-color-pressed: ${GDSEColorText};
    --background-color-hovered: ${GDSEColorFillHovered};
    --background-color-focus: ${GDSEColorFillHovered};
    --background-color-pressed: ${GDSEColorFillPressed};
  }
`, tm1DrawerHeaderTemplate = (td) => html`
    <template mode="${(Ae) => Ae.mode}">
      <div class="header">
        ${when((Ae) => Ae.mode === DrawerHeaderMode.nested && Ae.closable, html`
          <div class="back">
            <${td.tagFor(Button)}
              aria-label="back"
              @click="${(Ae) => Ae.navigateBack()}"
              size="small" variant="lightweight"
              icon="back"
              iconPosition="only-icon"
            />
          </div>
        `)}

        <div class="heading-wrapper">
          <div class="heading">
            <${td.tagFor(Typography)} type="heading-m">
              <slot name="heading">
                ${(Ae) => Ae.heading}
              </slot>
            </${td.tagFor(Typography)}>
          </div>
          <div class="subheading">
            <${td.tagFor(Typography)} type="subheading-m">
              <slot name="subheading">
                ${(Ae) => Ae.subheading}
              </slot>
            </${td.tagFor(Typography)}>
          </div>
        </div>

        ${when((Ae) => Ae.mode !== DrawerHeaderMode.main, html`
          <slot data-testid="slot"></slot>
        `)}

        ${when((Ae) => Ae.mode === DrawerHeaderMode.main && Ae.closable, html`
          <div class="close">
            <${td.tagFor(Button)}
              aria-label="close"
              @click="${(Ae) => Ae.close()}"
              size="small"
              variant="lightweight"
              icon="close"
              iconPosition="only-icon"
            />
          </div>
        `)}
      </div>
    </template>
  `;
var __defProp$D = Object.defineProperty, __getOwnPropDesc$D = Object.getOwnPropertyDescriptor, __decorateClass$D = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$D(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$D(Ae, xr, id), id;
};
const DrawerHeaderMode = {
  main: "main",
  nested: "nested"
};
class DrawerHeader extends FoundationElement {
  constructor() {
    super(...arguments), this.heading = "", this.subheading = "", this.mode = DrawerHeaderMode.main, this.closable = !1;
  }
  isDrawer(Ae) {
    return (Ae == null ? void 0 : Ae.nodeName.toLocaleLowerCase()) === "tm1-drawer";
  }
  close() {
    this.isDrawer(this.parentNode) && this.parentNode.close();
  }
  navigateBack() {
    this.isDrawer(this.parentNode) && this.parentNode.navigateBack();
  }
}
__decorateClass$D([
  attr()
], DrawerHeader.prototype, "heading", 2);
__decorateClass$D([
  attr()
], DrawerHeader.prototype, "subheading", 2);
__decorateClass$D([
  attr()
], DrawerHeader.prototype, "mode", 2);
__decorateClass$D([
  attr({ mode: "boolean" })
], DrawerHeader.prototype, "closable", 2);
const tm1DrawerHeader = DrawerHeader.compose({
  baseName: "drawer-header",
  template: tm1DrawerHeaderTemplate,
  styles: tm1DrawerHeaderStyles
}), tm1DrawerStyles = () => css`
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${GDSEColorBackgroundOverlay};
    touch-action: none;
    opacity: 0;
    visibility: hidden;
    z-index: ${GDSEZIndexLayoutOverlay};
  }

  :host([open]) .overlay {
    opacity: 1;
    visibility: visible;
  }

  .positioning-region {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    transform: translateX(20px);
    transition:
      transform 0.3s ease-in-out,
      opacity 0.3s ease-in-out,
      visibility 0s linear;
    z-index: ${GDSEZIndexLayoutOverlay};
    opacity: 0;
    visibility: hidden;
  }

  :host([open]) .positioning-region {
    transform: translateX(0px);
    opacity: 1;
    visibility: visible;
  }

  .drawer {
    background-color: ${GDSEColorSurfaceModal};
    display: inline-flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    max-width: 480px;
    width: 100%;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0s linear;
    z-index: ${GDSEZIndexDrawerContent};
  }

  :host([open]) .drawer {
    opacity: 1;
    visibility: visible;
  }

  :host([size='small']) .drawer {
    max-width: 320px;
  }

  :host([size='large']) .drawer {
    max-width: 720px;
  }

  :host([size='xlarge']) .drawer {
    max-width: 960px;
  }

  .content {
    height: 100%;
    overflow-y: auto;
    display: flex;
    padding: 0px ${GDSESpacing300};
    align-items: flex-start;
    gap: ${GDSESpacing100};
    opacity: 0;
    visibility: hidden;
  }

  :host([open]) .content {
    opacity: 1;
    visibility: visible;
  }

  :host(:not([open])) .overlay,
  :host(:not([open])) .positioning-region,
  :host(:not([open])) .drawer,
  :host(:not([open])) .content {
    opacity: 0;
    visibility: hidden;
  }

  .gutter-shadow-top .header {
    box-shadow: 0px 11px 8px -10px #ccc;
  }

  .gutter-shadow-bottom .footer {
    box-shadow: 0px -11px 8px -10px #ccc;
  }
`, overlay = () => html`
  ${when(
  (td) => td.open,
  html` <div class="overlay" part="overlay" role="presentation" @click="${(td) => td.overlayHandler()}"></div> `
)}
`, tm1DrawerTemplate = (td) => html`
    <template tabindex="-1">
      ${overlay()}
      <div class="positioning-region" part="positioning-region">
        <div role="dialog" class="drawer" ${ref("drawer")} tabindex="0">
          <div class="header" ?hidden="${(Ae) => !Ae.headerSlot}">
            <slot name="header"></slot>
          </div>

          <div ${ref("contentElement")} data-testid="content" class="content">
            <slot></slot>
          </div>
          
          <div class="footer" ?hidden="${(Ae) => !Ae.footerSlot}">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </template>
  `;
var __defProp$C = Object.defineProperty, __getOwnPropDesc$C = Object.getOwnPropertyDescriptor, __decorateClass$C = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$C(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$C(Ae, xr, id), id;
};
const DrawerSize = {
  small: "small",
  medium: "medium",
  large: "large",
  xlarge: "xlarge"
};
class Drawer extends FoundationElement {
  constructor() {
    super(...arguments), this.disableClickOutside = !1, this.open = !1, this.size = DrawerSize.medium, this.headerSlot = null, this.footerSlot = null, this.isNavigateBack = !1, this.handleContentScroll = () => {
      var id, od, ad, rd, sd, nd;
      const Ae = (((id = this.contentElement) == null ? void 0 : id.scrollHeight) || 0) - Math.abs(((od = this.contentElement) == null ? void 0 : od.scrollTop) || 0) - (((ad = this.contentElement) == null ? void 0 : ad.clientHeight) || 0), xr = ((rd = this.contentElement) == null ? void 0 : rd.scrollTop) === 0, ed = Ae <= 1 && Ae >= -1;
      (sd = this.drawer) == null || sd.classList.toggle("gutter-shadow-top", !xr), (nd = this.drawer) == null || nd.classList.toggle("gutter-shadow-bottom", !ed);
    };
  }
  openChanged(Ae, xr) {
    document.body.style.overflowY = xr === !0 ? "hidden" : "auto", this.$fastController.isConnected && !xr && !this.isNavigateBack && this.$emit("close"), this.$fastController.isConnected && !xr && this.isNavigateBack && (this.$emit("navigate-back"), this.isNavigateBack = !1);
  }
  close() {
    this.open = !1;
  }
  navigateBack() {
    this.isNavigateBack = !0, this.close();
  }
  connectedCallback() {
    var Ae;
    super.connectedCallback(), this.headerSlot = this.querySelector('[slot="header"]'), this.footerSlot = this.querySelector('[slot="footer"]'), (Ae = this.contentElement) == null || Ae.addEventListener("scroll", this.handleContentScroll);
  }
  disconnectedCallback() {
    var Ae;
    super.disconnectedCallback(), (Ae = this.contentElement) == null || Ae.removeEventListener("scroll", this.handleContentScroll);
  }
  overlayHandler() {
    this.disableClickOutside || (this.close(), this.$emit("click-outside"));
  }
}
__decorateClass$C([
  attr({ mode: "boolean", attribute: "disable-click-outside" }),
  attr({ mode: "boolean", attribute: "disableClickOutside" })
], Drawer.prototype, "disableClickOutside", 2);
__decorateClass$C([
  attr({ mode: "boolean" })
], Drawer.prototype, "open", 2);
__decorateClass$C([
  attr()
], Drawer.prototype, "size", 2);
__decorateClass$C([
  observable
], Drawer.prototype, "headerSlot", 2);
__decorateClass$C([
  observable
], Drawer.prototype, "footerSlot", 2);
const tm1Drawer = Drawer.compose({
  baseName: "drawer",
  template: tm1DrawerTemplate,
  styles: tm1DrawerStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Drawer(),
  tm1DrawerFooter(),
  tm1DrawerHeader()
);
const tm1ProgressRingStyles = () => css`
  @keyframes progress-ring {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  :host {
    display: block;
    position: relative;
  }

  :host([size='regular']) {
    height: 80px;

    --border-width: 3px;
    --margin-value: 7px;
    --outer-ring-length: 80px;
    --middle-ring-length: 60px;
    --inner-ring-length: 40px;
  }

  :host([size='small']) {
    height: 48px;

    --border-width: 2px;
    --margin-value: 4px;
    --outer-ring-length: 48px;
    --middle-ring-length: 36px;
    --inner-ring-length: 24px;
  }

  :host([size='xsmall']) {
    height: 24px;

    --border-width: 1px;
    --margin-value: 3px;
    --outer-ring-length: 24px;
    --middle-ring-length: 16px;
    --inner-ring-length: 8px;
  }

  :host([size='xxsmall']) {
    height: 16px;

    --border-width: 1px;
    --margin-value: 1px;
    --outer-ring-length: 16px;
    --middle-ring-length: 12px;
    --inner-ring-length: 8px;
  }

  :host .ring > div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    border-radius: ${GDSERadiusPill};
    animation: progress-ring 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }

  :host([paused]) .ring > div {
    animation-play-state: paused;
  }

  :host .ring > div:nth-child(1) {
    animation-delay: -0.45s;
  }

  :host .ring > div:nth-child(2) {
    animation-delay: -0.3s;
  }

  :host .ring > div:nth-child(3) {
    animation-delay: -0.15s;
  }

  :host .outer-ring > div {
    left: calc(50% - var(--outer-ring-length) / 2);
    width: var(--outer-ring-length);
    height: var(--outer-ring-length);
    margin: 0px;
  }

  :host .middle-ring > div {
    width: var(--middle-ring-length);
    height: var(--middle-ring-length);
    margin-top: var(--margin-value);
    margin-left: var(--margin-value);
  }

  :host .inner-ring > div {
    width: var(--inner-ring-length);
    height: var(--inner-ring-length);
    margin-top: var(--margin-value);
    margin-left: var(--margin-value);
  }

  ${progressRingLightStyles}

  ${progressRingDarkStyles}
`, tm1ProgressRingTemplate = html`
  <template
    role="progressbar"
    value="${(td) => td.value || null}"
    max="${(td) => td.max || null}"
    min="${(td) => td.min !== void 0 ? td.min : null}"
    aria-valuenow="${(td) => td.value || 0}"
    aria-valuemin="${(td) => td.min || 0}"
    aria-valuemax="${(td) => td.max || 100}"
    aria-label="${(td) => td.ariaLabel}"
    theme="${(td) => td.theme}"
  >
    <div class="ring outer-ring">
      <div></div>
      <div></div>
      <div></div>
      <div class="ring middle-ring">
        <div></div>
        <div></div>
        <div></div>
        <div class="ring inner-ring">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </template>
`;
var __defProp$B = Object.defineProperty, __getOwnPropDesc$B = Object.getOwnPropertyDescriptor, __decorateClass$B = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$B(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$B(Ae, xr, id), id;
};
const ProgressRingSize = {
  xxsmall: "xxsmall",
  xsmall: "xsmall",
  small: "small",
  regular: "regular"
};
class ProgressRing extends BaseProgress {
  constructor() {
    super(...arguments), this.size = "regular", this.ariaLabel = "progress-ring", this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
}
__decorateClass$B([
  attr()
], ProgressRing.prototype, "size", 2);
__decorateClass$B([
  attr({ attribute: "aria-label" })
], ProgressRing.prototype, "ariaLabel", 2);
__decorateClass$B([
  observable
], ProgressRing.prototype, "theme", 2);
const tm1ProgressRing = ProgressRing.compose({
  baseName: "progress-ring",
  baseClass: BaseProgress,
  template: tm1ProgressRingTemplate,
  styles: tm1ProgressRingStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1ProgressRing()
);
const tm1EmptyStateStyles = () => css`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${GDSESpacing225};
  }

  .media-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info-container {
    text-align: center;
    display: inline-flex;
    flex-direction: column;
    gap: ${GDSESpacing50};
  }

  .action-container {
    display: flex;
    gap: ${GDSESpacing100};
  }

  .circle {
    background-color: ${GDSEColorBackgroundAlt};
    border-radius: ${GDSERadiusPill};
    width: 24px;
    height: 24px;
    padding: 12px;
  }

  .empty-action {
     display: none;
     visibility: hidden;
  }

  tm1-typography {
    color: ${GDSEColorText};
  }

  ::slotted(tm1-icon) {
    fill: ${GDSEColorTextLight};
    background-color: ${GDSEColorBackgroundAlt};
    border-radius: ${GDSERadiusPill};
  }

  ::slotted(tm1-icon[size="small"]) {
    padding: ${GDSESpacing100};
  }

  ::slotted(tm1-icon[size="regular"]) {
    padding: ${GDSESpacing150};
  }

  ::slotted(tm1-icon[size="large"]) {
    padding: ${GDSESpacing300};
  }
`, tm1EmptyStateTemplate = (td) => html`
  ${when((Ae) => Ae.variant === "no-result", html`
    <slot name="icon" ${slotted("iconSlot")}></slot>
    ${when((Ae) => !Ae.hasIcon(), html`<slot class="media-container" name="media" data-testid="media-container"></slot>`)}
  `)}
  ${when((Ae) => Ae.variant === "loading", html`
    <div class="loading-container">
      <${td.tagFor(ProgressRing)} class="circle" size="xsmall"></${td.tagFor(ProgressRing)}>
    </div>
  `)}
  <div class="info-container">
    <${td.tagFor(Typography)} type="heading-s">${(Ae) => Ae.title}</${td.tagFor(Typography)}>
    <${td.tagFor(Typography)} type="body-m">${(Ae) => Ae.subtitle}</${td.tagFor(Typography)}>
  </div>
  <slot class="action-container ${(Ae) => Ae.hasAction() ? "" : "empty-action"}" name="action" ${slotted("actionSlot")} data-testid="action-container"></slot>
`;
var __defProp$A = Object.defineProperty, __getOwnPropDesc$A = Object.getOwnPropertyDescriptor, __decorateClass$A = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$A(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$A(Ae, xr, id), id;
};
const EmptyStateVariant = {
  noResult: "no-result",
  loading: "loading"
};
class EmptyState extends FoundationElement {
  constructor() {
    super(...arguments), this.variant = "no-result", this.iconSlot = [], this.actionSlot = [], this.hasIcon = () => {
      var Ae;
      return ((Ae = this.iconSlot) == null ? void 0 : Ae.length) !== 0;
    }, this.hasAction = () => {
      var Ae;
      return ((Ae = this.actionSlot) == null ? void 0 : Ae.length) !== 0;
    }, this.deprecated = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.deprecated = features.isEnabled(this, "prd3267-deprecated-design-system");
  }
  iconSlotChanged() {
    this.deprecated && this.iconSlot.length !== 0 && console.warn('icon slot is deprecated, please use "media" instead');
  }
}
__decorateClass$A([
  attr
], EmptyState.prototype, "title", 2);
__decorateClass$A([
  attr
], EmptyState.prototype, "subtitle", 2);
__decorateClass$A([
  attr
], EmptyState.prototype, "variant", 2);
__decorateClass$A([
  observable
], EmptyState.prototype, "iconSlot", 2);
__decorateClass$A([
  observable
], EmptyState.prototype, "actionSlot", 2);
const tm1EmptyState = EmptyState.compose({
  baseName: "empty-state",
  template: tm1EmptyStateTemplate,
  styles: tm1EmptyStateStyles
});
designSystem.register(
  tm1EmptyState()
);
const tm1FileUploadItemStyles = i$2`
  :host {
    border: 1px solid var(--gdse-s-color-border);
    background: var(--gdse-s-color-background);
    padding: var(--gdse-g-spacing-100) var(--gdse-g-spacing-150);
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  :host([state='error']) {
    border-color: var(--gdse-s-color-border-critical);
  }

  :host([state='loading']) .name {
    max-width: 190px;
  }

  :host([state='success']) .name {
    max-width: 170px;
  }

  tm1-progress-ring {
    width: 16px;
  }

  .name {
    word-wrap: break-word;
  }

  .state-container {
    display: flex;
    align-items: center;
    gap: var(--gdse-g-spacing-100);
  }
`;
var __defProp$z = Object.defineProperty, __getOwnPropDesc$z = Object.getOwnPropertyDescriptor, __decorateClass$z = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$z(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$z(Ae, xr, id), id;
};
const FileUploadItemState = {
  loading: "loading",
  success: "success",
  error: "error"
}, h0 = class h0 extends h {
  constructor() {
    super(...arguments), this.state = FileUploadItemState.loading, this.cancelText = "Cancel", this.deleteText = "Delete";
  }
  render() {
    return ke$1`
      <tm1-typography type="body-m" class="name">
        ${this.fileName}
      </tm1-typography>

      <div class="state-container">
        ${nn(this.state === FileUploadItemState.loading, () => ke$1`
          <tm1-progress-ring size="xxsmall" data-testid="progress-ring"></tm1-progress-ring>
          <tm1-button variant="lightweight" @click=${() => emit(this, "cancel", this)} size="small">${this.cancelText}</tm1-button>
        `)}

        ${nn(this.state === FileUploadItemState.success, () => ke$1`
          <tm1-icon icon="success" size="small" data-testid="success-icon"></tm1-icon>
          <tm1-button variant="lightweight" @click=${() => emit(this, "delete", this)} iconPosition="before" icon="delete" size="small">${this.deleteText}</tm1-button>
        `)}

        ${nn(this.state === FileUploadItemState.error, () => ke$1`
          <tm1-icon icon="error" size="small" data-testid="error-icon"></tm1-icon>
        `)}
      </div>
    `;
  }
};
h0.styles = tm1FileUploadItemStyles;
let FileUploadItem = h0;
__decorateClass$z([
  n({ attribute: "file-name" })
], FileUploadItem.prototype, "fileName", 2);
__decorateClass$z([
  n({ reflect: !0 })
], FileUploadItem.prototype, "state", 2);
__decorateClass$z([
  n({ attribute: "cancel-text" })
], FileUploadItem.prototype, "cancelText", 2);
__decorateClass$z([
  n({ attribute: "delete-text" })
], FileUploadItem.prototype, "deleteText", 2);
customElements.get("tm1-file-upload-item") || customElements.define("tm1-file-upload-item", FileUploadItem);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let td = 0; td < 256; ++td)
  byteToHex.push((td + 256).toString(16).slice(1));
function unsafeStringify(td, Ae = 0) {
  return byteToHex[td[Ae + 0]] + byteToHex[td[Ae + 1]] + byteToHex[td[Ae + 2]] + byteToHex[td[Ae + 3]] + "-" + byteToHex[td[Ae + 4]] + byteToHex[td[Ae + 5]] + "-" + byteToHex[td[Ae + 6]] + byteToHex[td[Ae + 7]] + "-" + byteToHex[td[Ae + 8]] + byteToHex[td[Ae + 9]] + "-" + byteToHex[td[Ae + 10]] + byteToHex[td[Ae + 11]] + byteToHex[td[Ae + 12]] + byteToHex[td[Ae + 13]] + byteToHex[td[Ae + 14]] + byteToHex[td[Ae + 15]];
}
const randomUUID = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(td, Ae, xr) {
  if (native.randomUUID && !Ae && !td)
    return native.randomUUID();
  td = td || {};
  const ed = td.random || (td.rng || rng)();
  if (ed[6] = ed[6] & 15 | 64, ed[8] = ed[8] & 63 | 128, Ae) {
    xr = xr || 0;
    for (let id = 0; id < 16; ++id)
      Ae[xr + id] = ed[id];
    return Ae;
  }
  return unsafeStringify(ed);
}
const tm1FileUploadStyles = i$2`
  :host {
    width: 100%;
    height: 100%;
  }

  #file-upload {
    max-width: 300px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--gdse-g-spacing-100);
    margin-bottom: var(--gdse-g-spacing-200);
  }

  .icon-container {
    background-color: var(--gdse-s-color-background-alt);
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--gdse-s-radius-pill)
  }

  .subtitle {
    color: var(--gdse-s-color-text-light);
    text-align: center;
  }

  .drop-space {
    display: flex;
    padding: var(--gdse-g-spacing-250);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--gdse-g-spacing-200);
    align-self: stretch;
    border-radius: var(--gdse-g-border-radius-50);
    border: 1px dashed var(--gdse-s-color-border-input-default);
    background: var(--gdse-s-color-background-alt);
    height: 134px;
  }

  .drop-space.focus {
    border-color: var(--gdse-s-color-border-primary);
    background: var(--gdse-s-color-fill-primary-hovered-light);
  }

  .drag-drop {
    text-align: center;
  }

  .drop-text {
    color: var(--gdse-s-color-text-primary);
  }

  .files-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .files-container tm1-file-upload-item:first-child {
    margin-top: var(--gdse-g-spacing-200);
  }

  .files-container tm1-file-upload-item:not(:last-child):not([state='error']) {
    border-bottom: none;
  }

  .error {
    color: var(--gdse-s-color-text-critical);
    margin-top: var(--gdse-g-spacing-100);
    width: 100%;
  }
`;
var __defProp$y = Object.defineProperty, __getOwnPropDesc$y = Object.getOwnPropertyDescriptor, __decorateClass$y = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$y(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$y(Ae, xr, id), id;
};
const FileUploadVariant = {
  default: "default",
  "upload-only": "upload-only"
}, FileUploadErrorType = {
  size: "size",
  type: "type"
}, u0 = class u0 extends h {
  constructor() {
    super(...arguments), this.variant = FileUploadVariant.default, this.title = "Upload Your File", this.actionText = "Add File", this.dropText = "Drop Your File Here", this.cancelText = "Cancel", this.deleteText = "Delete", this.state = "default", this.hasError = !0, this.fileItems = [], this.files = [], this.fileItemsContainer = ii();
  }
  connectedCallback() {
    super.connectedCallback(), this.input = document.createElement("input"), this.input.type = "file", this.input.onchange = () => {
      var xr;
      const Ae = (xr = this.input.files) == null ? void 0 : xr[0];
      this.uploadFile(Ae);
    }, document.addEventListener("dragenter", (Ae) => {
      Ae.preventDefault(), this.state = "focus";
    }, !1), document.addEventListener("dragleave", () => this.state = "default", !1), document.addEventListener("drop", (Ae) => {
      var ed;
      Ae.preventDefault(), this.state = "default";
      const xr = (ed = Ae.dataTransfer) == null ? void 0 : ed.files[0];
      this.uploadFile(xr);
    }, !1), document.addEventListener("dragover", (Ae) => {
      Ae.preventDefault(), this.state = "focus";
    }, !1);
  }
  uploadFile(Ae) {
    var nd, cd, ud, ld;
    const xr = new FileReader();
    xr.readAsDataURL(Ae);
    const ed = v4(), id = document.createElement("tm1-file-upload-item");
    setAttributes(id, { "file-name": Ae.name, id: ed, "cancel-text": this.cancelText, "delete-text": this.deleteText }), id.addEventListener("delete", (dd) => this.handleDelete(dd), !1), id.addEventListener("cancel", (dd) => this.handleCancel(xr, dd), !1), (nd = this.fileItemsContainer.value) == null || nd.prepend(id), this.fileItems = Array.from((ud = (cd = this.fileItemsContainer.value) == null ? void 0 : cd.children) != null ? ud : []);
    let od = null;
    const ad = (ld = this.fileType) == null ? void 0 : ld.split(","), rd = !!this.maxSize && Ae.size > this.maxSize, sd = !!this.fileType && !(ad != null && ad.find((dd) => Ae.type.includes(dd)));
    this.hasError = this.hasError && (rd || sd), rd && sd ? od = { file: Ae, error: "all" } : rd ? od = { file: Ae, error: "size" } : sd && (od = { file: Ae, error: "type" }), xr.onloadstart = () => {
      this.fileItems[0] && (this.fileItems[0].state = FileUploadItemState.loading);
    }, xr.onloadend = () => {
      this.fileItems[0] && (rd || sd ? this.fileItems[0].state = FileUploadItemState.error : (this.fileItems[0].state = FileUploadItemState.success, this.files.push({ file: Ae, id: ed }), emit(this, "change", this.files.map((dd) => dd.file))));
    }, xr.onerror = () => {
      this.fileItems[0] && (this.fileItems[0].state = FileUploadItemState.error);
    }, this.fileWithError !== od && (emit(this, "error", od), this.fileWithError = od);
  }
  handleDelete(Ae) {
    var xr, ed;
    Ae.detail.remove(), this.files = this.files.filter((id) => id.id !== Ae.detail.id), this.fileItems = Array.from((ed = (xr = this.fileItemsContainer.value) == null ? void 0 : xr.children) != null ? ed : []), emit(this, "change", this.files.map((id) => id.file));
  }
  handleCancel(Ae, xr) {
    Ae.abort(), this.handleDelete(xr);
  }
  render() {
    return ke$1`
      <div id="file-upload">
        ${nn(this.variant === FileUploadVariant.default, () => ke$1`
          <div class="intro" data-testid="intro">
            <div class="icon-container">
              <tm1-icon icon="file" color="var(--gdse-s-color-fill-loading)" />
            </div>
            <tm1-typography type="heading-s">${this.title}</tm1-typography>
            <tm1-typography type="body-m" class="subtitle">${this.subtitle}</tm1-typography>
          </div>
        `)}

        <div class="drop-space ${this.state}" data-testid="drop-space">
          ${nn(this.state === "default", () => ke$1`
            <tm1-typography type="body-m" class="drag-drop">${this.dragDropText}</tm1-typography>
            <tm1-button variant="outline" @click=${() => this.input.click()} aria-controls="file-upload">${this.actionText}</tm1-button>
          `)}

          ${nn(this.state === "focus", () => ke$1`
            <tm1-typography type="heading-s" class="drop-text">${this.dropText}</tm1-typography>
          `)}
        </div>

        <slot class="files-container" ${Kt(this.fileItemsContainer)}></slot>

        ${nn(!!this.fileWithError, () => ke$1`
          <tm1-typography class="error" type="body-m">${this.error}</tm1-typography>
        `)}
      </div>
    `;
  }
};
u0.styles = tm1FileUploadStyles;
let FileUpload = u0;
__decorateClass$y([
  n()
], FileUpload.prototype, "variant", 2);
__decorateClass$y([
  n()
], FileUpload.prototype, "title", 2);
__decorateClass$y([
  n({ attribute: "max-size" })
], FileUpload.prototype, "maxSize", 2);
__decorateClass$y([
  n({ attribute: "file-type" })
], FileUpload.prototype, "fileType", 2);
__decorateClass$y([
  n()
], FileUpload.prototype, "subtitle", 2);
__decorateClass$y([
  n({ attribute: "drag-drop-text" })
], FileUpload.prototype, "dragDropText", 2);
__decorateClass$y([
  n({ attribute: "action-text" })
], FileUpload.prototype, "actionText", 2);
__decorateClass$y([
  n({ attribute: "drop-text" })
], FileUpload.prototype, "dropText", 2);
__decorateClass$y([
  n({ attribute: "cancel-text" })
], FileUpload.prototype, "cancelText", 2);
__decorateClass$y([
  n({ attribute: "delete-text" })
], FileUpload.prototype, "deleteText", 2);
__decorateClass$y([
  n()
], FileUpload.prototype, "error", 2);
__decorateClass$y([
  r()
], FileUpload.prototype, "state", 2);
__decorateClass$y([
  r()
], FileUpload.prototype, "hasError", 2);
__decorateClass$y([
  r()
], FileUpload.prototype, "fileItems", 2);
__decorateClass$y([
  r()
], FileUpload.prototype, "files", 2);
__decorateClass$y([
  r()
], FileUpload.prototype, "input", 2);
__decorateClass$y([
  r()
], FileUpload.prototype, "fileWithError", 2);
customElements.get("tm1-file-upload") || customElements.define("tm1-file-upload", FileUpload);
const tm1GridStyles = css`
  :host {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  :host ::slotted(.col-1) {
    grid-column: auto / span 1;
  }

  :host ::slotted(.col-2) {
    grid-column: auto / span 2;
  }

  :host ::slotted(.col-3) {
    grid-column: auto / span 3;
  }

  :host ::slotted(.col-4) {
    grid-column: auto / span 4;
  }

  :host ::slotted(.col-5) {
    grid-column: auto / span 5;
  }

  :host ::slotted(.col-6) {
    grid-column: auto / span 6;
  }

  :host ::slotted(.col-7) {
    grid-column: auto / span 7;
  }

  :host ::slotted(.col-8) {
    grid-column: auto / span 8;
  }

  :host ::slotted(.col-9) {
    grid-column: auto / span 9;
  }

  :host ::slotted(.col-10) {
    grid-column: auto / span 10;
  }

  :host ::slotted(.col-11) {
    grid-column: auto / span 11;
  }

  :host ::slotted(.col-12) {
    grid-column: auto / span 12;
  }

  :host ::slotted(.row-1) {
    grid-row: auto / span 1;
  }

  :host ::slotted(.row-2) {
    grid-row: auto / span 2;
  }

  :host ::slotted(.row-3) {
    grid-row: auto / span 3;
  }

  :host ::slotted(.row-4) {
    grid-row: auto / span 4;
  }

  :host ::slotted(.row-5) {
    grid-row: auto / span 5;
  }

  :host ::slotted(.row-6) {
    grid-row: auto / span 6;
  }

  :host ::slotted(.row-7) {
    grid-row: auto / span 7;
  }

  :host ::slotted(.row-8) {
    grid-row: auto / span 8;
  }

  :host ::slotted(.row-9) {
    grid-row: auto / span 9;
  }

  :host ::slotted(.row-10) {
    grid-row: auto / span 10;
  }

  :host ::slotted(.row-11) {
    grid-row: auto / span 11;
  }

  :host ::slotted(.row-12) {
    grid-row: auto / span 12;
  }

  @media (min-width: 600px) and (max-width: 768px) {
    :host {
      gap: 20px;
      margin: 0 30px;
    }
  }

  @media (min-width: 769px) and (max-width: 1440px) {
    :host {
      gap: 32px;
      margin: 0 80px;
    }
  }

  @media (min-width: 1441px) {
    :host {
      gap: 40px;
      margin: 0 120px;
    }
  }
`, tm1GridTemplate = () => html`<template>
  <slot></slot>
  </template>`, GridColumns = {
  "col-1": "col-1",
  "col-2": "col-2",
  "col-3": "col-3",
  "col-4": "col-4",
  "col-5": "col-5",
  "col-6": "col-6",
  "col-7": "col-7",
  "col-8": "col-8",
  "col-9": "col-9",
  "col-10": "col-10",
  "col-11": "col-11",
  "col-12": "col-12"
}, GridRows = {
  "row-1": "row-1",
  "row-2": "row-2",
  "row-3": "row-3",
  "row-4": "row-4",
  "row-5": "row-5",
  "row-6": "row-6",
  "row-7": "row-7",
  "row-8": "row-8",
  "row-9": "row-9",
  "row-10": "row-10",
  "row-11": "row-11",
  "row-12": "row-12"
};
class Grid extends FoundationElement {
}
const tm1Grid = Grid.compose({
  baseName: "grid",
  template: tm1GridTemplate,
  styles: tm1GridStyles
});
designSystem.register(
  tm1Grid()
);
const tm1InsightStyles = () => css`
  :host {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    container-type: inline-size;
    color: ${GDSEColorText};
  }

  .header {
    margin-bottom: ${GDSESpacing200};
  }

  tm1-icon {
    margin-right: ${GDSESpacing150};
  }

  .title {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .subtitle-section {
    margin-top: ${GDSESpacing100};
  }

  .number {
    margin-right: ${GDSESpacing100};
  }

  .actions {
    display: flex;
    height: max-content;
  }

  .actions tm1-button:not(:last-child) {
    margin-right: ${GDSESpacing100};
  }

  @container (max-width: 375px) {
    .actions {
      display: flex;
      width: 100%;
    }

    .actions tm1-button {
      flex: 1;
    }
  }
`, tm1InsightTemplate = (td) => html`
<template data-testid="insight">
  <div class="header" >
    <div class="title">
      ${when(
  (Ae) => Ae.type && Ae.type !== "neutral",
  html`
          <${td.tagFor(Icon)}
            icon="statusArrow${(Ae) => firstLetterUppercase(Ae.type || "")}"
            color="var(--gdse-s-color-fill-${(Ae) => Ae.type === "neutral" ? "negative" : Ae.type})"
          >
          </${td.tagFor(Icon)}>
        `
)}
      ${when(
  (Ae) => (typeof Ae.number == "string" || "number") && Ae.number !== "",
  html`
      <${td.tagFor(Typography)}
        type="statement-l"
        class="number"
        style="color: var(--gdse-s-color-fill-${(Ae) => Ae.type === "neutral" ? "negative" : Ae.type});"
      >
        ${(Ae) => Ae.number}
      </${td.tagFor(Typography)}>`
)}
      <${td.tagFor(Typography)} type="statement-l"><slot name="title"></slot></${td.tagFor(Typography)}>
    </div>
    <${td.tagFor(Typography)} type="statement-l"><slot name="second-title"></slot></${td.tagFor(Typography)}>
    <${td.tagFor(Typography)} type="statement-subtext-l"><slot name="subtitle"></slot></${td.tagFor(Typography)}>
  </div>

  <div class="actions">
    <slot name="actions"></slot>
    ${when(
  (Ae) => !!Ae.actions.length,
  html`${repeat(
    (Ae) => Ae.actions,
    html`
          <${td.tagFor(Button)}
            variant="${(Ae) => Ae.secondary ? "outline" : "solid"}"
            @click="${(Ae) => Ae.action()}"
            ?disabled="${(Ae) => Ae.disabled}"
            ?isLoading="${(Ae) => Ae.isLoading}"
            icon="${(Ae) => Ae.icon || ""}"
            iconPosition="${(Ae) => Ae.iconPosition || ""}"
          >
            ${(Ae) => Ae.text}
          </${td.tagFor(Button)}>`
  )}`
)}
  </div>
</template>
`;
var __defProp$x = Object.defineProperty, __getOwnPropDesc$x = Object.getOwnPropertyDescriptor, __decorateClass$x = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$x(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$x(Ae, xr, id), id;
};
class Insight extends FoundationElement {
  constructor() {
    super(...arguments), this.actions = [];
  }
}
__decorateClass$x([
  attr()
], Insight.prototype, "type", 2);
__decorateClass$x([
  attr()
], Insight.prototype, "number", 2);
__decorateClass$x([
  attr()
], Insight.prototype, "actions", 2);
const tm1Insight = Insight.compose({
  baseName: "insight",
  template: tm1InsightTemplate,
  styles: tm1InsightStyles
});
designSystem.register(
  tm1Insight()
);
const mobileStylesheetBehavior$1 = new MatchMediaStyleSheetBehavior(
  matchMedia("(max-width: 767px)"),
  css`
    .stat-title {
      justify-content: space-between;
    }
  `
), tm1StatStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    gap: ${GDSESpacing50};
    font-family: ${GDSEFontFamily};
    color: ${GDSEColorText};
  }

  :host([data-theme="dark"]) {
    gap: ${GDSESpacing150};
  }

  :host([data-theme="dark"]) .stat-title {
    gap: ${GDSESpacing150};
  }

  .stat-title {
    gap: ${GDSESpacing100};
    display: flex;
    align-items: center;
    height: 10px;
    color: ${GDSEColorText};
    justify-content: flex-start;

    @media screen and (max-width: 550px) {
      justify-content: flex-end;
    }
  }

  .stat-content {
    gap: ${GDSESpacing300};
  }

  .stat-actions {
    display: flex;
    align-items: center;
    color: ${GDSEColorTextLight};
  }

  .hidden {
    display: none;
  }
`.withBehaviors(mobileStylesheetBehavior$1), tm1StatTemplate = (td) => html`
  <template data-theme=${(Ae) => Ae.theme}>
    <div class="stat-title">
        <${td.tagFor(Typography)} class="stat-title-name" type=${(Ae) => Ae.headerTypographyType}>
          <slot name="title">
            ${(Ae) => Ae.header}
          </slot>
        </${td.tagFor(Typography)}>
        <div class="stat-actions">
          <slot name="actions"></slot>
        </div>
      </div>
      <${td.tagFor(Typography)} class="${(Ae) => Ae.contentClasses()}" type=${(Ae) => Ae.bodyTypographyType}>
        <slot ${slotted("defaultSlottedContent")}></slot>
      </${td.tagFor(Typography)}>
  </template>
`;
var __defProp$w = Object.defineProperty, __getOwnPropDesc$w = Object.getOwnPropertyDescriptor, __decorateClass$w = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$w(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$w(Ae, xr, id), id;
};
const StatSizes = {
  medium: "medium",
  large: "large"
};
class Stat extends FoundationElement {
  constructor() {
    super(...arguments), this.header = "", this.defaultSlottedContent = [], this.size = StatSizes.medium, this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this.contentClasses = () => this.defaultSlottedContent.length !== 0 ? "stat-content" : "stat-content hidden";
  }
  get headerTypographyType() {
    return this.theme === ThemeType.dark ? "label-container-s" : this.size === StatSizes.large ? "label-status-m" : "label-data-regular";
  }
  get bodyTypographyType() {
    return this.theme === ThemeType.dark ? "data-xl" : this.size === StatSizes.large ? "data-l" : "data-m";
  }
}
__decorateClass$w([
  attr()
], Stat.prototype, "header", 2);
__decorateClass$w([
  observable
], Stat.prototype, "defaultSlottedContent", 2);
__decorateClass$w([
  attr()
], Stat.prototype, "size", 2);
__decorateClass$w([
  observable
], Stat.prototype, "theme", 2);
const tm1Stat = Stat.compose({
  baseName: "stat",
  template: tm1StatTemplate,
  styles: tm1StatStyles
});
designSystem.register(
  tm1Stat()
);
const tm1InsightCardHeaderStyles = css`
  :host {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title {
    color: ${GDSEColorTextLight};
  }

  .header,
  .icons {
    display: flex;
    align-items: center;
  }

  .actions {
    display: flex;
  }

  ::slotted([slot='actions']),
  ::slotted([slot='info']) {
    margin-left: ${GDSESpacing100};
  }
`, tm1InsightCardHeaderTemplate = () => html`
  <template>
    <div class="header">
      <tm1-typography type="label-container-l" class="title"><slot></slot></tm1-typography>
      <div class="icons"><slot name="info"></slot></div>
    </div>
    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </template>
`;
class InsightCardHeader extends FoundationElement {
}
const tm1InsightCardHeader = InsightCardHeader.compose({
  baseName: "insight-card-header",
  template: tm1InsightCardHeaderTemplate,
  styles: tm1InsightCardHeaderStyles
}), mobileStylesheetBehavior = new MatchMediaStyleSheetBehavior(
  matchMedia("(max-width: 767px)"),
  css`
    :host {
      gap: ${GDSESpacing600};
    }
  `
), tm1InsightCardStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    gap: ${GDSESpacing500};
    font-family: ${GDSEFontFamily};
    background-color: ${GDSEColorSurfaceCard};
    padding: ${GDSESpacing300};
    border-radius: ${GDSERadiusSurface};
  }

  :host([theme='legacy']),
  :host([theme='light']) {
    box-shadow: none;
    border: 1px solid ${GDSEColorBorder};
  }

  .header::slotted {
    gap: ${GDSESpacing300};
  }

  .content {
    display: flex;
    align-items: center;
    align-self: stretch;
    font-family: ${GDSEFontFamily};
    color: ${GDSEColorText};
  }

  .header {
    width: 100%;
  }
`.withBehaviors(mobileStylesheetBehavior), tm1InsightCardTemplate = (td) => html`
  <template theme=${(Ae) => Ae.theme}>
    <div class="header">
      <slot name="header">
        <${td.tagFor(Stat)} header=${(Ae) => Ae.header} data-testid="tm1-stat"></${td.tagFor(Stat)}>
      </slot>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </template>
`;
var __defProp$v = Object.defineProperty, __getOwnPropDesc$v = Object.getOwnPropertyDescriptor, __decorateClass$v = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$v(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$v(Ae, xr, id), id;
};
class InsightCard extends FoundationElement {
  constructor() {
    super(...arguments), this.header = "", this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
}
__decorateClass$v([
  attr()
], InsightCard.prototype, "header", 2);
__decorateClass$v([
  observable
], InsightCard.prototype, "theme", 2);
const tm1InsightCard = InsightCard.compose({
  baseName: "insight-card",
  template: tm1InsightCardTemplate,
  styles: tm1InsightCardStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1InsightCardHeader(),
  tm1InsightCard()
);
const tm1ListItemStyles = i$2`
:host {
  box-sizing: border-box;
  color: var(--gdse-s-color-text);
  background-color: var(--gdse-s-color-fill-input);
  cursor: pointer;
  fill: currentcolor;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  margin: 0;
  outline: none;
  overflow: hidden;
  padding:  var(--padding, var(--gdse-s-spacing-list-ver-s) var(--gdse-s-spacing-list-hor-s));
  user-select: none;
  white-space: nowrap;
  pointer-events: auto;
}

:host([hidden]) {
  display: none;
}

:host(:active),
:host(:focus),
:host(:focus-visible) {
  box-shadow: 0 0 0 2px inset var(--focus-stroke-inner);
  background: var(--gdse-s-color-surface-pressed);
}

:host(:not([disabled])[selected][aria-selected="true"]:hover) ::part(control) {
  background: var(--gdse-s-color-fill-primary-hovered);
  border-color: var(--gdse-s-color-fill-primary-hovered);
}

:host(:not([disabled]):active),
:host(:not([selected]):active) {
  background: var(--gdse-s-color-surface-pressed);
}

:host([aria-checked="true"][checked]:not([disabled])),
:host([aria-selected="true"][selected]:not([disabled])) {
  background: var(--gdse-s-color-surface-selected);
}

:host(:not([disabled]):hover),
:host(:not([disabled]):not([selected]):hover),
:host([selected]:not([checked]):hover),
:host([aria-selected="true"]:not([disabled]):hover),
:host([aria-checked="true"][aria-selected="false"]:not([disabled]):hover),
:host([hovered]:not([disabled])) {
  background: var(--gdse-s-color-surface-hovered);
}

:host([disabled]) {
  cursor: not-allowed;
  color: var(--gdse-s-color-text-disabled);
  pointer-events: none;
}

.container {
  display: flex;
  align-items: center;
  width: 100%;
}

.check-icon {
  margin-left: var(--gdse-g-spacing-100);
}

:host([align-top]) .container,
:host([alignTop]) .container {
  align-items: flex-start;
}

:host(:not([align-top])) tm1-checkbox,
:host(:not([alignTop])) tm1-checkbox {
  padding-top: 0;
}

:host tm1-checkbox {
  max-width: 16px;
  padding-right: var(--gdse-g-spacing-125);
}

:host tm1-typography {
  width: 100%;
}

.content {
  grid-column-start: 2;
  justify-self: start;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.start,
.end,
::slotted(svg) {
  display: flex;
}

::slotted(svg) {
  height: 16px;
  width: 16px;
}

::slotted([slot='end']) {
  margin-inline-start: 1ch;
}

::slotted([slot='start']) {
  margin-inline-end: 1ch;
}
`;
var __defProp$u = Object.defineProperty, __getOwnPropDesc$u = Object.getOwnPropertyDescriptor, __decorateClass$u = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$u(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$u(Ae, xr, id), id;
}, Wp;
let ListItem$1 = (Wp = class extends h {
  constructor(Ae, xr, ed) {
    var id;
    super(), this.alignTop = !1, this.ariaPosInSet = null, this.ariaSetSize = null, this.multiple = !1, this.initialValue = void 0, this.role = "option", this._value = void 0, this._ariaChecked = "false", this._ariaSelected = "false", this._ariaDisabled = "false", this.dirtyValue = !1, this.contentElement = ii(), Ae && (this.textContent = Ae), xr && (this.initialValue = xr), ed && (this.selected = ed), this.proxy = new Option(
      `${this.textContent}`,
      this.initialValue,
      this.selected
    ), this.proxy.disabled = (id = this.disabled) != null ? id : !1;
  }
  get label() {
    var Ae;
    return (Ae = this.value) != null ? Ae : this.text;
  }
  get text() {
    var Ae, xr;
    return (xr = (Ae = this.textContent) == null ? void 0 : Ae.replace(/\s+/g, " ").trim()) != null ? xr : "";
  }
  set value(Ae) {
    const xr = `${Ae != null ? Ae : ""}`;
    this._value = xr, this.dirtyValue = !0, this.proxy instanceof HTMLOptionElement && (this.proxy.value = xr);
  }
  get value() {
    var Ae;
    return (Ae = this._value) != null ? Ae : this.text;
  }
  get form() {
    return this.proxy ? this.proxy.form : null;
  }
  get ariaChecked() {
    var Ae, xr;
    return (xr = this._ariaChecked || ((Ae = this.checked) == null ? void 0 : Ae.toString())) != null ? xr : "false";
  }
  set ariaChecked(Ae) {
    this._ariaChecked !== Ae && (this._ariaChecked = Ae);
  }
  get ariaDisabled() {
    var Ae, xr;
    return (xr = this._ariaDisabled || ((Ae = this.disabled) == null ? void 0 : Ae.toString())) != null ? xr : "false";
  }
  set ariaDisabled(Ae) {
    this._ariaDisabled !== Ae && (this._ariaDisabled = Ae);
  }
  get ariaSelected() {
    var Ae, xr;
    return (xr = this._ariaSelected || ((Ae = this.selected) == null ? void 0 : Ae.toString())) != null ? xr : "false";
  }
  set ariaSelected(Ae) {
    this._ariaSelected !== Ae && (this._ariaSelected = Ae);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", this.handleClick, !1);
  }
  updated(Ae) {
    super.updated(Ae), Array.from(Ae).forEach((xr) => {
      switch (xr[0]) {
        case "disabled":
          this.disabledChanged();
          break;
        case "checked":
          this.checkedChanged();
          break;
        case "selected":
          this.selectedChanged();
          break;
        case "role":
          this.setAttribute("role", "option");
          break;
      }
    });
  }
  disabledChanged() {
    var Ae, xr, ed, id;
    this.ariaDisabled = (xr = (Ae = this.disabled) == null ? void 0 : Ae.toString()) != null ? xr : "false", setAttributes(this, {
      "aria-disabled": (ed = this.ariaDisabled) != null ? ed : "false",
      disabled: this.disabled
    }), this.proxy instanceof HTMLOptionElement && (this.proxy.disabled = (id = this.disabled) != null ? id : !1);
  }
  checkedChanged() {
    var Ae, xr, ed;
    this.ariaChecked = (xr = (Ae = this.checked) == null ? void 0 : Ae.toString()) != null ? xr : "false", setAttributes(this, {
      "aria-checked": (ed = this.ariaChecked) != null ? ed : "false",
      checked: this.checked
    }), emit(this, "change", this.checked);
  }
  selectedChanged() {
    var Ae, xr, ed, id;
    this.ariaSelected = (xr = (Ae = this.selected) == null ? void 0 : Ae.toString()) != null ? xr : "false", setAttributes(this, {
      "aria-selected": (ed = this.ariaSelected) != null ? ed : "false",
      selected: this.selected
    }), this.proxy instanceof HTMLOptionElement && (this.proxy.selected = (id = this.selected) != null ? id : !1), emit(this, "change", this.selected);
  }
  slottedContentChanged() {
    this.proxy instanceof HTMLOptionElement && (this.proxy.textContent = this.textContent), emit(this, "contentchange", null);
  }
  getTextContent() {
    var Ae;
    return (Ae = this.proxy.textContent) != null ? Ae : "";
  }
  handleClick() {
    this.multiple ? this.selected = !this.selected : Array.from(this.children).find((xr) => xr.nodeName === "TM1-BUTTON" || xr.nodeName === "A") || (this.checked = !this.checked);
  }
  render() {
    return ke$1`
      <div class="container" data-testid="container">
        ${nn(this.multiple, () => ke$1`<tm1-checkbox
            ?checked=${this.selected}
            ?current-checked=${this.selected}
            size="small"
            ?disabled=${this.disabled}
            aria-labelledby="list-item-text">
          </tm1-checkbox>`)}

        <slot name="start" class="start"></slot>
          <span class="content" part="content">
            <tm1-typography type="body-l" id="list-item-text">
              <slot ${Kt(this.contentElement)} ${Kt(this.slottedContentChanged)}></slot>
            </tm1-typography>

            <tm1-typography type="body-m">
              ${this.secondaryText}
            </tm1-typography>
          </span>

        <slot name="end" class="end"></slot>
        ${nn(this.checked && !this.multiple, () => ke$1`<tm1-icon class="check-icon" icon="check" size="small" color="${this.disabled ? "var(--gdse-s-color-fill-disabled" : "var(--gdse-s-color-fill-primary"}"></tm1-icon>`)}
      </div>
    `;
  }
}, Wp.styles = tm1ListItemStyles, Wp);
__decorateClass$u([
  n({ attribute: "align-top", type: Boolean, reflect: !0 }),
  n({ attribute: "aligntop", type: Boolean, reflect: !0 })
], ListItem$1.prototype, "alignTop", 2);
__decorateClass$u([
  n({ attribute: "aria-posinset", reflect: !0 }),
  n({ attribute: "ariaposinset", reflect: !0 })
], ListItem$1.prototype, "ariaPosInSet", 2);
__decorateClass$u([
  n({ attribute: "aria-setsize", reflect: !0 }),
  n({ attribute: "ariasetsize", reflect: !0 })
], ListItem$1.prototype, "ariaSetSize", 2);
__decorateClass$u([
  n({ attribute: "secondary-text", reflect: !0 }),
  n({ attribute: "secondarytext", reflect: !0 })
], ListItem$1.prototype, "secondaryText", 2);
__decorateClass$u([
  n({ type: Boolean, reflect: !0 })
], ListItem$1.prototype, "disabled", 2);
__decorateClass$u([
  n({ type: Boolean, reflect: !0 })
], ListItem$1.prototype, "checked", 2);
__decorateClass$u([
  n({ type: Boolean, reflect: !0 })
], ListItem$1.prototype, "selected", 2);
__decorateClass$u([
  n({ type: Boolean, reflect: !0 })
], ListItem$1.prototype, "multiple", 2);
__decorateClass$u([
  n({ attribute: "value", reflect: !1 })
], ListItem$1.prototype, "initialValue", 2);
__decorateClass$u([
  n({ reflect: !0 })
], ListItem$1.prototype, "role", 2);
__decorateClass$u([
  r()
], ListItem$1.prototype, "proxy", 2);
__decorateClass$u([
  n({ attribute: "aria-checked", reflect: !0 }),
  n({ attribute: "ariachecked", reflect: !0 })
], ListItem$1.prototype, "ariaChecked", 1);
__decorateClass$u([
  n({ attribute: "aria-disabled", reflect: !0 })
], ListItem$1.prototype, "ariaDisabled", 1);
__decorateClass$u([
  n({ attribute: "aria-selected", reflect: !0 })
], ListItem$1.prototype, "ariaSelected", 1);
customElements.get("tm1-list-item") || customElements.define("tm1-list-item", ListItem$1);
const tm1ListItemsGroupStyles = i$2`
  slot {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
  }
`;
var __defProp$t = Object.defineProperty, __getOwnPropDesc$t = Object.getOwnPropertyDescriptor, __decorateClass$t = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$t(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$t(Ae, xr, id), id;
};
const p0 = class p0 extends h {
  constructor() {
    super(...arguments), this.label = "";
  }
  render() {
    return ke$1`<tm1-list-items-header label=${this.label}></tm1-list-items-header>
    <slot data-testid="list-items"></slot>`;
  }
};
p0.styles = tm1ListItemsGroupStyles;
let ListItemsGroup = p0;
__decorateClass$t([
  n()
], ListItemsGroup.prototype, "label", 2);
customElements.get("tm1-list-items-group") || customElements.define("tm1-list-items-group", ListItemsGroup);
const tm1ListItemsHeaderStyles = i$2`
  :host {
    cursor: default;
  }

  .label {
    padding:  var(--padding, var(--gdse-s-spacing-list-ver-s) var(--gdse-s-spacing-list-hor-s));
    color: var(--gdse-s-color-text-light);
    text-transform: uppercase;
  }
`;
var __defProp$s = Object.defineProperty, __getOwnPropDesc$s = Object.getOwnPropertyDescriptor, __decorateClass$s = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$s(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$s(Ae, xr, id), id;
};
const g0 = class g0 extends h {
  constructor() {
    super(...arguments), this.label = "";
  }
  render() {
    return ke$1`<tm1-typography type="label-container-m" class="label" data-testid="label">
      <label ?hidden="${!this.label}">${this.label}</label>
      <slot></slot>
    </tm1-typography>`;
  }
};
g0.styles = tm1ListItemsHeaderStyles;
let ListItemsHeader = g0;
__decorateClass$s([
  n()
], ListItemsHeader.prototype, "label", 2);
customElements.get("tm1-list-items-header") || customElements.define("tm1-list-items-header", ListItemsHeader);
class _NumberField extends FoundationElement {
}
class FormAssociatedNumberField extends FormAssociated(_NumberField) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("input");
  }
}
const tm1NumberFieldStyles = () => css`
  :host {
    outline: none;
    width: 100%;
    user-select: none;
    ${numberFieldSizeRegular}
  }

  .root {
    row-gap: ${GDSESpacing50};
    border-radius: ${GDSERadiusInput};
    border: 1px solid ${GDSEColorBorderInputDefault};
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: row;
    color: ${GDSEColorText};
    background: field;
    padding: var(--padding);
    height: var(--input-size);
    line-height: var(--line-height);
  }

  .control {
    outline: none;
    box-sizing: border-box;
    color: ${GDSEColorText};
    width: 100%;

    -webkit-appearance: none;
    background: transparent;
    border: ${GDSERadiusSharp};
    border: none;
    height: calc(100% - 4px);
  }

  :host([inputsize='small']) {
    ${numberFieldSizeSmall}
  }

  :host([inputsize='large']) {
    ${numberFieldSizeLarge}
  }

  .controls {
    opacity: 0;
  }

  :host(:not([disabled])[class~='invalid']) .root {
    border-color: ${GDSEColorBorderCritical} !important;
  }

  .label {
    display: block;
    cursor: pointer;
    margin-bottom: ${GDSESpacing25};

    color: ${GDSEColorText};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .label__hidden {
    display: none;
    visibility: hidden;
  }

  .start,
  .control,
  .controls,
  .end {
    align-self: center;
  }

  .start,
  .end {
    display: flex;
    margin: auto;
    fill: currentcolor;
  }

  .start {
    padding-right: 9px;
  }

  .end {
    padding-left: 9px;
  }

  .step-up-glyph,
  .step-down-glyph {
    display: block;
    padding: ${GDSESpacing50} ${GDSESpacing100};
    cursor: pointer;
  }

  .typography {
    width: 100%;
    align-self: center;
  }

  :host([inputsize='small']) .step-up-glyph,
  :host([inputsize='small']) .step-down-glyph {
    display: block;
    padding: ${GDSESpacing25} ${GDSESpacing100};
    cursor: pointer;
  }

  :host([inputsize='large']) .step-up-glyph,
  :host([inputsize='large']) .step-down-glyph {
    display: block;
    padding: ${GDSESpacing50} ${GDSESpacing150};
    cursor: pointer;
  }

  .step-up-glyph:before,
  .step-down-glyph:before {
    content: '';
    display: block;
    border: solid transparent 5px;
  }

  :host([inputsize='small']) .step-up-glyph:before,
  :host([inputsize='small']) .step-down-glyph:before {
    content: '';
    display: block;
    border: solid transparent 4px;
  }

  :host([inputsize='large']) .step-up-glyph:before,
  :host([inputsize='large']) .step-down-glyph:before {
    content: '';
    display: block;
    border: solid transparent 6px;
  }

  :host([inputsize='small']) .step-up-glyph:before,
  :host([inputsize='large']) .step-up-glyph:before,
  .step-up-glyph:before {
    border-bottom-color: ${GDSEColorTextMuted};
  }

  :host([inputsize='small']) .step-down-glyph:before,
  :host([inputsize='large']) .step-down-glyph:before,
  .step-down-glyph:before {
    border-top-color: ${GDSEColorTextMuted};
  }

  ::slotted(svg) {
    width: 16px;
    height: 16px;
  }

  :host(:hover:not([disabled])) .controls,
  :host(:focus-within:not([disabled])) .controls {
    opacity: 1;
  }

  :host([variant='filled']) .root {
    background: #ededed;
  }

  :host([variant='filled']:hover:not([disabled])) .root {
    background: #e5e5e5;
  }

  :host(:hover:not([disabled]):not([readonly])) .root {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host(:focus:not([disabled]):not([readonly])) .root {
    border-color: ${GDSEColorBorderInputActive};
  }

  :host([readonly]),
  :host([disabled]),
  :host([disabled]) .label,
  :host([readonly]) .label,
  :host([disabled]) .root,
  :host([readonly]) .root,
  :host([readonly]) .control,
  :host([disabled]) .control {
    cursor: not-allowed;
  }

  :host([readonly]) .root {
    border: none;
    background: transparent;
    padding: ${GDSESpacing0};
  }

  :host(:hover:not([disabled])) .controls,
  :host(:focus-within:not([disabled])) .controls {
    opacity: 1;
  }

  :host([disabled]) .root {
    border: 1px solid ${GDSEColorBorderInputDisabled};
    background-color: ${GDSEColorFillInputDisabled};
  }

  :host([disabled]) .control,
  :host([disabled]) .control::placeholder {
    color: ${GDSEColorTextDisabled};
  }

  :host input::placeholder {
    color: ${GDSEColorTextMuted};
  }

  .error {
    display: flex;
    align-items: center;
    margin-top: ${GDSESpacing25};
    gap: ${GDSESpacing50};
  }

  .error-label {
    margin-left: ${GDSESpacing50};
    color: ${GDSEColorFillCritical};
  }
`, numberFieldSizeSmall = cssPartial`
  --line-height: 21px;
  --input-size: 28px;
  --padding: ${GDSESpacingInputVerS} ${GDSESpacingInputHorS};
`, numberFieldSizeRegular = cssPartial`
  --line-height: 14px;
  --input-size: 36px;
  --padding: ${GDSESpacingInputVerM} ${GDSESpacingInputHorM};
`, numberFieldSizeLarge = cssPartial`
  --line-height: 24px;
  --input-size: 44px;
  --padding: ${GDSESpacingInputVerL} ${GDSESpacingInputHorL};
`, tm1NumberFieldTemplate = (td, Ae) => html`
  <template tabindex="0">
    ${when(
  (xr) => xr.hasLabel(),
  html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="label" data-testid="label">
        <label part="label" for="control">
          ${(xr) => xr.label ? xr.label : html`<slot ${slotted("defaultSlottedNodes")}></slot>`}
        </label>
      </${td.tagFor(Typography)}>`
)}

    <div class="root" part="root" data-testid="root">
      ${startSlotTemplate(td, Ae)}
      <${td.tagFor(Typography)} class="typography" data-testid="input-Typography" type="${(xr) => {
  var ed;
  return xr.textType()[(ed = xr.inputSize) != null ? ed : "regular"];
}}">
        <input
          class="control"
          id="control"
          part="control"
          aria-atomic="${(xr) => {
  var ed;
  return (ed = xr.ariaAtomic) != null ? ed : !1;
}}"
          aria-busy="${(xr) => {
  var ed;
  return (ed = xr.ariaBusy) != null ? ed : !1;
}}"
          aria-controls="${(xr) => {
  var ed;
  return (ed = xr.ariaControls) != null ? ed : "control";
}}"
          aria-current="${(xr) => {
  var ed;
  return (ed = xr.ariaCurrent) != null ? ed : null;
}}"
          aria-describedby="${(xr) => xr.ariaDescribedby}"
          aria-details="${(xr) => xr.ariaDetails}"
          aria-disabled="${(xr) => {
  var ed;
  return (ed = xr.ariaDisabled || xr.disabled) != null ? ed : !1;
}}"
          aria-flowto="${(xr) => xr.ariaFlowto}"
          aria-haspopup="${(xr) => {
  var ed;
  return (ed = xr.ariaHaspopup) != null ? ed : !1;
}}"
          aria-hidden="${(xr) => {
  var ed;
  return (ed = xr.ariaHidden) != null ? ed : !1;
}}"
          aria-invalid="${(xr) => {
  var ed;
  return (ed = xr.ariaInvalid) != null ? ed : null;
}}"
          aria-keyshortcuts="${(xr) => xr.ariaKeyshortcuts}"
          aria-label="${(xr) => {
  var ed;
  return (ed = xr.ariaLabel || xr.label) != null ? ed : "";
}}"
          aria-labelledby="${(xr) => xr.ariaLabelledby}"
          aria-live="${(xr) => {
  var ed;
  return (ed = xr.ariaLive) != null ? ed : !1;
}}"
          aria-owns="${(xr) => xr.ariaOwns}"
          aria-relevant="${(xr) => {
  var ed;
  return (ed = xr.ariaRelevant) != null ? ed : "additions text";
}}"
          aria-roledescription="${(xr) => xr.ariaRoledescription}"
          autocomplete="off"
          ?autofocus="${(xr) => {
  var ed;
  return (ed = xr.autofocus) != null ? ed : !1;
}}"
          ?disabled="${(xr) => {
  var ed;
  return (ed = xr.disabled) != null ? ed : !1;
}}"
          ?readonly="${(xr) => {
  var ed;
  return (ed = xr.readOnly) != null ? ed : !1;
}}"
          ?required="${(xr) => {
  var ed;
  return (ed = xr.required) != null ? ed : !1;
}}"
          inputmode="numeric"
          list="${(xr) => {
  var ed;
  return (ed = xr.list) != null ? ed : null;
}}"
          max="${(xr) => xr.max}"
          maxlength="${(xr) => xr.maxlength}"
          min="${(xr) => xr.min}"
          minlength="${(xr) => xr.minlength}"
          name="${(xr) => xr.name}"
          placeholder="${(xr) => {
  var ed;
  return (ed = xr.placeholder) != null ? ed : "";
}}"
          role="spinbutton"
          size="${(xr) => xr.size}"
          step="${(xr) => xr.step}"
          type="text"
          value="${(xr) => {
  var ed;
  return (ed = xr.value) != null ? ed : "";
}}"
          @input="${(xr) => xr.handleTextInput()}"
          @change="${(xr) => xr.handleChange()}"
          @keydown="${(xr, ed) => xr.handleKeyDown(ed.event)}"
          @blur="${(xr) => xr.handleBlur()}"
          ${ref("control")}
        />
      </${td.tagFor(Typography)}>
      ${when(
  (xr) => !xr.hideStep && !xr.readOnly && !xr.disabled,
  html`
          <div class="controls" part="controls" data-testid="controls">
            <div class="step-up" part="step-up" @click="${(xr) => xr.stepUp()}">
              <slot name="step-up-glyph">
                <span class="step-up-glyph" part="step-up-glyph" data-testid="step-up-glyph" />
              </slot>
            </div>

            <div class="step-down" part="step-down" @click="${(xr) => xr.stepDown()}">
              <slot name="step-down-glyph">
                <span class="step-down-glyph" part="step-down-glyph" data-testid="step-down-glyph" />
              </slot>
            </div>
          </div>
        `
)}
      ${endSlotTemplate(td, Ae)}
    </div>
    ${when(
  (xr) => xr.hasError() && !xr.readOnly && !xr.disabled,
  html`
      <div class="error">
        <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
          <${td.tagFor(Typography)}
          tag="span"
          type="label-helpertext-regular"
          class="error-label"
          role="alert"
          aria-role="alert"
        >
          ${(xr) => xr.error}
        </${td.tagFor(Typography)}>
      </div>
    `
)}
  </template>
`;
var __defProp$r = Object.defineProperty, __getOwnPropDesc$r = Object.getOwnPropertyDescriptor, __decorateClass$r = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$r(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$r(Ae, xr, id), id;
};
class NumberField extends FormAssociatedNumberField {
  constructor() {
    super(...arguments), this.readOnly = !1, this.hideStep = !1, this.inputSize = "regular", this.noExponent = !0, this.variant = "outline", this.step = 1, this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" }), this.isUserInput = !1, this.handleKeyDown = (Ae) => {
      if (this.disabled || this.readOnly)
        return !0;
      switch (Ae.key) {
        case keyArrowUp:
          return this.stepUp(), !1;
        case keyArrowDown:
          return this.stepDown(), !1;
        case "e":
          if (this.noExponent)
            return Ae.preventDefault(), !1;
      }
      return !0;
    }, this.hasLabel = () => {
      var Ae;
      return !!this.label || ((Ae = this.defaultSlottedNodes) == null ? void 0 : Ae.length) !== 0;
    };
  }
  /**
  * Ensures that the max is greater than the min and that the value
  *  is less than the max
  * @param previous - the previous max value
  * @param next - updated max value
  *
  * @internal
  */
  maxChanged(Ae, xr) {
    var od;
    const ed = Math.max(xr, (od = this.min) != null ? od : xr), id = Math.min(this.min, this.max);
    xr && this.max !== ed && (this.max = ed), this.min && this.min !== id && (this.min = id), this.value = this.getValidValue(this.value);
  }
  /**
  * Ensures that the min is less than the max and that the value
  *  is greater than the min
  * @param previous - previous min value
  * @param next - updated min value
  *
  * @internal
  */
  minChanged(Ae, xr) {
    var od;
    const ed = Math.min(xr, (od = this.max) != null ? od : xr), id = Math.max(this.min, this.max);
    xr && this.min !== ed && (this.min = ed), this.max && this.max !== id && (this.max = id), this.value = this.getValidValue(this.value);
  }
  /**
   * The value property, typed as a number.
   *
   * @public
   */
  get valueAsNumber() {
    return parseFloat(super.value);
  }
  set valueAsNumber(Ae) {
    this.value = Ae.toString();
  }
  /**
   * Validates that the value is a number between the min and max
   * @param previous - previous stored value
   * @param next - value being updated
   * @param updateControl - should the text field be updated with value, defaults to true
   * @internal
   */
  valueChanged(Ae, xr) {
    var id;
    const ed = this.getValidValue(xr);
    if (xr !== ed) {
      this.value = ed;
      return;
    }
    this.$fastController.isConnected && ((id = this.control) == null ? void 0 : id.value) !== ed && (this.control.value = this.value), super.valueChanged(Ae, this.value), Ae !== void 0 && !this.isUserInput && (this.$emit("input"), this.$emit("change")), this.isUserInput = !1, this.validate(), this.hasError();
  }
  /** {@inheritDoc (FormAssociated:interface).validate} */
  validate() {
    super.validate(this.control);
  }
  /**
   * Sets the internal value to a valid number between the min and max properties
   * @param value - user input
   *
   * @internal
   */
  getValidValue(Ae) {
    var rd, sd, nd, cd, ud, ld;
    let xr = parseFloat(Ae);
    const ed = (sd = (rd = Ae.match(new RegExp("e", "g"))) == null ? void 0 : rd.length) != null ? sd : 0, id = (cd = (nd = Ae.match(new RegExp("-", "g"))) == null ? void 0 : nd.length) != null ? cd : 0;
    if (isNaN(xr))
      return Ae.startsWith("-") && id === 1 ? Ae : Ae.startsWith("-") && id === 2 ? Ae.substring(0, Ae.length - 1) : "";
    if (xr > Number.MAX_SAFE_INTEGER)
      return ed === 1 || ed === 0 ? Ae : Ae.substring(0, Ae.length - 1);
    const od = (ud = this.max) != null ? ud : xr, ad = (ld = this.min) != null ? ld : xr;
    return xr = Math.min(xr, od), xr = Math.max(xr, ad), Ae.endsWith(".") ? xr.toString() + "." : Ae.includes("e") && !this.noExponent ? Ae.endsWith("e") && ed === 1 ? xr.toString() + "e" : Ae.endsWith("e") ? Ae.substring(0, Ae.length - 1) : Ae : xr.toString();
  }
  /**
   * Increments the value using the step value
   *
   * @public
   */
  stepUp() {
    let Ae;
    if (Number(this.value) >= Number.MIN_SAFE_INTEGER && Number(this.value) <= Number.MAX_SAFE_INTEGER ? Ae = parseFloat(this.value) : this.value.includes("e") || (Ae = BigInt(this.value)), Ae) {
      const xr = typeof Ae == "bigint" ? BigInt(Ae) + BigInt(this.step) : isNaN(Ae) ? this.min > 0 ? this.min : this.max < 0 ? this.max : this.min ? 0 : this.step : Number(Ae) + this.step;
      this.value = xr.toString();
    } else
      this.value = "1";
  }
  /**
   * Decrements the value using the step value
   *
   * @public
   */
  stepDown() {
    let Ae;
    if (Number(this.value) >= Number.MIN_SAFE_INTEGER && Number(this.value) <= Number.MAX_SAFE_INTEGER ? Ae = parseFloat(this.value) : this.value.includes("e") || (Ae = BigInt(this.value)), Ae) {
      const xr = typeof Ae == "bigint" ? BigInt(Ae) - BigInt(this.step) : isNaN(Ae) ? this.min > 0 ? this.min : this.max < 0 ? this.max : this.min ? 0 : 0 - this.step : Number(Ae) - this.step;
      this.value = xr.toString();
    } else
      this.value = "-1";
  }
  /**
   * Sets up the initial state of the number field
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.proxy.setAttribute("type", "number"), this.validate(), this.control.value = this.value, this.autofocus && DOM.queueUpdate(() => {
      this.focus();
    });
  }
  /**
   * Selects all the text in the number field
   *
   * @public
   */
  select() {
    this.control.select(), this.$emit("select");
  }
  /**
   * Handles the internal control's `input` event
   * @internal
   */
  handleTextInput() {
    this.control.value = this.control.value.replace(/[^0-9\-+e.]/g, ""), this.isUserInput = !0, this.value = this.control.value;
  }
  /**
   * Change event handler for inner control.
   * @remarks
   * "Change" events are not `composable` so they will not
   * permeate the shadow DOM boundary. This fn effectively proxies
   * the change event, emitting a `change` event whenever the internal
   * control emits a `change` event
   * @internal
   */
  handleChange() {
    this.$emit("change");
  }
  /**
   * Handles populating the input field with a validated value when
   *  leaving the input field.
   * @internal
   */
  handleBlur() {
    this.control.value = this.value, this.$emit("blur");
  }
  hasError() {
    var Ae, xr, ed;
    return ((xr = (Ae = this.control) == null ? void 0 : Ae.checkValidity()) != null ? xr : !0) === !1 || this.error ? (this.classList.add("invalid"), !0) : ((ed = this.classList) == null || ed.remove("invalid"), !1);
  }
  formResetCallback() {
    super.formResetCallback(), this.value = "";
  }
}
__decorateClass$r([
  attr({ mode: "boolean", attribute: "read-only" }),
  attr({ mode: "boolean", attribute: "readonly" })
], NumberField.prototype, "readOnly", 2);
__decorateClass$r([
  attr({ mode: "boolean" })
], NumberField.prototype, "autofocus", 2);
__decorateClass$r([
  attr({ mode: "boolean", attribute: "hide-step" }),
  attr({ mode: "boolean", attribute: "hidestep" })
], NumberField.prototype, "hideStep", 2);
__decorateClass$r([
  attr({ attribute: "input-size" }),
  attr({ attribute: "inputsize" })
], NumberField.prototype, "inputSize", 2);
__decorateClass$r([
  attr({ mode: "boolean", attribute: "no-exponent" }),
  attr({ mode: "boolean", attribute: "noexponent" })
], NumberField.prototype, "noExponent", 2);
__decorateClass$r([
  attr()
], NumberField.prototype, "label", 2);
__decorateClass$r([
  attr()
], NumberField.prototype, "error", 2);
__decorateClass$r([
  attr()
], NumberField.prototype, "variant", 2);
__decorateClass$r([
  attr
], NumberField.prototype, "placeholder", 2);
__decorateClass$r([
  attr
], NumberField.prototype, "list", 2);
__decorateClass$r([
  attr({ converter: nullableNumberConverter })
], NumberField.prototype, "maxlength", 2);
__decorateClass$r([
  attr({ converter: nullableNumberConverter })
], NumberField.prototype, "minlength", 2);
__decorateClass$r([
  attr({ converter: nullableNumberConverter })
], NumberField.prototype, "size", 2);
__decorateClass$r([
  attr({ converter: nullableNumberConverter })
], NumberField.prototype, "step", 2);
__decorateClass$r([
  attr()
], NumberField.prototype, "max", 2);
__decorateClass$r([
  attr()
], NumberField.prototype, "min", 2);
__decorateClass$r([
  observable
], NumberField.prototype, "defaultSlottedNodes", 2);
applyMixins(NumberField, StartEnd, DelegatesARIATextbox);
const tm1NumberField = NumberField.compose({
  baseName: "number-field",
  template: tm1NumberFieldTemplate,
  styles: tm1NumberFieldStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1NumberField()
);
const tm1SwitchStyles = () => css`
  ${display("grid")}
  :host {
    grid-template: auto / fit-content(0px) auto;
    outline: none;
    margin: ${GDSESpacing50} ${GDSESpacing0};
    width: fit-content;
    user-select: none;
    grid-column-gap: ${GDSESpacing100};
    background: transparent;
  }

  :host([disabled][aria-checked='true']) .switch {
    background: ${GDSEColorFillDisabled};
    border: none;
  }

  :host([disabled][aria-checked='false']) .switch {
    background: ${GDSEColorFillDisabled};
    border-color: ${GDSEColorFillDisabled};
  }

  :host([disabled]) .label,
  :host([readonly]) .label,
  :host([disabled]) .description,
  :host([readonly]) .description,
  :host([disabled]) .label-description,
  :host([readonly]) .label-description,
  :host([readonly]) .switch,
  :host([disabled]) .switch {
    cursor: not-allowed;
  }

  .label-description,
  :host(:not([disabled])[aria-checked='true']) .switch:hover {
    cursor: pointer;
  }

  .description {
    color: ${GDSEColorTextLight};
  }

  ::slotted(div) {
    color: ${GDSEColorTextLight};
  }

  .switch {
    position: relative;
    outline: none;
    box-sizing: border-box;
    width: 42px;
    height: 24px;
    background: ${GDSEColorFillInput};
    border-radius: ${GDSERadiusPill};
    border: 1px solid ${GDSEColorBorderInputDefault};
  }

  :host([size='small']) .switch {
    width: 29px;
    height: 16px;
  }

  :host(:not([disabled]):not([aria-checked='true'])) .switch:hover {
    border-color: ${GDSEColorBorderInputHovered};
    cursor: pointer;
  }

  .checked-indicator {
    position: absolute;
    background: ${GDSEColorTextLight};
    transition: all 0.2s ease-in-out;
    top: 3px;
    left: 3px;
    bottom: 3px;
    right: 21px;
    border-radius: ${GDSEBorderRadiusFull};
  }

  :host([disabled]) .checked-indicator {
    background: ${GDSEColorTextDisabled};
  }

  :host([size='small']) .checked-indicator {
    top: 2px;
    left: 2px;
    bottom: 2px;
    right: 15px;
  }

  :host([aria-checked='true']) .checked-indicator {
    background: ${GDSEColorTextOnfillStrong};
    border-color: ${GDSEColorTextOnfillStrong};
    left: 21px;
    top: 3px;
    right: 3px;
    bottom: 3px;
  }

  :host([aria-checked='true'][size='small']) .checked-indicator {
    left: 16px;
    right: 3px;
  }

  .status-message {
    color: ${GDSEColorText};
  }

  :host([disabled]) .status-message,
  :host([readonly]) .status-message {
    cursor: not-allowed;
  }

  .label {
    color: ${GDSEColorText};
  }

  .label-description {
    color: ${GDSEColorTextLight};
  }

  :host([disabled]) .label-description {
    color: ${GDSEColorTextLight};
  }

  .label__hidden {
    display: none;
    visibility: hidden;
  }

  :host([aria-checked='true']) .switch,
  :host([aria-checked='true']:not([disabled])) .switch:active {
    background: ${GDSEColorFillInputSelected};
    border-color: ${GDSEColorFillInputSelected};
  }

  :host([aria-checked='true']:not([disabled])) .switch:hover {
    border-color: ${GDSEColorFillPrimary};
    background: ${GDSEColorFillPrimary};
  }

  :host([aria-checked='true']:not([disabled])) .switch:hover .checked-indicator {
    border-color: ${GDSEColorBorderPrimary};
    background: ${GDSEColorFillInput};
  }

  :host([aria-checked='true']:not([disabled])) .switch:active .checked-indicator {
    background: ${GDSEColorFillInput};
  }

  :host([aria-checked='false']:not([disabled]):focus) .switch {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host(:not([disabled]):focus) .switch:after {
    content: '';
    position: absolute;
    inset: -5px;
    border: ${GDSEBorderWidth25} solid ${GDSEColorBorderFocus};
    border-radius: 50px;
  }
`, tm1SwitchTemplate = (td, Ae) => html`
  <template
    role="switch"
    aria-checked="${(xr) => xr.checked}"
    aria-disabled="${(xr) => xr.disabled}"
    aria-readonly="${(xr) => {
  var ed;
  return (ed = xr.readOnly) != null ? ed : !1;
}}"
    tabindex="${(xr) => xr.disabled ? null : 0}"
    @keypress="${(xr, ed) => xr.keypressHandler(ed.event)}"
    @click="${(xr, ed) => xr.clickHandler(ed.event)}"
    class="${(xr) => xr.checked ? "checked" : ""}"
  >
    <div part="switch" class="switch" data-testid="switch">
      <slot name="switch">${Ae.switch || ""}</slot>
    </div>

    <div class="label-description" data-testid="label-description">
      <${td.tagFor(Typography)}
        type="${(xr) => xr.size ? xr.textType[xr.size] : "body-l"}"
        part="label"
        class="label ${(xr) => xr.labelClasses}"
        data-testid="label"
        ${ref("label")}
      >
        <slot ${slotted("defaultSlottedNodes")}></slot>
      </${td.tagFor(Typography)}>
      ${when(
  (xr) => xr.description,
  html`
          <div>
            <${td.tagFor(Typography)} class="description" type="body-m" data-testid="description">
              ${(xr) => xr.description}
            </${td.tagFor(Typography)}>
          </div>
       `
)}
    </div>
  </template>
`;
var __defProp$q = Object.defineProperty, __getOwnPropDesc$q = Object.getOwnPropertyDescriptor, __decorateClass$q = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$q(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$q(Ae, xr, id), id;
};
class Switch extends Switch$1 {
  constructor() {
    var Ae;
    super(...arguments), this.size = "regular", this.description = "", this.textType = { small: "body-m", regular: "body-l" }, this.labelClasses = ((Ae = this.label) == null ? void 0 : Ae.innerHTML) !== "" ? "" : "label__hidden";
  }
  checkedChanged(Ae, xr) {
    this.value = xr ? "on" : "off", super.checkedChanged(Ae, xr);
  }
}
__decorateClass$q([
  attr()
], Switch.prototype, "size", 2);
__decorateClass$q([
  attr()
], Switch.prototype, "description", 2);
__decorateClass$q([
  observable
], Switch.prototype, "label", 2);
const tm1Switch = Switch.compose({
  baseName: "switch",
  baseClass: Switch$1,
  template: tm1SwitchTemplate,
  styles: tm1SwitchStyles,
  switch: '<span class="checked-indicator" part="checked-indicator"></span>'
});
designSystem.register(
  tm1Switch()
);
const tm1ObjectBadgesStyles = css`
  :host {
    display: flex;
    align-items: center;
  }

  :host .badges-container {
    display: inline-flex;
    justify-content: flex-end;
    margin: ${GDSESpacing50} ${GDSESpacing0};
    gap: ${GDSESpacing100};
  }
`, tm1ObjectBadgesTemplate = html`
  <div class="badges-container" data-testid="badges-container">
    <slot></slot>
  </div>
`;
class ObjectBadges extends FoundationElement {
}
const tm1ObjectBadges = ObjectBadges.compose({
  baseName: "object-badges",
  template: tm1ObjectBadgesTemplate,
  styles: tm1ObjectBadgesStyles
}), tm1ObjectDateStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-right: ${GDSESpacing300};
  }

  :host .date-container {
    margin: ${GDSESpacing0} ${GDSESpacing100};
    white-space: nowrap;
  }

  :host .month-day {
    padding-bottom: ${GDSESpacing100};
    color: ${GDSEColorText};
    text-transform: uppercase;
  }

  :host .year {
    color: ${GDSEColorTextLight};
  }
`, tm1ObjectDateTemplate = (td) => html`
  <div class="date-container" data-testid="date-container">
    <${td.tagFor(Typography)} type="title-list-m" tag="span">
      <div class="month-day" data-testid="month-day"><slot name="monthDay">${(Ae) => Ae == null ? void 0 : Ae.monthDay}</slot></div>
    </${td.tagFor(Typography)}>
    <${td.tagFor(Typography)} type="subtitle-list-m" tag="span">
      <div class="year" data-testid="year"><slot name="year">${(Ae) => Ae == null ? void 0 : Ae.year}</slot></div>
    </${td.tagFor(Typography)}>
  </div>
`;
var __defProp$p = Object.defineProperty, __getOwnPropDesc$p = Object.getOwnPropertyDescriptor, __decorateClass$p = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$p(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$p(Ae, xr, id), id;
};
class ObjectDate extends FoundationElement {
  constructor() {
    super(...arguments), this.monthDay = "", this.year = "";
  }
}
__decorateClass$p([
  attr()
], ObjectDate.prototype, "monthDay", 2);
__decorateClass$p([
  attr()
], ObjectDate.prototype, "year", 2);
const tm1ObjectDate = ObjectDate.compose({
  baseName: "object-date",
  template: tm1ObjectDateTemplate,
  styles: tm1ObjectDateStyles
}), tm1ObjectHeaderStyles = css`
  :host {
    display: flex;
    align-items: center;
    padding: ${GDSESpacing200} ${GDSESpacing300};
  }

  :host ::slotted(tm1-object-media) {
    padding-right: ${GDSESpacing300};
  }

  :host ::slotted([slot='end']) {
    justify-content: end;
  }
`, tm1ObjectHeaderTemplate = () => html`
  <template>
    <slot name="start"></slot>
    <slot name="date"></slot>
    <slot name="media"></slot>
    <slot></slot>
    <slot name="action"></slot>
    <slot name="end"></slot>
  </template>
`;
class ObjectHeader extends FoundationElement {
}
const tm1ObjectHeader = ObjectHeader.compose({
  baseName: "object-header",
  template: tm1ObjectHeaderTemplate,
  styles: tm1ObjectHeaderStyles
}), tm1ObjectInlineActionsStyles = css`
  :host {
    ${inputSizeRegular$1}
    --input-width: 144px;
    --option-height: 37px;
    display: flex;
    align-items: center;
  }

  :host .inline-actions-container {
    display: flex;
    align-items: center;
  }

  :host .kebab-actions-button {
    height: 100%;
    vertical-align: middle;
    margin-left: ${GDSESpacing250};
  }

  ::part(popover-overlay) {
    border: none;
    box-shadow: none;
  }

  :host .listbox {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    cursor: pointer;
    width: 100%;
    max-width: var(--input-width);
    width: var(--input-width);
    max-height: calc(var(--size, 4) * var(--option-height));
    border-radius: ${GDSEWidthLarge};
    box-shadow:
      0px 1px 4px 0px rgba(38, 38, 38, 0.12),
      0px 0px 6px 0px rgba(38, 38, 38, 0.06);
    transition: opacity 0.1s ease-in 0s;
  }

  ::slotted([role='option']),
  ::slotted(option) {
    flex: 0 0 auto;
    font-size: var(--font-size);
    color: ${GDSEColorTextLight};
    padding: var(--padding);
    max-height: var(--input-size);
  }

  :host :not([slot='kebab-actions'])::slotted(tm1-button:not(:first-child)) {
    margin-left: ${GDSESpacing150};
  }

  :host tm1-button {
    --text-color: ${GDSEColorTextLight};
    --text-color-hovered: ${GDSEColorTextLight};
    --text-color-focus: ${GDSEColorTextLight};
    --text-color-pressed: ${GDSEColorText};
    --background-color-hovered: ${GDSEColorFillHovered};
    --background-color-focus: ${GDSEColorFillHovered};
    --background-color-pressed: ${GDSEColorFillPressed};
  }
`, tm1ObjectInlineActionsTemplate = (td) => html`
  <div class="inline-actions-container">
    <slot class="button-actions-container"></slot>
    ${when(
  (Ae) => Ae.hasKebab,
  html`
        <${td.tagFor(Popover)}
            alignment="${(Ae) => Ae.popoverConfig.alignment || defaultInlineActionsPopoverConfig.alignment}"
            direction="${(Ae) => Ae.popoverConfig.direction || defaultInlineActionsPopoverConfig.direction}"
            mode="${(Ae) => Ae.popoverConfig.mode || defaultInlineActionsPopoverConfig.mode}"
            padding="${(Ae) => Ae.popoverConfig.padding || defaultInlineActionsPopoverConfig.padding}"
            triggerHeight="${(Ae) => Ae.popoverConfig.triggerHeight}"
            ?visible="${(Ae) => Ae.popoverConfig.visible}"
            ?closeOnClick="${(Ae) => Ae.popoverConfig.closeOnClick}"
            ?floating-ui="${(Ae) => Ae.popoverConfig.floatingUi}"
        >
            <${td.tagFor(Button)}
                slot="trigger"
                class="kebab-actions-button"
                size="regular"
                variant="lightweight"
                iconPosition="only-icon"
                icon="kebab"
                aria-label="button-popover"
            ></${td.tagFor(Button)}>
            <div class="listbox">
              <slot name="kebab-actions"></slot>
            </div>
        </${td.tagFor(Popover)}>
        `
)}
  </div>
`;
var __defProp$o = Object.defineProperty, __getOwnPropDesc$o = Object.getOwnPropertyDescriptor, __decorateClass$o = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$o(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$o(Ae, xr, id), id;
};
const defaultInlineActionsPopoverConfig = {
  padding: "none",
  alignment: "end",
  direction: "down",
  mode: "relative",
  closeOnClick: !0
};
class ObjectInlineActions extends FoundationElement {
  constructor() {
    super(...arguments), this.hasKebab = !1, this.popoverConfig = defaultInlineActionsPopoverConfig;
  }
}
__decorateClass$o([
  attr({ mode: "boolean", attribute: "has-kebab" })
], ObjectInlineActions.prototype, "hasKebab", 2);
__decorateClass$o([
  attr({ attribute: "popover-config" })
], ObjectInlineActions.prototype, "popoverConfig", 2);
const tm1ObjectInlineActions = ObjectInlineActions.compose({
  baseName: "object-inline-actions",
  template: tm1ObjectInlineActionsTemplate,
  styles: tm1ObjectInlineActionsStyles
}), tm1ObjectListStyles = css`
  :host {
    display: block;
    --object-list-cell-hover-background-color: rgba(24, 181, 183, 0.08);
  }

  @keyframes appear {
    from {
      margin-top: ${GDSESpacing250};
      opacity: 0;
    }

    to {
      margin-top: ${GDSESpacing0};
      opacity: 1;
    }
  }

  .container {
    animation: appear 0.5s ease-out;
    display: grid;
    grid-template-columns: var(--object-list-grid-template-columns, 40% repeat(auto-fit, minmax(50px, 1fr)));
    grid-template-rows: auto 1fr;
    box-sizing: border-box;
  }

  .container * {
    box-sizing: border-box;
  }

  .result-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mobile {
    display: contents;
  }

  slot[name='mobile'] {
    --object-list-cell-hover-background-color: none;
  }
`, tm1ObjectListTemplate = html`
  <div class="container ${(td) => td.mobile ? "mobile" : ""}" role="table">
    ${(td) => td.mobile ? html`<slot name="mobile"></slot>` : html`<slot data-testid="content"></slot>`}
  </div>
  <div part="empty-state" class="result-container">
    <slot name="empty-state"></slot>
  </div>
`;
var __defProp$n = Object.defineProperty, __getOwnPropDesc$n = Object.getOwnPropertyDescriptor, __decorateClass$n = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$n(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$n(Ae, xr, id), id;
};
class ObjectList extends FoundationElement {
  constructor() {
    super(...arguments), this.mobile = !1, this.hostSizeBehavior = new HostSizeBehavior(this, (Ae) => {
      this.mobileThreshold && (this.mobile = Ae.contentRect.width < this.mobileThreshold);
    });
  }
}
__decorateClass$n([
  attr({ attribute: "mobile-threshold" })
], ObjectList.prototype, "mobileThreshold", 2);
__decorateClass$n([
  attr({ mode: "boolean" })
], ObjectList.prototype, "mobile", 2);
const tm1ObjectList = ObjectList.compose({
  baseName: "object-list",
  template: tm1ObjectListTemplate,
  styles: tm1ObjectListStyles
}), tm1ObjectListCellStyles = css`
  :host {
    box-sizing: border-box;
    border-bottom: var(--object-list-cell-border-bottom, 1px solid ${GDSEColorBorder});
    background: var(--object-list-cell-background-color, ${GDSEColorSurface});
    position: var(--object-list-header-position, static);
    top: 0;
  }

  :host * {
    box-sizing: border-box;
  }

  .row__cell {
    padding: var(--object-list-header-cell-padding, ${GDSESpacing300}) ${GDSESpacing0};
    width: 100%;
    height: 100%;
  }

  .cell__inner {
    padding: ${GDSESpacing0} ${GDSESpacing150};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .h-left {
    justify-content: flex-start;
  }

  .h-right {
    justify-content: flex-end;
  }

  .v-top {
    align-items: flex-start;
  }

  .v-bottom {
    align-items: flex-end;
  }

  .border-left {
    border-left: 1px solid ${GDSEColorBorder};
  }

  .border-right {
    border-right: 1px solid ${GDSEColorBorder};
  }

  .text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .direction {
    margin-left: ${GDSESpacing50};
  }

  .sortable {
    cursor: pointer;
  }
`, tm1ObjectListCellTemplate = (td) => html`
<div class="row__cell ${(Ae) => Ae.isSortable() ? "sortable" : ""}" role="${(Ae) => Ae.role}" part="cell">
  <div
    data-testid="inner-cell"
    class="cell__inner
    ${(Ae) => Ae.borderRight ? "border-right" : ""}
    ${(Ae) => Ae.borderLeft ? "border-left" : ""}
    ${(Ae) => Ae.horizontalAlign && `h-${Ae.horizontalAlign}`}
    ${(Ae) => Ae.verticalAlign && `v-${Ae.verticalAlign}`}
    ${(Ae) => Ae.role === "columnheader" ? "text-ellipsis" : ""}"
    part="inner-cell"
  >
    <slot></slot>
    ${when((Ae) => Ae.isSortable(), html`<${td.tagFor(Icon)} ${ref("icon")} class="direction" icon="${(Ae) => `sort${firstLetterUppercase(Ae.sortDirection)}`}" size="small" />`)}
  </div>
</div>
`;
var __defProp$m = Object.defineProperty, __getOwnPropDesc$m = Object.getOwnPropertyDescriptor, __decorateClass$m = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$m(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$m(Ae, xr, id), id;
}, position = /* @__PURE__ */ ((td) => (td.LEFT = "left", td.RIGHT = "right", td.TOP = "top", td.BOTTOM = "bottom", td.CENTER = "center", td))(position || {});
class ObjectListCell extends FoundationElement {
  constructor() {
    super(...arguments), this.verticalAlign = "center", this.horizontalAlign = "center", this.borderLeft = !1, this.borderRight = !1, this.role = "cell", this.sortable = !1, this.sortDirection = "", this.isSortable = () => {
      var Ae;
      return ((Ae = this.parentNode) == null ? void 0 : Ae.nodeName.toUpperCase()) === "TM1-OBJECT-LIST-HEADER" && this.sortable;
    };
  }
  sortDirectionChanged(Ae, xr) {
    Ae !== xr && (this.sortDirection = xr, this.$emit("change", this.sortDirection));
  }
}
__decorateClass$m([
  attr({ attribute: "vertical-align" }),
  attr({ attribute: "verticalalign" })
], ObjectListCell.prototype, "verticalAlign", 2);
__decorateClass$m([
  attr({ attribute: "horizontal-align" }),
  attr({ attribute: "horizontalalign" })
], ObjectListCell.prototype, "horizontalAlign", 2);
__decorateClass$m([
  attr({ mode: "boolean", attribute: "border-left" }),
  attr({ mode: "boolean", attribute: "borderleft" })
], ObjectListCell.prototype, "borderLeft", 2);
__decorateClass$m([
  attr({ mode: "boolean", attribute: "border-right" }),
  attr({ mode: "boolean", attribute: "borderright" })
], ObjectListCell.prototype, "borderRight", 2);
__decorateClass$m([
  attr()
], ObjectListCell.prototype, "role", 2);
__decorateClass$m([
  attr({ mode: "boolean" })
], ObjectListCell.prototype, "sortable", 2);
__decorateClass$m([
  attr({ attribute: "sort-direction" }),
  attr({ attribute: "sortdirection" })
], ObjectListCell.prototype, "sortDirection", 2);
__decorateClass$m([
  observable
], ObjectListCell.prototype, "icon", 2);
const tm1ObjectListCell = ObjectListCell.compose({
  baseName: "object-list-cell",
  template: tm1ObjectListCellTemplate,
  styles: tm1ObjectListCellStyles
}), tm1ObjectListExpandableRowActionStyles = css`
  :host {
    display: contents;
  }

  .expandable-row-action {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .trigger {
    all: unset;
    height: 100%;
    text-align: center;
    flex: 0 0 auto;
    color: ${GDSEColorTextLight};
    padding: ${GDSESpacing50} ${GDSESpacing100};
  }

  .trigger:hover {
    cursor: pointer;
  }

  .trigger::part(control):focus-visible {
    background-color: transparent;
  }

  :host([noPaddingExpandButton]) .trigger::part(control),
  :host([no-padding-expand-button]) .trigger::part(control),
  :host([noPaddingExpandButton]) .trigger,
  :host([no-padding-expand-button]) .trigger {
    padding: 0;
  }
`, tm1ObjectListExpandableRowActionTemplate = (td) => html`
  <div class="expandable-row-action" style="justify-content: ${(Ae) => Ae.contentPosition};">
    <slot name="start"></slot>
    <${td.tagFor(Button)}
      data-testid="trigger"
      class="trigger"
      iconPosition="only-icon"
      aria-label="button-icon"
      size="${(Ae) => Ae.iconSize || "regular"}"
      @click="${(Ae) => Ae.handleActionClick()}"
      icon="${(Ae) => Ae.iconType}"
    ></${td.tagFor(Button)}>
    <slot name="end"></slot>
  </div>
`;
var __defProp$l = Object.defineProperty, __getOwnPropDesc$l = Object.getOwnPropertyDescriptor, __decorateClass$l = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$l(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$l(Ae, xr, id), id;
};
const ExpansionTriggerIconType = {
  FORWARD: "forward",
  DOWN: "down",
  UP: "up"
}, RowExpandedState = {
  EXPANDED: "expanded",
  COLLAPSED: "collapsed"
}, ExpandableRowActionContentPosition = {
  CENTER: "center",
  SPACE_BETWEEN: "space-between"
}, ExpandableRowActionIconDirection = {
  UP: "up",
  RIGHT: "right"
};
class ObjectListExpandableRowAction extends FoundationElement {
  constructor() {
    super(...arguments), this.initialExpanded = RowExpandedState.COLLAPSED, this.expanded = !1, this.iconDirection = ExpandableRowActionIconDirection.RIGHT, this.iconType = ExpansionTriggerIconType.FORWARD, this.iconSize = IconSize.regular, this.contentPosition = ExpandableRowActionContentPosition.CENTER, this.noPaddingExpandButton = !1;
  }
  iconDirectionChanged(Ae, xr) {
    Ae !== xr && this.setIconDirection();
  }
  setIconDirection() {
    this.iconType = this.expanded ? ExpansionTriggerIconType.DOWN : this.iconDirection === ExpandableRowActionIconDirection.RIGHT ? ExpansionTriggerIconType.FORWARD : ExpansionTriggerIconType.UP;
  }
  handleActionClick() {
    this.expanded = !this.expanded, this.setIconDirection(), this.focus();
    const Ae = {
      detail: { expanded: this.expanded },
      bubbles: !0,
      composed: !0
    };
    this.dispatchEvent(new CustomEvent("toggleExpandableRow", Ae));
  }
  initialExpandedChanged(Ae, xr) {
    xr === RowExpandedState.EXPANDED && this.handleActionClick();
  }
}
__decorateClass$l([
  attr({ attribute: "initial-expanded" })
], ObjectListExpandableRowAction.prototype, "initialExpanded", 2);
__decorateClass$l([
  attr({ mode: "boolean" })
], ObjectListExpandableRowAction.prototype, "expanded", 2);
__decorateClass$l([
  attr({ attribute: "icon-direction" }),
  attr({ attribute: "icondirection" })
], ObjectListExpandableRowAction.prototype, "iconDirection", 2);
__decorateClass$l([
  attr()
], ObjectListExpandableRowAction.prototype, "iconType", 2);
__decorateClass$l([
  attr({ attribute: "icon-size" })
], ObjectListExpandableRowAction.prototype, "iconSize", 2);
__decorateClass$l([
  attr({ attribute: "content-position" }),
  attr({ attribute: "contentposition" })
], ObjectListExpandableRowAction.prototype, "contentPosition", 2);
__decorateClass$l([
  attr({ mode: "boolean", attribute: "noPaddingExpandButton" }),
  attr({ mode: "boolean", attribute: "no-padding-expand-button" })
], ObjectListExpandableRowAction.prototype, "noPaddingExpandButton", 2);
const tm1ObjectListExpandableRowAction = ObjectListExpandableRowAction.compose({
  baseName: "object-list-expandable-row-action",
  template: tm1ObjectListExpandableRowActionTemplate,
  styles: tm1ObjectListExpandableRowActionStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
}), tm1ObjectListExpandableRowStyles = css`
  :host {
    display: contents;
  }

  .expandable-row {
    display: contents;
  }

  .expanded {
    --object-list-row-background-color: ${GDSEColorSurfaceCard};
    --object-list-cell-border-bottom: 0;
  }

  .expandable-row-item {
    background-color: var(--object-list-row-background-color);
    margin-bottom: ${GDSESpacing25};
  }

  [theme='legacy'] .expandable-row-item,
  [theme='light'] .expandable-row-item {
    border-bottom: 1px solid ${GDSEColorBorder};
    margin-bottom: ${GDSESpacing0};
  }

  .mobile[theme='legacy'] .expandable-row-item,
  .mobile[theme='light'] .expandable-row-item {
    border-bottom: none;
  }

  ::slotted(tm1-object-list-row[slot="expandable-row-item"]) {
    display: grid;
    grid-template: auto / auto max-content minmax(0, 1fr) minmax(0, max-content) minmax(0, max-content);
  }
`, tm1ObjectListExpandableRowTemplate = html`
  <div
    data-testid="expandable-row"
    class="expandable-row ${(td) => td.expanded ? "expanded" : ""} ${(td) => td.mobile ? " mobile" : ""}"
    theme=${(td) => td.theme}
    @toggleExpandableRow="${(td, Ae) => td.toggleRowListener(Ae.event)}"
  >
    <slot></slot>
    ${when(
  (td) => td.expanded,
  html`
        <div
          data-testid="expandable-row-item"
          class="expandable-row-item"
          style="${(td) => `grid-column: ${td.numColumns >= 1 ? `span ${td.numColumns}` : "span 1"};`}"
        >
          <slot name="expandable-row-item"></slot>
        </div>
      `
)}
  </div>
`;
var __defProp$k = Object.defineProperty, __getOwnPropDesc$k = Object.getOwnPropertyDescriptor, __decorateClass$k = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$k(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$k(Ae, xr, id), id;
};
class ObjectListExpandableRow extends FoundationElement {
  constructor() {
    super(...arguments), this.numColumns = 0, this.expanded = !1, this.hostSizeBehavior = new HostSizeBehavior(this, (Ae) => {
      this.mobileThreshold && (this.mobile = Ae.contentRect.width < this.mobileThreshold);
    }), this.theme = ThemeType.light, this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    });
  }
  toggleRowListener(Ae) {
    this.expanded = Ae.detail.expanded ? Ae.detail.expanded : !1;
  }
}
__decorateClass$k([
  attr({ attribute: "mobileThreshold" }),
  attr({ attribute: "mobile-threshold" })
], ObjectListExpandableRow.prototype, "mobileThreshold", 2);
__decorateClass$k([
  attr({ attribute: "numColumns" }),
  attr({ attribute: "num-columns" })
], ObjectListExpandableRow.prototype, "numColumns", 2);
__decorateClass$k([
  attr
], ObjectListExpandableRow.prototype, "expanded", 2);
__decorateClass$k([
  observable
], ObjectListExpandableRow.prototype, "mobile", 2);
__decorateClass$k([
  observable
], ObjectListExpandableRow.prototype, "theme", 2);
const tm1ObjectListExpandableRow = ObjectListExpandableRow.compose({
  baseName: "object-list-expandable-row",
  template: tm1ObjectListExpandableRowTemplate,
  styles: tm1ObjectListExpandableRowStyles
}), tm1ObjectListHeaderStyles = css`
  :host {
    display: contents;
  }

  ::slotted(tm1-object-list-cell) {
    z-index: 1;
  }

  .row {
    display: contents;
  }

  .header {
    color: ${GDSEColorTextLight};

    --object-list-cell-background-color: ${GDSEColorSurfaceAlt};
    --object-list-cell-border-bottom: none;
    --object-list-cell-role: columnheader;
    --object-list-header-position: static;
    --object-list-header-cell-padding: ${GDSESpacing150};
  }
`, tm1ObjectListHeaderTemplate = (td) => html`
  <template @click=${(Ae, xr) => Ae.handleCustomClick(xr.event)}>
    <div class="header row" role="row" style="${(Ae) => Ae.sticky === !0 && "--object-list-header-position: sticky;"}">
      <${td.tagFor(Typography)} type="title-list-m" class="row">
        <slot></slot>
      </${td.tagFor(Typography)}>
    </div>
  </template>
`;
var __defProp$j = Object.defineProperty, __getOwnPropDesc$j = Object.getOwnPropertyDescriptor, __decorateClass$j = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$j(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$j(Ae, xr, id), id;
};
class ObjectListHeader extends FoundationElement {
  constructor() {
    super(...arguments), this.sticky = !1;
  }
  handleCustomClick(Ae) {
    var ed;
    const xr = Ae.composedPath().find((id) => id.nodeName === "TM1-OBJECT-LIST-CELL");
    if (xr && xr.sortable) {
      const id = (ed = this.querySelectorAll("tm1-object-list-cell[sortable]")) != null ? ed : [];
      Array.from(id).forEach((od) => {
        od.sortDirection !== "" && od !== xr && (od.sortDirection = "");
      }), xr.sortDirection === "" ? xr.sortDirection = "asc" : xr.sortDirection === "asc" ? xr.sortDirection = "desc" : xr.sortDirection = "asc";
    }
  }
}
__decorateClass$j([
  attr({ mode: "boolean" })
], ObjectListHeader.prototype, "sticky", 2);
const tm1ObjectListHeader = ObjectListHeader.compose({
  baseName: "object-list-header",
  template: tm1ObjectListHeaderTemplate,
  styles: tm1ObjectListHeaderStyles
}), tm1ObjectListRowStyles = css`
  :host {
    display: contents;
  }

  .row {
    display: contents;
    --object-list-cell-background-color: var(--object-list-row-background-color, ${GDSEColorSurface});
  }

  .row:hover {
    --object-list-cell-background-color: var(--object-list-row-hover-background-color, ${GDSEColorObjectListHover});
  }

  tm1-checkbox {
    width: 20px;
    padding: ${GDSESpacing0} ${GDSESpacing0} ${GDSESpacing0} ${GDSESpacing100};
    margin-left: 0;
  }
`, tm1ObjectListRowTemplate = (td) => html`
  <div class="row" part="row" role="row" slot="heading">
    ${when((Ae) => Ae.multiSelect, html`
      <${td.tagFor(ObjectListCell)}>
        <${td.tagFor(Checkbox)} class="multiselect" ?checked="${(Ae) => Ae.checked}" @change="${(Ae, xr) => Ae.handleChange(xr.event)}"></${td.tagFor(Checkbox)}>
      </${td.tagFor(ObjectListCell)}>
    `)}
    <slot @change="${(Ae, xr) => Ae.handleChange(xr.event)}"></slot>
  </div>
`;
var __defProp$i = Object.defineProperty, __getOwnPropDesc$i = Object.getOwnPropertyDescriptor, __decorateClass$i = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$i(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$i(Ae, xr, id), id;
};
class ObjectListRow extends FoundationElement {
  constructor() {
    super(...arguments), this.multiSelect = !1, this.checked = !1;
  }
  handleChange(Ae) {
    var id;
    const xr = Ae.target, ed = (id = this.shadowRoot) == null ? void 0 : id.querySelector("tm1-checkbox.multiselect");
    Ae.stopPropagation(), xr === ed && (this.checked = Ae.target.checked, this.$emit("change", this.checked));
  }
}
__decorateClass$i([
  attr({ mode: "boolean", attribute: "multi-select" }),
  attr({ mode: "boolean", attribute: "multiselect" })
], ObjectListRow.prototype, "multiSelect", 2);
__decorateClass$i([
  observable
], ObjectListRow.prototype, "cellsRef", 2);
__decorateClass$i([
  attr({ mode: "boolean" })
], ObjectListRow.prototype, "checked", 2);
const tm1ObjectListRow = ObjectListRow.compose({
  baseName: "object-list-row",
  template: tm1ObjectListRowTemplate,
  styles: tm1ObjectListRowStyles
}), tm1ObjectMediaStyles = css`
  :host {
    display: block;
    position: relative;
    height: 100%;
    width: fit-content;

    --background-darker: ${GDSEColorSurfaceAlt};
    --background-lighter: ${GDSEColorFillHoveredLight};
  }

  .container {
    position: relative;
    display: block;
    overflow: hidden;
    background-color: var(--background-lighter);
    border-radius: ${GDSERadiusInput};
    width: 84px;
    height: 48px;
  }

  .circle {
    display: grid;
  }

  img {
    position: absolute;
    inset: 0px;
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: all 0.25s ease-in-out 0s;
  }

  .icon {
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.25s ease-in-out 0s;
  }

  img:hover,
  .icon:hover {
    transform: ${GDSEMediaHoverTransform};
  }

  :host([shape='circle']) .container {
    border-radius: ${GDSERadiusPill};
    width: 48px;
    height: 48px;
  }

  :host([shape='circle'][size='xsmall']) .icon {
    padding: 2px;
  }

  :host([shape='circle'][size='xsmall']) .container {
    width: 16px;
    height: 16px;
  }

  :host([shape='circle'][size='small']) .container {
    width: 24px;
    height: 24px;
  }

  :host([shape='circle'][size='medium']) .container {
    width: 48px;
    height: 48px;
  }

  :host([shape='circle'][size='large']) .container {
    width: 64px;
    height: 64px;
  }

  :host([shape='circle'][size='xlarge']) .container {
    width: 88px;
    height: 88px;
  }

  :host(:not([shape='circle'])[size='xsmall']) .container {
    width: 40px;
    height: 24px;
  }

  :host(:not([shape='circle'])[size='small']) .container {
    width: 56px;
    height: 32px;
  }

  :host(:not([shape='circle'])[size='medium']) .container {
    width: 84px;
    height: 48px;
  }

  :host(:not([shape='circle'])[size='large']) .container {
    width: 112px;
    height: 64px;
  }

  :host(:not([shape='circle'])[size='xlarge']) .container {
    width: 156px;
    height: 88px;
  }

  :host([size='custom']) {
    width: auto;
    height: auto;
  }

  :host([size='custom']) .container {
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
  }

  :host([shape='circle']) .container {
    aspect-ratio: 1 / 1;
  }

  :host([size='custom']) .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: ${GDSERadiusPill};
    background-color: var(--background-darker)
  }

  :host([size='custom']) img {
    width: 100%;
    height: 100%;
  }
`, tm1ObjectMediaTemplate = (td) => html`
  <template>
    <span class="container" part="container" data-testid="container">
      <div class="icon" part="media" data-testid="icon">
        <div class="circle">
          <${td.tagFor(Icon)}
            color="var(--gdse-s-color-text-light)"
            icon="${(Ae) => Ae.icon || "camera"}"
            size=${(Ae) => Ae.iconSize}
          />
        </div>
      </div>

      ${when(
  (Ae) => Ae.url,
  html`<img
          data-testid="img"
          part="media"
          alt="${(Ae) => Ae.alt || "object-media-image"}"
          src="${(Ae) => Ae.url}"
          loading="lazy"
          onerror="this.style.display='none'"
        />`
)}
    </span>
  </template>
`;
var __defProp$h = Object.defineProperty, __getOwnPropDesc$h = Object.getOwnPropertyDescriptor, __decorateClass$h = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$h(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$h(Ae, xr, id), id;
};
const ObjectMediaShape = {
  circle: "circle",
  rect: "rect"
}, ObjectMediaSize = {
  xsmall: "xsmall",
  small: "small",
  medium: "medium",
  large: "large",
  xlarge: "xlarge",
  custom: "custom"
}, ObjectMediaIconSizes = {
  xsmall: "small",
  small: "small",
  medium: "regular",
  large: "large",
  xlarge: "large"
};
class ObjectMedia extends FoundationElement {
  constructor() {
    super(...arguments), this.url = "", this.shape = ObjectMediaShape.rect, this.icon = void 0, this.size = ObjectMediaSize.medium, this.alt = void 0;
  }
  get iconSize() {
    return ObjectMediaSize.custom === this.size ? ObjectMediaIconSizes.medium : ObjectMediaIconSizes[this.size] || ObjectMediaIconSizes.medium;
  }
}
__decorateClass$h([
  attr()
], ObjectMedia.prototype, "url", 2);
__decorateClass$h([
  attr()
], ObjectMedia.prototype, "shape", 2);
__decorateClass$h([
  attr()
], ObjectMedia.prototype, "icon", 2);
__decorateClass$h([
  attr()
], ObjectMedia.prototype, "size", 2);
__decorateClass$h([
  attr()
], ObjectMedia.prototype, "alt", 2);
const tm1ObjectMedia = ObjectMedia.compose({
  baseName: "object-media",
  template: tm1ObjectMediaTemplate,
  styles: tm1ObjectMediaStyles
}), tm1ObjectTitleStyles = css`
  :host {
    width: 100%;
  }

  :host .title-container {
    padding-bottom: ${GDSESpacing75};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  :host .title-container tm1-typography {
    padding-right: ${GDSESpacing200};
  }

  :host .title-ellipsis-container {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  :host .title {
    color: ${GDSEColorText};
    overflow: hidden;
  }

  :host .title-date {
    color: ${GDSEColorText};
    text-decoration: none;
    vertical-align: top;
  }

  :host .subtitle {
    color: ${GDSEColorTextLight};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  :host([disabled]) .title,
  :host([disabled]) .title-date,
  :host([disabled]) .subtitle {
    color: ${GDSEColorTextMuted};
  }

  :host .title-link {
    text-decoration: none;
  }

  :host([href-title]) .title:hover {
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: ${GDSEColorText};
  }

  :host([disabled]) .title:hover {
    text-decoration-color: ${GDSEColorTextMuted};
  }

  :host([separated]) .title-container tm1-typography {
    flex: 1;
  }

  :host([separated]) .subtitle-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  :host .badges {
    display: flex;
    flex-wrap: wrap;
  }

  :host .badges ::slotted(tm1-badge:not(:last-child)) {
    margin-right: ${GDSESpacing100};
  }
`, tm1ObjectTitleTemplate = (td) => html`
  <template>
    <div class="title-container">
      <${td.tagFor(Typography)} tag="span" class="title-ellipsis-container" type="title-list-m">
        ${when(
  (Ae) => Ae.hrefTitle,
  html`<a tabindex="-1" data-testid="title-link" class="title-link" href="${(Ae) => Ae.hrefTitle}">
            ${when((Ae) => Ae.titleDate, html`<span class="title-date">${(Ae) => Ae.titleDate} • </span>`)}
            <span class="title">${(Ae) => Ae.title}</span>
            <slot name="object-title-title"></slot>
          </a>`
)}
        ${when(
  (Ae) => !Ae.hrefTitle,
  html`
            ${when((Ae) => Ae.titleDate, html`<span class="title-date">${(Ae) => Ae.titleDate} • </span>`)}
            <span class="title">${(Ae) => Ae.title}</span>
            <slot name="object-title-title"></slot>
          `
)}
      </${td.tagFor(Typography)}>

      <div class="badges">
        <slot name="object-title-badge"></slot>
      </div>
    </div>

    <div class="subtitle-container">
      <${td.tagFor(Typography)} tag="span" class="subtitle" type="subtitle-list-m">
        <span class="subtitle">${(Ae) => Ae.subtitle}</span>
        <slot name="object-title-subtitle"></slot>
      </${td.tagFor(Typography)}>

      <${td.tagFor(Typography)} tag="span" class="subtitle" type="subtitle-list-m">
        <span>${(Ae) => Ae.secondSubtitle}</span>
        <slot name="object-title-second-subtitle"></slot>
      </${td.tagFor(Typography)}>
    </div>
  </template>
`;
var __defProp$g = Object.defineProperty, __getOwnPropDesc$g = Object.getOwnPropertyDescriptor, __decorateClass$g = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$g(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$g(Ae, xr, id), id;
};
class ObjectTitle extends FoundationElement {
  constructor() {
    super(...arguments), this.title = "", this.titleDate = "", this.subtitle = "", this.secondSubtitle = "", this.disabled = !1, this.separated = !1;
  }
}
__decorateClass$g([
  attr()
], ObjectTitle.prototype, "title", 2);
__decorateClass$g([
  attr({ attribute: "titledate" }),
  attr({ attribute: "title-date" })
], ObjectTitle.prototype, "titleDate", 2);
__decorateClass$g([
  attr({ attribute: "hreftitle" }),
  attr({ attribute: "href-title" })
], ObjectTitle.prototype, "hrefTitle", 2);
__decorateClass$g([
  attr()
], ObjectTitle.prototype, "subtitle", 2);
__decorateClass$g([
  attr({ attribute: "secondsubtitle" }),
  attr({ attribute: "second-subtitle" })
], ObjectTitle.prototype, "secondSubtitle", 2);
__decorateClass$g([
  attr({ mode: "boolean" })
], ObjectTitle.prototype, "disabled", 2);
__decorateClass$g([
  attr({ mode: "boolean" })
], ObjectTitle.prototype, "separated", 2);
const tm1ObjectTitle = ObjectTitle.compose({
  baseName: "object-title",
  template: tm1ObjectTitleTemplate,
  styles: tm1ObjectTitleStyles
});
designSystem.register(
  tm1ObjectBadges(),
  tm1ObjectDate(),
  tm1ObjectHeader(),
  tm1ObjectInlineActions(),
  tm1ObjectList(),
  tm1ObjectListCell(),
  tm1ObjectListExpandableRow(),
  tm1ObjectListExpandableRowAction(),
  tm1ObjectListHeader(),
  tm1ObjectListRow(),
  tm1ObjectMedia(),
  tm1ObjectTitle()
);
const tm1OptionsHeaderStyles = () => css`
  :host {
    cursor: default;
  }

  .label {
    padding:  var(--padding, ${GDSESpacingListVerS} ${GDSESpacingListHorS});
    color: ${GDSEColorTextLight};
    text-transform: uppercase;
  }
`, tm1OptionsHeaderTemplate = (td) => html`
  <${td.tagFor(Typography)} type="label-container-m" class="label" data-testid="label-container">
    <label ?hidden="${(Ae) => !Ae.label}" data-testid="label">${(Ae) => Ae.label}</label>
    <slot></slot>
  </${td.tagFor(Typography)}>
`;
var __defProp$f = Object.defineProperty, __getOwnPropDesc$f = Object.getOwnPropertyDescriptor, __decorateClass$f = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$f(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$f(Ae, xr, id), id;
};
class OptionsHeader extends FoundationElement {
  constructor() {
    super(...arguments), this.label = "";
  }
}
__decorateClass$f([
  attr()
], OptionsHeader.prototype, "label", 2);
const tm1OptionsHeader = OptionsHeader.compose({
  baseName: "options-header",
  template: tm1OptionsHeaderTemplate,
  styles: tm1OptionsHeaderStyles
});
designSystem.register(
  tm1OptionsHeader()
);
const tm1OptionsGroupStyles = () => css`
  slot {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
  }
`, tm1OptionsGroupTemplate = (td) => html`
  <${td.tagFor(OptionsHeader)} label=${(Ae) => Ae.label}></${td.tagFor(OptionsHeader)}>
  <slot data-testid="options"></slot>
`;
var __defProp$e = Object.defineProperty, __getOwnPropDesc$e = Object.getOwnPropertyDescriptor, __decorateClass$e = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$e(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$e(Ae, xr, id), id;
};
class OptionsGroup extends FoundationElement {
  constructor() {
    super(...arguments), this.label = "";
  }
}
__decorateClass$e([
  attr()
], OptionsGroup.prototype, "label", 2);
const tm1OptionsGroup = OptionsGroup.compose({
  baseName: "options-group",
  template: tm1OptionsGroupTemplate,
  styles: tm1OptionsGroupStyles,
  shadowOptions: {
    mode: "open"
  }
});
designSystem.register(
  tm1OptionsGroup()
);
const tm1PageFooterStyles = () => css`
  :host {
    background: ${GDSEColorBackground};
    padding: ${GDSESpacing300};
    display: flex;
    align-items: center;
    justify-content: end;
    gap: ${GDSESpacing250};
  }
`, tm1PageFooterTemplate = () => html`
  <template>
    <slot></slot>
  </template>
`;
class PageFooter extends FoundationElement {
}
const tm1PageFooter = PageFooter.compose({
  baseName: "page-footer",
  baseClass: FoundationElement,
  template: tm1PageFooterTemplate,
  styles: tm1PageFooterStyles
});
designSystem.register(
  tm1PageFooter()
);
const tm1ProgressStyles = css`
  ${display("flex")} :host {
    align-items: center;
    outline: none;
    height: 4px;
    margin: 4px 0;
  }

  .progress {
    background-color: #ededed;
    border-radius: 4px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }

  .determinate {
    background-color: #ededed;
    border-radius: 4px;
    height: 100%;
    transition: all 0.2s ease-in-out;
    display: flex;
  }

  .indeterminate {
    height: 100%;
    border-radius: 4px;
    display: flex;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .indeterminate-indicator-1 {
    position: absolute;
    opacity: 0;
    height: 100%;
    background-color: #024cdf;
    border-radius: 4px;
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
    width: 40%;
    animation: indeterminate-1 2s infinite;
  }

  .indeterminate-indicator-2 {
    position: absolute;
    opacity: 0;
    height: 100%;
    background-color: #024cdf;
    border-radius: 4px;
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
    width: 60%;
    animation: indeterminate-2 2s infinite;
  }

  :host([paused]) .indeterminate-indicator-1,
  :host([paused]) .indeterminate-indicator-2 {
    animation-play-state: paused;
    background-color: #ededed;
  }

  :host([paused]) .determinate {
    background-color: #767676;
  }

  @keyframes indeterminate-1 {
    0% {
      opacity: 1;
      transform: translateX(-100%);
    }
    70% {
      opacity: 1;
      transform: translateX(300%);
    }
    70.01% {
      opacity: 0;
    }
    100% {
      opacity: 0;
      transform: translateX(300%);
    }
  }

  @keyframes indeterminate-2 {
    0% {
      opacity: 0;
      transform: translateX(-150%);
    }
    29.99% {
      opacity: 0;
    }
    30% {
      opacity: 1;
      transform: translateX(-150%);
    }
    100% {
      transform: translateX(166.66%);
      opacity: 1;
    }
  }
`.withBehaviors(
  forcedColorsStylesheetBehavior(css`
    .progress {
      forced-color-adjust: none;
      background-color: ${SystemColors.Field};
      box-shadow: 0 0 0 1px inset ${SystemColors.FieldText};
    }
    .determinate,
    .indeterminate-indicator-1,
    .indeterminate-indicator-2 {
      forced-color-adjust: none;
      background-color: ${SystemColors.FieldText};
    }
    :host([paused]) .determinate,
    :host([paused]) .indeterminate-indicator-1,
    :host([paused]) .indeterminate-indicator-2 {
      background-color: ${SystemColors.GrayText};
    }
  `)
);
class Progress extends BaseProgress {
}
const tm1Progress = Progress.compose({
  baseName: "progress",
  baseClass: BaseProgress,
  template: progressTemplate,
  styles: tm1ProgressStyles,
  shadowOptions: {
    delegatesFocus: !0
  },
  indeterminateIndicator1: `
    <span class="indeterminate-indicator-1" part="indeterminate-indicator-1"></span>
  `,
  indeterminateIndicator2: `
    <span class="indeterminate-indicator-2" part="indeterminate-indicator-2"></span>
  `
});
designSystem.register(
  tm1Progress()
);
const tm1RadioStyles = () => css`
  ${display("grid")}
  :host {
    grid-template: auto / fit-content(0px) auto;
    gap: ${GDSESpacing100};
    --input-size: 16px;
    outline: none;
    user-select: none;
    position: relative;
    transition: all 0.2s ease-in-out;
    margin-left: calc(${GDSESpacing100} * -2);
    padding: ${GDSESpacing0} ${GDSESpacing100} ${GDSESpacing0} ${GDSESpacing200};
  }

  .label-description {
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
  }

  .description {
    color: ${GDSEColorTextLight};
  }

  .error {
    color: ${GDSEColorTextCritical};
    display: flex;
    align-items: center;
    margin-top: ${GDSESpacing50};
    gap: ${GDSESpacing50};
  }

  :host([hidedescription]) .description {
    display: none;
  }

  :host([size='small']) {
    gap: ${GDSESpacing75};
  }

  :host([size='medium']) {
    --input-size: 18px;
    gap: ${GDSESpacing100};
  }

  :host([size='large']) {
    --input-size: 20px;
    gap: ${GDSESpacing100};
  }

  :host([iscentered]) .control {
    margin-top: auto;
    margin-bottom: auto;
  }

  .control {
    display: grid;
    align-self: self-start;
    position: relative;
    width: var(--input-size);
    height: var(--input-size);
    box-sizing: border-box;
    border-radius: ${GDSERadiusPill};
    border: 1px solid ${GDSEColorBorderInputDefault};
    outline: none;
    cursor: pointer;
  }

  .label {
    color: ${GDSEColorText};
    cursor: pointer;
    line-height: 16px;
  }

  .label__hidden {
    display: none;
    visibility: hidden;
  }

  .checked-indicator {
    position: absolute;
    width: 50%;
    height: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: ${GDSERadiusPill};
    background: ${GDSEColorFillInput};
    fill: ${GDSEColorFillInput};
    opacity: 0;
    pointer-events: none;
  }

  @-moz-document url-prefix() {
    .checked-indicator {
      width: 55%;
      height: 55%;
    }
  }

  :host(:not([disabled]):not([readonly])) .control {
    background: transparent;
    border: 1px solid ${GDSEColorBorderInputDefault};
    transition: 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  }

  :host([aria-checked='true']:not([disabled])) .control,
  :host([aria-checked='true']:not([disabled]):not([readonly]):focus) .control {
    background: ${GDSEColorFillPrimary};
    border: 1px solid ${GDSEColorBorderInfo};
    transition: 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
  }

  :host(:not([disabled]):not([readonly])) .control:hover {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host([disabled]) .label,
  :host([disabled]) .description {
    color: ${GDSEColorTextDisabled};
  }

  :host([disabled]) .label,
  :host([readonly]) .label,
  :host([readonly]) .control,
  :host([disabled]) .control {
    cursor: not-allowed;
  }

  :host([aria-checked='true']) .checked-indicator,
  :host(:not([disabled]):not([readonly])[aria-checked='false']) .control:active .checked-indicator {
    opacity: 1;
  }

  :host([disabled]) .control,
  :host([aria-checked='true'][disabled]) .control {
    border-color: ${GDSEColorBorderInputDisabled};
  }

  :host([aria-checked='true'][disabled]) .control {
    background: ${GDSEColorFillDisabled};
  }

  :host(:not([disabled]):not([readonly]):not(:focus)) .control:active {
    border-width: 3px;
    background: ${GDSEColorFillInputSelected};
    border-color: ${GDSEColorFillInputSelected};
  }

  :host(:not([disabled]):not([readonly]):focus) .control:after,
  :host(:not([disabled]):not([readonly])[size='medium']:focus) .control:before,
  :host(:not([disabled]):not([readonly])[size='large']:focus) .control:before {
    content: '';
    position: absolute;
    border-radius: ${GDSERadiusPill};
  }

  :host(:not([disabled]):not([readonly]):focus) .control:after {
    inset: -5px;
    border: 2px solid ${GDSEColorBorderPrimary};
  }

  :host(:not([disabled]):not([readonly])[size='medium']:focus) .control:before,
  :host(:not([disabled]):not([readonly])[size='large']:focus) .control:before {
    background: ${GDSEColorFillInput};
  }

  :host(:not([disabled]):not([readonly])[size='medium']:focus) .control:before {
    top: 5px;
    left: 5px;
    height: 6px;
    width: 6px;
  }

  :host(:not([disabled]):not([readonly])[size='large']:focus) .control:before {
    top: 6px;
    left: 6px;
    height: 7px;
    width: 7px;
  }

  :host(:not([disabled]):not([readonly])[size='medium']:focus) .control:after,
  :host(:not([disabled]):not([readonly])[size='large']:focus) .control:after {
    inset: -5px;
  }

  :host(:not([disabled]):not([readonly])[has-error]) .control {
    border-color: ${GDSEColorBorderCritical};
  }

  :host(:not([disabled]):not([readonly])[has-error]:focus) .control:after {
    border-color: ${GDSEColorFillInputSelected};
  }

  :host(:not([disabled]):not([readonly])[has-error]) .control:hover,
  :host([aria-checked='true']:not([disabled]):not([readonly])[has-error]) .control:hover {
    border-color: ${GDSEColorFillCriticalHovered};
  }

  :host([aria-checked='true']:not([disabled]):not([readonly])[has-error]) .control,
  :host(:not([disabled]):not([readonly])[has-error]:focus) .control {
    background-color: transparent;
    border-color: ${GDSEColorBorderCritical};
  }

  :host(:not([disabled]):not([readonly]):not(:focus)[has-error]) .control:active {
    background: transparent;
    border-color: ${GDSEColorFillCriticalPressed};
  }
`, renderError$1 = (td) => when(
  (Ae) => !!Ae.error && !Ae.disabled,
  html`
    <div class="error" data-testid="error-container">
      <${td.tagFor(Icon)} icon="errorSolid" size="small" aria-label="alert-icon"></${td.tagFor(Icon)}>
        <${td.tagFor(Typography)}
        tag="span"
        type="label-helpertext-regular"
        id="${(Ae) => Ae.errorDefaultId()}"
        role="alert"
      >
        ${(Ae) => Ae.error}
      </${td.tagFor(Typography)}>
    </div>
  `
), tm1RadioTemplate = (td) => html`
    <template
      id="${(Ae) => Ae.defaultId()}"
      role="radio"
      tabindex="${(Ae) => Ae.disabled ? -1 : "0"}"
      aria-checked="${(Ae) => Ae.checked}"
      aria-disabled="${(Ae) => Ae.disabled}"
      aria-errormessage="${(Ae) => Ae.errorDefaultId()}"
      aria-invalid="${(Ae) => !!Ae.error || Ae.required && !Ae.checked}"
      aria-required="${(Ae) => Ae.required}"
      ?has-error="${(Ae) => !!Ae.error}"
      @keypress="${(Ae, xr) => Ae.keypressHandler(xr.event)}"
      @click="${(Ae) => Ae.clickHandler()}"
      @change="${(Ae, xr) => Ae.changeHandler(xr.event)}"
    >
      <div part="control" class="control" data-testid="control">
        <div part="checked-indicator" class="checked-indicator"></div>
      </div>

      <div class="label-description">
        <${td.tagFor(Typography)}
          tag="label"
          part="label"
          class="${(Ae) => Ae.labelClasses}"
          data-testid="label"
          type="${(Ae) => Ae.size === "large" ? "body-l" : "body-m"}"
        >
          <slot
            ${slotted({
  property: "defaultSlottedNodes",
  filter: whitespaceFilter
})}
          ></slot>
        </${td.tagFor(Typography)}>

        <${td.tagFor(Typography)}
          tag="span"
          type="label-helpertext-regular"
          class="description"
        >
          <slot name="description"></slot>
        </${td.tagFor(Typography)}>

        ${renderError$1(td)}
      </div>
    </template>
  `;
var __defProp$d = Object.defineProperty, __getOwnPropDesc$d = Object.getOwnPropertyDescriptor, __decorateClass$d = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$d(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$d(Ae, xr, id), id;
};
const RadioSize = {
  small: "small",
  medium: "medium",
  large: "large"
};
class Radio extends Radio$1 {
  constructor() {
    var Ae;
    super(...arguments), this.error = "", this.isCentered = !1, this.hideDescription = !1, this.readOnly = !1, this.size = "small", this.labelClasses = ((Ae = this.label) == null ? void 0 : Ae.innerHTML) !== "" ? "label" : "label label__hidden", this.textType = () => ({ small: "body-m", large: "body-l" }), this.firstRender = !0, this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`;
  }
  clickHandler() {
    !this.disabled && !this.readOnly && (this.firstRender = !1, this.checked = !0, this.$emit("input"));
  }
  changeHandler(Ae) {
    this.firstRender && this.checked && (Ae.stopPropagation(), this.firstRender = !1);
  }
}
__decorateClass$d([
  attr()
], Radio.prototype, "error", 2);
__decorateClass$d([
  attr({ mode: "boolean", attribute: "is-centered" }),
  attr({ mode: "boolean", attribute: "iscentered" })
], Radio.prototype, "isCentered", 2);
__decorateClass$d([
  attr({ mode: "boolean", attribute: "hide-description" }),
  attr({ mode: "boolean", attribute: "hidedescription" })
], Radio.prototype, "hideDescription", 2);
__decorateClass$d([
  attr({ mode: "boolean", attribute: "read-only" }),
  attr({ mode: "boolean", attribute: "readonly" })
], Radio.prototype, "readOnly", 2);
__decorateClass$d([
  attr()
], Radio.prototype, "size", 2);
__decorateClass$d([
  observable
], Radio.prototype, "label", 2);
const tm1Radio = Radio.compose({
  baseName: "radio",
  baseClass: Radio$1,
  template: tm1RadioTemplate,
  styles: tm1RadioStyles
});
designSystem.register(
  tm1Radio()
);
const tm1RadioGroupStyles = () => css`
  :host {
    display: flex;
    flex-direction: column;
  }

  .container {
    display: flex;
    flex-direction: row;
    gap: ${GDSESpacing300};
  }

  .positioning-region {
    display: flex;
    flex-direction: row;
    gap: ${GDSESpacing400};
  }

  :host([orientation='vertical']) .positioning-region {
    flex-direction: column;
    gap: ${GDSESpacing50};
  }

  :host([orientation='vertical']) .container {
    flex-direction: column;
    gap: ${GDSESpacing100};
  }

  .error {
    color: ${GDSEColorTextCritical};
    display: flex;
    align-items: center;
    margin-top: ${GDSESpacing100};
    gap: ${GDSESpacing50};
  }

  :host ::slotted(tm1-radio) {
    margin-bottom: 0;
  }
`, RadioGroupOrientation = Orientation, renderError = (td) => when(
  (Ae) => !!Ae.error && !Ae.readOnly && !Ae.disabled,
  html`
    <div class="error" data-testid="error-container">
      <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
        <${td.tagFor(Typography)}
        type="label-helpertext-regular"
        id="${(Ae) => Ae.errorDefaultId()}"
        role="alert"
      >
        ${(Ae) => Ae.error}
      </${td.tagFor(Typography)}>
    </div>
  `
), tm1RadioGroupTemplate = (td) => html`
    <template
      id="${(Ae) => Ae.defaultId()}"
      role="radiogroup"
      tabindex="${(Ae) => Ae.disabled ? -1 : 0}"
      aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
      aria-readonly="${(Ae) => {
  var xr;
  return (xr = Ae.readOnly) != null ? xr : !1;
}}"
      aria-orientation="${(Ae) => Ae.orientation}"
      aria-errormessage="${(Ae) => Ae.errorDefaultId()}"
      @click="${(Ae, xr) => Ae.clickHandler(xr.event)}"
      @keydown="${(Ae, xr) => Ae.keydownHandler(xr.event)}"
      @focusout="${(Ae, xr) => Ae.focusOutHandler(xr.event)}"
    >
      <div class="container">
        <${td.tagFor(Typography)} type="label-helpertext-highemphasis" class="label" role="label">
          <slot name="label"></slot>
        </${td.tagFor(Typography)}>

        <div
          class="positioning-region ${(Ae) => Ae.orientation === RadioGroupOrientation.horizontal ? "horizontal" : "vertical"}"
          part="positioning-region"
          data-testid="positioning-region"
        >
          <slot
            ${slotted({
  flatten: !0,
  property: "slottedRadioButtons",
  filter: elements()
})}
          ></slot>
        </div>
      </div>

      ${renderError(td)}
    </template>
  `;
var __defProp$c = Object.defineProperty, __getOwnPropDesc$c = Object.getOwnPropertyDescriptor, __decorateClass$c = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$c(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$c(Ae, xr, id), id;
};
class RadioGroup extends RadioGroup$1 {
  constructor() {
    super(...arguments), this.error = "", this.readOnly = !1, this.size = "small", this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`;
  }
}
__decorateClass$c([
  attr()
], RadioGroup.prototype, "error", 2);
__decorateClass$c([
  attr({ mode: "boolean", attribute: "read-only" }),
  attr({ mode: "boolean", attribute: "readonly" })
], RadioGroup.prototype, "readOnly", 2);
__decorateClass$c([
  attr()
], RadioGroup.prototype, "size", 2);
const tm1RadioGroup = RadioGroup.compose({
  baseName: "radio-group",
  baseClass: RadioGroup$1,
  template: tm1RadioGroupTemplate,
  styles: tm1RadioGroupStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1RadioGroup()
);
const tm1SearchStyles = () => css`
    ${tm1TextFieldStyles()}

    :host {
      display: inline-block;
      outline: none;
      user-select: none;
      width: 100%;
      ${searchSizeRegular}
    }

    :host([size]) .root {
      width: max-content;
    }

    .label {
      display: block;
      color: ${GDSEColorText};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: ${GDSESpacing25};
      line-height: ${GDSELineHeightBody};
    }

    input {
      width: 100%;
      border: none;
      outline: none;
    }

    :host input[type='search']::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }

    button {
      padding: 0;
    }

    .search-icon {
      display: flex;
      margin: auto;
    }

    .clear-icon {
      display: flex;
      margin: auto;
    }

    .clear-button {
      background: transparent;
      color: ${GDSEColorTextLight};
      fill: ${GDSEColorTextLight};
      border: none;
      outline: none;
      padding: ${GDSESpacing0};
    }

    .clear-button:not([disabled]):not([readonly]):hover {
      cursor: pointer;
      fill: ${GDSEColorText};
      color: ${GDSEColorText};
    }

    :host ::part(root) {
      border: solid 1px ${GDSEColorBorderInputDefault};
      padding: var(--padding);
    }

  .search-typography {
    width: inherit;
  }
  `, searchSizeRegular = cssPartial`
  --input-size: 36px;
  --padding-vertical: ${GDSESpacingInputVerM};
  --padding: ${GDSESpacingInputVerM} ${GDSESpacingInputHorM};
`, tm1SearchTemplate = (td) => html`
  <template role="search">
    ${when(
  (Ae) => Ae.hasLabel(),
  html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="label">
        <label part="label" for="${(Ae) => Ae.defaultId()}">
          ${(Ae) => Ae.label ? Ae.label : html`<slot ${slotted("defaultSlottedNodes")}></slot>`}
        </label>
      </${td.tagFor(Typography)}>`
)}

    <div class="container">
      <div class="root" part="root" ${ref("root")} data-testid="root">
        <div class="control" part="control">

        <slot name="start">
          <${td.tagFor(Icon)}
            class="search-icon"
            icon="search"
            size="small"
            color="var(--gdse-s-color-text-light)"
            part="search-icon"
          >
          </${td.tagFor(Icon)}>
        </slot>

  <${td.tagFor(Typography)} data-testid="input-Typography" type="${(Ae) => {
  var xr;
  return `${Ae.textType()[(xr = Ae.inputSize) != null ? xr : "regular"]}`;
}}" class="search-typography" >
    <input
            id="${(Ae) => Ae.defaultId()}"
            class="${(Ae) => `${Ae.className}`}"
            aria-atomic="${(Ae) => {
  var xr;
  return (xr = Ae.ariaAtomic) != null ? xr : !1;
}}"
            aria-busy="${(Ae) => {
  var xr;
  return (xr = Ae.ariaBusy) != null ? xr : !1;
}}"
            aria-controls="${(Ae) => {
  var xr;
  return (xr = Ae.ariaControls) != null ? xr : Ae.defaultId();
}}"
            aria-current="${(Ae) => {
  var xr;
  return (xr = Ae.ariaCurrent) != null ? xr : null;
}}"
            aria-describedby="${(Ae) => Ae.ariaDescribedby}"
            aria-details="${(Ae) => Ae.ariaDetails}"
            aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled || Ae.disabled) != null ? xr : !1;
}}"
            aria-flowto="${(Ae) => Ae.ariaFlowto}"
            aria-haspopup="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHaspopup) != null ? xr : !1;
}}"
            aria-hidden="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHidden) != null ? xr : !1;
}}"
            aria-invalid="${(Ae) => {
  var xr;
  return (xr = Ae.ariaInvalid) != null ? xr : !1;
}}"
            aria-keyshortcuts="${(Ae) => Ae.ariaKeyshortcuts}"
            aria-label="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLabel || Ae.label) != null ? xr : "";
}}"
            aria-labelledby="${(Ae) => Ae.ariaLabelledby}"
            aria-live="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLive) != null ? xr : !1;
}}"
            aria-owns="${(Ae) => Ae.ariaOwns}"
            aria-relevant="${(Ae) => {
  var xr;
  return (xr = Ae.ariaRelevant) != null ? xr : "additions text";
}}"
            aria-roledescription="${(Ae) => Ae.ariaRoledescription}"
            ?autofocus="${(Ae) => {
  var xr;
  return (xr = Ae.autofocus) != null ? xr : !1;
}}"
            ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
            ?readonly="${(Ae) => {
  var xr;
  return (xr = Ae.readOnly) != null ? xr : !1;
}}"
            ?required="${(Ae) => {
  var xr;
  return (xr = Ae.required) != null ? xr : !1;
}}"
            ?spellcheck="${(Ae) => {
  var xr;
  return (xr = Ae.spellcheck) != null ? xr : !1;
}}"
            list="${(Ae) => Ae.list}"
            maxlength="${(Ae) => Ae.maxlength}"
            minlength="${(Ae) => Ae.minlength}"
            name="${(Ae) => Ae.name}"
            pattern="${(Ae) => Ae.pattern}"
            placeholder="${(Ae) => {
  var xr;
  return (xr = Ae.placeholder) != null ? xr : "";
}}"
            role="searchbox"
            size="${(Ae) => Ae.size}"
            type="search"
            value="${(Ae) => {
  var xr;
  return (xr = Ae.value) != null ? xr : "";
}}"
            @input="${(Ae) => Ae.handleTextInput()}"
            @change="${(Ae) => Ae.handleChange()}"
            @blur="${(Ae) => Ae.handleBlur()}"
            ${ref("control")}
          />
        </${td.tagFor(Typography)}>
          <slot name="close-button">
            <button
              class="clear-button"
              part="clear-button"
              aria-label="button-clear"
              aria-hidden="${(Ae) => Ae.value === ""}"
              ?hidden="${(Ae) => Ae.value === ""}"
              ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled || Ae.readOnly) != null ? xr : !1;
}}"
              tabindex="-1"
              role="button"
              @click=${(Ae) => Ae.handleClearInput()}
              data-testid="clear-button"
            >
            <slot name="close-glyph">
              <${td.tagFor(Icon)}
                class="clear-icon"
                icon="clear"
                size="small"
                color="inherit"
              ></${td.tagFor(Icon)}>
              </slot>
            </button>
          </slot>
          <slot name="end"></slot>
        </div>
        </div>
      </div>
    </div>
</template>`;
var __defProp$b = Object.defineProperty, __getOwnPropDesc$b = Object.getOwnPropertyDescriptor, __decorateClass$b = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$b(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$b(Ae, xr, id), id;
};
const SearchInputVariant = {
  outline: "outline"
};
class Search extends Search$1 {
  constructor() {
    super(...arguments), this.inputSize = "regular", this.variant = SearchInputVariant.outline, this.hasLabel = () => {
      var Ae;
      return this.label || ((Ae = this.defaultSlottedNodes) == null ? void 0 : Ae.length) !== 0;
    }, this.defaultId = () => this.id !== "" ? this.id : "control", this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" });
  }
  valueChanged(Ae, xr) {
    var id, od;
    super.valueChanged(Ae, xr);
    const ed = ((od = (id = this.control) == null ? void 0 : id.checkValidity()) != null ? od : !0) === !1;
    DOM.queueUpdate(() => {
      this.control && (this.control.value = xr), this.classList.toggle("invalid", ed);
    });
  }
  handleClearInput() {
    super.handleClearInput(), this.control.value = "", this.$emit("input");
  }
  handleBlur() {
    this.$emit("blur");
  }
  formResetCallback() {
    super.formResetCallback(), this.control.value = "";
  }
}
__decorateClass$b([
  attr()
], Search.prototype, "inputSize", 2);
__decorateClass$b([
  attr()
], Search.prototype, "variant", 2);
__decorateClass$b([
  attr()
], Search.prototype, "label", 2);
const tm1Search = Search.compose({
  baseName: "search",
  baseClass: Search$1,
  template: tm1SearchTemplate,
  styles: tm1SearchStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Search()
);
const tm1SegmentedControlStyles = css`
  :host {
    display: flex;
    align-items: flex-start;
    padding: ${GDSESpacing50};
    border-radius: ${GDSEBorderRadius75};
    outline: 1px solid ${GDSEColorBorder};
    background: ${GDSEColorSurface};
    width: max-content;
  }

  :host(:focus-visible) {
    outline: -webkit-focus-ring-color auto 1px;
  }
`, tm1SegmentedControlTemplate = () => html`
    <template
      aria-label="${(td) => {
  var Ae;
  return (Ae = td.ariaLabel) != null ? Ae : "";
}}"
      tabindex="0"
      options="${(td) => {
  var Ae;
  return (Ae = td.slottedSegmentControls) == null ? void 0 : Ae.length;
}}"
      @click=${(td, Ae) => td.clickHandler(Ae.event)}
      @keydown="${(td, Ae) => td.keydownHandler(Ae.event)}"
    >
      <slot ${slotted("slottedSegmentControls")}></slot>
    </template>
  `;
var __defProp$a = Object.defineProperty, __getOwnPropDesc$a = Object.getOwnPropertyDescriptor, __decorateClass$a = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$a(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$a(Ae, xr, id), id;
};
const SegmentedControlSize = {
  medium: "medium",
  large: "large"
};
class SegmentedControl extends FoundationElement {
  constructor() {
    super(...arguments), this.size = SegmentedControlSize.medium, this.activeIndex = 0;
  }
  get value() {
    return Observable.track(this, "value"), this._value;
  }
  set value(Ae) {
    var ed, id;
    const xr = `${this._value}`;
    this.$fastController.isConnected && this.slottedSegmentControls && ((ed = this.slottedSegmentControls) == null ? void 0 : ed.length) > 0 && ((id = this.slottedSegmentControls) == null || id.forEach((od, ad) => {
      this.activeIndex = od.value === Ae ? ad : this.activeIndex, od.selected = od.value === Ae;
    })), xr !== Ae && (this._value = Ae, Observable.notify(this, "value"), this.updateValue(!0));
  }
  clickHandler(Ae) {
    const xr = Ae.target.closest("tm1-segment-control");
    if (!(xr && xr.disabled || !xr))
      return this.value = xr.value, !0;
  }
  keydownHandler(Ae) {
    var ed, id, od, ad, rd, sd;
    switch (Ae.key || Ae.key.charCodeAt(0)) {
      case keySpace:
      case keyEnter: {
        Ae.preventDefault(), this.slottedSegmentControls && this.slottedSegmentControls.length > 0 && (this.value = this.slottedSegmentControls[this.activeIndex].value);
        break;
      }
      case keyTab: {
        Ae.preventDefault(), this.slottedSegmentControls && ((ed = this.slottedSegmentControls) != null && ed.length) && ((id = this.slottedSegmentControls) == null || id.forEach((nd, cd) => {
          cd === this.activeIndex && nd.focus();
        }));
        break;
      }
      case keyArrowLeft: {
        Ae.preventDefault(), this.slottedSegmentControls && ((od = this.slottedSegmentControls) != null && od.length) && (this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : this.activeIndex, (ad = this.slottedSegmentControls) == null || ad.forEach((nd, cd) => {
          nd.disabled || (nd.selected = cd === this.activeIndex, nd.selected && (this.value = nd.value, nd.focus()));
        }));
        break;
      }
      case keyArrowRight: {
        Ae.preventDefault(), this.slottedSegmentControls && ((rd = this.slottedSegmentControls) != null && rd.length) && (this.activeIndex = this.activeIndex < this.slottedSegmentControls.length - 1 ? this.activeIndex + 1 : this.activeIndex, (sd = this.slottedSegmentControls) == null || sd.forEach((nd, cd) => {
          nd.disabled || (nd.selected = cd === this.activeIndex, nd.selected && (this.value = nd.value, nd.focus()));
        }));
        break;
      }
    }
    return !0;
  }
  updateValue(Ae = !1) {
    Ae && this.$emit("change", this, {
      bubbles: !0,
      composed: void 0
    });
  }
}
__decorateClass$a([
  attr()
], SegmentedControl.prototype, "size", 2);
__decorateClass$a([
  observable
], SegmentedControl.prototype, "slottedSegmentControls", 2);
__decorateClass$a([
  observable
], SegmentedControl.prototype, "activeIndex", 2);
const tm1SegmentedControl = SegmentedControl.compose({
  baseName: "segmented-control",
  template: tm1SegmentedControlTemplate,
  styles: tm1SegmentedControlStyles,
  shadowOptions: {
    delegatesFocus: !1
  }
}), tm1SegmentControlStyles = css`
  :host {
    display: flex;
    min-width: 36px;
    justify-content: center;
    align-items: center;
    padding: ${GDSESpacing50} ${GDSESpacing100};
    justify-content: center;
    align-items: center;
    gap: ${GDSESpacing100};
    border-radius: 4px;
    color: ${GDSEColorText};
  }

  :host(:not([disabled]):not([selected]):hover),
  :host(:not([disabled]):not([selected]):focus) {
    background: ${GDSEColorFillHovered};
  }

  :host(:focus-visible) {
    outline: -webkit-focus-ring-color auto 1px;
  }

  :host(:not([disabled]):not([selected]):active) {
    background: ${GDSEColorFillPressed};
  }

  :host .text-container {
    display: flex;
    height: 20px;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-variant-numeric: lining-nums tabular-nums;
    text-overflow: ellipsis;
  }

  :host([disabled][selected]) {
    background-color: ${GDSEColorFillDisabled};
    color: ${GDSEColorTextDisabled};
  }

  :host([selected]) {
    background-color: ${GDSEColorFillSelected};
    color: ${GDSEColorTextOnfillStrong};
  }

  :host([disabled]) {
    color: ${GDSEColorTextDisabled};
  }

  :host([icon]:not([icononly]):not([icon-only])) .icon,
  :host(:not([icon-only]):not([icononly])) ::slotted(tm1-icon),
  :host(:not([icon-only]):not([icononly])) tm1-icon  {
    margin-inline-end: ${GDSESpacing100};
  }

  ::slotted(tm1-icon),
  tm1-icon {
    height: 20px;
    width: 20px;
  }

  :host([size='large']) ::slotted(tm1-icon),
  :host([size='large']) tm1-icon {
    height: 24px;
    width: 24px;
  }

  :host([size='large']) {
    padding: var(--gdse-g-spacing-75) var(--gdse-g-spacing-150);
  }

  :host([size='large']) .text-container {
    height: 24px;
  }

  tm1-typography {
    cursor: default;
  }
`, tm1SegmentControlTemplate = (td) => html`
    <template
      aria-disabled="${(Ae) => Ae.disabled}"
      aria-label="${(Ae) => {
  var xr;
  return Ae.ariaLabel || ((xr = Ae.defaultSlottedContent) == null ? void 0 : xr.innerHTML);
}}"
      aria-posinset="${(Ae) => Ae.ariaPosInSet}"
      aria-pressed="${(Ae) => Ae.ariaPressed}"
      aria-selected="${(Ae) => Ae.selected}"
      aria-setsize="${(Ae) => Ae.ariaSetSize}"
      role="option"
      tabindex="0"
    >
      <${td.tagFor(Typography)} class="text-container" type="${(Ae) => Ae.textType()[Ae.size]}">
        <slot class="icon" name="icon">
          ${when((Ae) => Ae.icon, html`
            <${td.tagFor(Icon)} role="img" class="icon" icon="${(Ae) => Ae.icon}" size="small"></${td.tagFor(Icon)}>
          `)}
        </slot>
        ${when((Ae) => !Ae.iconOnly, html`<slot ${slotted("defaultSlottedContent")}></slot>`)}
      </${td.tagFor(Typography)}>
    </template>
  `;
var __defProp$9 = Object.defineProperty, __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor, __decorateClass$9 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$9(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$9(Ae, xr, id), id;
};
class SegmentControl extends FoundationElement {
  constructor() {
    super(...arguments), this.size = SegmentedControlSize.medium, this.selected = !1, this.disabled = !1, this.iconOnly = !1, this.textType = () => ({ medium: "body-m", large: "body-l" });
  }
  // TO DO fix accessibility with tab
}
__decorateClass$9([
  attr()
], SegmentControl.prototype, "value", 2);
__decorateClass$9([
  attr()
], SegmentControl.prototype, "size", 2);
__decorateClass$9([
  attr({ mode: "boolean" })
], SegmentControl.prototype, "selected", 2);
__decorateClass$9([
  attr({ mode: "boolean" })
], SegmentControl.prototype, "disabled", 2);
__decorateClass$9([
  attr()
], SegmentControl.prototype, "icon", 2);
__decorateClass$9([
  attr({ mode: "boolean", attribute: "icononly" }),
  attr({ mode: "boolean", attribute: "icon-only" })
], SegmentControl.prototype, "iconOnly", 2);
__decorateClass$9([
  observable
], SegmentControl.prototype, "defaultSlottedContent", 2);
const tm1SegmentControl = SegmentControl.compose({
  baseName: "segment-control",
  template: tm1SegmentControlTemplate,
  styles: tm1SegmentControlStyles
});
designSystem.register(
  tm1SegmentControl(),
  tm1SegmentedControl()
);
const tm1MultiSelectV2Styles = css`
  ${selectStyles}

  :host .control {
    display: flex;
    align-items: center;
  }

  :host([disabled]) .control {
    cursor: not-allowed;
    background-color: ${GDSEColorFillInputDisabled};
    border-color: ${GDSEColorBorderDisabled};
    color: ${GDSEColorTextDisabled};
  }

  .placeholder {
    color: ${GDSEColorTextMuted};
  }

  .selected-value {
    display: flex;
    gap: 2px;
    flex: 1 1 auto;
    min-width: calc(var(--listbox-scroll-width, 0) - 16)px;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .indicator {
    flex: 0 0 auto;
    margin-inline-start: 1em;
  }

  ::slotted(svg) {
    align-self: center;
    height: 16px;
    width: 16px;
  }

  .indicator,
  .select-indicator {
    fill: ${GDSEColorTextLight};
  }

  :host([disabled]) .indicator,
  :host([disabled]) .select-indicator {
    fill: ${GDSEColorTextDisabled};
  }

  .start,
  .end,
  .indicator,
  .select-indicator,
  ::slotted(svg) {
    height: 1em;
    min-height: 16px;
    min-width: 16px;
    width: 1em;
  }

  .start,
  .end,
  ::slotted(svg) {
    fill: currentcolor;
  }

  ::slotted([role='option']),
  ::slotted(option) {
    max-height: none;
  }
`, tm1MultiSelectV2Template = (td, Ae) => {
  var xr;
  return html`
    <template
      ${ref("triggerEl")}
      id="${(ed) => ed.defaultId()}"
      class="${(ed) => `collapsible ${ed.open ? `${ed.position} open` : ed.position} ${ed.disabled ? "disabled" : ""}`}"
      aria-activedescendant="${(ed) => ed.ariaActivedescendant}"
      aria-controls="${(ed) => ed.ariaControls}"
      aria-disabled="${(ed) => ed.disabled}"
      aria-errormessage="${(ed) => {
    var id;
    return (id = ed.ariaErrormessage) != null ? id : ed.errorDefaultId();
  }}"
      aria-expanded="${(ed) => ed.open || ed.ariaExpanded}"
      aria-haspopup="listbox"
      aria-invalid="${(ed) => ed.isInvalid()}"
      aria-multiselectable="true"
      aria-label="${(ed) => {
    var id;
    return (id = ed.ariaLabel || ed.label) != null ? id : "";
  }}"
      error="${(ed) => ed.error}"
      ?has-error="${(ed) => !!ed.error}"
      ?open="${(ed) => ed.open}"
      role="combobox"
      multiple
      tabindex="${(ed) => ed.disabled ? null : "0"}"
      @click="${(ed, id) => ed.clickHandler(id.event)}"
      @keydown="${(ed, id) => ed.keydownHandler(id.event)}"
      @mousedown="${(ed, id) => ed.mousedownHandler(id.event)}"
    >
      ${when(
    (ed) => ed.label,
    html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="label">
          <label part="label" for="input">${(ed) => ed.label}</label>
        </${td.tagFor(Typography)}>`
  )}
      <${td.tagFor(Typography)} data-testid="input-Typography" type="${(ed) => {
    var id;
    return ed.textType()[(id = ed.inputSize) != null ? id : "regular"];
  }}">
        <div
          id="input"
          class="control"
          part="control"
          ?disabled="${(ed) => ed.disabled}"
          ${ref("control")}
          role="select"
        >
          <slot name="start"></slot>
          <slot name="button-container">
            <div class="selected-value ${(ed) => ed.placeholderShown() ? "placeholder" : ""}" part="selected-value">
              <slot name="selected-value" data-testid="display-value">
                ${(ed) => ed.multipleDisplayValue}
              </slot>
            </div>
            <div aria-hidden="true" class="indicator" part="indicator">
              <slot name="indicator">${(xr = Ae.indicator) != null ? xr : ""}</slot>
            </div>
          </slot>
          <slot name="end"></slot>
        </div>
      </${td.tagFor(Typography)}>
      ${when(
    (ed) => !!ed.error && !ed.disabled,
    html`<div class="error">
          <${td.tagFor(Icon)}
            icon="errorSolid"
            size="small"
            color="var(--gdse-s-color-fill-critical)"
          ></${td.tagFor(Icon)}>
          <${td.tagFor(Typography)}
            type="label-helpertext-regular"
            tag="span"
            id="${(ed) => ed.errorDefaultId()}"
            role="alert"
          >
            ${(ed) => ed.error}
          </${td.tagFor(Typography)}>
        </div>`
  )}

      <${td.tagFor(Listbox)}
        class="listbox"
        id="${(ed) => ed.listboxId}"
        size="${(ed) => ed.size}"
        part="listbox"
        data-testid="listbox"
        ?disabled="${(ed) => ed.disabled}"
        ?enableSelectAll=${(ed) => ed.enableSelectAll}
        ?hidden="${(ed) => !ed.open}"
        aria-multiselectable="true"
        isInsideElement
        multiple
        inputSize=${(ed) => ed.inputSize}
        selectAllText=${(ed) => ed.selectAllText}
        @change=${(ed, id) => ed.childrenChangeHandler(id.event)}
        @select-all=${(ed, id) => ed.selectAll(id.event)}
        @clear-all=${(ed, id) => ed.clearAll(id.event)}
        ${ref("listbox")}
      >
        <slot name='listbox-top' slot='listbox-top'></slot>
        <slot
          ${slotted({
    filter: (ed) => (isListboxOption(ed) || isListItem(ed)) && !ed.hidden,
    flatten: !0,
    property: "slottedOptions"
  })}
        ></slot>
        <slot name='listbox-bottom' slot='listbox-bottom'></slot>
      </${td.tagFor(Listbox)}>
    </template>
  `;
};
class _Select extends Listbox {
}
class FormAssociatedSelect extends FormAssociated(_Select) {
  constructor() {
    super(...arguments), this.proxy = document.createElement("select");
  }
}
const SelectLabelPosition = {
  top: "top",
  left: "left"
}, SelectPosition = {
  above: "above",
  below: "below"
};
var __defProp$8 = Object.defineProperty, __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor, __decorateClass$8 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$8(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$8(Ae, xr, id), id;
};
class MultiSelect extends FormAssociatedSelect {
  constructor() {
    super(), this.open = !1, this.error = "", this.placeholder = "", this.inputSize = "regular", this.label = "", this.labelPosition = SelectLabelPosition.top, this.multipleItemsSelectedText = "Item(s) selected", this.ariaActivedescendant = "", this.ariaExpanded = "false", this.position = SelectPosition.below, this.size = 4, this.selectAllText = "Select All", this.placeholderShown = () => this.multipleDisplayValue === this.placeholder, this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" }), this.isInvalid = () => !!this.error || this.required && (this.values === void 0 || this.values.length === 0), this._values = [], this.fastIsInitialized = !1, this.prevChangeValues = [], this.prevInputValues = [], this.listboxId = uniqueId("listbox-"), this.childrenChangeHandler = (Ae) => {
      Ae.stopPropagation(), DOM.queueUpdate(() => {
        this.open && this.prevInputValues.toString() !== this.values.toString() && (this.$emit("input", this, {
          bubbles: !0,
          composed: void 0
        }), this.prevInputValues = this.values);
      });
    }, this.clickBehavior = new ClickBehavior();
  }
  get collapsible() {
    return !1;
  }
  /**
   * This getter calculates and track the changed of multipleDisplayValue.
   *
   * @internal
   */
  get multipleDisplayValue() {
    var Ae;
    return Observable.track(this, "multipleDisplayValue"), this._values && ((Ae = this._values) == null ? void 0 : Ae.length) > 0 && this.selectedOptions.length > 0 ? `${this.selectedOptions.length} ${this.multipleItemsSelectedText}` : this.placeholder;
  }
  /**
   * The function that notify multipleDisplayValue has changed.
   *
   * @internal
   */
  updateMultipleDisplayValue() {
    Observable.notify(this, "multipleDisplayValue");
  }
  /**
   * Sets focus and synchronizes ARIA attributes when the open property changes.
   *
   * @param prev - the previous open value
   * @param next - the current open value
   *
   * @internal
   */
  openChanged() {
    var Ae;
    if (this.open) {
      this.ariaControls = this.listboxId, DOM.queueUpdate(() => this.setPositioning()), this.focusAndScrollOptionIntoView(), DOM.queueUpdate(() => this.focus());
      return;
    }
    (Ae = this.cleanup) == null || Ae.call(this), this.ariaControls = "";
  }
  /**
   * The values property.
   *
   * @public
   */
  get values() {
    return Observable.track(this, "values"), this._values;
  }
  set values(Ae) {
    this.fastIsInitialized = !!this.length;
    const xr = [...this.querySelectorAll("tm1-option"), ...this.querySelectorAll("tm1-list-item")], ed = this.slottedOptions ? Array.from(this.slottedOptions) : [];
    if (this.options = xr.length > 0 ? xr : ed, !this.options.length)
      return;
    this.selectedOptions = this.options.filter((ad) => Ae.includes(ad.value));
    const id = typeof Ae == "string" ? Ae.split(",") : Ae, od = this.options.some((ad) => ad.value === id[0]);
    Ae !== this.placeholder && Ae.length && od ? this.options.forEach((ad) => {
      ad.selected = Ae.includes(ad.value);
    }) : this.options.forEach((ad) => {
      ad.selected = !1;
    }), this.required && Ae.length ? (this.setValidity({}), this.setFormValue(Ae.toString())) : this.setFormValue(Ae.toString()), this._values = Ae, Observable.notify(this, "values"), this.updateMultipleDisplayValue();
  }
  /**
   * Updates the values when an option's value changes.
   *
   * @param source - the source object
   * @param propertyName - the property to evaluate
   *
   * @internal
   * @override
   */
  handleChange(Ae, xr) {
    super.handleChange(Ae, xr), xr === "values" && this.updateValue();
  }
  /**
   * Sets the value and display value to match the first selected option.
   *
   * @param shouldEmit - if true, the input and change events will be emitted
   *
   * @internal
   */
  updateValue(Ae) {
    this.$fastController.isConnected && !this.fastIsInitialized && this.selectedOptions.length >= 1 && this.selectedOptions.map((xr) => xr.value).toString() !== this.values.toString() && (this.values = this.selectedOptions.map((xr) => xr.value) || [], this.prevChangeValues = this.values, this.prevInputValues = this.values), this.updateMultipleDisplayValue(), Ae && (this.$emit("change"), this.prevChangeValues = this.values, this.prevInputValues.toString() !== this.values.toString() && (this.$emit("input", this, {
      bubbles: !0,
      composed: void 0
    }), this.prevInputValues = this.values));
  }
  /**
   * Calculate and apply listbox positioning based on available viewport space.
   *
   * @public
   */
  setPositioning() {
    let Ae = 0;
    DOM.queueUpdate(async () => {
      const xr = this.listbox.getOptions(), ed = xr.length > 0 ? xr : this.slottedOptions;
      Ae = this.listbox.setMaxHeight(ed);
    }), this.cleanup = autoUpdate(this, this.listbox, async () => {
      var rd;
      const { middlewareData: xr, placement: ed, x: id, y: od } = await computePosition(
        this.control,
        this.listbox,
        {
          placement: this.position === "above" ? "top" : "bottom",
          strategy: "fixed",
          middleware: [
            flip(),
            size({
              apply: ({ rects: sd }) => {
                Object.assign(this.listbox.style, {
                  maxHeight: `${Ae}px`,
                  width: `${sd.reference.width}px`
                });
              }
            }),
            hide()
          ]
        }
      ), ad = ed === "top" ? "above" : "below";
      if (ad !== this.position && (this.position = ad), (rd = xr.hide) != null && rd.referenceHidden) {
        this.open = !1;
        return;
      }
      Object.assign(this.listbox.style, {
        position: "fixed",
        left: `${id}px`,
        top: `${od + (this.position === "below" ? 2 : -2)}px`
      });
    });
  }
  /**
   * Synchronize the `aria-disabled` property when the `disabled` property changes.
   *
   * @param prev - The previous disabled value
   * @param next - The next disabled value
   *
   * @internal
   */
  disabledChanged(Ae, xr) {
    super.disabledChanged && super.disabledChanged(Ae, xr);
  }
  /**
   * Reset the element to its first selectable option when its parent form is reset.
   *
   * @internal
   */
  formResetCallback() {
    this.setProxyOptions(), super.setDefaultSelectedOption(), this.values.length > 0 && (this.values = []);
  }
  /**
   * Handle opening and closing the listbox when the select is clicked.
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(Ae) {
    var xr, ed;
    if (!this.disabled) {
      if (this.open) {
        const id = Ae.target.closest(
          "option,[role=option]"
        );
        if (id && id.disabled)
          return;
        this.selectedIndex = this._options.findIndex((od) => od.value === (id == null ? void 0 : id.value)), id && (!this.values || this.values.length === 0 || !((xr = this._values) != null && xr.includes(id == null ? void 0 : id.value)) ? this.values = [...this._values || [], id == null ? void 0 : id.value] : this._values.length > 0 && (this.values = this._values.filter((od) => od !== (id == null ? void 0 : id.value) || !od))), ((ed = Ae.target) == null ? void 0 : ed.tagName) === "TM1-MULTI-SELECT" && this.prevChangeValues.toString() !== this.values.toString() && DOM.queueUpdate(() => {
          this.open || this.updateValue(!0);
        });
      }
      return !this.open && this.prevInputValues.toString() !== this.values.toString() && this.updateValue(!0), !0;
    }
  }
  /**
   * Handles focus state when the element or its children lose focus.
   *
   * @param e - The focus event
   * @internal
   */
  focusoutHandler(Ae) {
    var id;
    if (super.focusoutHandler(Ae), !this.open)
      return !0;
    const xr = Ae.relatedTarget;
    if (this.isSameNode(xr)) {
      this.focus();
      return;
    }
    !this.contains(xr) && !((id = this.options) != null && id.includes(xr)) && this.prevChangeValues.toString() !== this.values.toString() && this.updateValue(!0);
  }
  /**
   * Synchronize the form-associated proxy and updates the values property of the element.
   *
   * @param prev - the previous collection of slotted option elements
   * @param next - the next collection of slotted option elements
   *
   * @internal
   */
  slottedOptionsChanged(Ae, xr) {
    this.options.forEach((ed) => {
      Observable.getNotifier(ed).unsubscribe(this, "values");
    }), super.slottedOptionsChanged(Ae, xr), this.options.forEach((ed) => {
      Observable.getNotifier(ed).subscribe(this, "values");
    }), this.setProxyOptions(), this.updateValue(), this.updateMultipleDisplayValue();
  }
  /**
   * Prevents focus when size is set and a scrollbar is clicked.
   *
   * @param e - the mouse event object
   *
   * @override
   * @internal
   */
  mousedownHandler(Ae) {
    var xr;
    return Ae.offsetX >= 0 && Ae.offsetX <= ((xr = this.listbox) == null ? void 0 : xr.scrollWidth) ? super.mousedownHandler(Ae) : this.collapsible;
  }
  /**
   * Sets the multiple property on the proxy element.
   *
   * @param prev - the previous multiple value
   * @param next - the current multiple value
   */
  multipleChanged(Ae, xr) {
    super.multipleChanged(Ae, xr), this.proxy && (this.proxy.multiple = xr);
  }
  /**
   * Updates the selectedness of each option when the list of selected options changes.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @override
   * @internal
   */
  selectedOptionsChanged(Ae, xr) {
    var ed;
    super.selectedOptionsChanged(Ae, xr), (ed = this.options) == null || ed.forEach((id, od) => {
      var rd;
      const ad = (rd = this.proxy) == null ? void 0 : rd.options.item(od);
      ad && (ad.selected = id.selected);
    });
  }
  /**
   * Resets and fills the proxy to match the component's options.
   *
   * @internal
   */
  setProxyOptions() {
    this.proxy instanceof HTMLSelectElement && this.options && (this.proxy.options.length = 0, this.options.forEach((Ae) => {
      const xr = Ae.proxy || (Ae instanceof HTMLOptionElement ? Ae.cloneNode() : null);
      xr && this.proxy.options.add(xr);
    }));
  }
  manageAction(Ae) {
    var xr;
    Ae.preventDefault(), this.open ? (xr = this.activeOption) == null || xr.click() : this.open = !this.open;
  }
  /**
   * Handle keyboard interaction for the select.
   *
   * @param e - the keyboard event
   * @internal
   */
  keydownHandler(Ae) {
    super.keydownHandler(Ae);
    const xr = Ae.key || Ae.key.charCodeAt(0);
    switch (xr) {
      case keySpace: {
        this.manageAction(Ae);
        break;
      }
      case keyArrowDown: {
        Ae.preventDefault(), this.selectNextOption(), this.activeOption && (this.activeOption.ariaChecked = "true");
        break;
      }
      case keyArrowUp: {
        Ae.preventDefault(), this.selectPreviousOption(), this.activeOption && (this.activeOption.ariaChecked = "true");
        break;
      }
      case keyHome:
      case keyEnd: {
        Ae.preventDefault();
        break;
      }
      case keyEnter: {
        this.manageAction(Ae);
        break;
      }
      case keyEscape: {
        this.open && (Ae.preventDefault(), this.open = !1);
        break;
      }
      case keyTab:
        return this.open && (Ae.preventDefault(), this.open = !1), !0;
    }
    return !this.open && this.prevChangeValues.toString() !== this.values.toString() && this.updateValue(!0), xr === keyArrowDown || xr === keyArrowUp;
  }
  /**
   * Update the selected attribute to true to all enabled child options
   *
   * @public
   */
  selectAll(Ae) {
    Ae == null || Ae.stopPropagation();
    const xr = [];
    this.options.forEach((ed) => {
      ed.disabled || xr.push(ed.value);
    }), this.values = xr, this.$emit("select-all"), this.prevInputValues.toString() !== this.values.toString() && (this.$emit("input", this, {
      bubbles: !0,
      composed: void 0
    }), this.prevInputValues = this.values);
  }
  /**
   * Update the selected attribute to false to all enabled child options
   *
   * @public
   */
  clearAll(Ae) {
    Ae == null || Ae.stopPropagation(), this.values = [], this.$emit("clear-all"), this.prevInputValues.toString() !== this.values.toString() && (this.$emit("input", this, {
      bubbles: !0,
      composed: void 0
    }), this.prevInputValues = this.values);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("contentchange", this.updateMultipleDisplayValue), this.$fastController.addBehaviors([this.clickBehavior]);
  }
  disconnectedCallback() {
    var Ae;
    this.removeEventListener("contentchange", this.updateMultipleDisplayValue), (Ae = this.cleanup) == null || Ae.call(this), this.$fastController.removeBehaviors([this.clickBehavior]), super.disconnectedCallback();
  }
  /**
   * Updates the proxy's size property when the size attribute changes.
   *
   * @param prev - the previous size
   * @param next - the current size
   *
   * @override
   * @internal
   */
  sizeChanged(Ae, xr) {
    if (typeof xr != "number" || xr === 0) {
      this.size = typeof xr == "string" ? parseInt(xr) : 4;
      return;
    }
    super.sizeChanged(Ae, xr), this.proxy && (this.proxy.size = xr);
  }
  onClickOutside(Ae, xr) {
    const ed = xr.composedPath().some((id) => id.nodeName === "TM1-LISTBOX");
    this.close(this.open && !ed);
  }
  onClick(Ae, xr) {
    const ed = xr.composedPath().some((id) => id.nodeName === "TM1-LISTBOX");
    this.close(this.open && Ae === this.triggerEl && !ed && !this.collapsible, !0);
  }
  /**
   * Updates the open attribute based on the functions param
   *
   * @param toClose - if should close listbox
   * @param canOpen - if it can open the listbox
   *
   * @private
   * @internal
   */
  close(Ae, xr = !1) {
    Ae ? (this.open = !1, this.options.forEach((ed) => ed.removeAttribute("hovered"))) : xr && (this.open = !0);
  }
}
__decorateClass$8([
  attr({ mode: "boolean" })
], MultiSelect.prototype, "open", 2);
__decorateClass$8([
  attr()
], MultiSelect.prototype, "error", 2);
__decorateClass$8([
  attr()
], MultiSelect.prototype, "placeholder", 2);
__decorateClass$8([
  attr({ attribute: "inputsize" }),
  attr({ attribute: "input-size" })
], MultiSelect.prototype, "inputSize", 2);
__decorateClass$8([
  attr()
], MultiSelect.prototype, "label", 2);
__decorateClass$8([
  attr({ attribute: "labelposition" }),
  attr({ attribute: "label-position" })
], MultiSelect.prototype, "labelPosition", 2);
__decorateClass$8([
  attr({ attribute: "multipleitemsselectedtext" }),
  attr({ attribute: "multiple-items-selected-text" })
], MultiSelect.prototype, "multipleItemsSelectedText", 2);
__decorateClass$8([
  attr({ attribute: "aria-activedescendant" })
], MultiSelect.prototype, "ariaActivedescendant", 2);
__decorateClass$8([
  attr({ attribute: "aria-expanded" })
], MultiSelect.prototype, "ariaExpanded", 2);
__decorateClass$8([
  attr()
], MultiSelect.prototype, "position", 2);
__decorateClass$8([
  attr()
], MultiSelect.prototype, "size", 2);
__decorateClass$8([
  attr({ attribute: "select-all-text" }),
  attr({ attribute: "selectalltext" })
], MultiSelect.prototype, "selectAllText", 2);
__decorateClass$8([
  observable
], MultiSelect.prototype, "control", 2);
__decorateClass$8([
  volatile
], MultiSelect.prototype, "collapsible", 1);
const tm1MultiSelect = MultiSelect.compose({
  baseName: "multi-select",
  template: tm1MultiSelectV2Template,
  styles: tm1MultiSelectV2Styles,
  indicator: `
    <svg class="svg-indicator" viewBox="0 0 16 16">
      <path d="M3.278 5.459A.75.75 0 0 0 2.221 6.52l5.263 5.24a.75.75 0 0 0 1.059 0l5.237-5.24a.75.75 0 0 0-1.06-1.06l-4.71 4.711L3.278 5.46z"/>
    </svg>
  `
}), tm1SelectStyles = css`
  ${selectStyles}

  :host .control {
    display: flex;
    align-items: center;
  }

  .placeholder {
    color: ${GDSEColorTextMuted};
  }

  .selected-value {
    display: flex;
    gap: 2px;
    flex: 1 1 auto;
    min-width: calc(var(--listbox-scroll-width, 0) - 16) px;
    overflow: hidden;
    overflow-y: auto;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-height: var(--input-size);
  }

  .indicator {
    flex: 0 0 auto;
    margin-inline-start: 1em;
  }

  ::slotted(svg) {
    align-self: center;
    height: 16px;
    width: 16px;
  }

  .indicator,
  .select-indicator {
    fill: ${GDSEColorTextLight};
  }

  :host([disabled]) .indicator,
  :host([disabled]) .select-indicator {
    fill: ${GDSEColorTextDisabled};
  }

  .start,
  .end,
  .indicator,
  .select-indicator,
  ::slotted(svg) {
    height: 1em;
    min-height: 16px;
    min-width: 16px;
    width: 1em;
  }

  .start,
  .end,
  ::slotted(svg) {
    fill: currentcolor;
  }

  ::slotted([role='option']),
  ::slotted(option) {
    max-height: none;
  }
`, tm1SelectTemplate = (td, Ae) => {
  var xr;
  return html`
    <template
      ${ref("triggerEl")}
      id="${(ed) => ed.defaultId()}"
      class="${(ed) => `collapsible ${ed.open ? `${ed.position} open` : ed.position} ${ed.disabled ? "disabled" : ""}`}"
      aria-activedescendant="${(ed) => ed.ariaActivedescendant}"
      aria-controls="${(ed) => ed.ariaControls}"
      aria-disabled="${(ed) => {
    var id;
    return (id = ed.disabled) != null ? id : !1;
  }}"
      aria-expanded="${(ed) => ed.open}"
      aria-haspopup="listbox"
      aria-invalid="${(ed) => ed.isInvalid()}"
      aria-errormessage="${(ed) => {
    var id;
    return (id = ed.ariaErrormessage) != null ? id : ed.errorDefaultId();
  }}"
      error="${(ed) => ed.error}"
      ?has-error="${(ed) => !!ed.error}"
      ?open="${(ed) => ed.open}"
      role="combobox"
      tabindex="${(ed) => ed.disabled ? null : "0"}"
      @click="${(ed, id) => ed.clickHandler(id.event)}"
      @keydown="${(ed, id) => ed.keydownHandler(id.event)}"
      @mousedown="${(ed, id) => ed.mousedownHandler(id.event)}"
    >
    ${when(
    (ed) => ed.label,
    html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="label">
          <label part="label" for="input">${(ed) => ed.label}</label>
        </${td.tagFor(Typography)}>`
  )}
      <${td.tagFor(Typography)} data-testid="input-Typography" type="${(ed) => {
    var id;
    return ed.textType()[(id = ed.inputSize) != null ? id : "regular"];
  }}">
        <div
          id="input"
          class="control"
          part="control"
          ?disabled="${(ed) => ed.disabled}"
          ${ref("control")}
          role="select"
        >
          <slot name="start"></slot>
          <slot name="button-container">
            <div class="selected-value ${(ed) => ed.placeholderShown() ? "placeholder" : ""}" part="selected-value">
              <slot name="selected-value" data-testid="display-value" ${ref("displayValueBlock")}>
                ${(ed) => ed.displayValue}
              </slot>
            </div>
            <div aria-hidden="true" class="indicator" part="indicator">
              <slot name="indicator">${(xr = Ae.indicator) != null ? xr : ""}</slot>
            </div>
          </slot>
          <slot name="end"></slot>
        </div>
      </${td.tagFor(Typography)}>
      ${when(
    (ed) => !!ed.error && !ed.disabled,
    html`<div class="error">
          <${td.tagFor(Icon)}
            icon="errorSolid"
            size="small"
            color="var(--gdse-s-color-fill-critical)"
          ></${td.tagFor(Icon)}>
          <${td.tagFor(Typography)}
            type="label-helpertext-regular"
            tag="span"
            id="${(ed) => ed.errorDefaultId()}"
            role="alert"
          >
            ${(ed) => ed.error}
          </${td.tagFor(Typography)}>
        </div>`
  )}

      <${td.tagFor(Listbox)}
        aria-multiselectable="false"
        class="listbox"
        id="${(ed) => ed.listboxId}"
        size="${(ed) => ed.size}"
        part="listbox"
        data-testid="listbox"
        ?disabled="${(ed) => ed.disabled}"
        ?hidden="${(ed) => !ed.open}"
        isInsideElement
        inputSize=${(ed) => ed.inputSize}
        @change="${(ed, id) => ed.handleOptionChanged(id.event)}"
        ${ref("listbox")}
      >
        <slot slot="listbox-top" name="listbox-top"></slot>
        <slot
          ${slotted({
    filter: (ed) => (isListboxOption(ed) || isListItem(ed)) && !ed.hidden,
    flatten: !0,
    property: "slottedOptions"
  })}
        ></slot>
        <slot slot="listbox-bottom" name="listbox-bottom"></slot>
      </${td.tagFor(Listbox)}>
    </template>
  `;
};
var __defProp$7 = Object.defineProperty, __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor, __decorateClass$7 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$7(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$7(Ae, xr, id), id;
};
class Select extends FormAssociatedSelect {
  constructor() {
    super(), this.open = !1, this.error = "", this.placeholder = "", this.inputSize = "regular", this.size = 4, this.label = "", this.labelPosition = SelectLabelPosition.top, this.ariaActivedescendant = "", this.ariaExpanded = "false", this.position = SelectPosition.below, this.deprecated = !1, this.placeholderShown = () => this.displayValue === this.placeholder, this.defaultId = () => this.id !== "" ? this.id : "control", this.errorDefaultId = () => `${this.defaultId()}-error`, this.textType = () => ({ small: "body-m", regular: "body-m", large: "body-l" }), this.isInvalid = () => !!this.error || this.required && (this.value === void 0 || this.value === ""), this.validOptions = ["TM1-OPTIONS-HEADER", "TM1-OPTIONS-GROUP", "TM1-LIST-ITEMS-HEADER", "TM1-LIST-ITEMS-GROUP"], this.listboxId = uniqueId("listbox-"), this.clickBehavior = new ClickBehavior();
  }
  /**
   * Sets focus and synchronizes ARIA attributes when the open property changes.
   *
   * @param prev - the previous open value
   * @param next - the current open value
   *
   * @internal
   */
  openChanged(Ae, xr) {
    var ed;
    if (this.open) {
      this.ariaControls = this.listboxId, DOM.queueUpdate(() => this.setPositioning()), this.focusAndScrollOptionIntoView(), this.indexWhenOpened = this.selectedIndex;
      return;
    }
    (ed = this.cleanup) == null || ed.call(this), this.ariaControls = "";
  }
  get collapsible() {
    return !0;
  }
  /**
   * The value property.
   *
   * @public
   */
  get value() {
    return Observable.track(this, "value"), this._value;
  }
  set value(Ae) {
    var ed, id, od, ad, rd, sd, nd;
    const xr = `${this._value}`;
    if ((ed = this._options) != null && ed.length) {
      const cd = this._options.findIndex((dd) => dd.value === Ae), ud = (od = (id = this._options[this.selectedIndex]) == null ? void 0 : id.value) != null ? od : null, ld = (rd = (ad = this._options[cd]) == null ? void 0 : ad.value) != null ? rd : null;
      (cd === -1 || ud !== ld) && (Ae = "", this.selectedIndex = cd), Ae = (nd = (sd = this.firstSelectedOption) == null ? void 0 : sd.value) != null ? nd : Ae;
    }
    this.required && Ae && (this.setValidity({}), this.setFormValue(Ae)), xr !== Ae && (this._value = Ae, super.valueChanged(xr, Ae), Observable.notify(this, "value"), this.updateDisplayValue());
  }
  /**
   * Sets the value and display value to match the first selected option.
   *
   * @param shouldEmit - if true, the input and change events will be emitted
   *
   * @internal
   */
  updateValue(Ae) {
    var xr, ed;
    this.$fastController.isConnected && (this.value = (ed = (xr = this.firstSelectedOption) == null ? void 0 : xr.value) != null ? ed : ""), Ae && (this.$emit("input"), this.$emit("change", this, {
      bubbles: !0,
      composed: void 0
    }));
  }
  /**
   * Updates the proxy value when the selected index changes.
   *
   * @param prev - the previous selected index
   * @param next - the next selected index
   *
   * @internal
   */
  selectedIndexChanged(Ae, xr) {
    super.selectedIndexChanged(Ae, xr), this.updateValue(), this.options.forEach((ed) => {
      ed.value === this.value ? (ed.selected = !0, ed.checked = !0) : (ed.selected = !1, ed.checked = !1);
    });
  }
  /**
   * Calculate and apply listbox positioning based on available viewport space.
   *
   * @public
   */
  setPositioning() {
    let Ae = 0;
    DOM.queueUpdate(() => {
      const xr = this.listbox.getOptions();
      Ae = this.listbox.setMaxHeight(xr);
    }), this.cleanup = autoUpdate(this, this.listbox, async () => {
      var rd;
      const { middlewareData: xr, placement: ed, x: id, y: od } = await computePosition(
        this.control,
        this.listbox,
        {
          placement: this.position === "above" ? "top" : "bottom",
          strategy: "fixed",
          middleware: [
            flip(),
            size({
              apply: ({ rects: sd }) => {
                Object.assign(this.listbox.style, {
                  maxHeight: `${Ae}px`,
                  width: `${sd.reference.width}px`
                });
              }
            }),
            hide()
          ]
        }
      ), ad = ed === "top" ? "above" : "below";
      if (ad !== this.position && (this.position = ad), (rd = xr.hide) != null && rd.referenceHidden) {
        this.open = !1;
        return;
      }
      Object.assign(this.listbox.style, {
        position: "fixed",
        left: `${id}px`,
        top: `${od + (this.position === "below" ? 2 : -2)}px`
      });
    });
  }
  /**
   * The value displayed on the button.
   *
   * @public
   */
  get displayValue() {
    var Ae, xr, ed;
    return Observable.track(this, "displayValue"), this.displayValueBlock && (this.placeholder && (this.displayValueBlock.innerHTML = this.placeholder), this.value && (this.displayValueBlock.innerHTML = (Ae = this.selectedOptions[0]) == null ? void 0 : Ae.innerHTML)), (ed = (xr = this.displayValueBlock) == null ? void 0 : xr.textContent) != null ? ed : "";
  }
  /**
   * Synchronize the `aria-disabled` property when the `disabled` property changes.
   *
   * @param prev - The previous disabled value
   * @param next - The next disabled value
   *
   * @internal
   */
  disabledChanged(Ae, xr) {
    super.disabledChanged && super.disabledChanged(Ae, xr), xr && this.open && (this.open = !1);
  }
  /**
   * Reset the element to its first selectable option when its parent form is reset.
   *
   * @internal
   */
  formResetCallback() {
    this.setProxyOptions(), super.setDefaultSelectedOption(), (this.selectedIndex !== -1 || this.value !== "") && (this.selectedIndex = -1, this.value = "");
  }
  /**
   * Handle opening and closing the listbox when the select is clicked.
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(Ae) {
    const xr = this._value;
    if (!this.disabled) {
      if (this.open) {
        if (Ae.target.nodeName.toUpperCase() === "TM1-BUTTON")
          return;
        const ed = Ae.target.closest(
          "option,[role=option]"
        );
        if (ed && ed.disabled || !ed)
          return;
      }
      return super.clickHandler(Ae), xr !== this.value && this.updateValue(!0), !0;
    }
  }
  handleOptionChanged(Ae) {
    Ae.stopPropagation(), (Ae.target.nodeName === "TM1-OPTION" || Ae.target.nodeName === "TM1-LIST-ITEM") && Ae.target.selected && (this.value = Ae.target.value);
  }
  /**
   * Handles focus state when the element or its children lose focus.
   *
   * @param e - The focus event
   * @internal
   */
  focusoutHandler(Ae) {
    var ed;
    if (super.focusoutHandler(Ae), !this.open)
      return !0;
    const xr = Ae.relatedTarget;
    if (this.isSameNode(xr)) {
      this.focus();
      return;
    }
    (ed = this.options) != null && ed.includes(xr) || this.indexWhenOpened !== this.selectedIndex && this.updateValue(!0);
  }
  /**
   * Updates the value when an option's value changes.
   *
   * @param source - the source object
   * @param propertyName - the property to evaluate
   *
   * @internal
   * @override
   */
  handleChange(Ae, xr) {
    super.handleChange(Ae, xr), xr === "value" && this.updateValue();
  }
  /**
   * Synchronize the form-associated proxy and updates the value property of the element.
   *
   * @param prev - the previous collection of slotted option elements
   * @param next - the next collection of slotted option elements
   *
   * @internal
   */
  slottedOptionsChanged(Ae, xr) {
    this.options.forEach((ed) => {
      Observable.getNotifier(ed).unsubscribe(this, "value");
    }), super.slottedOptionsChanged(Ae, xr), this.options.forEach((ed) => {
      Observable.getNotifier(ed).subscribe(this, "value");
    }), this.setProxyOptions(), this.updateValue();
  }
  /**
   * Prevents focus when size is set and a scrollbar is clicked.
   *
   * @param e - the mouse event object
   *
   * @override
   * @internal
   */
  mousedownHandler(Ae) {
    var xr;
    return Ae.offsetX >= 0 && Ae.offsetX <= ((xr = this.listbox) == null ? void 0 : xr.scrollWidth) ? super.mousedownHandler(Ae) : this.collapsible;
  }
  /**
   * Updates the selectedness of each option when the list of selected options changes.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @override
   * @internal
   */
  selectedOptionsChanged(Ae, xr) {
    var ed;
    super.selectedOptionsChanged(Ae, xr), (ed = this.options) == null || ed.forEach((id, od) => {
      var rd, sd;
      const ad = (rd = this.proxy) == null ? void 0 : rd.options.item(od);
      ad && (ad.selected = (sd = id.selected) != null ? sd : !1);
    });
  }
  /**
   * Sets the selected index to match the first option with the selected attribute, or
   * the first selectable option.
   *
   * @override
   * @internal
   */
  setDefaultSelectedOption() {
    let Ae = [];
    this.options.length > 0 && (Ae = this.options);
    const xr = Ae == null ? void 0 : Ae.findIndex(
      (ed) => ed.hasAttribute("selected") || ed.selected || ed.value === this.value
    );
    if (xr !== -1) {
      this.selectedIndex = xr;
      return;
    }
  }
  /**
   * Resets and fills the proxy to match the component's options.
   *
   * @internal
   */
  setProxyOptions() {
    this.proxy instanceof HTMLSelectElement && this.options && (this.proxy.options.length = 0, this.options.forEach((Ae) => {
      const xr = Ae.proxy || (Ae instanceof HTMLOptionElement ? Ae.cloneNode() : null);
      xr && this.proxy.options.add(xr);
    }));
  }
  /**
   * Handle keyboard interaction for the select.
   *
   * @param e - the keyboard event
   * @internal
   */
  keydownHandler(Ae) {
    var ed;
    super.keydownHandler(Ae);
    const xr = Ae.key || Ae.key.charCodeAt(0);
    switch (xr) {
      case keySpace: {
        Ae.preventDefault(), this.collapsible && this.typeAheadExpired && (this.open = !this.open);
        break;
      }
      case keyHome:
      case keyEnd: {
        Ae.preventDefault();
        break;
      }
      case keyEnter: {
        Ae.preventDefault(), this.open ? ((ed = this.activeOption) == null || ed.click(), this.open = !1) : this.open = !0;
        break;
      }
      case keyEscape: {
        this.open && (Ae.preventDefault(), this.open = !1);
        break;
      }
      case keyTab:
        return this.open && (Ae.preventDefault(), this.open = !1), this.$emit("change", this, {
          bubbles: !0,
          composed: void 0
        }), !0;
    }
    return !this.open && this.indexWhenOpened !== this.selectedIndex && xr !== keyArrowDown && xr !== keyArrowUp ? (this.updateValue(!0), this.indexWhenOpened = this.selectedIndex) : this.open && this.indexWhenOpened !== this.selectedIndex && (xr === keyArrowDown || xr === keyArrowUp) && (this.$emit("input"), this.indexWhenOpened = this.selectedIndex), !(xr === keyArrowDown || xr === keyArrowUp);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("contentchange", this.updateDisplayValue), this.deprecated = features.isEnabled(this, "prd3267-deprecated-design-system"), this.$fastController.addBehaviors([this.clickBehavior]);
  }
  disconnectedCallback() {
    var Ae;
    this.removeEventListener("contentchange", this.updateDisplayValue), (Ae = this.cleanup) == null || Ae.call(this), this.$fastController.removeBehaviors([this.clickBehavior]), super.disconnectedCallback();
  }
  /**
   * Updates the proxy's size property when the size attribute changes.
   *
   * @param prev - the previous size
   * @param next - the current size
   *
   * @override
   * @internal
   */
  sizeChanged(Ae, xr) {
    if (typeof xr != "number" || xr === 0) {
      this.size = typeof xr == "string" ? parseInt(xr) : 4;
      return;
    }
    super.sizeChanged(Ae, xr), this.proxy && (this.proxy.size = xr);
  }
  /**
   *
   * @internal
   */
  updateDisplayValue() {
    this.collapsible && Observable.notify(this, "displayValue");
  }
  onClickOutside(Ae) {
    this.close(this.open && !this.validOptions.includes(Ae.nodeName.toUpperCase()) && Ae.nodeName.toUpperCase() !== "TM1-BUTTON" && document.activeElement !== this);
  }
  onClick(Ae) {
    this.close(this.open && (!this.validOptions.includes(Ae.nodeName.toUpperCase()) || Ae === this.triggerEl), !0);
  }
  close(Ae, xr = !1) {
    Ae ? this.open = !1 : xr && (this.open = !0);
  }
}
__decorateClass$7([
  attr({ attribute: "open", mode: "boolean" })
], Select.prototype, "open", 2);
__decorateClass$7([
  attr({ attribute: "error" })
], Select.prototype, "error", 2);
__decorateClass$7([
  attr({ attribute: "placeholder" })
], Select.prototype, "placeholder", 2);
__decorateClass$7([
  attr({ attribute: "inputsize" }),
  attr({ attribute: "input-size" })
], Select.prototype, "inputSize", 2);
__decorateClass$7([
  attr()
], Select.prototype, "size", 2);
__decorateClass$7([
  attr({ attribute: "label" })
], Select.prototype, "label", 2);
__decorateClass$7([
  attr({ attribute: "labelposition" }),
  attr({ attribute: "label-position" })
], Select.prototype, "labelPosition", 2);
__decorateClass$7([
  attr({ attribute: "aria-activedescendant" })
], Select.prototype, "ariaActivedescendant", 2);
__decorateClass$7([
  attr({ attribute: "aria-expanded" })
], Select.prototype, "ariaExpanded", 2);
__decorateClass$7([
  attr({ attribute: "position" })
], Select.prototype, "position", 2);
__decorateClass$7([
  observable
], Select.prototype, "triggerEl", 2);
__decorateClass$7([
  volatile
], Select.prototype, "collapsible", 1);
__decorateClass$7([
  observable
], Select.prototype, "control", 2);
__decorateClass$7([
  observable
], Select.prototype, "displayValueBlock", 2);
const tm1Select = Select.compose({
  baseName: "select",
  template: tm1SelectTemplate,
  styles: tm1SelectStyles,
  indicator: `
    <svg class="svg-indicator" viewBox="0 0 16 16">
      <path d="M3.278 5.459A.75.75 0 0 0 2.221 6.52l5.263 5.24a.75.75 0 0 0 1.059 0l5.237-5.24a.75.75 0 0 0-1.06-1.06l-4.71 4.711L3.278 5.46z"/>
    </svg>
  `
});
designSystem.register(
  tm1MultiSelect(),
  tm1Select()
);
const tm1SliderLabelStyles = () => css`
  :host {
    display: 'block';
  }

  .root {
    position: absolute;
    display: grid;
  }

  :host(.horizontal) {
    align-self: start;
    grid-row: 2;
    margin-top: -4px;
  }

  :host(.vertical) {
    justify-self: start;
    grid-column: 2;
    margin-left: 2px;
  }

  .container {
    display: grid;
    justify-self: center;
  }

  :host(.horizontal) .container {
    grid-template-rows: auto auto;
    grid-template-columns: 0;
  }

  :host(.vertical) .container {
    grid-template-columns: auto auto;
    grid-template-rows: 0;
    min-width: calc(var(--thumb-size) * 1px);
    height: calc(var(--thumb-size) * 1px);
  }

  .label {
    justify-self: center;
    align-self: center;
    white-space: nowrap;
    max-width: 30px;
    margin: 2px 0;
  }

  .mark {
    width: 1px;
    height: 4px;
    background: #bebebe;
    justify-self: center;
  }

  :host(.vertical) .mark {
    transform: rotate(90deg);
    align-self: center;
  }

  :host(.vertical) .label {
    margin-left: 4px;
  }
`, tm1SliderLabelTemplate = (td) => html`
  <template aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}" class="${(Ae) => Ae.sliderOrientation}">
    <div ${ref("root")} part="root" class="root" style="${(Ae) => Ae.positionStyle}">
      <div class="container" data-testid="container">
        ${when((Ae) => !Ae.hideMark, html`<div class="mark" data-testid="mark"></div>`)}
        <div class="label" data-testid="label">
          <${td.tagFor(Typography)} tag="span" type="body-s">
            <slot></slot>
          </${td.tagFor(Typography)}>
        </div>
      </div>
    </div>
  </template>
`, SliderOrientation = Orientation;
class SliderLabel extends SliderLabel$1 {
  /**
   * @internal
   */
  connectedCallback() {
    super.connectedCallback(), this.positionStyle = this.repositionAsStyle();
  }
  /**
   * @internal
   */
  handleChange(Ae, xr) {
    super.handleChange(Ae, xr), this.positionStyle = this.repositionAsStyle();
  }
  repositionAsStyle() {
    const Ae = this.sliderDirection ? this.sliderDirection : Direction.ltr, xr = this.convertPixelToPercent(
      Number(this.position),
      Number(this.sliderMinPosition),
      Number(this.sliderMaxPosition)
    );
    let ed = +((1 - xr) * 100).toFixed(2), id = +(xr * 100).toFixed(2);
    return Number.isNaN(id) && Number.isNaN(ed) && (ed = 50, id = 50), this.sliderOrientation === SliderOrientation.horizontal ? Ae === Direction.rtl ? `right: ${id}%; left: ${ed}%;` : `left: ${id}%; right: ${ed}%;` : `top: ${ed}%; bottom: ${id}%;`;
  }
  /**
   * Converts a pixel coordinate on the track to a percent of the track's range
   */
  convertPixelToPercent(Ae, xr, ed, id) {
    let od = limit(0, 1, (Ae - xr) / (ed - xr));
    return id === Direction.rtl && (od = 1 - od), od;
  }
}
const tm1SliderLabel = SliderLabel.compose({
  baseName: "slider-label",
  baseClass: SliderLabel$1,
  template: tm1SliderLabelTemplate,
  styles: tm1SliderLabelStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
}), tm1SliderStyles = () => css`
  ${display("inline-grid")} :host {
    --thumb-size: calc((${heightNumber} / 2) + 6);
    --thumb-translate: calc(var(--thumb-size) * -0.5 + 4 / 2);
    align-items: center;
    width: 100%;
    user-select: none;
    box-sizing: border-box;
    border-radius: ${GDSERadiusSurface};
    outline: none;
    cursor: pointer;
  }

  :host .positioning-region {
    position: relative;
    margin: ${GDSESpacing0} ${GDSESpacing100};
    display: grid;
  }

  :host(.horizontal) .positioning-region {
    grid-template-rows: calc(var(--thumb-size) * 1px) 1fr;
  }

  :host(.vertical) .positioning-region {
    height: 100%;
    grid-template-columns: calc(var(--thumb-size) * 1px) 1fr;
  }

  .thumb-container {
    position: absolute;
    height: calc(var(--thumb-size) * 1px);
    width: calc(var(--thumb-size) * 1px);
    transition: all 0.2s ease;
  }

  .thumb-cursor {
    display: flex;
    position: relative;
    border: none;
    width: calc(var(--thumb-size) * 1px);
    height: calc(var(--thumb-size) * 1px);
    background: padding-box ${GDSEColorBorder};
    border-radius: ${GDSERadiusPill};
    box-sizing: border-box;
  }

  .thumb-cursor::after {
    content: '';
    display: block;
    border-radius: ${GDSERadiusPill};
    width: 100%;
    margin: ${GDSESpacing50};
    background: ${GDSEColorFillPrimary};
  }

  :host(:not(.disabled)) .thumb-cursor:hover::after {
    background: ${GDSEColorFillPrimary};
    margin: ${GDSESpacing25};
  }

  :host(:not(.disabled)) .thumb-cursor:active::after {
    background: ${GDSEColorFillPrimary};
    margin: ${GDSESpacing50};
  }

  :host(:not(.disabled)) .thumb-cursor:hover {
    background: padding-box ${GDSEColorBorder};
  }

  :host(:not(.disabled)) .thumb-cursor:active {
    background: padding-box ${GDSEColorBorder};
  }

  .track-start {
    background: ${GDSEColorFillPrimary};
    position: absolute;
    height: 100%;
    left: 0;
    border-radius: ${GDSERadiusSurface};
  }

  :host(.horizontal) .thumb-container {
    transform: translateX(calc(var(--thumb-size) * 0.5px)) translateY(calc(var(--thumb-translate) * 1px));
  }

  :host(.vertical) .thumb-container {
    transform: translateX(calc(var(--thumb-translate) * 1px)) translateY(calc(var(--thumb-size) * 0.5px));
  }

  :host(.horizontal) {
    min-width: calc(var(--thumb-size) * 1px);
  }

  :host(.horizontal) .track {
    right: -2px;
    left: -2px;
    align-self: start;
    height: 4px;
  }

  :host(.vertical) .track {
    top: -2px;
    bottom: -2px;
    width: 4px;
    height: 100%;
  }

  .track {
    background: ${GDSEColorBorder};
    border-radius: ${GDSERadiusInput};
    box-sizing: border-box;
    position: absolute;
  }

  :host(.vertical) {
    height: 100%;
    min-height: 240px;
    min-width: 80px;
  }

  :host(.vertical) .track-start {
    height: auto;
    width: 100%;
    top: 0;
  }

  :host(.disabled),
  :host(.readonly) {
    cursor: ${disabledCursor};
  }

  :host(.disabled) {
    opacity: 0.3;
  }

  :host([min='0'][max='0']) .track {
    background: ${GDSEColorFillPrimary};
  }

  :host([min='0'][max='0'].horizontal) .thumb-container {
    right: 0% !important;
  }

  :host([min='0'][max='0'].vertical) .thumb-container {
    bottom: 0% !important;
  }
`;
class Slider extends Slider$1 {
}
const tm1Slider = Slider.compose({
  baseName: "slider",
  baseClass: Slider$1,
  template: sliderTemplate,
  styles: tm1SliderStyles,
  thumb: '<div class="thumb-cursor"></div>'
});
designSystem.register(
  tm1Slider(),
  tm1SliderLabel()
);
const tabsSizeContext = "tm1-tabs-size", tabsActiveIdContext = "tm1-tabs-activeId", tm1TabStyles = () => css`
  :host {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    grid-row: 1;
    cursor: pointer;
    color: ${GDSEColorTextNavigationDefault};
    border-radius: ${GDSERadiusSharp};
    outline-offset: -2px;
    line-height: ${GDSELineHeightReset};
    min-width: var(--tab-min-width);
    min-height: var(--tab-min-height);
    padding: var(--tab-padding);
    overflow: hidden;
    width: max-content;
  }

  :host(:hover) {
    background: ${GDSEColorFillHovered};
  }

  :host(:focus),
  :host(:focus-visible) {
    z-index: ${GDSEZIndexLayoutFeedback};
    color: ${GDSEColorText};
  }

  :host(:focus-visible) {
    outline: 2px solid ${GDSEColorFillSelected};
  }

  :host(:active) {
    color: ${GDSEColorText};
    background: ${GDSEColorFillPressed};
  }

  :host([aria-selected='true']) {
    color: ${GDSEColorText};
    font-weight: ${GDSEFontWeightSemiBold};
  }

  :host([disabled]) {
    color: ${GDSEColorTextDisabled};
    cursor: not-allowed;
  }

  :host .tab-content {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  :host {
    border-bottom: 2px solid transparent;
  }

  :host .tab-content {
    padding-bottom: calc(var(--spacing-vertical) - 2px);
  }

  :host([aria-selected='true']) {
    border-bottom: 2px solid ${GDSEColorFillSelected};
  }

  :host([size='medium']) {
    --tab-min-width: ${GDSESpacingTabWidth};
    --tab-min-height: ${GDSESpacing200};
    --tab-padding: ${GDSESpacingTabVerM} ${GDSESpacingTabHorM};
  }

  :host([size='large']) {
    --tab-min-width: ${GDSESpacingTabWidth};
    --tab-min-height: ${GDSESpacing200};
    --tab-padding: ${GDSESpacingTabVerL} ${GDSESpacingTabHorL};
  }
`, tm1TabTemplate = (td, Ae) => html`
    <template
      slot="tab"
      role="tab"
      aria-disabled="${(xr) => xr.disabled}"
      size="${(xr) => xr.size || "medium"}"
      aria-selected="${(xr) => xr.selected}"
    >
      <${td.tagFor(Typography)} type="${(xr) => xr.typographyType}">
        ${startSlotTemplate(td, Ae)}

        <div class="tab-content">
          <slot></slot>
        </div>

        ${endSlotTemplate(td, Ae)}
      </${td.tagFor(Typography)}>
    </template>
  `;
var __defProp$6 = Object.defineProperty, __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor, __decorateClass$6 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$6(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$6(Ae, xr, id), id;
};
const textTypes = {
  medium: { selected: "label-ui-l-emphasis", normal: "label-ui-l" },
  large: { selected: "label-ui-xl-emphasis", normal: "label-ui-xl" }
};
class Tab extends Tab$1 {
  constructor() {
    super(...arguments), this.sizeConsumer = new ConsumerBehaviour(this, {
      context: tabsSizeContext,
      subscribe: !0,
      callback: (Ae) => this.size = Ae
    }), this.selectedConsumer = new ConsumerBehaviour(this, {
      context: tabsActiveIdContext,
      subscribe: !0,
      callback: (Ae) => this.selected = this.id === Ae
    });
  }
  get typographyType() {
    const Ae = textTypes[this.size || "medium"] || textTypes.medium;
    return this.selected ? Ae.selected : Ae.normal;
  }
}
__decorateClass$6([
  observable
], Tab.prototype, "size", 2);
__decorateClass$6([
  observable
], Tab.prototype, "selected", 2);
const tm1Tab = Tab.compose({
  baseName: "tab",
  baseClass: Tab$1,
  template: tm1TabTemplate,
  styles: tm1TabStyles
}), tm1TabPanelStyles = css`
  ${display("block")} :host {
    box-sizing: border-box;
    font-size: 14px;
    line-height: 20px;
    padding: 0 6px;
  }
`;
class TabPanel extends TabPanel$1 {
}
const tm1TabPanel = TabPanel.compose({
  baseName: "tab-panel",
  baseClass: TabPanel$1,
  template: tabPanelTemplate,
  styles: tm1TabPanelStyles
}), tm1TabsStyles = () => css`
  :host {
    display: grid;
    box-sizing: border-box;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto 1fr;
  }

  .tablist {
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: auto;
    position: relative;
    width: max-content;
    align-self: end;
    box-sizing: border-box;
  }

  .start,
  .end {
    align-self: center;
  }

  .tabpanel {
    grid-row: 2;
    grid-column-start: 1;
    grid-column-end: 4;
    position: relative;
  }

  /** tabs scroll */
  .tablist {
    max-width: max-content;
    grid-auto-flow: column;
    grid-auto-columns: auto;
    width: 100%;
    overflow-x: auto;
  }

  .tabpanel {
    overflow-y: auto;
  }

  :host([no-overflow]) .tabpanel {
    overflow: initial;
  }
`;
var __defProp$5 = Object.defineProperty, __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor, __decorateClass$5 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$5(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$5(Ae, xr, id), id;
};
class Tabs extends Tabs$1 {
  constructor() {
    super(...arguments), this.noOverflow = !1, this.orientation = TabsOrientation$1.horizontal, this.tabsSizeContext = new ProviderBehaviour(this, tabsSizeContext, void 0), this.tabsActiveIdContext = new ProviderBehaviour(this, tabsActiveIdContext, void 0);
  }
  sizeChanged() {
    this.tabsSizeContext.setValue(this.size);
  }
  connectedCallback() {
    super.connectedCallback(), this.tabsSizeContext.setValue(this.size), this.tabsActiveIdContext.setValue(this.activeid);
  }
  activeidChanged(Ae, xr) {
    super.activeidChanged(Ae, xr), this.tabsActiveIdContext.setValue(xr);
    let ed;
    const id = this.querySelectorAll("tm1-tab") || [], od = this.querySelectorAll("tm1-tab-panel") || [];
    id.forEach((ad) => {
      ad.id === xr && (ed = ad, ad.focus());
    }), od.forEach((ad) => {
      (ed == null ? void 0 : ed.getAttribute("aria-controls")) === ad.id ? (ad.removeAttribute("hidden"), ad.setAttribute("tabindex", "0")) : (ad.setAttribute("hidden", ""), ad.setAttribute("tabindex", "-1"));
    });
  }
}
__decorateClass$5([
  attr({ mode: "boolean", attribute: "no-overflow" })
], Tabs.prototype, "noOverflow", 2);
__decorateClass$5([
  attr()
], Tabs.prototype, "size", 2);
__decorateClass$5([
  attr()
], Tabs.prototype, "orientation", 2);
const tm1Tabs = Tabs.compose({
  baseName: "tabs",
  baseClass: Tabs$1,
  template: tabsTemplate,
  styles: tm1TabsStyles
}), TabsOrientation = {
  horizontal: "horizontal"
};
designSystem.register(
  tm1Tabs(),
  tm1Tab(),
  tm1TabPanel()
);
const tm1TextAreaStyles = () => css`
  :host {
    height: 100%;
    display: flex;
    flex-direction: column;
    outline: none;
    user-select: none;
    ${textAreaSizeRegular}
  }

  :host([input-size='small']),
  :host([inputsize='small']) {
    ${textAreaSizeSmall}
  }

  :host([input-size='large']),
  :host([inputsize='large']) {
    ${textAreaSizeLarge}
  }

  textarea {
    width: 100%;
    min-height: var(--input-size);
    resize: none;
    background-color: field;
    padding: var(--padding);
    border: 1px solid ${GDSEColorBorderInputDefault};
    border-radius: ${GDSERadiusInput};
    outline: none;
    box-sizing: border-box;
    color: ${GDSEColorText};
  }

  :host(:not([disabled]):not([readOnly])) textarea:hover {
    border-color: ${GDSEColorBorderInputHovered};
  }

  :host(:not([disabled]):not([readonly]):focus) textarea,
  :host(:not([disabled]):not([readonly]):active) textarea {
    border-color: ${GDSEColorBorderInputActive};
  }

  :host([disabled]) textarea {
    border: 1px solid ${GDSEColorBorderInputDisabled};
    background-color: ${GDSEColorFillInputDisabled};
    color: ${GDSEColorTextDisabled};
  }

  :host(:not([disabled])) textarea::placeholder {
    color: ${GDSEColorTextMuted};
  }

  :host([disabled]) textarea::placeholder {
    color: ${GDSEColorTextDisabled};
  }

  .label {
    color: ${GDSEColorText};
    margin-bottom: ${GDSESpacing25};
    line-height: ${GDSELineHeightBody};
  }

  .label__hidden {
    display: none;
    visibility: hidden;
  }

  .character-count,
  .supporting-text {
    color: ${GDSEColorTextLight};
  }

  ::slotted(svg) {
    width: 16px;
    height: 16px;
  }

  :host(:not([disabled]):not([readonly])) textarea[aria-invalid='true'] {
    border-color: ${GDSEColorBorderCritical};
  }

  :host([resize='both']) textarea {
    resize: both;
  }

  :host([resize='horizontal']) textarea {
    resize: horizontal;
  }

  :host([resize='vertical']) textarea {
    resize: vertical;
  }

  :host([cols]) {
    width: initial;
  }

  :host([rows]) textarea {
    height: initial;
  }

  :host([readonly]),
  :host([disabled]),
  :host([disabled]) .label,
  :host([readonly]) .label,
  :host([readonly]) textarea,
  :host([disabled]) textarea {
    cursor: not-allowed;
  }

  :host([readonly]) textarea {
    border: none;
    background: transparent;
    padding: ${GDSESpacing0};
  }

  :host([fullHeight]) textarea {
    height: 100% !important;
  }

  .body-m {
    font-family: ${semanticFonts.GDSETypographyBodyMFontFamily};
    font-size: ${semanticFonts.GDSETypographyBodyMFontSizeMobile};
    font-weight: ${semanticFonts.GDSETypographyBodyMFontWeight};
    line-height: ${semanticFonts.GDSETypographyBodyMLineHeight};
    letter-spacing: ${semanticFonts.GDSETypographyBodyMLetterSpacing};
    font-feature: auto;
    text-transform: initial;
    text-decoration: initial;
  }

  .error {
    display: flex;
    align-items: center;
    margin-top: ${GDSESpacing25};
    gap: ${GDSESpacing50};
    color: ${GDSEColorFillCritical};
  }
`, textAreaSizeSmall = cssPartial`
--input-size: 28px;
--padding: ${GDSESpacingInputVerS} ${GDSESpacingInputHorS};
`, textAreaSizeRegular = cssPartial`
--input-size: 36px;
--padding: ${GDSESpacingInputVerM} ${GDSESpacingInputHorM};
`, textAreaSizeLarge = cssPartial`
--input-size: 44px;
--padding: ${GDSESpacingInputVerL} ${GDSESpacingInputHorL};
`, tm1TextAreaTemplate = (td) => html`
  ${when(
  (Ae) => Ae.hasLabel(),
  html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="label" data-testid="label">
        <label part="label" for="${(Ae) => Ae.defaultId()}">
          ${(Ae) => Ae.label ? Ae.label : ""}
          <slot></slot>
        </label>
      </${td.tagFor(Typography)}>`
)}

    <textarea
      id="${(Ae) => Ae.defaultId()}"
      class="${(Ae) => `body-m ${Ae.className}`}"
      data-testid="textarea"
      part="control"
      aria-atomic="${(Ae) => {
  var xr;
  return (xr = Ae.ariaAtomic) != null ? xr : !1;
}}"
      aria-busy="${(Ae) => {
  var xr;
  return (xr = Ae.ariaBusy) != null ? xr : !1;
}}"
      aria-controls="${(Ae) => {
  var xr;
  return (xr = Ae.ariaControls) != null ? xr : Ae.defaultId();
}}"
      aria-current="${(Ae) => {
  var xr;
  return (xr = Ae.ariaCurrent) != null ? xr : null;
}}"
      aria-describedby="${(Ae) => Ae.ariaDescribedby}"
      aria-details="${(Ae) => Ae.ariaDetails}"
      aria-disabled="${(Ae) => {
  var xr;
  return (xr = Ae.ariaDisabled || Ae.disabled) != null ? xr : !1;
}}"
      aria-flowto="${(Ae) => Ae.ariaFlowto}"
      aria-haspopup="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHaspopup) != null ? xr : !1;
}}"
      aria-hidden="${(Ae) => {
  var xr;
  return (xr = Ae.ariaHidden) != null ? xr : !1;
}}"
      aria-invalid="${(Ae) => !!Ae.error && (Ae.validateOnBlur && Ae.hasBlurred || !Ae.validateOnBlur)}"
      aria-keyshortcuts="${(Ae) => Ae.ariaKeyshortcuts}"
      aria-label="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLabel || Ae.label) != null ? xr : "";
}}"
      aria-labelledby="${(Ae) => Ae.ariaLabelledby}"
      aria-live="${(Ae) => {
  var xr;
  return (xr = Ae.ariaLive) != null ? xr : !1;
}}"
      aria-owns="${(Ae) => Ae.ariaOwns}"
      aria-relevant="${(Ae) => {
  var xr;
  return (xr = Ae.ariaRelevant) != null ? xr : "additions text";
}}"
      aria-roledescription="${(Ae) => Ae.ariaRoledescription}"
      ?autofocus="${(Ae) => {
  var xr;
  return (xr = Ae.autofocus) != null ? xr : !1;
}}"
      ?disabled="${(Ae) => {
  var xr;
  return (xr = Ae.disabled) != null ? xr : !1;
}}"
      ?fullHeight="${(Ae) => Ae.fullHeight}"
      ?readonly="${(Ae) => Ae.readOnly}"
      ?required="${(Ae) => {
  var xr;
  return (xr = Ae.required) != null ? xr : !1;
}}"
      ?spellcheck="${(Ae) => {
  var xr;
  return (xr = Ae.spellcheck) != null ? xr : !1;
}}"
      cols="${(Ae) => Ae.cols}"
      form="${(Ae) => Ae.form}"
      list="${(Ae) => Ae.list}"
      maxlength="${(Ae) => Ae.maxlength}"
      minlength="${(Ae) => Ae.minlength}"
      name="${(Ae) => Ae.name}"
      placeholder="${(Ae) => {
  var xr;
  return (xr = Ae.placeholder) != null ? xr : "";
}}"
      rows="${(Ae) => Ae.rows}"
      wrap="${(Ae) => Ae.wrap}"
      @blur="${(Ae) => Ae.handleBlur()}"
      @input="${(Ae) => Ae.handleTextInput()}"
      @change="${(Ae) => Ae.handleChange()}"
      ${ref("control")}
    >${(Ae) => {
  var xr;
  return (xr = Ae.value) != null ? xr : D$1;
}}</textarea>

    ${when((Ae) => Ae.showCharacterCount && !Ae.errorLabel && !Ae.readOnly && !!Ae.maxlength, html`
      <${td.tagFor(Typography)} type="label-helpertext-regular" class="character-count">
        <label data-testid='character-count' part="character-count" for="${(Ae) => Ae.defaultId()}">
          ${(Ae) => Ae.getCharactersLeft()} ${(Ae) => Ae.characterCountLabel}
        </label>
      </${td.tagFor(Typography)}>
    `)}

    ${when(
  (Ae) => Ae.hasSupportingText() && !Ae.errorLabel && !Ae.showCharacterCount,
  html`<${td.tagFor(Typography)} type="label-helpertext-regular" class="supporting-text">
        <label part="supporting-text" for="${(Ae) => Ae.defaultId()}">
          ${(Ae) => Ae.supportingText ? Ae.supportingText : html`<slot ${slotted("supportingTextSlottedNodes")}></slot>`}
        </label>
      </${td.tagFor(Typography)}>`
)}
    ${when(
  (Ae) => !!Ae.errorLabel && !Ae.readOnly && !Ae.disabled,
  html`
    <div class="error" data-testid="error">
      <${td.tagFor(Icon)} icon="errorSolid" size="small"></${td.tagFor(Icon)}>
      <${td.tagFor(Typography)}
        tag="span"
        type="label-helpertext-regular"
        role="alert"
      >
        ${(Ae) => Ae.errorLabel}
      </${td.tagFor(Typography)}>
    </div>
  `
)}
`;
var __defProp$4 = Object.defineProperty, __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor, __decorateClass$4 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$4(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$4(Ae, xr, id), id;
};
class TextArea extends TextArea$1 {
  constructor() {
    super(...arguments), this.inputSize = "regular", this.supportingTextSlottedNodes = [], this.fullHeight = !1, this.tabIndex = 0, this.showCharacterCount = !1, this.characterCountLabel = "character(s) left", this.errorLabel = "", this.firstRender = !0, this.hasBlurred = !1, this.hasLabel = () => !!this.label || this.innerHTML, this.hasSupportingText = () => {
      var Ae;
      return !!this.supportingText || ((Ae = this.supportingTextSlottedNodes) == null ? void 0 : Ae.length) !== 0;
    }, this.defaultId = () => this.id !== "" ? this.id : "control", this.getCharactersLeft = () => (this.maxlength - this.value.length).toString(), this.handleTextInput = () => {
      this.value = this.control.value, this.$emit("input");
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.validate(), this.addEventListener("keydown", this.handleKeydown, !1);
  }
  disconnectedCallback() {
    this.removeEventListener("keydown", this.handleKeydown, !1), super.disconnectedCallback();
  }
  valueChanged(Ae, xr) {
    super.valueChanged(Ae, xr), DOM.queueUpdate(() => {
      this.control && (this.validate(), this.control.value = xr, this.hasError());
    });
  }
  errorChanged() {
    this.proxy instanceof HTMLTextAreaElement && this.valueChanged("", this.value);
  }
  hasError() {
    var xr, ed, id, od, ad, rd;
    if (this.validateOnBlur ? this.control && this.hasBlurred : this.control) {
      const sd = ((xr = this.control.checkValidity()) != null ? xr : !0) === !1 || !!this.error || ((ed = this.value) == null ? void 0 : ed.length) < this.minlength && !this.firstRender || ((id = this.value) == null ? void 0 : id.length) < this.minlength && !!this.value || this.required && !((od = this.value) != null && od.trim());
      if (this.classList.toggle("invalid", sd), this.control.ariaInvalid = sd.toString(), this.firstRender = !1, sd)
        return this.control.validationMessage && ((ad = this.elementInternals) == null || ad.setValidity(this.control.validity, this.control.validationMessage, this.control)), this.error ? this.errorLabel = this.error : ((rd = this.value) == null ? void 0 : rd.length) < this.minlength && (this.errorLabel = this.minLengthError || ""), !0;
      this.errorLabel = "";
    }
    return !1;
  }
  handleBlur() {
    this.hasBlurred = !0, this.hasError(), this.$emit("blur");
  }
  handleKeydown(Ae) {
    Ae.key === keyEnter && (Ae.preventDefault(), this.value = `${this.value}
`);
  }
  formResetCallback() {
    super.formResetCallback(), this.control && (this.value = "", this.control.value = "");
  }
}
__decorateClass$4([
  attr()
], TextArea.prototype, "inputSize", 2);
__decorateClass$4([
  attr()
], TextArea.prototype, "label", 2);
__decorateClass$4([
  attr({ attribute: "supporting-text" }),
  attr({ attribute: "supportingtext" })
], TextArea.prototype, "supportingText", 2);
__decorateClass$4([
  observable
], TextArea.prototype, "supportingTextSlottedNodes", 2);
__decorateClass$4([
  attr({ mode: "boolean", attribute: "full-height" }),
  attr({ mode: "boolean", attribute: "fullheight" })
], TextArea.prototype, "fullHeight", 2);
__decorateClass$4([
  attr()
], TextArea.prototype, "tabIndex", 2);
__decorateClass$4([
  attr()
], TextArea.prototype, "error", 2);
__decorateClass$4([
  attr({ attribute: "min-length-error" }),
  attr({ attribute: "minlengtherror" })
], TextArea.prototype, "minLengthError", 2);
__decorateClass$4([
  attr({ mode: "boolean", attribute: "show-character-count" }),
  attr({ mode: "boolean", attribute: "showcharactercount" })
], TextArea.prototype, "showCharacterCount", 2);
__decorateClass$4([
  attr({ attribute: "character-count-label" }),
  attr({ attribute: "charactercountlabel" })
], TextArea.prototype, "characterCountLabel", 2);
__decorateClass$4([
  attr({ mode: "boolean", attribute: "validate-on-blur" }),
  attr({ mode: "boolean", attribute: "validateonblur" })
], TextArea.prototype, "validateOnBlur", 2);
__decorateClass$4([
  attr()
], TextArea.prototype, "wrap", 2);
__decorateClass$4([
  observable
], TextArea.prototype, "errorLabel", 2);
const tm1TextArea = TextArea.compose({
  baseName: "text-area",
  baseClass: TextArea$1,
  template: tm1TextAreaTemplate,
  styles: tm1TextAreaStyles,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1TextArea()
);
const tm1ThemeProviderV2Styles = css`
  :host {
    display: contents;
  }
`, tm1ThemeProviderV2Template = html`<slot></slot>`;
var __defProp$3 = Object.defineProperty, __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor, __decorateClass$3 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$3(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$3(Ae, xr, id), id;
};
class ThemeProviderV2 extends FoundationElement {
  constructor() {
    super(...arguments), this.themeProvider = new ProviderBehaviour(this, themeContext, ThemeType.light), this.themeVersionProvider = new ProviderBehaviour(this, themeVersionContext, ThemeVersion.v1), this.version = ThemeVersion.v1, this.theme = ThemeType.light;
  }
  versionChanged(Ae, xr) {
    this.themeVersionProvider.value = xr;
  }
  themeChanged(Ae, xr) {
    xr === ThemeType.legacy && (xr = ThemeType.light, this.theme = ThemeType.light), this.themeManager && (this.themeManager.theme = xr, this.themeProvider.value = xr);
  }
  connectedCallback() {
    super.connectedCallback(), this.themeManager = new ThemeManager(this), this.themeManager.theme = this.theme, this.themeProvider.value = this.theme, this.themeVersionProvider.value = this.version;
  }
}
__decorateClass$3([
  observable
], ThemeProviderV2.prototype, "themeManager", 2);
__decorateClass$3([
  attr()
], ThemeProviderV2.prototype, "version", 2);
__decorateClass$3([
  attr()
], ThemeProviderV2.prototype, "theme", 2);
const tm1ThemeProviderV2 = ThemeProviderV2.compose({
  baseName: "theme-provider-v2",
  template: tm1ThemeProviderV2Template,
  styles: tm1ThemeProviderV2Styles
});
designSystem.register(
  tm1ThemeProviderV2()
);
const tm1ToastContainerTemplate = () => html`<div class="toast-container" data-testid="toast-container" ${ref("toastContainer")}></div>`, tm1ToastStyles = () => css`
  :host .toast {
    font-family: ${GDSEFontFamily};
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    position: fixed;
    opacity: 0;
    background-color: ${GDSEColorSurfaceTooltip};
    color: ${GDSEColorTextOnfill};
    border-radius: 4px;
    transition-duration: 0.3s;
    z-index: 1050;
    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    box-sizing: border-box;
    min-width: 328px;
    max-width: 640px;
    width: fit-content;
    --padding-icon: 0;
  }

  .call-to-action {
    display: flex;
  }

  .initial-white-space {
    white-space: initial;
  }

  .initial-white-space::part(control) {
    white-space: initial;
  }

  :host .toast-close-btn::slotted(.control){
    padding: 0;
  }

  :host(:not([type])) .toast-wrapper {
    padding: ${GDSESpacingTooltipHorM} ${GDSESpacingTooltipVerM} ;
    display: flex;
  }

  .toast-content {
    gap: ${GDSESpacing100};
    display: flex;
    flex-direction: column;
  }

  .toast-container {
    width: 100%;
  }

  :host .toast-wrapper {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    height: 100%;
    padding: ${GDSESpacingTooltipHorL} ${GDSESpacingTooltipVerL};
    gap: ${GDSESpacing150};
  }

  :host .toast-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    align-self: start;
  }

  :host .toast-message {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    line-height: 1.29;
    font-weight: 400;
    text-align: left;
    color: #fff;
  }

  :host .toast-close-btn {
    padding: 0;
    display: flex;
    align-self: start;
    margin-left: auto;
  }

  .toast-close-btn::part(control) {
    padding: 0;
  }

  :host .toast-close-btn .control {
    padding: 0 !important;
  }

  :host .toast-open {
    opacity: 1;
  }

  :host .toast-close {
    opacity: 0;
  }

  :host([position='top']) .toast-open,
  :host([position='top-right']) .toast-open,
  :host([position='top-left']) .toast-open {
    top: ${GDSESpacing500};
    transform: translateY(0px);
  }

  :host([position='bottom']) .toast-open,
  :host([position='bottom-right']) .toast-open,
  :host([position='bottom-left']) .toast-open {
    bottom: ${GDSESpacing500};
    transform: translateY(0px);
  }

  :host([position='right']) .toast,
  :host([position='top-right']) .toast,
  :host([position='bottom-right']) .toast {
    right: ${GDSESpacing500};
  }

  :host([position='left']) .toast,
  :host([position='top-left']) .toast,
  :host([position='bottom-left']) .toast {
    left: ${GDSESpacing500};
  }

  :host([position='top']) .toast,
  :host([position='bottom']) .toast {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }

  @media only screen and (max-width: 360px) {
    :host .toast-right,
    :host .toast-left {
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      max-width: fit-content;
    }
  }

  :host tm1-button {
    --text-color: ${GDSEColorTextLight};
    --text-color-hovered: ${GDSEColorTextLight};
    --text-color-focus: ${GDSEColorTextLight};
    --text-color-pressed: ${GDSEColorText};
    --background-color-hovered: ${GDSEColorFillHovered};
    --background-color-focus: ${GDSEColorFillHovered};
    --background-color-pressed: ${GDSEColorFillPressed};
  }
`, tm1ToastTemplate = (td) => html`
  <div role="alert" class="toast">
    <div class="toast-container" @click="${(Ae) => Ae.handleDestinationClick()}" data-testid="toast-container">
      <div class="toast-wrapper" @click="${(Ae) => Ae.onClick ? Ae.onClick() : () => {
}}" data-testid="toast-wrapper">
        ${when(
  (Ae) => Ae.type && Ae.showIcon,
  html`
            <div class="toast-icon" data-testid="toast-icon-container" >
              <${td.tagFor(Icon)} size="regular" icon="${(Ae) => Ae.icon}"></${td.tagFor(Icon)}>
            </div>
          `
)}
        <div class="toast-content">
          <div class="toast-message" data-testid="toast-message">
            <${td.tagFor(Typography)} type="label-helpertext-regular">
              ${(Ae) => Ae.text}
            </${td.tagFor(Typography)}>
          </div>
          ${when(
  (Ae) => Ae.action && Ae.actionText,
  html`
            <div class="call-to-action">
              <${td.tagFor(Button)} class="initial-white-space" variant="outline" inverse size="small" @click="${(Ae, xr) => Ae.handleAction(xr.event)}">
                ${(Ae) => Ae.actionText}
              </${td.tagFor(Button)}>
            </div>`
)}
        </div>
        ${when(
  (Ae) => !!Ae.dismissable,
  html`
          <${td.tagFor(Button)}
            class="toast-close-btn"
            variant="lightweight"
            icon="close"
            size="small"
            iconPosition="only-icon"
            inverse
            aria-label="close"
            @click="${(Ae) => Ae.closeToast()}"
          ></${td.tagFor(Button)}>`
)}
      </div>
    </div>
  </div>
`;
var __defProp$2 = Object.defineProperty, __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor, __decorateClass$2 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$2(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$2(Ae, xr, id), id;
};
const ToastType = {
  caution: "caution",
  error: "error",
  success: "success",
  info: "info"
}, ToastPosition = {
  bottomRight: "bottom-right"
};
class Toast extends FoundationElement {
  constructor() {
    super(...arguments), this.dismissable = !1, this.duration = 5e3, this.newWindow = !1, this.oldestFirst = !1, this.position = ToastPosition.bottomRight, this.text = "", this.showIcon = !0, this.theme = ThemeType.light, this.icon = "info", this.themeConsumer = new ConsumerBehaviour(this, {
      context: themeContext,
      subscribe: !0,
      callback: (Ae) => this.theme = Ae
    }), this.showToast = () => {
      this.openToast(), this.dismissable || setTimeout(() => {
        this.closeToast();
      }, this.duration);
    }, this.openToast = () => {
      DOM.queueUpdate(() => {
        var Ae, xr, ed, id;
        (xr = (Ae = this.shadowRoot) == null ? void 0 : Ae.querySelector(".toast")) == null || xr.classList.remove("toast-close"), (id = (ed = this.shadowRoot) == null ? void 0 : ed.querySelector(".toast")) == null || id.classList.add("toast-open");
      });
    }, this.closeToast = () => {
      DOM.queueUpdate(() => {
        var Ae, xr, ed, id;
        (xr = (Ae = this.shadowRoot) == null ? void 0 : Ae.querySelector(".toast")) == null || xr.classList.remove("toast-open"), (id = (ed = this.shadowRoot) == null ? void 0 : ed.querySelector(".toast")) == null || id.classList.add("toast-close");
      }), this.callback && this.callback(), this.$emit("close", this);
    }, this.handleAction = (Ae) => {
      Ae.stopPropagation(), this.action && this.action();
    }, this.handleDestinationClick = () => {
      this.destination && window.open(this.destination, this.newWindow === !0 ? "_blank" : "_self");
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.updateIcon();
  }
  typeChanged() {
    this.updateIcon();
  }
  updateIcon() {
    switch (this.type) {
      case "success":
        this.icon = this.theme === "dark" ? "success" : "successSolid";
        break;
      case "caution":
        this.icon = this.theme === "dark" ? "alert" : "alertSolid";
        break;
      case "error":
        this.icon = this.theme === "dark" ? "error" : "errorSolid";
        break;
      default:
        this.icon = this.theme === "dark" ? "info" : "infoSolid";
    }
  }
}
__decorateClass$2([
  attr()
], Toast.prototype, "action", 2);
__decorateClass$2([
  attr({ attribute: "action-text" }),
  attr({ attribute: "actiontext" })
], Toast.prototype, "actionText", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "callback", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "destination", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "dismissable", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "duration", 2);
__decorateClass$2([
  attr({ mode: "boolean", attribute: "new-window" }),
  attr({ mode: "boolean", attribute: "newwindow" })
], Toast.prototype, "newWindow", 2);
__decorateClass$2([
  attr({ attribute: "on-click" }),
  attr({ attribute: "onclick" })
], Toast.prototype, "onClick", 2);
__decorateClass$2([
  attr({ mode: "boolean", attribute: "oldest-first" }),
  attr({ mode: "boolean", attribute: "oldestfirst" })
], Toast.prototype, "oldestFirst", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "position", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "text", 2);
__decorateClass$2([
  attr()
], Toast.prototype, "type", 2);
__decorateClass$2([
  attr({ mode: "boolean", attribute: "show-icon" }),
  attr({ mode: "boolean", attribute: "showicon" })
], Toast.prototype, "showIcon", 2);
__decorateClass$2([
  observable
], Toast.prototype, "theme", 2);
__decorateClass$2([
  observable
], Toast.prototype, "icon", 2);
const tm1Toast = Toast.compose({
  baseName: "toast",
  styles: tm1ToastStyles,
  template: tm1ToastTemplate,
  shadowOptions: {
    delegatesFocus: !0
  }
});
class ToastContainer extends FoundationElement {
  constructor() {
    super(...arguments), this.oldestFirst = !0;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("close", this.removeToast);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("close", this.removeToast);
  }
  showToast(Ae) {
    var ed, id, od;
    const xr = this.buildToast(Ae);
    this.oldestFirst ? (id = this.toastContainer) == null || id.insertBefore(xr, (ed = this.toastContainer) == null ? void 0 : ed.firstChild) : (od = this.toastContainer) == null || od.appendChild(xr), xr.showToast(), this.reposition();
  }
  removeToast(Ae) {
    Ae.detail.remove(), this.reposition();
  }
  reposition() {
    DOM.queueUpdate(() => {
      var rd;
      let xr;
      const ed = {
        top: 40,
        bottom: 40
      }, id = {
        top: 40,
        bottom: 40
      }, od = {
        top: 40,
        bottom: 40
      };
      (((rd = this.shadowRoot) == null ? void 0 : rd.querySelectorAll("tm1-toast")) || []).forEach((sd) => {
        var ld;
        const nd = (ld = sd.shadowRoot) == null ? void 0 : ld.querySelector(".toast");
        sd.position.includes("top") ? xr = "top" : xr = "bottom";
        const cd = window.innerWidth > 0 ? window.innerWidth : screen.width, ud = nd.offsetHeight;
        cd <= 360 ? (nd.style[xr] = od[xr] + "px", od[xr] += ud + 15) : sd.position.includes("left") ? (nd.style[xr] = ed[xr] + "px", ed[xr] += ud + 15) : (nd.style[xr] = id[xr] + "px", id[xr] += ud + 15);
      });
    });
  }
  buildToast(Ae) {
    var ed, id, od, ad, rd;
    const xr = document.createElement("tm1-toast");
    return this.oldestFirst = (ed = Ae.oldestFirst) != null ? ed : !0, xr.action = Ae.action, xr.actionText = Ae.actionText, xr.callback = Ae.callback, xr.destination = Ae.destination, xr.dismissable = Ae.dismissable, xr.duration = Ae.duration, xr.destination = Ae.destination, xr.dismissable = (id = Ae.dismissable) != null ? id : !1, xr.duration = (od = Ae.duration) != null ? od : 5e3, xr.newWindow = (ad = Ae.newWindow) != null ? ad : !1, xr.onClick = Ae.onClick, xr.position = Ae.position || ToastPosition.bottomRight, xr.text = Ae.text || "", xr.type = Ae.type, xr.showIcon = (rd = Ae.showIcon) != null ? rd : !0, xr;
  }
}
const tm1ToastContainer = ToastContainer.compose({
  baseName: "toast-container",
  template: tm1ToastContainerTemplate,
  shadowOptions: {
    delegatesFocus: !0
  }
});
designSystem.register(
  tm1Toast(),
  tm1ToastContainer()
);
const tm1TreeViewItemStyles = css`
  :host([ltr]) .expand-collapse-glyph {
    transform: rotate(0deg);
  }

  :host(.nested[ltr]) .expand-collapse-button {
    left: var(--expand-collapse-button-nested-width, calc(${heightNumber} * -1px));
  }

  :host([ltr][selected])::after {
    left: 2px;
  }

  :host([ltr][expanded]) > .positioning-region .expand-collapse-glyph {
    transform: rotate(45deg);
  }

  .expand-collapse-glyph {
    transform: rotate(180deg);
  }

  :host(.nested) .expand-collapse-button {
    right: var(--expand-collapse-button-nested-width, 0px);
  }

  :host([selected])::after {
    right: 2px;
  }

  :host([expanded]) > .positioning-region .expand-collapse-glyph {
    transform: rotate(135deg);
  }

  @keyframes treeItemLoading {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  :host {
    fill: #2b2b2b;
  }

  ${display("block")} :host {
    contain: content;
    position: relative;
    outline: none;
    color: #2b2b2b;
    background: #ffffff;
    cursor: pointer;
    font-family: ${GDSEFontFamily};
    --expand-collapse-button-size: ${heightNumber}px;
    --tree-item-nested-width: 0;
  }

  :host(:focus) > .positioning-region {
    outline: none;
  }

  :host(:focus) .content-region {
    outline: none;
  }

  :host(:${focusVisible}) .positioning-region {
    border: #888888 1px solid;
    border-radius: 4px;
    color: #2b2b2b;
  }

  .positioning-region {
    display: flex;
    position: relative;
    box-sizing: border-box;
    background: #ffffff;
    border: transparent 1px solid;
    height: calc((${heightNumber} + 1) * 1px);
  }

  .positioning-region::before {
    content: '';
    display: block;
    width: var(--tree-item-nested-width);
    flex-shrink: 0;
  }

  :host(:not([disabled])) .positioning-region:hover {
    background: #f2f2f2;
  }

  :host(:not([disabled])) .positioning-region:active {
    background: #f7f7f7;
  }

  .content-region {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    width: 100%;
    height: ${heightNumber}px;
    margin-inline-start: 16px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }

  .items {
    /* TODO: adaptive typography https://github.com/microsoft/fast/issues/2432 */
    font-size: calc(1em + 20px);
  }

  .expand-collapse-button {
    background: none;
    border: none;
    outline: none;
    /* TODO: adaptive typography https://github.com/microsoft/fast/issues/2432 */
    width: 28px
    height: 28px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: 6px;
    margin-right: 6px;
  }

  .expand-collapse-glyph {
    transition: transform 0.1s linear;
    pointer-events: none;
    fill: currentcolor;
  }

  .start,
  .end {
    display: flex;
    fill: currentcolor;
  }

  ::slotted(svg) {
    /* TODO: adaptive typography https://github.com/microsoft/fast/issues/2432 */
    width: 16px;
    height: 16px;
  }

  .start {
    /* TODO: horizontalSpacing https://github.com/microsoft/fast/issues/2766 */
    margin-inline-end: 10px;
    
  }
  .end {
    /* TODO: horizontalSpacing https://github.com/microsoft/fast/issues/2766 */
    margin-inline-start: 10px;
  }

  :host([expanded]) > .items {
    animation: treeItemLoading ease-in 10ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  :host([disabled]) .content-region {
    opacity: 0.3;
    cursor: ${disabledCursor};
  }

  :host(.nested) .content-region {
    position: relative;
    margin-inline-start: var(--expand-collapse-button-size);
  }

  :host(.nested) .expand-collapse-button {
    position: absolute;
  }

  :host(.nested:not([disabled])) .expand-collapse-button:hover {
    background: #e5e5e5;
  }

  :host([selected]) .positioning-region {
    background: #ededed;
  }

  :host([selected]:not([disabled])) .positioning-region:hover {
    background: #e5e5e5;
  }

  :host([selected]:not([disabled])) .positioning-region:active {
    background: #f2f2f2;
  }

  :host([selected]:not([disabled])) .expand-collapse-button:hover {
    background: #e0e0e0;
  }

  :host([selected])::after {
    /* The background needs to be calculated based on the selected background state
          for this control. We currently have no way of changing that, so setting to
          accent-foreground-rest for the time being */
    background: #024cdf;
    border-radius: 4px;
    content: '';
    display: block;
    position: absolute;
    top: calc((${heightNumber} / 4) * 1px);
    width: 3px;
    height: calc((${heightNumber} / 2) * 1px);
  }

  ::slotted(tm1-tree-view-item) {
    --tree-item-nested-width: 1em;
    --expand-collapse-button-nested-width: calc(${heightNumber} * -1px);
  }
`.withBehaviors(
  forcedColorsStylesheetBehavior(css`
    :host {
      forced-color-adjust: none;
      border-color: transparent;
      background: ${SystemColors.Field};
      color: ${SystemColors.FieldText};
    }
    :host .content-region .expand-collapse-glyph {
      fill: ${SystemColors.FieldText};
    }
    :host .positioning-region:hover,
    :host([selected]) .positioning-region {
      background: ${SystemColors.Highlight};
    }
    :host .positioning-region:hover .content-region,
    :host([selected]) .positioning-region .content-region {
      color: ${SystemColors.HighlightText};
    }
    :host .positioning-region:hover .content-region .expand-collapse-glyph,
    :host .positioning-region:hover .content-region .start,
    :host .positioning-region:hover .content-region .end,
    :host([selected]) .content-region .expand-collapse-glyph,
    :host([selected]) .content-region .start,
    :host([selected]) .content-region .end {
      fill: ${SystemColors.HighlightText};
    }
    :host([selected])::after {
      background: ${SystemColors.Field};
    }
    :host(:${focusVisible}) .positioning-region {
      border-color: ${SystemColors.FieldText};
      box-shadow: 0 0 0 2px inset ${SystemColors.Field};
      color: ${SystemColors.FieldText};
    }
    :host([disabled]) .content-region,
    :host([disabled]) .positioning-region:hover .content-region {
      opacity: 1;
      color: ${SystemColors.GrayText};
    }
    :host([disabled]) .content-region .expand-collapse-glyph,
    :host([disabled]) .content-region .start,
    :host([disabled]) .content-region .end,
    :host([disabled]) .positioning-region:hover .content-region .expand-collapse-glyph,
    :host([disabled]) .positioning-region:hover .content-region .start,
    :host([disabled]) .positioning-region:hover .content-region .end {
      fill: ${SystemColors.GrayText};
    }
    :host([disabled]) .positioning-region:hover {
      background: ${SystemColors.Field};
    }
    .expand-collapse-glyph,
    .start,
    .end {
      fill: ${SystemColors.FieldText};
    }
    :host(.nested) .expand-collapse-button:hover {
      background: ${SystemColors.Field};
    }
    :host(.nested) .expand-collapse-button:hover .expand-collapse-glyph {
      fill: ${SystemColors.FieldText};
    }
  `)
), tm1TreeViewItemTemplate = (td, Ae) => html`
  <template
    role="treeitem"
    slot="${(xr) => xr.isNestedItem() ? "item" : void 0}"
    tabindex="-1"
    class="${(xr) => xr.expanded ? "expanded" : ""} ${(xr) => xr.selected ? "selected" : ""} ${(xr) => xr.nested ? "nested" : ""}
            ${(xr) => xr.disabled ? "disabled" : ""}"
    aria-expanded="${(xr) => xr.childItems && xr.childItemLength() > 0 ? xr.expanded : void 0}"
    aria-selected="${(xr) => xr.selected}"
    aria-disabled="${(xr) => xr.disabled}"
    @focusin="${(xr, ed) => xr.handleFocus(ed.event)}"
    @focusout="${(xr, ed) => xr.handleBlur(ed.event)}"
    ${children({
  property: "childItems",
  filter: elements()
})}
  >
    <div class="positioning-region" part="positioning-region">
      <div class="content-region" part="content-region">
        ${when(
  (xr) => xr.childItems && xr.childItemLength() > 0,
  html`
            <div
              aria-hidden="true"
              class="expand-collapse-button"
              part="expand-collapse-button"
              @click="${(xr, ed) => xr.handleExpandCollapseButtonClick(ed.event)}"
              ${ref("expandCollapseButton")}
            >
              <slot name="expand-collapse-glyph"> ${Ae.expandCollapseGlyph || ""} </slot>
            </div>
          `
)}
        ${startSlotTemplate(td, Ae)}
        <slot></slot>
        ${endSlotTemplate(td, Ae)}
      </div>
    </div>
    ${when(
  (xr) => xr.childItems && xr.childItemLength() > 0 && (xr.expanded || xr.renderCollapsedChildren),
  html`
        <div role="group" class="items" part="items">
          <slot name="item" ${slotted("items")}></slot>
        </div>
      `
)}
  </template>
`;
var __defProp$1 = Object.defineProperty, __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor, __decorateClass$1 = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc$1(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp$1(Ae, xr, id), id;
};
class TreeItem extends TreeItem$1 {
  constructor() {
    super(...arguments), this.ltr = !0;
  }
}
__decorateClass$1([
  attr({ mode: "boolean" })
], TreeItem.prototype, "ltr", 2);
const tm1TreeViewItem = TreeItem.compose({
  baseName: "tree-view-item",
  baseClass: TreeItem,
  template: tm1TreeViewItemTemplate,
  styles: tm1TreeViewItemStyles,
  expandCollapseGlyph: `
    <svg class="expand-collapse-glyph" width="12" height="12" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.65 2.15a.5.5 0 000 .7L7.79 6 4.65 9.15a.5.5 0 10.7.7l3.5-3.5a.5.5 0 000-.7l-3.5-3.5a.5.5 0 00-.7 0z"/>
    </svg>
  `
}), tm1TreeViewStyles = () => css`
  :host([hidden]) {
    display: none;
  }

  ${display("flex")} :host {
    flex-direction: column;
    align-items: stretch;
    min-width: fit-content;
    font-size: 14px;
  }

  :host:focus-visible {
    outline: none;
  }
`;
class TreeView extends TreeView$1 {
}
const tm1TreeView = TreeView.compose({
  baseName: "tree-view",
  baseClass: TreeView,
  template: treeViewTemplate,
  styles: tm1TreeViewStyles
});
designSystem.register(
  tm1TreeView(),
  tm1TreeViewItem()
);
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root$1.Symbol, objectProto$f = Object.prototype, hasOwnProperty$c = objectProto$f.hasOwnProperty, nativeObjectToString$1 = objectProto$f.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(td) {
  var Ae = hasOwnProperty$c.call(td, symToStringTag$1), xr = td[symToStringTag$1];
  try {
    td[symToStringTag$1] = void 0;
    var ed = !0;
  } catch (od) {
  }
  var id = nativeObjectToString$1.call(td);
  return ed && (Ae ? td[symToStringTag$1] = xr : delete td[symToStringTag$1]), id;
}
var objectProto$e = Object.prototype, nativeObjectToString = objectProto$e.toString;
function objectToString(td) {
  return nativeObjectToString.call(td);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(td) {
  return td == null ? td === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(td) ? getRawTag(td) : objectToString(td);
}
function isObjectLike(td) {
  return td != null && typeof td == "object";
}
var isArray = Array.isArray;
function isObject$1(td) {
  var Ae = typeof td;
  return td != null && (Ae == "object" || Ae == "function");
}
function identity(td) {
  return td;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(td) {
  if (!isObject$1(td))
    return !1;
  var Ae = baseGetTag(td);
  return Ae == funcTag$2 || Ae == genTag$1 || Ae == asyncTag || Ae == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"], maskSrcKey = function() {
  var td = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return td ? "Symbol(src)_1." + td : "";
}();
function isMasked(td) {
  return !!maskSrcKey && maskSrcKey in td;
}
var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource(td) {
  if (td != null) {
    try {
      return funcToString$2.call(td);
    } catch (Ae) {
    }
    try {
      return td + "";
    } catch (Ae) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$d = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$b = objectProto$d.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$b).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(td) {
  if (!isObject$1(td) || isMasked(td))
    return !1;
  var Ae = isFunction(td) ? reIsNative : reIsHostCtor;
  return Ae.test(toSource(td));
}
function getValue(td, Ae) {
  return td == null ? void 0 : td[Ae];
}
function getNative(td, Ae) {
  var xr = getValue(td, Ae);
  return baseIsNative(xr) ? xr : void 0;
}
var WeakMap$1 = getNative(root$1, "WeakMap"), objectCreate = Object.create, baseCreate = /* @__PURE__ */ function() {
  function td() {
  }
  return function(Ae) {
    if (!isObject$1(Ae))
      return {};
    if (objectCreate)
      return objectCreate(Ae);
    td.prototype = Ae;
    var xr = new td();
    return td.prototype = void 0, xr;
  };
}();
function apply(td, Ae, xr) {
  switch (xr.length) {
    case 0:
      return td.call(Ae);
    case 1:
      return td.call(Ae, xr[0]);
    case 2:
      return td.call(Ae, xr[0], xr[1]);
    case 3:
      return td.call(Ae, xr[0], xr[1], xr[2]);
  }
  return td.apply(Ae, xr);
}
function copyArray(td, Ae) {
  var xr = -1, ed = td.length;
  for (Ae || (Ae = Array(ed)); ++xr < ed; )
    Ae[xr] = td[xr];
  return Ae;
}
var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(td) {
  var Ae = 0, xr = 0;
  return function() {
    var ed = nativeNow(), id = HOT_SPAN - (ed - xr);
    if (xr = ed, id > 0) {
      if (++Ae >= HOT_COUNT)
        return arguments[0];
    } else
      Ae = 0;
    return td.apply(void 0, arguments);
  };
}
function constant(td) {
  return function() {
    return td;
  };
}
var defineProperty = function() {
  try {
    var td = getNative(Object, "defineProperty");
    return td({}, "", {}), td;
  } catch (Ae) {
  }
}(), baseSetToString = defineProperty ? function(td, Ae) {
  return defineProperty(td, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(Ae),
    writable: !0
  });
} : identity;
const baseSetToString$1 = baseSetToString;
var setToString = shortOut(baseSetToString$1);
function arrayEach(td, Ae) {
  for (var xr = -1, ed = td == null ? 0 : td.length; ++xr < ed && Ae(td[xr], xr, td) !== !1; )
    ;
  return td;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(td, Ae) {
  var xr = typeof td;
  return Ae = Ae == null ? MAX_SAFE_INTEGER$1 : Ae, !!Ae && (xr == "number" || xr != "symbol" && reIsUint.test(td)) && td > -1 && td % 1 == 0 && td < Ae;
}
function baseAssignValue(td, Ae, xr) {
  Ae == "__proto__" && defineProperty ? defineProperty(td, Ae, {
    configurable: !0,
    enumerable: !0,
    value: xr,
    writable: !0
  }) : td[Ae] = xr;
}
function eq(td, Ae) {
  return td === Ae || td !== td && Ae !== Ae;
}
var objectProto$c = Object.prototype, hasOwnProperty$a = objectProto$c.hasOwnProperty;
function assignValue(td, Ae, xr) {
  var ed = td[Ae];
  (!(hasOwnProperty$a.call(td, Ae) && eq(ed, xr)) || xr === void 0 && !(Ae in td)) && baseAssignValue(td, Ae, xr);
}
function copyObject(td, Ae, xr, ed) {
  var id = !xr;
  xr || (xr = {});
  for (var od = -1, ad = Ae.length; ++od < ad; ) {
    var rd = Ae[od], sd = ed ? ed(xr[rd], td[rd], rd, xr, td) : void 0;
    sd === void 0 && (sd = td[rd]), id ? baseAssignValue(xr, rd, sd) : assignValue(xr, rd, sd);
  }
  return xr;
}
var nativeMax = Math.max;
function overRest(td, Ae, xr) {
  return Ae = nativeMax(Ae === void 0 ? td.length - 1 : Ae, 0), function() {
    for (var ed = arguments, id = -1, od = nativeMax(ed.length - Ae, 0), ad = Array(od); ++id < od; )
      ad[id] = ed[Ae + id];
    id = -1;
    for (var rd = Array(Ae + 1); ++id < Ae; )
      rd[id] = ed[id];
    return rd[Ae] = xr(ad), apply(td, this, rd);
  };
}
function baseRest(td, Ae) {
  return setToString(overRest(td, Ae, identity), td + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(td) {
  return typeof td == "number" && td > -1 && td % 1 == 0 && td <= MAX_SAFE_INTEGER;
}
function isArrayLike(td) {
  return td != null && isLength(td.length) && !isFunction(td);
}
function isIterateeCall(td, Ae, xr) {
  if (!isObject$1(xr))
    return !1;
  var ed = typeof Ae;
  return (ed == "number" ? isArrayLike(xr) && isIndex(Ae, xr.length) : ed == "string" && Ae in xr) ? eq(xr[Ae], td) : !1;
}
function createAssigner(td) {
  return baseRest(function(Ae, xr) {
    var ed = -1, id = xr.length, od = id > 1 ? xr[id - 1] : void 0, ad = id > 2 ? xr[2] : void 0;
    for (od = td.length > 3 && typeof od == "function" ? (id--, od) : void 0, ad && isIterateeCall(xr[0], xr[1], ad) && (od = id < 3 ? void 0 : od, id = 1), Ae = Object(Ae); ++ed < id; ) {
      var rd = xr[ed];
      rd && td(Ae, rd, ed, od);
    }
    return Ae;
  });
}
var objectProto$b = Object.prototype;
function isPrototype(td) {
  var Ae = td && td.constructor, xr = typeof Ae == "function" && Ae.prototype || objectProto$b;
  return td === xr;
}
function baseTimes(td, Ae) {
  for (var xr = -1, ed = Array(td); ++xr < td; )
    ed[xr] = Ae(xr);
  return ed;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(td) {
  return isObjectLike(td) && baseGetTag(td) == argsTag$3;
}
var objectProto$a = Object.prototype, hasOwnProperty$9 = objectProto$a.hasOwnProperty, propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(td) {
  return isObjectLike(td) && hasOwnProperty$9.call(td, "callee") && !propertyIsEnumerable$1.call(td, "callee");
};
const isArguments$1 = isArguments;
function stubFalse() {
  return !1;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$2 = moduleExports$2 ? root$1.Buffer : void 0, nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse, argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = !0;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = !1;
function baseIsTypedArray(td) {
  return isObjectLike(td) && isLength(td.length) && !!typedArrayTags[baseGetTag(td)];
}
function baseUnary(td) {
  return function(Ae) {
    return td(Ae);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal.process, nodeUtil = function() {
  try {
    var td = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return td || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (Ae) {
  }
}(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, objectProto$9 = Object.prototype, hasOwnProperty$8 = objectProto$9.hasOwnProperty;
function arrayLikeKeys(td, Ae) {
  var xr = isArray(td), ed = !xr && isArguments$1(td), id = !xr && !ed && isBuffer(td), od = !xr && !ed && !id && isTypedArray(td), ad = xr || ed || id || od, rd = ad ? baseTimes(td.length, String) : [], sd = rd.length;
  for (var nd in td)
    (Ae || hasOwnProperty$8.call(td, nd)) && !(ad && // Safari 9 has enumerable `arguments.length` in strict mode.
    (nd == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    id && (nd == "offset" || nd == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    od && (nd == "buffer" || nd == "byteLength" || nd == "byteOffset") || // Skip index properties.
    isIndex(nd, sd))) && rd.push(nd);
  return rd;
}
function overArg(td, Ae) {
  return function(xr) {
    return td(Ae(xr));
  };
}
var nativeKeys = overArg(Object.keys, Object), objectProto$8 = Object.prototype, hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function baseKeys(td) {
  if (!isPrototype(td))
    return nativeKeys(td);
  var Ae = [];
  for (var xr in Object(td))
    hasOwnProperty$7.call(td, xr) && xr != "constructor" && Ae.push(xr);
  return Ae;
}
function keys(td) {
  return isArrayLike(td) ? arrayLikeKeys(td) : baseKeys(td);
}
function nativeKeysIn(td) {
  var Ae = [];
  if (td != null)
    for (var xr in Object(td))
      Ae.push(xr);
  return Ae;
}
var objectProto$7 = Object.prototype, hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function baseKeysIn(td) {
  if (!isObject$1(td))
    return nativeKeysIn(td);
  var Ae = isPrototype(td), xr = [];
  for (var ed in td)
    ed == "constructor" && (Ae || !hasOwnProperty$6.call(td, ed)) || xr.push(ed);
  return xr;
}
function keysIn(td) {
  return isArrayLike(td) ? arrayLikeKeys(td, !0) : baseKeysIn(td);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(td) {
  var Ae = this.has(td) && delete this.__data__[td];
  return this.size -= Ae ? 1 : 0, Ae;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$6 = Object.prototype, hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function hashGet(td) {
  var Ae = this.__data__;
  if (nativeCreate) {
    var xr = Ae[td];
    return xr === HASH_UNDEFINED$2 ? void 0 : xr;
  }
  return hasOwnProperty$5.call(Ae, td) ? Ae[td] : void 0;
}
var objectProto$5 = Object.prototype, hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function hashHas(td) {
  var Ae = this.__data__;
  return nativeCreate ? Ae[td] !== void 0 : hasOwnProperty$4.call(Ae, td);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(td, Ae) {
  var xr = this.__data__;
  return this.size += this.has(td) ? 0 : 1, xr[td] = nativeCreate && Ae === void 0 ? HASH_UNDEFINED$1 : Ae, this;
}
function Hash(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.clear(); ++Ae < xr; ) {
    var ed = td[Ae];
    this.set(ed[0], ed[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function assocIndexOf(td, Ae) {
  for (var xr = td.length; xr--; )
    if (eq(td[xr][0], Ae))
      return xr;
  return -1;
}
var arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete(td) {
  var Ae = this.__data__, xr = assocIndexOf(Ae, td);
  if (xr < 0)
    return !1;
  var ed = Ae.length - 1;
  return xr == ed ? Ae.pop() : splice.call(Ae, xr, 1), --this.size, !0;
}
function listCacheGet(td) {
  var Ae = this.__data__, xr = assocIndexOf(Ae, td);
  return xr < 0 ? void 0 : Ae[xr][1];
}
function listCacheHas(td) {
  return assocIndexOf(this.__data__, td) > -1;
}
function listCacheSet(td, Ae) {
  var xr = this.__data__, ed = assocIndexOf(xr, td);
  return ed < 0 ? (++this.size, xr.push([td, Ae])) : xr[ed][1] = Ae, this;
}
function ListCache(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.clear(); ++Ae < xr; ) {
    var ed = td[Ae];
    this.set(ed[0], ed[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$1, "Map");
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$1 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(td) {
  var Ae = typeof td;
  return Ae == "string" || Ae == "number" || Ae == "symbol" || Ae == "boolean" ? td !== "__proto__" : td === null;
}
function getMapData(td, Ae) {
  var xr = td.__data__;
  return isKeyable(Ae) ? xr[typeof Ae == "string" ? "string" : "hash"] : xr.map;
}
function mapCacheDelete(td) {
  var Ae = getMapData(this, td).delete(td);
  return this.size -= Ae ? 1 : 0, Ae;
}
function mapCacheGet(td) {
  return getMapData(this, td).get(td);
}
function mapCacheHas(td) {
  return getMapData(this, td).has(td);
}
function mapCacheSet(td, Ae) {
  var xr = getMapData(this, td), ed = xr.size;
  return xr.set(td, Ae), this.size += xr.size == ed ? 0 : 1, this;
}
function MapCache(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.clear(); ++Ae < xr; ) {
    var ed = td[Ae];
    this.set(ed[0], ed[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function arrayPush(td, Ae) {
  for (var xr = -1, ed = Ae.length, id = td.length; ++xr < ed; )
    td[id + xr] = Ae[xr];
  return td;
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
const getPrototype$1 = getPrototype;
var objectTag$3 = "[object Object]", funcProto = Function.prototype, objectProto$4 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$3 = objectProto$4.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject$3(td) {
  if (!isObjectLike(td) || baseGetTag(td) != objectTag$3)
    return !1;
  var Ae = getPrototype$1(td);
  if (Ae === null)
    return !0;
  var xr = hasOwnProperty$3.call(Ae, "constructor") && Ae.constructor;
  return typeof xr == "function" && xr instanceof xr && funcToString.call(xr) == objectCtorString;
}
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(td) {
  var Ae = this.__data__, xr = Ae.delete(td);
  return this.size = Ae.size, xr;
}
function stackGet(td) {
  return this.__data__.get(td);
}
function stackHas(td) {
  return this.__data__.has(td);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(td, Ae) {
  var xr = this.__data__;
  if (xr instanceof ListCache) {
    var ed = xr.__data__;
    if (!Map$1 || ed.length < LARGE_ARRAY_SIZE - 1)
      return ed.push([td, Ae]), this.size = ++xr.size, this;
    xr = this.__data__ = new MapCache(ed);
  }
  return xr.set(td, Ae), this.size = xr.size, this;
}
function Stack(td) {
  var Ae = this.__data__ = new ListCache(td);
  this.size = Ae.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(td, Ae) {
  return td && copyObject(Ae, keys(Ae), td);
}
function baseAssignIn(td, Ae) {
  return td && copyObject(Ae, keysIn(Ae), td);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$1 = moduleExports ? root$1.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(td, Ae) {
  if (Ae)
    return td.slice();
  var xr = td.length, ed = allocUnsafe ? allocUnsafe(xr) : new td.constructor(xr);
  return td.copy(ed), ed;
}
function arrayFilter(td, Ae) {
  for (var xr = -1, ed = td == null ? 0 : td.length, id = 0, od = []; ++xr < ed; ) {
    var ad = td[xr];
    Ae(ad, xr, td) && (od[id++] = ad);
  }
  return od;
}
function stubArray() {
  return [];
}
var objectProto$3 = Object.prototype, propertyIsEnumerable = objectProto$3.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols$1 ? function(td) {
  return td == null ? [] : (td = Object(td), arrayFilter(nativeGetSymbols$1(td), function(Ae) {
    return propertyIsEnumerable.call(td, Ae);
  }));
} : stubArray;
function copySymbols(td, Ae) {
  return copyObject(td, getSymbols(td), Ae);
}
var nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(td) {
  for (var Ae = []; td; )
    arrayPush(Ae, getSymbols(td)), td = getPrototype$1(td);
  return Ae;
} : stubArray;
function copySymbolsIn(td, Ae) {
  return copyObject(td, getSymbolsIn(td), Ae);
}
function baseGetAllKeys(td, Ae, xr) {
  var ed = Ae(td);
  return isArray(td) ? ed : arrayPush(ed, xr(td));
}
function getAllKeys(td) {
  return baseGetAllKeys(td, keys, getSymbols);
}
function getAllKeysIn(td) {
  return baseGetAllKeys(td, keysIn, getSymbolsIn);
}
var DataView = getNative(root$1, "DataView"), Promise$1 = getNative(root$1, "Promise"), Set$1 = getNative(root$1, "Set"), mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]", dataViewTag$3 = "[object DataView]", dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$4 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) && (getTag = function(td) {
  var Ae = baseGetTag(td), xr = Ae == objectTag$2 ? td.constructor : void 0, ed = xr ? toSource(xr) : "";
  if (ed)
    switch (ed) {
      case dataViewCtorString:
        return dataViewTag$3;
      case mapCtorString:
        return mapTag$4;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$4;
      case weakMapCtorString:
        return weakMapTag$1;
    }
  return Ae;
});
const getTag$1 = getTag;
var objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function initCloneArray(td) {
  var Ae = td.length, xr = new td.constructor(Ae);
  return Ae && typeof td[0] == "string" && hasOwnProperty$2.call(td, "index") && (xr.index = td.index, xr.input = td.input), xr;
}
var Uint8Array$1 = root$1.Uint8Array;
function cloneArrayBuffer(td) {
  var Ae = new td.constructor(td.byteLength);
  return new Uint8Array$1(Ae).set(new Uint8Array$1(td)), Ae;
}
function cloneDataView(td, Ae) {
  var xr = Ae ? cloneArrayBuffer(td.buffer) : td.buffer;
  return new td.constructor(xr, td.byteOffset, td.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(td) {
  var Ae = new td.constructor(td.source, reFlags.exec(td));
  return Ae.lastIndex = td.lastIndex, Ae;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(td) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(td)) : {};
}
function cloneTypedArray(td, Ae) {
  var xr = Ae ? cloneArrayBuffer(td.buffer) : td.buffer;
  return new td.constructor(xr, td.byteOffset, td.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(td, Ae, xr) {
  var ed = td.constructor;
  switch (Ae) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(td);
    case boolTag$2:
    case dateTag$2:
      return new ed(+td);
    case dataViewTag$2:
      return cloneDataView(td, xr);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(td, xr);
    case mapTag$3:
      return new ed();
    case numberTag$2:
    case stringTag$2:
      return new ed(td);
    case regexpTag$2:
      return cloneRegExp(td);
    case setTag$3:
      return new ed();
    case symbolTag$2:
      return cloneSymbol(td);
  }
}
function initCloneObject(td) {
  return typeof td.constructor == "function" && !isPrototype(td) ? baseCreate(getPrototype$1(td)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(td) {
  return isObjectLike(td) && getTag$1(td) == mapTag$2;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap, isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap, setTag$2 = "[object Set]";
function baseIsSet(td) {
  return isObjectLike(td) && getTag$1(td) == setTag$2;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet, isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet, CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(td, Ae, xr, ed, id, od) {
  var ad, rd = Ae & CLONE_DEEP_FLAG$1, sd = Ae & CLONE_FLAT_FLAG, nd = Ae & CLONE_SYMBOLS_FLAG$1;
  if (xr && (ad = id ? xr(td, ed, id, od) : xr(td)), ad !== void 0)
    return ad;
  if (!isObject$1(td))
    return td;
  var cd = isArray(td);
  if (cd) {
    if (ad = initCloneArray(td), !rd)
      return copyArray(td, ad);
  } else {
    var ud = getTag$1(td), ld = ud == funcTag || ud == genTag;
    if (isBuffer(td))
      return cloneBuffer(td, rd);
    if (ud == objectTag$1 || ud == argsTag$1 || ld && !id) {
      if (ad = sd || ld ? {} : initCloneObject(td), !rd)
        return sd ? copySymbolsIn(td, baseAssignIn(ad, td)) : copySymbols(td, baseAssign(ad, td));
    } else {
      if (!cloneableTags[ud])
        return id ? td : {};
      ad = initCloneByTag(td, ud, rd);
    }
  }
  od || (od = new Stack());
  var dd = od.get(td);
  if (dd)
    return dd;
  od.set(td, ad), isSet(td) ? td.forEach(function(fd) {
    ad.add(baseClone(fd, Ae, xr, fd, td, od));
  }) : isMap(td) && td.forEach(function(fd, bd) {
    ad.set(bd, baseClone(fd, Ae, xr, bd, td, od));
  });
  var pd = nd ? sd ? getAllKeysIn : getAllKeys : sd ? keysIn : keys, md = cd ? void 0 : pd(td);
  return arrayEach(md || td, function(fd, bd) {
    md && (bd = fd, fd = td[bd]), assignValue(ad, bd, baseClone(fd, Ae, xr, bd, td, od));
  }), ad;
}
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep$1(td) {
  return baseClone(td, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(td) {
  return this.__data__.set(td, HASH_UNDEFINED), this;
}
function setCacheHas(td) {
  return this.__data__.has(td);
}
function SetCache(td) {
  var Ae = -1, xr = td == null ? 0 : td.length;
  for (this.__data__ = new MapCache(); ++Ae < xr; )
    this.add(td[Ae]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(td, Ae) {
  for (var xr = -1, ed = td == null ? 0 : td.length; ++xr < ed; )
    if (Ae(td[xr], xr, td))
      return !0;
  return !1;
}
function cacheHas(td, Ae) {
  return td.has(Ae);
}
var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays(td, Ae, xr, ed, id, od) {
  var ad = xr & COMPARE_PARTIAL_FLAG$3, rd = td.length, sd = Ae.length;
  if (rd != sd && !(ad && sd > rd))
    return !1;
  var nd = od.get(td), cd = od.get(Ae);
  if (nd && cd)
    return nd == Ae && cd == td;
  var ud = -1, ld = !0, dd = xr & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  for (od.set(td, Ae), od.set(Ae, td); ++ud < rd; ) {
    var pd = td[ud], md = Ae[ud];
    if (ed)
      var fd = ad ? ed(md, pd, ud, Ae, td, od) : ed(pd, md, ud, td, Ae, od);
    if (fd !== void 0) {
      if (fd)
        continue;
      ld = !1;
      break;
    }
    if (dd) {
      if (!arraySome(Ae, function(bd, Sd) {
        if (!cacheHas(dd, Sd) && (pd === bd || id(pd, bd, xr, ed, od)))
          return dd.push(Sd);
      })) {
        ld = !1;
        break;
      }
    } else if (!(pd === md || id(pd, md, xr, ed, od))) {
      ld = !1;
      break;
    }
  }
  return od.delete(td), od.delete(Ae), ld;
}
function mapToArray(td) {
  var Ae = -1, xr = Array(td.size);
  return td.forEach(function(ed, id) {
    xr[++Ae] = [id, ed];
  }), xr;
}
function setToArray(td) {
  var Ae = -1, xr = Array(td.size);
  return td.forEach(function(ed) {
    xr[++Ae] = ed;
  }), xr;
}
var COMPARE_PARTIAL_FLAG$2 = 1, COMPARE_UNORDERED_FLAG = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(td, Ae, xr, ed, id, od, ad) {
  switch (xr) {
    case dataViewTag:
      if (td.byteLength != Ae.byteLength || td.byteOffset != Ae.byteOffset)
        return !1;
      td = td.buffer, Ae = Ae.buffer;
    case arrayBufferTag:
      return !(td.byteLength != Ae.byteLength || !od(new Uint8Array$1(td), new Uint8Array$1(Ae)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+td, +Ae);
    case errorTag:
      return td.name == Ae.name && td.message == Ae.message;
    case regexpTag:
    case stringTag:
      return td == Ae + "";
    case mapTag:
      var rd = mapToArray;
    case setTag:
      var sd = ed & COMPARE_PARTIAL_FLAG$2;
      if (rd || (rd = setToArray), td.size != Ae.size && !sd)
        return !1;
      var nd = ad.get(td);
      if (nd)
        return nd == Ae;
      ed |= COMPARE_UNORDERED_FLAG, ad.set(td, Ae);
      var cd = equalArrays(rd(td), rd(Ae), ed, id, od, ad);
      return ad.delete(td), cd;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(td) == symbolValueOf.call(Ae);
  }
  return !1;
}
var COMPARE_PARTIAL_FLAG$1 = 1, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects(td, Ae, xr, ed, id, od) {
  var ad = xr & COMPARE_PARTIAL_FLAG$1, rd = getAllKeys(td), sd = rd.length, nd = getAllKeys(Ae), cd = nd.length;
  if (sd != cd && !ad)
    return !1;
  for (var ud = sd; ud--; ) {
    var ld = rd[ud];
    if (!(ad ? ld in Ae : hasOwnProperty$1.call(Ae, ld)))
      return !1;
  }
  var dd = od.get(td), pd = od.get(Ae);
  if (dd && pd)
    return dd == Ae && pd == td;
  var md = !0;
  od.set(td, Ae), od.set(Ae, td);
  for (var fd = ad; ++ud < sd; ) {
    ld = rd[ud];
    var bd = td[ld], Sd = Ae[ld];
    if (ed)
      var vd = ad ? ed(Sd, bd, ld, Ae, td, od) : ed(bd, Sd, ld, td, Ae, od);
    if (!(vd === void 0 ? bd === Sd || id(bd, Sd, xr, ed, od) : vd)) {
      md = !1;
      break;
    }
    fd || (fd = ld == "constructor");
  }
  if (md && !fd) {
    var Ed = td.constructor, Td = Ae.constructor;
    Ed != Td && "constructor" in td && "constructor" in Ae && !(typeof Ed == "function" && Ed instanceof Ed && typeof Td == "function" && Td instanceof Td) && (md = !1);
  }
  return od.delete(td), od.delete(Ae), md;
}
var COMPARE_PARTIAL_FLAG = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep(td, Ae, xr, ed, id, od) {
  var ad = isArray(td), rd = isArray(Ae), sd = ad ? arrayTag : getTag$1(td), nd = rd ? arrayTag : getTag$1(Ae);
  sd = sd == argsTag ? objectTag : sd, nd = nd == argsTag ? objectTag : nd;
  var cd = sd == objectTag, ud = nd == objectTag, ld = sd == nd;
  if (ld && isBuffer(td)) {
    if (!isBuffer(Ae))
      return !1;
    ad = !0, cd = !1;
  }
  if (ld && !cd)
    return od || (od = new Stack()), ad || isTypedArray(td) ? equalArrays(td, Ae, xr, ed, id, od) : equalByTag(td, Ae, sd, xr, ed, id, od);
  if (!(xr & COMPARE_PARTIAL_FLAG)) {
    var dd = cd && hasOwnProperty.call(td, "__wrapped__"), pd = ud && hasOwnProperty.call(Ae, "__wrapped__");
    if (dd || pd) {
      var md = dd ? td.value() : td, fd = pd ? Ae.value() : Ae;
      return od || (od = new Stack()), id(md, fd, xr, ed, od);
    }
  }
  return ld ? (od || (od = new Stack()), equalObjects(td, Ae, xr, ed, id, od)) : !1;
}
function baseIsEqual(td, Ae, xr, ed, id) {
  return td === Ae ? !0 : td == null || Ae == null || !isObjectLike(td) && !isObjectLike(Ae) ? td !== td && Ae !== Ae : baseIsEqualDeep(td, Ae, xr, ed, baseIsEqual, id);
}
function createBaseFor(td) {
  return function(Ae, xr, ed) {
    for (var id = -1, od = Object(Ae), ad = ed(Ae), rd = ad.length; rd--; ) {
      var sd = ad[td ? rd : ++id];
      if (xr(od[sd], sd, od) === !1)
        break;
    }
    return Ae;
  };
}
var baseFor = createBaseFor();
function assignMergeValue(td, Ae, xr) {
  (xr !== void 0 && !eq(td[Ae], xr) || xr === void 0 && !(Ae in td)) && baseAssignValue(td, Ae, xr);
}
function isArrayLikeObject(td) {
  return isObjectLike(td) && isArrayLike(td);
}
function safeGet(td, Ae) {
  if (!(Ae === "constructor" && typeof td[Ae] == "function") && Ae != "__proto__")
    return td[Ae];
}
function toPlainObject(td) {
  return copyObject(td, keysIn(td));
}
function baseMergeDeep(td, Ae, xr, ed, id, od, ad) {
  var rd = safeGet(td, xr), sd = safeGet(Ae, xr), nd = ad.get(sd);
  if (nd) {
    assignMergeValue(td, xr, nd);
    return;
  }
  var cd = od ? od(rd, sd, xr + "", td, Ae, ad) : void 0, ud = cd === void 0;
  if (ud) {
    var ld = isArray(sd), dd = !ld && isBuffer(sd), pd = !ld && !dd && isTypedArray(sd);
    cd = sd, ld || dd || pd ? isArray(rd) ? cd = rd : isArrayLikeObject(rd) ? cd = copyArray(rd) : dd ? (ud = !1, cd = cloneBuffer(sd, !0)) : pd ? (ud = !1, cd = cloneTypedArray(sd, !0)) : cd = [] : isPlainObject$3(sd) || isArguments$1(sd) ? (cd = rd, isArguments$1(rd) ? cd = toPlainObject(rd) : (!isObject$1(rd) || isFunction(rd)) && (cd = initCloneObject(sd))) : ud = !1;
  }
  ud && (ad.set(sd, cd), id(cd, sd, ed, od, ad), ad.delete(sd)), assignMergeValue(td, xr, cd);
}
function baseMerge(td, Ae, xr, ed, id) {
  td !== Ae && baseFor(Ae, function(od, ad) {
    if (id || (id = new Stack()), isObject$1(od))
      baseMergeDeep(td, Ae, ad, xr, baseMerge, ed, id);
    else {
      var rd = ed ? ed(safeGet(td, ad), od, ad + "", td, Ae, id) : void 0;
      rd === void 0 && (rd = od), assignMergeValue(td, ad, rd);
    }
  }, keysIn);
}
function isEqual$2(td, Ae) {
  return baseIsEqual(td, Ae);
}
var merge = createAssigner(function(td, Ae, xr) {
  baseMerge(td, Ae, xr);
}), Scope = /* @__PURE__ */ ((td) => (td[td.TYPE = 3] = "TYPE", td[td.LEVEL = 12] = "LEVEL", td[td.ATTRIBUTE = 13] = "ATTRIBUTE", td[td.BLOT = 14] = "BLOT", td[td.INLINE = 7] = "INLINE", td[td.BLOCK = 11] = "BLOCK", td[td.BLOCK_BLOT = 10] = "BLOCK_BLOT", td[td.INLINE_BLOT = 6] = "INLINE_BLOT", td[td.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", td[td.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", td[td.ANY = 15] = "ANY", td))(Scope || {});
class Attributor {
  constructor(Ae, xr, ed = {}) {
    this.attrName = Ae, this.keyName = xr;
    const id = Scope.TYPE & Scope.ATTRIBUTE;
    this.scope = ed.scope != null ? (
      // Ignore type bits, force attribute bit
      ed.scope & Scope.LEVEL | id
    ) : Scope.ATTRIBUTE, ed.whitelist != null && (this.whitelist = ed.whitelist);
  }
  static keys(Ae) {
    return Array.from(Ae.attributes).map((xr) => xr.name);
  }
  add(Ae, xr) {
    return this.canAdd(Ae, xr) ? (Ae.setAttribute(this.keyName, xr), !0) : !1;
  }
  canAdd(Ae, xr) {
    return this.whitelist == null ? !0 : typeof xr == "string" ? this.whitelist.indexOf(xr.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(xr) > -1;
  }
  remove(Ae) {
    Ae.removeAttribute(this.keyName);
  }
  value(Ae) {
    const xr = Ae.getAttribute(this.keyName);
    return this.canAdd(Ae, xr) && xr ? xr : "";
  }
}
class ParchmentError extends Error {
  constructor(Ae) {
    Ae = "[Parchment] " + Ae, super(Ae), this.message = Ae, this.name = this.constructor.name;
  }
}
const _Registry = class r0 {
  constructor() {
    this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
  }
  static find(Ae, xr = !1) {
    if (Ae == null)
      return null;
    if (this.blots.has(Ae))
      return this.blots.get(Ae) || null;
    if (xr) {
      let ed = null;
      try {
        ed = Ae.parentNode;
      } catch (id) {
        return null;
      }
      return this.find(ed, xr);
    }
    return null;
  }
  create(Ae, xr, ed) {
    const id = this.query(xr);
    if (id == null)
      throw new ParchmentError(`Unable to create ${xr} blot`);
    const od = id, ad = (
      // @ts-expect-error Fix me later
      xr instanceof Node || xr.nodeType === Node.TEXT_NODE ? xr : od.create(ed)
    ), rd = new od(Ae, ad, ed);
    return r0.blots.set(rd.domNode, rd), rd;
  }
  find(Ae, xr = !1) {
    return r0.find(Ae, xr);
  }
  query(Ae, xr = Scope.ANY) {
    let ed;
    return typeof Ae == "string" ? ed = this.types[Ae] || this.attributes[Ae] : Ae instanceof Text || Ae.nodeType === Node.TEXT_NODE ? ed = this.types.text : typeof Ae == "number" ? Ae & Scope.LEVEL & Scope.BLOCK ? ed = this.types.block : Ae & Scope.LEVEL & Scope.INLINE && (ed = this.types.inline) : Ae instanceof Element && ((Ae.getAttribute("class") || "").split(/\s+/).some((id) => (ed = this.classes[id], !!ed)), ed = ed || this.tags[Ae.tagName]), ed == null ? null : "scope" in ed && xr & Scope.LEVEL & ed.scope && xr & Scope.TYPE & ed.scope ? ed : null;
  }
  register(...Ae) {
    return Ae.map((xr) => {
      const ed = "blotName" in xr, id = "attrName" in xr;
      if (!ed && !id)
        throw new ParchmentError("Invalid definition");
      if (ed && xr.blotName === "abstract")
        throw new ParchmentError("Cannot register abstract class");
      const od = ed ? xr.blotName : id ? xr.attrName : void 0;
      return this.types[od] = xr, id ? typeof xr.keyName == "string" && (this.attributes[xr.keyName] = xr) : ed && (xr.className && (this.classes[xr.className] = xr), xr.tagName && (Array.isArray(xr.tagName) ? xr.tagName = xr.tagName.map((ad) => ad.toUpperCase()) : xr.tagName = xr.tagName.toUpperCase(), (Array.isArray(xr.tagName) ? xr.tagName : [xr.tagName]).forEach((ad) => {
        (this.tags[ad] == null || xr.className == null) && (this.tags[ad] = xr);
      }))), xr;
    });
  }
};
_Registry.blots = /* @__PURE__ */ new WeakMap();
let Registry = _Registry;
function match(td, Ae) {
  return (td.getAttribute("class") || "").split(/\s+/).filter((xr) => xr.indexOf(`${Ae}-`) === 0);
}
class ClassAttributor extends Attributor {
  static keys(Ae) {
    return (Ae.getAttribute("class") || "").split(/\s+/).map((xr) => xr.split("-").slice(0, -1).join("-"));
  }
  add(Ae, xr) {
    return this.canAdd(Ae, xr) ? (this.remove(Ae), Ae.classList.add(`${this.keyName}-${xr}`), !0) : !1;
  }
  remove(Ae) {
    match(Ae, this.keyName).forEach((xr) => {
      Ae.classList.remove(xr);
    }), Ae.classList.length === 0 && Ae.removeAttribute("class");
  }
  value(Ae) {
    const xr = (match(Ae, this.keyName)[0] || "").slice(this.keyName.length + 1);
    return this.canAdd(Ae, xr) ? xr : "";
  }
}
const ClassAttributor$1 = ClassAttributor;
function camelize(td) {
  const Ae = td.split("-"), xr = Ae.slice(1).map((ed) => ed[0].toUpperCase() + ed.slice(1)).join("");
  return Ae[0] + xr;
}
class StyleAttributor extends Attributor {
  static keys(Ae) {
    return (Ae.getAttribute("style") || "").split(";").map((xr) => xr.split(":")[0].trim());
  }
  add(Ae, xr) {
    return this.canAdd(Ae, xr) ? (Ae.style[camelize(this.keyName)] = xr, !0) : !1;
  }
  remove(Ae) {
    Ae.style[camelize(this.keyName)] = "", Ae.getAttribute("style") || Ae.removeAttribute("style");
  }
  value(Ae) {
    const xr = Ae.style[camelize(this.keyName)];
    return this.canAdd(Ae, xr) ? xr : "";
  }
}
const StyleAttributor$1 = StyleAttributor;
class AttributorStore {
  constructor(Ae) {
    this.attributes = {}, this.domNode = Ae, this.build();
  }
  attribute(Ae, xr) {
    xr ? Ae.add(this.domNode, xr) && (Ae.value(this.domNode) != null ? this.attributes[Ae.attrName] = Ae : delete this.attributes[Ae.attrName]) : (Ae.remove(this.domNode), delete this.attributes[Ae.attrName]);
  }
  build() {
    this.attributes = {};
    const Ae = Registry.find(this.domNode);
    if (Ae == null)
      return;
    const xr = Attributor.keys(this.domNode), ed = ClassAttributor$1.keys(this.domNode), id = StyleAttributor$1.keys(this.domNode);
    xr.concat(ed).concat(id).forEach((od) => {
      const ad = Ae.scroll.query(od, Scope.ATTRIBUTE);
      ad instanceof Attributor && (this.attributes[ad.attrName] = ad);
    });
  }
  copy(Ae) {
    Object.keys(this.attributes).forEach((xr) => {
      const ed = this.attributes[xr].value(this.domNode);
      Ae.format(xr, ed);
    });
  }
  move(Ae) {
    this.copy(Ae), Object.keys(this.attributes).forEach((xr) => {
      this.attributes[xr].remove(this.domNode);
    }), this.attributes = {};
  }
  values() {
    return Object.keys(this.attributes).reduce(
      (Ae, xr) => (Ae[xr] = this.attributes[xr].value(this.domNode), Ae),
      {}
    );
  }
}
const AttributorStore$1 = AttributorStore, _ShadowBlot = class {
  constructor(Ae, xr) {
    this.scroll = Ae, this.domNode = xr, Registry.blots.set(xr, this), this.prev = null, this.next = null;
  }
  static create(Ae) {
    if (this.tagName == null)
      throw new ParchmentError("Blot definition missing tagName");
    let xr, ed;
    return Array.isArray(this.tagName) ? (typeof Ae == "string" ? (ed = Ae.toUpperCase(), parseInt(ed, 10).toString() === ed && (ed = parseInt(ed, 10))) : typeof Ae == "number" && (ed = Ae), typeof ed == "number" ? xr = document.createElement(this.tagName[ed - 1]) : ed && this.tagName.indexOf(ed) > -1 ? xr = document.createElement(ed) : xr = document.createElement(this.tagName[0])) : xr = document.createElement(this.tagName), this.className && xr.classList.add(this.className), xr;
  }
  // Hack for accessing inherited static methods
  get statics() {
    return this.constructor;
  }
  attach() {
  }
  clone() {
    const Ae = this.domNode.cloneNode(!1);
    return this.scroll.create(Ae);
  }
  detach() {
    this.parent != null && this.parent.removeChild(this), Registry.blots.delete(this.domNode);
  }
  deleteAt(Ae, xr) {
    this.isolate(Ae, xr).remove();
  }
  formatAt(Ae, xr, ed, id) {
    const od = this.isolate(Ae, xr);
    if (this.scroll.query(ed, Scope.BLOT) != null && id)
      od.wrap(ed, id);
    else if (this.scroll.query(ed, Scope.ATTRIBUTE) != null) {
      const ad = this.scroll.create(this.statics.scope);
      od.wrap(ad), ad.format(ed, id);
    }
  }
  insertAt(Ae, xr, ed) {
    const id = ed == null ? this.scroll.create("text", xr) : this.scroll.create(xr, ed), od = this.split(Ae);
    this.parent.insertBefore(id, od || void 0);
  }
  isolate(Ae, xr) {
    const ed = this.split(Ae);
    if (ed == null)
      throw new Error("Attempt to isolate at end");
    return ed.split(xr), ed;
  }
  length() {
    return 1;
  }
  offset(Ae = this.parent) {
    return this.parent == null || this === Ae ? 0 : this.parent.children.offset(this) + this.parent.offset(Ae);
  }
  optimize(Ae) {
    this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
  }
  remove() {
    this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
  }
  replaceWith(Ae, xr) {
    const ed = typeof Ae == "string" ? this.scroll.create(Ae, xr) : Ae;
    return this.parent != null && (this.parent.insertBefore(ed, this.next || void 0), this.remove()), ed;
  }
  split(Ae, xr) {
    return Ae === 0 ? this : this.next;
  }
  update(Ae, xr) {
  }
  wrap(Ae, xr) {
    const ed = typeof Ae == "string" ? this.scroll.create(Ae, xr) : Ae;
    if (this.parent != null && this.parent.insertBefore(ed, this.next || void 0), typeof ed.appendChild != "function")
      throw new ParchmentError(`Cannot wrap ${Ae}`);
    return ed.appendChild(this), ed;
  }
};
_ShadowBlot.blotName = "abstract";
let ShadowBlot = _ShadowBlot;
const _LeafBlot = class extends ShadowBlot {
  /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */
  static value(Ae) {
    return !0;
  }
  /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */
  index(Ae, xr) {
    return this.domNode === Ae || this.domNode.compareDocumentPosition(Ae) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(xr, 1) : -1;
  }
  /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */
  position(Ae, xr) {
    let ed = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
    return Ae > 0 && (ed += 1), [this.parent.domNode, ed];
  }
  /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */
  value() {
    return {
      [this.statics.blotName]: this.statics.value(this.domNode) || !0
    };
  }
};
_LeafBlot.scope = Scope.INLINE_BLOT;
let LeafBlot = _LeafBlot;
const LeafBlot$1 = LeafBlot;
class LinkedList {
  constructor() {
    this.head = null, this.tail = null, this.length = 0;
  }
  append(...Ae) {
    if (this.insertBefore(Ae[0], null), Ae.length > 1) {
      const xr = Ae.slice(1);
      this.append(...xr);
    }
  }
  at(Ae) {
    const xr = this.iterator();
    let ed = xr();
    for (; ed && Ae > 0; )
      Ae -= 1, ed = xr();
    return ed;
  }
  contains(Ae) {
    const xr = this.iterator();
    let ed = xr();
    for (; ed; ) {
      if (ed === Ae)
        return !0;
      ed = xr();
    }
    return !1;
  }
  indexOf(Ae) {
    const xr = this.iterator();
    let ed = xr(), id = 0;
    for (; ed; ) {
      if (ed === Ae)
        return id;
      id += 1, ed = xr();
    }
    return -1;
  }
  insertBefore(Ae, xr) {
    Ae != null && (this.remove(Ae), Ae.next = xr, xr != null ? (Ae.prev = xr.prev, xr.prev != null && (xr.prev.next = Ae), xr.prev = Ae, xr === this.head && (this.head = Ae)) : this.tail != null ? (this.tail.next = Ae, Ae.prev = this.tail, this.tail = Ae) : (Ae.prev = null, this.head = this.tail = Ae), this.length += 1);
  }
  offset(Ae) {
    let xr = 0, ed = this.head;
    for (; ed != null; ) {
      if (ed === Ae)
        return xr;
      xr += ed.length(), ed = ed.next;
    }
    return -1;
  }
  remove(Ae) {
    this.contains(Ae) && (Ae.prev != null && (Ae.prev.next = Ae.next), Ae.next != null && (Ae.next.prev = Ae.prev), Ae === this.head && (this.head = Ae.next), Ae === this.tail && (this.tail = Ae.prev), this.length -= 1);
  }
  iterator(Ae = this.head) {
    return () => {
      const xr = Ae;
      return Ae != null && (Ae = Ae.next), xr;
    };
  }
  find(Ae, xr = !1) {
    const ed = this.iterator();
    let id = ed();
    for (; id; ) {
      const od = id.length();
      if (Ae < od || xr && Ae === od && (id.next == null || id.next.length() !== 0))
        return [id, Ae];
      Ae -= od, id = ed();
    }
    return [null, 0];
  }
  forEach(Ae) {
    const xr = this.iterator();
    let ed = xr();
    for (; ed; )
      Ae(ed), ed = xr();
  }
  forEachAt(Ae, xr, ed) {
    if (xr <= 0)
      return;
    const [id, od] = this.find(Ae);
    let ad = Ae - od;
    const rd = this.iterator(id);
    let sd = rd();
    for (; sd && ad < Ae + xr; ) {
      const nd = sd.length();
      Ae > ad ? ed(
        sd,
        Ae - ad,
        Math.min(xr, ad + nd - Ae)
      ) : ed(sd, 0, Math.min(nd, Ae + xr - ad)), ad += nd, sd = rd();
    }
  }
  map(Ae) {
    return this.reduce((xr, ed) => (xr.push(Ae(ed)), xr), []);
  }
  reduce(Ae, xr) {
    const ed = this.iterator();
    let id = ed();
    for (; id; )
      xr = Ae(xr, id), id = ed();
    return xr;
  }
}
function makeAttachedBlot(td, Ae) {
  const xr = Ae.find(td);
  if (xr)
    return xr;
  try {
    return Ae.create(td);
  } catch (ed) {
    const id = Ae.create(Scope.INLINE);
    return Array.from(td.childNodes).forEach((od) => {
      id.domNode.appendChild(od);
    }), td.parentNode && td.parentNode.replaceChild(id.domNode, td), id.attach(), id;
  }
}
const _ParentBlot = class xh extends ShadowBlot {
  constructor(Ae, xr) {
    super(Ae, xr), this.uiNode = null, this.build();
  }
  appendChild(Ae) {
    this.insertBefore(Ae);
  }
  attach() {
    super.attach(), this.children.forEach((Ae) => {
      Ae.attach();
    });
  }
  attachUI(Ae) {
    this.uiNode != null && this.uiNode.remove(), this.uiNode = Ae, xh.uiClass && this.uiNode.classList.add(xh.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
  }
  /**
   * Called during construction, should fill its own children LinkedList.
   */
  build() {
    this.children = new LinkedList(), Array.from(this.domNode.childNodes).filter((Ae) => Ae !== this.uiNode).reverse().forEach((Ae) => {
      try {
        const xr = makeAttachedBlot(Ae, this.scroll);
        this.insertBefore(xr, this.children.head || void 0);
      } catch (xr) {
        if (xr instanceof ParchmentError)
          return;
        throw xr;
      }
    });
  }
  deleteAt(Ae, xr) {
    if (Ae === 0 && xr === this.length())
      return this.remove();
    this.children.forEachAt(Ae, xr, (ed, id, od) => {
      ed.deleteAt(id, od);
    });
  }
  descendant(Ae, xr = 0) {
    const [ed, id] = this.children.find(xr);
    return Ae.blotName == null && Ae(ed) || Ae.blotName != null && ed instanceof Ae ? [ed, id] : ed instanceof xh ? ed.descendant(Ae, id) : [null, -1];
  }
  descendants(Ae, xr = 0, ed = Number.MAX_VALUE) {
    let id = [], od = ed;
    return this.children.forEachAt(
      xr,
      ed,
      (ad, rd, sd) => {
        (Ae.blotName == null && Ae(ad) || Ae.blotName != null && ad instanceof Ae) && id.push(ad), ad instanceof xh && (id = id.concat(
          ad.descendants(Ae, rd, od)
        )), od -= sd;
      }
    ), id;
  }
  detach() {
    this.children.forEach((Ae) => {
      Ae.detach();
    }), super.detach();
  }
  enforceAllowedChildren() {
    let Ae = !1;
    this.children.forEach((xr) => {
      Ae || this.statics.allowedChildren.some(
        (ed) => xr instanceof ed
      ) || (xr.statics.scope === Scope.BLOCK_BLOT ? (xr.next != null && this.splitAfter(xr), xr.prev != null && this.splitAfter(xr.prev), xr.parent.unwrap(), Ae = !0) : xr instanceof xh ? xr.unwrap() : xr.remove());
    });
  }
  formatAt(Ae, xr, ed, id) {
    this.children.forEachAt(Ae, xr, (od, ad, rd) => {
      od.formatAt(ad, rd, ed, id);
    });
  }
  insertAt(Ae, xr, ed) {
    const [id, od] = this.children.find(Ae);
    if (id)
      id.insertAt(od, xr, ed);
    else {
      const ad = ed == null ? this.scroll.create("text", xr) : this.scroll.create(xr, ed);
      this.appendChild(ad);
    }
  }
  insertBefore(Ae, xr) {
    Ae.parent != null && Ae.parent.children.remove(Ae);
    let ed = null;
    this.children.insertBefore(Ae, xr || null), Ae.parent = this, xr != null && (ed = xr.domNode), (this.domNode.parentNode !== Ae.domNode || this.domNode.nextSibling !== ed) && this.domNode.insertBefore(Ae.domNode, ed), Ae.attach();
  }
  length() {
    return this.children.reduce((Ae, xr) => Ae + xr.length(), 0);
  }
  moveChildren(Ae, xr) {
    this.children.forEach((ed) => {
      Ae.insertBefore(ed, xr);
    });
  }
  optimize(Ae) {
    if (super.optimize(Ae), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0)
      if (this.statics.defaultChild != null) {
        const xr = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(xr);
      } else
        this.remove();
  }
  path(Ae, xr = !1) {
    const [ed, id] = this.children.find(Ae, xr), od = [[this, Ae]];
    return ed instanceof xh ? od.concat(ed.path(id, xr)) : (ed != null && od.push([ed, id]), od);
  }
  removeChild(Ae) {
    this.children.remove(Ae);
  }
  replaceWith(Ae, xr) {
    const ed = typeof Ae == "string" ? this.scroll.create(Ae, xr) : Ae;
    return ed instanceof xh && this.moveChildren(ed), super.replaceWith(ed);
  }
  split(Ae, xr = !1) {
    if (!xr) {
      if (Ae === 0)
        return this;
      if (Ae === this.length())
        return this.next;
    }
    const ed = this.clone();
    return this.parent && this.parent.insertBefore(ed, this.next || void 0), this.children.forEachAt(Ae, this.length(), (id, od, ad) => {
      const rd = id.split(od, xr);
      rd != null && ed.appendChild(rd);
    }), ed;
  }
  splitAfter(Ae) {
    const xr = this.clone();
    for (; Ae.next != null; )
      xr.appendChild(Ae.next);
    return this.parent && this.parent.insertBefore(xr, this.next || void 0), xr;
  }
  unwrap() {
    this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
  }
  update(Ae, xr) {
    const ed = [], id = [];
    Ae.forEach((od) => {
      od.target === this.domNode && od.type === "childList" && (ed.push(...od.addedNodes), id.push(...od.removedNodes));
    }), id.forEach((od) => {
      if (od.parentNode != null && // @ts-expect-error Fix me later
      od.tagName !== "IFRAME" && document.body.compareDocumentPosition(od) & Node.DOCUMENT_POSITION_CONTAINED_BY)
        return;
      const ad = this.scroll.find(od);
      ad != null && (ad.domNode.parentNode == null || ad.domNode.parentNode === this.domNode) && ad.detach();
    }), ed.filter((od) => od.parentNode === this.domNode && od !== this.uiNode).sort((od, ad) => od === ad ? 0 : od.compareDocumentPosition(ad) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((od) => {
      let ad = null;
      od.nextSibling != null && (ad = this.scroll.find(od.nextSibling));
      const rd = makeAttachedBlot(od, this.scroll);
      (rd.next !== ad || rd.next == null) && (rd.parent != null && rd.parent.removeChild(this), this.insertBefore(rd, ad || void 0));
    }), this.enforceAllowedChildren();
  }
};
_ParentBlot.uiClass = "";
let ParentBlot = _ParentBlot;
const ParentBlot$1 = ParentBlot;
function isEqual$1(td, Ae) {
  if (Object.keys(td).length !== Object.keys(Ae).length)
    return !1;
  for (const xr in td)
    if (td[xr] !== Ae[xr])
      return !1;
  return !0;
}
const _InlineBlot = class Wh extends ParentBlot$1 {
  static create(Ae) {
    return super.create(Ae);
  }
  static formats(Ae, xr) {
    const ed = xr.query(Wh.blotName);
    if (!(ed != null && Ae.tagName === ed.tagName)) {
      if (typeof this.tagName == "string")
        return !0;
      if (Array.isArray(this.tagName))
        return Ae.tagName.toLowerCase();
    }
  }
  constructor(Ae, xr) {
    super(Ae, xr), this.attributes = new AttributorStore$1(this.domNode);
  }
  format(Ae, xr) {
    if (Ae === this.statics.blotName && !xr)
      this.children.forEach((ed) => {
        ed instanceof Wh || (ed = ed.wrap(Wh.blotName, !0)), this.attributes.copy(ed);
      }), this.unwrap();
    else {
      const ed = this.scroll.query(Ae, Scope.INLINE);
      if (ed == null)
        return;
      ed instanceof Attributor ? this.attributes.attribute(ed, xr) : xr && (Ae !== this.statics.blotName || this.formats()[Ae] !== xr) && this.replaceWith(Ae, xr);
    }
  }
  formats() {
    const Ae = this.attributes.values(), xr = this.statics.formats(this.domNode, this.scroll);
    return xr != null && (Ae[this.statics.blotName] = xr), Ae;
  }
  formatAt(Ae, xr, ed, id) {
    this.formats()[ed] != null || this.scroll.query(ed, Scope.ATTRIBUTE) ? this.isolate(Ae, xr).format(ed, id) : super.formatAt(Ae, xr, ed, id);
  }
  optimize(Ae) {
    super.optimize(Ae);
    const xr = this.formats();
    if (Object.keys(xr).length === 0)
      return this.unwrap();
    const ed = this.next;
    ed instanceof Wh && ed.prev === this && isEqual$1(xr, ed.formats()) && (ed.moveChildren(this), ed.remove());
  }
  replaceWith(Ae, xr) {
    const ed = super.replaceWith(Ae, xr);
    return this.attributes.copy(ed), ed;
  }
  update(Ae, xr) {
    super.update(Ae, xr), Ae.some(
      (ed) => ed.target === this.domNode && ed.type === "attributes"
    ) && this.attributes.build();
  }
  wrap(Ae, xr) {
    const ed = super.wrap(Ae, xr);
    return ed instanceof Wh && this.attributes.move(ed), ed;
  }
};
_InlineBlot.allowedChildren = [_InlineBlot, LeafBlot$1], _InlineBlot.blotName = "inline", _InlineBlot.scope = Scope.INLINE_BLOT, _InlineBlot.tagName = "SPAN";
let InlineBlot = _InlineBlot;
const InlineBlot$1 = InlineBlot, _BlockBlot = class s0 extends ParentBlot$1 {
  static create(Ae) {
    return super.create(Ae);
  }
  static formats(Ae, xr) {
    const ed = xr.query(s0.blotName);
    if (!(ed != null && Ae.tagName === ed.tagName)) {
      if (typeof this.tagName == "string")
        return !0;
      if (Array.isArray(this.tagName))
        return Ae.tagName.toLowerCase();
    }
  }
  constructor(Ae, xr) {
    super(Ae, xr), this.attributes = new AttributorStore$1(this.domNode);
  }
  format(Ae, xr) {
    const ed = this.scroll.query(Ae, Scope.BLOCK);
    ed != null && (ed instanceof Attributor ? this.attributes.attribute(ed, xr) : Ae === this.statics.blotName && !xr ? this.replaceWith(s0.blotName) : xr && (Ae !== this.statics.blotName || this.formats()[Ae] !== xr) && this.replaceWith(Ae, xr));
  }
  formats() {
    const Ae = this.attributes.values(), xr = this.statics.formats(this.domNode, this.scroll);
    return xr != null && (Ae[this.statics.blotName] = xr), Ae;
  }
  formatAt(Ae, xr, ed, id) {
    this.scroll.query(ed, Scope.BLOCK) != null ? this.format(ed, id) : super.formatAt(Ae, xr, ed, id);
  }
  insertAt(Ae, xr, ed) {
    if (ed == null || this.scroll.query(xr, Scope.INLINE) != null)
      super.insertAt(Ae, xr, ed);
    else {
      const id = this.split(Ae);
      if (id != null) {
        const od = this.scroll.create(xr, ed);
        id.parent.insertBefore(od, id);
      } else
        throw new Error("Attempt to insertAt after block boundaries");
    }
  }
  replaceWith(Ae, xr) {
    const ed = super.replaceWith(Ae, xr);
    return this.attributes.copy(ed), ed;
  }
  update(Ae, xr) {
    super.update(Ae, xr), Ae.some(
      (ed) => ed.target === this.domNode && ed.type === "attributes"
    ) && this.attributes.build();
  }
};
_BlockBlot.blotName = "block", _BlockBlot.scope = Scope.BLOCK_BLOT, _BlockBlot.tagName = "P", _BlockBlot.allowedChildren = [
  InlineBlot$1,
  _BlockBlot,
  LeafBlot$1
];
let BlockBlot = _BlockBlot;
const BlockBlot$1 = BlockBlot, _ContainerBlot = class extends ParentBlot$1 {
  checkMerge() {
    return this.next !== null && this.next.statics.blotName === this.statics.blotName;
  }
  deleteAt(Ae, xr) {
    super.deleteAt(Ae, xr), this.enforceAllowedChildren();
  }
  formatAt(Ae, xr, ed, id) {
    super.formatAt(Ae, xr, ed, id), this.enforceAllowedChildren();
  }
  insertAt(Ae, xr, ed) {
    super.insertAt(Ae, xr, ed), this.enforceAllowedChildren();
  }
  optimize(Ae) {
    super.optimize(Ae), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
  }
};
_ContainerBlot.blotName = "container", _ContainerBlot.scope = Scope.BLOCK_BLOT;
let ContainerBlot = _ContainerBlot;
const ContainerBlot$1 = ContainerBlot;
class EmbedBlot extends LeafBlot$1 {
  static formats(Ae, xr) {
  }
  format(Ae, xr) {
    super.formatAt(0, this.length(), Ae, xr);
  }
  formatAt(Ae, xr, ed, id) {
    Ae === 0 && xr === this.length() ? this.format(ed, id) : super.formatAt(Ae, xr, ed, id);
  }
  formats() {
    return this.statics.formats(this.domNode, this.scroll);
  }
}
const EmbedBlot$1 = EmbedBlot, OBSERVER_CONFIG = {
  attributes: !0,
  characterData: !0,
  characterDataOldValue: !0,
  childList: !0,
  subtree: !0
}, MAX_OPTIMIZE_ITERATIONS = 100, _ScrollBlot = class extends ParentBlot$1 {
  constructor(Ae, xr) {
    super(null, xr), this.registry = Ae, this.scroll = this, this.build(), this.observer = new MutationObserver((ed) => {
      this.update(ed);
    }), this.observer.observe(this.domNode, OBSERVER_CONFIG), this.attach();
  }
  create(Ae, xr) {
    return this.registry.create(this, Ae, xr);
  }
  find(Ae, xr = !1) {
    const ed = this.registry.find(Ae, xr);
    return ed ? ed.scroll === this ? ed : xr ? this.find(ed.scroll.domNode.parentNode, !0) : null : null;
  }
  query(Ae, xr = Scope.ANY) {
    return this.registry.query(Ae, xr);
  }
  register(...Ae) {
    return this.registry.register(...Ae);
  }
  build() {
    this.scroll != null && super.build();
  }
  detach() {
    super.detach(), this.observer.disconnect();
  }
  deleteAt(Ae, xr) {
    this.update(), Ae === 0 && xr === this.length() ? this.children.forEach((ed) => {
      ed.remove();
    }) : super.deleteAt(Ae, xr);
  }
  formatAt(Ae, xr, ed, id) {
    this.update(), super.formatAt(Ae, xr, ed, id);
  }
  insertAt(Ae, xr, ed) {
    this.update(), super.insertAt(Ae, xr, ed);
  }
  optimize(Ae = [], xr = {}) {
    super.optimize(xr);
    const ed = xr.mutationsMap || /* @__PURE__ */ new WeakMap();
    let id = Array.from(this.observer.takeRecords());
    for (; id.length > 0; )
      Ae.push(id.pop());
    const od = (sd, nd = !0) => {
      sd == null || sd === this || sd.domNode.parentNode != null && (ed.has(sd.domNode) || ed.set(sd.domNode, []), nd && od(sd.parent));
    }, ad = (sd) => {
      ed.has(sd.domNode) && (sd instanceof ParentBlot$1 && sd.children.forEach(ad), ed.delete(sd.domNode), sd.optimize(xr));
    };
    let rd = Ae;
    for (let sd = 0; rd.length > 0; sd += 1) {
      if (sd >= MAX_OPTIMIZE_ITERATIONS)
        throw new Error("[Parchment] Maximum optimize iterations reached");
      for (rd.forEach((nd) => {
        const cd = this.find(nd.target, !0);
        cd != null && (cd.domNode === nd.target && (nd.type === "childList" ? (od(this.find(nd.previousSibling, !1)), Array.from(nd.addedNodes).forEach((ud) => {
          const ld = this.find(ud, !1);
          od(ld, !1), ld instanceof ParentBlot$1 && ld.children.forEach((dd) => {
            od(dd, !1);
          });
        })) : nd.type === "attributes" && od(cd.prev)), od(cd));
      }), this.children.forEach(ad), rd = Array.from(this.observer.takeRecords()), id = rd.slice(); id.length > 0; )
        Ae.push(id.pop());
    }
  }
  update(Ae, xr = {}) {
    Ae = Ae || this.observer.takeRecords();
    const ed = /* @__PURE__ */ new WeakMap();
    Ae.map((id) => {
      const od = this.find(id.target, !0);
      return od == null ? null : ed.has(od.domNode) ? (ed.get(od.domNode).push(id), null) : (ed.set(od.domNode, [id]), od);
    }).forEach((id) => {
      id != null && id !== this && ed.has(id.domNode) && id.update(ed.get(id.domNode) || [], xr);
    }), xr.mutationsMap = ed, ed.has(this.domNode) && super.update(ed.get(this.domNode), xr), this.optimize(Ae, xr);
  }
};
_ScrollBlot.blotName = "scroll", _ScrollBlot.defaultChild = BlockBlot$1, _ScrollBlot.allowedChildren = [BlockBlot$1, ContainerBlot$1], _ScrollBlot.scope = Scope.BLOCK_BLOT, _ScrollBlot.tagName = "DIV";
let ScrollBlot = _ScrollBlot;
const ScrollBlot$1 = ScrollBlot, _TextBlot = class x0 extends LeafBlot$1 {
  static create(Ae) {
    return document.createTextNode(Ae);
  }
  static value(Ae) {
    return Ae.data;
  }
  constructor(Ae, xr) {
    super(Ae, xr), this.text = this.statics.value(this.domNode);
  }
  deleteAt(Ae, xr) {
    this.domNode.data = this.text = this.text.slice(0, Ae) + this.text.slice(Ae + xr);
  }
  index(Ae, xr) {
    return this.domNode === Ae ? xr : -1;
  }
  insertAt(Ae, xr, ed) {
    ed == null ? (this.text = this.text.slice(0, Ae) + xr + this.text.slice(Ae), this.domNode.data = this.text) : super.insertAt(Ae, xr, ed);
  }
  length() {
    return this.text.length;
  }
  optimize(Ae) {
    super.optimize(Ae), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof x0 && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
  }
  position(Ae, xr = !1) {
    return [this.domNode, Ae];
  }
  split(Ae, xr = !1) {
    if (!xr) {
      if (Ae === 0)
        return this;
      if (Ae === this.length())
        return this.next;
    }
    const ed = this.scroll.create(this.domNode.splitText(Ae));
    return this.parent.insertBefore(ed, this.next || void 0), this.text = this.statics.value(this.domNode), ed;
  }
  update(Ae, xr) {
    Ae.some((ed) => ed.type === "characterData" && ed.target === this.domNode) && (this.text = this.statics.value(this.domNode));
  }
  value() {
    return this.text;
  }
};
_TextBlot.blotName = "text", _TextBlot.scope = Scope.INLINE_BLOT;
let TextBlot = _TextBlot;
const TextBlot$1 = TextBlot, Parchment = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Attributor,
  AttributorStore: AttributorStore$1,
  BlockBlot: BlockBlot$1,
  ClassAttributor: ClassAttributor$1,
  ContainerBlot: ContainerBlot$1,
  EmbedBlot: EmbedBlot$1,
  InlineBlot: InlineBlot$1,
  LeafBlot: LeafBlot$1,
  ParentBlot: ParentBlot$1,
  Registry,
  Scope,
  ScrollBlot: ScrollBlot$1,
  StyleAttributor: StyleAttributor$1,
  TextBlot: TextBlot$1
}, Symbol.toStringTag, { value: "Module" }));
var commonjsGlobal = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function getDefaultExportFromCjs(td) {
  return td && td.__esModule && Object.prototype.hasOwnProperty.call(td, "default") ? td.default : td;
}
function getAugmentedNamespace(td) {
  if (td.__esModule)
    return td;
  var Ae = td.default;
  if (typeof Ae == "function") {
    var xr = function ed() {
      return this instanceof ed ? Reflect.construct(Ae, arguments, this.constructor) : Ae.apply(this, arguments);
    };
    xr.prototype = Ae.prototype;
  } else
    xr = {};
  return Object.defineProperty(xr, "__esModule", { value: !0 }), Object.keys(td).forEach(function(ed) {
    var id = Object.getOwnPropertyDescriptor(td, ed);
    Object.defineProperty(xr, ed, id.get ? id : {
      enumerable: !0,
      get: function() {
        return td[ed];
      }
    });
  }), xr;
}
var Delta$1 = { exports: {} }, DIFF_DELETE = -1, DIFF_INSERT = 1, DIFF_EQUAL = 0;
function diff_main(td, Ae, xr, ed, id) {
  if (td === Ae)
    return td ? [[DIFF_EQUAL, td]] : [];
  if (xr != null) {
    var od = find_cursor_edit_diff(td, Ae, xr);
    if (od)
      return od;
  }
  var ad = diff_commonPrefix(td, Ae), rd = td.substring(0, ad);
  td = td.substring(ad), Ae = Ae.substring(ad), ad = diff_commonSuffix(td, Ae);
  var sd = td.substring(td.length - ad);
  td = td.substring(0, td.length - ad), Ae = Ae.substring(0, Ae.length - ad);
  var nd = diff_compute_(td, Ae);
  return rd && nd.unshift([DIFF_EQUAL, rd]), sd && nd.push([DIFF_EQUAL, sd]), diff_cleanupMerge(nd, id), ed && diff_cleanupSemantic(nd), nd;
}
function diff_compute_(td, Ae) {
  var xr;
  if (!td)
    return [[DIFF_INSERT, Ae]];
  if (!Ae)
    return [[DIFF_DELETE, td]];
  var ed = td.length > Ae.length ? td : Ae, id = td.length > Ae.length ? Ae : td, od = ed.indexOf(id);
  if (od !== -1)
    return xr = [
      [DIFF_INSERT, ed.substring(0, od)],
      [DIFF_EQUAL, id],
      [DIFF_INSERT, ed.substring(od + id.length)]
    ], td.length > Ae.length && (xr[0][0] = xr[2][0] = DIFF_DELETE), xr;
  if (id.length === 1)
    return [
      [DIFF_DELETE, td],
      [DIFF_INSERT, Ae]
    ];
  var ad = diff_halfMatch_(td, Ae);
  if (ad) {
    var rd = ad[0], sd = ad[1], nd = ad[2], cd = ad[3], ud = ad[4], ld = diff_main(rd, nd), dd = diff_main(sd, cd);
    return ld.concat([[DIFF_EQUAL, ud]], dd);
  }
  return diff_bisect_(td, Ae);
}
function diff_bisect_(td, Ae) {
  for (var xr = td.length, ed = Ae.length, id = Math.ceil((xr + ed) / 2), od = id, ad = 2 * id, rd = new Array(ad), sd = new Array(ad), nd = 0; nd < ad; nd++)
    rd[nd] = -1, sd[nd] = -1;
  rd[od + 1] = 0, sd[od + 1] = 0;
  for (var cd = xr - ed, ud = cd % 2 !== 0, ld = 0, dd = 0, pd = 0, md = 0, fd = 0; fd < id; fd++) {
    for (var bd = -fd + ld; bd <= fd - dd; bd += 2) {
      var Sd = od + bd, vd;
      bd === -fd || bd !== fd && rd[Sd - 1] < rd[Sd + 1] ? vd = rd[Sd + 1] : vd = rd[Sd - 1] + 1;
      for (var Ed = vd - bd; vd < xr && Ed < ed && td.charAt(vd) === Ae.charAt(Ed); )
        vd++, Ed++;
      if (rd[Sd] = vd, vd > xr)
        dd += 2;
      else if (Ed > ed)
        ld += 2;
      else if (ud) {
        var Td = od + cd - bd;
        if (Td >= 0 && Td < ad && sd[Td] !== -1) {
          var Gd = xr - sd[Td];
          if (vd >= Gd)
            return diff_bisectSplit_(td, Ae, vd, Ed);
        }
      }
    }
    for (var Id = -fd + pd; Id <= fd - md; Id += 2) {
      var Td = od + Id, Gd;
      Id === -fd || Id !== fd && sd[Td - 1] < sd[Td + 1] ? Gd = sd[Td + 1] : Gd = sd[Td - 1] + 1;
      for (var Pd = Gd - Id; Gd < xr && Pd < ed && td.charAt(xr - Gd - 1) === Ae.charAt(ed - Pd - 1); )
        Gd++, Pd++;
      if (sd[Td] = Gd, Gd > xr)
        md += 2;
      else if (Pd > ed)
        pd += 2;
      else if (!ud) {
        var Sd = od + cd - Id;
        if (Sd >= 0 && Sd < ad && rd[Sd] !== -1) {
          var vd = rd[Sd], Ed = od + vd - Sd;
          if (Gd = xr - Gd, vd >= Gd)
            return diff_bisectSplit_(td, Ae, vd, Ed);
        }
      }
    }
  }
  return [
    [DIFF_DELETE, td],
    [DIFF_INSERT, Ae]
  ];
}
function diff_bisectSplit_(td, Ae, xr, ed) {
  var id = td.substring(0, xr), od = Ae.substring(0, ed), ad = td.substring(xr), rd = Ae.substring(ed), sd = diff_main(id, od), nd = diff_main(ad, rd);
  return sd.concat(nd);
}
function diff_commonPrefix(td, Ae) {
  if (!td || !Ae || td.charAt(0) !== Ae.charAt(0))
    return 0;
  for (var xr = 0, ed = Math.min(td.length, Ae.length), id = ed, od = 0; xr < id; )
    td.substring(od, id) == Ae.substring(od, id) ? (xr = id, od = xr) : ed = id, id = Math.floor((ed - xr) / 2 + xr);
  return is_surrogate_pair_start(td.charCodeAt(id - 1)) && id--, id;
}
function diff_commonOverlap_(td, Ae) {
  var xr = td.length, ed = Ae.length;
  if (xr == 0 || ed == 0)
    return 0;
  xr > ed ? td = td.substring(xr - ed) : xr < ed && (Ae = Ae.substring(0, xr));
  var id = Math.min(xr, ed);
  if (td == Ae)
    return id;
  for (var od = 0, ad = 1; ; ) {
    var rd = td.substring(id - ad), sd = Ae.indexOf(rd);
    if (sd == -1)
      return od;
    ad += sd, (sd == 0 || td.substring(id - ad) == Ae.substring(0, ad)) && (od = ad, ad++);
  }
}
function diff_commonSuffix(td, Ae) {
  if (!td || !Ae || td.slice(-1) !== Ae.slice(-1))
    return 0;
  for (var xr = 0, ed = Math.min(td.length, Ae.length), id = ed, od = 0; xr < id; )
    td.substring(td.length - id, td.length - od) == Ae.substring(Ae.length - id, Ae.length - od) ? (xr = id, od = xr) : ed = id, id = Math.floor((ed - xr) / 2 + xr);
  return is_surrogate_pair_end(td.charCodeAt(td.length - id)) && id--, id;
}
function diff_halfMatch_(td, Ae) {
  var xr = td.length > Ae.length ? td : Ae, ed = td.length > Ae.length ? Ae : td;
  if (xr.length < 4 || ed.length * 2 < xr.length)
    return null;
  function id(dd, pd, md) {
    for (var fd = dd.substring(md, md + Math.floor(dd.length / 4)), bd = -1, Sd = "", vd, Ed, Td, Gd; (bd = pd.indexOf(fd, bd + 1)) !== -1; ) {
      var Id = diff_commonPrefix(
        dd.substring(md),
        pd.substring(bd)
      ), Pd = diff_commonSuffix(
        dd.substring(0, md),
        pd.substring(0, bd)
      );
      Sd.length < Pd + Id && (Sd = pd.substring(bd - Pd, bd) + pd.substring(bd, bd + Id), vd = dd.substring(0, md - Pd), Ed = dd.substring(md + Id), Td = pd.substring(0, bd - Pd), Gd = pd.substring(bd + Id));
    }
    return Sd.length * 2 >= dd.length ? [
      vd,
      Ed,
      Td,
      Gd,
      Sd
    ] : null;
  }
  var od = id(
    xr,
    ed,
    Math.ceil(xr.length / 4)
  ), ad = id(
    xr,
    ed,
    Math.ceil(xr.length / 2)
  ), rd;
  if (!od && !ad)
    return null;
  ad ? od ? rd = od[4].length > ad[4].length ? od : ad : rd = ad : rd = od;
  var sd, nd, cd, ud;
  td.length > Ae.length ? (sd = rd[0], nd = rd[1], cd = rd[2], ud = rd[3]) : (cd = rd[0], ud = rd[1], sd = rd[2], nd = rd[3]);
  var ld = rd[4];
  return [sd, nd, cd, ud, ld];
}
function diff_cleanupSemantic(td) {
  for (var Ae = !1, xr = [], ed = 0, id = null, od = 0, ad = 0, rd = 0, sd = 0, nd = 0; od < td.length; )
    td[od][0] == DIFF_EQUAL ? (xr[ed++] = od, ad = sd, rd = nd, sd = 0, nd = 0, id = td[od][1]) : (td[od][0] == DIFF_INSERT ? sd += td[od][1].length : nd += td[od][1].length, id && id.length <= Math.max(ad, rd) && id.length <= Math.max(sd, nd) && (td.splice(xr[ed - 1], 0, [
      DIFF_DELETE,
      id
    ]), td[xr[ed - 1] + 1][0] = DIFF_INSERT, ed--, ed--, od = ed > 0 ? xr[ed - 1] : -1, ad = 0, rd = 0, sd = 0, nd = 0, id = null, Ae = !0)), od++;
  for (Ae && diff_cleanupMerge(td), diff_cleanupSemanticLossless(td), od = 1; od < td.length; ) {
    if (td[od - 1][0] == DIFF_DELETE && td[od][0] == DIFF_INSERT) {
      var cd = td[od - 1][1], ud = td[od][1], ld = diff_commonOverlap_(cd, ud), dd = diff_commonOverlap_(ud, cd);
      ld >= dd ? (ld >= cd.length / 2 || ld >= ud.length / 2) && (td.splice(od, 0, [
        DIFF_EQUAL,
        ud.substring(0, ld)
      ]), td[od - 1][1] = cd.substring(
        0,
        cd.length - ld
      ), td[od + 1][1] = ud.substring(ld), od++) : (dd >= cd.length / 2 || dd >= ud.length / 2) && (td.splice(od, 0, [
        DIFF_EQUAL,
        cd.substring(0, dd)
      ]), td[od - 1][0] = DIFF_INSERT, td[od - 1][1] = ud.substring(
        0,
        ud.length - dd
      ), td[od + 1][0] = DIFF_DELETE, td[od + 1][1] = cd.substring(dd), od++), od++;
    }
    od++;
  }
}
var nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/, whitespaceRegex_ = /\s/, linebreakRegex_ = /[\r\n]/, blanklineEndRegex_ = /\n\r?\n$/, blanklineStartRegex_ = /^\r?\n\r?\n/;
function diff_cleanupSemanticLossless(td) {
  function Ae(dd, pd) {
    if (!dd || !pd)
      return 6;
    var md = dd.charAt(dd.length - 1), fd = pd.charAt(0), bd = md.match(nonAlphaNumericRegex_), Sd = fd.match(nonAlphaNumericRegex_), vd = bd && md.match(whitespaceRegex_), Ed = Sd && fd.match(whitespaceRegex_), Td = vd && md.match(linebreakRegex_), Gd = Ed && fd.match(linebreakRegex_), Id = Td && dd.match(blanklineEndRegex_), Pd = Gd && pd.match(blanklineStartRegex_);
    return Id || Pd ? 5 : Td || Gd ? 4 : bd && !vd && Ed ? 3 : vd || Ed ? 2 : bd || Sd ? 1 : 0;
  }
  for (var xr = 1; xr < td.length - 1; ) {
    if (td[xr - 1][0] == DIFF_EQUAL && td[xr + 1][0] == DIFF_EQUAL) {
      var ed = td[xr - 1][1], id = td[xr][1], od = td[xr + 1][1], ad = diff_commonSuffix(ed, id);
      if (ad) {
        var rd = id.substring(id.length - ad);
        ed = ed.substring(0, ed.length - ad), id = rd + id.substring(0, id.length - ad), od = rd + od;
      }
      for (var sd = ed, nd = id, cd = od, ud = Ae(ed, id) + Ae(id, od); id.charAt(0) === od.charAt(0); ) {
        ed += id.charAt(0), id = id.substring(1) + od.charAt(0), od = od.substring(1);
        var ld = Ae(ed, id) + Ae(id, od);
        ld >= ud && (ud = ld, sd = ed, nd = id, cd = od);
      }
      td[xr - 1][1] != sd && (sd ? td[xr - 1][1] = sd : (td.splice(xr - 1, 1), xr--), td[xr][1] = nd, cd ? td[xr + 1][1] = cd : (td.splice(xr + 1, 1), xr--));
    }
    xr++;
  }
}
function diff_cleanupMerge(td, Ae) {
  td.push([DIFF_EQUAL, ""]);
  for (var xr = 0, ed = 0, id = 0, od = "", ad = "", rd; xr < td.length; ) {
    if (xr < td.length - 1 && !td[xr][1]) {
      td.splice(xr, 1);
      continue;
    }
    switch (td[xr][0]) {
      case DIFF_INSERT:
        id++, ad += td[xr][1], xr++;
        break;
      case DIFF_DELETE:
        ed++, od += td[xr][1], xr++;
        break;
      case DIFF_EQUAL:
        var sd = xr - id - ed - 1;
        if (Ae) {
          if (sd >= 0 && ends_with_pair_start(td[sd][1])) {
            var nd = td[sd][1].slice(-1);
            if (td[sd][1] = td[sd][1].slice(
              0,
              -1
            ), od = nd + od, ad = nd + ad, !td[sd][1]) {
              td.splice(sd, 1), xr--;
              var cd = sd - 1;
              td[cd] && td[cd][0] === DIFF_INSERT && (id++, ad = td[cd][1] + ad, cd--), td[cd] && td[cd][0] === DIFF_DELETE && (ed++, od = td[cd][1] + od, cd--), sd = cd;
            }
          }
          if (starts_with_pair_end(td[xr][1])) {
            var nd = td[xr][1].charAt(0);
            td[xr][1] = td[xr][1].slice(1), od += nd, ad += nd;
          }
        }
        if (xr < td.length - 1 && !td[xr][1]) {
          td.splice(xr, 1);
          break;
        }
        if (od.length > 0 || ad.length > 0) {
          od.length > 0 && ad.length > 0 && (rd = diff_commonPrefix(ad, od), rd !== 0 && (sd >= 0 ? td[sd][1] += ad.substring(
            0,
            rd
          ) : (td.splice(0, 0, [
            DIFF_EQUAL,
            ad.substring(0, rd)
          ]), xr++), ad = ad.substring(rd), od = od.substring(rd)), rd = diff_commonSuffix(ad, od), rd !== 0 && (td[xr][1] = ad.substring(ad.length - rd) + td[xr][1], ad = ad.substring(
            0,
            ad.length - rd
          ), od = od.substring(
            0,
            od.length - rd
          )));
          var ud = id + ed;
          od.length === 0 && ad.length === 0 ? (td.splice(xr - ud, ud), xr = xr - ud) : od.length === 0 ? (td.splice(xr - ud, ud, [DIFF_INSERT, ad]), xr = xr - ud + 1) : ad.length === 0 ? (td.splice(xr - ud, ud, [DIFF_DELETE, od]), xr = xr - ud + 1) : (td.splice(
            xr - ud,
            ud,
            [DIFF_DELETE, od],
            [DIFF_INSERT, ad]
          ), xr = xr - ud + 2);
        }
        xr !== 0 && td[xr - 1][0] === DIFF_EQUAL ? (td[xr - 1][1] += td[xr][1], td.splice(xr, 1)) : xr++, id = 0, ed = 0, od = "", ad = "";
        break;
    }
  }
  td[td.length - 1][1] === "" && td.pop();
  var ld = !1;
  for (xr = 1; xr < td.length - 1; )
    td[xr - 1][0] === DIFF_EQUAL && td[xr + 1][0] === DIFF_EQUAL && (td[xr][1].substring(
      td[xr][1].length - td[xr - 1][1].length
    ) === td[xr - 1][1] ? (td[xr][1] = td[xr - 1][1] + td[xr][1].substring(
      0,
      td[xr][1].length - td[xr - 1][1].length
    ), td[xr + 1][1] = td[xr - 1][1] + td[xr + 1][1], td.splice(xr - 1, 1), ld = !0) : td[xr][1].substring(0, td[xr + 1][1].length) == td[xr + 1][1] && (td[xr - 1][1] += td[xr + 1][1], td[xr][1] = td[xr][1].substring(td[xr + 1][1].length) + td[xr + 1][1], td.splice(xr + 1, 1), ld = !0)), xr++;
  ld && diff_cleanupMerge(td, Ae);
}
function is_surrogate_pair_start(td) {
  return td >= 55296 && td <= 56319;
}
function is_surrogate_pair_end(td) {
  return td >= 56320 && td <= 57343;
}
function starts_with_pair_end(td) {
  return is_surrogate_pair_end(td.charCodeAt(0));
}
function ends_with_pair_start(td) {
  return is_surrogate_pair_start(td.charCodeAt(td.length - 1));
}
function remove_empty_tuples(td) {
  for (var Ae = [], xr = 0; xr < td.length; xr++)
    td[xr][1].length > 0 && Ae.push(td[xr]);
  return Ae;
}
function make_edit_splice(td, Ae, xr, ed) {
  return ends_with_pair_start(td) || starts_with_pair_end(ed) ? null : remove_empty_tuples([
    [DIFF_EQUAL, td],
    [DIFF_DELETE, Ae],
    [DIFF_INSERT, xr],
    [DIFF_EQUAL, ed]
  ]);
}
function find_cursor_edit_diff(td, Ae, xr) {
  var ed = typeof xr == "number" ? { index: xr, length: 0 } : xr.oldRange, id = typeof xr == "number" ? null : xr.newRange, od = td.length, ad = Ae.length;
  if (ed.length === 0 && (id === null || id.length === 0)) {
    var rd = ed.index, sd = td.slice(0, rd), nd = td.slice(rd), cd = id ? id.index : null;
    e: {
      var ud = rd + ad - od;
      if (cd !== null && cd !== ud || ud < 0 || ud > ad)
        break e;
      var ld = Ae.slice(0, ud), dd = Ae.slice(ud);
      if (dd !== nd)
        break e;
      var pd = Math.min(rd, ud), md = sd.slice(0, pd), fd = ld.slice(0, pd);
      if (md !== fd)
        break e;
      var bd = sd.slice(pd), Sd = ld.slice(pd);
      return make_edit_splice(md, bd, Sd, nd);
    }
    e: {
      if (cd !== null && cd !== rd)
        break e;
      var vd = rd, ld = Ae.slice(0, vd), dd = Ae.slice(vd);
      if (ld !== sd)
        break e;
      var Ed = Math.min(od - vd, ad - vd), Td = nd.slice(nd.length - Ed), Gd = dd.slice(dd.length - Ed);
      if (Td !== Gd)
        break e;
      var bd = nd.slice(0, nd.length - Ed), Sd = dd.slice(0, dd.length - Ed);
      return make_edit_splice(sd, bd, Sd, Td);
    }
  }
  if (ed.length > 0 && id && id.length === 0)
    e: {
      var md = td.slice(0, ed.index), Td = td.slice(ed.index + ed.length), pd = md.length, Ed = Td.length;
      if (ad < pd + Ed)
        break e;
      var fd = Ae.slice(0, pd), Gd = Ae.slice(ad - Ed);
      if (md !== fd || Td !== Gd)
        break e;
      var bd = td.slice(pd, od - Ed), Sd = Ae.slice(pd, ad - Ed);
      return make_edit_splice(md, bd, Sd, Td);
    }
  return null;
}
function diff(td, Ae, xr, ed) {
  return diff_main(td, Ae, xr, ed, !0);
}
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;
var diff_1 = diff, lodash_clonedeep = { exports: {} };
lodash_clonedeep.exports;
(function(td, Ae) {
  var xr = 200, ed = "__lodash_hash_undefined__", id = 9007199254740991, od = "[object Arguments]", ad = "[object Array]", rd = "[object Boolean]", sd = "[object Date]", nd = "[object Error]", cd = "[object Function]", ud = "[object GeneratorFunction]", ld = "[object Map]", dd = "[object Number]", pd = "[object Object]", md = "[object Promise]", fd = "[object RegExp]", bd = "[object Set]", Sd = "[object String]", vd = "[object Symbol]", Ed = "[object WeakMap]", Td = "[object ArrayBuffer]", Gd = "[object DataView]", Id = "[object Float32Array]", Pd = "[object Float64Array]", Hd = "[object Int8Array]", Rd = "[object Int16Array]", Cd = "[object Int32Array]", wd = "[object Uint8Array]", Ld = "[object Uint8ClampedArray]", kd = "[object Uint16Array]", Dd = "[object Uint32Array]", Fd = /[\\^$.*+?()[\]{}|]/g, xd = /\w*$/, Ad = /^\[object .+?Constructor\]$/, Nd = /^(?:0|[1-9]\d*)$/, zd = {};
  zd[od] = zd[ad] = zd[Td] = zd[Gd] = zd[rd] = zd[sd] = zd[Id] = zd[Pd] = zd[Hd] = zd[Rd] = zd[Cd] = zd[ld] = zd[dd] = zd[pd] = zd[fd] = zd[bd] = zd[Sd] = zd[vd] = zd[wd] = zd[Ld] = zd[kd] = zd[Dd] = !0, zd[nd] = zd[cd] = zd[Ed] = !1;
  var Wd = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, Ud = typeof self == "object" && self && self.Object === Object && self, oh = Wd || Ud || Function("return this")(), Vd = Ae && !Ae.nodeType && Ae, Od = Vd && !0 && td && !td.nodeType && td, lh = Od && Od.exports === Vd;
  function nh(hd, gd) {
    return hd.set(gd[0], gd[1]), hd;
  }
  function Xd(hd, gd) {
    return hd.add(gd), hd;
  }
  function wh(hd, gd) {
    for (var yd = -1, $d = hd ? hd.length : 0; ++yd < $d && gd(hd[yd], yd, hd) !== !1; )
      ;
    return hd;
  }
  function Oh(hd, gd) {
    for (var yd = -1, $d = gd.length, Bd = hd.length; ++yd < $d; )
      hd[Bd + yd] = gd[yd];
    return hd;
  }
  function Zh(hd, gd, yd, $d) {
    var Bd = -1, Md = hd ? hd.length : 0;
    for ($d && Md && (yd = hd[++Bd]); ++Bd < Md; )
      yd = gd(yd, hd[Bd], Bd, hd);
    return yd;
  }
  function Xh(hd, gd) {
    for (var yd = -1, $d = Array(hd); ++yd < hd; )
      $d[yd] = gd(yd);
    return $d;
  }
  function Zp(hd, gd) {
    return hd == null ? void 0 : hd[gd];
  }
  function Yh(hd) {
    var gd = !1;
    if (hd != null && typeof hd.toString != "function")
      try {
        gd = !!(hd + "");
      } catch (yd) {
      }
    return gd;
  }
  function Xp(hd) {
    var gd = -1, yd = Array(hd.size);
    return hd.forEach(function($d, Bd) {
      yd[++gd] = [Bd, $d];
    }), yd;
  }
  function Kh(hd, gd) {
    return function(yd) {
      return hd(gd(yd));
    };
  }
  function Yp(hd) {
    var gd = -1, yd = Array(hd.size);
    return hd.forEach(function($d) {
      yd[++gd] = $d;
    }), yd;
  }
  var m1 = Array.prototype, b1 = Function.prototype, Mh = Object.prototype, Qh = oh["__core-js_shared__"], Kp = function() {
    var hd = /[^.]+$/.exec(Qh && Qh.keys && Qh.keys.IE_PROTO || "");
    return hd ? "Symbol(src)_1." + hd : "";
  }(), Qp = b1.toString, fh = Mh.hasOwnProperty, Ph = Mh.toString, y1 = RegExp(
    "^" + Qp.call(fh).replace(Fd, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Fh = lh ? oh.Buffer : void 0, zh = oh.Symbol, Jh = oh.Uint8Array, ch = Kh(Object.getPrototypeOf, Object), Jp = Object.create, e1 = Mh.propertyIsEnumerable, S1 = m1.splice, Dp = Object.getOwnPropertySymbols, Bh = Fh ? Fh.isBuffer : void 0, t1 = Kh(Object.keys, Object), Hh = ph(oh, "DataView"), Lh = ph(oh, "Map"), uh = ph(oh, "Promise"), Rh = ph(oh, "Set"), Ep = ph(oh, "WeakMap"), Gh = ph(Object, "create"), xp = ah(Hh), _h = ah(Lh), Fp = ah(uh), Lp = ah(Rh), Gp = ah(Ep), $h = zh ? zh.prototype : void 0, i1 = $h ? $h.valueOf : void 0;
  function vh(hd) {
    var gd = -1, yd = hd ? hd.length : 0;
    for (this.clear(); ++gd < yd; ) {
      var $d = hd[gd];
      this.set($d[0], $d[1]);
    }
  }
  function v1() {
    this.__data__ = Gh ? Gh(null) : {};
  }
  function D1(hd) {
    return this.has(hd) && delete this.__data__[hd];
  }
  function C1(hd) {
    var gd = this.__data__;
    if (Gh) {
      var yd = gd[hd];
      return yd === ed ? void 0 : yd;
    }
    return fh.call(gd, hd) ? gd[hd] : void 0;
  }
  function o1(hd) {
    var gd = this.__data__;
    return Gh ? gd[hd] !== void 0 : fh.call(gd, hd);
  }
  function kp(hd, gd) {
    var yd = this.__data__;
    return yd[hd] = Gh && gd === void 0 ? ed : gd, this;
  }
  vh.prototype.clear = v1, vh.prototype.delete = D1, vh.prototype.get = C1, vh.prototype.has = o1, vh.prototype.set = kp;
  function Qd(hd) {
    var gd = -1, yd = hd ? hd.length : 0;
    for (this.clear(); ++gd < yd; ) {
      var $d = hd[gd];
      this.set($d[0], $d[1]);
    }
  }
  function E1() {
    this.__data__ = [];
  }
  function $1(hd) {
    var gd = this.__data__, yd = Nh(gd, hd);
    if (yd < 0)
      return !1;
    var $d = gd.length - 1;
    return yd == $d ? gd.pop() : S1.call(gd, yd, 1), !0;
  }
  function T1(hd) {
    var gd = this.__data__, yd = Nh(gd, hd);
    return yd < 0 ? void 0 : gd[yd][1];
  }
  function x1(hd) {
    return Nh(this.__data__, hd) > -1;
  }
  function w1(hd, gd) {
    var yd = this.__data__, $d = Nh(yd, hd);
    return $d < 0 ? yd.push([hd, gd]) : yd[$d][1] = gd, this;
  }
  Qd.prototype.clear = E1, Qd.prototype.delete = $1, Qd.prototype.get = T1, Qd.prototype.has = x1, Qd.prototype.set = w1;
  function eh(hd) {
    var gd = -1, yd = hd ? hd.length : 0;
    for (this.clear(); ++gd < yd; ) {
      var $d = hd[gd];
      this.set($d[0], $d[1]);
    }
  }
  function F1() {
    this.__data__ = {
      hash: new vh(),
      map: new (Lh || Qd)(),
      string: new vh()
    };
  }
  function L1(hd) {
    return Ah(this, hd).delete(hd);
  }
  function G1(hd) {
    return Ah(this, hd).get(hd);
  }
  function _1(hd) {
    return Ah(this, hd).has(hd);
  }
  function k1(hd, gd) {
    return Ah(this, hd).set(hd, gd), this;
  }
  eh.prototype.clear = F1, eh.prototype.delete = L1, eh.prototype.get = G1, eh.prototype.has = _1, eh.prototype.set = k1;
  function rh(hd) {
    this.__data__ = new Qd(hd);
  }
  function A1() {
    this.__data__ = new Qd();
  }
  function I1(hd) {
    return this.__data__.delete(hd);
  }
  function O1(hd) {
    return this.__data__.get(hd);
  }
  function M1(hd) {
    return this.__data__.has(hd);
  }
  function P1(hd, gd) {
    var yd = this.__data__;
    if (yd instanceof Qd) {
      var $d = yd.__data__;
      if (!Lh || $d.length < xr - 1)
        return $d.push([hd, gd]), this;
      yd = this.__data__ = new eh($d);
    }
    return yd.set(hd, gd), this;
  }
  rh.prototype.clear = A1, rh.prototype.delete = I1, rh.prototype.get = O1, rh.prototype.has = M1, rh.prototype.set = P1;
  function qh(hd, gd) {
    var yd = Hp(hd) || jh(hd) ? Xh(hd.length, String) : [], $d = yd.length, Bd = !!$d;
    for (var Md in hd)
      (gd || fh.call(hd, Md)) && !(Bd && (Md == "length" || K1(Md, $d))) && yd.push(Md);
    return yd;
  }
  function a1(hd, gd, yd) {
    var $d = hd[gd];
    (!(fh.call(hd, gd) && c1($d, yd)) || yd === void 0 && !(gd in hd)) && (hd[gd] = yd);
  }
  function Nh(hd, gd) {
    for (var yd = hd.length; yd--; )
      if (c1(hd[yd][0], gd))
        return yd;
    return -1;
  }
  function mh(hd, gd) {
    return hd && Bp(gd, qp(gd), hd);
  }
  function Mp(hd, gd, yd, $d, Bd, Md, qd) {
    var jd;
    if ($d && (jd = Md ? $d(hd, Bd, Md, qd) : $d(hd)), jd !== void 0)
      return jd;
    if (!yh(hd))
      return hd;
    var Yd = Hp(hd);
    if (Yd) {
      if (jd = X1(hd), !gd)
        return U1(hd, jd);
    } else {
      var Zd = Ch(hd), th = Zd == cd || Zd == ud;
      if (d1(hd))
        return Vh(hd, gd);
      if (Zd == pd || Zd == od || th && !Md) {
        if (Yh(hd))
          return Md ? hd : {};
        if (jd = bh(th ? {} : hd), !gd)
          return W1(hd, mh(jd, hd));
      } else {
        if (!zd[Zd])
          return Md ? hd : {};
        jd = Y1(hd, Zd, Mp, gd);
      }
    }
    qd || (qd = new rh());
    var sh = qd.get(hd);
    if (sh)
      return sh;
    if (qd.set(hd, jd), !Yd)
      var Kd = yd ? Z1(hd) : qp(hd);
    return wh(Kd || hd, function(ih, Jd) {
      Kd && (Jd = ih, ih = hd[Jd]), a1(jd, Jd, Mp(ih, gd, yd, $d, Jd, hd, qd));
    }), jd;
  }
  function z1(hd) {
    return yh(hd) ? Jp(hd) : {};
  }
  function B1(hd, gd, yd) {
    var $d = gd(hd);
    return Hp(hd) ? $d : Oh($d, yd(hd));
  }
  function H1(hd) {
    return Ph.call(hd);
  }
  function R1(hd) {
    if (!yh(hd) || J1(hd))
      return !1;
    var gd = Rp(hd) || Yh(hd) ? y1 : Ad;
    return gd.test(ah(hd));
  }
  function q1(hd) {
    if (!n1(hd))
      return t1(hd);
    var gd = [];
    for (var yd in Object(hd))
      fh.call(hd, yd) && yd != "constructor" && gd.push(yd);
    return gd;
  }
  function Vh(hd, gd) {
    if (gd)
      return hd.slice();
    var yd = new hd.constructor(hd.length);
    return hd.copy(yd), yd;
  }
  function zp(hd) {
    var gd = new hd.constructor(hd.byteLength);
    return new Jh(gd).set(new Jh(hd)), gd;
  }
  function kh(hd, gd) {
    var yd = gd ? zp(hd.buffer) : hd.buffer;
    return new hd.constructor(yd, hd.byteOffset, hd.byteLength);
  }
  function r1(hd, gd, yd) {
    var $d = gd ? yd(Xp(hd), !0) : Xp(hd);
    return Zh($d, nh, new hd.constructor());
  }
  function s1(hd) {
    var gd = new hd.constructor(hd.source, xd.exec(hd));
    return gd.lastIndex = hd.lastIndex, gd;
  }
  function N1(hd, gd, yd) {
    var $d = gd ? yd(Yp(hd), !0) : Yp(hd);
    return Zh($d, Xd, new hd.constructor());
  }
  function V1(hd) {
    return i1 ? Object(i1.call(hd)) : {};
  }
  function j1(hd, gd) {
    var yd = gd ? zp(hd.buffer) : hd.buffer;
    return new hd.constructor(yd, hd.byteOffset, hd.length);
  }
  function U1(hd, gd) {
    var yd = -1, $d = hd.length;
    for (gd || (gd = Array($d)); ++yd < $d; )
      gd[yd] = hd[yd];
    return gd;
  }
  function Bp(hd, gd, yd, $d) {
    yd || (yd = {});
    for (var Bd = -1, Md = gd.length; ++Bd < Md; ) {
      var qd = gd[Bd], jd = $d ? $d(yd[qd], hd[qd], qd, yd, hd) : void 0;
      a1(yd, qd, jd === void 0 ? hd[qd] : jd);
    }
    return yd;
  }
  function W1(hd, gd) {
    return Bp(hd, Dh(hd), gd);
  }
  function Z1(hd) {
    return B1(hd, qp, Dh);
  }
  function Ah(hd, gd) {
    var yd = hd.__data__;
    return Q1(gd) ? yd[typeof gd == "string" ? "string" : "hash"] : yd.map;
  }
  function ph(hd, gd) {
    var yd = Zp(hd, gd);
    return R1(yd) ? yd : void 0;
  }
  var Dh = Dp ? Kh(Dp, Object) : t0, Ch = H1;
  (Hh && Ch(new Hh(new ArrayBuffer(1))) != Gd || Lh && Ch(new Lh()) != ld || uh && Ch(uh.resolve()) != md || Rh && Ch(new Rh()) != bd || Ep && Ch(new Ep()) != Ed) && (Ch = function(hd) {
    var gd = Ph.call(hd), yd = gd == pd ? hd.constructor : void 0, $d = yd ? ah(yd) : void 0;
    if ($d)
      switch ($d) {
        case xp:
          return Gd;
        case _h:
          return ld;
        case Fp:
          return md;
        case Lp:
          return bd;
        case Gp:
          return Ed;
      }
    return gd;
  });
  function X1(hd) {
    var gd = hd.length, yd = hd.constructor(gd);
    return gd && typeof hd[0] == "string" && fh.call(hd, "index") && (yd.index = hd.index, yd.input = hd.input), yd;
  }
  function bh(hd) {
    return typeof hd.constructor == "function" && !n1(hd) ? z1(ch(hd)) : {};
  }
  function Y1(hd, gd, yd, $d) {
    var Bd = hd.constructor;
    switch (gd) {
      case Td:
        return zp(hd);
      case rd:
      case sd:
        return new Bd(+hd);
      case Gd:
        return kh(hd, $d);
      case Id:
      case Pd:
      case Hd:
      case Rd:
      case Cd:
      case wd:
      case Ld:
      case kd:
      case Dd:
        return j1(hd, $d);
      case ld:
        return r1(hd, $d, yd);
      case dd:
      case Sd:
        return new Bd(hd);
      case fd:
        return s1(hd);
      case bd:
        return N1(hd, $d, yd);
      case vd:
        return V1(hd);
    }
  }
  function K1(hd, gd) {
    return gd = gd == null ? id : gd, !!gd && (typeof hd == "number" || Nd.test(hd)) && hd > -1 && hd % 1 == 0 && hd < gd;
  }
  function Q1(hd) {
    var gd = typeof hd;
    return gd == "string" || gd == "number" || gd == "symbol" || gd == "boolean" ? hd !== "__proto__" : hd === null;
  }
  function J1(hd) {
    return !!Kp && Kp in hd;
  }
  function n1(hd) {
    var gd = hd && hd.constructor, yd = typeof gd == "function" && gd.prototype || Mh;
    return hd === yd;
  }
  function ah(hd) {
    if (hd != null) {
      try {
        return Qp.call(hd);
      } catch (gd) {
      }
      try {
        return hd + "";
      } catch (gd) {
      }
    }
    return "";
  }
  function l1(hd) {
    return Mp(hd, !0, !0);
  }
  function c1(hd, gd) {
    return hd === gd || hd !== hd && gd !== gd;
  }
  function jh(hd) {
    return e0(hd) && fh.call(hd, "callee") && (!e1.call(hd, "callee") || Ph.call(hd) == od);
  }
  var Hp = Array.isArray;
  function Uh(hd) {
    return hd != null && h1(hd.length) && !Rp(hd);
  }
  function e0(hd) {
    return u1(hd) && Uh(hd);
  }
  var d1 = Bh || i0;
  function Rp(hd) {
    var gd = yh(hd) ? Ph.call(hd) : "";
    return gd == cd || gd == ud;
  }
  function h1(hd) {
    return typeof hd == "number" && hd > -1 && hd % 1 == 0 && hd <= id;
  }
  function yh(hd) {
    var gd = typeof hd;
    return !!hd && (gd == "object" || gd == "function");
  }
  function u1(hd) {
    return !!hd && typeof hd == "object";
  }
  function qp(hd) {
    return Uh(hd) ? qh(hd) : q1(hd);
  }
  function t0() {
    return [];
  }
  function i0() {
    return !1;
  }
  td.exports = l1;
})(lodash_clonedeep, lodash_clonedeep.exports);
var lodash_clonedeepExports = lodash_clonedeep.exports, lodash_isequal = { exports: {} };
lodash_isequal.exports;
(function(td, Ae) {
  var xr = 200, ed = "__lodash_hash_undefined__", id = 1, od = 2, ad = 9007199254740991, rd = "[object Arguments]", sd = "[object Array]", nd = "[object AsyncFunction]", cd = "[object Boolean]", ud = "[object Date]", ld = "[object Error]", dd = "[object Function]", pd = "[object GeneratorFunction]", md = "[object Map]", fd = "[object Number]", bd = "[object Null]", Sd = "[object Object]", vd = "[object Promise]", Ed = "[object Proxy]", Td = "[object RegExp]", Gd = "[object Set]", Id = "[object String]", Pd = "[object Symbol]", Hd = "[object Undefined]", Rd = "[object WeakMap]", Cd = "[object ArrayBuffer]", wd = "[object DataView]", Ld = "[object Float32Array]", kd = "[object Float64Array]", Dd = "[object Int8Array]", Fd = "[object Int16Array]", xd = "[object Int32Array]", Ad = "[object Uint8Array]", Nd = "[object Uint8ClampedArray]", zd = "[object Uint16Array]", Wd = "[object Uint32Array]", Ud = /[\\^$.*+?()[\]{}|]/g, oh = /^\[object .+?Constructor\]$/, Vd = /^(?:0|[1-9]\d*)$/, Od = {};
  Od[Ld] = Od[kd] = Od[Dd] = Od[Fd] = Od[xd] = Od[Ad] = Od[Nd] = Od[zd] = Od[Wd] = !0, Od[rd] = Od[sd] = Od[Cd] = Od[cd] = Od[wd] = Od[ud] = Od[ld] = Od[dd] = Od[md] = Od[fd] = Od[Sd] = Od[Td] = Od[Gd] = Od[Id] = Od[Rd] = !1;
  var lh = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, nh = typeof self == "object" && self && self.Object === Object && self, Xd = lh || nh || Function("return this")(), wh = Ae && !Ae.nodeType && Ae, Oh = wh && !0 && td && !td.nodeType && td, Zh = Oh && Oh.exports === wh, Xh = Zh && lh.process, Zp = function() {
    try {
      return Xh && Xh.binding && Xh.binding("util");
    } catch (hd) {
    }
  }(), Yh = Zp && Zp.isTypedArray;
  function Xp(hd, gd) {
    for (var yd = -1, $d = hd == null ? 0 : hd.length, Bd = 0, Md = []; ++yd < $d; ) {
      var qd = hd[yd];
      gd(qd, yd, hd) && (Md[Bd++] = qd);
    }
    return Md;
  }
  function Kh(hd, gd) {
    for (var yd = -1, $d = gd.length, Bd = hd.length; ++yd < $d; )
      hd[Bd + yd] = gd[yd];
    return hd;
  }
  function Yp(hd, gd) {
    for (var yd = -1, $d = hd == null ? 0 : hd.length; ++yd < $d; )
      if (gd(hd[yd], yd, hd))
        return !0;
    return !1;
  }
  function m1(hd, gd) {
    for (var yd = -1, $d = Array(hd); ++yd < hd; )
      $d[yd] = gd(yd);
    return $d;
  }
  function b1(hd) {
    return function(gd) {
      return hd(gd);
    };
  }
  function Mh(hd, gd) {
    return hd.has(gd);
  }
  function Qh(hd, gd) {
    return hd == null ? void 0 : hd[gd];
  }
  function Kp(hd) {
    var gd = -1, yd = Array(hd.size);
    return hd.forEach(function($d, Bd) {
      yd[++gd] = [Bd, $d];
    }), yd;
  }
  function Qp(hd, gd) {
    return function(yd) {
      return hd(gd(yd));
    };
  }
  function fh(hd) {
    var gd = -1, yd = Array(hd.size);
    return hd.forEach(function($d) {
      yd[++gd] = $d;
    }), yd;
  }
  var Ph = Array.prototype, y1 = Function.prototype, Fh = Object.prototype, zh = Xd["__core-js_shared__"], Jh = y1.toString, ch = Fh.hasOwnProperty, Jp = function() {
    var hd = /[^.]+$/.exec(zh && zh.keys && zh.keys.IE_PROTO || "");
    return hd ? "Symbol(src)_1." + hd : "";
  }(), e1 = Fh.toString, S1 = RegExp(
    "^" + Jh.call(ch).replace(Ud, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Dp = Zh ? Xd.Buffer : void 0, Bh = Xd.Symbol, t1 = Xd.Uint8Array, Hh = Fh.propertyIsEnumerable, Lh = Ph.splice, uh = Bh ? Bh.toStringTag : void 0, Rh = Object.getOwnPropertySymbols, Ep = Dp ? Dp.isBuffer : void 0, Gh = Qp(Object.keys, Object), xp = Dh(Xd, "DataView"), _h = Dh(Xd, "Map"), Fp = Dh(Xd, "Promise"), Lp = Dh(Xd, "Set"), Gp = Dh(Xd, "WeakMap"), $h = Dh(Object, "create"), i1 = ah(xp), vh = ah(_h), v1 = ah(Fp), D1 = ah(Lp), C1 = ah(Gp), o1 = Bh ? Bh.prototype : void 0, kp = o1 ? o1.valueOf : void 0;
  function Qd(hd) {
    var gd = -1, yd = hd == null ? 0 : hd.length;
    for (this.clear(); ++gd < yd; ) {
      var $d = hd[gd];
      this.set($d[0], $d[1]);
    }
  }
  function E1() {
    this.__data__ = $h ? $h(null) : {}, this.size = 0;
  }
  function $1(hd) {
    var gd = this.has(hd) && delete this.__data__[hd];
    return this.size -= gd ? 1 : 0, gd;
  }
  function T1(hd) {
    var gd = this.__data__;
    if ($h) {
      var yd = gd[hd];
      return yd === ed ? void 0 : yd;
    }
    return ch.call(gd, hd) ? gd[hd] : void 0;
  }
  function x1(hd) {
    var gd = this.__data__;
    return $h ? gd[hd] !== void 0 : ch.call(gd, hd);
  }
  function w1(hd, gd) {
    var yd = this.__data__;
    return this.size += this.has(hd) ? 0 : 1, yd[hd] = $h && gd === void 0 ? ed : gd, this;
  }
  Qd.prototype.clear = E1, Qd.prototype.delete = $1, Qd.prototype.get = T1, Qd.prototype.has = x1, Qd.prototype.set = w1;
  function eh(hd) {
    var gd = -1, yd = hd == null ? 0 : hd.length;
    for (this.clear(); ++gd < yd; ) {
      var $d = hd[gd];
      this.set($d[0], $d[1]);
    }
  }
  function F1() {
    this.__data__ = [], this.size = 0;
  }
  function L1(hd) {
    var gd = this.__data__, yd = Vh(gd, hd);
    if (yd < 0)
      return !1;
    var $d = gd.length - 1;
    return yd == $d ? gd.pop() : Lh.call(gd, yd, 1), --this.size, !0;
  }
  function G1(hd) {
    var gd = this.__data__, yd = Vh(gd, hd);
    return yd < 0 ? void 0 : gd[yd][1];
  }
  function _1(hd) {
    return Vh(this.__data__, hd) > -1;
  }
  function k1(hd, gd) {
    var yd = this.__data__, $d = Vh(yd, hd);
    return $d < 0 ? (++this.size, yd.push([hd, gd])) : yd[$d][1] = gd, this;
  }
  eh.prototype.clear = F1, eh.prototype.delete = L1, eh.prototype.get = G1, eh.prototype.has = _1, eh.prototype.set = k1;
  function rh(hd) {
    var gd = -1, yd = hd == null ? 0 : hd.length;
    for (this.clear(); ++gd < yd; ) {
      var $d = hd[gd];
      this.set($d[0], $d[1]);
    }
  }
  function A1() {
    this.size = 0, this.__data__ = {
      hash: new Qd(),
      map: new (_h || eh)(),
      string: new Qd()
    };
  }
  function I1(hd) {
    var gd = ph(this, hd).delete(hd);
    return this.size -= gd ? 1 : 0, gd;
  }
  function O1(hd) {
    return ph(this, hd).get(hd);
  }
  function M1(hd) {
    return ph(this, hd).has(hd);
  }
  function P1(hd, gd) {
    var yd = ph(this, hd), $d = yd.size;
    return yd.set(hd, gd), this.size += yd.size == $d ? 0 : 1, this;
  }
  rh.prototype.clear = A1, rh.prototype.delete = I1, rh.prototype.get = O1, rh.prototype.has = M1, rh.prototype.set = P1;
  function qh(hd) {
    var gd = -1, yd = hd == null ? 0 : hd.length;
    for (this.__data__ = new rh(); ++gd < yd; )
      this.add(hd[gd]);
  }
  function a1(hd) {
    return this.__data__.set(hd, ed), this;
  }
  function Nh(hd) {
    return this.__data__.has(hd);
  }
  qh.prototype.add = qh.prototype.push = a1, qh.prototype.has = Nh;
  function mh(hd) {
    var gd = this.__data__ = new eh(hd);
    this.size = gd.size;
  }
  function Mp() {
    this.__data__ = new eh(), this.size = 0;
  }
  function z1(hd) {
    var gd = this.__data__, yd = gd.delete(hd);
    return this.size = gd.size, yd;
  }
  function B1(hd) {
    return this.__data__.get(hd);
  }
  function H1(hd) {
    return this.__data__.has(hd);
  }
  function R1(hd, gd) {
    var yd = this.__data__;
    if (yd instanceof eh) {
      var $d = yd.__data__;
      if (!_h || $d.length < xr - 1)
        return $d.push([hd, gd]), this.size = ++yd.size, this;
      yd = this.__data__ = new rh($d);
    }
    return yd.set(hd, gd), this.size = yd.size, this;
  }
  mh.prototype.clear = Mp, mh.prototype.delete = z1, mh.prototype.get = B1, mh.prototype.has = H1, mh.prototype.set = R1;
  function q1(hd, gd) {
    var yd = jh(hd), $d = !yd && c1(hd), Bd = !yd && !$d && Uh(hd), Md = !yd && !$d && !Bd && u1(hd), qd = yd || $d || Bd || Md, jd = qd ? m1(hd.length, String) : [], Yd = jd.length;
    for (var Zd in hd)
      (gd || ch.call(hd, Zd)) && !(qd && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Zd == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Bd && (Zd == "offset" || Zd == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Md && (Zd == "buffer" || Zd == "byteLength" || Zd == "byteOffset") || // Skip index properties.
      Y1(Zd, Yd))) && jd.push(Zd);
    return jd;
  }
  function Vh(hd, gd) {
    for (var yd = hd.length; yd--; )
      if (l1(hd[yd][0], gd))
        return yd;
    return -1;
  }
  function zp(hd, gd, yd) {
    var $d = gd(hd);
    return jh(hd) ? $d : Kh($d, yd(hd));
  }
  function kh(hd) {
    return hd == null ? hd === void 0 ? Hd : bd : uh && uh in Object(hd) ? Ch(hd) : n1(hd);
  }
  function r1(hd) {
    return yh(hd) && kh(hd) == rd;
  }
  function s1(hd, gd, yd, $d, Bd) {
    return hd === gd ? !0 : hd == null || gd == null || !yh(hd) && !yh(gd) ? hd !== hd && gd !== gd : N1(hd, gd, yd, $d, s1, Bd);
  }
  function N1(hd, gd, yd, $d, Bd, Md) {
    var qd = jh(hd), jd = jh(gd), Yd = qd ? sd : bh(hd), Zd = jd ? sd : bh(gd);
    Yd = Yd == rd ? Sd : Yd, Zd = Zd == rd ? Sd : Zd;
    var th = Yd == Sd, sh = Zd == Sd, Kd = Yd == Zd;
    if (Kd && Uh(hd)) {
      if (!Uh(gd))
        return !1;
      qd = !0, th = !1;
    }
    if (Kd && !th)
      return Md || (Md = new mh()), qd || u1(hd) ? Bp(hd, gd, yd, $d, Bd, Md) : W1(hd, gd, Yd, yd, $d, Bd, Md);
    if (!(yd & id)) {
      var ih = th && ch.call(hd, "__wrapped__"), Jd = sh && ch.call(gd, "__wrapped__");
      if (ih || Jd) {
        var Th = ih ? hd.value() : hd, Eh = Jd ? gd.value() : gd;
        return Md || (Md = new mh()), Bd(Th, Eh, yd, $d, Md);
      }
    }
    return Kd ? (Md || (Md = new mh()), Z1(hd, gd, yd, $d, Bd, Md)) : !1;
  }
  function V1(hd) {
    if (!h1(hd) || Q1(hd))
      return !1;
    var gd = d1(hd) ? S1 : oh;
    return gd.test(ah(hd));
  }
  function j1(hd) {
    return yh(hd) && Rp(hd.length) && !!Od[kh(hd)];
  }
  function U1(hd) {
    if (!J1(hd))
      return Gh(hd);
    var gd = [];
    for (var yd in Object(hd))
      ch.call(hd, yd) && yd != "constructor" && gd.push(yd);
    return gd;
  }
  function Bp(hd, gd, yd, $d, Bd, Md) {
    var qd = yd & id, jd = hd.length, Yd = gd.length;
    if (jd != Yd && !(qd && Yd > jd))
      return !1;
    var Zd = Md.get(hd);
    if (Zd && Md.get(gd))
      return Zd == gd;
    var th = -1, sh = !0, Kd = yd & od ? new qh() : void 0;
    for (Md.set(hd, gd), Md.set(gd, hd); ++th < jd; ) {
      var ih = hd[th], Jd = gd[th];
      if ($d)
        var Th = qd ? $d(Jd, ih, th, gd, hd, Md) : $d(ih, Jd, th, hd, gd, Md);
      if (Th !== void 0) {
        if (Th)
          continue;
        sh = !1;
        break;
      }
      if (Kd) {
        if (!Yp(gd, function(Eh, Ih) {
          if (!Mh(Kd, Ih) && (ih === Eh || Bd(ih, Eh, yd, $d, Md)))
            return Kd.push(Ih);
        })) {
          sh = !1;
          break;
        }
      } else if (!(ih === Jd || Bd(ih, Jd, yd, $d, Md))) {
        sh = !1;
        break;
      }
    }
    return Md.delete(hd), Md.delete(gd), sh;
  }
  function W1(hd, gd, yd, $d, Bd, Md, qd) {
    switch (yd) {
      case wd:
        if (hd.byteLength != gd.byteLength || hd.byteOffset != gd.byteOffset)
          return !1;
        hd = hd.buffer, gd = gd.buffer;
      case Cd:
        return !(hd.byteLength != gd.byteLength || !Md(new t1(hd), new t1(gd)));
      case cd:
      case ud:
      case fd:
        return l1(+hd, +gd);
      case ld:
        return hd.name == gd.name && hd.message == gd.message;
      case Td:
      case Id:
        return hd == gd + "";
      case md:
        var jd = Kp;
      case Gd:
        var Yd = $d & id;
        if (jd || (jd = fh), hd.size != gd.size && !Yd)
          return !1;
        var Zd = qd.get(hd);
        if (Zd)
          return Zd == gd;
        $d |= od, qd.set(hd, gd);
        var th = Bp(jd(hd), jd(gd), $d, Bd, Md, qd);
        return qd.delete(hd), th;
      case Pd:
        if (kp)
          return kp.call(hd) == kp.call(gd);
    }
    return !1;
  }
  function Z1(hd, gd, yd, $d, Bd, Md) {
    var qd = yd & id, jd = Ah(hd), Yd = jd.length, Zd = Ah(gd), th = Zd.length;
    if (Yd != th && !qd)
      return !1;
    for (var sh = Yd; sh--; ) {
      var Kd = jd[sh];
      if (!(qd ? Kd in gd : ch.call(gd, Kd)))
        return !1;
    }
    var ih = Md.get(hd);
    if (ih && Md.get(gd))
      return ih == gd;
    var Jd = !0;
    Md.set(hd, gd), Md.set(gd, hd);
    for (var Th = qd; ++sh < Yd; ) {
      Kd = jd[sh];
      var Eh = hd[Kd], Ih = gd[Kd];
      if ($d)
        var m0 = qd ? $d(Ih, Eh, Kd, gd, hd, Md) : $d(Eh, Ih, Kd, hd, gd, Md);
      if (!(m0 === void 0 ? Eh === Ih || Bd(Eh, Ih, yd, $d, Md) : m0)) {
        Jd = !1;
        break;
      }
      Th || (Th = Kd == "constructor");
    }
    if (Jd && !Th) {
      var p1 = hd.constructor, g1 = gd.constructor;
      p1 != g1 && "constructor" in hd && "constructor" in gd && !(typeof p1 == "function" && p1 instanceof p1 && typeof g1 == "function" && g1 instanceof g1) && (Jd = !1);
    }
    return Md.delete(hd), Md.delete(gd), Jd;
  }
  function Ah(hd) {
    return zp(hd, qp, X1);
  }
  function ph(hd, gd) {
    var yd = hd.__data__;
    return K1(gd) ? yd[typeof gd == "string" ? "string" : "hash"] : yd.map;
  }
  function Dh(hd, gd) {
    var yd = Qh(hd, gd);
    return V1(yd) ? yd : void 0;
  }
  function Ch(hd) {
    var gd = ch.call(hd, uh), yd = hd[uh];
    try {
      hd[uh] = void 0;
      var $d = !0;
    } catch (Md) {
    }
    var Bd = e1.call(hd);
    return $d && (gd ? hd[uh] = yd : delete hd[uh]), Bd;
  }
  var X1 = Rh ? function(hd) {
    return hd == null ? [] : (hd = Object(hd), Xp(Rh(hd), function(gd) {
      return Hh.call(hd, gd);
    }));
  } : t0, bh = kh;
  (xp && bh(new xp(new ArrayBuffer(1))) != wd || _h && bh(new _h()) != md || Fp && bh(Fp.resolve()) != vd || Lp && bh(new Lp()) != Gd || Gp && bh(new Gp()) != Rd) && (bh = function(hd) {
    var gd = kh(hd), yd = gd == Sd ? hd.constructor : void 0, $d = yd ? ah(yd) : "";
    if ($d)
      switch ($d) {
        case i1:
          return wd;
        case vh:
          return md;
        case v1:
          return vd;
        case D1:
          return Gd;
        case C1:
          return Rd;
      }
    return gd;
  });
  function Y1(hd, gd) {
    return gd = gd == null ? ad : gd, !!gd && (typeof hd == "number" || Vd.test(hd)) && hd > -1 && hd % 1 == 0 && hd < gd;
  }
  function K1(hd) {
    var gd = typeof hd;
    return gd == "string" || gd == "number" || gd == "symbol" || gd == "boolean" ? hd !== "__proto__" : hd === null;
  }
  function Q1(hd) {
    return !!Jp && Jp in hd;
  }
  function J1(hd) {
    var gd = hd && hd.constructor, yd = typeof gd == "function" && gd.prototype || Fh;
    return hd === yd;
  }
  function n1(hd) {
    return e1.call(hd);
  }
  function ah(hd) {
    if (hd != null) {
      try {
        return Jh.call(hd);
      } catch (gd) {
      }
      try {
        return hd + "";
      } catch (gd) {
      }
    }
    return "";
  }
  function l1(hd, gd) {
    return hd === gd || hd !== hd && gd !== gd;
  }
  var c1 = r1(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r1 : function(hd) {
    return yh(hd) && ch.call(hd, "callee") && !Hh.call(hd, "callee");
  }, jh = Array.isArray;
  function Hp(hd) {
    return hd != null && Rp(hd.length) && !d1(hd);
  }
  var Uh = Ep || i0;
  function e0(hd, gd) {
    return s1(hd, gd);
  }
  function d1(hd) {
    if (!h1(hd))
      return !1;
    var gd = kh(hd);
    return gd == dd || gd == pd || gd == nd || gd == Ed;
  }
  function Rp(hd) {
    return typeof hd == "number" && hd > -1 && hd % 1 == 0 && hd <= ad;
  }
  function h1(hd) {
    var gd = typeof hd;
    return hd != null && (gd == "object" || gd == "function");
  }
  function yh(hd) {
    return hd != null && typeof hd == "object";
  }
  var u1 = Yh ? b1(Yh) : j1;
  function qp(hd) {
    return Hp(hd) ? q1(hd) : U1(hd);
  }
  function t0() {
    return [];
  }
  function i0() {
    return !1;
  }
  td.exports = e0;
})(lodash_isequal, lodash_isequal.exports);
var lodash_isequalExports = lodash_isequal.exports, AttributeMap$1 = {};
Object.defineProperty(AttributeMap$1, "__esModule", { value: !0 });
const cloneDeep = lodash_clonedeepExports, isEqual = lodash_isequalExports;
var AttributeMap;
(function(td) {
  function Ae(od = {}, ad = {}, rd = !1) {
    typeof od != "object" && (od = {}), typeof ad != "object" && (ad = {});
    let sd = cloneDeep(ad);
    rd || (sd = Object.keys(sd).reduce((nd, cd) => (sd[cd] != null && (nd[cd] = sd[cd]), nd), {}));
    for (const nd in od)
      od[nd] !== void 0 && ad[nd] === void 0 && (sd[nd] = od[nd]);
    return Object.keys(sd).length > 0 ? sd : void 0;
  }
  td.compose = Ae;
  function xr(od = {}, ad = {}) {
    typeof od != "object" && (od = {}), typeof ad != "object" && (ad = {});
    const rd = Object.keys(od).concat(Object.keys(ad)).reduce((sd, nd) => (isEqual(od[nd], ad[nd]) || (sd[nd] = ad[nd] === void 0 ? null : ad[nd]), sd), {});
    return Object.keys(rd).length > 0 ? rd : void 0;
  }
  td.diff = xr;
  function ed(od = {}, ad = {}) {
    od = od || {};
    const rd = Object.keys(ad).reduce((sd, nd) => (ad[nd] !== od[nd] && od[nd] !== void 0 && (sd[nd] = ad[nd]), sd), {});
    return Object.keys(od).reduce((sd, nd) => (od[nd] !== ad[nd] && ad[nd] === void 0 && (sd[nd] = null), sd), rd);
  }
  td.invert = ed;
  function id(od, ad, rd = !1) {
    if (typeof od != "object")
      return ad;
    if (typeof ad != "object")
      return;
    if (!rd)
      return ad;
    const sd = Object.keys(ad).reduce((nd, cd) => (od[cd] === void 0 && (nd[cd] = ad[cd]), nd), {});
    return Object.keys(sd).length > 0 ? sd : void 0;
  }
  td.transform = id;
})(AttributeMap || (AttributeMap = {}));
AttributeMap$1.default = AttributeMap;
var Op$1 = {};
Object.defineProperty(Op$1, "__esModule", { value: !0 });
var Op;
(function(td) {
  function Ae(xr) {
    return typeof xr.delete == "number" ? xr.delete : typeof xr.retain == "number" ? xr.retain : typeof xr.retain == "object" && xr.retain !== null ? 1 : typeof xr.insert == "string" ? xr.insert.length : 1;
  }
  td.length = Ae;
})(Op || (Op = {}));
Op$1.default = Op;
var OpIterator = {};
Object.defineProperty(OpIterator, "__esModule", { value: !0 });
const Op_1 = Op$1;
class Iterator {
  constructor(Ae) {
    this.ops = Ae, this.index = 0, this.offset = 0;
  }
  hasNext() {
    return this.peekLength() < 1 / 0;
  }
  next(Ae) {
    Ae || (Ae = 1 / 0);
    const xr = this.ops[this.index];
    if (xr) {
      const ed = this.offset, id = Op_1.default.length(xr);
      if (Ae >= id - ed ? (Ae = id - ed, this.index += 1, this.offset = 0) : this.offset += Ae, typeof xr.delete == "number")
        return { delete: Ae };
      {
        const od = {};
        return xr.attributes && (od.attributes = xr.attributes), typeof xr.retain == "number" ? od.retain = Ae : typeof xr.retain == "object" && xr.retain !== null ? od.retain = xr.retain : typeof xr.insert == "string" ? od.insert = xr.insert.substr(ed, Ae) : od.insert = xr.insert, od;
      }
    } else
      return { retain: 1 / 0 };
  }
  peek() {
    return this.ops[this.index];
  }
  peekLength() {
    return this.ops[this.index] ? Op_1.default.length(this.ops[this.index]) - this.offset : 1 / 0;
  }
  peekType() {
    const Ae = this.ops[this.index];
    return Ae ? typeof Ae.delete == "number" ? "delete" : typeof Ae.retain == "number" || typeof Ae.retain == "object" && Ae.retain !== null ? "retain" : "insert" : "retain";
  }
  rest() {
    if (this.hasNext()) {
      if (this.offset === 0)
        return this.ops.slice(this.index);
      {
        const Ae = this.offset, xr = this.index, ed = this.next(), id = this.ops.slice(this.index);
        return this.offset = Ae, this.index = xr, [ed].concat(id);
      }
    } else
      return [];
  }
}
OpIterator.default = Iterator;
(function(td, Ae) {
  Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.AttributeMap = Ae.OpIterator = Ae.Op = void 0;
  const xr = diff_1, ed = lodash_clonedeepExports, id = lodash_isequalExports, od = AttributeMap$1;
  Ae.AttributeMap = od.default;
  const ad = Op$1;
  Ae.Op = ad.default;
  const rd = OpIterator;
  Ae.OpIterator = rd.default;
  const sd = "\0", nd = (ud, ld) => {
    if (typeof ud != "object" || ud === null)
      throw new Error(`cannot retain a ${typeof ud}`);
    if (typeof ld != "object" || ld === null)
      throw new Error(`cannot retain a ${typeof ld}`);
    const dd = Object.keys(ud)[0];
    if (!dd || dd !== Object.keys(ld)[0])
      throw new Error(`embed types not matched: ${dd} != ${Object.keys(ld)[0]}`);
    return [dd, ud[dd], ld[dd]];
  };
  class cd {
    constructor(ld) {
      Array.isArray(ld) ? this.ops = ld : ld != null && Array.isArray(ld.ops) ? this.ops = ld.ops : this.ops = [];
    }
    static registerEmbed(ld, dd) {
      this.handlers[ld] = dd;
    }
    static unregisterEmbed(ld) {
      delete this.handlers[ld];
    }
    static getHandler(ld) {
      const dd = this.handlers[ld];
      if (!dd)
        throw new Error(`no handlers for embed type "${ld}"`);
      return dd;
    }
    insert(ld, dd) {
      const pd = {};
      return typeof ld == "string" && ld.length === 0 ? this : (pd.insert = ld, dd != null && typeof dd == "object" && Object.keys(dd).length > 0 && (pd.attributes = dd), this.push(pd));
    }
    delete(ld) {
      return ld <= 0 ? this : this.push({ delete: ld });
    }
    retain(ld, dd) {
      if (typeof ld == "number" && ld <= 0)
        return this;
      const pd = { retain: ld };
      return dd != null && typeof dd == "object" && Object.keys(dd).length > 0 && (pd.attributes = dd), this.push(pd);
    }
    push(ld) {
      let dd = this.ops.length, pd = this.ops[dd - 1];
      if (ld = ed(ld), typeof pd == "object") {
        if (typeof ld.delete == "number" && typeof pd.delete == "number")
          return this.ops[dd - 1] = { delete: pd.delete + ld.delete }, this;
        if (typeof pd.delete == "number" && ld.insert != null && (dd -= 1, pd = this.ops[dd - 1], typeof pd != "object"))
          return this.ops.unshift(ld), this;
        if (id(ld.attributes, pd.attributes)) {
          if (typeof ld.insert == "string" && typeof pd.insert == "string")
            return this.ops[dd - 1] = { insert: pd.insert + ld.insert }, typeof ld.attributes == "object" && (this.ops[dd - 1].attributes = ld.attributes), this;
          if (typeof ld.retain == "number" && typeof pd.retain == "number")
            return this.ops[dd - 1] = { retain: pd.retain + ld.retain }, typeof ld.attributes == "object" && (this.ops[dd - 1].attributes = ld.attributes), this;
        }
      }
      return dd === this.ops.length ? this.ops.push(ld) : this.ops.splice(dd, 0, ld), this;
    }
    chop() {
      const ld = this.ops[this.ops.length - 1];
      return ld && typeof ld.retain == "number" && !ld.attributes && this.ops.pop(), this;
    }
    filter(ld) {
      return this.ops.filter(ld);
    }
    forEach(ld) {
      this.ops.forEach(ld);
    }
    map(ld) {
      return this.ops.map(ld);
    }
    partition(ld) {
      const dd = [], pd = [];
      return this.forEach((md) => {
        (ld(md) ? dd : pd).push(md);
      }), [dd, pd];
    }
    reduce(ld, dd) {
      return this.ops.reduce(ld, dd);
    }
    changeLength() {
      return this.reduce((ld, dd) => dd.insert ? ld + ad.default.length(dd) : dd.delete ? ld - dd.delete : ld, 0);
    }
    length() {
      return this.reduce((ld, dd) => ld + ad.default.length(dd), 0);
    }
    slice(ld = 0, dd = 1 / 0) {
      const pd = [], md = new rd.default(this.ops);
      let fd = 0;
      for (; fd < dd && md.hasNext(); ) {
        let bd;
        fd < ld ? bd = md.next(ld - fd) : (bd = md.next(dd - fd), pd.push(bd)), fd += ad.default.length(bd);
      }
      return new cd(pd);
    }
    compose(ld) {
      const dd = new rd.default(this.ops), pd = new rd.default(ld.ops), md = [], fd = pd.peek();
      if (fd != null && typeof fd.retain == "number" && fd.attributes == null) {
        let Sd = fd.retain;
        for (; dd.peekType() === "insert" && dd.peekLength() <= Sd; )
          Sd -= dd.peekLength(), md.push(dd.next());
        fd.retain - Sd > 0 && pd.next(fd.retain - Sd);
      }
      const bd = new cd(md);
      for (; dd.hasNext() || pd.hasNext(); )
        if (pd.peekType() === "insert")
          bd.push(pd.next());
        else if (dd.peekType() === "delete")
          bd.push(dd.next());
        else {
          const Sd = Math.min(dd.peekLength(), pd.peekLength()), vd = dd.next(Sd), Ed = pd.next(Sd);
          if (Ed.retain) {
            const Td = {};
            if (typeof vd.retain == "number")
              Td.retain = typeof Ed.retain == "number" ? Sd : Ed.retain;
            else if (typeof Ed.retain == "number")
              vd.retain == null ? Td.insert = vd.insert : Td.retain = vd.retain;
            else {
              const Id = vd.retain == null ? "insert" : "retain", [Pd, Hd, Rd] = nd(vd[Id], Ed.retain), Cd = cd.getHandler(Pd);
              Td[Id] = {
                [Pd]: Cd.compose(Hd, Rd, Id === "retain")
              };
            }
            const Gd = od.default.compose(vd.attributes, Ed.attributes, typeof vd.retain == "number");
            if (Gd && (Td.attributes = Gd), bd.push(Td), !pd.hasNext() && id(bd.ops[bd.ops.length - 1], Td)) {
              const Id = new cd(dd.rest());
              return bd.concat(Id).chop();
            }
          } else
            typeof Ed.delete == "number" && (typeof vd.retain == "number" || typeof vd.retain == "object" && vd.retain !== null) && bd.push(Ed);
        }
      return bd.chop();
    }
    concat(ld) {
      const dd = new cd(this.ops.slice());
      return ld.ops.length > 0 && (dd.push(ld.ops[0]), dd.ops = dd.ops.concat(ld.ops.slice(1))), dd;
    }
    diff(ld, dd) {
      if (this.ops === ld.ops)
        return new cd();
      const pd = [this, ld].map((vd) => vd.map((Ed) => {
        if (Ed.insert != null)
          return typeof Ed.insert == "string" ? Ed.insert : sd;
        const Td = vd === ld ? "on" : "with";
        throw new Error("diff() called " + Td + " non-document");
      }).join("")), md = new cd(), fd = xr(pd[0], pd[1], dd, !0), bd = new rd.default(this.ops), Sd = new rd.default(ld.ops);
      return fd.forEach((vd) => {
        let Ed = vd[1].length;
        for (; Ed > 0; ) {
          let Td = 0;
          switch (vd[0]) {
            case xr.INSERT:
              Td = Math.min(Sd.peekLength(), Ed), md.push(Sd.next(Td));
              break;
            case xr.DELETE:
              Td = Math.min(Ed, bd.peekLength()), bd.next(Td), md.delete(Td);
              break;
            case xr.EQUAL:
              Td = Math.min(bd.peekLength(), Sd.peekLength(), Ed);
              const Gd = bd.next(Td), Id = Sd.next(Td);
              id(Gd.insert, Id.insert) ? md.retain(Td, od.default.diff(Gd.attributes, Id.attributes)) : md.push(Id).delete(Td);
              break;
          }
          Ed -= Td;
        }
      }), md.chop();
    }
    eachLine(ld, dd = `
`) {
      const pd = new rd.default(this.ops);
      let md = new cd(), fd = 0;
      for (; pd.hasNext(); ) {
        if (pd.peekType() !== "insert")
          return;
        const bd = pd.peek(), Sd = ad.default.length(bd) - pd.peekLength(), vd = typeof bd.insert == "string" ? bd.insert.indexOf(dd, Sd) - Sd : -1;
        if (vd < 0)
          md.push(pd.next());
        else if (vd > 0)
          md.push(pd.next(vd));
        else {
          if (ld(md, pd.next(1).attributes || {}, fd) === !1)
            return;
          fd += 1, md = new cd();
        }
      }
      md.length() > 0 && ld(md, {}, fd);
    }
    invert(ld) {
      const dd = new cd();
      return this.reduce((pd, md) => {
        if (md.insert)
          dd.delete(ad.default.length(md));
        else {
          if (typeof md.retain == "number" && md.attributes == null)
            return dd.retain(md.retain), pd + md.retain;
          if (md.delete || typeof md.retain == "number") {
            const fd = md.delete || md.retain;
            return ld.slice(pd, pd + fd).forEach((Sd) => {
              md.delete ? dd.push(Sd) : md.retain && md.attributes && dd.retain(ad.default.length(Sd), od.default.invert(md.attributes, Sd.attributes));
            }), pd + fd;
          } else if (typeof md.retain == "object" && md.retain !== null) {
            const fd = ld.slice(pd, pd + 1), bd = new rd.default(fd.ops).next(), [Sd, vd, Ed] = nd(md.retain, bd.insert), Td = cd.getHandler(Sd);
            return dd.retain({ [Sd]: Td.invert(vd, Ed) }, od.default.invert(md.attributes, bd.attributes)), pd + 1;
          }
        }
        return pd;
      }, 0), dd.chop();
    }
    transform(ld, dd = !1) {
      if (dd = !!dd, typeof ld == "number")
        return this.transformPosition(ld, dd);
      const pd = ld, md = new rd.default(this.ops), fd = new rd.default(pd.ops), bd = new cd();
      for (; md.hasNext() || fd.hasNext(); )
        if (md.peekType() === "insert" && (dd || fd.peekType() !== "insert"))
          bd.retain(ad.default.length(md.next()));
        else if (fd.peekType() === "insert")
          bd.push(fd.next());
        else {
          const Sd = Math.min(md.peekLength(), fd.peekLength()), vd = md.next(Sd), Ed = fd.next(Sd);
          if (vd.delete)
            continue;
          if (Ed.delete)
            bd.push(Ed);
          else {
            const Td = vd.retain, Gd = Ed.retain;
            let Id = typeof Gd == "object" && Gd !== null ? Gd : Sd;
            if (typeof Td == "object" && Td !== null && typeof Gd == "object" && Gd !== null) {
              const Pd = Object.keys(Td)[0];
              if (Pd === Object.keys(Gd)[0]) {
                const Hd = cd.getHandler(Pd);
                Hd && (Id = {
                  [Pd]: Hd.transform(Td[Pd], Gd[Pd], dd)
                });
              }
            }
            bd.retain(Id, od.default.transform(vd.attributes, Ed.attributes, dd));
          }
        }
      return bd.chop();
    }
    transformPosition(ld, dd = !1) {
      dd = !!dd;
      const pd = new rd.default(this.ops);
      let md = 0;
      for (; pd.hasNext() && md <= ld; ) {
        const fd = pd.peekLength(), bd = pd.peekType();
        if (pd.next(), bd === "delete") {
          ld -= Math.min(fd, ld - md);
          continue;
        } else
          bd === "insert" && (md < ld || !dd) && (ld += fd);
        md += fd;
      }
      return ld;
    }
  }
  cd.Op = ad.default, cd.OpIterator = rd.default, cd.AttributeMap = od.default, cd.handlers = {}, Ae.default = cd, td.exports = cd, td.exports.default = cd;
})(Delta$1, Delta$1.exports);
var DeltaExports = Delta$1.exports;
const Delta = /* @__PURE__ */ getDefaultExportFromCjs(DeltaExports);
class Break extends EmbedBlot$1 {
  static value() {
  }
  optimize() {
    (this.prev || this.next) && this.remove();
  }
  length() {
    return 0;
  }
  value() {
    return "";
  }
}
Break.blotName = "break";
Break.tagName = "BR";
let Text$2 = class extends TextBlot$1 {
};
function escapeText(td) {
  return td.replace(/[&<>"']/g, (Ae) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[Ae]);
}
const Sh = class Sh extends InlineBlot$1 {
  static compare(Ae, xr) {
    const ed = Sh.order.indexOf(Ae), id = Sh.order.indexOf(xr);
    return ed >= 0 || id >= 0 ? ed - id : Ae === xr ? 0 : Ae < xr ? -1 : 1;
  }
  formatAt(Ae, xr, ed, id) {
    if (Sh.compare(this.statics.blotName, ed) < 0 && this.scroll.query(ed, Scope.BLOT)) {
      const od = this.isolate(Ae, xr);
      id && od.wrap(ed, id);
    } else
      super.formatAt(Ae, xr, ed, id);
  }
  optimize(Ae) {
    if (super.optimize(Ae), this.parent instanceof Sh && Sh.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
      const xr = this.parent.isolate(this.offset(), this.length());
      this.moveChildren(xr), xr.wrap(this);
    }
  }
};
_d(Sh, "allowedChildren", [Sh, Break, EmbedBlot$1, Text$2]), // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
_d(Sh, "order", [
  "cursor",
  "inline",
  // Must be lower
  "link",
  // Chrome wants <a> to be lower
  "underline",
  "strike",
  "italic",
  "bold",
  "script",
  "code"
  // Must be higher
]);
let Inline = Sh;
const NEWLINE_LENGTH = 1;
class Block extends BlockBlot$1 {
  constructor() {
    super(...arguments);
    _d(this, "cache", {});
  }
  delta() {
    return this.cache.delta == null && (this.cache.delta = blockDelta(this)), this.cache.delta;
  }
  deleteAt(xr, ed) {
    super.deleteAt(xr, ed), this.cache = {};
  }
  formatAt(xr, ed, id, od) {
    ed <= 0 || (this.scroll.query(id, Scope.BLOCK) ? xr + ed === this.length() && this.format(id, od) : super.formatAt(xr, Math.min(ed, this.length() - xr - 1), id, od), this.cache = {});
  }
  insertAt(xr, ed, id) {
    if (id != null) {
      super.insertAt(xr, ed, id), this.cache = {};
      return;
    }
    if (ed.length === 0)
      return;
    const od = ed.split(`
`), ad = od.shift();
    ad.length > 0 && (xr < this.length() - 1 || this.children.tail == null ? super.insertAt(Math.min(xr, this.length() - 1), ad) : this.children.tail.insertAt(this.children.tail.length(), ad), this.cache = {});
    let rd = this;
    od.reduce((sd, nd) => (rd = rd.split(sd, !0), rd.insertAt(0, nd), nd.length), xr + ad.length);
  }
  insertBefore(xr, ed) {
    const {
      head: id
    } = this.children;
    super.insertBefore(xr, ed), id instanceof Break && id.remove(), this.cache = {};
  }
  length() {
    return this.cache.length == null && (this.cache.length = super.length() + NEWLINE_LENGTH), this.cache.length;
  }
  moveChildren(xr, ed) {
    super.moveChildren(xr, ed), this.cache = {};
  }
  optimize(xr) {
    super.optimize(xr), this.cache = {};
  }
  path(xr) {
    return super.path(xr, !0);
  }
  removeChild(xr) {
    super.removeChild(xr), this.cache = {};
  }
  split(xr) {
    let ed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (ed && (xr === 0 || xr >= this.length() - NEWLINE_LENGTH)) {
      const od = this.clone();
      return xr === 0 ? (this.parent.insertBefore(od, this), this) : (this.parent.insertBefore(od, this.next), od);
    }
    const id = super.split(xr, ed);
    return this.cache = {}, id;
  }
}
Block.blotName = "block";
Block.tagName = "P";
Block.defaultChild = Break;
Block.allowedChildren = [Break, Inline, EmbedBlot$1, Text$2];
class BlockEmbed extends EmbedBlot$1 {
  attach() {
    super.attach(), this.attributes = new AttributorStore$1(this.domNode);
  }
  delta() {
    return new Delta().insert(this.value(), {
      ...this.formats(),
      ...this.attributes.values()
    });
  }
  format(Ae, xr) {
    const ed = this.scroll.query(Ae, Scope.BLOCK_ATTRIBUTE);
    ed != null && this.attributes.attribute(ed, xr);
  }
  formatAt(Ae, xr, ed, id) {
    this.format(ed, id);
  }
  insertAt(Ae, xr, ed) {
    if (ed != null) {
      super.insertAt(Ae, xr, ed);
      return;
    }
    const id = xr.split(`
`), od = id.pop(), ad = id.map((sd) => {
      const nd = this.scroll.create(Block.blotName);
      return nd.insertAt(0, sd), nd;
    }), rd = this.split(Ae);
    ad.forEach((sd) => {
      this.parent.insertBefore(sd, rd);
    }), od && this.parent.insertBefore(this.scroll.create("text", od), rd);
  }
}
BlockEmbed.scope = Scope.BLOCK_BLOT;
function blockDelta(td) {
  let Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return td.descendants(LeafBlot$1).reduce((xr, ed) => ed.length() === 0 ? xr : xr.insert(ed.value(), bubbleFormats(ed, {}, Ae)), new Delta()).insert(`
`, bubbleFormats(td));
}
function bubbleFormats(td) {
  let Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, xr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return td == null || ("formats" in td && typeof td.formats == "function" && (Ae = {
    ...Ae,
    ...td.formats()
  }, xr && delete Ae["code-token"]), td.parent == null || td.parent.statics.blotName === "scroll" || td.parent.statics.scope !== td.statics.scope) ? Ae : bubbleFormats(td.parent, Ae, xr);
}
const dh = class dh extends EmbedBlot$1 {
  // Zero width no break space
  static value() {
  }
  constructor(Ae, xr, ed) {
    super(Ae, xr), this.selection = ed, this.textNode = document.createTextNode(dh.CONTENTS), this.domNode.appendChild(this.textNode), this.savedLength = 0;
  }
  detach() {
    this.parent != null && this.parent.removeChild(this);
  }
  format(Ae, xr) {
    if (this.savedLength !== 0) {
      super.format(Ae, xr);
      return;
    }
    let ed = this, id = 0;
    for (; ed != null && ed.statics.scope !== Scope.BLOCK_BLOT; )
      id += ed.offset(ed.parent), ed = ed.parent;
    ed != null && (this.savedLength = dh.CONTENTS.length, ed.optimize(), ed.formatAt(id, dh.CONTENTS.length, Ae, xr), this.savedLength = 0);
  }
  index(Ae, xr) {
    return Ae === this.textNode ? 0 : super.index(Ae, xr);
  }
  length() {
    return this.savedLength;
  }
  position() {
    return [this.textNode, this.textNode.data.length];
  }
  remove() {
    super.remove(), this.parent = null;
  }
  restore() {
    if (this.selection.composing || this.parent == null)
      return null;
    const Ae = this.selection.getNativeRange();
    for (; this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode; )
      this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
    const xr = this.prev instanceof Text$2 ? this.prev : null, ed = xr ? xr.length() : 0, id = this.next instanceof Text$2 ? this.next : null, od = id ? id.text : "", {
      textNode: ad
    } = this, rd = ad.data.split(dh.CONTENTS).join("");
    ad.data = dh.CONTENTS;
    let sd;
    if (xr)
      sd = xr, (rd || id) && (xr.insertAt(xr.length(), rd + od), id && id.remove());
    else if (id)
      sd = id, id.insertAt(0, rd);
    else {
      const nd = document.createTextNode(rd);
      sd = this.scroll.create(nd), this.parent.insertBefore(sd, this);
    }
    if (this.remove(), Ae) {
      const nd = (ld, dd) => xr && ld === xr.domNode ? dd : ld === ad ? ed + dd - 1 : id && ld === id.domNode ? ed + rd.length + dd : null, cd = nd(Ae.start.node, Ae.start.offset), ud = nd(Ae.end.node, Ae.end.offset);
      if (cd !== null && ud !== null)
        return {
          startNode: sd.domNode,
          startOffset: cd,
          endNode: sd.domNode,
          endOffset: ud
        };
    }
    return null;
  }
  update(Ae, xr) {
    if (Ae.some((ed) => ed.type === "characterData" && ed.target === this.textNode)) {
      const ed = this.restore();
      ed && (xr.range = ed);
    }
  }
  // Avoid .ql-cursor being a descendant of `<a/>`.
  // The reason is Safari pushes down `<a/>` on text insertion.
  // That will cause DOM nodes not sync with the model.
  //
  // For example ({I} is the caret), given the markup:
  //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
  // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
  //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
  // And then "x" will be inserted after `<a/>`:
  //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
  optimize(Ae) {
    super.optimize(Ae);
    let {
      parent: xr
    } = this;
    for (; xr; ) {
      if (xr.domNode.tagName === "A") {
        this.savedLength = dh.CONTENTS.length, xr.isolate(this.offset(xr), this.length()).unwrap(), this.savedLength = 0;
        break;
      }
      xr = xr.parent;
    }
  }
  value() {
    return "";
  }
};
_d(dh, "blotName", "cursor"), _d(dh, "className", "ql-cursor"), _d(dh, "tagName", "span"), _d(dh, "CONTENTS", "\uFEFF");
let Cursor = dh;
var eventemitter3 = { exports: {} };
(function(td) {
  var Ae = Object.prototype.hasOwnProperty, xr = "~";
  function ed() {
  }
  Object.create && (ed.prototype = /* @__PURE__ */ Object.create(null), new ed().__proto__ || (xr = !1));
  function id(sd, nd, cd) {
    this.fn = sd, this.context = nd, this.once = cd || !1;
  }
  function od(sd, nd, cd, ud, ld) {
    if (typeof cd != "function")
      throw new TypeError("The listener must be a function");
    var dd = new id(cd, ud || sd, ld), pd = xr ? xr + nd : nd;
    return sd._events[pd] ? sd._events[pd].fn ? sd._events[pd] = [sd._events[pd], dd] : sd._events[pd].push(dd) : (sd._events[pd] = dd, sd._eventsCount++), sd;
  }
  function ad(sd, nd) {
    --sd._eventsCount === 0 ? sd._events = new ed() : delete sd._events[nd];
  }
  function rd() {
    this._events = new ed(), this._eventsCount = 0;
  }
  rd.prototype.eventNames = function() {
    var nd = [], cd, ud;
    if (this._eventsCount === 0)
      return nd;
    for (ud in cd = this._events)
      Ae.call(cd, ud) && nd.push(xr ? ud.slice(1) : ud);
    return Object.getOwnPropertySymbols ? nd.concat(Object.getOwnPropertySymbols(cd)) : nd;
  }, rd.prototype.listeners = function(nd) {
    var cd = xr ? xr + nd : nd, ud = this._events[cd];
    if (!ud)
      return [];
    if (ud.fn)
      return [ud.fn];
    for (var ld = 0, dd = ud.length, pd = new Array(dd); ld < dd; ld++)
      pd[ld] = ud[ld].fn;
    return pd;
  }, rd.prototype.listenerCount = function(nd) {
    var cd = xr ? xr + nd : nd, ud = this._events[cd];
    return ud ? ud.fn ? 1 : ud.length : 0;
  }, rd.prototype.emit = function(nd, cd, ud, ld, dd, pd) {
    var md = xr ? xr + nd : nd;
    if (!this._events[md])
      return !1;
    var fd = this._events[md], bd = arguments.length, Sd, vd;
    if (fd.fn) {
      switch (fd.once && this.removeListener(nd, fd.fn, void 0, !0), bd) {
        case 1:
          return fd.fn.call(fd.context), !0;
        case 2:
          return fd.fn.call(fd.context, cd), !0;
        case 3:
          return fd.fn.call(fd.context, cd, ud), !0;
        case 4:
          return fd.fn.call(fd.context, cd, ud, ld), !0;
        case 5:
          return fd.fn.call(fd.context, cd, ud, ld, dd), !0;
        case 6:
          return fd.fn.call(fd.context, cd, ud, ld, dd, pd), !0;
      }
      for (vd = 1, Sd = new Array(bd - 1); vd < bd; vd++)
        Sd[vd - 1] = arguments[vd];
      fd.fn.apply(fd.context, Sd);
    } else {
      var Ed = fd.length, Td;
      for (vd = 0; vd < Ed; vd++)
        switch (fd[vd].once && this.removeListener(nd, fd[vd].fn, void 0, !0), bd) {
          case 1:
            fd[vd].fn.call(fd[vd].context);
            break;
          case 2:
            fd[vd].fn.call(fd[vd].context, cd);
            break;
          case 3:
            fd[vd].fn.call(fd[vd].context, cd, ud);
            break;
          case 4:
            fd[vd].fn.call(fd[vd].context, cd, ud, ld);
            break;
          default:
            if (!Sd)
              for (Td = 1, Sd = new Array(bd - 1); Td < bd; Td++)
                Sd[Td - 1] = arguments[Td];
            fd[vd].fn.apply(fd[vd].context, Sd);
        }
    }
    return !0;
  }, rd.prototype.on = function(nd, cd, ud) {
    return od(this, nd, cd, ud, !1);
  }, rd.prototype.once = function(nd, cd, ud) {
    return od(this, nd, cd, ud, !0);
  }, rd.prototype.removeListener = function(nd, cd, ud, ld) {
    var dd = xr ? xr + nd : nd;
    if (!this._events[dd])
      return this;
    if (!cd)
      return ad(this, dd), this;
    var pd = this._events[dd];
    if (pd.fn)
      pd.fn === cd && (!ld || pd.once) && (!ud || pd.context === ud) && ad(this, dd);
    else {
      for (var md = 0, fd = [], bd = pd.length; md < bd; md++)
        (pd[md].fn !== cd || ld && !pd[md].once || ud && pd[md].context !== ud) && fd.push(pd[md]);
      fd.length ? this._events[dd] = fd.length === 1 ? fd[0] : fd : ad(this, dd);
    }
    return this;
  }, rd.prototype.removeAllListeners = function(nd) {
    var cd;
    return nd ? (cd = xr ? xr + nd : nd, this._events[cd] && ad(this, cd)) : (this._events = new ed(), this._eventsCount = 0), this;
  }, rd.prototype.off = rd.prototype.removeListener, rd.prototype.addListener = rd.prototype.on, rd.prefixed = xr, rd.EventEmitter = rd, td.exports = rd;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports), instances = /* @__PURE__ */ new WeakMap(), levels = ["error", "warn", "log", "info"];
let level = "warn";
function debug$6(td) {
  if (level && levels.indexOf(td) <= levels.indexOf(level)) {
    for (var Ae = arguments.length, xr = new Array(Ae > 1 ? Ae - 1 : 0), ed = 1; ed < Ae; ed++)
      xr[ed - 1] = arguments[ed];
    console[td](...xr);
  }
}
function namespace(td) {
  return levels.reduce((Ae, xr) => (Ae[xr] = debug$6.bind(console, xr, td), Ae), {});
}
namespace.level = (td) => {
  level = td;
};
debug$6.level = namespace.level;
const debug$5 = namespace("quill:events"), EVENTS = ["selectionchange", "mousedown", "mouseup", "click"];
EVENTS.forEach((td) => {
  document.addEventListener(td, function() {
    for (var Ae = arguments.length, xr = new Array(Ae), ed = 0; ed < Ae; ed++)
      xr[ed] = arguments[ed];
    Array.from(document.querySelectorAll(".ql-container")).forEach((id) => {
      const od = instances.get(id);
      od && od.emitter && od.emitter.handleDOM(...xr);
    });
  });
});
class Emitter extends EventEmitter {
  constructor() {
    super(), this.domListeners = {}, this.on("error", debug$5.error);
  }
  emit() {
    for (var Ae = arguments.length, xr = new Array(Ae), ed = 0; ed < Ae; ed++)
      xr[ed] = arguments[ed];
    return debug$5.log.call(debug$5, ...xr), super.emit(...xr);
  }
  handleDOM(Ae) {
    for (var xr = arguments.length, ed = new Array(xr > 1 ? xr - 1 : 0), id = 1; id < xr; id++)
      ed[id - 1] = arguments[id];
    (this.domListeners[Ae.type] || []).forEach((od) => {
      let {
        node: ad,
        handler: rd
      } = od;
      (Ae.target === ad || ad.contains(Ae.target)) && rd(Ae, ...ed);
    });
  }
  listenDOM(Ae, xr, ed) {
    this.domListeners[Ae] || (this.domListeners[Ae] = []), this.domListeners[Ae].push({
      node: xr,
      handler: ed
    });
  }
}
_d(Emitter, "events", {
  EDITOR_CHANGE: "editor-change",
  SCROLL_BEFORE_UPDATE: "scroll-before-update",
  SCROLL_BLOT_MOUNT: "scroll-blot-mount",
  SCROLL_BLOT_UNMOUNT: "scroll-blot-unmount",
  SCROLL_OPTIMIZE: "scroll-optimize",
  SCROLL_UPDATE: "scroll-update",
  SCROLL_EMBED_UPDATE: "scroll-embed-update",
  SELECTION_CHANGE: "selection-change",
  TEXT_CHANGE: "text-change",
  COMPOSITION_BEFORE_START: "composition-before-start",
  COMPOSITION_START: "composition-start",
  COMPOSITION_BEFORE_END: "composition-before-end",
  COMPOSITION_END: "composition-end"
}), _d(Emitter, "sources", {
  API: "api",
  SILENT: "silent",
  USER: "user"
});
const debug$4 = namespace("quill:selection");
class Range {
  constructor(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.index = Ae, this.length = xr;
  }
}
class Selection {
  constructor(Ae, xr) {
    this.emitter = xr, this.scroll = Ae, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = this.scroll.create("cursor", this), this.savedRange = new Range(0, 0), this.lastRange = this.savedRange, this.lastNative = null, this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, () => {
      !this.mouseDown && !this.composing && setTimeout(this.update.bind(this, Emitter.sources.USER), 1);
    }), this.emitter.on(Emitter.events.SCROLL_BEFORE_UPDATE, () => {
      if (!this.hasFocus())
        return;
      const ed = this.getNativeRange();
      ed != null && ed.start.node !== this.cursor.textNode && this.emitter.once(Emitter.events.SCROLL_UPDATE, (id, od) => {
        try {
          this.root.contains(ed.start.node) && this.root.contains(ed.end.node) && this.setNativeRange(ed.start.node, ed.start.offset, ed.end.node, ed.end.offset);
          const ad = od.some((rd) => rd.type === "characterData" || rd.type === "childList" || rd.type === "attributes" && rd.target === this.root);
          this.update(ad ? Emitter.sources.SILENT : id);
        } catch (ad) {
        }
      });
    }), this.emitter.on(Emitter.events.SCROLL_OPTIMIZE, (ed, id) => {
      if (id.range) {
        const {
          startNode: od,
          startOffset: ad,
          endNode: rd,
          endOffset: sd
        } = id.range;
        this.setNativeRange(od, ad, rd, sd), this.update(Emitter.sources.SILENT);
      }
    }), this.update(Emitter.sources.SILENT);
  }
  handleComposition() {
    this.emitter.on(Emitter.events.COMPOSITION_BEFORE_START, () => {
      this.composing = !0;
    }), this.emitter.on(Emitter.events.COMPOSITION_END, () => {
      if (this.composing = !1, this.cursor.parent) {
        const Ae = this.cursor.restore();
        if (!Ae)
          return;
        setTimeout(() => {
          this.setNativeRange(Ae.startNode, Ae.startOffset, Ae.endNode, Ae.endOffset);
        }, 1);
      }
    });
  }
  handleDragging() {
    this.emitter.listenDOM("mousedown", document.body, () => {
      this.mouseDown = !0;
    }), this.emitter.listenDOM("mouseup", document.body, () => {
      this.mouseDown = !1, this.update(Emitter.sources.USER);
    });
  }
  focus() {
    this.hasFocus() || (this.root.focus({
      preventScroll: !0
    }), this.setRange(this.savedRange));
  }
  format(Ae, xr) {
    this.scroll.update();
    const ed = this.getNativeRange();
    if (!(ed == null || !ed.native.collapsed || this.scroll.query(Ae, Scope.BLOCK))) {
      if (ed.start.node !== this.cursor.textNode) {
        const id = this.scroll.find(ed.start.node, !1);
        if (id == null)
          return;
        if (id instanceof LeafBlot$1) {
          const od = id.split(ed.start.offset);
          id.parent.insertBefore(this.cursor, od);
        } else
          id.insertBefore(this.cursor, ed.start.node);
        this.cursor.attach();
      }
      this.cursor.format(Ae, xr), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update();
    }
  }
  getBounds(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    const ed = this.scroll.length();
    Ae = Math.min(Ae, ed - 1), xr = Math.min(Ae + xr, ed - 1) - Ae;
    let id, [od, ad] = this.scroll.leaf(Ae);
    if (od == null)
      return null;
    if (xr > 0 && ad === od.length()) {
      const [cd] = this.scroll.leaf(Ae + 1);
      if (cd) {
        const [ud] = this.scroll.line(Ae), [ld] = this.scroll.line(Ae + 1);
        ud === ld && (od = cd, ad = 0);
      }
    }
    [id, ad] = od.position(ad, !0);
    const rd = document.createRange();
    if (xr > 0)
      return rd.setStart(id, ad), [od, ad] = this.scroll.leaf(Ae + xr), od == null ? null : ([id, ad] = od.position(ad, !0), rd.setEnd(id, ad), rd.getBoundingClientRect());
    let sd = "left", nd;
    if (id instanceof Text) {
      if (!id.data.length)
        return null;
      ad < id.data.length ? (rd.setStart(id, ad), rd.setEnd(id, ad + 1)) : (rd.setStart(id, ad - 1), rd.setEnd(id, ad), sd = "right"), nd = rd.getBoundingClientRect();
    } else {
      if (!(od.domNode instanceof Element))
        return null;
      nd = od.domNode.getBoundingClientRect(), ad > 0 && (sd = "right");
    }
    return {
      bottom: nd.top + nd.height,
      height: nd.height,
      left: nd[sd],
      right: nd[sd],
      top: nd.top,
      width: 0
    };
  }
  getNativeRange() {
    const Ae = document.getSelection();
    if (Ae == null || Ae.rangeCount <= 0)
      return null;
    const xr = Ae.getRangeAt(0);
    if (xr == null)
      return null;
    const ed = this.normalizeNative(xr);
    return debug$4.info("getNativeRange", ed), ed;
  }
  getRange() {
    const Ae = this.scroll.domNode;
    if ("isConnected" in Ae && !Ae.isConnected)
      return [null, null];
    const xr = this.getNativeRange();
    return xr == null ? [null, null] : [this.normalizedToRange(xr), xr];
  }
  hasFocus() {
    return document.activeElement === this.root || document.activeElement != null && contains(this.root, document.activeElement);
  }
  normalizedToRange(Ae) {
    const xr = [[Ae.start.node, Ae.start.offset]];
    Ae.native.collapsed || xr.push([Ae.end.node, Ae.end.offset]);
    const ed = xr.map((ad) => {
      const [rd, sd] = ad, nd = this.scroll.find(rd, !0), cd = nd.offset(this.scroll);
      return sd === 0 ? cd : nd instanceof LeafBlot$1 ? cd + nd.index(rd, sd) : cd + nd.length();
    }), id = Math.min(Math.max(...ed), this.scroll.length() - 1), od = Math.min(id, ...ed);
    return new Range(od, id - od);
  }
  normalizeNative(Ae) {
    if (!contains(this.root, Ae.startContainer) || !Ae.collapsed && !contains(this.root, Ae.endContainer))
      return null;
    const xr = {
      start: {
        node: Ae.startContainer,
        offset: Ae.startOffset
      },
      end: {
        node: Ae.endContainer,
        offset: Ae.endOffset
      },
      native: Ae
    };
    return [xr.start, xr.end].forEach((ed) => {
      let {
        node: id,
        offset: od
      } = ed;
      for (; !(id instanceof Text) && id.childNodes.length > 0; )
        if (id.childNodes.length > od)
          id = id.childNodes[od], od = 0;
        else if (id.childNodes.length === od)
          id = id.lastChild, id instanceof Text ? od = id.data.length : id.childNodes.length > 0 ? od = id.childNodes.length : od = id.childNodes.length + 1;
        else
          break;
      ed.node = id, ed.offset = od;
    }), xr;
  }
  rangeToNative(Ae) {
    const xr = this.scroll.length(), ed = (id, od) => {
      id = Math.min(xr - 1, id);
      const [ad, rd] = this.scroll.leaf(id);
      return ad ? ad.position(rd, od) : [null, -1];
    };
    return [...ed(Ae.index, !1), ...ed(Ae.index + Ae.length, !0)];
  }
  setNativeRange(Ae, xr) {
    let ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ae, id = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : xr, od = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
    if (debug$4.info("setNativeRange", Ae, xr, ed, id), Ae != null && (this.root.parentNode == null || Ae.parentNode == null || // @ts-expect-error Fix me later
    ed.parentNode == null))
      return;
    const ad = document.getSelection();
    if (ad != null)
      if (Ae != null) {
        this.hasFocus() || this.root.focus({
          preventScroll: !0
        });
        const {
          native: rd
        } = this.getNativeRange() || {};
        if (rd == null || od || Ae !== rd.startContainer || xr !== rd.startOffset || ed !== rd.endContainer || id !== rd.endOffset) {
          Ae instanceof Element && Ae.tagName === "BR" && (xr = Array.from(Ae.parentNode.childNodes).indexOf(Ae), Ae = Ae.parentNode), ed instanceof Element && ed.tagName === "BR" && (id = Array.from(ed.parentNode.childNodes).indexOf(ed), ed = ed.parentNode);
          const sd = document.createRange();
          sd.setStart(Ae, xr), sd.setEnd(ed, id), ad.removeAllRanges(), ad.addRange(sd);
        }
      } else
        ad.removeAllRanges(), this.root.blur();
  }
  setRange(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Emitter.sources.API;
    if (typeof xr == "string" && (ed = xr, xr = !1), debug$4.info("setRange", Ae), Ae != null) {
      const id = this.rangeToNative(Ae);
      this.setNativeRange(...id, xr);
    } else
      this.setNativeRange(null);
    this.update(ed);
  }
  update() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Emitter.sources.USER;
    const xr = this.lastRange, [ed, id] = this.getRange();
    if (this.lastRange = ed, this.lastNative = id, this.lastRange != null && (this.savedRange = this.lastRange), !isEqual$2(xr, this.lastRange)) {
      if (!this.composing && id != null && id.native.collapsed && id.start.node !== this.cursor.textNode) {
        const ad = this.cursor.restore();
        ad && this.setNativeRange(ad.startNode, ad.startOffset, ad.endNode, ad.endOffset);
      }
      const od = [Emitter.events.SELECTION_CHANGE, cloneDeep$1(this.lastRange), cloneDeep$1(xr), Ae];
      this.emitter.emit(Emitter.events.EDITOR_CHANGE, ...od), Ae !== Emitter.sources.SILENT && this.emitter.emit(...od);
    }
  }
}
function contains(td, Ae) {
  try {
    Ae.parentNode;
  } catch (xr) {
    return !1;
  }
  return td.contains(Ae);
}
const ASCII = /^[ -~]*$/;
class Editor {
  constructor(Ae) {
    this.scroll = Ae, this.delta = this.getDelta();
  }
  applyDelta(Ae) {
    this.scroll.update();
    let xr = this.scroll.length();
    this.scroll.batchStart();
    const ed = normalizeDelta(Ae), id = new Delta();
    return splitOpLines(ed.ops.slice()).reduce((ad, rd) => {
      const sd = DeltaExports.Op.length(rd);
      let nd = rd.attributes || {}, cd = !1, ud = !1;
      if (rd.insert != null) {
        if (id.retain(sd), typeof rd.insert == "string") {
          const pd = rd.insert;
          ud = !pd.endsWith(`
`) && (xr <= ad || !!this.scroll.descendant(BlockEmbed, ad)[0]), this.scroll.insertAt(ad, pd);
          const [md, fd] = this.scroll.line(ad);
          let bd = merge({}, bubbleFormats(md));
          if (md instanceof Block) {
            const [Sd] = md.descendant(LeafBlot$1, fd);
            Sd && (bd = merge(bd, bubbleFormats(Sd)));
          }
          nd = DeltaExports.AttributeMap.diff(bd, nd) || {};
        } else if (typeof rd.insert == "object") {
          const pd = Object.keys(rd.insert)[0];
          if (pd == null)
            return ad;
          const md = this.scroll.query(pd, Scope.INLINE) != null;
          if (md)
            (xr <= ad || this.scroll.descendant(BlockEmbed, ad)[0]) && (ud = !0);
          else if (ad > 0) {
            const [fd, bd] = this.scroll.descendant(LeafBlot$1, ad - 1);
            fd instanceof Text$2 ? fd.value()[bd] !== `
` && (cd = !0) : fd instanceof EmbedBlot$1 && fd.statics.scope === Scope.INLINE_BLOT && (cd = !0);
          }
          if (this.scroll.insertAt(ad, pd, rd.insert[pd]), md) {
            const [fd] = this.scroll.descendant(LeafBlot$1, ad);
            if (fd) {
              const bd = merge({}, bubbleFormats(fd));
              nd = DeltaExports.AttributeMap.diff(bd, nd) || {};
            }
          }
        }
        xr += sd;
      } else if (id.push(rd), rd.retain !== null && typeof rd.retain == "object") {
        const pd = Object.keys(rd.retain)[0];
        if (pd == null)
          return ad;
        this.scroll.updateEmbedAt(ad, pd, rd.retain[pd]);
      }
      Object.keys(nd).forEach((pd) => {
        this.scroll.formatAt(ad, sd, pd, nd[pd]);
      });
      const ld = cd ? 1 : 0, dd = ud ? 1 : 0;
      return xr += ld + dd, id.retain(ld), id.delete(dd), ad + sd + ld + dd;
    }, 0), id.reduce((ad, rd) => typeof rd.delete == "number" ? (this.scroll.deleteAt(ad, rd.delete), ad) : ad + DeltaExports.Op.length(rd), 0), this.scroll.batchEnd(), this.scroll.optimize(), this.update(ed);
  }
  deleteText(Ae, xr) {
    return this.scroll.deleteAt(Ae, xr), this.update(new Delta().retain(Ae).delete(xr));
  }
  formatLine(Ae, xr) {
    let ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.scroll.update(), Object.keys(ed).forEach((od) => {
      this.scroll.lines(Ae, Math.max(xr, 1)).forEach((ad) => {
        ad.format(od, ed[od]);
      });
    }), this.scroll.optimize();
    const id = new Delta().retain(Ae).retain(xr, cloneDeep$1(ed));
    return this.update(id);
  }
  formatText(Ae, xr) {
    let ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Object.keys(ed).forEach((od) => {
      this.scroll.formatAt(Ae, xr, od, ed[od]);
    });
    const id = new Delta().retain(Ae).retain(xr, cloneDeep$1(ed));
    return this.update(id);
  }
  getContents(Ae, xr) {
    return this.delta.slice(Ae, Ae + xr);
  }
  getDelta() {
    return this.scroll.lines().reduce((Ae, xr) => Ae.concat(xr.delta()), new Delta());
  }
  getFormat(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ed = [], id = [];
    xr === 0 ? this.scroll.path(Ae).forEach((rd) => {
      const [sd] = rd;
      sd instanceof Block ? ed.push(sd) : sd instanceof LeafBlot$1 && id.push(sd);
    }) : (ed = this.scroll.lines(Ae, xr), id = this.scroll.descendants(LeafBlot$1, Ae, xr));
    const [od, ad] = [ed, id].map((rd) => {
      const sd = rd.shift();
      if (sd == null)
        return {};
      let nd = bubbleFormats(sd);
      for (; Object.keys(nd).length > 0; ) {
        const cd = rd.shift();
        if (cd == null)
          return nd;
        nd = combineFormats(bubbleFormats(cd), nd);
      }
      return nd;
    });
    return {
      ...od,
      ...ad
    };
  }
  getHTML(Ae, xr) {
    const [ed, id] = this.scroll.line(Ae);
    if (ed) {
      const od = ed.length();
      return ed.length() >= id + xr && !(id === 0 && xr === od) ? convertHTML(ed, id, xr, !0) : convertHTML(this.scroll, Ae, xr, !0);
    }
    return "";
  }
  getText(Ae, xr) {
    return this.getContents(Ae, xr).filter((ed) => typeof ed.insert == "string").map((ed) => ed.insert).join("");
  }
  insertContents(Ae, xr) {
    const ed = normalizeDelta(xr), id = new Delta().retain(Ae).concat(ed);
    return this.scroll.insertContents(Ae, ed), this.update(id);
  }
  insertEmbed(Ae, xr, ed) {
    return this.scroll.insertAt(Ae, xr, ed), this.update(new Delta().retain(Ae).insert({
      [xr]: ed
    }));
  }
  insertText(Ae, xr) {
    let ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return xr = xr.replace(/\r\n/g, `
`).replace(/\r/g, `
`), this.scroll.insertAt(Ae, xr), Object.keys(ed).forEach((id) => {
      this.scroll.formatAt(Ae, xr.length, id, ed[id]);
    }), this.update(new Delta().retain(Ae).insert(xr, cloneDeep$1(ed)));
  }
  isBlank() {
    if (this.scroll.children.length === 0)
      return !0;
    if (this.scroll.children.length > 1)
      return !1;
    const Ae = this.scroll.children.head;
    if ((Ae == null ? void 0 : Ae.statics.blotName) !== Block.blotName)
      return !1;
    const xr = Ae;
    return xr.children.length > 1 ? !1 : xr.children.head instanceof Break;
  }
  removeFormat(Ae, xr) {
    const ed = this.getText(Ae, xr), [id, od] = this.scroll.line(Ae + xr);
    let ad = 0, rd = new Delta();
    id != null && (ad = id.length() - od, rd = id.delta().slice(od, od + ad - 1).insert(`
`));
    const nd = this.getContents(Ae, xr + ad).diff(new Delta().insert(ed).concat(rd)), cd = new Delta().retain(Ae).concat(nd);
    return this.applyDelta(cd);
  }
  update(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    const id = this.delta;
    if (xr.length === 1 && xr[0].type === "characterData" && // @ts-expect-error Fix me later
    xr[0].target.data.match(ASCII) && this.scroll.find(xr[0].target)) {
      const od = this.scroll.find(xr[0].target), ad = bubbleFormats(od), rd = od.offset(this.scroll), sd = xr[0].oldValue.replace(Cursor.CONTENTS, ""), nd = new Delta().insert(sd), cd = new Delta().insert(od.value()), ud = ed && {
        oldRange: shiftRange$1(ed.oldRange, -rd),
        newRange: shiftRange$1(ed.newRange, -rd)
      };
      Ae = new Delta().retain(rd).concat(nd.diff(cd, ud)).reduce((dd, pd) => pd.insert ? dd.insert(pd.insert, ad) : dd.push(pd), new Delta()), this.delta = id.compose(Ae);
    } else
      this.delta = this.getDelta(), (!Ae || !isEqual$2(id.compose(Ae), this.delta)) && (Ae = id.diff(this.delta, ed));
    return Ae;
  }
}
function convertListHTML(td, Ae, xr) {
  if (td.length === 0) {
    const [dd] = getListType(xr.pop());
    return Ae <= 0 ? `</li></${dd}>` : `</li></${dd}>${convertListHTML([], Ae - 1, xr)}`;
  }
  const [{
    child: ed,
    offset: id,
    length: od,
    indent: ad,
    type: rd
  }, ...sd] = td, [nd, cd] = getListType(rd);
  if (ad > Ae)
    return xr.push(rd), ad === Ae + 1 ? `<${nd}><li${cd}>${convertHTML(ed, id, od)}${convertListHTML(sd, ad, xr)}` : `<${nd}><li>${convertListHTML(td, Ae + 1, xr)}`;
  const ud = xr[xr.length - 1];
  if (ad === Ae && rd === ud)
    return `</li><li${cd}>${convertHTML(ed, id, od)}${convertListHTML(sd, ad, xr)}`;
  const [ld] = getListType(xr.pop());
  return `</li></${ld}>${convertListHTML(td, Ae - 1, xr)}`;
}
function convertHTML(td, Ae, xr) {
  let ed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if ("html" in td && typeof td.html == "function")
    return td.html(Ae, xr);
  if (td instanceof Text$2)
    return escapeText(td.value().slice(Ae, Ae + xr));
  if (td instanceof ParentBlot$1) {
    if (td.statics.blotName === "list-container") {
      const nd = [];
      return td.children.forEachAt(Ae, xr, (cd, ud, ld) => {
        const dd = "formats" in cd && typeof cd.formats == "function" ? cd.formats() : {};
        nd.push({
          child: cd,
          offset: ud,
          length: ld,
          indent: dd.indent || 0,
          type: dd.list
        });
      }), convertListHTML(nd, -1, []);
    }
    const id = [];
    if (td.children.forEachAt(Ae, xr, (nd, cd, ud) => {
      id.push(convertHTML(nd, cd, ud));
    }), ed || td.statics.blotName === "list")
      return id.join("");
    const {
      outerHTML: od,
      innerHTML: ad
    } = td.domNode, [rd, sd] = od.split(`>${ad}<`);
    return rd === "<table" ? `<table style="border: 1px solid #000;">${id.join("")}<${sd}` : `${rd}>${id.join("")}<${sd}`;
  }
  return td.domNode instanceof Element ? td.domNode.outerHTML : "";
}
function combineFormats(td, Ae) {
  return Object.keys(Ae).reduce((xr, ed) => {
    if (td[ed] == null)
      return xr;
    const id = Ae[ed];
    return id === td[ed] ? xr[ed] = id : Array.isArray(id) ? id.indexOf(td[ed]) < 0 ? xr[ed] = id.concat([td[ed]]) : xr[ed] = id : xr[ed] = [id, td[ed]], xr;
  }, {});
}
function getListType(td) {
  const Ae = td === "ordered" ? "ol" : "ul";
  switch (td) {
    case "checked":
      return [Ae, ' data-list="checked"'];
    case "unchecked":
      return [Ae, ' data-list="unchecked"'];
    default:
      return [Ae, ""];
  }
}
function normalizeDelta(td) {
  return td.reduce((Ae, xr) => {
    if (typeof xr.insert == "string") {
      const ed = xr.insert.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
      return Ae.insert(ed, xr.attributes);
    }
    return Ae.push(xr);
  }, new Delta());
}
function shiftRange$1(td, Ae) {
  let {
    index: xr,
    length: ed
  } = td;
  return new Range(xr + Ae, ed);
}
function splitOpLines(td) {
  const Ae = [];
  return td.forEach((xr) => {
    typeof xr.insert == "string" ? xr.insert.split(`
`).forEach((id, od) => {
      od && Ae.push({
        insert: `
`,
        attributes: xr.attributes
      }), id && Ae.push({
        insert: id,
        attributes: xr.attributes
      });
    }) : Ae.push(xr);
  }), Ae;
}
class Module {
  constructor(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.quill = Ae, this.options = xr;
  }
}
_d(Module, "DEFAULTS", {});
const GUARD_TEXT = "\uFEFF";
class Embed extends EmbedBlot$1 {
  constructor(Ae, xr) {
    super(Ae, xr), this.contentNode = document.createElement("span"), this.contentNode.setAttribute("contenteditable", "false"), Array.from(this.domNode.childNodes).forEach((ed) => {
      this.contentNode.appendChild(ed);
    }), this.leftGuard = document.createTextNode(GUARD_TEXT), this.rightGuard = document.createTextNode(GUARD_TEXT), this.domNode.appendChild(this.leftGuard), this.domNode.appendChild(this.contentNode), this.domNode.appendChild(this.rightGuard);
  }
  index(Ae, xr) {
    return Ae === this.leftGuard ? 0 : Ae === this.rightGuard ? 1 : super.index(Ae, xr);
  }
  restore(Ae) {
    let xr = null, ed;
    const id = Ae.data.split(GUARD_TEXT).join("");
    if (Ae === this.leftGuard)
      if (this.prev instanceof Text$2) {
        const od = this.prev.length();
        this.prev.insertAt(od, id), xr = {
          startNode: this.prev.domNode,
          startOffset: od + id.length
        };
      } else
        ed = document.createTextNode(id), this.parent.insertBefore(this.scroll.create(ed), this), xr = {
          startNode: ed,
          startOffset: id.length
        };
    else
      Ae === this.rightGuard && (this.next instanceof Text$2 ? (this.next.insertAt(0, id), xr = {
        startNode: this.next.domNode,
        startOffset: id.length
      }) : (ed = document.createTextNode(id), this.parent.insertBefore(this.scroll.create(ed), this.next), xr = {
        startNode: ed,
        startOffset: id.length
      }));
    return Ae.data = GUARD_TEXT, xr;
  }
  update(Ae, xr) {
    Ae.forEach((ed) => {
      if (ed.type === "characterData" && (ed.target === this.leftGuard || ed.target === this.rightGuard)) {
        const id = this.restore(ed.target);
        id && (xr.range = id);
      }
    });
  }
}
class Composition {
  constructor(Ae, xr) {
    _d(this, "isComposing", !1);
    this.scroll = Ae, this.emitter = xr, this.setupListeners();
  }
  setupListeners() {
    this.scroll.domNode.addEventListener("compositionstart", (Ae) => {
      this.isComposing || this.handleCompositionStart(Ae);
    }), this.scroll.domNode.addEventListener("compositionend", (Ae) => {
      this.isComposing && queueMicrotask(() => {
        this.handleCompositionEnd(Ae);
      });
    });
  }
  handleCompositionStart(Ae) {
    const xr = Ae.target instanceof Node ? this.scroll.find(Ae.target, !0) : null;
    xr && !(xr instanceof Embed) && (this.emitter.emit(Emitter.events.COMPOSITION_BEFORE_START, Ae), this.scroll.batchStart(), this.emitter.emit(Emitter.events.COMPOSITION_START, Ae), this.isComposing = !0);
  }
  handleCompositionEnd(Ae) {
    this.emitter.emit(Emitter.events.COMPOSITION_BEFORE_END, Ae), this.scroll.batchEnd(), this.emitter.emit(Emitter.events.COMPOSITION_END, Ae), this.isComposing = !1;
  }
}
const Vp = class Vp {
  constructor(Ae, xr) {
    _d(this, "modules", {});
    this.quill = Ae, this.options = xr;
  }
  init() {
    Object.keys(this.options.modules).forEach((Ae) => {
      this.modules[Ae] == null && this.addModule(Ae);
    });
  }
  addModule(Ae) {
    const xr = this.quill.constructor.import(`modules/${Ae}`);
    return this.modules[Ae] = new xr(this.quill, this.options.modules[Ae] || {}), this.modules[Ae];
  }
};
_d(Vp, "DEFAULTS", {
  modules: {}
}), _d(Vp, "themes", {
  default: Vp
});
let Theme = Vp;
const getParentElement = (td) => td.parentElement || td.getRootNode().host || null, getElementRect = (td) => {
  const Ae = td.getBoundingClientRect(), xr = "offsetWidth" in td && Math.abs(Ae.width) / td.offsetWidth || 1, ed = "offsetHeight" in td && Math.abs(Ae.height) / td.offsetHeight || 1;
  return {
    top: Ae.top,
    right: Ae.left + td.clientWidth * xr,
    bottom: Ae.top + td.clientHeight * ed,
    left: Ae.left
  };
}, paddingValueToInt = (td) => {
  const Ae = parseInt(td, 10);
  return Number.isNaN(Ae) ? 0 : Ae;
}, getScrollDistance = (td, Ae, xr, ed, id, od) => td < xr && Ae > ed ? 0 : td < xr ? -(xr - td + id) : Ae > ed ? Ae - td > ed - xr ? td + id - xr : Ae - ed + od : 0, scrollRectIntoView = (td, Ae) => {
  var od, ad, rd, sd, nd;
  const xr = td.ownerDocument;
  let ed = Ae, id = td;
  for (; id; ) {
    const cd = id === xr.body, ud = cd ? {
      top: 0,
      right: (ad = (od = window.visualViewport) == null ? void 0 : od.width) != null ? ad : xr.documentElement.clientWidth,
      bottom: (sd = (rd = window.visualViewport) == null ? void 0 : rd.height) != null ? sd : xr.documentElement.clientHeight,
      left: 0
    } : getElementRect(id), ld = getComputedStyle(id), dd = getScrollDistance(ed.left, ed.right, ud.left, ud.right, paddingValueToInt(ld.scrollPaddingLeft), paddingValueToInt(ld.scrollPaddingRight)), pd = getScrollDistance(ed.top, ed.bottom, ud.top, ud.bottom, paddingValueToInt(ld.scrollPaddingTop), paddingValueToInt(ld.scrollPaddingBottom));
    if (dd || pd)
      if (cd)
        (nd = xr.defaultView) == null || nd.scrollBy(dd, pd);
      else {
        const {
          scrollLeft: md,
          scrollTop: fd
        } = id;
        pd && (id.scrollTop += pd), dd && (id.scrollLeft += dd);
        const bd = id.scrollLeft - md, Sd = id.scrollTop - fd;
        ed = {
          left: ed.left - bd,
          top: ed.top - Sd,
          right: ed.right - bd,
          bottom: ed.bottom - Sd
        };
      }
    id = cd || ld.position === "fixed" ? null : getParentElement(id);
  }
}, MAX_REGISTER_ITERATIONS = 100, CORE_FORMATS = ["block", "break", "cursor", "inline", "scroll", "text"], createRegistryWithFormats = (td, Ae, xr) => {
  const ed = new Registry();
  return CORE_FORMATS.forEach((id) => {
    const od = Ae.query(id);
    od && ed.register(od);
  }), td.forEach((id) => {
    var rd;
    let od = Ae.query(id);
    od || xr.error(`Cannot register "${id}" specified in "formats" config. Are you sure it was registered?`);
    let ad = 0;
    for (; od; )
      if (ed.register(od), od = "blotName" in od && (rd = od.requiredContainer) != null ? rd : null, ad += 1, ad > MAX_REGISTER_ITERATIONS) {
        xr.error(`Cycle detected in registering blot requiredContainer: "${id}"`);
        break;
      }
  }), ed;
}, debug$3 = namespace("quill"), globalRegistry = new Registry();
ParentBlot$1.uiClass = "ql-ui";
const gh = class gh {
  static debug(Ae) {
    Ae === !0 && (Ae = "log"), namespace.level(Ae);
  }
  static find(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return instances.get(Ae) || globalRegistry.find(Ae, xr);
  }
  static import(Ae) {
    return this.imports[Ae] == null && debug$3.error(`Cannot import ${Ae}. Are you sure it was registered?`), this.imports[Ae];
  }
  static register() {
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) != "string") {
      const Ae = arguments.length <= 0 ? void 0 : arguments[0], xr = !!(!(arguments.length <= 1) && arguments[1]), ed = "attrName" in Ae ? Ae.attrName : Ae.blotName;
      typeof ed == "string" ? this.register(`formats/${ed}`, Ae, xr) : Object.keys(Ae).forEach((id) => {
        this.register(id, Ae[id], xr);
      });
    } else {
      const Ae = arguments.length <= 0 ? void 0 : arguments[0], xr = arguments.length <= 1 ? void 0 : arguments[1], ed = !!(!(arguments.length <= 2) && arguments[2]);
      this.imports[Ae] != null && !ed && debug$3.warn(`Overwriting ${Ae} with`, xr), this.imports[Ae] = xr, (Ae.startsWith("blots/") || Ae.startsWith("formats/")) && xr && typeof xr != "boolean" && xr.blotName !== "abstract" && globalRegistry.register(xr), typeof xr.register == "function" && xr.register(globalRegistry);
    }
  }
  constructor(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.options = expandConfig(Ae, xr), this.container = this.options.container, this.container == null) {
      debug$3.error("Invalid Quill container", Ae);
      return;
    }
    this.options.debug && gh.debug(this.options.debug);
    const ed = this.container.innerHTML.trim();
    this.container.classList.add("ql-container"), this.container.innerHTML = "", instances.set(this.container, this), this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.emitter = new Emitter();
    const id = ScrollBlot$1.blotName, od = this.options.registry.query(id);
    if (!od || !("blotName" in od))
      throw new Error(`Cannot initialize Quill without "${id}" blot`);
    if (this.scroll = new od(this.options.registry, this.root, {
      emitter: this.emitter
    }), this.editor = new Editor(this.scroll), this.selection = new Selection(this.scroll, this.emitter), this.composition = new Composition(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.uploader = this.theme.addModule("uploader"), this.theme.addModule("input"), this.theme.addModule("uiNode"), this.theme.init(), this.emitter.on(Emitter.events.EDITOR_CHANGE, (ad) => {
      ad === Emitter.events.TEXT_CHANGE && this.root.classList.toggle("ql-blank", this.editor.isBlank());
    }), this.emitter.on(Emitter.events.SCROLL_UPDATE, (ad, rd) => {
      const sd = this.selection.lastRange, [nd] = this.selection.getRange(), cd = sd && nd ? {
        oldRange: sd,
        newRange: nd
      } : void 0;
      modify.call(this, () => this.editor.update(null, rd, cd), ad);
    }), this.emitter.on(Emitter.events.SCROLL_EMBED_UPDATE, (ad, rd) => {
      const sd = this.selection.lastRange, [nd] = this.selection.getRange(), cd = sd && nd ? {
        oldRange: sd,
        newRange: nd
      } : void 0;
      modify.call(this, () => {
        const ud = new Delta().retain(ad.offset(this)).retain({
          [ad.statics.blotName]: rd
        });
        return this.editor.update(ud, [], cd);
      }, gh.sources.USER);
    }), ed) {
      const ad = this.clipboard.convert({
        html: `${ed}<p><br></p>`,
        text: `
`
      });
      this.setContents(ad);
    }
    this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable(), this.allowReadOnlyEdits = !1;
  }
  addContainer(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (typeof Ae == "string") {
      const ed = Ae;
      Ae = document.createElement("div"), Ae.classList.add(ed);
    }
    return this.container.insertBefore(Ae, xr), Ae;
  }
  blur() {
    this.selection.setRange(null);
  }
  deleteText(Ae, xr, ed) {
    return [Ae, xr, , ed] = overload(Ae, xr, ed), modify.call(this, () => this.editor.deleteText(Ae, xr), ed, Ae, -1 * xr);
  }
  disable() {
    this.enable(!1);
  }
  editReadOnly(Ae) {
    this.allowReadOnlyEdits = !0;
    const xr = Ae();
    return this.allowReadOnlyEdits = !1, xr;
  }
  enable() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.scroll.enable(Ae), this.container.classList.toggle("ql-disabled", !Ae);
  }
  focus() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.selection.focus(), Ae.preventScroll || this.scrollSelectionIntoView();
  }
  format(Ae, xr) {
    let ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Emitter.sources.API;
    return modify.call(this, () => {
      const id = this.getSelection(!0);
      let od = new Delta();
      if (id == null)
        return od;
      if (this.scroll.query(Ae, Scope.BLOCK))
        od = this.editor.formatLine(id.index, id.length, {
          [Ae]: xr
        });
      else {
        if (id.length === 0)
          return this.selection.format(Ae, xr), od;
        od = this.editor.formatText(id.index, id.length, {
          [Ae]: xr
        });
      }
      return this.setSelection(id, Emitter.sources.SILENT), od;
    }, ed);
  }
  formatLine(Ae, xr, ed, id, od) {
    let ad;
    return [Ae, xr, ad, od] = overload(
      Ae,
      xr,
      // @ts-expect-error
      ed,
      id,
      od
    ), modify.call(this, () => this.editor.formatLine(Ae, xr, ad), od, Ae, 0);
  }
  formatText(Ae, xr, ed, id, od) {
    let ad;
    return [Ae, xr, ad, od] = overload(
      // @ts-expect-error
      Ae,
      xr,
      ed,
      id,
      od
    ), modify.call(this, () => this.editor.formatText(Ae, xr, ad), od, Ae, 0);
  }
  getBounds(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ed = null;
    if (typeof Ae == "number" ? ed = this.selection.getBounds(Ae, xr) : ed = this.selection.getBounds(Ae.index, Ae.length), !ed)
      return null;
    const id = this.container.getBoundingClientRect();
    return {
      bottom: ed.bottom - id.top,
      height: ed.height,
      left: ed.left - id.left,
      right: ed.right - id.left,
      top: ed.top - id.top,
      width: ed.width
    };
  }
  getContents() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - Ae;
    return [Ae, xr] = overload(Ae, xr), this.editor.getContents(Ae, xr);
  }
  getFormat() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(!0), xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return typeof Ae == "number" ? this.editor.getFormat(Ae, xr) : this.editor.getFormat(Ae.index, Ae.length);
  }
  getIndex(Ae) {
    return Ae.offset(this.scroll);
  }
  getLength() {
    return this.scroll.length();
  }
  getLeaf(Ae) {
    return this.scroll.leaf(Ae);
  }
  getLine(Ae) {
    return this.scroll.line(Ae);
  }
  getLines() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
    return typeof Ae != "number" ? this.scroll.lines(Ae.index, Ae.length) : this.scroll.lines(Ae, xr);
  }
  getModule(Ae) {
    return this.theme.modules[Ae];
  }
  getSelection() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) && this.focus(), this.update(), this.selection.getRange()[0];
  }
  getSemanticHTML() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, xr = arguments.length > 1 ? arguments[1] : void 0;
    return typeof Ae == "number" && (xr = xr != null ? xr : this.getLength() - Ae), [Ae, xr] = overload(Ae, xr), this.editor.getHTML(Ae, xr);
  }
  getText() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, xr = arguments.length > 1 ? arguments[1] : void 0;
    return typeof Ae == "number" && (xr = xr != null ? xr : this.getLength() - Ae), [Ae, xr] = overload(Ae, xr), this.editor.getText(Ae, xr);
  }
  hasFocus() {
    return this.selection.hasFocus();
  }
  insertEmbed(Ae, xr, ed) {
    let id = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : gh.sources.API;
    return modify.call(this, () => this.editor.insertEmbed(Ae, xr, ed), id, Ae);
  }
  insertText(Ae, xr, ed, id, od) {
    let ad;
    return [Ae, , ad, od] = overload(Ae, 0, ed, id, od), modify.call(this, () => this.editor.insertText(Ae, xr, ad), od, Ae, xr.length);
  }
  isEnabled() {
    return this.scroll.isEnabled();
  }
  off() {
    return this.emitter.off(...arguments);
  }
  on() {
    return this.emitter.on(...arguments);
  }
  once() {
    return this.emitter.once(...arguments);
  }
  removeFormat(Ae, xr, ed) {
    return [Ae, xr, , ed] = overload(Ae, xr, ed), modify.call(this, () => this.editor.removeFormat(Ae, xr), ed, Ae);
  }
  scrollRectIntoView(Ae) {
    scrollRectIntoView(this.root, Ae);
  }
  /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */
  scrollIntoView() {
    console.warn("Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead."), this.scrollSelectionIntoView();
  }
  /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */
  scrollSelectionIntoView() {
    const Ae = this.selection.lastRange, xr = Ae && this.selection.getBounds(Ae.index, Ae.length);
    xr && this.scrollRectIntoView(xr);
  }
  setContents(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Emitter.sources.API;
    return modify.call(this, () => {
      Ae = new Delta(Ae);
      const ed = this.getLength(), id = this.editor.deleteText(0, ed), od = this.editor.insertContents(0, Ae), ad = this.editor.deleteText(this.getLength() - 1, 1);
      return id.compose(od).compose(ad);
    }, xr);
  }
  setSelection(Ae, xr, ed) {
    Ae == null ? this.selection.setRange(null, xr || gh.sources.API) : ([Ae, xr, , ed] = overload(Ae, xr, ed), this.selection.setRange(new Range(Math.max(0, Ae), xr), ed), ed !== Emitter.sources.SILENT && this.scrollSelectionIntoView());
  }
  setText(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Emitter.sources.API;
    const ed = new Delta().insert(Ae);
    return this.setContents(ed, xr);
  }
  update() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Emitter.sources.USER;
    const xr = this.scroll.update(Ae);
    return this.selection.update(Ae), xr;
  }
  updateContents(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Emitter.sources.API;
    return modify.call(this, () => (Ae = new Delta(Ae), this.editor.applyDelta(Ae)), xr, !0);
  }
};
_d(gh, "DEFAULTS", {
  bounds: null,
  modules: {
    clipboard: !0,
    keyboard: !0,
    history: !0,
    uploader: !0
  },
  placeholder: "",
  readOnly: !1,
  registry: globalRegistry,
  theme: "default"
}), _d(gh, "events", Emitter.events), _d(gh, "sources", Emitter.sources), _d(gh, "version", "2.0.2"), _d(gh, "imports", {
  delta: Delta,
  parchment: Parchment,
  "core/module": Module,
  "core/theme": Theme
});
let Quill = gh;
function resolveSelector(td) {
  return typeof td == "string" ? document.querySelector(td) : td;
}
function expandModuleConfig(td) {
  return Object.entries(td != null ? td : {}).reduce((Ae, xr) => {
    let [ed, id] = xr;
    return {
      ...Ae,
      [ed]: id === !0 ? {} : id
    };
  }, {});
}
function omitUndefinedValuesFromOptions(td) {
  return Object.fromEntries(Object.entries(td).filter((Ae) => Ae[1] !== void 0));
}
function expandConfig(td, Ae) {
  const xr = resolveSelector(td);
  if (!xr)
    throw new Error("Invalid Quill container");
  const id = !Ae.theme || Ae.theme === Quill.DEFAULTS.theme ? Theme : Quill.import(`themes/${Ae.theme}`);
  if (!id)
    throw new Error(`Invalid theme ${Ae.theme}. Did you register it?`);
  const {
    modules: od,
    ...ad
  } = Quill.DEFAULTS, {
    modules: rd,
    ...sd
  } = id.DEFAULTS;
  let nd = expandModuleConfig(Ae.modules);
  nd != null && nd.toolbar && nd.toolbar.constructor !== Object && (nd = {
    ...nd,
    toolbar: {
      container: nd.toolbar
    }
  });
  const cd = merge({}, expandModuleConfig(od), expandModuleConfig(rd), nd), ud = {
    ...ad,
    ...omitUndefinedValuesFromOptions(sd),
    ...omitUndefinedValuesFromOptions(Ae)
  };
  let ld = Ae.registry;
  return ld ? Ae.formats && debug$3.warn('Ignoring "formats" option because "registry" is specified') : ld = Ae.formats ? createRegistryWithFormats(Ae.formats, ud.registry, debug$3) : ud.registry, {
    ...ud,
    registry: ld,
    container: xr,
    theme: id,
    modules: Object.entries(cd).reduce((dd, pd) => {
      let [md, fd] = pd;
      if (!fd)
        return dd;
      const bd = Quill.import(`modules/${md}`);
      return bd == null ? (debug$3.error(`Cannot load ${md} module. Are you sure you registered it?`), dd) : {
        ...dd,
        // @ts-expect-error
        [md]: merge({}, bd.DEFAULTS || {}, fd)
      };
    }, {}),
    bounds: resolveSelector(ud.bounds)
  };
}
function modify(td, Ae, xr, ed) {
  if (!this.isEnabled() && Ae === Emitter.sources.USER && !this.allowReadOnlyEdits)
    return new Delta();
  let id = xr == null ? null : this.getSelection();
  const od = this.editor.delta, ad = td();
  if (id != null && (xr === !0 && (xr = id.index), ed == null ? id = shiftRange(id, ad, Ae) : ed !== 0 && (id = shiftRange(id, xr, ed, Ae)), this.setSelection(id, Emitter.sources.SILENT)), ad.length() > 0) {
    const rd = [Emitter.events.TEXT_CHANGE, ad, od, Ae];
    this.emitter.emit(Emitter.events.EDITOR_CHANGE, ...rd), Ae !== Emitter.sources.SILENT && this.emitter.emit(...rd);
  }
  return ad;
}
function overload(td, Ae, xr, ed, id) {
  let od = {};
  return typeof td.index == "number" && typeof td.length == "number" ? typeof Ae != "number" ? (id = ed, ed = xr, xr = Ae, Ae = td.length, td = td.index) : (Ae = td.length, td = td.index) : typeof Ae != "number" && (id = ed, ed = xr, xr = Ae, Ae = 0), typeof xr == "object" ? (od = xr, id = ed) : typeof xr == "string" && (ed != null ? od[xr] = ed : id = xr), id = id || Emitter.sources.API, [td, Ae, od, id];
}
function shiftRange(td, Ae, xr, ed) {
  const id = typeof xr == "number" ? xr : 0;
  if (td == null)
    return null;
  let od, ad;
  return Ae && typeof Ae.transformPosition == "function" ? [od, ad] = [td.index, td.index + td.length].map((rd) => (
    // @ts-expect-error -- TODO: add a better type guard around `index`
    Ae.transformPosition(rd, ed !== Emitter.sources.USER)
  )) : [od, ad] = [td.index, td.index + td.length].map((rd) => rd < Ae || rd === Ae && ed === Emitter.sources.USER ? rd : id >= 0 ? rd + id : Math.max(Ae, rd + id)), new Range(od, ad - od);
}
let Container$8 = class extends ContainerBlot$1 {
};
function isLine$1(td) {
  return td instanceof Block || td instanceof BlockEmbed;
}
function isUpdatable(td) {
  return typeof td.updateContent == "function";
}
class Scroll extends ScrollBlot$1 {
  constructor(Ae, xr, ed) {
    let {
      emitter: id
    } = ed;
    super(Ae, xr), this.emitter = id, this.batch = !1, this.optimize(), this.enable(), this.domNode.addEventListener("dragstart", (od) => this.handleDragStart(od));
  }
  batchStart() {
    Array.isArray(this.batch) || (this.batch = []);
  }
  batchEnd() {
    if (!this.batch)
      return;
    const Ae = this.batch;
    this.batch = !1, this.update(Ae);
  }
  emitMount(Ae) {
    this.emitter.emit(Emitter.events.SCROLL_BLOT_MOUNT, Ae);
  }
  emitUnmount(Ae) {
    this.emitter.emit(Emitter.events.SCROLL_BLOT_UNMOUNT, Ae);
  }
  emitEmbedUpdate(Ae, xr) {
    this.emitter.emit(Emitter.events.SCROLL_EMBED_UPDATE, Ae, xr);
  }
  deleteAt(Ae, xr) {
    const [ed, id] = this.line(Ae), [od] = this.line(Ae + xr);
    if (super.deleteAt(Ae, xr), od != null && ed !== od && id > 0) {
      if (ed instanceof BlockEmbed || od instanceof BlockEmbed) {
        this.optimize();
        return;
      }
      const ad = od.children.head instanceof Break ? null : od.children.head;
      ed.moveChildren(od, ad), ed.remove();
    }
    this.optimize();
  }
  enable() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.domNode.setAttribute("contenteditable", Ae ? "true" : "false");
  }
  formatAt(Ae, xr, ed, id) {
    super.formatAt(Ae, xr, ed, id), this.optimize();
  }
  insertAt(Ae, xr, ed) {
    if (Ae >= this.length())
      if (ed == null || this.scroll.query(xr, Scope.BLOCK) == null) {
        const id = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(id), ed == null && xr.endsWith(`
`) ? id.insertAt(0, xr.slice(0, -1), ed) : id.insertAt(0, xr, ed);
      } else {
        const id = this.scroll.create(xr, ed);
        this.appendChild(id);
      }
    else
      super.insertAt(Ae, xr, ed);
    this.optimize();
  }
  insertBefore(Ae, xr) {
    if (Ae.statics.scope === Scope.INLINE_BLOT) {
      const ed = this.scroll.create(this.statics.defaultChild.blotName);
      ed.appendChild(Ae), super.insertBefore(ed, xr);
    } else
      super.insertBefore(Ae, xr);
  }
  insertContents(Ae, xr) {
    const ed = this.deltaToRenderBlocks(xr.concat(new Delta().insert(`
`))), id = ed.pop();
    if (id == null)
      return;
    this.batchStart();
    const od = ed.shift();
    if (od) {
      const sd = od.type === "block" && (od.delta.length() === 0 || !this.descendant(BlockEmbed, Ae)[0] && Ae < this.length()), nd = od.type === "block" ? od.delta : new Delta().insert({
        [od.key]: od.value
      });
      insertInlineContents(this, Ae, nd);
      const cd = od.type === "block" ? 1 : 0, ud = Ae + nd.length() + cd;
      sd && this.insertAt(ud - 1, `
`);
      const ld = bubbleFormats(this.line(Ae)[0]), dd = DeltaExports.AttributeMap.diff(ld, od.attributes) || {};
      Object.keys(dd).forEach((pd) => {
        this.formatAt(ud - 1, 1, pd, dd[pd]);
      }), Ae = ud;
    }
    let [ad, rd] = this.children.find(Ae);
    if (ed.length && (ad && (ad = ad.split(rd), rd = 0), ed.forEach((sd) => {
      if (sd.type === "block") {
        const nd = this.createBlock(sd.attributes, ad || void 0);
        insertInlineContents(nd, 0, sd.delta);
      } else {
        const nd = this.create(sd.key, sd.value);
        this.insertBefore(nd, ad || void 0), Object.keys(sd.attributes).forEach((cd) => {
          nd.format(cd, sd.attributes[cd]);
        });
      }
    })), id.type === "block" && id.delta.length()) {
      const sd = ad ? ad.offset(ad.scroll) + rd : this.length();
      insertInlineContents(this, sd, id.delta);
    }
    this.batchEnd(), this.optimize();
  }
  isEnabled() {
    return this.domNode.getAttribute("contenteditable") === "true";
  }
  leaf(Ae) {
    const xr = this.path(Ae).pop();
    if (!xr)
      return [null, -1];
    const [ed, id] = xr;
    return ed instanceof LeafBlot$1 ? [ed, id] : [null, -1];
  }
  line(Ae) {
    return Ae === this.length() ? this.line(Ae - 1) : this.descendant(isLine$1, Ae);
  }
  lines() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
    const ed = (id, od, ad) => {
      let rd = [], sd = ad;
      return id.children.forEachAt(od, ad, (nd, cd, ud) => {
        isLine$1(nd) ? rd.push(nd) : nd instanceof ContainerBlot$1 && (rd = rd.concat(ed(nd, cd, sd))), sd -= ud;
      }), rd;
    };
    return ed(this, Ae, xr);
  }
  optimize() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.batch || (super.optimize(Ae, xr), Ae.length > 0 && this.emitter.emit(Emitter.events.SCROLL_OPTIMIZE, Ae, xr));
  }
  path(Ae) {
    return super.path(Ae).slice(1);
  }
  remove() {
  }
  update(Ae) {
    if (this.batch) {
      Array.isArray(Ae) && (this.batch = this.batch.concat(Ae));
      return;
    }
    let xr = Emitter.sources.USER;
    typeof Ae == "string" && (xr = Ae), Array.isArray(Ae) || (Ae = this.observer.takeRecords()), Ae = Ae.filter((ed) => {
      let {
        target: id
      } = ed;
      const od = this.find(id, !0);
      return od && !isUpdatable(od);
    }), Ae.length > 0 && this.emitter.emit(Emitter.events.SCROLL_BEFORE_UPDATE, xr, Ae), super.update(Ae.concat([])), Ae.length > 0 && this.emitter.emit(Emitter.events.SCROLL_UPDATE, xr, Ae);
  }
  updateEmbedAt(Ae, xr, ed) {
    const [id] = this.descendant((od) => od instanceof BlockEmbed, Ae);
    id && id.statics.blotName === xr && isUpdatable(id) && id.updateContent(ed);
  }
  handleDragStart(Ae) {
    Ae.preventDefault();
  }
  deltaToRenderBlocks(Ae) {
    const xr = [];
    let ed = new Delta();
    return Ae.forEach((id) => {
      var ad;
      const od = id == null ? void 0 : id.insert;
      if (od)
        if (typeof od == "string") {
          const rd = od.split(`
`);
          rd.slice(0, -1).forEach((nd) => {
            var cd;
            ed.insert(nd, id.attributes), xr.push({
              type: "block",
              delta: ed,
              attributes: (cd = id.attributes) != null ? cd : {}
            }), ed = new Delta();
          });
          const sd = rd[rd.length - 1];
          sd && ed.insert(sd, id.attributes);
        } else {
          const rd = Object.keys(od)[0];
          if (!rd)
            return;
          this.query(rd, Scope.INLINE) ? ed.push(id) : (ed.length() && xr.push({
            type: "block",
            delta: ed,
            attributes: {}
          }), ed = new Delta(), xr.push({
            type: "blockEmbed",
            key: rd,
            value: od[rd],
            attributes: (ad = id.attributes) != null ? ad : {}
          }));
        }
    }), ed.length() && xr.push({
      type: "block",
      delta: ed,
      attributes: {}
    }), xr;
  }
  createBlock(Ae, xr) {
    let ed;
    const id = {};
    Object.entries(Ae).forEach((rd) => {
      let [sd, nd] = rd;
      this.query(sd, Scope.BLOCK & Scope.BLOT) != null ? ed = sd : id[sd] = nd;
    });
    const od = this.create(ed || this.statics.defaultChild.blotName, ed ? Ae[ed] : void 0);
    this.insertBefore(od, xr || void 0);
    const ad = od.length();
    return Object.entries(id).forEach((rd) => {
      let [sd, nd] = rd;
      od.formatAt(0, ad, sd, nd);
    }), od;
  }
}
_d(Scroll, "blotName", "scroll"), _d(Scroll, "className", "ql-editor"), _d(Scroll, "tagName", "DIV"), _d(Scroll, "defaultChild", Block), _d(Scroll, "allowedChildren", [Block, BlockEmbed, Container$8]);
function insertInlineContents(td, Ae, xr) {
  xr.reduce((ed, id) => {
    const od = DeltaExports.Op.length(id);
    let ad = id.attributes || {};
    if (id.insert != null) {
      if (typeof id.insert == "string") {
        const rd = id.insert;
        td.insertAt(ed, rd);
        const [sd] = td.descendant(LeafBlot$1, ed), nd = bubbleFormats(sd);
        ad = DeltaExports.AttributeMap.diff(nd, ad) || {};
      } else if (typeof id.insert == "object") {
        const rd = Object.keys(id.insert)[0];
        if (rd == null)
          return ed;
        if (td.insertAt(ed, rd, id.insert[rd]), td.scroll.query(rd, Scope.INLINE) != null) {
          const [nd] = td.descendant(LeafBlot$1, ed), cd = bubbleFormats(nd);
          ad = DeltaExports.AttributeMap.diff(cd, ad) || {};
        }
      }
    }
    return Object.keys(ad).forEach((rd) => {
      td.formatAt(ed, od, rd, ad[rd]);
    }), ed + od;
  }, Ae);
}
const config$2 = {
  scope: Scope.BLOCK,
  whitelist: ["right", "center", "justify"]
}, AlignAttribute = new Attributor("align", "align", config$2), AlignClass = new ClassAttributor$1("align", "ql-align", config$2), AlignStyle = new StyleAttributor$1("align", "text-align", config$2);
class ColorAttributor extends StyleAttributor$1 {
  value(Ae) {
    let xr = super.value(Ae);
    return xr.startsWith("rgb(") ? (xr = xr.replace(/^[^\d]+/, "").replace(/[^\d]+$/, ""), `#${xr.split(",").map((id) => `00${parseInt(id, 10).toString(16)}`.slice(-2)).join("")}`) : xr;
  }
}
const ColorClass = new ClassAttributor$1("color", "ql-color", {
  scope: Scope.INLINE
}), ColorStyle = new ColorAttributor("color", "color", {
  scope: Scope.INLINE
}), BackgroundClass = new ClassAttributor$1("background", "ql-bg", {
  scope: Scope.INLINE
}), BackgroundStyle = new ColorAttributor("background", "background-color", {
  scope: Scope.INLINE
});
class CodeBlockContainer extends Container$8 {
  static create(Ae) {
    const xr = super.create(Ae);
    return xr.setAttribute("spellcheck", "false"), xr;
  }
  code(Ae, xr) {
    return this.children.map((ed) => ed.length() <= 1 ? "" : ed.domNode.innerText).join(`
`).slice(Ae, Ae + xr);
  }
  html(Ae, xr) {
    return `<pre>
${escapeText(this.code(Ae, xr))}
</pre>`;
  }
}
class CodeBlock extends Block {
  static register() {
    Quill.register(CodeBlockContainer);
  }
}
_d(CodeBlock, "TAB", "  ");
class Code extends Inline {
}
Code.blotName = "code";
Code.tagName = "CODE";
CodeBlock.blotName = "code-block";
CodeBlock.className = "ql-code-block";
CodeBlock.tagName = "DIV";
CodeBlockContainer.blotName = "code-block-container";
CodeBlockContainer.className = "ql-code-block-container";
CodeBlockContainer.tagName = "DIV";
CodeBlockContainer.allowedChildren = [CodeBlock];
CodeBlock.allowedChildren = [Text$2, Break, Cursor];
CodeBlock.requiredContainer = CodeBlockContainer;
const config$1 = {
  scope: Scope.BLOCK,
  whitelist: ["rtl"]
}, DirectionAttribute = new Attributor("direction", "dir", config$1), DirectionClass = new ClassAttributor$1("direction", "ql-direction", config$1), DirectionStyle = new StyleAttributor$1("direction", "direction", config$1), config = {
  scope: Scope.INLINE,
  whitelist: ["serif", "monospace"]
}, FontClass = new ClassAttributor$1("font", "ql-font", config);
class FontStyleAttributor extends StyleAttributor$1 {
  value(Ae) {
    return super.value(Ae).replace(/["']/g, "");
  }
}
const FontStyle = new FontStyleAttributor("font", "font-family", config), SizeClass = new ClassAttributor$1("size", "ql-size", {
  scope: Scope.INLINE,
  whitelist: ["small", "large", "huge"]
}), SizeStyle = new StyleAttributor$1("size", "font-size", {
  scope: Scope.INLINE,
  whitelist: ["10px", "18px", "32px"]
}), debug$2 = namespace("quill:keyboard"), SHORTKEY = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
class Keyboard extends Module {
  static match(Ae, xr) {
    return ["altKey", "ctrlKey", "metaKey", "shiftKey"].some((ed) => !!xr[ed] !== Ae[ed] && xr[ed] !== null) ? !1 : xr.key === Ae.key || xr.key === Ae.which;
  }
  constructor(Ae, xr) {
    super(Ae, xr), this.bindings = {}, Object.keys(this.options.bindings).forEach((ed) => {
      this.options.bindings[ed] && this.addBinding(this.options.bindings[ed]);
    }), this.addBinding({
      key: "Enter",
      shiftKey: null
    }, this.handleEnter), this.addBinding({
      key: "Enter",
      metaKey: null,
      ctrlKey: null,
      altKey: null
    }, () => {
    }), /Firefox/i.test(navigator.userAgent) ? (this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !0
    }, this.handleBackspace), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !0
    }, this.handleDelete)) : (this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !0,
      prefix: /^.?$/
    }, this.handleBackspace), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !0,
      suffix: /^.?$/
    }, this.handleDelete)), this.addBinding({
      key: "Backspace"
    }, {
      collapsed: !1
    }, this.handleDeleteRange), this.addBinding({
      key: "Delete"
    }, {
      collapsed: !1
    }, this.handleDeleteRange), this.addBinding({
      key: "Backspace",
      altKey: null,
      ctrlKey: null,
      metaKey: null,
      shiftKey: null
    }, {
      collapsed: !0,
      offset: 0
    }, this.handleBackspace), this.listen();
  }
  addBinding(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const id = normalize$2(Ae);
    if (id == null) {
      debug$2.warn("Attempted to add invalid keyboard binding", id);
      return;
    }
    typeof xr == "function" && (xr = {
      handler: xr
    }), typeof ed == "function" && (ed = {
      handler: ed
    }), (Array.isArray(id.key) ? id.key : [id.key]).forEach((ad) => {
      const rd = {
        ...id,
        key: ad,
        ...xr,
        ...ed
      };
      this.bindings[rd.key] = this.bindings[rd.key] || [], this.bindings[rd.key].push(rd);
    });
  }
  listen() {
    this.quill.root.addEventListener("keydown", (Ae) => {
      if (Ae.defaultPrevented || Ae.isComposing || Ae.keyCode === 229 && (Ae.key === "Enter" || Ae.key === "Backspace"))
        return;
      const id = (this.bindings[Ae.key] || []).concat(this.bindings[Ae.which] || []).filter((bd) => Keyboard.match(Ae, bd));
      if (id.length === 0)
        return;
      const od = Quill.find(Ae.target, !0);
      if (od && od.scroll !== this.quill.scroll)
        return;
      const ad = this.quill.getSelection();
      if (ad == null || !this.quill.hasFocus())
        return;
      const [rd, sd] = this.quill.getLine(ad.index), [nd, cd] = this.quill.getLeaf(ad.index), [ud, ld] = ad.length === 0 ? [nd, cd] : this.quill.getLeaf(ad.index + ad.length), dd = nd instanceof TextBlot$1 ? nd.value().slice(0, cd) : "", pd = ud instanceof TextBlot$1 ? ud.value().slice(ld) : "", md = {
        collapsed: ad.length === 0,
        // @ts-expect-error Fix me later
        empty: ad.length === 0 && rd.length() <= 1,
        format: this.quill.getFormat(ad),
        line: rd,
        offset: sd,
        prefix: dd,
        suffix: pd,
        event: Ae
      };
      id.some((bd) => {
        if (bd.collapsed != null && bd.collapsed !== md.collapsed || bd.empty != null && bd.empty !== md.empty || bd.offset != null && bd.offset !== md.offset)
          return !1;
        if (Array.isArray(bd.format)) {
          if (bd.format.every((Sd) => md.format[Sd] == null))
            return !1;
        } else if (typeof bd.format == "object" && !Object.keys(bd.format).every((Sd) => bd.format[Sd] === !0 ? md.format[Sd] != null : bd.format[Sd] === !1 ? md.format[Sd] == null : isEqual$2(bd.format[Sd], md.format[Sd])))
          return !1;
        return bd.prefix != null && !bd.prefix.test(md.prefix) || bd.suffix != null && !bd.suffix.test(md.suffix) ? !1 : bd.handler.call(this, ad, md, bd) !== !0;
      }) && Ae.preventDefault();
    });
  }
  handleBackspace(Ae, xr) {
    const ed = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(xr.prefix) ? 2 : 1;
    if (Ae.index === 0 || this.quill.getLength() <= 1)
      return;
    let id = {};
    const [od] = this.quill.getLine(Ae.index);
    let ad = new Delta().retain(Ae.index - ed).delete(ed);
    if (xr.offset === 0) {
      const [rd] = this.quill.getLine(Ae.index - 1);
      if (rd && !(rd.statics.blotName === "block" && rd.length() <= 1)) {
        const nd = od.formats(), cd = this.quill.getFormat(Ae.index - 1, 1);
        if (id = DeltaExports.AttributeMap.diff(nd, cd) || {}, Object.keys(id).length > 0) {
          const ud = new Delta().retain(Ae.index + od.length() - 2).retain(1, id);
          ad = ad.compose(ud);
        }
      }
    }
    this.quill.updateContents(ad, Quill.sources.USER), this.quill.focus();
  }
  handleDelete(Ae, xr) {
    const ed = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(xr.suffix) ? 2 : 1;
    if (Ae.index >= this.quill.getLength() - ed)
      return;
    let id = {};
    const [od] = this.quill.getLine(Ae.index);
    let ad = new Delta().retain(Ae.index).delete(ed);
    if (xr.offset >= od.length() - 1) {
      const [rd] = this.quill.getLine(Ae.index + 1);
      if (rd) {
        const sd = od.formats(), nd = this.quill.getFormat(Ae.index, 1);
        id = DeltaExports.AttributeMap.diff(sd, nd) || {}, Object.keys(id).length > 0 && (ad = ad.retain(rd.length() - 1).retain(1, id));
      }
    }
    this.quill.updateContents(ad, Quill.sources.USER), this.quill.focus();
  }
  handleDeleteRange(Ae) {
    deleteRange({
      range: Ae,
      quill: this.quill
    }), this.quill.focus();
  }
  handleEnter(Ae, xr) {
    const ed = Object.keys(xr.format).reduce((od, ad) => (this.quill.scroll.query(ad, Scope.BLOCK) && !Array.isArray(xr.format[ad]) && (od[ad] = xr.format[ad]), od), {}), id = new Delta().retain(Ae.index).delete(Ae.length).insert(`
`, ed);
    this.quill.updateContents(id, Quill.sources.USER), this.quill.setSelection(Ae.index + 1, Quill.sources.SILENT), this.quill.focus();
  }
}
const defaultOptions = {
  bindings: {
    bold: makeFormatHandler("bold"),
    italic: makeFormatHandler("italic"),
    underline: makeFormatHandler("underline"),
    indent: {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: "Tab",
      format: ["blockquote", "indent", "list"],
      handler(td, Ae) {
        return Ae.collapsed && Ae.offset !== 0 ? !0 : (this.quill.format("indent", "+1", Quill.sources.USER), !1);
      }
    },
    outdent: {
      key: "Tab",
      shiftKey: !0,
      format: ["blockquote", "indent", "list"],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler(td, Ae) {
        return Ae.collapsed && Ae.offset !== 0 ? !0 : (this.quill.format("indent", "-1", Quill.sources.USER), !1);
      }
    },
    "outdent backspace": {
      key: "Backspace",
      collapsed: !0,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ["indent", "list"],
      offset: 0,
      handler(td, Ae) {
        Ae.format.indent != null ? this.quill.format("indent", "-1", Quill.sources.USER) : Ae.format.list != null && this.quill.format("list", !1, Quill.sources.USER);
      }
    },
    "indent code-block": makeCodeBlockHandler(!0),
    "outdent code-block": makeCodeBlockHandler(!1),
    "remove tab": {
      key: "Tab",
      shiftKey: !0,
      collapsed: !0,
      prefix: /\t$/,
      handler(td) {
        this.quill.deleteText(td.index - 1, 1, Quill.sources.USER);
      }
    },
    tab: {
      key: "Tab",
      handler(td, Ae) {
        if (Ae.format.table)
          return !0;
        this.quill.history.cutoff();
        const xr = new Delta().retain(td.index).delete(td.length).insert("	");
        return this.quill.updateContents(xr, Quill.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(td.index + 1, Quill.sources.SILENT), !1;
      }
    },
    "blockquote empty enter": {
      key: "Enter",
      collapsed: !0,
      format: ["blockquote"],
      empty: !0,
      handler() {
        this.quill.format("blockquote", !1, Quill.sources.USER);
      }
    },
    "list empty enter": {
      key: "Enter",
      collapsed: !0,
      format: ["list"],
      empty: !0,
      handler(td, Ae) {
        const xr = {
          list: !1
        };
        Ae.format.indent && (xr.indent = !1), this.quill.formatLine(td.index, td.length, xr, Quill.sources.USER);
      }
    },
    "checklist enter": {
      key: "Enter",
      collapsed: !0,
      format: {
        list: "checked"
      },
      handler(td) {
        const [Ae, xr] = this.quill.getLine(td.index), ed = {
          // @ts-expect-error Fix me later
          ...Ae.formats(),
          list: "checked"
        }, id = new Delta().retain(td.index).insert(`
`, ed).retain(Ae.length() - xr - 1).retain(1, {
          list: "unchecked"
        });
        this.quill.updateContents(id, Quill.sources.USER), this.quill.setSelection(td.index + 1, Quill.sources.SILENT), this.quill.scrollSelectionIntoView();
      }
    },
    "header enter": {
      key: "Enter",
      collapsed: !0,
      format: ["header"],
      suffix: /^$/,
      handler(td, Ae) {
        const [xr, ed] = this.quill.getLine(td.index), id = new Delta().retain(td.index).insert(`
`, Ae.format).retain(xr.length() - ed - 1).retain(1, {
          header: null
        });
        this.quill.updateContents(id, Quill.sources.USER), this.quill.setSelection(td.index + 1, Quill.sources.SILENT), this.quill.scrollSelectionIntoView();
      }
    },
    "table backspace": {
      key: "Backspace",
      format: ["table"],
      collapsed: !0,
      offset: 0,
      handler() {
      }
    },
    "table delete": {
      key: "Delete",
      format: ["table"],
      collapsed: !0,
      suffix: /^$/,
      handler() {
      }
    },
    "table enter": {
      key: "Enter",
      shiftKey: null,
      format: ["table"],
      handler(td) {
        const Ae = this.quill.getModule("table");
        if (Ae) {
          const [xr, ed, id, od] = Ae.getTable(td), ad = tableSide(xr, ed, id, od);
          if (ad == null)
            return;
          let rd = xr.offset();
          if (ad < 0) {
            const sd = new Delta().retain(rd).insert(`
`);
            this.quill.updateContents(sd, Quill.sources.USER), this.quill.setSelection(td.index + 1, td.length, Quill.sources.SILENT);
          } else if (ad > 0) {
            rd += xr.length();
            const sd = new Delta().retain(rd).insert(`
`);
            this.quill.updateContents(sd, Quill.sources.USER), this.quill.setSelection(rd, Quill.sources.USER);
          }
        }
      }
    },
    "table tab": {
      key: "Tab",
      shiftKey: null,
      format: ["table"],
      handler(td, Ae) {
        const {
          event: xr,
          line: ed
        } = Ae, id = ed.offset(this.quill.scroll);
        xr.shiftKey ? this.quill.setSelection(id - 1, Quill.sources.USER) : this.quill.setSelection(id + ed.length(), Quill.sources.USER);
      }
    },
    "list autofill": {
      key: " ",
      shiftKey: null,
      collapsed: !0,
      format: {
        "code-block": !1,
        blockquote: !1,
        table: !1
      },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler(td, Ae) {
        if (this.quill.scroll.query("list") == null)
          return !0;
        const {
          length: xr
        } = Ae.prefix, [ed, id] = this.quill.getLine(td.index);
        if (id > xr)
          return !0;
        let od;
        switch (Ae.prefix.trim()) {
          case "[]":
          case "[ ]":
            od = "unchecked";
            break;
          case "[x]":
            od = "checked";
            break;
          case "-":
          case "*":
            od = "bullet";
            break;
          default:
            od = "ordered";
        }
        this.quill.insertText(td.index, " ", Quill.sources.USER), this.quill.history.cutoff();
        const ad = new Delta().retain(td.index - id).delete(xr + 1).retain(ed.length() - 2 - id).retain(1, {
          list: od
        });
        return this.quill.updateContents(ad, Quill.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(td.index - xr, Quill.sources.SILENT), !1;
      }
    },
    "code exit": {
      key: "Enter",
      collapsed: !0,
      format: ["code-block"],
      prefix: /^$/,
      suffix: /^\s*$/,
      handler(td) {
        const [Ae, xr] = this.quill.getLine(td.index);
        let ed = 2, id = Ae;
        for (; id != null && id.length() <= 1 && id.formats()["code-block"]; )
          if (id = id.prev, ed -= 1, ed <= 0) {
            const od = new Delta().retain(td.index + Ae.length() - xr - 2).retain(1, {
              "code-block": null
            }).delete(1);
            return this.quill.updateContents(od, Quill.sources.USER), this.quill.setSelection(td.index - 1, Quill.sources.SILENT), !1;
          }
        return !0;
      }
    },
    "embed left": makeEmbedArrowHandler("ArrowLeft", !1),
    "embed left shift": makeEmbedArrowHandler("ArrowLeft", !0),
    "embed right": makeEmbedArrowHandler("ArrowRight", !1),
    "embed right shift": makeEmbedArrowHandler("ArrowRight", !0),
    "table down": makeTableArrowHandler(!1),
    "table up": makeTableArrowHandler(!0)
  }
};
Keyboard.DEFAULTS = defaultOptions;
function makeCodeBlockHandler(td) {
  return {
    key: "Tab",
    shiftKey: !td,
    format: {
      "code-block": !0
    },
    handler(Ae, xr) {
      let {
        event: ed
      } = xr;
      const id = this.quill.scroll.query("code-block"), {
        TAB: od
      } = id;
      if (Ae.length === 0 && !ed.shiftKey) {
        this.quill.insertText(Ae.index, od, Quill.sources.USER), this.quill.setSelection(Ae.index + od.length, Quill.sources.SILENT);
        return;
      }
      const ad = Ae.length === 0 ? this.quill.getLines(Ae.index, 1) : this.quill.getLines(Ae);
      let {
        index: rd,
        length: sd
      } = Ae;
      ad.forEach((nd, cd) => {
        td ? (nd.insertAt(0, od), cd === 0 ? rd += od.length : sd += od.length) : nd.domNode.textContent.startsWith(od) && (nd.deleteAt(0, od.length), cd === 0 ? rd -= od.length : sd -= od.length);
      }), this.quill.update(Quill.sources.USER), this.quill.setSelection(rd, sd, Quill.sources.SILENT);
    }
  };
}
function makeEmbedArrowHandler(td, Ae) {
  return {
    key: td,
    shiftKey: Ae,
    altKey: null,
    [td === "ArrowLeft" ? "prefix" : "suffix"]: /^$/,
    handler(ed) {
      let {
        index: id
      } = ed;
      td === "ArrowRight" && (id += ed.length + 1);
      const [od] = this.quill.getLeaf(id);
      return od instanceof EmbedBlot$1 ? (td === "ArrowLeft" ? Ae ? this.quill.setSelection(ed.index - 1, ed.length + 1, Quill.sources.USER) : this.quill.setSelection(ed.index - 1, Quill.sources.USER) : Ae ? this.quill.setSelection(ed.index, ed.length + 1, Quill.sources.USER) : this.quill.setSelection(ed.index + ed.length + 1, Quill.sources.USER), !1) : !0;
    }
  };
}
function makeFormatHandler(td) {
  return {
    key: td[0],
    shortKey: !0,
    handler(Ae, xr) {
      this.quill.format(td, !xr.format[td], Quill.sources.USER);
    }
  };
}
function makeTableArrowHandler(td) {
  return {
    key: td ? "ArrowUp" : "ArrowDown",
    collapsed: !0,
    format: ["table"],
    handler(Ae, xr) {
      const ed = td ? "prev" : "next", id = xr.line, od = id.parent[ed];
      if (od != null) {
        if (od.statics.blotName === "table-row") {
          let ad = od.children.head, rd = id;
          for (; rd.prev != null; )
            rd = rd.prev, ad = ad.next;
          const sd = ad.offset(this.quill.scroll) + Math.min(xr.offset, ad.length() - 1);
          this.quill.setSelection(sd, 0, Quill.sources.USER);
        }
      } else {
        const ad = id.table()[ed];
        ad != null && (td ? this.quill.setSelection(ad.offset(this.quill.scroll) + ad.length() - 1, 0, Quill.sources.USER) : this.quill.setSelection(ad.offset(this.quill.scroll), 0, Quill.sources.USER));
      }
      return !1;
    }
  };
}
function normalize$2(td) {
  if (typeof td == "string" || typeof td == "number")
    td = {
      key: td
    };
  else if (typeof td == "object")
    td = cloneDeep$1(td);
  else
    return null;
  return td.shortKey && (td[SHORTKEY] = td.shortKey, delete td.shortKey), td;
}
function deleteRange(td) {
  let {
    quill: Ae,
    range: xr
  } = td;
  const ed = Ae.getLines(xr);
  let id = {};
  if (ed.length > 1) {
    const od = ed[0].formats(), ad = ed[ed.length - 1].formats();
    id = DeltaExports.AttributeMap.diff(ad, od) || {};
  }
  Ae.deleteText(xr, Quill.sources.USER), Object.keys(id).length > 0 && Ae.formatLine(xr.index, 1, id, Quill.sources.USER), Ae.setSelection(xr.index, Quill.sources.SILENT);
}
function tableSide(td, Ae, xr, ed) {
  return Ae.prev == null && Ae.next == null ? xr.prev == null && xr.next == null ? ed === 0 ? -1 : 1 : xr.prev == null ? -1 : 1 : Ae.prev == null ? -1 : Ae.next == null ? 1 : null;
}
const normalWeightRegexp = /font-weight:\s*normal/, blockTagNames = ["P", "OL", "UL"], isBlockElement = (td) => td && blockTagNames.includes(td.tagName), normalizeEmptyLines = (td) => {
  Array.from(td.querySelectorAll("br")).filter((Ae) => isBlockElement(Ae.previousElementSibling) && isBlockElement(Ae.nextElementSibling)).forEach((Ae) => {
    var xr;
    (xr = Ae.parentNode) == null || xr.removeChild(Ae);
  });
}, normalizeFontWeight = (td) => {
  Array.from(td.querySelectorAll('b[style*="font-weight"]')).filter((Ae) => {
    var xr;
    return (xr = Ae.getAttribute("style")) == null ? void 0 : xr.match(normalWeightRegexp);
  }).forEach((Ae) => {
    var ed;
    const xr = td.createDocumentFragment();
    xr.append(...Ae.childNodes), (ed = Ae.parentNode) == null || ed.replaceChild(xr, Ae);
  });
};
function normalize$1(td) {
  td.querySelector('[id^="docs-internal-guid-"]') && (normalizeFontWeight(td), normalizeEmptyLines(td));
}
const ignoreRegexp = /\bmso-list:[^;]*ignore/i, idRegexp = /\bmso-list:[^;]*\bl(\d+)/i, indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i, parseListItem = (td, Ae) => {
  const xr = td.getAttribute("style"), ed = xr == null ? void 0 : xr.match(idRegexp);
  if (!ed)
    return null;
  const id = Number(ed[1]), od = xr == null ? void 0 : xr.match(indentRegexp), ad = od ? Number(od[1]) : 1, rd = new RegExp(`@list l${id}:level${ad}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, "i"), sd = Ae.match(rd), nd = sd && sd[1] === "bullet" ? "bullet" : "ordered";
  return {
    id,
    indent: ad,
    type: nd,
    element: td
  };
}, normalizeListItem = (td) => {
  var ad, rd;
  const Ae = Array.from(td.querySelectorAll("[style*=mso-list]")), xr = [], ed = [];
  Ae.forEach((sd) => {
    (sd.getAttribute("style") || "").match(ignoreRegexp) ? xr.push(sd) : ed.push(sd);
  }), xr.forEach((sd) => {
    var nd;
    return (nd = sd.parentNode) == null ? void 0 : nd.removeChild(sd);
  });
  const id = td.documentElement.innerHTML, od = ed.map((sd) => parseListItem(sd, id)).filter((sd) => sd);
  for (; od.length; ) {
    const sd = [];
    let nd = od.shift();
    for (; nd; )
      sd.push(nd), nd = od.length && ((ad = od[0]) == null ? void 0 : ad.element) === nd.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
      od[0].id === nd.id ? od.shift() : null;
    const cd = document.createElement("ul");
    sd.forEach((dd) => {
      const pd = document.createElement("li");
      pd.setAttribute("data-list", dd.type), dd.indent > 1 && pd.setAttribute("class", `ql-indent-${dd.indent - 1}`), pd.innerHTML = dd.element.innerHTML, cd.appendChild(pd);
    });
    const ud = (rd = sd[0]) == null ? void 0 : rd.element, {
      parentNode: ld
    } = ud != null ? ud : {};
    ud && (ld == null || ld.replaceChild(cd, ud)), sd.slice(1).forEach((dd) => {
      let {
        element: pd
      } = dd;
      ld == null || ld.removeChild(pd);
    });
  }
};
function normalize(td) {
  td.documentElement.getAttribute("xmlns:w") === "urn:schemas-microsoft-com:office:word" && normalizeListItem(td);
}
const NORMALIZERS = [normalize, normalize$1], normalizeExternalHTML = (td) => {
  td.documentElement && NORMALIZERS.forEach((Ae) => {
    Ae(td);
  });
}, debug$1 = namespace("quill:clipboard"), CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ["br", matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ["li", matchIndent], ["ol, ul", matchList], ["pre", matchCodeBlock], ["tr", matchTable], ["b", createMatchAlias("bold")], ["i", createMatchAlias("italic")], ["strike", createMatchAlias("strike")], ["style", matchIgnore]], ATTRIBUTE_ATTRIBUTORS = [AlignAttribute, DirectionAttribute].reduce((td, Ae) => (td[Ae.keyName] = Ae, td), {}), STYLE_ATTRIBUTORS = [AlignStyle, BackgroundStyle, ColorStyle, DirectionStyle, FontStyle, SizeStyle].reduce((td, Ae) => (td[Ae.keyName] = Ae, td), {});
class Clipboard extends Module {
  constructor(Ae, xr) {
    var ed;
    super(Ae, xr), this.quill.root.addEventListener("copy", (id) => this.onCaptureCopy(id, !1)), this.quill.root.addEventListener("cut", (id) => this.onCaptureCopy(id, !0)), this.quill.root.addEventListener("paste", this.onCapturePaste.bind(this)), this.matchers = [], CLIPBOARD_CONFIG.concat((ed = this.options.matchers) != null ? ed : []).forEach((id) => {
      let [od, ad] = id;
      this.addMatcher(od, ad);
    });
  }
  addMatcher(Ae, xr) {
    this.matchers.push([Ae, xr]);
  }
  convert(Ae) {
    let {
      html: xr,
      text: ed
    } = Ae, id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (id[CodeBlock.blotName])
      return new Delta().insert(ed || "", {
        [CodeBlock.blotName]: id[CodeBlock.blotName]
      });
    if (!xr)
      return new Delta().insert(ed || "", id);
    const od = this.convertHTML(xr);
    return deltaEndsWith(od, `
`) && (od.ops[od.ops.length - 1].attributes == null || id.table) ? od.compose(new Delta().retain(od.length() - 1).delete(1)) : od;
  }
  normalizeHTML(Ae) {
    normalizeExternalHTML(Ae);
  }
  convertHTML(Ae) {
    const xr = new DOMParser().parseFromString(Ae, "text/html");
    this.normalizeHTML(xr);
    const ed = xr.body, id = /* @__PURE__ */ new WeakMap(), [od, ad] = this.prepareMatching(ed, id);
    return traverse(this.quill.scroll, ed, od, ad, id);
  }
  dangerouslyPasteHTML(Ae, xr) {
    let ed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Quill.sources.API;
    if (typeof Ae == "string") {
      const id = this.convert({
        html: Ae,
        text: ""
      });
      this.quill.setContents(id, xr), this.quill.setSelection(0, Quill.sources.SILENT);
    } else {
      const id = this.convert({
        html: xr,
        text: ""
      });
      this.quill.updateContents(new Delta().retain(Ae).concat(id), ed), this.quill.setSelection(Ae + id.length(), Quill.sources.SILENT);
    }
  }
  onCaptureCopy(Ae) {
    var ad, rd;
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (Ae.defaultPrevented)
      return;
    Ae.preventDefault();
    const [ed] = this.quill.selection.getRange();
    if (ed == null)
      return;
    const {
      html: id,
      text: od
    } = this.onCopy(ed, xr);
    (ad = Ae.clipboardData) == null || ad.setData("text/plain", od), (rd = Ae.clipboardData) == null || rd.setData("text/html", id), xr && deleteRange({
      range: ed,
      quill: this.quill
    });
  }
  /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */
  normalizeURIList(Ae) {
    return Ae.split(/\r?\n/).filter((xr) => xr[0] !== "#").join(`
`);
  }
  onCapturePaste(Ae) {
    var ad, rd, sd, nd, cd;
    if (Ae.defaultPrevented || !this.quill.isEnabled())
      return;
    Ae.preventDefault();
    const xr = this.quill.getSelection(!0);
    if (xr == null)
      return;
    const ed = (ad = Ae.clipboardData) == null ? void 0 : ad.getData("text/html");
    let id = (rd = Ae.clipboardData) == null ? void 0 : rd.getData("text/plain");
    if (!ed && !id) {
      const ud = (sd = Ae.clipboardData) == null ? void 0 : sd.getData("text/uri-list");
      ud && (id = this.normalizeURIList(ud));
    }
    const od = Array.from(((nd = Ae.clipboardData) == null ? void 0 : nd.files) || []);
    if (!ed && od.length > 0) {
      this.quill.uploader.upload(xr, od);
      return;
    }
    if (ed && od.length > 0) {
      const ud = new DOMParser().parseFromString(ed, "text/html");
      if (ud.body.childElementCount === 1 && ((cd = ud.body.firstElementChild) == null ? void 0 : cd.tagName) === "IMG") {
        this.quill.uploader.upload(xr, od);
        return;
      }
    }
    this.onPaste(xr, {
      html: ed,
      text: id
    });
  }
  onCopy(Ae) {
    const xr = this.quill.getText(Ae);
    return {
      html: this.quill.getSemanticHTML(Ae),
      text: xr
    };
  }
  onPaste(Ae, xr) {
    let {
      text: ed,
      html: id
    } = xr;
    const od = this.quill.getFormat(Ae.index), ad = this.convert({
      text: ed,
      html: id
    }, od);
    debug$1.log("onPaste", ad, {
      text: ed,
      html: id
    });
    const rd = new Delta().retain(Ae.index).delete(Ae.length).concat(ad);
    this.quill.updateContents(rd, Quill.sources.USER), this.quill.setSelection(rd.length() - Ae.length, Quill.sources.SILENT), this.quill.scrollSelectionIntoView();
  }
  prepareMatching(Ae, xr) {
    const ed = [], id = [];
    return this.matchers.forEach((od) => {
      const [ad, rd] = od;
      switch (ad) {
        case Node.TEXT_NODE:
          id.push(rd);
          break;
        case Node.ELEMENT_NODE:
          ed.push(rd);
          break;
        default:
          Array.from(Ae.querySelectorAll(ad)).forEach((sd) => {
            if (xr.has(sd)) {
              const nd = xr.get(sd);
              nd == null || nd.push(rd);
            } else
              xr.set(sd, [rd]);
          });
          break;
      }
    }), [ed, id];
  }
}
_d(Clipboard, "DEFAULTS", {
  matchers: []
});
function applyFormat(td, Ae, xr, ed) {
  return ed.query(Ae) ? td.reduce((id, od) => {
    if (!od.insert)
      return id;
    if (od.attributes && od.attributes[Ae])
      return id.push(od);
    const ad = xr ? {
      [Ae]: xr
    } : {};
    return id.insert(od.insert, {
      ...ad,
      ...od.attributes
    });
  }, new Delta()) : td;
}
function deltaEndsWith(td, Ae) {
  let xr = "";
  for (let ed = td.ops.length - 1; ed >= 0 && xr.length < Ae.length; --ed) {
    const id = td.ops[ed];
    if (typeof id.insert != "string")
      break;
    xr = id.insert + xr;
  }
  return xr.slice(-1 * Ae.length) === Ae;
}
function isLine(td, Ae) {
  if (!(td instanceof Element))
    return !1;
  const xr = Ae.query(td);
  return xr && xr.prototype instanceof EmbedBlot$1 ? !1 : ["address", "article", "blockquote", "canvas", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "iframe", "li", "main", "nav", "ol", "output", "p", "pre", "section", "table", "td", "tr", "ul", "video"].includes(td.tagName.toLowerCase());
}
function isBetweenInlineElements(td, Ae) {
  return td.previousElementSibling && td.nextElementSibling && !isLine(td.previousElementSibling, Ae) && !isLine(td.nextElementSibling, Ae);
}
const preNodes = /* @__PURE__ */ new WeakMap();
function isPre(td) {
  return td == null ? !1 : (preNodes.has(td) || (td.tagName === "PRE" ? preNodes.set(td, !0) : preNodes.set(td, isPre(td.parentNode))), preNodes.get(td));
}
function traverse(td, Ae, xr, ed, id) {
  return Ae.nodeType === Ae.TEXT_NODE ? ed.reduce((od, ad) => ad(Ae, od, td), new Delta()) : Ae.nodeType === Ae.ELEMENT_NODE ? Array.from(Ae.childNodes || []).reduce((od, ad) => {
    let rd = traverse(td, ad, xr, ed, id);
    return ad.nodeType === Ae.ELEMENT_NODE && (rd = xr.reduce((sd, nd) => nd(ad, sd, td), rd), rd = (id.get(ad) || []).reduce((sd, nd) => nd(ad, sd, td), rd)), od.concat(rd);
  }, new Delta()) : new Delta();
}
function createMatchAlias(td) {
  return (Ae, xr, ed) => applyFormat(xr, td, !0, ed);
}
function matchAttributor(td, Ae, xr) {
  const ed = Attributor.keys(td), id = ClassAttributor$1.keys(td), od = StyleAttributor$1.keys(td), ad = {};
  return ed.concat(id).concat(od).forEach((rd) => {
    let sd = xr.query(rd, Scope.ATTRIBUTE);
    sd != null && (ad[sd.attrName] = sd.value(td), ad[sd.attrName]) || (sd = ATTRIBUTE_ATTRIBUTORS[rd], sd != null && (sd.attrName === rd || sd.keyName === rd) && (ad[sd.attrName] = sd.value(td) || void 0), sd = STYLE_ATTRIBUTORS[rd], sd != null && (sd.attrName === rd || sd.keyName === rd) && (sd = STYLE_ATTRIBUTORS[rd], ad[sd.attrName] = sd.value(td) || void 0));
  }), Object.entries(ad).reduce((rd, sd) => {
    let [nd, cd] = sd;
    return applyFormat(rd, nd, cd, xr);
  }, Ae);
}
function matchBlot(td, Ae, xr) {
  const ed = xr.query(td);
  if (ed == null)
    return Ae;
  if (ed.prototype instanceof EmbedBlot$1) {
    const id = {}, od = ed.value(td);
    if (od != null)
      return id[ed.blotName] = od, new Delta().insert(id, ed.formats(td, xr));
  } else if (ed.prototype instanceof BlockBlot$1 && !deltaEndsWith(Ae, `
`) && Ae.insert(`
`), "blotName" in ed && "formats" in ed && typeof ed.formats == "function")
    return applyFormat(Ae, ed.blotName, ed.formats(td, xr), xr);
  return Ae;
}
function matchBreak(td, Ae) {
  return deltaEndsWith(Ae, `
`) || Ae.insert(`
`), Ae;
}
function matchCodeBlock(td, Ae, xr) {
  const ed = xr.query("code-block"), id = ed && "formats" in ed && typeof ed.formats == "function" ? ed.formats(td, xr) : !0;
  return applyFormat(Ae, "code-block", id, xr);
}
function matchIgnore() {
  return new Delta();
}
function matchIndent(td, Ae, xr) {
  const ed = xr.query(td);
  if (ed == null || // @ts-expect-error
  ed.blotName !== "list" || !deltaEndsWith(Ae, `
`))
    return Ae;
  let id = -1, od = td.parentNode;
  for (; od != null; )
    ["OL", "UL"].includes(od.tagName) && (id += 1), od = od.parentNode;
  return id <= 0 ? Ae : Ae.reduce((ad, rd) => rd.insert ? rd.attributes && typeof rd.attributes.indent == "number" ? ad.push(rd) : ad.insert(rd.insert, {
    indent: id,
    ...rd.attributes || {}
  }) : ad, new Delta());
}
function matchList(td, Ae, xr) {
  const ed = td;
  let id = ed.tagName === "OL" ? "ordered" : "bullet";
  const od = ed.getAttribute("data-checked");
  return od && (id = od === "true" ? "checked" : "unchecked"), applyFormat(Ae, "list", id, xr);
}
function matchNewline(td, Ae, xr) {
  if (!deltaEndsWith(Ae, `
`)) {
    if (isLine(td, xr) && (td.childNodes.length > 0 || td instanceof HTMLParagraphElement))
      return Ae.insert(`
`);
    if (Ae.length() > 0 && td.nextSibling) {
      let ed = td.nextSibling;
      for (; ed != null; ) {
        if (isLine(ed, xr))
          return Ae.insert(`
`);
        const id = xr.query(ed);
        if (id && id.prototype instanceof BlockEmbed)
          return Ae.insert(`
`);
        ed = ed.firstChild;
      }
    }
  }
  return Ae;
}
function matchStyles(td, Ae, xr) {
  var od;
  const ed = {}, id = td.style || {};
  return id.fontStyle === "italic" && (ed.italic = !0), id.textDecoration === "underline" && (ed.underline = !0), id.textDecoration === "line-through" && (ed.strike = !0), ((od = id.fontWeight) != null && od.startsWith("bold") || // @ts-expect-error Fix me later
  parseInt(id.fontWeight, 10) >= 700) && (ed.bold = !0), Ae = Object.entries(ed).reduce((ad, rd) => {
    let [sd, nd] = rd;
    return applyFormat(ad, sd, nd, xr);
  }, Ae), parseFloat(id.textIndent || 0) > 0 ? new Delta().insert("	").concat(Ae) : Ae;
}
function matchTable(td, Ae, xr) {
  var id, od;
  const ed = ((id = td.parentElement) == null ? void 0 : id.tagName) === "TABLE" ? td.parentElement : (od = td.parentElement) == null ? void 0 : od.parentElement;
  if (ed != null) {
    const rd = Array.from(ed.querySelectorAll("tr")).indexOf(td) + 1;
    return applyFormat(Ae, "table", rd, xr);
  }
  return Ae;
}
function matchText(td, Ae, xr) {
  var id;
  let ed = td.data;
  if (((id = td.parentElement) == null ? void 0 : id.tagName) === "O:P")
    return Ae.insert(ed.trim());
  if (!isPre(td)) {
    if (ed.trim().length === 0 && ed.includes(`
`) && !isBetweenInlineElements(td, xr))
      return Ae;
    const od = (ad, rd) => {
      const sd = rd.replace(/[^\u00a0]/g, "");
      return sd.length < 1 && ad ? " " : sd;
    };
    ed = ed.replace(/\r\n/g, " ").replace(/\n/g, " "), ed = ed.replace(/\s\s+/g, od.bind(od, !0)), (td.previousSibling == null && td.parentElement != null && isLine(td.parentElement, xr) || td.previousSibling instanceof Element && isLine(td.previousSibling, xr)) && (ed = ed.replace(/^\s+/, od.bind(od, !1))), (td.nextSibling == null && td.parentElement != null && isLine(td.parentElement, xr) || td.nextSibling instanceof Element && isLine(td.nextSibling, xr)) && (ed = ed.replace(/\s+$/, od.bind(od, !1)));
  }
  return Ae.insert(ed);
}
class History extends Module {
  constructor(xr, ed) {
    super(xr, ed);
    _d(this, "lastRecorded", 0);
    _d(this, "ignoreChange", !1);
    _d(this, "stack", {
      undo: [],
      redo: []
    });
    _d(this, "currentRange", null);
    this.quill.on(Quill.events.EDITOR_CHANGE, (id, od, ad, rd) => {
      id === Quill.events.SELECTION_CHANGE ? od && rd !== Quill.sources.SILENT && (this.currentRange = od) : id === Quill.events.TEXT_CHANGE && (this.ignoreChange || (!this.options.userOnly || rd === Quill.sources.USER ? this.record(od, ad) : this.transform(od)), this.currentRange = transformRange(this.currentRange, od));
    }), this.quill.keyboard.addBinding({
      key: "z",
      shortKey: !0
    }, this.undo.bind(this)), this.quill.keyboard.addBinding({
      key: ["z", "Z"],
      shortKey: !0,
      shiftKey: !0
    }, this.redo.bind(this)), /Win/i.test(navigator.platform) && this.quill.keyboard.addBinding({
      key: "y",
      shortKey: !0
    }, this.redo.bind(this)), this.quill.root.addEventListener("beforeinput", (id) => {
      id.inputType === "historyUndo" ? (this.undo(), id.preventDefault()) : id.inputType === "historyRedo" && (this.redo(), id.preventDefault());
    });
  }
  change(xr, ed) {
    if (this.stack[xr].length === 0)
      return;
    const id = this.stack[xr].pop();
    if (!id)
      return;
    const od = this.quill.getContents(), ad = id.delta.invert(od);
    this.stack[ed].push({
      delta: ad,
      range: transformRange(id.range, ad)
    }), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(id.delta, Quill.sources.USER), this.ignoreChange = !1, this.restoreSelection(id);
  }
  clear() {
    this.stack = {
      undo: [],
      redo: []
    };
  }
  cutoff() {
    this.lastRecorded = 0;
  }
  record(xr, ed) {
    if (xr.ops.length === 0)
      return;
    this.stack.redo = [];
    let id = xr.invert(ed), od = this.currentRange;
    const ad = Date.now();
    if (
      // @ts-expect-error Fix me later
      this.lastRecorded + this.options.delay > ad && this.stack.undo.length > 0
    ) {
      const rd = this.stack.undo.pop();
      rd && (id = id.compose(rd.delta), od = rd.range);
    } else
      this.lastRecorded = ad;
    id.length() !== 0 && (this.stack.undo.push({
      delta: id,
      range: od
    }), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift());
  }
  redo() {
    this.change("redo", "undo");
  }
  transform(xr) {
    transformStack(this.stack.undo, xr), transformStack(this.stack.redo, xr);
  }
  undo() {
    this.change("undo", "redo");
  }
  restoreSelection(xr) {
    if (xr.range)
      this.quill.setSelection(xr.range, Quill.sources.USER);
    else {
      const ed = getLastChangeIndex(this.quill.scroll, xr.delta);
      this.quill.setSelection(ed, Quill.sources.USER);
    }
  }
}
_d(History, "DEFAULTS", {
  delay: 1e3,
  maxStack: 100,
  userOnly: !1
});
function transformStack(td, Ae) {
  let xr = Ae;
  for (let ed = td.length - 1; ed >= 0; ed -= 1) {
    const id = td[ed];
    td[ed] = {
      delta: xr.transform(id.delta, !0),
      range: id.range && transformRange(id.range, xr)
    }, xr = id.delta.transform(xr), td[ed].delta.length() === 0 && td.splice(ed, 1);
  }
}
function endsWithNewlineChange(td, Ae) {
  const xr = Ae.ops[Ae.ops.length - 1];
  return xr == null ? !1 : xr.insert != null ? typeof xr.insert == "string" && xr.insert.endsWith(`
`) : xr.attributes != null ? Object.keys(xr.attributes).some((ed) => td.query(ed, Scope.BLOCK) != null) : !1;
}
function getLastChangeIndex(td, Ae) {
  const xr = Ae.reduce((id, od) => id + (od.delete || 0), 0);
  let ed = Ae.length() - xr;
  return endsWithNewlineChange(td, Ae) && (ed -= 1), ed;
}
function transformRange(td, Ae) {
  if (!td)
    return td;
  const xr = Ae.transformPosition(td.index), ed = Ae.transformPosition(td.index + td.length);
  return {
    index: xr,
    length: ed - xr
  };
}
class Uploader extends Module {
  constructor(Ae, xr) {
    super(Ae, xr), Ae.root.addEventListener("drop", (ed) => {
      var ad;
      ed.preventDefault();
      let id = null;
      if (document.caretRangeFromPoint)
        id = document.caretRangeFromPoint(ed.clientX, ed.clientY);
      else if (document.caretPositionFromPoint) {
        const rd = document.caretPositionFromPoint(ed.clientX, ed.clientY);
        id = document.createRange(), id.setStart(rd.offsetNode, rd.offset), id.setEnd(rd.offsetNode, rd.offset);
      }
      const od = id && Ae.selection.normalizeNative(id);
      if (od) {
        const rd = Ae.selection.normalizedToRange(od);
        (ad = ed.dataTransfer) != null && ad.files && this.upload(rd, ed.dataTransfer.files);
      }
    });
  }
  upload(Ae, xr) {
    const ed = [];
    Array.from(xr).forEach((id) => {
      var od;
      id && ((od = this.options.mimetypes) != null && od.includes(id.type)) && ed.push(id);
    }), ed.length > 0 && this.options.handler.call(this, Ae, ed);
  }
}
Uploader.DEFAULTS = {
  mimetypes: ["image/png", "image/jpeg"],
  handler(td, Ae) {
    if (!this.quill.scroll.query("image"))
      return;
    const xr = Ae.map((ed) => new Promise((id) => {
      const od = new FileReader();
      od.onload = () => {
        id(od.result);
      }, od.readAsDataURL(ed);
    }));
    Promise.all(xr).then((ed) => {
      const id = ed.reduce((od, ad) => od.insert({
        image: ad
      }), new Delta().retain(td.index).delete(td.length));
      this.quill.updateContents(id, Emitter.sources.USER), this.quill.setSelection(td.index + ed.length, Emitter.sources.SILENT);
    });
  }
};
const INSERT_TYPES = ["insertText", "insertReplacementText"];
let Input$5 = class extends Module {
  constructor(Ae, xr) {
    super(Ae, xr), Ae.root.addEventListener("beforeinput", (ed) => {
      this.handleBeforeInput(ed);
    }), /Android/i.test(navigator.userAgent) || Ae.on(Quill.events.COMPOSITION_BEFORE_START, () => {
      this.handleCompositionStart();
    });
  }
  deleteRange(Ae) {
    deleteRange({
      range: Ae,
      quill: this.quill
    });
  }
  replaceText(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (Ae.length === 0)
      return !1;
    if (xr) {
      const ed = this.quill.getFormat(Ae.index, 1);
      this.deleteRange(Ae), this.quill.updateContents(new Delta().retain(Ae.index).insert(xr, ed), Quill.sources.USER);
    } else
      this.deleteRange(Ae);
    return this.quill.setSelection(Ae.index + xr.length, 0, Quill.sources.SILENT), !0;
  }
  handleBeforeInput(Ae) {
    if (this.quill.composition.isComposing || Ae.defaultPrevented || !INSERT_TYPES.includes(Ae.inputType))
      return;
    const xr = Ae.getTargetRanges ? Ae.getTargetRanges()[0] : null;
    if (!xr || xr.collapsed === !0)
      return;
    const ed = getPlainTextFromInputEvent(Ae);
    if (ed == null)
      return;
    const id = this.quill.selection.normalizeNative(xr), od = id ? this.quill.selection.normalizedToRange(id) : null;
    od && this.replaceText(od, ed) && Ae.preventDefault();
  }
  handleCompositionStart() {
    const Ae = this.quill.getSelection();
    Ae && this.replaceText(Ae);
  }
};
function getPlainTextFromInputEvent(td) {
  var Ae;
  return typeof td.data == "string" ? td.data : (Ae = td.dataTransfer) != null && Ae.types.includes("text/plain") ? td.dataTransfer.getData("text/plain") : null;
}
const isMac = /Mac/i.test(navigator.platform), TTL_FOR_VALID_SELECTION_CHANGE = 100, canMoveCaretBeforeUINode = (td) => !!(td.key === "ArrowLeft" || td.key === "ArrowRight" || // RTL scripts or moving from the end of the previous line
td.key === "ArrowUp" || td.key === "ArrowDown" || td.key === "Home" || isMac && td.key === "a" && td.ctrlKey === !0);
class UINode extends Module {
  constructor(xr, ed) {
    super(xr, ed);
    _d(this, "isListening", !1);
    _d(this, "selectionChangeDeadline", 0);
    this.handleArrowKeys(), this.handleNavigationShortcuts();
  }
  handleArrowKeys() {
    this.quill.keyboard.addBinding({
      key: ["ArrowLeft", "ArrowRight"],
      offset: 0,
      shiftKey: null,
      handler(xr, ed) {
        let {
          line: id,
          event: od
        } = ed;
        if (!(id instanceof ParentBlot$1) || !id.uiNode)
          return !0;
        const ad = getComputedStyle(id.domNode).direction === "rtl";
        return ad && od.key !== "ArrowRight" || !ad && od.key !== "ArrowLeft" ? !0 : (this.quill.setSelection(xr.index - 1, xr.length + (od.shiftKey ? 1 : 0), Quill.sources.USER), !1);
      }
    });
  }
  handleNavigationShortcuts() {
    this.quill.root.addEventListener("keydown", (xr) => {
      !xr.defaultPrevented && canMoveCaretBeforeUINode(xr) && this.ensureListeningToSelectionChange();
    });
  }
  /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */
  ensureListeningToSelectionChange() {
    if (this.selectionChangeDeadline = Date.now() + TTL_FOR_VALID_SELECTION_CHANGE, this.isListening)
      return;
    this.isListening = !0;
    const xr = () => {
      this.isListening = !1, Date.now() <= this.selectionChangeDeadline && this.handleSelectionChange();
    };
    document.addEventListener("selectionchange", xr, {
      once: !0
    });
  }
  handleSelectionChange() {
    const xr = document.getSelection();
    if (!xr)
      return;
    const ed = xr.getRangeAt(0);
    if (ed.collapsed !== !0 || ed.startOffset !== 0)
      return;
    const id = this.quill.scroll.find(ed.startContainer);
    if (!(id instanceof ParentBlot$1) || !id.uiNode)
      return;
    const od = document.createRange();
    od.setStartAfter(id.uiNode), od.setEndAfter(id.uiNode), xr.removeAllRanges(), xr.addRange(od);
  }
}
Quill.register({
  "blots/block": Block,
  "blots/block/embed": BlockEmbed,
  "blots/break": Break,
  "blots/container": Container$8,
  "blots/cursor": Cursor,
  "blots/embed": Embed,
  "blots/inline": Inline,
  "blots/scroll": Scroll,
  "blots/text": Text$2,
  "modules/clipboard": Clipboard,
  "modules/history": History,
  "modules/keyboard": Keyboard,
  "modules/uploader": Uploader,
  "modules/input": Input$5,
  "modules/uiNode": UINode
});
class IndentAttributor extends ClassAttributor$1 {
  add(Ae, xr) {
    let ed = 0;
    if (xr === "+1" || xr === "-1") {
      const id = this.value(Ae) || 0;
      ed = xr === "+1" ? id + 1 : id - 1;
    } else
      typeof xr == "number" && (ed = xr);
    return ed === 0 ? (this.remove(Ae), !0) : super.add(Ae, ed.toString());
  }
  canAdd(Ae, xr) {
    return super.canAdd(Ae, xr) || super.canAdd(Ae, parseInt(xr, 10));
  }
  value(Ae) {
    return parseInt(super.value(Ae), 10) || void 0;
  }
}
const IndentClass = new IndentAttributor("indent", "ql-indent", {
  scope: Scope.BLOCK,
  // @ts-expect-error
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});
class Blockquote extends Block {
}
_d(Blockquote, "blotName", "blockquote"), _d(Blockquote, "tagName", "blockquote");
class Header extends Block {
  static formats(Ae) {
    return this.tagName.indexOf(Ae.tagName) + 1;
  }
}
_d(Header, "blotName", "header"), _d(Header, "tagName", ["H1", "H2", "H3", "H4", "H5", "H6"]);
class ListContainer extends Container$8 {
}
ListContainer.blotName = "list-container";
ListContainer.tagName = "OL";
class ListItem extends Block {
  static create(Ae) {
    const xr = super.create();
    return xr.setAttribute("data-list", Ae), xr;
  }
  static formats(Ae) {
    return Ae.getAttribute("data-list") || void 0;
  }
  static register() {
    Quill.register(ListContainer);
  }
  constructor(Ae, xr) {
    super(Ae, xr);
    const ed = xr.ownerDocument.createElement("span"), id = (od) => {
      if (!Ae.isEnabled())
        return;
      const ad = this.statics.formats(xr, Ae);
      ad === "checked" ? (this.format("list", "unchecked"), od.preventDefault()) : ad === "unchecked" && (this.format("list", "checked"), od.preventDefault());
    };
    ed.addEventListener("mousedown", id), ed.addEventListener("touchstart", id), this.attachUI(ed);
  }
  format(Ae, xr) {
    Ae === this.statics.blotName && xr ? this.domNode.setAttribute("data-list", xr) : super.format(Ae, xr);
  }
}
ListItem.blotName = "list";
ListItem.tagName = "LI";
ListContainer.allowedChildren = [ListItem];
ListItem.requiredContainer = ListContainer;
class Bold extends Inline {
  static create() {
    return super.create();
  }
  static formats() {
    return !0;
  }
  optimize(Ae) {
    super.optimize(Ae), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName);
  }
}
_d(Bold, "blotName", "bold"), _d(Bold, "tagName", ["STRONG", "B"]);
class Italic extends Bold {
}
_d(Italic, "blotName", "italic"), _d(Italic, "tagName", ["EM", "I"]);
class Link extends Inline {
  static create(Ae) {
    const xr = super.create(Ae);
    return xr.setAttribute("href", this.sanitize(Ae)), xr.setAttribute("rel", "noopener noreferrer"), xr.setAttribute("target", "_blank"), xr;
  }
  static formats(Ae) {
    return Ae.getAttribute("href");
  }
  static sanitize(Ae) {
    return sanitize(Ae, this.PROTOCOL_WHITELIST) ? Ae : this.SANITIZED_URL;
  }
  format(Ae, xr) {
    Ae !== this.statics.blotName || !xr ? super.format(Ae, xr) : this.domNode.setAttribute("href", this.constructor.sanitize(xr));
  }
}
_d(Link, "blotName", "link"), _d(Link, "tagName", "A"), _d(Link, "SANITIZED_URL", "about:blank"), _d(Link, "PROTOCOL_WHITELIST", ["http", "https", "mailto", "tel", "sms"]);
function sanitize(td, Ae) {
  const xr = document.createElement("a");
  xr.href = td;
  const ed = xr.href.slice(0, xr.href.indexOf(":"));
  return Ae.indexOf(ed) > -1;
}
class Script extends Inline {
  static create(Ae) {
    return Ae === "super" ? document.createElement("sup") : Ae === "sub" ? document.createElement("sub") : super.create(Ae);
  }
  static formats(Ae) {
    if (Ae.tagName === "SUB")
      return "sub";
    if (Ae.tagName === "SUP")
      return "super";
  }
}
_d(Script, "blotName", "script"), _d(Script, "tagName", ["SUB", "SUP"]);
class Strike extends Bold {
}
_d(Strike, "blotName", "strike"), _d(Strike, "tagName", ["S", "STRIKE"]);
class Underline extends Inline {
}
_d(Underline, "blotName", "underline"), _d(Underline, "tagName", "U");
class Formula extends Embed {
  static create(Ae) {
    if (window.katex == null)
      throw new Error("Formula module requires KaTeX.");
    const xr = super.create(Ae);
    return typeof Ae == "string" && (window.katex.render(Ae, xr, {
      throwOnError: !1,
      errorColor: "#f00"
    }), xr.setAttribute("data-value", Ae)), xr;
  }
  static value(Ae) {
    return Ae.getAttribute("data-value");
  }
  html() {
    const {
      formula: Ae
    } = this.value();
    return `<span>${Ae}</span>`;
  }
}
_d(Formula, "blotName", "formula"), _d(Formula, "className", "ql-formula"), _d(Formula, "tagName", "SPAN");
const ATTRIBUTES$1 = ["alt", "height", "width"];
class Image extends EmbedBlot$1 {
  static create(Ae) {
    const xr = super.create(Ae);
    return typeof Ae == "string" && xr.setAttribute("src", this.sanitize(Ae)), xr;
  }
  static formats(Ae) {
    return ATTRIBUTES$1.reduce((xr, ed) => (Ae.hasAttribute(ed) && (xr[ed] = Ae.getAttribute(ed)), xr), {});
  }
  static match(Ae) {
    return /\.(jpe?g|gif|png)$/.test(Ae) || /^data:image\/.+;base64/.test(Ae);
  }
  static sanitize(Ae) {
    return sanitize(Ae, ["http", "https", "data"]) ? Ae : "//:0";
  }
  static value(Ae) {
    return Ae.getAttribute("src");
  }
  format(Ae, xr) {
    ATTRIBUTES$1.indexOf(Ae) > -1 ? xr ? this.domNode.setAttribute(Ae, xr) : this.domNode.removeAttribute(Ae) : super.format(Ae, xr);
  }
}
_d(Image, "blotName", "image"), _d(Image, "tagName", "IMG");
const ATTRIBUTES = ["height", "width"];
class Video extends BlockEmbed {
  static create(Ae) {
    const xr = super.create(Ae);
    return xr.setAttribute("frameborder", "0"), xr.setAttribute("allowfullscreen", "true"), xr.setAttribute("src", this.sanitize(Ae)), xr;
  }
  static formats(Ae) {
    return ATTRIBUTES.reduce((xr, ed) => (Ae.hasAttribute(ed) && (xr[ed] = Ae.getAttribute(ed)), xr), {});
  }
  static sanitize(Ae) {
    return Link.sanitize(Ae);
  }
  static value(Ae) {
    return Ae.getAttribute("src");
  }
  format(Ae, xr) {
    ATTRIBUTES.indexOf(Ae) > -1 ? xr ? this.domNode.setAttribute(Ae, xr) : this.domNode.removeAttribute(Ae) : super.format(Ae, xr);
  }
  html() {
    const {
      video: Ae
    } = this.value();
    return `<a href="${Ae}">${Ae}</a>`;
  }
}
_d(Video, "blotName", "video"), _d(Video, "className", "ql-video"), _d(Video, "tagName", "IFRAME");
const TokenAttributor = new ClassAttributor$1("code-token", "hljs", {
  scope: Scope.INLINE
});
class CodeToken extends Inline {
  static formats(Ae, xr) {
    for (; Ae != null && Ae !== xr.domNode; ) {
      if (Ae.classList && Ae.classList.contains(CodeBlock.className))
        return super.formats(Ae, xr);
      Ae = Ae.parentNode;
    }
  }
  constructor(Ae, xr, ed) {
    super(Ae, xr, ed), TokenAttributor.add(this.domNode, ed);
  }
  format(Ae, xr) {
    Ae !== CodeToken.blotName ? super.format(Ae, xr) : xr ? TokenAttributor.add(this.domNode, xr) : (TokenAttributor.remove(this.domNode), this.domNode.classList.remove(this.statics.className));
  }
  optimize() {
    super.optimize(...arguments), TokenAttributor.value(this.domNode) || this.unwrap();
  }
}
CodeToken.blotName = "code-token";
CodeToken.className = "ql-token";
class SyntaxCodeBlock extends CodeBlock {
  static create(Ae) {
    const xr = super.create(Ae);
    return typeof Ae == "string" && xr.setAttribute("data-language", Ae), xr;
  }
  static formats(Ae) {
    return Ae.getAttribute("data-language") || "plain";
  }
  static register() {
  }
  // Syntax module will register
  format(Ae, xr) {
    Ae === this.statics.blotName && xr ? this.domNode.setAttribute("data-language", xr) : super.format(Ae, xr);
  }
  replaceWith(Ae, xr) {
    return this.formatAt(0, this.length(), CodeToken.blotName, !1), super.replaceWith(Ae, xr);
  }
}
class SyntaxCodeBlockContainer extends CodeBlockContainer {
  attach() {
    super.attach(), this.forceNext = !1, this.scroll.emitMount(this);
  }
  format(Ae, xr) {
    Ae === SyntaxCodeBlock.blotName && (this.forceNext = !0, this.children.forEach((ed) => {
      ed.format(Ae, xr);
    }));
  }
  formatAt(Ae, xr, ed, id) {
    ed === SyntaxCodeBlock.blotName && (this.forceNext = !0), super.formatAt(Ae, xr, ed, id);
  }
  highlight(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (this.children.head == null)
      return;
    const id = `${Array.from(this.domNode.childNodes).filter((ad) => ad !== this.uiNode).map((ad) => ad.textContent).join(`
`)}
`, od = SyntaxCodeBlock.formats(this.children.head.domNode);
    if (xr || this.forceNext || this.cachedText !== id) {
      if (id.trim().length > 0 || this.cachedText == null) {
        const ad = this.children.reduce((sd, nd) => sd.concat(blockDelta(nd, !1)), new Delta()), rd = Ae(id, od);
        ad.diff(rd).reduce((sd, nd) => {
          let {
            retain: cd,
            attributes: ud
          } = nd;
          return cd ? (ud && Object.keys(ud).forEach((ld) => {
            [SyntaxCodeBlock.blotName, CodeToken.blotName].includes(ld) && this.formatAt(sd, cd, ld, ud[ld]);
          }), sd + cd) : sd;
        }, 0);
      }
      this.cachedText = id, this.forceNext = !1;
    }
  }
  html(Ae, xr) {
    const [ed] = this.children.find(Ae);
    return `<pre data-language="${ed ? SyntaxCodeBlock.formats(ed.domNode) : "plain"}">
${escapeText(this.code(Ae, xr))}
</pre>`;
  }
  optimize(Ae) {
    if (super.optimize(Ae), this.parent != null && this.children.head != null && this.uiNode != null) {
      const xr = SyntaxCodeBlock.formats(this.children.head.domNode);
      xr !== this.uiNode.value && (this.uiNode.value = xr);
    }
  }
}
SyntaxCodeBlockContainer.allowedChildren = [SyntaxCodeBlock];
SyntaxCodeBlock.requiredContainer = SyntaxCodeBlockContainer;
SyntaxCodeBlock.allowedChildren = [CodeToken, Cursor, Text$2, Break];
const highlight = (td, Ae, xr) => {
  if (typeof td.versionString == "string") {
    const ed = td.versionString.split(".")[0];
    if (parseInt(ed, 10) >= 11)
      return td.highlight(xr, {
        language: Ae
      }).value;
  }
  return td.highlight(Ae, xr).value;
};
class Syntax extends Module {
  static register() {
    Quill.register(CodeToken, !0), Quill.register(SyntaxCodeBlock, !0), Quill.register(SyntaxCodeBlockContainer, !0);
  }
  constructor(Ae, xr) {
    if (super(Ae, xr), this.options.hljs == null)
      throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
    this.languages = this.options.languages.reduce((ed, id) => {
      let {
        key: od
      } = id;
      return ed[od] = !0, ed;
    }, {}), this.highlightBlot = this.highlightBlot.bind(this), this.initListener(), this.initTimer();
  }
  initListener() {
    this.quill.on(Quill.events.SCROLL_BLOT_MOUNT, (Ae) => {
      if (!(Ae instanceof SyntaxCodeBlockContainer))
        return;
      const xr = this.quill.root.ownerDocument.createElement("select");
      this.options.languages.forEach((ed) => {
        let {
          key: id,
          label: od
        } = ed;
        const ad = xr.ownerDocument.createElement("option");
        ad.textContent = od, ad.setAttribute("value", id), xr.appendChild(ad);
      }), xr.addEventListener("change", () => {
        Ae.format(SyntaxCodeBlock.blotName, xr.value), this.quill.root.focus(), this.highlight(Ae, !0);
      }), Ae.uiNode == null && (Ae.attachUI(xr), Ae.children.head && (xr.value = SyntaxCodeBlock.formats(Ae.children.head.domNode)));
    });
  }
  initTimer() {
    let Ae = null;
    this.quill.on(Quill.events.SCROLL_OPTIMIZE, () => {
      Ae && clearTimeout(Ae), Ae = setTimeout(() => {
        this.highlight(), Ae = null;
      }, this.options.interval);
    });
  }
  highlight() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (this.quill.selection.composing)
      return;
    this.quill.update(Quill.sources.USER);
    const ed = this.quill.getSelection();
    (Ae == null ? this.quill.scroll.descendants(SyntaxCodeBlockContainer) : [Ae]).forEach((od) => {
      od.highlight(this.highlightBlot, xr);
    }), this.quill.update(Quill.sources.SILENT), ed != null && this.quill.setSelection(ed, Quill.sources.SILENT);
  }
  highlightBlot(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "plain";
    if (xr = this.languages[xr] ? xr : "plain", xr === "plain")
      return escapeText(Ae).split(`
`).reduce((id, od, ad) => (ad !== 0 && id.insert(`
`, {
        [CodeBlock.blotName]: xr
      }), id.insert(od)), new Delta());
    const ed = this.quill.root.ownerDocument.createElement("div");
    return ed.classList.add(CodeBlock.className), ed.innerHTML = highlight(this.options.hljs, xr, Ae), traverse(this.quill.scroll, ed, [(id, od) => {
      const ad = TokenAttributor.value(id);
      return ad ? od.compose(new Delta().retain(od.length(), {
        [CodeToken.blotName]: ad
      })) : od;
    }], [(id, od) => id.data.split(`
`).reduce((ad, rd, sd) => (sd !== 0 && ad.insert(`
`, {
      [CodeBlock.blotName]: xr
    }), ad.insert(rd)), od)], /* @__PURE__ */ new WeakMap());
  }
}
Syntax.DEFAULTS = {
  hljs: window.hljs,
  interval: 1e3,
  languages: [{
    key: "plain",
    label: "Plain"
  }, {
    key: "bash",
    label: "Bash"
  }, {
    key: "cpp",
    label: "C++"
  }, {
    key: "cs",
    label: "C#"
  }, {
    key: "css",
    label: "CSS"
  }, {
    key: "diff",
    label: "Diff"
  }, {
    key: "xml",
    label: "HTML/XML"
  }, {
    key: "java",
    label: "Java"
  }, {
    key: "javascript",
    label: "JavaScript"
  }, {
    key: "markdown",
    label: "Markdown"
  }, {
    key: "php",
    label: "PHP"
  }, {
    key: "python",
    label: "Python"
  }, {
    key: "ruby",
    label: "Ruby"
  }, {
    key: "sql",
    label: "SQL"
  }]
};
const Up = class Up extends Block {
  static create(Ae) {
    const xr = super.create();
    return Ae ? xr.setAttribute("data-row", Ae) : xr.setAttribute("data-row", tableId()), xr;
  }
  static formats(Ae) {
    if (Ae.hasAttribute("data-row"))
      return Ae.getAttribute("data-row");
  }
  cellOffset() {
    return this.parent ? this.parent.children.indexOf(this) : -1;
  }
  format(Ae, xr) {
    Ae === Up.blotName && xr ? this.domNode.setAttribute("data-row", xr) : super.format(Ae, xr);
  }
  row() {
    return this.parent;
  }
  rowOffset() {
    return this.row() ? this.row().rowOffset() : -1;
  }
  table() {
    return this.row() && this.row().table();
  }
};
_d(Up, "blotName", "table"), _d(Up, "tagName", "TD");
let TableCell = Up;
class TableRow extends Container$8 {
  checkMerge() {
    if (super.checkMerge() && this.next.children.head != null) {
      const Ae = this.children.head.formats(), xr = this.children.tail.formats(), ed = this.next.children.head.formats(), id = this.next.children.tail.formats();
      return Ae.table === xr.table && Ae.table === ed.table && Ae.table === id.table;
    }
    return !1;
  }
  optimize(Ae) {
    super.optimize(Ae), this.children.forEach((xr) => {
      if (xr.next == null)
        return;
      const ed = xr.formats(), id = xr.next.formats();
      if (ed.table !== id.table) {
        const od = this.splitAfter(xr);
        od && od.optimize(), this.prev && this.prev.optimize();
      }
    });
  }
  rowOffset() {
    return this.parent ? this.parent.children.indexOf(this) : -1;
  }
  table() {
    return this.parent && this.parent.parent;
  }
}
_d(TableRow, "blotName", "table-row"), _d(TableRow, "tagName", "TR");
class TableBody extends Container$8 {
}
_d(TableBody, "blotName", "table-body"), _d(TableBody, "tagName", "TBODY");
class TableContainer extends Container$8 {
  balanceCells() {
    const Ae = this.descendants(TableRow), xr = Ae.reduce((ed, id) => Math.max(id.children.length, ed), 0);
    Ae.forEach((ed) => {
      new Array(xr - ed.children.length).fill(0).forEach(() => {
        let id;
        ed.children.head != null && (id = TableCell.formats(ed.children.head.domNode));
        const od = this.scroll.create(TableCell.blotName, id);
        ed.appendChild(od), od.optimize();
      });
    });
  }
  cells(Ae) {
    return this.rows().map((xr) => xr.children.at(Ae));
  }
  deleteColumn(Ae) {
    const [xr] = this.descendant(TableBody);
    xr == null || xr.children.head == null || xr.children.forEach((ed) => {
      const id = ed.children.at(Ae);
      id != null && id.remove();
    });
  }
  insertColumn(Ae) {
    const [xr] = this.descendant(TableBody);
    xr == null || xr.children.head == null || xr.children.forEach((ed) => {
      const id = ed.children.at(Ae), od = TableCell.formats(ed.children.head.domNode), ad = this.scroll.create(TableCell.blotName, od);
      ed.insertBefore(ad, id);
    });
  }
  insertRow(Ae) {
    const [xr] = this.descendant(TableBody);
    if (xr == null || xr.children.head == null)
      return;
    const ed = tableId(), id = this.scroll.create(TableRow.blotName);
    xr.children.head.children.forEach(() => {
      const ad = this.scroll.create(TableCell.blotName, ed);
      id.appendChild(ad);
    });
    const od = xr.children.at(Ae);
    xr.insertBefore(id, od);
  }
  rows() {
    const Ae = this.children.head;
    return Ae == null ? [] : Ae.children.map((xr) => xr);
  }
}
_d(TableContainer, "blotName", "table-container"), _d(TableContainer, "tagName", "TABLE");
TableContainer.allowedChildren = [TableBody];
TableBody.requiredContainer = TableContainer;
TableBody.allowedChildren = [TableRow];
TableRow.requiredContainer = TableBody;
TableRow.allowedChildren = [TableCell];
TableCell.requiredContainer = TableRow;
function tableId() {
  return `row-${Math.random().toString(36).slice(2, 6)}`;
}
class Table extends Module {
  static register() {
    Quill.register(TableCell), Quill.register(TableRow), Quill.register(TableBody), Quill.register(TableContainer);
  }
  constructor() {
    super(...arguments), this.listenBalanceCells();
  }
  balanceTables() {
    this.quill.scroll.descendants(TableContainer).forEach((Ae) => {
      Ae.balanceCells();
    });
  }
  deleteColumn() {
    const [Ae, , xr] = this.getTable();
    xr != null && (Ae.deleteColumn(xr.cellOffset()), this.quill.update(Quill.sources.USER));
  }
  deleteRow() {
    const [, Ae] = this.getTable();
    Ae != null && (Ae.remove(), this.quill.update(Quill.sources.USER));
  }
  deleteTable() {
    const [Ae] = this.getTable();
    if (Ae == null)
      return;
    const xr = Ae.offset();
    Ae.remove(), this.quill.update(Quill.sources.USER), this.quill.setSelection(xr, Quill.sources.SILENT);
  }
  getTable() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.quill.getSelection();
    if (Ae == null)
      return [null, null, null, -1];
    const [xr, ed] = this.quill.getLine(Ae.index);
    if (xr == null || xr.statics.blotName !== TableCell.blotName)
      return [null, null, null, -1];
    const id = xr.parent;
    return [id.parent.parent, id, xr, ed];
  }
  insertColumn(Ae) {
    const xr = this.quill.getSelection();
    if (!xr)
      return;
    const [ed, id, od] = this.getTable(xr);
    if (od == null)
      return;
    const ad = od.cellOffset();
    ed.insertColumn(ad + Ae), this.quill.update(Quill.sources.USER);
    let rd = id.rowOffset();
    Ae === 0 && (rd += 1), this.quill.setSelection(xr.index + rd, xr.length, Quill.sources.SILENT);
  }
  insertColumnLeft() {
    this.insertColumn(0);
  }
  insertColumnRight() {
    this.insertColumn(1);
  }
  insertRow(Ae) {
    const xr = this.quill.getSelection();
    if (!xr)
      return;
    const [ed, id, od] = this.getTable(xr);
    if (od == null)
      return;
    const ad = id.rowOffset();
    ed.insertRow(ad + Ae), this.quill.update(Quill.sources.USER), Ae > 0 ? this.quill.setSelection(xr, Quill.sources.SILENT) : this.quill.setSelection(xr.index + id.children.length, xr.length, Quill.sources.SILENT);
  }
  insertRowAbove() {
    this.insertRow(0);
  }
  insertRowBelow() {
    this.insertRow(1);
  }
  insertTable(Ae, xr) {
    const ed = this.quill.getSelection();
    if (ed == null)
      return;
    const id = new Array(Ae).fill(0).reduce((od) => {
      const ad = new Array(xr).fill(`
`).join("");
      return od.insert(ad, {
        table: tableId()
      });
    }, new Delta().retain(ed.index));
    this.quill.updateContents(id, Quill.sources.USER), this.quill.setSelection(ed.index, Quill.sources.SILENT), this.balanceTables();
  }
  listenBalanceCells() {
    this.quill.on(Quill.events.SCROLL_OPTIMIZE, (Ae) => {
      Ae.some((xr) => ["TD", "TR", "TBODY", "TABLE"].includes(xr.target.tagName) ? (this.quill.once(Quill.events.TEXT_CHANGE, (ed, id, od) => {
        od === Quill.sources.USER && this.balanceTables();
      }), !0) : !1);
    });
  }
}
const debug = namespace("quill:toolbar");
class Toolbar extends Module {
  constructor(Ae, xr) {
    var ed, id;
    if (super(Ae, xr), Array.isArray(this.options.container)) {
      const od = document.createElement("div");
      od.setAttribute("role", "toolbar"), addControls(od, this.options.container), (id = (ed = Ae.container) == null ? void 0 : ed.parentNode) == null || id.insertBefore(od, Ae.container), this.container = od;
    } else
      typeof this.options.container == "string" ? this.container = document.querySelector(this.options.container) : this.container = this.options.container;
    if (!(this.container instanceof HTMLElement)) {
      debug.error("Container required for toolbar", this.options);
      return;
    }
    this.container.classList.add("ql-toolbar"), this.controls = [], this.handlers = {}, this.options.handlers && Object.keys(this.options.handlers).forEach((od) => {
      var rd;
      const ad = (rd = this.options.handlers) == null ? void 0 : rd[od];
      ad && this.addHandler(od, ad);
    }), Array.from(this.container.querySelectorAll("button, select")).forEach((od) => {
      this.attach(od);
    }), this.quill.on(Quill.events.EDITOR_CHANGE, () => {
      const [od] = this.quill.selection.getRange();
      this.update(od);
    });
  }
  addHandler(Ae, xr) {
    this.handlers[Ae] = xr;
  }
  attach(Ae) {
    let xr = Array.from(Ae.classList).find((id) => id.indexOf("ql-") === 0);
    if (!xr)
      return;
    if (xr = xr.slice(3), Ae.tagName === "BUTTON" && Ae.setAttribute("type", "button"), this.handlers[xr] == null && this.quill.scroll.query(xr) == null) {
      debug.warn("ignoring attaching to nonexistent format", xr, Ae);
      return;
    }
    const ed = Ae.tagName === "SELECT" ? "change" : "click";
    Ae.addEventListener(ed, (id) => {
      let od;
      if (Ae.tagName === "SELECT") {
        if (Ae.selectedIndex < 0)
          return;
        const rd = Ae.options[Ae.selectedIndex];
        rd.hasAttribute("selected") ? od = !1 : od = rd.value || !1;
      } else
        Ae.classList.contains("ql-active") ? od = !1 : od = Ae.value || !Ae.hasAttribute("value"), id.preventDefault();
      this.quill.focus();
      const [ad] = this.quill.selection.getRange();
      if (this.handlers[xr] != null)
        this.handlers[xr].call(this, od);
      else if (
        // @ts-expect-error
        this.quill.scroll.query(xr).prototype instanceof EmbedBlot$1
      ) {
        if (od = prompt(`Enter ${xr}`), !od)
          return;
        this.quill.updateContents(new Delta().retain(ad.index).delete(ad.length).insert({
          [xr]: od
        }), Quill.sources.USER);
      } else
        this.quill.format(xr, od, Quill.sources.USER);
      this.update(ad);
    }), this.controls.push([xr, Ae]);
  }
  update(Ae) {
    const xr = Ae == null ? {} : this.quill.getFormat(Ae);
    this.controls.forEach((ed) => {
      const [id, od] = ed;
      if (od.tagName === "SELECT") {
        let ad = null;
        if (Ae == null)
          ad = null;
        else if (xr[id] == null)
          ad = od.querySelector("option[selected]");
        else if (!Array.isArray(xr[id])) {
          let rd = xr[id];
          typeof rd == "string" && (rd = rd.replace(/"/g, '\\"')), ad = od.querySelector(`option[value="${rd}"]`);
        }
        ad == null ? (od.value = "", od.selectedIndex = -1) : ad.selected = !0;
      } else if (Ae == null)
        od.classList.remove("ql-active"), od.setAttribute("aria-pressed", "false");
      else if (od.hasAttribute("value")) {
        const ad = xr[id], rd = ad === od.getAttribute("value") || ad != null && ad.toString() === od.getAttribute("value") || ad == null && !od.getAttribute("value");
        od.classList.toggle("ql-active", rd), od.setAttribute("aria-pressed", rd.toString());
      } else {
        const ad = xr[id] != null;
        od.classList.toggle("ql-active", ad), od.setAttribute("aria-pressed", ad.toString());
      }
    });
  }
}
Toolbar.DEFAULTS = {};
function addButton(td, Ae, xr) {
  const ed = document.createElement("button");
  ed.setAttribute("type", "button"), ed.classList.add(`ql-${Ae}`), ed.setAttribute("aria-pressed", "false"), xr != null ? (ed.value = xr, ed.setAttribute("aria-label", `${Ae}: ${xr}`)) : ed.setAttribute("aria-label", Ae), td.appendChild(ed);
}
function addControls(td, Ae) {
  Array.isArray(Ae[0]) || (Ae = [Ae]), Ae.forEach((xr) => {
    const ed = document.createElement("span");
    ed.classList.add("ql-formats"), xr.forEach((id) => {
      if (typeof id == "string")
        addButton(ed, id);
      else {
        const od = Object.keys(id)[0], ad = id[od];
        Array.isArray(ad) ? addSelect(ed, od, ad) : addButton(ed, od, ad);
      }
    }), td.appendChild(ed);
  });
}
function addSelect(td, Ae, xr) {
  const ed = document.createElement("select");
  ed.classList.add(`ql-${Ae}`), xr.forEach((id) => {
    const od = document.createElement("option");
    id !== !1 ? od.setAttribute("value", String(id)) : od.setAttribute("selected", "selected"), ed.appendChild(od);
  }), td.appendChild(ed);
}
Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean() {
      const td = this.quill.getSelection();
      if (td != null)
        if (td.length === 0) {
          const Ae = this.quill.getFormat();
          Object.keys(Ae).forEach((xr) => {
            this.quill.scroll.query(xr, Scope.INLINE) != null && this.quill.format(xr, !1, Quill.sources.USER);
          });
        } else
          this.quill.removeFormat(td.index, td.length, Quill.sources.USER);
    },
    direction(td) {
      const {
        align: Ae
      } = this.quill.getFormat();
      td === "rtl" && Ae == null ? this.quill.format("align", "right", Quill.sources.USER) : !td && Ae === "right" && this.quill.format("align", !1, Quill.sources.USER), this.quill.format("direction", td, Quill.sources.USER);
    },
    indent(td) {
      const Ae = this.quill.getSelection(), xr = this.quill.getFormat(Ae), ed = parseInt(xr.indent || 0, 10);
      if (td === "+1" || td === "-1") {
        let id = td === "+1" ? 1 : -1;
        xr.direction === "rtl" && (id *= -1), this.quill.format("indent", ed + id, Quill.sources.USER);
      }
    },
    link(td) {
      td === !0 && (td = prompt("Enter link URL:")), this.quill.format("link", td, Quill.sources.USER);
    },
    list(td) {
      const Ae = this.quill.getSelection(), xr = this.quill.getFormat(Ae);
      td === "check" ? xr.list === "checked" || xr.list === "unchecked" ? this.quill.format("list", !1, Quill.sources.USER) : this.quill.format("list", "unchecked", Quill.sources.USER) : this.quill.format("list", td, Quill.sources.USER);
    }
  }
};
const alignLeftIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"/></svg>', alignCenterIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"/><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"/></svg>', alignRightIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"/></svg>', alignJustifyIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"/></svg>', backgroundIcon = '<svg viewbox="0 0 18 18"><g class="ql-fill ql-color-label"><polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"/><rect height="1" width="1" x="4" y="4"/><polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"/><rect height="1" width="1" x="2" y="6"/><rect height="1" width="1" x="3" y="5"/><rect height="1" width="1" x="4" y="7"/><polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"/><rect height="1" width="1" x="2" y="12"/><rect height="1" width="1" x="2" y="9"/><rect height="1" width="1" x="2" y="15"/><polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"/><rect height="1" width="1" x="3" y="8"/><path d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"/><path d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"/><path d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"/><rect height="1" width="1" x="12" y="2"/><rect height="1" width="1" x="11" y="3"/><path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"/><rect height="1" width="1" x="2" y="3"/><rect height="1" width="1" x="6" y="2"/><rect height="1" width="1" x="3" y="2"/><rect height="1" width="1" x="5" y="3"/><rect height="1" width="1" x="9" y="2"/><rect height="1" width="1" x="15" y="14"/><polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"/><rect height="1" width="1" x="13" y="7"/><rect height="1" width="1" x="15" y="5"/><rect height="1" width="1" x="14" y="6"/><rect height="1" width="1" x="15" y="8"/><rect height="1" width="1" x="14" y="9"/><path d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"/><rect height="1" width="1" x="14" y="3"/><polygon points="12 6.868 12 6 11.62 6 12 6.868"/><rect height="1" width="1" x="15" y="2"/><rect height="1" width="1" x="12" y="5"/><rect height="1" width="1" x="13" y="4"/><polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"/><rect height="1" width="1" x="9" y="14"/><rect height="1" width="1" x="8" y="15"/><path d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"/><rect height="1" width="1" x="5" y="15"/><path d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"/><rect height="1" width="1" x="11" y="15"/><path d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"/><rect height="1" width="1" x="14" y="15"/><rect height="1" width="1" x="15" y="11"/></g><polyline class="ql-stroke" points="5.5 13 9 5 12.5 13"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="11" y2="11"/></svg>', blockquoteIcon = '<svg viewbox="0 0 18 18"><rect class="ql-fill ql-stroke" height="3" width="3" x="4" y="5"/><rect class="ql-fill ql-stroke" height="3" width="3" x="11" y="5"/><path class="ql-even ql-fill ql-stroke" d="M7,8c0,4.031-3,5-3,5"/><path class="ql-even ql-fill ql-stroke" d="M14,8c0,4.031-3,5-3,5"/></svg>', boldIcon = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"/><path class="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"/></svg>', cleanIcon = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="5" x2="13" y1="3" y2="3"/><line class="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"/><line class="ql-stroke" x1="11" x2="15" y1="11" y2="15"/><line class="ql-stroke" x1="15" x2="11" y1="11" y2="15"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="7" x="2" y="14"/></svg>', codeIcon = '<svg viewbox="0 0 18 18"><polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"/><polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"/><line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"/></svg>', colorIcon = '<svg viewbox="0 0 18 18"><line class="ql-color-label ql-stroke ql-transparent" x1="3" x2="15" y1="15" y2="15"/><polyline class="ql-stroke" points="5.5 11 9 3 12.5 11"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="9" y2="9"/></svg>', directionLeftToRightIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"/><line class="ql-stroke ql-fill" x1="15" x2="11" y1="4" y2="4"/><path class="ql-fill" d="M11,3a3,3,0,0,0,0,6h1V3H11Z"/><rect class="ql-fill" height="11" width="1" x="11" y="4"/><rect class="ql-fill" height="11" width="1" x="13" y="4"/></svg>', directionRightToLeftIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"/><line class="ql-stroke ql-fill" x1="9" x2="5" y1="4" y2="4"/><path class="ql-fill" d="M5,3A3,3,0,0,0,5,9H6V3H5Z"/><rect class="ql-fill" height="11" width="1" x="5" y="4"/><rect class="ql-fill" height="11" width="1" x="7" y="4"/></svg>', formulaIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z"/><rect class="ql-fill" height="1.6" rx="0.8" ry="0.8" width="5" x="5.15" y="6.2"/><path class="ql-fill" d="M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z"/></svg>', headerIcon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z"/></svg>', header2Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', header3Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', header4Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z"/></svg>', header5Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>', header6Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z"/></svg>', italicIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"/><line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"/><line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"/></svg>', imageIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="10" width="12" x="3" y="4"/><circle class="ql-fill" cx="6" cy="7" r="1"/><polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"/></svg>', indentIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"/></svg>', outdentIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="5 7 5 11 3 9 5 7"/></svg>', linkIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"/><path class="ql-even ql-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"/><path class="ql-even ql-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"/></svg>', listBulletIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"/><line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"/></svg>', listCheckIcon = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="9" x2="15" y1="4" y2="4"/><polyline class="ql-stroke" points="3 4 4 5 6 3"/><line class="ql-stroke" x1="9" x2="15" y1="14" y2="14"/><polyline class="ql-stroke" points="3 14 4 15 6 13"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="3 9 4 10 6 8"/></svg>', listOrderedIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"/><line class="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"/><path class="ql-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"/><path class="ql-stroke ql-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"/><path class="ql-stroke ql-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"/></svg>', subscriptIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z"/><path class="ql-fill" d="M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z"/></svg>', superscriptIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z"/><path class="ql-fill" d="M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z"/></svg>', strikeIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke ql-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"/><path class="ql-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"/><path class="ql-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"/></svg>', tableIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="2" width="3" x="5" y="5"/><rect class="ql-fill" height="2" width="4" x="9" y="5"/><g class="ql-fill ql-transparent"><rect height="2" width="3" x="5" y="8"/><rect height="2" width="4" x="9" y="8"/><rect height="2" width="3" x="5" y="11"/><rect height="2" width="4" x="9" y="11"/></g></svg>', underlineIcon = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"/></svg>', videoIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="12" width="1" x="5" y="3"/><rect class="ql-fill" height="12" width="1" x="12" y="3"/><rect class="ql-fill" height="2" width="8" x="5" y="8"/><rect class="ql-fill" height="1" width="3" x="3" y="5"/><rect class="ql-fill" height="1" width="3" x="3" y="7"/><rect class="ql-fill" height="1" width="3" x="3" y="10"/><rect class="ql-fill" height="1" width="3" x="3" y="12"/><rect class="ql-fill" height="1" width="3" x="12" y="5"/><rect class="ql-fill" height="1" width="3" x="12" y="7"/><rect class="ql-fill" height="1" width="3" x="12" y="10"/><rect class="ql-fill" height="1" width="3" x="12" y="12"/></svg>', Icons = {
  align: {
    "": alignLeftIcon,
    center: alignCenterIcon,
    right: alignRightIcon,
    justify: alignJustifyIcon
  },
  background: backgroundIcon,
  blockquote: blockquoteIcon,
  bold: boldIcon,
  clean: cleanIcon,
  code: codeIcon,
  "code-block": codeIcon,
  color: colorIcon,
  direction: {
    "": directionLeftToRightIcon,
    rtl: directionRightToLeftIcon
  },
  formula: formulaIcon,
  header: {
    1: headerIcon,
    2: header2Icon,
    3: header3Icon,
    4: header4Icon,
    5: header5Icon,
    6: header6Icon
  },
  italic: italicIcon,
  image: imageIcon,
  indent: {
    "+1": indentIcon,
    "-1": outdentIcon
  },
  link: linkIcon,
  list: {
    bullet: listBulletIcon,
    check: listCheckIcon,
    ordered: listOrderedIcon
  },
  script: {
    sub: subscriptIcon,
    super: superscriptIcon
  },
  strike: strikeIcon,
  table: tableIcon,
  underline: underlineIcon,
  video: videoIcon
}, DropdownIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"/><polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"/></svg>';
let optionsCounter = 0;
function toggleAriaAttribute(td, Ae) {
  td.setAttribute(Ae, `${td.getAttribute(Ae) !== "true"}`);
}
class Picker {
  constructor(Ae) {
    this.select = Ae, this.container = document.createElement("span"), this.buildPicker(), this.select.style.display = "none", this.select.parentNode.insertBefore(this.container, this.select), this.label.addEventListener("mousedown", () => {
      this.togglePicker();
    }), this.label.addEventListener("keydown", (xr) => {
      switch (xr.key) {
        case "Enter":
          this.togglePicker();
          break;
        case "Escape":
          this.escape(), xr.preventDefault();
          break;
      }
    }), this.select.addEventListener("change", this.update.bind(this));
  }
  togglePicker() {
    this.container.classList.toggle("ql-expanded"), toggleAriaAttribute(this.label, "aria-expanded"), toggleAriaAttribute(this.options, "aria-hidden");
  }
  buildItem(Ae) {
    const xr = document.createElement("span");
    xr.tabIndex = "0", xr.setAttribute("role", "button"), xr.classList.add("ql-picker-item");
    const ed = Ae.getAttribute("value");
    return ed && xr.setAttribute("data-value", ed), Ae.textContent && xr.setAttribute("data-label", Ae.textContent), xr.addEventListener("click", () => {
      this.selectItem(xr, !0);
    }), xr.addEventListener("keydown", (id) => {
      switch (id.key) {
        case "Enter":
          this.selectItem(xr, !0), id.preventDefault();
          break;
        case "Escape":
          this.escape(), id.preventDefault();
          break;
      }
    }), xr;
  }
  buildLabel() {
    const Ae = document.createElement("span");
    return Ae.classList.add("ql-picker-label"), Ae.innerHTML = DropdownIcon, Ae.tabIndex = "0", Ae.setAttribute("role", "button"), Ae.setAttribute("aria-expanded", "false"), this.container.appendChild(Ae), Ae;
  }
  buildOptions() {
    const Ae = document.createElement("span");
    Ae.classList.add("ql-picker-options"), Ae.setAttribute("aria-hidden", "true"), Ae.tabIndex = "-1", Ae.id = `ql-picker-options-${optionsCounter}`, optionsCounter += 1, this.label.setAttribute("aria-controls", Ae.id), this.options = Ae, Array.from(this.select.options).forEach((xr) => {
      const ed = this.buildItem(xr);
      Ae.appendChild(ed), xr.selected === !0 && this.selectItem(ed);
    }), this.container.appendChild(Ae);
  }
  buildPicker() {
    Array.from(this.select.attributes).forEach((Ae) => {
      this.container.setAttribute(Ae.name, Ae.value);
    }), this.container.classList.add("ql-picker"), this.label = this.buildLabel(), this.buildOptions();
  }
  escape() {
    this.close(), setTimeout(() => this.label.focus(), 1);
  }
  close() {
    this.container.classList.remove("ql-expanded"), this.label.setAttribute("aria-expanded", "false"), this.options.setAttribute("aria-hidden", "true");
  }
  selectItem(Ae) {
    let xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    const ed = this.container.querySelector(".ql-selected");
    Ae !== ed && (ed != null && ed.classList.remove("ql-selected"), Ae != null && (Ae.classList.add("ql-selected"), this.select.selectedIndex = Array.from(Ae.parentNode.children).indexOf(Ae), Ae.hasAttribute("data-value") ? this.label.setAttribute("data-value", Ae.getAttribute("data-value")) : this.label.removeAttribute("data-value"), Ae.hasAttribute("data-label") ? this.label.setAttribute("data-label", Ae.getAttribute("data-label")) : this.label.removeAttribute("data-label"), xr && (this.select.dispatchEvent(new Event("change")), this.close())));
  }
  update() {
    let Ae;
    if (this.select.selectedIndex > -1) {
      const ed = (
        // @ts-expect-error Fix me later
        this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex]
      );
      Ae = this.select.options[this.select.selectedIndex], this.selectItem(ed);
    } else
      this.selectItem(null);
    const xr = Ae != null && Ae !== this.select.querySelector("option[selected]");
    this.label.classList.toggle("ql-active", xr);
  }
}
class ColorPicker extends Picker {
  constructor(Ae, xr) {
    super(Ae), this.label.innerHTML = xr, this.container.classList.add("ql-color-picker"), Array.from(this.container.querySelectorAll(".ql-picker-item")).slice(0, 7).forEach((ed) => {
      ed.classList.add("ql-primary");
    });
  }
  buildItem(Ae) {
    const xr = super.buildItem(Ae);
    return xr.style.backgroundColor = Ae.getAttribute("value") || "", xr;
  }
  selectItem(Ae, xr) {
    super.selectItem(Ae, xr);
    const ed = this.label.querySelector(".ql-color-label"), id = Ae && Ae.getAttribute("data-value") || "";
    ed && (ed.tagName === "line" ? ed.style.stroke = id : ed.style.fill = id);
  }
}
class IconPicker extends Picker {
  constructor(Ae, xr) {
    super(Ae), this.container.classList.add("ql-icon-picker"), Array.from(this.container.querySelectorAll(".ql-picker-item")).forEach((ed) => {
      ed.innerHTML = xr[ed.getAttribute("data-value") || ""];
    }), this.defaultItem = this.container.querySelector(".ql-selected"), this.selectItem(this.defaultItem);
  }
  selectItem(Ae, xr) {
    super.selectItem(Ae, xr);
    const ed = Ae || this.defaultItem;
    if (ed != null) {
      if (this.label.innerHTML === ed.innerHTML)
        return;
      this.label.innerHTML = ed.innerHTML;
    }
  }
}
const isScrollable = (td) => {
  const {
    overflowY: Ae
  } = getComputedStyle(td, null);
  return Ae !== "visible" && Ae !== "clip";
};
class Tooltip {
  constructor(Ae, xr) {
    this.quill = Ae, this.boundsContainer = xr || document.body, this.root = Ae.addContainer("ql-tooltip"), this.root.innerHTML = this.constructor.TEMPLATE, isScrollable(this.quill.root) && this.quill.root.addEventListener("scroll", () => {
      this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
    }), this.hide();
  }
  hide() {
    this.root.classList.add("ql-hidden");
  }
  position(Ae) {
    const xr = Ae.left + Ae.width / 2 - this.root.offsetWidth / 2, ed = Ae.bottom + this.quill.root.scrollTop;
    this.root.style.left = `${xr}px`, this.root.style.top = `${ed}px`, this.root.classList.remove("ql-flip");
    const id = this.boundsContainer.getBoundingClientRect(), od = this.root.getBoundingClientRect();
    let ad = 0;
    if (od.right > id.right && (ad = id.right - od.right, this.root.style.left = `${xr + ad}px`), od.left < id.left && (ad = id.left - od.left, this.root.style.left = `${xr + ad}px`), od.bottom > id.bottom) {
      const rd = od.bottom - od.top, sd = Ae.bottom - Ae.top + rd;
      this.root.style.top = `${ed - sd}px`, this.root.classList.add("ql-flip");
    }
    return ad;
  }
  show() {
    this.root.classList.remove("ql-editing"), this.root.classList.remove("ql-hidden");
  }
}
const ALIGNS = [!1, "center", "right", "justify"], COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"], FONTS = [!1, "serif", "monospace"], HEADERS = ["1", "2", "3", !1], SIZES = ["small", !1, "large", "huge"];
class BaseTheme extends Theme {
  constructor(Ae, xr) {
    super(Ae, xr);
    const ed = (id) => {
      if (!document.body.contains(Ae.root)) {
        document.body.removeEventListener("click", ed);
        return;
      }
      this.tooltip != null && // @ts-expect-error
      !this.tooltip.root.contains(id.target) && // @ts-expect-error
      document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus() && this.tooltip.hide(), this.pickers != null && this.pickers.forEach((od) => {
        od.container.contains(id.target) || od.close();
      });
    };
    Ae.emitter.listenDOM("click", document.body, ed);
  }
  addModule(Ae) {
    const xr = super.addModule(Ae);
    return Ae === "toolbar" && this.extendToolbar(xr), xr;
  }
  buildButtons(Ae, xr) {
    Array.from(Ae).forEach((ed) => {
      (ed.getAttribute("class") || "").split(/\s+/).forEach((od) => {
        if (od.startsWith("ql-") && (od = od.slice(3), xr[od] != null))
          if (od === "direction")
            ed.innerHTML = xr[od][""] + xr[od].rtl;
          else if (typeof xr[od] == "string")
            ed.innerHTML = xr[od];
          else {
            const ad = ed.value || "";
            ad != null && xr[od][ad] && (ed.innerHTML = xr[od][ad]);
          }
      });
    });
  }
  buildPickers(Ae, xr) {
    this.pickers = Array.from(Ae).map((id) => {
      if (id.classList.contains("ql-align") && (id.querySelector("option") == null && fillSelect(id, ALIGNS), typeof xr.align == "object"))
        return new IconPicker(id, xr.align);
      if (id.classList.contains("ql-background") || id.classList.contains("ql-color")) {
        const od = id.classList.contains("ql-background") ? "background" : "color";
        return id.querySelector("option") == null && fillSelect(id, COLORS, od === "background" ? "#ffffff" : "#000000"), new ColorPicker(id, xr[od]);
      }
      return id.querySelector("option") == null && (id.classList.contains("ql-font") ? fillSelect(id, FONTS) : id.classList.contains("ql-header") ? fillSelect(id, HEADERS) : id.classList.contains("ql-size") && fillSelect(id, SIZES)), new Picker(id);
    });
    const ed = () => {
      this.pickers.forEach((id) => {
        id.update();
      });
    };
    this.quill.on(Emitter.events.EDITOR_CHANGE, ed);
  }
}
BaseTheme.DEFAULTS = merge({}, Theme.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula() {
          this.quill.theme.tooltip.edit("formula");
        },
        image() {
          let td = this.container.querySelector("input.ql-image[type=file]");
          td == null && (td = document.createElement("input"), td.setAttribute("type", "file"), td.setAttribute("accept", this.quill.uploader.options.mimetypes.join(", ")), td.classList.add("ql-image"), td.addEventListener("change", () => {
            const Ae = this.quill.getSelection(!0);
            this.quill.uploader.upload(Ae, td.files), td.value = "";
          }), this.container.appendChild(td)), td.click();
        },
        video() {
          this.quill.theme.tooltip.edit("video");
        }
      }
    }
  }
});
class BaseTooltip extends Tooltip {
  constructor(Ae, xr) {
    super(Ae, xr), this.textbox = this.root.querySelector('input[type="text"]'), this.listen();
  }
  listen() {
    this.textbox.addEventListener("keydown", (Ae) => {
      Ae.key === "Enter" ? (this.save(), Ae.preventDefault()) : Ae.key === "Escape" && (this.cancel(), Ae.preventDefault());
    });
  }
  cancel() {
    this.hide(), this.restoreFocus();
  }
  edit() {
    let Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link", xr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (this.root.classList.remove("ql-hidden"), this.root.classList.add("ql-editing"), this.textbox == null)
      return;
    xr != null ? this.textbox.value = xr : Ae !== this.root.getAttribute("data-mode") && (this.textbox.value = "");
    const ed = this.quill.getBounds(this.quill.selection.savedRange);
    ed != null && this.position(ed), this.textbox.select(), this.textbox.setAttribute("placeholder", this.textbox.getAttribute(`data-${Ae}`) || ""), this.root.setAttribute("data-mode", Ae);
  }
  restoreFocus() {
    this.quill.focus({
      preventScroll: !0
    });
  }
  save() {
    let {
      value: Ae
    } = this.textbox;
    switch (this.root.getAttribute("data-mode")) {
      case "link": {
        const {
          scrollTop: xr
        } = this.quill.root;
        this.linkRange ? (this.quill.formatText(this.linkRange, "link", Ae, Emitter.sources.USER), delete this.linkRange) : (this.restoreFocus(), this.quill.format("link", Ae, Emitter.sources.USER)), this.quill.root.scrollTop = xr;
        break;
      }
      case "video":
        Ae = extractVideoUrl(Ae);
      case "formula": {
        if (!Ae)
          break;
        const xr = this.quill.getSelection(!0);
        if (xr != null) {
          const ed = xr.index + xr.length;
          this.quill.insertEmbed(
            ed,
            // @ts-expect-error Fix me later
            this.root.getAttribute("data-mode"),
            Ae,
            Emitter.sources.USER
          ), this.root.getAttribute("data-mode") === "formula" && this.quill.insertText(ed + 1, " ", Emitter.sources.USER), this.quill.setSelection(ed + 2, Emitter.sources.USER);
        }
        break;
      }
    }
    this.textbox.value = "", this.hide();
  }
}
function extractVideoUrl(td) {
  let Ae = td.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || td.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  return Ae ? `${Ae[1] || "https"}://www.youtube.com/embed/${Ae[2]}?showinfo=0` : (Ae = td.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) ? `${Ae[1] || "https"}://player.vimeo.com/video/${Ae[2]}/` : td;
}
function fillSelect(td, Ae) {
  let xr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  Ae.forEach((ed) => {
    const id = document.createElement("option");
    ed === xr ? id.setAttribute("selected", "selected") : id.setAttribute("value", String(ed)), td.appendChild(id);
  });
}
const TOOLBAR_CONFIG$1 = [["bold", "italic", "link"], [{
  header: 1
}, {
  header: 2
}, "blockquote"]];
class BubbleTooltip extends BaseTooltip {
  constructor(Ae, xr) {
    super(Ae, xr), this.quill.on(Emitter.events.EDITOR_CHANGE, (ed, id, od, ad) => {
      if (ed === Emitter.events.SELECTION_CHANGE)
        if (id != null && id.length > 0 && ad === Emitter.sources.USER) {
          this.show(), this.root.style.left = "0px", this.root.style.width = "", this.root.style.width = `${this.root.offsetWidth}px`;
          const rd = this.quill.getLines(id.index, id.length);
          if (rd.length === 1) {
            const sd = this.quill.getBounds(id);
            sd != null && this.position(sd);
          } else {
            const sd = rd[rd.length - 1], nd = this.quill.getIndex(sd), cd = Math.min(sd.length() - 1, id.index + id.length - nd), ud = this.quill.getBounds(new Range(nd, cd));
            ud != null && this.position(ud);
          }
        } else
          document.activeElement !== this.textbox && this.quill.hasFocus() && this.hide();
    });
  }
  listen() {
    super.listen(), this.root.querySelector(".ql-close").addEventListener("click", () => {
      this.root.classList.remove("ql-editing");
    }), this.quill.on(Emitter.events.SCROLL_OPTIMIZE, () => {
      setTimeout(() => {
        if (this.root.classList.contains("ql-hidden"))
          return;
        const Ae = this.quill.getSelection();
        if (Ae != null) {
          const xr = this.quill.getBounds(Ae);
          xr != null && this.position(xr);
        }
      }, 1);
    });
  }
  cancel() {
    this.show();
  }
  position(Ae) {
    const xr = super.position(Ae), ed = this.root.querySelector(".ql-tooltip-arrow");
    return ed.style.marginLeft = "", xr !== 0 && (ed.style.marginLeft = `${-1 * xr - ed.offsetWidth / 2}px`), xr;
  }
}
_d(BubbleTooltip, "TEMPLATE", ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join(""));
class BubbleTheme extends BaseTheme {
  constructor(Ae, xr) {
    xr.modules.toolbar != null && xr.modules.toolbar.container == null && (xr.modules.toolbar.container = TOOLBAR_CONFIG$1), super(Ae, xr), this.quill.container.classList.add("ql-bubble");
  }
  extendToolbar(Ae) {
    this.tooltip = new BubbleTooltip(this.quill, this.options.bounds), Ae.container != null && (this.tooltip.root.appendChild(Ae.container), this.buildButtons(Ae.container.querySelectorAll("button"), Icons), this.buildPickers(Ae.container.querySelectorAll("select"), Icons));
  }
}
BubbleTheme.DEFAULTS = merge({}, BaseTheme.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link(td) {
          td ? this.quill.theme.tooltip.edit() : this.quill.format("link", !1, Quill.sources.USER);
        }
      }
    }
  }
});
const TOOLBAR_CONFIG = [[{
  header: ["1", "2", "3", !1]
}], ["bold", "italic", "underline", "link"], [{
  list: "ordered"
}, {
  list: "bullet"
}], ["clean"]];
class SnowTooltip extends BaseTooltip {
  constructor() {
    super(...arguments);
    _d(this, "preview", this.root.querySelector("a.ql-preview"));
  }
  listen() {
    super.listen(), this.root.querySelector("a.ql-action").addEventListener("click", (xr) => {
      this.root.classList.contains("ql-editing") ? this.save() : this.edit("link", this.preview.textContent), xr.preventDefault();
    }), this.root.querySelector("a.ql-remove").addEventListener("click", (xr) => {
      if (this.linkRange != null) {
        const ed = this.linkRange;
        this.restoreFocus(), this.quill.formatText(ed, "link", !1, Emitter.sources.USER), delete this.linkRange;
      }
      xr.preventDefault(), this.hide();
    }), this.quill.on(Emitter.events.SELECTION_CHANGE, (xr, ed, id) => {
      if (xr != null) {
        if (xr.length === 0 && id === Emitter.sources.USER) {
          const [od, ad] = this.quill.scroll.descendant(Link, xr.index);
          if (od != null) {
            this.linkRange = new Range(xr.index - ad, od.length());
            const rd = Link.formats(od.domNode);
            this.preview.textContent = rd, this.preview.setAttribute("href", rd), this.show();
            const sd = this.quill.getBounds(this.linkRange);
            sd != null && this.position(sd);
            return;
          }
        } else
          delete this.linkRange;
        this.hide();
      }
    });
  }
  show() {
    super.show(), this.root.removeAttribute("data-mode");
  }
}
_d(SnowTooltip, "TEMPLATE", ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join(""));
class SnowTheme extends BaseTheme {
  constructor(Ae, xr) {
    xr.modules.toolbar != null && xr.modules.toolbar.container == null && (xr.modules.toolbar.container = TOOLBAR_CONFIG), super(Ae, xr), this.quill.container.classList.add("ql-snow");
  }
  extendToolbar(Ae) {
    Ae.container != null && (Ae.container.classList.add("ql-snow"), this.buildButtons(Ae.container.querySelectorAll("button"), Icons), this.buildPickers(Ae.container.querySelectorAll("select"), Icons), this.tooltip = new SnowTooltip(this.quill, this.options.bounds), Ae.container.querySelector(".ql-link") && this.quill.keyboard.addBinding({
      key: "k",
      shortKey: !0
    }, (xr, ed) => {
      Ae.handlers.link.call(Ae, !ed.format.link);
    }));
  }
}
SnowTheme.DEFAULTS = merge({}, BaseTheme.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link(td) {
          if (td) {
            const Ae = this.quill.getSelection();
            if (Ae == null || Ae.length === 0)
              return;
            let xr = this.quill.getText(Ae);
            /^\S+@\S+\.\S+$/.test(xr) && xr.indexOf("mailto:") !== 0 && (xr = `mailto:${xr}`);
            const {
              tooltip: ed
            } = this.quill.theme;
            ed.edit("link", xr);
          } else
            this.quill.format("link", !1, Quill.sources.USER);
        }
      }
    }
  }
});
Quill.register({
  "attributors/attribute/direction": DirectionAttribute,
  "attributors/class/align": AlignClass,
  "attributors/class/background": BackgroundClass,
  "attributors/class/color": ColorClass,
  "attributors/class/direction": DirectionClass,
  "attributors/class/font": FontClass,
  "attributors/class/size": SizeClass,
  "attributors/style/align": AlignStyle,
  "attributors/style/background": BackgroundStyle,
  "attributors/style/color": ColorStyle,
  "attributors/style/direction": DirectionStyle,
  "attributors/style/font": FontStyle,
  "attributors/style/size": SizeStyle
}, !0);
Quill.register({
  "formats/align": AlignClass,
  "formats/direction": DirectionClass,
  "formats/indent": IndentClass,
  "formats/background": BackgroundStyle,
  "formats/color": ColorStyle,
  "formats/font": FontClass,
  "formats/size": SizeClass,
  "formats/blockquote": Blockquote,
  "formats/code-block": CodeBlock,
  "formats/header": Header,
  "formats/list": ListItem,
  "formats/bold": Bold,
  "formats/code": Code,
  "formats/italic": Italic,
  "formats/link": Link,
  "formats/script": Script,
  "formats/strike": Strike,
  "formats/underline": Underline,
  "formats/formula": Formula,
  "formats/image": Image,
  "formats/video": Video,
  "modules/syntax": Syntax,
  "modules/table": Table,
  "modules/toolbar": Toolbar,
  "themes/bubble": BubbleTheme,
  "themes/snow": SnowTheme,
  "ui/icons": Icons,
  "ui/picker": Picker,
  "ui/icon-picker": IconPicker,
  "ui/color-picker": ColorPicker,
  "ui/tooltip": Tooltip
}, !0);
var lib$5 = {}, Parser$3 = {}, Tokenizer = {}, decode = {}, decodeDataHtml = {};
Object.defineProperty(decodeDataHtml, "__esModule", { value: !0 });
decodeDataHtml.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(td) {
    return td.charCodeAt(0);
  })
);
var decodeDataXml = {};
Object.defineProperty(decodeDataXml, "__esModule", { value: !0 });
decodeDataXml.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(td) {
    return td.charCodeAt(0);
  })
);
var decode_codepoint = {};
(function(td) {
  var Ae;
  Object.defineProperty(td, "__esModule", { value: !0 }), td.replaceCodePoint = td.fromCodePoint = void 0;
  var xr = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  td.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (Ae = String.fromCodePoint) !== null && Ae !== void 0 ? Ae : function(od) {
    var ad = "";
    return od > 65535 && (od -= 65536, ad += String.fromCharCode(od >>> 10 & 1023 | 55296), od = 56320 | od & 1023), ad += String.fromCharCode(od), ad;
  };
  function ed(od) {
    var ad;
    return od >= 55296 && od <= 57343 || od > 1114111 ? 65533 : (ad = xr.get(od)) !== null && ad !== void 0 ? ad : od;
  }
  td.replaceCodePoint = ed;
  function id(od) {
    return (0, td.fromCodePoint)(ed(od));
  }
  td.default = id;
})(decode_codepoint);
(function(td) {
  var Ae = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Cd, wd, Ld, kd) {
    kd === void 0 && (kd = Ld);
    var Dd = Object.getOwnPropertyDescriptor(wd, Ld);
    (!Dd || ("get" in Dd ? !wd.__esModule : Dd.writable || Dd.configurable)) && (Dd = { enumerable: !0, get: function() {
      return wd[Ld];
    } }), Object.defineProperty(Cd, kd, Dd);
  } : function(Cd, wd, Ld, kd) {
    kd === void 0 && (kd = Ld), Cd[kd] = wd[Ld];
  }), xr = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Cd, wd) {
    Object.defineProperty(Cd, "default", { enumerable: !0, value: wd });
  } : function(Cd, wd) {
    Cd.default = wd;
  }), ed = commonjsGlobal && commonjsGlobal.__importStar || function(Cd) {
    if (Cd && Cd.__esModule)
      return Cd;
    var wd = {};
    if (Cd != null)
      for (var Ld in Cd)
        Ld !== "default" && Object.prototype.hasOwnProperty.call(Cd, Ld) && Ae(wd, Cd, Ld);
    return xr(wd, Cd), wd;
  }, id = commonjsGlobal && commonjsGlobal.__importDefault || function(Cd) {
    return Cd && Cd.__esModule ? Cd : { default: Cd };
  };
  Object.defineProperty(td, "__esModule", { value: !0 }), td.decodeXML = td.decodeHTMLStrict = td.decodeHTMLAttribute = td.decodeHTML = td.determineBranch = td.EntityDecoder = td.DecodingMode = td.BinTrieFlags = td.fromCodePoint = td.replaceCodePoint = td.decodeCodePoint = td.xmlDecodeTree = td.htmlDecodeTree = void 0;
  var od = id(decodeDataHtml);
  td.htmlDecodeTree = od.default;
  var ad = id(decodeDataXml);
  td.xmlDecodeTree = ad.default;
  var rd = ed(decode_codepoint);
  td.decodeCodePoint = rd.default;
  var sd = decode_codepoint;
  Object.defineProperty(td, "replaceCodePoint", { enumerable: !0, get: function() {
    return sd.replaceCodePoint;
  } }), Object.defineProperty(td, "fromCodePoint", { enumerable: !0, get: function() {
    return sd.fromCodePoint;
  } });
  var nd;
  (function(Cd) {
    Cd[Cd.NUM = 35] = "NUM", Cd[Cd.SEMI = 59] = "SEMI", Cd[Cd.EQUALS = 61] = "EQUALS", Cd[Cd.ZERO = 48] = "ZERO", Cd[Cd.NINE = 57] = "NINE", Cd[Cd.LOWER_A = 97] = "LOWER_A", Cd[Cd.LOWER_F = 102] = "LOWER_F", Cd[Cd.LOWER_X = 120] = "LOWER_X", Cd[Cd.LOWER_Z = 122] = "LOWER_Z", Cd[Cd.UPPER_A = 65] = "UPPER_A", Cd[Cd.UPPER_F = 70] = "UPPER_F", Cd[Cd.UPPER_Z = 90] = "UPPER_Z";
  })(nd || (nd = {}));
  var cd = 32, ud;
  (function(Cd) {
    Cd[Cd.VALUE_LENGTH = 49152] = "VALUE_LENGTH", Cd[Cd.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", Cd[Cd.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(ud = td.BinTrieFlags || (td.BinTrieFlags = {}));
  function ld(Cd) {
    return Cd >= nd.ZERO && Cd <= nd.NINE;
  }
  function dd(Cd) {
    return Cd >= nd.UPPER_A && Cd <= nd.UPPER_F || Cd >= nd.LOWER_A && Cd <= nd.LOWER_F;
  }
  function pd(Cd) {
    return Cd >= nd.UPPER_A && Cd <= nd.UPPER_Z || Cd >= nd.LOWER_A && Cd <= nd.LOWER_Z || ld(Cd);
  }
  function md(Cd) {
    return Cd === nd.EQUALS || pd(Cd);
  }
  var fd;
  (function(Cd) {
    Cd[Cd.EntityStart = 0] = "EntityStart", Cd[Cd.NumericStart = 1] = "NumericStart", Cd[Cd.NumericDecimal = 2] = "NumericDecimal", Cd[Cd.NumericHex = 3] = "NumericHex", Cd[Cd.NamedEntity = 4] = "NamedEntity";
  })(fd || (fd = {}));
  var bd;
  (function(Cd) {
    Cd[Cd.Legacy = 0] = "Legacy", Cd[Cd.Strict = 1] = "Strict", Cd[Cd.Attribute = 2] = "Attribute";
  })(bd = td.DecodingMode || (td.DecodingMode = {}));
  var Sd = (
    /** @class */
    function() {
      function Cd(wd, Ld, kd) {
        this.decodeTree = wd, this.emitCodePoint = Ld, this.errors = kd, this.state = fd.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = bd.Strict;
      }
      return Cd.prototype.startEntity = function(wd) {
        this.decodeMode = wd, this.state = fd.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, Cd.prototype.write = function(wd, Ld) {
        switch (this.state) {
          case fd.EntityStart:
            return wd.charCodeAt(Ld) === nd.NUM ? (this.state = fd.NumericStart, this.consumed += 1, this.stateNumericStart(wd, Ld + 1)) : (this.state = fd.NamedEntity, this.stateNamedEntity(wd, Ld));
          case fd.NumericStart:
            return this.stateNumericStart(wd, Ld);
          case fd.NumericDecimal:
            return this.stateNumericDecimal(wd, Ld);
          case fd.NumericHex:
            return this.stateNumericHex(wd, Ld);
          case fd.NamedEntity:
            return this.stateNamedEntity(wd, Ld);
        }
      }, Cd.prototype.stateNumericStart = function(wd, Ld) {
        return Ld >= wd.length ? -1 : (wd.charCodeAt(Ld) | cd) === nd.LOWER_X ? (this.state = fd.NumericHex, this.consumed += 1, this.stateNumericHex(wd, Ld + 1)) : (this.state = fd.NumericDecimal, this.stateNumericDecimal(wd, Ld));
      }, Cd.prototype.addToNumericResult = function(wd, Ld, kd, Dd) {
        if (Ld !== kd) {
          var Fd = kd - Ld;
          this.result = this.result * Math.pow(Dd, Fd) + parseInt(wd.substr(Ld, Fd), Dd), this.consumed += Fd;
        }
      }, Cd.prototype.stateNumericHex = function(wd, Ld) {
        for (var kd = Ld; Ld < wd.length; ) {
          var Dd = wd.charCodeAt(Ld);
          if (ld(Dd) || dd(Dd))
            Ld += 1;
          else
            return this.addToNumericResult(wd, kd, Ld, 16), this.emitNumericEntity(Dd, 3);
        }
        return this.addToNumericResult(wd, kd, Ld, 16), -1;
      }, Cd.prototype.stateNumericDecimal = function(wd, Ld) {
        for (var kd = Ld; Ld < wd.length; ) {
          var Dd = wd.charCodeAt(Ld);
          if (ld(Dd))
            Ld += 1;
          else
            return this.addToNumericResult(wd, kd, Ld, 10), this.emitNumericEntity(Dd, 2);
        }
        return this.addToNumericResult(wd, kd, Ld, 10), -1;
      }, Cd.prototype.emitNumericEntity = function(wd, Ld) {
        var kd;
        if (this.consumed <= Ld)
          return (kd = this.errors) === null || kd === void 0 || kd.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (wd === nd.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === bd.Strict)
          return 0;
        return this.emitCodePoint((0, rd.replaceCodePoint)(this.result), this.consumed), this.errors && (wd !== nd.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, Cd.prototype.stateNamedEntity = function(wd, Ld) {
        for (var kd = this.decodeTree, Dd = kd[this.treeIndex], Fd = (Dd & ud.VALUE_LENGTH) >> 14; Ld < wd.length; Ld++, this.excess++) {
          var xd = wd.charCodeAt(Ld);
          if (this.treeIndex = Ed(kd, Dd, this.treeIndex + Math.max(1, Fd), xd), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === bd.Attribute && // We shouldn't have consumed any characters after the entity,
            (Fd === 0 || // And there should be no invalid characters.
            md(xd)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (Dd = kd[this.treeIndex], Fd = (Dd & ud.VALUE_LENGTH) >> 14, Fd !== 0) {
            if (xd === nd.SEMI)
              return this.emitNamedEntityData(this.treeIndex, Fd, this.consumed + this.excess);
            this.decodeMode !== bd.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, Cd.prototype.emitNotTerminatedNamedEntity = function() {
        var wd, Ld = this, kd = Ld.result, Dd = Ld.decodeTree, Fd = (Dd[kd] & ud.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(kd, Fd, this.consumed), (wd = this.errors) === null || wd === void 0 || wd.missingSemicolonAfterCharacterReference(), this.consumed;
      }, Cd.prototype.emitNamedEntityData = function(wd, Ld, kd) {
        var Dd = this.decodeTree;
        return this.emitCodePoint(Ld === 1 ? Dd[wd] & ~ud.VALUE_LENGTH : Dd[wd + 1], kd), Ld === 3 && this.emitCodePoint(Dd[wd + 2], kd), kd;
      }, Cd.prototype.end = function() {
        var wd;
        switch (this.state) {
          case fd.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== bd.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case fd.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case fd.NumericHex:
            return this.emitNumericEntity(0, 3);
          case fd.NumericStart:
            return (wd = this.errors) === null || wd === void 0 || wd.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case fd.EntityStart:
            return 0;
        }
      }, Cd;
    }()
  );
  td.EntityDecoder = Sd;
  function vd(Cd) {
    var wd = "", Ld = new Sd(Cd, function(kd) {
      return wd += (0, rd.fromCodePoint)(kd);
    });
    return function(Dd, Fd) {
      for (var xd = 0, Ad = 0; (Ad = Dd.indexOf("&", Ad)) >= 0; ) {
        wd += Dd.slice(xd, Ad), Ld.startEntity(Fd);
        var Nd = Ld.write(
          Dd,
          // Skip the "&"
          Ad + 1
        );
        if (Nd < 0) {
          xd = Ad + Ld.end();
          break;
        }
        xd = Ad + Nd, Ad = Nd === 0 ? xd + 1 : xd;
      }
      var zd = wd + Dd.slice(xd);
      return wd = "", zd;
    };
  }
  function Ed(Cd, wd, Ld, kd) {
    var Dd = (wd & ud.BRANCH_LENGTH) >> 7, Fd = wd & ud.JUMP_TABLE;
    if (Dd === 0)
      return Fd !== 0 && kd === Fd ? Ld : -1;
    if (Fd) {
      var xd = kd - Fd;
      return xd < 0 || xd >= Dd ? -1 : Cd[Ld + xd] - 1;
    }
    for (var Ad = Ld, Nd = Ad + Dd - 1; Ad <= Nd; ) {
      var zd = Ad + Nd >>> 1, Wd = Cd[zd];
      if (Wd < kd)
        Ad = zd + 1;
      else if (Wd > kd)
        Nd = zd - 1;
      else
        return Cd[zd + Dd];
    }
    return -1;
  }
  td.determineBranch = Ed;
  var Td = vd(od.default), Gd = vd(ad.default);
  function Id(Cd, wd) {
    return wd === void 0 && (wd = bd.Legacy), Td(Cd, wd);
  }
  td.decodeHTML = Id;
  function Pd(Cd) {
    return Td(Cd, bd.Attribute);
  }
  td.decodeHTMLAttribute = Pd;
  function Hd(Cd) {
    return Td(Cd, bd.Strict);
  }
  td.decodeHTMLStrict = Hd;
  function Rd(Cd) {
    return Gd(Cd, bd.Strict);
  }
  td.decodeXML = Rd;
})(decode);
(function(td) {
  Object.defineProperty(td, "__esModule", { value: !0 }), td.QuoteType = void 0;
  var Ae = decode, xr;
  (function(ld) {
    ld[ld.Tab = 9] = "Tab", ld[ld.NewLine = 10] = "NewLine", ld[ld.FormFeed = 12] = "FormFeed", ld[ld.CarriageReturn = 13] = "CarriageReturn", ld[ld.Space = 32] = "Space", ld[ld.ExclamationMark = 33] = "ExclamationMark", ld[ld.Number = 35] = "Number", ld[ld.Amp = 38] = "Amp", ld[ld.SingleQuote = 39] = "SingleQuote", ld[ld.DoubleQuote = 34] = "DoubleQuote", ld[ld.Dash = 45] = "Dash", ld[ld.Slash = 47] = "Slash", ld[ld.Zero = 48] = "Zero", ld[ld.Nine = 57] = "Nine", ld[ld.Semi = 59] = "Semi", ld[ld.Lt = 60] = "Lt", ld[ld.Eq = 61] = "Eq", ld[ld.Gt = 62] = "Gt", ld[ld.Questionmark = 63] = "Questionmark", ld[ld.UpperA = 65] = "UpperA", ld[ld.LowerA = 97] = "LowerA", ld[ld.UpperF = 70] = "UpperF", ld[ld.LowerF = 102] = "LowerF", ld[ld.UpperZ = 90] = "UpperZ", ld[ld.LowerZ = 122] = "LowerZ", ld[ld.LowerX = 120] = "LowerX", ld[ld.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(xr || (xr = {}));
  var ed;
  (function(ld) {
    ld[ld.Text = 1] = "Text", ld[ld.BeforeTagName = 2] = "BeforeTagName", ld[ld.InTagName = 3] = "InTagName", ld[ld.InSelfClosingTag = 4] = "InSelfClosingTag", ld[ld.BeforeClosingTagName = 5] = "BeforeClosingTagName", ld[ld.InClosingTagName = 6] = "InClosingTagName", ld[ld.AfterClosingTagName = 7] = "AfterClosingTagName", ld[ld.BeforeAttributeName = 8] = "BeforeAttributeName", ld[ld.InAttributeName = 9] = "InAttributeName", ld[ld.AfterAttributeName = 10] = "AfterAttributeName", ld[ld.BeforeAttributeValue = 11] = "BeforeAttributeValue", ld[ld.InAttributeValueDq = 12] = "InAttributeValueDq", ld[ld.InAttributeValueSq = 13] = "InAttributeValueSq", ld[ld.InAttributeValueNq = 14] = "InAttributeValueNq", ld[ld.BeforeDeclaration = 15] = "BeforeDeclaration", ld[ld.InDeclaration = 16] = "InDeclaration", ld[ld.InProcessingInstruction = 17] = "InProcessingInstruction", ld[ld.BeforeComment = 18] = "BeforeComment", ld[ld.CDATASequence = 19] = "CDATASequence", ld[ld.InSpecialComment = 20] = "InSpecialComment", ld[ld.InCommentLike = 21] = "InCommentLike", ld[ld.BeforeSpecialS = 22] = "BeforeSpecialS", ld[ld.SpecialStartSequence = 23] = "SpecialStartSequence", ld[ld.InSpecialTag = 24] = "InSpecialTag", ld[ld.BeforeEntity = 25] = "BeforeEntity", ld[ld.BeforeNumericEntity = 26] = "BeforeNumericEntity", ld[ld.InNamedEntity = 27] = "InNamedEntity", ld[ld.InNumericEntity = 28] = "InNumericEntity", ld[ld.InHexEntity = 29] = "InHexEntity";
  })(ed || (ed = {}));
  function id(ld) {
    return ld === xr.Space || ld === xr.NewLine || ld === xr.Tab || ld === xr.FormFeed || ld === xr.CarriageReturn;
  }
  function od(ld) {
    return ld === xr.Slash || ld === xr.Gt || id(ld);
  }
  function ad(ld) {
    return ld >= xr.Zero && ld <= xr.Nine;
  }
  function rd(ld) {
    return ld >= xr.LowerA && ld <= xr.LowerZ || ld >= xr.UpperA && ld <= xr.UpperZ;
  }
  function sd(ld) {
    return ld >= xr.UpperA && ld <= xr.UpperF || ld >= xr.LowerA && ld <= xr.LowerF;
  }
  var nd;
  (function(ld) {
    ld[ld.NoValue = 0] = "NoValue", ld[ld.Unquoted = 1] = "Unquoted", ld[ld.Single = 2] = "Single", ld[ld.Double = 3] = "Double";
  })(nd = td.QuoteType || (td.QuoteType = {}));
  var cd = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, ud = (
    /** @class */
    function() {
      function ld(dd, pd) {
        var md = dd.xmlMode, fd = md === void 0 ? !1 : md, bd = dd.decodeEntities, Sd = bd === void 0 ? !0 : bd;
        this.cbs = pd, this.state = ed.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = ed.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = fd, this.decodeEntities = Sd, this.entityTrie = fd ? Ae.xmlDecodeTree : Ae.htmlDecodeTree;
      }
      return ld.prototype.reset = function() {
        this.state = ed.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = ed.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, ld.prototype.write = function(dd) {
        this.offset += this.buffer.length, this.buffer = dd, this.parse();
      }, ld.prototype.end = function() {
        this.running && this.finish();
      }, ld.prototype.pause = function() {
        this.running = !1;
      }, ld.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, ld.prototype.getIndex = function() {
        return this.index;
      }, ld.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, ld.prototype.stateText = function(dd) {
        dd === xr.Lt || !this.decodeEntities && this.fastForwardTo(xr.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = ed.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && dd === xr.Amp && (this.state = ed.BeforeEntity);
      }, ld.prototype.stateSpecialStartSequence = function(dd) {
        var pd = this.sequenceIndex === this.currentSequence.length, md = pd ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          od(dd)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (dd | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!md)
          this.isSpecial = !1;
        else if (!pd) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = ed.InTagName, this.stateInTagName(dd);
      }, ld.prototype.stateInSpecialTag = function(dd) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (dd === xr.Gt || id(dd)) {
            var pd = this.index - this.currentSequence.length;
            if (this.sectionStart < pd) {
              var md = this.index;
              this.index = pd, this.cbs.ontext(this.sectionStart, pd), this.index = md;
            }
            this.isSpecial = !1, this.sectionStart = pd + 2, this.stateInClosingTagName(dd);
            return;
          }
          this.sequenceIndex = 0;
        }
        (dd | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === cd.TitleEnd ? this.decodeEntities && dd === xr.Amp && (this.state = ed.BeforeEntity) : this.fastForwardTo(xr.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(dd === xr.Lt);
      }, ld.prototype.stateCDATASequence = function(dd) {
        dd === cd.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === cd.Cdata.length && (this.state = ed.InCommentLike, this.currentSequence = cd.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = ed.InDeclaration, this.stateInDeclaration(dd));
      }, ld.prototype.fastForwardTo = function(dd) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === dd)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, ld.prototype.stateInCommentLike = function(dd) {
        dd === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === cd.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = ed.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : dd !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, ld.prototype.isTagStartChar = function(dd) {
        return this.xmlMode ? !od(dd) : rd(dd);
      }, ld.prototype.startSpecial = function(dd, pd) {
        this.isSpecial = !0, this.currentSequence = dd, this.sequenceIndex = pd, this.state = ed.SpecialStartSequence;
      }, ld.prototype.stateBeforeTagName = function(dd) {
        if (dd === xr.ExclamationMark)
          this.state = ed.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (dd === xr.Questionmark)
          this.state = ed.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(dd)) {
          var pd = dd | 32;
          this.sectionStart = this.index, !this.xmlMode && pd === cd.TitleEnd[2] ? this.startSpecial(cd.TitleEnd, 3) : this.state = !this.xmlMode && pd === cd.ScriptEnd[2] ? ed.BeforeSpecialS : ed.InTagName;
        } else
          dd === xr.Slash ? this.state = ed.BeforeClosingTagName : (this.state = ed.Text, this.stateText(dd));
      }, ld.prototype.stateInTagName = function(dd) {
        od(dd) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = ed.BeforeAttributeName, this.stateBeforeAttributeName(dd));
      }, ld.prototype.stateBeforeClosingTagName = function(dd) {
        id(dd) || (dd === xr.Gt ? this.state = ed.Text : (this.state = this.isTagStartChar(dd) ? ed.InClosingTagName : ed.InSpecialComment, this.sectionStart = this.index));
      }, ld.prototype.stateInClosingTagName = function(dd) {
        (dd === xr.Gt || id(dd)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = ed.AfterClosingTagName, this.stateAfterClosingTagName(dd));
      }, ld.prototype.stateAfterClosingTagName = function(dd) {
        (dd === xr.Gt || this.fastForwardTo(xr.Gt)) && (this.state = ed.Text, this.baseState = ed.Text, this.sectionStart = this.index + 1);
      }, ld.prototype.stateBeforeAttributeName = function(dd) {
        dd === xr.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = ed.InSpecialTag, this.sequenceIndex = 0) : this.state = ed.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : dd === xr.Slash ? this.state = ed.InSelfClosingTag : id(dd) || (this.state = ed.InAttributeName, this.sectionStart = this.index);
      }, ld.prototype.stateInSelfClosingTag = function(dd) {
        dd === xr.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = ed.Text, this.baseState = ed.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : id(dd) || (this.state = ed.BeforeAttributeName, this.stateBeforeAttributeName(dd));
      }, ld.prototype.stateInAttributeName = function(dd) {
        (dd === xr.Eq || od(dd)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = ed.AfterAttributeName, this.stateAfterAttributeName(dd));
      }, ld.prototype.stateAfterAttributeName = function(dd) {
        dd === xr.Eq ? this.state = ed.BeforeAttributeValue : dd === xr.Slash || dd === xr.Gt ? (this.cbs.onattribend(nd.NoValue, this.index), this.state = ed.BeforeAttributeName, this.stateBeforeAttributeName(dd)) : id(dd) || (this.cbs.onattribend(nd.NoValue, this.index), this.state = ed.InAttributeName, this.sectionStart = this.index);
      }, ld.prototype.stateBeforeAttributeValue = function(dd) {
        dd === xr.DoubleQuote ? (this.state = ed.InAttributeValueDq, this.sectionStart = this.index + 1) : dd === xr.SingleQuote ? (this.state = ed.InAttributeValueSq, this.sectionStart = this.index + 1) : id(dd) || (this.sectionStart = this.index, this.state = ed.InAttributeValueNq, this.stateInAttributeValueNoQuotes(dd));
      }, ld.prototype.handleInAttributeValue = function(dd, pd) {
        dd === pd || !this.decodeEntities && this.fastForwardTo(pd) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(pd === xr.DoubleQuote ? nd.Double : nd.Single, this.index), this.state = ed.BeforeAttributeName) : this.decodeEntities && dd === xr.Amp && (this.baseState = this.state, this.state = ed.BeforeEntity);
      }, ld.prototype.stateInAttributeValueDoubleQuotes = function(dd) {
        this.handleInAttributeValue(dd, xr.DoubleQuote);
      }, ld.prototype.stateInAttributeValueSingleQuotes = function(dd) {
        this.handleInAttributeValue(dd, xr.SingleQuote);
      }, ld.prototype.stateInAttributeValueNoQuotes = function(dd) {
        id(dd) || dd === xr.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(nd.Unquoted, this.index), this.state = ed.BeforeAttributeName, this.stateBeforeAttributeName(dd)) : this.decodeEntities && dd === xr.Amp && (this.baseState = this.state, this.state = ed.BeforeEntity);
      }, ld.prototype.stateBeforeDeclaration = function(dd) {
        dd === xr.OpeningSquareBracket ? (this.state = ed.CDATASequence, this.sequenceIndex = 0) : this.state = dd === xr.Dash ? ed.BeforeComment : ed.InDeclaration;
      }, ld.prototype.stateInDeclaration = function(dd) {
        (dd === xr.Gt || this.fastForwardTo(xr.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = ed.Text, this.sectionStart = this.index + 1);
      }, ld.prototype.stateInProcessingInstruction = function(dd) {
        (dd === xr.Gt || this.fastForwardTo(xr.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = ed.Text, this.sectionStart = this.index + 1);
      }, ld.prototype.stateBeforeComment = function(dd) {
        dd === xr.Dash ? (this.state = ed.InCommentLike, this.currentSequence = cd.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = ed.InDeclaration;
      }, ld.prototype.stateInSpecialComment = function(dd) {
        (dd === xr.Gt || this.fastForwardTo(xr.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = ed.Text, this.sectionStart = this.index + 1);
      }, ld.prototype.stateBeforeSpecialS = function(dd) {
        var pd = dd | 32;
        pd === cd.ScriptEnd[3] ? this.startSpecial(cd.ScriptEnd, 4) : pd === cd.StyleEnd[3] ? this.startSpecial(cd.StyleEnd, 4) : (this.state = ed.InTagName, this.stateInTagName(dd));
      }, ld.prototype.stateBeforeEntity = function(dd) {
        this.entityExcess = 1, this.entityResult = 0, dd === xr.Number ? this.state = ed.BeforeNumericEntity : dd === xr.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = ed.InNamedEntity, this.stateInNamedEntity(dd));
      }, ld.prototype.stateInNamedEntity = function(dd) {
        if (this.entityExcess += 1, this.trieIndex = (0, Ae.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, dd), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var pd = this.trieCurrent & Ae.BinTrieFlags.VALUE_LENGTH;
        if (pd) {
          var md = (pd >> 14) - 1;
          if (!this.allowLegacyEntity() && dd !== xr.Semi)
            this.trieIndex += md;
          else {
            var fd = this.index - this.entityExcess + 1;
            fd > this.sectionStart && this.emitPartial(this.sectionStart, fd), this.entityResult = this.trieIndex, this.trieIndex += md, this.entityExcess = 0, this.sectionStart = this.index + 1, md === 0 && this.emitNamedEntity();
          }
        }
      }, ld.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var dd = (this.entityTrie[this.entityResult] & Ae.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (dd) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~Ae.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, ld.prototype.stateBeforeNumericEntity = function(dd) {
        (dd | 32) === xr.LowerX ? (this.entityExcess++, this.state = ed.InHexEntity) : (this.state = ed.InNumericEntity, this.stateInNumericEntity(dd));
      }, ld.prototype.emitNumericEntity = function(dd) {
        var pd = this.index - this.entityExcess - 1, md = pd + 2 + +(this.state === ed.InHexEntity);
        md !== this.index && (pd > this.sectionStart && this.emitPartial(this.sectionStart, pd), this.sectionStart = this.index + Number(dd), this.emitCodePoint((0, Ae.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, ld.prototype.stateInNumericEntity = function(dd) {
        dd === xr.Semi ? this.emitNumericEntity(!0) : ad(dd) ? (this.entityResult = this.entityResult * 10 + (dd - xr.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, ld.prototype.stateInHexEntity = function(dd) {
        dd === xr.Semi ? this.emitNumericEntity(!0) : ad(dd) ? (this.entityResult = this.entityResult * 16 + (dd - xr.Zero), this.entityExcess++) : sd(dd) ? (this.entityResult = this.entityResult * 16 + ((dd | 32) - xr.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, ld.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === ed.Text || this.baseState === ed.InSpecialTag);
      }, ld.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === ed.Text || this.state === ed.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === ed.InAttributeValueDq || this.state === ed.InAttributeValueSq || this.state === ed.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, ld.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, ld.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var dd = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case ed.Text: {
              this.stateText(dd);
              break;
            }
            case ed.SpecialStartSequence: {
              this.stateSpecialStartSequence(dd);
              break;
            }
            case ed.InSpecialTag: {
              this.stateInSpecialTag(dd);
              break;
            }
            case ed.CDATASequence: {
              this.stateCDATASequence(dd);
              break;
            }
            case ed.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(dd);
              break;
            }
            case ed.InAttributeName: {
              this.stateInAttributeName(dd);
              break;
            }
            case ed.InCommentLike: {
              this.stateInCommentLike(dd);
              break;
            }
            case ed.InSpecialComment: {
              this.stateInSpecialComment(dd);
              break;
            }
            case ed.BeforeAttributeName: {
              this.stateBeforeAttributeName(dd);
              break;
            }
            case ed.InTagName: {
              this.stateInTagName(dd);
              break;
            }
            case ed.InClosingTagName: {
              this.stateInClosingTagName(dd);
              break;
            }
            case ed.BeforeTagName: {
              this.stateBeforeTagName(dd);
              break;
            }
            case ed.AfterAttributeName: {
              this.stateAfterAttributeName(dd);
              break;
            }
            case ed.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(dd);
              break;
            }
            case ed.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(dd);
              break;
            }
            case ed.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(dd);
              break;
            }
            case ed.AfterClosingTagName: {
              this.stateAfterClosingTagName(dd);
              break;
            }
            case ed.BeforeSpecialS: {
              this.stateBeforeSpecialS(dd);
              break;
            }
            case ed.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(dd);
              break;
            }
            case ed.InSelfClosingTag: {
              this.stateInSelfClosingTag(dd);
              break;
            }
            case ed.InDeclaration: {
              this.stateInDeclaration(dd);
              break;
            }
            case ed.BeforeDeclaration: {
              this.stateBeforeDeclaration(dd);
              break;
            }
            case ed.BeforeComment: {
              this.stateBeforeComment(dd);
              break;
            }
            case ed.InProcessingInstruction: {
              this.stateInProcessingInstruction(dd);
              break;
            }
            case ed.InNamedEntity: {
              this.stateInNamedEntity(dd);
              break;
            }
            case ed.BeforeEntity: {
              this.stateBeforeEntity(dd);
              break;
            }
            case ed.InHexEntity: {
              this.stateInHexEntity(dd);
              break;
            }
            case ed.InNumericEntity: {
              this.stateInNumericEntity(dd);
              break;
            }
            default:
              this.stateBeforeNumericEntity(dd);
          }
          this.index++;
        }
        this.cleanup();
      }, ld.prototype.finish = function() {
        this.state === ed.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, ld.prototype.handleTrailingData = function() {
        var dd = this.buffer.length + this.offset;
        this.state === ed.InCommentLike ? this.currentSequence === cd.CdataEnd ? this.cbs.oncdata(this.sectionStart, dd, 0) : this.cbs.oncomment(this.sectionStart, dd, 0) : this.state === ed.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === ed.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === ed.InTagName || this.state === ed.BeforeAttributeName || this.state === ed.BeforeAttributeValue || this.state === ed.AfterAttributeName || this.state === ed.InAttributeName || this.state === ed.InAttributeValueSq || this.state === ed.InAttributeValueDq || this.state === ed.InAttributeValueNq || this.state === ed.InClosingTagName || this.cbs.ontext(this.sectionStart, dd);
      }, ld.prototype.emitPartial = function(dd, pd) {
        this.baseState !== ed.Text && this.baseState !== ed.InSpecialTag ? this.cbs.onattribdata(dd, pd) : this.cbs.ontext(dd, pd);
      }, ld.prototype.emitCodePoint = function(dd) {
        this.baseState !== ed.Text && this.baseState !== ed.InSpecialTag ? this.cbs.onattribentity(dd) : this.cbs.ontextentity(dd);
      }, ld;
    }()
  );
  td.default = ud;
})(Tokenizer);
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(td, Ae, xr, ed) {
  ed === void 0 && (ed = xr);
  var id = Object.getOwnPropertyDescriptor(Ae, xr);
  (!id || ("get" in id ? !Ae.__esModule : id.writable || id.configurable)) && (id = { enumerable: !0, get: function() {
    return Ae[xr];
  } }), Object.defineProperty(td, ed, id);
} : function(td, Ae, xr, ed) {
  ed === void 0 && (ed = xr), td[ed] = Ae[xr];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(td, Ae) {
  Object.defineProperty(td, "default", { enumerable: !0, value: Ae });
} : function(td, Ae) {
  td.default = Ae;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(td) {
  if (td && td.__esModule)
    return td;
  var Ae = {};
  if (td != null)
    for (var xr in td)
      xr !== "default" && Object.prototype.hasOwnProperty.call(td, xr) && __createBinding$1(Ae, td, xr);
  return __setModuleDefault$1(Ae, td), Ae;
};
Object.defineProperty(Parser$3, "__esModule", { value: !0 });
Parser$3.Parser = void 0;
var Tokenizer_js_1 = __importStar$1(Tokenizer), decode_js_1 = decode, formTags = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), pTag = /* @__PURE__ */ new Set(["p"]), tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]), ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]), rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]), openImpliesClose = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", pTag],
  ["h1", pTag],
  ["h2", pTag],
  ["h3", pTag],
  ["h4", pTag],
  ["h5", pTag],
  ["h6", pTag],
  ["select", formTags],
  ["input", formTags],
  ["output", formTags],
  ["button", formTags],
  ["datalist", formTags],
  ["textarea", formTags],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", ddtTags],
  ["dt", ddtTags],
  ["address", pTag],
  ["article", pTag],
  ["aside", pTag],
  ["blockquote", pTag],
  ["details", pTag],
  ["div", pTag],
  ["dl", pTag],
  ["fieldset", pTag],
  ["figcaption", pTag],
  ["figure", pTag],
  ["footer", pTag],
  ["form", pTag],
  ["header", pTag],
  ["hr", pTag],
  ["main", pTag],
  ["nav", pTag],
  ["ol", pTag],
  ["pre", pTag],
  ["section", pTag],
  ["table", pTag],
  ["ul", pTag],
  ["rt", rtpTags],
  ["rp", rtpTags],
  ["tbody", tableSectionTags],
  ["tfoot", tableSectionTags]
]), voidElements = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]), htmlIntegrationElements = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), reNameEnd = /\s|\//, Parser$2 = (
  /** @class */
  function() {
    function td(Ae, xr) {
      xr === void 0 && (xr = {});
      var ed, id, od, ad, rd;
      this.options = xr, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = Ae != null ? Ae : {}, this.lowerCaseTagNames = (ed = xr.lowerCaseTags) !== null && ed !== void 0 ? ed : !xr.xmlMode, this.lowerCaseAttributeNames = (id = xr.lowerCaseAttributeNames) !== null && id !== void 0 ? id : !xr.xmlMode, this.tokenizer = new ((od = xr.Tokenizer) !== null && od !== void 0 ? od : Tokenizer_js_1.default)(this.options, this), (rd = (ad = this.cbs).onparserinit) === null || rd === void 0 || rd.call(ad, this);
    }
    return td.prototype.ontext = function(Ae, xr) {
      var ed, id, od = this.getSlice(Ae, xr);
      this.endIndex = xr - 1, (id = (ed = this.cbs).ontext) === null || id === void 0 || id.call(ed, od), this.startIndex = xr;
    }, td.prototype.ontextentity = function(Ae) {
      var xr, ed, id = this.tokenizer.getSectionStart();
      this.endIndex = id - 1, (ed = (xr = this.cbs).ontext) === null || ed === void 0 || ed.call(xr, (0, decode_js_1.fromCodePoint)(Ae)), this.startIndex = id;
    }, td.prototype.isVoidElement = function(Ae) {
      return !this.options.xmlMode && voidElements.has(Ae);
    }, td.prototype.onopentagname = function(Ae, xr) {
      this.endIndex = xr;
      var ed = this.getSlice(Ae, xr);
      this.lowerCaseTagNames && (ed = ed.toLowerCase()), this.emitOpenTag(ed);
    }, td.prototype.emitOpenTag = function(Ae) {
      var xr, ed, id, od;
      this.openTagStart = this.startIndex, this.tagname = Ae;
      var ad = !this.options.xmlMode && openImpliesClose.get(Ae);
      if (ad)
        for (; this.stack.length > 0 && ad.has(this.stack[this.stack.length - 1]); ) {
          var rd = this.stack.pop();
          (ed = (xr = this.cbs).onclosetag) === null || ed === void 0 || ed.call(xr, rd, !0);
        }
      this.isVoidElement(Ae) || (this.stack.push(Ae), foreignContextElements.has(Ae) ? this.foreignContext.push(!0) : htmlIntegrationElements.has(Ae) && this.foreignContext.push(!1)), (od = (id = this.cbs).onopentagname) === null || od === void 0 || od.call(id, Ae), this.cbs.onopentag && (this.attribs = {});
    }, td.prototype.endOpenTag = function(Ae) {
      var xr, ed;
      this.startIndex = this.openTagStart, this.attribs && ((ed = (xr = this.cbs).onopentag) === null || ed === void 0 || ed.call(xr, this.tagname, this.attribs, Ae), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, td.prototype.onopentagend = function(Ae) {
      this.endIndex = Ae, this.endOpenTag(!1), this.startIndex = Ae + 1;
    }, td.prototype.onclosetag = function(Ae, xr) {
      var ed, id, od, ad, rd, sd;
      this.endIndex = xr;
      var nd = this.getSlice(Ae, xr);
      if (this.lowerCaseTagNames && (nd = nd.toLowerCase()), (foreignContextElements.has(nd) || htmlIntegrationElements.has(nd)) && this.foreignContext.pop(), this.isVoidElement(nd))
        !this.options.xmlMode && nd === "br" && ((id = (ed = this.cbs).onopentagname) === null || id === void 0 || id.call(ed, "br"), (ad = (od = this.cbs).onopentag) === null || ad === void 0 || ad.call(od, "br", {}, !0), (sd = (rd = this.cbs).onclosetag) === null || sd === void 0 || sd.call(rd, "br", !1));
      else {
        var cd = this.stack.lastIndexOf(nd);
        if (cd !== -1)
          if (this.cbs.onclosetag)
            for (var ud = this.stack.length - cd; ud--; )
              this.cbs.onclosetag(this.stack.pop(), ud !== 0);
          else
            this.stack.length = cd;
        else
          !this.options.xmlMode && nd === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = xr + 1;
    }, td.prototype.onselfclosingtag = function(Ae) {
      this.endIndex = Ae, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = Ae + 1) : this.onopentagend(Ae);
    }, td.prototype.closeCurrentTag = function(Ae) {
      var xr, ed, id = this.tagname;
      this.endOpenTag(Ae), this.stack[this.stack.length - 1] === id && ((ed = (xr = this.cbs).onclosetag) === null || ed === void 0 || ed.call(xr, id, !Ae), this.stack.pop());
    }, td.prototype.onattribname = function(Ae, xr) {
      this.startIndex = Ae;
      var ed = this.getSlice(Ae, xr);
      this.attribname = this.lowerCaseAttributeNames ? ed.toLowerCase() : ed;
    }, td.prototype.onattribdata = function(Ae, xr) {
      this.attribvalue += this.getSlice(Ae, xr);
    }, td.prototype.onattribentity = function(Ae) {
      this.attribvalue += (0, decode_js_1.fromCodePoint)(Ae);
    }, td.prototype.onattribend = function(Ae, xr) {
      var ed, id;
      this.endIndex = xr, (id = (ed = this.cbs).onattribute) === null || id === void 0 || id.call(ed, this.attribname, this.attribvalue, Ae === Tokenizer_js_1.QuoteType.Double ? '"' : Ae === Tokenizer_js_1.QuoteType.Single ? "'" : Ae === Tokenizer_js_1.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, td.prototype.getInstructionName = function(Ae) {
      var xr = Ae.search(reNameEnd), ed = xr < 0 ? Ae : Ae.substr(0, xr);
      return this.lowerCaseTagNames && (ed = ed.toLowerCase()), ed;
    }, td.prototype.ondeclaration = function(Ae, xr) {
      this.endIndex = xr;
      var ed = this.getSlice(Ae, xr);
      if (this.cbs.onprocessinginstruction) {
        var id = this.getInstructionName(ed);
        this.cbs.onprocessinginstruction("!".concat(id), "!".concat(ed));
      }
      this.startIndex = xr + 1;
    }, td.prototype.onprocessinginstruction = function(Ae, xr) {
      this.endIndex = xr;
      var ed = this.getSlice(Ae, xr);
      if (this.cbs.onprocessinginstruction) {
        var id = this.getInstructionName(ed);
        this.cbs.onprocessinginstruction("?".concat(id), "?".concat(ed));
      }
      this.startIndex = xr + 1;
    }, td.prototype.oncomment = function(Ae, xr, ed) {
      var id, od, ad, rd;
      this.endIndex = xr, (od = (id = this.cbs).oncomment) === null || od === void 0 || od.call(id, this.getSlice(Ae, xr - ed)), (rd = (ad = this.cbs).oncommentend) === null || rd === void 0 || rd.call(ad), this.startIndex = xr + 1;
    }, td.prototype.oncdata = function(Ae, xr, ed) {
      var id, od, ad, rd, sd, nd, cd, ud, ld, dd;
      this.endIndex = xr;
      var pd = this.getSlice(Ae, xr - ed);
      this.options.xmlMode || this.options.recognizeCDATA ? ((od = (id = this.cbs).oncdatastart) === null || od === void 0 || od.call(id), (rd = (ad = this.cbs).ontext) === null || rd === void 0 || rd.call(ad, pd), (nd = (sd = this.cbs).oncdataend) === null || nd === void 0 || nd.call(sd)) : ((ud = (cd = this.cbs).oncomment) === null || ud === void 0 || ud.call(cd, "[CDATA[".concat(pd, "]]")), (dd = (ld = this.cbs).oncommentend) === null || dd === void 0 || dd.call(ld)), this.startIndex = xr + 1;
    }, td.prototype.onend = function() {
      var Ae, xr;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var ed = this.stack.length; ed > 0; this.cbs.onclosetag(this.stack[--ed], !0))
          ;
      }
      (xr = (Ae = this.cbs).onend) === null || xr === void 0 || xr.call(Ae);
    }, td.prototype.reset = function() {
      var Ae, xr, ed, id;
      (xr = (Ae = this.cbs).onreset) === null || xr === void 0 || xr.call(Ae), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (id = (ed = this.cbs).onparserinit) === null || id === void 0 || id.call(ed, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, td.prototype.parseComplete = function(Ae) {
      this.reset(), this.end(Ae);
    }, td.prototype.getSlice = function(Ae, xr) {
      for (; Ae - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var ed = this.buffers[0].slice(Ae - this.bufferOffset, xr - this.bufferOffset); xr - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), ed += this.buffers[0].slice(0, xr - this.bufferOffset);
      return ed;
    }, td.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, td.prototype.write = function(Ae) {
      var xr, ed;
      if (this.ended) {
        (ed = (xr = this.cbs).onerror) === null || ed === void 0 || ed.call(xr, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(Ae), this.tokenizer.running && (this.tokenizer.write(Ae), this.writeIndex++);
    }, td.prototype.end = function(Ae) {
      var xr, ed;
      if (this.ended) {
        (ed = (xr = this.cbs).onerror) === null || ed === void 0 || ed.call(xr, new Error(".end() after done!"));
        return;
      }
      Ae && this.write(Ae), this.ended = !0, this.tokenizer.end();
    }, td.prototype.pause = function() {
      this.tokenizer.pause();
    }, td.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, td.prototype.parseChunk = function(Ae) {
      this.write(Ae);
    }, td.prototype.done = function(Ae) {
      this.end(Ae);
    }, td;
  }()
);
Parser$3.Parser = Parser$2;
var lib$4 = {}, lib$3 = {};
(function(td) {
  Object.defineProperty(td, "__esModule", { value: !0 }), td.Doctype = td.CDATA = td.Tag = td.Style = td.Script = td.Comment = td.Directive = td.Text = td.Root = td.isTag = td.ElementType = void 0;
  var Ae;
  (function(ed) {
    ed.Root = "root", ed.Text = "text", ed.Directive = "directive", ed.Comment = "comment", ed.Script = "script", ed.Style = "style", ed.Tag = "tag", ed.CDATA = "cdata", ed.Doctype = "doctype";
  })(Ae = td.ElementType || (td.ElementType = {}));
  function xr(ed) {
    return ed.type === Ae.Tag || ed.type === Ae.Script || ed.type === Ae.Style;
  }
  td.isTag = xr, td.Root = Ae.Root, td.Text = Ae.Text, td.Directive = Ae.Directive, td.Comment = Ae.Comment, td.Script = Ae.Script, td.Style = Ae.Style, td.Tag = Ae.Tag, td.CDATA = Ae.CDATA, td.Doctype = Ae.Doctype;
})(lib$3);
var node$1 = {}, __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var td = function(Ae, xr) {
    return td = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ed, id) {
      ed.__proto__ = id;
    } || function(ed, id) {
      for (var od in id)
        Object.prototype.hasOwnProperty.call(id, od) && (ed[od] = id[od]);
    }, td(Ae, xr);
  };
  return function(Ae, xr) {
    if (typeof xr != "function" && xr !== null)
      throw new TypeError("Class extends value " + String(xr) + " is not a constructor or null");
    td(Ae, xr);
    function ed() {
      this.constructor = Ae;
    }
    Ae.prototype = xr === null ? Object.create(xr) : (ed.prototype = xr.prototype, new ed());
  };
}(), __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$1 = Object.assign || function(td) {
    for (var Ae, xr = 1, ed = arguments.length; xr < ed; xr++) {
      Ae = arguments[xr];
      for (var id in Ae)
        Object.prototype.hasOwnProperty.call(Ae, id) && (td[id] = Ae[id]);
    }
    return td;
  }, __assign$1.apply(this, arguments);
};
Object.defineProperty(node$1, "__esModule", { value: !0 });
node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.CDATA = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
var domelementtype_1$1 = lib$3, Node$6 = (
  /** @class */
  function() {
    function td() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(td.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(Ae) {
        this.parent = Ae;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(td.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(Ae) {
        this.prev = Ae;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(td.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(Ae) {
        this.next = Ae;
      },
      enumerable: !1,
      configurable: !0
    }), td.prototype.cloneNode = function(Ae) {
      return Ae === void 0 && (Ae = !1), cloneNode$1(this, Ae);
    }, td;
  }()
);
node$1.Node = Node$6;
var DataNode = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae(xr) {
      var ed = td.call(this) || this;
      return ed.data = xr, ed;
    }
    return Object.defineProperty(Ae.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(xr) {
        this.data = xr;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(Node$6)
);
node$1.DataNode = DataNode;
var Text$1 = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae() {
      var xr = td !== null && td.apply(this, arguments) || this;
      return xr.type = domelementtype_1$1.ElementType.Text, xr;
    }
    return Object.defineProperty(Ae.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(DataNode)
);
node$1.Text = Text$1;
var Comment$5 = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae() {
      var xr = td !== null && td.apply(this, arguments) || this;
      return xr.type = domelementtype_1$1.ElementType.Comment, xr;
    }
    return Object.defineProperty(Ae.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(DataNode)
);
node$1.Comment = Comment$5;
var ProcessingInstruction = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae(xr, ed) {
      var id = td.call(this, ed) || this;
      return id.name = xr, id.type = domelementtype_1$1.ElementType.Directive, id;
    }
    return Object.defineProperty(Ae.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(DataNode)
);
node$1.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae(xr) {
      var ed = td.call(this) || this;
      return ed.children = xr, ed;
    }
    return Object.defineProperty(Ae.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var xr;
        return (xr = this.children[0]) !== null && xr !== void 0 ? xr : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Ae.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Ae.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(xr) {
        this.children = xr;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(Node$6)
);
node$1.NodeWithChildren = NodeWithChildren;
var CDATA = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae() {
      var xr = td !== null && td.apply(this, arguments) || this;
      return xr.type = domelementtype_1$1.ElementType.CDATA, xr;
    }
    return Object.defineProperty(Ae.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(NodeWithChildren)
);
node$1.CDATA = CDATA;
var Document$5 = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae() {
      var xr = td !== null && td.apply(this, arguments) || this;
      return xr.type = domelementtype_1$1.ElementType.Root, xr;
    }
    return Object.defineProperty(Ae.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(NodeWithChildren)
);
node$1.Document = Document$5;
var Element$1 = (
  /** @class */
  function(td) {
    __extends(Ae, td);
    function Ae(xr, ed, id, od) {
      id === void 0 && (id = []), od === void 0 && (od = xr === "script" ? domelementtype_1$1.ElementType.Script : xr === "style" ? domelementtype_1$1.ElementType.Style : domelementtype_1$1.ElementType.Tag);
      var ad = td.call(this, id) || this;
      return ad.name = xr, ad.attribs = ed, ad.type = od, ad;
    }
    return Object.defineProperty(Ae.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Ae.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(xr) {
        this.name = xr;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(Ae.prototype, "attributes", {
      get: function() {
        var xr = this;
        return Object.keys(this.attribs).map(function(ed) {
          var id, od;
          return {
            name: ed,
            value: xr.attribs[ed],
            namespace: (id = xr["x-attribsNamespace"]) === null || id === void 0 ? void 0 : id[ed],
            prefix: (od = xr["x-attribsPrefix"]) === null || od === void 0 ? void 0 : od[ed]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), Ae;
  }(NodeWithChildren)
);
node$1.Element = Element$1;
function isTag(td) {
  return (0, domelementtype_1$1.isTag)(td);
}
node$1.isTag = isTag;
function isCDATA(td) {
  return td.type === domelementtype_1$1.ElementType.CDATA;
}
node$1.isCDATA = isCDATA;
function isText(td) {
  return td.type === domelementtype_1$1.ElementType.Text;
}
node$1.isText = isText;
function isComment(td) {
  return td.type === domelementtype_1$1.ElementType.Comment;
}
node$1.isComment = isComment;
function isDirective(td) {
  return td.type === domelementtype_1$1.ElementType.Directive;
}
node$1.isDirective = isDirective;
function isDocument(td) {
  return td.type === domelementtype_1$1.ElementType.Root;
}
node$1.isDocument = isDocument;
function hasChildren(td) {
  return Object.prototype.hasOwnProperty.call(td, "children");
}
node$1.hasChildren = hasChildren;
function cloneNode$1(td, Ae) {
  Ae === void 0 && (Ae = !1);
  var xr;
  if (isText(td))
    xr = new Text$1(td.data);
  else if (isComment(td))
    xr = new Comment$5(td.data);
  else if (isTag(td)) {
    var ed = Ae ? cloneChildren(td.children) : [], id = new Element$1(td.name, __assign$1({}, td.attribs), ed);
    ed.forEach(function(sd) {
      return sd.parent = id;
    }), td.namespace != null && (id.namespace = td.namespace), td["x-attribsNamespace"] && (id["x-attribsNamespace"] = __assign$1({}, td["x-attribsNamespace"])), td["x-attribsPrefix"] && (id["x-attribsPrefix"] = __assign$1({}, td["x-attribsPrefix"])), xr = id;
  } else if (isCDATA(td)) {
    var ed = Ae ? cloneChildren(td.children) : [], od = new CDATA(ed);
    ed.forEach(function(nd) {
      return nd.parent = od;
    }), xr = od;
  } else if (isDocument(td)) {
    var ed = Ae ? cloneChildren(td.children) : [], ad = new Document$5(ed);
    ed.forEach(function(nd) {
      return nd.parent = ad;
    }), td["x-mode"] && (ad["x-mode"] = td["x-mode"]), xr = ad;
  } else if (isDirective(td)) {
    var rd = new ProcessingInstruction(td.name, td.data);
    td["x-name"] != null && (rd["x-name"] = td["x-name"], rd["x-publicId"] = td["x-publicId"], rd["x-systemId"] = td["x-systemId"]), xr = rd;
  } else
    throw new Error("Not implemented yet: ".concat(td.type));
  return xr.startIndex = td.startIndex, xr.endIndex = td.endIndex, td.sourceCodeLocation != null && (xr.sourceCodeLocation = td.sourceCodeLocation), xr;
}
node$1.cloneNode = cloneNode$1;
function cloneChildren(td) {
  for (var Ae = td.map(function(ed) {
    return cloneNode$1(ed, !0);
  }), xr = 1; xr < Ae.length; xr++)
    Ae[xr].prev = Ae[xr - 1], Ae[xr - 1].next = Ae[xr];
  return Ae;
}
(function(td) {
  var Ae = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(rd, sd, nd, cd) {
    cd === void 0 && (cd = nd);
    var ud = Object.getOwnPropertyDescriptor(sd, nd);
    (!ud || ("get" in ud ? !sd.__esModule : ud.writable || ud.configurable)) && (ud = { enumerable: !0, get: function() {
      return sd[nd];
    } }), Object.defineProperty(rd, cd, ud);
  } : function(rd, sd, nd, cd) {
    cd === void 0 && (cd = nd), rd[cd] = sd[nd];
  }), xr = commonjsGlobal && commonjsGlobal.__exportStar || function(rd, sd) {
    for (var nd in rd)
      nd !== "default" && !Object.prototype.hasOwnProperty.call(sd, nd) && Ae(sd, rd, nd);
  };
  Object.defineProperty(td, "__esModule", { value: !0 }), td.DomHandler = void 0;
  var ed = lib$3, id = node$1;
  xr(node$1, td);
  var od = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, ad = (
    /** @class */
    function() {
      function rd(sd, nd, cd) {
        this.dom = [], this.root = new id.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof nd == "function" && (cd = nd, nd = od), typeof sd == "object" && (nd = sd, sd = void 0), this.callback = sd != null ? sd : null, this.options = nd != null ? nd : od, this.elementCB = cd != null ? cd : null;
      }
      return rd.prototype.onparserinit = function(sd) {
        this.parser = sd;
      }, rd.prototype.onreset = function() {
        this.dom = [], this.root = new id.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, rd.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, rd.prototype.onerror = function(sd) {
        this.handleCallback(sd);
      }, rd.prototype.onclosetag = function() {
        this.lastNode = null;
        var sd = this.tagStack.pop();
        this.options.withEndIndices && (sd.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(sd);
      }, rd.prototype.onopentag = function(sd, nd) {
        var cd = this.options.xmlMode ? ed.ElementType.Tag : void 0, ud = new id.Element(sd, nd, void 0, cd);
        this.addNode(ud), this.tagStack.push(ud);
      }, rd.prototype.ontext = function(sd) {
        var nd = this.lastNode;
        if (nd && nd.type === ed.ElementType.Text)
          nd.data += sd, this.options.withEndIndices && (nd.endIndex = this.parser.endIndex);
        else {
          var cd = new id.Text(sd);
          this.addNode(cd), this.lastNode = cd;
        }
      }, rd.prototype.oncomment = function(sd) {
        if (this.lastNode && this.lastNode.type === ed.ElementType.Comment) {
          this.lastNode.data += sd;
          return;
        }
        var nd = new id.Comment(sd);
        this.addNode(nd), this.lastNode = nd;
      }, rd.prototype.oncommentend = function() {
        this.lastNode = null;
      }, rd.prototype.oncdatastart = function() {
        var sd = new id.Text(""), nd = new id.CDATA([sd]);
        this.addNode(nd), sd.parent = nd, this.lastNode = sd;
      }, rd.prototype.oncdataend = function() {
        this.lastNode = null;
      }, rd.prototype.onprocessinginstruction = function(sd, nd) {
        var cd = new id.ProcessingInstruction(sd, nd);
        this.addNode(cd);
      }, rd.prototype.handleCallback = function(sd) {
        if (typeof this.callback == "function")
          this.callback(sd, this.dom);
        else if (sd)
          throw sd;
      }, rd.prototype.addNode = function(sd) {
        var nd = this.tagStack[this.tagStack.length - 1], cd = nd.children[nd.children.length - 1];
        this.options.withStartIndices && (sd.startIndex = this.parser.startIndex), this.options.withEndIndices && (sd.endIndex = this.parser.endIndex), nd.children.push(sd), cd && (sd.prev = cd, cd.next = sd), sd.parent = nd, this.lastNode = null;
      }, rd;
    }()
  );
  td.DomHandler = ad, td.default = ad;
})(lib$4);
var lib$2 = {}, stringify$5 = {}, lib$1 = {}, lib = {}, encode = {}, encodeHtml = {};
Object.defineProperty(encodeHtml, "__esModule", { value: !0 });
function restoreDiff(td) {
  for (var Ae = 1; Ae < td.length; Ae++)
    td[Ae][0] += td[Ae - 1][0] + 1;
  return td;
}
encodeHtml.default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var _escape = {};
(function(td) {
  Object.defineProperty(td, "__esModule", { value: !0 }), td.escapeText = td.escapeAttribute = td.escapeUTF8 = td.escape = td.encodeXML = td.getCodePoint = td.xmlReplacer = void 0, td.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var Ae = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  td.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(id, od) {
    return id.codePointAt(od);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(id, od) {
      return (id.charCodeAt(od) & 64512) === 55296 ? (id.charCodeAt(od) - 55296) * 1024 + id.charCodeAt(od + 1) - 56320 + 65536 : id.charCodeAt(od);
    }
  );
  function xr(id) {
    for (var od = "", ad = 0, rd; (rd = td.xmlReplacer.exec(id)) !== null; ) {
      var sd = rd.index, nd = id.charCodeAt(sd), cd = Ae.get(nd);
      cd !== void 0 ? (od += id.substring(ad, sd) + cd, ad = sd + 1) : (od += "".concat(id.substring(ad, sd), "&#x").concat((0, td.getCodePoint)(id, sd).toString(16), ";"), ad = td.xmlReplacer.lastIndex += +((nd & 64512) === 55296));
    }
    return od + id.substr(ad);
  }
  td.encodeXML = xr, td.escape = xr;
  function ed(id, od) {
    return function(rd) {
      for (var sd, nd = 0, cd = ""; sd = id.exec(rd); )
        nd !== sd.index && (cd += rd.substring(nd, sd.index)), cd += od.get(sd[0].charCodeAt(0)), nd = sd.index + 1;
      return cd + rd.substring(nd);
    };
  }
  td.escapeUTF8 = ed(/[&<>'"]/g, Ae), td.escapeAttribute = ed(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), td.escapeText = ed(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(_escape);
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(td) {
  return td && td.__esModule ? td : { default: td };
};
Object.defineProperty(encode, "__esModule", { value: !0 });
encode.encodeNonAsciiHTML = encode.encodeHTML = void 0;
var encode_html_js_1 = __importDefault$1(encodeHtml), escape_js_1 = _escape, htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function encodeHTML(td) {
  return encodeHTMLTrieRe(htmlReplacer, td);
}
encode.encodeHTML = encodeHTML;
function encodeNonAsciiHTML(td) {
  return encodeHTMLTrieRe(escape_js_1.xmlReplacer, td);
}
encode.encodeNonAsciiHTML = encodeNonAsciiHTML;
function encodeHTMLTrieRe(td, Ae) {
  for (var xr = "", ed = 0, id; (id = td.exec(Ae)) !== null; ) {
    var od = id.index;
    xr += Ae.substring(ed, od);
    var ad = Ae.charCodeAt(od), rd = encode_html_js_1.default.get(ad);
    if (typeof rd == "object") {
      if (od + 1 < Ae.length) {
        var sd = Ae.charCodeAt(od + 1), nd = typeof rd.n == "number" ? rd.n === sd ? rd.o : void 0 : rd.n.get(sd);
        if (nd !== void 0) {
          xr += nd, ed = td.lastIndex += 1;
          continue;
        }
      }
      rd = rd.v;
    }
    if (rd !== void 0)
      xr += rd, ed = od + 1;
    else {
      var cd = (0, escape_js_1.getCodePoint)(Ae, od);
      xr += "&#x".concat(cd.toString(16), ";"), ed = td.lastIndex += +(cd !== ad);
    }
  }
  return xr + Ae.substr(ed);
}
(function(td) {
  Object.defineProperty(td, "__esModule", { value: !0 }), td.decodeXMLStrict = td.decodeHTML5Strict = td.decodeHTML4Strict = td.decodeHTML5 = td.decodeHTML4 = td.decodeHTMLAttribute = td.decodeHTMLStrict = td.decodeHTML = td.decodeXML = td.DecodingMode = td.EntityDecoder = td.encodeHTML5 = td.encodeHTML4 = td.encodeNonAsciiHTML = td.encodeHTML = td.escapeText = td.escapeAttribute = td.escapeUTF8 = td.escape = td.encodeXML = td.encode = td.decodeStrict = td.decode = td.EncodingMode = td.EntityLevel = void 0;
  var Ae = decode, xr = encode, ed = _escape, id;
  (function(ld) {
    ld[ld.XML = 0] = "XML", ld[ld.HTML = 1] = "HTML";
  })(id = td.EntityLevel || (td.EntityLevel = {}));
  var od;
  (function(ld) {
    ld[ld.UTF8 = 0] = "UTF8", ld[ld.ASCII = 1] = "ASCII", ld[ld.Extensive = 2] = "Extensive", ld[ld.Attribute = 3] = "Attribute", ld[ld.Text = 4] = "Text";
  })(od = td.EncodingMode || (td.EncodingMode = {}));
  function ad(ld, dd) {
    dd === void 0 && (dd = id.XML);
    var pd = typeof dd == "number" ? dd : dd.level;
    if (pd === id.HTML) {
      var md = typeof dd == "object" ? dd.mode : void 0;
      return (0, Ae.decodeHTML)(ld, md);
    }
    return (0, Ae.decodeXML)(ld);
  }
  td.decode = ad;
  function rd(ld, dd) {
    var pd;
    dd === void 0 && (dd = id.XML);
    var md = typeof dd == "number" ? { level: dd } : dd;
    return (pd = md.mode) !== null && pd !== void 0 || (md.mode = Ae.DecodingMode.Strict), ad(ld, md);
  }
  td.decodeStrict = rd;
  function sd(ld, dd) {
    dd === void 0 && (dd = id.XML);
    var pd = typeof dd == "number" ? { level: dd } : dd;
    return pd.mode === od.UTF8 ? (0, ed.escapeUTF8)(ld) : pd.mode === od.Attribute ? (0, ed.escapeAttribute)(ld) : pd.mode === od.Text ? (0, ed.escapeText)(ld) : pd.level === id.HTML ? pd.mode === od.ASCII ? (0, xr.encodeNonAsciiHTML)(ld) : (0, xr.encodeHTML)(ld) : (0, ed.encodeXML)(ld);
  }
  td.encode = sd;
  var nd = _escape;
  Object.defineProperty(td, "encodeXML", { enumerable: !0, get: function() {
    return nd.encodeXML;
  } }), Object.defineProperty(td, "escape", { enumerable: !0, get: function() {
    return nd.escape;
  } }), Object.defineProperty(td, "escapeUTF8", { enumerable: !0, get: function() {
    return nd.escapeUTF8;
  } }), Object.defineProperty(td, "escapeAttribute", { enumerable: !0, get: function() {
    return nd.escapeAttribute;
  } }), Object.defineProperty(td, "escapeText", { enumerable: !0, get: function() {
    return nd.escapeText;
  } });
  var cd = encode;
  Object.defineProperty(td, "encodeHTML", { enumerable: !0, get: function() {
    return cd.encodeHTML;
  } }), Object.defineProperty(td, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return cd.encodeNonAsciiHTML;
  } }), Object.defineProperty(td, "encodeHTML4", { enumerable: !0, get: function() {
    return cd.encodeHTML;
  } }), Object.defineProperty(td, "encodeHTML5", { enumerable: !0, get: function() {
    return cd.encodeHTML;
  } });
  var ud = decode;
  Object.defineProperty(td, "EntityDecoder", { enumerable: !0, get: function() {
    return ud.EntityDecoder;
  } }), Object.defineProperty(td, "DecodingMode", { enumerable: !0, get: function() {
    return ud.DecodingMode;
  } }), Object.defineProperty(td, "decodeXML", { enumerable: !0, get: function() {
    return ud.decodeXML;
  } }), Object.defineProperty(td, "decodeHTML", { enumerable: !0, get: function() {
    return ud.decodeHTML;
  } }), Object.defineProperty(td, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return ud.decodeHTMLStrict;
  } }), Object.defineProperty(td, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return ud.decodeHTMLAttribute;
  } }), Object.defineProperty(td, "decodeHTML4", { enumerable: !0, get: function() {
    return ud.decodeHTML;
  } }), Object.defineProperty(td, "decodeHTML5", { enumerable: !0, get: function() {
    return ud.decodeHTML;
  } }), Object.defineProperty(td, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return ud.decodeHTMLStrict;
  } }), Object.defineProperty(td, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return ud.decodeHTMLStrict;
  } }), Object.defineProperty(td, "decodeXMLStrict", { enumerable: !0, get: function() {
    return ud.decodeXML;
  } });
})(lib);
var foreignNames = {};
Object.defineProperty(foreignNames, "__esModule", { value: !0 });
foreignNames.attributeNames = foreignNames.elementNames = void 0;
foreignNames.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(td) {
  return [td.toLowerCase(), td];
}));
foreignNames.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(td) {
  return [td.toLowerCase(), td];
}));
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign = Object.assign || function(td) {
    for (var Ae, xr = 1, ed = arguments.length; xr < ed; xr++) {
      Ae = arguments[xr];
      for (var id in Ae)
        Object.prototype.hasOwnProperty.call(Ae, id) && (td[id] = Ae[id]);
    }
    return td;
  }, __assign.apply(this, arguments);
}, __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(td, Ae, xr, ed) {
  ed === void 0 && (ed = xr);
  var id = Object.getOwnPropertyDescriptor(Ae, xr);
  (!id || ("get" in id ? !Ae.__esModule : id.writable || id.configurable)) && (id = { enumerable: !0, get: function() {
    return Ae[xr];
  } }), Object.defineProperty(td, ed, id);
} : function(td, Ae, xr, ed) {
  ed === void 0 && (ed = xr), td[ed] = Ae[xr];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(td, Ae) {
  Object.defineProperty(td, "default", { enumerable: !0, value: Ae });
} : function(td, Ae) {
  td.default = Ae;
}), __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(td) {
  if (td && td.__esModule)
    return td;
  var Ae = {};
  if (td != null)
    for (var xr in td)
      xr !== "default" && Object.prototype.hasOwnProperty.call(td, xr) && __createBinding(Ae, td, xr);
  return __setModuleDefault(Ae, td), Ae;
};
Object.defineProperty(lib$1, "__esModule", { value: !0 });
lib$1.render = void 0;
var ElementType = __importStar(lib$3), entities_1 = lib, foreignNames_js_1 = foreignNames, unencodedElements = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function replaceQuotes(td) {
  return td.replace(/"/g, "&quot;");
}
function formatAttributes(td, Ae) {
  var xr;
  if (td) {
    var ed = ((xr = Ae.encodeEntities) !== null && xr !== void 0 ? xr : Ae.decodeEntities) === !1 ? replaceQuotes : Ae.xmlMode || Ae.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
    return Object.keys(td).map(function(id) {
      var od, ad, rd = (od = td[id]) !== null && od !== void 0 ? od : "";
      return Ae.xmlMode === "foreign" && (id = (ad = foreignNames_js_1.attributeNames.get(id)) !== null && ad !== void 0 ? ad : id), !Ae.emptyAttrs && !Ae.xmlMode && rd === "" ? id : "".concat(id, '="').concat(ed(rd), '"');
    }).join(" ");
  }
}
var singleTag = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function render(td, Ae) {
  Ae === void 0 && (Ae = {});
  for (var xr = ("length" in td) ? td : [td], ed = "", id = 0; id < xr.length; id++)
    ed += renderNode(xr[id], Ae);
  return ed;
}
lib$1.render = render;
lib$1.default = render;
function renderNode(td, Ae) {
  switch (td.type) {
    case ElementType.Root:
      return render(td.children, Ae);
    case ElementType.Doctype:
    case ElementType.Directive:
      return renderDirective(td);
    case ElementType.Comment:
      return renderComment(td);
    case ElementType.CDATA:
      return renderCdata(td);
    case ElementType.Script:
    case ElementType.Style:
    case ElementType.Tag:
      return renderTag(td, Ae);
    case ElementType.Text:
      return renderText(td, Ae);
  }
}
var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
function renderTag(td, Ae) {
  var xr;
  Ae.xmlMode === "foreign" && (td.name = (xr = foreignNames_js_1.elementNames.get(td.name)) !== null && xr !== void 0 ? xr : td.name, td.parent && foreignModeIntegrationPoints.has(td.parent.name) && (Ae = __assign(__assign({}, Ae), { xmlMode: !1 }))), !Ae.xmlMode && foreignElements.has(td.name) && (Ae = __assign(__assign({}, Ae), { xmlMode: "foreign" }));
  var ed = "<".concat(td.name), id = formatAttributes(td.attribs, Ae);
  return id && (ed += " ".concat(id)), td.children.length === 0 && (Ae.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    Ae.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    Ae.selfClosingTags && singleTag.has(td.name)
  )) ? (Ae.xmlMode || (ed += " "), ed += "/>") : (ed += ">", td.children.length > 0 && (ed += render(td.children, Ae)), (Ae.xmlMode || !singleTag.has(td.name)) && (ed += "</".concat(td.name, ">"))), ed;
}
function renderDirective(td) {
  return "<".concat(td.data, ">");
}
function renderText(td, Ae) {
  var xr, ed = td.data || "";
  return ((xr = Ae.encodeEntities) !== null && xr !== void 0 ? xr : Ae.decodeEntities) !== !1 && !(!Ae.xmlMode && td.parent && unencodedElements.has(td.parent.name)) && (ed = Ae.xmlMode || Ae.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(ed) : (0, entities_1.escapeText)(ed)), ed;
}
function renderCdata(td) {
  return "<![CDATA[".concat(td.children[0].data, "]]>");
}
function renderComment(td) {
  return "<!--".concat(td.data, "-->");
}
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(td) {
  return td && td.__esModule ? td : { default: td };
};
Object.defineProperty(stringify$5, "__esModule", { value: !0 });
stringify$5.innerText = stringify$5.textContent = stringify$5.getText = stringify$5.getInnerHTML = stringify$5.getOuterHTML = void 0;
var domhandler_1$3 = lib$4, dom_serializer_1 = __importDefault(lib$1), domelementtype_1 = lib$3;
function getOuterHTML(td, Ae) {
  return (0, dom_serializer_1.default)(td, Ae);
}
stringify$5.getOuterHTML = getOuterHTML;
function getInnerHTML(td, Ae) {
  return (0, domhandler_1$3.hasChildren)(td) ? td.children.map(function(xr) {
    return getOuterHTML(xr, Ae);
  }).join("") : "";
}
stringify$5.getInnerHTML = getInnerHTML;
function getText(td) {
  return Array.isArray(td) ? td.map(getText).join("") : (0, domhandler_1$3.isTag)(td) ? td.name === "br" ? `
` : getText(td.children) : (0, domhandler_1$3.isCDATA)(td) ? getText(td.children) : (0, domhandler_1$3.isText)(td) ? td.data : "";
}
stringify$5.getText = getText;
function textContent(td) {
  return Array.isArray(td) ? td.map(textContent).join("") : (0, domhandler_1$3.hasChildren)(td) && !(0, domhandler_1$3.isComment)(td) ? textContent(td.children) : (0, domhandler_1$3.isText)(td) ? td.data : "";
}
stringify$5.textContent = textContent;
function innerText(td) {
  return Array.isArray(td) ? td.map(innerText).join("") : (0, domhandler_1$3.hasChildren)(td) && (td.type === domelementtype_1.ElementType.Tag || (0, domhandler_1$3.isCDATA)(td)) ? innerText(td.children) : (0, domhandler_1$3.isText)(td) ? td.data : "";
}
stringify$5.innerText = innerText;
var traversal = {};
Object.defineProperty(traversal, "__esModule", { value: !0 });
traversal.prevElementSibling = traversal.nextElementSibling = traversal.getName = traversal.hasAttrib = traversal.getAttributeValue = traversal.getSiblings = traversal.getParent = traversal.getChildren = void 0;
var domhandler_1$2 = lib$4;
function getChildren(td) {
  return (0, domhandler_1$2.hasChildren)(td) ? td.children : [];
}
traversal.getChildren = getChildren;
function getParent(td) {
  return td.parent || null;
}
traversal.getParent = getParent;
function getSiblings(td) {
  var Ae, xr, ed = getParent(td);
  if (ed != null)
    return getChildren(ed);
  for (var id = [td], od = td.prev, ad = td.next; od != null; )
    id.unshift(od), Ae = od, od = Ae.prev;
  for (; ad != null; )
    id.push(ad), xr = ad, ad = xr.next;
  return id;
}
traversal.getSiblings = getSiblings;
function getAttributeValue(td, Ae) {
  var xr;
  return (xr = td.attribs) === null || xr === void 0 ? void 0 : xr[Ae];
}
traversal.getAttributeValue = getAttributeValue;
function hasAttrib(td, Ae) {
  return td.attribs != null && Object.prototype.hasOwnProperty.call(td.attribs, Ae) && td.attribs[Ae] != null;
}
traversal.hasAttrib = hasAttrib;
function getName(td) {
  return td.name;
}
traversal.getName = getName;
function nextElementSibling(td) {
  for (var Ae, xr = td.next; xr !== null && !(0, domhandler_1$2.isTag)(xr); )
    Ae = xr, xr = Ae.next;
  return xr;
}
traversal.nextElementSibling = nextElementSibling;
function prevElementSibling(td) {
  for (var Ae, xr = td.prev; xr !== null && !(0, domhandler_1$2.isTag)(xr); )
    Ae = xr, xr = Ae.prev;
  return xr;
}
traversal.prevElementSibling = prevElementSibling;
var manipulation = {};
Object.defineProperty(manipulation, "__esModule", { value: !0 });
manipulation.prepend = manipulation.prependChild = manipulation.append = manipulation.appendChild = manipulation.replaceElement = manipulation.removeElement = void 0;
function removeElement(td) {
  if (td.prev && (td.prev.next = td.next), td.next && (td.next.prev = td.prev), td.parent) {
    var Ae = td.parent.children, xr = Ae.lastIndexOf(td);
    xr >= 0 && Ae.splice(xr, 1);
  }
  td.next = null, td.prev = null, td.parent = null;
}
manipulation.removeElement = removeElement;
function replaceElement(td, Ae) {
  var xr = Ae.prev = td.prev;
  xr && (xr.next = Ae);
  var ed = Ae.next = td.next;
  ed && (ed.prev = Ae);
  var id = Ae.parent = td.parent;
  if (id) {
    var od = id.children;
    od[od.lastIndexOf(td)] = Ae, td.parent = null;
  }
}
manipulation.replaceElement = replaceElement;
function appendChild(td, Ae) {
  if (removeElement(Ae), Ae.next = null, Ae.parent = td, td.children.push(Ae) > 1) {
    var xr = td.children[td.children.length - 2];
    xr.next = Ae, Ae.prev = xr;
  } else
    Ae.prev = null;
}
manipulation.appendChild = appendChild;
function append(td, Ae) {
  removeElement(Ae);
  var xr = td.parent, ed = td.next;
  if (Ae.next = ed, Ae.prev = td, td.next = Ae, Ae.parent = xr, ed) {
    if (ed.prev = Ae, xr) {
      var id = xr.children;
      id.splice(id.lastIndexOf(ed), 0, Ae);
    }
  } else
    xr && xr.children.push(Ae);
}
manipulation.append = append;
function prependChild(td, Ae) {
  if (removeElement(Ae), Ae.parent = td, Ae.prev = null, td.children.unshift(Ae) !== 1) {
    var xr = td.children[1];
    xr.prev = Ae, Ae.next = xr;
  } else
    Ae.next = null;
}
manipulation.prependChild = prependChild;
function prepend(td, Ae) {
  removeElement(Ae);
  var xr = td.parent;
  if (xr) {
    var ed = xr.children;
    ed.splice(ed.indexOf(td), 0, Ae);
  }
  td.prev && (td.prev.next = Ae), Ae.parent = xr, Ae.prev = td.prev, Ae.next = td, td.prev = Ae;
}
manipulation.prepend = prepend;
var querying = {};
Object.defineProperty(querying, "__esModule", { value: !0 });
querying.findAll = querying.existsOne = querying.findOne = querying.findOneChild = querying.find = querying.filter = void 0;
var domhandler_1$1 = lib$4;
function filter$1(td, Ae, xr, ed) {
  return xr === void 0 && (xr = !0), ed === void 0 && (ed = 1 / 0), find(td, Array.isArray(Ae) ? Ae : [Ae], xr, ed);
}
querying.filter = filter$1;
function find(td, Ae, xr, ed) {
  for (var id = [], od = [Ae], ad = [0]; ; ) {
    if (ad[0] >= od[0].length) {
      if (ad.length === 1)
        return id;
      od.shift(), ad.shift();
      continue;
    }
    var rd = od[0][ad[0]++];
    if (td(rd) && (id.push(rd), --ed <= 0))
      return id;
    xr && (0, domhandler_1$1.hasChildren)(rd) && rd.children.length > 0 && (ad.unshift(0), od.unshift(rd.children));
  }
}
querying.find = find;
function findOneChild(td, Ae) {
  return Ae.find(td);
}
querying.findOneChild = findOneChild;
function findOne(td, Ae, xr) {
  xr === void 0 && (xr = !0);
  for (var ed = null, id = 0; id < Ae.length && !ed; id++) {
    var od = Ae[id];
    if ((0, domhandler_1$1.isTag)(od))
      td(od) ? ed = od : xr && od.children.length > 0 && (ed = findOne(td, od.children, !0));
    else
      continue;
  }
  return ed;
}
querying.findOne = findOne;
function existsOne(td, Ae) {
  return Ae.some(function(xr) {
    return (0, domhandler_1$1.isTag)(xr) && (td(xr) || existsOne(td, xr.children));
  });
}
querying.existsOne = existsOne;
function findAll(td, Ae) {
  for (var xr = [], ed = [Ae], id = [0]; ; ) {
    if (id[0] >= ed[0].length) {
      if (ed.length === 1)
        return xr;
      ed.shift(), id.shift();
      continue;
    }
    var od = ed[0][id[0]++];
    (0, domhandler_1$1.isTag)(od) && (td(od) && xr.push(od), od.children.length > 0 && (id.unshift(0), ed.unshift(od.children)));
  }
}
querying.findAll = findAll;
var legacy = {};
Object.defineProperty(legacy, "__esModule", { value: !0 });
legacy.getElementsByTagType = legacy.getElementsByTagName = legacy.getElementById = legacy.getElements = legacy.testElement = void 0;
var domhandler_1 = lib$4, querying_js_1 = querying, Checks = {
  tag_name: function(td) {
    return typeof td == "function" ? function(Ae) {
      return (0, domhandler_1.isTag)(Ae) && td(Ae.name);
    } : td === "*" ? domhandler_1.isTag : function(Ae) {
      return (0, domhandler_1.isTag)(Ae) && Ae.name === td;
    };
  },
  tag_type: function(td) {
    return typeof td == "function" ? function(Ae) {
      return td(Ae.type);
    } : function(Ae) {
      return Ae.type === td;
    };
  },
  tag_contains: function(td) {
    return typeof td == "function" ? function(Ae) {
      return (0, domhandler_1.isText)(Ae) && td(Ae.data);
    } : function(Ae) {
      return (0, domhandler_1.isText)(Ae) && Ae.data === td;
    };
  }
};
function getAttribCheck(td, Ae) {
  return typeof Ae == "function" ? function(xr) {
    return (0, domhandler_1.isTag)(xr) && Ae(xr.attribs[td]);
  } : function(xr) {
    return (0, domhandler_1.isTag)(xr) && xr.attribs[td] === Ae;
  };
}
function combineFuncs(td, Ae) {
  return function(xr) {
    return td(xr) || Ae(xr);
  };
}
function compileTest(td) {
  var Ae = Object.keys(td).map(function(xr) {
    var ed = td[xr];
    return Object.prototype.hasOwnProperty.call(Checks, xr) ? Checks[xr](ed) : getAttribCheck(xr, ed);
  });
  return Ae.length === 0 ? null : Ae.reduce(combineFuncs);
}
function testElement(td, Ae) {
  var xr = compileTest(td);
  return xr ? xr(Ae) : !0;
}
legacy.testElement = testElement;
function getElements(td, Ae, xr, ed) {
  ed === void 0 && (ed = 1 / 0);
  var id = compileTest(td);
  return id ? (0, querying_js_1.filter)(id, Ae, xr, ed) : [];
}
legacy.getElements = getElements;
function getElementById(td, Ae, xr) {
  return xr === void 0 && (xr = !0), Array.isArray(Ae) || (Ae = [Ae]), (0, querying_js_1.findOne)(getAttribCheck("id", td), Ae, xr);
}
legacy.getElementById = getElementById;
function getElementsByTagName(td, Ae, xr, ed) {
  return xr === void 0 && (xr = !0), ed === void 0 && (ed = 1 / 0), (0, querying_js_1.filter)(Checks.tag_name(td), Ae, xr, ed);
}
legacy.getElementsByTagName = getElementsByTagName;
function getElementsByTagType(td, Ae, xr, ed) {
  return xr === void 0 && (xr = !0), ed === void 0 && (ed = 1 / 0), (0, querying_js_1.filter)(Checks.tag_type(td), Ae, xr, ed);
}
legacy.getElementsByTagType = getElementsByTagType;
var helpers = {};
(function(td) {
  Object.defineProperty(td, "__esModule", { value: !0 }), td.uniqueSort = td.compareDocumentPosition = td.DocumentPosition = td.removeSubsets = void 0;
  var Ae = lib$4;
  function xr(ad) {
    for (var rd = ad.length; --rd >= 0; ) {
      var sd = ad[rd];
      if (rd > 0 && ad.lastIndexOf(sd, rd - 1) >= 0) {
        ad.splice(rd, 1);
        continue;
      }
      for (var nd = sd.parent; nd; nd = nd.parent)
        if (ad.includes(nd)) {
          ad.splice(rd, 1);
          break;
        }
    }
    return ad;
  }
  td.removeSubsets = xr;
  var ed;
  (function(ad) {
    ad[ad.DISCONNECTED = 1] = "DISCONNECTED", ad[ad.PRECEDING = 2] = "PRECEDING", ad[ad.FOLLOWING = 4] = "FOLLOWING", ad[ad.CONTAINS = 8] = "CONTAINS", ad[ad.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(ed = td.DocumentPosition || (td.DocumentPosition = {}));
  function id(ad, rd) {
    var sd = [], nd = [];
    if (ad === rd)
      return 0;
    for (var cd = (0, Ae.hasChildren)(ad) ? ad : ad.parent; cd; )
      sd.unshift(cd), cd = cd.parent;
    for (cd = (0, Ae.hasChildren)(rd) ? rd : rd.parent; cd; )
      nd.unshift(cd), cd = cd.parent;
    for (var ud = Math.min(sd.length, nd.length), ld = 0; ld < ud && sd[ld] === nd[ld]; )
      ld++;
    if (ld === 0)
      return ed.DISCONNECTED;
    var dd = sd[ld - 1], pd = dd.children, md = sd[ld], fd = nd[ld];
    return pd.indexOf(md) > pd.indexOf(fd) ? dd === rd ? ed.FOLLOWING | ed.CONTAINED_BY : ed.FOLLOWING : dd === ad ? ed.PRECEDING | ed.CONTAINS : ed.PRECEDING;
  }
  td.compareDocumentPosition = id;
  function od(ad) {
    return ad = ad.filter(function(rd, sd, nd) {
      return !nd.includes(rd, sd + 1);
    }), ad.sort(function(rd, sd) {
      var nd = id(rd, sd);
      return nd & ed.PRECEDING ? -1 : nd & ed.FOLLOWING ? 1 : 0;
    }), ad;
  }
  td.uniqueSort = od;
})(helpers);
var feeds = {};
Object.defineProperty(feeds, "__esModule", { value: !0 });
feeds.getFeed = void 0;
var stringify_js_1 = stringify$5, legacy_js_1 = legacy;
function getFeed(td) {
  var Ae = getOneElement(isValidFeed, td);
  return Ae ? Ae.name === "feed" ? getAtomFeed(Ae) : getRssFeed(Ae) : null;
}
feeds.getFeed = getFeed;
function getAtomFeed(td) {
  var Ae, xr = td.children, ed = {
    type: "atom",
    items: (0, legacy_js_1.getElementsByTagName)("entry", xr).map(function(ad) {
      var rd, sd = ad.children, nd = { media: getMediaElements(sd) };
      addConditionally(nd, "id", "id", sd), addConditionally(nd, "title", "title", sd);
      var cd = (rd = getOneElement("link", sd)) === null || rd === void 0 ? void 0 : rd.attribs.href;
      cd && (nd.link = cd);
      var ud = fetch("summary", sd) || fetch("content", sd);
      ud && (nd.description = ud);
      var ld = fetch("updated", sd);
      return ld && (nd.pubDate = new Date(ld)), nd;
    })
  };
  addConditionally(ed, "id", "id", xr), addConditionally(ed, "title", "title", xr);
  var id = (Ae = getOneElement("link", xr)) === null || Ae === void 0 ? void 0 : Ae.attribs.href;
  id && (ed.link = id), addConditionally(ed, "description", "subtitle", xr);
  var od = fetch("updated", xr);
  return od && (ed.updated = new Date(od)), addConditionally(ed, "author", "email", xr, !0), ed;
}
function getRssFeed(td) {
  var Ae, xr, ed = (xr = (Ae = getOneElement("channel", td.children)) === null || Ae === void 0 ? void 0 : Ae.children) !== null && xr !== void 0 ? xr : [], id = {
    type: td.name.substr(0, 3),
    id: "",
    items: (0, legacy_js_1.getElementsByTagName)("item", td.children).map(function(ad) {
      var rd = ad.children, sd = { media: getMediaElements(rd) };
      addConditionally(sd, "id", "guid", rd), addConditionally(sd, "title", "title", rd), addConditionally(sd, "link", "link", rd), addConditionally(sd, "description", "description", rd);
      var nd = fetch("pubDate", rd) || fetch("dc:date", rd);
      return nd && (sd.pubDate = new Date(nd)), sd;
    })
  };
  addConditionally(id, "title", "title", ed), addConditionally(id, "link", "link", ed), addConditionally(id, "description", "description", ed);
  var od = fetch("lastBuildDate", ed);
  return od && (id.updated = new Date(od)), addConditionally(id, "author", "managingEditor", ed, !0), id;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"], MEDIA_KEYS_INT = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function getMediaElements(td) {
  return (0, legacy_js_1.getElementsByTagName)("media:content", td).map(function(Ae) {
    for (var xr = Ae.attribs, ed = {
      medium: xr.medium,
      isDefault: !!xr.isDefault
    }, id = 0, od = MEDIA_KEYS_STRING; id < od.length; id++) {
      var ad = od[id];
      xr[ad] && (ed[ad] = xr[ad]);
    }
    for (var rd = 0, sd = MEDIA_KEYS_INT; rd < sd.length; rd++) {
      var ad = sd[rd];
      xr[ad] && (ed[ad] = parseInt(xr[ad], 10));
    }
    return xr.expression && (ed.expression = xr.expression), ed;
  });
}
function getOneElement(td, Ae) {
  return (0, legacy_js_1.getElementsByTagName)(td, Ae, !0, 1)[0];
}
function fetch(td, Ae, xr) {
  return xr === void 0 && (xr = !1), (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(td, Ae, xr, 1)).trim();
}
function addConditionally(td, Ae, xr, ed, id) {
  id === void 0 && (id = !1);
  var od = fetch(xr, ed, id);
  od && (td[Ae] = od);
}
function isValidFeed(td) {
  return td === "rss" || td === "feed" || td === "rdf:RDF";
}
(function(td) {
  var Ae = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(id, od, ad, rd) {
    rd === void 0 && (rd = ad);
    var sd = Object.getOwnPropertyDescriptor(od, ad);
    (!sd || ("get" in sd ? !od.__esModule : sd.writable || sd.configurable)) && (sd = { enumerable: !0, get: function() {
      return od[ad];
    } }), Object.defineProperty(id, rd, sd);
  } : function(id, od, ad, rd) {
    rd === void 0 && (rd = ad), id[rd] = od[ad];
  }), xr = commonjsGlobal && commonjsGlobal.__exportStar || function(id, od) {
    for (var ad in id)
      ad !== "default" && !Object.prototype.hasOwnProperty.call(od, ad) && Ae(od, id, ad);
  };
  Object.defineProperty(td, "__esModule", { value: !0 }), td.hasChildren = td.isDocument = td.isComment = td.isText = td.isCDATA = td.isTag = void 0, xr(stringify$5, td), xr(traversal, td), xr(manipulation, td), xr(querying, td), xr(legacy, td), xr(helpers, td), xr(feeds, td);
  var ed = lib$4;
  Object.defineProperty(td, "isTag", { enumerable: !0, get: function() {
    return ed.isTag;
  } }), Object.defineProperty(td, "isCDATA", { enumerable: !0, get: function() {
    return ed.isCDATA;
  } }), Object.defineProperty(td, "isText", { enumerable: !0, get: function() {
    return ed.isText;
  } }), Object.defineProperty(td, "isComment", { enumerable: !0, get: function() {
    return ed.isComment;
  } }), Object.defineProperty(td, "isDocument", { enumerable: !0, get: function() {
    return ed.isDocument;
  } }), Object.defineProperty(td, "hasChildren", { enumerable: !0, get: function() {
    return ed.hasChildren;
  } });
})(lib$2);
(function(td) {
  var Ae = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(bd, Sd, vd, Ed) {
    Ed === void 0 && (Ed = vd);
    var Td = Object.getOwnPropertyDescriptor(Sd, vd);
    (!Td || ("get" in Td ? !Sd.__esModule : Td.writable || Td.configurable)) && (Td = { enumerable: !0, get: function() {
      return Sd[vd];
    } }), Object.defineProperty(bd, Ed, Td);
  } : function(bd, Sd, vd, Ed) {
    Ed === void 0 && (Ed = vd), bd[Ed] = Sd[vd];
  }), xr = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(bd, Sd) {
    Object.defineProperty(bd, "default", { enumerable: !0, value: Sd });
  } : function(bd, Sd) {
    bd.default = Sd;
  }), ed = commonjsGlobal && commonjsGlobal.__importStar || function(bd) {
    if (bd && bd.__esModule)
      return bd;
    var Sd = {};
    if (bd != null)
      for (var vd in bd)
        vd !== "default" && Object.prototype.hasOwnProperty.call(bd, vd) && Ae(Sd, bd, vd);
    return xr(Sd, bd), Sd;
  }, id = commonjsGlobal && commonjsGlobal.__importDefault || function(bd) {
    return bd && bd.__esModule ? bd : { default: bd };
  };
  Object.defineProperty(td, "__esModule", { value: !0 }), td.DomUtils = td.parseFeed = td.getFeed = td.ElementType = td.Tokenizer = td.createDomStream = td.parseDOM = td.parseDocument = td.DefaultHandler = td.DomHandler = td.Parser = void 0;
  var od = Parser$3, ad = Parser$3;
  Object.defineProperty(td, "Parser", { enumerable: !0, get: function() {
    return ad.Parser;
  } });
  var rd = lib$4, sd = lib$4;
  Object.defineProperty(td, "DomHandler", { enumerable: !0, get: function() {
    return sd.DomHandler;
  } }), Object.defineProperty(td, "DefaultHandler", { enumerable: !0, get: function() {
    return sd.DomHandler;
  } });
  function nd(bd, Sd) {
    var vd = new rd.DomHandler(void 0, Sd);
    return new od.Parser(vd, Sd).end(bd), vd.root;
  }
  td.parseDocument = nd;
  function cd(bd, Sd) {
    return nd(bd, Sd).children;
  }
  td.parseDOM = cd;
  function ud(bd, Sd, vd) {
    var Ed = new rd.DomHandler(bd, Sd, vd);
    return new od.Parser(Ed, Sd);
  }
  td.createDomStream = ud;
  var ld = Tokenizer;
  Object.defineProperty(td, "Tokenizer", { enumerable: !0, get: function() {
    return id(ld).default;
  } }), td.ElementType = ed(lib$3);
  var dd = lib$2, pd = lib$2;
  Object.defineProperty(td, "getFeed", { enumerable: !0, get: function() {
    return pd.getFeed;
  } });
  var md = { xmlMode: !0 };
  function fd(bd, Sd) {
    return Sd === void 0 && (Sd = md), (0, dd.getFeed)(cd(bd, Sd));
  }
  td.parseFeed = fd, td.DomUtils = ed(lib$2);
})(lib$5);
var escapeStringRegexp$1 = (td) => {
  if (typeof td != "string")
    throw new TypeError("Expected a string");
  return td.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, isPlainObject$2 = {};
Object.defineProperty(isPlainObject$2, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject(td) {
  return Object.prototype.toString.call(td) === "[object Object]";
}
function isPlainObject$1(td) {
  var Ae, xr;
  return isObject(td) === !1 ? !1 : (Ae = td.constructor, Ae === void 0 ? !0 : (xr = Ae.prototype, !(isObject(xr) === !1 || xr.hasOwnProperty("isPrototypeOf") === !1)));
}
isPlainObject$2.isPlainObject = isPlainObject$1;
var isMergeableObject = function td(Ae) {
  return isNonNullObject(Ae) && !isSpecial(Ae);
};
function isNonNullObject(td) {
  return !!td && typeof td == "object";
}
function isSpecial(td) {
  var Ae = Object.prototype.toString.call(td);
  return Ae === "[object RegExp]" || Ae === "[object Date]" || isReactElement(td);
}
var canUseSymbol = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(td) {
  return td.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(td) {
  return Array.isArray(td) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(td, Ae) {
  return Ae.clone !== !1 && Ae.isMergeableObject(td) ? deepmerge$1(emptyTarget(td), td, Ae) : td;
}
function defaultArrayMerge(td, Ae, xr) {
  return td.concat(Ae).map(function(ed) {
    return cloneUnlessOtherwiseSpecified(ed, xr);
  });
}
function getMergeFunction(td, Ae) {
  if (!Ae.customMerge)
    return deepmerge$1;
  var xr = Ae.customMerge(td);
  return typeof xr == "function" ? xr : deepmerge$1;
}
function getEnumerableOwnPropertySymbols(td) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(td).filter(function(Ae) {
    return Object.propertyIsEnumerable.call(td, Ae);
  }) : [];
}
function getKeys(td) {
  return Object.keys(td).concat(getEnumerableOwnPropertySymbols(td));
}
function propertyIsOnObject(td, Ae) {
  try {
    return Ae in td;
  } catch (xr) {
    return !1;
  }
}
function propertyIsUnsafe(td, Ae) {
  return propertyIsOnObject(td, Ae) && !(Object.hasOwnProperty.call(td, Ae) && Object.propertyIsEnumerable.call(td, Ae));
}
function mergeObject(td, Ae, xr) {
  var ed = {};
  return xr.isMergeableObject(td) && getKeys(td).forEach(function(id) {
    ed[id] = cloneUnlessOtherwiseSpecified(td[id], xr);
  }), getKeys(Ae).forEach(function(id) {
    propertyIsUnsafe(td, id) || (propertyIsOnObject(td, id) && xr.isMergeableObject(Ae[id]) ? ed[id] = getMergeFunction(id, xr)(td[id], Ae[id], xr) : ed[id] = cloneUnlessOtherwiseSpecified(Ae[id], xr));
  }), ed;
}
function deepmerge$1(td, Ae, xr) {
  xr = xr || {}, xr.arrayMerge = xr.arrayMerge || defaultArrayMerge, xr.isMergeableObject = xr.isMergeableObject || isMergeableObject, xr.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var ed = Array.isArray(Ae), id = Array.isArray(td), od = ed === id;
  return od ? ed ? xr.arrayMerge(td, Ae, xr) : mergeObject(td, Ae, xr) : cloneUnlessOtherwiseSpecified(Ae, xr);
}
deepmerge$1.all = function td(Ae, xr) {
  if (!Array.isArray(Ae))
    throw new Error("first argument should be an array");
  return Ae.reduce(function(ed, id) {
    return deepmerge$1(ed, id, xr);
  }, {});
};
var deepmerge_1 = deepmerge$1, cjs = deepmerge_1, parseSrcset$1 = { exports: {} };
(function(td) {
  (function(Ae, xr) {
    td.exports ? td.exports = xr() : Ae.parseSrcset = xr();
  })(commonjsGlobal, function() {
    return function(Ae) {
      function xr(Ed) {
        return Ed === " " || // space
        Ed === "	" || // horizontal tab
        Ed === `
` || // new line
        Ed === "\f" || // form feed
        Ed === "\r";
      }
      function ed(Ed) {
        var Td, Gd = Ed.exec(Ae.substring(fd));
        if (Gd)
          return Td = Gd[0], fd += Td.length, Td;
      }
      for (var id = Ae.length, od = /^[ \t\n\r\u000c]+/, ad = /^[, \t\n\r\u000c]+/, rd = /^[^ \t\n\r\u000c]+/, sd = /[,]+$/, nd = /^\d+$/, cd = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, ud, ld, dd, pd, md, fd = 0, bd = []; ; ) {
        if (ed(ad), fd >= id)
          return bd;
        ud = ed(rd), ld = [], ud.slice(-1) === "," ? (ud = ud.replace(sd, ""), vd()) : Sd();
      }
      function Sd() {
        for (ed(od), dd = "", pd = "in descriptor"; ; ) {
          if (md = Ae.charAt(fd), pd === "in descriptor")
            if (xr(md))
              dd && (ld.push(dd), dd = "", pd = "after descriptor");
            else if (md === ",") {
              fd += 1, dd && ld.push(dd), vd();
              return;
            } else if (md === "(")
              dd = dd + md, pd = "in parens";
            else if (md === "") {
              dd && ld.push(dd), vd();
              return;
            } else
              dd = dd + md;
          else if (pd === "in parens")
            if (md === ")")
              dd = dd + md, pd = "in descriptor";
            else if (md === "") {
              ld.push(dd), vd();
              return;
            } else
              dd = dd + md;
          else if (pd === "after descriptor" && !xr(md))
            if (md === "") {
              vd();
              return;
            } else
              pd = "in descriptor", fd -= 1;
          fd += 1;
        }
      }
      function vd() {
        var Ed = !1, Td, Gd, Id, Pd, Hd = {}, Rd, Cd, wd, Ld, kd;
        for (Pd = 0; Pd < ld.length; Pd++)
          Rd = ld[Pd], Cd = Rd[Rd.length - 1], wd = Rd.substring(0, Rd.length - 1), Ld = parseInt(wd, 10), kd = parseFloat(wd), nd.test(wd) && Cd === "w" ? ((Td || Gd) && (Ed = !0), Ld === 0 ? Ed = !0 : Td = Ld) : cd.test(wd) && Cd === "x" ? ((Td || Gd || Id) && (Ed = !0), kd < 0 ? Ed = !0 : Gd = kd) : nd.test(wd) && Cd === "h" ? ((Id || Gd) && (Ed = !0), Ld === 0 ? Ed = !0 : Id = Ld) : Ed = !0;
        Ed ? console && console.log && console.log("Invalid srcset descriptor found in '" + Ae + "' at '" + Rd + "'.") : (Hd.url = ud, Td && (Hd.w = Td), Gd && (Hd.d = Gd), Id && (Hd.h = Id), bd.push(Hd));
      }
    };
  });
})(parseSrcset$1);
var parseSrcsetExports = parseSrcset$1.exports, picocolors_browser = { exports: {} }, x = String, create = function() {
  return { isColorSupported: !1, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x };
};
picocolors_browser.exports = create();
picocolors_browser.exports.createColors = create;
var picocolors_browserExports = picocolors_browser.exports;
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
let pico = picocolors_browserExports, terminalHighlight$1 = require$$2, CssSyntaxError$3 = class w0 extends Error {
  constructor(Ae, xr, ed, id, od, ad) {
    super(Ae), this.name = "CssSyntaxError", this.reason = Ae, od && (this.file = od), id && (this.source = id), ad && (this.plugin = ad), typeof xr != "undefined" && typeof ed != "undefined" && (typeof xr == "number" ? (this.line = xr, this.column = ed) : (this.line = xr.line, this.column = xr.column, this.endLine = ed.line, this.endColumn = ed.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, w0);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(Ae) {
    if (!this.source)
      return "";
    let xr = this.source;
    Ae == null && (Ae = pico.isColorSupported), terminalHighlight$1 && Ae && (xr = terminalHighlight$1(xr));
    let ed = xr.split(/\r?\n/), id = Math.max(this.line - 3, 0), od = Math.min(this.line + 2, ed.length), ad = String(od).length, rd, sd;
    if (Ae) {
      let { bold: nd, gray: cd, red: ud } = pico.createColors(!0);
      rd = (ld) => nd(ud(ld)), sd = (ld) => cd(ld);
    } else
      rd = sd = (nd) => nd;
    return ed.slice(id, od).map((nd, cd) => {
      let ud = id + 1 + cd, ld = " " + (" " + ud).slice(-ad) + " | ";
      if (ud === this.line) {
        let dd = sd(ld.replace(/\d/g, " ")) + nd.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return rd(">") + sd(ld) + nd + `
 ` + dd + rd("^");
      }
      return " " + sd(ld) + nd;
    }).join(`
`);
  }
  toString() {
    let Ae = this.showSourceCode();
    return Ae && (Ae = `

` + Ae + `
`), this.name + ": " + this.message + Ae;
  }
};
var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;
var symbols = {};
symbols.isClean = Symbol("isClean");
symbols.my = Symbol("my");
const DEFAULT_RAW = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function capitalize(td) {
  return td[0].toUpperCase() + td.slice(1);
}
let Stringifier$2 = class {
  constructor(Ae) {
    this.builder = Ae;
  }
  atrule(Ae, xr) {
    let ed = "@" + Ae.name, id = Ae.params ? this.rawValue(Ae, "params") : "";
    if (typeof Ae.raws.afterName != "undefined" ? ed += Ae.raws.afterName : id && (ed += " "), Ae.nodes)
      this.block(Ae, ed + id);
    else {
      let od = (Ae.raws.between || "") + (xr ? ";" : "");
      this.builder(ed + id + od, Ae);
    }
  }
  beforeAfter(Ae, xr) {
    let ed;
    Ae.type === "decl" ? ed = this.raw(Ae, null, "beforeDecl") : Ae.type === "comment" ? ed = this.raw(Ae, null, "beforeComment") : xr === "before" ? ed = this.raw(Ae, null, "beforeRule") : ed = this.raw(Ae, null, "beforeClose");
    let id = Ae.parent, od = 0;
    for (; id && id.type !== "root"; )
      od += 1, id = id.parent;
    if (ed.includes(`
`)) {
      let ad = this.raw(Ae, null, "indent");
      if (ad.length)
        for (let rd = 0; rd < od; rd++)
          ed += ad;
    }
    return ed;
  }
  block(Ae, xr) {
    let ed = this.raw(Ae, "between", "beforeOpen");
    this.builder(xr + ed + "{", Ae, "start");
    let id;
    Ae.nodes && Ae.nodes.length ? (this.body(Ae), id = this.raw(Ae, "after")) : id = this.raw(Ae, "after", "emptyBody"), id && this.builder(id), this.builder("}", Ae, "end");
  }
  body(Ae) {
    let xr = Ae.nodes.length - 1;
    for (; xr > 0 && Ae.nodes[xr].type === "comment"; )
      xr -= 1;
    let ed = this.raw(Ae, "semicolon");
    for (let id = 0; id < Ae.nodes.length; id++) {
      let od = Ae.nodes[id], ad = this.raw(od, "before");
      ad && this.builder(ad), this.stringify(od, xr !== id || ed);
    }
  }
  comment(Ae) {
    let xr = this.raw(Ae, "left", "commentLeft"), ed = this.raw(Ae, "right", "commentRight");
    this.builder("/*" + xr + Ae.text + ed + "*/", Ae);
  }
  decl(Ae, xr) {
    let ed = this.raw(Ae, "between", "colon"), id = Ae.prop + ed + this.rawValue(Ae, "value");
    Ae.important && (id += Ae.raws.important || " !important"), xr && (id += ";"), this.builder(id, Ae);
  }
  document(Ae) {
    this.body(Ae);
  }
  raw(Ae, xr, ed) {
    let id;
    if (ed || (ed = xr), xr && (id = Ae.raws[xr], typeof id != "undefined"))
      return id;
    let od = Ae.parent;
    if (ed === "before" && (!od || od.type === "root" && od.first === Ae || od && od.type === "document"))
      return "";
    if (!od)
      return DEFAULT_RAW[ed];
    let ad = Ae.root();
    if (ad.rawCache || (ad.rawCache = {}), typeof ad.rawCache[ed] != "undefined")
      return ad.rawCache[ed];
    if (ed === "before" || ed === "after")
      return this.beforeAfter(Ae, ed);
    {
      let rd = "raw" + capitalize(ed);
      this[rd] ? id = this[rd](ad, Ae) : ad.walk((sd) => {
        if (id = sd.raws[xr], typeof id != "undefined")
          return !1;
      });
    }
    return typeof id == "undefined" && (id = DEFAULT_RAW[ed]), ad.rawCache[ed] = id, id;
  }
  rawBeforeClose(Ae) {
    let xr;
    return Ae.walk((ed) => {
      if (ed.nodes && ed.nodes.length > 0 && typeof ed.raws.after != "undefined")
        return xr = ed.raws.after, xr.includes(`
`) && (xr = xr.replace(/[^\n]+$/, "")), !1;
    }), xr && (xr = xr.replace(/\S/g, "")), xr;
  }
  rawBeforeComment(Ae, xr) {
    let ed;
    return Ae.walkComments((id) => {
      if (typeof id.raws.before != "undefined")
        return ed = id.raws.before, ed.includes(`
`) && (ed = ed.replace(/[^\n]+$/, "")), !1;
    }), typeof ed == "undefined" ? ed = this.raw(xr, null, "beforeDecl") : ed && (ed = ed.replace(/\S/g, "")), ed;
  }
  rawBeforeDecl(Ae, xr) {
    let ed;
    return Ae.walkDecls((id) => {
      if (typeof id.raws.before != "undefined")
        return ed = id.raws.before, ed.includes(`
`) && (ed = ed.replace(/[^\n]+$/, "")), !1;
    }), typeof ed == "undefined" ? ed = this.raw(xr, null, "beforeRule") : ed && (ed = ed.replace(/\S/g, "")), ed;
  }
  rawBeforeOpen(Ae) {
    let xr;
    return Ae.walk((ed) => {
      if (ed.type !== "decl" && (xr = ed.raws.between, typeof xr != "undefined"))
        return !1;
    }), xr;
  }
  rawBeforeRule(Ae) {
    let xr;
    return Ae.walk((ed) => {
      if (ed.nodes && (ed.parent !== Ae || Ae.first !== ed) && typeof ed.raws.before != "undefined")
        return xr = ed.raws.before, xr.includes(`
`) && (xr = xr.replace(/[^\n]+$/, "")), !1;
    }), xr && (xr = xr.replace(/\S/g, "")), xr;
  }
  rawColon(Ae) {
    let xr;
    return Ae.walkDecls((ed) => {
      if (typeof ed.raws.between != "undefined")
        return xr = ed.raws.between.replace(/[^\s:]/g, ""), !1;
    }), xr;
  }
  rawEmptyBody(Ae) {
    let xr;
    return Ae.walk((ed) => {
      if (ed.nodes && ed.nodes.length === 0 && (xr = ed.raws.after, typeof xr != "undefined"))
        return !1;
    }), xr;
  }
  rawIndent(Ae) {
    if (Ae.raws.indent)
      return Ae.raws.indent;
    let xr;
    return Ae.walk((ed) => {
      let id = ed.parent;
      if (id && id !== Ae && id.parent && id.parent === Ae && typeof ed.raws.before != "undefined") {
        let od = ed.raws.before.split(`
`);
        return xr = od[od.length - 1], xr = xr.replace(/\S/g, ""), !1;
      }
    }), xr;
  }
  rawSemicolon(Ae) {
    let xr;
    return Ae.walk((ed) => {
      if (ed.nodes && ed.nodes.length && ed.last.type === "decl" && (xr = ed.raws.semicolon, typeof xr != "undefined"))
        return !1;
    }), xr;
  }
  rawValue(Ae, xr) {
    let ed = Ae[xr], id = Ae.raws[xr];
    return id && id.value === ed ? id.raw : ed;
  }
  root(Ae) {
    this.body(Ae), Ae.raws.after && this.builder(Ae.raws.after);
  }
  rule(Ae) {
    this.block(Ae, this.rawValue(Ae, "selector")), Ae.raws.ownSemicolon && this.builder(Ae.raws.ownSemicolon, Ae, "end");
  }
  stringify(Ae, xr) {
    if (!this[Ae.type])
      throw new Error(
        "Unknown AST node type " + Ae.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[Ae.type](Ae, xr);
  }
};
var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;
let Stringifier$1 = stringifier;
function stringify$4(td, Ae) {
  new Stringifier$1(Ae).stringify(td);
}
var stringify_1 = stringify$4;
stringify$4.default = stringify$4;
let { isClean: isClean$2, my: my$2 } = symbols, CssSyntaxError$2 = cssSyntaxError, Stringifier = stringifier, stringify$3 = stringify_1;
function cloneNode(td, Ae) {
  let xr = new td.constructor();
  for (let ed in td) {
    if (!Object.prototype.hasOwnProperty.call(td, ed) || ed === "proxyCache")
      continue;
    let id = td[ed], od = typeof id;
    ed === "parent" && od === "object" ? Ae && (xr[ed] = Ae) : ed === "source" ? xr[ed] = id : Array.isArray(id) ? xr[ed] = id.map((ad) => cloneNode(ad, xr)) : (od === "object" && id !== null && (id = cloneNode(id)), xr[ed] = id);
  }
  return xr;
}
let Node$5 = class {
  constructor(Ae = {}) {
    this.raws = {}, this[isClean$2] = !1, this[my$2] = !0;
    for (let xr in Ae)
      if (xr === "nodes") {
        this.nodes = [];
        for (let ed of Ae[xr])
          typeof ed.clone == "function" ? this.append(ed.clone()) : this.append(ed);
      } else
        this[xr] = Ae[xr];
  }
  addToError(Ae) {
    if (Ae.postcssNode = this, Ae.stack && this.source && /\n\s{4}at /.test(Ae.stack)) {
      let xr = this.source;
      Ae.stack = Ae.stack.replace(
        /\n\s{4}at /,
        `$&${xr.input.from}:${xr.start.line}:${xr.start.column}$&`
      );
    }
    return Ae;
  }
  after(Ae) {
    return this.parent.insertAfter(this, Ae), this;
  }
  assign(Ae = {}) {
    for (let xr in Ae)
      this[xr] = Ae[xr];
    return this;
  }
  before(Ae) {
    return this.parent.insertBefore(this, Ae), this;
  }
  cleanRaws(Ae) {
    delete this.raws.before, delete this.raws.after, Ae || delete this.raws.between;
  }
  clone(Ae = {}) {
    let xr = cloneNode(this);
    for (let ed in Ae)
      xr[ed] = Ae[ed];
    return xr;
  }
  cloneAfter(Ae = {}) {
    let xr = this.clone(Ae);
    return this.parent.insertAfter(this, xr), xr;
  }
  cloneBefore(Ae = {}) {
    let xr = this.clone(Ae);
    return this.parent.insertBefore(this, xr), xr;
  }
  error(Ae, xr = {}) {
    if (this.source) {
      let { end: ed, start: id } = this.rangeBy(xr);
      return this.source.input.error(
        Ae,
        { column: id.column, line: id.line },
        { column: ed.column, line: ed.line },
        xr
      );
    }
    return new CssSyntaxError$2(Ae);
  }
  getProxyProcessor() {
    return {
      get(Ae, xr) {
        return xr === "proxyOf" ? Ae : xr === "root" ? () => Ae.root().toProxy() : Ae[xr];
      },
      set(Ae, xr, ed) {
        return Ae[xr] === ed || (Ae[xr] = ed, (xr === "prop" || xr === "value" || xr === "name" || xr === "params" || xr === "important" || /* c8 ignore next */
        xr === "text") && Ae.markDirty()), !0;
      }
    };
  }
  markDirty() {
    if (this[isClean$2]) {
      this[isClean$2] = !1;
      let Ae = this;
      for (; Ae = Ae.parent; )
        Ae[isClean$2] = !1;
    }
  }
  next() {
    if (!this.parent)
      return;
    let Ae = this.parent.index(this);
    return this.parent.nodes[Ae + 1];
  }
  positionBy(Ae, xr) {
    let ed = this.source.start;
    if (Ae.index)
      ed = this.positionInside(Ae.index, xr);
    else if (Ae.word) {
      xr = this.toString();
      let id = xr.indexOf(Ae.word);
      id !== -1 && (ed = this.positionInside(id, xr));
    }
    return ed;
  }
  positionInside(Ae, xr) {
    let ed = xr || this.toString(), id = this.source.start.column, od = this.source.start.line;
    for (let ad = 0; ad < Ae; ad++)
      ed[ad] === `
` ? (id = 1, od += 1) : id += 1;
    return { column: id, line: od };
  }
  prev() {
    if (!this.parent)
      return;
    let Ae = this.parent.index(this);
    return this.parent.nodes[Ae - 1];
  }
  rangeBy(Ae) {
    let xr = {
      column: this.source.start.column,
      line: this.source.start.line
    }, ed = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: xr.column + 1,
      line: xr.line
    };
    if (Ae.word) {
      let id = this.toString(), od = id.indexOf(Ae.word);
      od !== -1 && (xr = this.positionInside(od, id), ed = this.positionInside(od + Ae.word.length, id));
    } else
      Ae.start ? xr = {
        column: Ae.start.column,
        line: Ae.start.line
      } : Ae.index && (xr = this.positionInside(Ae.index)), Ae.end ? ed = {
        column: Ae.end.column,
        line: Ae.end.line
      } : typeof Ae.endIndex == "number" ? ed = this.positionInside(Ae.endIndex) : Ae.index && (ed = this.positionInside(Ae.index + 1));
    return (ed.line < xr.line || ed.line === xr.line && ed.column <= xr.column) && (ed = { column: xr.column + 1, line: xr.line }), { end: ed, start: xr };
  }
  raw(Ae, xr) {
    return new Stringifier().raw(this, Ae, xr);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...Ae) {
    if (this.parent) {
      let xr = this, ed = !1;
      for (let id of Ae)
        id === this ? ed = !0 : ed ? (this.parent.insertAfter(xr, id), xr = id) : this.parent.insertBefore(xr, id);
      ed || this.remove();
    }
    return this;
  }
  root() {
    let Ae = this;
    for (; Ae.parent && Ae.parent.type !== "document"; )
      Ae = Ae.parent;
    return Ae;
  }
  toJSON(Ae, xr) {
    let ed = {}, id = xr == null;
    xr = xr || /* @__PURE__ */ new Map();
    let od = 0;
    for (let ad in this) {
      if (!Object.prototype.hasOwnProperty.call(this, ad) || ad === "parent" || ad === "proxyCache")
        continue;
      let rd = this[ad];
      if (Array.isArray(rd))
        ed[ad] = rd.map((sd) => typeof sd == "object" && sd.toJSON ? sd.toJSON(null, xr) : sd);
      else if (typeof rd == "object" && rd.toJSON)
        ed[ad] = rd.toJSON(null, xr);
      else if (ad === "source") {
        let sd = xr.get(rd.input);
        sd == null && (sd = od, xr.set(rd.input, od), od++), ed[ad] = {
          end: rd.end,
          inputId: sd,
          start: rd.start
        };
      } else
        ed[ad] = rd;
    }
    return id && (ed.inputs = [...xr.keys()].map((ad) => ad.toJSON())), ed;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(Ae = stringify$3) {
    Ae.stringify && (Ae = Ae.stringify);
    let xr = "";
    return Ae(this, (ed) => {
      xr += ed;
    }), xr;
  }
  warn(Ae, xr, ed) {
    let id = { node: this };
    for (let od in ed)
      id[od] = ed[od];
    return Ae.warn(xr, id);
  }
  get proxyOf() {
    return this;
  }
};
var node = Node$5;
Node$5.default = Node$5;
let Node$4 = node, Declaration$4 = class extends Node$4 {
  constructor(Ae) {
    Ae && typeof Ae.value != "undefined" && typeof Ae.value != "string" && (Ae = { ...Ae, value: String(Ae.value) }), super(Ae), this.type = "decl";
  }
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
};
var declaration = Declaration$4;
Declaration$4.default = Declaration$4;
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", customAlphabet = (td, Ae = 21) => (xr = Ae) => {
  let ed = "", id = xr;
  for (; id--; )
    ed += td[Math.random() * td.length | 0];
  return ed;
}, nanoid$1 = (td = 21) => {
  let Ae = "", xr = td;
  for (; xr--; )
    Ae += urlAlphabet[Math.random() * 64 | 0];
  return Ae;
};
var nonSecure = { nanoid: nanoid$1, customAlphabet };
let { SourceMapConsumer: SourceMapConsumer$2, SourceMapGenerator: SourceMapGenerator$2 } = require$$2, { existsSync, readFileSync } = require$$2, { dirname: dirname$1, join } = require$$2;
function fromBase64(td) {
  return Buffer ? Buffer.from(td, "base64").toString() : window.atob(td);
}
let PreviousMap$2 = class {
  constructor(Ae, xr) {
    if (xr.map === !1)
      return;
    this.loadAnnotation(Ae), this.inline = this.startWith(this.annotation, "data:");
    let ed = xr.map ? xr.map.prev : void 0, id = this.loadMap(xr.from, ed);
    !this.mapFile && xr.from && (this.mapFile = xr.from), this.mapFile && (this.root = dirname$1(this.mapFile)), id && (this.text = id);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new SourceMapConsumer$2(this.text)), this.consumerCache;
  }
  decodeInline(Ae) {
    let xr = /^data:application\/json;charset=utf-?8;base64,/, ed = /^data:application\/json;base64,/, id = /^data:application\/json;charset=utf-?8,/, od = /^data:application\/json,/, ad = Ae.match(id) || Ae.match(od);
    if (ad)
      return decodeURIComponent(Ae.substr(ad[0].length));
    let rd = Ae.match(xr) || Ae.match(ed);
    if (rd)
      return fromBase64(Ae.substr(rd[0].length));
    let sd = Ae.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + sd);
  }
  getAnnotationURL(Ae) {
    return Ae.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(Ae) {
    return typeof Ae != "object" ? !1 : typeof Ae.mappings == "string" || typeof Ae._mappings == "string" || Array.isArray(Ae.sections);
  }
  loadAnnotation(Ae) {
    let xr = Ae.match(/\/\*\s*# sourceMappingURL=/g);
    if (!xr)
      return;
    let ed = Ae.lastIndexOf(xr.pop()), id = Ae.indexOf("*/", ed);
    ed > -1 && id > -1 && (this.annotation = this.getAnnotationURL(Ae.substring(ed, id)));
  }
  loadFile(Ae) {
    if (this.root = dirname$1(Ae), existsSync(Ae))
      return this.mapFile = Ae, readFileSync(Ae, "utf-8").toString().trim();
  }
  loadMap(Ae, xr) {
    if (xr === !1)
      return !1;
    if (xr) {
      if (typeof xr == "string")
        return xr;
      if (typeof xr == "function") {
        let ed = xr(Ae);
        if (ed) {
          let id = this.loadFile(ed);
          if (!id)
            throw new Error(
              "Unable to load previous source map: " + ed.toString()
            );
          return id;
        }
      } else {
        if (xr instanceof SourceMapConsumer$2)
          return SourceMapGenerator$2.fromSourceMap(xr).toString();
        if (xr instanceof SourceMapGenerator$2)
          return xr.toString();
        if (this.isMap(xr))
          return JSON.stringify(xr);
        throw new Error(
          "Unsupported previous source map format: " + xr.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let ed = this.annotation;
        return Ae && (ed = join(dirname$1(Ae), ed)), this.loadFile(ed);
      }
    }
  }
  startWith(Ae, xr) {
    return Ae ? Ae.substr(0, xr.length) === xr : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;
let { SourceMapConsumer: SourceMapConsumer$1, SourceMapGenerator: SourceMapGenerator$1 } = require$$2, { fileURLToPath, pathToFileURL: pathToFileURL$1 } = require$$2, { isAbsolute, resolve: resolve$1 } = require$$2, { nanoid } = nonSecure, terminalHighlight = require$$2, CssSyntaxError$1 = cssSyntaxError, PreviousMap$1 = previousMap, fromOffsetCache = Symbol("fromOffsetCache"), sourceMapAvailable$1 = !!(SourceMapConsumer$1 && SourceMapGenerator$1), pathAvailable$1 = !!(resolve$1 && isAbsolute), Input$4 = class {
  constructor(Ae, xr = {}) {
    if (Ae === null || typeof Ae == "undefined" || typeof Ae == "object" && !Ae.toString)
      throw new Error(`PostCSS received ${Ae} instead of CSS string`);
    if (this.css = Ae.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, xr.from && (!pathAvailable$1 || /^\w+:\/\//.test(xr.from) || isAbsolute(xr.from) ? this.file = xr.from : this.file = resolve$1(xr.from)), pathAvailable$1 && sourceMapAvailable$1) {
      let ed = new PreviousMap$1(this.css, xr);
      if (ed.text) {
        this.map = ed;
        let id = ed.consumer().file;
        !this.file && id && (this.file = this.mapResolve(id));
      }
    }
    this.file || (this.id = "<input css " + nanoid(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(Ae, xr, ed, id = {}) {
    let od, ad, rd;
    if (xr && typeof xr == "object") {
      let nd = xr, cd = ed;
      if (typeof nd.offset == "number") {
        let ud = this.fromOffset(nd.offset);
        xr = ud.line, ed = ud.col;
      } else
        xr = nd.line, ed = nd.column;
      if (typeof cd.offset == "number") {
        let ud = this.fromOffset(cd.offset);
        ad = ud.line, rd = ud.col;
      } else
        ad = cd.line, rd = cd.column;
    } else if (!ed) {
      let nd = this.fromOffset(xr);
      xr = nd.line, ed = nd.col;
    }
    let sd = this.origin(xr, ed, ad, rd);
    return sd ? od = new CssSyntaxError$1(
      Ae,
      sd.endLine === void 0 ? sd.line : { column: sd.column, line: sd.line },
      sd.endLine === void 0 ? sd.column : { column: sd.endColumn, line: sd.endLine },
      sd.source,
      sd.file,
      id.plugin
    ) : od = new CssSyntaxError$1(
      Ae,
      ad === void 0 ? xr : { column: ed, line: xr },
      ad === void 0 ? ed : { column: rd, line: ad },
      this.css,
      this.file,
      id.plugin
    ), od.input = { column: ed, endColumn: rd, endLine: ad, line: xr, source: this.css }, this.file && (pathToFileURL$1 && (od.input.url = pathToFileURL$1(this.file).toString()), od.input.file = this.file), od;
  }
  fromOffset(Ae) {
    let xr, ed;
    if (this[fromOffsetCache])
      ed = this[fromOffsetCache];
    else {
      let od = this.css.split(`
`);
      ed = new Array(od.length);
      let ad = 0;
      for (let rd = 0, sd = od.length; rd < sd; rd++)
        ed[rd] = ad, ad += od[rd].length + 1;
      this[fromOffsetCache] = ed;
    }
    xr = ed[ed.length - 1];
    let id = 0;
    if (Ae >= xr)
      id = ed.length - 1;
    else {
      let od = ed.length - 2, ad;
      for (; id < od; )
        if (ad = id + (od - id >> 1), Ae < ed[ad])
          od = ad - 1;
        else if (Ae >= ed[ad + 1])
          id = ad + 1;
        else {
          id = ad;
          break;
        }
    }
    return {
      col: Ae - ed[id] + 1,
      line: id + 1
    };
  }
  mapResolve(Ae) {
    return /^\w+:\/\//.test(Ae) ? Ae : resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", Ae);
  }
  origin(Ae, xr, ed, id) {
    if (!this.map)
      return !1;
    let od = this.map.consumer(), ad = od.originalPositionFor({ column: xr, line: Ae });
    if (!ad.source)
      return !1;
    let rd;
    typeof ed == "number" && (rd = od.originalPositionFor({ column: id, line: ed }));
    let sd;
    isAbsolute(ad.source) ? sd = pathToFileURL$1(ad.source) : sd = new URL(
      ad.source,
      this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile)
    );
    let nd = {
      column: ad.column,
      endColumn: rd && rd.column,
      endLine: rd && rd.line,
      line: ad.line,
      url: sd.toString()
    };
    if (sd.protocol === "file:")
      if (fileURLToPath)
        nd.file = fileURLToPath(sd);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let cd = od.sourceContentFor(ad.source);
    return cd && (nd.source = cd), nd;
  }
  toJSON() {
    let Ae = {};
    for (let xr of ["hasBOM", "css", "file", "id"])
      this[xr] != null && (Ae[xr] = this[xr]);
    return this.map && (Ae.map = { ...this.map }, Ae.map.consumerCache && (Ae.map.consumerCache = void 0)), Ae;
  }
  get from() {
    return this.file || this.id;
  }
};
var input = Input$4;
Input$4.default = Input$4;
terminalHighlight && terminalHighlight.registerInput && terminalHighlight.registerInput(Input$4);
let { SourceMapConsumer, SourceMapGenerator } = require$$2, { dirname, relative, resolve, sep } = require$$2, { pathToFileURL } = require$$2, Input$3 = input, sourceMapAvailable = !!(SourceMapConsumer && SourceMapGenerator), pathAvailable = !!(dirname && resolve && relative && sep), MapGenerator$2 = class {
  constructor(Ae, xr, ed, id) {
    this.stringify = Ae, this.mapOpts = ed.map || {}, this.root = xr, this.opts = ed, this.css = id, this.originalCSS = id, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let Ae;
    this.isInline() ? Ae = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? Ae = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? Ae = this.mapOpts.annotation(this.opts.to, this.root) : Ae = this.outputFile() + ".map";
    let xr = `
`;
    this.css.includes(`\r
`) && (xr = `\r
`), this.css += xr + "/*# sourceMappingURL=" + Ae + " */";
  }
  applyPrevMaps() {
    for (let Ae of this.previous()) {
      let xr = this.toUrl(this.path(Ae.file)), ed = Ae.root || dirname(Ae.file), id;
      this.mapOpts.sourcesContent === !1 ? (id = new SourceMapConsumer(Ae.text), id.sourcesContent && (id.sourcesContent = null)) : id = Ae.consumer(), this.map.applySourceMap(id, xr, this.toUrl(this.path(ed)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let Ae;
        for (let xr = this.root.nodes.length - 1; xr >= 0; xr--)
          Ae = this.root.nodes[xr], Ae.type === "comment" && Ae.text.indexOf("# sourceMappingURL=") === 0 && this.root.removeChild(xr);
      } else
        this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), pathAvailable && sourceMapAvailable && this.isMap())
      return this.generateMap();
    {
      let Ae = "";
      return this.stringify(this.root, (xr) => {
        Ae += xr;
      }), [Ae];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let Ae = this.previous()[0].consumer();
      Ae.file = this.outputFile(), this.map = SourceMapGenerator.fromSourceMap(Ae, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new SourceMapGenerator({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new SourceMapGenerator({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let Ae = 1, xr = 1, ed = "<no source>", id = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, od, ad;
    this.stringify(this.root, (rd, sd, nd) => {
      if (this.css += rd, sd && nd !== "end" && (id.generated.line = Ae, id.generated.column = xr - 1, sd.source && sd.source.start ? (id.source = this.sourcePath(sd), id.original.line = sd.source.start.line, id.original.column = sd.source.start.column - 1, this.map.addMapping(id)) : (id.source = ed, id.original.line = 1, id.original.column = 0, this.map.addMapping(id))), od = rd.match(/\n/g), od ? (Ae += od.length, ad = rd.lastIndexOf(`
`), xr = rd.length - ad) : xr += rd.length, sd && nd !== "start") {
        let cd = sd.parent || { raws: {} };
        (!(sd.type === "decl" || sd.type === "atrule" && !sd.nodes) || sd !== cd.last || cd.raws.semicolon) && (sd.source && sd.source.end ? (id.source = this.sourcePath(sd), id.original.line = sd.source.end.line, id.original.column = sd.source.end.column - 1, id.generated.line = Ae, id.generated.column = xr - 2, this.map.addMapping(id)) : (id.source = ed, id.original.line = 1, id.original.column = 0, id.generated.line = Ae, id.generated.column = xr - 1, this.map.addMapping(id)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((Ae) => Ae.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let Ae = this.mapOpts.annotation;
    return typeof Ae != "undefined" && Ae !== !0 ? !1 : this.previous().length ? this.previous().some((xr) => xr.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((Ae) => Ae.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(Ae) {
    if (this.mapOpts.absolute || Ae.charCodeAt(0) === 60 || /^\w+:\/\//.test(Ae))
      return Ae;
    let xr = this.memoizedPaths.get(Ae);
    if (xr)
      return xr;
    let ed = this.opts.to ? dirname(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (ed = dirname(resolve(ed, this.mapOpts.annotation)));
    let id = relative(ed, Ae);
    return this.memoizedPaths.set(Ae, id), id;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((Ae) => {
          if (Ae.source && Ae.source.input.map) {
            let xr = Ae.source.input.map;
            this.previousMaps.includes(xr) || this.previousMaps.push(xr);
          }
        });
      else {
        let Ae = new Input$3(this.originalCSS, this.opts);
        Ae.map && this.previousMaps.push(Ae.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let Ae = {};
    if (this.root)
      this.root.walk((xr) => {
        if (xr.source) {
          let ed = xr.source.input.from;
          if (ed && !Ae[ed]) {
            Ae[ed] = !0;
            let id = this.usesFileUrls ? this.toFileUrl(ed) : this.toUrl(this.path(ed));
            this.map.setSourceContent(id, xr.source.input.css);
          }
        }
      });
    else if (this.css) {
      let xr = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(xr, this.css);
    }
  }
  sourcePath(Ae) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(Ae.source.input.from) : this.toUrl(this.path(Ae.source.input.from));
  }
  toBase64(Ae) {
    return Buffer ? Buffer.from(Ae).toString("base64") : window.btoa(unescape(encodeURIComponent(Ae)));
  }
  toFileUrl(Ae) {
    let xr = this.memoizedFileURLs.get(Ae);
    if (xr)
      return xr;
    if (pathToFileURL) {
      let ed = pathToFileURL(Ae).toString();
      return this.memoizedFileURLs.set(Ae, ed), ed;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(Ae) {
    let xr = this.memoizedURLs.get(Ae);
    if (xr)
      return xr;
    sep === "\\" && (Ae = Ae.replace(/\\/g, "/"));
    let ed = encodeURI(Ae).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(Ae, ed), ed;
  }
};
var mapGenerator = MapGenerator$2;
let Node$3 = node, Comment$4 = class extends Node$3 {
  constructor(Ae) {
    super(Ae), this.type = "comment";
  }
};
var comment = Comment$4;
Comment$4.default = Comment$4;
let { isClean: isClean$1, my: my$1 } = symbols, Declaration$3 = declaration, Comment$3 = comment, Node$2 = node, parse$4, Rule$4, AtRule$4, Root$6;
function cleanSource(td) {
  return td.map((Ae) => (Ae.nodes && (Ae.nodes = cleanSource(Ae.nodes)), delete Ae.source, Ae));
}
function markTreeDirty(td) {
  if (td[isClean$1] = !1, td.proxyOf.nodes)
    for (let Ae of td.proxyOf.nodes)
      markTreeDirty(Ae);
}
let Container$7 = class F0 extends Node$2 {
  append(...Ae) {
    for (let xr of Ae) {
      let ed = this.normalize(xr, this.last);
      for (let id of ed)
        this.proxyOf.nodes.push(id);
    }
    return this.markDirty(), this;
  }
  cleanRaws(Ae) {
    if (super.cleanRaws(Ae), this.nodes)
      for (let xr of this.nodes)
        xr.cleanRaws(Ae);
  }
  each(Ae) {
    if (!this.proxyOf.nodes)
      return;
    let xr = this.getIterator(), ed, id;
    for (; this.indexes[xr] < this.proxyOf.nodes.length && (ed = this.indexes[xr], id = Ae(this.proxyOf.nodes[ed], ed), id !== !1); )
      this.indexes[xr] += 1;
    return delete this.indexes[xr], id;
  }
  every(Ae) {
    return this.nodes.every(Ae);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let Ae = this.lastEach;
    return this.indexes[Ae] = 0, Ae;
  }
  getProxyProcessor() {
    return {
      get(Ae, xr) {
        return xr === "proxyOf" ? Ae : Ae[xr] ? xr === "each" || typeof xr == "string" && xr.startsWith("walk") ? (...ed) => Ae[xr](
          ...ed.map((id) => typeof id == "function" ? (od, ad) => id(od.toProxy(), ad) : id)
        ) : xr === "every" || xr === "some" ? (ed) => Ae[xr](
          (id, ...od) => ed(id.toProxy(), ...od)
        ) : xr === "root" ? () => Ae.root().toProxy() : xr === "nodes" ? Ae.nodes.map((ed) => ed.toProxy()) : xr === "first" || xr === "last" ? Ae[xr].toProxy() : Ae[xr] : Ae[xr];
      },
      set(Ae, xr, ed) {
        return Ae[xr] === ed || (Ae[xr] = ed, (xr === "name" || xr === "params" || xr === "selector") && Ae.markDirty()), !0;
      }
    };
  }
  index(Ae) {
    return typeof Ae == "number" ? Ae : (Ae.proxyOf && (Ae = Ae.proxyOf), this.proxyOf.nodes.indexOf(Ae));
  }
  insertAfter(Ae, xr) {
    let ed = this.index(Ae), id = this.normalize(xr, this.proxyOf.nodes[ed]).reverse();
    ed = this.index(Ae);
    for (let ad of id)
      this.proxyOf.nodes.splice(ed + 1, 0, ad);
    let od;
    for (let ad in this.indexes)
      od = this.indexes[ad], ed < od && (this.indexes[ad] = od + id.length);
    return this.markDirty(), this;
  }
  insertBefore(Ae, xr) {
    let ed = this.index(Ae), id = ed === 0 ? "prepend" : !1, od = this.normalize(
      xr,
      this.proxyOf.nodes[ed],
      id
    ).reverse();
    ed = this.index(Ae);
    for (let rd of od)
      this.proxyOf.nodes.splice(ed, 0, rd);
    let ad;
    for (let rd in this.indexes)
      ad = this.indexes[rd], ed <= ad && (this.indexes[rd] = ad + od.length);
    return this.markDirty(), this;
  }
  normalize(Ae, xr) {
    if (typeof Ae == "string")
      Ae = cleanSource(parse$4(Ae).nodes);
    else if (typeof Ae == "undefined")
      Ae = [];
    else if (Array.isArray(Ae)) {
      Ae = Ae.slice(0);
      for (let id of Ae)
        id.parent && id.parent.removeChild(id, "ignore");
    } else if (Ae.type === "root" && this.type !== "document") {
      Ae = Ae.nodes.slice(0);
      for (let id of Ae)
        id.parent && id.parent.removeChild(id, "ignore");
    } else if (Ae.type)
      Ae = [Ae];
    else if (Ae.prop) {
      if (typeof Ae.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof Ae.value != "string" && (Ae.value = String(Ae.value)), Ae = [new Declaration$3(Ae)];
    } else if (Ae.selector || Ae.selectors)
      Ae = [new Rule$4(Ae)];
    else if (Ae.name)
      Ae = [new AtRule$4(Ae)];
    else if (Ae.text)
      Ae = [new Comment$3(Ae)];
    else
      throw new Error("Unknown node type in node creation");
    return Ae.map((id) => (id[my$1] || F0.rebuild(id), id = id.proxyOf, id.parent && id.parent.removeChild(id), id[isClean$1] && markTreeDirty(id), typeof id.raws.before == "undefined" && xr && typeof xr.raws.before != "undefined" && (id.raws.before = xr.raws.before.replace(/\S/g, "")), id.parent = this.proxyOf, id));
  }
  prepend(...Ae) {
    Ae = Ae.reverse();
    for (let xr of Ae) {
      let ed = this.normalize(xr, this.first, "prepend").reverse();
      for (let id of ed)
        this.proxyOf.nodes.unshift(id);
      for (let id in this.indexes)
        this.indexes[id] = this.indexes[id] + ed.length;
    }
    return this.markDirty(), this;
  }
  push(Ae) {
    return Ae.parent = this, this.proxyOf.nodes.push(Ae), this;
  }
  removeAll() {
    for (let Ae of this.proxyOf.nodes)
      Ae.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(Ae) {
    Ae = this.index(Ae), this.proxyOf.nodes[Ae].parent = void 0, this.proxyOf.nodes.splice(Ae, 1);
    let xr;
    for (let ed in this.indexes)
      xr = this.indexes[ed], xr >= Ae && (this.indexes[ed] = xr - 1);
    return this.markDirty(), this;
  }
  replaceValues(Ae, xr, ed) {
    return ed || (ed = xr, xr = {}), this.walkDecls((id) => {
      xr.props && !xr.props.includes(id.prop) || xr.fast && !id.value.includes(xr.fast) || (id.value = id.value.replace(Ae, ed));
    }), this.markDirty(), this;
  }
  some(Ae) {
    return this.nodes.some(Ae);
  }
  walk(Ae) {
    return this.each((xr, ed) => {
      let id;
      try {
        id = Ae(xr, ed);
      } catch (od) {
        throw xr.addToError(od);
      }
      return id !== !1 && xr.walk && (id = xr.walk(Ae)), id;
    });
  }
  walkAtRules(Ae, xr) {
    return xr ? Ae instanceof RegExp ? this.walk((ed, id) => {
      if (ed.type === "atrule" && Ae.test(ed.name))
        return xr(ed, id);
    }) : this.walk((ed, id) => {
      if (ed.type === "atrule" && ed.name === Ae)
        return xr(ed, id);
    }) : (xr = Ae, this.walk((ed, id) => {
      if (ed.type === "atrule")
        return xr(ed, id);
    }));
  }
  walkComments(Ae) {
    return this.walk((xr, ed) => {
      if (xr.type === "comment")
        return Ae(xr, ed);
    });
  }
  walkDecls(Ae, xr) {
    return xr ? Ae instanceof RegExp ? this.walk((ed, id) => {
      if (ed.type === "decl" && Ae.test(ed.prop))
        return xr(ed, id);
    }) : this.walk((ed, id) => {
      if (ed.type === "decl" && ed.prop === Ae)
        return xr(ed, id);
    }) : (xr = Ae, this.walk((ed, id) => {
      if (ed.type === "decl")
        return xr(ed, id);
    }));
  }
  walkRules(Ae, xr) {
    return xr ? Ae instanceof RegExp ? this.walk((ed, id) => {
      if (ed.type === "rule" && Ae.test(ed.selector))
        return xr(ed, id);
    }) : this.walk((ed, id) => {
      if (ed.type === "rule" && ed.selector === Ae)
        return xr(ed, id);
    }) : (xr = Ae, this.walk((ed, id) => {
      if (ed.type === "rule")
        return xr(ed, id);
    }));
  }
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
};
Container$7.registerParse = (td) => {
  parse$4 = td;
};
Container$7.registerRule = (td) => {
  Rule$4 = td;
};
Container$7.registerAtRule = (td) => {
  AtRule$4 = td;
};
Container$7.registerRoot = (td) => {
  Root$6 = td;
};
var container = Container$7;
Container$7.default = Container$7;
Container$7.rebuild = (td) => {
  td.type === "atrule" ? Object.setPrototypeOf(td, AtRule$4.prototype) : td.type === "rule" ? Object.setPrototypeOf(td, Rule$4.prototype) : td.type === "decl" ? Object.setPrototypeOf(td, Declaration$3.prototype) : td.type === "comment" ? Object.setPrototypeOf(td, Comment$3.prototype) : td.type === "root" && Object.setPrototypeOf(td, Root$6.prototype), td[my$1] = !0, td.nodes && td.nodes.forEach((Ae) => {
    Container$7.rebuild(Ae);
  });
};
let Container$6 = container, LazyResult$4, Processor$3, Document$4 = class extends Container$6 {
  constructor(Ae) {
    super({ type: "document", ...Ae }), this.nodes || (this.nodes = []);
  }
  toResult(Ae = {}) {
    return new LazyResult$4(new Processor$3(), this, Ae).stringify();
  }
};
Document$4.registerLazyResult = (td) => {
  LazyResult$4 = td;
};
Document$4.registerProcessor = (td) => {
  Processor$3 = td;
};
var document$1 = Document$4;
Document$4.default = Document$4;
let Warning$2 = class {
  constructor(Ae, xr = {}) {
    if (this.type = "warning", this.text = Ae, xr.node && xr.node.source) {
      let ed = xr.node.rangeBy(xr);
      this.line = ed.start.line, this.column = ed.start.column, this.endLine = ed.end.line, this.endColumn = ed.end.column;
    }
    for (let ed in xr)
      this[ed] = xr[ed];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var warning = Warning$2;
Warning$2.default = Warning$2;
let Warning$1 = warning, Result$3 = class {
  constructor(Ae, xr, ed) {
    this.processor = Ae, this.messages = [], this.root = xr, this.opts = ed, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(Ae, xr = {}) {
    xr.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (xr.plugin = this.lastPlugin.postcssPlugin);
    let ed = new Warning$1(Ae, xr);
    return this.messages.push(ed), ed;
  }
  warnings() {
    return this.messages.filter((Ae) => Ae.type === "warning");
  }
  get content() {
    return this.css;
  }
};
var result = Result$3;
Result$3.default = Result$3;
const SINGLE_QUOTE = 39, DOUBLE_QUOTE = 34, BACKSLASH = 92, SLASH = 47, NEWLINE = 10, SPACE = 32, FEED = 12, TAB = 9, CR = 13, OPEN_SQUARE = 91, CLOSE_SQUARE = 93, OPEN_PARENTHESES = 40, CLOSE_PARENTHESES = 41, OPEN_CURLY = 123, CLOSE_CURLY = 125, SEMICOLON = 59, ASTERISK = 42, COLON = 58, AT = 64, RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g, RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, RE_BAD_BRACKET = /.[\r\n"'(/\\]/, RE_HEX_ESCAPE = /[\da-f]/i;
var tokenize = function td(Ae, xr = {}) {
  let ed = Ae.css.valueOf(), id = xr.ignoreErrors, od, ad, rd, sd, nd, cd, ud, ld, dd, pd, md = ed.length, fd = 0, bd = [], Sd = [];
  function vd() {
    return fd;
  }
  function Ed(Pd) {
    throw Ae.error("Unclosed " + Pd, fd);
  }
  function Td() {
    return Sd.length === 0 && fd >= md;
  }
  function Gd(Pd) {
    if (Sd.length)
      return Sd.pop();
    if (fd >= md)
      return;
    let Hd = Pd ? Pd.ignoreUnclosed : !1;
    switch (od = ed.charCodeAt(fd), od) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED: {
        ad = fd;
        do
          ad += 1, od = ed.charCodeAt(ad);
        while (od === SPACE || od === NEWLINE || od === TAB || od === CR || od === FEED);
        pd = ["space", ed.slice(fd, ad)], fd = ad - 1;
        break;
      }
      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES: {
        let Rd = String.fromCharCode(od);
        pd = [Rd, Rd, fd];
        break;
      }
      case OPEN_PARENTHESES: {
        if (ld = bd.length ? bd.pop()[1] : "", dd = ed.charCodeAt(fd + 1), ld === "url" && dd !== SINGLE_QUOTE && dd !== DOUBLE_QUOTE && dd !== SPACE && dd !== NEWLINE && dd !== TAB && dd !== FEED && dd !== CR) {
          ad = fd;
          do {
            if (cd = !1, ad = ed.indexOf(")", ad + 1), ad === -1)
              if (id || Hd) {
                ad = fd;
                break;
              } else
                Ed("bracket");
            for (ud = ad; ed.charCodeAt(ud - 1) === BACKSLASH; )
              ud -= 1, cd = !cd;
          } while (cd);
          pd = ["brackets", ed.slice(fd, ad + 1), fd, ad], fd = ad;
        } else
          ad = ed.indexOf(")", fd + 1), sd = ed.slice(fd, ad + 1), ad === -1 || RE_BAD_BRACKET.test(sd) ? pd = ["(", "(", fd] : (pd = ["brackets", sd, fd, ad], fd = ad);
        break;
      }
      case SINGLE_QUOTE:
      case DOUBLE_QUOTE: {
        rd = od === SINGLE_QUOTE ? "'" : '"', ad = fd;
        do {
          if (cd = !1, ad = ed.indexOf(rd, ad + 1), ad === -1)
            if (id || Hd) {
              ad = fd + 1;
              break;
            } else
              Ed("string");
          for (ud = ad; ed.charCodeAt(ud - 1) === BACKSLASH; )
            ud -= 1, cd = !cd;
        } while (cd);
        pd = ["string", ed.slice(fd, ad + 1), fd, ad], fd = ad;
        break;
      }
      case AT: {
        RE_AT_END.lastIndex = fd + 1, RE_AT_END.test(ed), RE_AT_END.lastIndex === 0 ? ad = ed.length - 1 : ad = RE_AT_END.lastIndex - 2, pd = ["at-word", ed.slice(fd, ad + 1), fd, ad], fd = ad;
        break;
      }
      case BACKSLASH: {
        for (ad = fd, nd = !0; ed.charCodeAt(ad + 1) === BACKSLASH; )
          ad += 1, nd = !nd;
        if (od = ed.charCodeAt(ad + 1), nd && od !== SLASH && od !== SPACE && od !== NEWLINE && od !== TAB && od !== CR && od !== FEED && (ad += 1, RE_HEX_ESCAPE.test(ed.charAt(ad)))) {
          for (; RE_HEX_ESCAPE.test(ed.charAt(ad + 1)); )
            ad += 1;
          ed.charCodeAt(ad + 1) === SPACE && (ad += 1);
        }
        pd = ["word", ed.slice(fd, ad + 1), fd, ad], fd = ad;
        break;
      }
      default: {
        od === SLASH && ed.charCodeAt(fd + 1) === ASTERISK ? (ad = ed.indexOf("*/", fd + 2) + 1, ad === 0 && (id || Hd ? ad = ed.length : Ed("comment")), pd = ["comment", ed.slice(fd, ad + 1), fd, ad], fd = ad) : (RE_WORD_END.lastIndex = fd + 1, RE_WORD_END.test(ed), RE_WORD_END.lastIndex === 0 ? ad = ed.length - 1 : ad = RE_WORD_END.lastIndex - 2, pd = ["word", ed.slice(fd, ad + 1), fd, ad], bd.push(pd), fd = ad);
        break;
      }
    }
    return fd++, pd;
  }
  function Id(Pd) {
    Sd.push(Pd);
  }
  return {
    back: Id,
    endOfFile: Td,
    nextToken: Gd,
    position: vd
  };
};
let Container$5 = container, AtRule$3 = class extends Container$5 {
  constructor(Ae) {
    super(Ae), this.type = "atrule";
  }
  append(...Ae) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...Ae);
  }
  prepend(...Ae) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...Ae);
  }
};
var atRule = AtRule$3;
AtRule$3.default = AtRule$3;
Container$5.registerAtRule(AtRule$3);
let Container$4 = container, LazyResult$3, Processor$2, Root$5 = class extends Container$4 {
  constructor(Ae) {
    super(Ae), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(Ae, xr, ed) {
    let id = super.normalize(Ae);
    if (xr) {
      if (ed === "prepend")
        this.nodes.length > 1 ? xr.raws.before = this.nodes[1].raws.before : delete xr.raws.before;
      else if (this.first !== xr)
        for (let od of id)
          od.raws.before = xr.raws.before;
    }
    return id;
  }
  removeChild(Ae, xr) {
    let ed = this.index(Ae);
    return !xr && ed === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[ed].raws.before), super.removeChild(Ae);
  }
  toResult(Ae = {}) {
    return new LazyResult$3(new Processor$2(), this, Ae).stringify();
  }
};
Root$5.registerLazyResult = (td) => {
  LazyResult$3 = td;
};
Root$5.registerProcessor = (td) => {
  Processor$2 = td;
};
var root = Root$5;
Root$5.default = Root$5;
Container$4.registerRoot(Root$5);
let list$2 = {
  comma(td) {
    return list$2.split(td, [","], !0);
  },
  space(td) {
    let Ae = [" ", `
`, "	"];
    return list$2.split(td, Ae);
  },
  split(td, Ae, xr) {
    let ed = [], id = "", od = !1, ad = 0, rd = !1, sd = "", nd = !1;
    for (let cd of td)
      nd ? nd = !1 : cd === "\\" ? nd = !0 : rd ? cd === sd && (rd = !1) : cd === '"' || cd === "'" ? (rd = !0, sd = cd) : cd === "(" ? ad += 1 : cd === ")" ? ad > 0 && (ad -= 1) : ad === 0 && Ae.includes(cd) && (od = !0), od ? (id !== "" && ed.push(id.trim()), id = "", od = !1) : id += cd;
    return (xr || id !== "") && ed.push(id.trim()), ed;
  }
};
var list_1 = list$2;
list$2.default = list$2;
let Container$3 = container, list$1 = list_1, Rule$3 = class extends Container$3 {
  constructor(Ae) {
    super(Ae), this.type = "rule", this.nodes || (this.nodes = []);
  }
  get selectors() {
    return list$1.comma(this.selector);
  }
  set selectors(Ae) {
    let xr = this.selector ? this.selector.match(/,\s*/) : null, ed = xr ? xr[0] : "," + this.raw("between", "beforeOpen");
    this.selector = Ae.join(ed);
  }
};
var rule = Rule$3;
Rule$3.default = Rule$3;
Container$3.registerRule(Rule$3);
let Declaration$2 = declaration, tokenizer = tokenize, Comment$2 = comment, AtRule$2 = atRule, Root$4 = root, Rule$2 = rule;
const SAFE_COMMENT_NEIGHBOR = {
  empty: !0,
  space: !0
};
function findLastWithPosition(td) {
  for (let Ae = td.length - 1; Ae >= 0; Ae--) {
    let xr = td[Ae], ed = xr[3] || xr[2];
    if (ed)
      return ed;
  }
}
let Parser$1 = class {
  constructor(Ae) {
    this.input = Ae, this.root = new Root$4(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: Ae, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(Ae) {
    let xr = new AtRule$2();
    xr.name = Ae[1].slice(1), xr.name === "" && this.unnamedAtrule(xr, Ae), this.init(xr, Ae[2]);
    let ed, id, od, ad = !1, rd = !1, sd = [], nd = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (Ae = this.tokenizer.nextToken(), ed = Ae[0], ed === "(" || ed === "[" ? nd.push(ed === "(" ? ")" : "]") : ed === "{" && nd.length > 0 ? nd.push("}") : ed === nd[nd.length - 1] && nd.pop(), nd.length === 0)
        if (ed === ";") {
          xr.source.end = this.getPosition(Ae[2]), xr.source.end.offset++, this.semicolon = !0;
          break;
        } else if (ed === "{") {
          rd = !0;
          break;
        } else if (ed === "}") {
          if (sd.length > 0) {
            for (od = sd.length - 1, id = sd[od]; id && id[0] === "space"; )
              id = sd[--od];
            id && (xr.source.end = this.getPosition(id[3] || id[2]), xr.source.end.offset++);
          }
          this.end(Ae);
          break;
        } else
          sd.push(Ae);
      else
        sd.push(Ae);
      if (this.tokenizer.endOfFile()) {
        ad = !0;
        break;
      }
    }
    xr.raws.between = this.spacesAndCommentsFromEnd(sd), sd.length ? (xr.raws.afterName = this.spacesAndCommentsFromStart(sd), this.raw(xr, "params", sd), ad && (Ae = sd[sd.length - 1], xr.source.end = this.getPosition(Ae[3] || Ae[2]), xr.source.end.offset++, this.spaces = xr.raws.between, xr.raws.between = "")) : (xr.raws.afterName = "", xr.params = ""), rd && (xr.nodes = [], this.current = xr);
  }
  checkMissedSemicolon(Ae) {
    let xr = this.colon(Ae);
    if (xr === !1)
      return;
    let ed = 0, id;
    for (let od = xr - 1; od >= 0 && (id = Ae[od], !(id[0] !== "space" && (ed += 1, ed === 2))); od--)
      ;
    throw this.input.error(
      "Missed semicolon",
      id[0] === "word" ? id[3] + 1 : id[2]
    );
  }
  colon(Ae) {
    let xr = 0, ed, id, od;
    for (let [ad, rd] of Ae.entries()) {
      if (ed = rd, id = ed[0], id === "(" && (xr += 1), id === ")" && (xr -= 1), xr === 0 && id === ":")
        if (!od)
          this.doubleColon(ed);
        else {
          if (od[0] === "word" && od[1] === "progid")
            continue;
          return ad;
        }
      od = ed;
    }
    return !1;
  }
  comment(Ae) {
    let xr = new Comment$2();
    this.init(xr, Ae[2]), xr.source.end = this.getPosition(Ae[3] || Ae[2]), xr.source.end.offset++;
    let ed = Ae[1].slice(2, -2);
    if (/^\s*$/.test(ed))
      xr.text = "", xr.raws.left = ed, xr.raws.right = "";
    else {
      let id = ed.match(/^(\s*)([^]*\S)(\s*)$/);
      xr.text = id[2], xr.raws.left = id[1], xr.raws.right = id[3];
    }
  }
  createTokenizer() {
    this.tokenizer = tokenizer(this.input);
  }
  decl(Ae, xr) {
    let ed = new Declaration$2();
    this.init(ed, Ae[0][2]);
    let id = Ae[Ae.length - 1];
    for (id[0] === ";" && (this.semicolon = !0, Ae.pop()), ed.source.end = this.getPosition(
      id[3] || id[2] || findLastWithPosition(Ae)
    ), ed.source.end.offset++; Ae[0][0] !== "word"; )
      Ae.length === 1 && this.unknownWord(Ae), ed.raws.before += Ae.shift()[1];
    for (ed.source.start = this.getPosition(Ae[0][2]), ed.prop = ""; Ae.length; ) {
      let nd = Ae[0][0];
      if (nd === ":" || nd === "space" || nd === "comment")
        break;
      ed.prop += Ae.shift()[1];
    }
    ed.raws.between = "";
    let od;
    for (; Ae.length; )
      if (od = Ae.shift(), od[0] === ":") {
        ed.raws.between += od[1];
        break;
      } else
        od[0] === "word" && /\w/.test(od[1]) && this.unknownWord([od]), ed.raws.between += od[1];
    (ed.prop[0] === "_" || ed.prop[0] === "*") && (ed.raws.before += ed.prop[0], ed.prop = ed.prop.slice(1));
    let ad = [], rd;
    for (; Ae.length && (rd = Ae[0][0], !(rd !== "space" && rd !== "comment")); )
      ad.push(Ae.shift());
    this.precheckMissedSemicolon(Ae);
    for (let nd = Ae.length - 1; nd >= 0; nd--) {
      if (od = Ae[nd], od[1].toLowerCase() === "!important") {
        ed.important = !0;
        let cd = this.stringFrom(Ae, nd);
        cd = this.spacesFromEnd(Ae) + cd, cd !== " !important" && (ed.raws.important = cd);
        break;
      } else if (od[1].toLowerCase() === "important") {
        let cd = Ae.slice(0), ud = "";
        for (let ld = nd; ld > 0; ld--) {
          let dd = cd[ld][0];
          if (ud.trim().indexOf("!") === 0 && dd !== "space")
            break;
          ud = cd.pop()[1] + ud;
        }
        ud.trim().indexOf("!") === 0 && (ed.important = !0, ed.raws.important = ud, Ae = cd);
      }
      if (od[0] !== "space" && od[0] !== "comment")
        break;
    }
    Ae.some((nd) => nd[0] !== "space" && nd[0] !== "comment") && (ed.raws.between += ad.map((nd) => nd[1]).join(""), ad = []), this.raw(ed, "value", ad.concat(Ae), xr), ed.value.includes(":") && !xr && this.checkMissedSemicolon(Ae);
  }
  doubleColon(Ae) {
    throw this.input.error(
      "Double colon",
      { offset: Ae[2] },
      { offset: Ae[2] + Ae[1].length }
    );
  }
  emptyRule(Ae) {
    let xr = new Rule$2();
    this.init(xr, Ae[2]), xr.selector = "", xr.raws.between = "", this.current = xr;
  }
  end(Ae) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(Ae[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(Ae);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(Ae) {
    if (this.spaces += Ae[1], this.current.nodes) {
      let xr = this.current.nodes[this.current.nodes.length - 1];
      xr && xr.type === "rule" && !xr.raws.ownSemicolon && (xr.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }
  // Helpers
  getPosition(Ae) {
    let xr = this.input.fromOffset(Ae);
    return {
      column: xr.col,
      line: xr.line,
      offset: Ae
    };
  }
  init(Ae, xr) {
    this.current.push(Ae), Ae.source = {
      input: this.input,
      start: this.getPosition(xr)
    }, Ae.raws.before = this.spaces, this.spaces = "", Ae.type !== "comment" && (this.semicolon = !1);
  }
  other(Ae) {
    let xr = !1, ed = null, id = !1, od = null, ad = [], rd = Ae[1].startsWith("--"), sd = [], nd = Ae;
    for (; nd; ) {
      if (ed = nd[0], sd.push(nd), ed === "(" || ed === "[")
        od || (od = nd), ad.push(ed === "(" ? ")" : "]");
      else if (rd && id && ed === "{")
        od || (od = nd), ad.push("}");
      else if (ad.length === 0)
        if (ed === ";")
          if (id) {
            this.decl(sd, rd);
            return;
          } else
            break;
        else if (ed === "{") {
          this.rule(sd);
          return;
        } else if (ed === "}") {
          this.tokenizer.back(sd.pop()), xr = !0;
          break;
        } else
          ed === ":" && (id = !0);
      else
        ed === ad[ad.length - 1] && (ad.pop(), ad.length === 0 && (od = null));
      nd = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (xr = !0), ad.length > 0 && this.unclosedBracket(od), xr && id) {
      if (!rd)
        for (; sd.length && (nd = sd[sd.length - 1][0], !(nd !== "space" && nd !== "comment")); )
          this.tokenizer.back(sd.pop());
      this.decl(sd, rd);
    } else
      this.unknownWord(sd);
  }
  parse() {
    let Ae;
    for (; !this.tokenizer.endOfFile(); )
      switch (Ae = this.tokenizer.nextToken(), Ae[0]) {
        case "space":
          this.spaces += Ae[1];
          break;
        case ";":
          this.freeSemicolon(Ae);
          break;
        case "}":
          this.end(Ae);
          break;
        case "comment":
          this.comment(Ae);
          break;
        case "at-word":
          this.atrule(Ae);
          break;
        case "{":
          this.emptyRule(Ae);
          break;
        default:
          this.other(Ae);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(Ae, xr, ed, id) {
    let od, ad, rd = ed.length, sd = "", nd = !0, cd, ud;
    for (let ld = 0; ld < rd; ld += 1)
      od = ed[ld], ad = od[0], ad === "space" && ld === rd - 1 && !id ? nd = !1 : ad === "comment" ? (ud = ed[ld - 1] ? ed[ld - 1][0] : "empty", cd = ed[ld + 1] ? ed[ld + 1][0] : "empty", !SAFE_COMMENT_NEIGHBOR[ud] && !SAFE_COMMENT_NEIGHBOR[cd] ? sd.slice(-1) === "," ? nd = !1 : sd += od[1] : nd = !1) : sd += od[1];
    if (!nd) {
      let ld = ed.reduce((dd, pd) => dd + pd[1], "");
      Ae.raws[xr] = { raw: ld, value: sd };
    }
    Ae[xr] = sd;
  }
  rule(Ae) {
    Ae.pop();
    let xr = new Rule$2();
    this.init(xr, Ae[0][2]), xr.raws.between = this.spacesAndCommentsFromEnd(Ae), this.raw(xr, "selector", Ae), this.current = xr;
  }
  spacesAndCommentsFromEnd(Ae) {
    let xr, ed = "";
    for (; Ae.length && (xr = Ae[Ae.length - 1][0], !(xr !== "space" && xr !== "comment")); )
      ed = Ae.pop()[1] + ed;
    return ed;
  }
  // Errors
  spacesAndCommentsFromStart(Ae) {
    let xr, ed = "";
    for (; Ae.length && (xr = Ae[0][0], !(xr !== "space" && xr !== "comment")); )
      ed += Ae.shift()[1];
    return ed;
  }
  spacesFromEnd(Ae) {
    let xr, ed = "";
    for (; Ae.length && (xr = Ae[Ae.length - 1][0], xr === "space"); )
      ed = Ae.pop()[1] + ed;
    return ed;
  }
  stringFrom(Ae, xr) {
    let ed = "";
    for (let id = xr; id < Ae.length; id++)
      ed += Ae[id][1];
    return Ae.splice(xr, Ae.length - xr), ed;
  }
  unclosedBlock() {
    let Ae = this.current.source.start;
    throw this.input.error("Unclosed block", Ae.line, Ae.column);
  }
  unclosedBracket(Ae) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: Ae[2] },
      { offset: Ae[2] + 1 }
    );
  }
  unexpectedClose(Ae) {
    throw this.input.error(
      "Unexpected }",
      { offset: Ae[2] },
      { offset: Ae[2] + 1 }
    );
  }
  unknownWord(Ae) {
    throw this.input.error(
      "Unknown word",
      { offset: Ae[0][2] },
      { offset: Ae[0][2] + Ae[0][1].length }
    );
  }
  unnamedAtrule(Ae, xr) {
    throw this.input.error(
      "At-rule without name",
      { offset: xr[2] },
      { offset: xr[2] + xr[1].length }
    );
  }
};
var parser = Parser$1;
let Container$2 = container, Parser = parser, Input$2 = input;
function parse$3(td, Ae) {
  let xr = new Input$2(td, Ae), ed = new Parser(xr);
  try {
    ed.parse();
  } catch (id) {
    throw id;
  }
  return ed.root;
}
var parse_1 = parse$3;
parse$3.default = parse$3;
Container$2.registerParse(parse$3);
let { isClean, my } = symbols, MapGenerator$1 = mapGenerator, stringify$2 = stringify_1, Container$1 = container, Document$3 = document$1, Result$2 = result, parse$2 = parse_1, Root$3 = root;
const TYPE_TO_CLASS_NAME = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, PLUGIN_PROPS = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, NOT_VISITORS = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, CHILDREN = 0;
function isPromise(td) {
  return typeof td == "object" && typeof td.then == "function";
}
function getEvents(td) {
  let Ae = !1, xr = TYPE_TO_CLASS_NAME[td.type];
  return td.type === "decl" ? Ae = td.prop.toLowerCase() : td.type === "atrule" && (Ae = td.name.toLowerCase()), Ae && td.append ? [
    xr,
    xr + "-" + Ae,
    CHILDREN,
    xr + "Exit",
    xr + "Exit-" + Ae
  ] : Ae ? [xr, xr + "-" + Ae, xr + "Exit", xr + "Exit-" + Ae] : td.append ? [xr, CHILDREN, xr + "Exit"] : [xr, xr + "Exit"];
}
function toStack(td) {
  let Ae;
  return td.type === "document" ? Ae = ["Document", CHILDREN, "DocumentExit"] : td.type === "root" ? Ae = ["Root", CHILDREN, "RootExit"] : Ae = getEvents(td), {
    eventIndex: 0,
    events: Ae,
    iterator: 0,
    node: td,
    visitorIndex: 0,
    visitors: []
  };
}
function cleanMarks(td) {
  return td[isClean] = !1, td.nodes && td.nodes.forEach((Ae) => cleanMarks(Ae)), td;
}
let postcss$1 = {}, LazyResult$2 = class L0 {
  constructor(Ae, xr, ed) {
    this.stringified = !1, this.processed = !1;
    let id;
    if (typeof xr == "object" && xr !== null && (xr.type === "root" || xr.type === "document"))
      id = cleanMarks(xr);
    else if (xr instanceof L0 || xr instanceof Result$2)
      id = cleanMarks(xr.root), xr.map && (typeof ed.map == "undefined" && (ed.map = {}), ed.map.inline || (ed.map.inline = !1), ed.map.prev = xr.map);
    else {
      let od = parse$2;
      ed.syntax && (od = ed.syntax.parse), ed.parser && (od = ed.parser), od.parse && (od = od.parse);
      try {
        id = od(xr, ed);
      } catch (ad) {
        this.processed = !0, this.error = ad;
      }
      id && !id[my] && Container$1.rebuild(id);
    }
    this.result = new Result$2(Ae, id, ed), this.helpers = { ...postcss$1, postcss: postcss$1, result: this.result }, this.plugins = this.processor.plugins.map((od) => typeof od == "object" && od.prepare ? { ...od, ...od.prepare(this.result) } : od);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(Ae) {
    return this.async().catch(Ae);
  }
  finally(Ae) {
    return this.async().then(Ae, Ae);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(Ae, xr) {
    let ed = this.result.lastPlugin;
    try {
      xr && xr.addToError(Ae), this.error = Ae, Ae.name === "CssSyntaxError" && !Ae.plugin ? (Ae.plugin = ed.postcssPlugin, Ae.setMessage()) : ed.postcssVersion;
    } catch (id) {
      console && console.error && console.error(id);
    }
    return Ae;
  }
  prepareVisitors() {
    this.listeners = {};
    let Ae = (xr, ed, id) => {
      this.listeners[ed] || (this.listeners[ed] = []), this.listeners[ed].push([xr, id]);
    };
    for (let xr of this.plugins)
      if (typeof xr == "object")
        for (let ed in xr) {
          if (!PLUGIN_PROPS[ed] && /^[A-Z]/.test(ed))
            throw new Error(
              `Unknown event ${ed} in ${xr.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!NOT_VISITORS[ed])
            if (typeof xr[ed] == "object")
              for (let id in xr[ed])
                id === "*" ? Ae(xr, ed, xr[ed][id]) : Ae(
                  xr,
                  ed + "-" + id.toLowerCase(),
                  xr[ed][id]
                );
            else
              typeof xr[ed] == "function" && Ae(xr, ed, xr[ed]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let Ae = 0; Ae < this.plugins.length; Ae++) {
      let xr = this.plugins[Ae], ed = this.runOnRoot(xr);
      if (isPromise(ed))
        try {
          await ed;
        } catch (id) {
          throw this.handleError(id);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let Ae = this.result.root;
      for (; !Ae[isClean]; ) {
        Ae[isClean] = !0;
        let xr = [toStack(Ae)];
        for (; xr.length > 0; ) {
          let ed = this.visitTick(xr);
          if (isPromise(ed))
            try {
              await ed;
            } catch (id) {
              let od = xr[xr.length - 1].node;
              throw this.handleError(id, od);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [xr, ed] of this.listeners.OnceExit) {
          this.result.lastPlugin = xr;
          try {
            if (Ae.type === "document") {
              let id = Ae.nodes.map(
                (od) => ed(od, this.helpers)
              );
              await Promise.all(id);
            } else
              await ed(Ae, this.helpers);
          } catch (id) {
            throw this.handleError(id);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(Ae) {
    this.result.lastPlugin = Ae;
    try {
      if (typeof Ae == "object" && Ae.Once) {
        if (this.result.root.type === "document") {
          let xr = this.result.root.nodes.map(
            (ed) => Ae.Once(ed, this.helpers)
          );
          return isPromise(xr[0]) ? Promise.all(xr) : xr;
        }
        return Ae.Once(this.result.root, this.helpers);
      } else if (typeof Ae == "function")
        return Ae(this.result.root, this.result);
    } catch (xr) {
      throw this.handleError(xr);
    }
  }
  stringify() {
    if (this.error)
      throw this.error;
    if (this.stringified)
      return this.result;
    this.stringified = !0, this.sync();
    let Ae = this.result.opts, xr = stringify$2;
    Ae.syntax && (xr = Ae.syntax.stringify), Ae.stringifier && (xr = Ae.stringifier), xr.stringify && (xr = xr.stringify);
    let id = new MapGenerator$1(xr, this.result.root, this.result.opts).generate();
    return this.result.css = id[0], this.result.map = id[1], this.result;
  }
  sync() {
    if (this.error)
      throw this.error;
    if (this.processed)
      return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let Ae of this.plugins) {
      let xr = this.runOnRoot(Ae);
      if (isPromise(xr))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let Ae = this.result.root;
      for (; !Ae[isClean]; )
        Ae[isClean] = !0, this.walkSync(Ae);
      if (this.listeners.OnceExit)
        if (Ae.type === "document")
          for (let xr of Ae.nodes)
            this.visitSync(this.listeners.OnceExit, xr);
        else
          this.visitSync(this.listeners.OnceExit, Ae);
    }
    return this.result;
  }
  then(Ae, xr) {
    return this.async().then(Ae, xr);
  }
  toString() {
    return this.css;
  }
  visitSync(Ae, xr) {
    for (let [ed, id] of Ae) {
      this.result.lastPlugin = ed;
      let od;
      try {
        od = id(xr, this.helpers);
      } catch (ad) {
        throw this.handleError(ad, xr.proxyOf);
      }
      if (xr.type !== "root" && xr.type !== "document" && !xr.parent)
        return !0;
      if (isPromise(od))
        throw this.getAsyncError();
    }
  }
  visitTick(Ae) {
    let xr = Ae[Ae.length - 1], { node: ed, visitors: id } = xr;
    if (ed.type !== "root" && ed.type !== "document" && !ed.parent) {
      Ae.pop();
      return;
    }
    if (id.length > 0 && xr.visitorIndex < id.length) {
      let [ad, rd] = id[xr.visitorIndex];
      xr.visitorIndex += 1, xr.visitorIndex === id.length && (xr.visitors = [], xr.visitorIndex = 0), this.result.lastPlugin = ad;
      try {
        return rd(ed.toProxy(), this.helpers);
      } catch (sd) {
        throw this.handleError(sd, ed);
      }
    }
    if (xr.iterator !== 0) {
      let ad = xr.iterator, rd;
      for (; rd = ed.nodes[ed.indexes[ad]]; )
        if (ed.indexes[ad] += 1, !rd[isClean]) {
          rd[isClean] = !0, Ae.push(toStack(rd));
          return;
        }
      xr.iterator = 0, delete ed.indexes[ad];
    }
    let od = xr.events;
    for (; xr.eventIndex < od.length; ) {
      let ad = od[xr.eventIndex];
      if (xr.eventIndex += 1, ad === CHILDREN) {
        ed.nodes && ed.nodes.length && (ed[isClean] = !0, xr.iterator = ed.getIterator());
        return;
      } else if (this.listeners[ad]) {
        xr.visitors = this.listeners[ad];
        return;
      }
    }
    Ae.pop();
  }
  walkSync(Ae) {
    Ae[isClean] = !0;
    let xr = getEvents(Ae);
    for (let ed of xr)
      if (ed === CHILDREN)
        Ae.nodes && Ae.each((id) => {
          id[isClean] || this.walkSync(id);
        });
      else {
        let id = this.listeners[ed];
        if (id && this.visitSync(id, Ae.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
};
LazyResult$2.registerPostcss = (td) => {
  postcss$1 = td;
};
var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;
Root$3.registerLazyResult(LazyResult$2);
Document$3.registerLazyResult(LazyResult$2);
let MapGenerator = mapGenerator, stringify$1 = stringify_1, parse$1 = parse_1;
const Result$1 = result;
let NoWorkResult$1 = class {
  constructor(Ae, xr, ed) {
    xr = xr.toString(), this.stringified = !1, this._processor = Ae, this._css = xr, this._opts = ed, this._map = void 0;
    let id, od = stringify$1;
    this.result = new Result$1(this._processor, id, this._opts), this.result.css = xr;
    let ad = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return ad.root;
      }
    });
    let rd = new MapGenerator(od, id, this._opts, xr);
    if (rd.isMap()) {
      let [sd, nd] = rd.generate();
      sd && (this.result.css = sd), nd && (this.result.map = nd);
    } else
      rd.clearAnnotation(), this.result.css = rd.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(Ae) {
    return this.async().catch(Ae);
  }
  finally(Ae) {
    return this.async().then(Ae, Ae);
  }
  sync() {
    if (this.error)
      throw this.error;
    return this.result;
  }
  then(Ae, xr) {
    return this.async().then(Ae, xr);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let Ae, xr = parse$1;
    try {
      Ae = xr(this._css, this._opts);
    } catch (ed) {
      this.error = ed;
    }
    if (this.error)
      throw this.error;
    return this._root = Ae, Ae;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
};
var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;
let NoWorkResult = noWorkResult, LazyResult$1 = lazyResult, Document$2 = document$1, Root$2 = root, Processor$1 = class {
  constructor(Ae = []) {
    this.version = "8.4.41", this.plugins = this.normalize(Ae);
  }
  normalize(Ae) {
    let xr = [];
    for (let ed of Ae)
      if (ed.postcss === !0 ? ed = ed() : ed.postcss && (ed = ed.postcss), typeof ed == "object" && Array.isArray(ed.plugins))
        xr = xr.concat(ed.plugins);
      else if (typeof ed == "object" && ed.postcssPlugin)
        xr.push(ed);
      else if (typeof ed == "function")
        xr.push(ed);
      else if (!(typeof ed == "object" && (ed.parse || ed.stringify)))
        throw new Error(ed + " is not a PostCSS plugin");
    return xr;
  }
  process(Ae, xr = {}) {
    return !this.plugins.length && !xr.parser && !xr.stringifier && !xr.syntax ? new NoWorkResult(this, Ae, xr) : new LazyResult$1(this, Ae, xr);
  }
  use(Ae) {
    return this.plugins = this.plugins.concat(this.normalize([Ae])), this;
  }
};
var processor = Processor$1;
Processor$1.default = Processor$1;
Root$2.registerProcessor(Processor$1);
Document$2.registerProcessor(Processor$1);
let Declaration$1 = declaration, PreviousMap = previousMap, Comment$1 = comment, AtRule$1 = atRule, Input$1 = input, Root$1 = root, Rule$1 = rule;
function fromJSON$1(td, Ae) {
  if (Array.isArray(td))
    return td.map((id) => fromJSON$1(id));
  let { inputs: xr, ...ed } = td;
  if (xr) {
    Ae = [];
    for (let id of xr) {
      let od = { ...id, __proto__: Input$1.prototype };
      od.map && (od.map = {
        ...od.map,
        __proto__: PreviousMap.prototype
      }), Ae.push(od);
    }
  }
  if (ed.nodes && (ed.nodes = td.nodes.map((id) => fromJSON$1(id, Ae))), ed.source) {
    let { inputId: id, ...od } = ed.source;
    ed.source = od, id != null && (ed.source.input = Ae[id]);
  }
  if (ed.type === "root")
    return new Root$1(ed);
  if (ed.type === "decl")
    return new Declaration$1(ed);
  if (ed.type === "rule")
    return new Rule$1(ed);
  if (ed.type === "comment")
    return new Comment$1(ed);
  if (ed.type === "atrule")
    return new AtRule$1(ed);
  throw new Error("Unknown node type: " + td.type);
}
var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;
let CssSyntaxError = cssSyntaxError, Declaration = declaration, LazyResult = lazyResult, Container = container, Processor = processor, stringify = stringify_1, fromJSON = fromJSON_1, Document$1 = document$1, Warning = warning, Comment = comment, AtRule = atRule, Result = result, Input = input, parse = parse_1, list = list_1, Rule = rule, Root = root, Node$1 = node;
function postcss(...td) {
  return td.length === 1 && Array.isArray(td[0]) && (td = td[0]), new Processor(td);
}
postcss.plugin = function td(Ae, xr) {
  let ed = !1;
  function id(...ad) {
    console && console.warn && !ed && (ed = !0, console.warn(
      Ae + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      Ae + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let rd = xr(...ad);
    return rd.postcssPlugin = Ae, rd.postcssVersion = new Processor().version, rd;
  }
  let od;
  return Object.defineProperty(id, "postcss", {
    get() {
      return od || (od = id()), od;
    }
  }), id.process = function(ad, rd, sd) {
    return postcss([id(sd)]).process(ad, rd);
  }, id;
};
postcss.stringify = stringify;
postcss.parse = parse;
postcss.fromJSON = fromJSON;
postcss.list = list;
postcss.comment = (td) => new Comment(td);
postcss.atRule = (td) => new AtRule(td);
postcss.decl = (td) => new Declaration(td);
postcss.rule = (td) => new Rule(td);
postcss.root = (td) => new Root(td);
postcss.document = (td) => new Document$1(td);
postcss.CssSyntaxError = CssSyntaxError;
postcss.Declaration = Declaration;
postcss.Container = Container;
postcss.Processor = Processor;
postcss.Document = Document$1;
postcss.Comment = Comment;
postcss.Warning = Warning;
postcss.AtRule = AtRule;
postcss.Result = Result;
postcss.Input = Input;
postcss.Rule = Rule;
postcss.Root = Root;
postcss.Node = Node$1;
LazyResult.registerPostcss(postcss);
var postcss_1 = postcss;
postcss.default = postcss;
const htmlparser = lib$5, escapeStringRegexp = escapeStringRegexp$1, { isPlainObject } = isPlainObject$2, deepmerge = cjs, parseSrcset = parseSrcsetExports, { parse: postcssParse } = postcss_1, mediaTags = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], vulnerableTags = ["script", "style"];
function each(td, Ae) {
  td && Object.keys(td).forEach(function(xr) {
    Ae(td[xr], xr);
  });
}
function has(td, Ae) {
  return {}.hasOwnProperty.call(td, Ae);
}
function filter(td, Ae) {
  const xr = [];
  return each(td, function(ed) {
    Ae(ed) && xr.push(ed);
  }), xr;
}
function isEmptyObject(td) {
  for (const Ae in td)
    if (has(td, Ae))
      return !1;
  return !0;
}
function stringifySrcset(td) {
  return td.map(function(Ae) {
    if (!Ae.url)
      throw new Error("URL missing");
    return Ae.url + (Ae.w ? ` ${Ae.w}w` : "") + (Ae.h ? ` ${Ae.h}h` : "") + (Ae.d ? ` ${Ae.d}x` : "");
  }).join(", ");
}
var sanitizeHtml_1 = sanitizeHtml;
const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
function sanitizeHtml(td, Ae, xr) {
  if (td == null)
    return "";
  typeof td == "number" && (td = td.toString());
  let ed = "", id = "";
  function od(Dd, Fd) {
    const xd = this;
    this.tag = Dd, this.attribs = Fd || {}, this.tagPosition = ed.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function() {
      if (fd.length) {
        const Ad = fd[fd.length - 1];
        Ad.text += xd.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      fd.length && mediaTags.includes(this.tag) && fd[fd.length - 1].mediaChildren.push(this.tag);
    };
  }
  Ae = Object.assign({}, sanitizeHtml.defaults, Ae), Ae.parser = Object.assign({}, htmlParserDefaults, Ae.parser);
  const ad = function(Dd) {
    return Ae.allowedTags === !1 || (Ae.allowedTags || []).indexOf(Dd) > -1;
  };
  vulnerableTags.forEach(function(Dd) {
    ad(Dd) && !Ae.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${Dd}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const rd = Ae.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let sd, nd;
  Ae.allowedAttributes && (sd = {}, nd = {}, each(Ae.allowedAttributes, function(Dd, Fd) {
    sd[Fd] = [];
    const xd = [];
    Dd.forEach(function(Ad) {
      typeof Ad == "string" && Ad.indexOf("*") >= 0 ? xd.push(escapeStringRegexp(Ad).replace(/\\\*/g, ".*")) : sd[Fd].push(Ad);
    }), xd.length && (nd[Fd] = new RegExp("^(" + xd.join("|") + ")$"));
  }));
  const cd = {}, ud = {}, ld = {};
  each(Ae.allowedClasses, function(Dd, Fd) {
    if (sd && (has(sd, Fd) || (sd[Fd] = []), sd[Fd].push("class")), cd[Fd] = Dd, Array.isArray(Dd)) {
      const xd = [];
      cd[Fd] = [], ld[Fd] = [], Dd.forEach(function(Ad) {
        typeof Ad == "string" && Ad.indexOf("*") >= 0 ? xd.push(escapeStringRegexp(Ad).replace(/\\\*/g, ".*")) : Ad instanceof RegExp ? ld[Fd].push(Ad) : cd[Fd].push(Ad);
      }), xd.length && (ud[Fd] = new RegExp("^(" + xd.join("|") + ")$"));
    }
  });
  const dd = {};
  let pd;
  each(Ae.transformTags, function(Dd, Fd) {
    let xd;
    typeof Dd == "function" ? xd = Dd : typeof Dd == "string" && (xd = sanitizeHtml.simpleTransform(Dd)), Fd === "*" ? pd = xd : dd[Fd] = xd;
  });
  let md, fd, bd, Sd, vd, Ed, Td = !1;
  Id();
  const Gd = new htmlparser.Parser({
    onopentag: function(Dd, Fd) {
      if (Ae.enforceHtmlBoundary && Dd === "html" && Id(), vd) {
        Ed++;
        return;
      }
      const xd = new od(Dd, Fd);
      fd.push(xd);
      let Ad = !1;
      const Nd = !!xd.text;
      let zd;
      if (has(dd, Dd) && (zd = dd[Dd](Dd, Fd), xd.attribs = Fd = zd.attribs, zd.text !== void 0 && (xd.innerText = zd.text), Dd !== zd.tagName && (xd.name = Dd = zd.tagName, Sd[md] = zd.tagName)), pd && (zd = pd(Dd, Fd), xd.attribs = Fd = zd.attribs, Dd !== zd.tagName && (xd.name = Dd = zd.tagName, Sd[md] = zd.tagName)), (!ad(Dd) || Ae.disallowedTagsMode === "recursiveEscape" && !isEmptyObject(bd) || Ae.nestingLimit != null && md >= Ae.nestingLimit) && (Ad = !0, bd[md] = !0, (Ae.disallowedTagsMode === "discard" || Ae.disallowedTagsMode === "completelyDiscard") && rd.indexOf(Dd) !== -1 && (vd = !0, Ed = 1), bd[md] = !0), md++, Ad) {
        if (Ae.disallowedTagsMode === "discard" || Ae.disallowedTagsMode === "completelyDiscard")
          return;
        id = ed, ed = "";
      }
      ed += "<" + Dd, Dd === "script" && (Ae.allowedScriptHostnames || Ae.allowedScriptDomains) && (xd.innerText = ""), (!sd || has(sd, Dd) || sd["*"]) && each(Fd, function(Wd, Ud) {
        if (!VALID_HTML_ATTRIBUTE_NAME.test(Ud)) {
          delete xd.attribs[Ud];
          return;
        }
        if (Wd === "" && !Ae.allowedEmptyAttributes.includes(Ud) && (Ae.nonBooleanAttributes.includes(Ud) || Ae.nonBooleanAttributes.includes("*"))) {
          delete xd.attribs[Ud];
          return;
        }
        let oh = !1;
        if (!sd || has(sd, Dd) && sd[Dd].indexOf(Ud) !== -1 || sd["*"] && sd["*"].indexOf(Ud) !== -1 || has(nd, Dd) && nd[Dd].test(Ud) || nd["*"] && nd["*"].test(Ud))
          oh = !0;
        else if (sd && sd[Dd]) {
          for (const Vd of sd[Dd])
            if (isPlainObject(Vd) && Vd.name && Vd.name === Ud) {
              oh = !0;
              let Od = "";
              if (Vd.multiple === !0) {
                const lh = Wd.split(" ");
                for (const nh of lh)
                  Vd.values.indexOf(nh) !== -1 && (Od === "" ? Od = nh : Od += " " + nh);
              } else
                Vd.values.indexOf(Wd) >= 0 && (Od = Wd);
              Wd = Od;
            }
        }
        if (oh) {
          if (Ae.allowedSchemesAppliedToAttributes.indexOf(Ud) !== -1 && Hd(Dd, Wd)) {
            delete xd.attribs[Ud];
            return;
          }
          if (Dd === "script" && Ud === "src") {
            let Vd = !0;
            try {
              const Od = Rd(Wd);
              if (Ae.allowedScriptHostnames || Ae.allowedScriptDomains) {
                const lh = (Ae.allowedScriptHostnames || []).find(function(Xd) {
                  return Xd === Od.url.hostname;
                }), nh = (Ae.allowedScriptDomains || []).find(function(Xd) {
                  return Od.url.hostname === Xd || Od.url.hostname.endsWith(`.${Xd}`);
                });
                Vd = lh || nh;
              }
            } catch (Od) {
              Vd = !1;
            }
            if (!Vd) {
              delete xd.attribs[Ud];
              return;
            }
          }
          if (Dd === "iframe" && Ud === "src") {
            let Vd = !0;
            try {
              const Od = Rd(Wd);
              if (Od.isRelativeUrl)
                Vd = has(Ae, "allowIframeRelativeUrls") ? Ae.allowIframeRelativeUrls : !Ae.allowedIframeHostnames && !Ae.allowedIframeDomains;
              else if (Ae.allowedIframeHostnames || Ae.allowedIframeDomains) {
                const lh = (Ae.allowedIframeHostnames || []).find(function(Xd) {
                  return Xd === Od.url.hostname;
                }), nh = (Ae.allowedIframeDomains || []).find(function(Xd) {
                  return Od.url.hostname === Xd || Od.url.hostname.endsWith(`.${Xd}`);
                });
                Vd = lh || nh;
              }
            } catch (Od) {
              Vd = !1;
            }
            if (!Vd) {
              delete xd.attribs[Ud];
              return;
            }
          }
          if (Ud === "srcset")
            try {
              let Vd = parseSrcset(Wd);
              if (Vd.forEach(function(Od) {
                Hd("srcset", Od.url) && (Od.evil = !0);
              }), Vd = filter(Vd, function(Od) {
                return !Od.evil;
              }), Vd.length)
                Wd = stringifySrcset(filter(Vd, function(Od) {
                  return !Od.evil;
                })), xd.attribs[Ud] = Wd;
              else {
                delete xd.attribs[Ud];
                return;
              }
            } catch (Vd) {
              delete xd.attribs[Ud];
              return;
            }
          if (Ud === "class") {
            const Vd = cd[Dd], Od = cd["*"], lh = ud[Dd], nh = ld[Dd], Xd = ud["*"], wh = [
              lh,
              Xd
            ].concat(nh).filter(function(Oh) {
              return Oh;
            });
            if (Vd && Od ? Wd = kd(Wd, deepmerge(Vd, Od), wh) : Wd = kd(Wd, Vd || Od, wh), !Wd.length) {
              delete xd.attribs[Ud];
              return;
            }
          }
          if (Ud === "style") {
            if (Ae.parseStyleAttributes)
              try {
                const Vd = postcssParse(Dd + " {" + Wd + "}", { map: !1 }), Od = Cd(Vd, Ae.allowedStyles);
                if (Wd = wd(Od), Wd.length === 0) {
                  delete xd.attribs[Ud];
                  return;
                }
              } catch (Vd) {
                typeof window != "undefined" && console.warn('Failed to parse "' + Dd + " {" + Wd + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete xd.attribs[Ud];
                return;
              }
            else if (Ae.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          ed += " " + Ud, Wd && Wd.length ? ed += '="' + Pd(Wd, !0) + '"' : Ae.allowedEmptyAttributes.includes(Ud) && (ed += '=""');
        } else
          delete xd.attribs[Ud];
      }), Ae.selfClosing.indexOf(Dd) !== -1 ? ed += " />" : (ed += ">", xd.innerText && !Nd && !Ae.textFilter && (ed += Pd(xd.innerText), Td = !0)), Ad && (ed = id + Pd(ed), id = "");
    },
    ontext: function(Dd) {
      if (vd)
        return;
      const Fd = fd[fd.length - 1];
      let xd;
      if (Fd && (xd = Fd.tag, Dd = Fd.innerText !== void 0 ? Fd.innerText : Dd), Ae.disallowedTagsMode === "completelyDiscard" && !ad(xd))
        Dd = "";
      else if ((Ae.disallowedTagsMode === "discard" || Ae.disallowedTagsMode === "completelyDiscard") && (xd === "script" || xd === "style"))
        ed += Dd;
      else {
        const Ad = Pd(Dd, !1);
        Ae.textFilter && !Td ? ed += Ae.textFilter(Ad, xd) : Td || (ed += Ad);
      }
      if (fd.length) {
        const Ad = fd[fd.length - 1];
        Ad.text += Dd;
      }
    },
    onclosetag: function(Dd, Fd) {
      if (vd)
        if (Ed--, !Ed)
          vd = !1;
        else
          return;
      const xd = fd.pop();
      if (!xd)
        return;
      if (xd.tag !== Dd) {
        fd.push(xd);
        return;
      }
      vd = Ae.enforceHtmlBoundary ? Dd === "html" : !1, md--;
      const Ad = bd[md];
      if (Ad) {
        if (delete bd[md], Ae.disallowedTagsMode === "discard" || Ae.disallowedTagsMode === "completelyDiscard") {
          xd.updateParentNodeText();
          return;
        }
        id = ed, ed = "";
      }
      if (Sd[md] && (Dd = Sd[md], delete Sd[md]), Ae.exclusiveFilter && Ae.exclusiveFilter(xd)) {
        ed = ed.substr(0, xd.tagPosition);
        return;
      }
      if (xd.updateParentNodeMediaChildren(), xd.updateParentNodeText(), // Already output />
      Ae.selfClosing.indexOf(Dd) !== -1 || // Escaped tag, closing tag is implied
      Fd && !ad(Dd) && ["escape", "recursiveEscape"].indexOf(Ae.disallowedTagsMode) >= 0) {
        Ad && (ed = id, id = "");
        return;
      }
      ed += "</" + Dd + ">", Ad && (ed = id + Pd(ed), id = ""), Td = !1;
    }
  }, Ae.parser);
  return Gd.write(td), Gd.end(), ed;
  function Id() {
    ed = "", md = 0, fd = [], bd = {}, Sd = {}, vd = !1, Ed = 0;
  }
  function Pd(Dd, Fd) {
    return typeof Dd != "string" && (Dd = Dd + ""), Ae.parser.decodeEntities && (Dd = Dd.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Fd && (Dd = Dd.replace(/"/g, "&quot;"))), Dd = Dd.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Fd && (Dd = Dd.replace(/"/g, "&quot;")), Dd;
  }
  function Hd(Dd, Fd) {
    for (Fd = Fd.replace(/[\x00-\x20]+/g, ""); ; ) {
      const Nd = Fd.indexOf("<!--");
      if (Nd === -1)
        break;
      const zd = Fd.indexOf("-->", Nd + 4);
      if (zd === -1)
        break;
      Fd = Fd.substring(0, Nd) + Fd.substring(zd + 3);
    }
    const xd = Fd.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!xd)
      return Fd.match(/^[/\\]{2}/) ? !Ae.allowProtocolRelative : !1;
    const Ad = xd[1].toLowerCase();
    return has(Ae.allowedSchemesByTag, Dd) ? Ae.allowedSchemesByTag[Dd].indexOf(Ad) === -1 : !Ae.allowedSchemes || Ae.allowedSchemes.indexOf(Ad) === -1;
  }
  function Rd(Dd) {
    if (Dd = Dd.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), Dd.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let Fd = "relative://relative-site";
    for (let Nd = 0; Nd < 100; Nd++)
      Fd += `/${Nd}`;
    const xd = new URL(Dd, Fd);
    return {
      isRelativeUrl: xd && xd.hostname === "relative-site" && xd.protocol === "relative:",
      url: xd
    };
  }
  function Cd(Dd, Fd) {
    if (!Fd)
      return Dd;
    const xd = Dd.nodes[0];
    let Ad;
    return Fd[xd.selector] && Fd["*"] ? Ad = deepmerge(
      Fd[xd.selector],
      Fd["*"]
    ) : Ad = Fd[xd.selector] || Fd["*"], Ad && (Dd.nodes[0].nodes = xd.nodes.reduce(Ld(Ad), [])), Dd;
  }
  function wd(Dd) {
    return Dd.nodes[0].nodes.reduce(function(Fd, xd) {
      return Fd.push(
        `${xd.prop}:${xd.value}${xd.important ? " !important" : ""}`
      ), Fd;
    }, []).join(";");
  }
  function Ld(Dd) {
    return function(Fd, xd) {
      return has(Dd, xd.prop) && Dd[xd.prop].some(function(Nd) {
        return Nd.test(xd.value);
      }) && Fd.push(xd), Fd;
    };
  }
  function kd(Dd, Fd, xd) {
    return Fd ? (Dd = Dd.split(/\s+/), Dd.filter(function(Ad) {
      return Fd.indexOf(Ad) !== -1 || xd.some(function(Nd) {
        return Nd.test(Ad);
      });
    }).join(" ")) : Dd;
  }
}
const htmlParserDefaults = {
  decodeEntities: !0
};
sanitizeHtml.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "main",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0
};
sanitizeHtml.simpleTransform = function(td, Ae, xr) {
  return xr = xr === void 0 ? !0 : xr, Ae = Ae || {}, function(ed, id) {
    let od;
    if (xr)
      for (od in Ae)
        id[od] = Ae[od];
    else
      id = Ae;
    return {
      tagName: td,
      attribs: id
    };
  };
};
const sanitizeHTML = /* @__PURE__ */ getDefaultExportFromCjs(sanitizeHtml_1), quillStyles = `/*!
 * Quill Editor v2.0.2
 * https://quilljs.com
 * Copyright (c) 2017-2024, Slab
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container:not(.ql-disabled) li[data-list=checked]>.ql-ui,.ql-container:not(.ql-disabled) li[data-list=unchecked]>.ql-ui{cursor:pointer}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor p,.ql-editor ol,.ql-editor pre,.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{margin:0;padding:0}@supports (counter-set:none){.ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{counter-set:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor table{border-collapse:collapse}.ql-editor td{border:1px solid #000;padding:2px 5px}.ql-editor ol{padding-left:1.5em}.ql-editor li{list-style-type:none;padding-left:1.5em;position:relative}.ql-editor li>.ql-ui:before{display:inline-block;margin-left:-1.5em;margin-right:.3em;text-align:right;white-space:nowrap;width:1.2em}.ql-editor li[data-list=checked]>.ql-ui,.ql-editor li[data-list=unchecked]>.ql-ui{color:#777}.ql-editor li[data-list=bullet]>.ql-ui:before{content:"•"}.ql-editor li[data-list=checked]>.ql-ui:before{content:"☑"}.ql-editor li[data-list=unchecked]>.ql-ui:before{content:"☐"}@supports (counter-set:none){.ql-editor li[data-list]{counter-set:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list]{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered]{counter-increment:list-0}.ql-editor li[data-list=ordered]>.ql-ui:before{content:counter(list-0,decimal) ". "}.ql-editor li[data-list=ordered].ql-indent-1{counter-increment:list-1}.ql-editor li[data-list=ordered].ql-indent-1>.ql-ui:before{content:counter(list-1,lower-alpha) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-1{counter-set:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-2{counter-increment:list-2}.ql-editor li[data-list=ordered].ql-indent-2>.ql-ui:before{content:counter(list-2,lower-roman) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-2{counter-set:list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-3{counter-increment:list-3}.ql-editor li[data-list=ordered].ql-indent-3>.ql-ui:before{content:counter(list-3,decimal) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-3{counter-set:list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-4{counter-increment:list-4}.ql-editor li[data-list=ordered].ql-indent-4>.ql-ui:before{content:counter(list-4,lower-alpha) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-4{counter-set:list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-5{counter-increment:list-5}.ql-editor li[data-list=ordered].ql-indent-5>.ql-ui:before{content:counter(list-5,lower-roman) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-5{counter-set:list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-6{counter-increment:list-6}.ql-editor li[data-list=ordered].ql-indent-6>.ql-ui:before{content:counter(list-6,decimal) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-6{counter-set:list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-6{counter-reset:list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-7{counter-increment:list-7}.ql-editor li[data-list=ordered].ql-indent-7>.ql-ui:before{content:counter(list-7,lower-alpha) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-7{counter-set:list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-7{counter-reset:list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-8{counter-increment:list-8}.ql-editor li[data-list=ordered].ql-indent-8>.ql-ui:before{content:counter(list-8,lower-roman) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-8{counter-set:list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-8{counter-reset:list-9}}.ql-editor li[data-list=ordered].ql-indent-9{counter-increment:list-9}.ql-editor li[data-list=ordered].ql-indent-9>.ql-ui:before{content:counter(list-9,decimal) ". "}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor li.ql-direction-rtl{padding-right:1.5em}.ql-editor li.ql-direction-rtl>.ql-ui:before{margin-left:.3em;margin-right:-1.5em;text-align:left}.ql-editor table{table-layout:fixed;width:100%}.ql-editor table td{outline:none}.ql-editor .ql-code-block-container{font-family:monospace}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor .ql-ui{position:absolute}.ql-editor.ql-blank:before{color:#0009;content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}`, quillSnowStyles = `/*!
 * Quill Editor v2.0.2
 * https://quilljs.com
 * Copyright (c) 2017-2024, Slab
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container:not(.ql-disabled) li[data-list=checked]>.ql-ui,.ql-container:not(.ql-disabled) li[data-list=unchecked]>.ql-ui{cursor:pointer}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor p,.ql-editor ol,.ql-editor pre,.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{margin:0;padding:0}@supports (counter-set:none){.ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{counter-set:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor table{border-collapse:collapse}.ql-editor td{border:1px solid #000;padding:2px 5px}.ql-editor ol{padding-left:1.5em}.ql-editor li{list-style-type:none;padding-left:1.5em;position:relative}.ql-editor li>.ql-ui:before{display:inline-block;margin-left:-1.5em;margin-right:.3em;text-align:right;white-space:nowrap;width:1.2em}.ql-editor li[data-list=checked]>.ql-ui,.ql-editor li[data-list=unchecked]>.ql-ui{color:#777}.ql-editor li[data-list=bullet]>.ql-ui:before{content:"•"}.ql-editor li[data-list=checked]>.ql-ui:before{content:"☑"}.ql-editor li[data-list=unchecked]>.ql-ui:before{content:"☐"}@supports (counter-set:none){.ql-editor li[data-list]{counter-set:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list]{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered]{counter-increment:list-0}.ql-editor li[data-list=ordered]>.ql-ui:before{content:counter(list-0,decimal) ". "}.ql-editor li[data-list=ordered].ql-indent-1{counter-increment:list-1}.ql-editor li[data-list=ordered].ql-indent-1>.ql-ui:before{content:counter(list-1,lower-alpha) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-1{counter-set:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-2{counter-increment:list-2}.ql-editor li[data-list=ordered].ql-indent-2>.ql-ui:before{content:counter(list-2,lower-roman) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-2{counter-set:list-3 list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-3{counter-increment:list-3}.ql-editor li[data-list=ordered].ql-indent-3>.ql-ui:before{content:counter(list-3,decimal) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-3{counter-set:list-4 list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-4{counter-increment:list-4}.ql-editor li[data-list=ordered].ql-indent-4>.ql-ui:before{content:counter(list-4,lower-alpha) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-4{counter-set:list-5 list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-5{counter-increment:list-5}.ql-editor li[data-list=ordered].ql-indent-5>.ql-ui:before{content:counter(list-5,lower-roman) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-5{counter-set:list-6 list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-6{counter-increment:list-6}.ql-editor li[data-list=ordered].ql-indent-6>.ql-ui:before{content:counter(list-6,decimal) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-6{counter-set:list-7 list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-6{counter-reset:list-7 list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-7{counter-increment:list-7}.ql-editor li[data-list=ordered].ql-indent-7>.ql-ui:before{content:counter(list-7,lower-alpha) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-7{counter-set:list-8 list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-7{counter-reset:list-8 list-9}}.ql-editor li[data-list=ordered].ql-indent-8{counter-increment:list-8}.ql-editor li[data-list=ordered].ql-indent-8>.ql-ui:before{content:counter(list-8,lower-roman) ". "}@supports (counter-set:none){.ql-editor li[data-list].ql-indent-8{counter-set:list-9}}@supports not (counter-set:none){.ql-editor li[data-list].ql-indent-8{counter-reset:list-9}}.ql-editor li[data-list=ordered].ql-indent-9{counter-increment:list-9}.ql-editor li[data-list=ordered].ql-indent-9>.ql-ui:before{content:counter(list-9,decimal) ". "}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor li.ql-direction-rtl{padding-right:1.5em}.ql-editor li.ql-direction-rtl>.ql-ui:before{margin-left:.3em;margin-right:-1.5em;text-align:left}.ql-editor table{table-layout:fixed;width:100%}.ql-editor table td{outline:none}.ql-editor .ql-code-block-container{font-family:monospace}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor .ql-ui{position:absolute}.ql-editor.ql-blank:before{color:#0009;content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after{clear:both;content:"";display:table}.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg{float:left;height:100%}.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover{outline:none}.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file]{display:none}.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected{color:#06c}.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill{fill:#06c}.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow,.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:"";display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-thin,.ql-snow .ql-stroke.ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor .ql-code-block-container{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor .ql-code-block-container{margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor .ql-code-block-container{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label:before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""]):before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-label:before,.ql-snow .ql-picker.ql-header .ql-picker-item:before{content:"Normal"}.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before{content:"Heading 1"}.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before{content:"Heading 2"}.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before{content:"Heading 3"}.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before{content:"Heading 4"}.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before{content:"Heading 5"}.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]:before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before{content:"Heading 6"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]:before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]:before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]:before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]:before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]:before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]:before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-label:before,.ql-snow .ql-picker.ql-font .ql-picker-item:before{content:"Sans Serif"}.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{content:"Serif"}.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{content:"Monospace"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-label:before,.ql-snow .ql-picker.ql-size .ql-picker-item:before{content:"Normal"}.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{content:"Small"}.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{content:"Large"}.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{content:"Huge"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-code-block-container{position:relative}.ql-code-block-container .ql-ui{right:5px;top:5px}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:#0003 0 2px 8px}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip:before{content:"Visit URL:";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action:after{border-right:1px solid #ccc;content:"Edit";margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove:before{content:"Remove";margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action:after{border-right:0;content:"Save";padding-right:0}.ql-snow .ql-tooltip[data-mode=link]:before{content:"Enter link:"}.ql-snow .ql-tooltip[data-mode=formula]:before{content:"Enter formula:"}.ql-snow .ql-tooltip[data-mode=video]:before{content:"Enter video:"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}`, tm1WysiwygStyles = i$2`
  tm1-wysiwyg {
    width: 100%;
    height: 100%;
    display: block;
  }

  tm1-wysiwyg .input-container {
    position: relative;
  }

  tm1-wysiwyg .hidden {
    opacity: 0;
    position: absolute;
    bottom: 0;
    height: 0;
  }

  tm1-wysiwyg #editor {
    font-family: var(--gdse-g-font-family);
    min-height: 100px;
  }

  tm1-wysiwyg .ql-snow.ql-toolbar {
    background-color: var(--gdse-s-color-background-alt);
    padding: var(--gdse-g-spacing-100);
  }

  tm1-wysiwyg .ql-snow.ql-toolbar button {
    cursor: pointer;
    width: 22px;
    height: 22px;
    color: var(--gdse-s-color-text);
  }

  tm1-wysiwyg .ql-formats:not(:last-child) {
    margin-right: 7px!important;
    padding-right: 8px;
    border-right: 1px solid var(--gdse-s-color-border-input-default);
  }

  tm1-wysiwyg .helper {
    color: var(--gdse-s-color-text-light);
    margin-top: var(--gdse-g-spacing-25);
  }

  tm1-wysiwyg .label {
    color: var(--gdse-s-color-text);
    margin-bottom: var(--gdse-g-spacing-25);
    line-height: var(--gdse-g-line-height-body);
  }
`, styles = [
  r$3(quillStyles),
  r$3(quillSnowStyles),
  tm1WysiwygStyles
];
var __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __decorateClass = (td, Ae, xr, ed) => {
  for (var id = ed > 1 ? void 0 : ed ? __getOwnPropDesc(Ae, xr) : Ae, od = td.length - 1, ad; od >= 0; od--)
    (ad = td[od]) && (id = (ed ? ad(Ae, xr, id) : ad(id)) || id);
  return ed && id && __defProp(Ae, xr, id), id;
};
const WysiwygOptions = {
  bold: "bold",
  italic: "italic",
  underline: "underline",
  strike: "strike",
  script: "script",
  color: "color",
  background: "background",
  font: "font",
  header: "header",
  blockquote: "blockquote",
  list: "list",
  align: "align",
  codeBlock: "code-block",
  link: "link",
  image: "image",
  video: "video"
}, WysiwygReturnType = {
  html: "html",
  text: "text"
}, f0 = class f0 extends h {
  constructor() {
    super(...arguments), this._options = [], this.emptyArrayOptions = ["color", "background", "font", "align", "header", "size", "indent"], this.defaultId = () => this.id !== "" ? this.id : "control", this.options = [], this.placeholder = "", this.returnType = "html", this.required = !1, this.readOnly = !1, this.hasError = !1;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  handleInput(Ae) {
    Ae.stopPropagation();
  }
  async firstUpdated() {
    this.internals = this.attachInternals(), this.getAttribute("tabindex") || this.setAttribute("tabindex", "-1");
    const Ae = this.querySelector("#editor");
    await this.setOptions(), this.quillEditor = new Quill(Ae, {
      placeholder: this.placeholder,
      readOnly: this.readOnly,
      theme: "snow",
      modules: {
        toolbar: this._options
      }
    });
    const xr = this.querySelector(".ql-toolbar"), ed = this.querySelector(".ql-editor");
    if (ed.style.height = getComputedStyle(Ae).height, xr.addEventListener("mousedown", (id) => id.preventDefault(), !0), this.quillEditor.on("selection-change", (id, od) => {
      id === null && od !== null ? emit(this, "blur", "") : id !== null && od === null && emit(this, "focus", "");
    }), this.quillEditor.on("text-change", (id, od, ad) => {
      if (ad == "user") {
        const rd = this.quillEditor.getSemanticHTML(), sd = this.quillEditor.getContents().ops[0].insert, nd = this.returnType === WysiwygReturnType.html ? rd : sd;
        this.internals.setFormValue(nd), this._value = nd == null ? void 0 : nd.replace("<p></p>", ""), emit(this, "input", this._value);
      }
    }), this.readOnly && this.quillEditor.enable(!1), this.value) {
      this.value = sanitizeHTML(this.value), this._value = this.value;
      const id = this.quillEditor.clipboard.convert({ html: this.value });
      this.quillEditor.setContents(id, "silent");
    }
  }
  setOptions() {
    var Ae;
    this.options && typeof this.options == "string" ? this.options.includes("[") ? this._options = JSON.parse(this.options) : this._options = this.options.replaceAll(" ", "").split(",") : this.options.length > 0 ? this._options = [...this.options] : this._options = Object.values(WysiwygOptions), (Ae = this._options) == null || Ae.forEach((xr, ed) => {
      switch (xr) {
        case "list":
          this.setOption(ed, [{ list: "ordered" }, { list: "bullet" }, { list: "check" }]);
          break;
        case "script":
          this.setOption(ed, [{ script: "sub" }, { script: "super" }]);
          break;
      }
      if (this.emptyArrayOptions.includes(xr))
        this._options[ed] = { [xr]: [] };
      else if (Array.isArray(xr))
        return xr.map((id, od) => {
          switch (id) {
            case "list":
              this.setOptionArray(ed, od, [...xr, { list: "ordered" }, { list: "bullet" }, { list: "check" }]);
              break;
            case "script":
              this.setOptionArray(ed, od, [...xr, { script: "sub" }, { script: "super" }]);
              break;
            default:
              if (this.emptyArrayOptions.includes(id)) {
                xr[od] = { [id]: [] };
                break;
              } else
                return id;
          }
        });
      return xr;
    });
  }
  setOption(Ae, xr) {
    xr.forEach((ed, id) => {
      id === 0 ? this._options[Ae] = ed : this._options.splice(Ae + id, 0, ed);
    });
  }
  setOptionArray(Ae, xr, ed) {
    this._options[Ae] = ed, this._options[Ae].splice(xr, 1);
  }
  checkValidity() {
    const Ae = this.querySelector("textarea"), xr = this.querySelector("#editor");
    this.hasError = !Ae.validity.valid, this.internals.setValidity(Ae == null ? void 0 : Ae.validity, Ae == null ? void 0 : Ae.validationMessage, xr);
  }
  formResetCallback() {
    this.quillEditor.setContents(""), this.internals.setFormValue(""), this._value = "";
  }
  render() {
    return ke$1`
      <style>${styles}</style>

      ${nn(!!this.label, () => ke$1`
        <tm1-typography class="label" type="label-helpertext-regular" data-testid="label">
          <label part="label" for="${this.defaultId()}">
            ${this.label}
          </label>
          </tm1-typography>`)}

      <div
        id="editor"
        aria-invalid=${this.hasError}
        data-testid="editor"
        @focusout=${this.checkValidity}
        @input=${this.handleInput}
      ></div>
      <div class="input-container">
        <textarea class="hidden" ?required=${this.required} ?readonly=${this.readOnly}>${this._value}</textarea>
      </div>

      ${nn(!!this.supportingText && !this.readOnly, () => ke$1`
        <tm1-typography type="label-helpertext-regular" class="helper" data-testid="helper">
          ${this.supportingText}
        </tm1-typography>`)}
    `;
  }
  createRenderRoot() {
    return this;
  }
};
f0.formAssociated = !0;
let Wysiwyg = f0;
__decorateClass([
  n({ type: String, attribute: !0, reflect: !0 })
], Wysiwyg.prototype, "label", 2);
__decorateClass([
  n({ type: String, attribute: !0, reflect: !0 })
], Wysiwyg.prototype, "name", 2);
__decorateClass([
  n({ type: String, attribute: "supporting-text", reflect: !0 }),
  n({ type: String, attribute: "supportingtext", reflect: !0 })
], Wysiwyg.prototype, "supportingText", 2);
__decorateClass([
  n()
], Wysiwyg.prototype, "options", 2);
__decorateClass([
  n()
], Wysiwyg.prototype, "placeholder", 2);
__decorateClass([
  n({ attribute: "return-type" }),
  n({ attribute: "returntype" })
], Wysiwyg.prototype, "returnType", 2);
__decorateClass([
  n({ type: Boolean, attribute: !0, reflect: !0 })
], Wysiwyg.prototype, "required", 2);
__decorateClass([
  n({ type: Boolean, attribute: !0, reflect: !0 })
], Wysiwyg.prototype, "readOnly", 2);
__decorateClass([
  n({ type: String, attribute: !0 })
], Wysiwyg.prototype, "value", 2);
__decorateClass([
  r()
], Wysiwyg.prototype, "_value", 2);
__decorateClass([
  r()
], Wysiwyg.prototype, "hasError", 2);
customElements.get("tm1-wysiwyg") || customElements.define("tm1-wysiwyg", Wysiwyg);
function provideTm1DesignSystem(td) {
  const Ae = new RootThemeNotifier(td), xr = new ThemeManager(td, { onThemeChanged: (id) => Ae.value = id }), ed = DesignSystem.getOrCreate(td).withElementDisambiguation(() => ElementDisambiguation.ignoreDuplicate).withPrefix("tm1").register(
    tm1Accordion(),
    tm1AccordionItem(),
    tm1ActionGroup(),
    tm1Anchor(),
    tm1Avatar(),
    tm1Badge(),
    tm1Banner(),
    tm1Button(),
    tm1Card(),
    tm1Calendar(),
    tm1CardFooter(),
    tm1CardContent(),
    tm1CardHeader(),
    tm1Checkbox(),
    tm1CheckboxGroup(),
    tm1Combobox(),
    tm1CopyAction(),
    tm1DataGrid(),
    tm1DataGridCell(),
    tm1DataGridRow(),
    tm1DataRefreshChip(),
    tm1DatePickerV2(),
    tm1DateTimePicker(),
    tm1DeprecateToken(),
    tm1Dialog(),
    tm1DialogStepContent(),
    tm1DialogFooter(),
    tm1Disclosure(),
    tm1Divider(),
    tm1Drawer(),
    tm1DrawerHeader(),
    tm1DrawerFooter(),
    tm1Insight(),
    tm1Grid(),
    tm1Icon(),
    tm1IconTooltip(),
    tm1InsightCard(),
    tm1InsightCardHeader(),
    tm1Listbox(),
    tm1MultiSelect(),
    tm1EmptyState(),
    tm1NumberField(),
    tm1ObjectBadges(),
    tm1ObjectDate(),
    tm1ObjectHeader(),
    tm1ObjectInlineActions(),
    tm1ObjectList(),
    tm1ObjectListCell(),
    tm1ObjectListExpandableRow(),
    tm1ObjectListExpandableRowAction(),
    tm1ObjectListHeader(),
    tm1ObjectListRow(),
    tm1ObjectMedia(),
    tm1ObjectTitle(),
    tm1Option(),
    tm1OptionsGroup(),
    tm1OptionsHeader(),
    tm1Popover(),
    tm1Progress(),
    tm1ProgressRing(),
    tm1Radio(),
    tm1RadioGroup(),
    tm1Search(),
    tm1Select(),
    tm1SegmentControl(),
    tm1SegmentedControl(),
    tm1Skeleton(),
    tm1Slider(),
    tm1SliderLabel(),
    tm1Stat(),
    tm1Switch(),
    tm1Tab(),
    tm1TabPanel(),
    tm1Tabs(),
    tm1TextArea(),
    tm1TextField(),
    tm1ThemeProvider(),
    tm1ThemeProviderV2(),
    tm1TimePicker(),
    tm1Toast(),
    tm1ToastContainer(),
    tm1Tooltip(),
    tm1TreeView(),
    tm1TreeViewItem(),
    tm1PageFooter()
  );
  return {
    themeManager: xr,
    ...ed
  };
}
const bundledDependencies = {
  fastElement,
  fastReactWrapper,
  fastFoundation
}, { themeManager } = provideTm1DesignSystem();
setThemeManager(themeManager);
export {
  AccentButtonStyles,
  Accordion,
  AccordionItem,
  Anchor,
  AnchorTarget,
  AnchorVariant,
  Avatar,
  AvatarFill,
  AvatarShape,
  Badge,
  BadgeV2,
  BadgeV2Type,
  BadgeV2Variant,
  Banner,
  BannerVariant,
  Button,
  ButtonColor,
  ButtonIconPosition,
  ButtonSize,
  ButtonVariant,
  Calendar,
  CalendarOrder,
  CalendarPosition,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardVariant,
  Checkbox,
  CheckboxGroup,
  CheckboxGroupOrientation,
  CheckboxSize,
  ClickBehavior,
  Combobox,
  ComboboxAutocomplete,
  ConsumerBehaviour,
  DataGrid,
  DataGridCell,
  DataGridCellTypes,
  DataGridRow,
  DataGridRowTypes,
  DataRefreshChip,
  DatePickerMode,
  DatePickerV2,
  DateTimePicker,
  DelegatesARIACombobox,
  DeprecateToken,
  Dialog,
  DialogFooterElement,
  DialogFooterV2,
  DialogStepContent,
  DialogStepContentV2,
  DialogV2,
  Disclosure,
  DisclosureAppearance,
  DisclosureDisplay,
  Divider,
  Drawer,
  DrawerFooter,
  DrawerHeader,
  DrawerHeaderMode,
  DrawerSize,
  EmptyState,
  EmptyStateVariant,
  ExpandableRowActionContentPosition,
  ExpandableRowActionIconDirection,
  ExpansionTriggerIconType,
  FeatureFlags,
  FileUpload,
  FileUploadErrorType,
  FileUploadItem,
  FileUploadItemState,
  FileUploadVariant,
  FlyoutPosBottom,
  FlyoutPosBottomFill,
  FlyoutPosTallest,
  FlyoutPosTallestFill,
  FlyoutPosTop,
  FlyoutPosTopFill,
  FormAssociatedCombobox,
  FormAssociatedNumberField,
  FormAssociatedSelect,
  GDSEBorderRadius0,
  GDSEBorderRadius10,
  GDSEBorderRadius100,
  GDSEBorderRadius25,
  GDSEBorderRadius50,
  GDSEBorderRadius75,
  GDSEBorderRadiusFull,
  GDSEBorderWidth0,
  GDSEBorderWidth10,
  GDSEBorderWidth25,
  GDSEColorBackground,
  GDSEColorBackgroundAlt,
  GDSEColorBackgroundOverlay,
  GDSEColorBlue100,
  GDSEColorBlue200,
  GDSEColorBlue300,
  GDSEColorBlue400,
  GDSEColorBlue500,
  GDSEColorBlue600,
  GDSEColorBlue700,
  GDSEColorBlue800,
  GDSEColorBorder,
  GDSEColorBorderCritical,
  GDSEColorBorderDataPerformance,
  GDSEColorBorderDisabled,
  GDSEColorBorderFocus,
  GDSEColorBorderFocusInverse,
  GDSEColorBorderHovered,
  GDSEColorBorderInfo,
  GDSEColorBorderInformation,
  GDSEColorBorderInputActive,
  GDSEColorBorderInputActiveInverse,
  GDSEColorBorderInputDefault,
  GDSEColorBorderInputDefaultInverse,
  GDSEColorBorderInputDisabled,
  GDSEColorBorderInputDisabledInverse,
  GDSEColorBorderInputFocused,
  GDSEColorBorderInputHovered,
  GDSEColorBorderInputHoveredInverse,
  GDSEColorBorderInputPressed,
  GDSEColorBorderNeutral,
  GDSEColorBorderPopover,
  GDSEColorBorderPositive,
  GDSEColorBorderPressed,
  GDSEColorBorderPrimary,
  GDSEColorBorderPrimaryDisabled,
  GDSEColorBorderPrimaryFocused,
  GDSEColorBorderPrimaryHovered,
  GDSEColorBorderPrimaryLoading,
  GDSEColorBorderPrimaryPressed,
  GDSEColorBorderSecondary,
  GDSEColorBorderSecondaryDisabled,
  GDSEColorBorderSecondaryFocus,
  GDSEColorBorderSecondaryLoading,
  GDSEColorBorderTertiaryLoading,
  GDSEColorBorderWarning,
  GDSEColorCallisto,
  GDSEColorCallistoA,
  GDSEColorCallistoB,
  GDSEColorCosmoA,
  GDSEColorCosmoAB,
  GDSEColorCosmoB,
  GDSEColorCosmoC,
  GDSEColorCosmoD,
  GDSEColorCosmoE,
  GDSEColorCosmos,
  GDSEColorFillCritical,
  GDSEColorFillCriticalHovered,
  GDSEColorFillCriticalLight,
  GDSEColorFillCriticalLightStrong,
  GDSEColorFillCriticalPressed,
  GDSEColorFillCriticalPressedLight,
  GDSEColorFillCriticalSecondaryHovered,
  GDSEColorFillCriticalSecondaryPressed,
  GDSEColorFillDataAttention,
  GDSEColorFillDataBenchmark,
  GDSEColorFillDataBg,
  GDSEColorFillDataBgAlt,
  GDSEColorFillDataComparative,
  GDSEColorFillDataComparativeLite,
  GDSEColorFillDataComparativeMed,
  GDSEColorFillDataHold,
  GDSEColorFillDataPerformance,
  GDSEColorFillDataPerformanceLite,
  GDSEColorFillDataPerformanceMed,
  GDSEColorFillDataSold,
  GDSEColorFillDataSoldLite,
  GDSEColorFillDataSoldMed,
  GDSEColorFillDisabled,
  GDSEColorFillDisabledLight,
  GDSEColorFillDraft,
  GDSEColorFillFocused,
  GDSEColorFillHovered,
  GDSEColorFillHoveredInverse,
  GDSEColorFillHoveredLight,
  GDSEColorFillInfo,
  GDSEColorFillInfoLight,
  GDSEColorFillInfoLightStrong,
  GDSEColorFillInput,
  GDSEColorFillInputDisabled,
  GDSEColorFillInputFocused,
  GDSEColorFillInputHovered,
  GDSEColorFillInputPressed,
  GDSEColorFillInputSelected,
  GDSEColorFillInputSelectedAlt,
  GDSEColorFillLight,
  GDSEColorFillLoading,
  GDSEColorFillNavigationDefault,
  GDSEColorFillNavigationHovered,
  GDSEColorFillNavigationSelected,
  GDSEColorFillNegative,
  GDSEColorFillPositive,
  GDSEColorFillPositiveHovered,
  GDSEColorFillPositiveLight,
  GDSEColorFillPositiveLightStrong,
  GDSEColorFillPositivePressed,
  GDSEColorFillPositivePressedLight,
  GDSEColorFillPositiveSecondaryHovered,
  GDSEColorFillPositiveSecondaryPressed,
  GDSEColorFillPressed,
  GDSEColorFillPressedInverse,
  GDSEColorFillPressedLight,
  GDSEColorFillPrimary,
  GDSEColorFillPrimaryDisabled,
  GDSEColorFillPrimaryFocused,
  GDSEColorFillPrimaryHovered,
  GDSEColorFillPrimaryHoveredLight,
  GDSEColorFillPrimaryPressed,
  GDSEColorFillPrimaryPressedLight,
  GDSEColorFillPrimarySelected,
  GDSEColorFillPrimarySelectedLight,
  GDSEColorFillSecondary,
  GDSEColorFillSecondaryDisabled,
  GDSEColorFillSecondaryFocused,
  GDSEColorFillSecondaryHovered,
  GDSEColorFillSecondaryInverse,
  GDSEColorFillSecondaryPressed,
  GDSEColorFillSelected,
  GDSEColorFillWarning,
  GDSEColorFillWarningHovered,
  GDSEColorFillWarningLight,
  GDSEColorFillWarningLightStrong,
  GDSEColorFillWarningPressed,
  GDSEColorFillWarningPressedLight,
  GDSEColorGanymede,
  GDSEColorGreen100,
  GDSEColorGreen200,
  GDSEColorGreen300,
  GDSEColorGreen400,
  GDSEColorGreen500,
  GDSEColorGreen600,
  GDSEColorGreen700,
  GDSEColorGrey100,
  GDSEColorGrey200,
  GDSEColorGrey300,
  GDSEColorGrey400,
  GDSEColorGrey500,
  GDSEColorGrey600,
  GDSEColorGrey700,
  GDSEColorGrey800,
  GDSEColorGrey900,
  GDSEColorJupiter,
  GDSEColorJupiterA,
  GDSEColorJupiterB,
  GDSEColorMars,
  GDSEColorMarsA,
  GDSEColorMarsB,
  GDSEColorMonoBlack,
  GDSEColorMonoWhite,
  GDSEColorNeptune,
  GDSEColorNeptuneA,
  GDSEColorOberon,
  GDSEColorOberonA,
  GDSEColorOberonB,
  GDSEColorObjectListHover,
  GDSEColorRed100,
  GDSEColorRed200,
  GDSEColorRed300,
  GDSEColorRed400,
  GDSEColorRed500,
  GDSEColorRed600,
  GDSEColorRed700,
  GDSEColorSkeletonShimmer,
  GDSEColorSpotlight,
  GDSEColorSurface,
  GDSEColorSurfaceAlt,
  GDSEColorSurfaceCard,
  GDSEColorSurfaceHovered,
  GDSEColorSurfaceInverse,
  GDSEColorSurfaceModal,
  GDSEColorSurfacePopover,
  GDSEColorSurfacePressed,
  GDSEColorSurfaceSelected,
  GDSEColorSurfaceTooltip,
  GDSEColorText,
  GDSEColorTextCritical,
  GDSEColorTextCriticalHovered,
  GDSEColorTextCriticalSecondary,
  GDSEColorTextCriticalSecondaryHovered,
  GDSEColorTextCriticalStrong,
  GDSEColorTextData,
  GDSEColorTextDisabled,
  GDSEColorTextFocused,
  GDSEColorTextHovered,
  GDSEColorTextInfo,
  GDSEColorTextInfoHovered,
  GDSEColorTextInfoStrong,
  GDSEColorTextInformation,
  GDSEColorTextInputDefault,
  GDSEColorTextInputDisabled,
  GDSEColorTextInputFocused,
  GDSEColorTextInputHovered,
  GDSEColorTextInputPressed,
  GDSEColorTextInputSelected,
  GDSEColorTextInputSelectedAlt,
  GDSEColorTextInverse,
  GDSEColorTextInverseStatic,
  GDSEColorTextLight,
  GDSEColorTextLightInverse,
  GDSEColorTextLoading,
  GDSEColorTextMuted,
  GDSEColorTextMutedInverse,
  GDSEColorTextNavigationDefault,
  GDSEColorTextNavigationHovered,
  GDSEColorTextNavigationSelected,
  GDSEColorTextOnfill,
  GDSEColorTextOnfillHovered,
  GDSEColorTextOnfillStrong,
  GDSEColorTextOnfillStrongHovered,
  GDSEColorTextPositive,
  GDSEColorTextPositiveHovered,
  GDSEColorTextPositiveSecondary,
  GDSEColorTextPositiveSecondaryHovered,
  GDSEColorTextPositiveStrong,
  GDSEColorTextPressed,
  GDSEColorTextPrimary,
  GDSEColorTextPrimaryDisabled,
  GDSEColorTextPrimaryHovered,
  GDSEColorTextPrimaryInverse,
  GDSEColorTextPrimaryLoading,
  GDSEColorTextPrimaryPressed,
  GDSEColorTextSecondary,
  GDSEColorTextSecondaryDisabled,
  GDSEColorTextSecondaryFocused,
  GDSEColorTextSecondaryHovered,
  GDSEColorTextSecondaryLoading,
  GDSEColorTextSecondaryPressed,
  GDSEColorTextStatic,
  GDSEColorTextWarning,
  GDSEColorTextWarningStrong,
  GDSEColorTitan,
  GDSEColorTransparent,
  GDSEColorYellow100,
  GDSEColorYellow200,
  GDSEColorYellow300,
  GDSEColorYellow400,
  GDSEColorYellow500,
  GDSEColorYellow600,
  GDSEColorYellow700,
  GDSEFontFamily,
  GDSEFontFeatureTable,
  GDSEFontFeatureText,
  GDSEFontSize1,
  GDSEFontSize10,
  GDSEFontSize11,
  GDSEFontSize2,
  GDSEFontSize3,
  GDSEFontSize4,
  GDSEFontSize5,
  GDSEFontSize6,
  GDSEFontSize7,
  GDSEFontSize8,
  GDSEFontSize9,
  GDSEFontWeightBold,
  GDSEFontWeightLight,
  GDSEFontWeightRegular,
  GDSEFontWeightSemiBold,
  GDSEFontWeightThin,
  GDSELetterSpacing0,
  GDSELetterSpacing1,
  GDSELetterSpacing2,
  GDSELetterSpacingNeg1,
  GDSELetterSpacingNeg2,
  GDSELineHeightBody,
  GDSELineHeightReset,
  GDSELineHeightTitle,
  GDSEMediaHoverTransform,
  GDSERadiusInput,
  GDSERadiusPill,
  GDSERadiusPopover,
  GDSERadiusSharp,
  GDSERadiusSurface,
  GDSESpacing0,
  GDSESpacing100,
  GDSESpacing1000,
  GDSESpacing1200,
  GDSESpacing125,
  GDSESpacing150,
  GDSESpacing1500,
  GDSESpacing175,
  GDSESpacing200,
  GDSESpacing2000,
  GDSESpacing225,
  GDSESpacing25,
  GDSESpacing250,
  GDSESpacing2500,
  GDSESpacing300,
  GDSESpacing400,
  GDSESpacing50,
  GDSESpacing500,
  GDSESpacing600,
  GDSESpacing75,
  GDSESpacing800,
  GDSESpacingActionHorL,
  GDSESpacingActionHorM,
  GDSESpacingActionHorS,
  GDSESpacingActionIconL,
  GDSESpacingActionIconM,
  GDSESpacingActionIconS,
  GDSESpacingActionVerL,
  GDSESpacingActionVerM,
  GDSESpacingActionVerS,
  GDSESpacingInputHorL,
  GDSESpacingInputHorM,
  GDSESpacingInputHorS,
  GDSESpacingInputVerL,
  GDSESpacingInputVerM,
  GDSESpacingInputVerS,
  GDSESpacingListHorS,
  GDSESpacingListVerS,
  GDSESpacingPillHorS,
  GDSESpacingPillVerS,
  GDSESpacingSurfaceHorXS,
  GDSESpacingSurfaceVerXS,
  GDSESpacingTabHorL,
  GDSESpacingTabHorM,
  GDSESpacingTabVerL,
  GDSESpacingTabVerM,
  GDSESpacingTabWidth,
  GDSESpacingTooltipHorL,
  GDSESpacingTooltipHorM,
  GDSESpacingTooltipVerL,
  GDSESpacingTooltipVerM,
  GDSETextCaseNone,
  GDSETextCaseUpper,
  GDSETypographyBodyLFontFamily,
  GDSETypographyBodyLFontFeature,
  GDSETypographyBodyLFontSize,
  GDSETypographyBodyLFontSizeMobile,
  GDSETypographyBodyLFontWeight,
  GDSETypographyBodyLLetterSpacing,
  GDSETypographyBodyLLineHeight,
  GDSETypographyBodyMFontFamily,
  GDSETypographyBodyMFontFeature,
  GDSETypographyBodyMFontSize,
  GDSETypographyBodyMFontSizeMobile,
  GDSETypographyBodyMFontWeight,
  GDSETypographyBodyMLetterSpacing,
  GDSETypographyBodyMLineHeight,
  GDSETypographyBodySFontFamily,
  GDSETypographyBodySFontFeature,
  GDSETypographyBodySFontSize,
  GDSETypographyBodySFontSizeMobile,
  GDSETypographyBodySFontWeight,
  GDSETypographyBodySLetterSpacing,
  GDSETypographyBodySLineHeight,
  GDSETypographyBodyXLFontFamily,
  GDSETypographyBodyXLFontFeature,
  GDSETypographyBodyXLFontSize,
  GDSETypographyBodyXLFontSizeMobile,
  GDSETypographyBodyXLFontWeight,
  GDSETypographyBodyXLLetterSpacing,
  GDSETypographyBodyXLLineHeight,
  GDSETypographyDataContextFontFamily,
  GDSETypographyDataContextFontSize,
  GDSETypographyDataContextFontSizeMobile,
  GDSETypographyDataContextFontWeight,
  GDSETypographyDataContextLetterSpacing,
  GDSETypographyDataContextLineHeight,
  GDSETypographyDataLFontFamily,
  GDSETypographyDataLFontFeature,
  GDSETypographyDataLFontSize,
  GDSETypographyDataLFontSizeMobile,
  GDSETypographyDataLFontWeight,
  GDSETypographyDataLFontWeightMobile,
  GDSETypographyDataLLetterSpacing,
  GDSETypographyDataLLineHeight,
  GDSETypographyDataMFontFamily,
  GDSETypographyDataMFontFeature,
  GDSETypographyDataMFontSize,
  GDSETypographyDataMFontSizeMobile,
  GDSETypographyDataMFontWeight,
  GDSETypographyDataMLetterSpacing,
  GDSETypographyDataMLineHeight,
  GDSETypographyDataMLineHeightMobile,
  GDSETypographyDataSFontFamily,
  GDSETypographyDataSFontFeature,
  GDSETypographyDataSFontSize,
  GDSETypographyDataSFontSizeMobile,
  GDSETypographyDataSFontWeight,
  GDSETypographyDataSLetterSpacing,
  GDSETypographyDataSLineHeight,
  GDSETypographyDataXLFontFamily,
  GDSETypographyDataXLFontSize,
  GDSETypographyDataXLFontSizeMobile,
  GDSETypographyDataXLFontWeight,
  GDSETypographyDataXLFontWeightMobile,
  GDSETypographyDataXLLetterSpacing,
  GDSETypographyDataXLLineHeight,
  GDSETypographyDataXSFontFamily,
  GDSETypographyDataXSFontFeature,
  GDSETypographyDataXSFontSize,
  GDSETypographyDataXSFontSizeMobile,
  GDSETypographyDataXSFontWeight,
  GDSETypographyDataXSLetterSpacing,
  GDSETypographyDataXSLineHeight,
  GDSETypographyDataXXLFontFamily,
  GDSETypographyDataXXLFontSize,
  GDSETypographyDataXXLFontSizeMobile,
  GDSETypographyDataXXLFontWeight,
  GDSETypographyDataXXLLetterSpacing,
  GDSETypographyDataXXLLineHeight,
  GDSETypographyHeadingLFontFamily,
  GDSETypographyHeadingLFontSize,
  GDSETypographyHeadingLFontSizeMobile,
  GDSETypographyHeadingLFontWeight,
  GDSETypographyHeadingLLetterSpacing,
  GDSETypographyHeadingLLineHeight,
  GDSETypographyHeadingMFontFamily,
  GDSETypographyHeadingMFontSize,
  GDSETypographyHeadingMFontSizeMobile,
  GDSETypographyHeadingMFontWeight,
  GDSETypographyHeadingMLetterSpacing,
  GDSETypographyHeadingMLineHeight,
  GDSETypographyHeadingSFontFamily,
  GDSETypographyHeadingSFontSize,
  GDSETypographyHeadingSFontSizeMobile,
  GDSETypographyHeadingSFontWeight,
  GDSETypographyHeadingSLetterSpacing,
  GDSETypographyHeadingSLineHeight,
  GDSETypographyLabelButtonLFontFamily,
  GDSETypographyLabelButtonLFontSize,
  GDSETypographyLabelButtonLFontWeight,
  GDSETypographyLabelButtonLLetterSpacing,
  GDSETypographyLabelButtonLLineHeight,
  GDSETypographyLabelButtonMFontFamily,
  GDSETypographyLabelButtonMFontSize,
  GDSETypographyLabelButtonMFontWeight,
  GDSETypographyLabelButtonMLetterSpacing,
  GDSETypographyLabelButtonMLineHeight,
  GDSETypographyLabelButtonSFontFamily,
  GDSETypographyLabelButtonSFontSize,
  GDSETypographyLabelButtonSFontWeight,
  GDSETypographyLabelButtonSLetterSpacing,
  GDSETypographyLabelButtonSLineHeight,
  GDSETypographyLabelContainerLFontFamily,
  GDSETypographyLabelContainerLFontSize,
  GDSETypographyLabelContainerLFontWeight,
  GDSETypographyLabelContainerLLetterSpacing,
  GDSETypographyLabelContainerLLineHeight,
  GDSETypographyLabelContainerLTextTransform,
  GDSETypographyLabelContainerMFontFamily,
  GDSETypographyLabelContainerMFontSize,
  GDSETypographyLabelContainerMFontWeight,
  GDSETypographyLabelContainerMLetterSpacing,
  GDSETypographyLabelContainerMLineHeight,
  GDSETypographyLabelContainerMTextTransform,
  GDSETypographyLabelContainerSFontFamily,
  GDSETypographyLabelContainerSFontSize,
  GDSETypographyLabelContainerSFontWeight,
  GDSETypographyLabelContainerSLetterSpacing,
  GDSETypographyLabelContainerSLineHeight,
  GDSETypographyLabelContainerSTextTransform,
  GDSETypographyLabelDataHighemphasisFontFamily,
  GDSETypographyLabelDataHighemphasisFontFeature,
  GDSETypographyLabelDataHighemphasisFontSize,
  GDSETypographyLabelDataHighemphasisFontWeight,
  GDSETypographyLabelDataHighemphasisLetterSpacing,
  GDSETypographyLabelDataHighemphasisLineHeight,
  GDSETypographyLabelDataHighemphasisTextTransform,
  GDSETypographyLabelDataLFontFamily,
  GDSETypographyLabelDataLFontSize,
  GDSETypographyLabelDataLFontSizeMobile,
  GDSETypographyLabelDataLFontWeight,
  GDSETypographyLabelDataLLetterSpacing,
  GDSETypographyLabelDataLLineHeight,
  GDSETypographyLabelDataMFontFamily,
  GDSETypographyLabelDataMFontSize,
  GDSETypographyLabelDataMFontWeight,
  GDSETypographyLabelDataMLetterSpacing,
  GDSETypographyLabelDataMLineHeight,
  GDSETypographyLabelDataRegularFontFamily,
  GDSETypographyLabelDataRegularFontFeature,
  GDSETypographyLabelDataRegularFontSize,
  GDSETypographyLabelDataRegularFontWeight,
  GDSETypographyLabelDataRegularLetterSpacing,
  GDSETypographyLabelDataRegularLineHeight,
  GDSETypographyLabelDataSFontFamily,
  GDSETypographyLabelDataSFontSize,
  GDSETypographyLabelDataSFontSizeMobile,
  GDSETypographyLabelDataSFontWeight,
  GDSETypographyLabelDataSLetterSpacing,
  GDSETypographyLabelDataSLineHeight,
  GDSETypographyLabelHelpertextHighemphasisFontFamily,
  GDSETypographyLabelHelpertextHighemphasisFontSize,
  GDSETypographyLabelHelpertextHighemphasisFontSizeMobile,
  GDSETypographyLabelHelpertextHighemphasisFontWeight,
  GDSETypographyLabelHelpertextHighemphasisLetterSpacing,
  GDSETypographyLabelHelpertextHighemphasisLineHeight,
  GDSETypographyLabelHelpertextRegularFontFamily,
  GDSETypographyLabelHelpertextRegularFontSize,
  GDSETypographyLabelHelpertextRegularFontSizeMobile,
  GDSETypographyLabelHelpertextRegularFontWeight,
  GDSETypographyLabelHelpertextRegularLetterSpacing,
  GDSETypographyLabelHelpertextRegularLineHeight,
  GDSETypographyLabelNavBreadcrumbsFontFamily,
  GDSETypographyLabelNavBreadcrumbsFontSize,
  GDSETypographyLabelNavBreadcrumbsFontSizeMobile,
  GDSETypographyLabelNavBreadcrumbsFontWeight,
  GDSETypographyLabelNavBreadcrumbsLetterSpacing,
  GDSETypographyLabelNavBreadcrumbsLineHeight,
  GDSETypographyLabelNavigationLFontFamily,
  GDSETypographyLabelNavigationLFontFeature,
  GDSETypographyLabelNavigationLFontSize,
  GDSETypographyLabelNavigationLFontWeight,
  GDSETypographyLabelNavigationLLetterSpacing,
  GDSETypographyLabelNavigationLLineHeight,
  GDSETypographyLabelNavigationMFontFamily,
  GDSETypographyLabelNavigationMFontFeature,
  GDSETypographyLabelNavigationMFontSize,
  GDSETypographyLabelNavigationMFontWeight,
  GDSETypographyLabelNavigationMLetterSpacing,
  GDSETypographyLabelNavigationMLineHeight,
  GDSETypographyLabelStatusMFontFamily,
  GDSETypographyLabelStatusMFontFeature,
  GDSETypographyLabelStatusMFontSize,
  GDSETypographyLabelStatusMFontWeight,
  GDSETypographyLabelStatusMLetterSpacing,
  GDSETypographyLabelStatusMLineHeight,
  GDSETypographyLabelStatusMTextTransform,
  GDSETypographyLabelStatusSFontFamily,
  GDSETypographyLabelStatusSFontSize,
  GDSETypographyLabelStatusSFontWeight,
  GDSETypographyLabelStatusSLetterSpacing,
  GDSETypographyLabelStatusSLineHeight,
  GDSETypographyLabelTableEmphasisFontFamily,
  GDSETypographyLabelTableEmphasisFontSize,
  GDSETypographyLabelTableEmphasisFontWeight,
  GDSETypographyLabelTableEmphasisLetterSpacing,
  GDSETypographyLabelTableEmphasisLineHeight,
  GDSETypographyLabelTableFontFamily,
  GDSETypographyLabelTableFontSize,
  GDSETypographyLabelTableFontWeight,
  GDSETypographyLabelTableLetterSpacing,
  GDSETypographyLabelTableLineHeight,
  GDSETypographyLabelUILEmphasisFontFamily,
  GDSETypographyLabelUILEmphasisFontSize,
  GDSETypographyLabelUILEmphasisFontWeight,
  GDSETypographyLabelUILEmphasisLetterSpacing,
  GDSETypographyLabelUILEmphasisLineHeight,
  GDSETypographyLabelUILFontFamily,
  GDSETypographyLabelUILFontSize,
  GDSETypographyLabelUILFontWeight,
  GDSETypographyLabelUILLetterSpacing,
  GDSETypographyLabelUILLineHeight,
  GDSETypographyLabelUIMEmphasisFontFamily,
  GDSETypographyLabelUIMEmphasisFontSize,
  GDSETypographyLabelUIMEmphasisFontWeight,
  GDSETypographyLabelUIMEmphasisLetterSpacing,
  GDSETypographyLabelUIMEmphasisLineHeight,
  GDSETypographyLabelUIMFontFamily,
  GDSETypographyLabelUIMFontSize,
  GDSETypographyLabelUIMFontWeight,
  GDSETypographyLabelUIMLetterSpacing,
  GDSETypographyLabelUIMLineHeight,
  GDSETypographyLabelUISEmphasisFontFamily,
  GDSETypographyLabelUISEmphasisFontSize,
  GDSETypographyLabelUISEmphasisFontWeight,
  GDSETypographyLabelUISEmphasisLetterSpacing,
  GDSETypographyLabelUISEmphasisLineHeight,
  GDSETypographyLabelUISFontFamily,
  GDSETypographyLabelUISFontSize,
  GDSETypographyLabelUISFontWeight,
  GDSETypographyLabelUISLetterSpacing,
  GDSETypographyLabelUISLineHeight,
  GDSETypographyLabelUIXLEmphasisFontFamily,
  GDSETypographyLabelUIXLEmphasisFontSize,
  GDSETypographyLabelUIXLEmphasisFontSizeMobile,
  GDSETypographyLabelUIXLEmphasisFontWeight,
  GDSETypographyLabelUIXLEmphasisLetterSpacing,
  GDSETypographyLabelUIXLEmphasisLineHeight,
  GDSETypographyLabelUIXLFontFamily,
  GDSETypographyLabelUIXLFontSize,
  GDSETypographyLabelUIXLFontWeight,
  GDSETypographyLabelUIXLLetterSpacing,
  GDSETypographyLabelUIXLLineHeight,
  GDSETypographyStatementLFontFamily,
  GDSETypographyStatementLFontSize,
  GDSETypographyStatementLFontSizeMobile,
  GDSETypographyStatementLFontWeight,
  GDSETypographyStatementLLetterSpacing,
  GDSETypographyStatementLLineHeight,
  GDSETypographyStatementSubtextLFontFamily,
  GDSETypographyStatementSubtextLFontSize,
  GDSETypographyStatementSubtextLFontSizeMobile,
  GDSETypographyStatementSubtextLFontWeight,
  GDSETypographyStatementSubtextLLetterSpacing,
  GDSETypographyStatementSubtextLLineHeight,
  GDSETypographySubheadingLFontFamily,
  GDSETypographySubheadingLFontSize,
  GDSETypographySubheadingLFontWeight,
  GDSETypographySubheadingLLetterSpacing,
  GDSETypographySubheadingLLineHeight,
  GDSETypographySubheadingMFontFamily,
  GDSETypographySubheadingMFontSize,
  GDSETypographySubheadingMFontWeight,
  GDSETypographySubheadingMLetterSpacing,
  GDSETypographySubheadingMLineHeight,
  GDSETypographySubheadingSFontFamily,
  GDSETypographySubheadingSFontSize,
  GDSETypographySubheadingSFontWeight,
  GDSETypographySubheadingSLetterSpacing,
  GDSETypographySubheadingSLineHeight,
  GDSETypographySubtitleListMFontFamily,
  GDSETypographySubtitleListMFontFeature,
  GDSETypographySubtitleListMFontSize,
  GDSETypographySubtitleListMFontWeight,
  GDSETypographySubtitleListMLetterSpacing,
  GDSETypographySubtitleListMLineHeight,
  GDSETypographySubtitleListSFontFamily,
  GDSETypographySubtitleListSFontFeature,
  GDSETypographySubtitleListSFontSize,
  GDSETypographySubtitleListSFontWeight,
  GDSETypographySubtitleListSLetterSpacing,
  GDSETypographySubtitleListSLineHeight,
  GDSETypographySubtitlePageFontFamily,
  GDSETypographySubtitlePageFontSize,
  GDSETypographySubtitlePageFontSizeMobile,
  GDSETypographySubtitlePageFontWeight,
  GDSETypographySubtitlePageLetterSpacing,
  GDSETypographySubtitlePageLineHeight,
  GDSETypographySubtitleSectionFontFamily,
  GDSETypographySubtitleSectionFontSize,
  GDSETypographySubtitleSectionFontWeight,
  GDSETypographySubtitleSectionLetterSpacing,
  GDSETypographySubtitleSectionLineHeight,
  GDSETypographyTitleListMFontFamily,
  GDSETypographyTitleListMFontFeature,
  GDSETypographyTitleListMFontSize,
  GDSETypographyTitleListMFontWeight,
  GDSETypographyTitleListMLetterSpacing,
  GDSETypographyTitleListMLineHeight,
  GDSETypographyTitleListSFontFamily,
  GDSETypographyTitleListSFontFeature,
  GDSETypographyTitleListSFontSize,
  GDSETypographyTitleListSFontWeight,
  GDSETypographyTitleListSLetterSpacing,
  GDSETypographyTitleListSLineHeight,
  GDSETypographyTitlePageFontFamily,
  GDSETypographyTitlePageFontSize,
  GDSETypographyTitlePageFontSizeMobile,
  GDSETypographyTitlePageFontWeight,
  GDSETypographyTitlePageLetterSpacing,
  GDSETypographyTitlePageLineHeight,
  GDSETypographyTitleSectionFontFamily,
  GDSETypographyTitleSectionFontSize,
  GDSETypographyTitleSectionFontWeight,
  GDSETypographyTitleSectionLetterSpacing,
  GDSETypographyTitleSectionLineHeight,
  GDSEWidthDefault,
  GDSEWidthLarge,
  GDSEWidthNone,
  GDSEZIndexDefault,
  GDSEZIndexDrawerContent,
  GDSEZIndexDrawerOverlay,
  GDSEZIndexFilterPanel,
  GDSEZIndexLayoutAds,
  GDSEZIndexLayoutFeedback,
  GDSEZIndexLayoutHeader,
  GDSEZIndexLayoutMenu,
  GDSEZIndexLayoutOverlay,
  GDSEZIndexReset,
  GDSEZIndexSearchSuggestBase,
  GDSEZIndexSearchSuggestFields,
  GDSEZIndexSharedAutocomplete,
  GDSEZIndexTooltip,
  GDSEZIndexUnset,
  GenerateHeaderOptions,
  Grid,
  GridColumns,
  GridRows,
  HostSizeBehavior,
  Icon,
  IconSize,
  IconTooltip,
  InputSize,
  Insight,
  InsightCard,
  InsightCardHeader,
  Language,
  LightweightButtonStyles,
  ListItem$1 as ListItem,
  ListItemsGroup,
  ListItemsHeader,
  Listbox,
  ListboxOption,
  MonthType,
  MultiSelect,
  NumberField,
  ObjectBadges,
  ObjectDate,
  ObjectHeader,
  ObjectInlineActions,
  ObjectList,
  ObjectListCell,
  ObjectListExpandableRow,
  ObjectListExpandableRowAction,
  ObjectListHeader,
  ObjectListRow,
  ObjectMedia,
  ObjectMediaIconSizes,
  ObjectMediaShape,
  ObjectMediaSize,
  ObjectTitle,
  Option$1 as Option,
  OptionsGroup,
  OptionsHeader,
  Orientation,
  OutlineButtonStyles,
  PageFooter,
  Popover,
  PopoverAlignment,
  PopoverDirection,
  PopoverMode,
  PopoverPadding,
  Progress,
  ProgressRing,
  ProgressRingSize,
  ProviderBehaviour,
  Radio,
  RadioGroup,
  RadioSize,
  RootThemeNotifier,
  RowExpandedState,
  Search,
  SearchInputVariant,
  SegmentControl,
  SegmentedControl,
  SegmentedControlSize,
  Select,
  SelectLabelPosition,
  SelectPosition,
  Skeleton,
  Slider,
  SliderLabel,
  SliderMode,
  SliderOrientation,
  Stat,
  TabsOrientation,
  TextAreaResize,
  TextField,
  TextFieldType,
  ThemeManager,
  ThemeProvider,
  ThemeProviderV2,
  ThemeType,
  ThemeVersion,
  TimePicker,
  Tm1CopyAction,
  Tm1FontLetterSpacing1,
  Tm1FontLetterSpacing2,
  Tm1FontLineHeight1,
  Tm1FontLineHeight2,
  Tm1FontLineHeight3,
  Tm1FontLineHeight4,
  Tm1FontSize0,
  Tm1FontSize1,
  Tm1FontSize10,
  Tm1FontSize11,
  Tm1FontSize12,
  Tm1FontSize13,
  Tm1FontSize14,
  Tm1FontSize15,
  Tm1FontSize2,
  Tm1FontSize3,
  Tm1FontSize4,
  Tm1FontSize5,
  Tm1FontSize6,
  Tm1FontSize7,
  Tm1FontSize8,
  Tm1FontSize9,
  Tm1FontTextDecorationNone,
  Toast,
  ToastContainer,
  ToastPosition,
  ToastType,
  Tooltip$1 as Tooltip,
  TooltipPosition,
  TooltipVariant,
  TreeItem,
  TreeView,
  Typography,
  ValueNotifier,
  ViewTemplate,
  WeekdayType,
  Wysiwyg,
  WysiwygOptions,
  WysiwygReturnType,
  ariaLink,
  badge$2 as badge,
  baseButtonsStyles,
  baseCardStyles,
  buildExamples,
  buildStory,
  buildTokenTable,
  bundledDependencies,
  cssObjectToString,
  darkTheme,
  datePickerSizeLarge,
  datePickerSizeRegular,
  datePickerSizeSmall,
  defaultInlineActionsPopoverConfig,
  defaultVariantCardStyles,
  deprecatedTokens,
  designSystem,
  emit,
  features,
  firstLetterUppercase,
  formatDate,
  formatDateToString,
  formatTokenName,
  getActiveEl,
  getActiveElIndex,
  getAttributes,
  getComputedStyle$2 as getComputedStyle,
  getDirection,
  getFocusableInputs,
  getFormatPartsIdx,
  getRootActiveElement,
  getThemeManager,
  globalBorders,
  globalColors,
  globalSpacings,
  globalTypographies,
  heightNumber,
  hexToRgb,
  hostSelector,
  iconTooltipTemplate,
  inputSizeLarge$1 as inputSizeLarge,
  inputSizeRegular$1 as inputSizeRegular,
  inputSizeSmall$1 as inputSizeSmall,
  isListItem,
  isOptionGroup,
  isSecureContext,
  isValidDate,
  language,
  legacyTheme,
  lightTheme,
  normalizeUserInput,
  numberFieldSizeLarge,
  numberFieldSizeRegular,
  numberFieldSizeSmall,
  outlineVariantCardStyles,
  parseElementLang,
  position,
  progressRingDarkStyles,
  progressRingLightStyles,
  provideTm1DesignSystem,
  removeElement$1 as removeElement,
  renderLitTemplate,
  searchSizeRegular,
  selectStyles,
  semanticBorders,
  semanticColors,
  semanticFonts,
  semanticSpacings,
  setAttributes,
  setThemeManager,
  shadowVariantCardStyles,
  sprites,
  textFieldSizeLarge,
  textFieldSizeRegular,
  textFieldSizeSmall,
  themeContext,
  themeManager,
  themeVersionContext,
  tm1Accordion,
  tm1AccordionItem,
  tm1AccordionItemStyles,
  tm1AccordionStyles,
  tm1ActionGroup,
  tm1Anchor,
  tm1AnchorStyles,
  tm1Avatar,
  tm1AvatarStyles,
  tm1AvatarTemplate,
  tm1Badge,
  tm1BadgeStyles,
  tm1BadgeV2Styles,
  tm1Banner,
  tm1BannerStyles,
  tm1BannerTemplate,
  tm1Button,
  tm1ButtonStyles,
  tm1ButtonStylesV2,
  tm1Calendar,
  tm1CalendarStyles,
  tm1Card,
  tm1CardContent,
  tm1CardContentStyles,
  tm1CardFooter,
  tm1CardFooterStyles,
  tm1CardHeader,
  tm1CardHeaderStyles,
  tm1CardStyles,
  tm1Checkbox,
  tm1CheckboxGroup,
  tm1CheckboxGroupStyles,
  tm1CheckboxStyles,
  tm1Combobox,
  tm1ComboboxStyles,
  tm1CopyAction,
  tm1DataGrid,
  tm1DataGridCell,
  tm1DataGridCellStyles,
  tm1DataGridRow,
  tm1DataGridRowStyles,
  tm1DataGridStyles,
  tm1DataRefreshChip,
  tm1DataRefreshChipStyles,
  tm1DataRefreshChipTemplate,
  tm1DatePickerStyles,
  tm1DatePickerV2,
  tm1DateTimePicker,
  tm1DateTimePickerTemplate,
  tm1DeprecateToken,
  tm1Dialog,
  tm1DialogFooter,
  tm1DialogFooterStyles,
  tm1DialogFooterV2Styles,
  tm1DialogStepContent,
  tm1DialogStepContentStyles,
  tm1DialogStepContentV2Styles,
  tm1DialogStyles,
  tm1DialogV2Styles,
  tm1Disclosure,
  tm1DisclosureStyles,
  tm1Divider,
  tm1DividerStyles,
  tm1Drawer,
  tm1DrawerFooter,
  tm1DrawerFooterStyles,
  tm1DrawerFooterTemplate,
  tm1DrawerHeader,
  tm1DrawerHeaderStyles,
  tm1DrawerHeaderTemplate,
  tm1DrawerStyles,
  tm1DrawerTemplate,
  tm1EmptyState,
  tm1EmptyStateStyles,
  tm1EmptyStateTemplate,
  tm1FileUploadItemStyles,
  tm1FileUploadStyles,
  tm1Grid,
  tm1GridStyles,
  tm1Icon,
  tm1IconStyles,
  tm1IconTooltip,
  tm1Insight,
  tm1InsightCard,
  tm1InsightCardHeader,
  tm1InsightCardHeaderStyles,
  tm1InsightCardHeaderTemplate,
  tm1InsightCardStyles,
  tm1InsightCardTemplate,
  tm1ListItemStyles,
  tm1ListItemsGroupStyles,
  tm1ListItemsHeaderStyles,
  tm1Listbox,
  tm1ListboxStyles,
  tm1ListboxTemplate,
  tm1MultiSelect,
  tm1MultiSelectV2Styles,
  tm1MultiSelectV2Template,
  tm1NumberField,
  tm1NumberFieldStyles,
  tm1NumberFieldTemplate,
  tm1ObjectBadges,
  tm1ObjectBadgesStyles,
  tm1ObjectBadgesTemplate,
  tm1ObjectDate,
  tm1ObjectDateStyles,
  tm1ObjectDateTemplate,
  tm1ObjectHeader,
  tm1ObjectHeaderStyles,
  tm1ObjectHeaderTemplate,
  tm1ObjectInlineActions,
  tm1ObjectInlineActionsStyles,
  tm1ObjectInlineActionsTemplate,
  tm1ObjectList,
  tm1ObjectListCell,
  tm1ObjectListCellStyles,
  tm1ObjectListCellTemplate,
  tm1ObjectListExpandableRow,
  tm1ObjectListExpandableRowAction,
  tm1ObjectListExpandableRowActionStyles,
  tm1ObjectListExpandableRowActionTemplate,
  tm1ObjectListExpandableRowStyles,
  tm1ObjectListExpandableRowTemplate,
  tm1ObjectListHeader,
  tm1ObjectListHeaderStyles,
  tm1ObjectListHeaderTemplate,
  tm1ObjectListRow,
  tm1ObjectListRowStyles,
  tm1ObjectListRowTemplate,
  tm1ObjectListStyles,
  tm1ObjectListTemplate,
  tm1ObjectMedia,
  tm1ObjectMediaStyles,
  tm1ObjectMediaTemplate,
  tm1ObjectTitle,
  tm1ObjectTitleStyles,
  tm1ObjectTitleTemplate,
  tm1Option,
  tm1OptionStyles,
  tm1OptionTemplate,
  tm1OptionsGroup,
  tm1OptionsGroupStyles,
  tm1OptionsGroupTemplate,
  tm1OptionsHeader,
  tm1OptionsHeaderStyles,
  tm1OptionsHeaderTemplate,
  tm1PageFooter,
  tm1PageFooterStyles,
  tm1Popover,
  tm1PopoverStyles,
  tm1PopoverTemplate,
  tm1Progress,
  tm1ProgressRing,
  tm1ProgressStyles,
  tm1Radio,
  tm1RadioGroup,
  tm1RadioGroupStyles,
  tm1RadioStyles,
  tm1Search,
  tm1SearchStyles,
  tm1SearchTemplate,
  tm1SegmentControl,
  tm1SegmentControlStyles,
  tm1SegmentControlTemplate,
  tm1SegmentedControl,
  tm1SegmentedControlStyles,
  tm1SegmentedControlTemplate,
  tm1Select,
  tm1SelectStyles,
  tm1SelectTemplate,
  tm1Skeleton,
  tm1SkeletonStyles,
  tm1Slider,
  tm1SliderLabel,
  tm1SliderLabelStyles,
  tm1SliderStyles,
  tm1Stat,
  tm1StatStyles,
  tm1StatTemplate,
  tm1Switch,
  tm1Tab,
  tm1TabPanel,
  tm1Tabs,
  tm1TextArea,
  tm1TextField,
  tm1TextFieldStyles,
  tm1TextFieldTemplate,
  tm1ThemeProvider,
  tm1ThemeProviderStyles,
  tm1ThemeProviderTemplate,
  tm1ThemeProviderV2,
  tm1ThemeProviderV2Styles,
  tm1ThemeProviderV2Template,
  tm1TimePicker,
  tm1TimePickerStyles,
  tm1TimePickerTemplate,
  tm1Toast,
  tm1ToastContainer,
  tm1ToastContainerTemplate,
  tm1ToastStyles,
  tm1ToastTemplate,
  tm1Tooltip,
  tm1TooltipStyles,
  tm1TreeView,
  tm1TreeViewItem,
  tm1TreeViewItemStyles,
  tm1TreeViewStyles,
  tm1Typography,
  tm1TypographyStyles,
  tooltipTemplate$1 as tooltipTemplate,
  typeRampBase,
  typeRampMinus1,
  typeRampMinus2,
  typeRampPlus1,
  typeRampPlus2,
  typeRampPlus3,
  typeRampPlus5,
  typeRampPlus6,
  typographyTypes,
  variantBehavior,
  waitForElm
};
//# sourceMappingURL=tm1-design-system.mjs.map
